(() => {

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gKp6f", function(module, exports) {

$parcel$export(module.exports, "createMap", () => $c3146981bf65af08$export$d49c9aa30b771d59);
$parcel$export(module.exports, "renderRoute", () => $c3146981bf65af08$export$d46b353f6608364f);

var $kMGLj = parcelRequire("kMGLj");
function $c3146981bf65af08$export$d49c9aa30b771d59(options) {
    (0, (/*@__PURE__*/$parcel$interopDefault($kMGLj))).accessToken = mapboxSettings.accessToken;
    return new (0, (/*@__PURE__*/$parcel$interopDefault($kMGLj))).Map({
        style: 'mapbox://styles/eventconnectors/cml7thwbn000301qzaw4f0b4p',
        ...options
    });
}
function $c3146981bf65af08$export$d46b353f6608364f(canvas) {
    const zoomOutButton = canvas.parentElement.querySelector('.map-action.zoom-out');
    const zoomInButton = canvas.parentElement.querySelector('.map-action.zoom-in');
    const settings = JSON.parse(canvas.dataset.settings);
    const { calculatedCoordinates: calculatedCoordinates, routeCoordinates: routeCoordinates, pois: pois, center: center, zoom: zoom = 12 } = settings;
    const map = $c3146981bf65af08$export$d49c9aa30b771d59({
        container: canvas,
        center: center,
        zoom: zoom
    });
    map.scrollZoom.disable();
    map.dragPan.enable();
    map.on('load', ()=>{
        map.addSource('Line', {
            'type': 'geojson',
            'data': $c3146981bf65af08$var$toGeoJsonFeatureCollection(calculatedCoordinates)
        });
        map.addLayer({
            'id': 'Line',
            'type': 'line',
            'source': 'Line',
            'layout': {
                'line-join': 'round',
                'line-cap': 'round'
            },
            'paint': {
                'line-color': '#D92E20',
                'line-width': 5
            }
        });
        const bounds = new (0, (/*@__PURE__*/$parcel$interopDefault($kMGLj))).LngLatBounds(calculatedCoordinates[0], calculatedCoordinates[0]);
        for (const coord of calculatedCoordinates)bounds.extend(coord);
        // Add route coordinates as markers
        routeCoordinates.forEach((coord)=>{
            const el = document.createElement('div');
            el.className = 'map-marker';
            const marker = new (0, (/*@__PURE__*/$parcel$interopDefault($kMGLj))).Marker(el).setLngLat(coord).addTo(map);
            bounds.extend(coord);
        });
        // Add POI markers with a text label for the title
        pois.forEach((poi)=>{
            const markerElement = document.createElement('div');
            markerElement.className = 'map-marker map-marker-solid';
            markerElement.innerHTML = `<i class="${poi.icon}"></i>`;
            const marker = new (0, (/*@__PURE__*/$parcel$interopDefault($kMGLj))).Marker(markerElement).setLngLat([
                poi.lng,
                poi.lat
            ]).addTo(map);
            const popupElement = document.createElement('div');
            popupElement.className = 'map-popup';
            popupElement.innerHTML = `<h3>${poi.title}</h3><p>${poi.description}</p>`;
            const popup = new (0, (/*@__PURE__*/$parcel$interopDefault($kMGLj))).Popup({
                offset: 15,
                closeButton: false,
                closeOnClick: false
            }).setLngLat([
                poi.lng,
                poi.lat
            ]).setDOMContent(popupElement);
            marker.getElement().addEventListener('mouseenter', ()=>popup.addTo(map));
            marker.getElement().addEventListener('mouseleave', ()=>popup.remove());
            bounds.extend([
                poi.lng,
                poi.lat
            ]);
        });
        map.fitBounds(bounds, {
            padding: 40
        });
    });
    zoomOutButton.addEventListener('click', ()=>{
        map.zoomOut();
    });
    zoomInButton.addEventListener('click', ()=>{
        map.zoomIn();
    });
    return map;
}
function $c3146981bf65af08$var$toGeoJsonFeatureCollection(coordinates) {
    return {
        type: 'FeatureCollection',
        features: [
            {
                type: 'Feature',
                geometry: {
                    type: 'LineString',
                    coordinates: coordinates
                },
                properties: {}
            }
        ]
    };
}

});
parcelRegister("kMGLj", function(module, exports) {
/* Mapbox GL JS is Copyright © 2020 Mapbox and subject to the Mapbox Terms of Service ((https://www.mapbox.com/legal/tos/). */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    let shared, worker, mapboxgl;
    function define(o, e1) {
        if (!shared) shared = e1;
        else if (!worker) worker = e1;
        else {
            const r = {};
            shared(r), mapboxgl = e1(r);
            const n = "self.onerror = function() { console.error('An error occurred while parsing the WebWorker bundle. This is most likely due to improper transpilation by Babel; please see https://docs.mapbox.com/mapbox-gl-js/guides/install/#transpiling'); }; var sharedChunk = {}; (" + shared + ")(sharedChunk); (" + worker + ")(undefined, sharedChunk); self.onerror = null;";
            typeof window < "u" && window && window.URL && window.URL.createObjectURL && (mapboxgl.workerUrl = window.URL.createObjectURL(new Blob([
                n
            ], {
                type: "text/javascript"
            })));
        }
    }
    define([
        "exports"
    ], function(e1) {
        var t1 = 1e-6, r = "undefined" != typeof Float32Array ? Float32Array : Array;
        function n(e1, t1) {
            var r = t1[0], n = t1[1], i = t1[2], s = t1[3], a = r * s - i * n;
            return a ? (e1[0] = s * (a = 1 / a), e1[1] = -n * a, e1[2] = -i * a, e1[3] = r * a, e1) : null;
        }
        function i() {
            var e1 = new r(9);
            return r != Float32Array && (e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[5] = 0, e1[6] = 0, e1[7] = 0), e1[0] = 1, e1[4] = 1, e1[8] = 1, e1;
        }
        function s(e1, t1) {
            var r = t1[0], n = t1[1], i = t1[2], s = t1[3], a = t1[4], o = t1[5], l = t1[6], u = t1[7], c = t1[8];
            return e1[0] = a * c - o * u, e1[1] = i * u - n * c, e1[2] = n * o - i * a, e1[3] = o * l - s * c, e1[4] = r * c - i * l, e1[5] = i * s - r * o, e1[6] = s * u - a * l, e1[7] = n * l - r * u, e1[8] = r * a - n * s, e1;
        }
        function a(e1, t1, r) {
            var n = t1[0], i = t1[1], s = t1[2], a = t1[3], o = t1[4], l = t1[5], u = t1[6], c = t1[7], h = t1[8], d = r[0], p = r[1], f = r[2], m = r[3], y = r[4], g = r[5], x = r[6], v = r[7], b = r[8];
            return e1[0] = d * n + p * a + f * u, e1[1] = d * i + p * o + f * c, e1[2] = d * s + p * l + f * h, e1[3] = m * n + y * a + g * u, e1[4] = m * i + y * o + g * c, e1[5] = m * s + y * l + g * h, e1[6] = x * n + v * a + b * u, e1[7] = x * i + v * o + b * c, e1[8] = x * s + v * l + b * h, e1;
        }
        function o() {
            var e1 = new r(16);
            return r != Float32Array && (e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0), e1[0] = 1, e1[5] = 1, e1[10] = 1, e1[15] = 1, e1;
        }
        function l(e1) {
            var t1 = new r(16);
            return t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1[3] = e1[3], t1[4] = e1[4], t1[5] = e1[5], t1[6] = e1[6], t1[7] = e1[7], t1[8] = e1[8], t1[9] = e1[9], t1[10] = e1[10], t1[11] = e1[11], t1[12] = e1[12], t1[13] = e1[13], t1[14] = e1[14], t1[15] = e1[15], t1;
        }
        function u(e1) {
            return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = 1, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 1, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }
        function c(e1, t1) {
            var r = t1[0], n = t1[1], i = t1[2], s = t1[3], a = t1[4], o = t1[5], l = t1[6], u = t1[7], c = t1[8], h = t1[9], d = t1[10], p = t1[11], f = t1[12], m = t1[13], y = t1[14], g = t1[15], x = r * o - n * a, v = r * l - i * a, b = r * u - s * a, w = n * l - i * o, _ = n * u - s * o, A = i * u - s * l, I = c * m - h * f, M = c * y - d * f, B = c * g - p * f, S = h * y - d * m, P = h * g - p * m, T = d * g - p * y, z = x * T - v * P + b * S + w * B - _ * M + A * I;
            return z ? (e1[0] = (o * T - l * P + u * S) * (z = 1 / z), e1[1] = (i * P - n * T - s * S) * z, e1[2] = (m * A - y * _ + g * w) * z, e1[3] = (d * _ - h * A - p * w) * z, e1[4] = (l * B - a * T - u * M) * z, e1[5] = (r * T - i * B + s * M) * z, e1[6] = (y * b - f * A - g * v) * z, e1[7] = (c * A - d * b + p * v) * z, e1[8] = (a * P - o * B + u * I) * z, e1[9] = (n * B - r * P - s * I) * z, e1[10] = (f * _ - m * b + g * x) * z, e1[11] = (h * b - c * _ - p * x) * z, e1[12] = (o * M - a * S - l * I) * z, e1[13] = (r * S - n * M + i * I) * z, e1[14] = (m * v - f * w - y * x) * z, e1[15] = (c * w - h * v + d * x) * z, e1) : null;
        }
        function h(e1, t1, r) {
            var n = t1[0], i = t1[1], s = t1[2], a = t1[3], o = t1[4], l = t1[5], u = t1[6], c = t1[7], h = t1[8], d = t1[9], p = t1[10], f = t1[11], m = t1[12], y = t1[13], g = t1[14], x = t1[15], v = r[0], b = r[1], w = r[2], _ = r[3];
            return e1[0] = v * n + b * o + w * h + _ * m, e1[1] = v * i + b * l + w * d + _ * y, e1[2] = v * s + b * u + w * p + _ * g, e1[3] = v * a + b * c + w * f + _ * x, e1[4] = (v = r[4]) * n + (b = r[5]) * o + (w = r[6]) * h + (_ = r[7]) * m, e1[5] = v * i + b * l + w * d + _ * y, e1[6] = v * s + b * u + w * p + _ * g, e1[7] = v * a + b * c + w * f + _ * x, e1[8] = (v = r[8]) * n + (b = r[9]) * o + (w = r[10]) * h + (_ = r[11]) * m, e1[9] = v * i + b * l + w * d + _ * y, e1[10] = v * s + b * u + w * p + _ * g, e1[11] = v * a + b * c + w * f + _ * x, e1[12] = (v = r[12]) * n + (b = r[13]) * o + (w = r[14]) * h + (_ = r[15]) * m, e1[13] = v * i + b * l + w * d + _ * y, e1[14] = v * s + b * u + w * p + _ * g, e1[15] = v * a + b * c + w * f + _ * x, e1;
        }
        function d(e1, t1, r) {
            var n, i, s, a, o, l, u, c, h, d, p, f, m = r[0], y = r[1], g = r[2];
            return t1 === e1 ? (e1[12] = t1[0] * m + t1[4] * y + t1[8] * g + t1[12], e1[13] = t1[1] * m + t1[5] * y + t1[9] * g + t1[13], e1[14] = t1[2] * m + t1[6] * y + t1[10] * g + t1[14], e1[15] = t1[3] * m + t1[7] * y + t1[11] * g + t1[15]) : (i = t1[1], s = t1[2], a = t1[3], o = t1[4], l = t1[5], u = t1[6], c = t1[7], h = t1[8], d = t1[9], p = t1[10], f = t1[11], e1[0] = n = t1[0], e1[1] = i, e1[2] = s, e1[3] = a, e1[4] = o, e1[5] = l, e1[6] = u, e1[7] = c, e1[8] = h, e1[9] = d, e1[10] = p, e1[11] = f, e1[12] = n * m + o * y + h * g + t1[12], e1[13] = i * m + l * y + d * g + t1[13], e1[14] = s * m + u * y + p * g + t1[14], e1[15] = a * m + c * y + f * g + t1[15]), e1;
        }
        function p(e1, t1, r) {
            var n = r[0], i = r[1], s = r[2];
            return e1[0] = t1[0] * n, e1[1] = t1[1] * n, e1[2] = t1[2] * n, e1[3] = t1[3] * n, e1[4] = t1[4] * i, e1[5] = t1[5] * i, e1[6] = t1[6] * i, e1[7] = t1[7] * i, e1[8] = t1[8] * s, e1[9] = t1[9] * s, e1[10] = t1[10] * s, e1[11] = t1[11] * s, e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15], e1;
        }
        function f(e1, t1, r) {
            var n = Math.sin(r), i = Math.cos(r), s = t1[4], a = t1[5], o = t1[6], l = t1[7], u = t1[8], c = t1[9], h = t1[10], d = t1[11];
            return t1 !== e1 && (e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1[3] = t1[3], e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15]), e1[4] = s * i + u * n, e1[5] = a * i + c * n, e1[6] = o * i + h * n, e1[7] = l * i + d * n, e1[8] = u * i - s * n, e1[9] = c * i - a * n, e1[10] = h * i - o * n, e1[11] = d * i - l * n, e1;
        }
        function m(e1, t1, r) {
            var n = Math.sin(r), i = Math.cos(r), s = t1[0], a = t1[1], o = t1[2], l = t1[3], u = t1[8], c = t1[9], h = t1[10], d = t1[11];
            return t1 !== e1 && (e1[4] = t1[4], e1[5] = t1[5], e1[6] = t1[6], e1[7] = t1[7], e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15]), e1[0] = s * i - u * n, e1[1] = a * i - c * n, e1[2] = o * i - h * n, e1[3] = l * i - d * n, e1[8] = s * n + u * i, e1[9] = a * n + c * i, e1[10] = o * n + h * i, e1[11] = l * n + d * i, e1;
        }
        function y(e1, t1, r) {
            var n = Math.sin(r), i = Math.cos(r), s = t1[0], a = t1[1], o = t1[2], l = t1[3], u = t1[4], c = t1[5], h = t1[6], d = t1[7];
            return t1 !== e1 && (e1[8] = t1[8], e1[9] = t1[9], e1[10] = t1[10], e1[11] = t1[11], e1[12] = t1[12], e1[13] = t1[13], e1[14] = t1[14], e1[15] = t1[15]), e1[0] = s * i + u * n, e1[1] = a * i + c * n, e1[2] = o * i + h * n, e1[3] = l * i + d * n, e1[4] = u * i - s * n, e1[5] = c * i - a * n, e1[6] = h * i - o * n, e1[7] = d * i - l * n, e1;
        }
        function g(e1, t1) {
            return e1[0] = t1[0], e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = t1[1], e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = t1[2], e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }
        function x(e1, r, n) {
            var i, s, a, o = n[0], l = n[1], u = n[2], c = Math.sqrt(o * o + l * l + u * u);
            return c < t1 ? null : (o *= c = 1 / c, l *= c, u *= c, i = Math.sin(r), s = Math.cos(r), e1[0] = o * o * (a = 1 - s) + s, e1[1] = l * o * a + u * i, e1[2] = u * o * a - l * i, e1[3] = 0, e1[4] = o * l * a - u * i, e1[5] = l * l * a + s, e1[6] = u * l * a + o * i, e1[7] = 0, e1[8] = o * u * a + l * i, e1[9] = l * u * a - o * i, e1[10] = u * u * a + s, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1);
        }
        function v(e1, t1) {
            var r = t1[0], n = t1[1], i = t1[2], s = t1[4], a = t1[5], o = t1[6], l = t1[8], u = t1[9], c = t1[10];
            return e1[0] = Math.sqrt(r * r + n * n + i * i), e1[1] = Math.sqrt(s * s + a * a + o * o), e1[2] = Math.sqrt(l * l + u * u + c * c), e1;
        }
        function b(e1, t1) {
            var r = t1[0], n = t1[1], i = t1[2], s = t1[3], a = r + r, o = n + n, l = i + i, u = r * a, c = n * a, h = n * o, d = i * a, p = i * o, f = i * l, m = s * a, y = s * o, g = s * l;
            return e1[0] = 1 - h - f, e1[1] = c + g, e1[2] = d - y, e1[3] = 0, e1[4] = c - g, e1[5] = 1 - u - f, e1[6] = p + m, e1[7] = 0, e1[8] = d + y, e1[9] = p - m, e1[10] = 1 - u - h, e1[11] = 0, e1[12] = 0, e1[13] = 0, e1[14] = 0, e1[15] = 1, e1;
        }
        var w = h;
        function _() {
            var e1 = new r(3);
            return r != Float32Array && (e1[0] = 0, e1[1] = 0, e1[2] = 0), e1;
        }
        function A(e1) {
            var t1 = new r(3);
            return t1[0] = e1[0], t1[1] = e1[1], t1[2] = e1[2], t1;
        }
        function I(e1) {
            var t1 = e1[0], r = e1[1], n = e1[2];
            return Math.sqrt(t1 * t1 + r * r + n * n);
        }
        function M(e1, t1, n) {
            var i = new r(3);
            return i[0] = e1, i[1] = t1, i[2] = n, i;
        }
        function B(e1, t1, r, n) {
            return e1[0] = t1, e1[1] = r, e1[2] = n, e1;
        }
        function S(e1, t1, r) {
            return e1[0] = t1[0] + r[0], e1[1] = t1[1] + r[1], e1[2] = t1[2] + r[2], e1;
        }
        function P(e1, t1, r) {
            return e1[0] = t1[0] - r[0], e1[1] = t1[1] - r[1], e1[2] = t1[2] - r[2], e1;
        }
        function T(e1, t1, r) {
            return e1[0] = t1[0] * r[0], e1[1] = t1[1] * r[1], e1[2] = t1[2] * r[2], e1;
        }
        function z(e1, t1, r) {
            return e1[0] = Math.min(t1[0], r[0]), e1[1] = Math.min(t1[1], r[1]), e1[2] = Math.min(t1[2], r[2]), e1;
        }
        function k(e1, t1, r) {
            return e1[0] = Math.max(t1[0], r[0]), e1[1] = Math.max(t1[1], r[1]), e1[2] = Math.max(t1[2], r[2]), e1;
        }
        function V(e1, t1, r) {
            return e1[0] = t1[0] * r, e1[1] = t1[1] * r, e1[2] = t1[2] * r, e1;
        }
        function F(e1, t1, r, n) {
            return e1[0] = t1[0] + r[0] * n, e1[1] = t1[1] + r[1] * n, e1[2] = t1[2] + r[2] * n, e1;
        }
        function D(e1, t1) {
            var r = t1[0] - e1[0], n = t1[1] - e1[1], i = t1[2] - e1[2];
            return Math.sqrt(r * r + n * n + i * i);
        }
        function E(e1, t1) {
            var r = t1[0] - e1[0], n = t1[1] - e1[1], i = t1[2] - e1[2];
            return r * r + n * n + i * i;
        }
        function C(e1) {
            var t1 = e1[0], r = e1[1], n = e1[2];
            return t1 * t1 + r * r + n * n;
        }
        function R(e1, t1) {
            return e1[0] = -t1[0], e1[1] = -t1[1], e1[2] = -t1[2], e1;
        }
        function L(e1, t1) {
            var r = t1[0], n = t1[1], i = t1[2], s = r * r + n * n + i * i;
            return s > 0 && (s = 1 / Math.sqrt(s)), e1[0] = t1[0] * s, e1[1] = t1[1] * s, e1[2] = t1[2] * s, e1;
        }
        function O(e1, t1) {
            return e1[0] * t1[0] + e1[1] * t1[1] + e1[2] * t1[2];
        }
        function U(e1, t1, r) {
            var n = t1[0], i = t1[1], s = t1[2], a = r[0], o = r[1], l = r[2];
            return e1[0] = i * l - s * o, e1[1] = s * a - n * l, e1[2] = n * o - i * a, e1;
        }
        function N(e1, t1, r, n) {
            var i = t1[0], s = t1[1], a = t1[2];
            return e1[0] = i + n * (r[0] - i), e1[1] = s + n * (r[1] - s), e1[2] = a + n * (r[2] - a), e1;
        }
        function j(e1, t1, r) {
            var n = t1[0], i = t1[1], s = t1[2], a = r[3] * n + r[7] * i + r[11] * s + r[15];
            return e1[0] = (r[0] * n + r[4] * i + r[8] * s + r[12]) / (a = a || 1), e1[1] = (r[1] * n + r[5] * i + r[9] * s + r[13]) / a, e1[2] = (r[2] * n + r[6] * i + r[10] * s + r[14]) / a, e1;
        }
        function G(e1, t1, r) {
            var n = t1[0], i = t1[1], s = t1[2];
            return e1[0] = n * r[0] + i * r[3] + s * r[6], e1[1] = n * r[1] + i * r[4] + s * r[7], e1[2] = n * r[2] + i * r[5] + s * r[8], e1;
        }
        function $(e1, t1, r) {
            var n = r[0], i = r[1], s = r[2], a = r[3], o = t1[0], l = t1[1], u = t1[2], c = i * u - s * l, h = s * o - n * u, d = n * l - i * o;
            return e1[0] = o + a * (c += c) + i * (d += d) - s * (h += h), e1[1] = l + a * h + s * c - n * d, e1[2] = u + a * d + n * h - i * c, e1;
        }
        function q(e1) {
            return e1[0] = 0, e1[1] = 0, e1[2] = 0, e1;
        }
        function H(e1, t1) {
            return e1[0] === t1[0] && e1[1] === t1[1] && e1[2] === t1[2];
        }
        var X = P, Z = T, W = I;
        function Y() {
            var e1 = new r(4);
            return r != Float32Array && (e1[0] = 0, e1[1] = 0, e1[2] = 0, e1[3] = 0), e1;
        }
        function J(e1, t1, r) {
            return e1[0] = t1[0] * r, e1[1] = t1[1] * r, e1[2] = t1[2] * r, e1[3] = t1[3] * r, e1;
        }
        function K(e1, t1) {
            var r = t1[0], n = t1[1], i = t1[2], s = t1[3], a = r * r + n * n + i * i + s * s;
            return a > 0 && (a = 1 / Math.sqrt(a)), e1[0] = r * a, e1[1] = n * a, e1[2] = i * a, e1[3] = s * a, e1;
        }
        function Q(e1, t1) {
            return e1[0] * t1[0] + e1[1] * t1[1] + e1[2] * t1[2] + e1[3] * t1[3];
        }
        function ee(e1, t1, r) {
            var n = t1[0], i = t1[1], s = t1[2], a = t1[3];
            return e1[0] = r[0] * n + r[4] * i + r[8] * s + r[12] * a, e1[1] = r[1] * n + r[5] * i + r[9] * s + r[13] * a, e1[2] = r[2] * n + r[6] * i + r[10] * s + r[14] * a, e1[3] = r[3] * n + r[7] * i + r[11] * s + r[15] * a, e1;
        }
        function te() {
            var e1 = new r(4);
            return r != Float32Array && (e1[0] = 0, e1[1] = 0, e1[2] = 0), e1[3] = 1, e1;
        }
        function re(e1) {
            return e1[0] = 0, e1[1] = 0, e1[2] = 0, e1[3] = 1, e1;
        }
        function ne(e1, t1, r) {
            r *= .5;
            var n = t1[0], i = t1[1], s = t1[2], a = t1[3], o = Math.sin(r), l = Math.cos(r);
            return e1[0] = n * l + a * o, e1[1] = i * l + s * o, e1[2] = s * l - i * o, e1[3] = a * l - n * o, e1;
        }
        function ie(e1, t1, r) {
            r *= .5;
            var n = t1[0], i = t1[1], s = t1[2], a = t1[3], o = Math.sin(r), l = Math.cos(r);
            return e1[0] = n * l - s * o, e1[1] = i * l + a * o, e1[2] = s * l + n * o, e1[3] = a * l - i * o, e1;
        }
        _(), Y();
        var se, ae, oe, le = K, ue = (se = _(), ae = M(1, 0, 0), oe = M(0, 1, 0), function(e1, t1, r) {
            var n = O(t1, r);
            return n < -0.999999 ? (U(se, ae, t1), W(se) < 1e-6 && U(se, oe, t1), L(se, se), function(e1, t1, r) {
                r *= .5;
                var n = Math.sin(r);
                e1[0] = n * t1[0], e1[1] = n * t1[1], e1[2] = n * t1[2], e1[3] = Math.cos(r);
            }(e1, se, Math.PI), e1) : n > .999999 ? (e1[0] = 0, e1[1] = 0, e1[2] = 0, e1[3] = 1, e1) : (U(se, t1, r), e1[0] = se[0], e1[1] = se[1], e1[2] = se[2], e1[3] = 1 + n, le(e1, e1));
        });
        function ce() {
            var e1 = new r(2);
            return r != Float32Array && (e1[0] = 0, e1[1] = 0), e1;
        }
        function he(e1, t1) {
            var n = new r(2);
            return n[0] = e1, n[1] = t1, n;
        }
        function de(e1, t1, r) {
            return e1[0] = t1, e1[1] = r, e1;
        }
        function pe(e1, t1, r) {
            return e1[0] = t1[0] + r[0], e1[1] = t1[1] + r[1], e1;
        }
        function fe(e1, t1, r) {
            return e1[0] = t1[0] - r[0], e1[1] = t1[1] - r[1], e1;
        }
        function me(e1, t1, r) {
            return e1[0] = t1[0] * r, e1[1] = t1[1] * r, e1;
        }
        function ye(e1) {
            var t1 = e1[0], r = e1[1];
            return Math.sqrt(t1 * t1 + r * r);
        }
        function ge(e1, t1) {
            var r = t1[0], n = t1[1], i = r * r + n * n;
            return i > 0 && (i = 1 / Math.sqrt(i)), e1[0] = t1[0] * i, e1[1] = t1[1] * i, e1;
        }
        function xe(e1, t1) {
            return e1[0] * t1[0] + e1[1] * t1[1];
        }
        te(), te(), i();
        var ve, be, we = fe;
        function _e(e1) {
            return e1 && e1.__esModule && Object.prototype.hasOwnProperty.call(e1, "default") ? e1.default : e1;
        }
        ce();
        var Ae = function() {
            if (be) return ve;
            function e1(e1, t1, r, n) {
                this.cx = 3 * e1, this.bx = 3 * (r - e1) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * t1, this.by = 3 * (n - t1) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = e1, this.p1y = t1, this.p2x = r, this.p2y = n;
            }
            return be = 1, ve = e1, e1.prototype = {
                sampleCurveX: function(e1) {
                    return ((this.ax * e1 + this.bx) * e1 + this.cx) * e1;
                },
                sampleCurveY: function(e1) {
                    return ((this.ay * e1 + this.by) * e1 + this.cy) * e1;
                },
                sampleCurveDerivativeX: function(e1) {
                    return (3 * this.ax * e1 + 2 * this.bx) * e1 + this.cx;
                },
                solveCurveX: function(e1, t1) {
                    if (void 0 === t1 && (t1 = 1e-6), e1 < 0) return 0;
                    if (e1 > 1) return 1;
                    for(var r = e1, n = 0; n < 8; n++){
                        var i = this.sampleCurveX(r) - e1;
                        if (Math.abs(i) < t1) return r;
                        var s = this.sampleCurveDerivativeX(r);
                        if (Math.abs(s) < 1e-6) break;
                        r -= i / s;
                    }
                    var a = 0, o = 1;
                    for(r = e1, n = 0; n < 20 && (i = this.sampleCurveX(r), !(Math.abs(i - e1) < t1)); n++)e1 > i ? a = r : o = r, r = .5 * (o - a) + a;
                    return r;
                },
                solve: function(e1, t1) {
                    return this.sampleCurveY(this.solveCurveX(e1, t1));
                }
            }, ve;
        }(), Ie = _e(Ae);
        function Me(e1, t1) {
            this.x = e1, this.y = t1;
        }
        function Be(e1, t1) {
            if (Array.isArray(e1)) {
                if (!Array.isArray(t1) || e1.length !== t1.length) return !1;
                for(let r = 0; r < e1.length; r++)if (!Be(e1[r], t1[r])) return !1;
                return !0;
            }
            if ("object" == typeof e1 && null !== e1 && null !== t1) {
                if ("object" != typeof t1) return !1;
                if (Object.keys(e1).length !== Object.keys(t1).length) return !1;
                for(const r in e1)if (!Be(e1[r], t1[r])) return !1;
                return !0;
            }
            return e1 === t1;
        }
        Me.prototype = {
            clone () {
                return new Me(this.x, this.y);
            },
            add (e1) {
                return this.clone()._add(e1);
            },
            sub (e1) {
                return this.clone()._sub(e1);
            },
            multByPoint (e1) {
                return this.clone()._multByPoint(e1);
            },
            divByPoint (e1) {
                return this.clone()._divByPoint(e1);
            },
            mult (e1) {
                return this.clone()._mult(e1);
            },
            div (e1) {
                return this.clone()._div(e1);
            },
            rotate (e1) {
                return this.clone()._rotate(e1);
            },
            rotateAround (e1, t1) {
                return this.clone()._rotateAround(e1, t1);
            },
            matMult (e1) {
                return this.clone()._matMult(e1);
            },
            unit () {
                return this.clone()._unit();
            },
            perp () {
                return this.clone()._perp();
            },
            round () {
                return this.clone()._round();
            },
            mag () {
                return Math.sqrt(this.x * this.x + this.y * this.y);
            },
            equals (e1) {
                return this.x === e1.x && this.y === e1.y;
            },
            dist (e1) {
                return Math.sqrt(this.distSqr(e1));
            },
            distSqr (e1) {
                const t1 = e1.x - this.x, r = e1.y - this.y;
                return t1 * t1 + r * r;
            },
            angle () {
                return Math.atan2(this.y, this.x);
            },
            angleTo (e1) {
                return Math.atan2(this.y - e1.y, this.x - e1.x);
            },
            angleWith (e1) {
                return this.angleWithSep(e1.x, e1.y);
            },
            angleWithSep (e1, t1) {
                return Math.atan2(this.x * t1 - this.y * e1, this.x * e1 + this.y * t1);
            },
            _matMult (e1) {
                const t1 = e1[2] * this.x + e1[3] * this.y;
                return this.x = e1[0] * this.x + e1[1] * this.y, this.y = t1, this;
            },
            _add (e1) {
                return this.x += e1.x, this.y += e1.y, this;
            },
            _sub (e1) {
                return this.x -= e1.x, this.y -= e1.y, this;
            },
            _mult (e1) {
                return this.x *= e1, this.y *= e1, this;
            },
            _div (e1) {
                return this.x /= e1, this.y /= e1, this;
            },
            _multByPoint (e1) {
                return this.x *= e1.x, this.y *= e1.y, this;
            },
            _divByPoint (e1) {
                return this.x /= e1.x, this.y /= e1.y, this;
            },
            _unit () {
                return this._div(this.mag()), this;
            },
            _perp () {
                const e1 = this.y;
                return this.y = this.x, this.x = -e1, this;
            },
            _rotate (e1) {
                const t1 = Math.cos(e1), r = Math.sin(e1), n = r * this.x + t1 * this.y;
                return this.x = t1 * this.x - r * this.y, this.y = n, this;
            },
            _rotateAround (e1, t1) {
                const r = Math.cos(e1), n = Math.sin(e1), i = t1.y + n * (this.x - t1.x) + r * (this.y - t1.y);
                return this.x = t1.x + r * (this.x - t1.x) - n * (this.y - t1.y), this.y = i, this;
            },
            _round () {
                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
            },
            constructor: Me
        }, Me.convert = function(e1) {
            if (e1 instanceof Me) return e1;
            if (Array.isArray(e1)) return new Me(+e1[0], +e1[1]);
            if (void 0 !== e1.x && void 0 !== e1.y) return new Me(+e1.x, +e1.y);
            throw new Error("Expected [x, y] or {x, y} point format");
        };
        const Se = Math.PI / 180, Pe = 180 / Math.PI;
        function Te(e1) {
            return e1 * Se;
        }
        function ze(e1) {
            return e1 * Pe;
        }
        const ke = [
            [
                0,
                0
            ],
            [
                1,
                0
            ],
            [
                1,
                1
            ],
            [
                0,
                1
            ]
        ];
        function Ve(e1) {
            if (e1 <= 0) return 0;
            if (e1 >= 1) return 1;
            const t1 = e1 * e1, r = t1 * e1;
            return 4 * (e1 < .5 ? r : 3 * (e1 - t1) + r - .75);
        }
        function Fe(e1, t1, r, n) {
            const i = new Ie(e1, t1, r, n);
            return function(e1) {
                return i.solve(e1);
            };
        }
        const De = Fe(.25, .1, .25, 1);
        function Ee(e1, t1, r) {
            return Math.min(r, Math.max(t1, e1));
        }
        function Ce(e1, t1, r) {
            return (r = Ee((r - e1) / (t1 - e1), 0, 1)) * r * (3 - 2 * r);
        }
        function Re(e1, t1, r) {
            const n = r - t1, i = ((e1 - t1) % n + n) % n + t1;
            return i === t1 ? r : i;
        }
        function Le(e1, t1, r) {
            if (!e1.length) return r(null, []);
            let n = e1.length;
            const i = new Array(e1.length);
            let s = null;
            e1.forEach((e1, a)=>{
                t1(e1, (e1, t1)=>{
                    e1 && (s = e1), i[a] = t1, 0 === --n && r(s, i);
                });
            });
        }
        let Oe = 1;
        function Ue() {
            return Oe++;
        }
        function Ne(e1) {
            return e1 <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log2(e1)));
        }
        function je(e1, t1) {
            e1.forEach((e1)=>{
                t1[e1] && (t1[e1] = t1[e1].bind(t1));
            });
        }
        function Ge(e1, t1, r) {
            const n = {};
            for(const r in e1)n[r] = t1.call(this, e1[r], r, e1);
            return n;
        }
        function $e(e1, t1, r) {
            const n = {};
            for(const r in e1)t1.call(this, e1[r], r, e1) && (n[r] = e1[r]);
            return n;
        }
        function qe(e1) {
            return Array.isArray(e1) ? e1.map(qe) : "object" == typeof e1 && e1 ? Ge(e1, qe) : e1;
        }
        function He(e1, t1) {
            for(let r = 0; r < e1.length; r++)if (t1.indexOf(e1[r]) >= 0) return !0;
            return !1;
        }
        const Xe = {};
        function Ze(e1) {
            Xe[e1] || ("undefined" != typeof console && console.warn(e1), Xe[e1] = !0);
        }
        function We(e1, t1, r) {
            return (r.y - e1.y) * (t1.x - e1.x) > (t1.y - e1.y) * (r.x - e1.x);
        }
        function Ye(e1) {
            let t1 = 0;
            for(let r, n, i = 0, s = e1.length, a = s - 1; i < s; a = i++)r = e1[i], n = e1[a], t1 += (n.x - r.x) * (r.y + n.y);
            return t1;
        }
        function Je([e1, t1, r]) {
            const n = Te(t1 + 90), i = Te(r);
            return {
                x: e1 * Math.cos(n) * Math.sin(i),
                y: e1 * Math.sin(n) * Math.sin(i),
                z: e1 * Math.cos(i),
                azimuthal: t1,
                polar: r
            };
        }
        function Ke(e1) {
            return ("undefined" != typeof self || void 0 !== e1) && "undefined" != typeof WorkerGlobalScope && (void 0 !== e1 ? e1 : self) instanceof WorkerGlobalScope;
        }
        function Qe(e1) {
            const t1 = {};
            if (e1.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (e1, r, n, i)=>{
                const s = n || i;
                return t1[r] = !s || s.toLowerCase(), "";
            }), t1["max-age"]) {
                const e1 = parseInt(t1["max-age"], 10);
                isNaN(e1) ? delete t1["max-age"] : t1["max-age"] = e1;
            }
            return t1;
        }
        let et, tt = null;
        function rt(e1, t1) {
            return [
                e1[4 * t1],
                e1[4 * t1 + 1],
                e1[4 * t1 + 2],
                e1[4 * t1 + 3]
            ];
        }
        function nt(e1, t1, r, n) {
            for(; t1 < r;){
                const i = t1 + r >> 1;
                e1[i] < n ? t1 = i + 1 : r = i;
            }
            return t1;
        }
        function it(e1, t1, r, n) {
            for(; t1 < r;){
                const i = t1 + r >> 1;
                e1[i] <= n ? t1 = i + 1 : r = i;
            }
            return t1;
        }
        function st(e1) {
            return e1 > 0 ? 1 / (1.001 - e1) : 1 + e1;
        }
        function at(e1) {
            return e1 > 0 ? 1 - 1 / (1.001 - e1) : -e1;
        }
        function ot(e1, t1, r) {
            return (e1 - t1.min) * (r.max - r.min) / (t1.max - t1.min) + r.min;
        }
        const lt = {
            API_URL: "https://api.mapbox.com",
            get API_URL_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;
            },
            get API_TILEJSON_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/v[0-9]*\/.*\.json.*$)/i;
            },
            get API_SPRITE_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*\/sprite.*\..*$)/i;
            },
            get API_FONTS_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/fonts\/v[0-9]*\/)(.*\.pbf.*$)/i;
            },
            get API_STYLE_REGEX () {
                return /^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/styles\/v[0-9]*\/)(.*$)/i;
            },
            get API_CDN_URL_REGEX () {
                return /^((https?:)?\/\/)?api\.mapbox\.c(n|om)(\/mapbox-gl-js\/)(.*$)/i;
            },
            get EVENTS_URL () {
                if (!lt.API_URL) return null;
                try {
                    const e1 = new URL(lt.API_URL);
                    return "api.mapbox.cn" === e1.hostname ? "https://events.mapbox.cn/events/v2" : "api.mapbox.com" === e1.hostname ? "https://events.mapbox.com/events/v2" : null;
                } catch (e1) {
                    return null;
                }
            },
            SESSION_PATH: "/map-sessions/v1",
            FEEDBACK_URL: "https://apps.mapbox.com/feedback",
            TILE_URL_VERSION: "v4",
            RASTER_URL_PREFIX: "raster/v1",
            RASTERARRAYS_URL_PREFIX: "rasterarrays/v1",
            REQUIRE_ACCESS_TOKEN: !0,
            ACCESS_TOKEN: null,
            DEFAULT_STYLE: "mapbox://styles/mapbox/standard",
            MAX_PARALLEL_IMAGE_REQUESTS: 16,
            DRACO_URL: "/mapbox-gl-js/draco_decoder_gltf_v1.5.6.wasm",
            MESHOPT_URL: "/mapbox-gl-js/meshopt_base_v0.20.wasm",
            MESHOPT_SIMD_URL: "/mapbox-gl-js/meshopt_simd_v0.20.wasm",
            BUILDING_GEN_URL: "/mapbox-gl-js/building-gen/building_gen_v1.2.4.wasm",
            GLYPHS_URL: "mapbox://fonts/mapbox/{fontstack}/{range}.pbf",
            TILES3D_URL_PREFIX: "3dtiles/v1",
            TILE_PROVIDER_URLS: Object.assign(Object.create(null), {
                pmtiles: "/mapbox-gl-js/mapbox-gl-pmtiles-provider-v0.0.1.js"
            })
        };
        function ut() {
            return new URL(lt.DRACO_URL, lt.API_URL).href;
        }
        function ct() {
            if ("object" != typeof WebAssembly) throw new Error("WebAssembly not supported, cannot instantiate meshoptimizer");
            return new URL(function() {
                if (void 0 === et) {
                    if ("object" != typeof WebAssembly) return !1;
                    const e1 = new Uint8Array([
                        0,
                        97,
                        115,
                        109,
                        1,
                        0,
                        0,
                        0,
                        1,
                        4,
                        1,
                        96,
                        0,
                        0,
                        3,
                        3,
                        2,
                        0,
                        0,
                        5,
                        3,
                        1,
                        0,
                        1,
                        12,
                        1,
                        0,
                        10,
                        22,
                        2,
                        12,
                        0,
                        65,
                        0,
                        65,
                        0,
                        65,
                        0,
                        252,
                        10,
                        0,
                        0,
                        11,
                        7,
                        0,
                        65,
                        0,
                        253,
                        15,
                        26,
                        11
                    ]);
                    et = WebAssembly.validate(e1);
                }
                return et;
            }() ? lt.MESHOPT_SIMD_URL : lt.MESHOPT_URL, lt.API_URL).href;
        }
        function ht() {
            return new URL(lt.BUILDING_GEN_URL, lt.API_URL).href;
        }
        function dt(e1) {
            return lt.API_URL_REGEX.test(e1);
        }
        function pt(e1) {
            return lt.API_SPRITE_REGEX.test(e1);
        }
        let ft, mt, yt, gt, xt, vt;
        function bt() {
            return null == ft && (ft = self.OffscreenCanvas && new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof self.createImageBitmap), ft;
        }
        const wt = {
            now: ()=>void 0 !== gt ? gt : performance.now(),
            setNow (e1) {
                gt = e1;
            },
            restoreNow () {
                gt = void 0;
            },
            frame (e1) {
                const t1 = requestAnimationFrame(e1);
                return {
                    cancel: ()=>cancelAnimationFrame(t1)
                };
            },
            getImageData (e1, t1 = 0) {
                const { width: r, height: n } = e1;
                xt || (xt = document.createElement("canvas"));
                const i = xt.getContext("2d", {
                    willReadFrequently: !0
                });
                if (!i) throw new Error("failed to create canvas 2d context");
                return (r > xt.width || n > xt.height) && (xt.width = r, xt.height = n), i.clearRect(-t1, -t1, r + 2 * t1, n + 2 * t1), i.drawImage(e1, 0, 0, r, n), i.getImageData(-t1, -t1, r + 2 * t1, n + 2 * t1);
            },
            resolveURL: (e1)=>(mt || (mt = document.createElement("a")), mt.href = e1, mt.href),
            get devicePixelRatio () {
                return window.devicePixelRatio;
            },
            get prefersReducedMotion () {
                return !!window.matchMedia && (null == yt && (yt = window.matchMedia("(prefers-reduced-motion: reduce)")), yt.matches);
            },
            hasCanvasFingerprintNoise () {
                if (void 0 !== vt) return vt;
                if (!bt()) return vt = !1, !1;
                const e1 = new OffscreenCanvas(85, 1), t1 = e1.getContext("2d", {
                    willReadFrequently: !0
                });
                let r = 0;
                for(let n = 0; n < e1.width; ++n)t1.fillStyle = `rgba(${r++},${r++},${r++}, 255)`, t1.fillRect(n, 0, 1, 1);
                const n = t1.getImageData(0, 0, e1.width, e1.height);
                r = 0;
                for(let e1 = 0; e1 < n.data.length; ++e1)if (e1 % 4 != 3 && r++ !== n.data[e1]) return vt = !0, !0;
                return vt = !1, !1;
            }
        };
        function _t(e1, t1) {
            const r = e1.indexOf("?");
            if (r < 0) return `${e1}?${new URLSearchParams(t1).toString()}`;
            const n = new URLSearchParams(e1.slice(r));
            for(const e1 in t1)n.set(e1, t1[e1]);
            return `${e1.slice(0, r)}?${n.toString()}`;
        }
        function At(e1, t1 = {
            persistentParams: []
        }) {
            const r = e1.indexOf("?");
            if (r < 0) return e1;
            const n = new URLSearchParams, i = new URLSearchParams(e1.slice(r));
            for (const e1 of t1.persistentParams){
                const t1 = i.get(e1);
                t1 && n.set(e1, t1);
            }
            const s = n.toString();
            return `${e1.slice(0, r)}${s.length > 0 ? `?${s}` : ""}`;
        }
        const It = "mapbox-tiles";
        let Mt = 500, Bt = 50;
        const St = [
            "language",
            "worldview",
            "jobid"
        ];
        let Pt;
        function Tt() {
            try {
                return caches;
            } catch (e1) {}
        }
        function zt() {
            const e1 = Tt();
            e1 && null == Pt && (Pt = e1.open(It));
        }
        let kt = 1 / 0;
        const Vt = {
            supported: !1,
            testSupport: function(e1) {
                !Et && Dt && (Ct ? Lt(e1) : Ft = e1);
            }
        };
        let Ft, Dt, Et = !1, Ct = !1;
        const Rt = "undefined" != typeof self ? self : {};
        function Lt(e1) {
            const t1 = e1.createTexture();
            e1.bindTexture(e1.TEXTURE_2D, t1);
            try {
                if (e1.texImage2D(e1.TEXTURE_2D, 0, e1.RGBA, e1.RGBA, e1.UNSIGNED_BYTE, Dt), e1.isContextLost()) return;
                Vt.supported = !0;
            } catch (e1) {}
            e1.deleteTexture(t1), Et = !0;
        }
        Rt.document && (Dt = Rt.document.createElement("img"), Dt.onload = function() {
            Ft && Lt(Ft), Ft = null, Ct = !0;
        }, Dt.onerror = function() {
            Et = !0, Ft = null;
        }, Dt.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");
        const Ot = {
            Unknown: "Unknown",
            Style: "Style",
            Source: "Source",
            Tile: "Tile",
            Glyphs: "Glyphs",
            SpriteImage: "SpriteImage",
            SpriteJSON: "SpriteJSON",
            Iconset: "Iconset",
            Image: "Image",
            Model: "Model"
        };
        Object.freeze(Ot);
        class Ut extends Error {
            constructor(e1, t1, r){
                401 === t1 && dt(r) && (e1 += ": you may have provided an invalid Mapbox access token. See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes"), super(e1), this.status = t1, this.url = r;
            }
            toString() {
                return `${this.name}: ${this.message} (${this.status}): ${this.url}`;
            }
        }
        function Nt(e1) {
            return "object" == typeof e1 && null !== e1 && "status" in e1 && 404 === e1.status;
        }
        const jt = Ke() ? ()=>self.worker.referrer : ()=>("blob:" === location.protocol ? parent : self).location.href;
        const Gt = function(e1, t1) {
            var r;
            return /^file:/.test(r = e1.url) || /^file:/.test(jt()) && !/^\w+:/.test(r) ? function(e1, t1) {
                const r = new XMLHttpRequest;
                r.open(e1.method || "GET", e1.url, !0), "arrayBuffer" === e1.type && (r.responseType = "arraybuffer");
                for(const t1 in e1.headers)r.setRequestHeader(t1, e1.headers[t1]);
                return "json" === e1.type && (r.responseType = "text", r.setRequestHeader("Accept", "application/json")), r.withCredentials = "include" === e1.credentials, r.onerror = ()=>{
                    t1(new Error(r.statusText));
                }, r.onload = ()=>{
                    if ((r.status >= 200 && r.status < 300 || 0 === r.status) && null !== r.response) {
                        let n = r.response;
                        if ("json" === e1.type) try {
                            n = JSON.parse(r.response);
                        } catch (e1) {
                            return t1(e1);
                        }
                        const i = new Headers;
                        r.getAllResponseHeaders().trim().split(/[\r\n]+/).forEach((e1)=>{
                            const t1 = e1.split(": "), r = t1.shift(), n = t1.join(": ");
                            i.append(r, n);
                        }), t1(null, n, i);
                    } else t1(new Ut(r.statusText, r.status, e1.url));
                }, r.send(e1.body), {
                    cancel: ()=>r.abort()
                };
            }(e1, t1) : function(e1, t1) {
                const r = new AbortController, n = new Request(e1.url, {
                    method: e1.method || "GET",
                    body: e1.body,
                    credentials: e1.credentials,
                    headers: e1.headers,
                    referrer: jt(),
                    referrerPolicy: e1.referrerPolicy,
                    signal: r.signal
                });
                let i = !1, s = !1;
                const a = (o = n.url).indexOf("sku=") > 0 && dt(o);
                var o;
                "json" === e1.type && n.headers.set("Accept", "application/json");
                const l = (r, i, o)=>{
                    if (s) return;
                    if (r && "SecurityError" !== r.message && Ze(r.toString()), i && o) return u(i);
                    const l = Date.now();
                    fetch(n).then((r)=>{
                        if (r.ok) {
                            const e1 = a ? r.clone() : null;
                            return u(r, e1, l);
                        }
                        return t1(new Ut(r.statusText, r.status, e1.url));
                    }).catch((r)=>{
                        "AbortError" !== r.name && t1(new Error(`${r.message} ${e1.url}`));
                    });
                }, u = (r, a, o)=>{
                    ("arrayBuffer" === e1.type ? r.arrayBuffer() : "json" === e1.type ? r.json() : r.text()).then((e1)=>{
                        s || (a && o && function(e1, t1, r) {
                            if (zt(), null == Pt) return;
                            const n = Qe(t1.headers.get("cache-control") || "");
                            if (n["no-store"]) return;
                            const i = {
                                status: t1.status,
                                statusText: t1.statusText,
                                headers: new Headers
                            };
                            t1.headers.forEach((e1, t1)=>i.headers.set(t1, e1)), n["max-age"] && i.headers.set("Expires", new Date(r + 1e3 * n["max-age"]).toUTCString());
                            const s = i.headers.get("expires");
                            if (!s) return;
                            if (new Date(s).getTime() - r < 42e4) return;
                            let a = At(e1.url, {
                                persistentParams: St
                            });
                            if (206 === t1.status) {
                                const t1 = e1.headers.get("Range");
                                if (!t1) return;
                                i.status = 200, a = _t(a, {
                                    range: t1
                                });
                            }
                            const o = new Response(200 !== (l = t1.status) && 404 !== l && [
                                101,
                                103,
                                204,
                                205,
                                304
                            ].includes(l) ? null : t1.body, i);
                            var l;
                            zt(), null != Pt && Pt.then((e1)=>e1.put(a, o)).catch((e1)=>Ze(e1.message));
                        }(n, a, o), i = !0, t1(null, e1, r.headers));
                    }).catch((e1)=>{
                        s || t1(new Error(e1.message));
                    });
                };
                return a ? function(e1, t1) {
                    if (zt(), null == Pt) return t1(null);
                    Pt.then((r)=>{
                        let n = At(e1.url, {
                            persistentParams: St
                        });
                        const i = e1.headers.get("Range");
                        i && (n = _t(n, {
                            range: i
                        })), r.match(n).then((e1)=>{
                            const i = function(e1) {
                                if (!e1) return !1;
                                const t1 = new Date(e1.headers.get("expires") || 0), r = Qe(e1.headers.get("cache-control") || "");
                                return Number(t1) > Date.now() && !r["no-cache"];
                            }(e1);
                            r.delete(n).catch(t1), i && r.put(n, e1.clone()).catch(t1), t1(null, e1, i);
                        }).catch(t1);
                    }).catch(t1);
                }(n, l) : l(null, null), {
                    cancel: ()=>{
                        s = !0, i || r.abort();
                    }
                };
            }(e1, t1);
        }, $t = function(e1, t1) {
            return Gt(Object.assign(e1, {
                type: "arrayBuffer"
            }), t1);
        };
        function qt(e1) {
            const t1 = document.createElement("a");
            return t1.href = e1, t1.protocol === location.protocol && t1.host === location.host;
        }
        let Ht, Xt;
        Ht = [], Xt = 0;
        const Zt = function(e1, t1) {
            if (Vt.supported && (e1.headers || (e1.headers = {}), e1.headers.accept = "image/webp,*/*"), Xt >= lt.MAX_PARALLEL_IMAGE_REQUESTS) {
                const r = {
                    requestParameters: e1,
                    callback: t1,
                    cancelled: !1,
                    cancel () {
                        this.cancelled = !0;
                    }
                };
                return Ht.push(r), r;
            }
            Xt++;
            let r = !1;
            const n = ()=>{
                if (!r) for(r = !0, Xt--; Ht.length && Xt < lt.MAX_PARALLEL_IMAGE_REQUESTS;){
                    const e1 = Ht.shift(), { requestParameters: t1, callback: r, cancelled: n } = e1;
                    n || (e1.cancel = Zt(t1, r).cancel);
                }
            }, i = $t(e1, (e1, r, i)=>{
                n(), e1 ? t1(e1) : r && function(e1, t1) {
                    const r = new Blob([
                        new Uint8Array(e1)
                    ], {
                        type: "image/png"
                    });
                    createImageBitmap(r).then((e1)=>{
                        t1(null, e1);
                    }).catch((e1)=>{
                        t1(new Error(`Could not load image because of ${e1.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`));
                    });
                }(r, (e1, r)=>t1(e1, r, i));
            });
            return {
                cancel: ()=>{
                    i.cancel(), n();
                }
            };
        };
        var Wt, Yt, Jt, Kt = {
            exports: {}
        }, Qt = {
            exports: {}
        }, er = {
            exports: {}
        }, tr = function() {
            if (Jt) return Kt.exports;
            Jt = 1;
            var e1 = (Wt || (Wt = 1, Qt.exports = function(e1, t1) {
                var r, n, i, s, a, o, l, u;
                for(n = e1.length - (r = 3 & e1.length), i = t1, a = 3432918353, o = 461845907, u = 0; u < n;)l = 255 & e1.charCodeAt(u) | (255 & e1.charCodeAt(++u)) << 8 | (255 & e1.charCodeAt(++u)) << 16 | (255 & e1.charCodeAt(++u)) << 24, ++u, i = 27492 + (65535 & (s = 5 * (65535 & (i = (i ^= l = (65535 & (l = (l = (65535 & l) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295) << 13 | i >>> 19)) + ((5 * (i >>> 16) & 65535) << 16) & 4294967295)) + (((s >>> 16) + 58964 & 65535) << 16);
                switch(l = 0, r){
                    case 3:
                        l ^= (255 & e1.charCodeAt(u + 2)) << 16;
                    case 2:
                        l ^= (255 & e1.charCodeAt(u + 1)) << 8;
                    case 1:
                        i ^= l = (65535 & (l = (l = (65535 & (l ^= 255 & e1.charCodeAt(u))) * a + (((l >>> 16) * a & 65535) << 16) & 4294967295) << 15 | l >>> 17)) * o + (((l >>> 16) * o & 65535) << 16) & 4294967295;
                }
                return i ^= e1.length, i = 2246822507 * (65535 & (i ^= i >>> 16)) + ((2246822507 * (i >>> 16) & 65535) << 16) & 4294967295, i = 3266489909 * (65535 & (i ^= i >>> 13)) + ((3266489909 * (i >>> 16) & 65535) << 16) & 4294967295, (i ^= i >>> 16) >>> 0;
            }), Qt.exports), t1 = (Yt || (Yt = 1, er.exports = function(e1, t1) {
                for(var r, n = e1.length, i = t1 ^ n, s = 0; n >= 4;)r = 1540483477 * (65535 & (r = 255 & e1.charCodeAt(s) | (255 & e1.charCodeAt(++s)) << 8 | (255 & e1.charCodeAt(++s)) << 16 | (255 & e1.charCodeAt(++s)) << 24)) + ((1540483477 * (r >>> 16) & 65535) << 16), i = 1540483477 * (65535 & i) + ((1540483477 * (i >>> 16) & 65535) << 16) ^ (r = 1540483477 * (65535 & (r ^= r >>> 24)) + ((1540483477 * (r >>> 16) & 65535) << 16)), n -= 4, ++s;
                switch(n){
                    case 3:
                        i ^= (255 & e1.charCodeAt(s + 2)) << 16;
                    case 2:
                        i ^= (255 & e1.charCodeAt(s + 1)) << 8;
                    case 1:
                        i = 1540483477 * (65535 & (i ^= 255 & e1.charCodeAt(s))) + ((1540483477 * (i >>> 16) & 65535) << 16);
                }
                return i = 1540483477 * (65535 & (i ^= i >>> 13)) + ((1540483477 * (i >>> 16) & 65535) << 16), (i ^= i >>> 15) >>> 0;
            }), er.exports);
            return Kt.exports = e1, Kt.exports.murmur3 = e1, Kt.exports.murmur2 = t1, Kt.exports;
        }(), rr = _e(tr);
        class nr {
            constructor(e1, ...t1){
                Object.assign(this, t1[0] || {}), this.type = e1;
            }
        }
        class ir extends nr {
            constructor(e1, t1 = {}){
                super("error", Object.assign({
                    error: e1
                }, t1));
            }
        }
        function sr(e1, t1, r) {
            r[e1] && -1 !== r[e1].indexOf(t1) || (r[e1] = r[e1] || [], r[e1].push(t1));
        }
        function ar(e1, t1, r) {
            if (r && r[e1]) {
                const n = r[e1].indexOf(t1);
                -1 !== n && r[e1].splice(n, 1);
            }
        }
        class or {
            on(e1, t1) {
                return this._listeners = this._listeners || {}, sr(e1, t1, this._listeners), this;
            }
            off(e1, t1) {
                return ar(e1, t1, this._listeners), ar(e1, t1, this._oneTimeListeners), this;
            }
            once(e1, t1) {
                return t1 ? (this._oneTimeListeners = this._oneTimeListeners || {}, sr(e1, t1, this._oneTimeListeners), this) : new Promise((t1)=>{
                    this.once(e1, t1);
                });
            }
            fire(e1, t1) {
                const r = "string" == typeof e1 ? new nr(e1, t1) : e1, n = r.type;
                if (this.listens(n)) {
                    r.target = this;
                    const e1 = this._listeners && this._listeners[n] ? this._listeners[n].slice() : [];
                    for (const t1 of e1)t1.call(this, r);
                    const t1 = this._oneTimeListeners && this._oneTimeListeners[n] ? this._oneTimeListeners[n].slice() : [];
                    for (const e1 of t1)ar(n, e1, this._oneTimeListeners), e1.call(this, r);
                    const i = this._eventedParent;
                    if (i) {
                        const e1 = "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData;
                        Object.assign(r, e1), i.fire(r);
                    }
                } else r instanceof ir && console.error(r.error);
                return this;
            }
            listens(e1) {
                return !!(this._listeners && this._listeners[e1] && this._listeners[e1].length > 0 || this._oneTimeListeners && this._oneTimeListeners[e1] && this._oneTimeListeners[e1].length > 0 || this._eventedParent && this._eventedParent.listens(e1));
            }
            setEventedParent(e1, t1) {
                return this._eventedParent = e1, this._eventedParentData = t1, this;
            }
        }
        class lr {
            constructor(e1){
                "string" == typeof e1 ? this.name = e1 : (this.name = e1.name, this.iconsetId = e1.iconsetId);
            }
            static from(e1) {
                return new lr(e1);
            }
            static toString(e1) {
                return e1.iconsetId ? `${e1.name}${e1.iconsetId}` : e1.name;
            }
            static parse(e1) {
                const [t1, r] = e1.split("");
                return new lr({
                    name: t1,
                    iconsetId: r
                });
            }
            static isEqual(e1, t1) {
                return e1.name === t1.name && e1.iconsetId === t1.iconsetId;
            }
            toString() {
                return lr.toString(this);
            }
            serialize() {
                return {
                    name: this.name,
                    iconsetId: this.iconsetId
                };
            }
        }
        var ur, cr = {}, hr = function() {
            if (ur) return cr;
            ur = 1;
            var e1 = {
                transparent: [
                    0,
                    0,
                    0,
                    0
                ],
                aliceblue: [
                    240,
                    248,
                    255,
                    1
                ],
                antiquewhite: [
                    250,
                    235,
                    215,
                    1
                ],
                aqua: [
                    0,
                    255,
                    255,
                    1
                ],
                aquamarine: [
                    127,
                    255,
                    212,
                    1
                ],
                azure: [
                    240,
                    255,
                    255,
                    1
                ],
                beige: [
                    245,
                    245,
                    220,
                    1
                ],
                bisque: [
                    255,
                    228,
                    196,
                    1
                ],
                black: [
                    0,
                    0,
                    0,
                    1
                ],
                blanchedalmond: [
                    255,
                    235,
                    205,
                    1
                ],
                blue: [
                    0,
                    0,
                    255,
                    1
                ],
                blueviolet: [
                    138,
                    43,
                    226,
                    1
                ],
                brown: [
                    165,
                    42,
                    42,
                    1
                ],
                burlywood: [
                    222,
                    184,
                    135,
                    1
                ],
                cadetblue: [
                    95,
                    158,
                    160,
                    1
                ],
                chartreuse: [
                    127,
                    255,
                    0,
                    1
                ],
                chocolate: [
                    210,
                    105,
                    30,
                    1
                ],
                coral: [
                    255,
                    127,
                    80,
                    1
                ],
                cornflowerblue: [
                    100,
                    149,
                    237,
                    1
                ],
                cornsilk: [
                    255,
                    248,
                    220,
                    1
                ],
                crimson: [
                    220,
                    20,
                    60,
                    1
                ],
                cyan: [
                    0,
                    255,
                    255,
                    1
                ],
                darkblue: [
                    0,
                    0,
                    139,
                    1
                ],
                darkcyan: [
                    0,
                    139,
                    139,
                    1
                ],
                darkgoldenrod: [
                    184,
                    134,
                    11,
                    1
                ],
                darkgray: [
                    169,
                    169,
                    169,
                    1
                ],
                darkgreen: [
                    0,
                    100,
                    0,
                    1
                ],
                darkgrey: [
                    169,
                    169,
                    169,
                    1
                ],
                darkkhaki: [
                    189,
                    183,
                    107,
                    1
                ],
                darkmagenta: [
                    139,
                    0,
                    139,
                    1
                ],
                darkolivegreen: [
                    85,
                    107,
                    47,
                    1
                ],
                darkorange: [
                    255,
                    140,
                    0,
                    1
                ],
                darkorchid: [
                    153,
                    50,
                    204,
                    1
                ],
                darkred: [
                    139,
                    0,
                    0,
                    1
                ],
                darksalmon: [
                    233,
                    150,
                    122,
                    1
                ],
                darkseagreen: [
                    143,
                    188,
                    143,
                    1
                ],
                darkslateblue: [
                    72,
                    61,
                    139,
                    1
                ],
                darkslategray: [
                    47,
                    79,
                    79,
                    1
                ],
                darkslategrey: [
                    47,
                    79,
                    79,
                    1
                ],
                darkturquoise: [
                    0,
                    206,
                    209,
                    1
                ],
                darkviolet: [
                    148,
                    0,
                    211,
                    1
                ],
                deeppink: [
                    255,
                    20,
                    147,
                    1
                ],
                deepskyblue: [
                    0,
                    191,
                    255,
                    1
                ],
                dimgray: [
                    105,
                    105,
                    105,
                    1
                ],
                dimgrey: [
                    105,
                    105,
                    105,
                    1
                ],
                dodgerblue: [
                    30,
                    144,
                    255,
                    1
                ],
                firebrick: [
                    178,
                    34,
                    34,
                    1
                ],
                floralwhite: [
                    255,
                    250,
                    240,
                    1
                ],
                forestgreen: [
                    34,
                    139,
                    34,
                    1
                ],
                fuchsia: [
                    255,
                    0,
                    255,
                    1
                ],
                gainsboro: [
                    220,
                    220,
                    220,
                    1
                ],
                ghostwhite: [
                    248,
                    248,
                    255,
                    1
                ],
                gold: [
                    255,
                    215,
                    0,
                    1
                ],
                goldenrod: [
                    218,
                    165,
                    32,
                    1
                ],
                gray: [
                    128,
                    128,
                    128,
                    1
                ],
                green: [
                    0,
                    128,
                    0,
                    1
                ],
                greenyellow: [
                    173,
                    255,
                    47,
                    1
                ],
                grey: [
                    128,
                    128,
                    128,
                    1
                ],
                honeydew: [
                    240,
                    255,
                    240,
                    1
                ],
                hotpink: [
                    255,
                    105,
                    180,
                    1
                ],
                indianred: [
                    205,
                    92,
                    92,
                    1
                ],
                indigo: [
                    75,
                    0,
                    130,
                    1
                ],
                ivory: [
                    255,
                    255,
                    240,
                    1
                ],
                khaki: [
                    240,
                    230,
                    140,
                    1
                ],
                lavender: [
                    230,
                    230,
                    250,
                    1
                ],
                lavenderblush: [
                    255,
                    240,
                    245,
                    1
                ],
                lawngreen: [
                    124,
                    252,
                    0,
                    1
                ],
                lemonchiffon: [
                    255,
                    250,
                    205,
                    1
                ],
                lightblue: [
                    173,
                    216,
                    230,
                    1
                ],
                lightcoral: [
                    240,
                    128,
                    128,
                    1
                ],
                lightcyan: [
                    224,
                    255,
                    255,
                    1
                ],
                lightgoldenrodyellow: [
                    250,
                    250,
                    210,
                    1
                ],
                lightgray: [
                    211,
                    211,
                    211,
                    1
                ],
                lightgreen: [
                    144,
                    238,
                    144,
                    1
                ],
                lightgrey: [
                    211,
                    211,
                    211,
                    1
                ],
                lightpink: [
                    255,
                    182,
                    193,
                    1
                ],
                lightsalmon: [
                    255,
                    160,
                    122,
                    1
                ],
                lightseagreen: [
                    32,
                    178,
                    170,
                    1
                ],
                lightskyblue: [
                    135,
                    206,
                    250,
                    1
                ],
                lightslategray: [
                    119,
                    136,
                    153,
                    1
                ],
                lightslategrey: [
                    119,
                    136,
                    153,
                    1
                ],
                lightsteelblue: [
                    176,
                    196,
                    222,
                    1
                ],
                lightyellow: [
                    255,
                    255,
                    224,
                    1
                ],
                lime: [
                    0,
                    255,
                    0,
                    1
                ],
                limegreen: [
                    50,
                    205,
                    50,
                    1
                ],
                linen: [
                    250,
                    240,
                    230,
                    1
                ],
                magenta: [
                    255,
                    0,
                    255,
                    1
                ],
                maroon: [
                    128,
                    0,
                    0,
                    1
                ],
                mediumaquamarine: [
                    102,
                    205,
                    170,
                    1
                ],
                mediumblue: [
                    0,
                    0,
                    205,
                    1
                ],
                mediumorchid: [
                    186,
                    85,
                    211,
                    1
                ],
                mediumpurple: [
                    147,
                    112,
                    219,
                    1
                ],
                mediumseagreen: [
                    60,
                    179,
                    113,
                    1
                ],
                mediumslateblue: [
                    123,
                    104,
                    238,
                    1
                ],
                mediumspringgreen: [
                    0,
                    250,
                    154,
                    1
                ],
                mediumturquoise: [
                    72,
                    209,
                    204,
                    1
                ],
                mediumvioletred: [
                    199,
                    21,
                    133,
                    1
                ],
                midnightblue: [
                    25,
                    25,
                    112,
                    1
                ],
                mintcream: [
                    245,
                    255,
                    250,
                    1
                ],
                mistyrose: [
                    255,
                    228,
                    225,
                    1
                ],
                moccasin: [
                    255,
                    228,
                    181,
                    1
                ],
                navajowhite: [
                    255,
                    222,
                    173,
                    1
                ],
                navy: [
                    0,
                    0,
                    128,
                    1
                ],
                oldlace: [
                    253,
                    245,
                    230,
                    1
                ],
                olive: [
                    128,
                    128,
                    0,
                    1
                ],
                olivedrab: [
                    107,
                    142,
                    35,
                    1
                ],
                orange: [
                    255,
                    165,
                    0,
                    1
                ],
                orangered: [
                    255,
                    69,
                    0,
                    1
                ],
                orchid: [
                    218,
                    112,
                    214,
                    1
                ],
                palegoldenrod: [
                    238,
                    232,
                    170,
                    1
                ],
                palegreen: [
                    152,
                    251,
                    152,
                    1
                ],
                paleturquoise: [
                    175,
                    238,
                    238,
                    1
                ],
                palevioletred: [
                    219,
                    112,
                    147,
                    1
                ],
                papayawhip: [
                    255,
                    239,
                    213,
                    1
                ],
                peachpuff: [
                    255,
                    218,
                    185,
                    1
                ],
                peru: [
                    205,
                    133,
                    63,
                    1
                ],
                pink: [
                    255,
                    192,
                    203,
                    1
                ],
                plum: [
                    221,
                    160,
                    221,
                    1
                ],
                powderblue: [
                    176,
                    224,
                    230,
                    1
                ],
                purple: [
                    128,
                    0,
                    128,
                    1
                ],
                rebeccapurple: [
                    102,
                    51,
                    153,
                    1
                ],
                red: [
                    255,
                    0,
                    0,
                    1
                ],
                rosybrown: [
                    188,
                    143,
                    143,
                    1
                ],
                royalblue: [
                    65,
                    105,
                    225,
                    1
                ],
                saddlebrown: [
                    139,
                    69,
                    19,
                    1
                ],
                salmon: [
                    250,
                    128,
                    114,
                    1
                ],
                sandybrown: [
                    244,
                    164,
                    96,
                    1
                ],
                seagreen: [
                    46,
                    139,
                    87,
                    1
                ],
                seashell: [
                    255,
                    245,
                    238,
                    1
                ],
                sienna: [
                    160,
                    82,
                    45,
                    1
                ],
                silver: [
                    192,
                    192,
                    192,
                    1
                ],
                skyblue: [
                    135,
                    206,
                    235,
                    1
                ],
                slateblue: [
                    106,
                    90,
                    205,
                    1
                ],
                slategray: [
                    112,
                    128,
                    144,
                    1
                ],
                slategrey: [
                    112,
                    128,
                    144,
                    1
                ],
                snow: [
                    255,
                    250,
                    250,
                    1
                ],
                springgreen: [
                    0,
                    255,
                    127,
                    1
                ],
                steelblue: [
                    70,
                    130,
                    180,
                    1
                ],
                tan: [
                    210,
                    180,
                    140,
                    1
                ],
                teal: [
                    0,
                    128,
                    128,
                    1
                ],
                thistle: [
                    216,
                    191,
                    216,
                    1
                ],
                tomato: [
                    255,
                    99,
                    71,
                    1
                ],
                turquoise: [
                    64,
                    224,
                    208,
                    1
                ],
                violet: [
                    238,
                    130,
                    238,
                    1
                ],
                wheat: [
                    245,
                    222,
                    179,
                    1
                ],
                white: [
                    255,
                    255,
                    255,
                    1
                ],
                whitesmoke: [
                    245,
                    245,
                    245,
                    1
                ],
                yellow: [
                    255,
                    255,
                    0,
                    1
                ],
                yellowgreen: [
                    154,
                    205,
                    50,
                    1
                ]
            };
            function t1(e1) {
                return (e1 = Math.round(e1)) < 0 ? 0 : e1 > 255 ? 255 : e1;
            }
            function r(e1) {
                return t1("%" === e1[e1.length - 1] ? parseFloat(e1) / 100 * 255 : parseInt(e1));
            }
            function n(e1) {
                var t1;
                return (t1 = "%" === e1[e1.length - 1] ? parseFloat(e1) / 100 : parseFloat(e1)) < 0 ? 0 : t1 > 1 ? 1 : t1;
            }
            function i(e1, t1, r) {
                return r < 0 ? r += 1 : r > 1 && (r -= 1), 6 * r < 1 ? e1 + (t1 - e1) * r * 6 : 2 * r < 1 ? t1 : 3 * r < 2 ? e1 + (t1 - e1) * (2 / 3 - r) * 6 : e1;
            }
            try {
                cr.parseCSSColor = function(s) {
                    var a, o = s.replace(/ /g, "").toLowerCase();
                    if (o in e1) return e1[o].slice();
                    if ("#" === o[0]) return 4 === o.length ? (a = parseInt(o.substr(1), 16)) >= 0 && a <= 4095 ? [
                        (3840 & a) >> 4 | (3840 & a) >> 8,
                        240 & a | (240 & a) >> 4,
                        15 & a | (15 & a) << 4,
                        1
                    ] : null : 7 === o.length && (a = parseInt(o.substr(1), 16)) >= 0 && a <= 16777215 ? [
                        (16711680 & a) >> 16,
                        (65280 & a) >> 8,
                        255 & a,
                        1
                    ] : null;
                    var l = o.indexOf("("), u = o.indexOf(")");
                    if (-1 !== l && u + 1 === o.length) {
                        var c = o.substr(0, l), h = o.substr(l + 1, u - (l + 1)).split(","), d = 1;
                        switch(c){
                            case "rgba":
                                if (4 !== h.length) return null;
                                d = n(h.pop());
                            case "rgb":
                                return 3 !== h.length ? null : [
                                    r(h[0]),
                                    r(h[1]),
                                    r(h[2]),
                                    d
                                ];
                            case "hsla":
                                if (4 !== h.length) return null;
                                d = n(h.pop());
                            case "hsl":
                                if (3 !== h.length) return null;
                                var p = (parseFloat(h[0]) % 360 + 360) % 360 / 360, f = n(h[1]), m = n(h[2]), y = m <= .5 ? m * (f + 1) : m + f - m * f, g = 2 * m - y;
                                return [
                                    t1(255 * i(g, y, p + 1 / 3)),
                                    t1(255 * i(g, y, p)),
                                    t1(255 * i(g, y, p - 1 / 3)),
                                    d
                                ];
                            default:
                                return null;
                        }
                    }
                    return null;
                };
            } catch (e1) {}
            return cr;
        }();
        class dr {
            constructor(e1, t1, r, n = 1){
                this.r = e1, this.g = t1, this.b = r, this.a = n;
            }
            static parse(e1) {
                if (!e1) return;
                if (e1 instanceof dr) return e1;
                if ("string" != typeof e1) return;
                const t1 = hr.parseCSSColor(e1);
                return t1 ? new dr(t1[0] / 255, t1[1] / 255, t1[2] / 255, t1[3]) : void 0;
            }
            toString() {
                const [e1, t1, r, n] = [
                    this.r,
                    this.g,
                    this.b,
                    this.a
                ];
                return `rgba(${Math.round(255 * e1)},${Math.round(255 * t1)},${Math.round(255 * r)},${n})`;
            }
            toNonPremultipliedRenderColor(e1) {
                const { r: t1, g: r, b: n, a: i } = this;
                return new fr(e1, t1, r, n, i);
            }
            toPremultipliedRenderColor(e1) {
                const { r: t1, g: r, b: n, a: i } = this;
                return new mr(e1, t1 * i, r * i, n * i, i);
            }
            clone() {
                return new dr(this.r, this.g, this.b, this.a);
            }
        }
        class pr {
            constructor(e1, t1, r, n, i, s = !1){
                if (this.premultiplied = !1, this.premultiplied = s, e1) {
                    const s = e1.image.height, a = s * s;
                    this.premultiplied ? (t1 = 0 === i ? 0 : t1 / i * (s - 1), r = 0 === i ? 0 : r / i * (s - 1), n = 0 === i ? 0 : n / i * (s - 1)) : (t1 *= s - 1, r *= s - 1, n *= s - 1), t1 = Math.max(0, Math.min(s - 1, t1)), r = Math.max(0, Math.min(s - 1, r)), n = Math.max(0, Math.min(s - 1, n));
                    const o = Math.floor(t1), l = Math.floor(r), u = Math.floor(n), c = Math.ceil(t1), h = Math.ceil(r), d = Math.ceil(n), p = t1 - o, f = r - l, m = n - u, y = e1.image.data, g = 4 * (o + l * a + u * s), x = 4 * (o + l * a + d * s), v = 4 * (o + h * a + u * s), b = 4 * (o + h * a + d * s), w = 4 * (c + l * a + u * s), _ = 4 * (c + l * a + d * s), A = 4 * (c + h * a + u * s), I = 4 * (c + h * a + d * s);
                    this.r = yr(yr(yr(y[g], y[x], m), yr(y[v], y[b], m), f), yr(yr(y[w], y[_], m), yr(y[A], y[I], m), f), p) / 255 * (this.premultiplied ? i : 1), this.g = yr(yr(yr(y[g + 1], y[x + 1], m), yr(y[v + 1], y[b + 1], m), f), yr(yr(y[w + 1], y[_ + 1], m), yr(y[A + 1], y[I + 1], m), f), p) / 255 * (this.premultiplied ? i : 1), this.b = yr(yr(yr(y[g + 2], y[x + 2], m), yr(y[v + 2], y[b + 2], m), f), yr(yr(y[w + 2], y[_ + 2], m), yr(y[A + 2], y[I + 2], m), f), p) / 255 * (this.premultiplied ? i : 1), this.a = i;
                } else this.r = t1, this.g = r, this.b = n, this.a = i;
            }
            toArray() {
                const { r: e1, g: t1, b: r, a: n } = this;
                return [
                    255 * e1,
                    255 * t1,
                    255 * r,
                    n
                ];
            }
            toHslaArray() {
                let { r: e1, g: t1, b: r, a: n } = this;
                if (this.premultiplied) {
                    if (0 === n) return [
                        0,
                        0,
                        0,
                        0
                    ];
                    const i = 1 / n;
                    e1 *= i, t1 *= i, r *= i;
                }
                const i = Math.min(Math.max(e1, 0), 1), s = Math.min(Math.max(t1, 0), 1), a = Math.min(Math.max(r, 0), 1), o = Math.min(i, s, a), l = Math.max(i, s, a), u = l - o, c = .5 * (o + l);
                if (0 === u) return [
                    0,
                    0,
                    100 * c,
                    n
                ];
                const h = c > .5 ? u / (2 - l - o) : u / (l + o);
                let d;
                switch(l){
                    case i:
                        d = 60 * ((s - a) / u + (s < a ? 6 : 0));
                        break;
                    case s:
                        d = 60 * ((a - i) / u + 2);
                        break;
                    default:
                        d = 60 * ((i - s) / u + 4);
                }
                return [
                    d,
                    100 * h,
                    100 * c,
                    n
                ];
            }
            toArray01() {
                const { r: e1, g: t1, b: r, a: n } = this;
                return [
                    e1,
                    t1,
                    r,
                    n
                ];
            }
            toArray01Scaled(e1) {
                const { r: t1, g: r, b: n } = this;
                return [
                    t1 * e1,
                    r * e1,
                    n * e1
                ];
            }
            toArray01Linear() {
                const { r: e1, g: t1, b: r, a: n } = this;
                return [
                    Math.pow(e1, 2.2),
                    Math.pow(t1, 2.2),
                    Math.pow(r, 2.2),
                    n
                ];
            }
        }
        class fr extends pr {
            constructor(e1, t1, r, n, i){
                super(e1, t1, r, n, i, !1);
            }
        }
        class mr extends pr {
            constructor(e1, t1, r, n, i){
                super(e1, t1, r, n, i, !0);
            }
        }
        function yr(e1, t1, r) {
            return e1 * (1 - r) + t1 * r;
        }
        function gr(e1, t1, r) {
            return e1.map((e1, n)=>yr(e1, t1[n], r));
        }
        dr.black = new dr(0, 0, 0, 1), dr.white = new dr(1, 1, 1, 1), dr.transparent = new dr(0, 0, 0, 0), dr.red = new dr(1, 0, 0, 1), dr.blue = new dr(0, 0, 1, 1);
        var xr = Object.freeze({
            __proto__: null,
            array: gr,
            color: function(e1, t1, r) {
                return new dr(yr(e1.r, t1.r, r), yr(e1.g, t1.g, r), yr(e1.b, t1.b, r), yr(e1.a, t1.a, r));
            },
            number: yr
        });
        class vr extends Error {
            constructor(e1, t1){
                super(t1), this.message = t1, this.key = e1;
            }
        }
        class br {
            constructor(e1, t1 = []){
                this.parent = e1, this.bindings = {};
                for (const [e1, r] of t1)this.bindings[e1] = r;
            }
            concat(e1) {
                return new br(this, e1);
            }
            get(e1) {
                if (this.bindings[e1]) return this.bindings[e1];
                if (this.parent) return this.parent.get(e1);
                throw new Error(`${e1} not found in scope.`);
            }
            has(e1) {
                return !!this.bindings[e1] || !!this.parent && this.parent.has(e1);
            }
        }
        const wr = {
            kind: "null"
        }, _r = {
            kind: "number"
        }, Ar = {
            kind: "string"
        }, Ir = {
            kind: "boolean"
        }, Mr = {
            kind: "color"
        }, Br = {
            kind: "object"
        }, Sr = {
            kind: "value"
        }, Pr = {
            kind: "collator"
        }, Tr = {
            kind: "formatted"
        }, zr = {
            kind: "resolvedImage"
        };
        function kr(e1, t1) {
            return {
                kind: "array",
                itemType: e1,
                N: t1
            };
        }
        function Vr(e1) {
            if ("array" === e1.kind) {
                const t1 = Vr(e1.itemType);
                return "number" == typeof e1.N ? `array<${t1}, ${e1.N}>` : "value" === e1.itemType.kind ? "array" : `array<${t1}>`;
            }
            return e1.kind;
        }
        const Fr = [
            wr,
            _r,
            Ar,
            Ir,
            Mr,
            Tr,
            Br,
            kr(Sr),
            zr
        ];
        function Dr(e1, t1) {
            if ("error" === t1.kind) return null;
            if ("array" === e1.kind) {
                if ("array" === t1.kind && (0 === t1.N && "value" === t1.itemType.kind || !Dr(e1.itemType, t1.itemType)) && ("number" != typeof e1.N || e1.N === t1.N)) return null;
            } else {
                if (e1.kind === t1.kind) return null;
                if ("value" === e1.kind) {
                    for (const e1 of Fr)if (!Dr(e1, t1)) return null;
                }
            }
            return `Expected ${Vr(e1)} but found ${Vr(t1)} instead.`;
        }
        function Er(e1, t1) {
            return t1.some((t1)=>t1.kind === e1.kind);
        }
        function Cr(e1, t1) {
            return t1.some((t1)=>"null" === t1 ? null === e1 : "array" === t1 ? Array.isArray(e1) : "object" === t1 ? e1 && !Array.isArray(e1) && "object" == typeof e1 : t1 === typeof e1);
        }
        function Rr(e1, t1) {
            return "array" === e1.kind && "array" === t1.kind ? e1.N === t1.N && Rr(e1.itemType, t1.itemType) : e1.kind === t1.kind;
        }
        class Lr {
            constructor(e1, t1, r){
                this.sensitivity = e1 ? t1 ? "variant" : "case" : t1 ? "accent" : "base", this.locale = r, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                    sensitivity: this.sensitivity,
                    usage: "search"
                });
            }
            compare(e1, t1) {
                return this.collator.compare(e1, t1);
            }
            resolvedLocale() {
                return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
            }
        }
        class Or {
            constructor(e1, t1, r, n, i){
                this.text = e1.normalize ? e1.normalize() : e1, this.image = t1, this.scale = r, this.fontStack = n, this.textColor = i;
            }
        }
        class Ur {
            constructor(e1){
                this.sections = e1;
            }
            static fromString(e1) {
                return new Ur([
                    new Or(e1, null, null, null, null)
                ]);
            }
            isEmpty() {
                return 0 === this.sections.length || !this.sections.some((e1)=>0 !== e1.text.length || !!e1.image && e1.image.hasPrimary());
            }
            static factory(e1) {
                return e1 instanceof Ur ? e1 : Ur.fromString(e1);
            }
            toString() {
                return 0 === this.sections.length ? "" : this.sections.map((e1)=>e1.text).join("");
            }
            serialize() {
                const e1 = [
                    "format"
                ];
                for (const t1 of this.sections){
                    if (t1.image) {
                        const r = t1.image.getPrimary().id.toString();
                        e1.push([
                            "image",
                            r
                        ]);
                        continue;
                    }
                    e1.push(t1.text);
                    const r = {};
                    t1.fontStack && (r["text-font"] = [
                        "literal",
                        t1.fontStack.split(",")
                    ]), t1.scale && (r["font-scale"] = t1.scale), t1.textColor && (r["text-color"] = [
                        "rgba"
                    ].concat(t1.textColor.toNonPremultipliedRenderColor(null).toArray())), e1.push(r);
                }
                return e1;
            }
        }
        class Nr {
            constructor(e1, t1 = {}){
                this.id = lr.from(e1), this.params = t1.params, this.sx = t1.sx || 1, this.sy = t1.sy || 1;
            }
            toString() {
                return JSON.stringify(this);
            }
            static parse(e1) {
                let t1, r, n, i;
                try {
                    ({ id: t1, params: r, sx: n, sy: i } = JSON.parse(e1) || {});
                } catch (e1) {
                    return null;
                }
                return t1 ? new Nr(t1, {
                    params: r,
                    sx: n,
                    sy: i
                }) : null;
            }
            scaleSelf(e1, t1 = e1) {
                return this.sx *= e1, this.sy *= t1, this;
            }
        }
        class jr {
            constructor(e1, t1, r, n, i = !1){
                this.primaryId = lr.from(e1), this.primaryOptions = t1, r && (this.secondaryId = lr.from(r)), this.secondaryOptions = n, this.available = i;
            }
            toString() {
                return this.primaryId && this.secondaryId ? `[${this.primaryId.name},${this.secondaryId.name}]` : this.primaryId.name;
            }
            hasPrimary() {
                return !!this.primaryId;
            }
            getPrimary() {
                return new Nr(this.primaryId, this.primaryOptions);
            }
            hasSecondary() {
                return !!this.secondaryId;
            }
            getSecondary() {
                return this.secondaryId ? new Nr(this.secondaryId, this.secondaryOptions) : null;
            }
            static from(e1) {
                return "string" == typeof e1 ? jr.build({
                    name: e1
                }) : e1;
            }
            static build(e1, t1, r, n) {
                return !e1 || "object" == typeof e1 && !("name" in e1) ? null : new jr(e1, r, t1, n);
            }
        }
        function Gr(e1, t1, r, n) {
            return "number" == typeof e1 && e1 >= 0 && e1 <= 255 && "number" == typeof t1 && t1 >= 0 && t1 <= 255 && "number" == typeof r && r >= 0 && r <= 255 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : `Invalid rgba value [${[
                e1,
                t1,
                r,
                n
            ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof n ? [
                e1,
                t1,
                r,
                n
            ] : [
                e1,
                t1,
                r
            ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
        }
        function $r(e1) {
            if (null === e1) return !0;
            if ("string" == typeof e1) return !0;
            if ("boolean" == typeof e1) return !0;
            if ("number" == typeof e1) return !0;
            if (e1 instanceof dr) return !0;
            if (e1 instanceof Lr) return !0;
            if (e1 instanceof Ur) return !0;
            if (e1 instanceof jr) return !0;
            if (Array.isArray(e1)) {
                for (const t1 of e1)if (!$r(t1)) return !1;
                return !0;
            }
            if ("object" == typeof e1) {
                for(const t1 in e1)if (!$r(e1[t1])) return !1;
                return !0;
            }
            return !1;
        }
        function qr(e1) {
            if (null === e1) return wr;
            if ("string" == typeof e1) return Ar;
            if ("boolean" == typeof e1) return Ir;
            if ("number" == typeof e1) return _r;
            if (e1 instanceof dr) return Mr;
            if (e1 instanceof Lr) return Pr;
            if (e1 instanceof Ur) return Tr;
            if (e1 instanceof jr) return zr;
            if (Array.isArray(e1)) {
                const t1 = e1.length;
                let r;
                for (const t1 of e1){
                    const e1 = qr(t1);
                    if (r) {
                        if (r === e1) continue;
                        r = Sr;
                        break;
                    }
                    r = e1;
                }
                return kr(r || Sr, t1);
            }
            return Br;
        }
        function Hr(e1) {
            const t1 = typeof e1;
            return null === e1 ? "" : "string" === t1 || "number" === t1 || "boolean" === t1 ? String(e1) : e1 instanceof Ur || e1 instanceof jr || e1 instanceof dr ? e1.toString() : JSON.stringify(e1);
        }
        class Xr {
            constructor(e1, t1){
                this.type = e1, this.value = t1;
            }
            static parse(e1, t1) {
                if (2 !== e1.length) return t1.error(`'literal' expression requires exactly one argument, but found ${e1.length - 1} instead.`);
                if (!$r(e1[1])) return t1.error("invalid value");
                const r = e1[1];
                let n = qr(r);
                const i = t1.expectedType;
                return "array" !== n.kind || 0 !== n.N || !i || "array" !== i.kind || "number" == typeof i.N && 0 !== i.N || (n = i), new Xr(n, r);
            }
            evaluate() {
                return this.value;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return "array" === this.type.kind || "object" === this.type.kind ? [
                    "literal",
                    this.value
                ] : this.value instanceof dr ? [
                    "rgba"
                ].concat(this.value.toNonPremultipliedRenderColor(null).toArray()) : this.value instanceof Ur ? this.value.serialize() : this.value;
            }
        }
        class Zr {
            constructor(e1){
                this.name = "ExpressionEvaluationError", this.message = e1;
            }
            toJSON() {
                return this.message;
            }
        }
        const Wr = {
            string: Ar,
            number: _r,
            boolean: Ir,
            object: Br
        };
        class Yr {
            constructor(e1, t1){
                this.type = e1, this.args = t1;
            }
            static parse(e1, t1) {
                if (e1.length < 2) return t1.error("Expected at least one argument.");
                let r, n = 1;
                const i = e1[0];
                if ("array" === i) {
                    let i, s;
                    if (e1.length > 2) {
                        const r = e1[1];
                        if ("string" != typeof r || !(r in Wr) || "object" === r) return t1.error('The item type argument of "array" must be one of string, number, boolean', 1);
                        i = Wr[r], n++;
                    } else i = Sr;
                    if (e1.length > 3) {
                        if (null !== e1[2] && ("number" != typeof e1[2] || e1[2] < 0 || e1[2] !== Math.floor(e1[2]))) return t1.error('The length argument to "array" must be a positive integer literal', 2);
                        s = e1[2], n++;
                    }
                    r = kr(i, s);
                } else r = Wr[i];
                const s = [];
                for(; n < e1.length; n++){
                    const r = t1.parse(e1[n], n, Sr);
                    if (!r) return null;
                    s.push(r);
                }
                return new Yr(r, s);
            }
            evaluate(e1) {
                for(let t1 = 0; t1 < this.args.length; t1++){
                    const r = this.args[t1].evaluate(e1);
                    if (!Dr(this.type, qr(r))) return r;
                    if (t1 === this.args.length - 1) throw new Zr(`The expression ${JSON.stringify(this.args[t1].serialize())} evaluated to ${Vr(qr(r))} but was expected to be of type ${Vr(this.type)}.`);
                }
                return null;
            }
            eachChild(e1) {
                this.args.forEach(e1);
            }
            outputDefined() {
                return this.args.every((e1)=>e1.outputDefined());
            }
            serialize() {
                const e1 = this.type, t1 = [
                    e1.kind
                ];
                if ("array" === e1.kind) {
                    const r = e1.itemType;
                    if ("string" === r.kind || "number" === r.kind || "boolean" === r.kind) {
                        t1.push(r.kind);
                        const n = e1.N;
                        ("number" == typeof n || this.args.length > 1) && t1.push(n);
                    }
                }
                return t1.concat(this.args.map((e1)=>e1.serialize()));
            }
        }
        class Jr {
            constructor(e1){
                this.type = Tr, this.sections = e1;
            }
            static parse(e1, t1) {
                if (e1.length < 2) return t1.error("Expected at least one argument.");
                const r = e1[1];
                if (!Array.isArray(r) && "object" == typeof r) return t1.error("First argument must be an image or text section.");
                const n = [];
                let i = !1;
                for(let r = 1; r <= e1.length - 1; ++r){
                    const s = e1[r];
                    if (i && "object" == typeof s && !Array.isArray(s)) {
                        i = !1;
                        let e1 = null;
                        if (s["font-scale"] && (e1 = t1.parseObjectValue(s["font-scale"], r, "font-scale", _r), !e1)) return null;
                        let a = null;
                        if (s["text-font"] && (a = t1.parseObjectValue(s["text-font"], r, "text-font", kr(Ar)), !a)) return null;
                        let o = null;
                        if (s["text-color"] && (o = t1.parseObjectValue(s["text-color"], r, "text-color", Mr), !o)) return null;
                        const l = n[n.length - 1];
                        l.scale = e1, l.font = a, l.textColor = o;
                    } else {
                        const s = t1.parse(e1[r], r, Sr);
                        if (!s) return null;
                        const a = s.type.kind;
                        if ("string" !== a && "value" !== a && "null" !== a && "resolvedImage" !== a) return t1.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                        i = !0, n.push({
                            content: s,
                            scale: null,
                            font: null,
                            textColor: null
                        });
                    }
                }
                return new Jr(n);
            }
            evaluate(e1) {
                return new Ur(this.sections.map((t1)=>{
                    const r = t1.content.evaluate(e1);
                    return Rr(qr(r), zr) ? new Or("", r, null, null, null) : new Or(Hr(r), null, t1.scale ? t1.scale.evaluate(e1) : null, t1.font ? t1.font.evaluate(e1).join(",") : null, t1.textColor ? t1.textColor.evaluate(e1) : null);
                }));
            }
            eachChild(e1) {
                for (const t1 of this.sections)e1(t1.content), t1.scale && e1(t1.scale), t1.font && e1(t1.font), t1.textColor && e1(t1.textColor);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const e1 = [
                    "format"
                ];
                for (const t1 of this.sections){
                    e1.push(t1.content.serialize());
                    const r = {};
                    t1.scale && (r["font-scale"] = t1.scale.serialize()), t1.font && (r["text-font"] = t1.font.serialize()), t1.textColor && (r["text-color"] = t1.textColor.serialize()), e1.push(r);
                }
                return e1;
            }
        }
        class Kr {
            constructor(e1, t1, r, n){
                this._imageWarnHistory = {}, this.type = zr, this.namePrimary = e1, this.nameSecondary = t1, r && (this.paramsPrimary = r.params, this.iconsetIdPrimary = r.iconset ? r.iconset.id : void 0), n && (this.paramsSecondary = n.params, this.iconsetIdSecondary = n.iconset ? n.iconset.id : void 0);
            }
            static parse(e1, t1) {
                if (e1.length < 2) return t1.error("Expected two or more arguments.");
                let r = 1;
                const n = [];
                function i() {
                    if (r < e1.length) {
                        const i = t1.parse(e1[r], r++, Ar);
                        return i ? (n.push({
                            image: i,
                            options: {}
                        }), !0) : (t1.error(n.length ? "Secondary image variant is not a string." : "No image name provided."), !1);
                    }
                    return !0;
                }
                function s() {
                    if (r < e1.length) {
                        const s = e1[r];
                        if (null === (i = s) || "object" != typeof i || Array.isArray(i)) return !0;
                        const a = s.params, o = s.iconset, l = t1.concat(r);
                        if (!a && !o) return r++, !0;
                        if (a) {
                            if ("object" != typeof a || a.constructor !== Object) return l.error('Image options "params" should be an object'), !1;
                            const e1 = {}, t1 = l.concat(void 0, "params");
                            for(const r in a){
                                if (!r) return t1.error("Image parameter name should be non-empty"), !1;
                                const n = t1.concat(void 0, r).parse(a[r], void 0, Mr, void 0, {
                                    typeAnnotation: "coerce"
                                });
                                if (!n) return !1;
                                e1[r] = n;
                            }
                            n[n.length - 1].options.params = e1;
                        }
                        if (o) {
                            if ("object" != typeof o || o.constructor !== Object) return l.error('Image options "iconset" should be an object'), !1;
                            if (!o.id) return l.error('Image options "iconset" should have an "id" property'), !1;
                            n[n.length - 1].options.iconset = o;
                        }
                        return r++, !0;
                    }
                    var i;
                    return !0;
                }
                for(let e1 = 0; e1 < 2; e1++)if (!i() || !s()) return;
                return new Kr(n[0].image, n[1] ? n[1].image : void 0, n[0].options, n[1] ? n[1].options : void 0);
            }
            evaluateParams(e1, t1) {
                const r = {};
                if (t1) {
                    for(const n in t1)if (t1[n]) try {
                        r[n] = t1[n].evaluate(e1);
                    } catch (e1) {
                        continue;
                    }
                    if (0 !== Object.keys(r).length) return {
                        params: r
                    };
                }
            }
            evaluate(e1) {
                const t1 = {
                    name: this.namePrimary.evaluate(e1),
                    iconsetId: this.iconsetIdPrimary
                }, r = this.nameSecondary ? {
                    name: this.nameSecondary.evaluate(e1),
                    iconsetId: this.iconsetIdSecondary
                } : void 0, n = jr.build(t1, r, this.paramsPrimary ? this.evaluateParams(e1, this.paramsPrimary) : void 0, this.paramsSecondary ? this.evaluateParams(e1, this.paramsSecondary) : void 0);
                if (n && e1.availableImages) {
                    const t1 = n.getPrimary().id;
                    if (n.available = e1.availableImages.some((e1)=>lr.isEqual(e1, t1)), n.available) {
                        const t1 = n.getSecondary() ? n.getSecondary().id : null;
                        t1 && (n.available = e1.availableImages.some((e1)=>lr.isEqual(e1, t1)));
                    }
                }
                return n;
            }
            eachChild(e1) {
                if (e1(this.namePrimary), this.paramsPrimary) for(const t1 in this.paramsPrimary)this.paramsPrimary[t1] && e1(this.paramsPrimary[t1]);
                if (this.nameSecondary && (e1(this.nameSecondary), this.paramsSecondary)) for(const t1 in this.paramsSecondary)this.paramsSecondary[t1] && e1(this.paramsSecondary[t1]);
            }
            outputDefined() {
                return !1;
            }
            serializeOptions(e1, t1) {
                const r = {};
                if (t1 && (r.iconset = {
                    id: t1
                }), e1) {
                    r.params = {};
                    for(const t1 in e1)e1[t1] && (r.params[t1] = e1[t1].serialize());
                }
                return Object.keys(r).length > 0 ? r : void 0;
            }
            serialize() {
                const e1 = [
                    "image",
                    this.namePrimary.serialize()
                ];
                if (this.paramsPrimary || this.iconsetIdPrimary) {
                    const t1 = this.serializeOptions(this.paramsPrimary, this.iconsetIdPrimary);
                    t1 && e1.push(t1);
                }
                if (this.nameSecondary && (e1.push(this.nameSecondary.serialize()), this.paramsSecondary || this.iconsetIdSecondary)) {
                    const t1 = this.serializeOptions(this.paramsSecondary, this.iconsetIdSecondary);
                    t1 && e1.push(t1);
                }
                return e1;
            }
        }
        function Qr(e1) {
            return tn(e1) ? "string" : rn(e1) ? "number" : nn(e1) ? "boolean" : Array.isArray(e1) ? "array" : null === e1 ? "null" : en(e1) ? "object" : typeof e1;
        }
        function en(e1) {
            return null != e1 && !Array.isArray(e1) && "function" != typeof e1 && !(e1 instanceof String || e1 instanceof Number || e1 instanceof Boolean) && "object" == typeof e1;
        }
        function tn(e1) {
            return "string" == typeof e1 || e1 instanceof String;
        }
        function rn(e1) {
            return "number" == typeof e1 || e1 instanceof Number;
        }
        function nn(e1) {
            return "boolean" == typeof e1 || e1 instanceof Boolean;
        }
        const sn = {
            "to-boolean": Ir,
            "to-color": Mr,
            "to-number": _r,
            "to-string": Ar
        };
        class an {
            constructor(e1, t1){
                this.type = e1, this.args = t1;
            }
            static parse(e1, t1) {
                if (e1.length < 2) return t1.error("Expected at least one argument.");
                const r = e1[0], n = [];
                let i = wr;
                if ("to-array" === r) {
                    if (!Array.isArray(e1[1])) return null;
                    const r = e1[1].length;
                    if (t1.expectedType) {
                        if ("array" !== t1.expectedType.kind) return t1.error(`Expected ${t1.expectedType.kind} but found array.`);
                        i = kr(t1.expectedType.itemType, r);
                    } else {
                        if (!(r > 0 && $r(e1[1][0]))) return null;
                        i = kr(qr(e1[1][0]), r);
                    }
                    for(let s = 0; s < r; s++){
                        const r = e1[1][s];
                        let a;
                        if (Array.isArray(r)) a = t1.parse(r, void 0, i.itemType);
                        else {
                            const e1 = Qr(r);
                            if (e1 !== i.itemType.kind) return t1.error(`Expected ${i.itemType.kind} but found ${e1}.`);
                            a = t1.registry.literal.parse([
                                "literal",
                                void 0 === r ? null : r
                            ], t1);
                        }
                        if (!a) return null;
                        n.push(a);
                    }
                } else {
                    if (("to-boolean" === r || "to-string" === r) && 2 !== e1.length) return t1.error("Expected one argument.");
                    i = sn[r];
                    for(let r = 1; r < e1.length; r++){
                        const i = t1.parse(e1[r], r, Sr);
                        if (!i) return null;
                        n.push(i);
                    }
                }
                return new an(i, n);
            }
            evaluate(e1) {
                if ("boolean" === this.type.kind) return Boolean(this.args[0].evaluate(e1));
                if ("color" === this.type.kind) {
                    let t1, r;
                    for (const n of this.args){
                        if (t1 = n.evaluate(e1), r = null, t1 instanceof dr) return t1;
                        if ("string" == typeof t1) {
                            const r = e1.parseColor(t1);
                            if (r) return r;
                        } else if (Array.isArray(t1) && (r = t1.length < 3 || t1.length > 4 ? `Invalid rbga value ${JSON.stringify(t1)}: expected an array containing either three or four numeric values.` : Gr(t1[0], t1[1], t1[2], t1[3]), !r)) return new dr(t1[0] / 255, t1[1] / 255, t1[2] / 255, t1[3]);
                    }
                    throw new Zr(r || `Could not parse color from value '${"string" == typeof t1 ? t1 : String(JSON.stringify(t1))}'`);
                }
                if ("number" === this.type.kind) {
                    let t1 = null;
                    for (const r of this.args){
                        if (t1 = r.evaluate(e1), null === t1) return 0;
                        const n = Number(t1);
                        if (!isNaN(n)) return n;
                    }
                    throw new Zr(`Could not convert ${JSON.stringify(t1)} to number.`);
                }
                return "formatted" === this.type.kind ? Ur.fromString(Hr(this.args[0].evaluate(e1))) : "resolvedImage" === this.type.kind ? jr.build(Hr(this.args[0].evaluate(e1))) : "array" === this.type.kind ? this.args.map((t1)=>t1.evaluate(e1)) : Hr(this.args[0].evaluate(e1));
            }
            eachChild(e1) {
                this.args.forEach(e1);
            }
            outputDefined() {
                return this.args.every((e1)=>e1.outputDefined());
            }
            serialize() {
                if ("formatted" === this.type.kind) return new Jr([
                    {
                        content: this.args[0],
                        scale: null,
                        font: null,
                        textColor: null
                    }
                ]).serialize();
                if ("resolvedImage" === this.type.kind) return new Kr(this.args[0]).serialize();
                const e1 = "array" === this.type.kind ? [] : [
                    `to-${this.type.kind}`
                ];
                return this.eachChild((t1)=>{
                    e1.push(t1.serialize());
                }), e1;
            }
        }
        const on = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        class ln {
            constructor(e1, t1, r){
                this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = {}, this.availableImages = null, this.canonical = null, this.featureTileCoord = null, this.featureDistanceData = null, this.scope = e1, this.options = t1, this.iconImageUseTheme = r;
            }
            id() {
                return this.feature && void 0 !== this.feature.id ? this.feature.id : null;
            }
            geometryType() {
                return this.feature ? "number" == typeof this.feature.type ? on[this.feature.type] : this.feature.type : null;
            }
            geometry() {
                return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
            }
            canonicalID() {
                return this.canonical;
            }
            properties() {
                return this.feature && this.feature.properties || {};
            }
            measureLight(e1) {
                return this.globals.brightness || 0;
            }
            distanceFromCenter() {
                if (this.featureTileCoord && this.featureDistanceData) {
                    const e1 = this.featureDistanceData.center, t1 = this.featureDistanceData.scale, { x: r, y: n } = this.featureTileCoord;
                    return this.featureDistanceData.bearing[0] * (r * t1 - e1[0]) + this.featureDistanceData.bearing[1] * (n * t1 - e1[1]);
                }
                return 0;
            }
            parseColor(e1) {
                let t1 = this._parseColorCache[e1];
                return t1 || (t1 = this._parseColorCache[e1] = dr.parse(e1)), t1;
            }
            getConfig(e1) {
                return this.options ? this.options.get(e1) : null;
            }
        }
        class un {
            constructor(e1, t1, r, n, i){
                this.name = e1, this.type = t1, this._evaluate = r, this.args = n, this._overloadIndex = i;
            }
            evaluate(e1) {
                if (!this._evaluate) {
                    const e1 = un.definitions[this.name];
                    this._evaluate = Array.isArray(e1) ? e1[2] : e1.overloads[this._overloadIndex][1];
                }
                return this._evaluate(e1, this.args);
            }
            eachChild(e1) {
                this.args.forEach(e1);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    this.name
                ].concat(this.args.map((e1)=>e1.serialize()));
            }
            static parse(e1, t1) {
                const r = e1[0], n = un.definitions[r];
                if (!n) return t1.error(`Unknown expression "${r}". If you wanted a literal array, use ["literal", [...]].`, 0);
                const i = Array.isArray(n) ? n[0] : n.type, s = Array.isArray(n) ? [
                    [
                        n[1],
                        n[2]
                    ]
                ] : n.overloads, a = [];
                let o = null, l = -1;
                for (const [n, u] of s){
                    if (Array.isArray(n) && n.length !== e1.length - 1) continue;
                    a.push(n), l++, o = new Pi(t1.registry, t1.path, null, t1.scope, void 0, t1._scope, t1.options, t1.iconImageUseTheme);
                    const s = [];
                    let c = !1;
                    for(let t1 = 1; t1 < e1.length; t1++){
                        const r = e1[t1], i = Array.isArray(n) ? n[t1 - 1] : n.type, a = o.parse(r, 1 + s.length, i);
                        if (!a) {
                            c = !0;
                            break;
                        }
                        s.push(a);
                    }
                    if (!c) {
                        if (Array.isArray(n) && n.length !== s.length) o.error(`Expected ${n.length} arguments, but found ${s.length} instead.`);
                        else {
                            for(let e1 = 0; e1 < s.length; e1++){
                                const t1 = Array.isArray(n) ? n[e1] : n.type, r = s[e1];
                                o.concat(e1 + 1).checkSubtype(t1, r.type);
                            }
                            if (0 === o.errors.length) return new un(r, i, u, s, l);
                        }
                    }
                }
                if (1 === a.length) t1.errors.push(...o.errors);
                else {
                    const r = (a.length ? a : s.map(([e1])=>e1)).map(cn).join(" | "), n = [];
                    for(let r = 1; r < e1.length; r++){
                        const i = t1.parse(e1[r], 1 + n.length);
                        if (!i) return null;
                        n.push(Vr(i.type));
                    }
                    t1.error(`Expected arguments of type ${r}, but found (${n.join(", ")}) instead.`);
                }
                return null;
            }
            static register(e1, t1) {
                un.definitions = t1;
                for(const r in t1)e1[r] = un;
            }
        }
        function cn(e1) {
            return Array.isArray(e1) ? `(${e1.map(Vr).join(", ")})` : `(${Vr(e1.type)}...)`;
        }
        class hn {
            constructor(e1, t1, r){
                this.type = Pr, this.locale = r, this.caseSensitive = e1, this.diacriticSensitive = t1;
            }
            static parse(e1, t1) {
                if (2 !== e1.length) return t1.error("Expected one argument."), null;
                const r = e1[1];
                if ("object" != typeof r || Array.isArray(r)) return t1.error("Collator options argument must be an object."), null;
                const n = void 0 === r["case-sensitive"] ? t1.parse(!1, 1, Ir) : t1.parseObjectValue(r["case-sensitive"], 1, "case-sensitive", Ir);
                if (!n) return null;
                const i = void 0 === r["diacritic-sensitive"] ? t1.parse(!1, 1, Ir) : t1.parseObjectValue(r["diacritic-sensitive"], 1, "diacritic-sensitive", Ir);
                if (!i) return null;
                let s = null;
                return r.locale && (s = t1.parseObjectValue(r.locale, 1, "locale", Ar), !s) ? null : new hn(n, i, s);
            }
            evaluate(e1) {
                return new Lr(this.caseSensitive.evaluate(e1), this.diacriticSensitive.evaluate(e1), this.locale ? this.locale.evaluate(e1) : null);
            }
            eachChild(e1) {
                e1(this.caseSensitive), e1(this.diacriticSensitive), this.locale && e1(this.locale);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const e1 = {};
                return e1["case-sensitive"] = this.caseSensitive.serialize(), e1["diacritic-sensitive"] = this.diacriticSensitive.serialize(), this.locale && (e1.locale = this.locale.serialize()), [
                    "collator",
                    e1
                ];
            }
        }
        function dn(e1, t1, r = 0, n = e1.length - 1, i = fn) {
            for(; n > r;){
                if (n - r > 600) {
                    const s = n - r + 1, a = t1 - r + 1, o = Math.log(s), l = .5 * Math.exp(2 * o / 3), u = .5 * Math.sqrt(o * l * (s - l) / s) * (a - s / 2 < 0 ? -1 : 1);
                    dn(e1, t1, Math.max(r, Math.floor(t1 - a * l / s + u)), Math.min(n, Math.floor(t1 + (s - a) * l / s + u)), i);
                }
                const s = e1[t1];
                let a = r, o = n;
                for(pn(e1, r, t1), i(e1[n], s) > 0 && pn(e1, r, n); a < o;){
                    for(pn(e1, a, o), a++, o--; i(e1[a], s) < 0;)a++;
                    for(; i(e1[o], s) > 0;)o--;
                }
                0 === i(e1[r], s) ? pn(e1, r, o) : (o++, pn(e1, o, n)), o <= t1 && (r = o + 1), t1 <= o && (n = o - 1);
            }
        }
        function pn(e1, t1, r) {
            const n = e1[t1];
            e1[t1] = e1[r], e1[r] = n;
        }
        function fn(e1, t1) {
            return e1 < t1 ? -1 : e1 > t1 ? 1 : 0;
        }
        function mn(e1) {
            let t1 = 0;
            for(let r, n, i = 0, s = e1.length, a = s - 1; i < s; a = i++)r = e1[i], n = e1[a], t1 += (n.x - r.x) * (r.y + n.y);
            return t1;
        }
        function yn(e1, t1) {
            e1[0] = Math.min(e1[0], t1[0]), e1[1] = Math.min(e1[1], t1[1]), e1[2] = Math.max(e1[2], t1[0]), e1[3] = Math.max(e1[3], t1[1]);
        }
        function gn(e1, t1) {
            return !(e1[0] <= t1[0] || e1[2] >= t1[2] || e1[1] <= t1[1] || e1[3] >= t1[3]);
        }
        function xn(e1, t1, r) {
            const n = e1[0] - t1[0], i = e1[1] - t1[1], s = e1[0] - r[0], a = e1[1] - r[1];
            return n * a - s * i === 0 && n * s <= 0 && i * a <= 0;
        }
        function vn(e1, t1, r) {
            return t1[1] > e1[1] != r[1] > e1[1] && e1[0] < (r[0] - t1[0]) * (e1[1] - t1[1]) / (r[1] - t1[1]) + t1[0];
        }
        function bn(e1, t1, r = !1) {
            let n = !1;
            for(let i = 0, s = t1.length; i < s; i++){
                const s = t1[i];
                for(let t1 = 0, i = s.length, a = i - 1; t1 < i; a = t1++){
                    const i = s[a], o = s[t1];
                    if (xn(e1, i, o)) return r;
                    vn(e1, i, o) && (n = !n);
                }
            }
            return n;
        }
        function wn(e1, t1, r, n) {
            const i = n[0] - r[0], s = n[1] - r[1], a = (e1[0] - r[0]) * s - i * (e1[1] - r[1]), o = (t1[0] - r[0]) * s - i * (t1[1] - r[1]);
            return a > 0 && o < 0 || a < 0 && o > 0;
        }
        function _n(e1, t1, r, n) {
            var i, s;
            return 0 !== (i = [
                n[0] - r[0],
                n[1] - r[1]
            ])[0] * (s = [
                t1[0] - e1[0],
                t1[1] - e1[1]
            ])[1] - i[1] * s[0] && !(!wn(e1, t1, r, n) || !wn(r, n, e1, t1));
        }
        function An(e1) {
            const t1 = new Me(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY), r = new Me(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY);
            for (const n of e1[0])t1.x > n.x && (t1.x = n.x), t1.y > n.y && (t1.y = n.y), r.x < n.x && (r.x = n.x), r.y < n.y && (r.y = n.y);
            return {
                min: t1,
                max: r
            };
        }
        const In = 8192;
        function Mn(e1, t1) {
            const r = (180 + e1[0]) / 360, n = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + e1[1] * Math.PI / 360))) / 360, i = Math.pow(2, t1.z);
            return [
                Math.round(r * i * In),
                Math.round(n * i * In)
            ];
        }
        function Bn(e1, t1) {
            for(let r = 0; r < t1.length; r++)if (bn(e1, t1[r])) return !0;
            return !1;
        }
        function Sn(e1, t1, r) {
            for (const n of r)for(let r = 0, i = n.length, s = i - 1; r < i; s = r++)if (_n(e1, t1, n[s], n[r])) return !0;
            return !1;
        }
        function Pn(e1, t1) {
            for(let r = 0; r < e1.length; ++r)if (!bn(e1[r], t1)) return !1;
            for(let r = 0; r < e1.length - 1; ++r)if (Sn(e1[r], e1[r + 1], t1)) return !1;
            return !0;
        }
        function Tn(e1, t1) {
            for(let r = 0; r < t1.length; r++)if (Pn(e1, t1[r])) return !0;
            return !1;
        }
        function zn(e1, t1, r) {
            const n = [];
            for(let i = 0; i < e1.length; i++){
                const s = [];
                for(let n = 0; n < e1[i].length; n++){
                    const a = Mn(e1[i][n], r);
                    yn(t1, a), s.push(a);
                }
                n.push(s);
            }
            return n;
        }
        function kn(e1, t1, r) {
            const n = [];
            for(let i = 0; i < e1.length; i++){
                const s = zn(e1[i], t1, r);
                n.push(s);
            }
            return n;
        }
        function Vn(e1, t1, r, n) {
            if (e1[0] < r[0] || e1[0] > r[2]) {
                const t1 = .5 * n;
                let i = e1[0] - r[0] > t1 ? -n : r[0] - e1[0] > t1 ? n : 0;
                0 === i && (i = e1[0] - r[2] > t1 ? -n : r[2] - e1[0] > t1 ? n : 0), e1[0] += i;
            }
            yn(t1, e1);
        }
        function Fn(e1, t1, r, n) {
            const i = Math.pow(2, n.z) * In, s = [
                n.x * In,
                n.y * In
            ], a = [];
            if (!e1) return a;
            for (const n of e1)for (const e1 of n){
                const n = [
                    e1.x + s[0],
                    e1.y + s[1]
                ];
                Vn(n, t1, r, i), a.push(n);
            }
            return a;
        }
        function Dn(e1, t1, r, n) {
            const i = Math.pow(2, n.z) * In, s = [
                n.x * In,
                n.y * In
            ], a = [];
            if (!e1) return a;
            for (const r of e1){
                const e1 = [];
                for (const n of r){
                    const r = [
                        n.x + s[0],
                        n.y + s[1]
                    ];
                    yn(t1, r), e1.push(r);
                }
                a.push(e1);
            }
            if (t1[2] - t1[0] <= i / 2) {
                (o = t1)[0] = o[1] = 1 / 0, o[2] = o[3] = -1 / 0;
                for (const e1 of a)for (const n of e1)Vn(n, t1, r, i);
            }
            var o;
            return a;
        }
        class En {
            constructor(e1, t1){
                this.type = Ir, this.geojson = e1, this.geometries = t1;
            }
            static parse(e1, t1) {
                if (2 !== e1.length) return t1.error(`'within' expression requires exactly one argument, but found ${e1.length - 1} instead.`);
                if ($r(e1[1])) {
                    const t1 = e1[1];
                    if ("FeatureCollection" === t1.type) for(let e1 = 0; e1 < t1.features.length; ++e1){
                        const r = t1.features[e1].geometry.type;
                        if ("Polygon" === r || "MultiPolygon" === r) return new En(t1, t1.features[e1].geometry);
                    }
                    else if ("Feature" === t1.type) {
                        const e1 = t1.geometry.type;
                        if ("Polygon" === e1 || "MultiPolygon" === e1) return new En(t1, t1.geometry);
                    } else if ("Polygon" === t1.type || "MultiPolygon" === t1.type) return new En(t1, t1);
                }
                return t1.error("'within' expression requires valid geojson object that contains polygon geometry type.");
            }
            evaluate(e1) {
                if (null != e1.geometry() && null != e1.canonicalID()) {
                    if ("Point" === e1.geometryType()) return function(e1, t1) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = e1.canonicalID();
                        if (!i) return !1;
                        if ("Polygon" === t1.type) {
                            const s = zn(t1.coordinates, n, i), a = Fn(e1.geometry(), r, n, i);
                            if (!gn(r, n)) return !1;
                            for (const e1 of a)if (!bn(e1, s)) return !1;
                        }
                        if ("MultiPolygon" === t1.type) {
                            const s = kn(t1.coordinates, n, i), a = Fn(e1.geometry(), r, n, i);
                            if (!gn(r, n)) return !1;
                            for (const e1 of a)if (!Bn(e1, s)) return !1;
                        }
                        return !0;
                    }(e1, this.geometries);
                    if ("LineString" === e1.geometryType()) return function(e1, t1) {
                        const r = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], n = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ], i = e1.canonicalID();
                        if (!i) return !1;
                        if ("Polygon" === t1.type) {
                            const s = zn(t1.coordinates, n, i), a = Dn(e1.geometry(), r, n, i);
                            if (!gn(r, n)) return !1;
                            for (const e1 of a)if (!Pn(e1, s)) return !1;
                        }
                        if ("MultiPolygon" === t1.type) {
                            const s = kn(t1.coordinates, n, i), a = Dn(e1.geometry(), r, n, i);
                            if (!gn(r, n)) return !1;
                            for (const e1 of a)if (!Tn(e1, s)) return !1;
                        }
                        return !0;
                    }(e1, this.geometries);
                }
                return !1;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "within",
                    this.geojson
                ];
            }
        }
        const Cn = {
            kilometers: 1,
            miles: 1e3 / 1609.344,
            nauticalmiles: 1e3 / 1852,
            meters: 1e3,
            metres: 1e3,
            yards: 1e3 / .9144,
            feet: 1e3 / .3048,
            inches: 1e3 / .0254
        }, Rn = 1 / 298.257223563, Ln = Rn * (2 - Rn), On = Math.PI / 180;
        class Un {
            static fromTile(e1, t1, r) {
                const n = Math.PI * (1 - 2 * (e1 + .5) / Math.pow(2, t1)), i = Math.atan(.5 * (Math.exp(n) - Math.exp(-n))) / On;
                return new Un(i, r);
            }
            static get units() {
                return Cn;
            }
            constructor(e1, t1){
                if (void 0 === e1) throw new Error("No latitude given.");
                if (t1 && !Cn[t1]) throw new Error(`Unknown unit ${t1}. Use one of: ${Object.keys(Cn).join(", ")}`);
                const r = 6378.137 * On * (t1 ? Cn[t1] : 1), n = Math.cos(e1 * On), i = 1 / (1 - Ln * (1 - n * n)), s = Math.sqrt(i);
                this.kx = r * s * n, this.ky = r * s * i * (1 - Ln);
            }
            distance(e1, t1) {
                const r = Gn(e1[0] - t1[0]) * this.kx, n = (e1[1] - t1[1]) * this.ky;
                return Math.sqrt(r * r + n * n);
            }
            bearing(e1, t1) {
                const r = Gn(t1[0] - e1[0]) * this.kx;
                return Math.atan2(r, (t1[1] - e1[1]) * this.ky) / On;
            }
            destination(e1, t1, r) {
                const n = r * On;
                return this.offset(e1, Math.sin(n) * t1, Math.cos(n) * t1);
            }
            offset(e1, t1, r) {
                return [
                    e1[0] + t1 / this.kx,
                    e1[1] + r / this.ky
                ];
            }
            lineDistance(e1) {
                let t1 = 0;
                for(let r = 0; r < e1.length - 1; r++)t1 += this.distance(e1[r], e1[r + 1]);
                return t1;
            }
            area(e1) {
                let t1 = 0;
                for(let r = 0; r < e1.length; r++){
                    const n = e1[r];
                    for(let e1 = 0, i = n.length, s = i - 1; e1 < i; s = e1++)t1 += Gn(n[e1][0] - n[s][0]) * (n[e1][1] + n[s][1]) * (r ? -1 : 1);
                }
                return Math.abs(t1) / 2 * this.kx * this.ky;
            }
            along(e1, t1) {
                let r = 0;
                if (t1 <= 0) return e1[0];
                for(let n = 0; n < e1.length - 1; n++){
                    const i = e1[n], s = e1[n + 1], a = this.distance(i, s);
                    if (r += a, r > t1) return jn(i, s, (t1 - (r - a)) / a);
                }
                return e1[e1.length - 1];
            }
            pointToSegmentDistance(e1, t1, r) {
                let [n, i] = t1, s = Gn(r[0] - n) * this.kx, a = (r[1] - i) * this.ky;
                if (0 !== s || 0 !== a) {
                    const t1 = (Gn(e1[0] - n) * this.kx * s + (e1[1] - i) * this.ky * a) / (s * s + a * a);
                    t1 > 1 ? (n = r[0], i = r[1]) : t1 > 0 && (n += s / this.kx * t1, i += a / this.ky * t1);
                }
                return s = Gn(e1[0] - n) * this.kx, a = (e1[1] - i) * this.ky, Math.sqrt(s * s + a * a);
            }
            pointOnLine(e1, t1) {
                let r = 1 / 0, n = e1[0][0], i = e1[0][1], s = 0, a = 0;
                for(let o = 0; o < e1.length - 1; o++){
                    let l = e1[o][0], u = e1[o][1], c = Gn(e1[o + 1][0] - l) * this.kx, h = (e1[o + 1][1] - u) * this.ky, d = 0;
                    0 === c && 0 === h || (d = (Gn(t1[0] - l) * this.kx * c + (t1[1] - u) * this.ky * h) / (c * c + h * h), d > 1 ? (l = e1[o + 1][0], u = e1[o + 1][1]) : d > 0 && (l += c / this.kx * d, u += h / this.ky * d)), c = Gn(t1[0] - l) * this.kx, h = (t1[1] - u) * this.ky;
                    const p = c * c + h * h;
                    p < r && (r = p, n = l, i = u, s = o, a = d);
                }
                return {
                    point: [
                        n,
                        i
                    ],
                    index: s,
                    t: Math.max(0, Math.min(1, a))
                };
            }
            lineSlice(e1, t1, r) {
                let n = this.pointOnLine(r, e1), i = this.pointOnLine(r, t1);
                if (n.index > i.index || n.index === i.index && n.t > i.t) {
                    const e1 = n;
                    n = i, i = e1;
                }
                const s = [
                    n.point
                ], a = n.index + 1, o = i.index;
                !Nn(r[a], s[0]) && a <= o && s.push(r[a]);
                for(let e1 = a + 1; e1 <= o; e1++)s.push(r[e1]);
                return Nn(r[o], i.point) || s.push(i.point), s;
            }
            lineSliceAlong(e1, t1, r) {
                let n = 0;
                const i = [];
                for(let s = 0; s < r.length - 1; s++){
                    const a = r[s], o = r[s + 1], l = this.distance(a, o);
                    if (n += l, n > e1 && 0 === i.length && i.push(jn(a, o, (e1 - (n - l)) / l)), n >= t1) return i.push(jn(a, o, (t1 - (n - l)) / l)), i;
                    n > e1 && i.push(o);
                }
                return i;
            }
            bufferPoint(e1, t1) {
                const r = t1 / this.ky, n = t1 / this.kx;
                return [
                    e1[0] - n,
                    e1[1] - r,
                    e1[0] + n,
                    e1[1] + r
                ];
            }
            bufferBBox(e1, t1) {
                const r = t1 / this.ky, n = t1 / this.kx;
                return [
                    e1[0] - n,
                    e1[1] - r,
                    e1[2] + n,
                    e1[3] + r
                ];
            }
            insideBBox(e1, t1) {
                return Gn(e1[0] - t1[0]) >= 0 && Gn(e1[0] - t1[2]) <= 0 && e1[1] >= t1[1] && e1[1] <= t1[3];
            }
        }
        function Nn(e1, t1) {
            return e1[0] === t1[0] && e1[1] === t1[1];
        }
        function jn(e1, t1, r) {
            const n = Gn(t1[0] - e1[0]);
            return [
                e1[0] + n * r,
                e1[1] + (t1[1] - e1[1]) * r
            ];
        }
        function Gn(e1) {
            for(; e1 < -180;)e1 += 360;
            for(; e1 > 180;)e1 -= 360;
            return e1;
        }
        class $n {
            constructor(e1 = [], t1 = (e1, t1)=>e1 < t1 ? -1 : e1 > t1 ? 1 : 0){
                if (this.data = e1, this.length = this.data.length, this.compare = t1, this.length > 0) for(let e1 = (this.length >> 1) - 1; e1 >= 0; e1--)this._down(e1);
            }
            push(e1) {
                this.data.push(e1), this._up(this.length++);
            }
            pop() {
                if (0 === this.length) return;
                const e1 = this.data[0], t1 = this.data.pop();
                return --this.length > 0 && (this.data[0] = t1, this._down(0)), e1;
            }
            peek() {
                return this.data[0];
            }
            _up(e1) {
                const { data: t1, compare: r } = this, n = t1[e1];
                for(; e1 > 0;){
                    const i = e1 - 1 >> 1, s = t1[i];
                    if (r(n, s) >= 0) break;
                    t1[e1] = s, e1 = i;
                }
                t1[e1] = n;
            }
            _down(e1) {
                const { data: t1, compare: r } = this, n = this.length >> 1, i = t1[e1];
                for(; e1 < n;){
                    let n = 1 + (e1 << 1);
                    const s = n + 1;
                    if (s < this.length && r(t1[s], t1[n]) < 0 && (n = s), r(t1[n], i) >= 0) break;
                    t1[e1] = t1[n], e1 = n;
                }
                t1[e1] = i;
            }
        }
        var qn = 8192;
        function Hn(e1, t1) {
            return t1.dist - e1.dist;
        }
        function Xn(e1) {
            const t1 = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            if (t1.length !== e1.length) return !1;
            for(let r = 0; r < t1.length; r++)if (t1[r] !== e1[r]) return !1;
            return !0;
        }
        function Zn(e1) {
            return e1[1] - e1[0] + 1;
        }
        function Wn(e1, t1) {
            const r = e1[1] >= e1[0] && e1[1] < t1;
            return r || console.warn("Distance Expression: Index is out of range"), r;
        }
        function Yn(e1, t1) {
            if (e1[0] > e1[1]) return [
                null,
                null
            ];
            const r = Zn(e1);
            if (t1) {
                if (2 === r) return [
                    e1,
                    null
                ];
                const t1 = Math.floor(r / 2);
                return [
                    [
                        e1[0],
                        e1[0] + t1
                    ],
                    [
                        e1[0] + t1,
                        e1[1]
                    ]
                ];
            }
            {
                if (1 === r) return [
                    e1,
                    null
                ];
                const t1 = Math.floor(r / 2) - 1;
                return [
                    [
                        e1[0],
                        e1[0] + t1
                    ],
                    [
                        e1[0] + t1 + 1,
                        e1[1]
                    ]
                ];
            }
        }
        function Jn(e1, t1) {
            const r = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            if (!Wn(t1, e1.length)) return r;
            for(let n = t1[0]; n <= t1[1]; ++n)yn(r, e1[n]);
            return r;
        }
        function Kn(e1) {
            const t1 = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ];
            for(let r = 0; r < e1.length; ++r)for(let n = 0; n < e1[r].length; ++n)yn(t1, e1[r][n]);
            return t1;
        }
        function Qn(e1, t1, r) {
            if (Xn(e1) || Xn(t1)) return NaN;
            let n = 0, i = 0;
            return e1[2] < t1[0] && (n = t1[0] - e1[2]), e1[0] > t1[2] && (n = e1[0] - t1[2]), e1[1] > t1[3] && (i = e1[1] - t1[3]), e1[3] < t1[1] && (i = t1[1] - e1[3]), r.distance([
                0,
                0
            ], [
                n,
                i
            ]);
        }
        function ei(e1) {
            return 360 * e1 - 180;
        }
        function ti(e1) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * e1) * Math.PI / 180)) - 90;
        }
        function ri(e1, t1, r = 8192) {
            const n = Math.pow(2, t1.z), i = (e1.y / r + t1.y) / n;
            return [
                ei((e1.x / r + t1.x) / n),
                ti(i)
            ];
        }
        function ni(e1, t1) {
            const r = [];
            for(let n = 0; n < e1.length; ++n)r.push(ri(e1[n], t1));
            return r;
        }
        function ii(e1, t1, r) {
            const n = r.pointOnLine(t1, e1).point;
            return r.distance(e1, n);
        }
        function si(e1, t1, r, n, i) {
            const s = r.slice(n[0], n[1] + 1);
            let a = 1 / 0;
            for(let r = t1[0]; r <= t1[1]; ++r)if (0 === (a = Math.min(a, ii(e1[r], s, i)))) return 0;
            return a;
        }
        function ai(e1, t1, r, n, i) {
            const s = Math.min(i.pointToSegmentDistance(e1, r, n), i.pointToSegmentDistance(t1, r, n)), a = Math.min(i.pointToSegmentDistance(r, e1, t1), i.pointToSegmentDistance(n, e1, t1));
            return Math.min(s, a);
        }
        function oi(e1, t1, r, n, i) {
            if (!Wn(t1, e1.length) || !Wn(n, r.length)) return NaN;
            let s = 1 / 0;
            for(let a = t1[0]; a < t1[1]; ++a)for(let t1 = n[0]; t1 < n[1]; ++t1){
                if (_n(e1[a], e1[a + 1], r[t1], r[t1 + 1])) return 0;
                s = Math.min(s, ai(e1[a], e1[a + 1], r[t1], r[t1 + 1], i));
            }
            return s;
        }
        function li(e1, t1, r, n, i) {
            if (!Wn(t1, e1.length) || !Wn(n, r.length)) return NaN;
            let s = 1 / 0;
            for(let a = t1[0]; a <= t1[1]; ++a)for(let t1 = n[0]; t1 <= n[1]; ++t1)if (0 === (s = Math.min(s, i.distance(e1[a], r[t1])))) return s;
            return s;
        }
        function ui(e1, t1, r) {
            if (bn(e1, t1, !0)) return 0;
            let n = 1 / 0;
            for (const i of t1){
                const t1 = i.length;
                if (t1 < 2) return console.warn("Distance Expression: Invalid polygon!"), NaN;
                if (i[0] !== i[t1 - 1] && 0 === (n = Math.min(n, r.pointToSegmentDistance(e1, i[t1 - 1], i[0])))) return n;
                if (0 === (n = Math.min(n, ii(e1, i, r)))) return n;
            }
            return n;
        }
        function ci(e1, t1, r, n) {
            if (!Wn(t1, e1.length)) return NaN;
            for(let n = t1[0]; n <= t1[1]; ++n)if (bn(e1[n], r, !0)) return 0;
            let i = 1 / 0;
            for(let s = t1[0]; s < t1[1]; ++s)for (const t1 of r)for(let r = 0, a = t1.length, o = a - 1; r < a; o = r++){
                if (_n(e1[s], e1[s + 1], t1[o], t1[r])) return 0;
                i = Math.min(i, ai(e1[s], e1[s + 1], t1[o], t1[r], n));
            }
            return i;
        }
        function hi(e1, t1) {
            for (const r of e1)for(let e1 = 0; e1 <= r.length - 1; ++e1)if (bn(r[e1], t1, !0)) return !0;
            return !1;
        }
        function di(e1, t1, r, n = 1 / 0) {
            const i = Kn(e1), s = Kn(t1);
            if (n !== 1 / 0 && Qn(i, s, r) >= n) return n;
            if (gn(i, s)) {
                if (hi(e1, t1)) return 0;
            } else if (hi(t1, e1)) return 0;
            let a = n;
            for (const n of e1)for(let e1 = 0, i = n.length, s = i - 1; e1 < i; s = e1++)for (const i of t1)for(let t1 = 0, o = i.length, l = o - 1; t1 < o; l = t1++){
                if (_n(n[s], n[e1], i[l], i[t1])) return 0;
                a = Math.min(a, ai(n[s], n[e1], i[l], i[t1], r));
            }
            return a;
        }
        function pi(e1, t1, r, n, i, s, a) {
            if (null === s || null === a) return;
            const o = Qn(Jn(n, s), Jn(i, a), r);
            o < t1 && e1.push({
                dist: o,
                range1: s,
                range2: a
            });
        }
        function fi(e1, t1, r, n, i = 1 / 0) {
            let s = Math.min(n.distance(e1[0], r[0][0]), i);
            if (0 === s) return s;
            const a = new $n([
                {
                    dist: 0,
                    range1: [
                        0,
                        e1.length - 1
                    ],
                    range2: [
                        0,
                        0
                    ]
                }
            ], Hn), o = t1 ? 50 : 100, l = Kn(r);
            for(; a.length;){
                const i = a.pop();
                if (i.dist >= s) continue;
                const u = i.range1;
                if (Zn(u) <= o) {
                    if (!Wn(u, e1.length)) return NaN;
                    if (t1) {
                        const t1 = ci(e1, u, r, n);
                        if (0 === (s = Math.min(s, t1))) return s;
                    } else for(let t1 = u[0]; t1 <= u[1]; ++t1){
                        const i = ui(e1[t1], r, n);
                        if (0 === (s = Math.min(s, i))) return s;
                    }
                } else {
                    const r = Yn(u, t1);
                    if (null !== r[0]) {
                        const t1 = Qn(Jn(e1, r[0]), l, n);
                        t1 < s && a.push({
                            dist: t1,
                            range1: r[0],
                            range2: [
                                0,
                                0
                            ]
                        });
                    }
                    if (null !== r[1]) {
                        const t1 = Qn(Jn(e1, r[1]), l, n);
                        t1 < s && a.push({
                            dist: t1,
                            range1: r[1],
                            range2: [
                                0,
                                0
                            ]
                        });
                    }
                }
            }
            return s;
        }
        function mi(e1, t1, r, n, i, s = 1 / 0) {
            let a = Math.min(s, i.distance(e1[0], r[0]));
            if (0 === a) return a;
            const o = new $n([
                {
                    dist: 0,
                    range1: [
                        0,
                        e1.length - 1
                    ],
                    range2: [
                        0,
                        r.length - 1
                    ]
                }
            ], Hn), l = t1 ? 50 : 100, u = n ? 50 : 100;
            for(; o.length;){
                const s = o.pop();
                if (s.dist >= a) continue;
                const c = s.range1, h = s.range2;
                if (Zn(c) <= l && Zn(h) <= u) {
                    if (!Wn(c, e1.length) || !Wn(h, r.length)) return NaN;
                    if (t1 && n ? a = Math.min(a, oi(e1, c, r, h, i)) : t1 || n ? t1 && !n ? a = Math.min(a, si(r, h, e1, c, i)) : !t1 && n && (a = Math.min(a, si(e1, c, r, h, i))) : a = Math.min(a, li(e1, c, r, h, i)), 0 === a) return a;
                } else {
                    const s = Yn(c, t1), l = Yn(h, n);
                    pi(o, a, i, e1, r, s[0], l[0]), pi(o, a, i, e1, r, s[0], l[1]), pi(o, a, i, e1, r, s[1], l[0]), pi(o, a, i, e1, r, s[1], l[1]);
                }
            }
            return a;
        }
        function yi(e1, t1, r, n, i = 1 / 0) {
            let s = i;
            const a = Jn(e1, [
                0,
                e1.length - 1
            ]);
            for (const i of r)if (!(s !== 1 / 0 && Qn(a, Jn(i, [
                0,
                i.length - 1
            ]), n) >= s) && (s = Math.min(s, mi(e1, t1, i, !0, n, s)), 0 === s)) return s;
            return s;
        }
        function gi(e1, t1, r, n, i = 1 / 0) {
            let s = i;
            const a = Jn(e1, [
                0,
                e1.length - 1
            ]);
            for (const i of r){
                if (s !== 1 / 0 && Qn(a, Kn(i), n) >= s) continue;
                const r = fi(e1, t1, i, n, s);
                if (isNaN(r)) return r;
                if (0 === (s = Math.min(s, r))) return s;
            }
            return s;
        }
        function xi(e1) {
            return "Point" === e1 || "MultiPoint" === e1 || "LineString" === e1 || "MultiLineString" === e1 || "Polygon" === e1 || "MultiPolygon" === e1;
        }
        class vi {
            constructor(e1, t1){
                this.type = _r, this.geojson = e1, this.geometries = t1;
            }
            static parse(e1, t1) {
                if (2 !== e1.length) return t1.error(`'distance' expression requires either one argument, but found ' ${e1.length - 1} instead.`);
                if ($r(e1[1])) {
                    const t1 = e1[1];
                    if ("FeatureCollection" === t1.type) {
                        for(let e1 = 0; e1 < t1.features.length; ++e1)if (xi(t1.features[e1].geometry.type)) return new vi(t1, t1.features[e1].geometry);
                    } else if ("Feature" === t1.type) {
                        if (xi(t1.geometry.type)) return new vi(t1, t1.geometry);
                    } else if (xi(t1.type)) return new vi(t1, t1);
                }
                return t1.error("'distance' expression needs to be an array with format ['Distance', GeoJSONObj].");
            }
            evaluate(e1) {
                const t1 = e1.geometry(), r = e1.canonicalID();
                if (null != t1 && null != r) {
                    if ("Point" === e1.geometryType()) return function(e1, t1, r) {
                        const n = [];
                        for (const r of e1)for (const e1 of r)n.push(ri(e1, t1));
                        const i = new Un(n[0][1], "meters");
                        return "Point" === r.type || "MultiPoint" === r.type || "LineString" === r.type ? mi(n, !1, "Point" === r.type ? [
                            r.coordinates
                        ] : r.coordinates, "LineString" === r.type, i) : "MultiLineString" === r.type ? yi(n, !1, r.coordinates, i) : "Polygon" === r.type || "MultiPolygon" === r.type ? gi(n, !1, "Polygon" === r.type ? [
                            r.coordinates
                        ] : r.coordinates, i) : null;
                    }(t1, r, this.geometries);
                    if ("LineString" === e1.geometryType()) return function(e1, t1, r) {
                        const n = [];
                        for (const r of e1){
                            const e1 = [];
                            for (const n of r)e1.push(ri(n, t1));
                            n.push(e1);
                        }
                        const i = new Un(n[0][0][1], "meters");
                        if ("Point" === r.type || "MultiPoint" === r.type || "LineString" === r.type) return yi("Point" === r.type ? [
                            r.coordinates
                        ] : r.coordinates, "LineString" === r.type, n, i);
                        if ("MultiLineString" === r.type) {
                            let e1 = 1 / 0;
                            for(let t1 = 0; t1 < r.coordinates.length; t1++){
                                const s = yi(r.coordinates[t1], !0, n, i, e1);
                                if (isNaN(s)) return s;
                                if (0 === (e1 = Math.min(e1, s))) return e1;
                            }
                            return e1;
                        }
                        if ("Polygon" === r.type || "MultiPolygon" === r.type) {
                            let e1 = 1 / 0;
                            for(let t1 = 0; t1 < n.length; t1++){
                                const s = gi(n[t1], !0, "Polygon" === r.type ? [
                                    r.coordinates
                                ] : r.coordinates, i, e1);
                                if (isNaN(s)) return s;
                                if (0 === (e1 = Math.min(e1, s))) return e1;
                            }
                            return e1;
                        }
                        return null;
                    }(t1, r, this.geometries);
                    if ("Polygon" === e1.geometryType()) return function(e1, t1, r) {
                        const n = [];
                        for (const r of function(e1) {
                            const t1 = e1.length;
                            if (t1 <= 1) return [
                                e1
                            ];
                            const r = [];
                            let n, i;
                            for(let s = 0; s < t1; s++){
                                const t1 = mn(e1[s]);
                                0 !== t1 && (e1[s].area = Math.abs(t1), void 0 === i && (i = t1 < 0), i === t1 < 0 ? (n && r.push(n), n = [
                                    e1[s]
                                ]) : n.push(e1[s]));
                            }
                            return n && r.push(n), r;
                        }(e1)){
                            const e1 = [];
                            for(let n = 0; n < r.length; ++n)e1.push(ni(r[n], t1));
                            n.push(e1);
                        }
                        const i = new Un(n[0][0][0][1], "meters");
                        if ("Point" === r.type || "MultiPoint" === r.type || "LineString" === r.type) return gi("Point" === r.type ? [
                            r.coordinates
                        ] : r.coordinates, "LineString" === r.type, n, i);
                        if ("MultiLineString" === r.type) {
                            let e1 = 1 / 0;
                            for(let t1 = 0; t1 < r.coordinates.length; t1++){
                                const s = gi(r.coordinates[t1], !0, n, i, e1);
                                if (isNaN(s)) return s;
                                if (0 === (e1 = Math.min(e1, s))) return e1;
                            }
                            return e1;
                        }
                        return "Polygon" === r.type || "MultiPolygon" === r.type ? function(e1, t1, r) {
                            let n = 1 / 0;
                            for (const i of e1)for (const e1 of t1){
                                const t1 = di(i, e1, r, n);
                                if (isNaN(t1)) return t1;
                                if (0 === (n = Math.min(n, t1))) return n;
                            }
                            return n;
                        }("Polygon" === r.type ? [
                            r.coordinates
                        ] : r.coordinates, n, i) : null;
                    }(t1, r, this.geometries);
                    console.warn("Distance Expression: currently only evaluates valid Point/LineString/Polygon geometries.");
                } else console.warn("Distance Expression: requires valid feature and canonical information.");
                return null;
            }
            eachChild() {}
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "distance",
                    this.geojson
                ];
            }
        }
        function bi(e1) {
            if (e1 instanceof un) {
                if ("get" === e1.name && 1 === e1.args.length) return !1;
                if ("feature-state" === e1.name) return !1;
                if ("has" === e1.name && 1 === e1.args.length) return !1;
                if ("properties" === e1.name || "geometry-type" === e1.name || "id" === e1.name) return !1;
                if (/^filter-/.test(e1.name)) return !1;
            }
            if (e1 instanceof En) return !1;
            if (e1 instanceof vi) return !1;
            if (e1 instanceof Bi) return e1.featureConstant;
            let t1 = !0;
            return e1.eachChild((e1)=>{
                t1 && !bi(e1) && (t1 = !1);
            }), t1;
        }
        function wi(e1) {
            if (e1 instanceof un && "feature-state" === e1.name) return !1;
            let t1 = !0;
            return e1.eachChild((e1)=>{
                t1 && !wi(e1) && (t1 = !1);
            }), t1;
        }
        function _i(e1, t1) {
            if (e1 instanceof un && t1.indexOf(e1.name) >= 0) return !1;
            let r = !0;
            return e1.eachChild((e1)=>{
                r && !_i(e1, t1) && (r = !1);
            }), r;
        }
        function Ai(e1, t1, r) {
            return [
                e1,
                t1,
                r
            ].filter(Boolean).join("");
        }
        function Ii(e1, t1) {
            switch(e1){
                case "string":
                    return Hr(t1);
                case "number":
                    return +t1;
                case "boolean":
                    return !!t1;
                case "color":
                    return dr.parse(t1);
                case "formatted":
                    return Ur.fromString(Hr(t1));
                case "resolvedImage":
                    return jr.build(Hr(t1));
            }
            return t1;
        }
        function Mi(e1, t1, r, n) {
            return void 0 !== n && (e1 = n * Math.round(e1 / n)), void 0 !== t1 && e1 < t1 && (e1 = t1), void 0 !== r && e1 > r && (e1 = r), e1;
        }
        class Bi {
            constructor(e1, t1, r, n = !1){
                this.type = e1, this.key = t1, this.scope = r, this.featureConstant = n;
            }
            static parse(e1, t1) {
                let r = t1.expectedType;
                if (null == r && (r = Sr), e1.length < 2 || e1.length > 3) return t1.error("Invalid number of arguments for 'config' expression.");
                const n = t1.parse(e1[1], 1);
                if (!(n instanceof Xr)) return t1.error("Key name of 'config' expression must be a string literal.");
                let i, s = !0;
                const a = Hr(n.value);
                if (e1.length >= 3) {
                    const r = t1.parse(e1[2], 2);
                    if (!(r instanceof Xr)) return t1.error("Scope of 'config' expression must be a string literal.");
                    i = Hr(r.value);
                }
                if (t1.options) {
                    const e1 = Ai(a, i, t1._scope), r = t1.options.get(e1);
                    r && (s = bi(r.value || r.default));
                }
                return new Bi(r, a, i, s);
            }
            evaluate(e1) {
                const t1 = Ai(this.key, this.scope, e1.scope), r = e1.getConfig(t1);
                if (!r) return null;
                const { type: n, value: i, values: s, minValue: a, maxValue: o, stepValue: l } = r, u = r.default.evaluate(e1);
                let c = u;
                if (i) {
                    const t1 = e1.scope;
                    e1.scope = (t1 || "").split("").slice(1).join(""), c = i.evaluate(e1), e1.scope = t1;
                }
                return n && (c = Ii(n, c)), void 0 === c || void 0 === a && void 0 === o && void 0 === l || ("number" == typeof c ? c = Mi(c, a, o, l) : Array.isArray(c) && (c = c.map((e1)=>"number" == typeof e1 ? Mi(e1, a, o, l) : e1))), void 0 !== i && void 0 !== c && s && !s.includes(c) && (c = u, n && (c = Ii(n, c))), (n && n !== this.type || void 0 !== c && !Rr(qr(c), this.type)) && (c = Ii(this.type.kind, c)), c;
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
            serialize() {
                const e1 = [
                    "config",
                    this.key
                ];
                return this.scope && e1.concat(this.scope), e1;
            }
        }
        class Si {
            constructor(e1, t1){
                this.type = t1.type, this.name = e1, this.boundExpression = t1;
            }
            static parse(e1, t1) {
                if (2 !== e1.length || "string" != typeof e1[1]) return t1.error("'var' expression requires exactly one string literal argument.");
                const r = e1[1];
                return t1.scope.has(r) ? new Si(r, t1.scope.get(r)) : t1.error(`Unknown variable "${r}". Make sure "${r}" has been bound in an enclosing "let" expression before using it.`, 1);
            }
            evaluate(e1) {
                return this.boundExpression.evaluate(e1);
            }
            eachChild() {}
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "var",
                    this.name
                ];
            }
        }
        class Pi {
            constructor(e1, t1 = [], r, n = new br, i = [], s, a, o){
                this.registry = e1, this.path = t1, this.key = t1.map((e1)=>"string" == typeof e1 ? `['${e1}']` : `[${e1}]`).join(""), this.scope = n, this.errors = i, this.expectedType = r, this._scope = s, this.options = a, this.iconImageUseTheme = o;
            }
            parse(e1, t1, r, n, i = {}) {
                return t1 || r ? this.concat(t1, null, r, n)._parse(e1, i) : this._parse(e1, i);
            }
            parseObjectValue(e1, t1, r, n, i, s = {}) {
                return this.concat(t1, r, n, i)._parse(e1, s);
            }
            _parse(e1, t1) {
                function r(e1, t1, r) {
                    return "assert" === r ? new Yr(t1, [
                        e1
                    ]) : "coerce" === r ? new an(t1, [
                        e1
                    ]) : e1;
                }
                if (null !== e1 && "string" != typeof e1 && "boolean" != typeof e1 && "number" != typeof e1 || (e1 = [
                    "literal",
                    e1
                ]), Array.isArray(e1)) {
                    if (0 === e1.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                    const n = "string" == typeof e1[0] ? this.registry[e1[0]] : void 0;
                    if (n) {
                        let i = n.parse(e1, this);
                        if (!i) return null;
                        if (this.expectedType) {
                            const e1 = this.expectedType, n = i.type;
                            if ("string" !== e1.kind && "number" !== e1.kind && "boolean" !== e1.kind && "object" !== e1.kind && "array" !== e1.kind || "value" !== n.kind) {
                                if ("color" !== e1.kind && "formatted" !== e1.kind && "resolvedImage" !== e1.kind || "value" !== n.kind && "string" !== n.kind) {
                                    if (this.checkSubtype(e1, n)) return null;
                                } else i = r(i, e1, t1.typeAnnotation || "coerce");
                            } else i = r(i, e1, t1.typeAnnotation || "assert");
                        }
                        if (!(i instanceof Xr) && "resolvedImage" !== i.type.kind && Ti(i)) {
                            const e1 = new ln(this._scope, this.options, this.iconImageUseTheme);
                            try {
                                i = new Xr(i.type, i.evaluate(e1));
                            } catch (e1) {
                                return this.error(e1.message), null;
                            }
                        }
                        return i;
                    }
                    return an.parse([
                        "to-array",
                        e1
                    ], this);
                }
                return this.error(void 0 === e1 ? "'undefined' value invalid. Use null instead." : "object" == typeof e1 ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof e1} instead.`);
            }
            concat(e1, t1, r, n) {
                let i = "number" == typeof e1 ? this.path.concat(e1) : this.path;
                i = "string" == typeof t1 ? i.concat(t1) : i;
                const s = n ? this.scope.concat(n) : this.scope;
                return new Pi(this.registry, i, r || null, s, this.errors, this._scope, this.options, this.iconImageUseTheme);
            }
            error(e1, ...t1) {
                const r = `${this.key}${t1.map((e1)=>`[${e1}]`).join("")}`;
                this.errors.push(new vr(r, e1));
            }
            checkSubtype(e1, t1) {
                const r = Dr(e1, t1);
                return r && this.error(r), r;
            }
        }
        function Ti(e1) {
            if (e1 instanceof Si) return Ti(e1.boundExpression);
            if (e1 instanceof un && "error" === e1.name) return !1;
            if (e1 instanceof hn) return !1;
            if (e1 instanceof En) return !1;
            if (e1 instanceof vi) return !1;
            if (e1 instanceof Bi) return !1;
            const t1 = e1 instanceof an || e1 instanceof Yr;
            let r = !0;
            return e1.eachChild((e1)=>{
                r = t1 ? r && Ti(e1) : r && e1 instanceof Xr;
            }), !!r && bi(e1) && _i(e1, [
                "zoom",
                "heatmap-density",
                "worldview",
                "line-progress",
                "raster-value",
                "sky-radial-progress",
                "accumulated",
                "is-supported-script",
                "pitch",
                "distance-from-center",
                "measure-light",
                "raster-particle-speed",
                "is-active-floor"
            ]);
        }
        function zi(e1, t1) {
            const r = e1.length - 1;
            let n, i, s = 0, a = r, o = 0;
            for(; s <= a;)if (o = Math.floor((s + a) / 2), n = e1[o], i = e1[o + 1], n <= t1) {
                if (o === r || t1 < i) return o;
                s = o + 1;
            } else {
                if (!(n > t1)) throw new Zr("Input is not a number.");
                a = o - 1;
            }
            return 0;
        }
        class ki {
            constructor(e1, t1, r){
                this.type = e1, this.input = t1, this.labels = [], this.outputs = [];
                for (const [e1, t1] of r)this.labels.push(e1), this.outputs.push(t1);
            }
            static parse(e1, t1) {
                if (e1.length - 1 < 4) return t1.error(`Expected at least 4 arguments, but found only ${e1.length - 1}.`);
                if ((e1.length - 1) % 2 != 0) return t1.error("Expected an even number of arguments.");
                const r = t1.parse(e1[1], 1, _r);
                if (!r) return null;
                const n = [];
                let i = null;
                t1.expectedType && "value" !== t1.expectedType.kind && (i = t1.expectedType);
                for(let r = 1; r < e1.length; r += 2){
                    const s = 1 === r ? -1 / 0 : e1[r], a = e1[r + 1], o = r, l = r + 1;
                    if ("number" != typeof s) return t1.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', o);
                    if (n.length && n[n.length - 1][0] >= s) return t1.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', o);
                    const u = t1.parse(a, l, i);
                    if (!u) return null;
                    i = i || u.type, n.push([
                        s,
                        u
                    ]);
                }
                return new ki(i, r, n);
            }
            evaluate(e1) {
                const t1 = this.labels, r = this.outputs;
                if (1 === t1.length) return r[0].evaluate(e1);
                const n = this.input.evaluate(e1);
                if (n <= t1[0]) return r[0].evaluate(e1);
                const i = t1.length;
                return n >= t1[i - 1] ? r[i - 1].evaluate(e1) : r[zi(t1, n)].evaluate(e1);
            }
            eachChild(e1) {
                e1(this.input);
                for (const t1 of this.outputs)e1(t1);
            }
            outputDefined() {
                return this.outputs.every((e1)=>e1.outputDefined());
            }
            serialize() {
                const e1 = [
                    "step",
                    this.input.serialize()
                ];
                for(let t1 = 0; t1 < this.labels.length; t1++)t1 > 0 && e1.push(this.labels[t1]), e1.push(this.outputs[t1].serialize());
                return e1;
            }
        }
        const Vi = .95047, Fi = 1.08883, Di = 4 / 29, Ei = 6 / 29, Ci = 3 * Ei * Ei, Ri = Ei * Ei * Ei, Li = Math.PI / 180, Oi = 180 / Math.PI;
        function Ui(e1) {
            return e1 > Ri ? Math.pow(e1, 1 / 3) : e1 / Ci + Di;
        }
        function Ni(e1) {
            return e1 > Ei ? e1 * e1 * e1 : Ci * (e1 - Di);
        }
        function ji(e1) {
            return 255 * (e1 <= .0031308 ? 12.92 * e1 : 1.055 * Math.pow(e1, 1 / 2.4) - .055);
        }
        function Gi(e1) {
            return (e1 /= 255) <= .04045 ? e1 / 12.92 : Math.pow((e1 + .055) / 1.055, 2.4);
        }
        function $i(e1) {
            const t1 = Gi(e1.r), r = Gi(e1.g), n = Gi(e1.b), i = Ui((.4124564 * t1 + .3575761 * r + .1804375 * n) / Vi), s = Ui((.2126729 * t1 + .7151522 * r + .072175 * n) / 1);
            return {
                l: 116 * s - 16,
                a: 500 * (i - s),
                b: 200 * (s - Ui((.0193339 * t1 + .119192 * r + .9503041 * n) / Fi)),
                alpha: e1.a
            };
        }
        function qi(e1) {
            let t1 = (e1.l + 16) / 116, r = isNaN(e1.a) ? t1 : t1 + e1.a / 500, n = isNaN(e1.b) ? t1 : t1 - e1.b / 200;
            return t1 = 1 * Ni(t1), r = Vi * Ni(r), n = Fi * Ni(n), new dr(ji(3.2404542 * r - 1.5371385 * t1 - .4985314 * n), ji(-0.969266 * r + 1.8760108 * t1 + .041556 * n), ji(.0556434 * r - .2040259 * t1 + 1.0572252 * n), e1.alpha);
        }
        function Hi(e1, t1, r) {
            const n = t1 - e1;
            return e1 + r * (n > 180 || n < -180 ? n - 360 * Math.round(n / 360) : n);
        }
        const Xi = {
            forward: $i,
            reverse: qi,
            interpolate: function(e1, t1, r) {
                return {
                    l: yr(e1.l, t1.l, r),
                    a: yr(e1.a, t1.a, r),
                    b: yr(e1.b, t1.b, r),
                    alpha: yr(e1.alpha, t1.alpha, r)
                };
            }
        }, Zi = {
            forward: function(e1) {
                const { l: t1, a: r, b: n } = $i(e1), i = Math.atan2(n, r) * Oi;
                return {
                    h: i < 0 ? i + 360 : i,
                    c: Math.sqrt(r * r + n * n),
                    l: t1,
                    alpha: e1.a
                };
            },
            reverse: function(e1) {
                const t1 = e1.h * Li, r = e1.c;
                return qi({
                    l: e1.l,
                    a: Math.cos(t1) * r,
                    b: Math.sin(t1) * r,
                    alpha: e1.alpha
                });
            },
            interpolate: function(e1, t1, r) {
                return {
                    h: Hi(e1.h, t1.h, r),
                    c: yr(e1.c, t1.c, r),
                    l: yr(e1.l, t1.l, r),
                    alpha: yr(e1.alpha, t1.alpha, r)
                };
            }
        };
        var Wi = Object.freeze({
            __proto__: null,
            hcl: Zi,
            lab: Xi
        });
        class Yi {
            constructor(e1, t1, r, n, i){
                this.type = e1, this.operator = t1, this.interpolation = r, this.input = n, this.labels = [], this.outputs = [];
                for (const [e1, t1] of i)this.labels.push(e1), this.outputs.push(t1);
            }
            static interpolationFactor(e1, t1, r, n) {
                let i = 0;
                if ("exponential" === e1.name) i = Ji(t1, e1.base, r, n);
                else if ("linear" === e1.name) i = Ji(t1, 1, r, n);
                else if ("cubic-bezier" === e1.name) {
                    const s = e1.controlPoints;
                    i = new Ie(s[0], s[1], s[2], s[3]).solve(Ji(t1, 1, r, n));
                }
                return i;
            }
            static parse(e1, t1) {
                let [r, n, i, ...s] = e1;
                if (!Array.isArray(n) || 0 === n.length) return t1.error("Expected an interpolation type expression.", 1);
                if ("linear" === n[0]) n = {
                    name: "linear"
                };
                else if ("exponential" === n[0]) {
                    const e1 = n[1];
                    if ("number" != typeof e1) return t1.error("Exponential interpolation requires a numeric base.", 1, 1);
                    n = {
                        name: "exponential",
                        base: e1
                    };
                } else {
                    if ("cubic-bezier" !== n[0]) return t1.error(`Unknown interpolation type ${String(n[0])}`, 1, 0);
                    {
                        const e1 = n.slice(1);
                        if (4 !== e1.length || e1.some((e1)=>"number" != typeof e1 || e1 < 0 || e1 > 1)) return t1.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                        n = {
                            name: "cubic-bezier",
                            controlPoints: e1
                        };
                    }
                }
                if (e1.length - 1 < 4) return t1.error(`Expected at least 4 arguments, but found only ${e1.length - 1}.`);
                if (e1.length - 1 > 3 && (e1.length - 1) % 2 != 0) return t1.error("Expected an even number of arguments.");
                if (i = t1.parse(i, 2, _r), !i) return null;
                const a = [];
                let o = null;
                "interpolate-hcl" === r || "interpolate-lab" === r ? o = Mr : t1.expectedType && "value" !== t1.expectedType.kind && (o = t1.expectedType);
                for(let e1 = 0; e1 < s.length; e1 += 2){
                    const r = s[e1], n = s[e1 + 1], i = e1 + 3, l = e1 + 4;
                    if ("number" != typeof r) return t1.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', i);
                    if (a.length && a[a.length - 1][0] >= r) return t1.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', i);
                    const u = t1.parse(n, l, o);
                    if (!u) return null;
                    o = o || u.type, a.push([
                        r,
                        u
                    ]);
                }
                return "number" === o.kind || "color" === o.kind || "array" === o.kind && "number" === o.itemType.kind && "number" == typeof o.N ? new Yi(o, r, n, i, a) : t1.error(`Type ${Vr(o)} is not interpolatable.`);
            }
            evaluate(e1) {
                const t1 = this.labels, r = this.outputs;
                if (1 === t1.length) return r[0].evaluate(e1);
                const n = this.input.evaluate(e1);
                if (n <= t1[0]) return r[0].evaluate(e1);
                const i = t1.length;
                if (n >= t1[i - 1]) return r[i - 1].evaluate(e1);
                const s = zi(t1, n), a = Yi.interpolationFactor(this.interpolation, n, t1[s], t1[s + 1]), o = r[s].evaluate(e1), l = r[s + 1].evaluate(e1);
                return "interpolate" === this.operator ? xr[this.type.kind.toLowerCase()](o, l, a) : "interpolate-hcl" === this.operator ? Zi.reverse(Zi.interpolate(Zi.forward(o), Zi.forward(l), a)) : Xi.reverse(Xi.interpolate(Xi.forward(o), Xi.forward(l), a));
            }
            eachChild(e1) {
                e1(this.input);
                for (const t1 of this.outputs)e1(t1);
            }
            outputDefined() {
                return this.outputs.every((e1)=>e1.outputDefined());
            }
            serialize() {
                let e1;
                e1 = "linear" === this.interpolation.name ? [
                    "linear"
                ] : "exponential" === this.interpolation.name ? 1 === this.interpolation.base ? [
                    "linear"
                ] : [
                    "exponential",
                    this.interpolation.base
                ] : [
                    "cubic-bezier",
                    ...this.interpolation.controlPoints
                ];
                const t1 = [
                    this.operator,
                    e1,
                    this.input.serialize()
                ];
                for(let e1 = 0; e1 < this.labels.length; e1++)t1.push(this.labels[e1], this.outputs[e1].serialize());
                return t1;
            }
        }
        function Ji(e1, t1, r, n) {
            const i = n - r, s = e1 - r;
            return 0 === i ? 0 : 1 === t1 ? s / i : (Math.pow(t1, s) - 1) / (Math.pow(t1, i) - 1);
        }
        class Ki {
            constructor(e1, t1){
                this.type = e1, this.args = t1;
            }
            static parse(e1, t1) {
                if (e1.length < 2) return t1.error("Expectected at least one argument."), null;
                let r = null;
                const n = t1.expectedType;
                n && "value" !== n.kind && (r = n);
                const i = [];
                for (const n of e1.slice(1)){
                    const e1 = t1.parse(n, 1 + i.length, r, void 0, {
                        typeAnnotation: "omit"
                    });
                    if (!e1) return null;
                    r = r || e1.type, i.push(e1);
                }
                const s = n && i.some((e1)=>Dr(n, e1.type));
                return new Ki(s ? Sr : r, i);
            }
            evaluate(e1) {
                let t1, r = null, n = 0;
                for (const i of this.args){
                    if (n++, r = i.evaluate(e1), r && r instanceof jr && !r.available && (t1 || (t1 = r), r = null, n === this.args.length)) return t1;
                    if (null !== r) break;
                }
                return r;
            }
            eachChild(e1) {
                this.args.forEach(e1);
            }
            outputDefined() {
                return this.args.every((e1)=>e1.outputDefined());
            }
            serialize() {
                const e1 = [
                    "coalesce"
                ];
                return this.eachChild((t1)=>{
                    e1.push(t1.serialize());
                }), e1;
            }
        }
        class Qi {
            constructor(e1, t1){
                this.type = t1.type, this.bindings = [].concat(e1), this.result = t1;
            }
            evaluate(e1) {
                return this.result.evaluate(e1);
            }
            eachChild(e1) {
                for (const t1 of this.bindings)e1(t1[1]);
                e1(this.result);
            }
            static parse(e1, t1) {
                if (e1.length < 4) return t1.error(`Expected at least 3 arguments, but found ${e1.length - 1} instead.`);
                const r = [];
                for(let n = 1; n < e1.length - 1; n += 2){
                    const i = e1[n];
                    if ("string" != typeof i) return t1.error(`Expected string, but found ${typeof i} instead.`, n);
                    if (/[^a-zA-Z0-9_]/.test(i)) return t1.error("Variable names must contain only alphanumeric characters or '_'.", n);
                    const s = t1.parse(e1[n + 1], n + 1);
                    if (!s) return null;
                    r.push([
                        i,
                        s
                    ]);
                }
                const n = t1.parse(e1[e1.length - 1], e1.length - 1, t1.expectedType, r);
                return n ? new Qi(r, n) : null;
            }
            outputDefined() {
                return this.result.outputDefined();
            }
            serialize() {
                const e1 = [
                    "let"
                ];
                for (const [t1, r] of this.bindings)e1.push(t1, r.serialize());
                return e1.push(this.result.serialize()), e1;
            }
        }
        class es {
            constructor(e1, t1, r){
                this.type = e1, this.index = t1, this.input = r;
            }
            static parse(e1, t1) {
                if (3 !== e1.length) return t1.error(`Expected 2 arguments, but found ${e1.length - 1} instead.`);
                const r = t1.parse(e1[1], 1, _r), n = t1.parse(e1[2], 2, kr(t1.expectedType || Sr));
                return r && n ? new es(n.type.itemType, r, n) : null;
            }
            evaluate(e1) {
                const t1 = this.index.evaluate(e1), r = this.input.evaluate(e1);
                if (t1 < 0) throw new Zr("Array index out of bounds: negative index");
                if (t1 >= r.length) throw new Zr("Array index out of bounds: index exceeds array size");
                if (t1 !== Math.floor(t1)) throw new Zr("Array index must be an integer. Use at-interpolated for fractional indices");
                return r[t1];
            }
            eachChild(e1) {
                e1(this.index), e1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "at",
                    this.index.serialize(),
                    this.input.serialize()
                ];
            }
        }
        class ts {
            constructor(e1, t1, r){
                this.type = e1, this.index = t1, this.input = r;
            }
            static parse(e1, t1) {
                if (3 !== e1.length) return t1.error(`Expected 2 arguments, but found ${e1.length - 1} instead.`);
                const r = t1.parse(e1[1], 1, _r), n = t1.parse(e1[2], 2, kr(t1.expectedType || Sr));
                return r && n ? new ts(n.type.itemType, r, n) : null;
            }
            evaluate(e1) {
                const t1 = this.index.evaluate(e1), r = this.input.evaluate(e1);
                if (t1 < 0) throw new Zr(`Array index out of bounds: ${t1} < 0.`);
                if (t1 > r.length - 1) throw new Zr(`Array index out of bounds: ${t1} > ${r.length - 1}.`);
                if (t1 === Math.floor(t1)) return r[t1];
                const n = Math.floor(t1), i = Math.ceil(t1), s = r[n], a = r[i];
                if ("number" != typeof s || "number" != typeof a) throw new Zr(`Cannot interpolate between non-number values at index ${t1}.`);
                const o = t1 - n;
                return s * (1 - o) + a * o;
            }
            eachChild(e1) {
                e1(this.index), e1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "at-interpolated",
                    this.index.serialize(),
                    this.input.serialize()
                ];
            }
        }
        class rs {
            constructor(e1, t1){
                this.type = Ir, this.needle = e1, this.haystack = t1;
            }
            static parse(e1, t1) {
                if (3 !== e1.length) return t1.error(`Expected 2 arguments, but found ${e1.length - 1} instead.`), null;
                const r = t1.parse(e1[1], 1, Sr), n = t1.parse(e1[2], 2, Sr);
                return r && n ? Er(r.type, [
                    Ir,
                    Ar,
                    _r,
                    wr,
                    Sr
                ]) ? new rs(r, n) : (t1.error(`Expected first argument to be of type boolean, string, number or null, but found ${Vr(r.type)} instead`), null) : null;
            }
            evaluate(e1) {
                const t1 = this.needle.evaluate(e1), r = this.haystack.evaluate(e1);
                if (null == r) return !1;
                if (!Cr(t1, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new Zr(`Expected first argument to be of type boolean, string, number or null, but found ${Vr(qr(t1))} instead.`);
                if (!Cr(r, [
                    "string",
                    "array"
                ])) throw new Zr(`Expected second argument to be of type array or string, but found ${Vr(qr(r))} instead.`);
                return r.indexOf(t1) >= 0;
            }
            eachChild(e1) {
                e1(this.needle), e1(this.haystack);
            }
            outputDefined() {
                return !0;
            }
            serialize() {
                return [
                    "in",
                    this.needle.serialize(),
                    this.haystack.serialize()
                ];
            }
        }
        class ns {
            constructor(e1, t1, r){
                this.type = _r, this.needle = e1, this.haystack = t1, this.fromIndex = r;
            }
            static parse(e1, t1) {
                if (e1.length <= 2 || e1.length >= 5) return t1.error(`Expected 3 or 4 arguments, but found ${e1.length - 1} instead.`), null;
                const r = t1.parse(e1[1], 1, Sr), n = t1.parse(e1[2], 2, Sr);
                if (!r || !n) return null;
                if (!Er(r.type, [
                    Ir,
                    Ar,
                    _r,
                    wr,
                    Sr
                ])) return t1.error(`Expected first argument to be of type boolean, string, number or null, but found ${Vr(r.type)} instead`), null;
                if (4 === e1.length) {
                    const i = t1.parse(e1[3], 3, _r);
                    return i ? new ns(r, n, i) : null;
                }
                return new ns(r, n);
            }
            evaluate(e1) {
                const t1 = this.needle.evaluate(e1), r = this.haystack.evaluate(e1);
                if (!Cr(t1, [
                    "boolean",
                    "string",
                    "number",
                    "null"
                ])) throw new Zr(`Expected first argument to be of type boolean, string, number or null, but found ${Vr(qr(t1))} instead.`);
                if (!Cr(r, [
                    "string",
                    "array"
                ])) throw new Zr(`Expected second argument to be of type array or string, but found ${Vr(qr(r))} instead.`);
                if (this.fromIndex) {
                    const n = this.fromIndex.evaluate(e1);
                    return r.indexOf(t1, n);
                }
                return r.indexOf(t1);
            }
            eachChild(e1) {
                e1(this.needle), e1(this.haystack), this.fromIndex && e1(this.fromIndex);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                if (null != this.fromIndex && void 0 !== this.fromIndex) {
                    const e1 = this.fromIndex.serialize();
                    return [
                        "index-of",
                        this.needle.serialize(),
                        this.haystack.serialize(),
                        e1
                    ];
                }
                return [
                    "index-of",
                    this.needle.serialize(),
                    this.haystack.serialize()
                ];
            }
        }
        class is {
            constructor(e1, t1, r, n, i, s){
                this.inputType = e1, this.type = t1, this.input = r, this.cases = n, this.outputs = i, this.otherwise = s;
            }
            static parse(e1, t1) {
                if (e1.length < 5) return t1.error(`Expected at least 4 arguments, but found only ${e1.length - 1}.`);
                if (e1.length % 2 != 1) return t1.error("Expected an even number of arguments.");
                let r, n;
                t1.expectedType && "value" !== t1.expectedType.kind && (n = t1.expectedType);
                const i = {}, s = [];
                for(let a = 2; a < e1.length - 1; a += 2){
                    let o = e1[a];
                    const l = e1[a + 1];
                    Array.isArray(o) || (o = [
                        o
                    ]);
                    const u = t1.concat(a);
                    if (0 === o.length) return u.error("Expected at least one branch label.");
                    for (const e1 of o){
                        if ("number" != typeof e1 && "string" != typeof e1) return u.error("Branch labels must be numbers or strings.");
                        if ("number" == typeof e1 && Math.abs(e1) > Number.MAX_SAFE_INTEGER) return u.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                        if ("number" == typeof e1 && Math.floor(e1) !== e1) return u.error("Numeric branch labels must be integer values.");
                        if (r) {
                            if (u.checkSubtype(r, qr(e1))) return null;
                        } else r = qr(e1);
                        if (void 0 !== i[String(e1)]) return u.error("Branch labels must be unique.");
                        i[String(e1)] = s.length;
                    }
                    const c = t1.parse(l, a, n);
                    if (!c) return null;
                    n = n || c.type, s.push(c);
                }
                const a = t1.parse(e1[1], 1, Sr);
                if (!a) return null;
                const o = t1.parse(e1[e1.length - 1], e1.length - 1, n);
                return o ? "value" !== a.type.kind && t1.concat(1).checkSubtype(r, a.type) ? null : new is(r, n, a, i, s, o) : null;
            }
            evaluate(e1) {
                const t1 = this.input.evaluate(e1);
                return (Rr(qr(t1), this.inputType) && this.outputs[this.cases[t1]] || this.otherwise).evaluate(e1);
            }
            eachChild(e1) {
                e1(this.input), this.outputs.forEach(e1), e1(this.otherwise);
            }
            outputDefined() {
                return this.outputs.every((e1)=>e1.outputDefined()) && this.otherwise.outputDefined();
            }
            serialize() {
                const e1 = [
                    "match",
                    this.input.serialize()
                ], t1 = Object.keys(this.cases).sort(), r = [], n = {};
                for (const e1 of t1){
                    const t1 = n[this.cases[e1]];
                    void 0 === t1 ? (n[this.cases[e1]] = r.length, r.push([
                        this.cases[e1],
                        [
                            e1
                        ]
                    ])) : r[t1][1].push(e1);
                }
                const i = (e1)=>"number" === this.inputType.kind ? Number(e1) : e1;
                for (const [t1, n] of r)e1.push(1 === n.length ? i(n[0]) : n.map(i)), e1.push(this.outputs[t1].serialize());
                return e1.push(this.otherwise.serialize()), e1;
            }
        }
        class ss {
            constructor(e1, t1, r){
                this.type = e1, this.branches = t1, this.otherwise = r;
            }
            static parse(e1, t1) {
                if (e1.length < 4) return t1.error(`Expected at least 3 arguments, but found only ${e1.length - 1}.`), null;
                if (e1.length % 2 != 0) return t1.error("Expected an odd number of arguments."), null;
                let r;
                t1.expectedType && "value" !== t1.expectedType.kind && (r = t1.expectedType);
                const n = [];
                for(let i = 1; i < e1.length - 1; i += 2){
                    const s = t1.parse(e1[i], i, Ir);
                    if (!s) return null;
                    const a = t1.parse(e1[i + 1], i + 1, r);
                    if (!a) return null;
                    n.push([
                        s,
                        a
                    ]), r = r || a.type;
                }
                const i = t1.parse(e1[e1.length - 1], e1.length - 1, r);
                return i ? new ss(r, n, i) : null;
            }
            evaluate(e1) {
                for (const [t1, r] of this.branches)if (t1.evaluate(e1)) return r.evaluate(e1);
                return this.otherwise.evaluate(e1);
            }
            eachChild(e1) {
                for (const [t1, r] of this.branches)e1(t1), e1(r);
                e1(this.otherwise);
            }
            outputDefined() {
                return this.branches.every(([e1, t1])=>t1.outputDefined()) && this.otherwise.outputDefined();
            }
            serialize() {
                const e1 = [
                    "case"
                ];
                return this.eachChild((t1)=>{
                    e1.push(t1.serialize());
                }), e1;
            }
        }
        class as {
            constructor(e1, t1, r, n){
                this.type = e1, this.input = t1, this.beginIndex = r, this.endIndex = n;
            }
            static parse(e1, t1) {
                if (e1.length <= 2 || e1.length >= 5) return t1.error(`Expected 3 or 4 arguments, but found ${e1.length - 1} instead.`), null;
                const r = t1.parse(e1[1], 1, Sr), n = t1.parse(e1[2], 2, _r);
                if (!r || !n) return null;
                if (!Er(r.type, [
                    kr(Sr),
                    Ar,
                    Sr
                ])) return t1.error(`Expected first argument to be of type array or string, but found ${Vr(r.type)} instead`), null;
                if (4 === e1.length) {
                    const i = t1.parse(e1[3], 3, _r);
                    return i ? new as(r.type, r, n, i) : null;
                }
                return new as(r.type, r, n);
            }
            evaluate(e1) {
                const t1 = this.input.evaluate(e1), r = this.beginIndex.evaluate(e1);
                if (!Cr(t1, [
                    "string",
                    "array"
                ])) throw new Zr(`Expected first argument to be of type array or string, but found ${Vr(qr(t1))} instead.`);
                if (this.endIndex) {
                    const n = this.endIndex.evaluate(e1);
                    return t1.slice(r, n);
                }
                return t1.slice(r);
            }
            eachChild(e1) {
                e1(this.input), e1(this.beginIndex), this.endIndex && e1(this.endIndex);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                if (null != this.endIndex && void 0 !== this.endIndex) {
                    const e1 = this.endIndex.serialize();
                    return [
                        "slice",
                        this.input.serialize(),
                        this.beginIndex.serialize(),
                        e1
                    ];
                }
                return [
                    "slice",
                    this.input.serialize(),
                    this.beginIndex.serialize()
                ];
            }
        }
        class os {
            constructor(e1, t1){
                this.type = kr(Ar), this.str = e1, this.delimiter = t1;
            }
            static parse(e1, t1) {
                if (3 !== e1.length) return t1.error(`Expected 2 arguments, but found ${e1.length - 1} instead.`);
                const r = t1.parse(e1[1], 1, Ar), n = t1.parse(e1[2], 2, Ar);
                return r && n ? new os(r, n) : void 0;
            }
            evaluate(e1) {
                const t1 = this.str.evaluate(e1), r = this.delimiter.evaluate(e1);
                return t1.split(r);
            }
            eachChild(e1) {
                e1(this.str), e1(this.delimiter);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return [
                    "split",
                    this.str.serialize(),
                    this.delimiter.serialize()
                ];
            }
        }
        function ls(e1, t1) {
            return "==" === e1 || "!=" === e1 ? "boolean" === t1.kind || "string" === t1.kind || "number" === t1.kind || "null" === t1.kind || "value" === t1.kind : "string" === t1.kind || "number" === t1.kind || "value" === t1.kind;
        }
        function us(e1, t1, r, n) {
            return 0 === n.compare(t1, r);
        }
        function cs(e1, t1, r) {
            const n = "==" !== e1 && "!=" !== e1;
            return class i {
                constructor(e1, t1, r){
                    this.type = Ir, this.lhs = e1, this.rhs = t1, this.collator = r, this.hasUntypedArgument = "value" === e1.type.kind || "value" === t1.type.kind;
                }
                static parse(e1, t1) {
                    if (3 !== e1.length && 4 !== e1.length) return t1.error("Expected two or three arguments.");
                    const r = e1[0];
                    let s = t1.parse(e1[1], 1, Sr);
                    if (!s) return null;
                    if (!ls(r, s.type)) return t1.concat(1).error(`"${r}" comparisons are not supported for type '${Vr(s.type)}'.`);
                    let a = t1.parse(e1[2], 2, Sr);
                    if (!a) return null;
                    if (!ls(r, a.type)) return t1.concat(2).error(`"${r}" comparisons are not supported for type '${Vr(a.type)}'.`);
                    if (s.type.kind !== a.type.kind && "value" !== s.type.kind && "value" !== a.type.kind) return t1.error(`Cannot compare types '${Vr(s.type)}' and '${Vr(a.type)}'.`);
                    n && ("value" === s.type.kind && "value" !== a.type.kind ? s = new Yr(a.type, [
                        s
                    ]) : "value" !== s.type.kind && "value" === a.type.kind && (a = new Yr(s.type, [
                        a
                    ])));
                    let o = null;
                    if (4 === e1.length) {
                        if ("string" !== s.type.kind && "string" !== a.type.kind && "value" !== s.type.kind && "value" !== a.type.kind) return t1.error("Cannot use collator to compare non-string types.");
                        if (o = t1.parse(e1[3], 3, Pr), !o) return null;
                    }
                    return new i(s, a, o);
                }
                evaluate(i) {
                    const s = this.lhs.evaluate(i), a = this.rhs.evaluate(i);
                    if (n && this.hasUntypedArgument) {
                        const t1 = qr(s), r = qr(a);
                        if (t1.kind !== r.kind || "string" !== t1.kind && "number" !== t1.kind) throw new Zr(`Expected arguments for "${e1}" to be (string, string) or (number, number), but found (${t1.kind}, ${r.kind}) instead.`);
                    }
                    if (this.collator && !n && this.hasUntypedArgument) {
                        const e1 = qr(s), r = qr(a);
                        if ("string" !== e1.kind || "string" !== r.kind) return t1(i, s, a);
                    }
                    return this.collator ? r(i, s, a, this.collator.evaluate(i)) : t1(i, s, a);
                }
                eachChild(e1) {
                    e1(this.lhs), e1(this.rhs), this.collator && e1(this.collator);
                }
                outputDefined() {
                    return !0;
                }
                serialize() {
                    const t1 = [
                        e1
                    ];
                    return this.eachChild((e1)=>{
                        t1.push(e1.serialize());
                    }), t1;
                }
            };
        }
        const hs = cs("==", function(e1, t1, r) {
            return t1 === r;
        }, us), ds = cs("!=", function(e1, t1, r) {
            return t1 !== r;
        }, function(e1, t1, r, n) {
            return !us(0, t1, r, n);
        }), ps = cs("<", function(e1, t1, r) {
            return t1 < r;
        }, function(e1, t1, r, n) {
            return n.compare(t1, r) < 0;
        }), fs = cs(">", function(e1, t1, r) {
            return t1 > r;
        }, function(e1, t1, r, n) {
            return n.compare(t1, r) > 0;
        }), ms = cs("<=", function(e1, t1, r) {
            return t1 <= r;
        }, function(e1, t1, r, n) {
            return n.compare(t1, r) <= 0;
        }), ys = cs(">=", function(e1, t1, r) {
            return t1 >= r;
        }, function(e1, t1, r, n) {
            return n.compare(t1, r) >= 0;
        });
        class gs {
            constructor(e1, t1, r, n, i, s){
                this.type = Ar, this.number = e1, this.locale = t1, this.currency = r, this.unit = n, this.minFractionDigits = i, this.maxFractionDigits = s;
            }
            static parse(e1, t1) {
                if (3 !== e1.length) return t1.error("Expected two arguments.");
                const r = t1.parse(e1[1], 1, _r);
                if (!r) return null;
                const n = e1[2];
                if ("object" != typeof n || Array.isArray(n)) return t1.error("NumberFormat options argument must be an object.");
                let i = null;
                if (n.locale && (i = t1.parseObjectValue(n.locale, 2, "locale", Ar), !i)) return null;
                let s = null;
                if (n.currency && (s = t1.parseObjectValue(n.currency, 2, "currency", Ar), !s)) return null;
                let a = null;
                if (n.unit && (a = t1.parseObjectValue(n.unit, 2, "unit", Ar), !a)) return null;
                let o = null;
                if (n["min-fraction-digits"] && (o = t1.parseObjectValue(n["min-fraction-digits"], 2, "min-fraction-digits", _r), !o)) return null;
                let l = null;
                return n["max-fraction-digits"] && (l = t1.parseObjectValue(n["max-fraction-digits"], 2, "max-fraction-digits", _r), !l) ? null : new gs(r, i, s, a, o, l);
            }
            evaluate(e1) {
                return new Intl.NumberFormat(this.locale ? this.locale.evaluate(e1) : [], {
                    style: (this.currency ? "currency" : this.unit && "unit") || "decimal",
                    currency: this.currency ? this.currency.evaluate(e1) : void 0,
                    unit: this.unit ? this.unit.evaluate(e1) : void 0,
                    minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(e1) : void 0,
                    maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(e1) : void 0
                }).format(this.number.evaluate(e1));
            }
            eachChild(e1) {
                e1(this.number), this.locale && e1(this.locale), this.currency && e1(this.currency), this.unit && e1(this.unit), this.minFractionDigits && e1(this.minFractionDigits), this.maxFractionDigits && e1(this.maxFractionDigits);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const e1 = {};
                return this.locale && (e1.locale = this.locale.serialize()), this.currency && (e1.currency = this.currency.serialize()), this.unit && (e1.unit = this.unit.serialize()), this.minFractionDigits && (e1["min-fraction-digits"] = this.minFractionDigits.serialize()), this.maxFractionDigits && (e1["max-fraction-digits"] = this.maxFractionDigits.serialize()), [
                    "number-format",
                    this.number.serialize(),
                    e1
                ];
            }
        }
        class xs {
            constructor(e1){
                this.type = _r, this.input = e1;
            }
            static parse(e1, t1) {
                if (2 !== e1.length) return t1.error(`Expected 1 argument, but found ${e1.length - 1} instead.`), null;
                const r = t1.parse(e1[1], 1);
                return r ? "array" !== r.type.kind && "string" !== r.type.kind && "value" !== r.type.kind ? (t1.error(`Expected argument of type string or array, but found ${Vr(r.type)} instead.`), null) : new xs(r) : null;
            }
            evaluate(e1) {
                const t1 = this.input.evaluate(e1);
                if ("string" == typeof t1) return t1.length;
                if (Array.isArray(t1)) return t1.length;
                throw new Zr(`Expected value to be of type string or array, but found ${Vr(qr(t1))} instead.`);
            }
            eachChild(e1) {
                e1(this.input);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                const e1 = [
                    "length"
                ];
                return this.eachChild((t1)=>{
                    e1.push(t1.serialize());
                }), e1;
            }
        }
        function vs(e1) {
            return function() {
                e1 = 1831565813 + (e1 |= 0) | 0;
                let t1 = Math.imul(e1 ^ e1 >>> 15, 1 | e1);
                return t1 = t1 + Math.imul(t1 ^ t1 >>> 7, 61 | t1) ^ t1, ((t1 ^ t1 >>> 14) >>> 0) / 4294967296;
            };
        }
        const bs = {
            "==": hs,
            "!=": ds,
            ">": fs,
            "<": ps,
            ">=": ys,
            "<=": ms,
            array: Yr,
            at: es,
            "at-interpolated": ts,
            boolean: Yr,
            case: ss,
            coalesce: Ki,
            collator: hn,
            format: Jr,
            image: Kr,
            in: rs,
            "index-of": ns,
            interpolate: Yi,
            "interpolate-hcl": Yi,
            "interpolate-lab": Yi,
            length: xs,
            let: Qi,
            literal: Xr,
            match: is,
            number: Yr,
            "number-format": gs,
            object: Yr,
            slice: as,
            step: ki,
            string: Yr,
            "to-boolean": an,
            "to-color": an,
            "to-number": an,
            "to-string": an,
            var: Si,
            within: En,
            distance: vi,
            config: Bi,
            split: os
        };
        function ws(e1, [t1, r, n, i]) {
            t1 = t1.evaluate(e1), r = r.evaluate(e1), n = n.evaluate(e1);
            const s = i ? i.evaluate(e1) : 1, a = Gr(t1, r, n, s);
            if (a) throw new Zr(a);
            return new dr(t1 / 255, r / 255, n / 255, s);
        }
        function _s(e1, [t1, r, n, i]) {
            t1 = t1.evaluate(e1), r = r.evaluate(e1), n = n.evaluate(e1);
            const s = i ? i.evaluate(e1) : 1, a = function(e1, t1, r, n) {
                return "number" == typeof e1 && e1 >= 0 && e1 <= 360 ? "number" == typeof t1 && t1 >= 0 && t1 <= 100 && "number" == typeof r && r >= 0 && r <= 100 ? void 0 === n || "number" == typeof n && n >= 0 && n <= 1 ? null : `Invalid hsla value [${[
                    e1,
                    t1,
                    r,
                    n
                ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid hsla value [${("number" == typeof n ? [
                    e1,
                    t1,
                    r,
                    n
                ] : [
                    e1,
                    t1,
                    r
                ]).join(", ")}]: 's', and 'l' must be between 0 and 100.` : `Invalid hsla value [${("number" == typeof n ? [
                    e1,
                    t1,
                    r,
                    n
                ] : [
                    e1,
                    t1,
                    r
                ]).join(", ")}]: 'h' must be between 0 and 360.`;
            }(t1, r, n, s);
            if (a) throw new Zr(a);
            const o = `hsla(${t1}, ${r}%, ${n}%, ${s})`, l = dr.parse(o);
            if (!l) throw new Zr(`Failed to parse HSLA color: ${o}`);
            return l;
        }
        function As(e1, t1) {
            return e1 in t1;
        }
        function Is(e1, t1) {
            const r = t1[e1];
            return void 0 === r ? null : r;
        }
        function Ms(e1) {
            return {
                type: e1
            };
        }
        function Bs(e1) {
            if (e1 instanceof Bi) return new Set([
                e1.key
            ]);
            let t1 = new Set;
            return e1.eachChild((e1)=>{
                t1 = new Set([
                    ...t1,
                    ...Bs(e1)
                ]);
            }), t1;
        }
        function Ss(e1) {
            if (e1 instanceof un && "is-active-floor" === e1.name) return !0;
            let t1 = !1;
            return e1.eachChild((e1)=>{
                !t1 && Ss(e1) && (t1 = !0);
            }), t1;
        }
        function Ps(e1) {
            return {
                result: "success",
                value: e1
            };
        }
        function Ts(e1) {
            return {
                result: "error",
                value: e1
            };
        }
        function zs(e1, t1) {
            return !!e1 && !!e1.parameters && e1.parameters.indexOf(t1) > -1;
        }
        function ks(e1) {
            return "data-driven" === e1["property-type"];
        }
        function Vs(e1) {
            return zs(e1.expression, "measure-light");
        }
        function Fs(e1) {
            return zs(e1.expression, "zoom");
        }
        function Ds(e1) {
            return !!e1.expression && e1.expression.interpolated;
        }
        function Es(e1) {
            return "object" == typeof e1 && null !== e1 && !Array.isArray(e1);
        }
        function Cs(e1) {
            return e1;
        }
        function Rs(e1, t1) {
            const r = "color" === t1.type, n = e1.stops && "object" == typeof e1.stops[0][0], i = n || !(n || void 0 !== e1.property), s = e1.type || (Ds(t1) ? "exponential" : "interval");
            if (r && ((e1 = Object.assign({}, e1)).stops && (e1.stops = e1.stops.map((e1)=>[
                    e1[0],
                    dr.parse(e1[1])
                ])), e1.default = dr.parse(e1.default ? e1.default : t1.default)), e1.colorSpace && "rgb" !== e1.colorSpace && !Wi[e1.colorSpace]) throw new Error(`Unknown color space: ${e1.colorSpace}`);
            let a, o, l;
            if ("exponential" === s) a = Ns;
            else if ("interval" === s) a = Us;
            else if ("categorical" === s) {
                a = Os, o = Object.create(null);
                for (const t1 of e1.stops)o[t1[0]] = t1[1];
                l = typeof e1.stops[0][0];
            } else {
                if ("identity" !== s) throw new Error(`Unknown function type "${s}"`);
                a = js;
            }
            if (n) {
                const r = {}, n = [];
                for(let t1 = 0; t1 < e1.stops.length; t1++){
                    const i = e1.stops[t1], s = i[0].zoom;
                    void 0 === r[s] && (r[s] = {
                        zoom: s,
                        type: e1.type,
                        property: e1.property,
                        default: e1.default,
                        stops: []
                    }, n.push(s)), r[s].stops.push([
                        i[0].value,
                        i[1]
                    ]);
                }
                const i = [];
                for (const e1 of n)i.push([
                    r[e1].zoom,
                    Rs(r[e1], t1)
                ]);
                const s = {
                    name: "linear"
                };
                return {
                    kind: "composite",
                    interpolationType: s,
                    interpolationFactor: Yi.interpolationFactor.bind(void 0, s),
                    zoomStops: i.map((e1)=>e1[0]),
                    evaluate: ({ zoom: r }, n)=>Ns({
                            stops: i,
                            base: e1.base
                        }, t1, r).evaluate(r, n)
                };
            }
            if (i) {
                const r = "exponential" === s ? {
                    name: "exponential",
                    base: void 0 !== e1.base ? e1.base : 1
                } : null;
                return {
                    kind: "camera",
                    interpolationType: r,
                    interpolationFactor: Yi.interpolationFactor.bind(void 0, r),
                    zoomStops: e1.stops.map((e1)=>e1[0]),
                    evaluate: ({ zoom: r })=>a(e1, t1, r, o, l)
                };
            }
            return {
                kind: "source",
                evaluate (r, n) {
                    const i = n && n.properties ? n.properties[e1.property] : void 0;
                    return void 0 === i ? Ls(e1.default, t1.default) : a(e1, t1, i, o, l);
                }
            };
        }
        function Ls(e1, t1, r) {
            return void 0 !== e1 ? e1 : void 0 !== t1 ? t1 : void 0 !== r ? r : void 0;
        }
        function Os(e1, t1, r, n, i) {
            return Ls(typeof r === i ? n[r] : void 0, e1.default, t1.default);
        }
        function Us(e1, t1, r) {
            if (!rn(r)) return Ls(e1.default, t1.default);
            const n = e1.stops.length;
            if (1 === n) return e1.stops[0][1];
            if (r <= e1.stops[0][0]) return e1.stops[0][1];
            if (r >= e1.stops[n - 1][0]) return e1.stops[n - 1][1];
            const i = zi(e1.stops.map((e1)=>e1[0]), r);
            return e1.stops[i][1];
        }
        function Ns(e1, t1, r) {
            const n = void 0 !== e1.base ? e1.base : 1;
            if (!rn(r)) return Ls(e1.default, t1.default);
            const i = e1.stops.length;
            if (1 === i) return e1.stops[0][1];
            if (r <= e1.stops[0][0]) return e1.stops[0][1];
            if (r >= e1.stops[i - 1][0]) return e1.stops[i - 1][1];
            const s = zi(e1.stops.map((e1)=>e1[0]), r), a = function(e1, t1, r, n) {
                const i = n - r, s = e1 - r;
                return 0 === i ? 0 : 1 === t1 ? s / i : (Math.pow(t1, s) - 1) / (Math.pow(t1, i) - 1);
            }(r, n, e1.stops[s][0], e1.stops[s + 1][0]), o = e1.stops[s][1], l = e1.stops[s + 1][1];
            let u = xr[t1.type] || Cs;
            if (e1.colorSpace && "rgb" !== e1.colorSpace) {
                const t1 = Wi[e1.colorSpace];
                u = (e1, r)=>t1.reverse(t1.interpolate(t1.forward(e1), t1.forward(r), a));
            }
            return "function" == typeof o.evaluate ? {
                evaluate (...e1) {
                    const t1 = o.evaluate.apply(void 0, e1), r = l.evaluate.apply(void 0, e1);
                    if (void 0 !== t1 && void 0 !== r) return u(t1, r, a);
                }
            } : u(o, l, a);
        }
        function js(e1, t1, r) {
            return "color" === t1.type ? r = dr.parse(r) : "formatted" === t1.type ? r = Ur.fromString(r.toString()) : "resolvedImage" === t1.type ? r = jr.build(r.toString()) : Qr(r) === t1.type || "enum" === t1.type && t1.values[r] || (r = void 0), Ls(r, e1.default, t1.default);
        }
        un.register(bs, {
            error: [
                {
                    kind: "error"
                },
                [
                    Ar
                ],
                (e1, [t1])=>{
                    throw new Zr(t1.evaluate(e1));
                }
            ],
            typeof: [
                Ar,
                [
                    Sr
                ],
                (e1, [t1])=>Vr(qr(t1.evaluate(e1)))
            ],
            "to-rgba": [
                kr(_r, 4),
                [
                    Mr
                ],
                (e1, [t1])=>t1.evaluate(e1).toNonPremultipliedRenderColor(null).toArray()
            ],
            "to-hsla": [
                kr(_r, 4),
                [
                    Mr
                ],
                (e1, [t1])=>t1.evaluate(e1).toNonPremultipliedRenderColor(null).toHslaArray()
            ],
            rgb: [
                Mr,
                [
                    _r,
                    _r,
                    _r
                ],
                ws
            ],
            rgba: [
                Mr,
                [
                    _r,
                    _r,
                    _r,
                    _r
                ],
                ws
            ],
            hsl: [
                Mr,
                [
                    _r,
                    _r,
                    _r
                ],
                _s
            ],
            hsla: [
                Mr,
                [
                    _r,
                    _r,
                    _r,
                    _r
                ],
                _s
            ],
            has: {
                type: Ir,
                overloads: [
                    [
                        [
                            Ar
                        ],
                        (e1, [t1])=>As(t1.evaluate(e1), e1.properties())
                    ],
                    [
                        [
                            Ar,
                            Br
                        ],
                        (e1, [t1, r])=>As(t1.evaluate(e1), r.evaluate(e1))
                    ]
                ]
            },
            get: {
                type: Sr,
                overloads: [
                    [
                        [
                            Ar
                        ],
                        (e1, [t1])=>Is(t1.evaluate(e1), e1.properties())
                    ],
                    [
                        [
                            Ar,
                            Br
                        ],
                        (e1, [t1, r])=>Is(t1.evaluate(e1), r.evaluate(e1))
                    ]
                ]
            },
            "feature-state": [
                Sr,
                [
                    Ar
                ],
                (e1, [t1])=>Is(t1.evaluate(e1), e1.featureState || {})
            ],
            properties: [
                Br,
                [],
                (e1)=>e1.properties()
            ],
            "geometry-type": [
                Ar,
                [],
                (e1)=>e1.geometryType()
            ],
            worldview: [
                Ar,
                [],
                (e1)=>e1.globals.worldview || ""
            ],
            "is-active-floor": [
                Ir,
                Ms(Ar),
                (e1, t1)=>{
                    if (!(e1.globals && e1.globals.activeFloors && e1.globals.activeFloors.size > 0)) return !1;
                    if (0 === t1.length) return !0;
                    const r = e1.globals.activeFloors;
                    return t1.some((t1)=>{
                        const n = t1.evaluate(e1);
                        return r.has(n);
                    });
                }
            ],
            id: [
                Sr,
                [],
                (e1)=>e1.id()
            ],
            zoom: [
                _r,
                [],
                (e1)=>e1.globals.zoom
            ],
            pitch: [
                _r,
                [],
                (e1)=>e1.globals.pitch || 0
            ],
            "distance-from-center": [
                _r,
                [],
                (e1)=>e1.distanceFromCenter()
            ],
            "measure-light": [
                _r,
                [
                    Ar
                ],
                (e1, [t1])=>e1.measureLight(t1.evaluate(e1))
            ],
            "heatmap-density": [
                _r,
                [],
                (e1)=>e1.globals.heatmapDensity || 0
            ],
            "line-progress": [
                _r,
                [],
                (e1)=>e1.globals.lineProgress || 0
            ],
            "raster-value": [
                _r,
                [],
                (e1)=>e1.globals.rasterValue || 0
            ],
            "raster-particle-speed": [
                _r,
                [],
                (e1)=>e1.globals.rasterParticleSpeed || 0
            ],
            "sky-radial-progress": [
                _r,
                [],
                (e1)=>e1.globals.skyRadialProgress || 0
            ],
            accumulated: [
                Sr,
                [],
                (e1)=>void 0 === e1.globals.accumulated ? null : e1.globals.accumulated
            ],
            "+": [
                _r,
                Ms(_r),
                (e1, t1)=>{
                    let r = 0;
                    for (const n of t1)r += n.evaluate(e1);
                    return r;
                }
            ],
            "*": [
                _r,
                Ms(_r),
                (e1, t1)=>{
                    let r = 1;
                    for (const n of t1)r *= n.evaluate(e1);
                    return r;
                }
            ],
            "-": {
                type: _r,
                overloads: [
                    [
                        [
                            _r,
                            _r
                        ],
                        (e1, [t1, r])=>t1.evaluate(e1) - r.evaluate(e1)
                    ],
                    [
                        [
                            _r
                        ],
                        (e1, [t1])=>-t1.evaluate(e1)
                    ]
                ]
            },
            "/": [
                _r,
                [
                    _r,
                    _r
                ],
                (e1, [t1, r])=>t1.evaluate(e1) / r.evaluate(e1)
            ],
            "%": [
                _r,
                [
                    _r,
                    _r
                ],
                (e1, [t1, r])=>t1.evaluate(e1) % r.evaluate(e1)
            ],
            ln2: [
                _r,
                [],
                ()=>Math.LN2
            ],
            pi: [
                _r,
                [],
                ()=>Math.PI
            ],
            e: [
                _r,
                [],
                ()=>Math.E
            ],
            "^": [
                _r,
                [
                    _r,
                    _r
                ],
                (e1, [t1, r])=>Math.pow(t1.evaluate(e1), r.evaluate(e1))
            ],
            sqrt: [
                _r,
                [
                    _r
                ],
                (e1, [t1])=>Math.sqrt(t1.evaluate(e1))
            ],
            log10: [
                _r,
                [
                    _r
                ],
                (e1, [t1])=>Math.log(t1.evaluate(e1)) / Math.LN10
            ],
            ln: [
                _r,
                [
                    _r
                ],
                (e1, [t1])=>Math.log(t1.evaluate(e1))
            ],
            log2: [
                _r,
                [
                    _r
                ],
                (e1, [t1])=>Math.log2(t1.evaluate(e1))
            ],
            sin: [
                _r,
                [
                    _r
                ],
                (e1, [t1])=>Math.sin(t1.evaluate(e1))
            ],
            cos: [
                _r,
                [
                    _r
                ],
                (e1, [t1])=>Math.cos(t1.evaluate(e1))
            ],
            tan: [
                _r,
                [
                    _r
                ],
                (e1, [t1])=>Math.tan(t1.evaluate(e1))
            ],
            asin: [
                _r,
                [
                    _r
                ],
                (e1, [t1])=>Math.asin(t1.evaluate(e1))
            ],
            acos: [
                _r,
                [
                    _r
                ],
                (e1, [t1])=>Math.acos(t1.evaluate(e1))
            ],
            atan: [
                _r,
                [
                    _r
                ],
                (e1, [t1])=>Math.atan(t1.evaluate(e1))
            ],
            min: [
                _r,
                Ms(_r),
                (e1, t1)=>Math.min(...t1.map((t1)=>t1.evaluate(e1)))
            ],
            max: [
                _r,
                Ms(_r),
                (e1, t1)=>Math.max(...t1.map((t1)=>t1.evaluate(e1)))
            ],
            abs: [
                _r,
                [
                    _r
                ],
                (e1, [t1])=>Math.abs(t1.evaluate(e1))
            ],
            round: [
                _r,
                [
                    _r
                ],
                (e1, [t1])=>{
                    const r = t1.evaluate(e1);
                    return r < 0 ? -Math.round(-r) : Math.round(r);
                }
            ],
            floor: [
                _r,
                [
                    _r
                ],
                (e1, [t1])=>Math.floor(t1.evaluate(e1))
            ],
            ceil: [
                _r,
                [
                    _r
                ],
                (e1, [t1])=>Math.ceil(t1.evaluate(e1))
            ],
            "filter-==": [
                Ir,
                [
                    Ar,
                    Sr
                ],
                (e1, [t1, r])=>e1.properties()[t1.value] === r.value
            ],
            "filter-id-==": [
                Ir,
                [
                    Sr
                ],
                (e1, [t1])=>e1.id() === t1.value
            ],
            "filter-type-==": [
                Ir,
                [
                    Ar
                ],
                (e1, [t1])=>e1.geometryType() === t1.value
            ],
            "filter-<": [
                Ir,
                [
                    Ar,
                    Sr
                ],
                (e1, [t1, r])=>{
                    const n = e1.properties()[t1.value], i = r.value;
                    return typeof n == typeof i && n < i;
                }
            ],
            "filter-id-<": [
                Ir,
                [
                    Sr
                ],
                (e1, [t1])=>{
                    const r = e1.id(), n = t1.value;
                    return typeof r == typeof n && r < n;
                }
            ],
            "filter->": [
                Ir,
                [
                    Ar,
                    Sr
                ],
                (e1, [t1, r])=>{
                    const n = e1.properties()[t1.value], i = r.value;
                    return typeof n == typeof i && n > i;
                }
            ],
            "filter-id->": [
                Ir,
                [
                    Sr
                ],
                (e1, [t1])=>{
                    const r = e1.id(), n = t1.value;
                    return typeof r == typeof n && r > n;
                }
            ],
            "filter-<=": [
                Ir,
                [
                    Ar,
                    Sr
                ],
                (e1, [t1, r])=>{
                    const n = e1.properties()[t1.value], i = r.value;
                    return typeof n == typeof i && n <= i;
                }
            ],
            "filter-id-<=": [
                Ir,
                [
                    Sr
                ],
                (e1, [t1])=>{
                    const r = e1.id(), n = t1.value;
                    return typeof r == typeof n && r <= n;
                }
            ],
            "filter->=": [
                Ir,
                [
                    Ar,
                    Sr
                ],
                (e1, [t1, r])=>{
                    const n = e1.properties()[t1.value], i = r.value;
                    return typeof n == typeof i && n >= i;
                }
            ],
            "filter-id->=": [
                Ir,
                [
                    Sr
                ],
                (e1, [t1])=>{
                    const r = e1.id(), n = t1.value;
                    return typeof r == typeof n && r >= n;
                }
            ],
            "filter-has": [
                Ir,
                [
                    Sr
                ],
                (e1, [t1])=>t1.value in e1.properties()
            ],
            "filter-has-id": [
                Ir,
                [],
                (e1)=>null !== e1.id() && void 0 !== e1.id()
            ],
            "filter-type-in": [
                Ir,
                [
                    kr(Ar)
                ],
                (e1, [t1])=>t1.value.indexOf(e1.geometryType()) >= 0
            ],
            "filter-id-in": [
                Ir,
                [
                    kr(Sr)
                ],
                (e1, [t1])=>t1.value.indexOf(e1.id()) >= 0
            ],
            "filter-in-small": [
                Ir,
                [
                    Ar,
                    kr(Sr)
                ],
                (e1, [t1, r])=>r.value.indexOf(e1.properties()[t1.value]) >= 0
            ],
            "filter-in-large": [
                Ir,
                [
                    Ar,
                    kr(Sr)
                ],
                (e1, [t1, r])=>(function(e1, t1, r, n) {
                        for(; r <= n;){
                            const i = r + n >> 1;
                            if (t1[i] === e1) return !0;
                            t1[i] > e1 ? n = i - 1 : r = i + 1;
                        }
                        return !1;
                    })(e1.properties()[t1.value], r.value, 0, r.value.length - 1)
            ],
            all: {
                type: Ir,
                overloads: [
                    [
                        [
                            Ir,
                            Ir
                        ],
                        (e1, [t1, r])=>t1.evaluate(e1) && r.evaluate(e1)
                    ],
                    [
                        Ms(Ir),
                        (e1, t1)=>{
                            for (const r of t1)if (!r.evaluate(e1)) return !1;
                            return !0;
                        }
                    ]
                ]
            },
            any: {
                type: Ir,
                overloads: [
                    [
                        [
                            Ir,
                            Ir
                        ],
                        (e1, [t1, r])=>t1.evaluate(e1) || r.evaluate(e1)
                    ],
                    [
                        Ms(Ir),
                        (e1, t1)=>{
                            for (const r of t1)if (r.evaluate(e1)) return !0;
                            return !1;
                        }
                    ]
                ]
            },
            "!": [
                Ir,
                [
                    Ir
                ],
                (e1, [t1])=>!t1.evaluate(e1)
            ],
            "is-supported-script": [
                Ir,
                [
                    Ar
                ],
                (e1, [t1])=>{
                    const r = e1.globals && e1.globals.isSupportedScript;
                    return !r || r(t1.evaluate(e1));
                }
            ],
            upcase: [
                Ar,
                [
                    Ar
                ],
                (e1, [t1])=>t1.evaluate(e1).toUpperCase()
            ],
            downcase: [
                Ar,
                [
                    Ar
                ],
                (e1, [t1])=>t1.evaluate(e1).toLowerCase()
            ],
            concat: [
                Ar,
                Ms(Sr),
                (e1, t1)=>t1.map((t1)=>Hr(t1.evaluate(e1))).join("")
            ],
            "resolved-locale": [
                Ar,
                [
                    Pr
                ],
                (e1, [t1])=>t1.evaluate(e1).resolvedLocale()
            ],
            random: [
                _r,
                [
                    _r,
                    _r,
                    Sr
                ],
                (e1, t1)=>{
                    const [r, n, i] = t1.map((t1)=>t1.evaluate(e1));
                    if (r > n) return r;
                    if (r === n) return r;
                    let s;
                    if ("string" == typeof i) s = function(e1) {
                        let t1 = 0;
                        if (0 === e1.length) return t1;
                        for(let r = 0; r < e1.length; r++)t1 = (t1 << 5) - t1 + e1.charCodeAt(r), t1 &= t1;
                        return t1;
                    }(i);
                    else {
                        if ("number" != typeof i) throw new Zr(`Invalid seed input: ${i}`);
                        s = i;
                    }
                    return r + vs(s)() * (n - r);
                }
            ]
        });
        class Gs {
            constructor(e1, t1, r, n, i){
                this.expression = e1, this._warningHistory = {}, this._scope = r, this._options = n, this._iconImageUseTheme = i, this._evaluator = new ln(r, n, i), this._defaultValue = t1 ? function(e1) {
                    return "color" === e1.type && (Es(e1.default) || Array.isArray(e1.default)) ? new dr(0, 0, 0, 0) : "color" === e1.type ? dr.parse(e1.default) || null : void 0 === e1.default ? null : e1.default;
                }(t1) : null, this._enumValues = t1 && "enum" === t1.type ? t1.values : null, this.configDependencies = Bs(e1), this.isIndoorDependent = Ss(e1);
            }
            evaluateWithoutErrorHandling(e1, t1, r, n, i, s, a, o) {
                return this._evaluator.globals = e1, this._evaluator.feature = t1, this._evaluator.featureState = r, this._evaluator.canonical = n || null, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = s, this._evaluator.featureTileCoord = a || null, this._evaluator.featureDistanceData = o || null, this.expression.evaluate(this._evaluator);
            }
            evaluate(e1, t1, r, n, i, s, a, o, l) {
                this._evaluator || (this._evaluator = new ln(this._scope, this._options, this._iconImageUseTheme)), this._evaluator.globals = e1, this._evaluator.feature = t1 || null, this._evaluator.featureState = r || null, this._evaluator.canonical = n || null, this._evaluator.availableImages = i || null, this._evaluator.formattedSection = s || null, this._evaluator.featureTileCoord = a || null, this._evaluator.featureDistanceData = o || null, this._evaluator.iconImageUseTheme = l || null;
                try {
                    const e1 = this.expression.evaluate(this._evaluator);
                    if (null == e1 || "number" == typeof e1 && e1 != e1) return this._defaultValue;
                    if (this._enumValues && !(e1 in this._enumValues)) throw new Zr(`Expected value to be one of ${Object.keys(this._enumValues).map((e1)=>JSON.stringify(e1)).join(", ")}, but found ${JSON.stringify(e1)} instead.`);
                    return e1;
                } catch (e1) {
                    const t1 = e1;
                    return this._warningHistory[t1.message] || (this._warningHistory[t1.message] = !0, "undefined" != typeof console && console.warn(`Failed to evaluate expression "${JSON.stringify(this.expression.serialize())}". ${t1.message}`)), this._defaultValue;
                }
            }
        }
        function $s(e1) {
            return Array.isArray(e1) && e1.length > 0 && "string" == typeof e1[0] && e1[0] in bs;
        }
        function qs(e1, t1, r, n, i) {
            const s = new Pi(bs, [], t1 ? function(e1) {
                const t1 = {
                    color: Mr,
                    string: Ar,
                    number: _r,
                    enum: Ar,
                    boolean: Ir,
                    formatted: Tr,
                    resolvedImage: zr
                };
                return "array" === e1.type ? kr(t1[e1.value] || Sr, e1.length) : t1[e1.type];
            }(t1) : void 0, void 0, void 0, r, n, i), a = s.parse(e1, void 0, void 0, void 0, t1 && "string" === t1.type ? {
                typeAnnotation: "coerce"
            } : void 0);
            return a ? Ps(new Gs(a, t1, r, n, i)) : Ts(s.errors);
        }
        class Hs {
            constructor(e1, t1, r, n){
                this.kind = e1, this._styleExpression = t1, this.isLightConstant = r, this.isLineProgressConstant = n, this.isStateDependent = "constant" !== e1 && !wi(t1.expression), this.configDependencies = Bs(t1.expression), this.isIndoorDependent = Ss(t1.expression);
            }
            evaluateWithoutErrorHandling(e1, t1, r, n, i, s) {
                return this._styleExpression.evaluateWithoutErrorHandling(e1, t1, r, n, i, s);
            }
            evaluate(e1, t1, r, n, i, s, a) {
                return this._styleExpression.evaluate(e1, t1, r, n, i, s, void 0, void 0, a);
            }
        }
        class Xs {
            constructor(e1, t1, r, n, i, s){
                this.kind = e1, this.zoomStops = r, this._styleExpression = t1, this.isStateDependent = "camera" !== e1 && !wi(t1.expression), this.isIndoorDependent = Ss(t1.expression), this.isLightConstant = i, this.isLineProgressConstant = s, this.configDependencies = Bs(t1.expression), this.interpolationType = n;
            }
            evaluateWithoutErrorHandling(e1, t1, r, n, i, s) {
                return this._styleExpression.evaluateWithoutErrorHandling(e1, t1, r, n, i, s);
            }
            evaluate(e1, t1, r, n, i, s) {
                return this._styleExpression.evaluate(e1, t1, r, n, i, s);
            }
            interpolationFactor(e1, t1, r) {
                return this.interpolationType ? Yi.interpolationFactor(this.interpolationType, e1, t1, r) : 0;
            }
        }
        function Zs(e1, t1, r, n, i) {
            if ("error" === (e1 = qs(e1, t1, r, n, i)).result) return e1;
            const s = e1.value.expression, a = bi(s);
            if (!a && !ks(t1)) return Ts([
                new vr("", "data expressions not supported")
            ]);
            const o = _i(s, [
                "zoom",
                "pitch",
                "distance-from-center"
            ]);
            if (!o && !Fs(t1)) return Ts([
                new vr("", "zoom expressions not supported")
            ]);
            const l = _i(s, [
                "measure-light"
            ]);
            if (!l && !Vs(t1)) return Ts([
                new vr("", "measure-light expression not supported")
            ]);
            const u = _i(s, [
                "line-progress"
            ]);
            if (!u && !function(e1) {
                return zs(e1.expression, "line-progress");
            }(t1)) return Ts([
                new vr("", "line-progress expression not supported")
            ]);
            const c = t1.expression && t1.expression.relaxZoomRestriction, h = Ys(s);
            return h || o || c ? h instanceof vr ? Ts([
                h
            ]) : h instanceof Yi && !Ds(t1) ? Ts([
                new vr("", '"interpolate" expressions cannot be used with this property')
            ]) : Ps(h ? new Xs(a && u ? "camera" : "composite", e1.value, h.labels, h instanceof Yi ? h.interpolation : void 0, l, u) : new Hs(a && u ? "constant" : "source", e1.value, l, u)) : Ts([
                new vr("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression, or in the properties of atmosphere.')
            ]);
        }
        class Ws {
            constructor(e1, t1){
                this._parameters = e1, this._specification = t1, Object.assign(this, Rs(this._parameters, this._specification));
            }
            static deserialize(e1) {
                return new Ws(e1._parameters, e1._specification);
            }
            static serialize(e1) {
                return {
                    _parameters: e1._parameters,
                    _specification: e1._specification
                };
            }
        }
        function Ys(e1) {
            let t1 = null;
            if (e1 instanceof Qi) t1 = Ys(e1.result);
            else if (e1 instanceof Ki) {
                for (const r of e1.args)if (t1 = Ys(r), t1) break;
            } else (e1 instanceof ki || e1 instanceof Yi) && e1.input instanceof un && "zoom" === e1.input.name && (t1 = e1);
            return t1 instanceof vr || e1.eachChild((e1)=>{
                const r = Ys(e1);
                r instanceof vr ? t1 = r : t1 && r && t1 !== r && (t1 = new vr("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
            }), t1;
        }
        var Js, Ks, Qs = function() {
            if (Ks) return Js;
            Ks = 1, Js = t1;
            var e1 = 3;
            function t1(t1, r, n) {
                var i = this.cells = [];
                if (t1 instanceof ArrayBuffer) {
                    this.arrayBuffer = t1;
                    var s = new Int32Array(this.arrayBuffer);
                    t1 = s[0], this.d = (r = s[1]) + 2 * (n = s[2]);
                    for(var a = 0; a < this.d * this.d; a++){
                        var o = s[e1 + a], l = s[e1 + a + 1];
                        i.push(o === l ? null : s.subarray(o, l));
                    }
                    var u = s[e1 + i.length + 1];
                    this.keys = s.subarray(s[e1 + i.length], u), this.bboxes = s.subarray(u), this.insert = this._insertReadonly;
                } else {
                    this.d = r + 2 * n;
                    for(var c = 0; c < this.d * this.d; c++)i.push([]);
                    this.keys = [], this.bboxes = [];
                }
                this.n = r, this.extent = t1, this.padding = n, this.scale = r / t1, this.uid = 0;
                var h = n / r * t1;
                this.min = -h, this.max = t1 + h;
            }
            return t1.prototype.insert = function(e1, t1, r, n, i) {
                this._forEachCell(t1, r, n, i, this._insertCell, this.uid++), this.keys.push(e1), this.bboxes.push(t1), this.bboxes.push(r), this.bboxes.push(n), this.bboxes.push(i);
            }, t1.prototype._insertReadonly = function() {
                throw "Cannot insert into a GridIndex created from an ArrayBuffer.";
            }, t1.prototype._insertCell = function(e1, t1, r, n, i, s) {
                this.cells[i].push(s);
            }, t1.prototype.query = function(e1, t1, r, n, i) {
                var s = this.min, a = this.max;
                if (e1 <= s && t1 <= s && a <= r && a <= n && !i) return Array.prototype.slice.call(this.keys);
                var o = [];
                return this._forEachCell(e1, t1, r, n, this._queryCell, o, {}, i), o;
            }, t1.prototype._queryCell = function(e1, t1, r, n, i, s, a, o) {
                var l = this.cells[i];
                if (null !== l) for(var u = this.keys, c = this.bboxes, h = 0; h < l.length; h++){
                    var d = l[h];
                    if (void 0 === a[d]) {
                        var p = 4 * d;
                        (o ? o(c[p + 0], c[p + 1], c[p + 2], c[p + 3]) : e1 <= c[p + 2] && t1 <= c[p + 3] && r >= c[p + 0] && n >= c[p + 1]) ? (a[d] = !0, s.push(u[d])) : a[d] = !1;
                    }
                }
            }, t1.prototype._forEachCell = function(e1, t1, r, n, i, s, a, o) {
                for(var l = this._convertToCellCoord(e1), u = this._convertToCellCoord(t1), c = this._convertToCellCoord(r), h = this._convertToCellCoord(n), d = l; d <= c; d++)for(var p = u; p <= h; p++){
                    var f = this.d * p + d;
                    if ((!o || o(this._convertFromCellCoord(d), this._convertFromCellCoord(p), this._convertFromCellCoord(d + 1), this._convertFromCellCoord(p + 1))) && i.call(this, e1, t1, r, n, f, s, a, o)) return;
                }
            }, t1.prototype._convertFromCellCoord = function(e1) {
                return (e1 - this.padding) / this.scale;
            }, t1.prototype._convertToCellCoord = function(e1) {
                return Math.max(0, Math.min(this.d - 1, Math.floor(e1 * this.scale) + this.padding));
            }, t1.prototype.toArrayBuffer = function() {
                if (this.arrayBuffer) return this.arrayBuffer;
                for(var t1 = this.cells, r = e1 + this.cells.length + 1 + 1, n = 0, i = 0; i < this.cells.length; i++)n += this.cells[i].length;
                var s = new Int32Array(r + n + this.keys.length + this.bboxes.length);
                s[0] = this.extent, s[1] = this.n, s[2] = this.padding;
                for(var a = r, o = 0; o < t1.length; o++){
                    var l = t1[o];
                    s[e1 + o] = a, s.set(l, a), a += l.length;
                }
                return s[e1 + t1.length] = a, s.set(this.keys, a), s[e1 + t1.length + 1] = a += this.keys.length, s.set(this.bboxes, a), a += this.bboxes.length, s.buffer;
            }, Js;
        }(), ea = _e(Qs);
        const ta = {};
        function ra(e1, t1, r = {}) {
            Object.defineProperty(e1, "_classRegistryKey", {
                value: t1,
                writable: !1
            }), ta[t1] = {
                klass: e1,
                omit: r.omit || []
            };
        }
        ra(Object, "Object"), ea.serialize = function(e1, t1) {
            const r = e1.toArrayBuffer();
            return t1 && t1.add(r), {
                buffer: r
            };
        }, ea.deserialize = function(e1) {
            return new ea(e1.buffer);
        }, Object.defineProperty(ea, "name", {
            value: "Grid"
        }), ra(ea, "Grid"), delete Me.prototype.constructor, ra(dr, "Color"), ra(Error, "Error"), ra(Ur, "Formatted"), ra(Or, "FormattedSection"), ra(Ut, "AJAXError"), ra(jr, "ResolvedImage"), ra(Ws, "StylePropertyFunction"), ra(Gs, "StyleExpression", {
            omit: [
                "_evaluator"
            ]
        }), ra(lr, "ImageId"), ra(Nr, "ImageVariant"), ra(Xs, "ZoomDependentExpression"), ra(Hs, "ZoomConstantExpression"), ra(un, "CompoundExpression", {
            omit: [
                "_evaluate"
            ]
        });
        for(const e1 in bs)ta[bs[e1]._classRegistryKey] || ra(bs[e1], `Expression${e1}`);
        function na(e1) {
            return e1 && (e1 instanceof ArrayBuffer || e1.constructor && "ArrayBuffer" === e1.constructor.name);
        }
        function ia(e1, t1) {
            if (null == e1 || "boolean" == typeof e1 || "number" == typeof e1 || "string" == typeof e1 || e1 instanceof Boolean || e1 instanceof Number || e1 instanceof String || e1 instanceof Date || e1 instanceof RegExp) return e1;
            if (na(e1) || e1 instanceof ImageBitmap) return t1 && t1.add(e1), e1;
            if (ArrayBuffer.isView(e1)) return t1 && t1.add(e1.buffer), e1;
            if (e1 instanceof ImageData) return t1 && t1.add(e1.data.buffer), e1;
            if (Array.isArray(e1)) {
                const r = [];
                for (const n of e1)r.push(ia(n, t1));
                return r;
            }
            if (e1 instanceof Map) {
                const r = {
                    $name: "Map",
                    entries: []
                };
                for (const [n, i] of e1.entries())r.entries.push(ia(n), ia(i, t1));
                return r;
            }
            if (e1 instanceof Set) {
                const t1 = {
                    $name: "Set"
                };
                let r = 0;
                for (const n of e1.values())t1[++r] = ia(n);
                return t1;
            }
            if ("bigint" == typeof e1) return {
                $name: "BigInt",
                value: e1.toString()
            };
            if ("object" == typeof e1) {
                const r = e1.constructor, n = r._classRegistryKey;
                if (!n) throw new Error(`Can't serialize object of unregistered class "${r.name}".`);
                const i = r.serialize ? r.serialize(e1, t1) : {};
                if (!r.serialize) {
                    for(const r in e1)e1.hasOwnProperty(r) && (ta[n].omit.indexOf(r) >= 0 || (i[r] = ia(e1[r], t1)));
                    e1 instanceof Error && (i.message = e1.message);
                }
                if (i.$name) throw new Error("$name property is reserved for worker serialization logic.");
                return "Object" !== n && (i.$name = n), i;
            }
            throw new Error("can't serialize object of type " + typeof e1);
        }
        function sa(e1) {
            if (null == e1 || "boolean" == typeof e1 || "number" == typeof e1 || "string" == typeof e1 || e1 instanceof Boolean || e1 instanceof Number || e1 instanceof String || e1 instanceof Date || e1 instanceof RegExp || na(e1) || e1 instanceof ImageBitmap || ArrayBuffer.isView(e1) || e1 instanceof ImageData) return e1;
            if (Array.isArray(e1)) return e1.map(sa);
            if ("object" == typeof e1) {
                const t1 = e1.$name || "Object";
                if ("Map" === t1) {
                    const t1 = e1.entries || [], r = new Map;
                    for(let e1 = 0; e1 < t1.length; e1 += 2)r.set(sa(t1[e1]), sa(t1[e1 + 1]));
                    return r;
                }
                if ("Set" === t1) {
                    const t1 = new Set;
                    for (const r of Object.keys(e1))"$name" !== r && t1.add(sa(e1[r]));
                    return t1;
                }
                if ("BigInt" === t1) return BigInt(e1.value);
                const { klass: r } = ta[t1];
                if (!r) throw new Error(`Can't deserialize unregistered class "${t1}".`);
                if (r.deserialize) return r.deserialize(e1);
                const n = Object.create(r.prototype);
                for (const t1 of Object.keys(e1))"$name" !== t1 && (n[t1] = sa(e1[t1]));
                return n;
            }
            throw new Error("can't deserialize object of type " + typeof e1);
        }
        const aa = (e1)=>e1 >= 1536 && e1 <= 1791, oa = (e1)=>e1 >= 1872 && e1 <= 1919, la = (e1)=>e1 >= 2208 && e1 <= 2303, ua = (e1)=>e1 >= 11904 && e1 <= 12031, ca = (e1)=>e1 >= 12032 && e1 <= 12255, ha = (e1)=>e1 >= 12272 && e1 <= 12287, da = (e1)=>e1 >= 12288 && e1 <= 12351, pa = (e1)=>e1 >= 12352 && e1 <= 12447, fa = (e1)=>e1 >= 12448 && e1 <= 12543, ma = (e1)=>e1 >= 12544 && e1 <= 12591, ya = (e1)=>e1 >= 12704 && e1 <= 12735, ga = (e1)=>e1 >= 12736 && e1 <= 12783, xa = (e1)=>e1 >= 12784 && e1 <= 12799, va = (e1)=>e1 >= 12800 && e1 <= 13055, ba = (e1)=>e1 >= 13056 && e1 <= 13311, wa = (e1)=>e1 >= 13312 && e1 <= 19903, _a = (e1)=>e1 >= 19968 && e1 <= 40959, Aa = (e1)=>e1 >= 40960 && e1 <= 42127, Ia = (e1)=>e1 >= 42128 && e1 <= 42191, Ma = (e1)=>e1 >= 44032 && e1 <= 55215, Ba = (e1)=>e1 >= 63744 && e1 <= 64255, Sa = (e1)=>e1 >= 64336 && e1 <= 65023, Pa = (e1)=>e1 >= 65040 && e1 <= 65055, Ta = (e1)=>e1 >= 65072 && e1 <= 65103, za = (e1)=>e1 >= 65104 && e1 <= 65135, ka = (e1)=>e1 >= 65136 && e1 <= 65279, Va = (e1)=>e1 >= 65280 && e1 <= 65519;
        function Fa(e1) {
            for (const t1 of e1)if (Ra(t1.charCodeAt(0))) return !0;
            return !1;
        }
        function Da(e1) {
            for (const t1 of e1)if (!Ea(t1.charCodeAt(0))) return !1;
            return !0;
        }
        function Ea(e1) {
            return !(aa(e1) || oa(e1) || la(e1) || Sa(e1) || ka(e1));
        }
        function Ca(e1) {
            return !(e1 < 11904 || !(ya(e1) || ma(e1) || Ta(e1) || Ba(e1) || ba(e1) || ua(e1) || ga(e1) || da(e1) || wa(e1) || _a(e1) || va(e1) || Va(e1) || pa(e1) || ha(e1) || ca(e1) || xa(e1) || fa(e1) || Pa(e1) || Ia(e1) || Aa(e1)));
        }
        function Ra(e1) {
            return !(746 !== e1 && 747 !== e1 && (e1 < 4352 || !(ya(e1) || ma(e1) || Ta(e1) && !(e1 >= 65097 && e1 <= 65103) || Ba(e1) || ba(e1) || ua(e1) || ga(e1) || !(!da(e1) || e1 >= 12296 && e1 <= 12305 || e1 >= 12308 && e1 <= 12319 || 12336 === e1) || wa(e1) || _a(e1) || va(e1) || ((e1)=>e1 >= 12592 && e1 <= 12687)(e1) || ((e1)=>e1 >= 43360 && e1 <= 43391)(e1) || ((e1)=>e1 >= 55216 && e1 <= 55295)(e1) || ((e1)=>e1 >= 4352 && e1 <= 4607)(e1) || Ma(e1) || pa(e1) || ha(e1) || ((e1)=>e1 >= 12688 && e1 <= 12703)(e1) || ca(e1) || xa(e1) || fa(e1) && 12540 !== e1 || !(!Va(e1) || 65288 === e1 || 65289 === e1 || 65293 === e1 || e1 >= 65306 && e1 <= 65310 || 65339 === e1 || 65341 === e1 || 65343 === e1 || e1 >= 65371 && e1 <= 65503 || 65507 === e1 || e1 >= 65512 && e1 <= 65519) || !(!za(e1) || e1 >= 65112 && e1 <= 65118 || e1 >= 65123 && e1 <= 65126) || ((e1)=>e1 >= 5120 && e1 <= 5759)(e1) || ((e1)=>e1 >= 6320 && e1 <= 6399)(e1) || Pa(e1) || ((e1)=>e1 >= 19904 && e1 <= 19967)(e1) || Aa(e1) || Ia(e1))));
        }
        function La(e1) {
            return 12312 === e1 || 12313 === e1 || 12316 === e1 || 12540 === e1 || 12448 === e1;
        }
        function Oa(e1) {
            return !(Ra(e1) || function(e1) {
                return !!(((e1)=>e1 >= 128 && e1 <= 255)(e1) && (167 === e1 || 169 === e1 || 174 === e1 || 177 === e1 || 188 === e1 || 189 === e1 || 190 === e1 || 215 === e1 || 247 === e1) || ((e1)=>e1 >= 8192 && e1 <= 8303)(e1) && (8214 === e1 || 8224 === e1 || 8225 === e1 || 8240 === e1 || 8241 === e1 || 8251 === e1 || 8252 === e1 || 8258 === e1 || 8263 === e1 || 8264 === e1 || 8265 === e1 || 8273 === e1) || ((e1)=>e1 >= 8448 && e1 <= 8527)(e1) || ((e1)=>e1 >= 8528 && e1 <= 8591)(e1) || ((e1)=>e1 >= 8960 && e1 <= 9215)(e1) && (e1 >= 8960 && e1 <= 8967 || e1 >= 8972 && e1 <= 8991 || e1 >= 8996 && e1 <= 9e3 || 9003 === e1 || e1 >= 9085 && e1 <= 9114 || e1 >= 9150 && e1 <= 9165 || 9167 === e1 || e1 >= 9169 && e1 <= 9179 || e1 >= 9186 && e1 <= 9215) || ((e1)=>e1 >= 9216 && e1 <= 9279)(e1) && 9251 !== e1 || ((e1)=>e1 >= 9280 && e1 <= 9311)(e1) || ((e1)=>e1 >= 9312 && e1 <= 9471)(e1) || ((e1)=>e1 >= 9632 && e1 <= 9727)(e1) || ((e1)=>e1 >= 9728 && e1 <= 9983)(e1) && !(e1 >= 9754 && e1 <= 9759) || ((e1)=>e1 >= 11008 && e1 <= 11263)(e1) && (e1 >= 11026 && e1 <= 11055 || e1 >= 11088 && e1 <= 11097 || e1 >= 11192 && e1 <= 11243) || da(e1) || fa(e1) || ((e1)=>e1 >= 57344 && e1 <= 63743)(e1) || Ta(e1) || za(e1) || Va(e1) || 8734 === e1 || 8756 === e1 || 8757 === e1 || e1 >= 9984 && e1 <= 10087 || e1 >= 10102 && e1 <= 10131 || 65532 === e1 || 65533 === e1);
            }(e1));
        }
        function Ua(e1) {
            return aa(e1) || oa(e1) || la(e1) || Sa(e1) || ka(e1);
        }
        function Na(e1) {
            return e1 >= 1424 && e1 <= 2303 || Sa(e1) || ka(e1);
        }
        function ja(e1, t1) {
            return !(!t1 && Na(e1) || e1 >= 2304 && e1 <= 3583 || e1 >= 3840 && e1 <= 4255 || ((e1)=>e1 >= 6016 && e1 <= 6143)(e1));
        }
        function Ga(e1) {
            for (const t1 of e1)if (Na(t1.charCodeAt(0))) return !0;
            return !1;
        }
        const $a = {
            unavailable: "unavailable",
            deferred: "deferred",
            loading: "loading",
            parsing: "parsing",
            parsed: "parsed",
            loaded: "loaded",
            error: "error"
        };
        let qa = null, Ha = $a.unavailable, Xa = null;
        const Za = function(e1) {
            e1 && "string" == typeof e1 && e1.indexOf("NetworkError") > -1 && (Ha = $a.error), qa && qa(e1);
        };
        function Wa() {
            Ya.fire(new nr("pluginStateChange", {
                pluginStatus: Ha,
                pluginURL: Xa
            }));
        }
        const Ya = new or, Ja = function() {
            return Ha;
        }, Ka = function() {
            if (Ha !== $a.deferred || !Xa) throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");
            Ha = $a.loading, Wa(), Xa && $t({
                url: Xa
            }, (e1)=>{
                e1 ? Za(e1) : (Ha = $a.loaded, Wa());
            });
        }, Qa = {
            applyArabicShaping: null,
            processBidirectionalText: null,
            processStyledBidirectionalText: null,
            isLoaded: ()=>Ha === $a.loaded || null != Qa.applyArabicShaping,
            isLoading: ()=>Ha === $a.loading,
            setState (e1) {
                Ha = e1.pluginStatus, Xa = e1.pluginURL;
            },
            isParsing: ()=>Ha === $a.parsing,
            isParsed: ()=>Ha === $a.parsed,
            getPluginURL: ()=>Xa
        }, eo = function() {
            Qa.isLoading() || Qa.isLoaded() || "deferred" !== Ja() || Ka();
        };
        class to {
            constructor(e1, t1){
                this.zoom = e1, t1 ? (this.now = t1.now, this.fadeDuration = t1.fadeDuration, this.transition = t1.transition, this.pitch = t1.pitch, this.brightness = t1.brightness, this.worldview = t1.worldview, this.activeFloors = t1.activeFloors) : (this.now = 0, this.fadeDuration = 0, this.transition = {}, this.pitch = 0, this.brightness = 0);
            }
            isSupportedScript(e1) {
                return function(e1, t1) {
                    for (const r of e1)if (!ja(r.charCodeAt(0), t1)) return !1;
                    return !0;
                }(e1, Qa.isLoaded());
            }
        }
        class ro {
            constructor(e1, t1, r, n, i){
                this.property = e1, this.value = t1, this.expression = function(e1, t1, r, n, i) {
                    if (Es(e1)) return new Ws(e1, t1);
                    if ($s(e1) || Array.isArray(e1) && e1.length > 0) {
                        const s = Zs(e1, t1, r, n, i);
                        if ("error" === s.result) throw new Error(s.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                        return s.value;
                    }
                    {
                        let r = e1;
                        return "string" == typeof e1 && "color" === t1.type && (r = dr.parse(e1)), {
                            kind: "constant",
                            configDependencies: new Set,
                            isIndoorDependent: !1,
                            evaluate: ()=>r
                        };
                    }
                }(void 0 === t1 ? e1.specification.default : t1, e1.specification, r, n, i);
            }
            isIndoorDependent() {
                return this.expression.isIndoorDependent;
            }
            isDataDriven() {
                return "source" === this.expression.kind || "composite" === this.expression.kind;
            }
            possiblyEvaluate(e1, t1, r, n) {
                return this.property.possiblyEvaluate(this, e1, t1, r, n);
            }
        }
        class no {
            constructor(e1, t1, r, n){
                this.property = e1, this.value = new ro(e1, void 0, t1, r, n);
            }
            transitioned(e1, t1) {
                return new so(this.property, this.value, t1, Object.assign({}, e1.transition, this.transition), e1.now);
            }
            untransitioned() {
                return new so(this.property, this.value, null, {}, 0);
            }
        }
        class io {
            constructor(e1, t1, r, n){
                this._properties = e1, this._values = Object.create(e1.defaultTransitionablePropertyValues), this._scope = t1, this._options = r, this._iconImageUseTheme = n, this._isIndoorDependent = !1, this.configDependencies = new Set;
            }
            getValue(e1) {
                return qe(this._values[e1].value.value);
            }
            setValue(e1, t1) {
                this._values.hasOwnProperty(e1) || (this._values[e1] = new no(this._values[e1].property, this._scope, this._options, this._iconImageUseTheme)), this._values[e1].value = new ro(this._values[e1].property, null === t1 ? void 0 : qe(t1), this._scope, this._options, this._iconImageUseTheme), this._values[e1].value.expression.configDependencies && (this.configDependencies = new Set([
                    ...this.configDependencies,
                    ...this._values[e1].value.expression.configDependencies
                ]), this._isIndoorDependent = this._isIndoorDependent || this._values[e1].value.isIndoorDependent());
            }
            setTransitionOrValue(e1, t1) {
                t1 && (this._options = t1);
                const r = this._properties.properties;
                if (e1) for(const t1 in e1){
                    const n = e1[t1];
                    if (t1.endsWith("-transition")) {
                        const e1 = t1.slice(0, -11);
                        r[e1] && this.setTransition(e1, n);
                    } else r.hasOwnProperty(t1) && this.setValue(t1, n);
                }
            }
            getTransition(e1) {
                return qe(this._values[e1].transition);
            }
            setTransition(e1, t1) {
                this._values.hasOwnProperty(e1) || (this._values[e1] = new no(this._values[e1].property)), this._values[e1].transition = qe(t1) || void 0;
            }
            serialize() {
                const e1 = {};
                for (const t1 of Object.keys(this._values)){
                    const r = this.getValue(t1);
                    void 0 !== r && (e1[t1] = r);
                    const n = this.getTransition(t1);
                    void 0 !== n && (e1[`${t1}-transition`] = n);
                }
                return e1;
            }
            transitioned(e1, t1) {
                const r = new ao(this._properties);
                for (const n of Object.keys(this._values))r._values[n] = this._values[n].transitioned(e1, t1._values[n]);
                return r;
            }
            untransitioned() {
                const e1 = new ao(this._properties);
                for (const t1 of Object.keys(this._values))e1._values[t1] = this._values[t1].untransitioned();
                return e1;
            }
            isIndoorDependent() {
                return this._isIndoorDependent;
            }
        }
        class so {
            constructor(e1, t1, r, n, i){
                const s = n.delay || 0, a = n.duration || 0;
                i = i || 0, this.property = e1, this.value = t1, this.begin = i + s, this.end = this.begin + a, e1.specification.transition && (n.delay || n.duration) && (this.prior = r);
            }
            possiblyEvaluate(e1, t1, r) {
                const n = e1.now || 0, i = this.value.possiblyEvaluate(e1, t1, r), s = this.prior;
                if (s) {
                    if (n > this.end) return this.prior = null, i;
                    if (this.value.isDataDriven()) return this.prior = null, i;
                    if (n < this.begin) return s.possiblyEvaluate(e1, t1, r);
                    {
                        const a = (n - this.begin) / (this.end - this.begin);
                        return this.property.interpolate(s.possiblyEvaluate(e1, t1, r), i, Ve(a));
                    }
                }
                return i;
            }
        }
        class ao {
            constructor(e1){
                this._properties = e1, this._values = Object.create(e1.defaultTransitioningPropertyValues);
            }
            possiblyEvaluate(e1, t1, r) {
                const n = new uo(this._properties);
                for (const i of Object.keys(this._values))n._values[i] = this._values[i].possiblyEvaluate(e1, t1, r);
                return n;
            }
            hasTransition() {
                for (const e1 of Object.keys(this._values))if (this._values[e1].prior) return !0;
                return !1;
            }
        }
        class oo {
            constructor(e1, t1, r, n){
                this._properties = e1, this._values = Object.create(e1.defaultPropertyValues), this._scope = t1, this._options = r, this._iconImageUseTheme = n, this._isIndoorDependent = !1, this.configDependencies = new Set;
            }
            getValue(e1) {
                return qe(this._values[e1].value);
            }
            setValue(e1, t1) {
                this._values[e1] = new ro(this._values[e1].property, null === t1 ? void 0 : qe(t1), this._scope, this._options, this._iconImageUseTheme), this._values[e1].expression.configDependencies && (this.configDependencies = new Set([
                    ...this.configDependencies,
                    ...this._values[e1].expression.configDependencies
                ]), this._isIndoorDependent = this._isIndoorDependent || this._values[e1].isIndoorDependent());
            }
            serialize() {
                const e1 = {};
                for (const t1 of Object.keys(this._values)){
                    const r = this.getValue(t1);
                    void 0 !== r && (e1[t1] = r);
                }
                return e1;
            }
            possiblyEvaluate(e1, t1, r, n) {
                const i = new uo(this._properties);
                for (const s of Object.keys(this._values))i._values[s] = this._values[s].possiblyEvaluate(e1, t1, r, n);
                return i;
            }
            isIndoorDependent() {
                return this._isIndoorDependent;
            }
        }
        class lo {
            constructor(e1, t1, r, n){
                this.property = e1, this.value = t1, this.parameters = r, this.iconImageUseTheme = n;
            }
            isConstant() {
                return "constant" === this.value.kind;
            }
            constantOr(e1) {
                return "constant" === this.value.kind ? this.value.value : e1;
            }
            evaluate(e1, t1, r, n, i) {
                return this.property.evaluate(this.value, this.parameters, e1, t1, r, n, this.iconImageUseTheme, i);
            }
        }
        class uo {
            constructor(e1){
                this._properties = e1, this._values = Object.create(e1.defaultPossiblyEvaluatedValues);
            }
            get(e1) {
                return this._values[e1];
            }
        }
        class co {
            constructor(e1){
                this.specification = e1;
            }
            possiblyEvaluate(e1, t1) {
                return e1.expression.evaluate(t1);
            }
            interpolate(e1, t1, r) {
                const n = xr[this.specification.type];
                return n ? n(e1, t1, r) : e1;
            }
        }
        class ho {
            constructor(e1, t1){
                this.specification = e1, this.overrides = t1;
            }
            possiblyEvaluate(e1, t1, r, n, i) {
                return "constant" === e1.expression.kind || "camera" === e1.expression.kind ? new lo(this, {
                    kind: "constant",
                    value: e1.expression.evaluate(t1, null, {}, r, n, void 0, i)
                }, t1) : new lo(this, e1.expression, t1, i);
            }
            interpolate(e1, t1, r) {
                if ("constant" !== e1.value.kind || "constant" !== t1.value.kind) return e1;
                if (void 0 === e1.value.value || void 0 === t1.value.value) return new lo(this, {
                    kind: "constant",
                    value: void 0
                }, e1.parameters);
                const n = xr[this.specification.type];
                return n ? new lo(this, {
                    kind: "constant",
                    value: n(e1.value.value, t1.value.value, r)
                }, e1.parameters) : e1;
            }
            evaluate(e1, t1, r, n, i, s, a, o) {
                return "constant" === e1.kind ? e1.value : e1.evaluate(t1, r, n, i, s, o, a);
            }
        }
        class po {
            constructor(e1){
                this.specification = e1;
            }
            possiblyEvaluate(e1, t1, r, n) {
                return !!e1.expression.evaluate(t1, null, {}, r, n);
            }
            interpolate() {
                return !1;
            }
        }
        class fo {
            constructor(e1){
                this.properties = e1, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                const t1 = new to(0, {});
                for(const r in e1){
                    const n = e1[r], i = n.specification;
                    i && i.overridable && this.overridableProperties.push(r);
                    const s = this.defaultPropertyValues[r] = new ro(n, void 0), a = this.defaultTransitionablePropertyValues[r] = new no(n);
                    this.defaultTransitioningPropertyValues[r] = a.untransitioned(), this.defaultPossiblyEvaluatedValues[r] = s.possiblyEvaluate(t1);
                }
            }
        }
        ra(ho, "DataDrivenProperty"), ra(co, "DataConstantProperty"), ra(po, "ColorRampProperty");
        var mo = JSON.parse('{"$version":8,"$root":{"version":{"type":"enum","values":[8]},"fragment":{"type":"boolean"},"name":{"type":"string"},"metadata":{"type":"*"},"center":{"type":"array","value":"number"},"zoom":{"type":"number"},"bearing":{"type":"number","default":0,"period":360},"pitch":{"type":"number","default":0},"light":{"type":"light"},"lights":{"type":"array","value":"light-3d"},"terrain":{"type":"terrain","optional":true},"fog":{"type":"fog"},"snow":{"type":"snow"},"rain":{"type":"rain"},"camera":{"type":"camera"},"color-theme":{"type":"colorTheme"},"indoor":{"type":"indoor"},"imports":{"type":"array","value":"import"},"iconsets":{"type":"iconsets"},"schema":{"type":"schema"},"sources":{"type":"sources"},"sprite":{"type":"string"},"glyphs":{"type":"string","default":"mapbox://fonts/mapbox/{fontstack}/{range}.pbf"},"transition":{"type":"transition"},"projection":{"type":"projection"},"layers":{"type":"array","value":"layer"},"models":{"type":"models"},"featuresets":{"type":"featuresets"}},"featuresets":{"*":{"type":"featureset"}},"featureset":{"metadata":{"type":"*"},"selectors":{"type":"array","value":"selector"}},"selector":{"layer":{"type":"string"},"properties":{"type":"selectorProperty"},"featureNamespace":{"type":"string"},"_uniqueFeatureID":{"type":"boolean"}},"selectorProperty":{"*":{"type":"*"}},"model":{"type":"string"},"import":{"id":{"type":"string"},"url":{"type":"string"},"config":{"type":"config"},"data":{"type":"$root"},"color-theme":{"type":"colorTheme","optional":true}},"config":{"*":{"type":"*"}},"schema":{"*":{"type":"option"}},"option":{"default":{"type":"*","expression":{}},"type":{"type":"enum","values":{"string":1,"number":1,"boolean":1,"color":1}},"array":{"type":"boolean"},"minValue":{"type":"number"},"maxValue":{"type":"number"},"stepValue":{"type":"number"},"values":{"type":"array","value":"*"},"metadata":{"type":"*"}},"models":{"*":{"type":"model"}},"light-3d":{"id":{"type":"string"},"properties":{"type":"properties"},"type":{"type":"enum","values":{"ambient":{},"directional":{},"flat":{}}}},"properties":["properties_light_directional","properties_light_ambient","properties_light_flat"],"properties_light_directional":{"direction":{"type":"array","default":[210,30],"minimum":[0,0],"maximum":[360,90],"length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"use-theme":true,"transition":true},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"cast-shadows":{"type":"boolean","default":false},"shadow-quality":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"parameters":["zoom"]}},"shadow-intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"shadow-draw-before-layer":{"type":"string"}},"properties_light_ambient":{"color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"use-theme":true,"transition":true},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"properties_light_flat":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"use-theme":true,"transition":true},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"iconsets":{"*":{"type":"iconset"}},"iconset":["iconset_sprite","iconset_source"],"iconset_sprite":{"type":{"type":"enum","values":{"sprite":1}},"url":{"type":"string"}},"iconset_source":{"type":{"type":"enum","values":{"source":1}},"source":{"type":"string"}},"sources":{"*":{"type":"source"}},"source":["source_vector","source_raster","source_raster_dem","source_raster_array","source_geojson","source_video","source_image","source_model"],"source_vector":{"type":{"type":"enum","values":{"vector":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"extra_bounds":{"type":"array","value":{"type":"array","value":"number","length":4}},"scheme":{"type":"enum","values":{"xyz":1,"tms":1},"default":"xyz"},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"attribution":{"type":"string"},"promoteId":{"type":"promoteId"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster":{"type":{"type":"enum","values":{"raster":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"extra_bounds":{"type":"array","value":{"type":"array","value":"number","length":4}},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"scheme":{"type":"enum","values":{"xyz":1,"tms":1},"default":"xyz"},"attribution":{"type":"string"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_dem":{"type":{"type":"enum","values":{"raster-dem":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"extra_bounds":{"type":"array","value":{"type":"array","value":"number","length":4}},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"encoding":{"type":"enum","values":{"terrarium":1,"mapbox":1},"default":"mapbox"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_raster_array":{"type":{"type":"enum","values":{"raster-array":1}},"url":{"type":"string"},"tiles":{"type":"array","value":"string"},"bounds":{"type":"array","value":"number","length":4,"default":[-180,-85.051129,180,85.051129]},"extra_bounds":{"type":"array","value":{"type":"array","value":"number","length":4}},"minzoom":{"type":"number","default":0},"maxzoom":{"type":"number","default":22},"tileSize":{"type":"number","default":512},"attribution":{"type":"string"},"rasterLayers":{"type":"*"},"volatile":{"type":"boolean","default":false},"*":{"type":"*"}},"source_geojson":{"type":{"type":"enum","values":{"geojson":1}},"data":{"type":"*"},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"attribution":{"type":"string"},"buffer":{"type":"number","default":128,"maximum":512,"minimum":0},"filter":{"type":"*"},"tolerance":{"type":"number","default":0.375},"cluster":{"type":"boolean","default":false},"clusterRadius":{"type":"number","default":50,"minimum":0},"clusterMaxZoom":{"type":"number"},"clusterMinPoints":{"type":"number"},"clusterProperties":{"type":"*"},"lineMetrics":{"type":"boolean","default":false},"generateId":{"type":"boolean","default":false},"promoteId":{"type":"promoteId"},"dynamic":{"type":"boolean","default":false}},"source_video":{"type":{"type":"enum","values":{"video":1}},"urls":{"type":"array","value":"string"},"coordinates":{"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"source_image":{"type":{"type":"enum","values":{"image":1}},"url":{"type":"string"},"coordinates":{"type":"array","length":4,"value":{"type":"array","length":2,"value":"number"}}},"modelNodeOverride":{"orientation":{"type":"array","value":"number","length":3,"default":[0,0,0],"period":360}},"modelNodeOverrides":{"*":{"type":"modelNodeOverride"}},"modelMaterialOverride":{"model-color":{"type":"color"},"model-color-mix-intensity":{"type":"number"},"model-opacity":{"type":"number"},"model-emissive-strength":{"type":"number"}},"modelMaterialOverrides":{"*":{"type":"modelMaterialOverride"}},"modelSourceModel":{"uri":{"type":"string"},"position":{"type":"array","value":"number","length":2,"default":[0,0],"minimum":[-180,-90],"maximum":[180,90]},"orientation":{"type":"array","value":"number","length":3,"default":[0,0,0],"period":360},"nodeOverrides":{"type":"modelNodeOverrides"},"materialOverrides":{"type":"modelMaterialOverrides"},"nodeOverrideNames":{"type":"array","value":"string"},"materialOverrideNames":{"type":"array","value":"string"},"featureProperties":{"type":"*"}},"modelSourceModels":{"*":{"type":"modelSourceModel"}},"source_model":{"type":{"type":"enum","values":{"model":1,"batched-model":1}},"url":{"type":"string"},"maxzoom":{"type":"number","default":18},"minzoom":{"type":"number","default":0},"tiles":{"type":"array","value":"string"},"models":{"type":"modelSourceModels"}},"layer":{"id":{"type":"string"},"type":{"type":"enum","values":{"fill":{},"line":{},"symbol":{},"circle":{},"heatmap":{},"fill-extrusion":{},"building":{},"raster":{},"raster-particle":{},"hillshade":{},"model":{},"background":{},"sky":{},"slot":{},"clip":{}}},"metadata":{"type":"*"},"source":{"type":"string"},"source-layer":{"type":"string"},"slot":{"type":"string"},"minzoom":{"type":"number","minimum":0,"maximum":24},"maxzoom":{"type":"number","minimum":0,"maximum":24},"filter":{"type":"filter"},"layout":{"type":"layout"},"paint":{"type":"paint"},"appearances":{"type":"array","value":"appearance","supported-layer-types":["symbol"]}},"appearance":{"condition":{"type":"boolean","expression":{"interpolated":true,"parameters":["zoom","pitch","feature","feature-state","measure-light","distance-from-center"]},"property-type":"data-driven"},"name":{"type":"string"},"properties":{"type":"*"}},"layout":["layout_clip","layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_building","layout_symbol","layout_raster","layout_raster-particle","layout_hillshade","layout_background","layout_sky","layout_model"],"layout_background":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_sky":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_model":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}},"model-id":{"type":"string","default":"","property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"model-allow-density-reduction":{"type":"boolean","default":true}},"layout_clip":{"clip-layer-types":{"type":"array","value":"enum","values":{"model":1,"symbol":1},"default":[],"expression":{}},"clip-layer-scope":{"type":"array","value":"string","default":[],"expression":{}},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_fill":{"fill-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}},"fill-elevation-reference":{"type":"enum","values":{"none":1,"hd-road-base":1,"hd-road-markup":1},"default":"none","expression":{}},"fill-construct-bridge-guard-rail":{"type":"boolean","default":"true","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"}},"layout_circle":{"circle-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"circle-elevation-reference":{"type":"enum","values":{"none":1,"hd-road-markup":1},"default":"none","expression":{}},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_heatmap":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_fill-extrusion":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}},"fill-extrusion-edge-radius":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{}},"source-max-zoom":{"type":"number","minimum":0,"maximum":24}},"layout_building":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}},"building-facade":{"type":"boolean","default":false,"expression":{"parameters":["feature"]},"property-type":"data-driven"},"building-facade-floors":{"type":"number","minimum":1,"maximum":200,"default":3,"property-type":"data-driven","expression":{"parameters":["feature"]}},"building-facade-unit-width":{"type":"number","minimum":1,"maximum":20,"default":3.1,"property-type":"data-driven","expression":{"parameters":["feature"]}},"building-facade-window":{"type":"array","length":2,"value":"number","minimum":0.1,"maximum":1,"default":[0.9,0.9],"property-type":"data-driven","expression":{"parameters":["feature"]}},"building-roof-shape":{"type":"enum","values":{"flat":1,"hipped":1,"gabled":1,"parapet":1,"mansard":1,"skillion":1,"pyramidal":1},"default":"flat","expression":{"parameters":["feature"]},"property-type":"data-driven"},"building-height":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{},"property-type":"data-driven"},"building-base":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{},"property-type":"data-driven"},"building-flood-light-wall-radius":{"property-type":"data-driven","type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"building-flood-light-ground-radius":{"property-type":"data-driven","type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"building-flip-roof-orientation":{"property-type":"data-driven","type":"boolean","default":false,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}}},"layout_line":{"line-cap":{"type":"enum","values":{"butt":1,"round":1,"square":1},"default":"butt","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-join":{"type":"enum","values":{"bevel":1,"round":1,"miter":1,"none":1},"default":"miter","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-miter-limit":{"type":"number","default":2,"expression":{"interpolated":true,"parameters":["zoom"]}},"line-round-limit":{"type":"number","default":1.05,"expression":{"interpolated":true,"parameters":["zoom"]}},"line-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-z-offset":{"type":"number","default":0,"expression":{"parameters":["zoom","feature","line-progress"]},"property-type":"data-driven"},"line-elevation-reference":{"type":"enum","values":{"none":1,"sea":1,"ground":1,"hd-road-markup":1},"default":"none","expression":{}},"line-cross-slope":{"type":"number","expression":{}},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}},"line-width-unit":{"type":"enum","values":{"pixels":1,"meters":1},"default":"pixels","expression":{"parameters":["zoom"]}},"line-elevation-ground-scale":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","feature","line-progress"]},"transition":true,"property-type":"data-driven"}},"layout_symbol":{"symbol-placement":{"type":"enum","values":{"point":1,"line":1,"line-center":1},"default":"point","expression":{"parameters":["zoom"]}},"symbol-spacing":{"type":"number","default":250,"minimum":1,"expression":{"interpolated":true,"parameters":["zoom"]}},"symbol-avoid-edges":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"symbol-sort-key":{"type":"number","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"symbol-z-order":{"type":"enum","values":{"auto":1,"viewport-y":1,"source":1},"default":"auto","expression":{"parameters":["zoom"]}},"symbol-z-elevate":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"symbol-elevation-reference":{"type":"enum","values":{"sea":1,"ground":1,"hd-road-markup":1},"default":"ground","expression":{"parameters":["zoom"]}},"icon-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"icon-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"icon-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"icon-rotation-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]}},"icon-size":{"type":"number","default":1,"minimum":0,"appearance":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-size-scale-range":{"type":"array","value":"number","length":2,"default":[0.8,2],"minimum":[0.1,0.1],"maximum":[10,10],"expression":{}},"icon-text-fit":{"type":"enum","values":{"none":1,"width":1,"height":1,"both":1},"default":"none","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit-padding":{"type":"array","value":"number","length":4,"default":[0,0,0,0],"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-image":{"type":"resolvedImage","tokens":true,"appearance":true,"use-theme":true,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-rotate":{"type":"number","default":0,"period":360,"appearance":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]}},"icon-keep-upright":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"icon-offset":{"type":"array","value":"number","length":2,"default":[0,0],"appearance":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-anchor":{"type":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"icon-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]}},"text-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]}},"text-rotation-alignment":{"type":"enum","values":{"map":1,"viewport":1,"auto":1},"default":"auto","expression":{"parameters":["zoom"]}},"text-field":{"type":"formatted","default":"","tokens":true,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-font":{"type":"array","value":"string","default":["Open Sans Regular","Arial Unicode MS Regular"],"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-size":{"type":"number","default":16,"minimum":0,"appearance":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-size-scale-range":{"type":"array","value":"number","length":2,"default":[0.8,2],"minimum":[0.1,0.1],"maximum":[10,10],"expression":{}},"text-max-width":{"type":"number","default":10,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-line-height":{"type":"number","default":1.2,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-letter-spacing":{"type":"number","default":0,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-justify":{"type":"enum","values":{"auto":1,"left":1,"center":1,"right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-radial-offset":{"type":"number","default":0,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["zoom","feature"]}},"text-variable-anchor":{"type":"array","value":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"expression":{"parameters":["zoom"]}},"text-anchor":{"type":"enum","values":{"center":1,"left":1,"right":1,"top":1,"bottom":1,"top-left":1,"top-right":1,"bottom-left":1,"bottom-right":1},"default":"center","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-max-angle":{"type":"number","default":45,"expression":{"interpolated":true,"parameters":["zoom"]}},"text-writing-mode":{"type":"array","value":"enum","values":{"horizontal":1,"vertical":1},"expression":{"parameters":["zoom"]}},"text-rotate":{"type":"number","default":0,"period":360,"appearance":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-padding":{"type":"number","default":2,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]}},"text-keep-upright":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"text-transform":{"type":"enum","values":{"none":1,"uppercase":1,"lowercase":1},"default":"none","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-offset":{"type":"array","value":"number","length":2,"default":[0,0],"appearance":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"text-allow-overlap":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"text-ignore-placement":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"text-optional":{"type":"boolean","default":false,"expression":{"parameters":["zoom"]}},"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_raster":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_raster-particle":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"layout_hillshade":{"visibility":{"type":"enum","values":{"visible":1,"none":1},"default":"visible","expression":{}}},"filter":{"type":"array","value":"*"},"filter_symbol":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature","pitch","distance-from-center"]}},"filter_fill":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_hillshade":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_raster":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_raster-particle":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_clip":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_model":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_line":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_circle":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_fill-extrusion":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_building":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_heatmap":{"type":"boolean","default":false,"property-type":"data-driven","expression":{"parameters":["zoom","feature"]}},"filter_operator":{"type":"enum","values":{"==":1,"!=":1,">":1,">=":1,"<":1,"<=":1,"in":1,"!in":1,"all":1,"any":1,"none":1,"has":1,"!has":1}},"geometry_type":{"type":"enum","values":{"Point":1,"LineString":1,"Polygon":1}},"function":{"expression":{"type":"expression"},"stops":{"type":"array","value":"function_stop"},"base":{"type":"number","default":1,"minimum":0},"property":{"type":"string","default":"$zoom"},"type":{"type":"enum","values":{"identity":1,"exponential":1,"interval":1,"categorical":1},"default":"exponential"},"colorSpace":{"type":"enum","values":{"rgb":1,"lab":1,"hcl":1},"default":"rgb"},"default":{"type":"*"}},"function_stop":{"type":"array","minimum":0,"maximum":24,"value":["number","color"],"length":2},"expression":{"type":"array","value":"*","minimum":1},"fog":{"range":{"type":"array","default":[0.5,10],"minimum":-20,"maximum":20,"length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"high-color":{"type":"color","default":"#245cdf","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"space-color":{"type":"color","default":["interpolate",["linear"],["zoom"],4,"#010b19",7,"#367ab9"],"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"horizon-blend":{"type":"number","default":["interpolate",["linear"],["zoom"],4,0.2,7,0.1],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"star-intensity":{"type":"number","default":["interpolate",["linear"],["zoom"],5,0.35,6,0],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vertical-range":{"type":"array","default":[0,0],"minimum":0,"length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}}},"snow":{"density":{"type":"number","default":["interpolate",["linear"],["zoom"],11,0,13,0.85],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette":{"type":"number","default":["interpolate",["linear"],["zoom"],11,0,13,0.3],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette-color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"center-thinning":{"type":"number","default":0.4,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"direction":{"type":"array","default":[0,50],"minimum":0,"maximum":360,"length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"flake-size":{"type":"number","default":0.71,"minimum":0,"maximum":5,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true}},"rain":{"density":{"type":"number","default":["interpolate",["linear"],["zoom"],11,0,13,0.5],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"color":{"type":"color","default":["interpolate",["linear"],["measure-light","brightness"],0,"#03113d",0.3,"#a8adbc"],"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"opacity":{"type":"number","default":["interpolate",["linear"],["measure-light","brightness"],0,0.88,1,0.7],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette":{"type":"number","default":["interpolate",["linear"],["zoom"],11,0,13,1],"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"vignette-color":{"type":"color","default":["interpolate",["linear"],["measure-light","brightness"],0,"#001736",0.3,"#464646"],"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"use-theme":true,"transition":true},"center-thinning":{"type":"number","default":0.57,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true},"direction":{"type":"array","default":[0,80],"minimum":0,"maximum":360,"length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"droplet-size":{"type":"array","default":[2.6,18.2],"minimum":0,"maximum":50,"length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true}},"distortion-strength":{"type":"number","default":0.7,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"],"relaxZoomRestriction":true},"transition":true}},"camera":{"camera-projection":{"type":"enum","values":{"perspective":1,"orthographic":1},"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]},"default":"perspective"}},"colorTheme":{"data":{"type":"string","expression":{}}},"indoor_source":{"sourceId":{"type":"string"},"sourceLayers":{"type":"array","value":"string"}},"indoor":{"*":{"type":"indoor_source"}},"light":{"anchor":{"type":"enum","default":"viewport","values":{"map":1,"viewport":1},"expression":{"parameters":["zoom"]}},"position":{"type":"array","default":[1.15,210,30],"length":3,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"color":{"type":"color","default":"#ffffff","expression":{"interpolated":true,"parameters":["zoom"]},"use-theme":true,"transition":true},"intensity":{"type":"number","default":0.5,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"projection":{"name":{"type":"enum","values":{"albers":1,"equalEarth":1,"equirectangular":1,"lambertConformalConic":1,"mercator":1,"naturalEarth":1,"winkelTripel":1,"globe":1},"default":"mercator"},"center":{"type":"array","length":2,"value":"number","minimum":[-180,-90],"maximum":[180,90]},"parallels":{"type":"array","length":2,"value":"number","minimum":[-90,-90],"maximum":[90,90]}},"terrain":{"source":{"type":"string"},"exaggeration":{"type":"number","default":1,"minimum":0,"maximum":1000,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true}},"paint":["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_building","paint_symbol","paint_raster","paint_raster-particle","paint_hillshade","paint_background","paint_sky","paint_model"],"paint_fill":{"fill-antialias":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"fill-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-outline-color":{"type":"color","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"fill-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-pattern-cross-fade":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-z-offset":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-bridge-guard-rail-color":{"type":"color","default":"rgba(241, 236, 225, 255)","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature"]},"property-type":"data-driven"},"fill-tunnel-structure-color":{"type":"color","default":"rgba(241, 236, 225, 255)","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature"]},"property-type":"data-driven"}},"paint_fill-extrusion":{"fill-extrusion-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-extrusion-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"fill-extrusion-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"fill-extrusion-pattern-cross-fade":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-height":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-base":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-height-alignment":{"type":"enum","values":{"terrain":1,"flat":1},"default":"flat"},"fill-extrusion-base-alignment":{"type":"enum","values":{"terrain":1,"flat":1},"default":"terrain"},"fill-extrusion-vertical-gradient":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"fill-extrusion-ambient-occlusion-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-radius":{"type":"number","default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-wall-radius":{"type":"number","default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-ground-radius":{"type":"number","default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"fill-extrusion-ambient-occlusion-ground-attenuation":{"type":"number","default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-flood-light-color":{"type":"color","default":"#ffffff","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-flood-light-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"fill-extrusion-flood-light-wall-radius":{"property-type":"data-driven","type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"fill-extrusion-flood-light-ground-radius":{"property-type":"data-driven","type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state"]}},"fill-extrusion-flood-light-ground-attenuation":{"type":"number","default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-vertical-scale":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"fill-extrusion-rounded-roof":{"type":"boolean","default":true,"expression":{"parameters":["zoom"]}},"fill-extrusion-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{}},"fill-extrusion-front-cutoff":{"type":"array","value":"number","expression":{"interpolated":true,"parameters":["zoom"]},"length":3,"default":[0,0,1],"minimum":[0,0,0],"maximum":[1,1,1]},"fill-extrusion-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature-state"]},"property-type":"data-driven"},"fill-extrusion-line-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"fill-extrusion-cast-shadows":{"type":"boolean","default":true}},"paint_building":{"building-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"building-ambient-occlusion-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"parameters":[]},"transition":true},"building-ambient-occlusion-ground-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"building-ambient-occlusion-ground-radius":{"type":"number","default":3,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"building-ambient-occlusion-ground-attenuation":{"type":"number","default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"building-vertical-scale":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"building-cast-shadows":{"type":"boolean","default":true},"building-color":{"type":"color","default":"rgba(193, 154, 127, 1)","use-theme":true,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"property-type":"data-driven"},"building-emissive-strength":{"type":"number","default":0,"minimum":0,"maximum":5,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"property-type":"data-driven"},"building-facade-emissive-chance":{"type":"number","default":0.35,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["measure-light","zoom"]}},"building-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{}},"building-front-cutoff":{"type":"array","value":"number","expression":{"interpolated":true,"parameters":["zoom"]},"length":3,"default":[0,0,1],"minimum":[0,0,0],"maximum":[1,1,1]},"building-flood-light-color":{"type":"color","default":"#ffffff","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"building-flood-light-intensity":{"type":"number","default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"building-flood-light-ground-attenuation":{"type":"number","default":0.69,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}}},"paint_line":{"line-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"line-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"line-width":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light","line-progress"]},"property-type":"data-driven"},"line-gap-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-offset":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"line-dasharray":{"type":"array","value":"number","minimum":0,"expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom","feature"]},"property-type":"data-driven"},"line-pattern-cross-fade":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"line-gradient":{"type":"color","use-theme":true,"expression":{"interpolated":true,"parameters":["line-progress"]}},"line-trim-offset":{"type":"array","value":"number","length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1]},"line-trim-fade-range":{"type":"array","value":"number","length":2,"default":[0,0],"minimum":[0,0],"maximum":[1,1],"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"line-trim-color":{"type":"color","default":"transparent","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"line-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]},"property-type":"data-driven"},"line-border-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-border-color":{"type":"color","default":"rgba(0, 0, 0, 0)","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-occlusion-opacity":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"line-blend-mode":{"type":"enum","values":{"default":1,"multiply":1,"additive":1},"default":"default","expression":{"parameters":["zoom"]}}},"paint_circle":{"circle-radius":{"type":"number","default":5,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-blur":{"type":"number","default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"circle-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"circle-pitch-scale":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"circle-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1},"default":"viewport","expression":{"parameters":["zoom"]}},"circle-stroke-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-stroke-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-stroke-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"circle-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}}},"paint_heatmap":{"heatmap-radius":{"type":"number","default":30,"minimum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"heatmap-weight":{"type":"number","default":1,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"property-type":"data-driven"},"heatmap-intensity":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"heatmap-color":{"type":"color","default":["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",0.1,"royalblue",0.3,"cyan",0.5,"lime",0.7,"yellow",1,"red"],"use-theme":true,"expression":{"interpolated":true,"parameters":["heatmap-density"]}},"heatmap-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}}},"paint_symbol":{"icon-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"appearance":true,"property-type":"data-driven"},"icon-occlusion-opacity":{"type":"number","minimum":0,"maximum":1,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"appearance":true,"property-type":"data-driven"},"icon-emissive-strength":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature-state"]},"appearance":true,"property-type":"data-driven"},"text-emissive-strength":{"type":"number","default":1,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light","feature-state"]},"appearance":true,"property-type":"data-driven"},"icon-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"appearance":true,"property-type":"data-driven"},"icon-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"appearance":true,"property-type":"data-driven"},"icon-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"appearance":true,"property-type":"data-driven"},"icon-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"appearance":true,"property-type":"data-driven"},"icon-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"appearance":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"icon-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"icon-image-cross-fade":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"text-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"appearance":true,"property-type":"data-driven"},"text-occlusion-opacity":{"type":"number","minimum":0,"maximum":1,"default":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"appearance":true,"property-type":"data-driven"},"text-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"overridable":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"appearance":true,"property-type":"data-driven"},"text-halo-color":{"type":"color","default":"rgba(0, 0, 0, 0)","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"appearance":true,"property-type":"data-driven"},"text-halo-width":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"appearance":true,"property-type":"data-driven"},"text-halo-blur":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","feature","feature-state","measure-light"]},"appearance":true,"property-type":"data-driven"},"text-translate":{"type":"array","value":"number","length":2,"default":[0,0],"transition":true,"appearance":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"text-translate-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":["zoom"]}},"icon-color-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":{}},"icon-color-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"expression":{}},"icon-color-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{}},"icon-color-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{}},"symbol-z-offset":{"type":"number","default":0,"minimum":0,"transition":true,"appearance":true,"expression":{"interpolated":true,"parameters":["zoom","feature"]},"property-type":"data-driven"}},"paint_raster":{"raster-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-color":{"type":"color","use-theme":true,"expression":{"interpolated":true,"parameters":["raster-value"]}},"raster-color-mix":{"type":"array","default":[0.2126,0.7152,0.0722,0],"length":4,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-color-range":{"type":"array","length":2,"value":"number","transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-hue-rotate":{"type":"number","default":0,"period":360,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-brightness-min":{"type":"number","default":0,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-brightness-max":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-saturation":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-contrast":{"type":"number","default":0,"minimum":-1,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-resampling":{"type":"enum","values":{"linear":1,"nearest":1},"default":"linear","expression":{"parameters":["zoom"]}},"raster-fade-duration":{"type":"number","default":300,"minimum":0,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"raster-array-band":{"type":"string"},"raster-elevation":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-elevation-reference":{"type":"enum","values":{"sea":1,"ground":1},"default":"sea","expression":{}}},"paint_raster-particle":{"raster-particle-array-band":{"type":"string"},"raster-particle-count":{"type":"number","default":512,"minimum":1},"raster-particle-color":{"type":"color","use-theme":true,"expression":{"interpolated":true,"parameters":["raster-particle-speed"]}},"raster-particle-max-speed":{"type":"number","default":1,"minimum":1},"raster-particle-speed-factor":{"type":"number","default":0.2,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-particle-fade-opacity-factor":{"type":"number","default":0.98,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"raster-particle-reset-rate-factor":{"type":"number","default":0.8,"minimum":0,"maximum":1},"raster-particle-elevation":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}}},"paint_hillshade":{"hillshade-illumination-direction":{"type":"number","default":335,"minimum":0,"maximum":359,"expression":{"interpolated":true,"parameters":["zoom"]}},"hillshade-illumination-anchor":{"type":"enum","values":{"map":1,"viewport":1},"default":"viewport","expression":{"parameters":["zoom"]}},"hillshade-exaggeration":{"type":"number","default":0.5,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"hillshade-shadow-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"hillshade-highlight-color":{"type":"color","default":"#FFFFFF","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"hillshade-accent-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"hillshade-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}}},"paint_background":{"background-pitch-alignment":{"type":"enum","values":{"map":1,"viewport":1},"default":"map","expression":{"parameters":[]}},"background-color":{"type":"color","default":"#000000","use-theme":true,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}},"background-pattern":{"type":"resolvedImage","expression":{"parameters":["zoom"]}},"background-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}},"background-emissive-strength":{"type":"number","default":0,"minimum":0,"transition":true,"expression":{"interpolated":true,"parameters":["zoom","measure-light"]}}},"paint_sky":{"sky-type":{"type":"enum","values":{"gradient":1,"atmosphere":1},"default":"atmosphere","expression":{"parameters":["zoom"]}},"sky-atmosphere-sun":{"type":"array","value":"number","length":2,"minimum":[0,0],"maximum":[360,180],"expression":{"parameters":["zoom"]}},"sky-atmosphere-sun-intensity":{"type":"number","default":10,"minimum":0,"maximum":100},"sky-gradient-center":{"type":"array","value":"number","default":[0,0],"length":2,"minimum":[0,0],"maximum":[360,180],"expression":{"parameters":["zoom"]}},"sky-gradient-radius":{"type":"number","default":90,"minimum":0,"maximum":180,"expression":{"parameters":["zoom"]}},"sky-gradient":{"type":"color","default":["interpolate",["linear"],["sky-radial-progress"],0.8,"#87ceeb",1,"white"],"use-theme":true,"expression":{"interpolated":true,"parameters":["sky-radial-progress"]}},"sky-atmosphere-halo-color":{"type":"color","default":"white","use-theme":true},"sky-atmosphere-color":{"type":"color","default":"white","use-theme":true},"sky-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["zoom"]}}},"paint_model":{"model-opacity":{"type":"number","default":1,"minimum":0,"maximum":1,"transition":true,"expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"property-type":"data-driven"},"model-rotation":{"type":"array","value":"number","length":3,"default":[0,0,0],"period":360,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-scale":{"type":"array","value":"number","length":3,"default":[1,1,1],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-translation":{"type":"array","value":"number","length":3,"default":[0,0,0],"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","zoom"]},"transition":true},"model-color":{"type":"color","default":"#ffffff","property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light","zoom"]},"use-theme":true,"transition":true},"model-color-mix-intensity":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-type":{"type":"enum","values":{"common-3d":1,"location-indicator":1},"default":"common-3d"},"model-cast-shadows":{"type":"boolean","default":true},"model-receive-shadows":{"type":"boolean","default":true},"model-ambient-occlusion-intensity":{"type":"number","default":1,"minimum":0,"maximum":1,"expression":{"interpolated":true,"parameters":["zoom"]},"transition":true},"model-emissive-strength":{"type":"number","property-type":"data-driven","default":0,"minimum":0,"maximum":5,"expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-roughness":{"type":"number","default":1,"minimum":0,"maximum":1,"property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state"]},"transition":true},"model-height-based-emissive-strength-multiplier":{"type":"array","default":[1,1,1,1,0],"length":5,"value":"number","property-type":"data-driven","expression":{"interpolated":true,"parameters":["feature","feature-state","measure-light"]},"transition":true},"model-cutoff-fade-range":{"type":"number","default":0,"minimum":0,"maximum":1,"expression":{}},"model-front-cutoff":{"type":"array","value":"number","expression":{"interpolated":true,"parameters":["zoom"]},"length":3,"default":[0,0,1],"minimum":[0,0,0],"maximum":[1,1,1]},"model-elevation-reference":{"type":"enum","values":{"sea":1,"ground":1,"hd-road-markup":1},"default":"ground","expression":{}},"model-ignore-line-cutout":{"type":"boolean","default":false,"expression":{}}},"transition":{"duration":{"type":"number","default":300,"minimum":0},"delay":{"type":"number","default":0,"minimum":0}},"promoteId":{"*":{"type":"*"}}}');
        function yo(e1) {
            return e1 instanceof Number || e1 instanceof String || e1 instanceof Boolean ? e1.valueOf() : e1;
        }
        function go(e1) {
            if (Array.isArray(e1)) return e1.map(go);
            if (e1 instanceof Object && !(e1 instanceof Number || e1 instanceof String || e1 instanceof Boolean)) {
                const t1 = {};
                for(const r in e1)t1[r] = go(e1[r]);
                return t1;
            }
            return yo(e1);
        }
        function xo(e1) {
            if (!0 === e1 || !1 === e1) return !0;
            if (!Array.isArray(e1) || 0 === e1.length) return !1;
            switch(e1[0]){
                case "has":
                    return e1.length >= 2 && "$id" !== e1[1] && "$type" !== e1[1];
                case "in":
                    return e1.length >= 3 && ("string" != typeof e1[1] || Array.isArray(e1[2]));
                case "!in":
                case "!has":
                case "none":
                    return !1;
                case "==":
                case "!=":
                case ">":
                case ">=":
                case "<":
                case "<=":
                    return 3 !== e1.length || Array.isArray(e1[1]) || Array.isArray(e1[2]);
                case "any":
                case "all":
                    for (const t1 of e1.slice(1))if (!xo(t1) && "boolean" != typeof t1) return !1;
                    return !0;
                default:
                    return !0;
            }
        }
        function vo(e1, t1 = "", r = null, n = "fill") {
            if (null == e1) return {
                filter: ()=>!0,
                needGeometry: !1,
                needFeature: !1
            };
            xo(e1) || (e1 = Bo(e1));
            const i = e1;
            let s = !0;
            try {
                s = function(e1) {
                    if (!_o(e1)) return e1;
                    let t1 = go(e1);
                    return wo(t1), t1 = bo(t1), t1;
                }(i);
            } catch (e1) {
                console.warn(`Failed to extract static filter. Filter will continue working, but at higher memory usage and slower framerate.\nThis is most likely a bug, please report this via https://github.com/mapbox/mapbox-gl-js/issues/new?assignees=&labels=&template=Bug_report.md\nand paste the contents of this message in the report.\nThank you!\nFilter Expression:\n${JSON.stringify(i, null, 2)}\n        `);
            }
            let a = null, o = null;
            if ("background" !== n && "sky" !== n && "slot" !== n) {
                o = mo[`filter_${n}`];
                const e1 = qs(s, o, t1, r);
                if ("error" === e1.result) throw new Error(e1.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                a = (t1, r, n)=>e1.value.evaluate(t1, r, {}, n);
            }
            let l = null, u = null;
            if (s !== i) {
                const e1 = qs(i, o, t1, r);
                if ("error" === e1.result) throw new Error(e1.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                l = (t1, r, n, i, s)=>e1.value.evaluate(t1, r, {}, n, void 0, void 0, i, s), u = !bi(e1.value.expression);
            }
            return {
                filter: a,
                dynamicFilter: l || void 0,
                needGeometry: Mo(s),
                needFeature: !!u
            };
        }
        function bo(e1) {
            if (!Array.isArray(e1)) return e1;
            const t1 = function(e1) {
                if (Ao.has(e1[0])) {
                    for(let t1 = 1; t1 < e1.length; t1++)if (_o(e1[t1])) return !0;
                }
                return e1;
            }(e1);
            return !0 === t1 ? t1 : t1.map((e1)=>bo(e1));
        }
        function wo(e1) {
            let t1 = !1;
            const r = [];
            if ("case" === e1[0]) {
                for(let n = 1; n < e1.length - 1; n += 2)t1 = t1 || _o(e1[n]), r.push(e1[n + 1]);
                r.push(e1[e1.length - 1]);
            } else if ("match" === e1[0]) {
                t1 = t1 || _o(e1[1]);
                for(let t1 = 2; t1 < e1.length - 1; t1 += 2)r.push(e1[t1 + 1]);
                r.push(e1[e1.length - 1]);
            } else if ("step" === e1[0]) {
                t1 = t1 || _o(e1[1]);
                for(let t1 = 1; t1 < e1.length - 1; t1 += 2)r.push(e1[t1 + 1]);
            }
            t1 && (e1.length = 0, e1.push("any", ...r));
            for(let t1 = 1; t1 < e1.length; t1++)wo(e1[t1]);
        }
        function _o(e1) {
            if (!Array.isArray(e1)) return !1;
            if ("pitch" === (t1 = e1[0]) || "distance-from-center" === t1) return !0;
            var t1;
            for(let t1 = 1; t1 < e1.length; t1++)if (_o(e1[t1])) return !0;
            return !1;
        }
        const Ao = new Set([
            "in",
            "==",
            "!=",
            ">",
            ">=",
            "<",
            "<=",
            "to-boolean"
        ]);
        function Io(e1, t1) {
            return e1 < t1 ? -1 : e1 > t1 ? 1 : 0;
        }
        function Mo(e1) {
            if (!Array.isArray(e1)) return !1;
            if ("within" === e1[0] || "distance" === e1[0]) return !0;
            for(let t1 = 1; t1 < e1.length; t1++)if (Mo(e1[t1])) return !0;
            return !1;
        }
        function Bo(e1) {
            if (!e1) return !0;
            const t1 = e1[0];
            var r;
            return e1.length <= 1 ? "any" !== t1 : "==" === t1 ? So(e1[1], e1[2], "==") : "!=" === t1 ? zo(So(e1[1], e1[2], "==")) : "<" === t1 || ">" === t1 || "<=" === t1 || ">=" === t1 ? So(e1[1], e1[2], t1) : "any" === t1 ? (r = e1.slice(1), [
                "any"
            ].concat(r.map(Bo))) : "all" === t1 ? [
                "all"
            ].concat(e1.slice(1).map(Bo)) : "none" === t1 ? [
                "all"
            ].concat(e1.slice(1).map(Bo).map(zo)) : "in" === t1 ? Po(e1[1], e1.slice(2)) : "!in" === t1 ? zo(Po(e1[1], e1.slice(2))) : "has" === t1 ? To(e1[1]) : "!has" !== t1 || zo(To(e1[1]));
        }
        function So(e1, t1, r) {
            switch(e1){
                case "$type":
                    return [
                        `filter-type-${r}`,
                        t1
                    ];
                case "$id":
                    return [
                        `filter-id-${r}`,
                        t1
                    ];
                default:
                    return [
                        `filter-${r}`,
                        e1,
                        t1
                    ];
            }
        }
        function Po(e1, t1) {
            if (0 === t1.length) return !1;
            switch(e1){
                case "$type":
                    return [
                        "filter-type-in",
                        [
                            "literal",
                            t1
                        ]
                    ];
                case "$id":
                    return [
                        "filter-id-in",
                        [
                            "literal",
                            t1
                        ]
                    ];
                default:
                    return t1.length > 200 && !t1.some((e1)=>typeof e1 != typeof t1[0]) ? [
                        "filter-in-large",
                        e1,
                        [
                            "literal",
                            t1.sort(Io)
                        ]
                    ] : [
                        "filter-in-small",
                        e1,
                        [
                            "literal",
                            t1
                        ]
                    ];
            }
        }
        function To(e1) {
            switch(e1){
                case "$type":
                    return !0;
                case "$id":
                    return [
                        "filter-has-id"
                    ];
                default:
                    return [
                        "filter-has",
                        e1
                    ];
            }
        }
        function zo(e1) {
            return [
                "!",
                e1
            ];
        }
        const ko = "";
        function Vo(e1, t1) {
            return t1 ? `${e1}${ko}${t1}` : e1;
        }
        let Fo;
        const Do = ()=>Fo || (Fo = new fo({
                "icon-size": new ho(mo.layout_symbol["icon-size"]),
                "icon-image": new ho(mo.layout_symbol["icon-image"]),
                "icon-rotate": new ho(mo.layout_symbol["icon-rotate"]),
                "icon-offset": new ho(mo.layout_symbol["icon-offset"]),
                "text-size": new ho(mo.layout_symbol["text-size"]),
                "text-rotate": new ho(mo.layout_symbol["text-rotate"]),
                "text-offset": new ho(mo.layout_symbol["text-offset"])
            }));
        let Eo;
        const Co = ()=>Eo || (Eo = new fo({
                "icon-opacity": new ho(mo.paint_symbol["icon-opacity"]),
                "icon-occlusion-opacity": new ho(mo.paint_symbol["icon-occlusion-opacity"]),
                "icon-emissive-strength": new ho(mo.paint_symbol["icon-emissive-strength"]),
                "text-emissive-strength": new ho(mo.paint_symbol["text-emissive-strength"]),
                "icon-color": new ho(mo.paint_symbol["icon-color"]),
                "icon-halo-color": new ho(mo.paint_symbol["icon-halo-color"]),
                "icon-halo-width": new ho(mo.paint_symbol["icon-halo-width"]),
                "icon-halo-blur": new ho(mo.paint_symbol["icon-halo-blur"]),
                "icon-translate": new ho(mo.paint_symbol["icon-translate"]),
                "text-opacity": new ho(mo.paint_symbol["text-opacity"]),
                "text-occlusion-opacity": new ho(mo.paint_symbol["text-occlusion-opacity"]),
                "text-color": new ho(mo.paint_symbol["text-color"], {
                    runtimeType: Mr,
                    getOverride: (e1)=>e1.textColor,
                    hasOverride: (e1)=>!!e1.textColor
                }),
                "text-halo-color": new ho(mo.paint_symbol["text-halo-color"]),
                "text-halo-width": new ho(mo.paint_symbol["text-halo-width"]),
                "text-halo-blur": new ho(mo.paint_symbol["text-halo-blur"]),
                "text-translate": new ho(mo.paint_symbol["text-translate"]),
                "symbol-z-offset": new ho(mo.paint_symbol["symbol-z-offset"]),
                "icon-color-use-theme": new ho({
                    type: "string",
                    default: "default",
                    "property-type": "data-driven"
                }),
                "icon-halo-color-use-theme": new ho({
                    type: "string",
                    default: "default",
                    "property-type": "data-driven"
                }),
                "text-color-use-theme": new ho({
                    type: "string",
                    default: "default",
                    "property-type": "data-driven"
                }),
                "text-halo-color-use-theme": new ho({
                    type: "string",
                    default: "default",
                    "property-type": "data-driven"
                })
            }));
        class Ro {
            constructor(e1, t1, r, n, i, s){
                this._conditionSpec = e1, this._propertiesSpec = r;
                const a = qs(e1, mo.appearance.condition);
                if ("success" === a.result && (this.condition = a.value), this.name = t1, r) {
                    this.layoutProperties = new uo(Do()), this.unevaluatedLayout = new oo(Do(), n, i, s), this.paintProperties = new uo(Co()), this.unevaluatedPaint = new oo(Co(), n, i, "");
                    for(const e1 in r)e1 in this.unevaluatedLayout._values ? this.unevaluatedLayout.setValue(e1, r[e1]) : e1 in this.unevaluatedPaint._values && this.unevaluatedPaint.setValue(e1, r[e1]);
                }
            }
            isActive(e1) {
                return !(this.condition || !e1.isHidden || "hidden" !== this.name) || this.condition.evaluate(e1.globals, e1.feature, e1.featureState, e1.canonical);
            }
            getCondition() {
                return this.condition;
            }
            getName() {
                return this.name;
            }
            getLayoutProperty(e1) {
                return this.layoutProperties.get(e1);
            }
            getPaintProperty(e1) {
                return this.paintProperties.get(e1);
            }
            getUnevaluatedLayoutProperties() {
                return this.unevaluatedLayout;
            }
            getUnevaluatedLayoutProperty(e1) {
                return this.unevaluatedLayout._values[e1];
            }
            getUnevaluatedPaintProperty(e1) {
                return this.unevaluatedPaint._values[e1];
            }
            recalculate(e1, t1, r) {
                this.unevaluatedLayout && (this.layoutProperties = this.unevaluatedLayout.possiblyEvaluate(e1, void 0, t1, r)), this.unevaluatedPaint && (this.paintProperties = this.unevaluatedPaint.possiblyEvaluate(e1, void 0, t1, ""));
            }
            serialize() {
                const e1 = {};
                e1.condition = this.condition.expression.serialize(), this.name && (e1.name = this.name);
                const t1 = this.unevaluatedLayout ? this.unevaluatedLayout.serialize() : {}, r = this.unevaluatedPaint ? this.unevaluatedPaint.serialize() : {}, n = Object.assign({}, t1, r);
                return Object.keys(n).length > 0 && (e1.properties = n), e1;
            }
            hasIconLayoutProperties() {
                const e1 = this.hasLayoutProperty("icon-image"), t1 = this.hasLayoutProperty("icon-size"), r = this.hasLayoutProperty("icon-offset"), n = this.hasLayoutProperty("icon-rotate");
                return e1 || t1 || r || n;
            }
            hasTextLayoutProperties() {
                const e1 = this.hasLayoutProperty("text-size"), t1 = this.hasLayoutProperty("text-offset"), r = this.hasLayoutProperty("text-rotate");
                return e1 || t1 || r;
            }
            hasIconPaintProperties() {
                return !!this.unevaluatedPaint && Object.keys(this.unevaluatedPaint._values).filter((e1)=>!e1.endsWith("-use-theme")).some((e1)=>(e1.startsWith("icon-") || "symbol-z-offset" === e1) && this.hasPaintProperty(e1));
            }
            hasTextPaintProperties() {
                return !!this.unevaluatedPaint && Object.keys(this.unevaluatedPaint._values).filter((e1)=>!e1.endsWith("-use-theme")).some((e1)=>(e1.startsWith("text-") || "symbol-z-offset" === e1) && this.hasPaintProperty(e1));
            }
            hasLayoutProperty(e1) {
                return this.unevaluatedLayout && void 0 !== this.unevaluatedLayout._values[e1].value;
            }
            hasPaintProperty(e1) {
                return this.unevaluatedPaint && void 0 !== this.unevaluatedPaint._values[e1].value;
            }
        }
        const Lo = "-transition", Oo = new Set([
            "fill",
            "line",
            "background",
            "hillshade",
            "raster"
        ]);
        class Uo extends or {
            constructor(e1, t1, r, n, i, s){
                if (super(), this.id = e1.id, this.fqid = Vo(this.id, r), this.type = e1.type, this.scope = r, this.lut = n, this.options = i, this.iconImageUseTheme = s, this.appearances = new Array, this.appearancesVersion = 0, this._featureFilter = {
                    filter: ()=>!0,
                    needGeometry: !1,
                    needFeature: !1
                }, this._filterCompiled = !1, this.expressionDependencies = {
                    isIndoorDependent: !1,
                    configDependencies: new Set
                }, "custom" !== e1.type) {
                    if (this.metadata = e1.metadata, this.minzoom = e1.minzoom, this.maxzoom = e1.maxzoom, e1.type && "background" !== e1.type && "sky" !== e1.type && "slot" !== e1.type) {
                        this.source = e1.source, this.sourceLayer = e1["source-layer"], this.filter = e1.filter;
                        const t1 = qs(this.filter, mo[`filter_${e1.type}`]);
                        "error" !== t1.result && (this.expressionDependencies.configDependencies = new Set([
                            ...this.expressionDependencies.configDependencies,
                            ...t1.value.configDependencies
                        ]), this.expressionDependencies.isIndoorDependent = this.expressionDependencies.isIndoorDependent || t1.value.isIndoorDependent);
                    }
                    if (e1.slot && (this.slot = e1.slot), e1.appearances && this.setAppearances(e1.appearances), t1.layout && (this._unevaluatedLayout = new oo(t1.layout, this.scope, i, this.iconImageUseTheme), this.expressionDependencies.configDependencies = new Set([
                        ...this.expressionDependencies.configDependencies,
                        ...this._unevaluatedLayout.configDependencies
                    ]), this.expressionDependencies.isIndoorDependent = this.expressionDependencies.isIndoorDependent || this._unevaluatedLayout.isIndoorDependent()), t1.paint) {
                        this._transitionablePaint = new io(t1.paint, this.scope, i);
                        for(const t1 in e1.paint)this.setPaintProperty(t1, e1.paint[t1]);
                        for(const t1 in e1.layout)this.setLayoutProperty(t1, e1.layout[t1]);
                        this.expressionDependencies.configDependencies = new Set([
                            ...this.expressionDependencies.configDependencies,
                            ...this._transitionablePaint.configDependencies
                        ]), this.expressionDependencies.isIndoorDependent = this.expressionDependencies.isIndoorDependent || this._transitionablePaint.isIndoorDependent(), this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new uo(t1.paint);
                    }
                }
            }
            onAdd(e1) {}
            onRemove(e1) {}
            isDraped(e1) {
                return !this.is3D(!0) && Oo.has(this.type);
            }
            getLayoutProperty(e1) {
                return "visibility" === e1 ? this.visibility : this._unevaluatedLayout.getValue(e1);
            }
            setLayoutProperty(e1, t1) {
                if ("custom" === this.type && "visibility" === e1) return void (this.visibility = t1);
                const r = this._unevaluatedLayout;
                r._properties.properties[e1] && (r.setValue(e1, t1), this.expressionDependencies.configDependencies = new Set([
                    ...this.expressionDependencies.configDependencies,
                    ...r.configDependencies
                ]), this.expressionDependencies.isIndoorDependent = this.expressionDependencies.isIndoorDependent || r.isIndoorDependent(), "visibility" === e1 && this.possiblyEvaluateVisibility());
            }
            setAppearances(e1) {
                this.appearances = [], e1.forEach((e1)=>{
                    this.appearances.push(new Ro(e1.condition, e1.name, e1.properties, this.scope, this.options, this.iconImageUseTheme));
                }), this.appearancesVersion++;
            }
            possiblyEvaluateVisibility() {
                this._unevaluatedLayout._values.visibility && (this.visibility = this._unevaluatedLayout._values.visibility.possiblyEvaluate({
                    zoom: 0
                }));
            }
            getPaintProperty(e1) {
                return e1.endsWith(Lo) ? this._transitionablePaint.getTransition(e1.slice(0, -11)) : this._transitionablePaint.getValue(e1);
            }
            isPaintProperty(e1) {
                return !!this._transitionablePaint._properties.properties[e1];
            }
            setPaintProperty(e1, t1) {
                const r = this._transitionablePaint, n = r._properties.properties;
                if (e1.endsWith(Lo)) {
                    const i = e1.slice(0, -11);
                    return n[i] && r.setTransition(i, t1 || void 0), !1;
                }
                if (!n[e1]) return !1;
                const i = r._values[e1], s = i.value.isDataDriven(), a = i.value;
                r.setValue(e1, t1), this.expressionDependencies.configDependencies = new Set([
                    ...this.expressionDependencies.configDependencies,
                    ...r.configDependencies
                ]), this.expressionDependencies.isIndoorDependent = this.expressionDependencies.isIndoorDependent || r.isIndoorDependent(), this._handleSpecialPaintPropertyUpdate(e1);
                const o = r._values[e1].value, l = o.isDataDriven(), u = e1.endsWith("pattern") || "line-dasharray" === e1;
                return l || s || u || this._handleOverridablePaintPropertyUpdate(e1, a, o);
            }
            _handleSpecialPaintPropertyUpdate(e1) {}
            getProgramIds() {
                return null;
            }
            getDefaultProgramParams(e1, t1, r) {
                return null;
            }
            _handleOverridablePaintPropertyUpdate(e1, t1, r) {
                return !1;
            }
            isHidden(e1) {
                return !!(this.minzoom && e1 < this.minzoom) || !!(this.maxzoom && e1 >= this.maxzoom) || "none" === this.visibility;
            }
            updateTransitions(e1) {
                this._transitioningPaint = this._transitionablePaint.transitioned(e1, this._transitioningPaint);
            }
            hasTransition() {
                return this._transitioningPaint.hasTransition();
            }
            recalculate(e1, t1) {
                this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(e1, void 0, t1, this.iconImageUseTheme)), this.paint = this._transitioningPaint.possiblyEvaluate(e1, void 0, t1);
            }
            serialize() {
                const e1 = {
                    id: this.id,
                    type: this.type,
                    slot: this.slot,
                    source: this.source,
                    "source-layer": this.sourceLayer,
                    metadata: this.metadata,
                    minzoom: this.minzoom,
                    maxzoom: this.maxzoom,
                    filter: this.filter,
                    layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                    paint: this._transitionablePaint && this._transitionablePaint.serialize()
                };
                return 0 !== this.appearances.length && (e1.appearances = this.appearances.map((e1)=>e1.serialize())), $e(e1, (e1, t1)=>!(void 0 === e1 || "layout" === t1 && !Object.keys(e1).length || "paint" === t1 && !Object.keys(e1).length));
            }
            is3D(e1) {
                return !1;
            }
            hasElevation() {
                return !1;
            }
            isSky() {
                return !1;
            }
            isTileClipped() {
                return !1;
            }
            hasOffscreenPass() {
                return !1;
            }
            hasShadowPass() {
                return !1;
            }
            canCastShadows() {
                return !1;
            }
            hasLightBeamPass() {
                return !1;
            }
            cutoffRange() {
                return 0;
            }
            tileCoverLift() {
                return 0;
            }
            resize() {}
            _clear() {}
            isStateDependent() {
                for(const e1 in this.paint._values){
                    const t1 = this.paint.get(e1);
                    if (t1 instanceof lo && ks(t1.property.specification) && ("source" === t1.value.kind || "composite" === t1.value.kind) && t1.value.isStateDependent) return !0;
                }
                for (const e1 of this.appearances)if (!wi(e1.condition.expression)) return !0;
                return !1;
            }
            compileFilter(e1) {
                this._filterCompiled || (this._featureFilter = vo(this.filter, this.scope, e1), this._filterCompiled = !0);
            }
            invalidateCompiledFilter() {
                this._filterCompiled = !1;
            }
            dynamicFilter() {
                return this._featureFilter.dynamicFilter;
            }
            dynamicFilterNeedsFeature() {
                return this._featureFilter.needFeature;
            }
            dynamicFilterNeedsGeometry() {
                return this._featureFilter.needGeometry;
            }
            getLayerRenderingStats() {
                return this._stats;
            }
            resetLayerRenderingStats(e1) {
                this._stats && ("shadow" === e1.renderPass ? this._stats.numRenderedVerticesInShadowPass = 0 : this._stats.numRenderedVerticesInTransparentPass = 0);
            }
            getAppearances() {
                return this.appearances;
            }
            queryRenderedFeatures(e1, t1, r) {
                return {};
            }
            queryRadius(e1) {}
            queryIntersectsFeature(e1, t1, r, n, i, s, a, o, l, u) {}
        }
        const No = {
            Int8: Int8Array,
            Uint8: Uint8Array,
            Int16: Int16Array,
            Uint16: Uint16Array,
            Int32: Int32Array,
            Uint32: Uint32Array,
            Float32: Float32Array
        };
        class jo {
            constructor(e1, t1){
                this._structArray = e1, this._pos1 = t1 * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
            }
        }
        const Go = new ArrayBuffer(0);
        class $o {
            constructor(){
                this._reallocCount = 0, this.capacity = 0, this.length = 0;
            }
            static serialize(e1, t1) {
                return e1._trim(), t1 && e1.arrayBuffer && t1.add(e1.arrayBuffer), {
                    length: e1.length,
                    arrayBuffer: e1.arrayBuffer
                };
            }
            static deserialize(e1) {
                const t1 = Object.create(this.prototype);
                return t1.arrayBuffer = e1.arrayBuffer, t1.length = e1.length, e1.arrayBuffer ? t1.capacity = e1.arrayBuffer.byteLength / t1.bytesPerElement : (t1.capacity = 0, t1.arrayBuffer = Go), t1._refreshViews(), t1;
            }
            _trim() {
                this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
            }
            clear() {
                this.length = 0;
            }
            resize(e1) {
                this.reserve(e1), this.length = e1;
            }
            reserve(e1) {
                if (e1 > this.capacity) {
                    this._reallocCount++, this.capacity = Math.max(e1, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                    const t1 = this.uint8;
                    this._refreshViews(), t1 && this.uint8.set(t1);
                }
            }
            reserveForAdditional(e1) {
                this.reserve(this.length + e1);
            }
            _refreshViews() {
                throw new Error("StructArray#_refreshViews() must be implemented by each concrete StructArray layout");
            }
            emplace(...e1) {
                throw new Error("StructArray#emplace() must be implemented by each concrete StructArray layout");
            }
            emplaceBack(...e1) {
                throw new Error("StructArray#emplaceBack() must be implemented by each concrete StructArray layout");
            }
            destroy() {
                this.int8 = this.uint8 = this.int16 = this.uint16 = this.int32 = this.uint32 = this.float32 = null, this.arrayBuffer = null;
            }
        }
        function qo(e1, t1 = 1) {
            let r = 0, n = 0;
            return {
                members: e1.map((e1)=>{
                    const i = No[e1.type].BYTES_PER_ELEMENT, s = r = Ho(r, Math.max(t1, i)), a = e1.components || 1;
                    return n = Math.max(n, i), r += i * a, {
                        name: e1.name,
                        type: e1.type,
                        components: a,
                        offset: s
                    };
                }),
                size: Ho(r, Math.max(n, t1)),
                alignment: t1
            };
        }
        function Ho(e1, t1) {
            return Math.ceil(e1 / t1) * t1;
        }
        class Xo extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e1, t1);
            }
            emplace(e1, t1, r) {
                const n = 2 * e1;
                return this.int16[n + 0] = t1, this.int16[n + 1] = r, e1;
            }
        }
        Xo.prototype.bytesPerElement = 4, ra(Xo, "StructArrayLayout2i4");
        class Zo extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t1, r);
            }
            emplace(e1, t1, r, n) {
                const i = 3 * e1;
                return this.int16[i + 0] = t1, this.int16[i + 1] = r, this.int16[i + 2] = n, e1;
            }
        }
        Zo.prototype.bytesPerElement = 6, ra(Zo, "StructArrayLayout3i6");
        class Wo extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, e1, t1, r, n);
            }
            emplace(e1, t1, r, n, i) {
                const s = 4 * e1;
                return this.int16[s + 0] = t1, this.int16[s + 1] = r, this.uint16[s + 2] = n, this.uint16[s + 3] = i, e1;
            }
        }
        Wo.prototype.bytesPerElement = 8, ra(Wo, "StructArrayLayout2i2ui8");
        class Yo extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t1 = this.length;
                return this.resize(t1 + 1), this.emplace(t1, e1);
            }
            emplace(e1, t1) {
                return this.float32[1 * e1 + 0] = t1, e1;
            }
        }
        Yo.prototype.bytesPerElement = 4, ra(Yo, "StructArrayLayout1f4");
        class Jo extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t1, r);
            }
            emplace(e1, t1, r, n) {
                const i = 4 * e1, s = 2 * e1;
                return this.int16[i + 0] = t1, this.int16[i + 1] = r, this.float32[s + 1] = n, e1;
            }
        }
        Jo.prototype.bytesPerElement = 8, ra(Jo, "StructArrayLayout2i1f8");
        class Ko extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t1, r);
            }
            emplace(e1, t1, r, n) {
                const i = 4 * e1;
                return this.int16[i + 0] = t1, this.int16[i + 1] = r, this.int16[i + 2] = n, e1;
            }
        }
        Ko.prototype.bytesPerElement = 8, ra(Ko, "StructArrayLayout3i8");
        class Qo extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, e1, t1, r, n);
            }
            emplace(e1, t1, r, n, i) {
                const s = 4 * e1;
                return this.int16[s + 0] = t1, this.int16[s + 1] = r, this.int16[s + 2] = n, this.int16[s + 3] = i, e1;
            }
        }
        Qo.prototype.bytesPerElement = 8, ra(Qo, "StructArrayLayout4i8");
        class el extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r, n, i) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, e1, t1, r, n, i);
            }
            emplace(e1, t1, r, n, i, s) {
                const a = 5 * e1;
                return this.int16[a + 0] = t1, this.int16[a + 1] = r, this.int16[a + 2] = n, this.int16[a + 3] = i, this.int16[a + 4] = s, e1;
            }
        }
        el.prototype.bytesPerElement = 10, ra(el, "StructArrayLayout5i10");
        class tl extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r, n, i, s, a) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e1, t1, r, n, i, s, a);
            }
            emplace(e1, t1, r, n, i, s, a, o) {
                const l = 6 * e1, u = 12 * e1, c = 3 * e1;
                return this.int16[l + 0] = t1, this.int16[l + 1] = r, this.uint8[u + 4] = n, this.uint8[u + 5] = i, this.uint8[u + 6] = s, this.uint8[u + 7] = a, this.float32[c + 2] = o, e1;
            }
        }
        tl.prototype.bytesPerElement = 12, ra(tl, "StructArrayLayout2i4ub1f12");
        class rl extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t1, r);
            }
            emplace(e1, t1, r, n) {
                const i = 3 * e1;
                return this.float32[i + 0] = t1, this.float32[i + 1] = r, this.float32[i + 2] = n, e1;
            }
        }
        rl.prototype.bytesPerElement = 12, ra(rl, "StructArrayLayout3f12");
        class nl extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r, n, i) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, e1, t1, r, n, i);
            }
            emplace(e1, t1, r, n, i, s) {
                const a = 6 * e1, o = 3 * e1;
                return this.uint16[a + 0] = t1, this.uint16[a + 1] = r, this.uint16[a + 2] = n, this.uint16[a + 3] = i, this.float32[o + 2] = s, e1;
            }
        }
        nl.prototype.bytesPerElement = 12, ra(nl, "StructArrayLayout4ui1f12");
        class il extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, e1, t1, r, n);
            }
            emplace(e1, t1, r, n, i) {
                const s = 4 * e1;
                return this.uint16[s + 0] = t1, this.uint16[s + 1] = r, this.uint16[s + 2] = n, this.uint16[s + 3] = i, e1;
            }
        }
        il.prototype.bytesPerElement = 8, ra(il, "StructArrayLayout4ui8");
        class sl extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r, n, i, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, e1, t1, r, n, i, s);
            }
            emplace(e1, t1, r, n, i, s, a) {
                const o = 6 * e1;
                return this.int16[o + 0] = t1, this.int16[o + 1] = r, this.int16[o + 2] = n, this.int16[o + 3] = i, this.int16[o + 4] = s, this.int16[o + 5] = a, e1;
            }
        }
        sl.prototype.bytesPerElement = 12, ra(sl, "StructArrayLayout6i12");
        class al extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r, n, i, s, a, o, l, u, c, h) {
                const d = this.length;
                return this.resize(d + 1), this.emplace(d, e1, t1, r, n, i, s, a, o, l, u, c, h);
            }
            emplace(e1, t1, r, n, i, s, a, o, l, u, c, h, d) {
                const p = 12 * e1;
                return this.int16[p + 0] = t1, this.int16[p + 1] = r, this.int16[p + 2] = n, this.int16[p + 3] = i, this.uint16[p + 4] = s, this.uint16[p + 5] = a, this.uint16[p + 6] = o, this.uint16[p + 7] = l, this.int16[p + 8] = u, this.int16[p + 9] = c, this.int16[p + 10] = h, this.int16[p + 11] = d, e1;
            }
        }
        al.prototype.bytesPerElement = 24, ra(al, "StructArrayLayout4i4ui4i24");
        class ol extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r, n, i, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, e1, t1, r, n, i, s);
            }
            emplace(e1, t1, r, n, i, s, a) {
                const o = 10 * e1, l = 5 * e1;
                return this.int16[o + 0] = t1, this.int16[o + 1] = r, this.int16[o + 2] = n, this.float32[l + 2] = i, this.float32[l + 3] = s, this.float32[l + 4] = a, e1;
            }
        }
        ol.prototype.bytesPerElement = 20, ra(ol, "StructArrayLayout3i3f20");
        class ll extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, e1, t1, r, n);
            }
            emplace(e1, t1, r, n, i) {
                const s = 4 * e1;
                return this.float32[s + 0] = t1, this.float32[s + 1] = r, this.float32[s + 2] = n, this.float32[s + 3] = i, e1;
            }
        }
        ll.prototype.bytesPerElement = 16, ra(ll, "StructArrayLayout4f16");
        class ul extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t1 = this.length;
                return this.resize(t1 + 1), this.emplace(t1, e1);
            }
            emplace(e1, t1) {
                return this.uint32[1 * e1 + 0] = t1, e1;
            }
        }
        ul.prototype.bytesPerElement = 4, ra(ul, "StructArrayLayout1ul4");
        class cl extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e1, t1);
            }
            emplace(e1, t1, r) {
                const n = 2 * e1;
                return this.uint16[n + 0] = t1, this.uint16[n + 1] = r, e1;
            }
        }
        cl.prototype.bytesPerElement = 4, ra(cl, "StructArrayLayout2ui4");
        class hl extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r, n, i, s, a, o, l, u, c, h, d) {
                const p = this.length;
                return this.resize(p + 1), this.emplace(p, e1, t1, r, n, i, s, a, o, l, u, c, h, d);
            }
            emplace(e1, t1, r, n, i, s, a, o, l, u, c, h, d, p) {
                const f = 20 * e1, m = 10 * e1;
                return this.int16[f + 0] = t1, this.int16[f + 1] = r, this.int16[f + 2] = n, this.int16[f + 3] = i, this.int16[f + 4] = s, this.float32[m + 3] = a, this.float32[m + 4] = o, this.float32[m + 5] = l, this.float32[m + 6] = u, this.int16[f + 14] = c, this.uint32[m + 8] = h, this.uint16[f + 18] = d, this.uint16[f + 19] = p, e1;
            }
        }
        hl.prototype.bytesPerElement = 40, ra(hl, "StructArrayLayout5i4f1i1ul2ui40");
        class dl extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r, n, i, s, a) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e1, t1, r, n, i, s, a);
            }
            emplace(e1, t1, r, n, i, s, a, o) {
                const l = 8 * e1;
                return this.int16[l + 0] = t1, this.int16[l + 1] = r, this.int16[l + 2] = n, this.int16[l + 4] = i, this.int16[l + 5] = s, this.int16[l + 6] = a, this.int16[l + 7] = o, e1;
            }
        }
        dl.prototype.bytesPerElement = 16, ra(dl, "StructArrayLayout3i2i2i16");
        class pl extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r, n, i) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, e1, t1, r, n, i);
            }
            emplace(e1, t1, r, n, i, s) {
                const a = 4 * e1, o = 8 * e1;
                return this.float32[a + 0] = t1, this.float32[a + 1] = r, this.float32[a + 2] = n, this.int16[o + 6] = i, this.int16[o + 7] = s, e1;
            }
        }
        pl.prototype.bytesPerElement = 16, ra(pl, "StructArrayLayout2f1f2i16");
        class fl extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r, n, i, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, e1, t1, r, n, i, s);
            }
            emplace(e1, t1, r, n, i, s, a) {
                const o = 20 * e1, l = 5 * e1;
                return this.uint8[o + 0] = t1, this.uint8[o + 1] = r, this.float32[l + 1] = n, this.float32[l + 2] = i, this.float32[l + 3] = s, this.float32[l + 4] = a, e1;
            }
        }
        fl.prototype.bytesPerElement = 20, ra(fl, "StructArrayLayout2ub4f20");
        class ml extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r) {
                const n = this.length;
                return this.resize(n + 1), this.emplace(n, e1, t1, r);
            }
            emplace(e1, t1, r, n) {
                const i = 3 * e1;
                return this.uint16[i + 0] = t1, this.uint16[i + 1] = r, this.uint16[i + 2] = n, e1;
            }
        }
        ml.prototype.bytesPerElement = 6, ra(ml, "StructArrayLayout3ui6");
        class yl extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r, n, i, s, a, o, l, u, c, h, d, p, f, m, y, g, x, v, b) {
                const w = this.length;
                return this.resize(w + 1), this.emplace(w, e1, t1, r, n, i, s, a, o, l, u, c, h, d, p, f, m, y, g, x, v, b);
            }
            emplace(e1, t1, r, n, i, s, a, o, l, u, c, h, d, p, f, m, y, g, x, v, b, w) {
                const _ = 30 * e1, A = 15 * e1, I = 60 * e1;
                return this.int16[_ + 0] = t1, this.int16[_ + 1] = r, this.int16[_ + 2] = n, this.float32[A + 2] = i, this.float32[A + 3] = s, this.uint16[_ + 8] = a, this.uint16[_ + 9] = o, this.uint32[A + 5] = l, this.uint32[A + 6] = u, this.uint32[A + 7] = c, this.uint16[_ + 16] = h, this.uint16[_ + 17] = d, this.uint16[_ + 18] = p, this.float32[A + 10] = f, this.float32[A + 11] = m, this.uint8[I + 48] = y, this.uint8[I + 49] = g, this.uint8[I + 50] = x, this.uint32[A + 13] = v, this.int16[_ + 28] = b, this.uint8[I + 58] = w, e1;
            }
        }
        yl.prototype.bytesPerElement = 60, ra(yl, "StructArrayLayout3i2f2ui3ul3ui2f3ub1ul1i1ub60");
        class gl extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r, n, i, s, a, o, l, u, c, h, d, p, f, m, y, g, x, v, b, w, _, A, I, M, B, S, P, T, z, k, V) {
                const F = this.length;
                return this.resize(F + 1), this.emplace(F, e1, t1, r, n, i, s, a, o, l, u, c, h, d, p, f, m, y, g, x, v, b, w, _, A, I, M, B, S, P, T, z, k, V);
            }
            emplace(e1, t1, r, n, i, s, a, o, l, u, c, h, d, p, f, m, y, g, x, v, b, w, _, A, I, M, B, S, P, T, z, k, V, F) {
                const D = 20 * e1, E = 40 * e1, C = 80 * e1;
                return this.float32[D + 0] = t1, this.float32[D + 1] = r, this.int16[E + 4] = n, this.int16[E + 5] = i, this.int16[E + 6] = s, this.int16[E + 7] = a, this.int16[E + 8] = o, this.int16[E + 9] = l, this.int16[E + 10] = u, this.int16[E + 11] = c, this.int16[E + 12] = h, this.uint16[E + 13] = d, this.uint16[E + 14] = p, this.uint16[E + 15] = f, this.uint16[E + 16] = m, this.uint16[E + 17] = y, this.uint16[E + 18] = g, this.uint16[E + 19] = x, this.uint16[E + 20] = v, this.uint16[E + 21] = b, this.uint16[E + 22] = w, this.uint16[E + 23] = _, this.uint16[E + 24] = A, this.uint16[E + 25] = I, this.uint16[E + 26] = M, this.uint16[E + 27] = B, this.uint32[D + 14] = S, this.float32[D + 15] = P, this.float32[D + 16] = T, this.float32[D + 17] = z, this.float32[D + 18] = k, this.uint8[C + 76] = V, this.uint16[E + 39] = F, e1;
            }
        }
        gl.prototype.bytesPerElement = 80, ra(gl, "StructArrayLayout2f9i15ui1ul4f1ub1ui80");
        class xl extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r, n, i, s) {
                const a = this.length;
                return this.resize(a + 1), this.emplace(a, e1, t1, r, n, i, s);
            }
            emplace(e1, t1, r, n, i, s, a) {
                const o = 6 * e1;
                return this.float32[o + 0] = t1, this.float32[o + 1] = r, this.float32[o + 2] = n, this.float32[o + 3] = i, this.float32[o + 4] = s, this.float32[o + 5] = a, e1;
            }
        }
        xl.prototype.bytesPerElement = 24, ra(xl, "StructArrayLayout6f24");
        class vl extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r, n, i) {
                const s = this.length;
                return this.resize(s + 1), this.emplace(s, e1, t1, r, n, i);
            }
            emplace(e1, t1, r, n, i, s) {
                const a = 5 * e1;
                return this.float32[a + 0] = t1, this.float32[a + 1] = r, this.float32[a + 2] = n, this.float32[a + 3] = i, this.float32[a + 4] = s, e1;
            }
        }
        vl.prototype.bytesPerElement = 20, ra(vl, "StructArrayLayout5f20");
        class bl extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r, n, i, s, a) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e1, t1, r, n, i, s, a);
            }
            emplace(e1, t1, r, n, i, s, a, o) {
                const l = 7 * e1;
                return this.float32[l + 0] = t1, this.float32[l + 1] = r, this.float32[l + 2] = n, this.float32[l + 3] = i, this.float32[l + 4] = s, this.float32[l + 5] = a, this.float32[l + 6] = o, e1;
            }
        }
        bl.prototype.bytesPerElement = 28, ra(bl, "StructArrayLayout7f28");
        class wl extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r, n, i, s, a, o, l, u, c) {
                const h = this.length;
                return this.resize(h + 1), this.emplace(h, e1, t1, r, n, i, s, a, o, l, u, c);
            }
            emplace(e1, t1, r, n, i, s, a, o, l, u, c, h) {
                const d = 11 * e1;
                return this.float32[d + 0] = t1, this.float32[d + 1] = r, this.float32[d + 2] = n, this.float32[d + 3] = i, this.float32[d + 4] = s, this.float32[d + 5] = a, this.float32[d + 6] = o, this.float32[d + 7] = l, this.float32[d + 8] = u, this.float32[d + 9] = c, this.float32[d + 10] = h, e1;
            }
        }
        wl.prototype.bytesPerElement = 44, ra(wl, "StructArrayLayout11f44");
        class _l extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r, n, i, s, a, o, l) {
                const u = this.length;
                return this.resize(u + 1), this.emplace(u, e1, t1, r, n, i, s, a, o, l);
            }
            emplace(e1, t1, r, n, i, s, a, o, l, u) {
                const c = 9 * e1;
                return this.float32[c + 0] = t1, this.float32[c + 1] = r, this.float32[c + 2] = n, this.float32[c + 3] = i, this.float32[c + 4] = s, this.float32[c + 5] = a, this.float32[c + 6] = o, this.float32[c + 7] = l, this.float32[c + 8] = u, e1;
            }
        }
        _l.prototype.bytesPerElement = 36, ra(_l, "StructArrayLayout9f36");
        class Al extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1) {
                const r = this.length;
                return this.resize(r + 1), this.emplace(r, e1, t1);
            }
            emplace(e1, t1, r) {
                const n = 2 * e1;
                return this.float32[n + 0] = t1, this.float32[n + 1] = r, e1;
            }
        }
        Al.prototype.bytesPerElement = 8, ra(Al, "StructArrayLayout2f8");
        class Il extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r, n) {
                const i = this.length;
                return this.resize(i + 1), this.emplace(i, e1, t1, r, n);
            }
            emplace(e1, t1, r, n, i) {
                const s = 6 * e1;
                return this.uint32[3 * e1 + 0] = t1, this.uint16[s + 2] = r, this.uint16[s + 3] = n, this.uint16[s + 4] = i, e1;
            }
        }
        Il.prototype.bytesPerElement = 12, ra(Il, "StructArrayLayout1ul3ui12");
        class Ml extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t1 = this.length;
                return this.resize(t1 + 1), this.emplace(t1, e1);
            }
            emplace(e1, t1) {
                return this.uint16[1 * e1 + 0] = t1, e1;
            }
        }
        Ml.prototype.bytesPerElement = 2, ra(Ml, "StructArrayLayout1ui2");
        class Bl extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r, n, i, s, a, o, l, u, c, h, d, p, f, m) {
                const y = this.length;
                return this.resize(y + 1), this.emplace(y, e1, t1, r, n, i, s, a, o, l, u, c, h, d, p, f, m);
            }
            emplace(e1, t1, r, n, i, s, a, o, l, u, c, h, d, p, f, m, y) {
                const g = 16 * e1;
                return this.float32[g + 0] = t1, this.float32[g + 1] = r, this.float32[g + 2] = n, this.float32[g + 3] = i, this.float32[g + 4] = s, this.float32[g + 5] = a, this.float32[g + 6] = o, this.float32[g + 7] = l, this.float32[g + 8] = u, this.float32[g + 9] = c, this.float32[g + 10] = h, this.float32[g + 11] = d, this.float32[g + 12] = p, this.float32[g + 13] = f, this.float32[g + 14] = m, this.float32[g + 15] = y, e1;
            }
        }
        Bl.prototype.bytesPerElement = 64, ra(Bl, "StructArrayLayout16f64");
        class Sl extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
            }
            emplaceBack(e1, t1, r, n, i, s, a) {
                const o = this.length;
                return this.resize(o + 1), this.emplace(o, e1, t1, r, n, i, s, a);
            }
            emplace(e1, t1, r, n, i, s, a, o) {
                const l = 10 * e1, u = 5 * e1;
                return this.uint16[l + 0] = t1, this.uint16[l + 1] = r, this.uint16[l + 2] = n, this.uint16[l + 3] = i, this.float32[u + 2] = s, this.float32[u + 3] = a, this.float32[u + 4] = o, e1;
            }
        }
        Sl.prototype.bytesPerElement = 20, ra(Sl, "StructArrayLayout4ui3f20");
        class Pl extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t1 = this.length;
                return this.resize(t1 + 1), this.emplace(t1, e1);
            }
            emplace(e1, t1) {
                return this.int16[1 * e1 + 0] = t1, e1;
            }
        }
        Pl.prototype.bytesPerElement = 2, ra(Pl, "StructArrayLayout1i2");
        class Tl extends $o {
            _refreshViews() {
                this.uint8 = new Uint8Array(this.arrayBuffer);
            }
            emplaceBack(e1) {
                const t1 = this.length;
                return this.resize(t1 + 1), this.emplace(t1, e1);
            }
            emplace(e1, t1) {
                return this.uint8[1 * e1 + 0] = t1, e1;
            }
        }
        Tl.prototype.bytesPerElement = 1, ra(Tl, "StructArrayLayout1ub1");
        class zl extends jo {
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
                return this._structArray.int16[this._pos2 + 3];
            }
            get tileAnchorY() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get x1() {
                return this._structArray.float32[this._pos4 + 3];
            }
            get y1() {
                return this._structArray.float32[this._pos4 + 4];
            }
            get x2() {
                return this._structArray.float32[this._pos4 + 5];
            }
            get y2() {
                return this._structArray.float32[this._pos4 + 6];
            }
            get padding() {
                return this._structArray.int16[this._pos2 + 14];
            }
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 8];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 19];
            }
        }
        zl.prototype.size = 40;
        class kl extends hl {
            get(e1) {
                return new zl(this, e1);
            }
        }
        ra(kl, "CollisionBoxArray");
        class Vl extends jo {
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 2];
            }
            get tileAnchorX() {
                return this._structArray.float32[this._pos4 + 2];
            }
            get tileAnchorY() {
                return this._structArray.float32[this._pos4 + 3];
            }
            get glyphStartIndex() {
                return this._structArray.uint16[this._pos2 + 8];
            }
            get numGlyphs() {
                return this._structArray.uint16[this._pos2 + 9];
            }
            get vertexStartIndex() {
                return this._structArray.uint32[this._pos4 + 5];
            }
            get lineStartIndex() {
                return this._structArray.uint32[this._pos4 + 6];
            }
            get lineLength() {
                return this._structArray.uint32[this._pos4 + 7];
            }
            get segment() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get lowerSize() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get upperSize() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get lineOffsetX() {
                return this._structArray.float32[this._pos4 + 10];
            }
            get lineOffsetY() {
                return this._structArray.float32[this._pos4 + 11];
            }
            get writingMode() {
                return this._structArray.uint8[this._pos1 + 48];
            }
            get placedOrientation() {
                return this._structArray.uint8[this._pos1 + 49];
            }
            set placedOrientation(e1) {
                this._structArray.uint8[this._pos1 + 49] = e1;
            }
            get hidden() {
                return this._structArray.uint8[this._pos1 + 50];
            }
            set hidden(e1) {
                this._structArray.uint8[this._pos1 + 50] = e1;
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 13];
            }
            set crossTileID(e1) {
                this._structArray.uint32[this._pos4 + 13] = e1;
            }
            get associatedIconIndex() {
                return this._structArray.int16[this._pos2 + 28];
            }
            get flipState() {
                return this._structArray.uint8[this._pos1 + 58];
            }
            set flipState(e1) {
                this._structArray.uint8[this._pos1 + 58] = e1;
            }
        }
        Vl.prototype.size = 60;
        class Fl extends yl {
            get(e1) {
                return new Vl(this, e1);
            }
        }
        ra(Fl, "PlacedSymbolArray");
        class Dl extends jo {
            get tileAnchorX() {
                return this._structArray.float32[this._pos4 + 0];
            }
            get tileAnchorY() {
                return this._structArray.float32[this._pos4 + 1];
            }
            get projectedAnchorX() {
                return this._structArray.int16[this._pos2 + 4];
            }
            get projectedAnchorY() {
                return this._structArray.int16[this._pos2 + 5];
            }
            get projectedAnchorZ() {
                return this._structArray.int16[this._pos2 + 6];
            }
            get rightJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 7];
            }
            get centerJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 8];
            }
            get leftJustifiedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 9];
            }
            get verticalPlacedTextSymbolIndex() {
                return this._structArray.int16[this._pos2 + 10];
            }
            get placedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 11];
            }
            get verticalPlacedIconSymbolIndex() {
                return this._structArray.int16[this._pos2 + 12];
            }
            get key() {
                return this._structArray.uint16[this._pos2 + 13];
            }
            get textBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 14];
            }
            get textBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 15];
            }
            get verticalTextBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 16];
            }
            get verticalTextBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 17];
            }
            get iconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 18];
            }
            get iconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 19];
            }
            get verticalIconBoxStartIndex() {
                return this._structArray.uint16[this._pos2 + 20];
            }
            get verticalIconBoxEndIndex() {
                return this._structArray.uint16[this._pos2 + 21];
            }
            get featureIndex() {
                return this._structArray.uint16[this._pos2 + 22];
            }
            get numHorizontalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 23];
            }
            get numVerticalGlyphVertices() {
                return this._structArray.uint16[this._pos2 + 24];
            }
            get numIconVertices() {
                return this._structArray.uint16[this._pos2 + 25];
            }
            get numVerticalIconVertices() {
                return this._structArray.uint16[this._pos2 + 26];
            }
            get useRuntimeCollisionCircles() {
                return this._structArray.uint16[this._pos2 + 27];
            }
            get crossTileID() {
                return this._structArray.uint32[this._pos4 + 14];
            }
            set crossTileID(e1) {
                this._structArray.uint32[this._pos4 + 14] = e1;
            }
            get textOffset0() {
                return this._structArray.float32[this._pos4 + 15];
            }
            get textOffset1() {
                return this._structArray.float32[this._pos4 + 16];
            }
            get collisionCircleDiameter() {
                return this._structArray.float32[this._pos4 + 17];
            }
            get zOffset() {
                return this._structArray.float32[this._pos4 + 18];
            }
            set zOffset(e1) {
                this._structArray.float32[this._pos4 + 18] = e1;
            }
            get hasIconTextFit() {
                return this._structArray.uint8[this._pos1 + 76];
            }
            get elevationFeatureIndex() {
                return this._structArray.uint16[this._pos2 + 39];
            }
        }
        Dl.prototype.size = 80;
        class El extends gl {
            get(e1) {
                return new Dl(this, e1);
            }
        }
        ra(El, "SymbolInstanceArray");
        class Cl extends Yo {
            getoffsetX(e1) {
                return this.float32[1 * e1 + 0];
            }
        }
        ra(Cl, "GlyphOffsetArray");
        class Rl extends Xo {
            getx(e1) {
                return this.int16[2 * e1 + 0];
            }
            gety(e1) {
                return this.int16[2 * e1 + 1];
            }
        }
        ra(Rl, "SymbolLineVertexArray");
        class Ll extends jo {
            get featureIndex() {
                return this._structArray.uint32[this._pos4 + 0];
            }
            get sourceLayerIndex() {
                return this._structArray.uint16[this._pos2 + 2];
            }
            get bucketIndex() {
                return this._structArray.uint16[this._pos2 + 3];
            }
            get layoutVertexArrayOffset() {
                return this._structArray.uint16[this._pos2 + 4];
            }
        }
        Ll.prototype.size = 12;
        class Ol extends Il {
            get(e1) {
                return new Ll(this, e1);
            }
        }
        ra(Ol, "FeatureIndexArray");
        class Ul extends cl {
            geta_centroid_pos0(e1) {
                return this.uint16[2 * e1 + 0];
            }
            geta_centroid_pos1(e1) {
                return this.uint16[2 * e1 + 1];
            }
        }
        ra(Ul, "FillExtrusionCentroidArray");
        class Nl extends jo {
            get a_join_normal_inside0() {
                return this._structArray.int16[this._pos2 + 0];
            }
            get a_join_normal_inside1() {
                return this._structArray.int16[this._pos2 + 1];
            }
            get a_join_normal_inside2() {
                return this._structArray.int16[this._pos2 + 2];
            }
        }
        Nl.prototype.size = 6;
        class jl extends Zo {
            get(e1) {
                return new Nl(this, e1);
            }
        }
        ra(jl, "FillExtrusionWallArray");
        const Gl = qo([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), $l = qo([
            {
                name: "a_circle_z_offset",
                components: 1,
                type: "Float32"
            }
        ], 4), ql = qo([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ]);
        class Hl {
            constructor(e1 = []){
                this.segments = e1;
            }
            _prepareSegment(e1, t1, r, n, i) {
                let s = this.segments[this.segments.length - 1];
                return e1 > Hl.MAX_VERTEX_ARRAY_LENGTH && Ze(`Max vertices per segment is ${Hl.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${e1}`), (!s || s.vertexLength + e1 > Hl.MAX_VERTEX_ARRAY_LENGTH || s.sortKey !== n || void 0 !== i && s && void 0 !== s.batchIndex && s.batchIndex !== i) && (s = {
                    vertexOffset: t1,
                    primitiveOffset: r,
                    vertexLength: 0,
                    primitiveLength: 0
                }, void 0 !== n && (s.sortKey = n), void 0 !== i && (s.batchIndex = i), this.segments.push(s)), s;
            }
            prepareSegment(e1, t1, r, n, i) {
                return this._prepareSegment(e1, t1.length, r.length, n, i);
            }
            get() {
                return this.segments;
            }
            destroy() {
                for (const e1 of this.segments)for(const t1 in e1.vaos)e1.vaos[t1].destroy();
            }
            static simpleSegment(e1, t1, r, n) {
                return new Hl([
                    {
                        vertexOffset: e1,
                        primitiveOffset: t1,
                        vertexLength: r,
                        primitiveLength: n,
                        vaos: {},
                        sortKey: 0
                    }
                ]);
            }
        }
        function Xl(e1, t1) {
            return 256 * (e1 = Ee(Math.floor(e1), 0, 255)) + Ee(Math.floor(t1), 0, 255);
        }
        Hl.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, ra(Hl, "SegmentVector");
        const Zl = qo([
            {
                name: "a_pattern",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixel_ratio",
                components: 1,
                type: "Float32"
            }
        ]), Wl = qo([
            {
                name: "a_pattern_b",
                components: 4,
                type: "Uint16"
            }
        ]), Yl = qo([
            {
                name: "a_dash",
                components: 4,
                type: "Uint16"
            }
        ]);
        class Jl {
            constructor(){
                this.ids = [], this.uniqueIds = [], this.positions = [], this.indexed = !1;
            }
            add(e1, t1, r, n) {
                this.ids.push(Kl(e1)), this.positions.push(t1, r, n);
            }
            eachPosition(e1, t1) {
                const r = Kl(e1);
                let n = 0, i = this.ids.length - 1;
                for(; n < i;){
                    const e1 = n + i >> 1;
                    this.ids[e1] >= r ? i = e1 : n = e1 + 1;
                }
                for(; this.ids[n] === r;)t1(this.positions[3 * n], this.positions[3 * n + 1], this.positions[3 * n + 2]), n++;
            }
            static serialize(e1, t1) {
                const r = new Float64Array(e1.ids), n = new Uint32Array(e1.positions);
                return Ql(r, n, 0, r.length - 1), t1 && (t1.add(r.buffer), t1.add(n.buffer)), {
                    ids: r,
                    positions: n
                };
            }
            static deserialize(e1) {
                const t1 = new Jl;
                let r;
                t1.ids = e1.ids, t1.positions = e1.positions;
                for (const e1 of t1.ids)e1 !== r && t1.uniqueIds.push(e1), r = e1;
                return t1.indexed = !0, t1;
            }
        }
        function Kl(e1) {
            const t1 = +e1;
            return Number.isSafeInteger(t1) ? t1 : rr(String(e1));
        }
        function Ql(e1, t1, r, n) {
            for(; r < n;){
                const i = e1[r + n >> 1];
                let s = r - 1, a = n + 1;
                for(;;){
                    do s++;
                    while (e1[s] < i);
                    do a--;
                    while (e1[a] > i);
                    if (s >= a) break;
                    eu(e1, s, a), eu(t1, 3 * s, 3 * a), eu(t1, 3 * s + 1, 3 * a + 1), eu(t1, 3 * s + 2, 3 * a + 2);
                }
                a - r < n - a ? (Ql(e1, t1, r, a), r = a + 1) : (Ql(e1, t1, a + 1, n), n = a);
            }
        }
        function eu(e1, t1, r) {
            const n = e1[t1];
            e1[t1] = e1[r], e1[r] = n;
        }
        ra(Jl, "FeaturePositionMap");
        class tu {
            constructor(e1){
                this.gl = e1.gl, this.initialized = !1;
            }
            fetchUniformLocation(e1, t1) {
                return this.location || this.initialized || (this.location = this.gl.getUniformLocation(e1, t1), this.initialized = !0), !!this.location;
            }
            set(e1, t1, r) {
                throw new Error("Uniform#set() must be implemented by each concrete Uniform");
            }
        }
        class ru extends tu {
            constructor(e1){
                super(e1), this.current = 0;
            }
            set(e1, t1, r) {
                this.fetchUniformLocation(e1, t1) && this.current !== r && (this.current = r, this.gl.uniform1i(this.location, r));
            }
        }
        class nu extends tu {
            constructor(e1){
                super(e1), this.current = 0;
            }
            set(e1, t1, r) {
                this.fetchUniformLocation(e1, t1) && this.current !== r && (this.current = r, this.gl.uniform1f(this.location, r));
            }
        }
        class iu extends tu {
            constructor(e1){
                super(e1), this.current = [
                    0,
                    0
                ];
            }
            set(e1, t1, r) {
                this.fetchUniformLocation(e1, t1) && (r[0] === this.current[0] && r[1] === this.current[1] || (this.current = r, this.gl.uniform2f(this.location, r[0], r[1])));
            }
        }
        class su extends tu {
            constructor(e1){
                super(e1), this.current = [
                    0,
                    0,
                    0
                ];
            }
            set(e1, t1, r) {
                this.fetchUniformLocation(e1, t1) && (r[0] === this.current[0] && r[1] === this.current[1] && r[2] === this.current[2] || (this.current = r, this.gl.uniform3f(this.location, r[0], r[1], r[2])));
            }
        }
        class au extends tu {
            constructor(e1){
                super(e1), this.current = [
                    0,
                    0,
                    0,
                    0
                ];
            }
            set(e1, t1, r) {
                this.fetchUniformLocation(e1, t1) && (r[0] === this.current[0] && r[1] === this.current[1] && r[2] === this.current[2] && r[3] === this.current[3] || (this.current = r, this.gl.uniform4ui(this.location, r[0], r[1], r[2], r[3])));
            }
        }
        class ou extends tu {
            constructor(e1){
                super(e1), this.current = [
                    0,
                    0,
                    0,
                    0
                ];
            }
            set(e1, t1, r) {
                this.fetchUniformLocation(e1, t1) && (r[0] === this.current[0] && r[1] === this.current[1] && r[2] === this.current[2] && r[3] === this.current[3] || (this.current = r, this.gl.uniform4f(this.location, r[0], r[1], r[2], r[3])));
            }
        }
        class lu extends tu {
            constructor(e1){
                super(e1), this.current = dr.transparent.toPremultipliedRenderColor(null);
            }
            set(e1, t1, r) {
                this.fetchUniformLocation(e1, t1) && (r.r === this.current.r && r.g === this.current.g && r.b === this.current.b && r.a === this.current.a || (this.current = r, this.gl.uniform4f(this.location, r.r, r.g, r.b, r.a)));
            }
        }
        const uu = new Float32Array(16);
        class cu extends tu {
            constructor(e1){
                super(e1), this.current = uu;
            }
            set(e1, t1, r) {
                if (this.fetchUniformLocation(e1, t1)) {
                    if (r[12] !== this.current[12] || r[0] !== this.current[0]) return this.current = r, void this.gl.uniformMatrix4fv(this.location, !1, r);
                    for(let e1 = 1; e1 < 16; e1++)if (r[e1] !== this.current[e1]) {
                        this.current = r, this.gl.uniformMatrix4fv(this.location, !1, r);
                        break;
                    }
                }
            }
        }
        const hu = new Float32Array(9), du = new Float32Array(4);
        class pu extends tu {
            constructor(e1){
                super(e1), this.current = du;
            }
            set(e1, t1, r) {
                if (this.fetchUniformLocation(e1, t1)) {
                    for(let e1 = 0; e1 < 4; e1++)if (r[e1] !== this.current[e1]) {
                        this.current = r, this.gl.uniformMatrix2fv(this.location, !1, r);
                        break;
                    }
                }
            }
        }
        function fu(e1) {
            return [
                Xl(255 * e1.r, 255 * e1.g),
                Xl(255 * e1.b, 255 * e1.a)
            ];
        }
        function mu(e1, t1, r, n, i, s, a, o) {
            return !!e1 && ("composite" === e1.kind || "source" === e1.kind ? "none" === e1.evaluate(new to(0, {
                brightness: s,
                worldview: o
            }), t1, r, i, n, a) : "none" === e1.value);
        }
        class yu {
            constructor(e1, t1, r, n){
                this.value = e1, this.uniformNames = t1.map((e1)=>`u_${e1}`), this.type = r, this.context = n;
            }
            setUniform(e1, t1, r, n, i) {
                const s = n.constantOr(this.value);
                t1.set(e1, i, s instanceof dr ? s.toPremultipliedRenderColor(this.lutExpression && "constant" === this.lutExpression.kind && "none" === this.lutExpression.value ? null : this.context.lut) : s);
            }
            getBinding(e1, t1) {
                return "color" === this.type ? new lu(e1) : new nu(e1);
            }
        }
        class gu {
            constructor(e1, t1){
                this.uniformNames = t1.map((e1)=>`u_${e1}`), this.pattern = null, this.patternTransition = null, this.pixelRatio = 1;
            }
            setConstantPatternPositions(e1, t1) {
                this.pixelRatio = e1.pixelRatio || 1, this.pattern = e1.tl.concat(e1.br), this.patternTransition = t1 ? t1.tl.concat(t1.br) : this.pattern;
            }
            setUniform(e1, t1, r, n, i) {
                let s = null;
                "u_pattern" !== i && "u_dash" !== i || (s = this.pattern), "u_pattern_b" === i && (s = this.patternTransition), "u_pixel_ratio" === i && (s = this.pixelRatio), s && t1.set(e1, i, s);
            }
            getBinding(e1, t1) {
                return "u_pattern" === t1 || "u_pattern_b" === t1 || "u_dash" === t1 ? new au(e1) : new nu(e1);
            }
        }
        class xu {
            constructor(e1, t1, r, n){
                this.expression = e1, this.type = r, this.maxValue = 0, this.paintVertexAttributes = t1.map((e1)=>({
                        name: `a_${e1}`,
                        type: "Float32",
                        components: "color" === r ? 2 : 1,
                        offset: 0
                    })), this.paintVertexArray = new n;
            }
            populatePaintArray(e1, t1, r, n, i, s, a, o) {
                const l = this.paintVertexArray.length, u = "composite" === this.expression.kind || "source" === this.expression.kind ? this.expression.evaluate(new to(0, {
                    brightness: s,
                    worldview: o
                }), t1, {}, i, n, a) : "constant" === this.expression.kind && this.expression.value, c = mu(this.lutExpression, t1, {}, n, i, s, a, o);
                this.paintVertexArray.resize(e1), this._setPaintValue(l, e1, u, c ? null : this.context.lut);
            }
            updatePaintArray(e1, t1, r, n, i, s, a, o) {
                const l = "composite" === this.expression.kind || "source" === this.expression.kind ? this.expression.evaluate({
                    zoom: 0,
                    brightness: a,
                    worldview: o
                }, r, n, void 0, i) : "constant" === this.expression.kind && this.expression.value, u = mu(this.lutExpression, r, n, i, void 0, a, void 0, o);
                this._setPaintValue(e1, t1, l, u ? null : this.context.lut);
            }
            _setPaintValue(e1, t1, r, n) {
                if ("color" === this.type) {
                    const i = fu(r.toPremultipliedRenderColor(n));
                    for(let r = e1; r < t1; r++)this.paintVertexArray.emplace(r, i[0], i[1]);
                } else {
                    for(let n = e1; n < t1; n++)this.paintVertexArray.emplace(n, r);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r));
                }
            }
            upload(e1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = e1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.lutExpression && "constant" !== this.lutExpression.kind && (this.lutExpression.isStateDependent || !this.lutExpression.isLightConstant) || "constant" !== this.expression.kind && (this.expression.isStateDependent || !this.expression.isLightConstant)));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
        }
        class vu {
            constructor(e1, t1, r, n, i, s){
                this.expression = e1, this.uniformNames = t1.map((e1)=>`u_${e1}_t`), this.type = r, this.useIntegerZoom = n, this.context = i, this.maxValue = 0, this.paintVertexAttributes = t1.map((e1)=>({
                        name: `a_${e1}`,
                        type: "Float32",
                        components: "color" === r ? 4 : 2,
                        offset: 0
                    })), this.paintVertexArray = new s;
            }
            populatePaintArray(e1, t1, r, n, i, s, a, o) {
                const l = this.expression.evaluate(new to(this.context.zoom, {
                    brightness: s,
                    worldview: o
                }), t1, {}, i, n, a), u = this.expression.evaluate(new to(this.context.zoom + 1, {
                    brightness: s,
                    worldview: o
                }), t1, {}, i, n, a), c = mu(this.lutExpression, t1, {}, n, i, s, a, o), h = this.paintVertexArray.length;
                this.paintVertexArray.resize(e1), this._setPaintValue(h, e1, l, u, c ? null : this.context.lut);
            }
            updatePaintArray(e1, t1, r, n, i, s, a, o) {
                const l = this.expression.evaluate({
                    zoom: this.context.zoom,
                    brightness: a,
                    worldview: o
                }, r, n, void 0, i), u = this.expression.evaluate({
                    zoom: this.context.zoom + 1,
                    brightness: a,
                    worldview: o
                }, r, n, void 0, i), c = mu(this.lutExpression, r, n, i, void 0, a, void 0, o);
                this._setPaintValue(e1, t1, l, u, c ? null : this.context.lut);
            }
            _setPaintValue(e1, t1, r, n, i) {
                if ("color" === this.type) {
                    const s = fu(r.toPremultipliedRenderColor(i)), a = fu(n.toPremultipliedRenderColor(i));
                    for(let r = e1; r < t1; r++)this.paintVertexArray.emplace(r, s[0], s[1], a[0], a[1]);
                } else {
                    for(let i = e1; i < t1; i++)this.paintVertexArray.emplace(i, r, n);
                    this.maxValue = Math.max(this.maxValue, Math.abs(r), Math.abs(n));
                }
            }
            upload(e1) {
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = e1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent || !this.expression.isLightConstant));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
            }
            setUniform(e1, t1, r, n, i) {
                const s = this.useIntegerZoom ? Math.floor(r.zoom) : r.zoom, a = Ee(this.expression.interpolationFactor(s, this.context.zoom, this.context.zoom + 1), 0, 1);
                t1.set(e1, i, a);
            }
            getBinding(e1, t1) {
                return new nu(e1);
            }
        }
        class bu {
            constructor(e1, t1, r, n, i){
                this.expression = e1, this.layerId = i, this.paintVertexAttributes = ("array" === r ? Yl : Zl).members;
                for(let e1 = 0; e1 < t1.length; ++e1);
                this.paintVertexArray = new n, this.paintTransitionVertexArray = new il;
            }
            populatePaintArray(e1, t1, r, n) {
                const i = this.paintVertexArray.length;
                this.paintVertexArray.resize(e1), this._setPaintValues(i, e1, t1.patterns && t1.patterns[this.layerId], r);
            }
            updatePaintArray(e1, t1, r, n, i, s, a) {
                this._setPaintValues(e1, t1, r.patterns && r.patterns[this.layerId], s);
            }
            _setPaintValues(e1, t1, r, n) {
                if (!n || !r) return;
                const i = n[r[0]], s = n[r[1]];
                if (i) {
                    if (i) {
                        const { tl: r, br: n, pixelRatio: s } = i;
                        for(let i = e1; i < t1; i++)this.paintVertexArray.emplace(i, r[0], r[1], n[0], n[1], s);
                    }
                    if (s) {
                        this.paintTransitionVertexArray.resize(this.paintVertexArray.length);
                        const { tl: r, br: n } = s;
                        for(let i = e1; i < t1; i++)this.paintTransitionVertexArray.emplace(i, r[0], r[1], n[0], n[1]);
                    }
                }
            }
            upload(e1) {
                const t1 = this.expression.isStateDependent || !this.expression.isLightConstant;
                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer = e1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, t1)), this.paintTransitionVertexArray && this.paintTransitionVertexArray.length && (this.paintTransitionVertexBuffer = e1.createVertexBuffer(this.paintTransitionVertexArray, Wl.members, t1));
            }
            destroy() {
                this.paintVertexBuffer && this.paintVertexBuffer.destroy(), this.paintTransitionVertexBuffer && this.paintTransitionVertexBuffer.destroy();
            }
        }
        class wu {
            constructor(e1, t1, r = ()=>!0){
                this.binders = {}, this._buffers = [], this.context = t1;
                const n = [], i = e1;
                for(const s in e1.paint._values){
                    const a = i.paint.get(s);
                    if (s.endsWith("-use-theme")) continue;
                    if (!r(s)) continue;
                    if (!(a instanceof lo && ks(a.property.specification))) continue;
                    const o = Iu(s, e1.type), l = a.value, u = a.property.specification.type, c = !!a.property.useIntegerZoom, h = "line-dasharray" === s || s.endsWith("pattern"), d = i.paint.get(`${s}-use-theme`), p = "line-dasharray" === s && "constant" !== i.layout.get("line-cap").value.kind || d && "constant" !== d.value.kind;
                    if ("constant" !== l.kind || p) {
                        if ("source" === l.kind || p || h) {
                            const t1 = Su(s, u, "source");
                            this.binders[s] = h ? new bu(l, o, u, t1, e1.id) : new xu(l, o, u, t1), n.push(`/a_${s}`);
                        } else {
                            const e1 = Su(s, u, "composite");
                            this.binders[s] = new vu(l, o, u, c, t1, e1), n.push(`/z_${s}`);
                        }
                    } else this.binders[s] = h ? new gu(l.value, o) : new yu(l.value, o, u, t1), n.push(`/u_${s}`);
                    d && (this.binders[s].lutExpression = d.value);
                }
                this.cacheKey = n.sort().join("");
            }
            getMaxValue(e1) {
                const t1 = this.binders[e1];
                return t1 instanceof xu || t1 instanceof vu ? t1.maxValue : 0;
            }
            populatePaintArrays(e1, t1, r, n, i, s, a, o) {
                for(const l in this.binders){
                    const u = this.binders[l];
                    u.context = this.context, (u instanceof xu || u instanceof vu || u instanceof bu) && u.populatePaintArray(e1, t1, r, n, i, s, a, o);
                }
            }
            setConstantPatternPositions(e1, t1) {
                for(const r in this.binders){
                    const n = this.binders[r];
                    n instanceof gu && n.setConstantPatternPositions(e1, t1);
                }
            }
            getPatternTransitionVertexBuffer(e1) {
                const t1 = this.binders[e1];
                return t1 instanceof bu ? t1.paintTransitionVertexBuffer : null;
            }
            updatePaintArrays(e1, t1, r, n, i, s, a, o, l, u) {
                let c = !1;
                const h = Object.keys(e1), d = 0 !== h.length && !o, p = d ? h : t1.uniqueIds;
                this.context.lut = i.lut;
                for(const o in this.binders){
                    const h = this.binders[o];
                    if (h.context = this.context, (h instanceof xu || h instanceof vu || h instanceof bu) && h.expression && h.expression.kind && "constant" !== h.expression.kind && (!0 === h.expression.isStateDependent || !1 === h.expression.isLightConstant)) {
                        const f = i.paint.get(o);
                        h.expression = f.value;
                        for (const r of p){
                            const i = e1[r.toString()];
                            t1.eachPosition(r, (e1, t1, r)=>{
                                const o = n.feature(e1);
                                h.updatePaintArray(t1, r, o, i, s, a, l, u);
                            });
                        }
                        if (!d) for (const t1 of r.uniqueIds){
                            const i = e1[t1.toString()];
                            r.eachPosition(t1, (e1, t1, r)=>{
                                const o = n.feature(e1);
                                h.updatePaintArray(t1, r, o, i, s, a, l, u);
                            });
                        }
                        c = !0;
                    }
                }
                return c;
            }
            defines() {
                const e1 = [];
                for(const t1 in this.binders){
                    const r = this.binders[t1];
                    (r instanceof yu || r instanceof gu) && e1.push(...r.uniformNames.map((e1)=>`#define HAS_UNIFORM_${e1}`));
                }
                return e1;
            }
            getPaintVertexBuffers() {
                return this._buffers;
            }
            getUniforms(e1) {
                const t1 = [];
                for(const r in this.binders){
                    const n = this.binders[r];
                    if (n instanceof yu || n instanceof gu || n instanceof vu) for (const i of n.uniformNames)t1.push({
                        name: i,
                        property: r,
                        binding: n.getBinding(e1, i)
                    });
                }
                return t1;
            }
            setUniforms(e1, t1, r, n, i) {
                for (const { name: t1, property: s, binding: a } of r)this.binders[s].setUniform(e1, a, i, n.get(s), t1);
            }
            updatePaintBuffers() {
                this._buffers = [];
                for(const e1 in this.binders){
                    const t1 = this.binders[e1];
                    (t1 instanceof xu || t1 instanceof vu || t1 instanceof bu) && t1.paintVertexBuffer && this._buffers.push(t1.paintVertexBuffer), t1 instanceof bu && t1.paintTransitionVertexBuffer && this._buffers.push(t1.paintTransitionVertexBuffer);
                }
            }
            upload(e1) {
                for(const t1 in this.binders){
                    const r = this.binders[t1];
                    (r instanceof xu || r instanceof vu || r instanceof bu) && r.upload(e1);
                }
                this.updatePaintBuffers();
            }
            destroy() {
                for(const e1 in this.binders){
                    const t1 = this.binders[e1];
                    (t1 instanceof xu || t1 instanceof vu || t1 instanceof bu) && t1.destroy();
                }
            }
        }
        class _u {
            constructor(e1, t1, r = ()=>!0){
                this.programConfigurations = {};
                for (const n of e1)this.programConfigurations[n.id] = new wu(n, t1, r);
                this.needsUpload = !1, this._featureMap = new Jl, this._featureMapWithoutIds = new Jl, this._bufferOffset = 0, this._idlessCounter = 0;
            }
            populatePaintArrays(e1, t1, r, n, i, s, a, o, l) {
                for(const r in this.programConfigurations)this.programConfigurations[r].populatePaintArrays(e1, t1, n, i, s, a, o, l);
                void 0 !== t1.id ? this._featureMap.add(t1.id, r, this._bufferOffset, e1) : (this._featureMapWithoutIds.add(this._idlessCounter, r, this._bufferOffset, e1), this._idlessCounter += 1), this._bufferOffset = e1, this.needsUpload = !0;
            }
            updatePaintArrays(e1, t1, r, n, i, s, a, o) {
                for (const l of r)this.needsUpload = this.programConfigurations[l.id].updatePaintArrays(e1, this._featureMap, this._featureMapWithoutIds, t1, l, n, i, s, a || 0, o) || this.needsUpload;
            }
            get(e1) {
                return this.programConfigurations[e1];
            }
            upload(e1) {
                if (this.needsUpload) {
                    for(const t1 in this.programConfigurations)this.programConfigurations[t1].upload(e1);
                    this.needsUpload = !1;
                }
            }
            destroy() {
                for(const e1 in this.programConfigurations)this.programConfigurations[e1].destroy();
            }
        }
        const Au = {
            "text-opacity": [
                "opacity"
            ],
            "icon-opacity": [
                "opacity"
            ],
            "text-occlusion-opacity": [
                "occlusion_opacity"
            ],
            "icon-occlusion-opacity": [
                "occlusion_opacity"
            ],
            "text-color": [
                "fill_color"
            ],
            "icon-color": [
                "fill_color"
            ],
            "text-emissive-strength": [
                "emissive_strength"
            ],
            "icon-emissive-strength": [
                "emissive_strength"
            ],
            "text-halo-color": [
                "halo_color"
            ],
            "icon-halo-color": [
                "halo_color"
            ],
            "text-halo-blur": [
                "halo_blur"
            ],
            "icon-halo-blur": [
                "halo_blur"
            ],
            "text-halo-width": [
                "halo_width"
            ],
            "icon-halo-width": [
                "halo_width"
            ],
            "symbol-z-offset": [
                "z_offset"
            ],
            "line-gap-width": [
                "gapwidth"
            ],
            "line-pattern": [
                "pattern",
                "pixel_ratio",
                "pattern_b"
            ],
            "fill-pattern": [
                "pattern",
                "pixel_ratio",
                "pattern_b"
            ],
            "fill-extrusion-pattern": [
                "pattern",
                "pixel_ratio",
                "pattern_b"
            ],
            "line-dasharray": [
                "dash"
            ],
            "fill-bridge-guard-rail-color": [
                "structure_color"
            ],
            "fill-tunnel-structure-color": [
                "structure_color"
            ]
        };
        function Iu(e1, t1) {
            return Au[e1] || [
                e1.replace(`${t1}-`, "").replace(/-/g, "_")
            ];
        }
        const Mu = {
            "line-pattern": {
                source: nl,
                composite: nl
            },
            "fill-pattern": {
                source: nl,
                composite: nl
            },
            "fill-extrusion-pattern": {
                source: nl,
                composite: nl
            },
            "line-dasharray": {
                source: il,
                composite: il
            }
        }, Bu = {
            color: {
                source: Al,
                composite: ll
            },
            number: {
                source: Yo,
                composite: Al
            }
        };
        function Su(e1, t1, r) {
            const n = Mu[e1];
            return n && n[r] || Bu[t1][r];
        }
        ra(yu, "ConstantBinder"), ra(gu, "PatternConstantBinder"), ra(xu, "SourceExpressionBinder"), ra(bu, "PatternCompositeBinder"), ra(vu, "CompositeExpressionBinder"), ra(wu, "ProgramConfiguration", {
            omit: [
                "_buffers"
            ]
        }), ra(_u, "ProgramConfigurationSet");
        const Pu = qn / Math.PI / 2, Tu = 64, zu = [
            Tu,
            32,
            16
        ], ku = -Pu, Vu = Pu;
        function Fu(e1, t1, r, n = Pu) {
            return r = Te(r), [
                e1 * Math.sin(r) * n,
                -t1 * n,
                e1 * Math.cos(r) * n
            ];
        }
        function Du(e1, t1, r) {
            return Fu(Math.cos(Te(e1)), Math.sin(Te(e1)), t1, r);
        }
        const Eu = 6371008.8, Cu = 2 * Math.PI * Eu;
        class Ru {
            constructor(e1, t1){
                if (isNaN(e1) || isNaN(t1)) throw new Error(`Invalid LngLat object: (${e1}, ${t1})`);
                if (this.lng = +e1, this.lat = +t1, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
            }
            wrap() {
                return new Ru(Re(this.lng, -180, 180), this.lat);
            }
            toArray() {
                return [
                    this.lng,
                    this.lat
                ];
            }
            toString() {
                return `LngLat(${this.lng}, ${this.lat})`;
            }
            distanceTo(e1) {
                const t1 = Math.PI / 180, r = this.lat * t1, n = e1.lat * t1, i = Math.sin(r) * Math.sin(n) + Math.cos(r) * Math.cos(n) * Math.cos((e1.lng - this.lng) * t1);
                return Eu * Math.acos(Math.min(i, 1));
            }
            toBounds(e1 = 0) {
                const t1 = 360 * e1 / 40075017, r = t1 / Math.cos(Math.PI / 180 * this.lat);
                return new Lu({
                    lng: this.lng - r,
                    lat: this.lat - t1
                }, {
                    lng: this.lng + r,
                    lat: this.lat + t1
                });
            }
            toEcef(e1) {
                return Du(this.lat, this.lng, Pu + e1 * Pu / Eu);
            }
            static convert(e1) {
                if (e1 instanceof Ru) return e1;
                if (Array.isArray(e1) && (2 === e1.length || 3 === e1.length)) return new Ru(Number(e1[0]), Number(e1[1]));
                if (!Array.isArray(e1) && "object" == typeof e1 && null !== e1) return new Ru(Number("lng" in e1 ? e1.lng : e1.lon), Number(e1.lat));
                throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
            }
        }
        class Lu {
            constructor(e1, t1){
                e1 && (t1 ? this.setSouthWest(e1).setNorthEast(t1) : Array.isArray(e1) && 4 === e1.length ? this.setSouthWest([
                    e1[0],
                    e1[1]
                ]).setNorthEast([
                    e1[2],
                    e1[3]
                ]) : this.setSouthWest(e1[0]).setNorthEast(e1[1]));
            }
            setNorthEast(e1) {
                return this._ne = e1 instanceof Ru ? new Ru(e1.lng, e1.lat) : Ru.convert(e1), this;
            }
            setSouthWest(e1) {
                return this._sw = e1 instanceof Ru ? new Ru(e1.lng, e1.lat) : Ru.convert(e1), this;
            }
            extend(e1) {
                const t1 = this._sw, r = this._ne;
                let n, i;
                if (e1 instanceof Ru) n = e1, i = e1;
                else {
                    if (!(e1 instanceof Lu)) return Array.isArray(e1) ? 4 === e1.length || e1.every(Array.isArray) ? this.extend(Lu.convert(e1)) : this.extend(Ru.convert(e1)) : "object" == typeof e1 && null !== e1 && e1.hasOwnProperty("lat") && (e1.hasOwnProperty("lon") || e1.hasOwnProperty("lng")) ? this.extend(Ru.convert(e1)) : this;
                    if (n = e1._sw, i = e1._ne, !n || !i) return this;
                }
                return t1 || r ? (t1.lng = Math.min(n.lng, t1.lng), t1.lat = Math.min(n.lat, t1.lat), r.lng = Math.max(i.lng, r.lng), r.lat = Math.max(i.lat, r.lat)) : (this._sw = new Ru(n.lng, n.lat), this._ne = new Ru(i.lng, i.lat)), this;
            }
            getCenter() {
                return new Ru((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
            }
            getSouthWest() {
                return this._sw;
            }
            getNorthEast() {
                return this._ne;
            }
            getNorthWest() {
                return new Ru(this.getWest(), this.getNorth());
            }
            getSouthEast() {
                return new Ru(this.getEast(), this.getSouth());
            }
            getWest() {
                return this._sw.lng;
            }
            getSouth() {
                return this._sw.lat;
            }
            getEast() {
                return this._ne.lng;
            }
            getNorth() {
                return this._ne.lat;
            }
            toArray() {
                return [
                    this._sw.toArray(),
                    this._ne.toArray()
                ];
            }
            toString() {
                return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
            }
            isEmpty() {
                return !(this._sw && this._ne);
            }
            contains(e1) {
                const { lng: t1, lat: r } = Ru.convert(e1);
                let n = this._sw.lng <= t1 && t1 <= this._ne.lng;
                return this._sw.lng > this._ne.lng && (n = this._sw.lng >= t1 && t1 >= this._ne.lng), this._sw.lat <= r && r <= this._ne.lat && n;
            }
            static convert(e1) {
                if (e1) return e1 instanceof Lu ? e1 : new Lu(e1);
            }
        }
        function Ou(e1) {
            return Cu * Math.cos(e1 * Math.PI / 180);
        }
        function Uu(e1) {
            return (180 + e1) / 360;
        }
        function Nu(e1) {
            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + e1 * Math.PI / 360))) / 360;
        }
        function ju(e1, t1) {
            return e1 / Ou(t1);
        }
        function Gu(e1) {
            return 360 * e1 - 180;
        }
        function $u(e1) {
            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * e1) * Math.PI / 180)) - 90;
        }
        function qu(e1, t1) {
            return e1 * Ou($u(t1));
        }
        const Hu = 85.051129;
        function Xu(e1) {
            return Math.cos(Te(Ee(e1, -85.051129, Hu)));
        }
        function Zu(e1, t1) {
            const r = Ee(t1, 0, 25.5), n = Math.pow(2, r);
            return Xu(e1) * Cu / (512 * n);
        }
        function Wu(e1) {
            return 1 / Math.cos(e1 * Math.PI / 180);
        }
        function Yu(e1, t1 = 0) {
            const r = Math.exp(Math.PI * (1 - (e1.y + t1 / qn) / (1 << e1.z) * 2));
            return 80150034 * r / (r * r + 1) / qn / (1 << e1.z);
        }
        class Ju {
            constructor(e1, t1, r = 0){
                this.x = +e1, this.y = +t1, this.z = +r;
            }
            static fromLngLat(e1, t1 = 0) {
                const r = Ru.convert(e1);
                return new Ju(Uu(r.lng), Nu(r.lat), ju(t1, r.lat));
            }
            toLngLat() {
                return new Ru(Gu(this.x), $u(this.y));
            }
            toAltitude() {
                return qu(this.z, this.y);
            }
            meterInMercatorCoordinateUnits() {
                return 1 / Cu * Wu($u(this.y));
            }
        }
        function Ku(e1, t1, r, n, i, s, a, o, l) {
            const u = (t1 + n) / 2, c = (r + i) / 2, h = new Me(u, c);
            o(h), function(e1, t1, r, n, i, s) {
                const a = r - i, o = n - s;
                return Math.abs((n - t1) * a - (r - e1) * o) / Math.hypot(a, o);
            }(h.x, h.y, s.x, s.y, a.x, a.y) >= l ? (Ku(e1, t1, r, u, c, s, h, o, l), Ku(e1, u, c, n, i, h, a, o, l)) : e1.push(a);
        }
        function Qu(e1, t1, r) {
            let n = e1[0], i = n.x, s = n.y;
            t1(n);
            const a = [
                n
            ];
            for(let o = 1; o < e1.length; o++){
                const l = e1[o], { x: u, y: c } = l;
                t1(l), Ku(a, i, s, u, c, n, l, t1, r), i = u, s = c, n = l;
            }
            return a;
        }
        function ec(e1, t1, r, n) {
            if (n(t1, r)) {
                const i = t1.add(r)._mult(.5);
                ec(e1, t1, i, n), ec(e1, i, r, n);
            } else e1.push(r);
        }
        function tc(e1, t1) {
            let r = e1[0];
            const n = [
                r
            ];
            for(let i = 1; i < e1.length; i++){
                const s = e1[i];
                ec(n, r, s, t1), r = s;
            }
            return n;
        }
        const rc = Math.pow(2, 14) - 1, nc = -rc - 1;
        function ic(e1, t1) {
            const r = Math.round(e1.x * t1), n = Math.round(e1.y * t1);
            return e1.x = Ee(r, nc, rc), e1.y = Ee(n, nc, rc), (r < e1.x || r > e1.x + 1 || n < e1.y || n > e1.y + 1) && Ze("Geometry exceeds allowed extent, reduce your vector tile buffer size"), e1;
        }
        function sc(e1, t1, r) {
            const n = e1.loadGeometry(), i = e1.extent, s = qn / i;
            if (t1 && r && r.projection.isReprojectedInTileSpace) {
                const s = 1 << t1.z, { scale: a, x: o, y: l, projection: u } = r, c = (e1)=>{
                    const r = Gu((t1.x + e1.x / i) / s), n = $u((t1.y + e1.y / i) / s), c = u.project(r, n);
                    e1.x = (c.x * a - o) * i, e1.y = (c.y * a - l) * i;
                };
                for(let t1 = 0; t1 < n.length; t1++)if (1 !== e1.type) n[t1] = Qu(n[t1], c, 1);
                else {
                    const e1 = [];
                    for (const r of n[t1])r.x < 0 || r.x >= i || r.y < 0 || r.y >= i || (c(r), e1.push(r));
                    n[t1] = e1;
                }
            }
            for (const e1 of n)for (const t1 of e1)ic(t1, s);
            return n;
        }
        function ac(e1, t1) {
            return {
                type: e1.type,
                id: e1.id,
                properties: e1.properties,
                geometry: t1 ? sc(e1) : []
            };
        }
        class oc {
            constructor(e1, t1, r, n, i){
                this.properties = {}, this.extent = r, this.type = 0, this.id = void 0, this._pbf = e1, this._geometry = -1, this._keys = n, this._values = i, e1.readFields(lc, this, t1);
            }
            loadGeometry() {
                const e1 = this._pbf;
                e1.pos = this._geometry;
                const t1 = e1.readVarint() + e1.pos, r = [];
                let n, i = 1, s = 0, a = 0, o = 0;
                for(; e1.pos < t1;){
                    if (s <= 0) {
                        const t1 = e1.readVarint();
                        i = 7 & t1, s = t1 >> 3;
                    }
                    if (s--, 1 === i || 2 === i) a += e1.readSVarint(), o += e1.readSVarint(), 1 === i && (n && r.push(n), n = []), n && n.push(new Me(a, o));
                    else {
                        if (7 !== i) throw new Error(`unknown command ${i}`);
                        n && n.push(n[0].clone());
                    }
                }
                return n && r.push(n), r;
            }
            bbox() {
                const e1 = this._pbf;
                e1.pos = this._geometry;
                const t1 = e1.readVarint() + e1.pos;
                let r = 1, n = 0, i = 0, s = 0, a = 1 / 0, o = -1 / 0, l = 1 / 0, u = -1 / 0;
                for(; e1.pos < t1;){
                    if (n <= 0) {
                        const t1 = e1.readVarint();
                        r = 7 & t1, n = t1 >> 3;
                    }
                    if (n--, 1 === r || 2 === r) i += e1.readSVarint(), s += e1.readSVarint(), i < a && (a = i), i > o && (o = i), s < l && (l = s), s > u && (u = s);
                    else if (7 !== r) throw new Error(`unknown command ${r}`);
                }
                return [
                    a,
                    l,
                    o,
                    u
                ];
            }
            toGeoJSON(e1, t1, r) {
                const n = this.extent * Math.pow(2, r), i = this.extent * e1, s = this.extent * t1, a = this.loadGeometry();
                function o(e1) {
                    return [
                        360 * (e1.x + i) / n - 180,
                        360 / Math.PI * Math.atan(Math.exp((1 - 2 * (e1.y + s) / n) * Math.PI)) - 90
                    ];
                }
                function l(e1) {
                    return e1.map(o);
                }
                let u;
                if (1 === this.type) {
                    const e1 = [];
                    for (const t1 of a)e1.push(t1[0]);
                    const t1 = l(e1);
                    u = 1 === e1.length ? {
                        type: "Point",
                        coordinates: t1[0]
                    } : {
                        type: "MultiPoint",
                        coordinates: t1
                    };
                } else if (2 === this.type) {
                    const e1 = a.map(l);
                    u = 1 === e1.length ? {
                        type: "LineString",
                        coordinates: e1[0]
                    } : {
                        type: "MultiLineString",
                        coordinates: e1
                    };
                } else {
                    if (3 !== this.type) throw new Error("unknown feature type");
                    {
                        const e1 = function(e1) {
                            const t1 = e1.length;
                            if (t1 <= 1) return [
                                e1
                            ];
                            const r = [];
                            let n, i;
                            for(let s = 0; s < t1; s++){
                                const t1 = uc(e1[s]);
                                0 !== t1 && (void 0 === i && (i = t1 < 0), i === t1 < 0 ? (n && r.push(n), n = [
                                    e1[s]
                                ]) : n && n.push(e1[s]));
                            }
                            return n && r.push(n), r;
                        }(a), t1 = [];
                        for (const r of e1)t1.push(r.map(l));
                        u = 1 === t1.length ? {
                            type: "Polygon",
                            coordinates: t1[0]
                        } : {
                            type: "MultiPolygon",
                            coordinates: t1
                        };
                    }
                }
                const c = {
                    type: "Feature",
                    geometry: u,
                    properties: this.properties
                };
                return null != this.id && (c.id = this.id), c;
            }
        }
        function lc(e1, t1, r) {
            1 === e1 ? t1.id = r.readVarint() : 2 === e1 ? function(e1, t1) {
                const r = e1.readVarint() + e1.pos;
                for(; e1.pos < r;){
                    const r = t1._keys[e1.readVarint()], n = t1._values[e1.readVarint()];
                    t1.properties[r] = n;
                }
            }(r, t1) : 3 === e1 ? t1.type = r.readVarint() : 4 === e1 && (t1._geometry = r.pos);
        }
        function uc(e1) {
            let t1 = 0;
            for(let r, n, i = 0, s = e1.length, a = s - 1; i < s; a = i++)r = e1[i], n = e1[a], t1 += (n.x - r.x) * (r.y + n.y);
            return t1;
        }
        oc.types = [
            "Unknown",
            "Point",
            "LineString",
            "Polygon"
        ];
        class cc {
            constructor(e1, t1){
                this.version = 1, this.name = "", this.extent = 4096, this.length = 0, this._pbf = e1, this._keys = [], this._values = [], this._features = [], e1.readFields(hc, this, t1), this.length = this._features.length;
            }
            feature(e1) {
                if (e1 < 0 || e1 >= this._features.length) throw new Error("feature index out of bounds");
                this._pbf.pos = this._features[e1];
                const t1 = this._pbf.readVarint() + this._pbf.pos;
                return new oc(this._pbf, t1, this.extent, this._keys, this._values);
            }
        }
        function hc(e1, t1, r) {
            15 === e1 ? t1.version = r.readVarint() : 1 === e1 ? t1.name = r.readString() : 5 === e1 ? t1.extent = r.readVarint() : 2 === e1 ? t1._features.push(r.pos) : 3 === e1 ? t1._keys.push(r.readString()) : 4 === e1 && t1._values.push(function(e1) {
                let t1 = null;
                const r = e1.readVarint() + e1.pos;
                for(; e1.pos < r;){
                    const r = e1.readVarint() >> 3;
                    t1 = 1 === r ? e1.readString() : 2 === r ? e1.readFloat() : 3 === r ? e1.readDouble() : 4 === r ? e1.readVarint64() : 5 === r ? e1.readVarint() : 6 === r ? e1.readSVarint() : 7 === r ? e1.readBoolean() : null;
                }
                if (null == t1) throw new Error("unknown feature value");
                return t1;
            }(r));
        }
        class dc {
            constructor(e1, t1){
                this.layers = e1.readFields(pc, {}, t1);
            }
        }
        function pc(e1, t1, r) {
            if (3 === e1) {
                const e1 = new cc(r, r.readVarint() + r.pos);
                e1.length && (t1[e1.name] = e1);
            }
        }
        const fc = "3d_elevation_id", mc = "level";
        class yc {
            constructor(){
                this._valid = !1;
            }
            reset(e1) {
                return this.feature = e1, this._valid = !0, this._geometry = e1.loadGeometry(), 0 !== this._geometry.length && 0 !== this._geometry[0].length || (this._valid = !1), this;
            }
            geometry(e1, t1) {
                return this._valid && e1(t1(this._geometry)), this;
            }
            require(e1, t1, r) {
                return this.get(e1, !0, t1, r);
            }
            optional(e1, t1, r) {
                return this.get(e1, !1, t1, r);
            }
            success() {
                return this._valid;
            }
            get(e1, t1, r, n) {
                const i = this.feature.properties.hasOwnProperty(e1) ? +this.feature.properties[e1] : void 0;
                return this._valid && void 0 !== i && !Number.isNaN(i) ? r(n ? n(i) : i) : t1 && (this._valid = !1), this;
            }
        }
        class gc {
            constructor(e1, t1){
                this.featureFunc = e1, this.vertexFunc = t1;
            }
            parseFeature(e1, t1, r) {
                return this.featureFunc(e1, t1, r);
            }
            parseVertex(e1, t1, r) {
                return this.vertexFunc(e1, t1, r);
            }
        }
        const xc = new gc((e1, t1, r)=>e1.reset(t1).require(fc, (e1)=>{
                r.id = e1;
            }).optional("fixed_height_relative", (e1)=>{
                r.constantHeight = e1;
            }, bc.decodeRelativeHeight).geometry((e1)=>{
                r.bounds = e1;
            }, An).success(), (e1, t1, r)=>e1.reset(t1).require(fc, (e1)=>{
                r.id = e1;
            }).require("elevation_idx", (e1)=>{
                r.idx = e1;
            }).require("extent", (e1)=>{
                r.extent = e1;
            }).require("height_relative", (e1)=>{
                r.height = e1;
            }, bc.decodeRelativeHeight).geometry((e1)=>{
                r.position = e1;
            }, bc.getPoint).success()), vc = new gc((e1, t1, r)=>e1.reset(t1).require(fc, (e1)=>{
                r.id = e1;
            }).optional("fixed_height", (e1)=>{
                r.constantHeight = e1;
            }, bc.decodeMetricHeight).geometry((e1)=>{
                r.bounds = e1;
            }, An).success(), (e1, t1, r)=>e1.reset(t1).require(fc, (e1)=>{
                r.id = e1;
            }).require("elevation_idx", (e1)=>{
                r.idx = e1;
            }).require("extent", (e1)=>{
                r.extent = e1;
            }).require("height", (e1)=>{
                r.height = e1;
            }, bc.decodeMetricHeight).geometry((e1)=>{
                r.position = e1;
            }, bc.getPoint).success());
        class bc {
            static getPoint(e1) {
                return he(e1[0][0].x, e1[0][0].y);
            }
            static decodeRelativeHeight(e1) {
                return 1e-4 * e1 * 5;
            }
            static decodeMetricHeight(e1) {
                return 1e-4 * e1;
            }
            static getVersionSchema(e1) {
                return e1 ? "1.0.1" === e1 ? vc : void 0 : xc;
            }
            static parse(e1) {
                const t1 = [], r = [], n = e1.length, i = new yc;
                for(let s = 0; s < n; s++){
                    const n = e1.feature(s), a = n.properties.version, o = bc.getVersionSchema(a);
                    if (void 0 === o) {
                        Ze(`Unknown elevation feature version number ${a || "(unknown)"}`);
                        continue;
                    }
                    const l = n.properties.type;
                    if (!l) continue;
                    const u = oc.types[n.type];
                    if ("Point" === u && "curve_point" === l) {
                        const e1 = {};
                        o.parseVertex(i, n, e1) && t1.push(e1);
                    } else if ("Polygon" === u && "curve_meta" === l) {
                        const e1 = {};
                        o.parseFeature(i, n, e1) && r.push(e1);
                    }
                }
                return {
                    vertices: t1,
                    features: r
                };
            }
        }
        class wc {
            constructor(e1, t1){
                this.pos = e1, this.dir = t1;
            }
            intersectsPlane(e1, t1, r) {
                const n = xe(t1, this.dir);
                if (Math.abs(n) < 1e-6) return !1;
                const i = ((e1[0] - this.pos[0]) * t1[0] + (e1[1] - this.pos[1]) * t1[1]) / n;
                return r[0] = this.pos[0] + this.dir[0] * i, r[1] = this.pos[1] + this.dir[1] * i, !0;
            }
        }
        class _c {
            constructor(e1, t1){
                this.pos = e1, this.dir = t1;
            }
            intersectsPlane(e1, t1, r) {
                const n = O(t1, this.dir);
                if (Math.abs(n) < 1e-6) return !1;
                const i = ((e1[0] - this.pos[0]) * t1[0] + (e1[1] - this.pos[1]) * t1[1] + (e1[2] - this.pos[2]) * t1[2]) / n;
                return r[0] = this.pos[0] + this.dir[0] * i, r[1] = this.pos[1] + this.dir[1] * i, r[2] = this.pos[2] + this.dir[2] * i, !0;
            }
            closestPointOnSphere(e1, r, n) {
                if (function(e1, r) {
                    var n = e1[0], i = e1[1], s = e1[2], a = r[0], o = r[1], l = r[2];
                    return Math.abs(n - a) <= t1 * Math.max(1, Math.abs(n), Math.abs(a)) && Math.abs(i - o) <= t1 * Math.max(1, Math.abs(i), Math.abs(o)) && Math.abs(s - l) <= t1 * Math.max(1, Math.abs(s), Math.abs(l));
                }(this.pos, e1) || 0 === r) return n[0] = n[1] = n[2] = 0, !1;
                const [i, s, a] = this.dir, o = this.pos[0] - e1[0], l = this.pos[1] - e1[1], u = this.pos[2] - e1[2], c = i * i + s * s + a * a, h = 2 * (o * i + l * s + u * a), d = h * h - 4 * c * (o * o + l * l + u * u - r * r);
                if (d < 0) {
                    const e1 = Math.max(-h / 2, 0), t1 = o + i * e1, c = l + s * e1, d = u + a * e1, p = Math.hypot(t1, c, d);
                    return n[0] = t1 * r / p, n[1] = c * r / p, n[2] = d * r / p, !1;
                }
                {
                    const e1 = (-h - Math.sqrt(d)) / (2 * c);
                    if (e1 < 0) {
                        const e1 = Math.hypot(o, l, u);
                        return n[0] = o * r / e1, n[1] = l * r / e1, n[2] = u * r / e1, !1;
                    }
                    return n[0] = o + i * e1, n[1] = l + s * e1, n[2] = u + a * e1, !0;
                }
            }
        }
        class Ac {
            constructor(e1, t1, r, n, i){
                this.TL = e1, this.TR = t1, this.BR = r, this.BL = n, this.horizon = i;
            }
            static fromInvProjectionMatrix(e1, t1, r) {
                const n = [
                    -1,
                    1,
                    1
                ], i = [
                    1,
                    1,
                    1
                ], s = [
                    1,
                    -1,
                    1
                ], a = [
                    -1,
                    -1,
                    1
                ], o = j(n, n, e1), l = j(i, i, e1), u = j(s, s, e1), c = j(a, a, e1);
                return new Ac(o, l, u, c, t1 / r);
            }
        }
        function Ic(e1, t1, r) {
            let n = 1 / 0, i = -1 / 0;
            const s = [];
            for (const a of e1){
                X(s, a, t1);
                const e1 = O(s, r);
                n = Math.min(n, e1), i = Math.max(i, e1);
            }
            return [
                n,
                i
            ];
        }
        function Mc(e1, t1) {
            let r = !0;
            for(let n = 0; n < e1.planes.length; n++){
                const i = e1.planes[n];
                let s = 0;
                for(let e1 = 0; e1 < t1.length; e1++)s += +(O(i, t1[e1]) + i[3] >= 0);
                if (0 === s) return 0;
                s !== t1.length && (r = !1);
            }
            return r ? 2 : 1;
        }
        function Bc(e1, t1) {
            for (const r of e1.projections){
                const n = Ic(t1, e1.points[0], r.axis);
                if (r.projection[1] < n[0] || r.projection[0] > n[1]) return 0;
            }
            return 1;
        }
        function Sc(e1, t1) {
            let r = 0;
            const n = [
                0,
                0,
                0,
                0
            ];
            for(let i = 0; i < e1.length; i++)n[0] = e1[i][0], n[1] = e1[i][1], n[2] = e1[i][2], n[3] = 1, Q(n, t1) >= 0 && r++;
            return r;
        }
        class Pc {
            constructor(e1, t1){
                this.points = e1 || new Array(8).fill([
                    0,
                    0,
                    0
                ]), this.planes = t1 || new Array(6).fill([
                    0,
                    0,
                    0,
                    0
                ]), this.bounds = Tc.fromPoints(this.points), this.projections = [], this.frustumEdges = [
                    X([], this.points[2], this.points[3]),
                    X([], this.points[0], this.points[3]),
                    X([], this.points[4], this.points[0]),
                    X([], this.points[5], this.points[1]),
                    X([], this.points[6], this.points[2]),
                    X([], this.points[7], this.points[3])
                ];
                for (const e1 of this.frustumEdges){
                    const t1 = [
                        0,
                        -e1[2],
                        e1[1]
                    ], r = [
                        e1[2],
                        0,
                        -e1[0]
                    ];
                    this.projections.push({
                        axis: t1,
                        projection: Ic(this.points, this.points[0], t1)
                    }), this.projections.push({
                        axis: r,
                        projection: Ic(this.points, this.points[0], r)
                    });
                }
            }
            static fromInvProjectionMatrix(e1, t1, r, n) {
                const i = Math.pow(2, r), s = [
                    [
                        -1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        1,
                        -1,
                        1
                    ],
                    [
                        1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        -1,
                        1
                    ],
                    [
                        -1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        1,
                        1,
                        1
                    ],
                    [
                        1,
                        -1,
                        1,
                        1
                    ],
                    [
                        -1,
                        -1,
                        1,
                        1
                    ]
                ].map((r)=>{
                    const s = ee([], r, e1), a = 1 / s[3] / t1 * i;
                    var o, l, u;
                    return (o = s)[0] = (l = s)[0] * (u = [
                        a,
                        a,
                        n ? 1 / s[3] : a,
                        a
                    ])[0], o[1] = l[1] * u[1], o[2] = l[2] * u[2], o[3] = l[3] * u[3], o;
                }), a = [
                    [
                        0,
                        1,
                        2
                    ],
                    [
                        6,
                        5,
                        4
                    ],
                    [
                        0,
                        3,
                        7
                    ],
                    [
                        2,
                        1,
                        5
                    ],
                    [
                        3,
                        2,
                        6
                    ],
                    [
                        0,
                        4,
                        5
                    ]
                ].map((e1)=>{
                    const t1 = L([], U([], X([], s[e1[0]], s[e1[1]]), X([], s[e1[2]], s[e1[1]]))), r = -O(t1, s[e1[1]]);
                    return t1.concat(r);
                }), o = [];
                for(let e1 = 0; e1 < s.length; e1++)o.push([
                    s[e1][0],
                    s[e1][1],
                    s[e1][2]
                ]);
                return new Pc(o, a);
            }
            intersectsPrecise(e1, t1, r) {
                for(let r = 0; r < t1.length; r++)if (!Sc(e1, t1[r])) return 0;
                for(let t1 = 0; t1 < this.planes.length; t1++)if (!Sc(e1, this.planes[t1])) return 0;
                for (const t1 of r)for (const r of this.frustumEdges){
                    const n = U([], t1, r), i = I(n);
                    if (0 === i) continue;
                    V(n, n, 1 / i);
                    const s = Ic(this.points, this.points[0], n), a = Ic(e1, this.points[0], n);
                    if (s[0] > a[1] || a[0] > s[1]) return 0;
                }
                return 1;
            }
            containsPoint(e1) {
                for (const t1 of this.planes){
                    const r = t1[3];
                    if (O([
                        t1[0],
                        t1[1],
                        t1[2]
                    ], e1) + r < 0) return !1;
                }
                return !0;
            }
        }
        class Tc {
            static fromPoints(e1) {
                const t1 = [
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], r = [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ];
                for (const n of e1)z(t1, t1, n), k(r, r, n);
                return new Tc(t1, r);
            }
            static fromTileIdAndHeight(e1, t1, r) {
                const n = 1 << e1.canonical.z, i = e1.canonical.x, s = e1.canonical.y;
                return new Tc([
                    i / n,
                    s / n,
                    t1
                ], [
                    (i + 1) / n,
                    (s + 1) / n,
                    r
                ]);
            }
            static applyTransform(e1, t1) {
                const r = e1.getCorners();
                for(let e1 = 0; e1 < r.length; ++e1)j(r[e1], r[e1], t1);
                return Tc.fromPoints(r);
            }
            static applyTransformFast(e1, t1) {
                const r = [
                    t1[12],
                    t1[13],
                    t1[14]
                ], n = [
                    ...r
                ];
                for(let i = 0; i < 3; i++)for(let s = 0; s < 3; s++){
                    const a = t1[4 * s + i], o = a * e1.min[s], l = a * e1.max[s];
                    r[i] += Math.min(o, l), n[i] += Math.max(o, l);
                }
                return new Tc(r, n);
            }
            static projectAabbCorners(e1, t1) {
                const r = e1.getCorners();
                for(let e1 = 0; e1 < r.length; ++e1)j(r[e1], r[e1], t1);
                return r;
            }
            constructor(e1, t1){
                this.min = e1, this.max = t1, this.center = V([], S([], this.min, this.max), .5);
            }
            quadrant(e1) {
                const t1 = [
                    e1 % 2 == 0,
                    e1 < 2
                ], r = A(this.min), n = A(this.max);
                for(let e1 = 0; e1 < t1.length; e1++)r[e1] = t1[e1] ? this.min[e1] : this.center[e1], n[e1] = t1[e1] ? this.center[e1] : this.max[e1];
                return n[2] = this.max[2], new Tc(r, n);
            }
            distanceX(e1) {
                return Math.max(Math.min(this.max[0], e1[0]), this.min[0]) - e1[0];
            }
            distanceY(e1) {
                return Math.max(Math.min(this.max[1], e1[1]), this.min[1]) - e1[1];
            }
            distanceZ(e1) {
                return Math.max(Math.min(this.max[2], e1[2]), this.min[2]) - e1[2];
            }
            getCorners() {
                const e1 = this.min, t1 = this.max;
                return [
                    [
                        e1[0],
                        e1[1],
                        e1[2]
                    ],
                    [
                        t1[0],
                        e1[1],
                        e1[2]
                    ],
                    [
                        t1[0],
                        t1[1],
                        e1[2]
                    ],
                    [
                        e1[0],
                        t1[1],
                        e1[2]
                    ],
                    [
                        e1[0],
                        e1[1],
                        t1[2]
                    ],
                    [
                        t1[0],
                        e1[1],
                        t1[2]
                    ],
                    [
                        t1[0],
                        t1[1],
                        t1[2]
                    ],
                    [
                        e1[0],
                        t1[1],
                        t1[2]
                    ]
                ];
            }
            intersects(e1) {
                return this.intersectsAabb(e1.bounds) ? Mc(e1, this.getCorners()) : 0;
            }
            intersectsFlat(e1) {
                return this.intersectsAabb(e1.bounds) ? Mc(e1, [
                    [
                        this.min[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        0
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        0
                    ]
                ]) : 0;
            }
            intersectsPrecise(e1, t1) {
                return t1 || this.intersects(e1) ? Bc(e1, this.getCorners()) : 0;
            }
            intersectsPreciseFlat(e1, t1) {
                return t1 || this.intersectsFlat(e1) ? Bc(e1, [
                    [
                        this.min[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.min[1],
                        0
                    ],
                    [
                        this.max[0],
                        this.max[1],
                        0
                    ],
                    [
                        this.min[0],
                        this.max[1],
                        0
                    ]
                ]) : 0;
            }
            intersectsAabb(e1) {
                for(let t1 = 0; t1 < 3; ++t1)if (this.min[t1] > e1.max[t1] || e1.min[t1] > this.max[t1]) return !1;
                return !0;
            }
            intersectsAabbXY(e1) {
                return !(this.min[0] > e1.max[0] || e1.min[0] > this.max[0] || this.min[1] > e1.max[1] || e1.min[1] > this.max[1]);
            }
            encapsulate(e1) {
                for(let t1 = 0; t1 < 3; t1++)this.min[t1] = Math.min(this.min[t1], e1.min[t1]), this.max[t1] = Math.max(this.max[t1], e1.max[t1]);
            }
            encapsulatePoint(e1) {
                for(let t1 = 0; t1 < 3; t1++)this.min[t1] = Math.min(this.min[t1], e1[t1]), this.max[t1] = Math.max(this.max[t1], e1[t1]);
            }
            closestPoint(e1) {
                return [
                    Math.max(Math.min(this.max[0], e1[0]), this.min[0]),
                    Math.max(Math.min(this.max[1], e1[1]), this.min[1]),
                    Math.max(Math.min(this.max[2], e1[2]), this.min[2])
                ];
            }
        }
        ra(Tc, "Aabb");
        class zc {
            constructor(e1, t1){
                this.feature = e1, this.metersToTile = t1, this.index = 0;
            }
            get() {
                const e1 = this.feature.vertices[this.index], t1 = this.feature.vertexProps[this.index].dir, r = t1[1], n = -t1[0], i = (e1.extent + 1) * this.metersToTile;
                return [
                    new Me(Math.trunc(e1.position[0] + r * i), Math.trunc(e1.position[1] + n * i)),
                    new Me(Math.trunc(e1.position[0] - r * i), Math.trunc(e1.position[1] - n * i))
                ];
            }
            next() {
                this.index++;
            }
            valid() {
                return this.index < this.feature.vertices.length;
            }
        }
        class kc {
            constructor(e1, t1, r, n, i, s){
                if (this.vertices = new Array, this.vertexProps = new Array, this.edges = new Array, this.edgeProps = new Array, this._tmpVec2 = [
                    ce(),
                    ce(),
                    ce(),
                    ce(),
                    ce(),
                    ce(),
                    ce()
                ], this.id = e1, this.heightRange = {
                    min: r,
                    max: r
                }, this.safeArea = t1, this.constantHeight = r, null == this.constantHeight && (null != this.constantHeight || 0 !== n.length)) {
                    this.vertices = n, this.edges = i, this.edges = this.edges.filter((e1)=>{
                        var t1, r;
                        return e1.a < this.vertices.length && e1.b < this.vertices.length && !((t1 = this.vertices[e1.a].position)[0] === (r = this.vertices[e1.b].position)[0] && t1[1] === r[1]);
                    }), this.heightRange = {
                        min: Number.POSITIVE_INFINITY,
                        max: Number.NEGATIVE_INFINITY
                    };
                    for (const e1 of this.vertices)this.vertexProps.push({
                        dir: he(0, 0)
                    }), this.heightRange.min = Math.min(this.heightRange.min, e1.height), this.heightRange.max = Math.max(this.heightRange.max, e1.height);
                    for (const e1 of this.edges){
                        const t1 = this.vertices[e1.a].position, r = this.vertices[e1.b].position, n = fe(ce(), r, t1), i = ye(n), s = me(ce(), n, 1 / i);
                        this.edgeProps.push({
                            vec: n,
                            dir: s,
                            len: i
                        });
                        const a = this.vertexProps[e1.a].dir, o = this.vertexProps[e1.b].dir;
                        pe(a, a, s), pe(o, o, s);
                    }
                    for (const e1 of this.vertexProps)0 === e1.dir[0] && 0 === e1.dir[1] || ge(e1.dir, e1.dir);
                    this.tessellate(s);
                }
            }
            pointElevation(e1) {
                if (null != this.constantHeight) return this.constantHeight;
                const t1 = this.getClosestEdge(e1);
                if (null == t1) return 0;
                const [r, n] = t1;
                return yr(this.vertices[this.edges[r].a].height, this.vertices[this.edges[r].b].height, n);
            }
            computeSlopeNormal(e1, t1) {
                const r = this.getClosestEdge(e1);
                if (!r) return M(0, 0, 1);
                const n = r[0], i = this.edges[n], s = this.edgeProps[n].vec, a = M(s[0], s[1], (this.vertices[i.b].height - this.vertices[i.a].height) * t1), o = M(a[1], -a[0], 0);
                U(o, o, a);
                const l = I(o);
                return l > 0 ? V(o, o, 1 / l) : B(o, 0, 0, 1);
            }
            getSafeArea() {
                return this.safeArea;
            }
            isTunnel() {
                return this.heightRange.max <= -5;
            }
            getClosestEdge(e1) {
                if (0 === this.edges.length) return;
                let t1 = 0, r = Number.POSITIVE_INFINITY, n = 0;
                const [i, s, a, o, l, u, c] = this._tmpVec2;
                de(c, e1.x, e1.y);
                const h = new wc(c, null);
                for(let e1 = 0; e1 < this.edges.length; e1++){
                    const d = this.edges[e1], p = this.edgeProps[e1].dir;
                    h.dir = p;
                    const f = this.vertices[d.a].position, m = this.vertices[d.b].position, y = h.intersectsPlane(f, this.vertexProps[d.a].dir, i), g = h.intersectsPlane(m, this.vertexProps[d.b].dir, s);
                    if (!y || !g) continue;
                    fe(a, s, i), fe(o, c, i);
                    const x = xe(a, a), v = x > 0 ? xe(o, a) / x : 0, b = Ee(v, 0, 1), w = Math.abs((v - b) * this.edgeProps[e1].len);
                    fe(l, c, f), de(u, p[1], -p[0]);
                    const _ = w + Math.abs(xe(l, u));
                    _ < r && (t1 = e1, r = _, n = b);
                }
                return [
                    t1,
                    n
                ];
            }
            tessellate(e1) {
                const t1 = _(), r = _(), n = _(), i = _();
                for(let s = this.edges.length - 1; s >= 0; --s){
                    const a = this.edges[s].a, o = this.edges[s].b, { position: l, height: u, extent: c } = this.vertices[a], { position: h, height: d, extent: p } = this.vertices[o], f = this.vertexProps[a].dir, m = this.vertexProps[o].dir;
                    if (B(t1, l[0] / e1, l[1] / e1, u), B(r, h[0] / e1, h[1] / e1, d), B(n, f[1], -f[0], 0), V(n, n, c), B(i, m[1], -m[0], 0), V(i, i, p), this.distSqLines(M(t1[0] + .5 * n[0], t1[1] + .5 * n[1], t1[2] + .5 * n[2]), M(r[0] - .5 * i[0], r[1] - .5 * i[1], r[2] - .5 * i[2]), M(t1[0] - .5 * n[0], t1[1] - .5 * n[1], t1[2] - .5 * n[2]), M(r[0] + .5 * i[0], r[1] + .5 * i[1], r[2] + .5 * i[2])) <= .0025000000000000005) continue;
                    const y = this.vertices.length, g = pe(ce(), l, h);
                    this.vertices.push({
                        position: me(g, g, .5),
                        height: .5 * (u + d),
                        extent: .5 * (c + p)
                    });
                    const x = pe(ce(), f, m);
                    this.vertexProps.push({
                        dir: ge(x, x)
                    }), this.edges.splice(s, 1), this.edgeProps.splice(s, 1), this.edges.push({
                        a: a,
                        b: y
                    }), this.edges.push({
                        a: y,
                        b: o
                    });
                    const v = fe(ce(), this.vertices[y].position, l), b = ye(v), w = {
                        vec: v,
                        dir: me(ce(), v, 1 / b),
                        len: b
                    };
                    this.edgeProps.push(w), this.edgeProps.push(w);
                }
            }
            distSqLines(e1, t1, r, n) {
                const i = P(_(), t1, e1), s = P(_(), n, r), a = P(_(), e1, r), o = O(i, i), l = O(i, s), u = O(i, a), c = O(s, s), h = O(s, a), d = o * c - l * l;
                if (0 === d) return E(N(i, r, n, O(a, s) / O(s, s)), e1);
                const p = (o * h - l * u) / d;
                return E(N(i, e1, t1, (l * h - u * c) / d), N(s, r, n, p));
            }
        }
        class Vc {
            static parseFrom(e1, t1) {
                const r = bc.parse(e1);
                if (!r) return [];
                let { vertices: n, features: i } = r;
                const s = 1 / Yu(t1);
                i.sort((e1, t1)=>e1.id - t1.id), n.sort((e1, t1)=>e1.id - t1.id || e1.idx - t1.idx), n = n.filter((e1, t1, r)=>t1 === r.findIndex((t1)=>t1.id === e1.id && t1.idx === e1.idx));
                const a = new Array;
                let o = 0;
                const l = n.length;
                for (const e1 of i){
                    if (e1.constantHeight) {
                        a.push(new kc(e1.id, e1.bounds, e1.constantHeight));
                        continue;
                    }
                    for(; o !== l && n[o].id < e1.id;)o++;
                    if (o === l || n[o].id !== e1.id) continue;
                    const t1 = new Array, r = new Array, i = o;
                    for(; o !== l && n[o].id === e1.id;){
                        const e1 = n[o];
                        if (t1.push({
                            position: e1.position,
                            height: e1.height,
                            extent: e1.extent
                        }), o !== i && n[o - 1].idx === e1.idx - 1) {
                            const e1 = o - i;
                            r.push({
                                a: e1 - 1,
                                b: e1
                            });
                        }
                        o++;
                    }
                    a.push(new kc(e1.id, e1.bounds, void 0, t1, r, s));
                }
                return a;
            }
            static getElevationFeature(e1, t1) {
                if (!t1) return;
                const r = +e1.properties[fc];
                return Number.isNaN(r) ? void 0 : t1.find((e1)=>e1.id === r);
            }
        }
        class Fc {
            constructor(e1, t1){
                this.zScale = 1, this.xOffset = 0, this.yOffset = 0, e1.equals(t1) || (this.zScale = Math.pow(2, t1.z - e1.z), this.xOffset = (e1.x * this.zScale - t1.x) * qn, this.yOffset = (e1.y * this.zScale - t1.y) * qn);
            }
            constantElevation(e1, t1) {
                if (null != e1.constantHeight) return this.computeBiasedHeight(e1.constantHeight, t1);
            }
            pointElevation(e1, t1, r) {
                const n = this.constantElevation(t1, r);
                return null != n ? n : (e1.x = e1.x * this.zScale + this.xOffset, e1.y = e1.y * this.zScale + this.yOffset, this.computeBiasedHeight(t1.pointElevation(e1), r));
            }
            computeBiasedHeight(e1, t1) {
                return t1 <= 0 ? e1 : e1 + t1 * Ce(0, t1, e1 >= 0 ? e1 : Math.abs(.5 * e1));
            }
        }
        ra(kc, "ElevationFeature");
        class Dc {
            constructor(e1){
                this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.hasPattern = !1, this.projection = e1.projection, this.layoutVertexArray = new Xo, this.indexArray = new ml, this.segments = new Hl, this.programConfigurations = new _u(e1.layers, {
                    zoom: e1.zoom,
                    lut: e1.lut
                }), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.elevationMode = this.layers[0].layout.get("circle-elevation-reference"), this.hasElevation = !1, "none" !== this.elevationMode && (this.elevatedLayoutVertexArray = new Yo), this.worldview = e1.worldview, this.hasAppearances = null;
            }
            updateFootprints(e1, t1) {}
            updateAppearances(e1, t1, r, n) {
                return {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
            }
            populate(e1, t1, r, n) {
                const i = this.layers[0], s = [];
                let a = null;
                "circle" === i.type && (a = i.layout.get("circle-sort-key"));
                for (const { feature: i, id: o, index: l, sourceLayerIndex: u } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, c = ac(i, e1);
                    if (!this.layers[0]._featureFilter.filter(new to(this.zoom, {
                        worldview: this.worldview,
                        activeFloors: t1.activeFloors
                    }), c, r)) continue;
                    const h = a ? a.evaluate(c, {}, r) : void 0, d = {
                        id: o,
                        properties: i.properties,
                        type: i.type,
                        sourceLayerIndex: u,
                        index: l,
                        geometry: e1 ? c.geometry : sc(i, r, n),
                        patterns: {},
                        sortKey: h
                    };
                    s.push(d);
                }
                a && s.sort((e1, t1)=>e1.sortKey - t1.sortKey);
                let o = null;
                "globe" === n.projection.name && (this.globeExtVertexArray = new sl, o = n.projection);
                for (const n of s){
                    const { geometry: i, index: s, sourceLayerIndex: a } = n, l = e1[s].feature;
                    this.addFeature(n, i, s, t1.availableImages, r, o, t1.brightness, t1.elevationFeatures), t1.featureIndex.insert(l, i, s, a, this.index);
                }
                this.hasElevation || (this.elevatedLayoutVertexArray = void 0);
            }
            update(e1, t1, r, n, i, s, a) {
                this.programConfigurations.updatePaintArrays(e1, t1, i, r, n, s, a, this.worldview);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(e1) {
                this.uploaded || (this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, Gl.members), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.globeExtVertexArray && (this.globeExtVertexBuffer = e1.createVertexBuffer(this.globeExtVertexArray, ql.members)), this.elevatedLayoutVertexArray && (this.elevatedLayoutVertexBuffer = e1.createVertexBuffer(this.elevatedLayoutVertexArray, $l.members))), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy(), this.elevatedLayoutVertexBuffer && this.elevatedLayoutVertexBuffer.destroy());
            }
            addFeature(e1, t1, r, n, i, s, a, o) {
                let l;
                "none" !== this.elevationMode && (l = Vc.getElevationFeature(e1, o));
                for (const r of t1)for (const t1 of r){
                    const r = t1.x, n = t1.y;
                    if (r < 0 || r >= qn || n < 0 || n >= qn) continue;
                    if (s) {
                        const e1 = s.projectTilePoint(r, n, i), t1 = s.upVector(i, r, n);
                        this.addGlobeExtVertex(e1, t1), this.addGlobeExtVertex(e1, t1), this.addGlobeExtVertex(e1, t1), this.addGlobeExtVertex(e1, t1);
                    }
                    const a = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray, e1.sortKey), o = a.vertexLength;
                    if (this.addCircleVertex(r, n, -1, -1), this.addCircleVertex(r, n, 1, -1), this.addCircleVertex(r, n, 1, 1), this.addCircleVertex(r, n, -1, 1), "none" !== this.elevationMode) {
                        const e1 = l ? l.pointElevation(new Me(r, n)) : 0;
                        this.hasElevation = this.hasElevation || 0 !== e1;
                        for(let t1 = 0; t1 < 4; t1++)this.elevatedLayoutVertexArray.emplaceBack(e1);
                    }
                    this.indexArray.emplaceBack(o, o + 1, o + 2), this.indexArray.emplaceBack(o, o + 2, o + 3), a.vertexLength += 4, a.primitiveLength += 2;
                }
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e1, r, {}, n, i, a, void 0, this.worldview);
            }
            addCircleVertex(e1, t1, r, n) {
                this.layoutVertexArray.emplaceBack(2 * e1 + (r + 1) / 2, 2 * t1 + (n + 1) / 2);
            }
            addGlobeExtVertex(e1, t1) {
                const r = 16384;
                this.globeExtVertexArray.emplaceBack(e1.x, e1.y, e1.z, t1[0] * r, t1[1] * r, t1[2] * r);
            }
        }
        function Ec(e1, t1) {
            for(let r = 0; r < e1.length; r++)if (Hc(t1, e1[r])) return !0;
            for(let r = 0; r < t1.length; r++)if (Hc(e1, t1[r])) return !0;
            return !!Oc(e1, t1);
        }
        function Cc(e1, t1, r) {
            return !!Hc(e1, t1) || !!Gc(t1, e1, r);
        }
        function Rc(e1, t1) {
            if (1 === e1.length) return qc(t1, e1[0]);
            for(let r = 0; r < t1.length; r++){
                const n = t1[r];
                for(let t1 = 0; t1 < n.length; t1++)if (Hc(e1, n[t1])) return !0;
            }
            for(let r = 0; r < e1.length; r++)if (qc(t1, e1[r])) return !0;
            for(let r = 0; r < t1.length; r++)if (Oc(e1, t1[r])) return !0;
            return !1;
        }
        function Lc(e1, t1, r) {
            if (e1.length > 1) {
                if (Oc(e1, t1)) return !0;
                for(let n = 0; n < t1.length; n++)if (Gc(t1[n], e1, r)) return !0;
            }
            for(let n = 0; n < e1.length; n++)if (Gc(e1[n], t1, r)) return !0;
            return !1;
        }
        function Oc(e1, t1) {
            if (0 === e1.length || 0 === t1.length) return !1;
            for(let r = 0; r < e1.length - 1; r++){
                const n = e1[r], i = e1[r + 1];
                for(let e1 = 0; e1 < t1.length - 1; e1++)if (Uc(n, i, t1[e1], t1[e1 + 1])) return !0;
            }
            return !1;
        }
        function Uc(e1, t1, r, n) {
            return We(e1, r, n) !== We(t1, r, n) && We(e1, t1, r) !== We(e1, t1, n);
        }
        function Nc(e1, t1, r) {
            return (e1.x - r.x) * (t1.y - r.y) - (e1.y - r.y) * (t1.x - r.x);
        }
        function jc(e1, t1, r, n) {
            const i = Nc(e1, t1, n), s = Nc(e1, t1, r);
            if (Math.sign(i) === Math.sign(s)) return;
            const a = Nc(r, n, e1), o = a + s - i;
            return Math.sign(a) !== Math.sign(o) ? [
                a / (a - o),
                s / (s - i)
            ] : void 0;
        }
        function Gc(e1, t1, r) {
            const n = r * r;
            if (1 === t1.length) return e1.distSqr(t1[0]) < n;
            for(let r = 1; r < t1.length; r++)if ($c(e1, t1[r - 1], t1[r]) < n) return !0;
            return !1;
        }
        function $c(e1, t1, r) {
            const n = t1.distSqr(r);
            if (0 === n) return e1.distSqr(t1);
            const i = ((e1.x - t1.x) * (r.x - t1.x) + (e1.y - t1.y) * (r.y - t1.y)) / n;
            return e1.distSqr(i < 0 ? t1 : i > 1 ? r : r.sub(t1)._mult(i)._add(t1));
        }
        function qc(e1, t1) {
            let r, n, i, s = !1;
            for(let a = 0; a < e1.length; a++){
                r = e1[a];
                for(let e1 = 0, a = r.length - 1; e1 < r.length; a = e1++)n = r[e1], i = r[a], n.y > t1.y != i.y > t1.y && t1.x < (i.x - n.x) * (t1.y - n.y) / (i.y - n.y) + n.x && (s = !s);
            }
            return s;
        }
        function Hc(e1, t1) {
            let r = !1;
            for(let n = 0, i = e1.length - 1; n < e1.length; i = n++){
                const s = e1[n], a = e1[i];
                s.y > t1.y != a.y > t1.y && t1.x < (a.x - s.x) * (t1.y - s.y) / (a.y - s.y) + s.x && (r = !r);
            }
            return r;
        }
        function Xc(e1, t1, r, n, i) {
            for (const s of e1)if (t1 <= s.x && r <= s.y && n >= s.x && i >= s.y) return !0;
            const s = [
                new Me(t1, r),
                new Me(t1, i),
                new Me(n, i),
                new Me(n, r)
            ];
            if (e1.length > 2) {
                for (const t1 of s)if (Hc(e1, t1)) return !0;
            }
            for(let t1 = 0; t1 < e1.length - 1; t1++)if (Zc(e1[t1], e1[t1 + 1], s)) return !0;
            return !1;
        }
        function Zc(e1, t1, r) {
            const n = r[0], i = r[2];
            if (e1.x < n.x && t1.x < n.x || e1.x > i.x && t1.x > i.x || e1.y < n.y && t1.y < n.y || e1.y > i.y && t1.y > i.y) return !1;
            const s = We(e1, t1, r[0]);
            return s !== We(e1, t1, r[1]) || s !== We(e1, t1, r[2]) || s !== We(e1, t1, r[3]);
        }
        function Wc(e1, t1, r, n, i, s) {
            let a = t1.y - e1.y, o = e1.x - t1.x;
            if (s = s || 0) {
                const e1 = a * a + o * o;
                if (0 === e1) return !0;
                const t1 = Math.sqrt(e1);
                a /= t1, o /= t1;
            }
            return !((r.x - e1.x) * a + (r.y - e1.y) * o - s < 0 || (n.x - e1.x) * a + (n.y - e1.y) * o - s < 0 || (i.x - e1.x) * a + (i.y - e1.y) * o - s < 0);
        }
        function Yc(e1, t1, r, n, i, s, a) {
            return !(Wc(e1, t1, n, i, s, a) || Wc(t1, r, n, i, s, a) || Wc(r, e1, n, i, s, a) || Wc(n, i, e1, t1, r, a) || Wc(i, s, e1, t1, r, a) || Wc(s, n, e1, t1, r, a));
        }
        function Jc(e1, t1, r) {
            const n = t1.paint.get(e1).value;
            return "constant" === n.kind ? n.value : r.programConfigurations.get(t1.id).getMaxValue(e1);
        }
        function Kc(e1) {
            return Math.sqrt(e1[0] * e1[0] + e1[1] * e1[1]);
        }
        function Qc(e1, t1, r, n, i) {
            if (!t1[0] && !t1[1]) return e1;
            const s = Me.convert(t1)._mult(i);
            "viewport" === r && s._rotate(-n);
            const a = [];
            for(let t1 = 0; t1 < e1.length; t1++)a.push(e1[t1].sub(s));
            return a;
        }
        function eh(e1, t1, r, n) {
            const i = Me.convert(e1)._mult(n);
            return "viewport" === t1 && i._rotate(-r), i;
        }
        let th, rh;
        ra(Dc, "CircleBucket", {
            omit: [
                "layers"
            ]
        });
        class nh {
            constructor(e1, t1, r){
                this.z = e1, this.x = t1, this.y = r, this.key = ah(0, e1, e1, t1, r);
            }
            equals(e1) {
                return this.z === e1.z && this.x === e1.x && this.y === e1.y;
            }
            isChildOf(e1) {
                const t1 = this.z - e1.z;
                return 0 === e1.z || e1.z < this.z && e1.x === this.x >> t1 && e1.y === this.y >> t1;
            }
            url(e1, t1) {
                const r = function(e1, t1, r) {
                    const n = 2 ** r, i = 2 * Math.PI * 6378137, s = i * (e1 / n - .5), a = i * (.5 - (t1 + 1) / n);
                    return `${s},${a},${s + i / n},${a + i / n}`;
                }(this.x, this.y, this.z), n = function(e1, t1, r) {
                    let n, i = "";
                    for(let s = e1; s > 0; s--)n = 1 << s - 1, i += (t1 & n ? 1 : 0) + (r & n ? 2 : 0);
                    return i;
                }(this.z, this.x, this.y);
                return e1[(this.x + this.y) % e1.length].replace("{prefix}", (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === t1 ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace("{quadkey}", n).replace("{bbox-epsg-3857}", r);
            }
            toString() {
                return `${this.z}/${this.x}/${this.y}`;
            }
        }
        class ih {
            constructor(e1, t1){
                this.wrap = e1, this.canonical = t1, this.key = ah(e1, t1.z, t1.z, t1.x, t1.y);
            }
        }
        class sh {
            constructor(e1, t1, r, n, i){
                this.overscaledZ = e1, this.wrap = t1, this.canonical = new nh(r, +n, +i), this.key = 0 === t1 && e1 === r ? this.canonical.key : ah(t1, e1, r, n, i);
            }
            equals(e1) {
                return this.overscaledZ === e1.overscaledZ && this.wrap === e1.wrap && this.canonical.equals(e1.canonical);
            }
            scaledTo(e1) {
                const t1 = this.canonical.z - e1;
                return e1 > this.canonical.z ? new sh(e1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new sh(e1, this.wrap, e1, this.canonical.x >> t1, this.canonical.y >> t1);
            }
            calculateScaledKey(e1, t1 = !0) {
                if (this.overscaledZ === e1 && t1) return this.key;
                if (e1 > this.canonical.z) return ah(this.wrap * +t1, e1, this.canonical.z, this.canonical.x, this.canonical.y);
                {
                    const r = this.canonical.z - e1;
                    return ah(this.wrap * +t1, e1, e1, this.canonical.x >> r, this.canonical.y >> r);
                }
            }
            isChildOf(e1) {
                if (e1.wrap !== this.wrap) return !1;
                const t1 = this.canonical.z - e1.canonical.z;
                return 0 === e1.overscaledZ || e1.overscaledZ < this.overscaledZ && e1.canonical.z < this.canonical.z && e1.canonical.x === this.canonical.x >> t1 && e1.canonical.y === this.canonical.y >> t1;
            }
            children(e1) {
                if (this.overscaledZ >= e1) return [
                    new sh(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                ];
                const t1 = this.canonical.z + 1, r = 2 * this.canonical.x, n = 2 * this.canonical.y;
                return [
                    new sh(t1, this.wrap, t1, r, n),
                    new sh(t1, this.wrap, t1, r + 1, n),
                    new sh(t1, this.wrap, t1, r, n + 1),
                    new sh(t1, this.wrap, t1, r + 1, n + 1)
                ];
            }
            isLessThan(e1) {
                return this.wrap < e1.wrap || !(this.wrap > e1.wrap) && (this.overscaledZ < e1.overscaledZ || !(this.overscaledZ > e1.overscaledZ) && (this.canonical.x < e1.canonical.x || !(this.canonical.x > e1.canonical.x) && this.canonical.y < e1.canonical.y));
            }
            wrapped() {
                return new sh(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            unwrapTo(e1) {
                return new sh(this.overscaledZ, e1, this.canonical.z, this.canonical.x, this.canonical.y);
            }
            overscaleFactor() {
                return Math.pow(2, this.overscaledZ - this.canonical.z);
            }
            toUnwrapped() {
                return new ih(this.wrap, this.canonical);
            }
            toString() {
                return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
            }
        }
        function ah(e1, t1, r, n, i) {
            const s = 1 << Math.min(r, 22);
            let a = s * (i % s) + n % s;
            return e1 && r < 22 && (a += s * s * ((e1 < 0 ? -2 * e1 - 1 : 2 * e1) % (1 << 2 * (22 - r)))), 16 * (32 * a + r) + (t1 - r);
        }
        const oh = [
            (e1)=>{
                let t1 = e1.canonical.x - 1, r = e1.wrap;
                return t1 < 0 && (t1 = (1 << e1.canonical.z) - 1, r--), new sh(e1.overscaledZ, r, e1.canonical.z, t1, e1.canonical.y);
            },
            (e1)=>{
                let t1 = e1.canonical.x + 1, r = e1.wrap;
                return t1 === 1 << e1.canonical.z && (t1 = 0, r++), new sh(e1.overscaledZ, r, e1.canonical.z, t1, e1.canonical.y);
            },
            (e1)=>new sh(e1.overscaledZ, e1.wrap, e1.canonical.z, e1.canonical.x, (0 === e1.canonical.y ? 1 << e1.canonical.z : e1.canonical.y) - 1),
            (e1)=>new sh(e1.overscaledZ, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y === (1 << e1.canonical.z) - 1 ? 0 : e1.canonical.y + 1)
        ];
        ra(nh, "CanonicalTileID"), ra(sh, "OverscaledTileID", {
            omit: [
                "projMatrix",
                "expandedProjMatrix"
            ]
        });
        const lh = qo([
            {
                type: "Float32",
                name: "a_globe_pos",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            }
        ]), { members: uh } = lh, ch = qo([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            }
        ]);
        var hh = qo([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            }
        ]);
        function dh(e1) {
            return e1 * Pu / Eu;
        }
        const ph = [
            new Tc([
                ku,
                ku,
                ku
            ], [
                Vu,
                Vu,
                Vu
            ]),
            new Tc([
                ku,
                ku,
                ku
            ], [
                0,
                0,
                Vu
            ]),
            new Tc([
                0,
                ku,
                ku
            ], [
                Vu,
                0,
                Vu
            ]),
            new Tc([
                ku,
                0,
                ku
            ], [
                0,
                Vu,
                Vu
            ]),
            new Tc([
                0,
                0,
                ku
            ], [
                Vu,
                Vu,
                Vu
            ])
        ];
        function fh(e1, t1, r, n = !0) {
            const i = V([], e1._camera.position, e1.worldSize), s = [
                t1,
                r,
                1,
                1
            ];
            ee(s, s, e1.pixelMatrixInverse), J(s, s, 1 / s[3]);
            const a = L([], X([], s, i)), o = e1.globeMatrix, l = [
                o[12],
                o[13],
                o[14]
            ], u = X([], l, i), c = I(u), h = L([], u), d = e1.worldSize / (2 * Math.PI), p = O(h, a), f = Math.asin(d / c);
            if (f < Math.acos(p)) {
                if (!n) return null;
                const e1 = [], t1 = [];
                V(e1, a, c / p), L(t1, X(t1, e1, u)), L(a, S(a, u, V(a, t1, Math.tan(f) * c)));
            }
            const m = [];
            new _c(i, a).closestPointOnSphere(l, d, m);
            const y = L([], rt(o, 0)), g = L([], rt(o, 1)), x = L([], rt(o, 2)), v = O(y, m), b = O(g, m), w = O(x, m), _ = ze(Math.asin(-b / d));
            let A = ze(Math.atan2(v, w));
            A = e1.center.lng + function(e1, t1) {
                const r = (t1 - e1 + 180) % 360 - 180;
                return r < -180 ? r + 360 : r;
            }(e1.center.lng, A);
            const M = Uu(A), B = Ee(Nu(_), 0, 1);
            return new Ju(M, B);
        }
        class mh {
            constructor(e1, t1, r){
                this.a = X([], e1, r), this.b = X([], t1, r), this.center = r;
                const n = L([], this.a), i = L([], this.b);
                this.angle = Math.acos(O(n, i));
            }
        }
        function yh(e1, t1) {
            if (0 === e1.angle) return null;
            let r;
            return r = 0 === e1.a[t1] ? 1 / e1.angle * .5 * Math.PI : 1 / e1.angle * Math.atan(e1.b[t1] / e1.a[t1] / Math.sin(e1.angle) - 1 / Math.tan(e1.angle)), r < 0 || r > 1 ? null : function(e1, t1, r, n) {
                const i = Math.sin(r);
                return e1 * (Math.sin((1 - n) * r) / i) + t1 * (Math.sin(n * r) / i);
            }(e1.a[t1], e1.b[t1], e1.angle, Ee(r, 0, 1)) + e1.center[t1];
        }
        function gh(e1) {
            if (e1.z <= 1) return ph[e1.z + 2 * e1.y + e1.x];
            const t1 = Ah(_h(e1));
            return Tc.fromPoints(t1);
        }
        function xh(e1, t1, r) {
            return V(e1, e1, 1 - r), F(e1, e1, t1, r);
        }
        function vh(e1, t1) {
            const r = Vh(t1.zoom);
            if (0 === r) return gh(e1);
            const n = _h(e1), i = Ah(n), s = Uu(n.getWest()) * t1.worldSize, a = Uu(n.getEast()) * t1.worldSize, o = Nu(n.getNorth()) * t1.worldSize, l = Nu(n.getSouth()) * t1.worldSize, u = [
                s,
                o,
                0
            ], h = [
                a,
                o,
                0
            ], d = [
                s,
                l,
                0
            ], p = [
                a,
                l,
                0
            ], f = c([], t1.globeMatrix);
            return j(u, u, f), j(h, h, f), j(d, d, f), j(p, p, f), i[0] = xh(i[0], d, r), i[1] = xh(i[1], p, r), i[2] = xh(i[2], h, r), i[3] = xh(i[3], u, r), Tc.fromPoints(i);
        }
        function bh(e1, t1, r) {
            for (const n of e1)j(n, n, t1), V(n, n, r);
        }
        function wh(e1, t1, r, n) {
            const i = t1 / e1.worldSize, s = e1.globeMatrix;
            if (r.z <= 1) {
                const e1 = gh(r).getCorners();
                return bh(e1, s, i), Tc.fromPoints(e1);
            }
            const a = _h(r, n), o = Ah(a, Pu + dh(e1._tileCoverLift));
            bh(o, s, i);
            const l = Number.MAX_VALUE, u = [
                -l,
                -l,
                -l
            ], c = [
                l,
                l,
                l
            ];
            if (a.contains(e1.center)) {
                for (const e1 of o)z(c, c, e1), k(u, u, e1);
                u[2] = 0;
                const t1 = e1.point, r = [
                    t1.x * i,
                    t1.y * i,
                    0
                ];
                return z(c, c, r), k(u, u, r), new Tc(c, u);
            }
            if (e1._tileCoverLift > 0) {
                for (const e1 of o)z(c, c, e1), k(u, u, e1);
                return new Tc(c, u);
            }
            const h = [
                s[12] * i,
                s[13] * i,
                s[14] * i
            ], d = a.getCenter(), p = Ee(e1.center.lat, -85.051129, Hu), f = Ee(d.lat, -85.051129, Hu), m = Uu(e1.center.lng), y = Nu(p);
            let g = m - Uu(d.lng);
            const x = y - Nu(f);
            g > .5 ? g -= 1 : g < -0.5 && (g += 1);
            let v = 0;
            Math.abs(g) > Math.abs(x) ? v = g >= 0 ? 1 : 3 : (v = x >= 0 ? 0 : 2, F(h, h, [
                s[4] * i,
                s[5] * i,
                s[6] * i
            ], -Math.sin(Te(x >= 0 ? a.getSouth() : a.getNorth())) * Pu));
            const b = o[v], w = o[(v + 1) % 4], _ = new mh(b, w, h), A = [
                yh(_, 0) || b[0],
                yh(_, 1) || b[1],
                yh(_, 2) || b[2]
            ], I = Vh(e1.zoom);
            if (I > 0) {
                const n = function({ x: e1, y: t1, z: r }, n, i, s, a) {
                    const o = 1 / (1 << r);
                    let l = e1 * o, u = l + o, c = t1 * o, h = c + o, d = 0;
                    const p = (l + u) / 2 - s;
                    return p > .5 ? d = -1 : p < -0.5 && (d = 1), l = ((l + d) * n - (s *= n)) * i + s, u = ((u + d) * n - s) * i + s, c = (c * n - (a *= n)) * i + a, h = (h * n - a) * i + a, [
                        [
                            l,
                            h,
                            0
                        ],
                        [
                            u,
                            h,
                            0
                        ],
                        [
                            u,
                            c,
                            0
                        ],
                        [
                            l,
                            c,
                            0
                        ]
                    ];
                }(r, t1, e1._pixelsPerMercatorPixel, m, y);
                for(let e1 = 0; e1 < o.length; e1++)xh(o[e1], n[e1], I);
                const i = S([], n[v], n[(v + 1) % 4]);
                V(i, i, .5), xh(A, i, I);
            }
            for (const e1 of o)z(c, c, e1), k(u, u, e1);
            return c[2] = Math.min(b[2], w[2]), z(c, c, A), k(u, u, A), new Tc(c, u);
        }
        function _h({ x: e1, y: t1, z: r }, n = !1) {
            const i = 1 / (1 << r), s = new Ru(Gu(e1 * i), t1 === (1 << r) - 1 && n ? -90 : $u((t1 + 1) * i)), a = new Ru(Gu((e1 + 1) * i), 0 === t1 && n ? 90 : $u(t1 * i));
            return new Lu(s, a);
        }
        function Ah(e1, t1 = Pu) {
            const r = Te(e1.getNorth()), n = Te(e1.getSouth()), i = Math.cos(r), s = Math.cos(n), a = Math.sin(r), o = Math.sin(n), l = e1.getWest(), u = e1.getEast();
            return [
                Fu(s, o, l, t1),
                Fu(s, o, u, t1),
                Fu(i, a, u, t1),
                Fu(i, a, l, t1)
            ];
        }
        function Ih(e1, t1, r, n) {
            const i = 1 << r.z, s = (e1 / qn + r.x) / i;
            return Du($u((t1 / qn + r.y) / i), Gu(s), n);
        }
        function Mh({ min: e1, max: t1 }) {
            return 16383 / Math.max(t1[0] - e1[0], t1[1] - e1[1], t1[2] - e1[2]);
        }
        const Bh = new Float64Array(16);
        function Sh(e1) {
            const t1 = Mh(e1), r = g(Bh, [
                t1,
                t1,
                t1
            ]);
            return d(r, r, R([], e1.min));
        }
        function Ph(e1) {
            const t1 = function(e1, t1) {
                return e1[0] = 1, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = 1, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 1, e1[11] = 0, e1[12] = t1[0], e1[13] = t1[1], e1[14] = t1[2], e1[15] = 1, e1;
            }(Bh, e1.min), r = 1 / Mh(e1);
            return p(t1, t1, [
                r,
                r,
                r
            ]);
        }
        function Th(e1) {
            const t1 = qn / (2 * Math.PI);
            return e1 / (2 * Math.PI) / t1;
        }
        function zh(e1, t1) {
            return qn / (512 * Math.pow(2, e1)) * Mh(gh(t1));
        }
        function kh(e1, t1, r, n, i) {
            const s = Th(r), a = [
                e1,
                t1,
                -r / (2 * Math.PI)
            ], o = u(new Float64Array(16));
            return d(o, o, a), p(o, o, [
                s,
                s,
                s
            ]), f(o, o, Te(-i)), m(o, o, Te(-n)), o;
        }
        function Vh(e1) {
            return Ce(5, 6, e1);
        }
        function Fh(e1, t1) {
            const r = Du(t1.lat, t1.lng), n = function(e1) {
                const t1 = Du(e1._center.lat, e1._center.lng);
                let r = U([], M(0, 1, 0), t1);
                const n = x([], -e1.angle, t1);
                r = j(r, r, n), x(n, -e1._pitch, r);
                const i = L([], t1);
                return V(i, i, dh(e1.cameraToCenterDistance / e1.pixelsPerMeter)), j(i, i, n), S([], t1, i);
            }(e1);
            var i, s, a, o, l, u, c, h, d, p;
            return a = (i = P([], n, r))[0], o = i[1], l = i[2], u = (s = r)[0], c = s[1], h = s[2], p = (d = Math.sqrt((a * a + o * o + l * l) * (u * u + c * c + h * h))) && O(i, s) / d, Math.acos(Math.min(Math.max(p, -1), 1));
        }
        function Dh(e1, t1) {
            return Fh(e1, t1) > Math.PI / 2 * 1.01;
        }
        const Eh = Te(85), Ch = Math.cos(Eh), Rh = Math.sin(Eh), Lh = o(), Oh = (e1)=>{
            const t1 = [];
            return "map" === e1.paint.get("circle-pitch-alignment") && t1.push("PITCH_WITH_MAP"), "map" === e1.paint.get("circle-pitch-scale") && t1.push("SCALE_WITH_MAP"), t1;
        };
        function Uh(e1, t1, r, n, i, s, a, o, l) {
            if (s && e1.queryGeometry.isAboveHorizon) return !1;
            s && (l *= e1.pixelToTileUnitsFactor);
            const u = e1.tileID.canonical, c = r.projection.upVectorScale(u, r.center.lat, r.worldSize).metersToTile;
            for (const h of t1)for (const t1 of h){
                const h = t1.add(o), d = i && r.elevation ? r.elevation.exaggeration() * i.getElevationAt(h.x, h.y, !0) : 0, p = r.projection.projectTilePoint(h.x, h.y, u);
                if (d > 0) {
                    const e1 = r.projection.upVector(u, h.x, h.y);
                    p.x += e1[0] * c * d, p.y += e1[1] * c * d, p.z += e1[2] * c * d;
                }
                const f = s ? h : Nh(p.x, p.y, p.z, n), m = s ? e1.tilespaceRays.map((e1)=>$h(e1, d)) : e1.queryGeometry.screenGeometry, y = ee([], [
                    p.x,
                    p.y,
                    p.z,
                    1
                ], n);
                if (!a && s ? l *= y[3] / r.cameraToCenterDistance : a && !s && (l *= r.cameraToCenterDistance / y[3]), s) {
                    const e1 = $u((t1.y / qn + u.y) / (1 << u.z));
                    l /= r.projection.pixelsPerMeter(e1, 1) / ju(1, e1);
                }
                if (Cc(m, f, l)) return !0;
            }
            return !1;
        }
        function Nh(e1, t1, r, n) {
            const i = ee([], [
                e1,
                t1,
                r,
                1
            ], n);
            return new Me(i[0] / i[3], i[1] / i[3]);
        }
        const jh = M(0, 0, 0), Gh = M(0, 0, 1);
        function $h(e1, t1) {
            const r = _();
            return jh[2] = t1, e1.intersectsPlane(jh, Gh, r), new Me(r[0], r[1]);
        }
        class qh extends Dc {
        }
        let Hh, Xh, Zh, Wh;
        function Yh(e1, { width: t1, height: r }, n, i) {
            if (i) {
                if (i instanceof Uint8ClampedArray) i = new Uint8Array(i.buffer);
                else if (i.length !== t1 * r * n) throw new RangeError("mismatched image size");
            } else i = new Uint8Array(t1 * r * n);
            return e1.width = t1, e1.height = r, e1.data = i, e1;
        }
        function Jh(e1, t1, r) {
            const { width: n, height: i } = t1;
            n === e1.width && i === e1.height || (Kh(e1, t1, {
                x: 0,
                y: 0
            }, {
                x: 0,
                y: 0
            }, {
                width: Math.min(e1.width, n),
                height: Math.min(e1.height, i)
            }, r, null), e1.width = n, e1.height = i, e1.data = t1.data);
        }
        function Kh(e1, t1, r, n, i, s, a, o) {
            if (0 === i.width || 0 === i.height) return t1;
            if (i.width > e1.width || i.height > e1.height || r.x > e1.width - i.width || r.y > e1.height - i.height) throw new RangeError("out of range source coordinates for image copy");
            if (i.width > t1.width || i.height > t1.height || n.x > t1.width - i.width || n.y > t1.height - i.height) throw new RangeError("out of range destination coordinates for image copy");
            const l = e1.data, u = t1.data, c = 4 === s && o;
            for(let o = 0; o < i.height; o++){
                const h = ((r.y + o) * e1.width + r.x) * s, d = ((n.y + o) * t1.width + n.x) * s;
                if (c) for(let e1 = 0; e1 < i.width; e1++){
                    const t1 = h + e1 * s + 3, r = d + e1 * s;
                    u[r + 0] = 255, u[r + 1] = 255, u[r + 2] = 255, u[r + 3] = l[t1];
                }
                else if (a) for(let e1 = 0; e1 < i.width; e1++){
                    const t1 = h + e1 * s, r = d + e1 * s, n = new dr(l[t1 + 0] / 255, l[t1 + 1] / 255, l[t1 + 2] / 255, l[t1 + 3]).toNonPremultipliedRenderColor(a).toArray();
                    u[r + 0] = n[0], u[r + 1] = n[1], u[r + 2] = n[2], u[r + 3] = n[3];
                }
                else for(let e1 = 0; e1 < i.width * s; e1++)u[d + e1] = l[h + e1];
            }
            return t1;
        }
        ra(qh, "HeatmapBucket", {
            omit: [
                "layers"
            ]
        });
        class Qh {
            constructor(e1, t1){
                Yh(this, e1, 1, t1);
            }
            resize(e1) {
                Jh(this, new Qh(e1), 1);
            }
            clone() {
                return new Qh({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(e1, t1, r, n, i) {
                Kh(e1, t1, r, n, i, 1, null);
            }
        }
        class ed {
            constructor(e1, t1){
                Yh(this, e1, 4, t1);
            }
            resize(e1) {
                Jh(this, new ed(e1), 4);
            }
            replace(e1, t1) {
                t1 ? this.data.set(e1) : this.data = e1 instanceof Uint8ClampedArray ? new Uint8Array(e1.buffer) : e1;
            }
            clone() {
                return new ed({
                    width: this.width,
                    height: this.height
                }, new Uint8Array(this.data));
            }
            static copy(e1, t1, r, n, i, s, a) {
                Kh(e1, t1, r, n, i, 4, s, a);
            }
        }
        class td {
            constructor(e1, t1){
                this.width = e1.width, this.height = e1.height, this.data = t1 instanceof Uint8Array ? new Float32Array(t1.buffer) : t1;
            }
        }
        function rd(e1) {
            const t1 = {}, r = e1.resolution || 256, n = e1.clips ? e1.clips.length : 1, i = e1.image || new ed({
                width: r,
                height: n
            }), s = (r, n, s)=>{
                t1[e1.evaluationKey] = s;
                const a = e1.expression.evaluate(t1), o = a ? a.toNonPremultipliedRenderColor(null) : null;
                o && (i.data[r + n + 0] = Math.floor(255 * o.r), i.data[r + n + 1] = Math.floor(255 * o.g), i.data[r + n + 2] = Math.floor(255 * o.b), i.data[r + n + 3] = Math.floor(255 * o.a));
            };
            if (e1.clips) for(let t1 = 0, i = 0; t1 < n; ++t1, i += 4 * r)for(let n = 0, a = 0; n < r; n++, a += 4){
                const o = n / (r - 1), { start: l, end: u } = e1.clips[t1];
                s(i, a, l * (1 - o) + u * o);
            }
            else for(let e1 = 0, t1 = 0; e1 < r; e1++, t1 += 4)s(0, t1, e1 / (r - 1));
            return i;
        }
        ra(Qh, "AlphaImage"), ra(ed, "RGBAImage");
        const nd = qo([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            }
        ], 4), id = qo([
            {
                name: "a_road_z_offset",
                components: 1,
                type: "Float32"
            }
        ], 4), sd = qo([
            {
                name: "a_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_height",
                components: 1,
                type: "Float32"
            }
        ], 4), ad = qo([
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ], 4);
        function od(e1, t1, r = 2) {
            const n = t1 && t1.length, i = n ? t1[0] * r : e1.length;
            let s = ld(e1, 0, i, r, !0);
            const a = [];
            if (!s || s.next === s.prev) return a;
            let o, l, u;
            if (n && (s = function(e1, t1, r, n) {
                const i = [];
                for(let r = 0, s = t1.length; r < s; r++){
                    const a = ld(e1, t1[r] * n, r < s - 1 ? t1[r + 1] * n : e1.length, n, !1);
                    a === a.next && (a.steiner = !0), i.push(vd(a));
                }
                i.sort(md);
                for(let e1 = 0; e1 < i.length; e1++)r = yd(i[e1], r);
                return r;
            }(e1, t1, s, r)), e1.length > 80 * r) {
                o = e1[0], l = e1[1];
                let t1 = o, n = l;
                for(let s = r; s < i; s += r){
                    const r = e1[s], i = e1[s + 1];
                    r < o && (o = r), i < l && (l = i), r > t1 && (t1 = r), i > n && (n = i);
                }
                u = Math.max(t1 - o, n - l), u = 0 !== u ? 32767 / u : 0;
            }
            return cd(s, a, r, o, l, u, 0), a;
        }
        function ld(e1, t1, r, n, i) {
            let s;
            if (i === function(e1, t1, r, n) {
                let i = 0;
                for(let s = t1, a = r - n; s < r; s += n)i += (e1[a] - e1[s]) * (e1[s + 1] + e1[a + 1]), a = s;
                return i;
            }(e1, t1, r, n) > 0) for(let i = t1; i < r; i += n)s = zd(i / n | 0, e1[i], e1[i + 1], s);
            else for(let i = r - n; i >= t1; i -= n)s = zd(i / n | 0, e1[i], e1[i + 1], s);
            return s && Id(s, s.next) && (kd(s), s = s.next), s;
        }
        function ud(e1, t1) {
            if (!e1) return e1;
            t1 || (t1 = e1);
            let r, n = e1;
            do if (r = !1, n.steiner || !Id(n, n.next) && 0 !== Ad(n.prev, n, n.next)) n = n.next;
            else {
                if (kd(n), n = t1 = n.prev, n === n.next) break;
                r = !0;
            }
            while (r || n !== t1);
            return t1;
        }
        function cd(e1, t1, r, n, i, s, a) {
            if (!e1) return;
            !a && s && function(e1, t1, r, n) {
                let i = e1;
                do 0 === i.z && (i.z = xd(i.x, i.y, t1, r, n)), i.prevZ = i.prev, i.nextZ = i.next, i = i.next;
                while (i !== e1);
                i.prevZ.nextZ = null, i.prevZ = null, function(e1) {
                    let t1, r = 1;
                    do {
                        let n, i = e1;
                        e1 = null;
                        let s = null;
                        for(t1 = 0; i;){
                            t1++;
                            let a = i, o = 0;
                            for(let e1 = 0; e1 < r && (o++, a = a.nextZ, a); e1++);
                            let l = r;
                            for(; o > 0 || l > 0 && a;)0 !== o && (0 === l || !a || i.z <= a.z) ? (n = i, i = i.nextZ, o--) : (n = a, a = a.nextZ, l--), s ? s.nextZ = n : e1 = n, n.prevZ = s, s = n;
                            i = a;
                        }
                        s.nextZ = null, r *= 2;
                    }while (t1 > 1);
                }(i);
            }(e1, n, i, s);
            let o = e1;
            for(; e1.prev !== e1.next;){
                const l = e1.prev, u = e1.next;
                if (s ? dd(e1, n, i, s) : hd(e1)) t1.push(l.i, e1.i, u.i), kd(e1), e1 = u.next, o = u.next;
                else if ((e1 = u) === o) {
                    a ? 1 === a ? cd(e1 = pd(ud(e1), t1), t1, r, n, i, s, 2) : 2 === a && fd(e1, t1, r, n, i, s) : cd(ud(e1), t1, r, n, i, s, 1);
                    break;
                }
            }
        }
        function hd(e1) {
            const t1 = e1.prev, r = e1, n = e1.next;
            if (Ad(t1, r, n) >= 0) return !1;
            const i = t1.x, s = r.x, a = n.x, o = t1.y, l = r.y, u = n.y, c = Math.min(i, s, a), h = Math.min(o, l, u), d = Math.max(i, s, a), p = Math.max(o, l, u);
            let f = n.next;
            for(; f !== t1;){
                if (f.x >= c && f.x <= d && f.y >= h && f.y <= p && wd(i, o, s, l, a, u, f.x, f.y) && Ad(f.prev, f, f.next) >= 0) return !1;
                f = f.next;
            }
            return !0;
        }
        function dd(e1, t1, r, n) {
            const i = e1.prev, s = e1, a = e1.next;
            if (Ad(i, s, a) >= 0) return !1;
            const o = i.x, l = s.x, u = a.x, c = i.y, h = s.y, d = a.y, p = Math.min(o, l, u), f = Math.min(c, h, d), m = Math.max(o, l, u), y = Math.max(c, h, d), g = xd(p, f, t1, r, n), x = xd(m, y, t1, r, n);
            let v = e1.prevZ, b = e1.nextZ;
            for(; v && v.z >= g && b && b.z <= x;){
                if (v.x >= p && v.x <= m && v.y >= f && v.y <= y && v !== i && v !== a && wd(o, c, l, h, u, d, v.x, v.y) && Ad(v.prev, v, v.next) >= 0) return !1;
                if (v = v.prevZ, b.x >= p && b.x <= m && b.y >= f && b.y <= y && b !== i && b !== a && wd(o, c, l, h, u, d, b.x, b.y) && Ad(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            for(; v && v.z >= g;){
                if (v.x >= p && v.x <= m && v.y >= f && v.y <= y && v !== i && v !== a && wd(o, c, l, h, u, d, v.x, v.y) && Ad(v.prev, v, v.next) >= 0) return !1;
                v = v.prevZ;
            }
            for(; b && b.z <= x;){
                if (b.x >= p && b.x <= m && b.y >= f && b.y <= y && b !== i && b !== a && wd(o, c, l, h, u, d, b.x, b.y) && Ad(b.prev, b, b.next) >= 0) return !1;
                b = b.nextZ;
            }
            return !0;
        }
        function pd(e1, t1) {
            let r = e1;
            do {
                const n = r.prev, i = r.next.next;
                !Id(n, i) && Md(n, r, r.next, i) && Pd(n, i) && Pd(i, n) && (t1.push(n.i, r.i, i.i), kd(r), kd(r.next), r = e1 = i), r = r.next;
            }while (r !== e1);
            return ud(r);
        }
        function fd(e1, t1, r, n, i, s) {
            let a = e1;
            do {
                let e1 = a.next.next;
                for(; e1 !== a.prev;){
                    if (a.i !== e1.i && _d(a, e1)) {
                        let o = Td(a, e1);
                        return a = ud(a, a.next), o = ud(o, o.next), cd(a, t1, r, n, i, s, 0), void cd(o, t1, r, n, i, s, 0);
                    }
                    e1 = e1.next;
                }
                a = a.next;
            }while (a !== e1);
        }
        function md(e1, t1) {
            let r = e1.x - t1.x;
            return 0 === r && (r = e1.y - t1.y, 0 === r) && (r = (e1.next.y - e1.y) / (e1.next.x - e1.x) - (t1.next.y - t1.y) / (t1.next.x - t1.x)), r;
        }
        function yd(e1, t1) {
            const r = function(e1, t1) {
                let r = t1;
                const n = e1.x, i = e1.y;
                let s, a = -1 / 0;
                if (Id(e1, r)) return r;
                do {
                    if (Id(e1, r.next)) return r.next;
                    if (i <= r.y && i >= r.next.y && r.next.y !== r.y) {
                        const e1 = r.x + (i - r.y) * (r.next.x - r.x) / (r.next.y - r.y);
                        if (e1 <= n && e1 > a && (a = e1, s = r.x < r.next.x ? r : r.next, e1 === n)) return s;
                    }
                    r = r.next;
                }while (r !== t1);
                if (!s) return null;
                const o = s, l = s.x, u = s.y;
                let c = 1 / 0;
                r = s;
                do {
                    if (n >= r.x && r.x >= l && n !== r.x && bd(i < u ? n : a, i, l, u, i < u ? a : n, i, r.x, r.y)) {
                        const t1 = Math.abs(i - r.y) / (n - r.x);
                        Pd(r, e1) && (t1 < c || t1 === c && (r.x > s.x || r.x === s.x && gd(s, r))) && (s = r, c = t1);
                    }
                    r = r.next;
                }while (r !== o);
                return s;
            }(e1, t1);
            if (!r) return t1;
            const n = Td(r, e1);
            return ud(n, n.next), ud(r, r.next);
        }
        function gd(e1, t1) {
            return Ad(e1.prev, e1, t1.prev) < 0 && Ad(t1.next, e1, e1.next) < 0;
        }
        function xd(e1, t1, r, n, i) {
            return (e1 = 1431655765 & ((e1 = 858993459 & ((e1 = 252645135 & ((e1 = 16711935 & ((e1 = (e1 - r) * i | 0) | e1 << 8)) | e1 << 4)) | e1 << 2)) | e1 << 1)) | (t1 = 1431655765 & ((t1 = 858993459 & ((t1 = 252645135 & ((t1 = 16711935 & ((t1 = (t1 - n) * i | 0) | t1 << 8)) | t1 << 4)) | t1 << 2)) | t1 << 1)) << 1;
        }
        function vd(e1) {
            let t1 = e1, r = e1;
            do (t1.x < r.x || t1.x === r.x && t1.y < r.y) && (r = t1), t1 = t1.next;
            while (t1 !== e1);
            return r;
        }
        function bd(e1, t1, r, n, i, s, a, o) {
            return (i - a) * (t1 - o) >= (e1 - a) * (s - o) && (e1 - a) * (n - o) >= (r - a) * (t1 - o) && (r - a) * (s - o) >= (i - a) * (n - o);
        }
        function wd(e1, t1, r, n, i, s, a, o) {
            return !(e1 === a && t1 === o) && bd(e1, t1, r, n, i, s, a, o);
        }
        function _d(e1, t1) {
            return e1.next.i !== t1.i && e1.prev.i !== t1.i && !function(e1, t1) {
                let r = e1;
                do {
                    if (r.i !== e1.i && r.next.i !== e1.i && r.i !== t1.i && r.next.i !== t1.i && Md(r, r.next, e1, t1)) return !0;
                    r = r.next;
                }while (r !== e1);
                return !1;
            }(e1, t1) && (Pd(e1, t1) && Pd(t1, e1) && function(e1, t1) {
                let r = e1, n = !1;
                const i = (e1.x + t1.x) / 2, s = (e1.y + t1.y) / 2;
                do r.y > s != r.next.y > s && r.next.y !== r.y && i < (r.next.x - r.x) * (s - r.y) / (r.next.y - r.y) + r.x && (n = !n), r = r.next;
                while (r !== e1);
                return n;
            }(e1, t1) && (Ad(e1.prev, e1, t1.prev) || Ad(e1, t1.prev, t1)) || Id(e1, t1) && Ad(e1.prev, e1, e1.next) > 0 && Ad(t1.prev, t1, t1.next) > 0);
        }
        function Ad(e1, t1, r) {
            return (t1.y - e1.y) * (r.x - t1.x) - (t1.x - e1.x) * (r.y - t1.y);
        }
        function Id(e1, t1) {
            return e1.x === t1.x && e1.y === t1.y;
        }
        function Md(e1, t1, r, n) {
            const i = Sd(Ad(e1, t1, r)), s = Sd(Ad(e1, t1, n)), a = Sd(Ad(r, n, e1)), o = Sd(Ad(r, n, t1));
            return i !== s && a !== o || !(0 !== i || !Bd(e1, r, t1)) || !(0 !== s || !Bd(e1, n, t1)) || !(0 !== a || !Bd(r, e1, n)) || !(0 !== o || !Bd(r, t1, n));
        }
        function Bd(e1, t1, r) {
            return t1.x <= Math.max(e1.x, r.x) && t1.x >= Math.min(e1.x, r.x) && t1.y <= Math.max(e1.y, r.y) && t1.y >= Math.min(e1.y, r.y);
        }
        function Sd(e1) {
            return e1 > 0 ? 1 : e1 < 0 ? -1 : 0;
        }
        function Pd(e1, t1) {
            return Ad(e1.prev, e1, e1.next) < 0 ? Ad(e1, t1, e1.next) >= 0 && Ad(e1, e1.prev, t1) >= 0 : Ad(e1, t1, e1.prev) < 0 || Ad(e1, e1.next, t1) < 0;
        }
        function Td(e1, t1) {
            const r = Vd(e1.i, e1.x, e1.y), n = Vd(t1.i, t1.x, t1.y), i = e1.next, s = t1.prev;
            return e1.next = t1, t1.prev = e1, r.next = i, i.prev = r, n.next = r, r.prev = n, s.next = n, n.prev = s, n;
        }
        function zd(e1, t1, r, n) {
            const i = Vd(e1, t1, r);
            return n ? (i.next = n.next, i.prev = n, n.next.prev = i, n.next = i) : (i.prev = i, i.next = i), i;
        }
        function kd(e1) {
            e1.next.prev = e1.prev, e1.prev.next = e1.next, e1.prevZ && (e1.prevZ.nextZ = e1.nextZ), e1.nextZ && (e1.nextZ.prevZ = e1.prevZ);
        }
        function Vd(e1, t1, r) {
            return {
                i: e1,
                x: t1,
                y: r,
                prev: null,
                next: null,
                z: 0,
                prevZ: null,
                nextZ: null,
                steiner: !1
            };
        }
        function Fd(e1, t1) {
            const r = e1.length;
            if (r <= 1) return [
                e1
            ];
            const n = [];
            let i, s;
            for(let t1 = 0; t1 < r; t1++){
                const r = Ye(e1[t1]);
                0 !== r && (e1[t1].area = Math.abs(r), void 0 === s && (s = r < 0), s === r < 0 ? (i && n.push(i), i = [
                    e1[t1]
                ]) : i.push(e1[t1]));
            }
            if (i && n.push(i), t1 > 1) for(let e1 = 0; e1 < n.length; e1++)n[e1].length <= t1 || (dn(n[e1], t1, 1, n[e1].length - 1, Dd), n[e1] = n[e1].slice(0, t1));
            return n;
        }
        function Dd(e1, t1) {
            return t1.area - e1.area;
        }
        function Ed(e1, t1, r = 1) {
            if (!e1) return null;
            const n = "string" == typeof e1 ? jr.from(e1).getPrimary() : e1.getPrimary(), i = "string" == typeof e1 ? null : e1.getSecondary();
            for (const e1 of [
                n,
                i
            ]){
                if (!e1) continue;
                const n = e1.id.toString();
                t1.has(n) || t1.set(n, []), e1.scaleSelf(r), t1.get(n).push(e1);
            }
            return {
                primary: n.toString(),
                secondary: i ? i.toString() : null
            };
        }
        function Cd(e1, t1, r, n) {
            const i = n.patternDependencies;
            let s = !1;
            for (const n of t1){
                const t1 = n.paint.get(`${e1}-pattern`);
                t1.isConstant() || (s = !0), Ed(t1.constantOr(null), i, r) && (s = !0);
            }
            return s;
        }
        function Rd(e1, t1, r, n, i, s) {
            const a = s.patternDependencies;
            for (const o of t1){
                const t1 = o.paint.get(`${e1}-pattern`).value;
                if ("constant" !== t1.kind) {
                    const e1 = Ed(t1.evaluate({
                        zoom: n
                    }, r, {}, void 0, s.availableImages), a, i);
                    if (!e1) continue;
                    const { primary: l, secondary: u } = e1;
                    l && (r.patterns[o.id] = [
                        l,
                        u
                    ].filter(Boolean));
                }
            }
            return r;
        }
        class Ld {
            constructor(){
                this.portals = [];
            }
            static isOnBorder(e1, t1) {
                return e1 <= 0 && t1 <= 0 || e1 >= qn && t1 >= qn;
            }
            static evaluate(e1) {
                if (0 === e1.length) return new Ld;
                let t1 = [];
                for (const r of e1)t1.push(...r.portals);
                if (0 === t1.length) return new Ld;
                for (const e1 of t1){
                    const t1 = e1.va, r = e1.vb;
                    (Ld.isOnBorder(t1.x, r.x) || Ld.isOnBorder(t1.y, r.y)) && (e1.type = "border");
                }
                const r = t1.filter((e1)=>"unevaluated" !== e1.type), n = t1.filter((e1)=>"unevaluated" === e1.type);
                if (0 === n.length) return new Ld;
                n.sort((e1, t1)=>e1.hash === t1.hash ? e1.isTunnel === t1.isTunnel ? 0 : e1.isTunnel ? -1 : 1 : e1.hash < t1.hash ? 1 : -1), t1 = r.concat(n);
                let i = r.length, s = i, a = i;
                do if (s++, s === t1.length || t1[i].hash !== t1[s].hash) {
                    if (s - i === 2) {
                        a < i && (t1[a] = t1[i], t1[i] = null);
                        const e1 = t1[a], r = t1[s - 1];
                        e1.type = e1.isTunnel !== r.isTunnel ? "tunnel" : "polygon", e1.connection = {
                            a: e1.connection.a,
                            b: r.connection.a
                        }, a++;
                    }
                    i = s;
                }
                while (i !== t1.length);
                return t1.splice(a), t1.sort((e1, t1)=>e1.hash < t1.hash ? 1 : -1), {
                    portals: t1
                };
            }
        }
        ra(Ld, "ElevationPortalGraph");
        class Od {
            constructor(e1, t1, r){
                this.outPositions = e1, this.outNormals = t1, this.outIndices = r, this.vertexLookup = new Map;
            }
            addVertex(e1, t1, r) {
                let n = e1[2];
                null != r && (n *= r);
                const i = `${e1[0]},${e1[1]},${e1[2]},${t1[0]},${t1[1]},${t1[2]}`, s = this.vertexLookup.get(i);
                if (null != s) return s;
                const a = this.outPositions.length;
                this.vertexLookup.set(i, a);
                const o = Math.trunc(16384 * t1[0]), l = Math.trunc(16384 * t1[1]), u = Math.trunc(16384 * t1[2]);
                return this.outPositions.emplaceBack(e1[0], e1[1], n), this.outNormals.emplaceBack(o, l, u), a;
            }
            addTriangle(e1, t1, r) {
                this.outIndices.emplaceBack(e1, t1, r);
            }
            addTriangles(e1, t1, r) {
                if (0 === e1.length) return;
                const n = 1 === r.length, i = _(), s = _();
                for(let a = 0; a < e1.length; a += 3){
                    const o = t1[e1[a + 0]], l = t1[e1[a + 1]], u = t1[e1[a + 2]], c = n ? r[0] : r[e1[a + 1]], h = n ? r[0] : r[e1[a + 2]];
                    B(i, o.x, o.y, n ? r[0] : r[e1[a + 0]]);
                    const d = this.addVertex(i, s);
                    B(i, l.x, l.y, c);
                    const p = this.addVertex(i, s);
                    B(i, u.x, u.y, h);
                    const f = this.addVertex(i, s);
                    this.outIndices.emplaceBack(d, p, f);
                }
            }
            addQuad(e1, t1, r, n, i, s) {
                const a = this.addVertex(e1, i, s), o = this.addVertex(t1, i, s), l = this.addVertex(r, i, s), u = this.addVertex(n, i, s);
                this.addTriangle(a, o, l), this.addTriangle(l, u, a);
            }
            getVertexCount() {
                return this.outPositions.length;
            }
            clearVertexLookup() {
                this.vertexLookup.clear();
            }
        }
        class Ud {
            constructor(e1, t1, r, n){
                this.unevaluatedPortals = new Ld, this.bridgeFeatureSections = [], this.tunnelFeatureSections = [], this.vertexHashLookup = new Map, this.unevalVertices = [], this.unevalHeights = [], this.unevalTriangles = [], this.unevalTunnelTriangles = [], this.unevalEdges = [], this.vertexPositions = new Jo, this.vertexNormals = new Ko, this.indexArray = new ml, this.tileToMeters = Yu(e1), this.bridgeProgramConfigurations = new _u(t1, {
                    zoom: r,
                    lut: n
                }, (e1)=>"fill-tunnel-structure-color" !== e1), this.tunnelProgramConfigurations = new _u(t1, {
                    zoom: r,
                    lut: n
                }, (e1)=>"fill-bridge-guard-rail-color" !== e1);
            }
            addVertices(e1, t1) {
                const r = this.unevalVertices.length;
                for(let r = 0; r < e1.length; r++)this.unevalVertices.push(e1[r]), this.unevalHeights.push(t1[r]);
                return r;
            }
            addTriangles(e1, t1, r) {
                const n = r ? this.unevalTunnelTriangles : this.unevalTriangles;
                for (const r of e1)n.push(r + t1);
            }
            addRenderableRing(e1, t1, r, n, i, s) {
                const a = [
                    new Me(i.min.x, i.min.y),
                    new Me(i.max.x, i.min.y),
                    new Me(i.max.x, i.max.y),
                    new Me(i.min.x, i.max.y)
                ];
                for(let o = 0; o < r - 1; o++){
                    const r = t1 + o, l = r + 1, u = this.unevalVertices[r], c = this.unevalVertices[l];
                    if (!(u.x >= i.min.x && u.x <= i.max.x && u.y >= i.min.y && u.y <= i.max.y || c.x >= i.min.x && c.x <= i.max.x && c.y >= i.min.y && c.y <= i.max.y || Zc(u, c, a))) continue;
                    if (this.isOnBorder(u.x, c.x) || this.isOnBorder(u.y, c.y)) continue;
                    const h = Ud.computeEdgeHash(this.unevalVertices[r], this.unevalVertices[l]);
                    let d, p = this.vertexHashLookup.get(Ud.computePosHash(u));
                    null != p ? d = p.next : (p = this.vertexHashLookup.get(Ud.computePosHash(c)), d = null != p ? p.prev : h), this.unevalEdges.push({
                        polygonIdx: e1,
                        a: r,
                        b: l,
                        hash: h,
                        portalHash: d,
                        isTunnel: n,
                        type: "unevaluated",
                        featureInfo: s
                    });
                }
            }
            addPortalCandidates(e1, t1, r, n, i) {
                if (0 !== t1.length) {
                    this.vertexHashLookup.clear();
                    for (const i of t1){
                        if (0 === i.length) continue;
                        const t1 = i[0];
                        let s = Ud.computeEdgeHash(t1[t1.length - 2], t1[t1.length - 1]);
                        for(let i = 0; i < t1.length - 1; i++){
                            const a = t1[i + 0], o = t1[i + 1], l = he(o.x - a.x, o.y - a.y), u = ye(l);
                            if (0 === u) continue;
                            let c = "unevaluated";
                            const h = n.pointElevation(a), d = n.pointElevation(o);
                            Math.abs(h) < .01 && Math.abs(d) < .01 ? c = "entrance" : (this.isOnBorder(a.x, o.x) || this.isOnBorder(a.y, o.y)) && (c = "border");
                            const p = Ud.computeEdgeHash(a, o);
                            this.unevaluatedPortals.portals.push({
                                connection: {
                                    a: e1,
                                    b: void 0
                                },
                                va: a,
                                vb: o,
                                vab: l,
                                length: u,
                                hash: p,
                                isTunnel: r,
                                type: c
                            });
                            const f = Ud.computePosHash(a);
                            this.vertexHashLookup.set(f, {
                                prev: s,
                                next: p
                            }), s = p;
                        }
                    }
                }
            }
            construct(e1) {
                if (0 === this.unevalVertices.length) return;
                const t1 = ()=>({
                        vertexOffset: 0,
                        primitiveOffset: this.indexArray.length
                    }), r = (e1)=>{
                    e1.primitiveLength = this.indexArray.length - e1.primitiveOffset;
                }, n = new Od(this.vertexPositions, this.vertexNormals, this.indexArray);
                this.prepareEdges(e1.portals, this.unevalEdges);
                const i = t1(), s = t1(), a = t1(), o = (e1, t1)=>{
                    e1.sort((e1, r)=>e1.type === t1 && r.type !== t1 ? -1 : e1.type !== t1 && r.type === t1 ? 1 : 0);
                    const r = e1.findIndex((e1)=>e1.type !== t1);
                    return r >= 0 ? r : e1.length;
                };
                let l = 0;
                this.unevalEdges.length > 0 && (l = o(this.unevalEdges, "none"), this.constructBridgeStructures(n, this.unevalVertices, this.unevalHeights, this.unevalEdges, {
                    min: 0,
                    max: l
                }, this.tileToMeters)), r(a);
                const u = t1(), c = t1();
                if (this.unevalEdges.length > 0) {
                    const e1 = this.unevalEdges.splice(l), t1 = o(e1, "tunnel") + l;
                    this.unevalEdges.push(...e1), this.constructTunnelStructures(n, this.unevalVertices, this.unevalHeights, this.unevalEdges, {
                        min: 0,
                        max: l
                    }, {
                        min: l,
                        max: t1
                    });
                }
                r(u), n.addTriangles(this.unevalTriangles, this.unevalVertices, this.unevalHeights), r(c), n.addTriangles(this.unevalTunnelTriangles, this.unevalVertices, this.unevalHeights), r(s), n.addTriangles(this.unevalTunnelTriangles, this.unevalVertices, [
                    -0.1
                ]), r(i), this.maskSegments = Hl.simpleSegment(0, c.primitiveOffset, 0, c.primitiveLength), this.depthSegments = Hl.simpleSegment(0, s.primitiveOffset, 0, s.primitiveLength), this.renderableBridgeSegments = Hl.simpleSegment(0, a.primitiveOffset, 0, a.primitiveLength), this.renderableTunnelSegments = Hl.simpleSegment(0, u.primitiveOffset, 0, u.primitiveLength), this.shadowCasterSegments = Hl.simpleSegment(0, i.primitiveOffset, 0, i.primitiveLength);
            }
            update(e1, t1, r, n, i, s, a, o) {
                this.bridgeProgramConfigurations.updatePaintArrays(e1, t1, i, r, n, s, a, o), this.tunnelProgramConfigurations.updatePaintArrays(e1, t1, i, r, n, s, a, o);
            }
            upload(e1) {
                this.vertexBuffer || 0 === this.vertexPositions.length || 0 === this.vertexNormals.length || 0 === this.indexArray.length || (this.vertexBuffer = e1.createVertexBuffer(this.vertexPositions, sd.members), this.vertexBufferNormal = e1.createVertexBuffer(this.vertexNormals, ad.members), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.bridgeProgramConfigurations.upload(e1), this.tunnelProgramConfigurations.upload(e1));
            }
            destroy() {
                this.vertexBuffer && (this.vertexBuffer.destroy(), this.vertexBufferNormal.destroy(), this.indexBuffer.destroy()), this.maskSegments && (this.maskSegments.destroy(), this.depthSegments.destroy(), this.renderableBridgeSegments.destroy(), this.renderableTunnelSegments.destroy(), this.shadowCasterSegments.destroy()), this.bridgeProgramConfigurations.destroy(), this.tunnelProgramConfigurations.destroy();
            }
            populatePaintArrays(e1, t1, r, n, i) {
                const s = (s, a)=>{
                    for(let o = 0; o < a.length - 1; o++){
                        const l = a[o].featureIndex, u = a[o + 1].vertexStart, c = e1.feature(l);
                        s.populatePaintArrays(u, c, l, {}, r, t1, n, void 0, i);
                    }
                };
                s(this.bridgeProgramConfigurations, this.bridgeFeatureSections), s(this.tunnelProgramConfigurations, this.tunnelFeatureSections);
            }
            computeVertexConnections(e1, t1, r, n, i) {
                const s = new Map;
                for(let a = n; a < i; a++){
                    const n = r[a], i = n.a, o = n.b, l = Ud.computePosHash(e1[i]), u = Ud.computePosHash(e1[o]);
                    let c = s.get(l);
                    c || (c = {}, s.set(l, c));
                    let h = s.get(u);
                    h || (h = {}, s.set(u, h)), t1[i] <= 0 && t1[o] <= 0 || (c.to = o, h.from = i);
                }
                return s;
            }
            isTerminalVertex(e1, t1) {
                const r = Ud.computePosHash(this.unevalVertices[e1]), n = t1.get(r);
                return !n || !n.from || !n.to;
            }
            constructBridgeStructures(e1, t1, r, n, i, s) {
                e1.clearVertexLookup();
                const a = this.computeVertexConnections(t1, r, n, i.min, i.max), o = 1 / s, l = .5 * o, u = (e1, n)=>B(e1, t1[n].x, t1[n].y, r[n] * o), c = _(), h = _(), d = _(), p = _(), f = _(), m = (e1, r)=>{
                    const n = a.get(Ud.computePosHash(t1[r])), i = n.from, s = n.to;
                    if (!i || !s) return;
                    u(c, i), u(h, r), u(d, s), q(p), H(c, h) || (X(f, h, c), L(p, f)), H(d, h) || (X(f, d, h), S(p, p, L(f, f)));
                    const o = W(p);
                    return o > 0 ? V(e1, p, 1 / o) : void 0;
                };
                let y = Number.POSITIVE_INFINITY;
                this.sortSubarray(n, i.min, i.max, (e1, t1)=>e1.featureInfo.featureIndex - t1.featureInfo.featureIndex);
                const g = _(), x = _(), v = _(), b = _(), w = _(), A = _(), I = _(), M = _(), P = _(), T = [
                    _(),
                    _(),
                    _(),
                    _()
                ], z = [
                    _(),
                    _(),
                    _(),
                    _()
                ], k = [
                    {
                        coord: new Me(0, 0),
                        height: 0
                    },
                    {
                        coord: new Me(0, 0),
                        height: 0
                    }
                ], F = (e1, t1)=>e1 > t1;
                for(let u = i.min; u < i.max; u++){
                    const i = n[u];
                    if (!i.featureInfo.guardRailEnabled) continue;
                    if (!this.prepareEdgePoints(k, t1, r, i, F)) continue;
                    const [c, h] = k;
                    if (B(g, c.coord.x, c.coord.y, o * c.height), B(x, h.coord.x, h.coord.y, o * h.height), H(g, x)) continue;
                    X(v, x, g), L(v, v);
                    const d = m(M, i.a) || v, p = m(P, i.b) || v;
                    B(b, d[1], -d[0], 0), L(b, b), B(w, p[1], -p[0], 0), L(w, w), U(M, b, d), L(A, M), U(M, w, p), L(I, M), S(T[0], g, V(M, X(M, b, A), l)), S(T[1], g, V(M, S(M, b, A), l)), S(T[2], g, V(M, A, l)), T[3] = g, S(z[0], x, V(M, X(M, w, I), l)), S(z[1], x, V(M, S(M, w, I), l)), S(z[2], x, V(M, I, l)), z[3] = x, y = this.addFeatureSection(i.featureInfo.featureIndex, y, this.bridgeFeatureSections, e1);
                    const f = e1.addVertex(T[0], b, s), _ = e1.addVertex(T[1], b, s), D = e1.addVertex(z[0], w, s), E = e1.addVertex(z[1], w, s);
                    e1.addTriangle(f, _, D), e1.addTriangle(_, E, D);
                    const C = e1.addVertex(T[1], A, s), O = e1.addVertex(T[2], A, s), N = e1.addVertex(z[1], I, s), j = e1.addVertex(z[2], I, s);
                    e1.addTriangle(C, O, N), e1.addTriangle(O, j, N), R(b, b), R(w, w);
                    const G = e1.addVertex(T[2], b, s), $ = e1.addVertex(T[3], b, s), q = e1.addVertex(z[2], w, s), Z = e1.addVertex(z[3], w, s);
                    e1.addTriangle(G, $, q), e1.addTriangle($, Z, q);
                    const W = this.isTerminalVertex(i.a, a), Y = this.isTerminalVertex(i.b, a);
                    c.height < .01 && W && e1.addQuad(T[3], T[2], T[1], T[0], R(d, d), s), h.height < .01 && Y && e1.addQuad(z[0], z[1], z[2], z[3], p, s);
                }
                this.bridgeFeatureSections.push({
                    featureIndex: Number.POSITIVE_INFINITY,
                    vertexStart: e1.getVertexCount()
                });
            }
            constructTunnelStructures(e1, t1, r, n, i, s) {
                e1.clearVertexLookup();
                let a = Number.POSITIVE_INFINITY;
                const o = (e1, t1)=>e1.featureInfo.featureIndex - t1.featureInfo.featureIndex;
                this.sortSubarray(n, i.min, i.max, o), this.sortSubarray(n, s.min, s.max, o);
                const l = (e1)=>L(e1, e1), u = [
                    {
                        coord: new Me(0, 0),
                        height: 0
                    },
                    {
                        coord: new Me(0, 0),
                        height: 0
                    }
                ], c = (e1, t1)=>e1 < t1, h = _(), d = _(), p = _(), f = _(), m = _();
                for(let s = i.min; s < i.max; s++){
                    if (!this.prepareEdgePoints(u, t1, r, n[s], c)) continue;
                    const [i, o] = u, y = l(B(m, -(o.coord.y - i.coord.y), o.coord.x - i.coord.x, 0));
                    a = this.addFeatureSection(n[s].featureInfo.featureIndex, a, this.tunnelFeatureSections, e1), e1.addQuad(B(h, i.coord.x, i.coord.y, i.height), B(d, o.coord.x, o.coord.y, o.height), B(p, o.coord.x, o.coord.y, n[s].isTunnel ? -0.1 : 0), B(f, i.coord.x, i.coord.y, n[s].isTunnel ? -0.1 : 0), y);
                }
                for(let i = s.min; i < s.max; i++){
                    const s = n[i];
                    s.isTunnel && ([s.a, s.b] = [
                        s.b,
                        s.a
                    ]);
                    const o = t1[s.a], u = t1[s.b], c = l(B(m, -(u.y - o.y), u.x - o.x, 0));
                    a = this.addFeatureSection(s.featureInfo.featureIndex, a, this.tunnelFeatureSections, e1), e1.addQuad(B(h, u.x, u.y, 0), B(d, o.x, o.y, 0), B(p, o.x, o.y, r[s.a] + 4), B(f, u.x, u.y, r[s.b] + 4), c), e1.addQuad(B(h, o.x, o.y, 0), B(d, u.x, u.y, 0), B(p, u.x, u.y, r[s.b] + 4), B(f, o.x, o.y, r[s.a] + 4), c);
                }
                this.tunnelFeatureSections.push({
                    featureIndex: Number.POSITIVE_INFINITY,
                    vertexStart: e1.getVertexCount()
                });
            }
            setElevatedPoint(e1, t1, r, n) {
                e1.coord.x = t1, e1.coord.y = r, e1.height = n;
            }
            prepareEdgePoints(e1, t1, r, n, i) {
                let s = t1[n.a].x, a = t1[n.a].y, o = t1[n.b].x, l = t1[n.b].y, u = r[n.a], c = r[n.b];
                const h = i(u, 0), d = i(c, 0);
                if (h && d) return this.setElevatedPoint(e1[0], s, a, u), this.setElevatedPoint(e1[1], o, l, c), !0;
                if (!h && !d) return !1;
                if (h) {
                    if (!d) {
                        const e1 = c / (c - u);
                        o = yr(o, s, e1), l = yr(l, a, e1), c = yr(c, u, e1);
                    }
                } else {
                    const e1 = u / (u - c);
                    s = yr(s, o, e1), a = yr(a, l, e1), u = yr(u, c, e1);
                }
                return this.setElevatedPoint(e1[0], s, a, u), this.setElevatedPoint(e1[1], o, l, c), !0;
            }
            prepareEdges(e1, t1) {
                if (0 === t1.length) return;
                t1.sort((e1, t1)=>e1.hash === t1.hash ? t1.polygonIdx - e1.polygonIdx : t1.hash > e1.hash ? 1 : -1);
                let r = 0, n = 0, i = 0, s = t1[r].polygonIdx;
                do n++, (n === t1.length || t1[r].hash !== t1[n].hash) && ((1 === n - r || t1[n - 1].polygonIdx !== s) && (i < r && (t1[i] = t1[r], t1[r] = null), t1[i].type = "none", i++), r = n, r !== t1.length && (s = t1[r].polygonIdx));
                while (r !== t1.length);
                if (t1.splice(i), 0 !== t1.length && 0 !== e1.length) {
                    t1.sort((e1, t1)=>e1.portalHash < t1.portalHash ? 1 : -1);
                    let r = 0, n = 0;
                    for(; r !== t1.length && n !== e1.length;){
                        const i = t1[r], s = e1[n];
                        i.portalHash > s.hash ? r++ : s.hash > i.portalHash ? n++ : (i.type = s.type, r++);
                    }
                }
            }
            isOnBorder(e1, t1) {
                return e1 <= 0 && t1 <= 0 || e1 >= qn && t1 >= qn;
            }
            addFeatureSection(e1, t1, r, n) {
                return e1 !== t1 && (t1 = e1, r.push({
                    featureIndex: e1,
                    vertexStart: n.getVertexCount()
                }), n.clearVertexLookup()), t1;
            }
            sortSubarray(e1, t1, r, n) {
                const i = e1.slice(t1, r);
                i.sort(n), e1.splice(t1, i.length, ...i);
            }
            static computeEdgeHash(e1, t1) {
                return (e1.y === t1.y && e1.x > t1.x || e1.y > t1.y) && ([e1, t1] = [
                    t1,
                    e1
                ]), BigInt(Ud.computePosHash(e1)) << 32n | BigInt(Ud.computePosHash(t1));
            }
            static computePosHash(e1) {
                return ((65535 & e1.x) << 16 | 65535 & e1.y) >>> 0;
            }
        }
        function Nd(e1, t1) {
            return e1 > t1 ? 1 : e1 < t1 ? -1 : 0;
        }
        class jd {
            constructor(e1 = Nd, t1 = !1){
                this._compare = e1, this._root = null, this._size = 0, this._noDuplicates = !!t1;
            }
            rotateLeft(e1) {
                var t1 = e1.right;
                t1 && (e1.right = t1.left, t1.left && (t1.left.parent = e1), t1.parent = e1.parent), e1.parent ? e1 === e1.parent.left ? e1.parent.left = t1 : e1.parent.right = t1 : this._root = t1, t1 && (t1.left = e1), e1.parent = t1;
            }
            rotateRight(e1) {
                var t1 = e1.left;
                t1 && (e1.left = t1.right, t1.right && (t1.right.parent = e1), t1.parent = e1.parent), e1.parent ? e1 === e1.parent.left ? e1.parent.left = t1 : e1.parent.right = t1 : this._root = t1, t1 && (t1.right = e1), e1.parent = t1;
            }
            _splay(e1) {
                for(; e1.parent;){
                    var t1 = e1.parent;
                    t1.parent ? t1.left === e1 && t1.parent.left === t1 ? (this.rotateRight(t1.parent), this.rotateRight(t1)) : t1.right === e1 && t1.parent.right === t1 ? (this.rotateLeft(t1.parent), this.rotateLeft(t1)) : t1.left === e1 && t1.parent.right === t1 ? (this.rotateRight(t1), this.rotateLeft(t1)) : (this.rotateLeft(t1), this.rotateRight(t1)) : t1.left === e1 ? this.rotateRight(t1) : this.rotateLeft(t1);
                }
            }
            splay(e1) {
                for(var t1, r, n, i, s; e1.parent;)(r = (t1 = e1.parent).parent) && r.parent ? ((n = r.parent).left === r ? n.left = e1 : n.right = e1, e1.parent = n) : (e1.parent = null, this._root = e1), i = e1.left, s = e1.right, e1 === t1.left ? (r && (r.left === t1 ? (t1.right ? (r.left = t1.right, r.left.parent = r) : r.left = null, t1.right = r, r.parent = t1) : (i ? (r.right = i, i.parent = r) : r.right = null, e1.left = r, r.parent = e1)), s ? (t1.left = s, s.parent = t1) : t1.left = null, e1.right = t1, t1.parent = e1) : (r && (r.right === t1 ? (t1.left ? (r.right = t1.left, r.right.parent = r) : r.right = null, t1.left = r, r.parent = t1) : (s ? (r.left = s, s.parent = r) : r.left = null, e1.right = r, r.parent = e1)), i ? (t1.right = i, i.parent = t1) : t1.right = null, e1.left = t1, t1.parent = e1);
            }
            replace(e1, t1) {
                e1.parent ? e1 === e1.parent.left ? e1.parent.left = t1 : e1.parent.right = t1 : this._root = t1, t1 && (t1.parent = e1.parent);
            }
            minNode(e1 = this._root) {
                if (e1) for(; e1.left;)e1 = e1.left;
                return e1;
            }
            maxNode(e1 = this._root) {
                if (e1) for(; e1.right;)e1 = e1.right;
                return e1;
            }
            insert(e1, t1) {
                var r = this._root, n = null, i = this._compare;
                if (this._noDuplicates) for(; r;){
                    if (n = r, 0 === i(r.key, e1)) return;
                    r = i(r.key, e1) < 0 ? r.right : r.left;
                }
                else for(; r;)n = r, r = i(r.key, e1) < 0 ? r.right : r.left;
                return r = {
                    key: e1,
                    data: t1,
                    left: null,
                    right: null,
                    parent: n
                }, n ? i(n.key, r.key) < 0 ? n.right = r : n.left = r : this._root = r, this.splay(r), this._size++, r;
            }
            find(e1) {
                for(var t1 = this._root, r = this._compare; t1;){
                    var n = r(t1.key, e1);
                    if (n < 0) t1 = t1.right;
                    else {
                        if (!(n > 0)) return t1;
                        t1 = t1.left;
                    }
                }
                return null;
            }
            contains(e1) {
                for(var t1 = this._root, r = this._compare; t1;){
                    var n = r(e1, t1.key);
                    if (0 === n) return !0;
                    t1 = n < 0 ? t1.left : t1.right;
                }
                return !1;
            }
            remove(e1) {
                var t1 = this.find(e1);
                if (!t1) return !1;
                if (this.splay(t1), t1.left) {
                    if (t1.right) {
                        var r = this.minNode(t1.right);
                        r.parent !== t1 && (this.replace(r, r.right), r.right = t1.right, r.right.parent = r), this.replace(t1, r), r.left = t1.left, r.left.parent = r;
                    } else this.replace(t1, t1.left);
                } else this.replace(t1, t1.right);
                return this._size--, !0;
            }
            removeNode(e1) {
                if (!e1) return !1;
                if (this.splay(e1), e1.left) {
                    if (e1.right) {
                        var t1 = this.minNode(e1.right);
                        t1.parent !== e1 && (this.replace(t1, t1.right), t1.right = e1.right, t1.right.parent = t1), this.replace(e1, t1), t1.left = e1.left, t1.left.parent = t1;
                    } else this.replace(e1, e1.left);
                } else this.replace(e1, e1.right);
                return this._size--, !0;
            }
            erase(e1) {
                var t1 = this.find(e1);
                if (t1) {
                    this.splay(t1);
                    var r = t1.left, n = t1.right, i = null;
                    r && (r.parent = null, i = this.maxNode(r), this.splay(i), this._root = i), n && (r ? i.right = n : this._root = n, n.parent = i), this._size--;
                }
            }
            pop() {
                var e1 = this._root, t1 = null;
                if (e1) {
                    for(; e1.left;)e1 = e1.left;
                    t1 = {
                        key: e1.key,
                        data: e1.data
                    }, this.remove(e1.key);
                }
                return t1;
            }
            next(e1) {
                var t1 = e1;
                if (t1) {
                    if (t1.right) for(t1 = t1.right; t1 && t1.left;)t1 = t1.left;
                    else for(t1 = e1.parent; t1 && t1.right === e1;)e1 = t1, t1 = t1.parent;
                }
                return t1;
            }
            prev(e1) {
                var t1 = e1;
                if (t1) {
                    if (t1.left) for(t1 = t1.left; t1 && t1.right;)t1 = t1.right;
                    else for(t1 = e1.parent; t1 && t1.left === e1;)e1 = t1, t1 = t1.parent;
                }
                return t1;
            }
            forEach(e1) {
                for(var t1 = this._root, r = [], n = !1, i = 0; !n;)t1 ? (r.push(t1), t1 = t1.left) : r.length > 0 ? (e1(t1 = r.pop(), i++), t1 = t1.right) : n = !0;
                return this;
            }
            range(e1, t1, r, n) {
                const i = [], s = this._compare;
                let a, o = this._root;
                for(; 0 !== i.length || o;)if (o) i.push(o), o = o.left;
                else {
                    if (o = i.pop(), a = s(o.key, t1), a > 0) break;
                    if (s(o.key, e1) >= 0 && r.call(n, o)) return this;
                    o = o.right;
                }
                return this;
            }
            keys() {
                for(var e1 = this._root, t1 = [], r = [], n = !1; !n;)e1 ? (t1.push(e1), e1 = e1.left) : t1.length > 0 ? (e1 = t1.pop(), r.push(e1.key), e1 = e1.right) : n = !0;
                return r;
            }
            values() {
                for(var e1 = this._root, t1 = [], r = [], n = !1; !n;)e1 ? (t1.push(e1), e1 = e1.left) : t1.length > 0 ? (e1 = t1.pop(), r.push(e1.data), e1 = e1.right) : n = !0;
                return r;
            }
            at(e1) {
                for(var t1 = this._root, r = [], n = !1, i = 0; !n;)if (t1) r.push(t1), t1 = t1.left;
                else if (r.length > 0) {
                    if (t1 = r.pop(), i === e1) return t1;
                    i++, t1 = t1.right;
                } else n = !0;
                return null;
            }
            load(e1 = [], t1 = [], r = !1) {
                if (0 !== this._size) throw new Error("bulk-load: tree is not empty");
                const n = e1.length;
                return r && $d(e1, t1, 0, n - 1, this._compare), this._root = Gd(null, e1, t1, 0, n), this._size = n, this;
            }
            min() {
                var e1 = this.minNode(this._root);
                return e1 ? e1.key : null;
            }
            max() {
                var e1 = this.maxNode(this._root);
                return e1 ? e1.key : null;
            }
            isEmpty() {
                return null === this._root;
            }
            get size() {
                return this._size;
            }
            static createTree(e1, t1, r, n, i) {
                return new jd(r, i).load(e1, t1, n);
            }
        }
        function Gd(e1, t1, r, n, i) {
            const s = i - n;
            if (s > 0) {
                const a = n + Math.floor(s / 2), o = {
                    key: t1[a],
                    data: r[a],
                    parent: e1
                };
                return o.left = Gd(o, t1, r, n, a), o.right = Gd(o, t1, r, a + 1, i), o;
            }
            return null;
        }
        function $d(e1, t1, r, n, i) {
            if (r >= n) return;
            const s = e1[r + n >> 1];
            let a = r - 1, o = n + 1;
            for(;;){
                do a++;
                while (i(e1[a], s) < 0);
                do o--;
                while (i(e1[o], s) > 0);
                if (a >= o) break;
                let r = e1[a];
                e1[a] = e1[o], e1[o] = r, r = t1[a], t1[a] = t1[o], t1[o] = r;
            }
            $d(e1, t1, r, o, i), $d(e1, t1, o + 1, n, i);
        }
        const qd = 11102230246251565e-32, Hd = 134217729, Xd = (3 + 8 * qd) * qd;
        function Zd(e1, t1, r, n, i) {
            let s, a, o, l, u = t1[0], c = n[0], h = 0, d = 0;
            c > u == c > -u ? (s = u, u = t1[++h]) : (s = c, c = n[++d]);
            let p = 0;
            if (h < e1 && d < r) for(c > u == c > -u ? (a = u + s, o = s - (a - u), u = t1[++h]) : (a = c + s, o = s - (a - c), c = n[++d]), s = a, 0 !== o && (i[p++] = o); h < e1 && d < r;)c > u == c > -u ? (a = s + u, l = a - s, o = s - (a - l) + (u - l), u = t1[++h]) : (a = s + c, l = a - s, o = s - (a - l) + (c - l), c = n[++d]), s = a, 0 !== o && (i[p++] = o);
            for(; h < e1;)a = s + u, l = a - s, o = s - (a - l) + (u - l), u = t1[++h], s = a, 0 !== o && (i[p++] = o);
            for(; d < r;)a = s + c, l = a - s, o = s - (a - l) + (c - l), c = n[++d], s = a, 0 !== o && (i[p++] = o);
            return 0 === s && 0 !== p || (i[p++] = s), p;
        }
        function Wd(e1) {
            return new Float64Array(e1);
        }
        const Yd = Wd(4), Jd = Wd(8), Kd = Wd(12), Qd = Wd(16), ep = Wd(4);
        function tp(e1, t1, r) {
            null === t1 ? (e1.inOut = !1, e1.otherInOut = !0) : (e1.isSubject === t1.isSubject ? (e1.inOut = !t1.inOut, e1.otherInOut = t1.otherInOut) : (e1.inOut = !t1.otherInOut, e1.otherInOut = t1.isVertical() ? !t1.inOut : t1.inOut), t1 && (e1.prevInResult = !rp(t1, r) || t1.isVertical() ? t1.prevInResult : t1)), e1.resultTransition = rp(e1, r) ? function(e1, t1) {
                let r, n = !e1.inOut, i = !e1.otherInOut;
                switch(t1){
                    case 0:
                        r = n && i;
                        break;
                    case 1:
                        r = n || i;
                        break;
                    case 3:
                        r = n !== i;
                        break;
                    case 2:
                        r = e1.isSubject ? n && !i : i && !n;
                }
                return r ? 1 : -1;
            }(e1, r) : 0;
        }
        function rp(e1, t1) {
            switch(e1.type){
                case 0:
                    switch(t1){
                        case 0:
                            return !e1.otherInOut;
                        case 1:
                            return e1.otherInOut;
                        case 2:
                            return e1.isSubject && e1.otherInOut || !e1.isSubject && !e1.otherInOut;
                        case 3:
                            return !0;
                    }
                    break;
                case 2:
                    return 0 === t1 || 1 === t1;
                case 3:
                    return 2 === t1;
                case 1:
                    return !1;
            }
            return !1;
        }
        class np {
            constructor(e1, t1, r, n, i){
                this.left = t1, this.point = e1, this.otherEvent = r, this.isSubject = n ?? !1, this.type = i || 0, this.inOut = !1, this.otherInOut = !1, this.prevInResult = null, this.resultTransition = 0, this.otherPos = -1, this.outputContourId = -1, this.isExteriorRing = !0;
            }
            isBelow(e1) {
                const t1 = this.point, r = this.otherEvent.point;
                return this.left ? (t1[0] - e1[0]) * (r[1] - e1[1]) - (r[0] - e1[0]) * (t1[1] - e1[1]) > 0 : (r[0] - e1[0]) * (t1[1] - e1[1]) - (t1[0] - e1[0]) * (r[1] - e1[1]) > 0;
            }
            isAbove(e1) {
                return !this.isBelow(e1);
            }
            isVertical() {
                return this.point[0] === this.otherEvent.point[0];
            }
            get inResult() {
                return 0 !== this.resultTransition;
            }
            clone() {
                const e1 = new np(this.point, this.left, this.otherEvent, this.isSubject, this.type);
                return e1.contourId = this.contourId, e1.resultTransition = this.resultTransition, e1.prevInResult = this.prevInResult, e1.isExteriorRing = this.isExteriorRing, e1.inOut = this.inOut, e1.otherInOut = this.otherInOut, e1;
            }
        }
        function ip(e1, t1) {
            return e1[0] === t1[0] && e1[1] === t1[1];
        }
        function sp(e1, t1, r) {
            const n = function(e1, t1, r, n, i, s) {
                const a = (t1 - s) * (r - i), o = (e1 - i) * (n - s), l = a - o;
                if (0 === a || 0 === o || a > 0 != o > 0) return l;
                const u = Math.abs(a + o);
                return Math.abs(l) >= 33306690738754716e-32 * u ? l : -function(e1, t1, r, n, i, s, a) {
                    let o, l, u, c, h, d, p, f, m, y, g, x, v, b, w, _, A, I;
                    const M = e1 - i, B = r - i, S = t1 - s, P = n - s;
                    b = M * P, d = Hd * M, p = d - (d - M), f = M - p, d = Hd * P, m = d - (d - P), y = P - m, w = f * y - (b - p * m - f * m - p * y), _ = S * B, d = Hd * S, p = d - (d - S), f = S - p, d = Hd * B, m = d - (d - B), y = B - m, A = f * y - (_ - p * m - f * m - p * y), g = w - A, h = w - g, Yd[0] = w - (g + h) + (h - A), x = b + g, h = x - b, v = b - (x - h) + (g - h), g = v - _, h = v - g, Yd[1] = v - (g + h) + (h - _), I = x + g, h = I - x, Yd[2] = x - (I - h) + (g - h), Yd[3] = I;
                    let T = function(e1, t1) {
                        let r = t1[0];
                        for(let e1 = 1; e1 < 4; e1++)r += t1[e1];
                        return r;
                    }(0, Yd), z = 22204460492503146e-32 * a;
                    if (T >= z || -T >= z) return T;
                    if (h = e1 - M, o = e1 - (M + h) + (h - i), h = r - B, u = r - (B + h) + (h - i), h = t1 - S, l = t1 - (S + h) + (h - s), h = n - P, c = n - (P + h) + (h - s), 0 === o && 0 === l && 0 === u && 0 === c) return T;
                    if (z = 11093356479670487e-47 * a + Xd * Math.abs(T), T += M * c + P * o - (S * u + B * l), T >= z || -T >= z) return T;
                    b = o * P, d = Hd * o, p = d - (d - o), f = o - p, d = Hd * P, m = d - (d - P), y = P - m, w = f * y - (b - p * m - f * m - p * y), _ = l * B, d = Hd * l, p = d - (d - l), f = l - p, d = Hd * B, m = d - (d - B), y = B - m, A = f * y - (_ - p * m - f * m - p * y), g = w - A, h = w - g, ep[0] = w - (g + h) + (h - A), x = b + g, h = x - b, v = b - (x - h) + (g - h), g = v - _, h = v - g, ep[1] = v - (g + h) + (h - _), I = x + g, h = I - x, ep[2] = x - (I - h) + (g - h), ep[3] = I;
                    const k = Zd(4, Yd, 4, ep, Jd);
                    b = M * c, d = Hd * M, p = d - (d - M), f = M - p, d = Hd * c, m = d - (d - c), y = c - m, w = f * y - (b - p * m - f * m - p * y), _ = S * u, d = Hd * S, p = d - (d - S), f = S - p, d = Hd * u, m = d - (d - u), y = u - m, A = f * y - (_ - p * m - f * m - p * y), g = w - A, h = w - g, ep[0] = w - (g + h) + (h - A), x = b + g, h = x - b, v = b - (x - h) + (g - h), g = v - _, h = v - g, ep[1] = v - (g + h) + (h - _), I = x + g, h = I - x, ep[2] = x - (I - h) + (g - h), ep[3] = I;
                    const V = Zd(k, Jd, 4, ep, Kd);
                    b = o * c, d = Hd * o, p = d - (d - o), f = o - p, d = Hd * c, m = d - (d - c), y = c - m, w = f * y - (b - p * m - f * m - p * y), _ = l * u, d = Hd * l, p = d - (d - l), f = l - p, d = Hd * u, m = d - (d - u), y = u - m, A = f * y - (_ - p * m - f * m - p * y), g = w - A, h = w - g, ep[0] = w - (g + h) + (h - A), x = b + g, h = x - b, v = b - (x - h) + (g - h), g = v - _, h = v - g, ep[1] = v - (g + h) + (h - _), I = x + g, h = I - x, ep[2] = x - (I - h) + (g - h), ep[3] = I;
                    const F = Zd(V, Kd, 4, ep, Qd);
                    return Qd[F - 1];
                }(e1, t1, r, n, i, s, u);
            }(e1[0], e1[1], t1[0], t1[1], r[0], r[1]);
            return n > 0 ? -1 : n < 0 ? 1 : 0;
        }
        function ap(e1, t1) {
            const r = e1.point, n = t1.point;
            return r[0] > n[0] ? 1 : r[0] < n[0] ? -1 : r[1] !== n[1] ? r[1] > n[1] ? 1 : -1 : function(e1, t1, r) {
                return e1.left !== t1.left ? e1.left ? 1 : -1 : 0 !== sp(r, e1.otherEvent.point, t1.otherEvent.point) ? e1.isBelow(t1.otherEvent.point) ? -1 : 1 : !e1.isSubject && t1.isSubject ? 1 : -1;
            }(e1, t1, r);
        }
        function op(e1, t1, r) {
            const n = new np(t1, !1, e1, e1.isSubject), i = new np(t1, !0, e1.otherEvent, e1.isSubject);
            return ip(e1.point, e1.otherEvent.point) && console.warn("what is that, a collapsed segment?", e1), n.contourId = i.contourId = e1.contourId, ap(i, e1.otherEvent) > 0 && (e1.otherEvent.left = !0, i.left = !1), e1.otherEvent.otherEvent = i, e1.otherEvent = n, r.push(i), r.push(n), r;
        }
        function lp(e1, t1) {
            return e1[0] * t1[1] - e1[1] * t1[0];
        }
        function up(e1, t1) {
            return e1[0] * t1[0] + e1[1] * t1[1];
        }
        function cp(e1, t1, r) {
            const n = function(e1, t1, r, n) {
                const i = [
                    t1[0] - e1[0],
                    t1[1] - e1[1]
                ], s = [
                    n[0] - r[0],
                    n[1] - r[1]
                ];
                function a(e1, t1, r) {
                    return [
                        e1[0] + t1 * r[0],
                        e1[1] + t1 * r[1]
                    ];
                }
                const o = [
                    r[0] - e1[0],
                    r[1] - e1[1]
                ];
                let l = lp(i, s), u = l * l;
                const c = up(i, i);
                if (u > 0) {
                    const t1 = lp(o, s) / l;
                    if (t1 < 0 || t1 > 1) return null;
                    const n = lp(o, i) / l;
                    return n < 0 || n > 1 ? null : 0 === t1 || 1 === t1 ? [
                        a(e1, t1, i)
                    ] : 0 === n || 1 === n ? [
                        a(r, n, s)
                    ] : [
                        a(e1, t1, i)
                    ];
                }
                if (l = lp(o, i), u = l * l, u > 0) return null;
                const h = up(i, o) / c, d = h + up(i, s) / c, p = Math.min(h, d), f = Math.max(h, d);
                return p <= 1 && f >= 0 ? 1 === p ? [
                    a(e1, p > 0 ? p : 0, i)
                ] : 0 === f ? [
                    a(e1, f < 1 ? f : 1, i)
                ] : [
                    a(e1, p > 0 ? p : 0, i),
                    a(e1, f < 1 ? f : 1, i)
                ] : null;
            }(e1.point, e1.otherEvent.point, t1.point, t1.otherEvent.point), i = n ? n.length : 0;
            if (0 === i || 1 === i && (ip(e1.point, t1.point) || ip(e1.otherEvent.point, t1.otherEvent.point)) || 2 === i && e1.isSubject === t1.isSubject) return 0;
            if (1 === i) return !ip(e1.point, n[0]) && !ip(e1.otherEvent.point, n[0]) && op(e1, n[0], r), !ip(t1.point, n[0]) && !ip(t1.otherEvent.point, n[0]) && op(t1, n[0], r), 1;
            const s = [];
            let a = !1, o = !1;
            return ip(e1.point, t1.point) ? a = !0 : 1 === ap(e1, t1) ? s.push(t1, e1) : s.push(e1, t1), ip(e1.otherEvent.point, t1.otherEvent.point) ? o = !0 : 1 === ap(e1.otherEvent, t1.otherEvent) ? s.push(t1.otherEvent, e1.otherEvent) : s.push(e1.otherEvent, t1.otherEvent), a && o || a ? (t1.type = 1, e1.type = t1.inOut === e1.inOut ? 2 : 3, a && !o && op(s[1].otherEvent, s[0].point, r), 2) : o ? (op(s[0], s[1].point, r), 3) : s[0] !== s[3].otherEvent ? (op(s[0], s[1].point, r), op(s[1], s[2].point, r), 3) : (op(s[0], s[1].point, r), op(s[3].otherEvent, s[2].point, r), 3);
        }
        function hp(e1, t1) {
            if (e1 === t1) return 0;
            if (0 !== sp(e1.point, e1.otherEvent.point, t1.point) || 0 !== sp(e1.point, e1.otherEvent.point, t1.otherEvent.point)) return ip(e1.point, t1.point) ? e1.isBelow(t1.otherEvent.point) ? -1 : 1 : e1.point[0] === t1.point[0] ? e1.point[1] < t1.point[1] ? -1 : 1 : 1 === ap(e1, t1) ? t1.isAbove(e1.point) ? -1 : 1 : e1.isBelow(t1.point) ? -1 : 1;
            if (e1.isSubject !== t1.isSubject) return e1.isSubject ? -1 : 1;
            {
                let r = e1.point, n = t1.point;
                if (r[0] === n[0] && r[1] === n[1]) return r = e1.otherEvent.point, n = t1.otherEvent.point, r[0] === n[0] && r[1] === n[1] ? 0 : (e1.contourId ?? 0) > (t1.contourId ?? 0) ? 1 : -1;
            }
            return 1 === ap(e1, t1) ? 1 : -1;
        }
        class dp {
            constructor(){
                this.points = [], this.holeIds = [], this.holeOf = null, this.depth = null;
            }
            isExterior() {
                return null == this.holeOf;
            }
        }
        function pp(e1, t1, r, n) {
            let i, s = e1 + 1, a = t1[e1].point;
            const o = t1.length;
            for(s < o && (i = t1[s].point); s < o && i[0] === a[0] && i[1] === a[1];){
                if (!r[s]) return s;
                s++, s < o && (i = t1[s].point);
            }
            for(s = e1 - 1; r[s] && s > n;)s--;
            return s;
        }
        function fp(e1, t1, r) {
            const n = new dp;
            if (null != e1.prevInResult) {
                const i = e1.prevInResult, s = i.outputContourId;
                if (i.resultTransition > 0) {
                    const e1 = t1[s];
                    if (null != e1.holeOf) {
                        const i = e1.holeOf;
                        t1[i].holeIds.push(r), n.holeOf = i, n.depth = t1[s].depth;
                    } else t1[s].holeIds.push(r), n.holeOf = s, n.depth = t1[s].depth + 1;
                } else n.holeOf = null, n.depth = t1[s].depth;
            } else n.holeOf = null, n.depth = 0;
            return n;
        }
        const mp = Math.max, yp = Math.min;
        let gp = 0;
        function xp(e1, t1, r, n, i, s) {
            let a, o, l, u, c, h;
            for(a = 0, o = e1.length - 1; a < o; a++){
                if (l = e1[a], u = e1[a + 1], c = new np(l, !1, void 0, t1), h = new np(u, !1, c, t1), c.otherEvent = h, l[0] === u[0] && l[1] === u[1]) continue;
                c.contourId = h.contourId = r, s || (c.isExteriorRing = !1, h.isExteriorRing = !1), ap(c, h) > 0 ? h.left = !0 : c.left = !0;
                const o = l[0], d = l[1];
                i[0] = yp(i[0], o), i[1] = yp(i[1], d), i[2] = mp(i[2], o), i[3] = mp(i[3], d), n.push(c), n.push(h);
            }
        }
        const vp = [];
        function bp(e1, t1, r) {
            let n = e1, i = t1;
            "number" == typeof e1[0][0][0] && (n = [
                e1
            ]), "number" == typeof t1[0][0][0] && (i = [
                t1
            ]);
            let s = function(e1, t1, r) {
                let n = null;
                return e1.length * t1.length === 0 && (0 === r ? n = vp : 2 === r ? n = e1 : (1 === r || 3 === r) && (n = 0 === e1.length ? t1 : e1)), n;
            }(n, i, r);
            if (s) return s === vp ? null : s;
            const a = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ], o = [
                1 / 0,
                1 / 0,
                -1 / 0,
                -1 / 0
            ], l = function(e1, t1, r, n, i) {
                const s = new $n(void 0, ap);
                let a, o, l, u, c, h;
                for(l = 0, u = e1.length; l < u; l++)for(a = e1[l], c = 0, h = a.length; c < h; c++)o = 0 === c, o && gp++, xp(a[c], !0, gp, s, r, o);
                for(l = 0, u = t1.length; l < u; l++)for(a = t1[l], c = 0, h = a.length; c < h; c++)o = 0 === c, 2 === i && (o = !1), o && gp++, xp(a[c], !1, gp, s, n, o);
                return s;
            }(n, i, a, o, r);
            if (s = function(e1, t1, r, n, i) {
                let s = null;
                return (r[0] > n[2] || n[0] > r[2] || r[1] > n[3] || n[1] > r[3]) && (0 === i ? s = vp : 2 === i ? s = e1 : (1 === i || 3 === i) && (s = e1.concat(t1))), s;
            }(n, i, a, o, r), s) return s === vp ? null : s;
            const u = function(e1, t1, r, n, i, s) {
                const a = new jd(hp), o = [], l = Math.min(n[2], i[2]);
                let u, c, h;
                for(; 0 !== e1.length;){
                    let t1 = e1.pop();
                    if (o.push(t1), 0 === s && t1.point[0] > l || 2 === s && t1.point[0] > n[2]) break;
                    if (t1.left) {
                        c = u = a.insert(t1), h = a.minNode(), u = u !== h ? a.prev(u) : null, c = a.next(c);
                        const r = u ? u.key : null;
                        let n;
                        if (tp(t1, r, s), c && 2 === cp(t1, c.key, e1) && (tp(t1, r, s), tp(c.key, t1, s)), u && 2 === cp(u.key, t1, e1)) {
                            let e1 = u;
                            e1 = e1 !== h ? a.prev(e1) : null, n = e1 ? e1.key : null, tp(r, n, s), tp(t1, r, s);
                        }
                    } else t1 = t1.otherEvent, c = u = a.find(t1), u && c && (u = u !== h ? a.prev(u) : null, c = a.next(c), a.remove(t1), c && u && cp(u.key, c.key, e1));
                }
                return o;
            }(l, 0, 0, a, o, r), c = function(e1) {
                let t1, r;
                const n = function(e1) {
                    let t1, r, n, i, s;
                    const a = [];
                    for(r = 0, n = e1.length; r < n; r++)t1 = e1[r], (t1.left && t1.inResult || !t1.left && t1.otherEvent.inResult) && a.push(t1);
                    let o = !1;
                    for(; !o;)for(o = !0, r = 0, n = a.length; r < n; r++)r + 1 < n && 1 === ap(a[r], a[r + 1]) && (i = a[r], a[r] = a[r + 1], a[r + 1] = i, o = !1);
                    for(r = 0, n = a.length; r < n; r++)t1 = a[r], t1.otherPos = r;
                    for(r = 0, n = a.length; r < n; r++)t1 = a[r], t1.left || (s = t1.otherPos, t1.otherPos = t1.otherEvent.otherPos, t1.otherEvent.otherPos = s);
                    return a;
                }(e1), i = {}, s = [];
                for(t1 = 0, r = n.length; t1 < r; t1++){
                    if (i[t1]) continue;
                    const e1 = s.length, r = fp(n[t1], s, e1), a = (t1)=>{
                        i[t1] = !0, t1 < n.length && n[t1] && (n[t1].outputContourId = e1);
                    };
                    let o = t1, l = t1;
                    for(r.points.push(n[t1].point); a(o), o = n[o].otherPos, a(o), r.points.push(n[o].point), o = pp(o, n, i, l), !(o == l || o >= n.length) && n[o];);
                    s.push(r);
                }
                return s;
            }(u), h = [];
            for(let e1 = 0; e1 < c.length; e1++){
                let t1 = c[e1];
                if (t1.isExterior()) {
                    let e1 = [
                        t1.points
                    ];
                    for(let r = 0; r < t1.holeIds.length; r++)e1.push(c[t1.holeIds[r]].points);
                    h.push(e1);
                }
            }
            return h;
        }
        function wp(e1, t1, r, n) {
            const i = [], s = 0 === n ? (e1, t1, r, n, i, s)=>{
                e1.push(new Me(s, r + (s - t1) / (n - t1) * (i - r)));
            } : (e1, t1, r, n, i, s)=>{
                e1.push(new Me(t1 + (s - r) / (i - r) * (n - t1), s));
            };
            for (const a of e1){
                const e1 = [];
                for (const i of a){
                    if (i.length <= 2) continue;
                    const a = [];
                    for(let e1 = 0; e1 < i.length - 1; e1++){
                        const o = i[e1].x, l = i[e1].y, u = i[e1 + 1].x, c = i[e1 + 1].y, h = 0 === n ? o : l, d = 0 === n ? u : c;
                        h < t1 ? d > t1 && s(a, o, l, u, c, t1) : h > r ? d < r && s(a, o, l, u, c, r) : a.push(i[e1]), d < t1 && h >= t1 && s(a, o, l, u, c, t1), d > r && h <= r && s(a, o, l, u, c, r);
                    }
                    let o = i[i.length - 1];
                    const l = 0 === n ? o.x : o.y;
                    l >= t1 && l <= r && a.push(o), a.length && (o = a[a.length - 1], a[0].x === o.x && a[0].y === o.y || a.push(a[0]), e1.push(a));
                }
                e1.length && i.push(e1);
            }
            return i;
        }
        function _p(e1, t1) {
            const r = bp(Ip(e1), Ip([
                t1
            ]), 0);
            return null == r ? [] : Mp(r);
        }
        function Ap(e1, t1, r = 0) {
            const n = 65536;
            let i = Ip(e1, n);
            const s = [];
            for(; t1.valid(); t1.next()){
                const [e1, i] = t1.get();
                let a = e1.x * n, o = e1.y * n, l = i.x * n, u = i.y * n;
                const c = l - a, h = u - o, d = Math.hypot(c, h);
                if (0 === d) continue;
                a -= c * r, o -= h * r, l += c * r, u += h * r;
                const p = Math.trunc(h / d * 3), f = -Math.trunc(c / d * 3);
                s.push([
                    [
                        [
                            a,
                            o
                        ],
                        [
                            l,
                            u
                        ],
                        [
                            l + p,
                            u + f
                        ],
                        [
                            a + p,
                            o + f
                        ],
                        [
                            a,
                            o
                        ]
                    ]
                ]);
            }
            return s.length > 0 && (i = bp(i, s, 2)), Mp(i, 1 / n, 128);
        }
        function Ip(e1, t1 = 1) {
            return [
                e1.map((e1)=>e1.map((e1)=>[
                            e1.x * t1,
                            e1.y * t1
                        ]))
            ];
        }
        function Mp(e1, t1 = 1, r) {
            return e1.map((e1)=>e1.map((e1, n)=>{
                    const i = e1.map((e1)=>{
                        let n = e1[0], i = e1[1];
                        return r && (n = Math.round(n / r) * r, i = Math.round(i / r) * r), new Me(n * t1, i * t1)._round();
                    });
                    return n > 0 && i.reverse(), i;
                }));
        }
        class Bp {
            constructor(e1, t1){
                this.layoutVertexArray = new Xo, this.indexArray = new ml, this.lineIndexArray = new cl, this.triangleSegments = new Hl, this.lineSegments = new Hl, this.programConfigurations = new _u(e1.layers, {
                    zoom: e1.zoom,
                    lut: e1.lut
                }), this.uploaded = !1, t1 && (this.elevatedLayoutVertexArray = new Yo);
            }
            update(e1, t1, r, n, i, s, a, o) {
                this.programConfigurations.updatePaintArrays(e1, t1, i, r, n, s, a, o);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            needsUpload() {
                return this.programConfigurations.needsUpload;
            }
            upload(e1) {
                this.uploaded || (this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, nd.members), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.lineIndexBuffer = e1.createIndexBuffer(this.lineIndexArray), this.elevatedLayoutVertexArray && this.elevatedLayoutVertexArray.length > 0 && (this.elevatedLayoutVertexBuffer = e1.createVertexBuffer(this.elevatedLayoutVertexArray, id.members))), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.elevatedLayoutVertexBuffer && this.elevatedLayoutVertexBuffer.destroy(), this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.lineIndexBuffer.destroy(), this.programConfigurations.destroy(), this.triangleSegments.destroy(), this.lineSegments.destroy());
            }
            populatePaintArrays(e1, t1, r, n, i, s, a) {
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e1, t1, r, n, i, s, void 0, a);
            }
        }
        class Sp {
            constructor(e1){
                this.zoom = e1.zoom, this.pixelRatio = e1.pixelRatio, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.hasPattern = !1, this.patternFeatures = [], this.lut = e1.lut, this.bufferData = new Bp(e1, !1), this.elevationBufferData = new Bp(e1, !0), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.projection = e1.projection, this.elevationMode = this.layers[0].layout.get("fill-elevation-reference"), this.sourceLayerIndex = e1.sourceLayerIndex, this.worldview = e1.worldview, this.hasAppearances = null;
            }
            updateFootprints(e1, t1) {}
            updateAppearances(e1, t1, r, n) {
                return {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
            }
            populate(e1, t1, r, n) {
                this.hasPattern = Cd("fill", this.layers, this.pixelRatio, t1);
                const i = this.layers[0].layout.get("fill-sort-key"), s = [];
                for (const { feature: a, id: o, index: l, sourceLayerIndex: u } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, c = ac(a, e1);
                    if (!this.layers[0]._featureFilter.filter(new to(this.zoom, {
                        worldview: this.worldview,
                        activeFloors: t1.activeFloors
                    }), c, r)) continue;
                    const h = i ? i.evaluate(c, {}, r, t1.availableImages) : void 0, d = {
                        id: o,
                        properties: a.properties,
                        type: a.type,
                        sourceLayerIndex: u,
                        index: l,
                        geometry: e1 ? c.geometry : sc(a, r, n),
                        patterns: {},
                        sortKey: h
                    };
                    s.push(d);
                }
                i && s.sort((e1, t1)=>e1.sortKey - t1.sortKey);
                for (const n of s){
                    const { geometry: i, index: s, sourceLayerIndex: a } = n;
                    if (this.hasPattern) {
                        const e1 = Rd("fill", this.layers, n, this.zoom, this.pixelRatio, t1);
                        this.patternFeatures.push(e1);
                    } else this.addFeature(n, i, s, r, {}, t1.availableImages, t1.brightness, t1.elevationFeatures);
                    t1.featureIndex.insert(e1[s].feature, i, s, a, this.index);
                }
            }
            update(e1, t1, r, n, i, s, a) {
                this.bufferData.update(e1, t1, r, n, i, s, a, this.worldview), this.elevationBufferData.update(e1, t1, r, n, i, s, a, this.worldview), this.elevatedStructures && this.elevatedStructures.update(e1, t1, r, n, i, s, a, this.worldview);
            }
            addFeatures(e1, t1, r, n, i, s) {
                for (const i of this.patternFeatures)this.addFeature(i, i.geometry, i.index, t1, r, n, s, e1.elevationFeatures);
            }
            isEmpty() {
                return this.bufferData.isEmpty() && this.elevationBufferData.isEmpty();
            }
            uploadPending() {
                return !this.uploaded || this.bufferData.needsUpload() || this.elevationBufferData.needsUpload();
            }
            upload(e1) {
                this.bufferData.upload(e1), this.elevationBufferData.upload(e1), this.elevatedStructures && this.elevatedStructures.upload(e1);
            }
            destroy() {
                this.bufferData.destroy(), this.elevationBufferData.destroy(), this.elevatedStructures && this.elevatedStructures.destroy();
            }
            addFeature(e1, t1, r, n, i, s = [], a, o) {
                const l = Fd(t1, 500);
                "none" !== this.elevationMode ? this.addElevatedRoadFeature(e1, l, n, r, o) : this.addGeometry(l, this.bufferData), this.bufferData.populatePaintArrays(e1, r, i, s, n, a, this.worldview), this.elevationBufferData.populatePaintArrays(e1, r, i, s, n, a, this.worldview);
            }
            getUnevaluatedPortalGraph() {
                return this.elevatedStructures ? this.elevatedStructures.unevaluatedPortals : void 0;
            }
            setEvaluatedPortalGraph(e1, t1, r, n, i) {
                this.elevatedStructures && (this.elevatedStructures.construct(e1), this.elevatedStructures.populatePaintArrays(t1, r, n, i, this.worldview));
            }
            addElevatedRoadFeature(e1, t1, r, n, i) {
                const s = new Array, a = Vc.getElevationFeature(e1, i);
                if (!a) return void this.addGeometry(t1, this.bufferData);
                {
                    const e1 = this.clipPolygonsToTile(t1, 1);
                    e1.length > 0 && s.push({
                        polygons: e1,
                        elevationFeature: a,
                        elevationTileID: r
                    });
                }
                const o = {
                    guardRailEnabled: this.layers[0].layout.get("fill-construct-bridge-guard-rail").evaluate(e1, {}, r),
                    featureIndex: n
                };
                for (const t1 of s)if (t1.elevationFeature) {
                    if ("hd-road-base" === this.elevationMode) {
                        this.elevatedStructures || (this.elevatedStructures = new Ud(t1.elevationTileID, this.layers, this.zoom, this.lut));
                        const r = t1.elevationFeature.isTunnel();
                        let n = 0;
                        e1.properties.hasOwnProperty(mc) && (n = +e1.properties[mc]), this.elevatedStructures.addPortalCandidates(t1.elevationFeature.id, t1.polygons, r, t1.elevationFeature, n);
                    }
                    null == t1.elevationFeature.constantHeight && (t1.polygons = this.prepareElevatedPolygons(t1.polygons, t1.elevationFeature, t1.elevationTileID));
                    const i = new Fc(r, t1.elevationTileID);
                    this.addElevatedGeometry(t1.polygons, i, t1.elevationFeature, "hd-road-base" === this.elevationMode ? 0 : .05, n, o);
                }
            }
            addElevatedGeometry(e1, t1, r, n, i, s) {
                const a = {
                    elevation: r,
                    elevationSampler: t1,
                    bias: n,
                    index: i,
                    featureInfo: s
                }, [o, l] = this.addGeometry(e1, this.elevationBufferData, a);
                null == this.elevationBufferData.heightRange ? this.elevationBufferData.heightRange = {
                    min: o,
                    max: l
                } : (this.elevationBufferData.heightRange.min = Math.min(this.elevationBufferData.heightRange.min, o), this.elevationBufferData.heightRange.max = Math.max(this.elevationBufferData.heightRange.max, l));
            }
            addGeometry(e1, t1, r) {
                let n = Number.POSITIVE_INFINITY, i = Number.NEGATIVE_INFINITY, s = null;
                r && (s = r.elevationSampler.constantElevation(r.elevation, r.bias), null != s && (n = s, i = s));
                const a = (e1, a, o)=>{
                    if (null != r) {
                        if (a.push(e1), null != s) t1.elevatedLayoutVertexArray.emplaceBack(s), o.push(s);
                        else {
                            const s = r.elevationSampler.pointElevation(e1, r.elevation, r.bias);
                            t1.elevatedLayoutVertexArray.emplaceBack(s), o.push(s), n = Math.min(n, s), i = Math.max(i, s);
                        }
                    }
                };
                for (const n of e1){
                    let e1 = 0;
                    for (const t1 of n)e1 += t1.length;
                    const i = t1.triangleSegments.prepareSegment(e1, t1.layoutVertexArray, t1.indexArray), s = i.vertexLength, o = [], l = [], u = [], c = [], h = [], d = t1.layoutVertexArray.length;
                    for (const e1 of n){
                        if (0 === e1.length) continue;
                        e1 !== n[0] && l.push(o.length / 2);
                        const i = t1.lineSegments.prepareSegment(e1.length, t1.layoutVertexArray, t1.lineIndexArray), s = i.vertexLength;
                        r && h.push(t1.layoutVertexArray.length - d), a(e1[0], u, c), t1.layoutVertexArray.emplaceBack(e1[0].x, e1[0].y), t1.lineIndexArray.emplaceBack(s + e1.length - 1, s), o.push(e1[0].x), o.push(e1[0].y);
                        for(let r = 1; r < e1.length; r++)a(e1[r], u, c), t1.layoutVertexArray.emplaceBack(e1[r].x, e1[r].y), t1.lineIndexArray.emplaceBack(s + r - 1, s + r), o.push(e1[r].x), o.push(e1[r].y);
                        i.vertexLength += e1.length, i.primitiveLength += e1.length;
                    }
                    const p = od(o, l);
                    for(let e1 = 0; e1 < p.length; e1 += 3)t1.indexArray.emplaceBack(s + p[e1], s + p[e1 + 1], s + p[e1 + 2]);
                    if (p.length > 0 && r && "hd-road-base" === this.elevationMode) {
                        const e1 = r.elevation.isTunnel(), t1 = r.elevation.safeArea, n = this.elevatedStructures.addVertices(u, c);
                        this.elevatedStructures.addTriangles(p, n, e1);
                        const i = h.length;
                        if (i > 0) {
                            for(let s = 0; s < i - 1; s++)this.elevatedStructures.addRenderableRing(r.index, h[s] + n, h[s + 1] - h[s], e1, t1, r.featureInfo);
                            this.elevatedStructures.addRenderableRing(r.index, h[i - 1] + n, u.length - h[i - 1], e1, t1, r.featureInfo);
                        }
                    }
                    i.vertexLength += e1, i.primitiveLength += p.length / 3;
                }
                return [
                    n,
                    i
                ];
            }
            prepareElevatedPolygons(e1, t1, r) {
                const n = 1 / Yu(r), i = [];
                for (const r of e1){
                    const e1 = Ap(r, new zc(t1, n), .1);
                    i.push(...e1);
                }
                return i;
            }
            clipPolygonsToTile(e1, t1) {
                const r = -t1, n = -t1, i = qn + t1, s = qn + t1;
                let a = 0;
                const o = [], l = [];
                for(; a < e1.length; a++){
                    const t1 = e1[a], u = An(t1);
                    (u.min.x >= r && u.max.x <= i && u.min.y >= n && u.max.y <= s ? o : l).push(t1);
                }
                if (o.length === e1.length) return e1;
                const u = [
                    new Me(r, n),
                    new Me(i, n),
                    new Me(i, s),
                    new Me(r, s),
                    new Me(r, n)
                ], c = o;
                for (const e1 of l)c.push(..._p(e1, u));
                return c;
            }
        }
        let Pp, Tp, zp, kp;
        ra(Sp, "FillBucket", {
            omit: [
                "layers",
                "patternFeatures"
            ]
        }), ra(Bp, "FillBufferData"), ra(Ud, "ElevatedStructures");
        class Vp {
            constructor(e1, t1, r, n){
                if (this.triangleCount = t1.length / 3, this.min = new Me(0, 0), this.max = new Me(0, 0), this.xScale = 0, this.yScale = 0, this.cellsX = 0, this.cellsY = 0, this.cells = [], this.payload = [], 0 === this.triangleCount || 0 === e1.length) return;
                const [i, s] = [
                    e1[0].clone(),
                    e1[0].clone()
                ];
                for(let t1 = 1; t1 < e1.length; ++t1){
                    const r = e1[t1];
                    i.x = Math.min(i.x, r.x), i.y = Math.min(i.y, r.y), s.x = Math.max(s.x, r.x), s.y = Math.max(s.y, r.y);
                }
                if (n) {
                    const e1 = Math.ceil(Math.max(s.x - i.x, s.y - i.y) / n);
                    r = Math.max(r, e1);
                }
                if (0 === r) return;
                this.min = i, this.max = s;
                const a = this.max.sub(this.min);
                a.x = Math.max(a.x, 1), a.y = Math.max(a.y, 1);
                const o = Math.max(a.x, a.y) / r;
                this.cellsX = Math.max(1, Math.ceil(a.x / o)), this.cellsY = Math.max(1, Math.ceil(a.y / o)), this.xScale = 1 / o, this.yScale = 1 / o;
                const l = [];
                for(let r = 0; r < this.triangleCount; r++){
                    const n = e1[t1[3 * r + 0]].sub(this.min), i = e1[t1[3 * r + 1]].sub(this.min), s = e1[t1[3 * r + 2]].sub(this.min), a = Fp(Math.floor(Math.min(n.x, i.x, s.x)), this.xScale, this.cellsX), u = Fp(Math.floor(Math.max(n.x, i.x, s.x)), this.xScale, this.cellsX), c = Fp(Math.floor(Math.min(n.y, i.y, s.y)), this.yScale, this.cellsY), h = Fp(Math.floor(Math.max(n.y, i.y, s.y)), this.yScale, this.cellsY), d = new Me(0, 0), p = new Me(0, 0), f = new Me(0, 0), m = new Me(0, 0);
                    for(let e1 = c; e1 <= h; ++e1){
                        d.y = p.y = e1 * o, f.y = m.y = (e1 + 1) * o;
                        for(let t1 = a; t1 <= u; ++t1)d.x = f.x = t1 * o, p.x = m.x = (t1 + 1) * o, (Yc(n, i, s, d, p, m) || Yc(n, i, s, d, m, f)) && l.push({
                            cellIdx: e1 * this.cellsX + t1,
                            triIdx: r
                        });
                    }
                }
                if (0 === l.length) return;
                l.sort((e1, t1)=>e1.cellIdx - t1.cellIdx || e1.triIdx - t1.triIdx);
                let u = 0;
                for(; u < l.length;){
                    const e1 = l[u].cellIdx, t1 = {
                        start: this.payload.length,
                        len: 0
                    };
                    for(; u < l.length && l[u].cellIdx === e1;)++t1.len, this.payload.push(l[u++].triIdx);
                    this.cells[e1] = t1;
                }
            }
            _lazyInitLookup() {
                this.lookup || (this.lookup = new Uint8Array(Math.ceil(this.triangleCount / 8))), this.lookup.fill(0);
            }
            queryPoint(e1, t1) {
                if (0 === this.triangleCount || 0 === this.cells.length) return;
                if (e1.x > this.max.x || this.min.x > e1.x || e1.y > this.max.y || this.min.y > e1.y) return;
                const r = Fp(e1.x - this.min.x, this.xScale, this.cellsX), n = Fp(e1.y - this.min.y, this.yScale, this.cellsY), i = this.cells[n * this.cellsX + r];
                if (i) {
                    this._lazyInitLookup();
                    for(let e1 = 0; e1 < i.len; e1++){
                        const r = this.payload[i.start + e1], n = Math.floor(r / 8), s = 1 << r % 8;
                        if (!(this.lookup[n] & s) && (this.lookup[n] |= s, t1.push(r), t1.length === this.triangleCount)) return;
                    }
                }
            }
            query(e1, t1, r) {
                if (0 === this.triangleCount || 0 === this.cells.length) return;
                if (e1.x > this.max.x || this.min.x > t1.x) return;
                if (e1.y > this.max.y || this.min.y > t1.y) return;
                this._lazyInitLookup();
                const n = Fp(e1.x - this.min.x, this.xScale, this.cellsX), i = Fp(t1.x - this.min.x, this.xScale, this.cellsX), s = Fp(e1.y - this.min.y, this.yScale, this.cellsY), a = Fp(t1.y - this.min.y, this.yScale, this.cellsY);
                for(let e1 = s; e1 <= a; e1++)for(let t1 = n; t1 <= i; t1++){
                    const n = this.cells[e1 * this.cellsX + t1];
                    if (n) for(let e1 = 0; e1 < n.len; e1++){
                        const t1 = this.payload[n.start + e1], i = Math.floor(t1 / 8), s = 1 << t1 % 8;
                        if (!(this.lookup[i] & s) && (this.lookup[i] |= s, r.push(t1), r.length === this.triangleCount)) return;
                    }
                }
            }
        }
        function Fp(e1, t1, r) {
            return Math.max(0, Math.min(r - 1, Math.floor(e1 * t1)));
        }
        ra(Vp, "TriangleGridIndex");
        class Dp {
            constructor(e1){
                this.zoom = e1.zoom, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.hasPattern = !1, this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.footprints = [], this.worldview = e1.worldview, this.hasAppearances = null;
            }
            updateFootprints(e1, t1) {
                for (const r of this.footprints)t1.push({
                    footprint: r,
                    id: e1
                });
            }
            updateAppearances(e1, t1, r, n) {
                return {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
            }
            populate(e1, t1, r, n) {
                const i = [];
                for (const { feature: s, id: a, index: o, sourceLayerIndex: l } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, u = ac(s, e1);
                    if (!this.layers[0]._featureFilter.filter(new to(this.zoom, {
                        worldview: this.worldview,
                        activeFloors: t1.activeFloors
                    }), u, r)) continue;
                    const c = {
                        id: a,
                        properties: s.properties,
                        type: s.type,
                        sourceLayerIndex: l,
                        index: o,
                        geometry: e1 ? u.geometry : sc(s, r, n),
                        patterns: {}
                    };
                    i.push(c);
                }
                for (const n of i){
                    const { geometry: i, index: s, sourceLayerIndex: a } = n;
                    this.addFeature(n, i, s, r, {}, t1.availableImages, t1.brightness), t1.featureIndex.insert(e1[s].feature, i, s, a, this.index);
                }
            }
            isEmpty() {
                return 0 === this.footprints.length;
            }
            uploadPending() {
                return !1;
            }
            upload(e1) {}
            update(e1, t1, r, n, i, s, a) {}
            destroy() {}
            addFeature(e1, t1, r, n, i, s = [], a) {
                for (const e1 of Fd(t1, 2)){
                    const t1 = [], r = [], n = [], i = new Me(1 / 0, 1 / 0), s = new Me(-1 / 0, -1 / 0);
                    for (const a of e1)if (0 !== a.length) {
                        a !== e1[0] && n.push(r.length / 2);
                        for(let e1 = 0; e1 < a.length; e1++)r.push(a[e1].x), r.push(a[e1].y), t1.push(a[e1]), i.x = Math.min(i.x, a[e1].x), i.y = Math.min(i.y, a[e1].y), s.x = Math.max(s.x, a[e1].x), s.y = Math.max(s.y, a[e1].y);
                    }
                    const a = od(r, n), o = new Vp(t1, a, 8, 256);
                    this.footprints.push({
                        vertices: t1,
                        indices: a,
                        grid: o,
                        min: i,
                        max: s
                    });
                }
            }
        }
        ra(Dp, "ClipBucket", {
            omit: [
                "layers"
            ]
        });
        const Ep = qo([
            {
                name: "a_pos_normal_ed",
                components: 4,
                type: "Int16"
            }
        ]), Cp = qo([
            {
                name: "a_pos_end",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_angular_offset_factor",
                components: 1,
                type: "Int16"
            }
        ]), Rp = qo([
            {
                name: "a_flood_light_ground_radius",
                components: 1,
                type: "Float32"
            }
        ]), Lp = qo([
            {
                name: "a_centroid_pos",
                components: 2,
                type: "Uint16"
            }
        ]), Op = qo([
            {
                name: "a_join_normal_inside",
                components: 3,
                type: "Int16"
            }
        ]), Up = qo([
            {
                name: "a_hidden_by_landmark",
                components: 1,
                type: "Uint8"
            }
        ]), Np = qo([
            {
                name: "a_pos_3",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_pos_normal_3",
                components: 3,
                type: "Int16"
            }
        ]), { members: jp } = Ep, Gp = Number.MAX_SAFE_INTEGER, $p = Gp - 1;
        function qp(e1, t1, r, n) {
            return e1.order < t1 || e1.order === Gp || !(e1.clipMask & r) || function(e1, t1) {
                return 0 !== t1.length && void 0 === t1.find((t1)=>t1 === e1);
            }(n, e1.clipScope);
        }
        function Hp(e1, t1) {
            return e1.x - t1.x || e1.y - t1.y;
        }
        function Xp(e1, t1) {
            return 0 === Hp(e1.min, t1.min) && 0 === Hp(e1.max, t1.max);
        }
        function Zp(e1, t1) {
            return !(e1.min.x > t1.max.x || e1.max.x < t1.min.x || e1.min.y > t1.max.y || e1.max.y < t1.min.y);
        }
        function Wp(e1, t1) {
            if (e1.length !== t1.length) return !1;
            for(let r = 0; r < e1.length; r++)if (e1[r].sourceId !== t1[r].sourceId || !Xp(e1[r], t1[r]) || e1[r].order !== t1[r].order || e1[r].clipMask !== t1[r].clipMask || !Be(e1[r].clipScope, t1[r].clipScope)) return !1;
            return !0;
        }
        function Yp(e1, t1, r) {
            const n = 1 / qn, i = 1 / (1 << r.canonical.z), s = (t1.x * n + r.canonical.x) * i + r.wrap, a = (t1.y * n + r.canonical.y) * i;
            return {
                min: new Me((e1.x * n + r.canonical.x) * i + r.wrap, (e1.y * n + r.canonical.y) * i),
                max: new Me(s, a)
            };
        }
        function Jp(e1, t1, r) {
            const n = 1 << r.canonical.z, i = ((t1.x - r.wrap) * n - r.canonical.x) * qn, s = (t1.y * n - r.canonical.y) * qn;
            return {
                min: new Me(((e1.x - r.wrap) * n - r.canonical.x) * qn, (e1.y * n - r.canonical.y) * qn),
                max: new Me(i, s)
            };
        }
        function Kp(e1, t1, r, n, i, s, a) {
            const o = e1.indices, l = e1.vertices, u = [];
            for(let c = n; c < n + i; c += 3){
                const n = t1[r[c + 0] + s], i = t1[r[c + 1] + s], h = t1[r[c + 2] + s], d = Math.min(n.x, i.x, h.x), p = Math.max(n.x, i.x, h.x), f = Math.min(n.y, i.y, h.y), m = Math.max(n.y, i.y, h.y);
                u.length = 0, e1.grid.query(new Me(d, f), new Me(p, m), u);
                for(let e1 = 0; e1 < u.length; e1++){
                    const t1 = u[e1];
                    if (Yc(l[o[3 * t1 + 0]], l[o[3 * t1 + 1]], l[o[3 * t1 + 2]], n, i, h, a)) return !0;
                }
            }
            return !1;
        }
        function Qp(e1, t1, r, n) {
            if (!e1 || !r) return !1;
            let i = e1.vertices;
            if (!t1.canonical.equals(n.canonical) || t1.wrap !== n.wrap) {
                if (r.vertices.length < e1.vertices.length) return Qp(r, n, e1, t1);
                const s = t1.canonical, a = n.canonical, o = Math.pow(2, a.z - s.z);
                i = e1.vertices.map((e1)=>new Me((e1.x + s.x * qn) * o - a.x * qn, (e1.y + s.y * qn) * o - a.y * qn));
            }
            return Kp(r, i, e1.indices, 0, e1.indices.length, 0, 0);
        }
        function ef(e1, t1, r, n) {
            const i = Math.pow(2, n.z - r.z);
            return new Me((e1 + r.x * qn) * i - n.x * qn, (t1 + r.y * qn) * i - n.y * qn);
        }
        function tf(e1, t1) {
            const r = [];
            t1.grid.queryPoint(e1, r);
            const n = t1.indices, i = t1.vertices;
            for(let t1 = 0; t1 < r.length; t1++){
                const s = r[t1];
                if (Hc([
                    i[n[3 * s + 0]],
                    i[n[3 * s + 1]],
                    i[n[3 * s + 2]]
                ], e1)) return !0;
            }
            return !1;
        }
        const rf = {
            None: 0,
            Model: 1,
            Symbol: 2,
            FillExtrusion: 4
        }, nf = [
            new Me(0, 0),
            new Me(qn, 0),
            new Me(qn, qn),
            new Me(0, qn)
        ];
        function sf(e1, t1) {
            const r = [];
            let n = [];
            if (!t1 || e1.length < 2) return [
                e1
            ];
            if (2 === e1.length) return Zc(e1[0], e1[1], nf) ? [
                e1
            ] : [];
            for(let t1 = 0; t1 < e1.length + 2; t1++){
                const i = e1[t1 % e1.length], s = e1[(t1 + 1) % e1.length], a = Zc(0 === t1 ? e1[e1.length - 1] : e1[(t1 - 1) % e1.length], i, nf), o = Zc(i, s, nf), l = a || o;
                l && n.push(i), l && o || n.length > 0 && (n.length > 1 && r.push(n), n = []);
            }
            return n.length > 1 && r.push(n), r;
        }
        const af = oc.types, of = [
            "fill-extrusion-base",
            "fill-extrusion-height",
            "fill-extrusion-color",
            "fill-extrusion-pattern",
            "fill-extrusion-flood-light-wall-radius",
            "fill-extrusion-line-width",
            "fill-extrusion-emissive-strength"
        ], lf = [
            "fill-extrusion-flood-light-ground-radius"
        ], uf = Math.pow(2, 13), cf = Math.pow(2, 15) - 1, hf = new Me(0, 1), df = 2147483648, pf = 1073741824;
        function ff(e1, t1, r, n, i, s, a, o) {
            e1.emplaceBack((t1 << 1) + a, (r << 1) + s, (Math.floor(n * uf) << 1) + i, Math.round(o));
        }
        function mf(e1, t1, r) {
            e1.emplaceBack(t1.x * qn, t1.y * qn, r ? 1 : 0);
        }
        function yf(e1, t1, r, n, i, s) {
            e1.emplaceBack(t1.x, t1.y, (r.x << 1) + n, (r.y << 1) + i, s);
        }
        function gf(e1, t1, r) {
            const n = 16384;
            e1.emplaceBack(t1.x, t1.y, t1.z, r[0] * n, r[1] * n, r[2] * n);
        }
        class xf {
            constructor(){
                this.vertexOffset = 0, this.vertexCount = 0, this.indexOffset = 0, this.indexCount = 0;
            }
        }
        class vf {
            constructor(){
                this.centroidXY = new Me(0, 0), this.vertexArrayOffset = 0, this.vertexCount = 0, this.groundVertexArrayOffset = 0, this.groundVertexCount = 0, this.flags = 0, this.footprintSegIdx = -1, this.footprintSegLen = 0, this.polygonSegIdx = -1, this.polygonSegLen = 0, this.min = new Me(Number.MAX_VALUE, Number.MAX_VALUE), this.max = new Me(-Number.MAX_VALUE, -Number.MAX_VALUE), this.height = 0, this.buildingId = 0, this.groupCentroidPos = new Me(0, 0);
            }
            span() {
                return new Me(this.max.x - this.min.x, this.max.y - this.min.y);
            }
        }
        class bf {
            constructor(){
                this.acc = new Me(0, 0), this.accCount = 0, this.centroidDataIndex = 0;
            }
            startRing(e1, t1) {
                e1.min.x === Number.MAX_VALUE && (e1.min.x = e1.max.x = t1.x, e1.min.y = e1.max.y = t1.y);
            }
            appendEdge(e1, t1, r) {
                this.accCount++, this.acc._add(t1);
                let n = !!this.borders;
                t1.x < e1.min.x ? (e1.min.x = t1.x, n = !0) : t1.x > e1.max.x && (e1.max.x = t1.x, n = !0), t1.y < e1.min.y ? (e1.min.y = t1.y, n = !0) : t1.y > e1.max.y && (e1.max.y = t1.y, n = !0), ((0 === t1.x || t1.x === qn) && t1.x === r.x) != ((0 === t1.y || t1.y === qn) && t1.y === r.y) && this.processBorderOverlap(t1, r), n && this.checkBorderIntersection(t1, r);
            }
            checkBorderIntersection(e1, t1) {
                t1.x < 0 != e1.x < 0 && this.addBorderIntersection(0, yr(t1.y, e1.y, (0 - t1.x) / (e1.x - t1.x))), t1.x > qn != e1.x > qn && this.addBorderIntersection(1, yr(t1.y, e1.y, (qn - t1.x) / (e1.x - t1.x))), t1.y < 0 != e1.y < 0 && this.addBorderIntersection(2, yr(t1.x, e1.x, (0 - t1.y) / (e1.y - t1.y))), t1.y > qn != e1.y > qn && this.addBorderIntersection(3, yr(t1.x, e1.x, (qn - t1.y) / (e1.y - t1.y)));
            }
            addBorderIntersection(e1, t1) {
                this.borders || (this.borders = [
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ],
                    [
                        Number.MAX_VALUE,
                        -Number.MAX_VALUE
                    ]
                ]);
                const r = this.borders[e1];
                t1 < r[0] && (r[0] = t1), t1 > r[1] && (r[1] = t1);
            }
            processBorderOverlap(e1, t1) {
                if (e1.x === t1.x) {
                    if (e1.y === t1.y) return;
                    const r = 0 === e1.x ? 0 : 1;
                    this.addBorderIntersection(r, t1.y), this.addBorderIntersection(r, e1.y);
                } else {
                    const r = 0 === e1.y ? 2 : 3;
                    this.addBorderIntersection(r, t1.x), this.addBorderIntersection(r, e1.x);
                }
            }
            centroid() {
                return 0 === this.accCount ? new Me(0, 0) : new Me(Math.floor(Math.max(0, this.acc.x) / this.accCount), Math.floor(Math.max(0, this.acc.y) / this.accCount));
            }
            intersectsCount() {
                return this.borders ? this.borders.reduce((e1, t1)=>e1 + +(t1[0] !== Number.MAX_VALUE), 0) : 0;
            }
        }
        function wf(e1, t1) {
            const r = e1.add(t1)._unit(), n = Ee(e1.x * r.x + e1.y * r.y, -1, 1);
            var i, s, a;
            return a = Math.acos(n), Math.min(4, Math.max(-4, Math.tan(a))) / 4 * cf * ((i = e1).x * (s = t1).y - i.y * s.x < 0 ? -1 : 1);
        }
        const _f = [
            (e1)=>e1.x < 0,
            (e1)=>e1.x > qn,
            (e1)=>e1.y < 0,
            (e1)=>e1.y > qn
        ];
        function Af(e1, t1, r, n) {
            const i = [
                4
            ];
            if (0 === n) return i;
            r._mult(n);
            const s = e1.sub(r), a = t1.sub(r), o = [
                e1,
                t1,
                s,
                a
            ];
            for(let e1 = 0; e1 < 4; e1++)for (const t1 of o)if (_f[e1](t1)) {
                i.push(e1);
                break;
            }
            return i;
        }
        class If {
            constructor(e1){
                this.groundRadiusArray = null, this.groundRadiusBuffer = null, this.vertexArray = new el, this.indexArray = new ml, this.programConfigurations = new _u(e1.layers, {
                    zoom: e1.zoom,
                    lut: e1.lut
                }, (e1)=>lf.includes(e1)), this._segments = new Hl, this.hiddenByLandmarkVertexArray = new Tl, this._segmentToGroundQuads = {}, this._segmentToGroundQuads[0] = [], this._segmentToRegionTriCounts = {}, this._segmentToRegionTriCounts[0] = [
                    0,
                    0,
                    0,
                    0,
                    0
                ], this.regionSegments = {}, this.regionSegments[4] = new Hl;
            }
            getDefaultSegment() {
                return this.regionSegments[4];
            }
            hasData() {
                return 0 !== this.vertexArray.length;
            }
            addData(e1, t1, r, n = !1) {
                const i = e1.length;
                if (i > 2) {
                    let s = Math.max(0, this._segments.get().length - 1);
                    const a = this._segments._prepareSegment(4 * i, this.vertexArray.length, 2 * this._segmentToGroundQuads[s].length);
                    let o;
                    s !== this._segments.get().length - 1 && (s++, this._segmentToGroundQuads[s] = [], this._segmentToRegionTriCounts[s] = [
                        0,
                        0,
                        0,
                        0,
                        0
                    ]);
                    {
                        const t1 = e1[0], r = e1[1];
                        o = wf(t1.sub(e1[i - 1])._perp()._unit(), r.sub(t1)._perp()._unit());
                    }
                    for(let l = 0; l < i; l++){
                        const u = l === i - 1 ? 0 : l + 1, c = e1[l], h = e1[u], d = e1[u === i - 1 ? 0 : u + 1], p = h.sub(c)._perp()._unit(), f = wf(p, d.sub(h)._perp()._unit()), m = o, y = f;
                        if (Tf(c, h, t1) || n && zf(c, t1) && zf(h, t1)) {
                            o = f;
                            continue;
                        }
                        const g = a.vertexLength;
                        yf(this.vertexArray, c, h, 1, 1, m), yf(this.vertexArray, c, h, 1, 0, m), yf(this.vertexArray, c, h, 0, 1, y), yf(this.vertexArray, c, h, 0, 0, y), a.vertexLength += 4;
                        const x = Af(c, h, p, r);
                        for (const e1 of x)this._segmentToGroundQuads[s].push({
                            id: g,
                            region: e1
                        }), this._segmentToRegionTriCounts[s][e1] += 2, a.primitiveLength += 2;
                        o = f;
                    }
                }
            }
            prepareBorderSegments() {
                if (!this.hasData()) return;
                const e1 = this._segments.get(), t1 = e1.length;
                for(let e1 = 0; e1 < t1; e1++)this._segmentToGroundQuads[e1].sort((e1, t1)=>e1.region - t1.region);
                for(let r = 0; r < t1; r++){
                    const t1 = this._segmentToGroundQuads[r], n = e1[r], i = this._segmentToRegionTriCounts[r];
                    i.reduce((e1, t1)=>e1 + t1, 0);
                    let s = 0;
                    for(let e1 = 0; e1 <= 4; e1++){
                        const t1 = i[e1];
                        if (0 !== t1) {
                            let r = this.regionSegments[e1];
                            r || (r = this.regionSegments[e1] = new Hl);
                            const i = {
                                vertexOffset: n.vertexOffset,
                                primitiveOffset: n.primitiveOffset + s,
                                vertexLength: n.vertexLength,
                                primitiveLength: t1
                            };
                            r.get().push(i);
                        }
                        s += t1;
                    }
                    for(let e1 = 0; e1 < t1.length; e1++){
                        const r = t1[e1].id;
                        this.indexArray.emplaceBack(r, r + 1, r + 3), this.indexArray.emplaceBack(r, r + 3, r + 2);
                    }
                }
                this._segmentToGroundQuads = null, this._segmentToRegionTriCounts = null, this._segments.destroy(), this._segments = null;
            }
            addPaintPropertiesData(e1, t1, r, n, i, s, a) {
                this.hasData() && this.programConfigurations.populatePaintArrays(this.vertexArray.length, e1, t1, r, n, i, s, void 0, a);
            }
            upload(e1) {
                this.hasData() && (this.vertexBuffer = e1.createVertexBuffer(this.vertexArray, Cp.members), this.indexBuffer = e1.createIndexBuffer(this.indexArray), null != this.groundRadiusArray && (this.groundRadiusBuffer = e1.createVertexBuffer(this.groundRadiusArray, Rp.members)));
            }
            uploadPaintProperties(e1) {
                this.hasData() && this.programConfigurations.upload(e1);
            }
            update(e1, t1, r, n, i, s, a, o) {
                this.hasData() && this.programConfigurations.updatePaintArrays(e1, t1, r, n, i, s, a, o);
            }
            updateHiddenByLandmark(e1) {
                this.updateHiddenByLandmarkRange(e1.groundVertexArrayOffset, e1.groundVertexCount, !!(e1.flags & df || e1.flags & pf));
            }
            updateHiddenByLandmarkRange(e1, t1, r) {
                if (!this.hasData()) return;
                const n = t1 + e1;
                if (0 !== t1) {
                    for(let t1 = e1; t1 < n; ++t1)this.hiddenByLandmarkVertexArray.emplace(t1, r ? 1 : 0);
                    this._needsHiddenByLandmarkUpdate = !0;
                }
            }
            uploadHiddenByLandmark(e1) {
                this.hasData() && this._needsHiddenByLandmarkUpdate && (!this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexArray.length > 0 ? this.hiddenByLandmarkVertexBuffer = e1.createVertexBuffer(this.hiddenByLandmarkVertexArray, Up.members, !0) : this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.updateData(this.hiddenByLandmarkVertexArray), this._needsHiddenByLandmarkUpdate = !1);
            }
            destroy() {
                if (this.vertexBuffer) {
                    this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.hiddenByLandmarkVertexBuffer && this.hiddenByLandmarkVertexBuffer.destroy(), this.groundRadiusBuffer && this.groundRadiusBuffer.destroy(), this._segments && this._segments.destroy(), this.programConfigurations.destroy();
                    for(let e1 = 0; e1 <= 4; e1++){
                        const t1 = this.regionSegments[e1];
                        t1 && t1.destroy();
                    }
                }
            }
        }
        class Mf {
            constructor(e1){
                this.zoom = e1.zoom, this.canonical = e1.canonical, this.overscaling = e1.overscaling, this.layers = e1.layers, this.pixelRatio = e1.pixelRatio, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.hasPattern = !1, this.edgeRadius = 0, this.projection = e1.projection, this.activeReplacements = [], this.replacementUpdateTime = 0, this.centroidData = [], this.footprintIndices = new ml, this.footprintVertices = new Xo, this.footprintSegments = [], this.layoutVertexArray = new Qo, this.centroidVertexArray = new Ul, this.wallVertexArray = new jl, this.indexArray = new ml, this.programConfigurations = new _u(e1.layers, {
                    zoom: e1.zoom,
                    lut: e1.lut
                }, (e1)=>of.includes(e1)), this.segments = new Hl, this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.groundEffect = new If(e1), this.maxHeight = 0, this.partLookup = {}, this.triangleSubSegments = [], this.polygonSegments = [], this.buildingGroups = new Map, this.worldview = e1.worldview, this.hasAppearances = null;
            }
            updateFootprints(e1, t1) {}
            updateAppearances(e1, t1, r, n) {
                return {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
            }
            populate(e1, t1, r, n) {
                this.features = [], this.hasPattern = Cd("fill-extrusion", this.layers, this.pixelRatio, t1), this.featuresOnBorder = [], this.borderFeatureIndices = [
                    [],
                    [],
                    [],
                    []
                ], this.borderDoneWithNeighborZ = [
                    -1,
                    -1,
                    -1,
                    -1
                ], this.selfDEMTileTimestamp = Number.MAX_VALUE, this.borderDEMTileTimestamp = [
                    Number.MAX_VALUE,
                    Number.MAX_VALUE,
                    Number.MAX_VALUE,
                    Number.MAX_VALUE
                ], this.tileToMeter = Yu(r), this.edgeRadius = this.layers[0].layout.get("fill-extrusion-edge-radius") / this.tileToMeter, this.wallMode = 0 !== this.layers[0].paint.get("fill-extrusion-line-width").constantOr(1);
                for (const { feature: i, id: s, index: a, sourceLayerIndex: o } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, l = ac(i, e1);
                    if (!this.layers[0]._featureFilter.filter(new to(this.zoom, {
                        worldview: this.worldview,
                        activeFloors: t1.activeFloors
                    }), l, r)) continue;
                    const u = {
                        id: s,
                        sourceLayerIndex: o,
                        index: a,
                        geometry: e1 ? l.geometry : sc(i, r, n),
                        properties: i.properties,
                        type: i.type,
                        patterns: {}
                    }, c = this.layoutVertexArray.length, h = "Polygon" === af[u.type];
                    if (this.hasPattern) this.features.push({
                        featureId: i.id,
                        feature: Rd("fill-extrusion", this.layers, u, this.zoom, this.pixelRatio, t1)
                    });
                    else if (this.wallMode) for (const e1 of u.geometry)for (const s of sf(e1, h))this.addFeature(i.id, u, [
                        s
                    ], a, r, {}, t1.availableImages, n, t1.brightness);
                    else this.addFeature(i.id, u, u.geometry, a, r, {}, t1.availableImages, n, t1.brightness);
                    t1.featureIndex.insert(i, u.geometry, a, o, this.index, c);
                }
                this._finalizeBuildingGroups(), this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles(), this.groundEffect.prepareBorderSegments(), this.polygonSegments.length = 0;
            }
            addFeatures(e1, t1, r, n, i, s) {
                for (const { featureId: e1, feature: a } of this.features){
                    const o = "Polygon" === af[a.type], { geometry: l } = a;
                    if (this.wallMode) for (const u of l)for (const l of sf(u, o))this.addFeature(e1, a, [
                        l
                    ], a.index, t1, r, n, i, s);
                    else this.addFeature(e1, a, l, a.index, t1, r, n, i, s);
                }
                this._finalizeBuildingGroups(), this.sortBorders(), "mercator" === this.projection.name && this.splitToSubtiles();
            }
            update(e1, t1, r, n, i, s, a) {
                this.programConfigurations.updatePaintArrays(e1, t1, i, r, n, s, a, this.worldview), this.groundEffect.update(e1, t1, i, r, n, s, a, this.worldview);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload || this.groundEffect.programConfigurations.needsUpload;
            }
            upload(e1) {
                this.uploaded || (this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, jp), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.wallVertexBuffer = e1.createVertexBuffer(this.wallVertexArray, Op.members), this.layoutVertexExtArray && (this.layoutVertexExtBuffer = e1.createVertexBuffer(this.layoutVertexExtArray, Np.members, !0)), this.groundEffect.upload(e1)), this.groundEffect.uploadPaintProperties(e1), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            uploadCentroid(e1) {
                this.groundEffect.uploadHiddenByLandmark(e1), this.needsCentroidUpdate && (!this.centroidVertexBuffer && this.centroidVertexArray.length > 0 ? this.centroidVertexBuffer = e1.createVertexBuffer(this.centroidVertexArray, Lp.members, !0) : this.centroidVertexBuffer && this.centroidVertexBuffer.updateData(this.centroidVertexArray), this.needsCentroidUpdate = !1);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.centroidVertexBuffer && this.centroidVertexBuffer.destroy(), this.layoutVertexExtBuffer && this.layoutVertexExtBuffer.destroy(), this.groundEffect.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            addFeature(e1, t1, r, n, i, s, a, o, l) {
                const u = this.layers[0].paint.get("fill-extrusion-flood-light-ground-radius").evaluate(t1, {}) / this.tileToMeter, c = [
                    new Me(0, 0),
                    new Me(qn, qn)
                ], h = o.projection, d = "globe" === h.name, p = this.wallMode || "Polygon" === af[t1.type], f = new bf;
                f.centroidDataIndex = this.centroidData.length;
                const m = new vf;
                m.buildingId = e1, t1.properties && t1.properties.hasOwnProperty("building_id") && (m.buildingId = Number(t1.properties.building_id)), f.buildingId = m.buildingId;
                const y = this.layers[0].paint.get("fill-extrusion-base").evaluate(t1, {}, i) <= 0, g = this.layers[0].paint.get("fill-extrusion-height").evaluate(t1, {}, i);
                let x;
                if (m.height = g, m.vertexArrayOffset = this.layoutVertexArray.length, m.groundVertexArrayOffset = this.groundEffect.vertexArray.length, d && !this.layoutVertexExtArray && (this.layoutVertexExtArray = new sl), this.wallMode) {
                    if (d) return void Ze("Non zero fill-extrusion-line-width is not yet supported on globe.");
                    if (1 !== r.length) return;
                    x = function(e1) {
                        const t1 = e1[0].x === e1[e1.length - 1].x && e1[0].y === e1[e1.length - 1].y, r = function(e1) {
                            let t1 = 0;
                            const r = e1.length;
                            for(let n = 0; n < r; n++)t1 += (e1[(n + 1) % r].x - e1[n].x) * (e1[(n + 1) % r].y + e1[n].y);
                            return t1 >= 0;
                        }(e1);
                        r || (e1 = e1.reverse());
                        const n = {
                            geometry: [],
                            joinNormals: [],
                            indices: []
                        }, i = [], s = [], a = [];
                        let o = e1.length;
                        for(; o >= 2 && e1[o - 1].equals(e1[o - 2]);)o--;
                        if (o < (t1 ? 3 : 2)) return n;
                        let l, u, c, h, d, p = 0;
                        for(; p < o - 1 && e1[p].equals(e1[p + 1]);)p++;
                        t1 && (l = e1[o - 2], d = e1[p].sub(l)._unit()._perp());
                        for(let r = p; r < o; r++){
                            if (c = r === o - 1 ? t1 ? e1[p + 1] : void 0 : e1[r + 1], c && e1[r].equals(c)) continue;
                            d && (h = d), l && (u = l), l = e1[r], d = c ? c.sub(l)._unit()._perp() : h, h = h || d;
                            let n = h.add(d);
                            0 === n.x && 0 === n.y || n._unit();
                            const f = n.x * d.x + n.y * d.y, m = 0 !== f ? 1 / f : 1 / 0, y = h.x * d.y - h.y * d.x > 0;
                            let g = "miter";
                            const x = 2;
                            "miter" === g && m > x && (g = "bevel"), "bevel" === g && (m > 100 && (g = "flipbevel"), m < x && (g = "miter"));
                            const v = (e1, t1, r, n)=>{
                                const o = new Me(e1.x, e1.y), l = new Me(e1.x, e1.y);
                                o.x += t1.x * n, o.y += t1.y * n, l.x -= t1.x * Math.max(r, 1), l.y -= t1.y * Math.max(r, 1), a.push(t1), i.push(o), s.push(l);
                            };
                            if ("miter" === g) n._mult(m), v(l, n, 0, 0);
                            else if ("flipbevel" === g) n = d.mult(-1), v(l, n, 0, 0), v(l, n.mult(-1), 0, 0);
                            else {
                                const e1 = -Math.sqrt(m * m - 1), t1 = y ? e1 : 0, r = y ? 0 : e1;
                                u && v(l, h, t1, r), c && v(l, d, t1, r);
                            }
                        }
                        n.geometry = [
                            ...i,
                            ...s.reverse(),
                            i[0]
                        ], n.joinNormals = [
                            ...a,
                            ...a.reverse(),
                            a[a.length - 1]
                        ];
                        const f = n.geometry.length - 1;
                        for(let e1 = 0; e1 < f / 2; e1++)if (e1 + 1 < f / 2) {
                            let t1 = e1, r = e1 + 1, i = f - 1 - e1, s = f - 2 - e1;
                            t1 = 0 === t1 ? f - 1 : t1 - 1, r = 0 === r ? f - 1 : r - 1, i = 0 === i ? f - 1 : i - 1, s = 0 === s ? f - 1 : s - 1, n.indices.push(i), n.indices.push(r), n.indices.push(t1), n.indices.push(i), n.indices.push(s), n.indices.push(r);
                        }
                        return n;
                    }(r[0]), r = [
                        x.geometry
                    ];
                }
                const v = (e1, t1)=>e1 < (t1.length - 1) / 2 || e1 === t1.length - 1, b = this.wallMode ? [
                    r
                ] : Fd(r, 500);
                for(let e1 = b.length - 1; e1 >= 0; e1--){
                    const t1 = b[e1];
                    (0 === t1.length || kf(t1[0])) && b.splice(e1, 1);
                }
                let w;
                if (d) w = Ef(b, c, i);
                else {
                    w = [];
                    for (const e1 of b)w.push({
                        polygon: e1,
                        bounds: c
                    });
                }
                const _ = p ? this.edgeRadius : 0, A = _ > 0 && this.zoom < 17, I = (e1, t1)=>{
                    if (0 === e1.length) return !1;
                    const r = e1[e1.length - 1];
                    return t1.x === r.x && t1.y === r.y;
                };
                for (const { polygon: e1, bounds: t1 } of w){
                    let r = 0, n = 0;
                    for (const t1 of e1)p && !t1[0].equals(t1[t1.length - 1]) && t1.push(t1[0]), n += p ? t1.length - 1 : t1.length;
                    const s = this.segments.prepareSegment((p ? 5 : 4) * n, this.layoutVertexArray, this.indexArray);
                    m.footprintSegIdx < 0 && (m.footprintSegIdx = this.footprintSegments.length), m.polygonSegIdx < 0 && (m.polygonSegIdx = this.polygonSegments.length);
                    const a = {
                        triangleArrayOffset: this.indexArray.length,
                        triangleCount: 0,
                        triangleSegIdx: this.segments.segments.length - 1
                    }, o = new xf;
                    if (o.vertexOffset = this.footprintVertices.length, o.indexOffset = 3 * this.footprintIndices.length, o.ringIndices = [], p) {
                        const n = [], a = [];
                        r = s.vertexLength;
                        for(let r = 0; r < e1.length; r++){
                            const l = e1[r];
                            l.length && 0 !== r && a.push(n.length / 2);
                            const c = [];
                            let p, f;
                            p = l[1].sub(l[0])._perp()._unit(), o.ringIndices.push(l.length - 1);
                            for(let e1 = 1; e1 < l.length; e1++){
                                const t1 = l[e1], r = l[e1 === l.length - 1 ? 1 : e1 + 1], a = t1.clone();
                                if (_) {
                                    f = r.sub(t1)._perp()._unit();
                                    const e1 = p.add(f)._unit(), n = _ * Math.min(4, 1 / (p.x * e1.x + p.y * e1.y));
                                    a.x += n * e1.x, a.y += n * e1.y, a.x = Math.round(a.x), a.y = Math.round(a.y), p = f;
                                }
                                if (!y || 0 !== _ && !A || I(c, a) || c.push(a), ff(this.layoutVertexArray, a.x, a.y, 0, 0, 1, 1, 0), this.wallMode) {
                                    const t1 = v(e1, l);
                                    mf(this.wallVertexArray, x.joinNormals[e1], !t1);
                                }
                                s.vertexLength++, this.footprintVertices.emplaceBack(t1.x, t1.y), n.push(t1.x, t1.y), d && gf(this.layoutVertexExtArray, h.projectTilePoint(a.x, a.y, i), h.upVector(i, a.x, a.y));
                            }
                            y && (0 === _ || A) && (0 !== c.length && I(c, c[0]) && c.pop(), this.groundEffect.addData(c, t1, u));
                        }
                        const l = this.wallMode ? x.indices : od(n, a);
                        for(let e1 = 0; e1 < l.length; e1 += 3)this.footprintIndices.emplaceBack(o.vertexOffset + l[e1 + 0], o.vertexOffset + l[e1 + 1], o.vertexOffset + l[e1 + 2]), this.indexArray.emplaceBack(r + l[e1], r + l[e1 + 2], r + l[e1 + 1]), s.primitiveLength++;
                        o.indexCount += l.length, o.vertexCount += this.footprintVertices.length - o.vertexOffset;
                    }
                    for(let n = 0; n < e1.length; n++){
                        const a = e1[n];
                        f.startRing(m, a[0]);
                        let o = a.length > 4 && Vf(a[a.length - 2], a[0], a[1]), l = _ ? Sf(a[a.length - 2], a[0], a[1], _) : 0;
                        const c = [];
                        let g, b, w;
                        b = a[1].sub(a[0])._perp()._unit();
                        let A = !0;
                        for(let e1 = 1, n = 0; e1 < a.length; e1++){
                            let u = a[e1 - 1], p = a[e1];
                            const M = a[e1 === a.length - 1 ? 1 : e1 + 1];
                            if (f.appendEdge(m, p, u), Tf(p, u, t1)) {
                                _ && (b = M.sub(p)._perp()._unit(), A = !A);
                                continue;
                            }
                            const B = p.sub(u)._perp(), S = B.x / (Math.abs(B.x) + Math.abs(B.y)), P = B.y > 0 ? 1 : 0, T = u.dist(p);
                            if (n + T > 32768 && (n = 0), _) {
                                w = M.sub(p)._perp()._unit();
                                let e1 = Pf(u, p, M, Bf(b, w), _);
                                isNaN(e1) && (e1 = 0);
                                const t1 = p.sub(u)._unit();
                                u = u.add(t1.mult(l))._round(), p = p.add(t1.mult(-e1))._round(), l = e1, b = w, y && this.zoom >= 17 && (I(c, u) || c.push(u), I(c, p) || c.push(p));
                            }
                            const z = s.vertexLength, k = a.length > 4 && Vf(u, p, M);
                            let V = Ff(n, o, A);
                            if (ff(this.layoutVertexArray, u.x, u.y, S, P, 0, 0, V), ff(this.layoutVertexArray, u.x, u.y, S, P, 0, 1, V), this.wallMode) {
                                const t1 = v(e1 - 1, a), r = x.joinNormals[e1 - 1];
                                mf(this.wallVertexArray, r, t1), mf(this.wallVertexArray, r, t1);
                            }
                            if (n += T, V = Ff(n, k, !A), o = k, ff(this.layoutVertexArray, p.x, p.y, S, P, 0, 0, V), ff(this.layoutVertexArray, p.x, p.y, S, P, 0, 1, V), this.wallMode) {
                                const t1 = v(e1, a), r = x.joinNormals[e1];
                                mf(this.wallVertexArray, r, t1), mf(this.wallVertexArray, r, t1);
                            }
                            if (s.vertexLength += 4, this.indexArray.emplaceBack(z + 0, z + 1, z + 2), this.indexArray.emplaceBack(z + 1, z + 3, z + 2), s.primitiveLength += 2, _) {
                                const n = r + (1 === e1 ? a.length - 2 : e1 - 2), i = 1 === e1 ? r : n + 1;
                                if (this.indexArray.emplaceBack(z + 1, n, z + 3), this.indexArray.emplaceBack(n, i, z + 3), s.primitiveLength += 2, void 0 === g && (g = z), !Tf(M, a[e1], t1)) {
                                    const t1 = e1 === a.length - 1 ? g : s.vertexLength;
                                    this.indexArray.emplaceBack(z + 2, z + 3, t1), this.indexArray.emplaceBack(z + 3, t1 + 1, t1), this.indexArray.emplaceBack(z + 3, i, t1 + 1), s.primitiveLength += 3;
                                }
                                A = !A;
                            }
                            if (d) {
                                const e1 = this.layoutVertexExtArray, t1 = h.projectTilePoint(u.x, u.y, i), r = h.projectTilePoint(p.x, p.y, i), n = h.upVector(i, u.x, u.y), s = h.upVector(i, p.x, p.y);
                                gf(e1, t1, n), gf(e1, t1, n), gf(e1, r, s), gf(e1, r, s);
                            }
                        }
                        p && (r += a.length - 1), y && _ && this.zoom >= 17 && (0 !== c.length && I(c, c[0]) && c.pop(), this.groundEffect.addData(c, t1, u, _ > 0));
                    }
                    this.footprintSegments.push(o), a.triangleCount = this.indexArray.length - a.triangleArrayOffset, this.polygonSegments.push(a), ++m.footprintSegLen, ++m.polygonSegLen;
                }
                if (m.vertexCount = this.layoutVertexArray.length - m.vertexArrayOffset, m.groundVertexCount = this.groundEffect.vertexArray.length - m.groundVertexArrayOffset, 0 !== m.vertexCount) {
                    if (m.centroidXY = f.borders ? hf : this.encodeCentroid(f, m), t1.properties && t1.properties.hasOwnProperty("building_id")) {
                        const e1 = m.buildingId;
                        let t1 = this.buildingGroups.get(e1);
                        t1 || (t1 = {
                            accX: 0,
                            accY: 0,
                            accCount: 0,
                            mergedMin: new Me(Number.MAX_VALUE, Number.MAX_VALUE),
                            mergedMax: new Me(-Number.MAX_VALUE, -Number.MAX_VALUE),
                            partIndices: []
                        }, this.buildingGroups.set(e1, t1)), t1.accX += f.acc.x, t1.accY += f.acc.y, t1.accCount += f.accCount, t1.mergedMin.x = Math.min(t1.mergedMin.x, m.min.x), t1.mergedMin.y = Math.min(t1.mergedMin.y, m.min.y), t1.mergedMax.x = Math.max(t1.mergedMax.x, m.max.x), t1.mergedMax.y = Math.max(t1.mergedMax.y, m.max.y), t1.partIndices.push(this.centroidData.length);
                    }
                    if (this.centroidData.push(m), f.borders) {
                        this.featuresOnBorder.push(f);
                        const e1 = this.featuresOnBorder.length - 1;
                        for(let t1 = 0; t1 < f.borders.length; t1++)f.borders[t1][0] !== Number.MAX_VALUE && this.borderFeatureIndices[t1].push(e1);
                    }
                    this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, t1, n, s, a, i, l, void 0, this.worldview), this.groundEffect.addPaintPropertiesData(t1, n, s, a, i, l, this.worldview), this.maxHeight = Math.max(this.maxHeight, g);
                }
            }
            _finalizeBuildingGroups() {
                for (const [, e1] of this.buildingGroups){
                    if (0 === e1.partIndices.length) continue;
                    const t1 = new bf;
                    t1.acc = new Me(e1.accX, e1.accY), t1.accCount = e1.accCount;
                    const r = new vf;
                    r.min = e1.mergedMin, r.max = e1.mergedMax;
                    const n = this.encodeCentroid(t1, r), i = t1.centroid();
                    for (const t1 of e1.partIndices){
                        const r = this.centroidData[t1];
                        r.centroidXY.x === hf.x && r.centroidXY.y === hf.y || (r.centroidXY = n), r.min = e1.mergedMin, r.max = e1.mergedMax, r.groupCentroidPos = i;
                    }
                }
                this.buildingGroups.clear();
            }
            sortBorders() {
                for(let e1 = 0; e1 < this.borderFeatureIndices.length; e1++)this.borderFeatureIndices[e1].sort((t1, r)=>this.featuresOnBorder[t1].borders[e1][0] - this.featuresOnBorder[r].borders[e1][0]);
            }
            splitToSubtiles() {
                const e1 = [];
                for(let t1 = 0; t1 < this.centroidData.length; t1++){
                    const r = this.centroidData[t1], n = +(r.min.y + r.max.y > qn), i = 2 * n + (+(r.min.x + r.max.x > qn) ^ n);
                    for(let n = 0; n < r.polygonSegLen; n++){
                        const s = r.polygonSegIdx + n;
                        e1.push({
                            centroidIdx: t1,
                            subtile: i,
                            polygonSegmentIdx: s,
                            triangleSegmentIdx: this.polygonSegments[s].triangleSegIdx
                        });
                    }
                }
                const t1 = new ml;
                e1.sort((e1, t1)=>e1.triangleSegmentIdx === t1.triangleSegmentIdx ? e1.subtile - t1.subtile : e1.triangleSegmentIdx - t1.triangleSegmentIdx);
                let r = 0, n = 0, i = 0;
                for (const t1 of e1){
                    if (t1.triangleSegmentIdx !== r) break;
                    i++;
                }
                const s = e1.length;
                for(; n !== e1.length;){
                    r = e1[n].triangleSegmentIdx;
                    let a = 0, o = n, l = n;
                    for(let t1 = o; t1 < i && e1[t1].subtile === a; t1++)l++;
                    for(; o !== i;){
                        const n = e1[o];
                        a = n.subtile;
                        const s = this.centroidData[n.centroidIdx].min.clone(), u = this.centroidData[n.centroidIdx].max.clone(), c = {
                            vertexOffset: this.segments.segments[r].vertexOffset,
                            primitiveOffset: t1.length,
                            vertexLength: this.segments.segments[r].vertexLength,
                            primitiveLength: 0,
                            sortKey: void 0,
                            vaos: {}
                        };
                        for(let r = o; r < l; r++){
                            const n = e1[r], i = this.polygonSegments[n.polygonSegmentIdx], a = this.centroidData[n.centroidIdx].min, o = this.centroidData[n.centroidIdx].max, l = this.indexArray.uint16;
                            for(let e1 = i.triangleArrayOffset; e1 < i.triangleArrayOffset + i.triangleCount; e1++)t1.emplaceBack(l[3 * e1], l[3 * e1 + 1], l[3 * e1 + 2]);
                            c.primitiveLength += i.triangleCount, s.x = Math.min(s.x, a.x), s.y = Math.min(s.y, a.y), u.x = Math.max(u.x, o.x), u.y = Math.max(u.y, o.y);
                        }
                        c.primitiveLength > 0 && this.triangleSubSegments.push({
                            segment: c,
                            min: s,
                            max: u
                        }), o = l;
                        for(let t1 = o; t1 < i && e1[t1].subtile === e1[o].subtile; t1++)l++;
                    }
                    n = i;
                    for(let t1 = n; t1 < s && e1[t1].triangleSegmentIdx === e1[n].triangleSegmentIdx; t1++)i++;
                }
                t1._trim(), this.indexArray = t1;
            }
            getVisibleSegments(e1, t1, r) {
                const n = new Hl;
                if (this.wallMode) {
                    for (const e1 of this.triangleSubSegments)n.segments.push(e1.segment);
                    return n;
                }
                let i = 0, s = 0;
                const a = 1 << e1.canonical.z;
                if (t1) {
                    const r = t1.getMinMaxForTile(e1);
                    r && (i = r.min, s = r.max);
                }
                s += this.maxHeight;
                const o = e1.toUnwrapped();
                let l;
                const u = [
                    o.canonical.x / a + o.wrap,
                    o.canonical.y / a
                ], c = [
                    (o.canonical.x + 1) / a + o.wrap,
                    (o.canonical.y + 1) / a
                ], h = (e1, t1, r)=>[
                        e1[0] * (1 - r[0]) + t1[0] * r[0],
                        e1[1] * (1 - r[1]) + t1[1] * r[1]
                    ], d = [], p = [];
                for (const e1 of this.triangleSubSegments){
                    d[0] = e1.min.x / qn, d[1] = e1.min.y / qn, p[0] = e1.max.x / qn, p[1] = e1.max.y / qn;
                    const t1 = h(u, c, d), a = h(u, c, p);
                    if (0 === new Tc([
                        t1[0],
                        t1[1],
                        i
                    ], [
                        a[0],
                        a[1],
                        s
                    ]).intersectsPrecise(r)) {
                        l && (n.segments.push(l), l = void 0);
                        continue;
                    }
                    const o = e1.segment;
                    l && l.vertexOffset !== o.vertexOffset && (n.segments.push(l), l = void 0), l ? (l.vertexLength += o.vertexLength, l.primitiveLength += o.primitiveLength) : l = {
                        vertexOffset: o.vertexOffset,
                        primitiveLength: o.primitiveLength,
                        vertexLength: o.vertexLength,
                        primitiveOffset: o.primitiveOffset,
                        sortKey: void 0,
                        vaos: {}
                    };
                }
                return l && n.segments.push(l), n;
            }
            encodeCentroid(e1, t1) {
                const r = e1.centroid(), n = t1.span(), i = Math.min(7, Math.round(n.x * this.tileToMeter / 10)), s = Math.min(6, Math.round(n.y * this.tileToMeter / 10));
                return new Me(Ee(r.x, 1, 8191) << 3 | i, Ee(r.y, 1, 8191) << 3 | s);
            }
            encodeBorderCentroid(e1) {
                if (!e1.borders) return new Me(0, 0);
                const t1 = e1.borders, r = Number.MAX_VALUE;
                if (t1[0][0] !== r || t1[1][0] !== r) {
                    const e1 = t1[0][0] !== r ? 0 : 1;
                    return new Me(6 | (t1[0][0] !== r ? 0 : 65528), (t1[e1][0] + t1[e1][1]) / 2 << 3 | 6);
                }
                {
                    const e1 = t1[2][0] !== r ? 2 : 3;
                    return new Me((t1[e1][0] + t1[e1][1]) / 2 << 3 | 6, 6 | (t1[2][0] !== r ? 0 : 65528));
                }
            }
            showCentroid(e1) {
                const t1 = this.centroidData[e1.centroidDataIndex];
                if (t1.flags &= df, 0 !== t1.groupCentroidPos.x || 0 !== t1.groupCentroidPos.y) {
                    const e1 = t1.span(), r = Math.min(7, Math.round(e1.x * this.tileToMeter / 10)), n = Math.min(6, Math.round(e1.y * this.tileToMeter / 10));
                    t1.centroidXY = new Me(Ee(t1.groupCentroidPos.x, 1, 8191) << 3 | r, Ee(t1.groupCentroidPos.y, 1, 8191) << 3 | n);
                } else t1.centroidXY = new Me(0, 0);
                this.writeCentroidToBuffer(t1);
            }
            writeCentroidToBuffer(e1) {
                this.groundEffect.updateHiddenByLandmark(e1);
                const t1 = e1.vertexArrayOffset, r = e1.vertexCount + e1.vertexArrayOffset, n = -1073741824 & e1.flags ? hf : e1.centroidXY, i = this.centroidVertexArray.geta_centroid_pos0(t1);
                if (this.centroidVertexArray.geta_centroid_pos1(t1) !== n.y || i !== n.x) {
                    for(let e1 = t1; e1 < r; ++e1)this.centroidVertexArray.emplace(e1, n.x, n.y);
                    this.needsCentroidUpdate = !0;
                }
            }
            createCentroidsBuffer() {
                this.centroidVertexArray.resize(this.layoutVertexArray.length), this.groundEffect.hiddenByLandmarkVertexArray.resize(this.groundEffect.vertexArray.length);
                for (const e1 of this.centroidData)this.writeCentroidToBuffer(e1);
            }
            updateReplacement(e1, t1, r) {
                if (t1.updateTime === this.replacementUpdateTime) return;
                this.replacementUpdateTime = t1.updateTime;
                const n = t1.getReplacementRegionsForTile(e1.toUnwrapped());
                if (Wp(this.activeReplacements, n)) return;
                if (this.activeReplacements = n, 0 === this.centroidVertexArray.length) this.createCentroidsBuffer();
                else for (const e1 of this.centroidData)e1.flags &= 1073741823;
                const i = [];
                for (const t1 of this.activeReplacements){
                    if (t1.order < r) continue;
                    const n = Math.max(1, Math.pow(2, t1.footprintTileId.canonical.z - e1.canonical.z));
                    if (t1.footprint.buildingIds) for (const e1 of this.centroidData)e1.flags & df || e1.flags & pf || t1.min.x > e1.max.x || e1.min.x > t1.max.x || t1.min.y > e1.max.y || e1.min.y > t1.max.y || t1.footprint.buildingIds.has(e1.buildingId) && (e1.flags |= t1.clipMask !== rf.None ? -1073741824 : df);
                    else for (const r of this.centroidData)if (!(r.flags & df || r.flags & pf || t1.min.x > r.max.x || r.min.x > t1.max.x || t1.min.y > r.max.y || r.min.y > t1.max.y)) for(let s = 0; s < r.footprintSegLen; s++){
                        const a = this.footprintSegments[r.footprintSegIdx + s];
                        if (i.length = 0, Cf(this.footprintVertices, a.vertexOffset, a.vertexCount, t1.footprintTileId.canonical, e1.canonical, i), Kp(t1.footprint, i, this.footprintIndices.uint16, a.indexOffset, a.indexCount, -a.vertexOffset, -n)) {
                            r.flags |= t1.clipMask !== rf.None ? -1073741824 : df;
                            break;
                        }
                    }
                }
                for (const e1 of this.centroidData)this.writeCentroidToBuffer(e1);
                this.borderDoneWithNeighborZ = [
                    -1,
                    -1,
                    -1,
                    -1
                ];
            }
            footprintContainsPoint(e1, t1, r) {
                let n = !1;
                for(let i = 0; i < r.footprintSegLen; i++){
                    const s = this.footprintSegments[r.footprintSegIdx + i];
                    let a = 0;
                    for (const r of s.ringIndices){
                        for(let i = a, o = r + a - 1; i < r + a; o = i++){
                            const r = this.footprintVertices.int16[2 * (i + s.vertexOffset) + 0], a = this.footprintVertices.int16[2 * (i + s.vertexOffset) + 1], l = this.footprintVertices.int16[2 * (o + s.vertexOffset) + 1];
                            a > t1 != l > t1 && e1 < (this.footprintVertices.int16[2 * (o + s.vertexOffset) + 0] - r) * (t1 - a) / (l - a) + r && (n = !n);
                        }
                        a = r;
                    }
                }
                return n;
            }
            getHeightAtTileCoord(e1, t1) {
                let r = Number.NEGATIVE_INFINITY, n = !0;
                const i = 4 * (e1 + qn) * qn + (t1 + qn);
                if (this.partLookup.hasOwnProperty(i)) {
                    const e1 = this.partLookup[i];
                    return e1 ? {
                        height: e1.height,
                        hidden: !!(e1.flags & df)
                    } : void 0;
                }
                for (const s of this.centroidData)e1 > s.max.x || s.min.x > e1 || t1 > s.max.y || s.min.y > t1 || s.height <= r || this.footprintContainsPoint(e1, t1, s) && (r = s.height, this.partLookup[i] = s, n = !!(s.flags & df));
                if (r !== Number.NEGATIVE_INFINITY) return {
                    height: r,
                    hidden: n
                };
                this.partLookup[i] = void 0;
            }
        }
        function Bf(e1, t1) {
            const r = e1.add(t1)._unit();
            return e1.x * r.x + e1.y * r.y;
        }
        function Sf(e1, t1, r, n) {
            const i = t1.sub(e1)._perp()._unit(), s = r.sub(t1)._perp()._unit();
            return Pf(e1, t1, r, Bf(i, s), n);
        }
        function Pf(e1, t1, r, n, i) {
            const s = Math.sqrt(1 - n * n);
            return Math.min(e1.dist(t1) / 3, t1.dist(r) / 3, i * s / n);
        }
        function Tf(e1, t1, r) {
            return e1.x < r[0].x && t1.x < r[0].x || e1.x > r[1].x && t1.x > r[1].x || e1.y < r[0].y && t1.y < r[0].y || e1.y > r[1].y && t1.y > r[1].y;
        }
        function zf(e1, t1) {
            return e1.x < t1[0].x || e1.x > t1[1].x || e1.y < t1[0].y || e1.y > t1[1].y;
        }
        function kf(e1) {
            return e1.every((e1)=>e1.x <= 0) || e1.every((e1)=>e1.x >= qn) || e1.every((e1)=>e1.y <= 0) || e1.every((e1)=>e1.y >= qn);
        }
        function Vf(e1, t1, r) {
            if (e1.x < 0 || e1.x >= qn || t1.x < 0 || t1.x >= qn || r.x < 0 || r.x >= qn) return !1;
            const n = r.sub(t1), i = n.perp(), s = e1.sub(t1);
            return (n.x * s.x + n.y * s.y) / Math.sqrt((n.x * n.x + n.y * n.y) * (s.x * s.x + s.y * s.y)) > -0.866 && i.x * s.x + i.y * s.y < 0;
        }
        function Ff(e1, t1, r) {
            const n = t1 ? 2 | e1 : -3 & e1;
            return r ? 1 | n : -2 & n;
        }
        function Df() {
            const e1 = Math.PI / 32, t1 = Math.tan(e1), r = Eu;
            return r * Math.sqrt(1 + 2 * t1 * t1) - r;
        }
        function Ef(e1, t1, r) {
            const n = 1 << r.z, i = Gu(r.x / n), s = Gu((r.x + 1) / n), a = $u(r.y / n), o = $u((r.y + 1) / n);
            return function(e1, t1, r, n, i = 0, s) {
                const a = [];
                if (!e1.length || !r || !n) return a;
                const o = (e1, t1)=>{
                    for (const r of e1)a.push({
                        polygon: r,
                        bounds: t1
                    });
                }, l = Math.ceil(Math.log2(r)), u = Math.ceil(Math.log2(n)), c = l - u, h = [];
                for(let e1 = 0; e1 < Math.abs(c); e1++)h.push(c > 0 ? 0 : 1);
                for(let e1 = 0; e1 < Math.min(l, u); e1++)h.push(0), h.push(1);
                let d = e1;
                if (d = wp(d, t1[0].y - i, t1[1].y + i, 1), d = wp(d, t1[0].x - i, t1[1].x + i, 0), !d.length) return a;
                const p = [];
                for(h.length ? p.push({
                    polygons: d,
                    bounds: t1,
                    depth: 0
                }) : o(d, t1); p.length;){
                    const e1 = p.pop(), t1 = e1.depth, r = h[t1], n = e1.bounds[0], a = e1.bounds[1], l = 0 === r ? n.x : n.y, u = 0 === r ? a.x : a.y, c = s ? s(r, l, u) : .5 * (l + u), d = wp(e1.polygons, l - i, c + i, r), f = wp(e1.polygons, c - i, u + i, r);
                    if (d.length) {
                        const e1 = [
                            n,
                            new Me(0 === r ? c : a.x, 1 === r ? c : a.y)
                        ];
                        h.length > t1 + 1 ? p.push({
                            polygons: d,
                            bounds: e1,
                            depth: t1 + 1
                        }) : o(d, e1);
                    }
                    if (f.length) {
                        const e1 = [
                            new Me(0 === r ? c : n.x, 1 === r ? c : n.y),
                            a
                        ];
                        h.length > t1 + 1 ? p.push({
                            polygons: f,
                            bounds: e1,
                            depth: t1 + 1
                        }) : o(f, e1);
                    }
                }
                return a;
            }(e1, t1, Math.ceil((s - i) / 11.25), Math.ceil((a - o) / 11.25), 1, (e1, t1, i)=>{
                if (0 === e1) return .5 * (t1 + i);
                {
                    const e1 = $u((r.y + t1 / qn) / n);
                    return (Nu(.5 * ($u((r.y + i / qn) / n) + e1)) * n - r.y) * qn;
                }
            });
        }
        function Cf(e1, t1, r, n, i, s) {
            const a = Math.pow(2, n.z - i.z);
            for(let o = 0; o < r; o++){
                let r = e1.int16[2 * (o + t1) + 0], l = e1.int16[2 * (o + t1) + 1];
                r = (r + i.x * qn) * a - n.x * qn, l = (l + i.y * qn) * a - n.y * qn, s.push(new Me(r, l));
            }
        }
        let Rf, Lf;
        ra(Mf, "FillExtrusionBucket", {
            omit: [
                "layers",
                "features"
            ]
        }), ra(vf, "PartData"), ra(xf, "FootprintSegment"), ra(bf, "BorderCentroidData"), ra(If, "GroundEffect");
        class Of extends Me {
            constructor(e1, t1, r){
                super(e1, t1), this.z = r;
            }
        }
        class Uf extends Of {
            constructor(e1, t1, r, n){
                super(e1, t1, r), this.w = n;
            }
        }
        function Nf(e1, t1, r, n) {
            const i = "x" === r ? "y" : "x", s = (n - e1[r]) / (t1[r] - e1[r]);
            e1[i] = Math.round(e1[i] + (t1[i] - e1[i]) * s), e1[r] = n, e1.hasOwnProperty("z") && (e1.z = yr(e1.z, t1.z, s)), e1.hasOwnProperty("w") && (e1.w = yr(e1.w, t1.w, s));
        }
        function jf(e1, t1, r, n) {
            const i = r, s = n;
            for (const r of [
                "x",
                "y"
            ]){
                let n = e1, a = t1;
                n[r] >= a[r] && (n = t1, a = e1), n[r] < i && a[r] > i && Nf(n, a, r, i), n[r] < s && a[r] > s && Nf(a, n, r, s);
            }
        }
        function Gf(e1, t1, r, n, i, s) {
            const a = [];
            for(let o = 0; o < e1.length; o++){
                const l = e1[o];
                let u;
                const c = a.length;
                let h = 0;
                for(let e1 = 0; e1 < l.length - 1; e1++){
                    let c = l[e1], d = l[e1 + 1], p = 0;
                    const f = h;
                    let m, y;
                    s && (p = Math.hypot(d.x - c.x, d.y - c.y), h += p, m = c, y = d), c.x < t1 && d.x < t1 || (c.x < t1 ? c = new Me(t1, c.y + (t1 - c.x) / (d.x - c.x) * (d.y - c.y))._round() : d.x < t1 && (d = new Me(t1, c.y + (t1 - c.x) / (d.x - c.x) * (d.y - c.y))._round()), c.y < r && d.y < r || (c.y < r ? c = new Me(c.x + (r - c.y) / (d.y - c.y) * (d.x - c.x), r)._round() : d.y < r && (d = new Me(c.x + (r - c.y) / (d.y - c.y) * (d.x - c.x), r)._round()), c.x >= n && d.x >= n || (c.x >= n ? c = new Me(n, c.y + (n - c.x) / (d.x - c.x) * (d.y - c.y))._round() : d.x >= n && (d = new Me(n, c.y + (n - c.x) / (d.x - c.x) * (d.y - c.y))._round()), c.y >= i && d.y >= i || (c.y >= i ? c = new Me(c.x + (i - c.y) / (d.y - c.y) * (d.x - c.x), i)._round() : d.y >= i && (d = new Me(c.x + (i - c.y) / (d.y - c.y) * (d.x - c.x), i)._round()), u && c.equals(u[u.length - 1]) || (u = [
                        c
                    ], a.push(u), s && s.push({
                        progress: {
                            min: f + qf(m, y, c) * p,
                            max: 1
                        },
                        parentIndex: o,
                        prevPoint: m,
                        nextPoint: y
                    })), u.push(d), s && (s[s.length - 1].progress.max = f + qf(m, y, d) * p, s[s.length - 1].nextPoint = y)))));
                }
                if (s && h > 0) for(let e1 = c; e1 < a.length; e1++)s[e1].progress.min /= h, s[e1].progress.max /= h;
            }
            return a;
        }
        function $f(e1, t1, r, n, i) {
            if (e1.length < 2) return void n.push(e1);
            const s = [];
            for(; t1.valid();){
                const [r, n] = t1.get();
                for(let t1 = 0; t1 < e1.length - 1; t1++){
                    const i = e1[t1], a = e1[t1 + 1], o = jc(i, a, r, n);
                    if (o) {
                        const [e1] = o, r = new Me(yr(i.x, a.x, e1), yr(i.y, a.y, e1));
                        s.push({
                            t: t1 + e1,
                            distance: 0,
                            point: r
                        });
                    }
                }
                t1.next();
            }
            if (0 === s.length) return void n.push(e1);
            s.sort((e1, t1)=>e1.t - t1.t);
            let a = 0, o = 0, l = [];
            for(n.push(l); a !== e1.length;){
                if (o === s.length) {
                    for(; a !== e1.length;)0 !== l.length && l[l.length - 1].equals(e1[a]) || l.push(e1[a]), a++;
                    break;
                }
                s[o].t <= a ? (0 !== l.length && l[l.length - 1].equals(s[o].point) || l.push(s[o].point), s[o].t, o++) : (0 !== l.length && l[l.length - 1].equals(e1[a]) || l.push(e1[a]), a++);
            }
        }
        function qf(e1, t1, r) {
            return e1.x !== t1.x ? (r.x - e1.x) / (t1.x - e1.x) : e1.y !== t1.y ? (r.y - e1.y) / (t1.y - e1.y) : 0;
        }
        function Hf(e1, t1) {
            return e1.x * t1.x + e1.y * t1.y;
        }
        function Xf(e1, t1) {
            if (1 === e1.length) {
                let r = 0;
                const n = t1[r++];
                let i;
                for(; !i || n.equals(i);)if (i = t1[r++], !i) return 1 / 0;
                for(; r < t1.length; r++){
                    const s = t1[r], a = e1[0], o = i.sub(n), l = s.sub(n), u = a.sub(n), c = Hf(o, o), h = Hf(o, l), d = Hf(l, l), p = Hf(u, o), f = Hf(u, l), m = c * d - h * h, y = (d * p - h * f) / m, g = (c * f - h * p) / m, x = n.z * (1 - y - g) + i.z * y + s.z * g;
                    if (isFinite(x)) return x;
                }
                return 1 / 0;
            }
            {
                let e1 = 1 / 0;
                for (const r of t1)e1 = Math.min(e1, r.z);
                return e1;
            }
        }
        function Zf(e1, t1, r) {
            let n = 1 / 0;
            Rc(r, t1) && (n = Xf(r, t1[0]));
            for(let i = 0; i < t1.length; i++){
                const s = t1[i], a = e1[i];
                for(let e1 = 0; e1 < s.length - 1; e1++){
                    const t1 = s[e1], i = [
                        t1,
                        s[e1 + 1],
                        a[e1 + 1],
                        a[e1],
                        t1
                    ];
                    Ec(r, i) && (n = Math.min(n, Xf(r, i)));
                }
            }
            return n !== 1 / 0 && n;
        }
        function Wf(e1, t1, r, n, i, s, a, o, l, u, c) {
            return "globe" === e1.projection.name ? function(e1, t1, r, n, i, s, a, o, l, u, c) {
                const h = [], d = [], p = e1.projection.upVectorScale(c, e1.center.lat, e1.worldSize).metersToTile, f = [
                    0,
                    0,
                    0,
                    1
                ], m = [
                    0,
                    0,
                    0,
                    1
                ], y = (e1, t1, r, n)=>{
                    e1[0] = t1, e1[1] = r, e1[2] = n, e1[3] = 1;
                }, g = Df();
                r > 0 && (r += g), n += g;
                for (const g of t1){
                    const t1 = [], x = [];
                    for (const h of g){
                        const d = h.x + i.x, g = h.y + i.y, v = e1.projection.projectTilePoint(d, g, c), b = e1.projection.upVector(c, h.x, h.y);
                        let w = r, _ = n;
                        if (a) {
                            const e1 = Yf(d, g, r, n, a, o, l, u);
                            w += e1.base, _ += e1.top;
                        }
                        0 !== r ? y(f, v.x + b[0] * p * w, v.y + b[1] * p * w, v.z + b[2] * p * w) : y(f, v.x, v.y, v.z), y(m, v.x + b[0] * p * _, v.y + b[1] * p * _, v.z + b[2] * p * _), j(f, f, s), j(m, m, s), t1.push(new Of(f[0], f[1], f[2])), x.push(new Of(m[0], m[1], m[2]));
                    }
                    h.push(t1), d.push(x);
                }
                return [
                    h,
                    d
                ];
            }(e1, t1, r, n, i, s, a, o, l, u, c) : a ? function(e1, t1, r, n, i, s, a, o, l) {
                const u = [], c = [], h = [
                    0,
                    0,
                    0,
                    1
                ];
                for (const d of e1){
                    const e1 = [], p = [];
                    for (const u of d){
                        const c = u.x + n.x, d = u.y + n.y, f = Yf(c, d, t1, r, s, a, o, l);
                        h[0] = c, h[1] = d, h[2] = f.base, h[3] = 1, ee(h, h, i), h[3] = Math.max(h[3], 1e-5);
                        const m = new Of(h[0] / h[3], h[1] / h[3], h[2] / h[3]);
                        h[0] = c, h[1] = d, h[2] = f.top, h[3] = 1, ee(h, h, i), h[3] = Math.max(h[3], 1e-5);
                        const y = new Of(h[0] / h[3], h[1] / h[3], h[2] / h[3]);
                        e1.push(m), p.push(y);
                    }
                    u.push(e1), c.push(p);
                }
                return [
                    u,
                    c
                ];
            }(t1, r, n, i, s, a, o, l, u) : function(e1, t1, r, n, i) {
                const s = [], a = [], o = i[8] * t1, l = i[9] * t1, u = i[10] * t1, c = i[11] * t1, h = i[8] * r, d = i[9] * r, p = i[10] * r, f = i[11] * r;
                for (const t1 of e1){
                    const e1 = [], r = [];
                    for (const s of t1){
                        const t1 = s.x + n.x, a = s.y + n.y, m = i[0] * t1 + i[4] * a + i[12], y = i[1] * t1 + i[5] * a + i[13], g = i[2] * t1 + i[6] * a + i[14], x = i[3] * t1 + i[7] * a + i[15], v = m + o, b = y + l, w = g + u, _ = Math.max(x + c, 1e-5), A = m + h, I = y + d, M = g + p, B = Math.max(x + f, 1e-5);
                        e1.push(new Of(v / _, b / _, w / _)), r.push(new Of(A / B, I / B, M / B));
                    }
                    s.push(e1), a.push(r);
                }
                return [
                    s,
                    a
                ];
            }(t1, r, n, i, s);
        }
        function Yf(e1, t1, r, n, i, s, a, o) {
            const l = a * i.getElevationAt(e1, t1, !0, !0), u = 0 !== s[0], c = u ? 0 === s[1] ? a * (s[0] / 7 - 450) : a * function(e1, t1, r) {
                const n = Math.floor(t1[0] / 8), i = Math.floor(t1[1] / 8), s = 10 * (t1[0] - 8 * n), a = 10 * (t1[1] - 8 * i), o = e1.getElevationAt(n, i, !0, !0), l = e1.getMeterToDEM(r), u = Math.floor(.5 * (s * l - 1)), c = Math.floor(.5 * (a * l - 1)), h = e1.tileCoordToPixel(n, i), d = 2 * u + 1, p = 2 * c + 1, f = function(e1, t1, r, n, i) {
                    return [
                        e1.getElevationAtPixel(t1, r, !0),
                        e1.getElevationAtPixel(t1 + i, r, !0),
                        e1.getElevationAtPixel(t1, r + i, !0),
                        e1.getElevationAtPixel(t1 + n, r + i, !0)
                    ];
                }(e1, h.x - u, h.y - c, d, p), m = Math.abs(f[0] - f[1]), y = Math.abs(f[2] - f[3]), g = Math.abs(f[0] - f[2]) + Math.abs(f[1] - f[3]), x = Math.min(.25, .5 * l * (m + y) / d), v = Math.min(.25, .5 * l * g / p);
                return o + Math.max(x * s, v * a);
            }(i, s, o) : l;
            return {
                base: l + (0 === r ? -1 : r),
                top: u ? Math.max(c + n, l + r + 2) : l + n
            };
        }
        const Jf = 4096;
        class Kf {
            constructor(e1){
                this.module = e1, this.memoryStack = this.module.malloc(Jf), this.memoryStackNextFree = this.memoryStack;
            }
            createIntArray(e1) {
                const t1 = this.memoryStackNextFree;
                return this.memoryStackNextFree += e1.length * Int32Array.BYTES_PER_ELEMENT, this.memoryStackNextFree - this.memoryStack > Jf ? -1 : (new Int32Array(this.module.heap32.buffer, t1, e1.length).set(e1), t1);
            }
            createFloatArray(e1) {
                const t1 = this.memoryStackNextFree;
                return this.memoryStackNextFree += e1.length * Float32Array.BYTES_PER_ELEMENT, this.memoryStackNextFree - this.memoryStack > Jf ? -1 : (new Float32Array(this.module.heapF32.buffer, t1, e1.length).set(e1), t1);
            }
            readStringBuffer(e1) {
                let t1 = "";
                for(; 0 !== this.module.heapU8[e1];)t1 += String.fromCharCode(this.module.heapU8[e1]), ++e1;
                return t1;
            }
            setStyle(e1) {
                const t1 = e1.normalScale;
                this.module.setStyle(t1[0], t1[1], t1[2], e1.tileToMeters);
            }
            setAOOptions(e1, t1) {
                this.module.setAOOptions(e1 ? 1 : 0, t1);
            }
            setMetricOptions(e1, t1) {
                this.module.setMetricOptions(e1 ? 1 : 0, t1);
            }
            setStructuralOptions(e1) {
                this.module.setStructuralOptions(e1 ? 1 : 0);
            }
            setFacadeOptions(e1, t1) {
                this.module.setFacadeOptions(e1, t1 ? 1 : 0);
            }
            setFauxFacadeOptions(e1, t1, r) {
                this.module.setFauxFacadeOptions(e1 ? 1 : 0, t1 ? 1 : 0, r);
            }
            setFacadeClassifierOptions(e1) {
                this.module.setFacadeClassifierOptions(e1);
            }
            generateMesh(e1, t1) {
                this.memoryStackNextFree = this.memoryStack;
                for (const t1 of e1){
                    const e1 = this.createIntArray(t1.ringIndices), r = this.createFloatArray(t1.coordinates);
                    if (-1 === e1 || -1 === r) return `building_gen: Out of stack memory: ${this.memoryStackNextFree - this.memoryStack}/4096`;
                    this.module.addFeature(t1.id, t1.sourceId, t1.minHeight, t1.height, t1.roofType, r, e1, t1.ringIndices.length - 1);
                }
                for (const e1 of t1){
                    let t1;
                    t1 = e1.entrances ? JSON.parse(e1.entrances) : [];
                    const r = this.createFloatArray(t1), n = this.createFloatArray(e1.coordinates);
                    if (-1 === r || -1 === n) return `building_gen: Out of stack memory: ${this.memoryStackNextFree - this.memoryStack}/4096`;
                    this.module.addFacade(e1.sourceId, e1.crossPerc, e1.distanceToRoad, r, t1.length, n, e1.coordinates.length);
                }
                if (!this.module.generateMesh()) {
                    const e1 = this.module.getLastError();
                    return this.readStringBuffer(e1);
                }
                const r = this.module.getMeshCount(), n = new Array(r);
                for(let e1 = 0; e1 < r; e1++){
                    const t1 = this.module.getPositionsPtr(e1), r = this.module.getPositionsLength(e1), i = new Float32Array(this.module.heapF32.buffer, t1, r), s = this.module.getNormalsPtr(e1), a = this.module.getNormalsLength(e1), o = new Float32Array(this.module.heapF32.buffer, s, a), l = this.module.getAOPtr(e1), u = this.module.getAOLength(e1), c = new Float32Array(this.module.heapF32.buffer, l, u), h = this.module.getUVPtr(e1), d = this.module.getUVLength(e1), p = new Float32Array(this.module.heapF32.buffer, h, d), f = this.module.getFauxFacadePtr(e1), m = this.module.getFauxFacadeLength(e1), y = new Uint8Array(this.module.heapU8.buffer, f, m), g = this.module.getIndicesPtr(e1), x = this.module.getIndicesLength(e1), v = new Int16Array(this.module.heap16.buffer, g, x), b = this.module.getBuildingPart(e1);
                    n[e1] = {
                        positions: i,
                        normals: o,
                        ao: c,
                        uv: p,
                        isFauxFacade: y,
                        indices: v,
                        buildingPart: b
                    };
                }
                const i = this.module.getRingCount(), s = [];
                for(let e1 = 0; e1 < i; e1++){
                    const t1 = this.module.getRingPtr(e1), r = this.module.getRingLength(e1), n = new Float32Array(this.module.heapF32.buffer, t1, r);
                    s.push(n);
                }
                return {
                    meshes: n,
                    outerRingLength: this.module.getOuterRingLength(),
                    modifiedPolygonRings: s
                };
            }
        }
        let Qf, em = null, tm = null, rm = null, nm = null, im = null;
        function sm() {
            return rm;
        }
        const am = 5120, om = 5121, lm = 5122, um = 5123, cm = 5125, hm = 5126, dm = {
            [am]: Int8Array,
            [om]: Uint8Array,
            [lm]: Int16Array,
            [um]: Uint16Array,
            [cm]: Uint32Array,
            [hm]: Float32Array
        }, pm = {
            [am]: "DT_INT8",
            [om]: "DT_UINT8",
            [lm]: "DT_INT16",
            [um]: "DT_UINT16",
            [cm]: "DT_UINT32",
            [hm]: "DT_FLOAT32"
        }, fm = {
            SCALAR: 1,
            VEC2: 2,
            VEC3: 3,
            VEC4: 4,
            MAT2: 4,
            MAT3: 9,
            MAT4: 16
        };
        function mm(e1, t1, r) {
            const n = r.json.bufferViews.length, i = r.buffers.length;
            t1.bufferView = n, r.json.bufferViews[n] = {
                buffer: i,
                byteLength: e1.byteLength
            }, r.buffers[i] = e1;
        }
        const ym = "KHR_draco_mesh_compression";
        function gm(e1, t1) {
            const r = e1.extensions && e1.extensions[ym];
            if (!r) return;
            const n = new em.Decoder, i = Im(t1, r.bufferView), s = new em.Mesh;
            if (!n.DecodeArrayToMesh(i, i.byteLength, s)) throw new Error("Failed to decode Draco mesh");
            const a = t1.json.accessors[e1.indices], o = dm[a.componentType], l = a.count * o.BYTES_PER_ELEMENT, u = em._malloc(l);
            o === Uint16Array ? n.GetTrianglesUInt16Array(s, l, u) : n.GetTrianglesUInt32Array(s, l, u), mm(em.memory.buffer.slice(u, u + l), a, t1), em._free(u);
            for (const i of Object.keys(r.attributes)){
                const a = n.GetAttributeByUniqueId(s, r.attributes[i]), o = t1.json.accessors[e1.attributes[i]], l = pm[o.componentType], u = o.count * fm[o.type] * dm[o.componentType].BYTES_PER_ELEMENT, c = em._malloc(u);
                n.GetAttributeDataArrayForAllPoints(s, a, em[l], u, c), mm(em.memory.buffer.slice(c, c + u), o, t1), em._free(c);
            }
            n.destroy(), s.destroy(), delete e1.extensions[ym];
        }
        const xm = "EXT_meshopt_compression";
        function vm(e1, t1) {
            if (!e1.extensions || !e1.extensions[xm]) return;
            const r = e1.extensions[xm], n = new Uint8Array(t1.buffers[r.buffer], r.byteOffset || 0, r.byteLength || 0), i = new Uint8Array(r.count * r.byteStride);
            tm.decodeGltfBuffer(i, r.count, r.byteStride, n, r.mode, r.filter), e1.buffer = t1.buffers.length, e1.byteOffset = 0, t1.buffers[e1.buffer] = i.buffer, delete e1.extensions[xm];
        }
        const bm = 1179937895, wm = new TextDecoder("utf8");
        function _m(e1, t1) {
            return new URL(e1, t1).href;
        }
        async function Am(e1, t1, r, n, i) {
            const s = await fetch(_m(e1.uri, n), {
                signal: i
            }), a = await s.arrayBuffer();
            t1.buffers[r] = a;
        }
        function Im(e1, t1) {
            const r = e1.json.bufferViews[t1];
            return new Uint8Array(e1.buffers[r.buffer], r.byteOffset || 0, r.byteLength);
        }
        async function Mm(e1, t1, r, n, i) {
            if (e1.uri) {
                const s = _m(e1.uri, n), a = await fetch(s, {
                    signal: i
                }), o = await a.blob(), l = await createImageBitmap(o);
                t1.images[r] = l;
            } else if (void 0 !== e1.bufferView) {
                const n = Im(t1, e1.bufferView), i = new Blob([
                    n
                ], {
                    type: e1.mimeType
                }), s = await createImageBitmap(i);
                t1.images[r] = s;
            }
        }
        async function Bm(e1, t1 = 0, r, n) {
            const i = {
                json: null,
                images: [],
                buffers: []
            };
            if (new Uint32Array(e1, t1, 1)[0] === bm) {
                const r = new Uint32Array(e1, t1);
                let n = 2;
                const s = (r[n++] >> 2) - 3, a = r[n++] >> 2;
                if (n++, i.json = JSON.parse(wm.decode(r.subarray(n, n + a))), n += a, n < s) {
                    const s = r[n++];
                    n++;
                    const a = t1 + (n << 2);
                    i.buffers[0] = e1.slice(a, a + s);
                }
            } else i.json = JSON.parse(wm.decode(new Uint8Array(e1, t1)));
            const { buffers: s, images: a, meshes: o, extensionsUsed: l, bufferViews: u } = i.json;
            if (s) {
                const e1 = [];
                for(let t1 = 0; t1 < s.length; t1++){
                    const a = s[t1];
                    a.uri ? e1.push(Am(a, i, t1, r, n)) : i.buffers[t1] || (i.buffers[t1] = null);
                }
                await Promise.all(e1);
            }
            if (n && n.aborted) throw new DOMException("Aborted", "AbortError");
            const c = [], h = l && l.includes(ym), d = l && l.includes(xm);
            if (h && c.push(function() {
                if (!em) return null != Qf ? Qf : (Qf = function(e1) {
                    let t1, r = null;
                    function n() {
                        t1 = new Uint8Array(r.buffer);
                    }
                    function i() {
                        throw new Error("Unexpected Draco error.");
                    }
                    const s = {
                        a: {
                            a: i,
                            d: function(e1, r, n) {
                                return t1.copyWithin(e1, r, r + n);
                            },
                            c: function(e1) {
                                const i = t1.length, s = Math.max(e1 >>> 0, Math.ceil(1.2 * i)), a = Math.ceil((s - i) / 65536);
                                try {
                                    return r.grow(a), n(), !0;
                                } catch (e1) {
                                    return !1;
                                }
                            },
                            b: i
                        }
                    };
                    return (WebAssembly.instantiateStreaming ? WebAssembly.instantiateStreaming(e1, s) : e1.then((e1)=>e1.arrayBuffer()).then((e1)=>WebAssembly.instantiate(e1, s))).then((e1)=>{
                        const { Rb: i, Qb: s, P: a, T: o, X: l, Ja: u, La: c, Qa: h, Va: d, Wa: p, eb: f, jb: m, f: y, e: g, yb: x, zb: v, Ab: b, Bb: w, Db: _, Gb: A } = e1.instance.exports;
                        r = g;
                        const I = (()=>{
                            let e1 = 0, r = 0, n = 0, a = 0;
                            return (o)=>{
                                n && (i(a), i(e1), r += n, n = e1 = 0), e1 || (r += 128, e1 = s(r));
                                const l = o.length + 7 & -8;
                                let u = e1;
                                l >= r && (n = l, u = a = s(l));
                                for(let e1 = 0; e1 < o.length; e1++)t1[u + e1] = o[e1];
                                return u;
                            };
                        })();
                        return n(), y(), {
                            memory: g,
                            _free: i,
                            _malloc: s,
                            Mesh: class {
                                constructor(){
                                    this.ptr = a();
                                }
                                destroy() {
                                    o(this.ptr);
                                }
                            },
                            Decoder: class {
                                constructor(){
                                    this.ptr = u();
                                }
                                destroy() {
                                    m(this.ptr);
                                }
                                DecodeArrayToMesh(e1, t1, r) {
                                    const n = I(e1), i = c(this.ptr, n, t1, r.ptr);
                                    return !!l(i);
                                }
                                GetAttributeByUniqueId(e1, t1) {
                                    return {
                                        ptr: h(this.ptr, e1.ptr, t1)
                                    };
                                }
                                GetTrianglesUInt16Array(e1, t1, r) {
                                    d(this.ptr, e1.ptr, t1, r);
                                }
                                GetTrianglesUInt32Array(e1, t1, r) {
                                    p(this.ptr, e1.ptr, t1, r);
                                }
                                GetAttributeDataArrayForAllPoints(e1, t1, r, n, i) {
                                    f(this.ptr, e1.ptr, t1.ptr, r, n, i);
                                }
                            },
                            DT_INT8: x(),
                            DT_UINT8: v(),
                            DT_INT16: b(),
                            DT_UINT16: w(),
                            DT_UINT32: _(),
                            DT_FLOAT32: A()
                        };
                    });
                }(fetch(ut())), Qf.then((e1)=>{
                    em = e1, Qf = void 0;
                }));
            }()), d && c.push(function() {
                if (tm) return;
                const e1 = function(e1) {
                    let t1;
                    const r = WebAssembly.instantiateStreaming(e1, {}).then((e1)=>{
                        t1 = e1.instance, t1.exports.__wasm_call_ctors();
                    }), n = {
                        NONE: "",
                        OCTAHEDRAL: "meshopt_decodeFilterOct",
                        QUATERNION: "meshopt_decodeFilterQuat",
                        EXPONENTIAL: "meshopt_decodeFilterExp"
                    }, i = {
                        ATTRIBUTES: "meshopt_decodeVertexBuffer",
                        TRIANGLES: "meshopt_decodeIndexBuffer",
                        INDICES: "meshopt_decodeIndexSequence"
                    };
                    return {
                        ready: r,
                        supported: !0,
                        decodeGltfBuffer (e1, r, s, a, o, l) {
                            !function(e1, t1, r, n, i, s, a) {
                                const o = e1.exports.sbrk, l = n + 3 & -4, u = o(l * i), c = o(s.length), h = new Uint8Array(e1.exports.memory.buffer);
                                h.set(s, c);
                                const d = t1(u, n, i, c, s.length);
                                if (0 === d && a && a(u, l, i), r.set(h.subarray(u, u + n * i)), o(u - o(0)), 0 !== d) throw new Error(`Malformed buffer data: ${d}`);
                            }(t1, t1.exports[i[o]], e1, r, s, a, t1.exports[n[l]]);
                        }
                    };
                }(fetch(ct()));
                return e1.ready.then(()=>{
                    tm = e1;
                });
            }()), a) for(let e1 = 0; e1 < a.length; e1++)c.push(Mm(a[e1], i, e1, r, n));
            if (c.length && await Promise.all(c), n && n.aborted) throw new DOMException("Aborted", "AbortError");
            if (h && o) for (const { primitives: e1 } of o)for (const t1 of e1)gm(t1, i);
            if (d && o && u) for (const e1 of u)vm(e1, i);
            return i;
        }
        async function Sm(e1, t1) {
            const r = await async function(e1, t1) {
                if (t1 && t1.aborted) throw new DOMException("Aborted", "AbortError");
                return new Promise((r, n)=>{
                    const i = Gt(e1, (e1, t1)=>{
                        e1 ? n(e1) : r(t1);
                    });
                    t1 && t1.addEventListener("abort", ()=>{
                        i.cancel(), n(new DOMException("Aborted", "AbortError"));
                    }, {
                        once: !0
                    });
                });
            }({
                url: e1,
                type: "arrayBuffer"
            }, t1);
            return Bm(r, 0, e1, t1);
        }
        function Pm(e1) {
            switch(e1){
                case WebGL2RenderingContext.RGBA8:
                case WebGL2RenderingContext.RGBA16F:
                    return WebGL2RenderingContext.RGBA;
                case WebGL2RenderingContext.DEPTH_COMPONENT16:
                    return WebGL2RenderingContext.DEPTH_COMPONENT;
                case WebGL2RenderingContext.DEPTH24_STENCIL8:
                    return WebGL2RenderingContext.DEPTH_STENCIL;
                case WebGL2RenderingContext.R8:
                case WebGL2RenderingContext.R32F:
                    return WebGL2RenderingContext.RED;
            }
        }
        function Tm(e1) {
            switch(e1){
                case WebGL2RenderingContext.RGBA8:
                    return WebGL2RenderingContext.UNSIGNED_BYTE;
                case WebGL2RenderingContext.RGBA16F:
                    return WebGL2RenderingContext.HALF_FLOAT;
                case WebGL2RenderingContext.DEPTH_COMPONENT16:
                    return WebGL2RenderingContext.UNSIGNED_SHORT;
                case WebGL2RenderingContext.DEPTH24_STENCIL8:
                    return WebGL2RenderingContext.UNSIGNED_INT_24_8;
                case WebGL2RenderingContext.R8:
                    return WebGL2RenderingContext.UNSIGNED_BYTE;
                case WebGL2RenderingContext.R32F:
                    return WebGL2RenderingContext.FLOAT;
            }
        }
        class zm {
            constructor(e1, t1, r, n){
                this.context = e1, this.format = r, this.useMipmap = n && n.useMipmap, this.texture = e1.gl.createTexture(), this.update(t1, {
                    premultiply: n && n.premultiply
                });
            }
            update(e1, t1) {
                const r = e1 && e1 instanceof HTMLVideoElement && 0 === e1.width ? e1.videoWidth : e1.width, n = e1 && e1 instanceof HTMLVideoElement && 0 === e1.height ? e1.videoHeight : e1.height, { context: i } = this, { gl: s } = i, { x: a, y: o } = t1 && t1.position ? t1.position : {
                    x: 0,
                    y: 0
                }, l = a + r, u = o + n;
                this.size && (this.size[0] !== l || this.size[1] !== u) && (!t1 || void 0 === t1.recreateWhenResize || t1.recreateWhenResize) && (s.bindTexture(s.TEXTURE_2D, null), s.deleteTexture(this.texture), this.texture = s.createTexture(), this.size = null), s.bindTexture(s.TEXTURE_2D, this.texture), i.pixelStoreUnpackFlipY.set(!1), i.pixelStoreUnpack.set(1), i.pixelStoreUnpackPremultiplyAlpha.set(this.format === s.RGBA8 && (!t1 || !1 !== t1.premultiply));
                const c = e1 instanceof HTMLImageElement || e1 instanceof HTMLCanvasElement || e1 instanceof HTMLVideoElement || e1 instanceof ImageData || ImageBitmap && e1 instanceof ImageBitmap;
                if (!this.size && l > 0 && u > 0) {
                    const e1 = this.useMipmap ? Math.floor(Math.log2(Math.max(l, u))) + 1 : 1;
                    s.texStorage2D(s.TEXTURE_2D, e1, this.format, l, u), this.size = [
                        l,
                        u
                    ];
                }
                this.size && (c ? s.texSubImage2D(s.TEXTURE_2D, 0, a, o, Pm(this.format), Tm(this.format), e1) : "data" in e1 && e1.data && s.texSubImage2D(s.TEXTURE_2D, 0, a, o, r, n, Pm(this.format), Tm(this.format), e1.data)), this.useMipmap && s.generateMipmap(s.TEXTURE_2D);
            }
            bind(e1, t1, r = !1) {
                const { context: n } = this, { gl: i } = n;
                i.bindTexture(i.TEXTURE_2D, this.texture), e1 !== this.minFilter && (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MAG_FILTER, e1), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_MIN_FILTER, this.useMipmap && !r ? e1 === i.NEAREST ? i.NEAREST_MIPMAP_NEAREST : i.LINEAR_MIPMAP_LINEAR : e1), this.minFilter = e1), t1 !== this.wrapS && (i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_S, t1), i.texParameteri(i.TEXTURE_2D, i.TEXTURE_WRAP_T, t1), this.wrapS = t1);
            }
            bindExtraParam(e1, t1, r, n, i) {
                const { context: s } = this, { gl: a } = s;
                a.bindTexture(a.TEXTURE_2D, this.texture), t1 !== this.magFilter && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MAG_FILTER, t1), this.magFilter = t1), e1 !== this.minFilter && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_MIN_FILTER, this.useMipmap ? e1 === a.NEAREST ? a.NEAREST_MIPMAP_NEAREST : a.LINEAR_MIPMAP_LINEAR : e1), this.minFilter = e1), r !== this.wrapS && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_S, r), this.wrapS = r), n !== this.wrapT && (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_WRAP_T, n), this.wrapT = n), i !== this.compareMode && (i ? (a.texParameteri(a.TEXTURE_2D, a.TEXTURE_COMPARE_MODE, a.COMPARE_REF_TO_TEXTURE), a.texParameteri(a.TEXTURE_2D, a.TEXTURE_COMPARE_FUNC, i)) : a.texParameteri(a.TEXTURE_2D, a.TEXTURE_COMPARE_MODE, a.NONE), this.compareMode = i);
            }
            destroy() {
                const { gl: e1 } = this.context;
                e1.deleteTexture(this.texture), this.texture = null;
            }
        }
        class km {
            constructor(e1, t1){
                this.context = e1, this.texture = t1;
            }
            bind(e1, t1) {
                const { context: r } = this, { gl: n } = r;
                n.bindTexture(n.TEXTURE_2D, this.texture), e1 !== this.minFilter && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MAG_FILTER, e1), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_MIN_FILTER, e1), this.minFilter = e1), t1 !== this.wrapS && (n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_S, t1), n.texParameteri(n.TEXTURE_2D, n.TEXTURE_WRAP_T, t1), this.wrapS = t1);
            }
        }
        const Vm = qo([
            {
                name: "a_pos_3f",
                components: 3,
                type: "Float32"
            }
        ]), Fm = qo([
            {
                name: "a_color_3f",
                components: 3,
                type: "Float32"
            }
        ]), Dm = qo([
            {
                name: "a_color_4f",
                components: 4,
                type: "Float32"
            }
        ]), Em = qo([
            {
                name: "a_uv_2f",
                components: 2,
                type: "Float32"
            }
        ]), Cm = qo([
            {
                name: "a_normal_3f",
                components: 3,
                type: "Float32"
            }
        ]), Rm = qo([
            {
                name: "a_normal_matrix0",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix1",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix2",
                components: 4,
                type: "Float32"
            },
            {
                name: "a_normal_matrix3",
                components: 4,
                type: "Float32"
            }
        ]), Lm = qo([
            {
                name: "a_pbr",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_heightBasedEmissiveStrength",
                components: 3,
                type: "Float32"
            }
        ]);
        function Om(e1, t1) {
            const r = Nm(e1.projection, e1.zoom, e1.width, e1.height), n = function(e1, t1, r, n, i) {
                const s = new Ru(r.lng - 180 * jm, r.lat), a = new Ru(r.lng + 180 * jm, r.lat), o = e1.project(s.lng, s.lat), l = e1.project(a.lng, a.lat), c = -Math.atan2(l.y - o.y, l.x - o.x), d = Ju.fromLngLat(r);
                d.y = Ee(d.y, -1 + jm, 1 - jm);
                const f = d.toLngLat(), m = e1.project(f.lng, f.lat), g = Ju.fromLngLat(f);
                g.x += jm;
                const x = g.toLngLat(), v = e1.project(x.lng, x.lat), b = $m(v.x - m.x, v.y - m.y, c), w = Ju.fromLngLat(f);
                w.y += jm;
                const _ = w.toLngLat(), A = e1.project(_.lng, _.lat), I = $m(A.x - m.x, A.y - m.y, c), M = Math.abs(b.x) / Math.abs(I.y), B = u([]);
                y(B, B, -c * (1 - (i ? 0 : n)));
                const S = u([]);
                return p(S, S, [
                    1,
                    1 - (1 - M) * n,
                    1
                ]), S[4] = -I.x / I.y * n, y(S, S, c), h(S, B, S), S;
            }(e1.projection, 0, e1.center, r, t1), i = Um(e1);
            return p(n, n, [
                i,
                i,
                1
            ]), n;
        }
        function Um(e1) {
            const t1 = e1.projection, r = Nm(e1.projection, e1.zoom, e1.width, e1.height), n = Gm(t1, e1.center), i = Gm(t1, Ru.convert(t1.center));
            return Math.pow(2, n * r + (1 - r) * i);
        }
        function Nm(e1, t1, r, n, i = 1 / 0) {
            const s = e1.range;
            if (!s) return 0;
            const a = Math.min(i, Math.max(r, n)), o = Math.log2(a / 1024);
            return Ce(s[0] + o, s[1] + o, t1);
        }
        const jm = 1 / 4e4;
        function Gm(e1, t1) {
            const r = Ee(t1.lat, -85.051129, Hu), n = new Ru(t1.lng - 180 * jm, r), i = new Ru(t1.lng + 180 * jm, r), s = e1.project(n.lng, r), a = e1.project(i.lng, r), o = Ju.fromLngLat(n), l = Ju.fromLngLat(i), u = a.x - s.x, c = a.y - s.y, h = l.x - o.x, d = l.y - o.y, p = Math.sqrt((h * h + d * d) / (u * u + c * c));
            return Math.log2(p);
        }
        function $m(e1, t1, r) {
            const n = Math.cos(r), i = Math.sin(r);
            return {
                x: e1 * n - t1 * i,
                y: e1 * i + t1 * n
            };
        }
        function qm(e1, t1, r) {
            u(e1), y(e1, e1, Te(t1[2])), f(e1, e1, Te(t1[0])), m(e1, e1, Te(t1[1])), p(e1, e1, r), h(e1, e1, [
                1,
                0,
                0,
                0,
                0,
                0,
                1,
                0,
                0,
                1,
                0,
                0,
                0,
                0,
                0,
                1
            ]);
        }
        function Hm(e1, t1, r, n, i, s, a, o) {
            const l = [
                r[0] - t1[0],
                r[1] - t1[1],
                0
            ], u = [
                n[0] - t1[0],
                n[1] - t1[1],
                0
            ];
            if (I(l) < 1e-12 || I(u) < 1e-12) return re(e1);
            const c = U([], l, u);
            L(c, c), P(u, n, t1), l[2] = (s - i) * o, u[2] = (a - i) * o;
            const h = l;
            return U(h, l, u), L(h, h), ue(e1, c, h);
        }
        function Xm(e1, t1, r = !1) {
            const n = Vh(t1.zoom), i = function(e1, t1, r) {
                const n = t1.worldSize, i = [
                    e1[12],
                    e1[13],
                    e1[14]
                ], s = $u(i[1] / n), a = Gu(i[0] / n), o = u([]), l = ju(1, s) * n, c = ju(1, 0) * n * Zu(s, t1.zoom), f = 1 / Th(n);
                let m = c * f;
                if (r) {
                    const e1 = Nm(t1.projection, t1.zoom, t1.width, t1.height, 1024);
                    m = f * t1.projection.pixelSpaceConversion(t1.center.lat, n, e1);
                }
                const y = Du(s, a);
                S(y, y, V([], L([], y), l * m * i[2]));
                const g = function(e1) {
                    const t1 = [
                        e1[0],
                        e1[1],
                        e1[2]
                    ];
                    let r = [
                        0,
                        1,
                        0
                    ];
                    const n = U([], r, t1);
                    return U(r, t1, n), 0 === C(r) && (r = [
                        0,
                        1,
                        0
                    ], U(n, t1, r)), L(n, n), L(r, r), L(t1, t1), [
                        n[0],
                        n[1],
                        n[2],
                        0,
                        r[0],
                        r[1],
                        r[2],
                        0,
                        t1[0],
                        t1[1],
                        t1[2],
                        0,
                        e1[0],
                        e1[1],
                        e1[2],
                        1
                    ];
                }(y);
                p(o, o, [
                    m,
                    m,
                    m * l
                ]), d(o, o, [
                    -i[0],
                    -i[1],
                    -i[2]
                ]);
                const x = h([], t1.globeMatrix, g);
                return h(x, x, o), h(x, x, e1), x;
            }(e1, t1, r);
            if (n > 0) {
                const r = function(e1, t1) {
                    const r = t1.worldSize, n = ju(1, 0) * r * Zu(t1.center.lat, t1.zoom) / Th(r), i = ju(1, t1.center.lat) * r, s = u([]);
                    m(s, s, Te(t1.center.lng)), f(s, s, Te(t1.center.lat)), d(s, s, [
                        0,
                        0,
                        Pu
                    ]), p(s, s, [
                        n,
                        n,
                        n * i
                    ]);
                    const a = t1.point;
                    return d(s, s, [
                        -a.x,
                        -a.y,
                        0
                    ]), h(s, s, e1), h(s, t1.globeMatrix, s);
                }(e1, t1);
                return function(e1, t1, r) {
                    const n = (e1, t1, r)=>{
                        const n = I(e1), i = I(t1), s = xh(e1, t1, r);
                        return V(s, s, 1 / I(s) * yr(n, i, r));
                    }, i = n([
                        e1[0],
                        e1[1],
                        e1[2]
                    ], [
                        t1[0],
                        t1[1],
                        t1[2]
                    ], r), s = n([
                        e1[4],
                        e1[5],
                        e1[6]
                    ], [
                        t1[4],
                        t1[5],
                        t1[6]
                    ], r), a = n([
                        e1[8],
                        e1[9],
                        e1[10]
                    ], [
                        t1[8],
                        t1[9],
                        t1[10]
                    ], r), o = xh([
                        e1[12],
                        e1[13],
                        e1[14]
                    ], [
                        t1[12],
                        t1[13],
                        t1[14]
                    ], r);
                    return [
                        i[0],
                        i[1],
                        i[2],
                        0,
                        s[0],
                        s[1],
                        s[2],
                        0,
                        a[0],
                        a[1],
                        a[2],
                        0,
                        o[0],
                        o[1],
                        o[2],
                        1
                    ];
                }(i, r, n);
            }
            return i;
        }
        function Zm(e1, t1, r, n) {
            const i = Tc.projectAabbCorners(n, r);
            let s = Number.MAX_VALUE;
            for(let e1 = 0; e1 < i.length; ++e1){
                const r = i[e1];
                r[0] = (.5 * r[0] + .5) * t1.width, r[1] = (.5 - .5 * r[1]) * t1.height, r[2] < s && (s = r[2]);
            }
            const a = function(e1) {
                const t1 = [];
                let r = 0;
                for(let t1 = 1; t1 < e1.length; t1++)(e1[t1][0] < e1[r][0] || e1[t1][0] === e1[r][0] && e1[t1][1] < e1[r][1]) && (r = t1);
                let n, i = r;
                const s = new Uint8Array(e1.length);
                do {
                    if (s[i]) break;
                    t1.push(new Me(e1[i][0], e1[i][1])), s[i] = 1, n = (i + 1) % e1.length;
                    for(let t1 = 0; t1 < e1.length; t1++){
                        if (e1[t1][0] === e1[n][0] && e1[t1][1] === e1[n][1] || e1[t1][0] === e1[i][0] && e1[t1][1] === e1[i][1]) continue;
                        const r = [
                            e1[t1][0] - e1[i][0],
                            e1[t1][1] - e1[i][1]
                        ], s = [
                            e1[n][0] - e1[i][0],
                            e1[n][1] - e1[i][1]
                        ], a = r[0] * s[1] - r[1] * s[0];
                        (a > 0 || 0 === a && r[0] * s[0] + r[1] * s[1] >= 0 && r[0] * r[0] + r[1] * r[1] > s[0] * s[0] + s[1] * s[1]) && (n = t1);
                    }
                    i = n;
                }while (i !== r);
                return t1.length > 0 && t1.push(t1[0]), t1;
            }(i);
            if (Ec(e1, a)) return s;
        }
        const Wm = 64, Ym = {
            CoordinateSpaceTile: 1,
            HasMapboxMeshFeatures: 4,
            HasMeshoptCompression: 8
        };
        function Jm(e1, t1, r, n, i, s, a, o, l, c = !1) {
            const f = r.zoom, m = r.project(n), y = Zu(n.lat, f), g = 1 / y;
            u(e1), d(e1, e1, [
                m.x + a[0] * g,
                m.y + a[1] * g,
                a[2]
            ]);
            let x = 1, v = 1;
            const w = r.worldSize;
            if (c) {
                if ("mercator" === r.projection.name) {
                    let e1 = 0;
                    r.elevation && (e1 = r.elevation.getAtPointOrZero(new Ju(m.x / w, m.y / w), 0));
                    const t1 = ee([], [
                        m.x,
                        m.y,
                        e1,
                        1
                    ], r.projMatrix)[3] / r.cameraToCenterDistance;
                    x = t1, v = t1 * Zu(r.center.lat, f);
                } else if ("globe" === r.projection.name) {
                    const t1 = Xm(e1, r), i = [
                        0,
                        0,
                        0,
                        1
                    ];
                    ee(i, i, h([], r.projMatrix, t1));
                    const s = i[3] / r.cameraToCenterDistance, a = Vh(f), o = r.projection.pixelsPerMeter(n.lat, w) * Zu(n.lat, f), l = r.projection.pixelsPerMeter(r.center.lat, w) * Zu(r.center.lat, f);
                    x = s / yr(o, Xu(r.center.lat), a), v = s * y / o, x *= l, v *= l;
                }
            } else x = g;
            p(e1, e1, [
                x,
                x,
                v
            ]);
            const _ = [
                ...e1
            ], A = t1.orientation, I = [];
            if (qm(I, [
                A[0] + (i ? i[0] : 0),
                A[1] + (i ? i[1] : 0),
                A[2] + (i ? i[2] : 0)
            ], s), h(e1, _, I), o && r.elevation) {
                let i = 0;
                const s = [];
                if (l && r.elevation) {
                    i = function(e1, t1, r, n, i) {
                        const s = t1.elevation;
                        if (!s) return 0;
                        const a = Tc.projectAabbCorners(r, n), o = ju(1, i.lat) * t1.worldSize, l = function(e1, t1) {
                            const r = [
                                0,
                                0,
                                1
                            ], n = [
                                {
                                    corners: [
                                        0,
                                        1,
                                        3,
                                        2
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        1,
                                        5,
                                        2,
                                        6
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        0,
                                        4,
                                        1,
                                        5
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        2,
                                        6,
                                        3,
                                        7
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        4,
                                        7,
                                        5,
                                        6
                                    ],
                                    dotProductWithUp: 0
                                },
                                {
                                    corners: [
                                        0,
                                        3,
                                        4,
                                        7
                                    ],
                                    dotProductWithUp: 0
                                }
                            ];
                            for (const i of n){
                                const n = e1[i.corners[0]], s = e1[i.corners[1]], a = e1[i.corners[2]], o = [
                                    s[0] - n[0],
                                    s[1] - n[1],
                                    t1 * (s[2] - n[2])
                                ], l = U(o, o, [
                                    a[0] - n[0],
                                    a[1] - n[1],
                                    t1 * (a[2] - n[2])
                                ]);
                                L(l, l), i.dotProductWithUp = O(l, r);
                            }
                            return n.sort((e1, t1)=>e1.dotProductWithUp - t1.dotProductWithUp), n[0].corners;
                        }(a, o), u = a[l[0]], c = a[l[1]], h = a[l[2]], d = a[l[3]], p = s.getAtPointOrZero(new Ju(u[0] / t1.worldSize, u[1] / t1.worldSize), 0), f = s.getAtPointOrZero(new Ju(c[0] / t1.worldSize, c[1] / t1.worldSize), 0), m = s.getAtPointOrZero(new Ju(h[0] / t1.worldSize, h[1] / t1.worldSize), 0), y = s.getAtPointOrZero(new Ju(d[0] / t1.worldSize, d[1] / t1.worldSize), 0), g = (p + y) / 2, x = (f + m) / 2;
                        return g > x ? f < m ? Hm(e1, c, d, u, f, y, p, o) : Hm(e1, h, u, d, m, p, y, o) : p < y ? Hm(e1, u, c, h, p, f, m, o) : Hm(e1, d, h, c, y, m, f, o), Math.max(g, x);
                    }(s, r, t1.aabb, e1, n);
                    const a = h([], b([], s), I);
                    h(e1, _, a);
                } else i = r.elevation.getAtPointOrZero(new Ju(m.x / w, m.y / w), 0);
                0 !== i && (e1[14] += i);
            }
        }
        class Km {
            constructor(e1, t1, r, n, i){
                this.materialOverrides = new Map, this.nodeOverrides = new Map, this.materialOverrideNames = [], this.nodeOverrideNames = [], this.featureProperties = {}, this.id = e1, this.uri = t1, this.position = null != r ? new Ru(r[0], r[1]) : new Ru(0, 0), this.orientation = null != n ? n : [
                    0,
                    0,
                    0
                ], this.nodes = i, this.uploaded = !1, this.aabb = new Tc([
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ]), this.matrix = [];
            }
            _applyTransformations(e1, t1) {
                h(e1.globalMatrix, t1, e1.localMatrix);
                const r = this.nodeOverrides.get(e1.name);
                if (void 0 !== r) {
                    const t1 = [];
                    i = r.orientation, u(n = t1), m(n, n, Te(i[1])), y(n, n, Te(i[2])), f(n, n, Te(i[0])), h(e1.globalMatrix, e1.globalMatrix, t1);
                }
                var n, i;
                if (e1.meshes) for (const t1 of e1.meshes){
                    const r = Tc.applyTransformFast(t1.aabb, e1.globalMatrix);
                    this.aabb.encapsulate(r);
                }
                if (e1.children) for (const t1 of e1.children)this._applyTransformations(t1, e1.globalMatrix);
            }
            computeBoundsAndApplyParent() {
                const e1 = u([]);
                this.aabb = new Tc([
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ]);
                for (const t1 of this.nodes)this._applyTransformations(t1, e1);
            }
            computeModelMatrix(e1, t1, r, n, i, s, a = !1) {
                Jm(this.matrix, this, e1.transform, this.position, t1, r, n, i, s, a);
            }
            upload(e1) {
                if (!this.uploaded) {
                    for (const t1 of this.nodes)ty(t1, e1);
                    for (const e1 of this.nodes)ry(e1);
                    this.uploaded = !0;
                }
            }
            destroy() {
                for (const e1 of this.nodes)iy(e1);
            }
        }
        function Qm(e1, t1, r = !1) {
            e1.uploaded || (e1.gfxTexture = new zm(t1, e1.image, r ? t1.gl.R8 : t1.gl.RGBA8, {
                useMipmap: e1.sampler.minFilter >= t1.gl.NEAREST_MIPMAP_NEAREST
            }), e1.uploaded = !0, e1.image = null);
        }
        function ey(e1, t1, r) {
            e1.indexBuffer = t1.createIndexBuffer(e1.indexArray, !1, !0), e1.vertexBuffer = t1.createVertexBuffer(e1.vertexArray, Vm.members, !1, !0), e1.normalArray && (e1.normalBuffer = t1.createVertexBuffer(e1.normalArray, Cm.members, !1, !0)), e1.texcoordArray && (e1.texcoordBuffer = t1.createVertexBuffer(e1.texcoordArray, Em.members, !1, !0)), e1.colorArray && (e1.colorBuffer = t1.createVertexBuffer(e1.colorArray, (12 === e1.colorArray.bytesPerElement ? Fm : Dm).members, !1, !0)), e1.featureArray && (e1.pbrBuffer = t1.createVertexBuffer(e1.featureArray, Lm.members, !0)), e1.segments = Hl.simpleSegment(0, 0, e1.vertexArray.length, e1.indexArray.length);
            const n = e1.material;
            n.pbrMetallicRoughness.baseColorTexture && Qm(n.pbrMetallicRoughness.baseColorTexture, t1), n.pbrMetallicRoughness.metallicRoughnessTexture && Qm(n.pbrMetallicRoughness.metallicRoughnessTexture, t1), n.normalTexture && Qm(n.normalTexture, t1), n.occlusionTexture && Qm(n.occlusionTexture, t1, r), n.emissionTexture && Qm(n.emissionTexture, t1);
        }
        function ty(e1, t1, r) {
            if (e1.meshes) for (const n of e1.meshes)ey(n, t1, r);
            if (e1.children) for (const n of e1.children)ty(n, t1, r);
        }
        function ry(e1) {
            if (e1.meshes) for (const t1 of e1.meshes)t1.indexArray.destroy(), t1.vertexArray.destroy(), t1.colorArray && t1.colorArray.destroy(), t1.normalArray && t1.normalArray.destroy(), t1.texcoordArray && t1.texcoordArray.destroy(), t1.featureArray && t1.featureArray.destroy();
            if (e1.children) for (const t1 of e1.children)ry(t1);
        }
        function ny(e1) {
            e1.pbrMetallicRoughness.baseColorTexture && e1.pbrMetallicRoughness.baseColorTexture.gfxTexture && e1.pbrMetallicRoughness.baseColorTexture.gfxTexture.destroy(), e1.pbrMetallicRoughness.metallicRoughnessTexture && e1.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture && e1.pbrMetallicRoughness.metallicRoughnessTexture.gfxTexture.destroy(), e1.normalTexture && e1.normalTexture.gfxTexture && e1.normalTexture.gfxTexture.destroy(), e1.emissionTexture && e1.emissionTexture.gfxTexture && e1.emissionTexture.gfxTexture.destroy(), e1.occlusionTexture && e1.occlusionTexture.gfxTexture && e1.occlusionTexture.gfxTexture.destroy();
        }
        function iy(e1) {
            if (e1.meshes) for (const t1 of e1.meshes)t1.vertexBuffer && (t1.vertexBuffer.destroy(), t1.indexBuffer.destroy(), t1.normalBuffer && t1.normalBuffer.destroy(), t1.texcoordBuffer && t1.texcoordBuffer.destroy(), t1.colorBuffer && t1.colorBuffer.destroy(), t1.pbrBuffer && t1.pbrBuffer.destroy(), t1.segments.destroy(), t1.material && ny(t1.material));
            if (e1.footprintDebugMesh && (e1.footprintDebugMesh.vertexBuffer.destroy(), e1.footprintDebugMesh.indexBuffer.destroy(), e1.footprintDebugMesh.segments.destroy()), e1.children) for (const t1 of e1.children)iy(t1);
        }
        function sy(e1, t1) {
            const r = e1.json.bufferViews[t1.bufferView], n = dm[t1.componentType];
            return new n(e1.buffers[r.buffer], (t1.byteOffset || 0) + (r.byteOffset || 0), t1.count * (r.byteStride && r.byteStride !== fm[t1.type] * n.BYTES_PER_ELEMENT ? r.byteStride / n.BYTES_PER_ELEMENT : fm[t1.type]));
        }
        function ay(e1, t1, r, n) {
            const i = dm[t1.componentType], s = function(e1) {
                switch(e1){
                    case Int8Array:
                        return 1 / 127;
                    case Uint8Array:
                        return 1 / 255;
                    case Int16Array:
                        return 1 / 32767;
                    case Uint16Array:
                        return 1 / 65535;
                    default:
                        return 1;
                }
            }(i), a = e1.json.bufferViews[t1.bufferView], o = a.byteStride ? a.byteStride / i.BYTES_PER_ELEMENT : fm[t1.type], l = r.float32, u = l.length / r.capacity;
            for(let e1 = 0, r = 0; e1 < t1.count * o; e1 += o, r += u)for(let t1 = 0; t1 < u; t1++)l[r + t1] = n[e1 + t1] * s;
            r._trim();
        }
        function oy(e1, t1, r) {
            const n = e1.indices, i = e1.attributes, s = {};
            s.indexArray = new ml;
            const a = t1.json.accessors[n], o = a.count / 3;
            s.indexArray.reserve(o);
            const l = sy(t1, a);
            for(let e1 = 0; e1 < o; e1++)s.indexArray.emplaceBack(l[3 * e1], l[3 * e1 + 1], l[3 * e1 + 2]);
            s.indexArray._trim(), s.vertexArray = new rl;
            const u = t1.json.accessors[i.POSITION];
            s.vertexArray.reserve(u.count);
            const c = sy(t1, u);
            for(let e1 = 0; e1 < u.count; e1++)s.vertexArray.emplaceBack(c[3 * e1], c[3 * e1 + 1], c[3 * e1 + 2]);
            if (s.vertexArray._trim(), s.aabb = new Tc(u.min, u.max), s.centroid = function(e1, t1) {
                const r = [
                    0,
                    0,
                    0
                ], n = e1.length;
                if (n > 0) {
                    for(let i = 0; i < n; i++){
                        const n = 3 * e1[i];
                        r[0] += t1[n], r[1] += t1[n + 1], r[2] += t1[n + 2];
                    }
                    r[0] /= n, r[1] /= n, r[2] /= n;
                }
                return r;
            }(l, c), void 0 !== i.COLOR_0) {
                const e1 = t1.json.accessors[i.COLOR_0], r = fm[e1.type], n = sy(t1, e1);
                s.colorArray = 3 === r ? new rl : new ll, s.colorArray.resize(e1.count), ay(t1, e1, s.colorArray, n);
            }
            if (void 0 !== i.NORMAL) {
                s.normalArray = new rl;
                const e1 = t1.json.accessors[i.NORMAL];
                s.normalArray.resize(e1.count);
                const r = sy(t1, e1);
                ay(t1, e1, s.normalArray, r);
            }
            if (void 0 !== i.TEXCOORD_0 && r.length > 0) {
                s.texcoordArray = new Al;
                const e1 = t1.json.accessors[i.TEXCOORD_0];
                s.texcoordArray.resize(e1.count);
                const r = sy(t1, e1);
                ay(t1, e1, s.texcoordArray, r);
            }
            if (void 0 !== i._FEATURE_ID_RGBA4444) {
                const e1 = t1.json.accessors[i._FEATURE_ID_RGBA4444];
                t1.json.extensionsUsed && t1.json.extensionsUsed.includes("EXT_meshopt_compression") && (s.featureData = sy(t1, e1));
            }
            void 0 !== i._FEATURE_RGBA4444 && (s.featureData = new Uint32Array(sy(t1, t1.json.accessors[i._FEATURE_RGBA4444]).buffer));
            const h = e1.material;
            return s.material = function(e1, t1) {
                const { emissiveFactor: r = [
                    0,
                    0,
                    0
                ], alphaMode: n = "OPAQUE", alphaCutoff: i = .5, normalTexture: s, occlusionTexture: a, emissiveTexture: o, doubleSided: l, name: u } = e1, { baseColorFactor: c = [
                    1,
                    1,
                    1,
                    1
                ], metallicFactor: h = 1, roughnessFactor: d = 1, baseColorTexture: p, metallicRoughnessTexture: f } = e1.pbrMetallicRoughness || {}, m = a ? t1[a.index] : void 0;
                if (a && a.extensions && a.extensions.KHR_texture_transform && m) {
                    const e1 = a.extensions.KHR_texture_transform;
                    m.offsetScale = [
                        e1.offset[0],
                        e1.offset[1],
                        e1.scale[0],
                        e1.scale[1]
                    ];
                }
                return {
                    name: u,
                    pbrMetallicRoughness: {
                        baseColorFactor: new dr(...c),
                        metallicFactor: h,
                        roughnessFactor: d,
                        baseColorTexture: p ? t1[p.index] : void 0,
                        metallicRoughnessTexture: f ? t1[f.index] : void 0
                    },
                    doubleSided: l,
                    emissiveFactor: new dr(...r),
                    alphaMode: n,
                    alphaCutoff: i,
                    normalTexture: s ? t1[s.index] : void 0,
                    occlusionTexture: m,
                    emissionTexture: o ? t1[o.index] : void 0,
                    defined: void 0 === e1.defined
                };
            }(void 0 !== h ? t1.json.materials[h] : {
                defined: !1
            }, r), s;
        }
        function ly(e1, t1, r) {
            const { matrix: n, rotation: i, translation: s, scale: a, mesh: o, extras: u, children: c, name: h } = e1, d = {};
            if (d.name = h, d.localMatrix = n || function(e1, t1, r, n) {
                var i = t1[0], s = t1[1], a = t1[2], o = t1[3], l = i + i, u = s + s, c = a + a, h = i * l, d = i * u, p = i * c, f = s * u, m = s * c, y = a * c, g = o * l, x = o * u, v = o * c, b = n[0], w = n[1], _ = n[2];
                return e1[0] = (1 - (f + y)) * b, e1[1] = (d + v) * b, e1[2] = (p - x) * b, e1[3] = 0, e1[4] = (d - v) * w, e1[5] = (1 - (h + y)) * w, e1[6] = (m + g) * w, e1[7] = 0, e1[8] = (p + x) * _, e1[9] = (m - g) * _, e1[10] = (1 - (h + f)) * _, e1[11] = 0, e1[12] = r[0], e1[13] = r[1], e1[14] = r[2], e1[15] = 1, e1;
            }([], i || [
                0,
                0,
                0,
                1
            ], s || [
                0,
                0,
                0
            ], a || [
                1,
                1,
                1
            ]), d.globalMatrix = l(d.localMatrix), void 0 !== o) {
                d.meshes = r[o];
                const e1 = d.anchor = [
                    0,
                    0
                ];
                for (const t1 of d.meshes){
                    const { min: r, max: n } = t1.aabb;
                    e1[0] += r[0] + n[0], e1[1] += r[1] + n[1];
                }
                e1[0] = Math.floor(e1[0] / d.meshes.length / 2), e1[1] = Math.floor(e1[1] / d.meshes.length / 2);
            }
            if (u && (u.id && (d.id = u.id), u.lights && (d.lights = function(e1) {
                if (!e1.length) return [];
                const t1 = function(e1) {
                    const t1 = atob(e1), r = new Uint8Array(t1.length);
                    for(let e1 = 0; e1 < t1.length; e1++)r[e1] = t1.codePointAt(e1);
                    return r;
                }(e1), r = [], n = t1.length / 24, i = new Uint16Array(t1.buffer), s = new Float32Array(t1.buffer);
                for(let e1 = 0; e1 < n; e1++){
                    const t1 = i[2 * e1 * 6] / 30, n = i[2 * e1 * 6 + 1] / 30, a = i[2 * e1 * 6 + 10] / 100, o = s[6 * e1 + 1], l = s[6 * e1 + 2], u = s[6 * e1 + 3], c = s[6 * e1 + 4], h = u - o, d = c - l, p = Math.hypot(h, d);
                    r.push({
                        pos: [
                            o + .5 * h,
                            l + .5 * d,
                            n
                        ],
                        normal: [
                            d / p,
                            -h / p,
                            0
                        ],
                        width: p,
                        height: t1,
                        depth: a,
                        points: [
                            o,
                            l,
                            u,
                            c
                        ]
                    });
                }
                return r;
            }(u.lights)), u.MAPBOX_geometry_bloom && (d.isGeometryBloom = u.MAPBOX_geometry_bloom)), c) {
                const e1 = [];
                for (const n of c)e1.push(ly(t1.json.nodes[n], t1, r));
                d.children = e1;
            }
            return d;
        }
        function uy(e1) {
            if (0 === e1.vertices.length || 0 === e1.indices.length) return null;
            const t1 = new Vp(e1.vertices, e1.indices, 8, 256), [r, n] = [
                t1.min.clone(),
                t1.max.clone()
            ];
            return {
                vertices: e1.vertices,
                indices: e1.indices,
                grid: t1,
                min: r,
                max: n
            };
        }
        function cy(e1) {
            if (!e1.extras || !e1.extras.ground) return null;
            const t1 = e1.extras.ground;
            if (!t1 || !Array.isArray(t1) || 0 === t1.length) return null;
            const r = t1[0];
            if (!r || !Array.isArray(r) || 0 === r.length) return null;
            const n = [];
            for (const e1 of r){
                if (!Array.isArray(e1) || 2 !== e1.length) continue;
                const t1 = e1[0], r = e1[1];
                "number" == typeof t1 && "number" == typeof r && n.push(new Me(t1, r));
            }
            if (n.length < 3) return null;
            n.length > 1 && n[n.length - 1].equals(n[0]) && n.pop();
            let i = 0;
            for(let e1 = 0; e1 < n.length; e1++){
                const t1 = n[e1], r = n[(e1 + 1) % n.length], s = n[(e1 + 2) % n.length];
                i += (t1.x - r.x) * (s.y - r.y) - (s.x - r.x) * (t1.y - r.y);
            }
            i > 0 && n.reverse();
            const s = od(n.flatMap((e1)=>[
                    e1.x,
                    e1.y
                ]), []);
            return 0 === s.length ? null : {
                vertices: n,
                indices: s
            };
        }
        function hy(e1, t1) {
            const r = [], n = [];
            let i = 0;
            const s = [];
            for (const a of e1){
                i = r.length;
                const e1 = a.vertexArray.float32, o = a.indexArray.uint16;
                for(let n = 0; n < a.vertexArray.length; n++)s[0] = e1[3 * n + 0], s[1] = e1[3 * n + 1], s[2] = e1[3 * n + 2], j(s, s, t1), r.push(new Me(s[0], s[1]));
                for(let e1 = 0; e1 < 3 * a.indexArray.length; e1++)n.push(o[e1] + i);
            }
            if (n.length % 3 != 0) return null;
            for(let e1 = 0; e1 < n.length; e1 += 3){
                const t1 = r[n[e1 + 0]], i = r[n[e1 + 1]], s = r[n[e1 + 2]];
                (t1.x - i.x) * (s.y - i.y) - (s.x - i.x) * (t1.y - i.y) > 0 && ([n[e1 + 1], n[e1 + 2]] = [
                    n[e1 + 2],
                    n[e1 + 1]
                ]);
            }
            return {
                vertices: r,
                indices: n
            };
        }
        function dy(e1) {
            const t1 = function(e1, t1) {
                const r = [], n = WebGL2RenderingContext;
                if (e1.json.textures) for (const i of e1.json.textures){
                    const s = {
                        magFilter: n.LINEAR,
                        minFilter: n.NEAREST,
                        wrapS: n.REPEAT,
                        wrapT: n.REPEAT
                    };
                    void 0 !== i.sampler && Object.assign(s, e1.json.samplers[i.sampler]), r.push({
                        image: t1[i.source],
                        sampler: s,
                        uploaded: !1
                    });
                }
                return r;
            }(e1, e1.images), r = function(e1, t1) {
                const r = [];
                for (const n of e1.json.meshes){
                    const i = [];
                    for (const r of n.primitives)i.push(oy(r, e1, t1));
                    r.push(i);
                }
                return r;
            }(e1, t1), { scenes: n, scene: i, nodes: s } = e1.json, a = n ? n[i || 0].nodes : [
                ...s.keys()
            ], o = [];
            for (const t1 of a)o.push(ly(s[t1], e1, r));
            return function(e1, t1, r) {
                const n = {}, i = new Set;
                for(let s = 0; s < e1.length; s++){
                    const e1 = r[t1[s]];
                    if (!e1.extras) continue;
                    const a = e1.extras["mapbox:footprint:version"], o = e1.extras["mapbox:footprint:id"];
                    (a || o) && i.add(s), "1.0.0" === a && o && (n[o] = s);
                }
                for(let s = 0; s < e1.length; s++){
                    if (i.has(s)) continue;
                    const a = e1[s], o = r[t1[s]];
                    if (!o.extras) continue;
                    let l = null;
                    a.id in n && (l = hy(e1[n[a.id]].meshes, a.localMatrix)), l || (l = cy(o)), l && (a.footprint = uy(l));
                }
                if (i.size > 0) {
                    const t1 = Array.from(i.values()).sort((e1, t1)=>e1 - t1);
                    for(let r = t1.length - 1; r >= 0; r--)e1.splice(t1[r], 1);
                }
            }(o, a, e1.json.nodes), o;
        }
        function py(e1) {
            e1.heightmap = new Float32Array(4096), e1.heightmap.fill(-1);
            const t1 = e1.vertexArray.float32, r = e1.aabb.min[0] - 1, n = e1.aabb.min[1] - 1, i = Wm / (e1.aabb.max[0] - r + 2), s = Wm / (e1.aabb.max[1] - n + 2);
            for(let a = 0; a < t1.length; a += 3){
                const o = t1[a + 2], l = (t1[a + 0] - r) * i | 0, u = (t1[a + 1] - n) * s | 0;
                o > e1.heightmap[u * Wm + l] && (e1.heightmap[u * Wm + l] = o);
            }
        }
        function fy(e1, t1, r, n, i) {
            r.reserve(r.length + 4 * e1.length), n.reserve(n.length + 10 * e1.length), i.reserve(i.length + 10 * e1.length);
            let s = n.length;
            for (const a of e1){
                const e1 = Math.min(10, Math.max(4, 1.3 * a.height)) * t1, o = [
                    -a.normal[1],
                    a.normal[0],
                    0
                ], l = Math.min(.29, .1 * a.width / a.depth), u = a.width - 2 * a.depth * t1 * (l + .01), c = F([], a.pos, o, u / 2), h = F([], a.pos, o, -u / 2), d = [
                    c[0],
                    c[1],
                    c[2] + a.height
                ], p = [
                    h[0],
                    h[1],
                    h[2] + a.height
                ], f = F([], a.normal, o, l);
                V(f, f, e1);
                const m = F([], a.normal, o, -l);
                V(m, m, e1), S(f, c, f), S(m, h, m), c[2] += .1, h[2] += .1, n.emplaceBack(f[0], f[1], f[2]), n.emplaceBack(m[0], m[1], m[2]), n.emplaceBack(c[0], c[1], c[2]), n.emplaceBack(h[0], h[1], h[2]), n.emplaceBack(d[0], d[1], d[2]), n.emplaceBack(p[0], p[1], p[2]), n.emplaceBack(c[0], c[1], c[2]), n.emplaceBack(h[0], h[1], h[2]), n.emplaceBack(f[0], f[1], f[2]), n.emplaceBack(m[0], m[1], m[2]);
                const y = u / e1 / 2;
                i.emplaceBack(-y - l, -1, y, .8), i.emplaceBack(y + l, -1, y, .8), i.emplaceBack(-y, 0, y, 1.3), i.emplaceBack(y, 0, y, 1.3), i.emplaceBack(y + l, -0.8, y, .7), i.emplaceBack(y + l, -0.8, y, .7), i.emplaceBack(0, 0, y, 1.3), i.emplaceBack(0, 0, y, 1.3), i.emplaceBack(y + l, -1.2, y, .8), i.emplaceBack(y + l, -1.2, y, .8), r.emplaceBack(6 + s, 4 + s, 8 + s), r.emplaceBack(7 + s, 9 + s, 5 + s), r.emplaceBack(0 + s, 1 + s, 2 + s), r.emplaceBack(1 + s, 3 + s, 2 + s), s += 10;
            }
        }
        function my(e1, t1) {
            const r = {};
            r.indexArray = new ml, r.vertexArray = new rl, r.colorArray = new ll, fy(e1, t1, r.indexArray, r.vertexArray, r.colorArray);
            const n = {
                defined: !0
            };
            n.emissiveFactor = dr.black;
            const i = {};
            return i.baseColorFactor = dr.white, n.pbrMetallicRoughness = i, r.material = n, r.aabb = new Tc([
                1 / 0,
                1 / 0,
                1 / 0
            ], [
                -1 / 0,
                -1 / 0,
                -1 / 0
            ]), r;
        }
        const yy = qo([
            {
                name: "a_pos_3f",
                components: 3,
                type: "Float32"
            }
        ]), gy = qo([
            {
                name: "a_normal_3",
                components: 3,
                type: "Int16"
            }
        ]), xy = qo([
            {
                name: "a_centroid_3",
                components: 3,
                type: "Int16"
            }
        ]), vy = qo([
            {
                name: "a_part_color_emissive",
                components: 2,
                type: "Uint16"
            }
        ]), by = qo([
            {
                name: "a_faux_facade_color_emissive",
                components: 2,
                type: "Uint16"
            }
        ]), wy = qo([
            {
                name: "a_faux_facade_data",
                components: 4,
                type: "Uint16"
            }
        ]), _y = qo([
            {
                name: "a_faux_facade_vertical_range",
                components: 2,
                type: "Uint16"
            }
        ]), Ay = qo([
            {
                name: "a_bloom_attenuation",
                components: 4,
                type: "Float32"
            }
        ]), Iy = qo([
            {
                name: "a_flood_light_wall_radius_1i16",
                components: 1,
                type: "Int16"
            }
        ]), My = oc.types, By = 32767;
        function Sy(e1, t1) {
            const r = qn + t1;
            for (const n of e1)for (const e1 of n)if (e1.x < -t1 || e1.x > r || e1.y < -t1 || e1.y > r) return !1;
            return !0;
        }
        function Py(e1) {
            switch(e1){
                case "flat":
                    return 3;
                case "hipped":
                    return 1;
                case "gabled":
                    return 2;
                case "parapet":
                    return 0;
                case "mansard":
                    return 4;
                case "skillion":
                    return 5;
                case "pyramidal":
                    return 6;
                default:
                    throw new Error(`Unknown roof shape: ${e1}`);
            }
        }
        class Ty {
            constructor(){
                this.layoutVertexArray = new rl, this.layoutAttenuationArray = new ll, this.layoutColorArray = new cl, this.indexArray = new ml, this.indexArrayForConflation = new ml, this.segmentsBucket = new Hl;
            }
        }
        class zy {
            constructor(e1){
                this.layoutFacadePaintArray = null, this.layoutFacadeDataArray = null, this.layoutFacadeVerticalRangeArray = null, this.segmentsBucket = new Hl, this.entranceBloom = new Ty;
                const t1 = 66560;
                this.layoutVertexArray = new rl, this.layoutVertexArray.reserve(t1), this.layoutNormalArray = new Zo, this.layoutNormalArray.reserve(t1), this.layoutCentroidArray = new Zo, this.layoutCentroidArray.reserve(t1), this.layoutColorArray = new cl, this.layoutColorArray.reserve(t1), this.layoutFloodLightDataArray = new Pl, this.layoutFloodLightDataArray.reserve(t1), this.layoutAOArray = new Tl, this.layoutAOArray.reserve(t1), this.indexArray = new ml, this.indexArray.reserve(66560), this.indexArrayForConflation = new ml, this.segmentsBucket = new Hl, this.entranceBloom = new Ty, e1 && (this.layoutFacadePaintArray = new cl, this.layoutFacadeDataArray = new il, this.layoutFacadeVerticalRangeArray = new cl);
            }
            reserve(e1, t1, r) {
                this.layoutVertexArray.reserveForAdditional(e1), this.layoutCentroidArray.reserveForAdditional(e1), this.layoutFloodLightDataArray.reserveForAdditional(e1), this.layoutNormalArray.reserveForAdditional(e1), this.layoutAOArray.reserveForAdditional(e1), this.layoutColorArray.reserveForAdditional(e1), this.indexArray.reserveForAdditional(t1), r && (this.layoutFacadePaintArray.reserveForAdditional(e1), this.layoutFacadeDataArray.reserveForAdditional(e1), this.layoutFacadeVerticalRangeArray.reserveForAdditional(e1));
            }
        }
        class ky {
            constructor(e1){
                this.colorBufferUploaded = !1, this.maxHeight = 0, this.replacementUpdateTime = 0, this.activeReplacements = [], this.footprints = [], this.footprintsVertices = new Al, this.footprintsIndices = new Ml, this.footprintsMin = new Me(1 / 0, 1 / 0), this.footprintsMax = new Me(-1 / 0, -1 / 0), this.featuresOnBorder = [], this.buildingWithoutFacade = new zy(!1), this.buildingWithFacade = new zy(!0), this.indexArrayForConflationUploaded = !1, this.featureFootprintLookup = new Map, this.buildingIds = new Set, this.footprintLookup = {}, this.zoom = e1.zoom, this.canonical = e1.canonical, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.hasPattern = !1, this.worldview = e1.worldview, this.lut = e1.lut, this.programConfigurations = new _u(e1.layers, {
                    zoom: e1.zoom,
                    lut: e1.lut
                }), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.projection = e1.projection, this.groundEffect = new If(e1), this.groundEffect.groundRadiusArray = new Yo, this.hasAppearances = null;
            }
            updateFootprints(e1, t1) {
                const r = new Vp([], [], 1), n = {
                    vertices: [],
                    indices: new Uint32Array(0),
                    grid: r,
                    min: this.footprintsMin,
                    max: this.footprintsMax,
                    buildingIds: this.buildingIds
                };
                t1.push({
                    footprint: n,
                    id: e1
                });
            }
            updateAppearances(e1, t1, r, n) {
                return {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
            }
            prepare() {
                return function() {
                    if (null != rm || null != nm) return null;
                    if (null != im) return im;
                    const e1 = fetch(ht());
                    return im = (function(e1) {
                        let t1, r, n, i, s;
                        function a() {
                            t1 = new Uint8Array(s.buffer), r = new Int16Array(s.buffer), n = new Int32Array(s.buffer), i = new Float32Array(s.buffer);
                        }
                        function o() {
                            throw new Error("Unexpected BuildingGen error.");
                        }
                        const l = ()=>{}, u = {
                            a: {
                                a: o,
                                f: function(e1) {
                                    const r = t1.length, n = Math.max(e1 >>> 0, Math.ceil(1.2 * r)), i = Math.ceil((n - r) / 65536);
                                    try {
                                        return s.grow(i), a(), !0;
                                    } catch (e1) {
                                        return !1;
                                    }
                                },
                                g: o,
                                b: l,
                                c: l,
                                d: l,
                                e: l
                            }
                        };
                        return (WebAssembly.instantiateStreaming ? WebAssembly.instantiateStreaming(e1, u) : e1.then((e1)=>e1.arrayBuffer()).then((e1)=>WebAssembly.instantiate(e1, u))).then((e1)=>{
                            const o = e1.instance.exports;
                            return (0, o.g)(), s = o.f, a(), new Kf({
                                setStyle: o.h,
                                setAOOptions: o.i,
                                setMetricOptions: o.j,
                                setStructuralOptions: o.k,
                                setFacadeOptions: o.l,
                                setFauxFacadeOptions: o.m,
                                setFacadeClassifierOptions: o.n,
                                addFeature: o.o,
                                addFacade: o.p,
                                generateMesh: o.q,
                                getLastError: o.r,
                                getOuterRingLength: o.s,
                                getMeshCount: o.t,
                                getPositionsPtr: o.u,
                                getPositionsLength: o.v,
                                getNormalsPtr: o.w,
                                getNormalsLength: o.x,
                                getAOPtr: o.y,
                                getAOLength: o.z,
                                getUVPtr: o.A,
                                getUVLength: o.B,
                                getFauxFacadePtr: o.C,
                                getFauxFacadeLength: o.D,
                                getIndicesPtr: o.E,
                                getIndicesLength: o.F,
                                getBuildingPart: o.G,
                                getRingCount: o.H,
                                getRingPtr: o.I,
                                getRingLength: o.J,
                                malloc: o.K,
                                free: o.L,
                                heapU8: t1,
                                heap16: r,
                                heap32: n,
                                heapF32: i
                            });
                        });
                    })(e1).then((e1)=>(im = null, rm = e1, rm)).catch((e1)=>{
                        Ze("Could not load building-gen"), im = null, nm = e1 instanceof Error ? e1 : new Error("Unknown error");
                    }), im;
                }();
            }
            populate(e1, t1, r, n) {
                const i = sm();
                if (!i) return;
                const s = Yu(r);
                this.tileToMeter = s, this.brightness = t1.brightness, i.setStyle({
                    normalScale: [
                        1,
                        -1,
                        s
                    ],
                    tileToMeters: s
                }), i.setAOOptions(!1, .3), i.setMetricOptions(!1, 16), i.setStructuralOptions(!0), i.setFacadeClassifierOptions(3);
                const a = new Map, o = new Map;
                let l = 0;
                for (const { feature: t1 } of e1){
                    if ("LineString" !== My[t1.type]) {
                        a.set(t1.id, t1.properties.source_id);
                        continue;
                    }
                    const e1 = this.layers[0]._featureFilter.needGeometry;
                    if (e1 && !this.layers[0]._featureFilter.filter(new to(this.zoom), t1, r)) continue;
                    const i = ac(t1, e1);
                    if (!e1 && !this.layers[0]._featureFilter.filter(new to(this.zoom), i, r)) continue;
                    const s = e1 ? i.geometry : sc(t1, r, n), u = [];
                    for (const e1 of s)for (const t1 of e1)u.push(t1.x), u.push(t1.y);
                    const c = {
                        coordinates: u,
                        crossPerc: t1.properties.cross_perc,
                        distanceToRoad: t1.properties.distance_to_road,
                        entrances: t1.properties.entrances,
                        sourceId: 0
                    }, h = t1.properties.source_id;
                    let d = o.get(h);
                    d || (d = [], o.set(h, d)), d.push(c), ++l;
                }
                this.maxHeight = 0;
                const u = new Array, c = new Set, h = (e1)=>{
                    null != e1 && c.add(e1);
                }, d = (e1, t1)=>{
                    null != e1 && u.push({
                        buildingId: e1,
                        footprintIndex: t1
                    });
                }, p = 64 * (e1.length - l), f = p / 2;
                this.buildingWithFacade.reserve(p, f, !0), this.buildingWithoutFacade.reserve(2 * p, 2 * f, !1), this.footprintsIndices.reserve(16 * (e1.length - l)), this.footprintsVertices.reserve(8 * (e1.length - l));
                for (const { feature: l, id: u, index: p, sourceLayerIndex: f } of e1){
                    if ("LineString" === My[l.type]) continue;
                    const e1 = this.layers[0]._featureFilter.needGeometry;
                    if (e1 && !this.layers[0]._featureFilter.filter(new to(this.zoom), l, r)) continue;
                    let m = null;
                    if (l.properties && l.properties.hasOwnProperty("building_id") && (m = Number(l.properties.building_id), c.has(m))) continue;
                    const y = ac(l, e1);
                    if (!e1 && !this.layers[0]._featureFilter.filter(new to(this.zoom), y, r)) continue;
                    const g = e1 ? y.geometry : sc(l, r, n), x = Fd(g, 500);
                    let v = !1;
                    for (const e1 of x)if (1 !== e1.length) {
                        v = !0;
                        break;
                    }
                    if (v) {
                        h(m);
                        continue;
                    }
                    if (!Sy(g, 163)) {
                        h(m);
                        continue;
                    }
                    const b = this.layers[0], w = Py(b.layout.get("building-roof-shape").evaluate(l, {}, r)), _ = b.layout.get("building-base").evaluate(l, {}, r), A = b.layout.get("building-height").evaluate(l, {}, r), I = b.layout.get("building-flood-light-ground-radius").evaluate(l, {}, r), M = b.paint.get("building-ambient-occlusion-intensity"), B = I / this.tileToMeter;
                    l.properties["building-part"] = "roof";
                    const S = b.paint.get("building-color").evaluate(l, {}, this.canonical).toPremultipliedRenderColor(this.lut), P = b.paint.get("building-emissive-strength").evaluate(l, {}, this.canonical);
                    l.properties["building-part"] = "wall";
                    const T = b.paint.get("building-color").evaluate(l, {}, this.canonical).toPremultipliedRenderColor(this.lut), z = b.paint.get("building-emissive-strength").evaluate(l, {}, this.canonical);
                    l.properties["building-part"] = "window";
                    const k = b.paint.get("building-color").evaluate(l, {}, this.canonical).toPremultipliedRenderColor(this.lut), V = b.paint.get("building-emissive-strength").evaluate(l, {}, this.canonical);
                    l.properties["building-part"] = "door";
                    const F = b.paint.get("building-color").evaluate(l, {}, this.canonical).toPremultipliedRenderColor(this.lut), D = b.paint.get("building-emissive-strength").evaluate(l, {}, this.canonical);
                    let E = b.layout.get("building-flood-light-wall-radius").evaluate(l, {}, r);
                    E = Ee(E, 0, 2048);
                    const C = E / 2048 * By, R = a.get(u), L = o.get(R) || [], O = 0 !== L.length && b.layout.get("building-facade").evaluate(l, {}, r);
                    i.setFacadeOptions(4, !0), i.setFauxFacadeOptions(O, !1, 1);
                    let U = 0, N = 0, j = 0, G = 0, $ = 0, q = 0, H = 0, X = 0, Z = 0, W = 0, Y = 0;
                    if (O) {
                        let e1 = Math.round(b.layout.get("building-facade-floors").evaluate(l, {}, r));
                        if (0 === _) {
                            e1 = Math.max(1, e1 - (L.length > 0 ? 1 : 0));
                            let t1 = 4;
                            if (A > 100) {
                                const e1 = [
                                    10,
                                    13,
                                    15
                                ];
                                t1 = e1[l.id ? l.id % e1.length : 0];
                            } else A <= 10 && (t1 = 3);
                            i.setFacadeOptions(t1, !0), $ = (A < 15 ? 1.3 : 1.61803) * t1 / s;
                        } else $ = _ / s;
                        q = A / s, $ = Math.min($, q), j = b.layout.get("building-facade-unit-width").evaluate(l, {}, r) / s, G = (q - $) / e1, i.setFauxFacadeOptions(!0, !0, j);
                        const t1 = b.layout.get("building-facade-window").evaluate(l, {}, r);
                        U = t1[0], N = t1[1], H = Math.floor(65535 * Math.min(1, $ / qn)), X = Math.floor(65535 * Math.min(1, q / qn)), Z = Math.floor(255 * U) << 8 | Math.floor(255 * N), W = Math.floor(65535 * Math.min(1, j / qn)), Y = Math.floor(65535 * Math.min(1, G / qn));
                    }
                    const J = Array(x.length), K = {
                        x: 1 / 0,
                        y: 1 / 0
                    }, Q = {
                        x: -1 / 0,
                        y: -1 / 0
                    }, ee = {
                        x: 0,
                        y: 0
                    };
                    let te = 0;
                    for(let e1 = 0; e1 < x.length; e1++){
                        const t1 = x[e1];
                        if (t1.length > 0) {
                            const r = [], n = Array(t1.length + 1);
                            n[0] = 0;
                            for(let e1 = 0; e1 < t1.length; e1++){
                                const i = t1[e1];
                                for(let e1 = 0; e1 < i.length; e1++){
                                    const t1 = i[i.length - e1 - 1];
                                    K.x = Math.min(K.x, t1.x), K.y = Math.min(K.y, t1.y), Q.x = Math.max(Q.x, t1.x), Q.y = Math.max(Q.y, t1.y), ee.x += t1.x, ee.y += t1.y, te++, r.push(t1.x), r.push(t1.y);
                                }
                                n[e1 + 1] = r.length;
                            }
                            J[e1] = {
                                id: l.id ? l.id : 0,
                                height: A,
                                minHeight: _,
                                sourceId: 0,
                                roofType: w,
                                coordinates: r,
                                ringIndices: n
                            };
                        }
                    }
                    ee.x /= te || 1, ee.y /= te || 1;
                    const re = i.generateMesh(J, L);
                    if ("string" == typeof re) {
                        Ze(`Unable to generate building ${l.id}: ${re}`), h(m);
                        continue;
                    }
                    if (0 === re.meshes.length || 0 === re.modifiedPolygonRings.length) {
                        h(m);
                        continue;
                    }
                    const ne = O ? this.buildingWithFacade : this.buildingWithoutFacade;
                    let ie = 0;
                    for (const e1 of re.meshes)ie += e1.positions.length / 3;
                    const se = ne.segmentsBucket.prepareSegment(ie, ne.layoutVertexArray, ne.indexArray), ae = [];
                    let oe = null, le = 0, ue = -1;
                    const ce = ne.layoutVertexArray.length, he = ce + ie;
                    ne.layoutVertexArray.resize(he), ne.layoutCentroidArray.resize(he), ne.layoutNormalArray.resize(he), ne.layoutAOArray.resize(he), ne.layoutColorArray.resize(he), ne.layoutFloodLightDataArray.resize(he), O && (ne.layoutFacadePaintArray.resize(he), ne.layoutFacadeDataArray.resize(he), ne.layoutFacadeVerticalRangeArray.resize(he));
                    const de = ne.indexArray.length;
                    let pe = 0, fe = ce;
                    for (const e1 of re.meshes){
                        let t1, r;
                        if (1 === e1.buildingPart) t1 = S, r = P;
                        else if (0 === e1.buildingPart) t1 = T, r = z;
                        else if (2 === e1.buildingPart) t1 = k, r = V;
                        else {
                            if (3 !== e1.buildingPart) continue;
                            t1 = F, r = D;
                        }
                        if (r = Ee(r, 0, 1), 3 === e1.buildingPart) {
                            const t1 = new Array;
                            for(let r = 0; r < e1.positions.length; r += 12){
                                const n = e1.positions[r + 0], i = e1.positions[r + 1], s = e1.positions[r + 3], a = e1.positions[r + 4], o = e1.positions[r + 2], l = e1.positions[r + 8] - o, u = 1, c = s - n, h = a - i, d = Math.hypot(c, h);
                                t1.push({
                                    pos: [
                                        n + .5 * c,
                                        i + .5 * h,
                                        o
                                    ],
                                    normal: [
                                        h / d,
                                        -c / d,
                                        0
                                    ],
                                    width: d,
                                    height: l,
                                    depth: u,
                                    points: [
                                        n,
                                        i,
                                        s,
                                        a
                                    ]
                                });
                            }
                            const r = ne.entranceBloom.segmentsBucket.prepareSegment(10 * t1.length, ne.entranceBloom.layoutVertexArray, ne.entranceBloom.indexArray), n = ne.entranceBloom.layoutVertexArray.length;
                            le = ne.entranceBloom.indexArray.length, fy(t1, .5 / this.tileToMeter, ne.entranceBloom.indexArray, ne.entranceBloom.layoutVertexArray, ne.entranceBloom.layoutAttenuationArray);
                            const i = ne.entranceBloom.layoutVertexArray.length - n;
                            ue = ne.entranceBloom.indexArray.length - le;
                            for(let e1 = 0; e1 < i; e1++)ne.entranceBloom.layoutColorArray.emplaceBack(255 * F.r << 8 | 255 * F.g, 255 * F.b << 8 | 51 * D);
                            r.vertexLength += i, r.primitiveLength += ue, oe = {
                                part: e1.buildingPart,
                                vertexOffset: n,
                                vertexLength: i
                            };
                        }
                        ne.layoutVertexArray.float32.set(e1.positions, 3 * fe);
                        const n = e1.positions.length / 3;
                        for(let i = 0; i < n; ++i){
                            const n = 3 * i;
                            pe = Math.max(pe, e1.positions[n + 2]);
                            const s = e1.normals[n + 1] * By, a = e1.normals[n + 2] * By, o = 3 * (fe + i);
                            ne.layoutNormalArray.int16[o] = e1.normals[n] * By, ne.layoutNormalArray.int16[o + 1] = s, ne.layoutNormalArray.int16[o + 2] = a;
                            const l = e1.ao[i];
                            ne.layoutAOArray.uint8[fe + i] = 255 * l;
                            const u = 1 + (l - 1) * M, c = 255 * t1.b * u << 8 | 255 * r;
                            ne.layoutColorArray.uint16[2 * (fe + i)] = 255 * t1.r * u << 8 | 255 * t1.g * u, ne.layoutColorArray.uint16[2 * (fe + i) + 1] = c;
                        }
                        const i = Math.min(8191, Math.max(0, Math.floor(ee.x))), s = Math.min(8191, Math.max(0, Math.floor(ee.y))), a = Math.floor(A), o = 20, l = 4 * i + Math.min(3, Math.round((Q.x - K.x) * this.tileToMeter / o)), u = 4 * s + Math.min(3, Math.round((Q.y - K.y) * this.tileToMeter / o));
                        for(let e1 = 0; e1 < n; ++e1){
                            const t1 = 3 * (fe + e1);
                            ne.layoutCentroidArray.int16[t1] = l, ne.layoutCentroidArray.int16[t1 + 1] = u, ne.layoutCentroidArray.int16[t1 + 2] = a;
                        }
                        if (ne.layoutFloodLightDataArray.int16.fill(0 === e1.buildingPart ? C : 0, fe, fe + n), O) {
                            const t1 = 255 * k.r << 8 | 255 * k.g, r = 255 * k.b << 8 | 255 * V;
                            for(let e1 = 0; e1 < n; ++e1){
                                const n = 2 * (fe + e1);
                                ne.layoutFacadePaintArray.uint16[n] = t1, ne.layoutFacadePaintArray.uint16[n + 1] = r;
                            }
                            for(let t1 = 0; t1 < n; ++t1)if (e1.isFauxFacade[t1]) {
                                const r = Math.min(65535, Math.floor(e1.uv[2 * t1] * re.outerRingLength));
                                ne.layoutFacadeDataArray.emplace(fe + t1, 1 | r, Z, W, Y), ne.layoutFacadeVerticalRangeArray.emplace(fe + t1, H, X);
                            } else ne.layoutFacadeDataArray.emplace(fe + t1, 0, 0, 0, 0), ne.layoutFacadeVerticalRangeArray.emplace(fe + t1, 0, 0);
                        }
                        const c = se.vertexLength, h = e1.indices.length / 3, d = ne.indexArray.length;
                        ne.indexArray.resize(d + h);
                        for(let t1 = 0; t1 < h; ++t1){
                            const r = 3 * t1, n = 3 * d + r;
                            ne.indexArray.uint16[n] = c + e1.indices[r], ne.indexArray.uint16[n + 1] = c + e1.indices[r + 1], ne.indexArray.uint16[n + 2] = c + e1.indices[r + 2];
                        }
                        1 !== e1.buildingPart && 0 !== e1.buildingPart && 2 !== e1.buildingPart && 3 !== e1.buildingPart || ae.push({
                            part: e1.buildingPart,
                            vertexOffset: fe,
                            vertexLength: e1.positions.length / 3
                        }), fe += n, se.vertexLength += n, se.primitiveLength += e1.indices.length / 3;
                    }
                    this.maxHeight = Math.max(this.maxHeight, pe);
                    const me = ne.indexArray.length - de, ye = this.footprintsIndices.length, ge = this.footprintsVertices.length, xe = [], ve = new Me(1 / 0, 1 / 0), be = new Me(-1 / 0, -1 / 0), we = this.groundEffect.vertexArray.length;
                    for (const e1 of re.modifiedPolygonRings){
                        const t1 = [], r = new Me(1 / 0, 1 / 0), n = new Me(-1 / 0, -1 / 0);
                        for(let i = 0; i < e1.length; i += 2){
                            const s = e1.length - i - 2;
                            r.x = Math.min(r.x, e1[s]), r.y = Math.min(r.y, e1[s + 1]), n.x = Math.max(n.x, e1[s]), n.y = Math.max(n.y, e1[s + 1]);
                            const a = new Me(e1[s], e1[s + 1]);
                            t1.push(a), xe.push(a.x, a.y), this.footprintsVertices.emplaceBack(a.x, a.y);
                        }
                        ve.x = Math.min(ve.x, r.x), ve.y = Math.min(ve.y, r.y), be.x = Math.max(be.x, n.x), be.y = Math.max(be.y, n.y), this.groundEffect.addData(t1, [
                            r,
                            n
                        ], B);
                    }
                    const _e = this.groundEffect.vertexArray.length - we;
                    this.groundEffect.groundRadiusArray.reserveForAdditional(_e);
                    for(let e1 = 0; e1 < _e; e1++)this.groundEffect.groundRadiusArray.emplaceBack(I);
                    (K.x < 0 || Q.x > qn || K.y < 0 || Q.y > qn) && this.featuresOnBorder.push({
                        featureId: l.id,
                        footprintIndex: this.footprints.length
                    });
                    {
                        const e1 = od(xe, null, 2);
                        this.footprintsIndices.resize(this.footprintsIndices.length + e1.length), this.footprintsIndices.uint16.set(e1, ye), this.buildingIds.add(null != m ? m : l.id), this.footprintsMin.x = Math.min(this.footprintsMin.x, ve.x), this.footprintsMin.y = Math.min(this.footprintsMin.y, ve.y), this.footprintsMax.x = Math.max(this.footprintsMax.x, be.x), this.footprintsMax.y = Math.max(this.footprintsMax.y, be.y);
                        const t1 = {
                            footprintVertexOffset: ge,
                            footprintVertexLength: this.footprintsVertices.length - ge,
                            footprintIndexOffset: ye,
                            footprintIndexLength: this.footprintsIndices.length - ye,
                            min: ve,
                            max: be,
                            hiddenFlags: 0,
                            indicesOffset: de,
                            indicesLength: me,
                            bloomIndicesOffset: le,
                            bloomIndicesLength: ue,
                            groundEffectVertexOffset: we,
                            groundEffectVertexLength: _e,
                            hasFauxFacade: O,
                            height: pe,
                            promoteId: u,
                            feature: y,
                            parts: ae,
                            buildingBloom: oe
                        }, r = this.footprints.length;
                        void 0 !== l.id && this.featureFootprintLookup.set(l.id, r), d(m, r), this.footprints.push(t1);
                    }
                    this.programConfigurations.populatePaintArrays(ne.layoutVertexArray.length, l, p, {}, t1.availableImages, r, t1.brightness), this.groundEffect.addPaintPropertiesData(l, p, {}, t1.availableImages, r, t1.brightness), t1.featureIndex.insert(l, g, p, f, this.index, ce);
                }
                u.forEach(({ buildingId: e1, footprintIndex: t1 })=>{
                    c.has(e1) && (this.footprints[t1].hiddenFlags |= 4);
                });
                const m = new Set;
                this.buildingIds.forEach((e1, t1, r)=>{
                    c.has(e1) || m.add(e1);
                }), this.buildingIds = m, this.groundEffect.prepareBorderSegments();
            }
            update(e1, t1, r, n, i, s, a) {
                this.programConfigurations.updatePaintArrays(e1, t1, i, r, n, s, a), this.groundEffect.update(e1, t1, i, r, n, s, a), this.evaluate(this.layers[0], e1), this.colorBufferUploaded = !1;
            }
            isEmpty() {
                return 0 === this.buildingWithoutFacade.layoutVertexArray.length && 0 === this.buildingWithFacade.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload || this.groundEffect.programConfigurations.needsUpload;
            }
            upload(e1) {
                const t1 = (t1)=>{
                    t1.layoutVertexBuffer = e1.createVertexBuffer(t1.layoutVertexArray, yy.members), t1.layoutNormalBuffer = e1.createVertexBuffer(t1.layoutNormalArray, gy.members), t1.layoutCentroidBuffer = e1.createVertexBuffer(t1.layoutCentroidArray, xy.members), t1.layoutFloodLightDataBuffer = e1.createVertexBuffer(t1.layoutFloodLightDataArray, Iy.members), t1.layoutFacadeDataArray && t1.layoutFacadeDataArray.length && (t1.layoutFacadeDataBuffer = e1.createVertexBuffer(t1.layoutFacadeDataArray, wy.members)), t1.layoutFacadeVerticalRangeArray && t1.layoutFacadeVerticalRangeArray.length && (t1.layoutFacadeVerticalRangeBuffer = e1.createVertexBuffer(t1.layoutFacadeVerticalRangeArray, _y.members)), t1.entranceBloom.layoutVertexArray.length && (t1.entranceBloom.layoutVertexBuffer = e1.createVertexBuffer(t1.entranceBloom.layoutVertexArray, yy.members), t1.entranceBloom.layoutAttenuationBuffer = e1.createVertexBuffer(t1.entranceBloom.layoutAttenuationArray, Ay.members)), this.uploadUpdatedColorBuffer(e1), this.uploadUpdatedIndexBuffer(e1);
                };
                this.uploaded || (t1(this.buildingWithoutFacade), t1(this.buildingWithFacade), this.groundEffect.upload(e1)), this.groundEffect.uploadPaintProperties(e1), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            destroy() {
                const e1 = (e1)=>{
                    e1.layoutVertexBuffer && (e1.layoutVertexBuffer.destroy(), e1.layoutNormalBuffer.destroy(), e1.layoutColorBuffer.destroy(), e1.segmentsBucket.destroy(), e1.indexBuffer && e1.indexBuffer.destroy(), e1.entranceBloom.layoutVertexBuffer && (e1.entranceBloom.layoutVertexBuffer.destroy(), e1.entranceBloom.layoutColorBuffer.destroy(), e1.entranceBloom.layoutAttenuationBuffer.destroy(), e1.entranceBloom.indexBuffer.destroy(), e1.entranceBloom.segmentsBucket.destroy()));
                };
                e1(this.buildingWithoutFacade), e1(this.buildingWithFacade), this.groundEffect.destroy(), this.programConfigurations.destroy();
            }
            updateFootprintHiddenFlags(e1, t1, r = !0) {
                let n = !1;
                const i = r ? t1 : 0, s = 0 | (r ? -1 : ~t1);
                0 === this.groundEffect.hiddenByLandmarkVertexArray.length && this.groundEffect.hiddenByLandmarkVertexArray.resize(this.groundEffect.vertexArray.length);
                for (const t1 of e1){
                    const e1 = this.footprints[t1], r = e1.hiddenFlags & s | i;
                    e1.hiddenFlags !== r && (e1.hiddenFlags = r, n = !0, this.groundEffect.updateHiddenByLandmarkRange(e1.groundEffectVertexOffset, e1.groundEffectVertexLength, 0 !== e1.hiddenFlags));
                }
                return n && (this.indexArrayForConflationUploaded = !1), n;
            }
            uploadUpdatedIndexBuffer(e1) {
                if (this.groundEffect.uploadHiddenByLandmark(e1), this.indexArrayForConflationUploaded) return;
                const t1 = (e1)=>{
                    0 !== e1.indexArray.length && (e1.indexArrayForConflation.resize(e1.indexArray.length), e1.indexArrayForConflation.uint16.set(e1.indexArray.uint16), e1.entranceBloom.indexArrayForConflation.resize(e1.entranceBloom.indexArray.length), e1.entranceBloom.indexArrayForConflation.uint16.set(e1.entranceBloom.indexArray.uint16));
                };
                t1(this.buildingWithoutFacade), t1(this.buildingWithFacade);
                for (const e1 of this.footprints){
                    const t1 = e1.hasFauxFacade ? this.buildingWithFacade : this.buildingWithoutFacade, r = e1.indicesOffset + e1.indicesLength;
                    if (0 !== e1.hiddenFlags) {
                        for(let n = e1.indicesOffset; n < r; n++)t1.indexArrayForConflation.uint16[3 * n + 0] = 0, t1.indexArrayForConflation.uint16[3 * n + 1] = 0, t1.indexArrayForConflation.uint16[3 * n + 2] = 0;
                        const n = e1.bloomIndicesOffset + e1.bloomIndicesLength;
                        for(let r = e1.bloomIndicesOffset; r < n; r++)t1.entranceBloom.indexArrayForConflation.uint16[3 * r + 0] = 0, t1.entranceBloom.indexArrayForConflation.uint16[3 * r + 1] = 0, t1.entranceBloom.indexArrayForConflation.uint16[3 * r + 2] = 0;
                    }
                }
                const r = (t1)=>{
                    0 !== t1.indexArray.length && (t1.indexBuffer ? t1.indexBuffer.updateData(t1.indexArrayForConflation) : t1.indexBuffer = e1.createIndexBuffer(t1.indexArrayForConflation, !0), t1.entranceBloom.indexBuffer ? t1.entranceBloom.indexBuffer.updateData(t1.entranceBloom.indexArrayForConflation) : t1.entranceBloom.indexBuffer = e1.createIndexBuffer(t1.entranceBloom.indexArrayForConflation, !0));
                };
                r(this.buildingWithoutFacade), r(this.buildingWithFacade), this.indexArrayForConflationUploaded = !0;
            }
            uploadUpdatedColorBuffer(e1) {
                const t1 = (t1)=>{
                    t1.layoutColorBuffer ? t1.layoutColorBuffer.updateData(t1.layoutColorArray) : t1.layoutColorBuffer = e1.createVertexBuffer(t1.layoutColorArray, vy.members, !0), t1.layoutFacadePaintArray && (t1.layoutFacadePaintBuffer ? t1.layoutFacadePaintBuffer.updateData(t1.layoutFacadePaintArray) : t1.layoutFacadePaintBuffer = e1.createVertexBuffer(t1.layoutFacadePaintArray, by.members, !0)), t1.entranceBloom.layoutColorBuffer ? t1.entranceBloom.layoutColorBuffer.updateData(t1.entranceBloom.layoutColorArray) : t1.entranceBloom.layoutColorBuffer = e1.createVertexBuffer(t1.entranceBloom.layoutColorArray, vy.members, !0);
                };
                t1(this.buildingWithoutFacade), t1(this.buildingWithFacade), this.colorBufferUploaded = !0;
            }
            evaluate(e1, t1) {
                const r = e1.paint.get("building-ambient-occlusion-intensity");
                for (const n of this.footprints){
                    if (4 & n.hiddenFlags) continue;
                    const i = t1[n.promoteId], s = n.feature;
                    s.properties["building-part"] = "roof";
                    const a = e1.paint.get("building-color").evaluate(s, i, this.canonical).toPremultipliedRenderColor(this.lut), o = e1.paint.get("building-emissive-strength").evaluate(s, i, this.canonical);
                    s.properties["building-part"] = "wall";
                    const l = e1.paint.get("building-color").evaluate(s, i, this.canonical).toPremultipliedRenderColor(this.lut), u = e1.paint.get("building-emissive-strength").evaluate(s, i, this.canonical);
                    s.properties["building-part"] = "window";
                    const c = e1.paint.get("building-color").evaluate(s, i, this.canonical).toPremultipliedRenderColor(this.lut), h = e1.paint.get("building-emissive-strength").evaluate(s, i, this.canonical);
                    s.properties["building-part"] = "door";
                    const d = e1.paint.get("building-color").evaluate(s, i, this.canonical).toPremultipliedRenderColor(this.lut), p = e1.paint.get("building-emissive-strength").evaluate(s, i, this.canonical), f = n.hasFauxFacade ? this.buildingWithFacade : this.buildingWithoutFacade;
                    for (const e1 of n.parts){
                        let t1, i = a;
                        1 === e1.part ? (i = a, t1 = o) : 0 === e1.part ? (i = l, t1 = u) : 2 === e1.part ? (i = c, t1 = h) : 3 === e1.part && (i = d, t1 = p), t1 = Ee(t1, 0, 1);
                        for(let s = 0; s < e1.vertexLength; s++){
                            const a = e1.vertexOffset + s, o = 1 + (f.layoutAOArray.uint8[a] / 255 - 1) * r;
                            f.layoutColorArray.emplace(a, i.r * o * 255 << 8 | i.g * o * 255, i.b * o * 255 << 8 | 255 * t1), n.hasFauxFacade && f.layoutFacadePaintArray.emplace(a, 255 * c.r << 8 | 255 * c.g, 255 * c.b << 8 | 255 * h);
                        }
                    }
                    const m = n.buildingBloom;
                    if (m) for(let e1 = 0; e1 < m.vertexLength; e1++)f.entranceBloom.layoutColorArray.emplace(m.vertexOffset + e1, 255 * d.r << 8 | 255 * d.g, 255 * d.b << 8 | 51 * p);
                }
            }
            needsEvaluation() {
                return !this.colorBufferUploaded;
            }
            updateReplacement(e1, t1, r) {
                if (t1.updateTime === this.replacementUpdateTime) return;
                this.replacementUpdateTime = t1.updateTime;
                const n = t1.getReplacementRegionsForTile(e1.toUnwrapped());
                if (Wp(this.activeReplacements, n)) return;
                this.activeReplacements = n;
                for (const e1 of this.footprints)e1.hiddenFlags &= -2;
                const i = [];
                for (const t1 of this.activeReplacements){
                    if (t1.order < r) continue;
                    const n = Math.max(1, Math.pow(2, t1.footprintTileId.canonical.z - e1.canonical.z));
                    for (const r of this.footprints)r.min.x > t1.max.x || r.max.x < t1.min.x || r.min.y > t1.max.y || r.max.y < t1.min.y || (i.length = 0, Fy(this.footprintsVertices, r.footprintVertexOffset, r.footprintVertexLength, t1.footprintTileId.canonical, e1.canonical, i), Kp(t1.footprint, i, this.footprintsIndices.uint16, r.footprintIndexOffset, r.footprintIndexLength, 0, -n) && (r.hiddenFlags |= 1));
                }
                0 === this.groundEffect.hiddenByLandmarkVertexArray.length && this.groundEffect.hiddenByLandmarkVertexArray.resize(this.groundEffect.vertexArray.length);
                for (const e1 of this.footprints)this.groundEffect.updateHiddenByLandmarkRange(e1.groundEffectVertexOffset, e1.groundEffectVertexLength, 0 !== e1.hiddenFlags);
                this.indexArrayForConflationUploaded = !1;
            }
            getFootprint(e1) {
                if (void 0 !== e1.id) {
                    const t1 = this.featureFootprintLookup.get(e1.id);
                    return this.footprints[t1];
                }
                return null;
            }
            getHeightAtTileCoord(e1, t1) {
                let r = Number.NEGATIVE_INFINITY, n = !0;
                const i = 4 * (e1 + qn) * qn + (t1 + qn);
                if (this.footprintLookup.hasOwnProperty(i)) {
                    const e1 = this.footprintLookup[i];
                    return e1 ? {
                        height: e1.height,
                        hidden: 0 !== e1.hiddenFlags
                    } : void 0;
                }
                const s = new Me(e1, t1);
                for (const a of this.footprints)e1 > a.max.x || a.min.x > e1 || t1 > a.max.y || a.min.y > t1 || a.height <= r || Vy(s, this.footprintsVertices.float32.subarray(2 * a.footprintVertexOffset, 2 * (a.footprintVertexOffset + a.footprintVertexLength)), this.footprintsIndices.uint16.subarray(a.footprintIndexOffset, a.footprintIndexOffset + a.footprintIndexLength)) && (r = a.height, this.footprintLookup[i] = a, n = 0 !== a.hiddenFlags);
                if (r !== Number.NEGATIVE_INFINITY) return {
                    height: r,
                    hidden: n
                };
                this.footprintLookup[i] = void 0;
            }
        }
        function Vy(e1, t1, r) {
            for(let n = 0; n < r.length; n += 3){
                const i = r[n], s = r[n + 1], a = r[n + 2], o = t1[2 * i + 0], l = t1[2 * i + 1], u = t1[2 * s + 0], c = t1[2 * s + 1], h = t1[2 * a + 0], d = t1[2 * a + 1], p = (o - h) * (e1.y - d) - (l - d) * (e1.x - h), f = (u - o) * (e1.y - l) - (c - l) * (e1.x - o);
                if (p < 0 != f < 0 && 0 !== p && 0 !== f) continue;
                const m = (h - u) * (e1.y - c) - (d - c) * (e1.x - u);
                if (0 === m || m < 0 == p + f <= 0) return !0;
            }
            return !1;
        }
        function Fy(e1, t1, r, n, i, s) {
            const a = Math.pow(2, n.z - i.z);
            for(let o = 0; o < r; o++){
                let r = e1.float32[2 * (o + t1) + 0], l = e1.float32[2 * (o + t1) + 1];
                r = (r + i.x * qn) * a - n.x * qn, l = (l + i.y * qn) * a - n.y * qn, s.push(new Me(r, l));
            }
        }
        let Dy, Ey;
        ra(ky, "BuildingBucket", {
            omit: [
                "layers"
            ]
        }), ra(zy, "BuildingGeometry"), ra(Ty, "BuildingBloomGeometry");
        const Cy = qo([
            {
                name: "a_pos_normal",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_data",
                components: 4,
                type: "Uint8"
            },
            {
                name: "a_linesofar",
                components: 1,
                type: "Float32"
            }
        ], 4), Ry = qo([
            {
                name: "a_z_offset_width",
                components: 3,
                type: "Float32"
            }
        ], 4), Ly = qo([
            {
                name: "a_elevation_ground_scale",
                components: 1,
                type: "Float32"
            }
        ], 4), { members: Oy } = Cy, Uy = qo([
            {
                name: "a_packed",
                components: 3,
                type: "Float32"
            }
        ]), { members: Ny } = Uy, jy = qo([
            {
                name: "a_pattern_data",
                components: 3,
                type: "Float32"
            }
        ]), { members: Gy } = jy;
        class $y {
            constructor(e1, t1){
                this.width = e1, this.height = t1, this.nextRow = 0, this.image = new Qh({
                    width: e1,
                    height: t1
                }), this.positions = {}, this.uploaded = !1;
            }
            getDash(e1, t1) {
                const r = this.getKey(e1, t1);
                return this.positions[r];
            }
            trim() {
                const e1 = this.width, t1 = this.height = Ne(this.nextRow);
                this.image.resize({
                    width: e1,
                    height: t1
                });
            }
            getKey(e1, t1) {
                return e1.join(",") + t1;
            }
            getDashRanges(e1, t1, r) {
                const n = [];
                let i = e1.length % 2 == 1 ? -e1[e1.length - 1] * r : 0, s = e1[0] * r, a = !0;
                n.push({
                    left: i,
                    right: s,
                    isDash: a,
                    zeroLength: 0 === e1[0]
                });
                let o = e1[0];
                for(let t1 = 1; t1 < e1.length; t1++){
                    a = !a;
                    const l = e1[t1];
                    i = o * r, o += l, s = o * r, n.push({
                        left: i,
                        right: s,
                        isDash: a,
                        zeroLength: 0 === l
                    });
                }
                return n;
            }
            addRoundDash(e1, t1, r) {
                const n = t1 / 2;
                for(let t1 = -r; t1 <= r; t1++){
                    const i = this.width * (this.nextRow + r + t1);
                    let s = 0, a = e1[s];
                    for(let o = 0; o < this.width; o++){
                        o / a.right > 1 && (a = e1[++s]);
                        const l = Math.abs(o - a.left), u = Math.abs(o - a.right), c = Math.min(l, u);
                        let h;
                        const d = t1 / r * (n + 1);
                        if (a.isDash) {
                            const e1 = n - Math.abs(d);
                            h = Math.sqrt(c * c + e1 * e1);
                        } else h = n - Math.sqrt(c * c + d * d);
                        this.image.data[i + o] = Math.max(0, Math.min(255, h + 128));
                    }
                }
            }
            addRegularDash(e1, t1) {
                for(let t1 = e1.length - 1; t1 >= 0; --t1){
                    const r = e1[t1], n = e1[t1 + 1];
                    r.zeroLength ? e1.splice(t1, 1) : n && n.isDash === r.isDash && (n.left = r.left, e1.splice(t1, 1));
                }
                const r = e1[0], n = e1[e1.length - 1];
                r.isDash === n.isDash && (r.left = n.left - this.width, n.right = r.right + this.width);
                const i = this.width * this.nextRow;
                let s = 0, a = e1[s];
                for(let r = 0; r < this.width; r++){
                    r / a.right > 1 && (a = e1[++s]);
                    const n = Math.abs(r - a.left), o = Math.abs(r - a.right), l = Math.min(n, o);
                    this.image.data[i + r] = Math.max(0, Math.min(255, (a.isDash ? l : -l) + t1 + 128));
                }
            }
            addDash(e1, t1) {
                const r = this.getKey(e1, t1);
                if (this.positions[r]) return this.positions[r];
                const n = "round" === t1, i = n ? 7 : 0, s = 2 * i + 1;
                if (this.nextRow + s > this.height) return Ze("LineAtlas out of space"), null;
                0 === e1.length && e1.push(1);
                let a = 0;
                for(let t1 = 0; t1 < e1.length; t1++)e1[t1] < 0 && (Ze("Negative value is found in line dasharray, replacing values with 0"), e1[t1] = 0), a += e1[t1];
                if (0 !== a) {
                    const r = this.width / a, s = this.getDashRanges(e1, this.width, r);
                    n ? this.addRoundDash(s, r, i) : this.addRegularDash(s, "square" === t1 ? .5 * r : 0);
                }
                const o = this.nextRow + i;
                this.nextRow += s;
                const l = Math.floor(a), u = {
                    tl: [
                        o,
                        i
                    ],
                    br: [
                        l,
                        Math.round(65535 * (a - l))
                    ]
                };
                return this.positions[r] = u, u;
            }
        }
        ra($y, "LineAtlas");
        const qy = oc.types, Hy = Math.cos(Math.PI / 180 * 37.5), Xy = Math.cos(Math.PI / 180 * 5);
        class Zy {
            constructor(e1){
                this.evaluationGlobals = {
                    zoom: 0,
                    lineProgress: void 0
                }, this.elevationType = "none", this.isSeaLevelReference = !1, this.zoom = e1.zoom, this.evaluationGlobals.zoom = this.zoom, this.overscaling = e1.overscaling, this.pixelRatio = e1.pixelRatio, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.projection = e1.projection, this.hasPattern = !1, this.hasCrossSlope = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((e1)=>{
                    this.gradients[e1.id] = {};
                }), this.layoutVertexArray = new tl, this.layoutVertexArray2 = new rl, this.patternVertexArray = new rl, this.indexArray = new ml, this.programConfigurations = new _u(e1.layers, {
                    zoom: e1.zoom,
                    lut: e1.lut
                }), this.segments = new Hl, this.maxLineLength = 0, this.zOffsetVertexArray = new rl, this.elevationGroundScaleVertexArray = new Yo, this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.tessellationStep = e1.tessellationStep ? e1.tessellationStep : 128, this.worldview = e1.worldview, this.hasAppearances = null;
            }
            updateFootprints(e1, t1) {}
            updateAppearances(e1, t1, r, n) {
                return {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
            }
            populate(e1, t1, r, n) {
                this.hasPattern = Cd("line", this.layers, this.pixelRatio, t1);
                const i = this.layers[0].layout.get("line-sort-key");
                this.tileToMeter = Yu(r);
                const s = this.layers[0].layout.get("line-elevation-reference");
                if ("hd-road-markup" === s) this.elevationType = "road";
                else {
                    const e1 = this.layers[0].layout.get("line-z-offset"), t1 = e1.isConstant() && !e1.constantOr(0);
                    this.elevationType = "sea" !== s && "ground" !== s && t1 ? "none" : "offset", "offset" === this.elevationType && "none" === s && Ze(`line-elevation-reference: ground is used for the layer ${this.layerIds[0]} because non-zero line-z-offset value was found.`), this.isSeaLevelReference = "sea" === s;
                }
                const a = this.layers[0].layout.get("line-cross-slope");
                this.hasCrossSlope = "offset" === this.elevationType && void 0 !== a;
                const o = [];
                for (const { feature: s, id: a, index: l, sourceLayerIndex: u } of e1){
                    const e1 = this.layers[0]._featureFilter.needGeometry, c = ac(s, e1);
                    if (!this.layers[0]._featureFilter.filter(new to(this.zoom, {
                        worldview: this.worldview,
                        activeFloors: t1.activeFloors
                    }), c, r)) continue;
                    const h = i ? i.evaluate(c, {}, r) : void 0, d = {
                        id: a,
                        properties: s.properties,
                        type: s.type,
                        sourceLayerIndex: u,
                        index: l,
                        geometry: e1 ? c.geometry : sc(s, r, n),
                        patterns: {},
                        sortKey: h
                    };
                    o.push(d);
                }
                i && o.sort((e1, t1)=>e1.sortKey - t1.sortKey);
                const { lineAtlas: l, featureIndex: u } = t1, c = this.addConstantDashes(l);
                for (const n of o){
                    const { geometry: i, index: s, sourceLayerIndex: a } = n;
                    if (c && this.addFeatureDashes(n, l), this.hasPattern) {
                        const e1 = Rd("line", this.layers, n, this.zoom, this.pixelRatio, t1);
                        this.patternFeatures.push(e1);
                    } else this.addFeature(n, i, s, r, l.positions, t1.availableImages, t1.brightness, t1.elevationFeatures);
                    u.insert(e1[s].feature, i, s, a, this.index);
                }
            }
            addConstantDashes(e1) {
                let t1 = !1;
                for (const r of this.layers){
                    const n = r.paint.get("line-dasharray").value, i = r.layout.get("line-cap").value;
                    if ("constant" !== n.kind || "constant" !== i.kind) t1 = !0;
                    else {
                        const t1 = i.value, r = n.value;
                        if (!r) continue;
                        e1.addDash(r, t1);
                    }
                }
                return t1;
            }
            addFeatureDashes(e1, t1) {
                const r = this.zoom;
                for (const n of this.layers){
                    const i = n.paint.get("line-dasharray").value, s = n.layout.get("line-cap").value;
                    if ("constant" === i.kind && "constant" === s.kind) continue;
                    let a, o;
                    if ("constant" === i.kind) {
                        if (a = i.value, !a) continue;
                    } else a = i.evaluate({
                        zoom: r
                    }, e1);
                    o = "constant" === s.kind ? s.value : s.evaluate({
                        zoom: r
                    }, e1), t1.addDash(a, o), e1.patterns[n.id] = [
                        t1.getKey(a, o)
                    ];
                }
            }
            update(e1, t1, r, n, i, s, a, o, l) {
                this.programConfigurations.updatePaintArrays(e1, t1, i, r, n, s, a, l);
            }
            addFeatures(e1, t1, r, n, i, s) {
                for (const i of this.patternFeatures)this.addFeature(i, i.geometry, i.index, t1, r, n, s, e1.elevationFeatures);
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length;
            }
            uploadPending() {
                return !this.uploaded || this.programConfigurations.needsUpload;
            }
            upload(e1) {
                this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = e1.createVertexBuffer(this.layoutVertexArray2, Ny)), 0 !== this.patternVertexArray.length && (this.patternVertexBuffer = e1.createVertexBuffer(this.patternVertexArray, Gy)), !this.zOffsetVertexBuffer && this.zOffsetVertexArray.length > 0 && (this.zOffsetVertexBuffer = e1.createVertexBuffer(this.zOffsetVertexArray, Ry.members, !0)), !this.elevationGroundScaleVertexBuffer && this.elevationGroundScaleVertexArray.length > 0 && (this.elevationGroundScaleVertexBuffer = e1.createVertexBuffer(this.elevationGroundScaleVertexArray, Ly.members, !0)), this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, Oy), this.indexBuffer = e1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(e1), this.uploaded = !0;
            }
            destroy() {
                this.layoutVertexBuffer && (this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy(), this.elevationGroundScaleVertexBuffer && this.elevationGroundScaleVertexBuffer.destroy(), this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
            }
            lineFeatureClips(e1, t1) {
                let r, n;
                if (t1 && t1 > 0 ? (r = `mapbox_clip_start_${t1}`, n = `mapbox_clip_end_${t1}`) : (r = "mapbox_clip_start", n = "mapbox_clip_end"), e1.properties && e1.properties.hasOwnProperty(r) && e1.properties.hasOwnProperty(n)) return {
                    start: +e1.properties[r],
                    end: +e1.properties[n]
                };
            }
            addFeature(e1, t1, r, n, i, s, a, o) {
                const l = this.layers[0].layout, u = l.get("line-join").evaluate(e1, {}), c = l.get("line-cap").evaluate(e1, {}), h = l.get("line-miter-limit"), d = l.get("line-round-limit");
                this.lineClips = this.lineFeatureClips(e1), this.lineFeature = e1;
                const p = !(!e1.properties || !e1.properties.hasOwnProperty("mapbox_line_metrics")) && e1.properties.mapbox_line_metrics;
                this.zOffsetValue = l.get("line-z-offset").value;
                const f = this.layers[0].paint.get("line-width").value;
                if ("constant" !== f.kind && !1 === f.isLineProgressConstant && (this.variableWidthValue = f), this.isSeaLevelReference) {
                    const e1 = l.get("line-elevation-ground-scale").value;
                    "constant" === e1.kind && 0 === e1.value || (this.elevationGroundScaleValue = e1);
                }
                if ("road" === this.elevationType) {
                    const r = this.layoutVertexArray.length;
                    if (!this.addElevatedRoadFeature(e1, t1, n, o, u, c, h, d)) {
                        const [i, s] = this.clipRuntimeLinesToTile(t1, 1);
                        for(let t1 = 0; t1 < i.length; t1++){
                            const r = i[t1], a = s[t1], o = {
                                progress: {
                                    min: a.progress.min,
                                    max: a.progress.max
                                },
                                nextDir: this.computeSegNextDir(a, r),
                                prevDir: this.computeSegPrevDir(a, r)
                            };
                            this.addLine(r, e1, n, u, c, h, d, o, p && a.parentIndex > 0 ? a.parentIndex : null);
                        }
                        this.fillNonElevatedRoadSegment(r);
                    }
                } else for(let r = 0; r < t1.length; r++)this.addLine(t1[r], e1, n, u, c, h, d, void 0, p && r > 0 ? r : null);
                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, e1, r, i, s, n, a, void 0, this.worldview);
            }
            computeSegNextDir(e1, t1) {
                return e1.nextPoint.sub(t1.at(-2)).unit();
            }
            computeSegPrevDir(e1, t1) {
                return t1[1].sub(e1.prevPoint).unit();
            }
            clipLinesToTile(e1, t1) {
                return Gf(e1, -t1, -t1, qn + t1, qn + t1);
            }
            clipRuntimeLinesToTile(e1, t1) {
                const r = [];
                return [
                    Gf(e1, -t1, -t1, qn + t1, qn + t1, r),
                    r
                ];
            }
            addElevatedRoadFeature(e1, t1, r, n, i, s, a, o) {
                const l = [], u = Vc.getElevationFeature(e1, n);
                if (u) {
                    const e1 = this.clipLinesToTile(t1, 1), n = this.prepareElevatedLines(e1, u, r);
                    for (const e1 of n)l.push({
                        geometry: e1,
                        elevation: u,
                        elevationTileID: r,
                        segment: {
                            progress: {
                                min: 0,
                                max: 1
                            },
                            nextDir: void 0,
                            prevDir: void 0
                        }
                    });
                }
                if (0 === l.length) return !1;
                for (const t1 of l){
                    const n = this.layoutVertexArray.length;
                    this.addLine(t1.geometry, e1, r, i, s, a, o);
                    const l = new Fc(r, t1.elevationTileID);
                    if (t1.elevation) for(let e1 = n; e1 < this.layoutVertexArray.length; e1++){
                        const r = new Me(this.layoutVertexArray.int16[6 * e1] >> 1, this.layoutVertexArray.int16[6 * e1 + 1] >> 1), n = l.pointElevation(r, t1.elevation, .05);
                        this.updateHeightRange(n), this.zOffsetVertexArray.emplaceBack(n, 0, 0);
                    }
                    else this.fillNonElevatedRoadSegment(n);
                }
                return !0;
            }
            prepareElevatedLines(e1, t1, r) {
                if (null != t1.constantHeight) return e1;
                const n = [], i = 1 / Yu(r);
                for (const r of e1)$f(r, new zc(t1, i), 0, n);
                return n;
            }
            fillNonElevatedRoadSegment(e1) {
                for(let t1 = e1; t1 < this.layoutVertexArray.length; t1++)this.zOffsetVertexArray.emplaceBack(0, 0, 0);
            }
            updateHeightRange(e1) {
                this.heightRange ? (this.heightRange.min = Math.min(this.heightRange.min, e1), this.heightRange.max = Math.max(this.heightRange.max, e1)) : this.heightRange = {
                    min: e1,
                    max: e1
                };
            }
            addLine(e1, t1, r, n, i, s, a, o, l) {
                this.distance = 0, this.prevDistance = 0, this.scaledDistance = 0, this.totalDistance = 0, this.totalFeatureLength = 0, this.lineSoFar = 0, this.currentVertex = void 0, this.lineClips = l ? this.lineFeatureClips(t1, l) : this.lineClips;
                const u = "none" === n;
                this.patternJoinNone = this.hasPattern && u, this.currentLineJoinType = n, this.segmentStart = 0, this.segmentStartf32 = 0, this.segmentPoints = [];
                const c = o && o.progress.min > 0, h = o && o.progress.max < 1;
                if (this.lineClips) {
                    let r = {
                        min: this.lineClips.start,
                        max: this.lineClips.end
                    }, n = 1;
                    if (o) {
                        const e1 = this.lineClips.end - this.lineClips.start;
                        r = function(e1, t1, r) {
                            return {
                                min: ot(e1.min, t1, r),
                                max: ot(e1.max, t1, r)
                            };
                        }(o.progress, {
                            min: 0,
                            max: 1
                        }, r), e1 > 0 && (n = (r.max - r.min) / e1);
                    }
                    const i = +t1.properties.mapbox_clip_feature_len, s = +t1.properties.mapbox_clip_seg_len;
                    if (Number.isNaN(i) || Number.isNaN(s)) {
                        for(let t1 = 0; t1 < e1.length - 1; t1++)this.totalDistance += e1[t1].dist(e1[t1 + 1]);
                        const t1 = this.totalDistance / (r.max - r.min);
                        this.totalFeatureLength = Number.isFinite(t1) ? t1 : 0, this.lineClips.start = r.min, this.lineClips.end = r.max, this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                    } else this.totalFeatureLength = i, this.distance = s * n, this.lineClips.start = r.min, this.lineClips.end = r.max, this.maxLineLength = Math.max(this.maxLineLength, this.distance);
                    this.lineClipsArray.push(this.lineClips), this.updateScaledDistance();
                }
                const d = "Polygon" === qy[t1.type];
                let p = e1.length;
                for(; p >= 2 && e1[p - 1].equals(e1[p - 2]);)p--;
                let f = 0;
                for(; f < p - 1 && e1[f].equals(e1[f + 1]);)f++;
                if (p < (d ? 3 : 2)) return;
                "bevel" === n && (s = 1.05);
                const m = this.segments.prepareSegment(10 * p, this.layoutVertexArray, this.indexArray);
                let y, g, x, v, b, w, _, A;
                o && o.prevDir && (w = o.prevDir.perp()), o && o.nextDir && (_ = o.nextDir.perp()), this.e1 = this.e2 = -1, d && (y = e1[p - 2], b = e1[f].sub(y)._unit()._perp());
                for(let t1 = f; t1 < p; t1++){
                    if (x = t1 === p - 1 ? d ? e1[f + 1] : void 0 : e1[t1 + 1], x && e1[t1].equals(x)) continue;
                    b && (v = b), y && (g = y), y = e1[t1], A = this.evaluateLineProgressFeatures(g ? g.dist(y) : 0), b = x ? x.sub(y)._unit()._perp() : v, v = v || b;
                    const r = g && x;
                    let o = r ? n : d || u ? "butt" : i;
                    const l = v.x * b.x + v.y * b.y;
                    if (u) {
                        const e1 = function(e1) {
                            if (e1.patternJoinNone) {
                                const t1 = e1.segmentPoints.length / 2, r = e1.lineSoFar - e1.segmentStart;
                                for(let n = 0; n < t1; ++n){
                                    const t1 = e1.segmentPoints[2 * n + 1], i = Math.round(e1.segmentPoints[2 * n]) + .5 + .25 * t1;
                                    e1.patternVertexArray.emplaceBack(i, r, e1.segmentStart), e1.patternVertexArray.emplaceBack(i, r, e1.segmentStart);
                                }
                                e1.segmentPoints.length = 0;
                            }
                            e1.e1 = e1.e2 = -1;
                        };
                        if (r && l < Xy) {
                            this.updateDistance(g, y), this.addCurrentVertex(y, v, 1, 1, m, A), e1(this), this.addCurrentVertex(y, b, -1, -1, m, A);
                            continue;
                        }
                        if (g) {
                            if (!x) {
                                this.updateDistance(g, y), this.addCurrentVertex(y, v, 1, 1, m, A), e1(this);
                                continue;
                            }
                            o = "miter";
                        }
                    }
                    let I = v.add(b);
                    0 === I.x && 0 === I.y || I._unit();
                    const M = I.x * b.x + I.y * b.y, B = 0 !== M ? 1 / M : 1 / 0, S = 2 * Math.sqrt(2 - 2 * M), P = M < Hy && g && x, T = v.x * b.y - v.y * b.x > 0, z = this.overscaling <= 16 ? 122880 / (512 * this.overscaling) : 0;
                    if (r && "round" === o) {
                        if (B < a) o = "miter";
                        else if (B <= 2) {
                            const e1 = Wy(y, -10, 8202);
                            o = "offset" === this.elevationType && (e1 || this.hasCrossSlope) ? "miter" : "fakeround";
                        }
                    }
                    if ("miter" === o && B > s && (o = "bevel"), "bevel" === o && (B > 2 && (o = "flipbevel"), B < s && (o = "miter")), g && !("miter" === o && P) && this.updateDistance(g, y), "miter" === o) {
                        if (P) {
                            const e1 = y.dist(g);
                            if (e1 > 2 * z) {
                                const t1 = y.sub(y.sub(g)._mult(z / e1)._round());
                                this.updateDistance(g, t1), this.addCurrentVertex(t1, v, 0, 0, m, A), g = t1;
                            }
                            this.updateDistance(g, y), I._mult(B), this.addCurrentVertex(y, I, 0, 0, m, A);
                            const t1 = y.dist(x);
                            if (t1 > 2 * z) {
                                const e1 = y.add(x.sub(y)._mult(z / t1)._round());
                                this.updateDistance(y, e1), this.addCurrentVertex(e1, b, 0, 0, m, A), y = e1;
                            }
                        } else I._mult(B), this.addCurrentVertex(y, I, 0, 0, m, A);
                    } else if ("flipbevel" === o) {
                        if (B > 100) I = b.mult(-1);
                        else {
                            const e1 = B * v.add(b).mag() / v.sub(b).mag();
                            I._perp()._mult(e1 * (T ? -1 : 1));
                        }
                        this.addCurrentVertex(y, I, 0, 0, m, A), this.addCurrentVertex(y, I.mult(-1), 0, 0, m, A);
                    } else if ("bevel" === o || "fakeround" === o) {
                        const e1 = y.dist(g);
                        let t1 = 1;
                        if ("offset" === this.elevationType && "bevel" === o && "round" !== this.currentLineJoinType && !this.patternJoinNone && null != A && g && x) {
                            const r = 4 * z;
                            e1 < r && (t1 = Math.max(0, e1 / r));
                        }
                        null != A && g && this.addCurrentVertex(y, _ || v, -t1, -t1, m, A);
                        const r = e1 <= 2 * z && "bevel" !== o, n = I.mult(T ? 1 : -1);
                        n._mult(B);
                        const i = b.mult(T ? -1 : 1), s = v.mult(T ? -1 : 1), a = this.evaluateLineProgressFeatures(this.distance);
                        if (null == A && (this.addHalfVertex(y, n.x, n.y, !1, !T, 0, m, a), r || this.addHalfVertex(y, n.x + 2 * s.x, n.y + 2 * s.y, !1, T, 0, m, a)), "fakeround" === o) {
                            const e1 = Math.round(180 * S / Math.PI / 20);
                            this.addHalfVertex(y, s.x, s.y, !1, T, 0, m, a);
                            for(let t1 = 0; t1 < e1; t1++){
                                let r = t1 / e1;
                                if (.5 !== r) {
                                    const e1 = r - .5;
                                    r += r * e1 * (r - 1) * ((1.0904 + l * (l * (3.55645 - 1.43519 * l) - 3.2452)) * e1 * e1 + (.848013 + l * (.215638 * l - 1.06021)));
                                }
                                const n = i.sub(s)._mult(r)._add(s)._unit();
                                this.addHalfVertex(y, n.x, n.y, !1, T, 0, m, a);
                            }
                            this.addHalfVertex(y, i.x, i.y, !1, T, 0, m, a);
                        }
                        r || null != A || this.addHalfVertex(y, n.x + 2 * i.x, n.y + 2 * i.y, !1, T, 0, m, a), null != A && x && this.addCurrentVertex(y, w || b, t1, t1, m, A);
                    } else if ("butt" === o) this.addCurrentVertex(y, I, 0, 0, m, A);
                    else if ("square" === o) {
                        if (!g) {
                            const e1 = c ? 0 : -1;
                            this.addCurrentVertex(y, I, e1, e1, m, A);
                        }
                        if (this.addCurrentVertex(y, I, 0, 0, m, A), g) {
                            const e1 = h ? 0 : 1;
                            this.addCurrentVertex(y, I, e1, e1, m, A);
                        }
                    } else if ("round" === o) {
                        if (g) {
                            const e1 = !r && _ ? _ : v;
                            this.addCurrentVertex(y, e1, 0, 0, m, A), !r && h || this.addCurrentVertex(y, e1, 1, 1, m, A, !0);
                        }
                        if (x) {
                            const e1 = !r && w ? w : b;
                            !r && c || this.addCurrentVertex(y, e1, -1, -1, m, A, !0), this.addCurrentVertex(y, e1, 0, 0, m, A);
                        }
                    }
                }
            }
            addVerticesTo(e1, t1, r, n, i, s, a, o, l, u) {
                const c = (t1.w - e1.w) / this.tessellationStep | 0;
                let h = 0;
                const d = this.scaledDistance;
                if (c > 1) {
                    this.lineSoFar = e1.w;
                    const r = (t1.x - e1.x) / c, n = (t1.y - e1.y) / c, i = (t1.z - e1.z) / c, s = (t1.w - e1.w) / c, a = t1.x - e1.x, o = t1.y - e1.y, d = Math.sqrt(a * a + o * o);
                    if (0 === d) return;
                    const p = -o / d, f = a / d, m = p, y = f, g = -p, x = -f;
                    for(let t1 = 1; t1 < c; ++t1){
                        e1.x += r, e1.y += n, e1.z += i, this.lineSoFar += s, h += s;
                        const t1 = this.evaluateLineProgressFeatures(this.prevDistance + h);
                        this.scaledDistance = (this.prevDistance + h) / this.totalDistance, this.addHalfVertex(e1, m, y, u, !1, 0, l, t1), this.addHalfVertex(e1, g, x, u, !0, 0, l, t1);
                    }
                }
                this.lineSoFar = t1.w, this.scaledDistance = d;
                const p = this.evaluateLineProgressFeatures(this.distance);
                this.addHalfVertex(t1, r, n, u, !1, a, l, p), this.addHalfVertex(t1, i, s, u, !0, -o, l, p);
            }
            evaluateLineProgressFeatures(e1) {
                if (!this.variableWidthValue && "offset" !== this.elevationType) return null;
                this.evaluationGlobals.lineProgress = 0, this.lineClips ? this.evaluationGlobals.lineProgress = Math.min(1, (this.totalFeatureLength * this.lineClips.start + e1) / this.totalFeatureLength) : Ze(`line-progress evaluation for ${this.layerIds[0]} requires enabling 'lineMetrics' for the source.`);
                let t1 = 0;
                this.variableWidthValue && "constant" !== this.variableWidthValue.kind && (t1 = this.variableWidthValue.evaluate(this.evaluationGlobals, this.lineFeature) || 0);
                const r = this.evaluateElevationGroundScale();
                return "offset" !== this.elevationType ? {
                    zOffset: 0,
                    variableWidth: t1,
                    elevationGroundScale: r
                } : "constant" === this.zOffsetValue.kind ? {
                    zOffset: this.zOffsetValue.value,
                    variableWidth: t1,
                    elevationGroundScale: r
                } : {
                    zOffset: this.zOffsetValue.evaluate(this.evaluationGlobals, this.lineFeature) || 0,
                    variableWidth: t1,
                    elevationGroundScale: r
                };
            }
            evaluateElevationGroundScale() {
                return this.elevationGroundScaleValue ? "constant" === this.elevationGroundScaleValue.kind ? this.elevationGroundScaleValue.value : this.elevationGroundScaleValue.evaluate(this.evaluationGlobals, this.lineFeature) || 0 : 0;
            }
            addCurrentVertex(e1, t1, r, n, i, s, a = !1) {
                const o = t1.x + t1.y * r, l = t1.y - t1.x * r, u = t1.y * n - t1.x, c = -t1.y - t1.x * n;
                if (null != s) {
                    const t1 = "offset" === this.elevationType, h = "offset" === this.elevationType ? 2 : 10, d = -h, p = qn + h, f = s.zOffset, m = new Uf(e1.x, e1.y, f, this.lineSoFar), y = !!t1 && Wy(e1, d, p), g = this.lineSoFar, x = this.distance;
                    if (this.currentVertex) {
                        if (y) {
                            const t1 = this.currentVertexIsOutside, s = this.currentVertex, h = new Uf(e1.x, e1.y, f, this.lineSoFar);
                            if (jf(s, h, d, p), !Wy(h, d, p)) {
                                if (t1) {
                                    this.e1 = this.e2 = -1, this.distance -= s.dist(m), this.lineSoFar = s.w;
                                    const e1 = this.evaluateLineProgressFeatures(s.w - this.totalFeatureLength * (this.lineClips ? this.lineClips.start : 0));
                                    this.addHalfVertex(s, o, l, a, !1, r, i, e1), this.addHalfVertex(s, u, c, a, !0, -n, i, e1), this.prevDistance = this.distance;
                                }
                                this.distance = this.prevDistance + s.dist(h), this.scaledDistance = this.distance / this.totalDistance, this.addVerticesTo(s, h, o, l, u, c, r, n, i, a), this.distance = x, this.scaledDistance = this.distance / this.totalDistance;
                            }
                        } else {
                            const e1 = this.currentVertex;
                            if (this.currentVertexIsOutside) {
                                jf(e1, m, d, p), this.e1 = this.e2 = -1, this.distance -= e1.dist(m), this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = e1.w;
                                const t1 = this.evaluateLineProgressFeatures(e1.w - this.totalFeatureLength * (this.lineClips ? this.lineClips.start : 0));
                                this.addHalfVertex(e1, o, l, a, !1, r, i, t1), this.addHalfVertex(e1, u, c, a, !0, -n, i, t1), this.prevDistance = this.distance, this.distance = x, this.scaledDistance = this.distance / this.totalDistance;
                            }
                            this.addVerticesTo(e1, m, o, l, u, c, r, n, i, a);
                        }
                    } else y || (this.addHalfVertex(e1, o, l, a, !1, r, i, s), this.addHalfVertex(e1, u, c, a, !0, -n, i, s));
                    this.currentVertex = m, this.currentVertexIsOutside = y, this.lineSoFar = g;
                } else this.addHalfVertex(e1, o, l, a, !1, r, i, s), this.addHalfVertex(e1, u, c, a, !0, -n, i, s);
            }
            addHalfVertex({ x: e1, y: t1 }, r, n, i, s, a, o, l) {
                if (this.patternJoinNone && (0 === this.segmentPoints.length && (this.segmentStart = this.lineSoFar, this.segmentStartf32 = Math.fround(this.lineSoFar)), s || this.segmentPoints.push(this.lineSoFar - this.segmentStart, a)), this.layoutVertexArray.emplaceBack((e1 << 1) + (i ? 1 : 0), (t1 << 1) + (s ? 1 : 0), Math.round(63 * r) + 128, Math.round(63 * n) + 128, 1 + (0 === a ? 0 : a < 0 ? -1 : 1), 0, this.lineSoFar - this.segmentStartf32), this.lineClips) {
                    const e1 = yr(this.lineClips.start, this.lineClips.end, this.scaledDistance);
                    this.layoutVertexArray2.emplaceBack(this.scaledDistance, this.lineClipsArray.length, e1);
                }
                const u = o.vertexLength++;
                if (this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, this.e2, u), o.primitiveLength++), s ? this.e2 = u : this.e1 = u, null != l && this.zOffsetVertexArray.emplaceBack(l.zOffset, l.variableWidth, l.variableWidth), this.elevationGroundScaleValue) {
                    const e1 = l ? l.elevationGroundScale : this.evaluateElevationGroundScale();
                    this.elevationGroundScaleVertexArray.emplaceBack(e1);
                }
            }
            updateScaledDistance() {
                this.lineClips ? (this.scaledDistance = this.distance / this.totalDistance, this.lineSoFar = this.totalFeatureLength * this.lineClips.start + this.distance) : this.lineSoFar = this.distance;
            }
            updateDistance(e1, t1) {
                this.prevDistance = this.distance, this.distance += e1.dist(t1), this.updateScaledDistance();
            }
        }
        function Wy(e1, t1, r) {
            return e1.x < t1 || e1.x > r || e1.y < t1 || e1.y > r;
        }
        let Yy, Jy;
        function Ky(e1, t1, r) {
            return t1 * (qn / (e1.tileSize * Math.pow(2, r - e1.tileID.overscaledZ)));
        }
        ra(Zy, "LineBucket", {
            omit: [
                "layers",
                "patternFeatures",
                "currentVertex",
                "currentVertexIsOutside"
            ]
        });
        const Qy = (e1, t1, r)=>(1 - r) * e1 + r * t1;
        function eg(e1, t1) {
            return 1 / Ky(e1, 1, t1.tileZoom);
        }
        function tg(e1, t1, r, n) {
            return e1.translatePosMatrix(n || t1.tileID.projMatrix, t1, r.paint.get("line-translate"), r.paint.get("line-translate-anchor"));
        }
        const rg = (e1)=>{
            const t1 = [];
            ng(e1) && t1.push("RENDER_LINE_DASH"), e1.paint.get("line-gradient") && t1.push("RENDER_LINE_GRADIENT"), "multiply" === e1.paint.get("line-blend-mode") && t1.push("LINE_BLEND_MULTIPLY");
            const r = e1.paint.get("line-trim-offset");
            0 === r[0] && 0 === r[1] || t1.push("RENDER_LINE_TRIM_OFFSET"), 0 !== e1.paint.get("line-border-width").constantOr(1) && t1.push("RENDER_LINE_BORDER");
            const n = "none" === e1.layout.get("line-join").constantOr("miter"), i = !!e1.paint.get("line-pattern").constantOr(1);
            return n && i && t1.push("LINE_JOIN_NONE"), t1;
        };
        function ng(e1) {
            const t1 = e1.paint.get("line-dasharray").value;
            return "constant" !== t1.kind || t1.value;
        }
        let ig;
        const sg = ()=>ig || (ig = {
                layout: Yy || (Yy = new fo({
                    "line-cap": new ho(mo.layout_line["line-cap"]),
                    "line-join": new ho(mo.layout_line["line-join"]),
                    "line-miter-limit": new co(mo.layout_line["line-miter-limit"]),
                    "line-round-limit": new co(mo.layout_line["line-round-limit"]),
                    "line-sort-key": new ho(mo.layout_line["line-sort-key"]),
                    "line-z-offset": new ho(mo.layout_line["line-z-offset"]),
                    "line-elevation-reference": new co(mo.layout_line["line-elevation-reference"]),
                    "line-cross-slope": new co(mo.layout_line["line-cross-slope"]),
                    visibility: new co(mo.layout_line.visibility),
                    "line-width-unit": new co(mo.layout_line["line-width-unit"]),
                    "line-elevation-ground-scale": new ho(mo.layout_line["line-elevation-ground-scale"])
                })),
                paint: Jy || (Jy = new fo({
                    "line-opacity": new ho(mo.paint_line["line-opacity"]),
                    "line-color": new ho(mo.paint_line["line-color"]),
                    "line-translate": new co(mo.paint_line["line-translate"]),
                    "line-translate-anchor": new co(mo.paint_line["line-translate-anchor"]),
                    "line-width": new ho(mo.paint_line["line-width"]),
                    "line-gap-width": new ho(mo.paint_line["line-gap-width"]),
                    "line-offset": new ho(mo.paint_line["line-offset"]),
                    "line-blur": new ho(mo.paint_line["line-blur"]),
                    "line-dasharray": new ho(mo.paint_line["line-dasharray"]),
                    "line-pattern": new ho(mo.paint_line["line-pattern"]),
                    "line-pattern-cross-fade": new co(mo.paint_line["line-pattern-cross-fade"]),
                    "line-gradient": new po(mo.paint_line["line-gradient"]),
                    "line-trim-offset": new co(mo.paint_line["line-trim-offset"]),
                    "line-trim-fade-range": new co(mo.paint_line["line-trim-fade-range"]),
                    "line-trim-color": new co(mo.paint_line["line-trim-color"]),
                    "line-emissive-strength": new ho(mo.paint_line["line-emissive-strength"]),
                    "line-border-width": new ho(mo.paint_line["line-border-width"]),
                    "line-border-color": new ho(mo.paint_line["line-border-color"]),
                    "line-occlusion-opacity": new co(mo.paint_line["line-occlusion-opacity"]),
                    "line-blend-mode": new co(mo.paint_line["line-blend-mode"]),
                    "line-color-use-theme": new ho({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "line-gradient-use-theme": new ho({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "line-trim-color-use-theme": new ho({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "line-border-color-use-theme": new ho({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    })
                }))
            }, ig);
        class ag extends ho {
            possiblyEvaluate(e1, t1) {
                return t1 = new to(Math.floor(t1.zoom), {
                    now: t1.now,
                    fadeDuration: t1.fadeDuration,
                    transition: t1.transition,
                    worldview: t1.worldview
                }), super.possiblyEvaluate(e1, t1);
            }
            evaluate(e1, t1, r, n) {
                return t1 = Object.assign({}, t1, {
                    zoom: Math.floor(t1.zoom)
                }), super.evaluate(e1, t1, r, n);
            }
        }
        let og;
        function lg(e1, t1) {
            return t1 > 0 ? t1 + 2 * e1 : e1;
        }
        const ug = qo([
            {
                name: "a_pos_offset",
                components: 4,
                type: "Int16"
            },
            {
                name: "a_tex_size",
                components: 4,
                type: "Uint16"
            },
            {
                name: "a_pixeloffset",
                components: 4,
                type: "Int16"
            }
        ], 4), cg = qo([
            {
                name: "a_globe_anchor",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_globe_normal",
                components: 3,
                type: "Float32"
            }
        ], 4), hg = qo([
            {
                name: "a_projected_pos",
                components: 4,
                type: "Float32"
            }
        ], 4);
        qo([
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint32"
            }
        ], 4);
        const dg = qo([
            {
                name: "a_auto_z_offset",
                components: 1,
                type: "Float32"
            }
        ], 4), pg = qo([
            {
                name: "a_feature_index",
                components: 1,
                type: "Float32"
            }
        ], 4), fg = qo([
            {
                name: "a_x_axis",
                components: 3,
                type: "Float32"
            },
            {
                name: "a_y_axis",
                components: 3,
                type: "Float32"
            }
        ]), mg = qo([
            {
                name: "a_texb",
                components: 2,
                type: "Uint16"
            }
        ]), yg = qo([
            {
                name: "a_placed",
                components: 2,
                type: "Uint8"
            },
            {
                name: "a_shift",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_elevation_from_sea",
                components: 2,
                type: "Float32"
            }
        ]), gg = qo([
            {
                name: "a_size_scale",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_padding",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_auto_z_offset",
                components: 1,
                type: "Float32"
            }
        ]);
        qo([
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Int16",
                name: "tileAnchorX"
            },
            {
                type: "Int16",
                name: "tileAnchorY"
            },
            {
                type: "Float32",
                name: "x1"
            },
            {
                type: "Float32",
                name: "y1"
            },
            {
                type: "Float32",
                name: "x2"
            },
            {
                type: "Float32",
                name: "y2"
            },
            {
                type: "Int16",
                name: "padding"
            },
            {
                type: "Uint32",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "sourceLayerIndex"
            },
            {
                type: "Uint16",
                name: "bucketIndex"
            }
        ]);
        const xg = qo([
            {
                name: "a_pos",
                components: 3,
                type: "Int16"
            },
            {
                name: "a_anchor_pos",
                components: 2,
                type: "Int16"
            },
            {
                name: "a_extrude",
                components: 2,
                type: "Int16"
            }
        ], 4), vg = qo([
            {
                name: "a_pos_2f",
                components: 2,
                type: "Float32"
            },
            {
                name: "a_radius",
                components: 1,
                type: "Float32"
            },
            {
                name: "a_flags",
                components: 2,
                type: "Int16"
            }
        ], 4);
        qo([
            {
                name: "triangle",
                components: 3,
                type: "Uint16"
            }
        ]), qo([
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Float32",
                name: "tileAnchorX"
            },
            {
                type: "Float32",
                name: "tileAnchorY"
            },
            {
                type: "Uint16",
                name: "glyphStartIndex"
            },
            {
                type: "Uint16",
                name: "numGlyphs"
            },
            {
                type: "Uint32",
                name: "vertexStartIndex"
            },
            {
                type: "Uint32",
                name: "lineStartIndex"
            },
            {
                type: "Uint32",
                name: "lineLength"
            },
            {
                type: "Uint16",
                name: "segment"
            },
            {
                type: "Uint16",
                name: "lowerSize"
            },
            {
                type: "Uint16",
                name: "upperSize"
            },
            {
                type: "Float32",
                name: "lineOffsetX"
            },
            {
                type: "Float32",
                name: "lineOffsetY"
            },
            {
                type: "Uint8",
                name: "writingMode"
            },
            {
                type: "Uint8",
                name: "placedOrientation"
            },
            {
                type: "Uint8",
                name: "hidden"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Int16",
                name: "associatedIconIndex"
            },
            {
                type: "Uint8",
                name: "flipState"
            }
        ]), qo([
            {
                type: "Float32",
                name: "tileAnchorX"
            },
            {
                type: "Float32",
                name: "tileAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorX"
            },
            {
                type: "Int16",
                name: "projectedAnchorY"
            },
            {
                type: "Int16",
                name: "projectedAnchorZ"
            },
            {
                type: "Int16",
                name: "rightJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "centerJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "leftJustifiedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedTextSymbolIndex"
            },
            {
                type: "Int16",
                name: "placedIconSymbolIndex"
            },
            {
                type: "Int16",
                name: "verticalPlacedIconSymbolIndex"
            },
            {
                type: "Uint16",
                name: "key"
            },
            {
                type: "Uint16",
                name: "textBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "textBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalTextBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "iconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxStartIndex"
            },
            {
                type: "Uint16",
                name: "verticalIconBoxEndIndex"
            },
            {
                type: "Uint16",
                name: "featureIndex"
            },
            {
                type: "Uint16",
                name: "numHorizontalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalGlyphVertices"
            },
            {
                type: "Uint16",
                name: "numIconVertices"
            },
            {
                type: "Uint16",
                name: "numVerticalIconVertices"
            },
            {
                type: "Uint16",
                name: "useRuntimeCollisionCircles"
            },
            {
                type: "Uint32",
                name: "crossTileID"
            },
            {
                type: "Float32",
                components: 2,
                name: "textOffset"
            },
            {
                type: "Float32",
                name: "collisionCircleDiameter"
            },
            {
                type: "Float32",
                name: "zOffset"
            },
            {
                type: "Uint8",
                name: "hasIconTextFit"
            },
            {
                type: "Uint16",
                name: "elevationFeatureIndex"
            }
        ]), qo([
            {
                type: "Float32",
                name: "offsetX"
            }
        ]), qo([
            {
                type: "Int16",
                name: "x"
            },
            {
                type: "Int16",
                name: "y"
            }
        ]);
        const bg = class e1 {
            constructor(t1 = null, r = 0, n = 4096){
                this.batchIndex = r, this.headerBuffer = null, this.propertiesBuffer = null, this.blockIndicesBuffer = null, this.context = t1 || null, this.propsDwords = n, this.totalBytes = 4 * this.propsDwords, this.headerData = new Uint32Array(e1.HEADER_DWORDS), this.propertiesData = new Float32Array(this.propsDwords), this.blockIndicesData = new Uint32Array(this.propsDwords);
                for(let e1 = 0; e1 < this.propsDwords; e1++)this.blockIndicesData[e1] = e1;
                t1 && this._initBuffers(t1);
            }
            _initBuffers(t1) {
                const r = t1.gl;
                if (this.totalBytes > t1.maxUniformBlockSize) throw new Error(`UBO size ${this.totalBytes} exceeds device limit ${t1.maxUniformBlockSize}`);
                if (this.headerBuffer = r.createBuffer(), !this.headerBuffer) throw new Error("Failed to create header UBO buffer");
                if (r.bindBuffer(r.UNIFORM_BUFFER, this.headerBuffer), r.bufferData(r.UNIFORM_BUFFER, e1.HEADER_BYTES, r.DYNAMIC_DRAW), this.propertiesBuffer = r.createBuffer(), !this.propertiesBuffer) throw new Error("Failed to create properties UBO buffer");
                if (r.bindBuffer(r.UNIFORM_BUFFER, this.propertiesBuffer), r.bufferData(r.UNIFORM_BUFFER, this.totalBytes, r.DYNAMIC_DRAW), this.blockIndicesBuffer = r.createBuffer(), !this.blockIndicesBuffer) throw new Error("Failed to create block-indices UBO buffer");
                r.bindBuffer(r.UNIFORM_BUFFER, this.blockIndicesBuffer), r.bufferData(r.UNIFORM_BUFFER, this.totalBytes, r.DYNAMIC_DRAW), r.bindBuffer(r.UNIFORM_BUFFER, null);
            }
            writeHeader(e1) {
                const t1 = this.headerData;
                t1[0] = e1.dataDrivenMask, t1[1] = e1.zoomDependentMask, t1[2] = e1.dataDrivenBlockSizeVec4, t1[3] = e1.offsets[0], t1[4] = e1.offsets[1], t1[5] = e1.offsets[2], t1[6] = e1.offsets[3], t1[7] = e1.offsets[4], t1[8] = e1.offsets[5], t1[9] = e1.offsets[6], t1[10] = e1.offsets[7], t1[11] = e1.offsets[8];
            }
            writeDataDrivenBlock(e1, t1, r) {
                const n = 4 * r.dataDrivenBlockSizeVec4;
                if (0 === n) return;
                const i = t1 * n;
                if (i + n > this.propertiesData.length) throw new Error(`UBO write out of bounds: feature index ${t1} exceeds propertiesData capacity`);
                for(let t1 = 0; t1 < 9; t1++)r.dataDrivenMask & 1 << t1 && null != e1[t1] && this._writeProperty(i + r.offsets[t1], t1, e1[t1], r.zoomDependentMask);
            }
            static getMaxFeatureCount(t1, r = 4096 - e1.HEADER_DWORDS) {
                const n = 4 * t1.dataDrivenBlockSizeVec4;
                return 0 === n ? 1 / 0 : Math.floor(r / n);
            }
            _writeProperty(e1, t1, r, n) {
                const i = this.propertiesData, s = 8 === t1, a = !!(n & 1 << t1);
                if (t1 < 2) {
                    const t1 = r;
                    i[e1] = t1[0], i[e1 + 1] = t1[1], i[e1 + 2] = t1[2], i[e1 + 3] = t1[3];
                } else if (s && a) {
                    const t1 = r;
                    i[e1] = t1[0], i[e1 + 1] = t1[1], i[e1 + 2] = t1[2], i[e1 + 3] = t1[3];
                } else if (s) {
                    const t1 = r;
                    i[e1] = t1[0], i[e1 + 1] = t1[1];
                } else if (a) {
                    const t1 = r;
                    i[e1] = t1[0], i[e1 + 1] = t1[1];
                } else i[e1] = r;
            }
            upload(e1) {
                this.context || (this.context = e1);
                const t1 = e1.gl;
                this.headerBuffer && this.propertiesBuffer && this.blockIndicesBuffer || this._initBuffers(e1), t1.bindBuffer(t1.UNIFORM_BUFFER, this.headerBuffer), t1.bufferSubData(t1.UNIFORM_BUFFER, 0, this.headerData), t1.bindBuffer(t1.UNIFORM_BUFFER, this.propertiesBuffer), t1.bufferSubData(t1.UNIFORM_BUFFER, 0, this.propertiesData), t1.bindBuffer(t1.UNIFORM_BUFFER, this.blockIndicesBuffer), t1.bufferSubData(t1.UNIFORM_BUFFER, 0, this.blockIndicesData), t1.bindBuffer(t1.UNIFORM_BUFFER, null);
            }
            bind(e1, t1) {
                const r = e1.gl, n = (e1, n, i)=>{
                    if (!n) return;
                    const s = r.getUniformBlockIndex(t1, e1);
                    s !== r.INVALID_INDEX && (r.uniformBlockBinding(t1, s, i), r.bindBufferBase(r.UNIFORM_BUFFER, i, n));
                }, i = 3 * this.batchIndex;
                n("SymbolPaintPropertiesHeaderUniform", this.headerBuffer, i), n("SymbolPaintPropertiesUniform", this.propertiesBuffer, i + 1), n("SymbolPaintPropertiesIndexUniform", this.blockIndicesBuffer, i + 2);
            }
            destroy() {
                if (this.context) {
                    const e1 = this.context.gl;
                    this.headerBuffer && (e1.deleteBuffer(this.headerBuffer), this.headerBuffer = null), this.propertiesBuffer && (e1.deleteBuffer(this.propertiesBuffer), this.propertiesBuffer = null), this.blockIndicesBuffer && (e1.deleteBuffer(this.blockIndicesBuffer), this.blockIndicesBuffer = null);
                }
            }
        };
        bg.HEADER_DWORDS = 12, bg.HEADER_BYTES = 48;
        let wg = bg;
        function _g(e1, t1, r, n) {
            return [
                Xl(255 * e1, 255 * t1),
                Xl(255 * r, 255 * n)
            ];
        }
        function Ag(e1, t1, r, n, i, s, a, o) {
            return !!e1 && ("constant" === e1.kind ? "none" === e1.value : "composite" === e1.kind || "source" === e1.kind ? "none" === e1.evaluate({
                zoom: 0,
                brightness: s,
                worldview: o
            }, t1, r, i, n, a) : "string" == typeof e1 && "none" === e1);
        }
        ra(wg, "SymbolPropertiesUBO", {
            omit: [
                "headerBuffer",
                "propertiesBuffer",
                "blockIndicesBuffer"
            ]
        });
        class Ig {
            constructor(e1, t1, r, n, i = "", s, a){
                this.layer = e1, this.zoom = t1, this.lut = r, this.isText = n, this.propDefs = this._getPropDefs(), this.worldview = i, this.maxUniformBufferBindings = s || 24, this.uboSizeDwords = a || 4096, this.featureVertexRangesFromId = new Map, this.allFeatures = [], this.ubos = [], this.featureCount = 0, this.cachedHeader = null, this.maxFeaturesPerBatch = 0, this.propertyHashToUBOIndex = new Map, this.canDeduplicate = this._checkIfAllPropertiesAreConstant(e1, n), this.cachedParams = null, this.cachedParamsNext = null, this.cachedBrightness = void 0, this.cachedConstantUniforms = null, this.cachedConstantRenderZoom = null, this.cachedConstantBrightness = void 0, this.activeAppearanceByVtIndex = new Map;
            }
            _getPropDefs() {
                const e1 = this.isText ? "text" : "icon";
                return [
                    {
                        name: `${e1}-color`,
                        useThemeName: `${e1}-color-use-theme`,
                        isColor: !0
                    },
                    {
                        name: `${e1}-halo-color`,
                        useThemeName: `${e1}-halo-color-use-theme`,
                        isColor: !0
                    },
                    {
                        name: `${e1}-opacity`,
                        useThemeName: null,
                        isColor: !1
                    },
                    {
                        name: `${e1}-halo-width`,
                        useThemeName: null,
                        isColor: !1
                    },
                    {
                        name: `${e1}-halo-blur`,
                        useThemeName: null,
                        isColor: !1
                    },
                    {
                        name: `${e1}-emissive-strength`,
                        useThemeName: null,
                        isColor: !1
                    },
                    {
                        name: `${e1}-occlusion-opacity`,
                        useThemeName: null,
                        isColor: !1
                    },
                    {
                        name: "symbol-z-offset",
                        useThemeName: null,
                        isColor: !1
                    },
                    {
                        name: `${e1}-translate`,
                        useThemeName: null,
                        isColor: !1,
                        isVec2: !0
                    }
                ];
            }
            buildHeader() {
                const e1 = this.layer.paint, t1 = this.propDefs;
                let r = 0, n = 0, i = 0, s = 0;
                const a = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0
                ];
                for(let o = 0; o < 9; o++){
                    const { name: l, isColor: u, isVec2: c } = t1[o], h = e1.get(l), d = !(!h || "function" != typeof h.isConstant || h.isConstant()), p = this._appearancesHavePaintProperties(l), f = d || p, m = !(!h || !h.value || "composite" !== h.value.kind), y = this.layer._transitionablePaint._values[l], g = !f && "camera" === (y && y.value && y.value.expression && y.value.expression.kind);
                    f ? (r |= 1 << o, m && (n |= 1 << o), u ? (s % 4 != 0 && (s = s + 3 & -4), a[o] = s, s += 4) : c ? m ? (s % 4 != 0 && (s = s + 3 & -4), a[o] = s, s += 4) : (s % 4 == 3 && s++, a[o] = s, s += 2) : (a[o] = s, s += m ? 2 : 1)) : g && (i |= 1 << o);
                }
                return {
                    dataDrivenMask: r,
                    zoomDependentMask: n,
                    cameraMask: i,
                    dataDrivenBlockSizeVec4: (0 === s ? 0 : s + 3 & -4) / 4,
                    offsets: a
                };
            }
            get hasCameraExpression() {
                return !(!this.cachedHeader || !this.cachedHeader.cameraMask);
            }
            evaluateAllProperties(e1, t1, r, n, i, s, a) {
                const { params: o, paramsNext: l } = this._getCachedParams(i), u = {
                    feature: e1,
                    featureState: t1,
                    canonical: r,
                    availableImages: n,
                    params: o,
                    paramsNext: l,
                    formattedSection: s
                }, c = this.cachedHeader, h = this.propDefs, d = new Array(9).fill(null);
                for(let e1 = 0; e1 < 9; e1++){
                    const { name: t1, useThemeName: r, isColor: n, isVec2: s } = h[e1], o = !!(c && c.zoomDependentMask & 1 << e1);
                    d[e1] = n ? this._evaluateColorValue(t1, r, u, i, o, a) : s ? this._evaluateTranslateValue(t1, o, u, a) : this._evaluateFloatValue(t1, o, u, a);
                }
                return d;
            }
            _evaluateColorValue(e1, t1, r, n, i, s) {
                const a = this.layer.paint, o = e1, l = s && s.hasPaintProperty(o) ? s.paintProperties.get(o) : a.get(e1), u = t1, c = t1 && s && s.hasPaintProperty(u) ? s.paintProperties.get(u) : t1 ? a.get(t1) : void 0;
                if (!l) return [
                    0,
                    0,
                    0,
                    1
                ];
                const h = Ag(c && "string" != typeof c ? c.value : void 0, r.feature, r.featureState, r.availableImages, r.canonical, n, r.formattedSection, this.worldview) ? null : this.lut;
                let d, p;
                l.isConstant() ? d = p = l.constantOr(dr.transparent) : (d = l.property.evaluate(l.value, r.params, r.feature, r.featureState, r.canonical, r.availableImages, l.iconImageUseTheme, r.formattedSection), p = i ? l.property.evaluate(l.value, r.paramsNext, r.feature, r.featureState, r.canonical, r.availableImages, l.iconImageUseTheme, r.formattedSection) : d);
                const f = (d || dr.transparent).toNonPremultipliedRenderColor(h), m = (p || dr.transparent).toNonPremultipliedRenderColor(h);
                if (i) {
                    const [e1, t1] = _g(f.r, f.g, f.b, f.a), [r, n] = _g(m.r, m.g, m.b, m.a);
                    return [
                        e1,
                        t1,
                        r,
                        n
                    ];
                }
                const [y, g] = _g(f.r, f.g, f.b, f.a);
                return [
                    y,
                    g,
                    0,
                    0
                ];
            }
            _evaluateFloatValue(e1, t1, r, n) {
                const i = this.layer.paint, s = e1.endsWith("opacity") ? 1 : 0, a = e1, o = n && n.hasPaintProperty(a) ? n.paintProperties.get(a) : i.get(e1);
                if (!o) return s;
                if (o.isConstant()) return o.constantOr(s);
                const l = o.property.evaluate(o.value, r.params, r.feature, r.featureState, r.canonical, r.availableImages, o.iconImageUseTheme, r.formattedSection), u = null != l ? l : s;
                if (t1) {
                    const e1 = o.property.evaluate(o.value, r.paramsNext, r.feature, r.featureState, r.canonical, r.availableImages, o.iconImageUseTheme, r.formattedSection);
                    return [
                        u,
                        null != e1 ? e1 : s
                    ];
                }
                return u;
            }
            _evaluateTranslateValue(e1, t1, r, n) {
                const i = this.layer.paint, s = e1, a = n && n.hasPaintProperty(s) ? n.paintProperties.get(s) : i.get(e1);
                if (!a) return [
                    0,
                    0
                ];
                if ("function" != typeof a.isConstant) return a || [
                    0,
                    0
                ];
                if (a.isConstant()) return a.constantOr([
                    0,
                    0
                ]);
                const o = a.property.evaluate(a.value, r.params, r.feature, r.featureState, r.canonical, r.availableImages, a.iconImageUseTheme, r.formattedSection) || [
                    0,
                    0
                ];
                if (t1) {
                    const e1 = a.property.evaluate(a.value, r.paramsNext, r.feature, r.featureState, r.canonical, r.availableImages, a.iconImageUseTheme, r.formattedSection) || [
                        0,
                        0
                    ];
                    return [
                        o[0],
                        o[1],
                        e1[0],
                        e1[1]
                    ];
                }
                return o;
            }
            _getCachedParams(e1) {
                return this.cachedParams && this.cachedParamsNext && this.cachedBrightness === e1 || (this.cachedParams = new to(this.zoom, {
                    brightness: e1,
                    worldview: this.worldview
                }), this.cachedParamsNext = new to(this.zoom + 1, {
                    brightness: e1,
                    worldview: this.worldview
                }), this.cachedBrightness = e1), {
                    params: this.cachedParams,
                    paramsNext: this.cachedParamsNext
                };
            }
            _appearancesHavePaintProperties(e1) {
                return this.layer.getAppearances().some(void 0 !== e1 ? (t1)=>t1.hasPaintProperty(e1) : this.isText ? (e1)=>e1.hasTextPaintProperties() : (e1)=>e1.hasIconPaintProperties());
            }
            _checkIfAllPropertiesAreConstant(e1, t1) {
                const r = e1.paint, n = t1 ? "text" : "icon", i = [
                    `${n}-color`,
                    `${n}-halo-color`,
                    `${n}-opacity`,
                    `${n}-halo-width`,
                    `${n}-halo-blur`,
                    `${n}-emissive-strength`,
                    `${n}-occlusion-opacity`,
                    "symbol-z-offset",
                    `${n}-translate`
                ];
                for (const e1 of i){
                    const t1 = r.get(e1);
                    if (t1 && "object" == typeof t1 && "isConstant" in t1 && !t1.isConstant()) return !1;
                }
                return !this._appearancesHavePaintProperties();
            }
            _hashDataDrivenValues(e1, t1) {
                if (0 === t1.dataDrivenMask) return "";
                const r = [];
                for(let n = 0; n < 9; n++){
                    if (!(t1.dataDrivenMask & 1 << n)) continue;
                    const i = e1[n];
                    null == i ? r.push("null") : Array.isArray(i) ? r.push(i.join(",")) : r.push(String(i));
                }
                return r.join("|");
            }
            getCurrentBatchIndex() {
                return this.cachedHeader && 0 !== this.maxFeaturesPerBatch ? Math.floor(this.featureCount / this.maxFeaturesPerBatch) : 0;
            }
            populateUBO(e1, t1, r, n, i, s, a) {
                const o = e1.id;
                if (!this.cachedHeader) {
                    this.cachedHeader = this.buildHeader();
                    const e1 = wg.getMaxFeatureCount(this.cachedHeader, this.uboSizeDwords);
                    this.maxFeaturesPerBatch = isFinite(e1) ? e1 : Number.MAX_SAFE_INTEGER;
                }
                const l = this.cachedHeader, u = this.evaluateAllProperties(e1, {}, r, n, i, s);
                if (this.canDeduplicate) {
                    const e1 = this._hashDataDrivenValues(u, l), r = this.propertyHashToUBOIndex.get(e1);
                    if (void 0 !== r) {
                        const e1 = isFinite(this.maxFeaturesPerBatch) ? Math.floor(r / this.maxFeaturesPerBatch) : 0, n = isFinite(this.maxFeaturesPerBatch) ? r % this.maxFeaturesPerBatch : r, i = {
                            batchIndex: e1,
                            localFeatureIndex: n,
                            vtFeatureIndex: t1,
                            featureId: o
                        };
                        return this.allFeatures.push(i), null != o && (this.featureVertexRangesFromId.has(o) || this.featureVertexRangesFromId.set(o, []), this.featureVertexRangesFromId.get(o).push(i)), n;
                    }
                    this.propertyHashToUBOIndex.set(e1, this.featureCount);
                }
                const c = this.featureCount++, h = isFinite(this.maxFeaturesPerBatch) ? Math.floor(c / this.maxFeaturesPerBatch) : 0, d = isFinite(this.maxFeaturesPerBatch) ? c % this.maxFeaturesPerBatch : c, p = a ? a.maxUniformBufferBindings : this.maxUniformBufferBindings;
                if (3 * h + 2 >= p) {
                    Ze(`Too many symbol features: batch ${h} requires binding points up to ${3 * h + 2}, device limit ${p}. Some features will render incorrectly.`);
                    const e1 = {
                        batchIndex: 0,
                        localFeatureIndex: 0,
                        vtFeatureIndex: t1,
                        featureId: o
                    };
                    return this.allFeatures.push(e1), null != o && (this.featureVertexRangesFromId.has(o) || this.featureVertexRangesFromId.set(o, []), this.featureVertexRangesFromId.get(o).push(e1)), 0;
                }
                this.ubos[h] || (this.ubos[h] = new wg(a, h, this.uboSizeDwords), this.ubos[h].writeHeader(l)), this.ubos[h].writeDataDrivenBlock(u, d, l);
                const f = {
                    batchIndex: h,
                    localFeatureIndex: d,
                    vtFeatureIndex: t1,
                    featureId: o
                };
                return this.allFeatures.push(f), null != o && (this.featureVertexRangesFromId.has(o) || this.featureVertexRangesFromId.set(o, []), this.featureVertexRangesFromId.get(o).push(f)), d;
            }
            updateFeatures(e1, t1, r, n, i, s, a) {
                if (this.layer = t1, this.cachedConstantUniforms = null, !this.cachedHeader) return;
                const o = this.cachedHeader;
                for (const t1 of e1){
                    const e1 = this.featureVertexRangesFromId.get(t1);
                    if (!e1) continue;
                    const l = s[t1] || {};
                    for (const s of e1){
                        if (!r) continue;
                        const e1 = r.feature(s.vtFeatureIndex);
                        if (!e1) continue;
                        const u = {
                            type: e1.type,
                            id: t1,
                            properties: e1.properties || {},
                            geometry: []
                        }, c = this.activeAppearanceByVtIndex ? this.activeAppearanceByVtIndex.get(s.vtFeatureIndex) : void 0, h = this.evaluateAllProperties(u, l, n, i, a, void 0, c);
                        this.ubos[s.batchIndex] && this.ubos[s.batchIndex].writeDataDrivenBlock(h, s.localFeatureIndex, o);
                    }
                }
            }
            updateDynamicExpressions(e1, t1, r, n, i, s) {
                if (this.layer = e1, this.cachedConstantUniforms = null, !this.cachedHeader) return;
                const a = this.cachedHeader;
                for (const e1 of this.allFeatures){
                    if (!t1) continue;
                    const o = t1.feature(e1.vtFeatureIndex);
                    if (!o) continue;
                    const l = null != e1.featureId && i[e1.featureId] || {}, u = {
                        type: o.type,
                        id: e1.featureId,
                        properties: o.properties || {},
                        geometry: []
                    }, c = this.activeAppearanceByVtIndex ? this.activeAppearanceByVtIndex.get(e1.vtFeatureIndex) : void 0, h = this.evaluateAllProperties(u, l, r, n, s, void 0, c);
                    this.ubos[e1.batchIndex] && this.ubos[e1.batchIndex].writeDataDrivenBlock(h, e1.localFeatureIndex, a);
                }
            }
            updateFeaturePaintForAppearance(e1, t1, r, n, i, s, a) {
                if (!this.layer) return !1;
                if (this.activeAppearanceByVtIndex || (this.activeAppearanceByVtIndex = new Map), this.activeAppearanceByVtIndex.set(e1, a || null), !this.cachedHeader) return !1;
                const o = this.cachedHeader;
                if (0 === o.dataDrivenMask) return !1;
                let l = !1;
                for (const u of this.allFeatures){
                    if (u.vtFeatureIndex !== e1) continue;
                    const c = this.evaluateAllProperties(t1, r, n, i, s, void 0, a);
                    this.ubos[u.batchIndex] && (this.ubos[u.batchIndex].writeDataDrivenBlock(c, u.localFeatureIndex, o), l = !0);
                }
                return l;
            }
            getConstantUniformValues(e1, t1) {
                const r = this.cachedHeader, n = !(!r || !r.cameraMask);
                if (this.cachedConstantUniforms && this.cachedConstantBrightness === t1 && (!n || this.cachedConstantRenderZoom === e1)) return this.cachedConstantUniforms;
                const i = this.layer.paint, s = this.propDefs, a = n ? new to(e1, {
                    brightness: t1,
                    worldview: this.worldview
                }) : null, o = {
                    type: 1,
                    id: void 0,
                    properties: {},
                    geometry: []
                }, l = (e1)=>{
                    const n = s[e1], l = i.get(n.name);
                    if (!l) return [
                        0,
                        0,
                        0,
                        1
                    ];
                    const u = n.useThemeName ? i.get(n.useThemeName) : void 0, c = Ag(u && "string" != typeof u ? u.value : void 0, o, {}, [], void 0, t1, void 0, this.worldview) ? null : this.lut;
                    let h;
                    h = r && r.cameraMask & 1 << e1 && a ? l.property.evaluate(l.value, a, o, {}, void 0, []) : l.constantOr(dr.transparent);
                    const d = (h || dr.transparent).toNonPremultipliedRenderColor(c);
                    return [
                        d.r,
                        d.g,
                        d.b,
                        d.a
                    ];
                }, u = (e1, t1)=>{
                    const n = i.get(s[e1].name);
                    if (!n) return t1;
                    if (r && r.cameraMask & 1 << e1 && a) {
                        const e1 = n.property.evaluate(n.value, a, o, {}, void 0, []);
                        return null != e1 ? e1 : t1;
                    }
                    return n.constantOr(t1);
                }, c = {
                    fill_np_color: l(0),
                    halo_np_color: l(1),
                    opacity: u(2, 1),
                    halo_width: u(3, 0),
                    halo_blur: u(4, 0),
                    emissive_strength: u(5, 0),
                    occlusion_opacity: u(6, 1),
                    z_offset: u(7, 0)
                };
                return this.cachedConstantUniforms = c, this.cachedConstantRenderZoom = e1, this.cachedConstantBrightness = t1, c;
            }
            upload(e1) {
                for (const t1 of this.ubos)t1.upload(e1);
            }
            bind(e1, t1, r = 0) {
                this.ubos[r] && this.ubos[r].bind(e1, t1);
            }
            destroy() {
                for (const e1 of this.ubos)e1.destroy();
                this.ubos = [], this.featureVertexRangesFromId.clear(), this.allFeatures = [], this.featureCount = 0, this.cachedHeader = null, this.maxFeaturesPerBatch = 0, this.propertyHashToUBOIndex && this.propertyHashToUBOIndex.clear();
            }
        }
        ra(Ig, "SymbolPropertyBinderUBO", {
            omit: [
                "layer",
                "cachedParams",
                "cachedParamsNext",
                "cachedBrightness",
                "propertyHashToUBOIndex",
                "cachedConstantUniforms",
                "cachedConstantRenderZoom",
                "cachedConstantBrightness",
                "activeAppearanceByVtIndex"
            ]
        });
        var Mg = 24;
        function Bg(e1, t1, r) {
            return e1.sections.forEach((e1)=>{
                e1.text = function(e1, t1, r) {
                    const n = t1.layout.get("text-transform").evaluate(r, {});
                    return "uppercase" === n ? e1 = e1.toLocaleUpperCase() : "lowercase" === n && (e1 = e1.toLocaleLowerCase()), Qa.applyArabicShaping && (e1 = Qa.applyArabicShaping(e1)), e1;
                }(e1.text, t1, r);
            }), e1;
        }
        const Sg = {
            "!": "\uFE15",
            "#": "\uFF03",
            $: "\uFF04",
            "%": "\uFF05",
            "&": "\uFF06",
            "(": "\uFE35",
            ")": "\uFE36",
            "*": "\uFF0A",
            "+": "\uFF0B",
            ",": "\uFE10",
            "-": "\uFE32",
            ".": "\u30FB",
            "/": "\uFF0F",
            ":": "\uFE13",
            ";": "\uFE14",
            "<": "\uFE3F",
            "=": "\uFF1D",
            ">": "\uFE40",
            "?": "\uFE16",
            "@": "\uFF20",
            "[": "\uFE47",
            "\\": "\uFF3C",
            "]": "\uFE48",
            "^": "\uFF3E",
            _: "\uFE33",
            "`": "\uFF40",
            "{": "\uFE37",
            "|": "\u2015",
            "}": "\uFE38",
            "~": "\uFF5E",
            "\xa2": "\uFFE0",
            "\xa3": "\uFFE1",
            "\xa5": "\uFFE5",
            "\xa6": "\uFFE4",
            "\xac": "\uFFE2",
            "\xaf": "\uFFE3",
            "\u2013": "\uFE32",
            "\u2014": "\uFE31",
            "\u2018": "\uFE43",
            "\u2019": "\uFE44",
            "\u201C": "\uFE41",
            "\u201D": "\uFE42",
            "\u2026": "\uFE19",
            "\u2027": "\u30FB",
            "\u20A9": "\uFFE6",
            "\u3001": "\uFE11",
            "\u3002": "\uFE12",
            "\u3008": "\uFE3F",
            "\u3009": "\uFE40",
            "\u300A": "\uFE3D",
            "\u300B": "\uFE3E",
            "\u300C": "\uFE41",
            "\u300D": "\uFE42",
            "\u300E": "\uFE43",
            "\u300F": "\uFE44",
            "\u3010": "\uFE3B",
            "\u3011": "\uFE3C",
            "\u3014": "\uFE39",
            "\u3015": "\uFE3A",
            "\u3016": "\uFE17",
            "\u3017": "\uFE18",
            "\uFF01": "\uFE15",
            "\uFF08": "\uFE35",
            "\uFF09": "\uFE36",
            "\uFF0C": "\uFE10",
            "\uFF0D": "\uFE32",
            "\uFF0E": "\u30FB",
            "\uFF1A": "\uFE13",
            "\uFF1B": "\uFE14",
            "\uFF1C": "\uFE3F",
            "\uFF1E": "\uFE40",
            "\uFF1F": "\uFE16",
            "\uFF3B": "\uFE47",
            "\uFF3D": "\uFE48",
            "\uFF3F": "\uFE33",
            "\uFF5B": "\uFE37",
            "\uFF5C": "\u2015",
            "\uFF5D": "\uFE38",
            "\uFF5F": "\uFE35",
            "\uFF60": "\uFE36",
            "\uFF61": "\uFE12",
            "\uFF62": "\uFE41",
            "\uFF63": "\uFE42",
            "\u2190": "\u2191",
            "\u2192": "\u2193"
        };
        function Pg(e1) {
            return "\uFE36" === e1 || "\uFE48" === e1 || "\uFE38" === e1 || "\uFE44" === e1 || "\uFE42" === e1 || "\uFE3E" === e1 || "\uFE3C" === e1 || "\uFE3A" === e1 || "\uFE18" === e1 || "\uFE40" === e1 || "\uFE10" === e1 || "\uFE13" === e1 || "\uFE14" === e1 || "\uFF40" === e1 || "\uFFE3" === e1 || "\uFE11" === e1 || "\uFE12" === e1;
        }
        function Tg(e1) {
            return "\uFE35" === e1 || "\uFE47" === e1 || "\uFE37" === e1 || "\uFE43" === e1 || "\uFE41" === e1 || "\uFE3D" === e1 || "\uFE3B" === e1 || "\uFE39" === e1 || "\uFE17" === e1 || "\uFE3F" === e1;
        }
        const zg = 4294967296, kg = 1 / zg, Vg = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf-8");
        let Fg = class {
            constructor(e1 = new Uint8Array(16)){
                this.buf = ArrayBuffer.isView(e1) ? e1 : new Uint8Array(e1), this.dataView = new DataView(this.buf.buffer), this.pos = 0, this.type = 0, this.length = this.buf.length;
            }
            readFields(e1, t1, r = this.length) {
                for(; this.pos < r;){
                    const r = this.readVarint(), n = r >> 3, i = this.pos;
                    this.type = 7 & r, e1(n, t1, this), this.pos === i && this.skip(r);
                }
                return t1;
            }
            readMessage(e1, t1) {
                return this.readFields(e1, t1, this.readVarint() + this.pos);
            }
            readFixed32() {
                const e1 = this.dataView.getUint32(this.pos, !0);
                return this.pos += 4, e1;
            }
            readSFixed32() {
                const e1 = this.dataView.getInt32(this.pos, !0);
                return this.pos += 4, e1;
            }
            readFixed64() {
                const e1 = this.dataView.getUint32(this.pos, !0) + this.dataView.getUint32(this.pos + 4, !0) * zg;
                return this.pos += 8, e1;
            }
            readSFixed64() {
                const e1 = this.dataView.getUint32(this.pos, !0) + this.dataView.getInt32(this.pos + 4, !0) * zg;
                return this.pos += 8, e1;
            }
            readFloat() {
                const e1 = this.dataView.getFloat32(this.pos, !0);
                return this.pos += 4, e1;
            }
            readDouble() {
                const e1 = this.dataView.getFloat64(this.pos, !0);
                return this.pos += 8, e1;
            }
            readVarint(e1) {
                const t1 = this.buf;
                let r, n;
                return n = t1[this.pos++], r = 127 & n, n < 128 ? r : (n = t1[this.pos++], r |= (127 & n) << 7, n < 128 ? r : (n = t1[this.pos++], r |= (127 & n) << 14, n < 128 ? r : (n = t1[this.pos++], r |= (127 & n) << 21, n < 128 ? r : (n = t1[this.pos], r |= (15 & n) << 28, function(e1, t1, r) {
                    const n = r.buf;
                    let i, s;
                    if (s = n[r.pos++], i = (112 & s) >> 4, s < 128) return Dg(e1, i, t1);
                    if (s = n[r.pos++], i |= (127 & s) << 3, s < 128) return Dg(e1, i, t1);
                    if (s = n[r.pos++], i |= (127 & s) << 10, s < 128) return Dg(e1, i, t1);
                    if (s = n[r.pos++], i |= (127 & s) << 17, s < 128) return Dg(e1, i, t1);
                    if (s = n[r.pos++], i |= (127 & s) << 24, s < 128) return Dg(e1, i, t1);
                    if (s = n[r.pos++], i |= (1 & s) << 31, s < 128) return Dg(e1, i, t1);
                    throw new Error("Expected varint not more than 10 bytes");
                }(r, e1, this)))));
            }
            readVarint64() {
                return this.readVarint(!0);
            }
            readSVarint() {
                const e1 = this.readVarint();
                return e1 % 2 == 1 ? (e1 + 1) / -2 : e1 / 2;
            }
            readBoolean() {
                return Boolean(this.readVarint());
            }
            readString() {
                const e1 = this.readVarint() + this.pos, t1 = this.pos;
                return this.pos = e1, e1 - t1 >= 12 && Vg ? Vg.decode(this.buf.subarray(t1, e1)) : function(e1, t1, r) {
                    let n = "", i = t1;
                    for(; i < r;){
                        const t1 = e1[i];
                        let s, a, o, l = null, u = t1 > 239 ? 4 : t1 > 223 ? 3 : t1 > 191 ? 2 : 1;
                        if (i + u > r) break;
                        1 === u ? t1 < 128 && (l = t1) : 2 === u ? (s = e1[i + 1], 128 == (192 & s) && (l = (31 & t1) << 6 | 63 & s, l <= 127 && (l = null))) : 3 === u ? (s = e1[i + 1], a = e1[i + 2], 128 == (192 & s) && 128 == (192 & a) && (l = (15 & t1) << 12 | (63 & s) << 6 | 63 & a, (l <= 2047 || l >= 55296 && l <= 57343) && (l = null))) : 4 === u && (s = e1[i + 1], a = e1[i + 2], o = e1[i + 3], 128 == (192 & s) && 128 == (192 & a) && 128 == (192 & o) && (l = (15 & t1) << 18 | (63 & s) << 12 | (63 & a) << 6 | 63 & o, (l <= 65535 || l >= 1114112) && (l = null))), null === l ? (l = 65533, u = 1) : l > 65535 && (l -= 65536, n += String.fromCharCode(l >>> 10 & 1023 | 55296), l = 56320 | 1023 & l), n += String.fromCharCode(l), i += u;
                    }
                    return n;
                }(this.buf, t1, e1);
            }
            readBytes() {
                const e1 = this.readVarint() + this.pos, t1 = this.buf.subarray(this.pos, e1);
                return this.pos = e1, t1;
            }
            readPackedVarint(e1 = [], t1) {
                const r = this.readPackedEnd();
                for(; this.pos < r;)e1.push(this.readVarint(t1));
                return e1;
            }
            readPackedSVarint(e1 = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e1.push(this.readSVarint());
                return e1;
            }
            readPackedBoolean(e1 = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e1.push(this.readBoolean());
                return e1;
            }
            readPackedFloat(e1 = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e1.push(this.readFloat());
                return e1;
            }
            readPackedDouble(e1 = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e1.push(this.readDouble());
                return e1;
            }
            readPackedFixed32(e1 = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e1.push(this.readFixed32());
                return e1;
            }
            readPackedSFixed32(e1 = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e1.push(this.readSFixed32());
                return e1;
            }
            readPackedFixed64(e1 = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e1.push(this.readFixed64());
                return e1;
            }
            readPackedSFixed64(e1 = []) {
                const t1 = this.readPackedEnd();
                for(; this.pos < t1;)e1.push(this.readSFixed64());
                return e1;
            }
            readPackedEnd() {
                return 2 === this.type ? this.readVarint() + this.pos : this.pos + 1;
            }
            skip(e1) {
                const t1 = 7 & e1;
                if (0 === t1) for(; this.buf[this.pos++] > 127;);
                else if (2 === t1) this.pos = this.readVarint() + this.pos;
                else if (5 === t1) this.pos += 4;
                else {
                    if (1 !== t1) throw new Error(`Unimplemented type: ${t1}`);
                    this.pos += 8;
                }
            }
            writeTag(e1, t1) {
                this.writeVarint(e1 << 3 | t1);
            }
            realloc(e1) {
                let t1 = this.length || 16;
                for(; t1 < this.pos + e1;)t1 *= 2;
                if (t1 !== this.length) {
                    const e1 = new Uint8Array(t1);
                    e1.set(this.buf), this.buf = e1, this.dataView = new DataView(e1.buffer), this.length = t1;
                }
            }
            finish() {
                return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
            }
            writeFixed32(e1) {
                this.realloc(4), this.dataView.setInt32(this.pos, e1, !0), this.pos += 4;
            }
            writeSFixed32(e1) {
                this.realloc(4), this.dataView.setInt32(this.pos, e1, !0), this.pos += 4;
            }
            writeFixed64(e1) {
                this.realloc(8), this.dataView.setInt32(this.pos, -1 & e1, !0), this.dataView.setInt32(this.pos + 4, Math.floor(e1 * kg), !0), this.pos += 8;
            }
            writeSFixed64(e1) {
                this.realloc(8), this.dataView.setInt32(this.pos, -1 & e1, !0), this.dataView.setInt32(this.pos + 4, Math.floor(e1 * kg), !0), this.pos += 8;
            }
            writeVarint(e1) {
                (e1 = +e1 || 0) > 268435455 || e1 < 0 ? function(e1, t1) {
                    let r, n;
                    if (e1 >= 0 ? (r = e1 % 4294967296 | 0, n = e1 / 4294967296 | 0) : (r = ~(-e1 % 4294967296), n = ~(-e1 / 4294967296), 4294967295 ^ r ? r = r + 1 | 0 : (r = 0, n = n + 1 | 0)), e1 >= 0x10000000000000000 || e1 < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                    t1.realloc(10), function(e1, t1, r) {
                        r.buf[r.pos++] = 127 & e1 | 128, e1 >>>= 7, r.buf[r.pos++] = 127 & e1 | 128, e1 >>>= 7, r.buf[r.pos++] = 127 & e1 | 128, e1 >>>= 7, r.buf[r.pos++] = 127 & e1 | 128, r.buf[r.pos] = 127 & (e1 >>>= 7);
                    }(r, 0, t1), function(e1, t1) {
                        const r = (7 & e1) << 4;
                        t1.buf[t1.pos++] |= r | ((e1 >>>= 3) ? 128 : 0), e1 && (t1.buf[t1.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), e1 && (t1.buf[t1.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), e1 && (t1.buf[t1.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), e1 && (t1.buf[t1.pos++] = 127 & e1 | ((e1 >>>= 7) ? 128 : 0), e1 && (t1.buf[t1.pos++] = 127 & e1)))));
                    }(n, t1);
                }(e1, this) : (this.realloc(4), this.buf[this.pos++] = 127 & e1 | (e1 > 127 ? 128 : 0), e1 <= 127 || (this.buf[this.pos++] = 127 & (e1 >>>= 7) | (e1 > 127 ? 128 : 0), e1 <= 127 || (this.buf[this.pos++] = 127 & (e1 >>>= 7) | (e1 > 127 ? 128 : 0), e1 <= 127 || (this.buf[this.pos++] = e1 >>> 7 & 127))));
            }
            writeSVarint(e1) {
                this.writeVarint(e1 < 0 ? 2 * -e1 - 1 : 2 * e1);
            }
            writeBoolean(e1) {
                this.writeVarint(+e1);
            }
            writeString(e1) {
                e1 = String(e1), this.realloc(4 * e1.length), this.pos++;
                const t1 = this.pos;
                this.pos = function(e1, t1, r) {
                    for(let n, i, s = 0; s < t1.length; s++){
                        if (n = t1.charCodeAt(s), n > 55295 && n < 57344) {
                            if (!i) {
                                n > 56319 || s + 1 === t1.length ? (e1[r++] = 239, e1[r++] = 191, e1[r++] = 189) : i = n;
                                continue;
                            }
                            if (n < 56320) {
                                e1[r++] = 239, e1[r++] = 191, e1[r++] = 189, i = n;
                                continue;
                            }
                            n = i - 55296 << 10 | n - 56320 | 65536, i = null;
                        } else i && (e1[r++] = 239, e1[r++] = 191, e1[r++] = 189, i = null);
                        n < 128 ? e1[r++] = n : (n < 2048 ? e1[r++] = n >> 6 | 192 : (n < 65536 ? e1[r++] = n >> 12 | 224 : (e1[r++] = n >> 18 | 240, e1[r++] = n >> 12 & 63 | 128), e1[r++] = n >> 6 & 63 | 128), e1[r++] = 63 & n | 128);
                    }
                    return r;
                }(this.buf, e1, this.pos);
                const r = this.pos - t1;
                r >= 128 && Eg(t1, r, this), this.pos = t1 - 1, this.writeVarint(r), this.pos += r;
            }
            writeFloat(e1) {
                this.realloc(4), this.dataView.setFloat32(this.pos, e1, !0), this.pos += 4;
            }
            writeDouble(e1) {
                this.realloc(8), this.dataView.setFloat64(this.pos, e1, !0), this.pos += 8;
            }
            writeBytes(e1) {
                const t1 = e1.length;
                this.writeVarint(t1), this.realloc(t1);
                for(let r = 0; r < t1; r++)this.buf[this.pos++] = e1[r];
            }
            writeRawMessage(e1, t1) {
                this.pos++;
                const r = this.pos;
                e1(t1, this);
                const n = this.pos - r;
                n >= 128 && Eg(r, n, this), this.pos = r - 1, this.writeVarint(n), this.pos += n;
            }
            writeMessage(e1, t1, r) {
                this.writeTag(e1, 2), this.writeRawMessage(t1, r);
            }
            writePackedVarint(e1, t1) {
                t1.length && this.writeMessage(e1, Cg, t1);
            }
            writePackedSVarint(e1, t1) {
                t1.length && this.writeMessage(e1, Rg, t1);
            }
            writePackedBoolean(e1, t1) {
                t1.length && this.writeMessage(e1, Ug, t1);
            }
            writePackedFloat(e1, t1) {
                t1.length && this.writeMessage(e1, Lg, t1);
            }
            writePackedDouble(e1, t1) {
                t1.length && this.writeMessage(e1, Og, t1);
            }
            writePackedFixed32(e1, t1) {
                t1.length && this.writeMessage(e1, Ng, t1);
            }
            writePackedSFixed32(e1, t1) {
                t1.length && this.writeMessage(e1, jg, t1);
            }
            writePackedFixed64(e1, t1) {
                t1.length && this.writeMessage(e1, Gg, t1);
            }
            writePackedSFixed64(e1, t1) {
                t1.length && this.writeMessage(e1, $g, t1);
            }
            writeBytesField(e1, t1) {
                this.writeTag(e1, 2), this.writeBytes(t1);
            }
            writeFixed32Field(e1, t1) {
                this.writeTag(e1, 5), this.writeFixed32(t1);
            }
            writeSFixed32Field(e1, t1) {
                this.writeTag(e1, 5), this.writeSFixed32(t1);
            }
            writeFixed64Field(e1, t1) {
                this.writeTag(e1, 1), this.writeFixed64(t1);
            }
            writeSFixed64Field(e1, t1) {
                this.writeTag(e1, 1), this.writeSFixed64(t1);
            }
            writeVarintField(e1, t1) {
                this.writeTag(e1, 0), this.writeVarint(t1);
            }
            writeSVarintField(e1, t1) {
                this.writeTag(e1, 0), this.writeSVarint(t1);
            }
            writeStringField(e1, t1) {
                this.writeTag(e1, 2), this.writeString(t1);
            }
            writeFloatField(e1, t1) {
                this.writeTag(e1, 5), this.writeFloat(t1);
            }
            writeDoubleField(e1, t1) {
                this.writeTag(e1, 1), this.writeDouble(t1);
            }
            writeBooleanField(e1, t1) {
                this.writeVarintField(e1, +t1);
            }
        };
        function Dg(e1, t1, r) {
            return r ? 4294967296 * t1 + (e1 >>> 0) : 4294967296 * (t1 >>> 0) + (e1 >>> 0);
        }
        function Eg(e1, t1, r) {
            const n = t1 <= 16383 ? 1 : t1 <= 2097151 ? 2 : t1 <= 268435455 ? 3 : Math.floor(Math.log(t1) / (7 * Math.LN2));
            r.realloc(n);
            for(let t1 = r.pos - 1; t1 >= e1; t1--)r.buf[t1 + n] = r.buf[t1];
        }
        function Cg(e1, t1) {
            for(let r = 0; r < e1.length; r++)t1.writeVarint(e1[r]);
        }
        function Rg(e1, t1) {
            for(let r = 0; r < e1.length; r++)t1.writeSVarint(e1[r]);
        }
        function Lg(e1, t1) {
            for(let r = 0; r < e1.length; r++)t1.writeFloat(e1[r]);
        }
        function Og(e1, t1) {
            for(let r = 0; r < e1.length; r++)t1.writeDouble(e1[r]);
        }
        function Ug(e1, t1) {
            for(let r = 0; r < e1.length; r++)t1.writeBoolean(e1[r]);
        }
        function Ng(e1, t1) {
            for(let r = 0; r < e1.length; r++)t1.writeFixed32(e1[r]);
        }
        function jg(e1, t1) {
            for(let r = 0; r < e1.length; r++)t1.writeSFixed32(e1[r]);
        }
        function Gg(e1, t1) {
            for(let r = 0; r < e1.length; r++)t1.writeFixed64(e1[r]);
        }
        function $g(e1, t1) {
            for(let r = 0; r < e1.length; r++)t1.writeSFixed64(e1[r]);
        }
        function qg(e1, t1, r) {
            t1.glyphs = [], 1 === e1 && r.readMessage(Hg, t1);
        }
        function Hg(e1, t1, r) {
            if (3 === e1) {
                const { id: e1, bitmap: n, width: i, height: s, left: a, top: o, advance: l } = r.readMessage(Xg, {});
                t1.glyphs.push({
                    id: e1,
                    bitmap: new Qh({
                        width: i + 6,
                        height: s + 6
                    }, n),
                    metrics: {
                        width: i,
                        height: s,
                        left: a,
                        top: o,
                        advance: l
                    }
                });
            } else 4 === e1 ? t1.ascender = r.readSVarint() : 5 === e1 && (t1.descender = r.readSVarint());
        }
        function Xg(e1, t1, r) {
            1 === e1 ? t1.id = r.readVarint() : 2 === e1 ? t1.bitmap = r.readBytes() : 3 === e1 ? t1.width = r.readVarint() : 4 === e1 ? t1.height = r.readVarint() : 5 === e1 ? t1.left = r.readSVarint() : 6 === e1 ? t1.top = r.readSVarint() : 7 === e1 && (t1.advance = r.readVarint());
        }
        const Zg = {
            horizontal: 1,
            vertical: 2,
            horizontalOnly: 3
        };
        class Wg {
            constructor(){
                this.scale = 1, this.fontStack = "", this.image = null;
            }
            static forText(e1, t1) {
                const r = new Wg;
                return r.scale = e1 || 1, r.fontStack = t1, r;
            }
            static forImage(e1) {
                const t1 = new Wg;
                return t1.image = e1, t1;
            }
        }
        class Yg {
            constructor(){
                this.text = "", this.sectionIndex = [], this.sections = [], this.imageSectionID = null;
            }
            static fromFeature(e1, t1, r, n = 1) {
                const i = new Yg;
                for(let s = 0; s < e1.sections.length; s++){
                    const a = e1.sections[s];
                    a.image ? i.addImageSection(a, r, n) : i.addTextSection(a, t1);
                }
                return i;
            }
            length() {
                return this.text.length;
            }
            getSection(e1) {
                return this.sections[this.sectionIndex[e1]];
            }
            getSections() {
                return this.sections;
            }
            getSectionIndex(e1) {
                return this.sectionIndex[e1];
            }
            getCodePoint(e1) {
                return this.text.codePointAt(e1);
            }
            verticalizePunctuation(e1) {
                this.text = function(e1, t1) {
                    let r = "";
                    for(let n = 0; n < e1.length; n++){
                        const i = e1.charCodeAt(n + 1) || null, s = e1.charCodeAt(n - 1) || null;
                        r += !t1 && (i && Oa(i) && !Sg[e1[n + 1]] || s && Oa(s) && !Sg[e1[n - 1]]) || !Sg[e1[n]] ? e1[n] : Sg[e1[n]];
                    }
                    return r;
                }(this.text, e1);
            }
            trim() {
                let e1 = 0;
                for(let t1 = 0; t1 < this.text.length && Kg[this.text.charCodeAt(t1)]; t1++)e1++;
                let t1 = this.text.length;
                for(let r = this.text.length - 1; r >= 0 && r >= e1 && Kg[this.text.charCodeAt(r)]; r--)t1--;
                this.text = this.text.substring(e1, t1), this.sectionIndex = this.sectionIndex.slice(e1, t1);
            }
            substring(e1, t1) {
                const r = new Yg;
                return r.text = this.text.substring(e1, t1), r.sectionIndex = this.sectionIndex.slice(e1, t1), r.sections = this.sections, r;
            }
            toString() {
                return this.text;
            }
            getMaxScale() {
                return this.sectionIndex.reduce((e1, t1)=>Math.max(e1, this.sections[t1].scale), 0);
            }
            addTextSection(e1, t1) {
                this.text += e1.text, this.sections.push(Wg.forText(e1.scale, e1.fontStack || t1));
                const r = this.sections.length - 1;
                for(let t1 = 0; t1 < e1.text.length; ++t1)this.sectionIndex.push(r);
            }
            addImageSection(e1, t1, r = 1) {
                const n = e1.image ? e1.image.getPrimary() : null;
                if (!n) return void Ze("Can't add FormattedSection with an empty image.");
                n.scaleSelf(t1 * r);
                const i = this.getNextImageSectionCharCode();
                i ? (this.text += String.fromCodePoint(i), this.sections.push(Wg.forImage(n)), this.sectionIndex.push(this.sections.length - 1)) : Ze("Reached maximum number of images 6401");
            }
            getNextImageSectionCharCode() {
                return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
            }
        }
        function Jg(e1, t1, r, n, i, s, a, o, l, u, c, h, d, p, f, m = 1, y = 1) {
            const g = Yg.fromFeature(e1, i, m, y);
            h === Zg.vertical && g.verticalizePunctuation(d);
            let x = [];
            const v = function(e1, t1, r, n, i, s, a = 1) {
                if (!e1) return [];
                const o = [], l = function(e1, t1, r, n, i, s, a = 1) {
                    let o = 0;
                    for(let r = 0; r < e1.length(); r++){
                        const l = e1.getSection(r);
                        o += ex(e1.getCodePoint(r), l, n, i, t1, s, a);
                    }
                    return o / Math.max(1, Math.ceil(o / r));
                }(e1, t1, r, n, i, s, a), u = e1.text.indexOf("\u200B") >= 0;
                let c = 0;
                for(let r = 0; r < e1.length(); r++){
                    const h = e1.getSection(r), d = e1.getCodePoint(r);
                    if (Kg[d] || (c += ex(d, h, n, i, t1, s, a)), r < e1.length() - 1) {
                        const t1 = Ca(d);
                        (Qg[d] || t1 || h.image) && o.push(nx(r + 1, c, l, o, rx(d, e1.getCodePoint(r + 1), t1 && u), !1));
                    }
                }
                return ix(nx(e1.length(), c, l, o, 0, !0));
            }(g, u, s, t1, n, p, y), { processBidirectionalText: b, processStyledBidirectionalText: w } = Qa;
            if (b && 1 === g.sections.length) {
                const e1 = b(g.toString(), v);
                for (const t1 of e1){
                    const e1 = new Yg;
                    e1.text = t1, e1.sections = g.sections;
                    for(let r = 0; r < t1.length; r++)e1.sectionIndex.push(0);
                    x.push(e1);
                }
            } else if (w) {
                const e1 = w(g.text, g.sectionIndex, v);
                for (const t1 of e1){
                    const e1 = new Yg;
                    e1.text = t1[0], e1.sectionIndex = t1[1], e1.sections = g.sections, x.push(e1);
                }
            } else x = function(e1, t1) {
                const r = [], n = e1.text;
                let i = 0;
                for (const n of t1)r.push(e1.substring(i, n)), i = n;
                return i < n.length && r.push(e1.substring(i, n.length)), r;
            }(g, v);
            const _ = [], A = {
                positionedLines: _,
                text: g.toString(),
                top: c[1],
                bottom: c[1],
                left: c[0],
                right: c[0],
                writingMode: h,
                iconsInText: !1,
                verticalizable: !1,
                hasBaseline: !1
            };
            if (function(e1, t1, r, n, i, s, a, o, l, u, c, h, d = 1) {
                let p = 0, f = 0, m = 0;
                const y = "right" === o ? 1 : "left" === o ? 0 : .5;
                let g = !1;
                for (const e1 of i){
                    const r = e1.getSections();
                    for (const e1 of r){
                        if (e1.image) continue;
                        const r = t1[e1.fontStack];
                        if (r && (g = void 0 !== r.ascender && void 0 !== r.descender, !g)) break;
                    }
                    if (!g) break;
                }
                let x = 0;
                for (const a of i){
                    a.trim();
                    const i = a.getMaxScale(), o = (i - 1) * Mg, v = {
                        positionedGlyphs: [],
                        lineOffset: 0
                    };
                    e1.positionedLines[x] = v;
                    const b = v.positionedGlyphs;
                    let w = 0;
                    if (!a.length()) {
                        f += s, ++x;
                        continue;
                    }
                    let _ = 0, A = 0;
                    for(let s = 0; s < a.length(); s++){
                        const o = a.getSection(s), m = a.getSectionIndex(s), y = a.getCodePoint(s);
                        let x = o.scale, v = null, I = null, M = null, B = Mg, S = 0, P = l;
                        P === Zg.vertical && La(y) && (P = Zg.horizontal);
                        const T = !(P === Zg.horizontal || !c && !Ra(y) || c && (Kg[y] || Ua(y)));
                        if (o.image) {
                            const t1 = n.get(o.image.toString());
                            if (!t1) continue;
                            M = o.image, e1.iconsInText = e1.iconsInText || !0, I = t1.paddedRect;
                            const r = t1.displaySize, s = r[0] * d, a = r[1] * d;
                            x = x * Mg / h, v = {
                                width: s,
                                height: a,
                                left: 0,
                                top: -3,
                                advance: T ? a : s,
                                localGlyph: !1
                            }, S = g ? -v.height * x : i * Mg - 17 - a * x, B = v.advance;
                            const l = (T ? s : a) * x - Mg * i;
                            l > 0 && l > w && (w = l);
                        } else {
                            const e1 = r[o.fontStack];
                            if (!e1) continue;
                            e1[y] && (I = e1[y]);
                            const n = t1[o.fontStack];
                            if (!n) continue;
                            const s = n.glyphs[y];
                            if (!s) continue;
                            if (v = s.metrics, B = 8203 !== y ? Mg : 0, g) {
                                const e1 = void 0 !== n.ascender ? Math.abs(n.ascender) : 0, t1 = void 0 !== n.descender ? Math.abs(n.descender) : 0, r = (e1 + t1) * x;
                                _ < r && (_ = r, A = (e1 - t1) / 2 * x), S = -e1 * x;
                            } else S = (i - x) * Mg - 17;
                        }
                        T ? (e1.verticalizable = !0, b.push({
                            glyph: y,
                            image: M,
                            x: p,
                            y: f + S,
                            vertical: T,
                            scale: x,
                            localGlyph: v.localGlyph,
                            fontStack: o.fontStack,
                            sectionIndex: m,
                            metrics: v,
                            rect: I
                        }), p += B * x + u) : (b.push({
                            glyph: y,
                            image: M,
                            x: p,
                            y: f + S,
                            vertical: T,
                            scale: x,
                            localGlyph: v.localGlyph,
                            fontStack: o.fontStack,
                            sectionIndex: m,
                            metrics: v,
                            rect: I
                        }), p += v.advance * x + u);
                    }
                    0 !== b.length && (m = Math.max(p - u, m), g ? ax(b, y, w, A, s * i / 2) : ax(b, y, w, 0, s / 2)), p = 0;
                    const I = s * i + w;
                    v.lineOffset = Math.max(w, o), f += I, ++x;
                }
                const v = f, { horizontalAlign: b, verticalAlign: w } = sx(a);
                (function(e1, t1, r, n, i, s) {
                    const a = (t1 - r) * i, o = -s * n;
                    for (const t1 of e1)for (const e1 of t1.positionedGlyphs)e1.x += a, e1.y += o;
                })(e1.positionedLines, y, b, w, m, v), e1.top += -w * v, e1.bottom = e1.top + v, e1.left += -b * m, e1.right = e1.left + m, e1.hasBaseline = g;
            }(A, t1, r, n, x, a, o, l, h, u, d, f, y), !function(e1) {
                for (const t1 of e1)if (0 !== t1.positionedGlyphs.length) return !1;
                return !0;
            }(_)) return A;
        }
        const Kg = {
            9: !0,
            10: !0,
            11: !0,
            12: !0,
            13: !0,
            32: !0
        }, Qg = {
            10: !0,
            32: !0,
            38: !0,
            40: !0,
            41: !0,
            43: !0,
            45: !0,
            47: !0,
            173: !0,
            183: !0,
            8203: !0,
            8208: !0,
            8211: !0,
            8231: !0
        };
        function ex(e1, t1, r, n, i, s, a = 1) {
            if (t1.image) {
                const e1 = n.get(t1.image.toString());
                return e1 ? e1.displaySize[0] * a * t1.scale * Mg / s + i : 0;
            }
            {
                const n = r[t1.fontStack], s = n && n.glyphs[e1];
                return s ? s.metrics.advance * t1.scale + i : 0;
            }
        }
        function tx(e1, t1, r, n) {
            const i = Math.pow(e1 - t1, 2);
            return n ? e1 < t1 ? i / 2 : 2 * i : i + Math.abs(r) * r;
        }
        function rx(e1, t1, r) {
            let n = 0;
            return 10 === e1 && (n -= 1e4), r && (n += 150), 40 !== e1 && 65288 !== e1 || (n += 50), 41 !== t1 && 65289 !== t1 || (n += 50), n;
        }
        function nx(e1, t1, r, n, i, s) {
            let a = null, o = tx(t1, r, i, s);
            for (const e1 of n){
                const n = tx(t1 - e1.x, r, i, s) + e1.badness;
                n <= o && (a = e1, o = n);
            }
            return {
                index: e1,
                x: t1,
                priorBreak: a,
                badness: o
            };
        }
        function ix(e1) {
            return e1 ? ix(e1.priorBreak).concat(e1.index) : [];
        }
        function sx(e1) {
            let t1 = .5, r = .5;
            switch(e1){
                case "right":
                case "top-right":
                case "bottom-right":
                    t1 = 1;
                    break;
                case "left":
                case "top-left":
                case "bottom-left":
                    t1 = 0;
            }
            switch(e1){
                case "bottom":
                case "bottom-right":
                case "bottom-left":
                    r = 1;
                    break;
                case "top":
                case "top-right":
                case "top-left":
                    r = 0;
            }
            return {
                horizontalAlign: t1,
                verticalAlign: r
            };
        }
        function ax(e1, t1, r, n, i) {
            if (!(t1 || r || n || i)) return;
            const s = e1.length - 1, a = e1[s], o = (a.x + a.metrics.advance * a.scale) * t1;
            for(let t1 = 0; t1 <= s; t1++)e1[t1].x -= o, e1[t1].y += r + n + i;
        }
        function ox(e1) {
            return void 0 !== e1.imagePrimary && void 0 !== e1.top && void 0 !== e1.bottom && void 0 !== e1.left && void 0 !== e1.right;
        }
        function lx(e1, t1, r, n) {
            const { horizontalAlign: i, verticalAlign: s } = sx(n), a = r[0] - e1.displaySize[0] * i, o = r[1] - e1.displaySize[1] * s;
            return {
                imagePrimary: e1,
                imageSecondary: t1,
                top: o,
                bottom: o + e1.displaySize[1],
                left: a,
                right: a + e1.displaySize[0]
            };
        }
        function ux(e1, t1, r, n, i, s) {
            const a = e1.imagePrimary;
            let o;
            if (a.content) {
                const e1 = a.content, t1 = a.pixelRatio || 1;
                o = [
                    e1[0] / t1,
                    e1[1] / t1,
                    a.displaySize[0] - e1[2] / t1,
                    a.displaySize[1] - e1[3] / t1
                ];
            }
            const l = t1.left * s, u = t1.right * s;
            let c, h, d, p;
            "width" === r || "both" === r ? (p = i[0] + l - n[3], h = i[0] + u + n[1]) : (p = i[0] + (l + u - a.displaySize[0]) / 2, h = p + a.displaySize[0]);
            const f = t1.top * s, m = t1.bottom * s;
            return "height" === r || "both" === r ? (c = i[1] + f - n[0], d = i[1] + m + n[2]) : (c = i[1] + (f + m - a.displaySize[1]) / 2, d = c + a.displaySize[1]), {
                imagePrimary: a,
                imageSecondary: void 0,
                top: c,
                right: h,
                bottom: d,
                left: p,
                collisionPadding: o
            };
        }
        function cx(e1) {
            return !e1.imagePrimary.stretchX;
        }
        function hx(e1) {
            return !e1.imagePrimary.stretchY;
        }
        function dx(e1) {
            return {
                width: e1.right - e1.left,
                height: e1.bottom - e1.top
            };
        }
        const px = 128;
        function fx(e1, t1, r, n) {
            const { expression: i } = t1;
            if ("constant" === i.kind) return {
                kind: "constant",
                layoutSize: i.evaluate(new to(e1 + 1, {
                    worldview: r
                }), void 0, void 0, void 0, n)
            };
            if ("source" === i.kind) return {
                kind: "source"
            };
            {
                const { zoomStops: t1, interpolationType: s } = i;
                let a = 0;
                for(; a < t1.length && t1[a] <= e1;)a++;
                a = Math.max(0, a - 1);
                let o = a;
                for(; o < t1.length && t1[o] < e1 + 1;)o++;
                o = Math.min(t1.length - 1, o);
                const l = t1[a], u = t1[o];
                return "composite" === i.kind ? {
                    kind: "composite",
                    minZoom: l,
                    maxZoom: u,
                    interpolationType: s
                } : {
                    kind: "camera",
                    minZoom: l,
                    maxZoom: u,
                    minSize: i.evaluate(new to(l, {
                        worldview: r
                    }), void 0, void 0, void 0, n),
                    maxSize: i.evaluate(new to(u, {
                        worldview: r
                    }), void 0, void 0, void 0, n),
                    interpolationType: s
                };
            }
        }
        function mx(e1, { uSize: t1, uSizeT: r }, { lowerSize: n, upperSize: i }) {
            return "source" === e1.kind ? n / px : "composite" === e1.kind ? yr(n / px, i / px, r) : t1;
        }
        function yx(e1, t1, r = 1) {
            let n = 0, i = 0;
            if ("constant" === e1.kind) i = e1.layoutSize * r;
            else if ("source" !== e1.kind) {
                const { interpolationType: s, minZoom: a, maxZoom: o } = e1, l = s ? Ee(Yi.interpolationFactor(s, t1, a, o), 0, 1) : 0;
                "camera" === e1.kind ? i = yr(e1.minSize, e1.maxSize, l) * r : n = l * r;
            }
            return {
                uSizeT: n,
                uSize: i
            };
        }
        class gx extends Me {
            constructor(e1, t1, r, n, i){
                super(e1, t1), this.angle = n, this.z = r, void 0 !== i && (this.segment = i);
            }
            clone() {
                return new gx(this.x, this.y, this.z, this.angle, this.segment);
            }
        }
        function xx(e1, t1, r, n, i) {
            if (void 0 === t1.segment) return !0;
            let s = t1, a = t1.segment + 1, o = 0;
            for(; o > -r / 2;){
                if (a--, a < 0) return !1;
                o -= e1[a].dist(s), s = e1[a];
            }
            o += e1[a].dist(e1[a + 1]), a++;
            const l = [];
            let u = 0;
            for(; o < r / 2;){
                const t1 = e1[a], r = e1[a + 1];
                if (!r) return !1;
                let s = e1[a - 1].angleTo(t1) - t1.angleTo(r);
                for(s = Math.abs((s + 3 * Math.PI) % (2 * Math.PI) - Math.PI), l.push({
                    distance: o,
                    angleDelta: s
                }), u += s; o - l[0].distance > n;)u -= l.shift().angleDelta;
                if (u > i) return !1;
                a++, o += t1.dist(r);
            }
            return !0;
        }
        function vx(e1) {
            let t1 = 0;
            for(let r = 0; r < e1.length - 1; r++)t1 += e1[r].dist(e1[r + 1]);
            return t1;
        }
        function bx(e1, t1, r) {
            return e1 ? .6 * t1 * r : 0;
        }
        function wx(e1, t1) {
            return Math.max(e1 ? e1.right - e1.left : 0, t1 ? t1.right - t1.left : 0);
        }
        function _x(e1, t1, r, n, i, s) {
            const a = bx(r, i, s), o = wx(r, n) * s;
            let l = 0;
            const u = vx(e1) / 2;
            for(let r = 0; r < e1.length - 1; r++){
                const n = e1[r], i = e1[r + 1], s = n.dist(i);
                if (l + s > u) {
                    const c = (u - l) / s, h = yr(n.x, i.x, c), d = yr(n.y, i.y, c), p = new gx(h, d, 0, i.angleTo(n), r);
                    return !a || xx(e1, p, o, a, t1) ? p : void 0;
                }
                l += s;
            }
        }
        function Ax(e1, t1, r, n, i, s, a, o, l) {
            const u = bx(n, s, a), c = wx(n, i), h = c * a, d = 0 === e1[0].x || e1[0].x === l || 0 === e1[0].y || e1[0].y === l;
            return t1 - h < t1 / 4 && (t1 = h + t1 / 4), Ix(e1, d ? t1 / 2 * o % t1 : (c / 2 + 2 * s) * a * o % t1, t1, u, r, h, d, !1, l);
        }
        function Ix(e1, t1, r, n, i, s, a, o, l) {
            const u = s / 2, c = vx(e1);
            let h = 0, d = t1 - r, p = [];
            for(let t1 = 0; t1 < e1.length - 1; t1++){
                const a = e1[t1], o = e1[t1 + 1], f = a.dist(o), m = o.angleTo(a);
                for(; d + r < h + f;){
                    d += r;
                    const y = (d - h) / f, g = yr(a.x, o.x, y), x = yr(a.y, o.y, y);
                    if (g >= 0 && g < l && x >= 0 && x < l && d - u >= 0 && d + u <= c) {
                        const r = new gx(g, x, 0, m, t1);
                        n && !xx(e1, r, s, n, i) || p.push(r);
                    }
                }
                h += f;
            }
            return o || p.length || a || (p = Ix(e1, h / 2, r, n, i, s, a, !0, l)), p;
        }
        function Mx(e1) {
            let t1 = 0, r = 0;
            for (const n of e1)t1 += n.w * n.h, r = Math.max(r, n.w);
            e1.sort((e1, t1)=>t1.h - e1.h);
            const n = [
                {
                    x: 0,
                    y: 0,
                    w: Math.max(Math.ceil(Math.sqrt(t1 / .95)), r),
                    h: 1 / 0
                }
            ];
            let i = 0, s = 0;
            for (const t1 of e1)for(let e1 = n.length - 1; e1 >= 0; e1--){
                const r = n[e1];
                if (!(t1.w > r.w || t1.h > r.h)) {
                    if (t1.x = r.x, t1.y = r.y, s = Math.max(s, t1.y + t1.h), i = Math.max(i, t1.x + t1.w), t1.w === r.w && t1.h === r.h) {
                        const t1 = n.pop();
                        t1 && e1 < n.length && (n[e1] = t1);
                    } else t1.h === r.h ? (r.x += t1.w, r.w -= t1.w) : t1.w === r.w ? (r.y += t1.h, r.h -= t1.h) : (n.push({
                        x: r.x + t1.w,
                        y: r.y,
                        w: r.w - t1.w,
                        h: t1.h
                    }), r.y += t1.h, r.h -= t1.h);
                    break;
                }
            }
            return {
                w: i,
                h: s,
                fill: t1 / (i * s) || 0
            };
        }
        function Bx(e1, t1) {
            return e1.id < t1.id ? -1 : e1.id > t1.id ? 1 : e1.version < t1.version ? -1 : e1.version > t1.version ? 1 : e1.sx < t1.sx ? -1 : e1.sx > t1.sx ? 1 : e1.sy < t1.sy ? -1 : e1.sy > t1.sy ? 1 : 0;
        }
        function Sx(e1) {
            let t1 = 0;
            for(let r = 0; r < e1.length; r++)t1 = (t1 << 5) - t1 + e1.charCodeAt(r), t1 &= t1;
            return t1;
        }
        function Px(e1, t1) {
            return (e1 << 5) - e1 + t1;
        }
        function Tx(e1, t1, r, n) {
            for (const [i] of e1.entries()){
                const e1 = n && n.get(i) || Nr.parse(i), s = e1.id.toString(), a = t1.get(s) || 0;
                r.push({
                    id: i,
                    version: a,
                    sx: e1.sx,
                    sy: e1.sy
                });
            }
        }
        ra(gx, "Anchor");
        class zx {
            constructor(e1, t1, r, n, i){
                this.iconDescriptors = [], this.patternDescriptors = [], this.requiresMipMaps = t1.size > 0, Tx(e1, r, this.iconDescriptors, i), Tx(t1, r, this.patternDescriptors, i), this.iconDescriptors.sort(Bx), this.patternDescriptors.sort(Bx);
                let s = 0;
                const a = n ? n.data : "";
                a && (s = Px(s, Sx(a))), s = Px(s, 1);
                for (const e1 of this.iconDescriptors)s = Px(s, Sx(e1.id)), s = Px(s, e1.version), s = Px(s, e1.sx), s = Px(s, e1.sy);
                s = Px(s, 1);
                for (const e1 of this.patternDescriptors)s = Px(s, Sx(e1.id)), s = Px(s, e1.version), s = Px(s, e1.sx), s = Px(s, e1.sy);
                this.hash = s;
            }
            subsetOf(e1) {
                return this.isSubsetArray(this.iconDescriptors, e1.iconDescriptors, Bx) && this.isSubsetArray(this.patternDescriptors, e1.patternDescriptors, Bx);
            }
            isSubsetArray(e1, t1, r) {
                let n = 0, i = 0;
                if (e1.length > t1.length) return !1;
                for(; n < e1.length && i < t1.length;){
                    const s = r(e1[n], t1[i]);
                    if (0 === s) n++, i++;
                    else {
                        if (s < 0) return !1;
                        i++;
                    }
                }
                return n === e1.length;
            }
        }
        ra(zx, "AtlasContentDescriptor");
        class kx {
            static getImagePositionScale(e1, t1, r) {
                if (t1 && e1) {
                    const { sx: t1, sy: r } = e1;
                    return {
                        x: t1,
                        y: r
                    };
                }
                return {
                    x: r,
                    y: r
                };
            }
            constructor(e1, t1, r, n){
                this.paddedRect = e1;
                const { pixelRatio: i, version: s, stretchX: a, stretchY: o, content: l, sdf: u, usvg: c } = t1;
                this.pixelRatio = i, this.stretchX = a, this.stretchY = o, this.content = l, this.version = s, this.padding = r, this.sdf = u, this.usvg = c, this.scale = kx.getImagePositionScale(n, c, i);
            }
            get tl() {
                return [
                    this.paddedRect.x + this.padding,
                    this.paddedRect.y + this.padding
                ];
            }
            get br() {
                return [
                    this.paddedRect.x + this.paddedRect.w - this.padding,
                    this.paddedRect.y + this.paddedRect.h - this.padding
                ];
            }
            get displaySize() {
                return [
                    (this.paddedRect.w - 2 * this.padding) / this.scale.x,
                    (this.paddedRect.h - 2 * this.padding) / this.scale.y
                ];
            }
        }
        function Vx(e1, t1, r) {
            const n = Nr.parse(e1), i = function(e1, t1, r = [
                1,
                1
            ]) {
                return {
                    x: 0,
                    y: 0,
                    w: (e1.data ? e1.data.width : e1.width * r[0]) + 2 * t1,
                    h: (e1.data ? e1.data.height : e1.height * r[1]) + 2 * t1
                };
            }(t1, r, [
                n.sx,
                n.sy
            ]);
            return {
                bin: i,
                imagePosition: new kx(i, t1, r, n),
                imageVariant: n
            };
        }
        function Fx(e1, t1) {
            const r = [];
            for (const [n, i] of e1.entries()){
                const e1 = Nr.parse(n);
                e1 && (r.push({
                    key: n,
                    value: i,
                    variant: e1
                }), t1 && t1.set(n, e1));
            }
            r.sort((e1, t1)=>{
                const r = e1.variant.id.toString().localeCompare(t1.variant.id.toString());
                return 0 !== r ? r : e1.variant.sx !== t1.variant.sx ? e1.variant.sx - t1.variant.sx : e1.variant.sy !== t1.variant.sy ? e1.variant.sy - t1.variant.sy : 0;
            });
            const n = new Map;
            for (const e1 of r)n.set(e1.key, e1.value);
            return n;
        }
        class Dx {
            constructor(e1){
                this.sourceAtlasHash = e1;
            }
        }
        class Ex {
            constructor(e1, t1, r, n){
                const i = new Map, s = new Map;
                this.haveRenderCallbacks = [];
                const a = [], o = void 0 !== n, l = o ? new Map : void 0, u = o ? Fx(e1, l) : e1, c = o ? Fx(t1, l) : t1;
                this.addImages(u, i, 1, a), this.addImages(c, s, 2, a);
                const { w: h, h: d } = Mx(a), p = new ed({
                    width: h || 1,
                    height: d || 1
                });
                for (const [e1, t1] of u.entries()){
                    const r = i.get(e1).paddedRect;
                    ed.copy(t1.data, p, {
                        x: 0,
                        y: 0
                    }, {
                        x: r.x + 1,
                        y: r.y + 1
                    }, t1.data, null, t1.sdf);
                }
                for (const [e1, t1] of c.entries()){
                    const n = s.get(e1), i = n.paddedRect;
                    let a = n.padding;
                    const o = i.x + a, l = i.y + a, u = t1.data.width, c = t1.data.height;
                    a = a > 1 ? a - 1 : a, ed.copy(t1.data, p, {
                        x: 0,
                        y: 0
                    }, {
                        x: o,
                        y: l
                    }, t1.data, r), ed.copy(t1.data, p, {
                        x: 0,
                        y: c - a
                    }, {
                        x: o,
                        y: l - a
                    }, {
                        width: u,
                        height: a
                    }, r), ed.copy(t1.data, p, {
                        x: 0,
                        y: 0
                    }, {
                        x: o,
                        y: l + c
                    }, {
                        width: u,
                        height: a
                    }, r), ed.copy(t1.data, p, {
                        x: u - a,
                        y: 0
                    }, {
                        x: o - a,
                        y: l
                    }, {
                        width: a,
                        height: c
                    }, r), ed.copy(t1.data, p, {
                        x: 0,
                        y: 0
                    }, {
                        x: o + u,
                        y: l
                    }, {
                        width: a,
                        height: c
                    }, r), ed.copy(t1.data, p, {
                        x: u - a,
                        y: c - a
                    }, {
                        x: o - a,
                        y: l - a
                    }, {
                        width: a,
                        height: a
                    }, r), ed.copy(t1.data, p, {
                        x: 0,
                        y: c - a
                    }, {
                        x: o + u,
                        y: l - a
                    }, {
                        width: a,
                        height: a
                    }, r), ed.copy(t1.data, p, {
                        x: 0,
                        y: 0
                    }, {
                        x: o + u,
                        y: l + c
                    }, {
                        width: a,
                        height: a
                    }, r), ed.copy(t1.data, p, {
                        x: u - a,
                        y: 0
                    }, {
                        x: o - a,
                        y: l + c
                    }, {
                        width: a,
                        height: a
                    }, r);
                }
                this.lut = r, this.image = p, this.iconPositions = i, this.patternPositions = s, o && (this.contentDescriptor = new zx(u, c, n, r, l));
            }
            addImages(e1, t1, r, n) {
                for (const [i, s] of e1.entries()){
                    const { bin: e1, imagePosition: a, imageVariant: o } = Vx(i, s, r);
                    t1.set(i, a), n.push(e1), s.hasRenderCallback && this.haveRenderCallbacks.push(o.id);
                }
            }
            patchUpdatedImages(e1, t1, r, n) {
                this.haveRenderCallbacks = this.haveRenderCallbacks.filter((t1)=>e1.hasImage(t1, r)), e1.dispatchRenderCallbacks(this.haveRenderCallbacks, r);
                for (const i of e1.getUpdatedImages(r)){
                    for (const n of this.iconPositions.keys()){
                        const s = Nr.parse(n);
                        if (lr.isEqual(s.id, i)) {
                            const s = e1.getImage(i, r);
                            this.patchUpdatedImage(this.iconPositions.get(n), s, t1, null);
                        }
                    }
                    for (const s of this.patternPositions.keys()){
                        const a = Nr.parse(s);
                        if (lr.isEqual(a.id, i)) {
                            const a = e1.getImage(i, r);
                            this.patchUpdatedImage(this.patternPositions.get(s), a, t1, n || this.lut);
                        }
                    }
                }
            }
            patchUpdatedImage(e1, t1, r, n = null) {
                if (!e1 || !t1) return;
                if (e1.version === t1.version) return;
                e1.version = t1.version;
                const [i, s] = e1.tl, a = e1.sdf;
                if (this.lut || a) {
                    const e1 = {
                        width: t1.data.width,
                        height: t1.data.height
                    }, o = new ed(e1);
                    ed.copy(t1.data, o, {
                        x: 0,
                        y: 0
                    }, {
                        x: 0,
                        y: 0
                    }, e1, n, a), r.update(o, {
                        position: {
                            x: i,
                            y: s
                        },
                        recreateWhenResize: !1
                    });
                } else r.update(t1.data, {
                    position: {
                        x: i,
                        y: s
                    },
                    recreateWhenResize: !1
                });
            }
        }
        ra(kx, "ImagePosition"), ra(Ex, "ImageAtlas", {
            omit: [
                "lut"
            ]
        }), ra(Dx, "ImageAtlasReference");
        const Cx = 1e20;
        function Rx(e1, t1, r, n, i, s, a, o, l) {
            for(let u = t1; u < t1 + n; u++)Lx(e1, r * s + u, s, i, a, o, l);
            for(let u = r; u < r + i; u++)Lx(e1, u * s + t1, 1, n, a, o, l);
        }
        function Lx(e1, t1, r, n, i, s, a) {
            s[0] = 0, a[0] = -Cx, a[1] = Cx, i[0] = e1[t1];
            for(let o = 1, l = 0, u = 0; o < n; o++){
                i[o] = e1[t1 + o * r];
                const n = o * o;
                do {
                    const e1 = s[l];
                    u = (i[o] - i[e1] + n - e1 * e1) / (o - e1) / 2;
                }while (u <= a[l] && --l > -1);
                l++, s[l] = o, a[l] = u, a[l + 1] = Cx;
            }
            for(let o = 0, l = 0; o < n; o++){
                for(; a[l + 1] < o;)l++;
                const n = s[l], u = o - n;
                e1[t1 + o * r] = i[n] + u * u;
            }
        }
        const Ox = {
            none: 0,
            ideographs: 1,
            all: 2
        };
        class Ux {
            constructor(e1, t1, r){
                this.requestManager = e1, this.localGlyphMode = t1, this.localFontFamily = r, this.url = "", this.entries = {}, this.localGlyphs = {
                    200: {},
                    400: {},
                    500: {},
                    900: {}
                };
            }
            setURL(e1) {
                this.url = e1;
            }
            prefetchRange(e1, t1) {
                const r = this.url || lt.GLYPHS_URL;
                if (!r) return;
                let n = this.entries[e1];
                n || (n = this.entries[e1] = {
                    glyphs: {},
                    requests: {},
                    ranges: {}
                }), n.ranges[t1] || n.requests[t1] || (n.requests[t1] = [], Ux.loadGlyphRange(e1, t1, r, this.requestManager, (e1, r)=>{
                    if (r) {
                        n.ascender = r.ascender, n.descender = r.descender;
                        for(const e1 in r.glyphs)this._doesCharSupportLocalGlyph(+e1) || (n.glyphs[+e1] = r.glyphs[+e1]);
                        n.ranges[t1] = !0;
                    }
                    for (const i of n.requests[t1] || [])i(e1, r);
                    delete n.requests[t1];
                }));
            }
            getGlyphs(e1, t1) {
                const r = [], n = this.url || lt.GLYPHS_URL;
                for(const t1 in e1)for (const n of e1[t1])r.push({
                    stack: t1,
                    id: n
                });
                Le(r, ({ stack: e1, id: t1 }, r)=>{
                    let i = this.entries[e1];
                    i || (i = this.entries[e1] = {
                        glyphs: {},
                        requests: {},
                        ranges: {},
                        ascender: void 0,
                        descender: void 0
                    });
                    let s = i.glyphs[t1];
                    if (void 0 !== s) return void r(null, {
                        stack: e1,
                        id: t1,
                        glyph: s
                    });
                    if (s = this._tinySDF(i, e1, t1), s) return i.glyphs[t1] = s, void r(null, {
                        stack: e1,
                        id: t1,
                        glyph: s
                    });
                    const a = Math.floor(t1 / 256);
                    if (256 * a > 65535) return Ze("glyphs > 65535 not supported"), void r(null, {
                        stack: e1,
                        id: t1,
                        glyph: s
                    });
                    if (i.ranges[a]) return void r(null, {
                        stack: e1,
                        id: t1,
                        glyph: s
                    });
                    let o = i.requests[a];
                    o || (o = i.requests[a] = [], Ux.loadGlyphRange(e1, a, n, this.requestManager, (e1, t1)=>{
                        if (t1) {
                            i.ascender = t1.ascender, i.descender = t1.descender;
                            for(const e1 in t1.glyphs)this._doesCharSupportLocalGlyph(+e1) || (i.glyphs[+e1] = t1.glyphs[+e1]);
                            i.ranges[a] = !0;
                        }
                        for (const r of o)r(e1, t1);
                        delete i.requests[a];
                    })), o.push((n, i)=>{
                        n ? r(n) : i && r(null, {
                            stack: e1,
                            id: t1,
                            glyph: i.glyphs[t1] || null
                        });
                    });
                }, (e1, r)=>{
                    if (e1) t1(e1);
                    else if (r) {
                        const e1 = {};
                        for (const { stack: t1, id: n, glyph: i } of r)void 0 === e1[t1] && (e1[t1] = {}), void 0 === e1[t1].glyphs && (e1[t1].glyphs = {}), e1[t1].glyphs[n] = i && {
                            id: i.id,
                            bitmap: i.bitmap.clone(),
                            metrics: i.metrics
                        }, e1[t1].ascender = this.entries[t1].ascender, e1[t1].descender = this.entries[t1].descender;
                        t1(null, e1);
                    }
                });
            }
            _doesCharSupportLocalGlyph(e1) {
                var t1;
                return this.localGlyphMode !== Ox.none && (this.localGlyphMode === Ox.all ? !!this.localFontFamily : !!this.localFontFamily && (_a(e1) || Ma(e1) || pa(e1) || fa(e1) || da(e1) || wa(e1) || (t1 = e1) >= 131072 && t1 <= 173791 || ((e1)=>e1 >= 66736 && e1 <= 66815)(e1)));
            }
            _tinySDF(e1, t1, r) {
                const n = this.localFontFamily;
                if (!n || !this._doesCharSupportLocalGlyph(r)) return;
                let i = e1.tinySDF;
                if (!i) {
                    let r = "400";
                    /bold/i.test(t1) ? r = "900" : /medium/i.test(t1) ? r = "500" : /light/i.test(t1) && (r = "200"), i = e1.tinySDF = new Ux.TinySDF({
                        fontFamily: n,
                        fontWeight: r,
                        fontSize: 48,
                        buffer: 6,
                        radius: 16
                    }), i.fontWeight = r;
                }
                const s = i.fontWeight;
                if (this.localGlyphs[s][r]) return this.localGlyphs[s][r];
                const a = String.fromCodePoint(r), { data: o, width: l, height: u, glyphWidth: c, glyphHeight: h, glyphLeft: d, glyphTop: p, glyphAdvance: f } = i.draw(a);
                return this.localGlyphs[s][r] = {
                    id: r,
                    bitmap: new Qh({
                        width: l,
                        height: u
                    }, o),
                    metrics: {
                        width: c / 2,
                        height: h / 2,
                        left: d / 2,
                        top: p / 2 - 27,
                        advance: f / 2,
                        localGlyph: !0
                    }
                };
            }
        }
        function Nx(e1, t1) {
            return e1 + t1[1] - t1[0];
        }
        function jx(e1, t1, r, n, i = 1) {
            const s = [], a = e1.imagePrimary, o = a.pixelRatio, l = a.paddedRect.w - 2, u = a.paddedRect.h - 2, c = (e1.right - e1.left) * i, h = (e1.bottom - e1.top) * i, d = a.stretchX || [
                [
                    0,
                    l
                ]
            ], p = a.stretchY || [
                [
                    0,
                    u
                ]
            ], f = d.reduce(Nx, 0), m = p.reduce(Nx, 0), y = l - f, g = u - m;
            let x = 0, v = f, b = 0, w = m, _ = 0, A = y, I = 0, M = g;
            if (a.content && n) {
                const e1 = a.content;
                x = $x(d, 0, e1[0]), b = $x(p, 0, e1[1]), v = $x(d, e1[0], e1[2]), w = $x(p, e1[1], e1[3]), _ = e1[0] - x, I = e1[1] - b, A = e1[2] - e1[0] - v, M = e1[3] - e1[1] - w;
            }
            const B = (n, s, l, u)=>{
                const d = Xx(n.stretch - x, v, c, e1.left * i), p = Zx(n.fixed - _, A, n.stretch, f), y = Xx(s.stretch - b, w, h, e1.top * i), g = Zx(s.fixed - I, M, s.stretch, m), B = Xx(l.stretch - x, v, c, e1.left * i), S = Zx(l.fixed - _, A, l.stretch, f), P = Xx(u.stretch - b, w, h, e1.top * i), T = Zx(u.fixed - I, M, u.stretch, m), z = new Me(d, y), k = new Me(B, y), V = new Me(B, P), F = new Me(d, P), D = new Me(p / o, g / o), E = new Me(S / o, T / o), C = t1 * Math.PI / 180;
                if (C) {
                    const e1 = Math.sin(C), t1 = Math.cos(C), r = [
                        t1,
                        -e1,
                        e1,
                        t1
                    ];
                    z._matMult(r), k._matMult(r), F._matMult(r), V._matMult(r);
                }
                const R = n.stretch + n.fixed, L = l.stretch + l.fixed, O = s.stretch + s.fixed, U = u.stretch + u.fixed, N = e1.imageSecondary;
                return {
                    tl: z,
                    tr: k,
                    bl: F,
                    br: V,
                    texPrimary: {
                        x: a.paddedRect.x + 1 + R,
                        y: a.paddedRect.y + 1 + O,
                        w: L - R,
                        h: U - O
                    },
                    texSecondary: N ? {
                        x: N.paddedRect.x + 1 + R,
                        y: N.paddedRect.y + 1 + O,
                        w: L - R,
                        h: U - O
                    } : void 0,
                    writingMode: void 0,
                    glyphOffset: [
                        0,
                        0
                    ],
                    sectionIndex: 0,
                    pixelOffsetTL: D,
                    pixelOffsetBR: E,
                    minFontScaleX: A / o / c,
                    minFontScaleY: M / o / h,
                    isSDF: r
                };
            };
            if (a.stretchX || a.stretchY) {
                const e1 = qx(d, y, f), t1 = qx(p, g, m);
                for(let r = 0; r < e1.length - 1; r++){
                    const n = e1[r], i = e1[r + 1];
                    for(let e1 = 0; e1 < t1.length - 1; e1++)s.push(B(n, t1[e1], i, t1[e1 + 1]));
                }
            } else s.push(B({
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: -1
            }, {
                fixed: 0,
                stretch: l + 1
            }, {
                fixed: 0,
                stretch: u + 1
            }));
            return s;
        }
        function Gx(e1, t1) {
            const r = e1.stretchY || [
                [
                    0,
                    e1.paddedRect.h - 2
                ]
            ];
            return e1.stretchX || e1.stretchY ? Hx(e1.stretchX || [
                [
                    0,
                    e1.paddedRect.w - 2
                ]
            ]) * Hx(r) : 1;
        }
        function $x(e1, t1, r) {
            let n = 0;
            for (const i of e1)n += Math.max(t1, Math.min(r, i[1])) - Math.max(t1, Math.min(r, i[0]));
            return n;
        }
        function qx(e1, t1, r) {
            const n = [
                {
                    fixed: -1,
                    stretch: 0
                }
            ];
            for (const [t1, r] of e1){
                const e1 = n[n.length - 1];
                n.push({
                    fixed: t1 - e1.stretch,
                    stretch: e1.stretch
                }), n.push({
                    fixed: t1 - e1.stretch,
                    stretch: e1.stretch + (r - t1)
                });
            }
            return n.push({
                fixed: t1 + 1,
                stretch: r
            }), n;
        }
        function Hx(e1) {
            return 2 * e1.length + 1;
        }
        function Xx(e1, t1, r, n) {
            return e1 / t1 * r + n;
        }
        function Zx(e1, t1, r, n) {
            return e1 - t1 * r / n;
        }
        function Wx(e1, t1, r, n) {
            const i = t1 + e1.positionedLines[n].lineOffset;
            return 0 === n ? r + i / 2 : r + (i + (t1 + e1.positionedLines[n - 1].lineOffset)) / 2;
        }
        function Yx(e1, t1, r, n, i, s, a, o, l, u = 1) {
            const c = [];
            if (0 === t1.positionedLines.length) return c;
            const h = (void 0 !== l ? l : n.layout.get("text-rotate").evaluate(s, {})) * Math.PI / 180, d = function(e1) {
                const t1 = e1[0], r = e1[1], n = t1 * r;
                return n > 0 ? [
                    t1,
                    -r
                ] : n < 0 ? [
                    -t1,
                    r
                ] : 0 === t1 ? [
                    r,
                    t1
                ] : [
                    r,
                    -t1
                ];
            }(r);
            let p = Math.abs(t1.top - t1.bottom);
            for (const e1 of t1.positionedLines)p -= e1.lineOffset;
            const f = t1.positionedLines.length, m = p / f;
            let y = t1.top - r[1];
            for(let e1 = 0; e1 < f; ++e1){
                const n = t1.positionedLines[e1];
                y = Wx(t1, m, y, e1);
                for (const e1 of n.positionedGlyphs){
                    if (!e1.rect) continue;
                    const n = e1.rect || {};
                    let s = 4, l = !0, p = 1, f = 0;
                    if (e1.image) {
                        const t1 = a.get(e1.image.toString());
                        if (!t1) continue;
                        if (t1.sdf) {
                            Ze("SDF images are not supported in formatted text and will be ignored.");
                            continue;
                        }
                        l = !1, p = t1.pixelRatio, s = 1 / p, t1.usvg || (p /= u);
                    }
                    const m = (i || o) && e1.vertical, g = e1.metrics.advance * e1.scale / 2, x = e1.metrics, v = e1.rect;
                    if (null === v) continue;
                    o && t1.verticalizable && (f = e1.image ? g - e1.metrics.width * e1.scale / 2 : 0);
                    const b = i ? [
                        e1.x + g,
                        e1.y
                    ] : [
                        0,
                        0
                    ];
                    let w = [
                        0,
                        0
                    ], _ = [
                        0,
                        0
                    ], A = !1;
                    i || (m ? (_ = [
                        e1.x + g + d[0],
                        e1.y + d[1] - f
                    ], A = !0) : w = [
                        e1.x + g + r[0],
                        e1.y + r[1] - f
                    ]);
                    const I = v.w * e1.scale / (p * (e1.localGlyph ? 2 : 1)), M = v.h * e1.scale / (p * (e1.localGlyph ? 2 : 1));
                    let B, S, P, T;
                    if (m) {
                        const t1 = e1.y - y, r = new Me(-g, g - t1), n = -Math.PI / 2, i = new Me(..._);
                        B = new Me(-g + w[0], w[1]), B._rotateAround(n, r)._add(i), B.x += -t1 + g, B.y -= (x.left - s) * e1.scale;
                        const a = e1.image ? x.advance * e1.scale : Mg * e1.scale, o = String.fromCodePoint(e1.glyph);
                        Pg(o) ? B.x += (1 - s) * e1.scale : Tg(o) ? B.x += a - x.height * e1.scale + (-s - 1) * e1.scale : B.x += e1.image || x.width + 2 * s === v.w && x.height + 2 * s === v.h ? (a - M) / 2 : (a - (x.height + 2 * s) * e1.scale) / 2, S = new Me(B.x, B.y - I), P = new Me(B.x + M, B.y), T = new Me(B.x + M, B.y - I);
                    } else {
                        const t1 = (x.left - s) * e1.scale - g + w[0], r = (-x.top - s) * e1.scale + w[1], n = t1 + I, i = r + M;
                        B = new Me(t1, r), S = new Me(n, r), P = new Me(t1, i), T = new Me(n, i);
                    }
                    if (h) {
                        let e1;
                        e1 = i ? new Me(0, 0) : A ? new Me(d[0], d[1]) : new Me(r[0], r[1]), B._rotateAround(h, e1), S._rotateAround(h, e1), P._rotateAround(h, e1), T._rotateAround(h, e1);
                    }
                    const z = new Me(0, 0), k = new Me(0, 0);
                    c.push({
                        tl: B,
                        tr: S,
                        bl: P,
                        br: T,
                        texPrimary: n,
                        texSecondary: void 0,
                        writingMode: t1.writingMode,
                        glyphOffset: b,
                        sectionIndex: e1.sectionIndex,
                        isSDF: l,
                        pixelOffsetTL: z,
                        pixelOffsetBR: k,
                        minFontScaleX: 0,
                        minFontScaleY: 0
                    });
                }
            }
            return c;
        }
        function Jx(e1, t1 = 1, r = !1) {
            let n = 1 / 0, i = 1 / 0, s = -1 / 0, a = -1 / 0;
            const o = e1[0];
            for(let e1 = 0; e1 < o.length; e1++){
                const t1 = o[e1];
                (!e1 || t1.x < n) && (n = t1.x), (!e1 || t1.y < i) && (i = t1.y), (!e1 || t1.x > s) && (s = t1.x), (!e1 || t1.y > a) && (a = t1.y);
            }
            const l = Math.min(s - n, a - i);
            let u = l / 2;
            const c = new $n([], Kx);
            if (0 === l) return new Me(n, i);
            for(let t1 = n; t1 < s; t1 += l)for(let r = i; r < a; r += l)c.push(new Qx(t1 + u, r + u, u, e1));
            let h = function(e1) {
                let t1 = 0, r = 0, n = 0;
                const i = e1[0];
                for(let e1 = 0, s = i.length, a = s - 1; e1 < s; a = e1++){
                    const s = i[e1], o = i[a], l = s.x * o.y - o.x * s.y;
                    r += (s.x + o.x) * l, n += (s.y + o.y) * l, t1 += 3 * l;
                }
                return new Qx(r / t1, n / t1, 0, e1);
            }(e1), d = c.length;
            for(; c.length;){
                const n = c.pop();
                (n.d > h.d || !h.d) && (h = n, r && console.log("found best %d after %d probes", Math.round(1e4 * n.d) / 1e4, d)), n.max - h.d <= t1 || (u = n.h / 2, c.push(new Qx(n.p.x - u, n.p.y - u, u, e1)), c.push(new Qx(n.p.x + u, n.p.y - u, u, e1)), c.push(new Qx(n.p.x - u, n.p.y + u, u, e1)), c.push(new Qx(n.p.x + u, n.p.y + u, u, e1)), d += 4);
            }
            return r && (console.log(`num probes: ${d}`), console.log(`best distance: ${h.d}`)), h.p;
        }
        function Kx(e1, t1) {
            return t1.max - e1.max;
        }
        Ux.loadGlyphRange = function(e1, t1, r, n, i) {
            const s = 256 * t1, a = s + 255, o = n.transformRequest(n.normalizeGlyphsURL(r).replace("{fontstack}", e1).replace("{range}", `${s}-${a}`), Ot.Glyphs);
            $t(o, (e1, t1)=>{
                if (e1) i(e1);
                else if (t1) {
                    const e1 = {}, r = function(e1) {
                        return new Fg(e1).readFields(qg, {});
                    }(t1);
                    for (const t1 of r.glyphs)e1[t1.id] = t1;
                    i(null, {
                        glyphs: e1,
                        ascender: r.ascender,
                        descender: r.descender
                    });
                }
            });
        }, Ux.TinySDF = class {
            constructor({ fontSize: e1 = 24, buffer: t1 = 3, radius: r = 8, cutoff: n = .25, fontFamily: i = "sans-serif", fontWeight: s = "normal", fontStyle: a = "normal", lang: o = null } = {}){
                this.buffer = t1, this.cutoff = n, this.radius = r, this.lang = o;
                const l = this.size = e1 + 4 * t1, u = this._createCanvas(l), c = this.ctx = u.getContext("2d", {
                    willReadFrequently: !0
                });
                c.font = `${a} ${s} ${e1}px ${i}`, c.textBaseline = "alphabetic", c.textAlign = "left", c.fillStyle = "black", this.gridOuter = new Float64Array(l * l), this.gridInner = new Float64Array(l * l), this.f = new Float64Array(l), this.z = new Float64Array(l + 1), this.v = new Uint16Array(l);
            }
            _createCanvas(e1) {
                const t1 = document.createElement("canvas");
                return t1.width = t1.height = e1, t1;
            }
            draw(e1) {
                const { width: t1, actualBoundingBoxAscent: r, actualBoundingBoxDescent: n, actualBoundingBoxLeft: i, actualBoundingBoxRight: s } = this.ctx.measureText(e1), a = Math.ceil(r), o = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(s - i))), l = Math.min(this.size - this.buffer, a + Math.ceil(n)), u = o + 2 * this.buffer, c = l + 2 * this.buffer, h = Math.max(u * c, 0), d = new Uint8ClampedArray(h), p = {
                    data: d,
                    width: u,
                    height: c,
                    glyphWidth: o,
                    glyphHeight: l,
                    glyphTop: a,
                    glyphLeft: 0,
                    glyphAdvance: t1
                };
                if (0 === o || 0 === l) return p;
                const { ctx: f, buffer: m, gridInner: y, gridOuter: g } = this;
                this.lang && (f.lang = this.lang), f.clearRect(m, m, o, l), f.fillText(e1, m, m + a);
                const x = f.getImageData(m, m, o, l);
                g.fill(Cx, 0, h), y.fill(0, 0, h);
                for(let e1 = 0; e1 < l; e1++)for(let t1 = 0; t1 < o; t1++){
                    const r = x.data[4 * (e1 * o + t1) + 3] / 255;
                    if (0 === r) continue;
                    const n = (e1 + m) * u + t1 + m;
                    if (1 === r) g[n] = 0, y[n] = Cx;
                    else {
                        const e1 = .5 - r;
                        g[n] = e1 > 0 ? e1 * e1 : 0, y[n] = e1 < 0 ? e1 * e1 : 0;
                    }
                }
                Rx(g, 0, 0, u, c, u, this.f, this.v, this.z), Rx(y, m, m, o, l, u, this.f, this.v, this.z);
                for(let e1 = 0; e1 < h; e1++){
                    const t1 = Math.sqrt(g[e1]) - Math.sqrt(y[e1]);
                    d[e1] = Math.round(255 - 255 * (t1 / this.radius + this.cutoff));
                }
                return p;
            }
        };
        class Qx {
            constructor(e1, t1, r, n){
                this.p = new Me(e1, t1), this.h = r, this.d = function(e1, t1) {
                    let r = !1, n = 1 / 0;
                    for(let i = 0; i < t1.length; i++){
                        const s = t1[i];
                        for(let t1 = 0, i = s.length, a = i - 1; t1 < i; a = t1++){
                            const i = s[t1], o = s[a];
                            i.y > e1.y != o.y > e1.y && e1.x < (o.x - i.x) * (e1.y - i.y) / (o.y - i.y) + i.x && (r = !r), n = Math.min(n, $c(e1, i, o));
                        }
                    }
                    return (r ? 1 : -1) * Math.sqrt(n);
                }(this.p, n), this.max = this.d + this.h * Math.SQRT2;
            }
        }
        const ev = Object.keys, tv = Number.POSITIVE_INFINITY, rv = Math.sqrt(2);
        function nv(e1, t1, r, n, i, s) {
            const a = ox(e1) && e1.collisionPadding ? e1.collisionPadding : [
                0,
                0,
                0,
                0
            ], o = {
                top: e1.top - a[1],
                bottom: e1.bottom + a[3],
                left: e1.left - a[0],
                right: e1.right + a[2],
                scaled: !1
            };
            return void 0 !== n && function(e1, t1) {
                e1.top *= t1, e1.bottom *= t1, e1.left *= t1, e1.right *= t1, e1.scaled = !0;
            }(o, n), s && (o.left += s[0], o.right += s[0], o.top += s[1], o.bottom += s[1]), r && function(e1, t1, r) {
                if (!t1) return;
                const n = Te(t1), i = new Me(r ? r[0] : 0, r ? r[1] : 0), s = new Me(e1.left, e1.top), a = new Me(e1.right, e1.top), o = new Me(e1.left, e1.bottom), l = new Me(e1.right, e1.bottom);
                s._rotateAround(n, i), a._rotateAround(n, i), o._rotateAround(n, i), l._rotateAround(n, i), e1.left = Math.min(s.x, a.x, o.x, l.x), e1.right = Math.max(s.x, a.x, o.x, l.x), e1.top = Math.min(s.y, a.y, o.y, l.y), e1.bottom = Math.max(s.y, a.y, o.y, l.y);
            }(o, r, i), t1 ? {
                top: Math.min(t1.top, o.top),
                bottom: Math.max(t1.bottom, o.bottom),
                left: Math.min(t1.left, o.left),
                right: Math.max(t1.right, o.right),
                scaled: t1.scaled || o.scaled
            } : o;
        }
        function iv(e1, [t1, r]) {
            let n = 0, i = 0;
            if (r === tv) {
                t1 < 0 && (t1 = 0);
                const r = t1 / rv;
                switch(e1){
                    case "top-right":
                    case "top-left":
                        i = r - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                        i = 7 - r;
                        break;
                    case "bottom":
                        i = 7 - t1;
                        break;
                    case "top":
                        i = t1 - 7;
                }
                switch(e1){
                    case "top-right":
                    case "bottom-right":
                        n = -r;
                        break;
                    case "top-left":
                    case "bottom-left":
                        n = r;
                        break;
                    case "left":
                        n = t1;
                        break;
                    case "right":
                        n = -t1;
                }
            } else {
                switch(t1 = Math.abs(t1), r = Math.abs(r), e1){
                    case "top-right":
                    case "top-left":
                    case "top":
                        i = r - 7;
                        break;
                    case "bottom-right":
                    case "bottom-left":
                    case "bottom":
                        i = 7 - r;
                }
                switch(e1){
                    case "top-right":
                    case "bottom-right":
                    case "right":
                        n = -t1;
                        break;
                    case "top-left":
                    case "bottom-left":
                    case "left":
                        n = t1;
                }
            }
            return [
                n,
                i
            ];
        }
        function sv(e1, t1, r, n, i, s, a, o, l, u, c, h, d, p, f) {
            const m = e1.layers[0], y = m.appearances;
            if (0 === y.length) return {
                iconBBox: null,
                iconVerticalBBox: null,
                textBBox: null,
                textVerticalBBox: null
            };
            const g = {
                iconBBox: null,
                iconVerticalBBox: null
            }, x = {
                textBBox: null,
                textVerticalBBox: null
            }, { baseIconRotate: v, baseTextRotate: b, iconScaleFactor: w } = function(e1, t1, r) {
                const n = e1.get("icon-rotate").evaluate(t1, {}, r), i = e1.get("text-rotate").evaluate(t1, {}, r), [s, a] = e1.get("icon-size-scale-range");
                return {
                    baseIconRotate: n,
                    baseTextRotate: i,
                    iconScaleFactor: Ee(1, s, a)
                };
            }(n, i, s);
            t1 && (g.iconBBox = nv(t1, g.iconBBox, v), r) && (g.iconVerticalBBox = nv(r, g.iconVerticalBBox, v + 90));
            const _ = Mv(h.horizontal);
            _ && (x.textBBox = nv(_, x.textBBox, b, 1, p)), h.vertical && (x.textVerticalBBox = nv(h.vertical, x.textVerticalBBox, b + 90, 1, p));
            for (const r of y)r.hasIconLayoutProperties() && av(g, e1, m, r, i, s, o, v, a, l, t1, u, w, c, f), r.hasTextLayoutProperties() && lv(x, m, r, i, s, p, b, d, _, h.vertical);
            return {
                iconBBox: g.iconBBox,
                iconVerticalBBox: g.iconVerticalBBox,
                textBBox: x.textBBox,
                textVerticalBBox: x.textVerticalBBox
            };
        }
        function av(e1, t1, r, n, i, s, a, o, l, u, c, h, d, p, f) {
            const { appearanceIconOffset: m, appearanceIconRotate: y, appearanceIconSize: g } = ov(n, r, i, s, a, o, l, u.iconScaleFactor);
            let x = null, v = null, b = null;
            n.hasLayoutProperty("icon-image") ? b = function(e1, t1, r, n, i, s, a, o) {
                let l = null;
                const u = t1.getAppearanceValueAndResolveTokens(r, "icon-image", n, i, o);
                if (u) {
                    const c = e1.getResolvedImageFromTokens(u), h = r.hasLayoutProperty("icon-size") ? r.getUnevaluatedLayoutProperty("icon-size") : t1._unevaluatedLayout._values["icon-size"], d = dv(c, fx(e1.zoom, h, e1.worldview, o), h, i, e1.zoom, n, e1.pixelRatio, a, e1.worldview, o);
                    l = s.get(d.iconPrimary.toString());
                }
                return l;
            }(t1, r, n, i, s, h, d, f) : c && (b = c.imagePrimary), b && (x = lx(b, null, m, p), t1.allowVerticalPlacement && (v = lx(b, null, m, p)));
            const w = l > 0 ? g / l : 1;
            x && (e1.iconBBox = nv(x, e1.iconBBox, y, 1 !== w ? w : void 0)), v && (e1.iconVerticalBBox = nv(v, e1.iconVerticalBBox, y + 90, 1 !== w ? w : void 0));
        }
        function ov(e1, t1, r, n, i, s, a, o) {
            const l = e1.hasLayoutProperty("icon-offset") ? t1.getAppearanceValueAndResolveTokens(e1, "icon-offset", r, n, []) : null, u = l && Array.isArray(l) ? l : i, c = e1.hasLayoutProperty("icon-rotate") ? t1.getAppearanceValueAndResolveTokens(e1, "icon-rotate", r, n, []) : null, h = "number" == typeof c ? c : s, d = e1.hasLayoutProperty("icon-size") ? t1.getAppearanceValueAndResolveTokens(e1, "icon-size", r, n, []) : null;
            return {
                appearanceIconOffset: u,
                appearanceIconRotate: h,
                appearanceIconSize: "number" == typeof d ? d * o : a
            };
        }
        function lv(e1, t1, r, n, i, s, a, o, l, u) {
            const { appearanceTextOffset: c, appearanceTextRotate: h, appearanceTextSize: d } = uv(r, t1, n, i, s, a, o), p = d / o, f = [
                (c[0] - s[0]) * p,
                (c[1] - s[1]) * p
            ], m = 0 !== f[0] || 0 !== f[1];
            l && (e1.textBBox = nv(l, e1.textBBox, h, p, c, m ? f : void 0)), u && (e1.textVerticalBBox = nv(u, e1.textVerticalBBox, h + 90, p, c, m ? f : void 0));
        }
        function uv(e1, t1, r, n, i, s, a) {
            const o = e1.hasLayoutProperty("text-offset") ? t1.getAppearanceValueAndResolveTokens(e1, "text-offset", r, n, []) : null, l = o && Array.isArray(o) ? [
                o[0] * Mg,
                o[1] * Mg
            ] : i, u = e1.hasLayoutProperty("text-rotate") ? t1.getAppearanceValueAndResolveTokens(e1, "text-rotate", r, n, []) : null, c = "number" == typeof u ? u : s, h = e1.hasLayoutProperty("text-size") ? t1.getAppearanceValueAndResolveTokens(e1, "text-size", r, n, []) : null;
            return {
                appearanceTextOffset: l,
                appearanceTextRotate: c,
                appearanceTextSize: "number" == typeof h ? h : a
            };
        }
        function cv(e1, t1, r, n, i, s, a, o, l) {
            if (!t1 || !t1.usvg) return;
            const u = dx(n), c = dx(i), h = "both" !== s && "width" !== s || !cx(n) ? 1 : c.width / u.width, d = "both" !== s && "height" !== s || !hx(n) ? 1 : c.height / u.height;
            r.scaleSelf(h, d);
            const p = r.toString();
            a.set(p, r), o.set(p, t1);
            const { imagePosition: f } = Vx(p, t1, 1);
            l.set(p, f);
        }
        function hv(e1, t1, r, n, i, s, a, o, l, u) {
            if (!e1) return;
            const c = function(e1, t1, r, n, i, s, a) {
                if ("camera" === e1.kind) return e1.maxSize;
                if ("composite" === e1.kind) {
                    const n = t1.possiblyEvaluate(new to(e1.maxZoom, {
                        worldview: s
                    }), r, a).evaluate(i, {}, r, a), o = t1.possiblyEvaluate(new to(e1.minZoom, {
                        worldview: s
                    }), r, a).evaluate(i, {}, r, a);
                    return Math.max(n, o);
                }
                return t1.possiblyEvaluate(new to(n, {
                    worldview: s
                }), r, a).evaluate(i, {}, r, a);
            }(t1, r, n, i, s, l, u);
            return e1.scaleSelf(c * o * a);
        }
        function dv(e1, t1, r, n, i, s, a, o, l, u) {
            return {
                iconPrimary: hv(e1.getPrimary(), t1, r, n, i, s, a, o, l, u),
                iconSecondary: hv(e1.getSecondary(), t1, r, n, i, s, a, o, l, u)
            };
        }
        function pv(e1, t1, r) {
            if (!t1) return;
            const n = r.get(e1.toString()), i = r.get(t1.toString());
            n && i && (n.paddedRect.w === i.paddedRect.w && n.paddedRect.h === i.paddedRect.h || Ze(`Mismatch in icon variant sizes: ${e1.toString()} and ${t1.toString()}`), n.usvg !== i.usvg && Ze(`Mismatch in icon variant image types: ${e1.id} and ${t1.id}`));
        }
        function fv(e1, t1, r, n) {
            if (!e1) return;
            const i = t1.get(r.toString());
            if (i && (e1.imagePrimary = i), n) {
                const r = t1.get(n.toString());
                e1.imageSecondary = r;
            }
        }
        function mv(e1, t1) {
            for(const r in e1.horizontal)yv(e1.horizontal[r], t1);
            yv(e1.vertical, t1);
        }
        function yv(e1, t1) {
            if (e1) {
                for (const r of e1.positionedLines)for (const e1 of r.positionedGlyphs)if (null !== e1.image) {
                    const r = e1.image.toString();
                    e1.rect = t1.get(r).paddedRect;
                }
            }
        }
        function gv(e1) {
            switch(e1){
                case "right":
                case "top-right":
                case "bottom-right":
                    return "right";
                case "left":
                case "top-left":
                case "bottom-left":
                    return "left";
            }
            return "center";
        }
        function xv(e1, t1, r, n, i, s, a, o, l) {
            const u = Mv(s.horizontal) || s.vertical, c = r.get("icon-text-fit-padding").evaluate(n, {}, i);
            let h, d = t1;
            return t1 && "none" !== l && (e1.allowVerticalPlacement && s.vertical && (h = ux(t1, s.vertical, l, c, o, a)), u && (d = ux(t1, u, l, c, o, a))), {
                defaultShapedIcon: d,
                verticallyShapedIcon: h
            };
        }
        function vv(e1, t1) {
            return e1 * t1 / 24;
        }
        function bv(e1, t1, r, n, i, s, a, o, l, u, c, h, d, p, f, m, y, g, x, v, b, w, _, A) {
            let I = a.textMaxSize.evaluate(t1, {}, d);
            void 0 === I ? I = o * a.textScaleFactor : I *= a.textScaleFactor;
            const M = e1.layers[0].layout, B = vv(o, a.textScaleFactor), S = Mv(r.horizontal) || r.vertical, P = e1.hasAnyAppearanceLayoutProperty([
                "text-size",
                "text-offset",
                "text-rotate"
            ]), T = e1.getAppearanceFeatureData(t1.index);
            ("none" !== y || P) && T && (T.textShaping = S, T.iconTextFitPadding = M.get("icon-text-fit-padding").evaluate(t1, {}, d), T.fontScale = B, T.textScaleFactor = a.textScaleFactor);
            const z = "globe" === p.name, k = e1.tilePixelRatio * I / 24, V = (L = e1.overscaling, e1.zoom > 18 && L > 2 && (L >>= 1), Math.max(qn / (512 * L), 1) * M.get("symbol-spacing")), F = M.get("text-padding") * e1.tilePixelRatio, D = M.get("icon-padding") * e1.tilePixelRatio, E = Te(M.get("text-max-angle")), C = "map" === M.get("icon-rotation-alignment") && "point" !== v, R = V / 2;
            var L;
            !1 === e1.hasAnyIconTextFit && "none" !== y && (e1.hasAnyIconTextFit = !0);
            const O = t1.properties ? +t1.properties[fc] : null, U = O && e1.elevationFeatureIdToIndex ? e1.elevationFeatureIdToIndex.get(O) : 65535, N = (o, l, v)=>{
                if (l.x < 0 || l.x >= qn || l.y < 0 || l.y >= qn) return;
                let A = null;
                if (z) {
                    const { x: e1, y: t1, z: r } = p.projectTilePoint(l.x, l.y, v);
                    A = {
                        anchor: new gx(e1, t1, r, 0, void 0),
                        up: p.upVector(v, l.x, l.y)
                    };
                }
                !function(e1, t1, r, n, i, s, a, o, l, u, c, h, d, p, f, m, y, g, x, v, b, w, _, A, I, M, B, S, P, T, z, k) {
                    const V = e1.addToLineVertexArray(t1, n);
                    let F, D, E, C, R, L, O, U = 0, N = 0, j = 0, G = 0, $ = -1, q = -1;
                    const H = {};
                    let X = rr("");
                    const Z = r ? r.anchor : t1, W = "none" !== S;
                    let Y = 0, J = 0;
                    if (void 0 === l._unevaluatedLayout.getValue("text-radial-offset")) {
                        const e1 = l.layout.get("text-offset").evaluate(b, {}, I);
                        Y = e1[0] * Mg, J = e1[1] * Mg;
                    } else Y = l.layout.get("text-radial-offset").evaluate(b, {}, I) * Mg, J = tv;
                    if (e1.allowVerticalPlacement && i.vertical) {
                        const e1 = i.vertical;
                        if (f) L = Sv(e1), o && (O = Sv(o));
                        else {
                            const r = l.layout.get("text-rotate").evaluate(b, {}, I) + 90;
                            E = Bv(u, Z, t1, c, h, d, e1, p, r, m, k), o && (C = Bv(u, Z, t1, c, h, d, o, g, r, null, z));
                        }
                    }
                    if (s) {
                        const n = l.layout.get("icon-rotate").evaluate(b, {}, I), i = jx(s, n, _, W, w.iconScaleFactor), a = o ? jx(o, n, _, W, w.iconScaleFactor) : void 0;
                        D = Bv(u, Z, t1, c, h, d, s, g, n, null, T);
                        const p = function(e1, t1, r, n, i, s, a, o, l, u) {
                            const c = e1.layers[0], h = c.appearances;
                            let d = t1.length;
                            if (r && (d = Math.max(d, r.length)), 0 === h.length) return d;
                            const [p, f] = n.get("icon-size-scale-range"), m = Ee(1, p, f);
                            for (const t1 of h)if (t1.hasLayoutProperty("icon-image")) {
                                const r = c.getAppearanceValueAndResolveTokens(t1, "icon-image", s, a, u);
                                if (r) {
                                    const n = e1.getResolvedImageFromTokens(r);
                                    if (n) {
                                        const r = t1.hasLayoutProperty("icon-size") ? t1.getUnevaluatedLayoutProperty("icon-size") : i._values["icon-size"], l = dv(n, fx(e1.zoom, r, e1.worldview, u), r, a, e1.zoom, s, e1.pixelRatio, m, e1.worldview, u), c = o.get(l.iconPrimary.toString());
                                        c && (d = Math.max(d, Gx(c)));
                                    }
                                }
                            }
                            return d;
                        }(e1, i, a, l.layout, l._unevaluatedLayout, b, I, e1.iconAtlasPositions, 0, A);
                        U = 4 * p;
                        const f = l.layout.get("icon-size").evaluate(b, {}, I, A), m = w.compositeIconSizes ? w.compositeIconSizes[0].evaluate(b, {}, I, A) : 0, y = w.compositeIconSizes ? w.compositeIconSizes[1].evaluate(b, {}, I, A) : 0, S = Iv(e1.layerIds[0], e1.iconSizeData, f, w.iconScaleFactor, m, y);
                        e1.addSymbols(e1.icon, i, S, v, x, b, void 0, r, t1, V.lineStartIndex, V.lineLength, -1, A, I, M, B, e1.symbolInstances.length, p), $ = e1.icon.placedSymbolArray.length - 1, a && (N = 4 * p, e1.addSymbols(e1.icon, a, S, v, x, b, Zg.vertical, r, t1, V.lineStartIndex, V.lineLength, -1, A, I, M, B, e1.symbolInstances.length, p), q = e1.icon.placedSymbolArray.length - 1);
                    }
                    for(const n in i.horizontal){
                        const s = n, o = i.horizontal[s];
                        F || (X = rr(o.text), f ? R = Sv(o) : F = Bv(u, Z, t1, c, h, d, o, p, l.layout.get("text-rotate").evaluate(b, {}, I), m, k));
                        const y = 1 === o.positionedLines.length;
                        if (j += Av(e1, r, t1, o, a, l, f, b, m, V, i.vertical ? Zg.horizontal : Zg.horizontalOnly, y ? ev(i.horizontal) : [
                            s
                        ], H, $, w, A, I, e1.symbolInstances.length, M), y) break;
                    }
                    i.vertical && (G += Av(e1, r, t1, i.vertical, a, l, f, b, m, V, Zg.vertical, [
                        "vertical"
                    ], H, q, w, A, I, e1.symbolInstances.length, M));
                    let K = -1;
                    const Q = (e1, t1)=>e1 ? Math.max(e1, t1) : t1;
                    K = Q(R, K), K = Q(L, K), K = Q(O, K);
                    const ee = K > -1 ? 1 : 0;
                    e1.glyphOffsetArray.length >= 65535 && Ze("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== b.sortKey && e1.addToSortKeyRanges(e1.symbolInstances.length, b.sortKey), e1.symbolInstances.emplaceBack(t1.x, t1.y, Z.x, Z.y, Z.z, H.right >= 0 ? H.right : -1, H.center >= 0 ? H.center : -1, H.left >= 0 ? H.left : -1, H.vertical >= 0 ? H.vertical : -1, $, q, X, void 0 !== F ? F : e1.collisionBoxArray.length, void 0 !== F ? F + 1 : e1.collisionBoxArray.length, void 0 !== E ? E : e1.collisionBoxArray.length, void 0 !== E ? E + 1 : e1.collisionBoxArray.length, void 0 !== D ? D : e1.collisionBoxArray.length, void 0 !== D ? D + 1 : e1.collisionBoxArray.length, C || e1.collisionBoxArray.length, C ? C + 1 : e1.collisionBoxArray.length, c, j, G, U, N, ee, 0, Y, J, K, 0, W ? 1 : 0, P);
                }(e1, l, A, o, r, n, s, i, e1.layers[0], e1.collisionBoxArray, t1.index, t1.sourceLayerIndex, e1.index, F, x, u, 0, D, C, g, t1, a, c, h, d, f, m, y, U, b, w, _);
            };
            if ("line" === v) for (const i of Gf(t1.geometry, 0, 0, qn, qn)){
                const t1 = Ax(i, V, E, r.vertical || S, n, 24, k, e1.overscaling, qn);
                for (const r of t1)S && Pv(e1, S.text, R, r) || N(i, r, d);
            }
            else if ("line-center" === v) {
                for (const e1 of t1.geometry)if (e1.length > 1) {
                    const t1 = _x(e1, E, r.vertical || S, n, 24, k);
                    t1 && N(e1, t1, d);
                }
            } else if ("Polygon" === t1.type) for (const e1 of Fd(t1.geometry, 0)){
                const t1 = Jx(e1, 16);
                N(e1[0], new gx(t1.x, t1.y, 0, 0, void 0), d);
            }
            else if ("LineString" === t1.type) for (const e1 of t1.geometry)N(e1, new gx(e1[0].x, e1[0].y, 0, 0, void 0), d);
            else if ("Point" === t1.type) for (const e1 of t1.geometry)for (const t1 of e1)N([
                t1
            ], new gx(t1.x, t1.y, 0, 0, void 0), d);
        }
        const wv = 255, _v = wv * px;
        function Av(e1, t1, r, n, i, s, a, o, l, u, c, h, d, p, f, m, y, g, x) {
            const v = Yx(0, n, l, s, a, o, i, e1.allowVerticalPlacement, void 0, f.textScaleFactor), b = s.layout.get("text-size").evaluate(o, {}, y), w = f.compositeTextSizes ? f.compositeTextSizes[0].evaluate(o, {}, y) : 0, _ = f.compositeTextSizes ? f.compositeTextSizes[1].evaluate(o, {}, y) : 0, A = Iv(e1.layerIds[0], e1.textSizeData, b, f.textScaleFactor, w, _);
            e1.addSymbols(e1.text, v, A, l, a, o, c, t1, r, u.lineStartIndex, u.lineLength, p, m, y, x, !1, g, v.length);
            for (const t1 of h)d[t1] = e1.text.placedSymbolArray.length - 1;
            return 4 * v.length;
        }
        function Iv(e1, t1, r, n, i, s) {
            const a = t1;
            let o = null;
            return "source" === a.kind ? (o = [
                px * r * n
            ], o[0] > _v && Ze(`${e1}: Value for "text-size" is >= ${wv}. Reduce your "text-size".`)) : "composite" === a.kind && (o = [
                px * i * n,
                px * s * n
            ], (o[0] > _v || o[1] > _v) && Ze(`${e1}: Value for "text-size" is >= ${wv}. Reduce your "text-size".`)), o;
        }
        function Mv(e1) {
            for(const t1 in e1)return e1[t1];
            return null;
        }
        function Bv(e1, t1, r, n, i, s, a, o, l, u, c) {
            let h, d, p, f;
            if (h = c ? c.top : a.top, d = c ? c.bottom : a.bottom, p = c ? c.left : a.left, f = c ? c.right : a.right, ox(a) && a.collisionPadding) {
                const e1 = a.collisionPadding;
                p -= e1[0], h -= e1[1], f += e1[2], d += e1[3];
            }
            if (l) {
                const e1 = new Me(p, h), t1 = new Me(f, h), r = new Me(p, d), n = new Me(f, d), i = Te(l);
                let s = new Me(0, 0);
                u && (s = new Me(u[0], u[1])), e1._rotateAround(i, s), t1._rotateAround(i, s), r._rotateAround(i, s), n._rotateAround(i, s), p = Math.min(e1.x, t1.x, r.x, n.x), f = Math.max(e1.x, t1.x, r.x, n.x), h = Math.min(e1.y, t1.y, r.y, n.y), d = Math.max(e1.y, t1.y, r.y, n.y);
            }
            return e1.emplaceBack(t1.x, t1.y, t1.z, r.x, r.y, p, h, f, d, o, n, i, s), e1.length - 1;
        }
        function Sv(e1) {
            ox(e1) && e1.collisionPadding && (e1.top -= e1.collisionPadding[1], e1.bottom += e1.collisionPadding[3]);
            const t1 = e1.bottom - e1.top;
            return t1 > 0 ? Math.max(10, t1) : null;
        }
        function Pv(e1, t1, r, n) {
            const i = e1.compareText;
            if (t1 in i) {
                const e1 = i[t1];
                for(let t1 = e1.length - 1; t1 >= 0; t1--)if (n.dist(e1[t1]) < r) return !0;
            } else i[t1] = [];
            return i[t1].push(n), !1;
        }
        function Tv(e1, t1) {
            const r = e1.fovAboveCenter, n = e1.elevation ? e1.elevation.getMinElevationBelowMSL() * t1 : 0, i = Math.min(n, e1.isOrthographic ? -10 * t1 : 0), s = (e1._camera.position[2] * e1.worldSize - i) / Math.cos(e1._pitch), a = Math.sin(r) * s / Math.sin(Math.max(Math.PI / 2 - e1._pitch - r, .01));
            let o = Math.sin(e1._pitch) * a + s;
            const l = s * (1 / e1._horizonShift);
            if (!e1.elevation || 0 === e1.elevation.exaggeration()) {
                let t1 = Math.max(e1.zoom - 17, 0);
                e1.isOrthographic && (t1 /= 10), o *= 1 + t1;
            }
            return Math.min(1.01 * o, l);
        }
        function zv(e1, t1) {
            if (!t1.isReprojectedInTileSpace) return {
                scale: 1 << e1.z,
                x: e1.x,
                y: e1.y,
                x2: e1.x + 1,
                y2: e1.y + 1,
                projection: t1
            };
            const r = Math.pow(2, -e1.z), n = e1.x * r, i = (e1.x + 1) * r, s = e1.y * r, a = (e1.y + 1) * r, o = Gu(n), l = Gu(i), u = $u(s), c = $u(a), h = t1.project(o, u), d = t1.project(l, u), p = t1.project(l, c), f = t1.project(o, c);
            let m = Math.min(h.x, d.x, p.x, f.x), y = Math.min(h.y, d.y, p.y, f.y), g = Math.max(h.x, d.x, p.x, f.x), x = Math.max(h.y, d.y, p.y, f.y);
            const v = r / 16;
            function b(e1, r, n, i, s, a) {
                const o = (n + s) / 2, l = (i + a) / 2, u = t1.project(Gu(o), $u(l)), c = Math.max(0, m - u.x, y - u.y, u.x - g, u.y - x);
                m = Math.min(m, u.x), g = Math.max(g, u.x), y = Math.min(y, u.y), x = Math.max(x, u.y), c > v && (b(e1, u, n, i, o, l), b(u, r, o, l, s, a));
            }
            b(h, d, n, s, i, s), b(d, p, i, s, i, a), b(p, f, i, a, n, a), b(f, h, n, a, n, s), m -= v, y -= v, g += v, x += v;
            const w = 1 / Math.max(g - m, x - y);
            return {
                scale: w,
                x: m * w,
                y: y * w,
                x2: g * w,
                y2: x * w,
                projection: t1
            };
        }
        function kv(e1, { x: t1, y: r }, n = 0) {
            return new Me(((t1 - n) * e1.scale - e1.x) * qn, (r * e1.scale - e1.y) * qn);
        }
        const Vv = u(new Float32Array(16));
        class Fv {
            constructor(e1){
                this.spec = e1, this.name = e1.name, this.wrap = !1, this.requiresDraping = !1, this.supportsWorldCopies = !1, this.supportsTerrain = !1, this.supportsFog = !1, this.supportsFreeCamera = !1, this.zAxisUnit = "meters", this.isReprojectedInTileSpace = !0, this.unsupportedLayers = [
                    "custom"
                ], this.center = [
                    0,
                    0
                ], this.range = [
                    3.5,
                    7
                ];
            }
            project(e1, t1) {
                return {
                    x: 0,
                    y: 0,
                    z: 0
                };
            }
            unproject(e1, t1) {
                return new Ru(0, 0);
            }
            projectTilePoint(e1, t1, r) {
                return {
                    x: e1,
                    y: t1,
                    z: 0
                };
            }
            locationPoint(e1, t1, r, n = !0) {
                return e1._coordinatePoint(e1.locationCoordinate(t1, r), n);
            }
            pixelsPerMeter(e1, t1) {
                return ju(1, e1) * t1;
            }
            pixelSpaceConversion(e1, t1, r) {
                return 1;
            }
            farthestPixelDistance(e1) {
                return Tv(e1, e1.pixelsPerMeter);
            }
            pointCoordinate(e1, t1, r, n) {
                const i = e1.horizonLineFromTop(!1), s = new Me(t1, Math.max(i, r));
                return e1.rayIntersectionCoordinate(e1.pointRayIntersection(s, n));
            }
            pointCoordinate3D(e1, t1, r) {
                const n = new Me(t1, r);
                if (e1.elevation) return e1.elevation.pointCoordinate(n);
                {
                    const t1 = this.pointCoordinate(e1, n.x, n.y, 0);
                    return [
                        t1.x,
                        t1.y,
                        t1.z
                    ];
                }
            }
            isPointAboveHorizon(e1, t1) {
                if (e1.elevation && e1.elevation.visibleDemTiles.length) return !this.pointCoordinate3D(e1, t1.x, t1.y);
                const r = e1.horizonLineFromTop();
                return t1.y < r;
            }
            createInversionMatrix(e1, t1) {
                return Vv;
            }
            createTileMatrix(e1, t1, r) {
                let n, i, s;
                const a = r.canonical, o = u(new Float64Array(16));
                if (this.isReprojectedInTileSpace) {
                    const l = zv(a, this);
                    n = 1, i = l.x + r.wrap * l.scale, s = l.y, p(o, o, [
                        n / l.scale,
                        n / l.scale,
                        e1.pixelsPerMeter / t1
                    ]);
                } else n = t1 / e1.zoomScale(a.z), i = (a.x + Math.pow(2, a.z) * r.wrap) * n, s = a.y * n;
                return d(o, o, [
                    i,
                    s,
                    0
                ]), p(o, o, [
                    n / qn,
                    n / qn,
                    1
                ]), o;
            }
            upVector(e1, t1, r) {
                return [
                    0,
                    0,
                    1
                ];
            }
            upVectorScale(e1, t1, r) {
                return {
                    metersToTile: 1
                };
            }
        }
        class Dv extends Fv {
            constructor(e1){
                super(e1), this.range = [
                    4,
                    7
                ], this.center = e1.center || [
                    -96,
                    37.5
                ];
                const [t1, r] = this.parallels = e1.parallels || [
                    29.5,
                    45.5
                ], n = Math.sin(Te(t1));
                this.n = (n + Math.sin(Te(r))) / 2, this.c = 1 + n * (2 * this.n - n), this.r0 = Math.sqrt(this.c) / this.n;
            }
            project(e1, t1) {
                const { n: r, c: n, r0: i } = this, s = Te(e1 - this.center[0]), a = Te(t1), o = Math.sqrt(n - 2 * r * Math.sin(a)) / r;
                return {
                    x: o * Math.sin(s * r),
                    y: o * Math.cos(s * r) - i,
                    z: 0
                };
            }
            unproject(e1, t1) {
                const { n: r, c: n, r0: i } = this, s = i + t1;
                let a = Math.atan2(e1, Math.abs(s)) * Math.sign(s);
                s * r < 0 && (a -= Math.PI * Math.sign(e1) * Math.sign(s));
                const o = Te(this.center[0]) * r;
                a = Re(a, -Math.PI - o, Math.PI - o);
                const l = Ee(ze(a / r) + this.center[0], -180, 180), u = Math.asin(Ee((n - (e1 * e1 + s * s) * r * r) / (2 * r), -1, 1)), c = Ee(ze(u), -85.051129, Hu);
                return new Ru(l, c);
            }
        }
        const Ev = 1.340264, Cv = -0.081106, Rv = 893e-6, Lv = .003796, Ov = Math.sqrt(3) / 2;
        class Uv extends Fv {
            project(e1, t1) {
                t1 = t1 / 180 * Math.PI, e1 = e1 / 180 * Math.PI;
                const r = Math.asin(Ov * Math.sin(t1)), n = r * r, i = n * n * n;
                return {
                    x: .5 * (e1 * Math.cos(r) / (Ov * (Ev + 3 * Cv * n + i * (7 * Rv + 9 * Lv * n))) / Math.PI + .5),
                    y: 1 - .5 * (r * (Ev + Cv * n + i * (Rv + Lv * n)) / Math.PI + 1),
                    z: 0
                };
            }
            unproject(e1, t1) {
                e1 = (2 * e1 - .5) * Math.PI;
                let r = t1 = (2 * (1 - t1) - 1) * Math.PI, n = r * r, i = n * n * n;
                for(let e1, s, a, o = 0; o < 12 && (s = r * (Ev + Cv * n + i * (Rv + Lv * n)) - t1, a = Ev + 3 * Cv * n + i * (7 * Rv + 9 * Lv * n), e1 = s / a, r = Ee(r - e1, -Math.PI / 3, Math.PI / 3), n = r * r, i = n * n * n, !(Math.abs(e1) < 1e-12)); ++o);
                const s = Ov * e1 * (Ev + 3 * Cv * n + i * (7 * Rv + 9 * Lv * n)) / Math.cos(r), a = Math.asin(Math.sin(r) / Ov), o = Ee(180 * s / Math.PI, -180, 180), l = Ee(180 * a / Math.PI, -85.051129, Hu);
                return new Ru(o, l);
            }
        }
        class Nv extends Fv {
            constructor(e1){
                super(e1), this.wrap = !0, this.supportsWorldCopies = !0;
            }
            project(e1, t1) {
                return {
                    x: .5 + e1 / 360,
                    y: .5 - t1 / 360,
                    z: 0
                };
            }
            unproject(e1, t1) {
                const r = 360 * (e1 - .5), n = Ee(360 * (.5 - t1), -85.051129, Hu);
                return new Ru(r, n);
            }
        }
        const jv = Math.PI / 2;
        function Gv(e1) {
            return Math.tan((jv + e1) / 2);
        }
        class $v extends Fv {
            constructor(e1){
                super(e1), this.center = e1.center || [
                    0,
                    30
                ];
                const [t1, r] = this.parallels = e1.parallels || [
                    30,
                    30
                ];
                let n = Te(t1), i = Te(r);
                this.southernCenter = n + i < 0, this.southernCenter && (n = -n, i = -i);
                const s = Math.cos(n), a = Gv(n);
                this.n = n === i ? Math.sin(n) : Math.log(s / Math.cos(i)) / Math.log(Gv(i) / a), this.f = s * Math.pow(Gv(n), this.n) / this.n;
            }
            project(e1, t1) {
                t1 = Te(t1), this.southernCenter && (t1 = -t1), e1 = Te(e1 - this.center[0]);
                const r = 1e-6, { n: n, f: i } = this;
                i > 0 ? t1 < -jv + r && (t1 = -jv + r) : t1 > jv - r && (t1 = jv - r);
                const s = i / Math.pow(Gv(t1), n);
                let a = s * Math.sin(n * e1), o = i - s * Math.cos(n * e1);
                return a = .5 * (a / Math.PI + .5), o = .5 * (o / Math.PI + .5), {
                    x: a,
                    y: this.southernCenter ? o : 1 - o,
                    z: 0
                };
            }
            unproject(e1, t1) {
                e1 = (2 * e1 - .5) * Math.PI, this.southernCenter && (t1 = 1 - t1), t1 = (2 * (1 - t1) - .5) * Math.PI;
                const { n: r, f: n } = this, i = n - t1, s = Math.sign(i), a = Math.sign(r) * Math.sqrt(e1 * e1 + i * i);
                let o = Math.atan2(e1, Math.abs(i)) * s;
                i * r < 0 && (o -= Math.PI * Math.sign(e1) * s);
                const l = Ee(ze(o / r) + this.center[0], -180, 180), u = Ee(ze(2 * Math.atan(Math.pow(n / a, 1 / r)) - jv), -85.051129, Hu);
                return new Ru(l, this.southernCenter ? -u : u);
            }
        }
        class qv extends Fv {
            constructor(e1){
                super(e1), this.wrap = !0, this.supportsWorldCopies = !0, this.supportsTerrain = !0, this.supportsFog = !0, this.supportsFreeCamera = !0, this.isReprojectedInTileSpace = !1, this.unsupportedLayers = [], this.range = null;
            }
            project(e1, t1) {
                return {
                    x: Uu(e1),
                    y: Nu(t1),
                    z: 0
                };
            }
            unproject(e1, t1) {
                const r = Gu(e1), n = $u(t1);
                return new Ru(r, n);
            }
        }
        const Hv = Te(Hu);
        class Xv extends Fv {
            project(e1, t1) {
                const r = (t1 = Te(t1)) * t1, n = r * r;
                return {
                    x: .5 * ((e1 = Te(e1)) * (.8707 - .131979 * r + n * (n * (.003971 * r - .001529 * n) - .013791)) / Math.PI + .5),
                    y: 1 - .5 * (t1 * (1.007226 + r * (.015085 + n * (.028874 * r - .044475 - .005916 * n))) / Math.PI + 1),
                    z: 0
                };
            }
            unproject(e1, t1) {
                e1 = (2 * e1 - .5) * Math.PI;
                let r = t1 = (2 * (1 - t1) - 1) * Math.PI, n = 25, i = 0, s = r * r;
                do {
                    s = r * r;
                    const e1 = s * s;
                    i = (r * (1.007226 + s * (.015085 + e1 * (.028874 * s - .044475 - .005916 * e1))) - t1) / (1.007226 + s * (.045255 + e1 * (.259866 * s - .311325 - .005916 * 11 * e1))), r = Ee(r - i, -Hv, Hv);
                }while (Math.abs(i) > 1e-6 && --n > 0);
                s = r * r;
                const a = Ee(ze(e1 / (.8707 + s * (s * (s * s * s * (.003971 - .001529 * s) - .013791) - .131979))), -180, 180), o = ze(r);
                return new Ru(a, o);
            }
        }
        const Zv = Te(Hu);
        class Wv extends Fv {
            project(e1, t1) {
                t1 = Te(t1), e1 = Te(e1);
                const r = Math.cos(t1), n = 2 / Math.PI, i = Math.acos(r * Math.cos(e1 / 2)), s = Math.sin(i) / i, a = .5 * (e1 * n + 2 * r * Math.sin(e1 / 2) / s) || 0, o = .5 * (t1 + Math.sin(t1) / s) || 0;
                return {
                    x: .5 * (a / Math.PI + .5),
                    y: 1 - .5 * (o / Math.PI + 1),
                    z: 0
                };
            }
            unproject(e1, t1) {
                let r = e1 = (2 * e1 - .5) * Math.PI, n = t1 = (2 * (1 - t1) - 1) * Math.PI, i = 25;
                const s = 1e-6;
                let a = 0, o = 0;
                do {
                    const i = Math.cos(n), s = Math.sin(n), l = 2 * s * i, u = s * s, c = i * i, h = Math.cos(r / 2), d = Math.sin(r / 2), p = 2 * h * d, f = d * d, m = 1 - c * h * h, y = m ? 1 / m : 0, g = m ? Math.acos(i * h) * Math.sqrt(1 / m) : 0, x = .5 * (2 * g * i * d + 2 * r / Math.PI) - e1, v = .5 * (g * s + n) - t1, b = .5 * y * (c * f + g * i * h * u) + 1 / Math.PI, w = y * (p * l / 4 - g * s * d), _ = .125 * y * (l * d - g * s * c * p), A = .5 * y * (u * h + g * f * i) + .5, I = w * _ - A * b;
                    a = (v * w - x * A) / I, o = (x * _ - v * b) / I, r = Ee(r - a, -Math.PI, Math.PI), n = Ee(n - o, -Zv, Zv);
                }while ((Math.abs(a) > s || Math.abs(o) > s) && --i > 0);
                return new Ru(ze(r), ze(n));
            }
        }
        class Yv extends Fv {
            constructor(e1){
                super(e1), this.center = e1.center || [
                    0,
                    0
                ], this.parallels = e1.parallels || [
                    0,
                    0
                ], this.cosPhi = Math.max(.01, Math.cos(Te(this.parallels[0]))), this.scale = 1 / (2 * Math.max(Math.PI * this.cosPhi, 1 / this.cosPhi)), this.wrap = !0, this.supportsWorldCopies = !0;
            }
            project(e1, t1) {
                const { scale: r, cosPhi: n } = this;
                return {
                    x: Te(e1) * n * r + .5,
                    y: -Math.sin(Te(t1)) / n * r + .5,
                    z: 0
                };
            }
            unproject(e1, t1) {
                const { scale: r, cosPhi: n } = this, i = -(t1 - .5) / r, s = Ee(ze((e1 - .5) / r) / n, -180, 180), a = Math.asin(Ee(i * n, -1, 1)), o = Ee(ze(a), -85.051129, Hu);
                return new Ru(s, o);
            }
        }
        class Jv extends qv {
            constructor(e1){
                super(e1), this.requiresDraping = !0, this.supportsWorldCopies = !1, this.supportsFog = !0, this.zAxisUnit = "pixels", this.unsupportedLayers = [
                    "debug"
                ], this.range = [
                    3,
                    5
                ];
            }
            projectTilePoint(e1, t1, r) {
                const n = Ih(e1, t1, r);
                return j(n, n, Sh(gh(r))), {
                    x: n[0],
                    y: n[1],
                    z: n[2]
                };
            }
            locationPoint(e1, t1, r) {
                const n = Du(t1.lat, t1.lng), i = L([], n), s = r ? e1._centerAltitude + r : e1.elevation ? e1.elevation.getAtPointOrZero(e1.locationCoordinate(t1), e1._centerAltitude) : e1._centerAltitude;
                F(n, n, i, ju(1, 0) * qn * s);
                const a = u(new Float64Array(16));
                return h(a, e1.pixelMatrix, e1.globeMatrix), j(n, n, a), new Me(n[0], n[1]);
            }
            pixelsPerMeter(e1, t1) {
                return ju(1, 0) * t1;
            }
            pixelSpaceConversion(e1, t1, r) {
                const n = ju(1, e1) * t1, i = yr(ju(1, 45) * t1, n, r);
                return this.pixelsPerMeter(e1, t1) / i;
            }
            createTileMatrix(e1, t1, r) {
                const n = Ph(gh(r.canonical));
                return h(new Float64Array(16), e1.globeMatrix, n);
            }
            createInversionMatrix(e1, t1) {
                const { center: r } = e1, n = Sh(gh(t1));
                return m(n, n, Te(r.lng)), f(n, n, Te(r.lat)), p(n, n, [
                    e1._pixelsPerMercatorPixel,
                    e1._pixelsPerMercatorPixel,
                    1
                ]), Float32Array.from(n);
            }
            pointCoordinate(e1, t1, r, n) {
                return fh(e1, t1, r, !0) || new Ju(0, 0);
            }
            pointCoordinate3D(e1, t1, r) {
                const n = this.pointCoordinate(e1, t1, r, 0);
                return [
                    n.x,
                    n.y,
                    n.z
                ];
            }
            isPointAboveHorizon(e1, t1) {
                return !fh(e1, t1.x, t1.y, !1);
            }
            farthestPixelDistance(e1) {
                const t1 = function(e1, t1) {
                    const r = e1.cameraToCenterDistance, n = e1._centerAltitude * t1, i = e1._camera, s = e1._camera.forward(), a = S([], V([], s, -r), [
                        0,
                        0,
                        n
                    ]), o = e1.worldSize / (2 * Math.PI), l = [
                        0,
                        0,
                        -o
                    ], u = e1.width / e1.height, c = Math.tan(e1.fovAboveCenter), h = V([], i.up(), c), d = V([], i.right(), c * u), p = L([], S([], S([], s, h), d)), f = [];
                    let m;
                    if (new _c(a, p).closestPointOnSphere(l, o, f)) {
                        const t1 = S([], f, l), r = X([], t1, a);
                        m = Math.cos(e1.fovAboveCenter) * I(r);
                    } else {
                        const e1 = X([], a, l), t1 = X([], l, a);
                        L(t1, t1);
                        const r = I(e1) - o;
                        m = Math.sqrt(r * (r + 2 * o));
                        const n = Math.acos(m / (o + r)) - Math.acos(O(s, t1));
                        m *= Math.cos(n);
                    }
                    return 1.01 * m;
                }(e1, this.pixelsPerMeter(e1.center.lat, e1.worldSize)), r = Vh(e1.zoom);
                if (r > 0) {
                    const n = Tv(e1, ju(1, e1.center.lat) * e1.worldSize), i = e1.worldSize / (2 * Math.PI), s = Math.max(e1.width, e1.height) / e1.worldSize * Math.PI;
                    return yr(t1, n + i * (1 - Math.cos(s)), Math.pow(r, 10));
                }
                return t1;
            }
            upVector(e1, t1, r) {
                return Ih(t1, r, e1, 1);
            }
            upVectorScale(e1) {
                return {
                    metersToTile: dh(Mh(gh(e1)))
                };
            }
        }
        function Kv(e1) {
            const t1 = e1.parallels, r = !!t1 && Math.abs(t1[0] + t1[1]) < .01;
            switch(e1.name){
                case "mercator":
                    return new qv(e1);
                case "equirectangular":
                    return new Nv(e1);
                case "naturalEarth":
                    return new Xv(e1);
                case "equalEarth":
                    return new Uv(e1);
                case "winkelTripel":
                    return new Wv(e1);
                case "albers":
                    return r ? new Yv(e1) : new Dv(e1);
                case "lambertConformalConic":
                    return r ? new Yv(e1) : new $v(e1);
                case "globe":
                    return new Jv(e1);
            }
            throw new Error(`Invalid projection name: ${e1.name}`);
        }
        class Qv {
            constructor(e1, t1){
                this.lastParams = null, this.lastAllFeaturesIndex = -2, this.appearancesVersion = t1, this.appearances = e1;
                const r = e1.map((e1)=>(function(e1) {
                        if (!e1.condition) return {
                            featureDependent: !1,
                            stateDependent: !1,
                            zoomDependent: !1,
                            pitchDependent: !1,
                            brightnessDependent: !1,
                            worldviewDependent: !1
                        };
                        const t1 = e1.condition.expression;
                        return {
                            featureDependent: !bi(t1),
                            stateDependent: !wi(t1),
                            zoomDependent: !_i(t1, [
                                "zoom"
                            ]),
                            pitchDependent: !_i(t1, [
                                "pitch"
                            ]),
                            brightnessDependent: !_i(t1, [
                                "brightness",
                                "measure-light"
                            ]),
                            worldviewDependent: !_i(t1, [
                                "worldview"
                            ])
                        };
                    })(e1));
                this.anyFeatureDependent = r.some((e1)=>e1.featureDependent), this.anyStateDependent = r.some((e1)=>e1.stateDependent);
            }
            update(e1, t1) {
                const r = this.lastParams, n = !r || r.zoom !== e1.zoom || r.pitch !== (e1.pitch || 0) || r.brightness !== (e1.brightness || 0) || r.worldview !== e1.worldview;
                this.lastParams = {
                    zoom: e1.zoom,
                    pitch: e1.pitch || 0,
                    brightness: e1.brightness || 0,
                    worldview: e1.worldview
                };
                const i = t1 && this.anyStateDependent;
                if (!n && !i && -2 !== this.lastAllFeaturesIndex) return {
                    kind: "no-changes"
                };
                if (!this.anyFeatureDependent && !i) {
                    const t1 = this.evaluateAllFeatures(e1);
                    return t1 === this.lastAllFeaturesIndex ? {
                        kind: "no-changes"
                    } : (this.lastAllFeaturesIndex = t1, {
                        kind: "all-features",
                        appearanceIndex: t1
                    });
                }
                return {
                    kind: "per-feature"
                };
            }
            evaluateAllFeatures(e1) {
                for(let t1 = 0; t1 < this.appearances.length; t1++){
                    const r = this.appearances[t1];
                    if (r.condition && r.condition.evaluate(e1, void 0, void 0, void 0)) return t1;
                }
                return -1;
            }
        }
        const eb = oc.types, tb = [
            {
                name: "a_fade_opacity",
                components: 1,
                type: "Uint8",
                offset: 0
            }
        ];
        function rb(e1, t1, r, n, i, s, a, o, l, u, c, h, d) {
            const p = o ? Math.min(_v, Math.round(o[0])) : 0, f = o ? Math.min(_v, Math.round(o[1])) : 0;
            e1.emplaceBack(t1, r, Math.round(32 * n), Math.round(32 * i), s, a, (p << 1) + (l ? 1 : 0), 0 + (f << 1), 16 * u, 16 * c, 256 * h, 256 * d);
        }
        function nb(e1, t1, r) {
            e1.emplaceBack(t1, r);
        }
        function ib(e1, t1, r, n, i, s, a) {
            e1.emplaceBack(t1, r, n, i, s, a);
        }
        const sb = (e1, t1, r, n)=>{
            for(let i = 0; i < t1; i++)e1.emplaceBack(r[0], r[1], r[2], n[0], n[1], n[2]);
        };
        function ab(e1, t1, r, n, i) {
            e1.emplaceBack(t1, r, n, i), e1.emplaceBack(t1, r, n, i), e1.emplaceBack(t1, r, n, i), e1.emplaceBack(t1, r, n, i);
        }
        function ob(e1) {
            for (const t1 of e1.sections)if (Ga(t1.text)) return !0;
            return !1;
        }
        const lb = 12;
        class ub {
            constructor(e1){
                this.layoutVertexArray = new al, this.indexArray = new ml, this.programConfigurations = e1, this.segments = new Hl, this.dynamicLayoutVertexArray = new ll, this.opacityVertexArray = new ul, this.placedSymbolArray = new Fl, this.iconTransitioningVertexArray = new cl, this.globeExtVertexArray = new ol, this.zOffsetVertexArray = new Yo, this.orientationVertexArray = new xl, this.symbolInstanceIndices = [], this.uboBinder = null, this.featureIdArray = new Yo, this.featureIdBuffer = null, this.cachedBatchIndices = null, this.cachedBatchSegments = null;
            }
            isEmpty() {
                return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length && 0 === this.iconTransitioningVertexArray.length;
            }
            getBatchGrouping(e1) {
                const t1 = e1.get().length === this.segments.get().length;
                if (t1 && this.cachedBatchIndices && this.cachedBatchSegments) return {
                    batchIndices: this.cachedBatchIndices,
                    batchSegments: this.cachedBatchSegments
                };
                const r = new Map;
                for (const t1 of e1.get()){
                    const e1 = void 0 !== t1.batchIndex ? t1.batchIndex : 0;
                    r.has(e1) || r.set(e1, []), r.get(e1).push(t1);
                }
                const n = Array.from(r.keys()).sort((e1, t1)=>e1 - t1), i = new Map;
                for (const e1 of n){
                    const t1 = r.get(e1);
                    i.set(e1, new Hl(t1));
                }
                return t1 && (this.cachedBatchIndices = n, this.cachedBatchSegments = i), {
                    batchIndices: n,
                    batchSegments: i
                };
            }
            snapshotSymbolVertexData(e1, t1) {
                const r = e1 * lb;
                return this.layoutVertexArray.uint16.slice(r, r + t1 * lb);
            }
            restoreSymbolVertexData(e1, t1) {
                this.layoutVertexArray.uint16.set(t1, e1 * lb);
            }
            updateSymbolVertexData(e1, t1, r, n, i, s, a, o, l, u, c, h, d) {
                const p = this.layoutVertexArray.uint16, f = e1 * lb;
                p[f] = t1, p[f + 1] = r, p[f + 2] = n, p[f + 3] = i, p[f + 4] = s, p[f + 5] = a, p[f + 6] = o, p[f + 7] = l, p[f + 8] = u, p[f + 9] = c, p[f + 10] = h, p[f + 11] = d;
            }
            upload(e1, t1, r, n, i, s) {
                this.isEmpty() || (r && (this.cachedBatchIndices = null, this.cachedBatchSegments = null, this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, ug.members, !!s), this.indexBuffer = e1.createIndexBuffer(this.indexArray, t1), this.dynamicLayoutVertexBuffer = e1.createVertexBuffer(this.dynamicLayoutVertexArray, hg.members, !0), this.opacityVertexBuffer = e1.createVertexBuffer(this.opacityVertexArray, tb, !0), this.iconTransitioningVertexArray.length > 0 && (this.iconTransitioningVertexBuffer = e1.createVertexBuffer(this.iconTransitioningVertexArray, mg.members, !0)), this.globeExtVertexArray.length > 0 && (this.globeExtVertexBuffer = e1.createVertexBuffer(this.globeExtVertexArray, cg.members, !0)), !this.zOffsetVertexBuffer && (this.zOffsetVertexArray.length > 0 || i) && (this.zOffsetVertexBuffer = e1.createVertexBuffer(this.zOffsetVertexArray, dg.members, !0)), !this.orientationVertexBuffer && this.orientationVertexArray && this.orientationVertexArray.length > 0 && (this.orientationVertexBuffer = e1.createVertexBuffer(this.orientationVertexArray, fg.members, !0)), this.opacityVertexBuffer.itemSize = 1, this.featureIdArray && this.featureIdArray.length > 0 && (this.featureIdBuffer = e1.createVertexBuffer(this.featureIdArray, pg.members, !1))), (r || n) && (this.programConfigurations.upload(e1), this.uboBinder && this.uboBinder.upload(e1)));
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy(), this.iconTransitioningVertexBuffer && this.iconTransitioningVertexBuffer.destroy(), this.globeExtVertexBuffer && this.globeExtVertexBuffer.destroy(), this.zOffsetVertexBuffer && this.zOffsetVertexBuffer.destroy(), this.orientationVertexBuffer && this.orientationVertexBuffer.destroy(), this.featureIdBuffer && this.featureIdBuffer.destroy(), this.uboBinder && this.uboBinder.destroy());
            }
        }
        ra(ub, "SymbolBuffers", {
            omit: [
                "cachedBatchIndices",
                "cachedBatchSegments"
            ]
        });
        class cb {
            constructor(e1, t1, r){
                this.layoutVertexArray = new e1, this.layoutAttributes = t1, this.indexArray = new r, this.segments = new Hl, this.collisionVertexArray = new fl, this.collisionVertexArrayExt = new ll;
            }
            upload(e1) {
                this.layoutVertexBuffer = e1.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = e1.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = e1.createVertexBuffer(this.collisionVertexArray, yg.members, !0), this.collisionVertexBufferExt = e1.createVertexBuffer(this.collisionVertexArrayExt, gg.members, !0);
            }
            destroy() {
                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy(), this.collisionVertexBufferExt.destroy());
            }
        }
        ra(cb, "CollisionBuffers");
        class hb {
            constructor(e1){
                this.collisionBoxArray = e1.collisionBoxArray, this.zoom = e1.zoom, this.overscaling = e1.overscaling, this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.index = e1.index, this.pixelRatio = e1.pixelRatio, this.sourceLayerIndex = e1.sourceLayerIndex, this.hasPattern = !1, this.hasRTLText = !1, this.fullyClipped = !1, this.hasAnyIconTextFit = !1, this.sortKeyRanges = [], this.collisionCircleArray = [], this.placementInvProjMatrix = u([]), this.placementViewportMatrix = u([]);
                const t1 = this.layers[0]._unevaluatedLayout._values;
                this.worldview = e1.worldview, this.localizable = e1.localizable, this.maxUniformBufferBindings = e1.maxUniformBufferBindings, this.maxUniformBlockSizeDwords = e1.maxUniformBlockSizeDwords, this.disableSymbolUBO = e1.disableSymbolUBO, this.textSizeData = fx(this.zoom, t1["text-size"], this.worldview, e1.availableImages), this.iconSizeData = fx(this.zoom, t1["icon-size"], this.worldview, e1.availableImages);
                const r = this.layers[0].layout, n = r.get("symbol-sort-key"), i = r.get("symbol-z-order");
                this.lut = e1.lut, this.canOverlap = r.get("text-allow-overlap") || r.get("icon-allow-overlap") || r.get("text-ignore-placement") || r.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== i && void 0 !== n.constantOr(1), this.sortFeaturesByY = ("viewport-y" === i || "auto" === i && !this.sortFeaturesByKey) && this.canOverlap, this.writingModes = r.get("text-writing-mode").map((e1)=>Zg[e1]), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.sourceID = e1.sourceID, this.projection = e1.projection, this.hasAnyZOffset = !1, this.zOffsetSortDirty = !1, this.zOffsetBuffersNeedUpload = !1, this.elevationType = "none", this.elevationStateComplete = !1, this.activeReplacements = [], this.replacementUpdateTime = 0, this.hasAnySecondaryIcon = !1, this.hasAppearances = null, this.featureAppearances = null, this.featureAppearanceData = new Map;
            }
            hasAnyAppearanceLayoutProperty(e1) {
                const t1 = this.layers[0].getAppearances();
                if (!t1 || 0 === t1.length) return !1;
                const r = Array.isArray(e1) ? e1 : [
                    e1
                ];
                return t1.some((e1)=>r.some((t1)=>e1.hasLayoutProperty(t1)));
            }
            getAppearanceFeatureData(e1) {
                return this.featureAppearanceData.get(e1);
            }
            createArrays() {
                this.text = new ub(new _u(this.layers, {
                    zoom: this.zoom,
                    lut: this.lut
                }, (e1)=>e1.startsWith("text") || e1.startsWith("symbol"))), this.icon = new ub(new _u(this.layers, {
                    zoom: this.zoom,
                    lut: this.lut
                }, (e1)=>e1.startsWith("icon") || e1.startsWith("symbol"))), this.disableSymbolUBO || (this.text.uboBinder = new Ig(this.layers[0], this.zoom, this.lut, !0, "", this.maxUniformBufferBindings, this.maxUniformBlockSizeDwords), this.icon.uboBinder = new Ig(this.layers[0], this.zoom, this.lut, !1, "", this.maxUniformBufferBindings, this.maxUniformBlockSizeDwords)), this.glyphOffsetArray = new Cl, this.lineVertexArray = new Rl, this.symbolInstances = new El;
            }
            calculateGlyphDependencies(e1, t1, r, n, i) {
                for (const r of e1){
                    const e1 = r.codePointAt(0);
                    if (void 0 === e1) break;
                    if (t1[e1] = !0, n && i && e1 <= 65535) {
                        const e1 = Sg[r];
                        e1 && (t1[e1.charCodeAt(0)] = !0);
                    }
                }
            }
            calculateEffectiveAppearanceIconSize(e1, t1, r, n, i, s, a) {
                if (!e1.hasLayoutProperty("icon-size")) return a * s;
                let o = 1;
                const l = e1.getUnevaluatedLayoutProperty("icon-size"), u = fx(this.zoom, l, this.worldview, i), c = yx(u, t1);
                if ("constant" !== u.kind && "camera" !== u.kind || (o = c.uSize), "composite" === u.kind) {
                    const { minZoom: e1, maxZoom: t1 } = u, s = l.possiblyEvaluate(new to(e1, {
                        worldview: this.worldview
                    }), n), a = l.possiblyEvaluate(new to(t1, {
                        worldview: this.worldview
                    }), n), h = s.evaluate(r, {}, n, i);
                    o = h + (a.evaluate(r, {}, n, i) - h) * c.uSizeT;
                }
                return "source" === u.kind && (o = l.possiblyEvaluate(new to(this.zoom, {
                    worldview: this.worldview
                }), n).evaluate(r, {}, n, i)), o * s;
            }
            updateFootprints(e1, t1) {}
            updateReplacement(e1, t1) {
                if (t1.updateTime === this.replacementUpdateTime) return !1;
                this.replacementUpdateTime = t1.updateTime;
                const r = t1.getReplacementRegionsForTile(e1.toUnwrapped(), !0);
                return !Wp(this.activeReplacements, r) && (this.activeReplacements = r, !0);
            }
            getResolvedImageFromTokens(e1) {
                return "string" == typeof e1 ? jr.build(e1) : e1;
            }
            populate(e1, t1, r, n) {
                const i = this.layers[0], s = i.layout, a = "globe" === this.projection.name, o = s.get("text-font"), l = s.get("text-field"), u = s.get("icon-image"), [c, h] = s.get("icon-size-scale-range"), d = Ee(t1.scaleFactor || 1, c, h), [p, f] = s.get("text-size-scale-range"), m = Ee(t1.scaleFactor || 1, p, f), y = ("constant" !== l.value.kind || l.value.value instanceof Ur && !l.value.value.isEmpty() || l.value.value.toString().length > 0) && ("constant" !== o.value.kind || o.value.value.length > 0), g = "constant" !== u.value.kind || !!u.value.value || Object.keys(u.parameters).length > 0, x = this.hasAnyAppearanceLayoutProperty("icon-image"), v = s.get("symbol-sort-key");
                if (this.features = [], this.featureAppearanceData = new Map, !y && !g && !x) return;
                const b = t1.iconDependencies, w = t1.glyphDependencies, _ = t1.availableImages, A = new to(this.zoom, {
                    worldview: this.worldview,
                    activeFloors: t1.activeFloors
                }), I = (e1)=>{
                    const t1 = e1.id.toString();
                    b.has(t1) ? b.get(t1).push(e1) : b.set(t1, [
                        e1
                    ]);
                };
                for (const t1 of e1){
                    const { feature: e1, id: l, index: u, sourceLayerIndex: c } = t1, h = i._featureFilter.needGeometry, p = ac(e1, h);
                    if (!i._featureFilter.filter(A, p, r)) continue;
                    if (h || (p.geometry = sc(e1, r, n)), a && 1 !== e1.type && r.z <= 5) {
                        const e1 = p.geometry, t1 = .98078528056, n = (e1, n)=>O(Ih(e1.x, e1.y, r, 1), Ih(n.x, n.y, r, 1)) < t1;
                        for(let t1 = 0; t1 < e1.length; t1++)e1[t1] = tc(e1[t1], n);
                    }
                    let f, M;
                    if (y) {
                        const e1 = i.getValueAndResolveTokens("text-field", p, r, _), t1 = Ur.factory(e1);
                        ob(t1) && (this.hasRTLText = !0), (!this.hasRTLText || "unavailable" === Ja() || this.hasRTLText && Qa.isParsed()) && (f = Bg(t1, i, p));
                    }
                    if (g) {
                        const e1 = i.getValueAndResolveTokens("icon-image", p, r, _);
                        M = this.getResolvedImageFromTokens(e1);
                    }
                    const B = this.layers[0];
                    let S = !1;
                    if (!M && x) {
                        const e1 = B.getAppearances();
                        for (const t1 of e1)if (t1.getLayoutProperty("icon-image")) {
                            const e1 = B.getAppearanceValueAndResolveTokens(t1, "icon-image", p, r, _);
                            if (e1) {
                                M = this.getResolvedImageFromTokens(e1), S = !0;
                                break;
                            }
                        }
                    }
                    if (!f && !M) continue;
                    const P = this.sortFeaturesByKey ? v.evaluate(p, {}, r) : void 0, T = {
                        id: l,
                        text: f,
                        icon: M,
                        index: u,
                        sourceLayerIndex: c,
                        geometry: p.geometry,
                        properties: e1.properties,
                        type: eb[e1.type],
                        sortKey: P
                    };
                    if (this.features.push(T), this.featureAppearanceData.set(u, {
                        id: l,
                        properties: e1.properties,
                        usesAppearanceIconAsPlaceholder: S,
                        isUsingAppearanceIconVertexData: !1,
                        isUsingAppearanceTextVertexData: !1,
                        layoutBasedIconVertexData: new Uint16Array(0),
                        layoutBasedTextVertexData: new Uint16Array(0),
                        activeAppearanceIndex: -2
                    }), M) {
                        const e1 = B._unevaluatedLayout._values, { iconPrimary: t1, iconSecondary: n } = dv(M, this.iconSizeData, e1["icon-size"], r, this.zoom, T, this.pixelRatio, d, this.worldview, _);
                        I(t1), n && (this.hasAnySecondaryIcon = !0, I(n));
                    }
                    const z = B.getAppearances();
                    if (0 !== z.length && z.forEach((e1)=>{
                        if (!e1.getLayoutProperty("icon-image")) return;
                        const t1 = this.getCombinedIconPrimary(e1, B, p, r, _, T, d);
                        t1 && I(t1);
                    }), f) {
                        const e1 = o.evaluate(p, {}, r).join(","), t1 = "map" === s.get("text-rotation-alignment") && "point" !== s.get("symbol-placement");
                        this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(Zg.vertical) >= 0;
                        for (const r of f.sections)if (r.image) {
                            const e1 = r.image.getPrimary().scaleSelf(this.pixelRatio * m), t1 = e1.id.toString(), n = b.get(t1) || [];
                            n.push(e1), b.set(t1, n);
                        } else {
                            const n = Fa(f.toString()), i = r.fontStack || e1, s = w[i] = w[i] || {};
                            this.calculateGlyphDependencies(r.text, s, t1, this.allowVerticalPlacement, n);
                        }
                    }
                }
                if ("line" === s.get("symbol-placement") && (this.features = function(e1) {
                    const t1 = {}, r = {}, n = [];
                    let i = 0;
                    function s(t1) {
                        n.push(e1[t1]), i++;
                    }
                    function a(e1, t1, i) {
                        const s = r[e1];
                        return delete r[e1], r[t1] = s, n[s].geometry[0].pop(), n[s].geometry[0] = n[s].geometry[0].concat(i[0]), s;
                    }
                    function o(e1, r, i) {
                        const s = t1[r];
                        return delete t1[r], t1[e1] = s, n[s].geometry[0].shift(), n[s].geometry[0] = i[0].concat(n[s].geometry[0]), s;
                    }
                    function l(e1, t1, r) {
                        const n = r ? t1[0][t1[0].length - 1] : t1[0][0];
                        return `${e1}:${n.x}:${n.y}`;
                    }
                    for(let u = 0; u < e1.length; u++){
                        const c = e1[u], h = c.geometry, d = c.text ? c.text.toString() : null;
                        if (!d) {
                            s(u);
                            continue;
                        }
                        const p = l(d, h), f = l(d, h, !0);
                        if (p in r && f in t1 && r[p] !== t1[f]) {
                            const e1 = o(p, f, h), i = a(p, f, n[e1].geometry);
                            delete t1[p], delete r[f], r[l(d, n[i].geometry, !0)] = i, n[e1].geometry = null;
                        } else p in r ? a(p, f, h) : f in t1 ? o(p, f, h) : (s(u), t1[p] = i - 1, r[f] = i - 1);
                    }
                    return n.filter((e1)=>e1.geometry);
                }(this.features)), "hd-road-markup" === s.get("symbol-elevation-reference")) {
                    if (this.elevationType = "road", t1.elevationFeatures) {
                        !this.elevationFeatures && t1.elevationFeatures.length > 0 && (this.elevationFeatures = [], this.elevationFeatureIdToIndex = new Map);
                        for (const e1 of t1.elevationFeatures)this.elevationFeatureIdToIndex.set(e1.id, this.elevationFeatures.length), this.elevationFeatures.push(e1);
                    }
                } else s.get("symbol-z-elevate") && (this.elevationType = "offset");
                "none" !== this.elevationType && (this.zOffsetBuffersNeedUpload = !0), this.sortFeaturesByKey && this.features.sort((e1, t1)=>e1.sortKey - t1.sortKey);
            }
            getCombinedIconPrimary(e1, t1, r, n, i, s, a) {
                let o, l;
                if (e1.hasLayoutProperty("icon-image")) {
                    const s = t1.getAppearanceValueAndResolveTokens(e1, "icon-image", r, n, i);
                    o = this.getResolvedImageFromTokens(s);
                } else {
                    const e1 = t1.getValueAndResolveTokens("icon-image", r, n, i);
                    o = this.getResolvedImageFromTokens(e1);
                }
                if (o) {
                    const r = e1.hasLayoutProperty("icon-size") ? e1.getUnevaluatedLayoutProperty("icon-size") : t1._unevaluatedLayout._values["icon-size"];
                    l = dv(o, fx(this.zoom, r, this.worldview, i), r, n, this.zoom, s, this.pixelRatio, a, this.worldview, i).iconPrimary;
                }
                return l;
            }
            updateSymbolInstanceIconVertices(e1, t1, r, n, i, s) {
                const { canonical: a, availableImages: o, globalProperties: l, layer: u, iconScaleFactor: c, featureState: h, layoutIconOffset: d, layoutIconSize: p, layoutIconRotate: f } = s;
                if (e1.placedIconSymbolIndex < 0) return {
                    vertexOffsetDelta: 0,
                    hasChanges: !1
                };
                if (t1.activeAppearanceIndex === r) return {
                    vertexOffsetDelta: e1.numIconVertices,
                    hasChanges: !1
                };
                const m = r >= 0 ? u.appearances[r] : null;
                if (m) {
                    const r = this.getCombinedIconPrimary(m, u, n, a, o, {
                        sortKey: void 0,
                        text: void 0,
                        icon: null,
                        index: e1.featureIndex,
                        sourceLayerIndex: e1.featureIndex,
                        geometry: [],
                        properties: t1.properties,
                        type: "Point",
                        id: t1.id
                    }, c);
                    if (!r) return {
                        vertexOffsetDelta: 0,
                        hasChanges: !1
                    };
                    const s = r.toString(), y = this.iconAtlasPositions && this.iconAtlasPositions.get(s);
                    if (y) {
                        const { appearanceIconOffset: r, appearanceIconRotate: s } = ov(m, u, n, a, d, f, p, c);
                        let g = lx(y, void 0, r, u.layout.get("icon-anchor").evaluate(n, h, a));
                        const x = y.sdf, v = u.layout.get("icon-text-fit").constantOr("none");
                        "none" !== v && t1.textShaping && t1.iconTextFitPadding && t1.fontScale && (g = ux(g, t1.textShaping, v, t1.iconTextFitPadding, r, t1.fontScale));
                        const b = this.calculateEffectiveAppearanceIconSize(m, l.zoom, n, a, o, c, p), w = 0, _ = 1 + (Math.min(_v, Math.round(b * px)) << 1), A = jx(g, s, x, "none" !== v, c);
                        t1.isUsingAppearanceIconVertexData || (t1.isUsingAppearanceIconVertexData = !0, t1.layoutBasedIconVertexData = this.icon.snapshotSymbolVertexData(i, e1.numIconVertices));
                        const I = Math.floor(e1.numIconVertices / 4), M = Math.min(A.length, I);
                        let B = i;
                        for(let r = 0; r < M; ++r){
                            const n = A[r], i = t1.layoutBasedIconVertexData[0] || e1.tileAnchorX, s = t1.layoutBasedIconVertexData[1] || e1.tileAnchorY, a = 16 * n.pixelOffsetTL.x, o = 16 * n.pixelOffsetTL.y, l = 16 * n.pixelOffsetBR.x, u = 16 * n.pixelOffsetBR.y, c = 16 * n.minFontScaleX, h = 16 * n.minFontScaleY;
                            this.icon.updateSymbolVertexData(B, i, s, Math.round(32 * n.tl.x), Math.round(32 * n.tl.y), n.texPrimary.x, n.texPrimary.y, w, _, a, o, c, h), this.icon.updateSymbolVertexData(B + 1, i, s, Math.round(32 * n.tr.x), Math.round(32 * n.tr.y), n.texPrimary.x + n.texPrimary.w, n.texPrimary.y, w, _, l, o, c, h), this.icon.updateSymbolVertexData(B + 2, i, s, Math.round(32 * n.bl.x), Math.round(32 * n.bl.y), n.texPrimary.x, n.texPrimary.y + n.texPrimary.h, w, _, a, u, c, h), this.icon.updateSymbolVertexData(B + 3, i, s, Math.round(32 * n.br.x), Math.round(32 * n.br.y), n.texPrimary.x + n.texPrimary.w, n.texPrimary.y + n.texPrimary.h, w, _, l, u, c, h), B += 4;
                        }
                        const S = e1.numIconVertices - 4 * M;
                        for(let e1 = 0; e1 < S; ++e1)this.icon.updateSymbolVertexData(B + e1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                        return {
                            vertexOffsetDelta: e1.numIconVertices,
                            hasChanges: !0
                        };
                    }
                } else {
                    if (t1.usesAppearanceIconAsPlaceholder) return this.icon.updateSymbolVertexData(i, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0), this.icon.updateSymbolVertexData(i + 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0), this.icon.updateSymbolVertexData(i + 2, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0), this.icon.updateSymbolVertexData(i + 3, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0), {
                        vertexOffsetDelta: e1.numIconVertices,
                        hasChanges: !0
                    };
                    if (t1.isUsingAppearanceIconVertexData) return this.icon.restoreSymbolVertexData(i, t1.layoutBasedIconVertexData), t1.isUsingAppearanceIconVertexData = !1, {
                        vertexOffsetDelta: t1.layoutBasedIconVertexData.length / lb,
                        hasChanges: !0
                    };
                }
                return {
                    vertexOffsetDelta: e1.numIconVertices,
                    hasChanges: !1
                };
            }
            updateSymbolInstanceTextVertices(e1, t1, r, n, i, s) {
                const { canonical: a, layer: o, textScaleFactor: l, imageMap: u, featureState: c, layoutTextOffset: h, layoutTextSize: d, layoutTextRotate: p, layoutMinZoomSize: f, layoutMaxZoomSize: m, layoutTextSizeMinZoom: y, layoutTextSizeMaxZoom: g, availableImages: x } = s, v = e1.numHorizontalGlyphVertices > 0 || e1.numVerticalGlyphVertices > 0;
                if (!v) return {
                    vertexOffsetDelta: v ? e1.numHorizontalGlyphVertices + e1.numVerticalGlyphVertices : 0,
                    hasChanges: !1
                };
                if (t1.activeAppearanceIndex === r) return {
                    vertexOffsetDelta: e1.numHorizontalGlyphVertices + e1.numVerticalGlyphVertices,
                    hasChanges: !1
                };
                const b = r >= 0 ? o.appearances[r] : null;
                if (b && t1.textShaping) {
                    const { appearanceTextOffset: r, appearanceTextRotate: s, appearanceTextSize: v } = uv(b, o, n, a, h, p, d);
                    t1.fontScale = vv(v, t1.textScaleFactor);
                    const w = b.getUnevaluatedLayoutProperty("text-size");
                    let _ = this.textSizeData, A = y, I = g;
                    b.hasLayoutProperty("text-size") && (_ = fx(this.zoom, w, this.worldview, x), A = "composite" === this.textSizeData.kind ? this.textSizeData.minZoom : 0, I = "composite" === this.textSizeData.kind ? this.textSizeData.maxZoom : 0);
                    const M = t1.textShaping.bottom - h[1], B = t1.textShaping.left - h[0], S = t1.textShaping.right - h[0];
                    t1.textShaping.top = r[1] + (t1.textShaping.top - h[1]), t1.textShaping.bottom = r[1] + M, t1.textShaping.left = r[0] + B, t1.textShaping.right = r[0] + S;
                    const P = Yx(0, t1.textShaping, r, o, !1, n, u, this.allowVerticalPlacement, s), T = v && "composite" === _.kind ? w.possiblyEvaluate(new to(A, {}), a).evaluate(n, c, a) : f, z = v && "composite" === _.kind ? w.possiblyEvaluate(new to(I, {}), a).evaluate(n, c, a) : m, k = Iv(b.name, _, v, l, T, z), V = Array.isArray(k) ? k[1] : v, F = 0, D = 1 + (Math.min(_v, Math.round(V * px)) << 1);
                    t1.isUsingAppearanceTextVertexData || (t1.isUsingAppearanceTextVertexData = !0, t1.layoutBasedTextVertexData = this.text.snapshotSymbolVertexData(i, e1.numHorizontalGlyphVertices + e1.numVerticalGlyphVertices));
                    for(let t1 = 0; t1 < P.length && t1 < (e1.numHorizontalGlyphVertices + e1.numVerticalGlyphVertices) / 4; ++t1){
                        const r = P[t1], n = r.glyphOffset[1], s = e1.tileAnchorX, a = e1.tileAnchorY, o = i + 4 * t1;
                        this.text.updateSymbolVertexData(o, s, a, Math.round(32 * r.tl.x), Math.round(32 * (n + r.tl.y)), r.texPrimary.x, r.texPrimary.y, F, D, r.pixelOffsetTL.x, r.pixelOffsetTL.y, r.minFontScaleX, r.minFontScaleY), this.text.updateSymbolVertexData(o + 1, s, a, Math.round(32 * r.tr.x), Math.round(32 * (n + r.tr.y)), r.texPrimary.x + r.texPrimary.w, r.texPrimary.y, F, D, r.pixelOffsetBR.x, r.pixelOffsetTL.y, r.minFontScaleX, r.minFontScaleY), this.text.updateSymbolVertexData(o + 2, s, a, Math.round(32 * r.bl.x), Math.round(32 * (n + r.bl.y)), r.texPrimary.x, r.texPrimary.y + r.texPrimary.h, F, D, r.pixelOffsetTL.x, r.pixelOffsetBR.y, r.minFontScaleX, r.minFontScaleY), this.text.updateSymbolVertexData(o + 3, s, a, Math.round(32 * r.br.x), Math.round(32 * (n + r.br.y)), r.texPrimary.x + r.texPrimary.w, r.texPrimary.y + r.texPrimary.h, F, D, r.pixelOffsetBR.x, r.pixelOffsetBR.y, r.minFontScaleX, r.minFontScaleY);
                    }
                    return {
                        vertexOffsetDelta: e1.numHorizontalGlyphVertices + e1.numVerticalGlyphVertices,
                        hasChanges: !0
                    };
                }
                return t1.isUsingAppearanceTextVertexData ? (this.text.restoreSymbolVertexData(i, t1.layoutBasedTextVertexData), t1.isUsingAppearanceTextVertexData = !1, {
                    vertexOffsetDelta: t1.layoutBasedTextVertexData.length / lb,
                    hasChanges: !0
                }) : {
                    vertexOffsetDelta: e1.numHorizontalGlyphVertices + e1.numVerticalGlyphVertices,
                    hasChanges: !1
                };
            }
            update(e1, t1, r, n, i, s, a, o) {
                if (this.text.programConfigurations.updatePaintArrays(e1, t1, i, r, n, s, a, this.worldview), this.icon.programConfigurations.updatePaintArrays(e1, t1, i, r, n, s, a, this.worldview), o) {
                    if (s) this.text.uboBinder && this.text.uboBinder.updateDynamicExpressions(i[0], t1, o, r, e1, a), this.icon.uboBinder && this.icon.uboBinder.updateDynamicExpressions(i[0], t1, o, r, e1, a);
                    else if (Object.keys(e1).length > 0) {
                        const n = new Set(Object.keys(e1).map((e1)=>{
                            const t1 = Number(e1);
                            return !isNaN(t1) && Number.isSafeInteger(t1) && String(t1) === e1 ? t1 : e1;
                        }));
                        this.text.uboBinder && this.text.uboBinder.updateFeatures(n, i[0], t1, o, r, e1, a), this.icon.uboBinder && this.icon.uboBinder.updateFeatures(n, i[0], t1, o, r, e1, a);
                    }
                }
            }
            updateRoadElevation(e1) {
                if ("road" !== this.elevationType || !this.elevationFeatures) return;
                if (this.elevationStateComplete) return;
                this.elevationStateComplete = !0, this.hasAnyZOffset = !1;
                let t1 = !1;
                const r = Yu(e1), n = 1 / r;
                let i = !1, s = !1;
                for(let e1 = 0; e1 < this.symbolInstances.length; e1++){
                    const a = this.symbolInstances.get(e1), o = M(1, 0, 0), l = M(0, 1, 0), { numHorizontalGlyphVertices: u, numVerticalGlyphVertices: c, numIconVertices: h, numVerticalIconVertices: d } = a, p = u > 0 || c > 0, f = h > 0, m = this.elevationFeatures[a.elevationFeatureIndex];
                    if (m) {
                        const e1 = new Me(a.tileAnchorX, a.tileAnchorY), u = .075 + m.pointElevation(e1);
                        a.zOffset !== u && (t1 = !0, a.zOffset = u), 0 !== u && (this.hasAnyZOffset = !0);
                        const c = m.computeSlopeNormal(e1, n), h = ue(te(), M(0, 0, 1), c);
                        $(o, o, h), $(l, l, h), o[2] *= r, l[2] *= r, 1 === o[0] && 0 === o[1] && 0 === o[2] && 0 === l[0] && 1 === l[1] && 0 === l[2] || (i = i || p, s = s || f);
                    }
                    if (p && (sb(this.text.orientationVertexArray, u, o, l), sb(this.text.orientationVertexArray, c, o, l)), f) {
                        const { placedIconSymbolIndex: e1, verticalPlacedIconSymbolIndex: t1 } = a;
                        e1 >= 0 && sb(this.icon.orientationVertexArray, h, o, l), t1 >= 0 && sb(this.icon.orientationVertexArray, d, o, l);
                    }
                }
                i || (this.text.orientationVertexArray = void 0), s || (this.icon.orientationVertexArray = void 0), t1 && (this.zOffsetBuffersNeedUpload = !0, this.zOffsetSortDirty = !0);
            }
            updateZOffset() {
                const e1 = (e1, t1, n)=>{
                    r += t1, r > e1.length && e1.resize(r);
                    for(let i = -t1; i < 0; i++)e1.emplace(i + r, n);
                }, t1 = (e1, t1, r)=>{
                    n += t1, n > e1.length && e1.resize(n);
                    for(let i = -t1; i < 0; i++)e1.emplace(i + n, r);
                };
                if (!this.zOffsetBuffersNeedUpload) return;
                this.zOffsetBuffersNeedUpload = !1;
                let r = 0, n = 0;
                for(let r = 0; r < this.symbolInstances.length; r++){
                    const n = this.symbolInstances.get(r), { numHorizontalGlyphVertices: i, numVerticalGlyphVertices: s, numIconVertices: a } = n, o = n.zOffset, l = a > 0;
                    if ((i > 0 || s > 0) && (e1(this.text.zOffsetVertexArray, i, o), e1(this.text.zOffsetVertexArray, s, o)), l) {
                        const { placedIconSymbolIndex: e1, verticalPlacedIconSymbolIndex: r } = n;
                        e1 >= 0 && t1(this.icon.zOffsetVertexArray, a, o), r >= 0 && t1(this.icon.zOffsetVertexArray, n.numVerticalIconVertices, o);
                    }
                }
                this.text.zOffsetVertexBuffer && this.text.zOffsetVertexBuffer.updateData(this.text.zOffsetVertexArray), this.icon.zOffsetVertexBuffer && this.icon.zOffsetVertexBuffer.updateData(this.icon.zOffsetVertexArray);
            }
            isEmpty() {
                return 0 === this.symbolInstances.length && !this.hasRTLText;
            }
            uploadPending() {
                return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
            }
            upload(e1, t1, r, n, i) {
                !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(e1), this.iconCollisionBox.upload(e1)), this.text.upload(e1, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload, this.hasAppearances), null === this.hasAppearances && (this.hasAppearances = this.layers.some((e1)=>e1.appearances && e1.appearances.length > 0)), this.icon.upload(e1, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload, this.zOffsetBuffersNeedUpload, this.hasAppearances), this.uploaded = !0;
            }
            updateAppearances(e1, t1, r, n, i, s = !1) {
                const a = {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
                if (!e1 || !r || !this.featureAppearanceData) return a;
                const o = t1 || {}, l = this.icon.layoutVertexArray && this.icon.layoutVertexArray.length > 0 && this.icon.layoutVertexArray.arrayBuffer, u = this.text.layoutVertexArray && this.text.layoutVertexArray.length > 0 && this.text.layoutVertexArray.arrayBuffer;
                if (!l && !u) return a;
                const c = this.layers[0], h = c.layout;
                this.featureAppearances && this.featureAppearances.appearancesVersion === c.appearancesVersion || (this.featureAppearances = new Qv(c.appearances, c.appearancesVersion));
                const d = this.featureAppearances.update(n, s);
                if ("no-changes" === d.kind) return a;
                let p = 1, f = 0, m = !1, y = !1;
                if (l) {
                    const [e1, t1] = h.get("icon-size-scale-range");
                    p = Ee(1, e1, t1);
                }
                let g = 1, x = 0, v = !1;
                if (u) {
                    const [e1, t1] = h.get("text-size-scale-range");
                    g = Ee(1, e1, t1);
                }
                const b = new Map;
                if (i && r) for (const e1 of r){
                    const t1 = i.getImage(e1, c.scope);
                    if (t1) {
                        const r = new Nr(e1.toString());
                        b.set(r.toString(), t1);
                    }
                }
                for(let t1 = 0; t1 < this.symbolInstances.length; t1++){
                    const i = this.symbolInstances.get(t1), s = this.getAppearanceFeatureData(i.featureIndex);
                    if (!s) continue;
                    const a = s.id, w = void 0 !== a ? o[String(a)] : void 0, _ = {
                        type: "Point",
                        id: s.id,
                        properties: s.properties,
                        geometry: []
                    };
                    let A;
                    if ("all-features" === d.kind) A = d.appearanceIndex;
                    else {
                        const t1 = c.appearances ? c.appearances.findIndex((t1)=>t1.isActive({
                                globals: n,
                                feature: _,
                                canonical: e1,
                                featureState: w
                            })) : -1;
                        A = t1 >= 0 ? t1 : -1;
                    }
                    const I = s.activeAppearanceIndex !== A;
                    if (u) {
                        const t1 = h.get("text-size"), n = "composite" === this.textSizeData.kind ? this.textSizeData.minZoom : 0, a = "composite" === this.textSizeData.kind ? this.textSizeData.maxZoom : 0, o = {
                            canonical: e1,
                            layer: c,
                            featureState: w,
                            availableImages: r,
                            textScaleFactor: g,
                            imageMap: b,
                            layoutTextOffset: h.get("text-offset").evaluate(_, w, e1).map((e1)=>e1 * Mg),
                            layoutTextSize: t1.evaluate(_, w, e1),
                            layoutTextRotate: h.get("text-rotate").evaluate(_, w, e1),
                            layoutMinZoomSize: t1.evaluate(_, {
                                zoom: n
                            }, e1),
                            layoutMaxZoomSize: t1.evaluate(_, {
                                zoom: a
                            }, e1),
                            layoutTextSizeMinZoom: n,
                            layoutTextSizeMaxZoom: a
                        }, l = this.updateSymbolInstanceTextVertices(i, s, A, _, x, o);
                        x += l.vertexOffsetDelta, v = v || l.hasChanges;
                    }
                    if (l) {
                        const t1 = {
                            canonical: e1,
                            layer: c,
                            featureState: w,
                            availableImages: r,
                            globalProperties: n,
                            iconScaleFactor: p,
                            layoutIconOffset: h.get("icon-offset").evaluate(_, w, e1),
                            layoutIconSize: h.get("icon-size").evaluate(_, w, e1, r),
                            layoutIconRotate: h.get("icon-rotate").evaluate(_, w, e1)
                        }, a = this.updateSymbolInstanceIconVertices(i, s, A, _, f, t1);
                        f += a.vertexOffsetDelta, m = m || a.hasChanges;
                    }
                    if (I) {
                        const t1 = i.featureIndex, s = n ? n.brightness : null, a = w || {}, o = A >= 0 ? c.appearances[A] : null;
                        this.text.uboBinder && (this.text.uboBinder.layer = c, y = this.text.uboBinder.updateFeaturePaintForAppearance(t1, _, a, e1, r, s, o) || y), this.icon.uboBinder && (this.icon.uboBinder.layer = c, y = this.icon.uboBinder.updateFeaturePaintForAppearance(t1, _, a, e1, r, s, o) || y);
                    }
                    s.activeAppearanceIndex = A;
                }
                return m && this.icon.layoutVertexBuffer && null !== this.icon.layoutVertexArray.arrayBuffer && this.icon.layoutVertexArray.length === this.icon.layoutVertexBuffer.length && this.icon.layoutVertexBuffer.updateData(this.icon.layoutVertexArray), v && this.text.layoutVertexBuffer && null !== this.text.layoutVertexArray.arrayBuffer && this.text.layoutVertexArray.length === this.text.layoutVertexBuffer.length && this.text.layoutVertexBuffer.updateData(this.text.layoutVertexArray), {
                    hasLayoutChanges: m || v,
                    hasUboChanges: y
                };
            }
            destroyDebugData() {
                this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
            }
            getProjection() {
                return this.projectionInstance || (this.projectionInstance = Kv(this.projection)), this.projectionInstance;
            }
            destroy() {
                this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
            }
            addToLineVertexArray(e1, t1) {
                const r = this.lineVertexArray.length;
                if (void 0 !== e1.segment) for (const { x: e1, y: r } of t1)this.lineVertexArray.emplaceBack(e1, r);
                return {
                    lineStartIndex: r,
                    lineLength: this.lineVertexArray.length - r
                };
            }
            addSymbols(e1, t1, r, n, i, s, a, o, l, u, c, h, d, p, f, m, y, g) {
                const x = e1.indexArray, v = e1.layoutVertexArray, b = e1.globeExtVertexArray, w = g, _ = e1.uboBinder ? e1.uboBinder.getCurrentBatchIndex() : void 0, A = e1.segments.prepareSegment(4 * w, v, x, this.canOverlap ? s.sortKey : void 0, _), I = this.glyphOffsetArray.length, M = A.vertexLength, B = this.allowVerticalPlacement && a === Zg.vertical ? Math.PI / 2 : 0, S = s.text && s.text.sections;
                let P = v.length, T = -1;
                for(let n = 0; n < t1.length; n++){
                    const { tl: i, tr: a, bl: u, br: c, texPrimary: h, texSecondary: y, pixelOffsetTL: g, pixelOffsetBR: w, minFontScaleX: _, minFontScaleY: I, glyphOffset: M, isSDF: z, sectionIndex: k } = t1[n], V = A.vertexLength, F = M[1];
                    if (rb(v, l.x, l.y, i.x, F + i.y, h.x, h.y, r, z, g.x, g.y, _, I), rb(v, l.x, l.y, a.x, F + a.y, h.x + h.w, h.y, r, z, w.x, g.y, _, I), rb(v, l.x, l.y, u.x, F + u.y, h.x, h.y + h.h, r, z, g.x, w.y, _, I), rb(v, l.x, l.y, c.x, F + c.y, h.x + h.w, h.y + h.h, r, z, w.x, w.y, _, I), o) {
                        const { x: t1, y: r, z: n } = o.anchor, [i, s, a] = o.up;
                        ib(b, t1, r, n, i, s, a), ib(b, t1, r, n, i, s, a), ib(b, t1, r, n, i, s, a), ib(b, t1, r, n, i, s, a), ab(e1.dynamicLayoutVertexArray, t1, r, n, B);
                    } else ab(e1.dynamicLayoutVertexArray, l.x, l.y, l.z, B);
                    if (m) {
                        const t1 = y || h;
                        nb(e1.iconTransitioningVertexArray, t1.x, t1.y), nb(e1.iconTransitioningVertexArray, t1.x + t1.w, t1.y), nb(e1.iconTransitioningVertexArray, t1.x, t1.y + t1.h), nb(e1.iconTransitioningVertexArray, t1.x + t1.w, t1.y + t1.h);
                    }
                    if (x.emplaceBack(V, V + 1, V + 2), x.emplaceBack(V + 1, V + 2, V + 3), A.vertexLength += 4, A.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(M[0]), (n === t1.length - 1 || k !== t1[n + 1].sectionIndex) && (e1.programConfigurations.populatePaintArrays(v.length, s, s.index, {}, d, p, f, S && S[k], this.worldview), e1.uboBinder && e1.featureIdArray)) {
                        const t1 = e1.uboBinder.populateUBO(s, s.index, p, d, f, S && S[k], void 0);
                        T = t1;
                        const r = v.length - P;
                        for(let n = 0; n < r; n++)e1.featureIdArray.emplaceBack(t1);
                        P = v.length;
                    }
                }
                const z = g - t1.length;
                if (0 !== z && (this._addNullVertices(z, v, r, o, b, e1, m, A, x), e1.uboBinder && e1.featureIdArray && T >= 0)) {
                    const t1 = 4 * z;
                    for(let r = 0; r < t1; r++)e1.featureIdArray.emplaceBack(T);
                }
                const k = o ? o.anchor : l;
                e1.placedSymbolArray.emplaceBack(k.x, k.y, k.z, l.x, l.y, I, this.glyphOffsetArray.length - I, M, u, c, l.segment, r ? r[0] : 0, r ? r[1] : 0, n[0], n[1], a, 0, 0, 0, h, 0), e1.symbolInstanceIndices.push(y);
            }
            _addNullVertices(e1, t1, r, n, i, s, a, o, l) {
                for(let u = 0; u < e1; u++){
                    for(let e1 = 0; e1 < 4; e1++)rb(t1, 0, 0, 0, 0, 0, 0, r, !1, 0, 0, 0, 0), n ? (ib(i, 0, 0, 0, 0, 0, 0), ab(s.dynamicLayoutVertexArray, 0, 0, 0, 0)) : ab(s.dynamicLayoutVertexArray, 0, 0, 0, 0), a && nb(s.iconTransitioningVertexArray, 0, 0);
                    const e1 = o.vertexLength;
                    l.emplaceBack(e1, e1 + 1, e1 + 2), l.emplaceBack(e1 + 1, e1 + 2, e1 + 3), o.vertexLength += 4, o.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(0);
                }
            }
            _commitLayoutVertex(e1, t1, r, n, i, s, a) {
                e1.emplaceBack(t1, r, n, i, s, Math.round(a.x), Math.round(a.y));
            }
            _addCollisionDebugVertices(e1, t1, r, n, i, s, a) {
                const o = r.segments.prepareSegment(4, r.layoutVertexArray, r.indexArray), l = o.vertexLength, u = a.tileAnchorX, c = a.tileAnchorY;
                for(let e1 = 0; e1 < 4; e1++)r.collisionVertexArray.emplaceBack(0, 0, 0, 0, 0, 0);
                this._commitDebugCollisionVertexUpdate(r.collisionVertexArrayExt, t1, e1.padding, a.zOffset), this._commitLayoutVertex(r.layoutVertexArray, n, i, s, u, c, new Me(e1.x1, e1.y1)), this._commitLayoutVertex(r.layoutVertexArray, n, i, s, u, c, new Me(e1.x2, e1.y1)), this._commitLayoutVertex(r.layoutVertexArray, n, i, s, u, c, new Me(e1.x2, e1.y2)), this._commitLayoutVertex(r.layoutVertexArray, n, i, s, u, c, new Me(e1.x1, e1.y2)), o.vertexLength += 4;
                const h = r.indexArray;
                h.emplaceBack(l, l + 1), h.emplaceBack(l + 1, l + 2), h.emplaceBack(l + 2, l + 3), h.emplaceBack(l + 3, l), o.primitiveLength += 4;
            }
            _addTextDebugCollisionBoxes(e1, t1, r, n, i, s) {
                for(let a = n; a < i; a++){
                    const n = r.get(a), i = this.getSymbolInstanceTextSize(e1, s, t1, a);
                    this._addCollisionDebugVertices(n, i, this.textCollisionBox, n.projectedAnchorX, n.projectedAnchorY, n.projectedAnchorZ, s);
                }
            }
            _addIconDebugCollisionBoxes(e1, t1, r, n, i, s) {
                for(let a = n; a < i; a++){
                    const n = r.get(a), i = this.getSymbolInstanceIconSize(e1, t1, s.placedIconSymbolIndex);
                    this._addCollisionDebugVertices(n, i, this.iconCollisionBox, n.projectedAnchorX, n.projectedAnchorY, n.projectedAnchorZ, s);
                }
            }
            generateCollisionDebugBuffers(e1, t1, r) {
                this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new cb(dl, xg.members, cl), this.iconCollisionBox = new cb(dl, xg.members, cl);
                const n = yx(this.iconSizeData, e1), i = yx(this.textSizeData, e1, r);
                for(let r = 0; r < this.symbolInstances.length; r++){
                    const s = this.symbolInstances.get(r);
                    this._addTextDebugCollisionBoxes(i, e1, t1, s.textBoxStartIndex, s.textBoxEndIndex, s), this._addTextDebugCollisionBoxes(i, e1, t1, s.verticalTextBoxStartIndex, s.verticalTextBoxEndIndex, s), this._addIconDebugCollisionBoxes(n, e1, t1, s.iconBoxStartIndex, s.iconBoxEndIndex, s), this._addIconDebugCollisionBoxes(n, e1, t1, s.verticalIconBoxStartIndex, s.verticalIconBoxEndIndex, s);
                }
            }
            getSymbolInstanceTextSize(e1, t1, r, n) {
                const i = this.text.placedSymbolArray.get(t1.rightJustifiedTextSymbolIndex >= 0 ? t1.rightJustifiedTextSymbolIndex : t1.centerJustifiedTextSymbolIndex >= 0 ? t1.centerJustifiedTextSymbolIndex : t1.leftJustifiedTextSymbolIndex >= 0 ? t1.leftJustifiedTextSymbolIndex : t1.verticalPlacedTextSymbolIndex >= 0 ? t1.verticalPlacedTextSymbolIndex : n), s = mx(this.textSizeData, e1, i) / Mg;
                return this.tilePixelRatio * s;
            }
            getSymbolInstanceIconSize(e1, t1, r) {
                const n = this.icon.placedSymbolArray.get(r), i = mx(this.iconSizeData, e1, n);
                return this.tilePixelRatio * i;
            }
            _commitDebugCollisionVertexUpdate(e1, t1, r, n) {
                e1.emplaceBack(t1, -r, -r, n), e1.emplaceBack(t1, r, -r, n), e1.emplaceBack(t1, r, r, n), e1.emplaceBack(t1, -r, r, n);
            }
            _updateTextDebugCollisionBoxes(e1, t1, r, n, i, s, a) {
                for(let a = n; a < i; a++){
                    const n = r.get(a), i = this.getSymbolInstanceTextSize(e1, s, t1, a);
                    this._commitDebugCollisionVertexUpdate(this.textCollisionBox.collisionVertexArrayExt, i, n.padding, s.zOffset);
                }
            }
            _updateIconDebugCollisionBoxes(e1, t1, r, n, i, s, a) {
                for(let a = n; a < i; a++){
                    const n = r.get(a), i = this.getSymbolInstanceIconSize(e1, t1, s.placedIconSymbolIndex);
                    this._commitDebugCollisionVertexUpdate(this.iconCollisionBox.collisionVertexArrayExt, i, n.padding, s.zOffset);
                }
            }
            updateCollisionDebugBuffers(e1, t1, r, n) {
                if (!this.hasDebugData()) return;
                this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexArrayExt.clear(), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexArrayExt.clear();
                const i = yx(this.iconSizeData, e1, n), s = yx(this.textSizeData, e1, r);
                for(let a = 0; a < this.symbolInstances.length; a++){
                    const o = this.symbolInstances.get(a);
                    this._updateTextDebugCollisionBoxes(s, e1, t1, o.textBoxStartIndex, o.textBoxEndIndex, o, r), this._updateTextDebugCollisionBoxes(s, e1, t1, o.verticalTextBoxStartIndex, o.verticalTextBoxEndIndex, o, r), this._updateIconDebugCollisionBoxes(i, e1, t1, o.iconBoxStartIndex, o.iconBoxEndIndex, o, n), this._updateIconDebugCollisionBoxes(i, e1, t1, o.verticalIconBoxStartIndex, o.verticalIconBoxEndIndex, o, n);
                }
                this.hasTextCollisionBoxData() && this.textCollisionBox.collisionVertexBufferExt && this.textCollisionBox.collisionVertexBufferExt.updateData(this.textCollisionBox.collisionVertexArrayExt), this.hasIconCollisionBoxData() && this.iconCollisionBox.collisionVertexBufferExt && this.iconCollisionBox.collisionVertexBufferExt.updateData(this.iconCollisionBox.collisionVertexArrayExt);
            }
            _deserializeCollisionBoxesForSymbol(e1, t1, r, n, i, s, a, o, l) {
                const u = {};
                if (t1 < r) {
                    const { x1: r, y1: n, x2: i, y2: s, padding: a, projectedAnchorX: o, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: d, featureIndex: p } = e1.get(t1);
                    u.textBox = {
                        x1: r,
                        y1: n,
                        x2: i,
                        y2: s,
                        padding: a,
                        projectedAnchorX: o,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: d
                    }, u.textFeatureIndex = p;
                }
                if (n < i) {
                    const { x1: t1, y1: r, x2: i, y2: s, padding: a, projectedAnchorX: o, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: d, featureIndex: p } = e1.get(n);
                    u.verticalTextBox = {
                        x1: t1,
                        y1: r,
                        x2: i,
                        y2: s,
                        padding: a,
                        projectedAnchorX: o,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: d
                    }, u.verticalTextFeatureIndex = p;
                }
                if (s < a) {
                    const { x1: t1, y1: r, x2: n, y2: i, padding: a, projectedAnchorX: o, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: d, featureIndex: p } = e1.get(s);
                    u.iconBox = {
                        x1: t1,
                        y1: r,
                        x2: n,
                        y2: i,
                        padding: a,
                        projectedAnchorX: o,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: d
                    }, u.iconFeatureIndex = p;
                }
                if (o < l) {
                    const { x1: t1, y1: r, x2: n, y2: i, padding: s, projectedAnchorX: a, projectedAnchorY: l, projectedAnchorZ: c, tileAnchorX: h, tileAnchorY: d, featureIndex: p } = e1.get(o);
                    u.verticalIconBox = {
                        x1: t1,
                        y1: r,
                        x2: n,
                        y2: i,
                        padding: s,
                        projectedAnchorX: a,
                        projectedAnchorY: l,
                        projectedAnchorZ: c,
                        tileAnchorX: h,
                        tileAnchorY: d
                    }, u.verticalIconFeatureIndex = p;
                }
                return u;
            }
            deserializeCollisionBoxes(e1) {
                this.collisionArrays = [];
                for(let t1 = 0; t1 < this.symbolInstances.length; t1++){
                    const r = this.symbolInstances.get(t1);
                    this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(e1, r.textBoxStartIndex, r.textBoxEndIndex, r.verticalTextBoxStartIndex, r.verticalTextBoxEndIndex, r.iconBoxStartIndex, r.iconBoxEndIndex, r.verticalIconBoxStartIndex, r.verticalIconBoxEndIndex));
                }
            }
            hasTextData() {
                return this.text.segments.get().length > 0;
            }
            hasIconData() {
                return this.icon.segments.get().length > 0;
            }
            hasDebugData() {
                return this.textCollisionBox && this.iconCollisionBox;
            }
            hasTextCollisionBoxData() {
                return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
            }
            hasIconCollisionBoxData() {
                return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
            }
            hasIconTextFit() {
                return this.hasAnyIconTextFit;
            }
            addIndicesForPlacedSymbol(e1, t1) {
                const r = e1.placedSymbolArray.get(t1), n = r.vertexStartIndex + 4 * r.numGlyphs;
                for(let t1 = r.vertexStartIndex; t1 < n; t1 += 4)e1.indexArray.emplaceBack(t1, t1 + 1, t1 + 2), e1.indexArray.emplaceBack(t1 + 1, t1 + 2, t1 + 3);
            }
            getSortedSymbolIndexes(e1) {
                if (this.sortedAngle === e1 && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                const t1 = Math.sin(e1), r = Math.cos(e1), n = [], i = [], s = [];
                for(let e1 = 0; e1 < this.symbolInstances.length; ++e1){
                    s.push(e1);
                    const a = this.symbolInstances.get(e1);
                    n.push(0 | Math.round(t1 * a.tileAnchorX + r * a.tileAnchorY)), i.push(a.featureIndex);
                }
                return s.sort((e1, t1)=>n[e1] - n[t1] || i[t1] - i[e1]), s;
            }
            getSortedIndexesByZOffset() {
                if (!this.zOffsetSortDirty) return this.symbolInstanceIndexesSortedZOffset;
                if (!this.symbolInstanceIndexesSortedZOffset) {
                    this.symbolInstanceIndexesSortedZOffset = [];
                    for(let e1 = 0; e1 < this.symbolInstances.length; ++e1)this.symbolInstanceIndexesSortedZOffset.push(e1);
                }
                return this.zOffsetSortDirty = !1, this.symbolInstanceIndexesSortedZOffset.sort((e1, t1)=>this.symbolInstances.get(t1).zOffset - this.symbolInstances.get(e1).zOffset);
            }
            addToSortKeyRanges(e1, t1) {
                const r = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                r && r.sortKey === t1 ? r.symbolInstanceEnd = e1 + 1 : this.sortKeyRanges.push({
                    sortKey: t1,
                    symbolInstanceStart: e1,
                    symbolInstanceEnd: e1 + 1
                });
            }
            sortFeatures(e1) {
                if (this.sortFeaturesByY && this.sortedAngle !== e1) {
                    if (this.text.segments.get().length > 1 || this.icon.segments.get().length > 1) this.sortFeaturesWithinSegments();
                    else {
                        this.symbolInstanceIndexes = this.getSortedSymbolIndexes(e1), this.sortedAngle = e1, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                        for (const e1 of this.symbolInstanceIndexes){
                            const t1 = this.symbolInstances.get(e1);
                            this.featureSortOrder.push(t1.featureIndex);
                            const { rightJustifiedTextSymbolIndex: r, centerJustifiedTextSymbolIndex: n, leftJustifiedTextSymbolIndex: i, verticalPlacedTextSymbolIndex: s, placedIconSymbolIndex: a, verticalPlacedIconSymbolIndex: o } = t1;
                            r >= 0 && this.addIndicesForPlacedSymbol(this.text, r), n >= 0 && n !== r && this.addIndicesForPlacedSymbol(this.text, n), i >= 0 && i !== n && i !== r && this.addIndicesForPlacedSymbol(this.text, i), s >= 0 && this.addIndicesForPlacedSymbol(this.text, s), a >= 0 && this.addIndicesForPlacedSymbol(this.icon, a), o >= 0 && this.addIndicesForPlacedSymbol(this.icon, o);
                        }
                        this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                    }
                }
            }
            getOrCreateSortedSymbolsByBatch(e1, t1) {
                const r = (this.text.uboBinder && this.text.uboBinder.maxFeaturesPerBatch > 0 ? this.text.uboBinder : this.icon.uboBinder && this.icon.uboBinder.maxFeaturesPerBatch > 0 ? this.icon.uboBinder : null).maxFeaturesPerBatch;
                if (this.symbolsByBatch) for (const r of this.symbolsByBatch.values())for (const n of r){
                    const r = this.symbolInstances.get(n.index);
                    n.rotatedY = 0 | Math.round(e1 * r.tileAnchorX + t1 * r.tileAnchorY);
                }
                else {
                    this.symbolsByBatch = new Map;
                    for(let n = 0; n < this.symbolInstances.length; n++){
                        const i = this.symbolInstances.get(n), s = Math.floor(n / r), a = 0 | Math.round(e1 * i.tileAnchorX + t1 * i.tileAnchorY);
                        this.symbolsByBatch.has(s) || this.symbolsByBatch.set(s, []), this.symbolsByBatch.get(s).push({
                            index: n,
                            rotatedY: a,
                            featureIndex: i.featureIndex
                        });
                    }
                }
                for (const e1 of this.symbolsByBatch.values())e1.sort((e1, t1)=>e1.rotatedY - t1.rotatedY || t1.featureIndex - e1.featureIndex);
                return this.symbolsByBatch;
            }
            rebuildTextSegmentIndices(e1, t1) {
                for (const r of e1){
                    const e1 = r.batchIndex;
                    if (void 0 === e1) continue;
                    const n = t1.get(e1);
                    if (!n) {
                        r.primitiveOffset = this.text.indexArray.length, r.primitiveLength = 0;
                        continue;
                    }
                    r.primitiveOffset = this.text.indexArray.length;
                    const i = this.text.indexArray.length;
                    for (const { index: e1 } of n){
                        const t1 = this.symbolInstances.get(e1), { rightJustifiedTextSymbolIndex: r, centerJustifiedTextSymbolIndex: n, leftJustifiedTextSymbolIndex: i, verticalPlacedTextSymbolIndex: s } = t1;
                        r >= 0 && this.addIndicesForPlacedSymbol(this.text, r), n >= 0 && n !== r && this.addIndicesForPlacedSymbol(this.text, n), i >= 0 && i !== n && i !== r && this.addIndicesForPlacedSymbol(this.text, i), s >= 0 && this.addIndicesForPlacedSymbol(this.text, s);
                    }
                    r.primitiveLength = this.text.indexArray.length - i;
                }
            }
            rebuildIconSegmentIndices(e1, t1) {
                for (const r of e1){
                    const e1 = r.batchIndex;
                    if (void 0 === e1) continue;
                    const n = t1.get(e1);
                    if (!n) {
                        r.primitiveOffset = this.icon.indexArray.length, r.primitiveLength = 0;
                        continue;
                    }
                    r.primitiveOffset = this.icon.indexArray.length;
                    const i = this.icon.indexArray.length;
                    for (const { index: e1 } of n){
                        const t1 = this.symbolInstances.get(e1), { placedIconSymbolIndex: r, verticalPlacedIconSymbolIndex: n } = t1;
                        r >= 0 && this.addIndicesForPlacedSymbol(this.icon, r), n >= 0 && this.addIndicesForPlacedSymbol(this.icon, n);
                    }
                    r.primitiveLength = this.icon.indexArray.length - i;
                }
            }
            sortFeaturesWithinSegments() {
                this.featureSortOrder = [];
                const e1 = Math.sin(this.sortedAngle), t1 = Math.cos(this.sortedAngle), r = this.getOrCreateSortedSymbolsByBatch(e1, t1), n = Array.from(r.keys()).sort((e1, t1)=>e1 - t1);
                for (const e1 of n){
                    const t1 = r.get(e1);
                    for (const { index: e1 } of t1){
                        const t1 = this.symbolInstances.get(e1);
                        this.featureSortOrder.push(t1.featureIndex);
                    }
                }
                this.text.indexArray.clear(), this.icon.indexArray.clear(), this.rebuildTextSegmentIndices(this.text.segments.get(), r), this.rebuildIconSegmentIndices(this.icon.segments.get(), r), this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
            }
            getElevationFeatureForText(e1) {
                const t1 = this.symbolInstances.get(this.text.symbolInstanceIndices[e1]).elevationFeatureIndex;
                let r;
                return this.elevationFeatures && t1 < this.elevationFeatures.length && (r = this.elevationFeatures[t1]), r;
            }
        }
        function db(e1, t1) {
            return t1.replace(/{([^{}]+)}/g, (t1, r)=>r in e1 ? String(e1[r]) : "");
        }
        let pb, fb, mb;
        ra(hb, "SymbolBucket", {
            omit: [
                "layers",
                "collisionBoxArray",
                "compareText",
                "features"
            ]
        }), hb.addDynamicAttributes = ab;
        class yb {
            constructor(e1){
                this.type = e1.property.overrides ? e1.property.overrides.runtimeType : wr, this.defaultValue = e1;
            }
            evaluate(e1) {
                if (e1.formattedSection) {
                    const t1 = this.defaultValue.property.overrides;
                    if (t1 && t1.hasOverride(e1.formattedSection)) return t1.getOverride(e1.formattedSection);
                }
                return e1.feature && e1.featureState ? this.defaultValue.evaluate(e1.feature, e1.featureState) : this.defaultValue.property.specification.default;
            }
            eachChild(e1) {
                this.defaultValue.isConstant() || e1(this.defaultValue.value._styleExpression.expression);
            }
            outputDefined() {
                return !1;
            }
            serialize() {
                return null;
            }
        }
        ra(yb, "FormatSectionOverride", {
            omit: [
                "defaultValue"
            ]
        });
        const gb = ()=>mb || (mb = {
                layout: pb || (pb = new fo({
                    "symbol-placement": new co(mo.layout_symbol["symbol-placement"]),
                    "symbol-spacing": new co(mo.layout_symbol["symbol-spacing"]),
                    "symbol-avoid-edges": new co(mo.layout_symbol["symbol-avoid-edges"]),
                    "symbol-sort-key": new ho(mo.layout_symbol["symbol-sort-key"]),
                    "symbol-z-order": new co(mo.layout_symbol["symbol-z-order"]),
                    "symbol-z-elevate": new co(mo.layout_symbol["symbol-z-elevate"]),
                    "symbol-elevation-reference": new co(mo.layout_symbol["symbol-elevation-reference"]),
                    "icon-allow-overlap": new co(mo.layout_symbol["icon-allow-overlap"]),
                    "icon-ignore-placement": new co(mo.layout_symbol["icon-ignore-placement"]),
                    "icon-optional": new co(mo.layout_symbol["icon-optional"]),
                    "icon-rotation-alignment": new co(mo.layout_symbol["icon-rotation-alignment"]),
                    "icon-size": new ho(mo.layout_symbol["icon-size"]),
                    "icon-size-scale-range": new co(mo.layout_symbol["icon-size-scale-range"]),
                    "icon-text-fit": new ho(mo.layout_symbol["icon-text-fit"]),
                    "icon-text-fit-padding": new ho(mo.layout_symbol["icon-text-fit-padding"]),
                    "icon-image": new ho(mo.layout_symbol["icon-image"]),
                    "icon-image-use-theme": new co({
                        type: "string",
                        default: "default",
                        "property-type": "data-constant"
                    }),
                    "icon-rotate": new ho(mo.layout_symbol["icon-rotate"]),
                    "icon-padding": new co(mo.layout_symbol["icon-padding"]),
                    "icon-keep-upright": new co(mo.layout_symbol["icon-keep-upright"]),
                    "icon-offset": new ho(mo.layout_symbol["icon-offset"]),
                    "icon-anchor": new ho(mo.layout_symbol["icon-anchor"]),
                    "icon-pitch-alignment": new co(mo.layout_symbol["icon-pitch-alignment"]),
                    "text-pitch-alignment": new co(mo.layout_symbol["text-pitch-alignment"]),
                    "text-rotation-alignment": new co(mo.layout_symbol["text-rotation-alignment"]),
                    "text-field": new ho(mo.layout_symbol["text-field"]),
                    "text-font": new ho(mo.layout_symbol["text-font"]),
                    "text-size": new ho(mo.layout_symbol["text-size"]),
                    "text-size-scale-range": new co(mo.layout_symbol["text-size-scale-range"]),
                    "text-max-width": new ho(mo.layout_symbol["text-max-width"]),
                    "text-line-height": new ho(mo.layout_symbol["text-line-height"]),
                    "text-letter-spacing": new ho(mo.layout_symbol["text-letter-spacing"]),
                    "text-justify": new ho(mo.layout_symbol["text-justify"]),
                    "text-radial-offset": new ho(mo.layout_symbol["text-radial-offset"]),
                    "text-variable-anchor": new co(mo.layout_symbol["text-variable-anchor"]),
                    "text-anchor": new ho(mo.layout_symbol["text-anchor"]),
                    "text-max-angle": new co(mo.layout_symbol["text-max-angle"]),
                    "text-writing-mode": new co(mo.layout_symbol["text-writing-mode"]),
                    "text-rotate": new ho(mo.layout_symbol["text-rotate"]),
                    "text-padding": new co(mo.layout_symbol["text-padding"]),
                    "text-keep-upright": new co(mo.layout_symbol["text-keep-upright"]),
                    "text-transform": new ho(mo.layout_symbol["text-transform"]),
                    "text-offset": new ho(mo.layout_symbol["text-offset"]),
                    "text-allow-overlap": new co(mo.layout_symbol["text-allow-overlap"]),
                    "text-ignore-placement": new co(mo.layout_symbol["text-ignore-placement"]),
                    "text-optional": new co(mo.layout_symbol["text-optional"]),
                    visibility: new co(mo.layout_symbol.visibility)
                })),
                paint: fb || (fb = new fo({
                    "icon-opacity": new ho(mo.paint_symbol["icon-opacity"]),
                    "icon-occlusion-opacity": new ho(mo.paint_symbol["icon-occlusion-opacity"]),
                    "icon-emissive-strength": new ho(mo.paint_symbol["icon-emissive-strength"]),
                    "text-emissive-strength": new ho(mo.paint_symbol["text-emissive-strength"]),
                    "icon-color": new ho(mo.paint_symbol["icon-color"]),
                    "icon-halo-color": new ho(mo.paint_symbol["icon-halo-color"]),
                    "icon-halo-width": new ho(mo.paint_symbol["icon-halo-width"]),
                    "icon-halo-blur": new ho(mo.paint_symbol["icon-halo-blur"]),
                    "icon-translate": new co(mo.paint_symbol["icon-translate"]),
                    "icon-translate-anchor": new co(mo.paint_symbol["icon-translate-anchor"]),
                    "icon-image-cross-fade": new co(mo.paint_symbol["icon-image-cross-fade"]),
                    "text-opacity": new ho(mo.paint_symbol["text-opacity"]),
                    "text-occlusion-opacity": new ho(mo.paint_symbol["text-occlusion-opacity"]),
                    "text-color": new ho(mo.paint_symbol["text-color"], {
                        runtimeType: Mr,
                        getOverride: (e1)=>e1.textColor,
                        hasOverride: (e1)=>!!e1.textColor
                    }),
                    "text-halo-color": new ho(mo.paint_symbol["text-halo-color"]),
                    "text-halo-width": new ho(mo.paint_symbol["text-halo-width"]),
                    "text-halo-blur": new ho(mo.paint_symbol["text-halo-blur"]),
                    "text-translate": new co(mo.paint_symbol["text-translate"]),
                    "text-translate-anchor": new co(mo.paint_symbol["text-translate-anchor"]),
                    "icon-color-saturation": new co(mo.paint_symbol["icon-color-saturation"]),
                    "icon-color-contrast": new co(mo.paint_symbol["icon-color-contrast"]),
                    "icon-color-brightness-min": new co(mo.paint_symbol["icon-color-brightness-min"]),
                    "icon-color-brightness-max": new co(mo.paint_symbol["icon-color-brightness-max"]),
                    "symbol-z-offset": new ho(mo.paint_symbol["symbol-z-offset"]),
                    "icon-color-use-theme": new ho({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "icon-halo-color-use-theme": new ho({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "text-color-use-theme": new ho({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    }),
                    "text-halo-color-use-theme": new ho({
                        type: "string",
                        default: "default",
                        "property-type": "data-driven"
                    })
                }))
            }, mb);
        class xb extends Uo {
            constructor(e1, t1, r, n){
                super(e1, gb(), t1, r, n, e1.layout ? e1.layout["icon-image-use-theme"] : null), this._colorAdjustmentMatrix = u([]), this.hasOcclusionOpacityProperties = void 0 !== e1.paint && ("icon-occlusion-opacity" in e1.paint || "text-occlusion-opacity" in e1.paint);
            }
            _handleSpecialPaintPropertyUpdate(e1) {
                "icon-occlusion-opacity" !== e1 && "text-occlusion-opacity" !== e1 || (this.hasOcclusionOpacityProperties = !0);
            }
            recalculate(e1, t1) {
                super.recalculate(e1, t1), this.appearances && this.appearances.forEach((r)=>{
                    r.recalculate(e1, t1, this.iconImageUseTheme);
                }), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = this.layout.get("text-rotation-alignment")), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment"));
                const r = this.layout.get("text-writing-mode");
                if (r) {
                    const e1 = [];
                    for (const t1 of r)e1.indexOf(t1) < 0 && e1.push(t1);
                    this.layout._values["text-writing-mode"] = e1;
                } else this.layout._values["text-writing-mode"] = "point" === this.layout.get("symbol-placement") ? [
                    "horizontal"
                ] : [
                    "horizontal",
                    "vertical"
                ];
                this._setPaintOverrides();
            }
            getColorAdjustmentMatrix(e1, t1, r, n) {
                return this._saturation === e1 && this._contrast === t1 && this._brightnessMin === r && this._brightnessMax === n || (this._colorAdjustmentMatrix = function(e1, t1, r, n) {
                    e1 = at(e1), t1 = st(t1);
                    const i = o(), s = e1 / 3, a = 1 - 2 * s, l = [
                        a,
                        s,
                        s,
                        0,
                        s,
                        a,
                        s,
                        0,
                        s,
                        s,
                        a,
                        0,
                        0,
                        0,
                        0,
                        1
                    ], u = .5 - .5 * t1, c = n - r;
                    return h(i, [
                        c,
                        0,
                        0,
                        0,
                        0,
                        c,
                        0,
                        0,
                        0,
                        0,
                        c,
                        0,
                        r,
                        r,
                        r,
                        1
                    ], [
                        t1,
                        0,
                        0,
                        0,
                        0,
                        t1,
                        0,
                        0,
                        0,
                        0,
                        t1,
                        0,
                        u,
                        u,
                        u,
                        1
                    ]), h(i, i, l), i;
                }(e1, t1, r, n), this._saturation = e1, this._contrast = t1, this._brightnessMin = r, this._brightnessMax = n), this._colorAdjustmentMatrix;
            }
            getValueAndResolveTokens(e1, t1, r, n) {
                const i = this.layout.get(e1).evaluate(t1, {}, r, n), s = this._unevaluatedLayout._values[e1];
                return s.isDataDriven() || $s(s.value) || !i ? i : db(t1.properties, i);
            }
            getAppearanceValueAndResolveTokens(e1, t1, r, n, i) {
                const s = e1.getLayoutProperty(t1);
                if (!s) return;
                const a = s.evaluate(r, {}, n, i), o = e1.getUnevaluatedLayoutProperties()._values[t1];
                return o.isDataDriven() || $s(o.value) || !a || "string" != typeof a ? a : db(r.properties, a);
            }
            createBucket(e1) {
                return new hb(e1);
            }
            queryRadius() {
                return 0;
            }
            queryIntersectsFeature() {
                return !1;
            }
            _setPaintOverrides() {
                for (const e1 of gb().paint.overridableProperties){
                    if (!xb.hasPaintOverride(this.layout, e1)) continue;
                    const t1 = this.paint.get(e1), r = new yb(t1), n = new Gs(r, t1.property.specification, this.scope, this.options, this.layout.get("icon-image-use-theme"));
                    let i = null;
                    i = "constant" === t1.value.kind || "source" === t1.value.kind ? new Hs("source", n) : new Xs("composite", n, t1.value.zoomStops, t1.value.interpolationType), this.paint._values[e1] = new lo(t1.property, i, t1.parameters);
                }
            }
            _handleOverridablePaintPropertyUpdate(e1, t1, r) {
                return !(!this.layout || t1.isDataDriven() || r.isDataDriven()) && xb.hasPaintOverride(this.layout, e1);
            }
            static hasPaintOverride(e1, t1) {
                const r = e1.get("text-field"), n = gb().paint.properties[t1];
                let i = !1;
                const s = (e1)=>{
                    for (const t1 of e1)if (n.overrides && n.overrides.hasOverride(t1)) return void (i = !0);
                };
                if ("constant" === r.value.kind && r.value.value instanceof Ur) s(r.value.value.sections);
                else if ("source" === r.value.kind) {
                    const e1 = (t1)=>{
                        i || (t1 instanceof Xr && qr(t1.value) === Tr ? s(t1.value.sections) : t1 instanceof Jr ? s(t1.sections) : t1.eachChild(e1));
                    }, t1 = r.value;
                    t1._styleExpression && e1(t1._styleExpression.expression);
                }
                return i;
            }
            getProgramIds() {
                return [
                    "symbol"
                ];
            }
            getDefaultProgramParams(e1, t1, r) {
                return {
                    config: new wu(this, {
                        zoom: t1,
                        lut: r
                    }),
                    overrideFog: !1
                };
            }
            hasElevation() {
                return this.layout && "hd-road-markup" === this.layout.get("symbol-elevation-reference");
            }
        }
        let vb, bb, wb, _b;
        var Ab = qo([
            {
                name: "a_pos",
                type: "Int16",
                components: 2
            },
            {
                name: "a_texture_pos",
                type: "Uint16",
                components: 2
            }
        ]);
        function Ib(e1, t1, r, n, i, o, l, u) {
            const c = [
                e1,
                t1,
                1,
                r,
                n,
                1,
                i,
                o,
                1
            ], h = [
                l,
                u,
                1
            ], d = s([], c), [p, f, m] = G(h, h, d);
            return a(c, c, [
                p,
                0,
                0,
                0,
                f,
                0,
                0,
                0,
                m
            ]);
        }
        function Mb(e1, t1, r, n, i, o, l, u) {
            const c = function(e1, t1, r, n, i, o, l, u) {
                const c = Ib(0, 0, 1, 0, 1, 1, 0, 1), h = Ib(e1, t1, r, n, i, o, l, u);
                return a(h, h, s([], c));
            }(e1, t1, r, n, i, o, l, u);
            return [
                c[2] / c[8] / qn,
                c[5] / c[8] / qn
            ];
        }
        function Bb(e1) {
            return [
                e1[0],
                Math.min(Math.max(e1[1], -85.051129), Hu)
            ];
        }
        class Sb extends or {
            constructor(e1, t1, r, n){
                super(), this.id = e1, this.dispatcher = r, this.coordinates = t1.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.onNorthPole = !1, this.onSouthPole = !1, this.setEventedParent(n), this.options = t1, this._dirty = !1;
            }
            load(e1, t1) {
                if (this._loaded = t1 || !1, this.fire(new nr("dataloading", {
                    dataType: "source"
                })), this.url = this.options.url, !this.url) return e1 && (this.coordinates = e1), this._loaded = !0, void this._finishLoading();
                this._imageRequest = Zt(this.map._requestManager.transformRequest(this.url, Ot.Image), (t1, r)=>{
                    this._imageRequest = null, this._loaded = !0, t1 ? this.fire(new ir(t1)) : r && (this.image = r, this._dirty = !0, this.width = this.image.width, this.height = this.image.height, e1 && (this.coordinates = e1), this._finishLoading());
                });
            }
            loaded() {
                return this._loaded;
            }
            updateImage(e1) {
                return e1.url ? (this._imageRequest && e1.url !== this.options.url && (this._imageRequest.cancel(), this._imageRequest = null), this.options.url = e1.url, this.load(e1.coordinates, this._loaded), this) : this;
            }
            setTexture(e1) {
                if (!(e1.handle instanceof WebGLTexture)) throw new Error("The provided handle is not a WebGLTexture instance");
                return this.texture = new km(this.map.painter.context, e1.handle), this.width = e1.dimensions[0], this.height = e1.dimensions[1], this._dirty = !1, this._loaded = !0, this._finishLoading(), this;
            }
            _finishLoading() {
                this.map && (this.setCoordinates(this.coordinates), this.fire(new nr("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                })));
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            onRemove(e1) {
                this._imageRequest && (this._imageRequest.cancel(), this._imageRequest = null), !this.texture || this.texture instanceof km || this.texture.destroy(), this.boundsBuffer && (this.boundsBuffer.destroy(), this.elevatedGlobeVertexBuffer && this.elevatedGlobeVertexBuffer.destroy(), this.elevatedGlobeIndexBuffer && this.elevatedGlobeIndexBuffer.destroy());
            }
            setCoordinates(e1) {
                if (this.coordinates = e1, this._boundsArray = void 0, this._unsupportedCoords = !1, !e1.length) return this;
                this.onNorthPole = !1, this.onSouthPole = !1;
                let t1 = e1[0][1], r = e1[0][1];
                for (const n of e1)n[1] > r && (r = n[1]), n[1] < t1 && (t1 = n[1]);
                const n = (r + t1) / 2;
                if (n > Hu ? this.onNorthPole = !0 : n < -85.051129 && (this.onSouthPole = !0), !this.onNorthPole && !this.onSouthPole) {
                    const t1 = e1.map(Ju.fromLngLat);
                    this.tileID = function(e1) {
                        let t1 = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0;
                        for (const s of e1)t1 = Math.min(t1, s.x), r = Math.min(r, s.y), n = Math.max(n, s.x), i = Math.max(i, s.y);
                        const s = Math.max(n - t1, i - r), a = Math.max(0, Math.floor(-Math.log2(s))), o = Math.pow(2, a);
                        let l = Math.floor((t1 + n) / 2 * o);
                        return l > 1 && (l -= 1), new nh(a, l, Math.floor((r + i) / 2 * o));
                    }(t1), this.minzoom = this.maxzoom = this.tileID.z;
                }
                return this.fire(new nr("data", {
                    dataType: "source",
                    sourceDataType: "content"
                })), this;
            }
            _clear() {
                !this.texture || this.texture instanceof km || (this.texture.destroy(), this._dirty = !0), this.texture = null, this._boundsArray = void 0, this._unsupportedCoords = !1;
            }
            _prepareData(e1) {
                for(const e1 in this.tiles){
                    const t1 = this.tiles[e1];
                    "loaded" !== t1.state && (t1.state = "loaded", t1.texture = this.texture);
                }
                if (this._boundsArray || this.onNorthPole || this.onSouthPole || this._unsupportedCoords) return;
                const t1 = zv(new nh(0, 0, 0), this.map.transform.projection), r = [
                    t1.projection.project(this.coordinates[0][0], this.coordinates[0][1]),
                    t1.projection.project(this.coordinates[1][0], this.coordinates[1][1]),
                    t1.projection.project(this.coordinates[2][0], this.coordinates[2][1]),
                    t1.projection.project(this.coordinates[3][0], this.coordinates[3][1])
                ];
                if (!function(e1) {
                    const t1 = e1[1].x - e1[0].x, r = e1[1].y - e1[0].y, n = e1[2].x - e1[1].x, i = e1[2].y - e1[1].y, s = e1[3].x - e1[2].x, a = e1[3].y - e1[2].y, o = e1[0].x - e1[3].x, l = e1[0].y - e1[3].y, u = t1 * i - n * r, c = n * a - s * i, h = s * l - o * a, d = o * r - t1 * l;
                    return u > 0 && c > 0 && h > 0 && d > 0 || u < 0 && c < 0 && h < 0 && d < 0;
                }(r)) return console.warn("Image source coordinates are defining non-convex area in the Mercator projection"), void (this._unsupportedCoords = !0);
                const n = zv(this.tileID, this.map.transform.projection), [i, o, l, u] = this.coordinates.map((e1)=>{
                    const t1 = n.projection.project(e1[0], e1[1]);
                    return kv(n, t1)._round();
                });
                this.perspectiveTransform = Mb(i.x, i.y, o.x, o.y, l.x, l.y, u.x, u.y);
                const c = this._boundsArray = new Wo;
                c.emplaceBack(i.x, i.y, 0, 0), c.emplaceBack(o.x, o.y, qn, 0), c.emplaceBack(u.x, u.y, 0, qn), c.emplaceBack(l.x, l.y, qn, qn), this.boundsBuffer && (this.boundsBuffer.destroy(), this.elevatedGlobeVertexBuffer && this.elevatedGlobeVertexBuffer.destroy(), this.elevatedGlobeIndexBuffer && this.elevatedGlobeIndexBuffer.destroy()), this.boundsBuffer = e1.createVertexBuffer(c, Ab.members), this.boundsSegments = Hl.simpleSegment(0, 0, 4, 2);
                const h = [], d = function(e1) {
                    return [
                        Bb(e1[0]),
                        Bb(e1[1]),
                        Bb(e1[2]),
                        Bb(e1[3])
                    ];
                }(this.coordinates), [p, f, m, y] = function(e1) {
                    let t1 = e1[0][0], r = t1, n = e1[0][1], i = n;
                    for(let s = 1; s < e1.length; s++)e1[s][0] < t1 ? t1 = e1[s][0] : e1[s][0] > r && (r = e1[s][0]), e1[s][1] < n ? n = e1[s][1] : e1[s][1] > i && (i = e1[s][1]);
                    return [
                        t1,
                        n,
                        r - t1,
                        i - n
                    ];
                }(d);
                {
                    const n = new Wo, [i, o, l, u] = function(e1) {
                        let t1 = e1[0].x, r = t1, n = e1[0].y, i = n;
                        for(let s = 1; s < e1.length; s++)e1[s].x < t1 ? t1 = e1[s].x : e1[s].x > r && (r = e1[s].x), e1[s].y < n ? n = e1[s].y : e1[s].y > i && (i = e1[s].y);
                        return [
                            t1,
                            n,
                            r - t1,
                            i - n
                        ];
                    }(r), c = (e1)=>[
                            (e1.x - i) / l,
                            (e1.y - o) / u
                        ], [d, g, x, v] = r.map(c), b = function(e1, t1, r, n, i, o, l, u) {
                        const c = Ib(0, 0, 1, 0, 1, 1, 0, 1);
                        return a(c, c, s([], Ib(e1, t1, r, n, i, o, l, u)));
                    }(d[0], d[1], g[0], g[1], x[0], x[1], v[0], v[1]);
                    this.elevatedGlobePerspectiveTransform = Mb(d[0], d[1], g[0], g[1], x[0], x[1], v[0], v[1]);
                    const w = (e1, t1)=>{
                        h.push(e1.lng);
                        const r = Math.round((e1.lng - p) / m * qn), i = Math.round((e1.lat - f) / y * qn), s = c(t1), a = G([], [
                            s[0],
                            s[1],
                            1
                        ], b), o = Math.round(a[0] / a[2] * qn), l = Math.round(a[1] / a[2] * qn);
                        n.emplaceBack(r, i, o, l);
                    }, _ = r[3].x - r[0].x, A = r[3].y - r[0].y, I = r[2].x - r[1].x, M = r[2].y - r[1].y;
                    for(let e1 = 0; e1 < 65; e1++){
                        const n = e1 / 64, i = [
                            r[0].x + n * _,
                            r[0].y + n * A
                        ], s = [
                            r[1].x + n * I,
                            r[1].y + n * M
                        ], a = s[0] - i[0], o = s[1] - i[1];
                        for(let e1 = 0; e1 < 65; e1++){
                            const r = e1 / 64, n = {
                                x: i[0] + a * r,
                                y: i[1] + o * r
                            };
                            w(t1.projection.unproject(n.x, n.y), n);
                        }
                    }
                    this.elevatedGlobeVertexBuffer = e1.createVertexBuffer(n, Ab.members);
                }
                {
                    this.maxLongitudeTriangleSize = 0;
                    let t1 = [], r = new ml;
                    const n = (e1, n, i)=>{
                        r.emplaceBack(e1, n, i);
                        const s = h[e1], a = h[n], o = h[i], l = Math.min(Math.min(s, a), o), u = Math.max(Math.max(s, a), o) - l;
                        u > this.maxLongitudeTriangleSize && (this.maxLongitudeTriangleSize = u), t1.push(l + u / 2);
                    };
                    for(let e1 = 0; e1 < 64; e1++)for(let t1 = 0; t1 < 64; t1++){
                        const r = 65 * e1 + t1, i = r + 1, s = r + 65, a = s + 1;
                        n(r, s, i), n(i, s, a);
                    }
                    [t1, r] = function(e1, t1) {
                        const r = Array.from({
                            length: e1.length
                        }, (e1, t1)=>t1);
                        r.sort((t1, r)=>e1[t1] - e1[r]);
                        const n = [], i = new ml;
                        for(let s = 0; s < r.length; s++){
                            const a = r[s];
                            n.push(e1[a]);
                            const o = 3 * a, l = o + 1;
                            i.emplaceBack(t1.uint16[o], t1.uint16[l], t1.uint16[l + 1]);
                        }
                        return [
                            n,
                            i
                        ];
                    }(t1, r), this.elevatedGlobeTrianglesCenterLongitudes = t1, this.elevatedGlobeIndexBuffer = e1.createIndexBuffer(r);
                }
                this.elevatedGlobeSegments = Hl.simpleSegment(0, 0, 4225, 8192), this.elevatedGlobeGridMatrix = new Float32Array([
                    0,
                    m / qn,
                    0,
                    y / qn,
                    0,
                    0,
                    f,
                    p,
                    0
                ]);
            }
            prepare() {
                const e1 = 0 !== Object.keys(this.tiles).length;
                if (this.tileID && !e1) return;
                const t1 = this.map.painter.context, r = t1.gl;
                !this._dirty || this.texture instanceof km || (this.texture ? this.texture.update(this.image) : (this.texture = new zm(t1, this.image, r.RGBA8), this.texture.bind(r.LINEAR, r.CLAMP_TO_EDGE)), this._dirty = !1), e1 && this._prepareData(t1);
            }
            loadTile(e1, t1) {
                this.tileID && this.tileID.equals(e1.tileID.canonical) ? (this.tiles[String(e1.tileID.wrap)] = e1, e1.buckets = {}, t1(null)) : (e1.state = "errored", t1(null));
            }
            serialize() {
                return {
                    type: "image",
                    url: this.options.url,
                    coordinates: this.coordinates
                };
            }
            hasTransition() {
                return !1;
            }
            getSegmentsForLongitude(e1) {
                const t1 = this.elevatedGlobeSegments;
                if (!this.elevatedGlobeTrianglesCenterLongitudes || !t1) return null;
                const r = this.elevatedGlobeTrianglesCenterLongitudes;
                let n = (i = e1 + 180) + 360 * Math.round((r[0] - i) / 360);
                var i;
                const s = new Hl, a = (e1, r)=>{
                    s.segments.push({
                        vertexOffset: 0,
                        primitiveOffset: e1,
                        vertexLength: t1.segments[0].vertexLength,
                        primitiveLength: r,
                        sortKey: void 0,
                        vaos: {}
                    });
                }, o = .51 * this.maxLongitudeTriangleSize;
                if (Math.abs(r[0] - n) <= o) {
                    const e1 = it(r, 0, r.length, n + o);
                    return e1 === r.length || a(e1, nt(r, e1 + 1, r.length, n + 360 - o) - e1), s;
                }
                n < r[0] && (n += 360);
                const l = nt(r, 0, r.length, n - o);
                if (l === r.length) return a(0, r.length), s;
                a(0, l - 0);
                const u = it(r, l + 1, r.length, n + o);
                return u !== r.length && a(u, r.length - u), s;
            }
        }
        const Pb = 1024, Tb = (Math.pow(Pb, 2) - 1) / 268170240;
        class zb extends Uo {
            constructor(e1, t1, r, n){
                super(e1, {
                    layout: wb || (wb = new fo({
                        visibility: new co(mo.layout_raster.visibility)
                    })),
                    paint: _b || (_b = new fo({
                        "raster-opacity": new co(mo.paint_raster["raster-opacity"]),
                        "raster-color": new po(mo.paint_raster["raster-color"]),
                        "raster-color-mix": new co(mo.paint_raster["raster-color-mix"]),
                        "raster-color-range": new co(mo.paint_raster["raster-color-range"]),
                        "raster-hue-rotate": new co(mo.paint_raster["raster-hue-rotate"]),
                        "raster-brightness-min": new co(mo.paint_raster["raster-brightness-min"]),
                        "raster-brightness-max": new co(mo.paint_raster["raster-brightness-max"]),
                        "raster-saturation": new co(mo.paint_raster["raster-saturation"]),
                        "raster-contrast": new co(mo.paint_raster["raster-contrast"]),
                        "raster-resampling": new co(mo.paint_raster["raster-resampling"]),
                        "raster-fade-duration": new co(mo.paint_raster["raster-fade-duration"]),
                        "raster-emissive-strength": new co(mo.paint_raster["raster-emissive-strength"]),
                        "raster-array-band": new co(mo.paint_raster["raster-array-band"]),
                        "raster-elevation": new co(mo.paint_raster["raster-elevation"]),
                        "raster-elevation-reference": new co(mo.paint_raster["raster-elevation-reference"]),
                        "raster-color-use-theme": new ho({
                            type: "string",
                            default: "default",
                            "property-type": "data-driven"
                        })
                    }))
                }, t1, r, n), this.updateColorRamp(), this._curRampRange = [
                    NaN,
                    NaN
                ];
            }
            getProgramIds() {
                return [
                    "raster"
                ];
            }
            hasColorMap() {
                return !!this._transitionablePaint._values["raster-color"].value.value;
            }
            tileCoverLift() {
                return this.paint.get("raster-elevation");
            }
            isDraped(e1) {
                return !(e1 && e1._source instanceof Sb && (e1._source.onNorthPole || e1._source.onSouthPole)) && 0 === this.paint.get("raster-elevation");
            }
            _handleSpecialPaintPropertyUpdate(e1) {
                "raster-color" !== e1 && "raster-color-range" !== e1 || (this._curRampRange = [
                    NaN,
                    NaN
                ], this.updateColorRamp());
            }
            _clear() {
                this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null);
            }
            updateColorRamp(e1) {
                if (!this.hasColorMap()) return;
                if (!this._curRampRange) return;
                const t1 = this._transitionablePaint._values["raster-color"].value.expression, [r, n] = e1 || this._transitionablePaint._values["raster-color-range"].value.expression.evaluate({
                    zoom: 0
                }) || [
                    NaN,
                    NaN
                ];
                isNaN(r) && isNaN(n) || r === this._curRampRange[0] && n === this._curRampRange[1] || (this.colorRamp = rd({
                    expression: t1,
                    evaluationKey: "rasterValue",
                    image: this.colorRamp,
                    clips: [
                        {
                            start: r,
                            end: n
                        }
                    ],
                    resolution: Pb
                }), this.colorRampTexture = null, this._curRampRange = [
                    r,
                    n
                ]);
            }
            is3D(e1) {
                return this.paint.get("raster-elevation") > 0;
            }
        }
        let kb, Vb, Fb, Db, Eb, Cb, Rb;
        class Lb extends Uo {
            constructor(e1, t1, r, n){
                super(e1, {
                    layout: kb || (kb = new fo({
                        visibility: new co(mo["layout_raster-particle"].visibility)
                    })),
                    paint: Vb || (Vb = new fo({
                        "raster-particle-array-band": new co(mo["paint_raster-particle"]["raster-particle-array-band"]),
                        "raster-particle-count": new co(mo["paint_raster-particle"]["raster-particle-count"]),
                        "raster-particle-color": new po(mo["paint_raster-particle"]["raster-particle-color"]),
                        "raster-particle-max-speed": new co(mo["paint_raster-particle"]["raster-particle-max-speed"]),
                        "raster-particle-speed-factor": new co(mo["paint_raster-particle"]["raster-particle-speed-factor"]),
                        "raster-particle-fade-opacity-factor": new co(mo["paint_raster-particle"]["raster-particle-fade-opacity-factor"]),
                        "raster-particle-reset-rate-factor": new co(mo["paint_raster-particle"]["raster-particle-reset-rate-factor"]),
                        "raster-particle-elevation": new co(mo["paint_raster-particle"]["raster-particle-elevation"]),
                        "raster-particle-color-use-theme": new ho({
                            type: "string",
                            default: "default",
                            "property-type": "data-driven"
                        })
                    }))
                }, t1, r, n), this._updateColorRamp(), this.lastInvalidatedAt = wt.now();
            }
            _clear() {
                this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null), this.tileFramebuffer && (this.tileFramebuffer.destroy(), this.tileFramebuffer = null), this.particleFramebuffer && (this.particleFramebuffer.destroy(), this.particleFramebuffer = null);
            }
            onRemove(e1) {
                this.colorRampTexture && this.colorRampTexture.destroy(), this.tileFramebuffer && this.tileFramebuffer.destroy(), this.particleFramebuffer && this.particleFramebuffer.destroy();
            }
            hasColorMap() {
                return !!this._transitionablePaint._values["raster-particle-color"].value.value;
            }
            getProgramIds() {
                return [
                    "rasterParticle"
                ];
            }
            hasOffscreenPass() {
                return "none" !== this.visibility;
            }
            isDraped(e1) {
                return !1;
            }
            _handleSpecialPaintPropertyUpdate(e1) {
                "raster-particle-color" !== e1 && "raster-particle-max-speed" !== e1 || (this._updateColorRamp(), this._invalidateAnimationState()), "raster-particle-count" === e1 && this._invalidateAnimationState();
            }
            _updateColorRamp() {
                if (!this.hasColorMap()) return;
                const e1 = this._transitionablePaint._values["raster-particle-color"].value.expression, t1 = this._transitionablePaint._values["raster-particle-max-speed"].value.expression.evaluate({
                    zoom: 0
                });
                this.colorRamp = rd({
                    expression: e1,
                    evaluationKey: "rasterParticleSpeed",
                    image: this.colorRamp,
                    clips: [
                        {
                            start: 0,
                            end: t1
                        }
                    ],
                    resolution: 256
                }), this.colorRampTexture = null;
            }
            _invalidateAnimationState() {
                this.lastInvalidatedAt = wt.now();
            }
            tileCoverLift() {
                return this.paint.get("raster-particle-elevation");
            }
        }
        class Ob extends Uo {
            constructor(e1, t1){
                super(e1, {}, t1, null), this.implementation = e1, e1.slot && (this.slot = e1.slot);
            }
            is3D(e1) {
                return "3d" === this.implementation.renderingMode;
            }
            hasOffscreenPass() {
                return void 0 !== this.implementation.prerender;
            }
            isDraped(e1) {
                return void 0 !== this.implementation.renderToTile;
            }
            shouldRedrape() {
                return !!this.implementation.shouldRerenderTiles && this.implementation.shouldRerenderTiles();
            }
            recalculate() {}
            updateTransitions() {}
            hasTransition() {
                return !1;
            }
            serialize() {}
            onAdd(e1) {
                this.implementation.onAdd && this.implementation.onAdd(e1, e1.painter.context.gl);
            }
            onRemove(e1) {
                this.implementation.onRemove && this.implementation.onRemove(e1, e1.painter.context.gl);
            }
        }
        function Ub(e1, t1, r) {
            const n = [
                0,
                0,
                1
            ], i = re([]);
            return ie(i, i, r ? -Te(e1) + Math.PI : Te(e1)), ne(i, i, -Te(t1)), $(n, n, i), L(n, n);
        }
        class Nb {
            constructor(e1, t1, r, n){
                this.message = (e1 ? `${e1}: ` : "") + r, n && (this.identifier = n), null != t1 && t1.__line__ && (this.line = t1.__line__);
            }
        }
        function jb(e1, t1) {
            const r = -1 === e1.indexOf("://");
            try {
                return new URL(e1, r && t1 ? "http://example.com" : void 0), !0;
            } catch (e1) {
                return !1;
            }
        }
        class Gb {
            constructor(e1, t1){
                this.feature = e1, this.instancedDataOffset = t1, this.instancedDataCount = 0, this.rotation = [
                    0,
                    0,
                    0
                ], this.scale = [
                    1,
                    1,
                    1
                ], this.translation = [
                    0,
                    0,
                    0
                ];
            }
        }
        class $b {
            constructor(){
                this.maxScale = 1, this.maxXYTranslationDistance = 0, this.instancedDataArray = new Bl, this.instancesEvaluatedElevation = [], this.features = [], this.idToFeaturesIndex = {};
            }
            colorForInstance(e1) {
                const t1 = 16 * e1, r = this.instancedDataArray.float32;
                let n = Math.floor(r[t1 + 2]);
                const i = 1.05 * (r[t1 + 2] - n);
                return n /= 100, [
                    r[t1] % 1 * 1.05,
                    r[t1 + 1] % 1 * 1.05,
                    i,
                    n
                ];
            }
            tileCoordinatesForInstance(e1) {
                const t1 = 16 * e1, r = this.instancedDataArray.float32;
                let n = r[t1 + 0];
                return n = n > qn ? n - qn : n, new Me(Math.trunc(n), Math.trunc(r[t1 + 1]));
            }
            translationForInstance(e1) {
                const t1 = 16 * e1, r = this.instancedDataArray.float32;
                return [
                    r[t1 + 4],
                    r[t1 + 5],
                    r[t1 + 6]
                ];
            }
            rotationScaleForInstance(e1) {
                const t1 = 16 * e1, r = this.instancedDataArray.float32;
                return [
                    r[t1 + 7],
                    r[t1 + 8],
                    r[t1 + 9],
                    r[t1 + 10],
                    r[t1 + 11],
                    r[t1 + 12],
                    r[t1 + 13],
                    r[t1 + 14],
                    r[t1 + 15]
                ];
            }
            transformForInstance(e1) {
                const t1 = 16 * e1, r = this.instancedDataArray.float32;
                return [
                    r[t1 + 7],
                    r[t1 + 8],
                    r[t1 + 9],
                    r[t1 + 4],
                    r[t1 + 10],
                    r[t1 + 11],
                    r[t1 + 12],
                    r[t1 + 5],
                    r[t1 + 13],
                    r[t1 + 14],
                    r[t1 + 15],
                    r[t1 + 6],
                    0,
                    0,
                    0,
                    1
                ];
            }
        }
        class qb {
            constructor(e1){
                this.zoom = e1.zoom, this.canonical = e1.canonical, this.overscaledZ = this.canonical.z + Math.log2(e1.overscaling), this.layers = e1.layers, this.layerIds = this.layers.map((e1)=>e1.fqid), this.projection = e1.projection, this.index = e1.index, this.worldview = e1.worldview, this.hasZoomDependentProperties = this.layers[0].isZoomDependent(), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.hasPattern = !1, this.instancesPerModel = {}, this.validForExaggeration = 0, this.maxVerticalOffset = 0, this.maxScale = 0, this.maxHeight = 0, this.lookupDim = this.zoom > this.canonical.z + 1 ? 0 : this.zoom > this.canonical.z ? 256 : this.zoom > 15 ? 75 : 100, this.instanceCount = 0, this.terrainElevationMin = 0, this.terrainElevationMax = 0, this.validForDEMTile = {
                    id: null,
                    timestamp: 0
                }, this.modelUris = [], this.modelsRequested = !1, this.activeReplacements = [], this.replacementUpdateTime = 0, this.styleDefinedModelURLs = e1.styleDefinedModelURLs, this.hasAppearances = null;
            }
            updateFootprints(e1, t1) {}
            updateAppearances(e1, t1, r, n) {
                return {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
            }
            populate(e1, t1, r, n) {
                this.tileToMeter = Yu(r);
                const i = this.layers[0]._featureFilter.needGeometry;
                this.lookup = new Uint8Array(this.lookupDim * this.lookupDim);
                const s = "hd-road-markup" === this.layers[0].paint.get("model-elevation-reference") ? t1.elevationFeatures : void 0;
                for (const { feature: a, id: o, index: l, sourceLayerIndex: u } of e1){
                    const e1 = null != o ? o : a.properties && a.properties.hasOwnProperty("id") ? a.properties.id : void 0, c = ac(a, i);
                    if (!this.layers[0]._featureFilter.filter(new to(this.zoom, {
                        worldview: this.worldview,
                        activeFloors: t1.activeFloors
                    }), c, r)) continue;
                    const h = {
                        id: e1,
                        sourceLayerIndex: u,
                        index: l,
                        geometry: i ? c.geometry : sc(a, r, n),
                        properties: a.properties,
                        type: a.type,
                        patterns: {}
                    }, d = this.addFeature(h, h.geometry, c, s, r);
                    d && t1.featureIndex.insert(a, h.geometry, l, u, this.index, this.instancesPerModel[d].instancedDataArray.length, 256);
                }
                this.lookup = null;
            }
            evaluateQueryRenderedFeaturePadding() {
                const e1 = this.layers[0].modelManager, t1 = this.layers[0].scope;
                let r = 0;
                for (const n of this.modelUris){
                    const i = e1.getModel(n, t1);
                    if (!i) continue;
                    const s = this.instancesPerModel[n];
                    if (s) {
                        const e1 = .5 * D(i.aabb.max, i.aabb.min) * s.maxScale + s.maxXYTranslationDistance, t1 = Math.min(qn, Math.max(e1 / this.tileToMeter, 256));
                        r = Math.max(t1, r);
                    }
                }
                return r;
            }
            update(e1, t1, r, n) {
                for(const t1 in this.instancesPerModel){
                    const r = this.instancesPerModel[t1];
                    for(const t1 in e1)r.idToFeaturesIndex.hasOwnProperty(t1) && (this.evaluate(r.features[r.idToFeaturesIndex[t1]], e1[t1], r, !0), this.uploaded = !1);
                }
                this.maxHeight = 0;
            }
            updateZoomBasedPaintProperties() {
                if (!this.hasZoomDependentProperties) return !1;
                let e1 = !1;
                for(const t1 in this.instancesPerModel){
                    const r = this.instancesPerModel[t1];
                    for (const t1 of r.features){
                        const n = this.layers[0], i = t1.feature, s = this.canonical, a = n.paint.get("model-rotation").evaluate(i, {}, s), o = n.paint.get("model-scale").evaluate(i, {}, s), l = n.paint.get("model-translation").evaluate(i, {}, s);
                        H(t1.rotation, a) && H(t1.scale, o) && H(t1.translation, l) || (this.evaluate(t1, t1.featureStates, r, !0), e1 = !0);
                    }
                }
                return e1;
            }
            updateReplacement(e1, t1, r, n) {
                if (t1.updateTime === this.replacementUpdateTime) return !1;
                this.replacementUpdateTime = t1.updateTime;
                const i = t1.getReplacementRegionsForTile(e1.toUnwrapped(), !0);
                if (Wp(this.activeReplacements, i)) return !1;
                this.activeReplacements = i;
                let s = !1;
                for(const t1 in this.instancesPerModel){
                    const i = this.instancesPerModel[t1], a = i.instancedDataArray;
                    for (const t1 of i.features){
                        const i = t1.instancedDataOffset, o = t1.instancedDataCount;
                        for(let t1 = 0; t1 < o; t1++){
                            const o = 16 * (t1 + i);
                            let l = a.float32[o + 0];
                            const u = l > qn;
                            l = u ? l - qn : l;
                            const c = Math.floor(l), h = Math.floor(a.float32[o + 1]);
                            let d = !1;
                            for (const t1 of this.activeReplacements)if (!qp(t1, r, rf.Model, n) && !(t1.min.x > c || c > t1.max.x || t1.min.y > h || h > t1.max.y) && (d = tf(ef(c, h, e1.canonical, t1.footprintTileId.canonical), t1.footprint), d)) break;
                            a.float32[o] = d ? l + qn : l, s = s || d !== u;
                        }
                    }
                }
                return s;
            }
            isEmpty() {
                for(const e1 in this.instancesPerModel)if (0 !== this.instancesPerModel[e1].instancedDataArray.length) return !1;
                return !0;
            }
            uploadPending() {
                return !this.uploaded;
            }
            upload(e1) {
                if (!this.uploaded) for(const t1 in this.instancesPerModel){
                    const r = this.instancesPerModel[t1];
                    r.instancedDataArray.length < 0 || 0 === r.instancedDataArray.length || (r.instancedDataBuffer ? r.instancedDataBuffer.updateData(r.instancedDataArray) : r.instancedDataBuffer = e1.createVertexBuffer(r.instancedDataArray, Rm.members, !0, void 0, this.instanceCount));
                }
                this.uploaded = !0;
            }
            destroy(e1) {
                for(const e1 in this.instancesPerModel){
                    const t1 = this.instancesPerModel[e1];
                    0 !== t1.instancedDataArray.length && t1.instancedDataBuffer && t1.instancedDataBuffer.destroy();
                }
                const t1 = this.layers[0].modelManager;
                if (e1 && t1 && this.modelUris && this.modelsRequested) for (const e1 of this.modelUris)t1.removeModel(e1, "", !0);
            }
            addFeature(e1, t1, r, n, i) {
                const s = this.layers[0], a = s.layout.get("model-id"), o = s.layout.get("model-allow-density-reduction"), l = a.evaluate(r, {}, this.canonical);
                if (!l) return Ze(`modelId is not evaluated for layer ${s.id} and it is not going to get rendered.`), l;
                (jb(l, !1) || void 0 !== this.styleDefinedModelURLs[l]) && (this.modelUris.includes(l) || this.modelUris.push(l)), this.instancesPerModel[l] || (this.instancesPerModel[l] = new $b);
                const u = this.instancesPerModel[l], c = u.instancedDataArray, h = new Gb(r, c.length);
                let d;
                n && (d = Vc.getElevationFeature(e1, n));
                for (const e1 of t1)for (const t1 of e1){
                    if (t1.x < 0 || t1.x >= qn || t1.y < 0 || t1.y >= qn) continue;
                    if (0 !== this.lookupDim && o) {
                        const e1 = (this.lookupDim - 1) / qn, r = this.lookupDim * (t1.y * e1 | 0) + t1.x * e1 | 0;
                        if (this.lookup) {
                            if (0 !== this.lookup[r]) continue;
                            this.lookup[r] = 1;
                        }
                    }
                    this.instanceCount++;
                    const e1 = c.length;
                    if (c.resize(e1 + 1), n) {
                        u.instancesRoadElevation || (u.instancesRoadElevation = []);
                        const e1 = d ? d.pointElevation(new Me(t1.x, t1.y)) : 0;
                        u.instancesRoadElevation.push(e1);
                    }
                    u.instancesEvaluatedElevation.push(0), c.float32[16 * e1] = t1.x, c.float32[16 * e1 + 1] = t1.y;
                }
                return h.instancedDataCount = u.instancedDataArray.length - h.instancedDataOffset, h.instancedDataCount > 0 && (e1.id && (u.idToFeaturesIndex[e1.id] = u.features.length), u.features.push(h), this.evaluate(h, {}, u, !1)), l;
            }
            getModelUris() {
                return this.modelUris;
            }
            evaluate(e1, t1, r, n) {
                const i = this.layers[0], s = e1.feature, a = this.canonical, o = e1.rotation = i.paint.get("model-rotation").evaluate(s, t1, a), l = e1.scale = i.paint.get("model-scale").evaluate(s, t1, a), u = e1.translation = i.paint.get("model-translation").evaluate(s, t1, a), c = Object.assign({}, i.paint.get("model-color").evaluate(s, t1, a));
                c.a = i.paint.get("model-color-mix-intensity").evaluate(s, t1, a);
                const h = [];
                this.maxVerticalOffset < u[2] && (this.maxVerticalOffset = u[2]);
                const d = u[0] * u[0] + u[1] * u[1], p = d > 0 ? Math.sqrt(d) : 0;
                r.maxScale = Math.max(Math.max(r.maxScale, l[0]), Math.max(l[1], l[2])), r.maxXYTranslationDistance = Math.max(r.maxXYTranslationDistance, p), this.maxScale = Math.max(Math.max(this.maxScale, l[0]), Math.max(l[1], l[2])), qm(h, o, l);
                const f = Math.round(100 * c.a) + c.b / 1.05;
                for(let t1 = 0; t1 < e1.instancedDataCount; ++t1){
                    const i = e1.instancedDataOffset + t1, s = 16 * i, o = r.instancedDataArray.float32;
                    let l = 0;
                    n && (l = o[s + 6] - r.instancesEvaluatedElevation[i]);
                    const d = 0 | o[s + 1];
                    o[s] = (0 | o[s]) + c.r / 1.05, o[s + 1] = d + c.g / 1.05, o[s + 2] = f, o[s + 3] = 1 / (a.z > 10 ? this.tileToMeter : Yu(a, d)), o[s + 4] = u[0], o[s + 5] = u[1], o[s + 6] = u[2] + (r.instancesRoadElevation ? r.instancesRoadElevation[i] : 0) + l, o[s + 7] = h[0], o[s + 8] = h[1], o[s + 9] = h[2], o[s + 10] = h[4], o[s + 11] = h[5], o[s + 12] = h[6], o[s + 13] = h[8], o[s + 14] = h[9], o[s + 15] = h[10], r.instancesEvaluatedElevation[i] = u[2];
                }
            }
        }
        ra(qb, "ModelBucket", {
            omit: [
                "layers"
            ]
        }), ra($b, "PerModelAttributes"), ra(Gb, "ModelFeature");
        class Hb {
            constructor(e1, t1, r){
                this._demTile = e1, this._dem = this._demTile.dem, this._scale = t1, this._offset = r;
            }
            static create(e1, t1, r) {
                const n = r || e1.findDEMTileFor(t1);
                if (!n || !n.dem) return;
                const i = n.dem, s = n.tileID, a = 1 << t1.canonical.z - s.canonical.z;
                return new Hb(n, i.dim / qn / a, [
                    (t1.canonical.x / a - s.canonical.x) * i.dim,
                    (t1.canonical.y / a - s.canonical.y) * i.dim
                ]);
            }
            tileCoordToPixel(e1, t1) {
                const r = t1 * this._scale + this._offset[1];
                return new Me(Math.floor(e1 * this._scale + this._offset[0]), Math.floor(r));
            }
            getElevationAt(e1, t1, r, n) {
                const i = e1 * this._scale + this._offset[0], s = t1 * this._scale + this._offset[1], a = Math.floor(i), o = Math.floor(s), l = this._dem;
                return n = !!n, r ? yr(yr(l.get(a, o, n), l.get(a, o + 1, n), s - o), yr(l.get(a + 1, o, n), l.get(a + 1, o + 1, n), s - o), i - a) : l.get(a, o, n);
            }
            getElevationAtPixel(e1, t1, r) {
                return this._dem.get(e1, t1, !!r);
            }
            getMeterToDEM(e1) {
                return (1 << this._demTile.tileID.canonical.z) * ju(1, e1) * this._dem.stride;
            }
        }
        const Xb = new Float32Array(262144), Zb = new Uint8Array(262144);
        function Wb(e1) {
            let t1 = 0;
            if (e1.meshes) for (const r of e1.meshes)t1 = Math.max(t1, r.aabb.max[2]);
            if (e1.children) for (const r of e1.children)t1 = Math.max(t1, Wb(r));
            return t1;
        }
        function Yb(e1, t1, r) {
            if (e1.meshes) for (const n of e1.meshes){
                if (n.aabb.min[0] === 1 / 0) continue;
                const i = Tc.applyTransform(n.aabb, e1.globalMatrix);
                r.insert(t1, i.min[0], i.min[1], i.max[0], i.max[1]);
            }
            if (e1.children) for (const n of e1.children)Yb(n, t1, r);
        }
        const Jb = [
            "",
            "wall",
            "door",
            "roof",
            "window",
            "lamp",
            "logo"
        ];
        class Kb {
            constructor(e1){
                this.node = e1, this.evaluatedRMEA = [
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        .4,
                        1,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ],
                    [
                        1,
                        0,
                        0,
                        1
                    ]
                ], this.hiddenByReplacement = !1, this.evaluatedTranslation = [
                    0,
                    0,
                    0
                ], this.evaluatedScale = [
                    1,
                    1,
                    1
                ], this.evaluatedColor = [], this.emissionHeightBasedParams = [], this.cameraCollisionOpacity = 1, this.feature = {
                    type: "Point",
                    id: e1.id,
                    geometry: [],
                    properties: {
                        height: Wb(e1)
                    }
                }, this.aabb = this._getLocalBounds(), this.state = null;
            }
            _getLocalBounds() {
                if (!this.node.meshes) return new Tc([
                    1 / 0,
                    1 / 0,
                    1 / 0
                ], [
                    -1 / 0,
                    -1 / 0,
                    -1 / 0
                ]);
                if (!this.aabb) {
                    let e1 = 0;
                    const t1 = new Tc([
                        1 / 0,
                        1 / 0,
                        1 / 0
                    ], [
                        -1 / 0,
                        -1 / 0,
                        -1 / 0
                    ]);
                    for (const r of this.node.meshes)this.node.lightMeshIndex !== e1 && (r.transformedAabb = Tc.applyTransformFast(r.aabb, this.node.globalMatrix), t1.encapsulate(r.transformedAabb)), e1++;
                    this.aabb = t1;
                }
                return this.aabb;
            }
        }
        class Qb {
            constructor(e1, t1, r, n, i, s, a, o){
                this.id = r, this.layers = e1, this.layerIds = this.layers.map((e1)=>e1.fqid), this.stateDependentLayerIds = this.layers.filter((e1)=>e1.isStateDependent()).map((e1)=>e1.id), this.modelTraits |= Ym.CoordinateSpaceTile, this.uploaded = !1, this.hasPattern = !1, n && (this.modelTraits |= Ym.HasMapboxMeshFeatures), i && (this.modelTraits |= Ym.HasMeshoptCompression), this.zoom = -1, this.terrainExaggeration = 1, this.projection = {
                    name: "mercator"
                }, this.replacementUpdateTime = 0, this.elevationReadFromZ = 255, this.brightness = s, this.worldview = o, this.dirty = !0, this.needsUpload = !1, this.filter = null, this.nodesInfo = [];
                for (const e1 of t1)this.nodesInfo.push(new Kb(e1)), Yb(e1, a.featureIndexArray.length, a.grid), a.featureIndexArray.emplaceBack(this.nodesInfo.length - 1, 0, a.bucketLayerIDs.length - 1, 0);
                this.states = {}, this.hasAppearances = null;
            }
            updateFootprints(e1, t1) {
                for (const r of this.getNodesInfo()){
                    const n = r.node;
                    n.footprint && t1.push({
                        footprint: n.footprint,
                        id: e1
                    });
                }
            }
            updateAppearances(e1, t1, r, n) {
                return {
                    hasLayoutChanges: !1,
                    hasUboChanges: !1
                };
            }
            update(e1) {
                const t1 = 0 !== Object.keys(e1).length;
                if (t1 && !this.stateDependentLayers.length) return;
                const r = t1 ? this.stateDependentLayers : this.layers;
                if (!Be(e1, this.states)) for (const t1 of r)this.evaluate(t1, e1);
                this.states = structuredClone(e1);
            }
            populate() {
                console.log("populate 3D model bucket");
            }
            uploadPending() {
                return !this.uploaded || this.needsUpload;
            }
            upload(e1) {
                if (!this.needsUpload) return;
                const t1 = this.getNodesInfo();
                for (const r of t1){
                    const t1 = r.node;
                    this.uploaded ? this.updatePbrBuffer(t1) : ty(t1, e1, !0);
                }
                for (const e1 of t1)ry(e1.node);
                this.uploaded = !0, this.needsUpload = !1;
            }
            updatePbrBuffer(e1) {
                let t1 = !1;
                if (!e1.meshes) return t1;
                for (const r of e1.meshes)r.pbrBuffer && (r.pbrBuffer.updateData(r.featureArray), t1 = !0);
                return t1;
            }
            needsReEvaluation(e1, t1, r) {
                const n = e1.transform.projectionOptions, i = e1.style.getBrightness(), s = this.brightness !== i;
                if (!this.uploaded || this.dirty || n.name !== this.projection.name || ew(r.paint.get("model-color").value, s) || ew(r.paint.get("model-color-mix-intensity").value, s) || ew(r.paint.get("model-roughness").value, s) || ew(r.paint.get("model-emissive-strength").value, s) || ew(r.paint.get("model-height-based-emissive-strength-multiplier").value, s)) {
                    this.projection = n, this.brightness = i;
                    const e1 = this.getNodesInfo();
                    for (const t1 of e1)t1.state = null;
                    return !0;
                }
                return !1;
            }
            evaluateTransform(e1, t1) {
                if (e1.transform.zoom === this.zoom) return;
                this.zoom = e1.transform.zoom;
                const r = this.getNodesInfo(), n = this.id.canonical;
                for (const e1 of r){
                    const r = e1.feature;
                    e1.evaluatedTranslation = t1.paint.get("model-translation").evaluate(r, {}, n), e1.evaluatedScale = t1.paint.get("model-scale").evaluate(r, {}, n);
                }
            }
            evaluate(e1, t1) {
                const r = this.getNodesInfo();
                for (const n of r){
                    if (!n.node.meshes) continue;
                    const r = n.feature, i = t1 && t1[r.id];
                    if (Be(i, n.state)) continue;
                    n.state = structuredClone(i);
                    const s = n.node.meshes && n.node.meshes[0].featureData, a = n.evaluatedColor[2], o = n.evaluatedRMEA[2], l = this.id.canonical;
                    if (n.hasTranslucentParts = !1, s) {
                        for(let t1 = 0; t1 < Jb.length; t1++){
                            const s = Jb[t1];
                            s.length && (r.properties.part = s);
                            const a = e1.paint.get("model-color").evaluate(r, i, l).toPremultipliedRenderColor(null), o = e1.paint.get("model-color-mix-intensity").evaluate(r, i, l);
                            n.evaluatedColor[t1] = [
                                a.r,
                                a.g,
                                a.b,
                                o
                            ], n.evaluatedRMEA[t1][0] = e1.paint.get("model-roughness").evaluate(r, i, l), n.evaluatedRMEA[t1][2] = e1.paint.get("model-emissive-strength").evaluate(r, i, l), n.evaluatedRMEA[t1][3] = a.a, n.emissionHeightBasedParams[t1] = e1.paint.get("model-height-based-emissive-strength-multiplier").evaluate(r, i, l), !n.hasTranslucentParts && a.a < 1 && (n.hasTranslucentParts = !0);
                        }
                        delete r.properties.part, rw(n, a !== n.evaluatedColor[2] || o !== n.evaluatedRMEA[2], this.modelTraits);
                    } else n.evaluatedRMEA[0][2] = e1.paint.get("model-emissive-strength").evaluate(r, i, l);
                    n.evaluatedTranslation = e1.paint.get("model-translation").evaluate(r, i, l), n.evaluatedScale = e1.paint.get("model-scale").evaluate(r, i, l), this.updatePbrBuffer(n.node) || (this.needsUpload = !0);
                }
                this.dirty = !1;
            }
            elevationUpdate(e1, t1, r, n) {
                const i = e1.findDEMTileFor(r);
                if (i && (i.tileID.canonical !== this.terrainTile || t1 !== this.terrainExaggeration)) {
                    if (i.dem && i.tileID.overscaledZ !== this.elevationReadFromZ) {
                        this.elevationReadFromZ = i.tileID.overscaledZ;
                        const t1 = Hb.create(e1, r, i);
                        if (!t1) return;
                        this.modelTraits & Ym.HasMapboxMeshFeatures && this.updateDEM(e1, t1, r, n);
                        for (const e1 of this.getNodesInfo()){
                            const r = e1.node;
                            if (!r.footprint || !r.footprint.vertices || !r.footprint.vertices.length) continue;
                            const n = r.footprint.vertices;
                            let i = t1.getElevationAt(n[0].x, n[0].y, !0, !0);
                            for(let e1 = 1; e1 < n.length; e1++)i = Math.min(i, t1.getElevationAt(n[e1].x, n[e1].y, !0, !0));
                            r.elevation = i;
                        }
                    }
                    this.terrainTile = i.tileID.canonical, this.terrainExaggeration = t1;
                }
            }
            updateDEM(e1, t1, r, n) {
                let i = t1._dem._modifiedForSources[n];
                if (void 0 === i && (t1._dem._modifiedForSources[n] = [], i = t1._dem._modifiedForSources[n]), i.includes(r.canonical)) return;
                const s = t1._dem.dim;
                i.push(r.canonical);
                let a = !1;
                for (const e1 of this.getNodesInfo()){
                    const r = e1.node;
                    if (!r.footprint || !r.footprint.grid) continue;
                    const n = r.footprint.grid, i = t1.tileCoordToPixel(n.min.x, n.min.y), o = t1.tileCoordToPixel(n.max.x, n.max.y), l = Math.min(Math.min(s - o.y, i.x), Math.min(i.y, s - o.x));
                    if (l < 0) continue;
                    const u = Ee(l, 2, 5);
                    let c = Math.max(0, i.x - u), h = Math.max(0, i.y - u), d = Math.min(o.x + u, s - 1), p = Math.min(o.y + u, s - 1);
                    for(let e1 = h; e1 <= p; ++e1)for(let t1 = c; t1 <= d; ++t1)Zb[e1 * s + t1] = 255;
                    let f = 0, m = 0;
                    for(let e1 = 0; e1 < n.cellsY; ++e1)for(let r = 0; r < n.cellsX; ++r){
                        if (!n.cells[e1 * n.cellsX + r]) continue;
                        const i = t1.tileCoordToPixel(n.min.x + r / n.xScale, n.min.y + e1 / n.yScale), a = t1.tileCoordToPixel(n.min.x + (r + 1) / n.xScale, n.min.y + (e1 + 1) / n.yScale);
                        for(let e1 = i.y; e1 <= Math.min(a.y + 1, s - 1); ++e1)for(let r = i.x; r <= Math.min(a.x + 1, s - 1); ++r)255 === Zb[e1 * s + r] && (Zb[e1 * s + r] = 0, f += t1.getElevationAtPixel(r, e1), m++);
                    }
                    const y = f / m;
                    c = Math.max(1, i.x - u), h = Math.max(1, i.y - u), d = Math.min(o.x + u, s - 2), p = Math.min(o.y + u, s - 2), a = !0;
                    for(let e1 = h; e1 <= p; ++e1)for(let r = c; r <= d; ++r)0 === Zb[e1 * s + r] && (Xb[e1 * s + r] = t1._dem.set(r, e1, y));
                    for(let e1 = 1; e1 < u; ++e1){
                        c = Math.max(1, i.x - e1), h = Math.max(1, i.y - e1), d = Math.min(o.x + e1, s - 2), p = Math.min(o.y + e1, s - 2);
                        for(let r = h; r <= p; ++r)for(let n = c; n <= d; ++n){
                            const i = r * s + n;
                            if (255 === Zb[i]) {
                                let a = 0, o = 0, l = -1, c = -1;
                                for(let t1 = -1; t1 <= 1; ++t1)for(let i = -1; i <= 1; ++i){
                                    const u = (r + t1) * s + n + i;
                                    if (Zb[u] >= e1) continue;
                                    const h = Xb[u], d = Math.abs(h);
                                    d > o && (a = h, o = d, l = i, c = t1);
                                }
                                if (o > .1) {
                                    const s = 1 - (e1 + .5 * Math.abs(l * c)) / u;
                                    let o = t1._dem.get(n, r) + a * s;
                                    const h = t1._dem.get(n + l, r + c), d = t1._dem.get(n - l, r - c, !0);
                                    (o - h) * (o - d) > 0 && (o = (h + d) / 2), Xb[i] = t1._dem.set(n, r, o), Zb[i] = e1;
                                }
                            }
                        }
                    }
                }
                a && (t1._demTile.needsDEMTextureUpload = !0, t1._dem._timestamp = wt.now());
            }
            setFilter(e1) {
                this.filter = e1 ? vo(e1) : null;
            }
            getNodesInfo() {
                return this.filter ? this.nodesInfo.filter((e1)=>this.filter.filter(new to(this.id.overscaledZ, {
                        worldview: this.worldview
                    }), e1.feature, this.id.canonical)) : this.nodesInfo;
            }
            destroy() {
                const e1 = this.getNodesInfo();
                for (const t1 of e1)ry(t1.node), iy(t1.node);
            }
            isEmpty() {
                return !this.nodesInfo.length;
            }
            updateReplacement(e1, t1) {
                if (t1.updateTime === this.replacementUpdateTime) return;
                this.replacementUpdateTime = t1.updateTime;
                const r = t1.getReplacementRegionsForTile(e1.toUnwrapped());
                for (const e1 of this.getNodesInfo()){
                    const t1 = e1.node.footprint;
                    e1.hiddenByReplacement = !!t1 && !r.find((e1)=>e1.footprint === t1);
                }
            }
            getHeightAtTileCoord(e1, t1) {
                const r = [], n = [
                    0,
                    0,
                    0
                ], i = u([]);
                for (const s of this.getNodesInfo()){
                    const a = s.node.meshes[0], o = a.transformedAabb;
                    if (e1 < o.min[0] || t1 < o.min[1] || e1 > o.max[0] || t1 > o.max[1]) continue;
                    if (!0 === s.node.hidden) return {
                        height: 1 / 0,
                        maxHeight: s.feature.properties.height,
                        hidden: !1,
                        verticalScale: s.evaluatedScale[2]
                    };
                    c(i, s.node.globalMatrix), n[0] = e1, n[1] = t1, j(n, n, i);
                    const l = (n[0] - a.aabb.min[0]) / (a.aabb.max[0] - a.aabb.min[0]) * Wm | 0, u = Math.min(63, (n[1] - a.aabb.min[1]) / (a.aabb.max[1] - a.aabb.min[1]) * Wm | 0) * Wm + Math.min(63, l), h = a.heightmap[u];
                    if (!(h < 0 && s.node.footprint)) {
                        if (s.hiddenByReplacement) return;
                        return {
                            height: h,
                            maxHeight: s.feature.properties.height,
                            hidden: !1,
                            verticalScale: s.evaluatedScale[2]
                        };
                    }
                    if (s.node.footprint.grid.query(new Me(e1, t1), new Me(e1, t1), r), r.length > 0) return {
                        height: void 0,
                        maxHeight: s.feature.properties.height,
                        hidden: s.hiddenByReplacement,
                        verticalScale: s.evaluatedScale[2]
                    };
                }
            }
        }
        function ew(e1, t1) {
            return e1 instanceof Hs && !e1.isLightConstant && t1;
        }
        function tw(e1, t1, r, n, i, s, a, o) {
            let l = (61440 & t1 | (61440 & t1) >> 4) >> 8, u = (3840 & t1 | (3840 & t1) >> 4) >> 4, c = 240 & t1 | (240 & t1) >> 4;
            r[3] > 0 && (l = yr(l, 255 * r[0], r[3]), u = yr(u, 255 * r[1], r[3]), c = yr(c, 255 * r[2], r[3]));
            const h = l << 8 | u, d = c << 8 | Math.floor(255 * n[3]), p = function(e1) {
                const t1 = Ee(e1, 0, 2);
                return Math.min(Math.round(.5 * t1 * 255), 255);
            }(n[2]) << 8 | 15 * n[0] << 4 | 15 * n[1], f = Ee(i[0], 0, 1), m = Ee(i[1], 0, 1), y = Ee(i[2], 0, 1), g = Ee(i[3], 0, 1);
            let x, v, b, w;
            if (f !== m && a !== s && m !== f) {
                const e1 = a - s;
                v = 1 / (e1 * (m - f)), b = -(s + e1 * f) / (e1 * (m - f));
                const t1 = Ee(i[4], -1, 1);
                w = Math.pow(10, t1), x = 255 * y << 8 | 255 * g;
            } else x = 65535, v = 0, b = 1, w = 1;
            if (e1.emplaceBack(h, d, p, x, v, b, w), o) {
                const e1 = o.length;
                o.clear();
                for(let t1 = 0; t1 < e1; t1++)o.emplaceBack(h, d, p, x, v, b, w);
            }
        }
        function rw(e1, t1, r) {
            const n = e1.node;
            let i = 0;
            const s = r & Ym.HasMeshoptCompression;
            for (const r of n.meshes){
                if (n.lights && n.lightMeshIndex === i) continue;
                if (!r.featureData) continue;
                r.featureArray = new Sl, r.featureArray.reserve(r.featureData.length);
                let a = t1;
                for (const t1 of r.featureData){
                    const i = s ? 65535 & t1 : t1 >> 16 & 65535, o = s ? t1 >> 16 & 65535 : 65535 & t1, l = (15 & o) < 8 ? 15 & o : 0, u = e1.evaluatedRMEA[l], c = e1.evaluatedColor[l], h = e1.emissionHeightBasedParams[l];
                    let d;
                    if (a && 2 === l && n.lights && (d = new Sl, d.resize(10 * n.lights.length)), tw(r.featureArray, i, c, u, h, r.aabb.min[2], r.aabb.max[2], d), d && a) {
                        a = !1;
                        const e1 = n.meshes[n.lightMeshIndex];
                        e1.featureArray = d, e1.featureArray._trim();
                    }
                }
                r.featureArray._trim(), i++;
            }
        }
        ra(Qb, "Tiled3dModelBucket", {
            omit: [
                "layers"
            ]
        }), ra(Kb, "Tiled3dModelFeature");
        const nw = [
            "id",
            "tile",
            "layer",
            "source",
            "sourceLayer",
            "state"
        ];
        class iw {
            constructor(e1, t1, r, n, i){
                this.type = "Feature", this._vectorTileFeature = e1, this._z = t1, this._x = r, this._y = n, this.properties = e1 ? e1.properties : {}, this.id = i;
            }
            clone() {
                const e1 = new iw(this._vectorTileFeature, this._z, this._x, this._y, this.id);
                return this.state && (e1.state = Object.assign({}, this.state)), this.layer && (e1.layer = Object.assign({}, this.layer)), this.source && (e1.source = this.source), this.sourceLayer && (e1.sourceLayer = this.sourceLayer), e1;
            }
            get geometry() {
                return void 0 === this._geometry && this._vectorTileFeature && (this._geometry = this._vectorTileFeature.toGeoJSON(this._x, this._y, this._z).geometry), this._geometry;
            }
            set geometry(e1) {
                this._geometry = e1;
            }
            toJSON() {
                const e1 = {
                    type: "Feature",
                    state: void 0,
                    geometry: this.geometry,
                    properties: this.properties
                };
                for (const t1 of nw)void 0 !== this[t1] && (e1[t1] = this[t1]);
                return e1;
            }
        }
        class sw extends or {
            constructor(e1, t1, r, n){
                super(), this.id = e1, this.type = "model", this.models = [], this._options = t1, this._modelsInfo = new Map, this._abortController = null;
            }
            cancelModelRequests() {
                this._abortController && (this._abortController.abort(), this._abortController = null);
            }
            loadGLTFFromURI(e1, t1) {
                return Sm(this.map._requestManager.transformRequest(e1, Ot.Model).url, t1);
            }
            async loadModel(e1, t1, r) {
                try {
                    const n = await this.loadGLTFFromURI(t1.uri, r);
                    if (r.aborted) return;
                    const i = this._modelsInfo.get(e1);
                    if (!i) return;
                    const s = dy(n), a = i.modelSpec, o = new Km(e1, a.uri, a.position, a.orientation, s);
                    sw.applyModelSpecification(o, a), o.computeBoundsAndApplyParent(), this.models.push(o), i.model = o;
                } catch (r) {
                    if (r instanceof Error && "AbortError" === r.name) return;
                    const n = r instanceof Error ? r.message : "Unknown error";
                    this.fire(new ir(new Error(`Could not load model ${e1} from ${t1.uri}: ${n}`)));
                }
            }
            async load() {
                this._abortController || (this._abortController = new AbortController);
                const e1 = this._abortController.signal, t1 = [];
                for(const r in this._options.models){
                    const n = this._options.models[r], i = this._modelsInfo.get(r);
                    if (i && i.model) {
                        i.modelSpec = n;
                        const e1 = i.model;
                        e1.position = null != n.position ? new Ru(n.position[0], n.position[1]) : new Ru(0, 0), e1.orientation = null != n.orientation ? n.orientation : [
                            0,
                            0,
                            0
                        ], sw.applyModelSpecification(e1, n), e1.computeBoundsAndApplyParent(), this.models.push(e1);
                    } else i ? i.modelSpec = n : (this._modelsInfo.set(r, {
                        modelSpec: n,
                        model: null
                    }), t1.push(this.loadModel(r, n, e1)));
                }
                0 !== t1.length ? (await Promise.allSettled(t1), e1.aborted || this.fire(new nr("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                }))) : this.loaded() && this.fire(new nr("data", {
                    dataType: "source",
                    sourceDataType: "metadata"
                }));
            }
            static applyModelSpecification(e1, t1) {
                t1.nodeOverrides && sw.convertNodeOverrides(e1, t1.nodeOverrides), t1.materialOverrides && sw.convertMaterialOverrides(e1, t1.materialOverrides), t1.nodeOverrideNames && (e1.nodeOverrideNames = [
                    ...t1.nodeOverrideNames
                ]), t1.materialOverrideNames && (e1.materialOverrideNames = [
                    ...t1.materialOverrideNames
                ]), t1.featureProperties && (e1.featureProperties = t1.featureProperties);
            }
            static convertNodeOverrides(e1, t1) {
                if (Array.isArray(t1) && t1.every((e1)=>"string" == typeof e1)) {
                    e1.nodeOverrideNames = [];
                    for (const r of t1)e1.nodeOverrideNames.push(r);
                } else Object.entries(t1).forEach(([t1, r])=>{
                    const n = {
                        orientation: [
                            0,
                            0,
                            0
                        ]
                    };
                    if (r.hasOwnProperty("orientation")) {
                        const e1 = r.orientation;
                        e1 && (n.orientation = e1);
                    }
                    e1.nodeOverrides.set(t1, n);
                });
            }
            static convertMaterialOverrides(e1, t1) {
                if (Array.isArray(t1) && t1.every((e1)=>"string" == typeof e1)) {
                    e1.materialOverrideNames = [];
                    for (const r of t1)e1.materialOverrideNames.push(r);
                } else Object.entries(t1).forEach(([t1, r])=>{
                    const n = {
                        color: new dr(1, 1, 1),
                        colorMix: 0,
                        emissionStrength: 0,
                        opacity: 1
                    }, i = r["model-color"];
                    void 0 !== i && (n.color.r = i[0], n.color.g = i[1], n.color.b = i[2]);
                    const s = r["model-color-mix-intensity"];
                    void 0 !== s && (n.colorMix = s);
                    const a = r["model-emissive-strength"];
                    void 0 !== a && (n.emissionStrength = a);
                    const o = r["model-opacity"];
                    void 0 !== o && (n.opacity = o), e1.materialOverrides.set(t1, n);
                });
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            hasTransition() {
                return !1;
            }
            loaded() {
                if (0 === this._modelsInfo.size) return !0;
                for (const e1 of this._modelsInfo.values())if (null == e1.model) return !1;
                return !0;
            }
            getModels() {
                return this.models;
            }
            loadTile(e1, t1) {}
            serialize() {
                return this._options;
            }
            setProperty(e1, t1) {
                return !1;
            }
            reload() {
                this.cancelModelRequests();
                const e1 = Vo(this.id, this.scope);
                this.map.style.clearSource(e1), this.models = [], this._modelsInfo.clear(), this.load();
            }
            onRemove(e1) {
                this.cancelModelRequests();
            }
            setModels(e1) {
                this.models = [];
                const t1 = new Map;
                for(const r in e1){
                    const n = e1[r], i = this._modelsInfo.get(r);
                    i && i.modelSpec.uri === n.uri && t1.set(r, i);
                }
                if (this._modelsInfo.size !== t1.size) {
                    this.cancelModelRequests();
                    for (const [e1, r] of t1)r.model || t1.delete(e1);
                }
                this._modelsInfo = t1, this._options.models = e1, this.load();
            }
        }
        function aw(e1, t1, r, n) {
            const i = 1 << e1.z;
            t1.lat = $u((n / qn + e1.y) / i), t1.lng = Gu((r / qn + e1.x) / i);
        }
        function ow(e1, t1, r, n) {
            const i = e1.getNodesInfo()[t1];
            if (!i || i.hiddenByReplacement || !i.node.meshes) return;
            let s = Number.MAX_VALUE;
            const a = i.node, o = r.tile, l = n.calculatePosMatrix(o.tileID.toUnwrapped(), n.worldSize), u = i.evaluatedScale;
            let c = 0;
            n.elevation && a.elevation && (c = a.elevation * n.elevation.exaggeration()), d(l, l, [
                (a.anchor ? a.anchor[0] : 0) * (u[0] - 1),
                (a.anchor ? a.anchor[1] : 0) * (u[1] - 1),
                c
            ]), p(l, l, u);
            const f = r.queryGeometry, m = f.isPointQuery() ? f.screenBounds : f.screenGeometry, y = function(e1) {
                const t1 = h([], l, e1.globalMatrix);
                h(t1, n.expandedFarZProjMatrix, t1);
                for(let r = 0; r < e1.meshes.length; ++r){
                    const i = e1.meshes[r];
                    if (r === e1.lightMeshIndex) continue;
                    const a = Zm(m, n, t1, i.aabb);
                    null != a && (s = Math.min(a, s));
                }
                if (e1.children) for (const t1 of e1.children)y(t1);
            };
            if (y(a), s === Number.MAX_VALUE) return;
            const g = new Ru(0, 0);
            return aw(o.tileID.canonical, g, i.node.anchor[0], i.node.anchor[1]), {
                intersectionZ: s,
                position: g,
                feature: i.feature
            };
        }
        const lw = {
            circle: class extends Uo {
                constructor(e1, t1, r, n){
                    super(e1, {
                        layout: th || (th = new fo({
                            "circle-sort-key": new ho(mo.layout_circle["circle-sort-key"]),
                            "circle-elevation-reference": new co(mo.layout_circle["circle-elevation-reference"]),
                            visibility: new co(mo.layout_circle.visibility)
                        })),
                        paint: rh || (rh = new fo({
                            "circle-radius": new ho(mo.paint_circle["circle-radius"]),
                            "circle-color": new ho(mo.paint_circle["circle-color"]),
                            "circle-blur": new ho(mo.paint_circle["circle-blur"]),
                            "circle-opacity": new ho(mo.paint_circle["circle-opacity"]),
                            "circle-translate": new co(mo.paint_circle["circle-translate"]),
                            "circle-translate-anchor": new co(mo.paint_circle["circle-translate-anchor"]),
                            "circle-pitch-scale": new co(mo.paint_circle["circle-pitch-scale"]),
                            "circle-pitch-alignment": new co(mo.paint_circle["circle-pitch-alignment"]),
                            "circle-stroke-width": new ho(mo.paint_circle["circle-stroke-width"]),
                            "circle-stroke-color": new ho(mo.paint_circle["circle-stroke-color"]),
                            "circle-stroke-opacity": new ho(mo.paint_circle["circle-stroke-opacity"]),
                            "circle-emissive-strength": new co(mo.paint_circle["circle-emissive-strength"]),
                            "circle-color-use-theme": new ho({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "circle-stroke-color-use-theme": new ho({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, r, n);
                }
                createBucket(e1) {
                    return new Dc(e1);
                }
                queryRadius(e1) {
                    const t1 = e1;
                    return Jc("circle-radius", this, t1) + Jc("circle-stroke-width", this, t1) + Kc(this.paint.get("circle-translate"));
                }
                queryIntersectsFeature(e1, t1, r, n, i, s, a, o) {
                    const l = eh(this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), s.angle, e1.pixelToTileUnitsFactor), u = this.paint.get("circle-radius").evaluate(t1, r) + this.paint.get("circle-stroke-width").evaluate(t1, r);
                    return Uh(e1, n, s, a, o, "map" === this.paint.get("circle-pitch-alignment"), "map" === this.paint.get("circle-pitch-scale"), l, u);
                }
                getProgramIds() {
                    return [
                        "circle"
                    ];
                }
                getDefaultProgramParams(e1, t1, r) {
                    const n = Oh(this);
                    return {
                        config: new wu(this, {
                            zoom: t1,
                            lut: r
                        }),
                        defines: n,
                        overrideFog: !1
                    };
                }
                is3D(e1) {
                    return !e1 && !!this.layout && "none" !== this.layout.get("circle-elevation-reference");
                }
                hasElevation() {
                    return this.layout && "none" !== this.layout.get("circle-elevation-reference");
                }
            },
            heatmap: class extends Uo {
                createBucket(e1) {
                    return new qh(e1);
                }
                constructor(e1, t1, r, n){
                    super(e1, {
                        layout: Hh || (Hh = new fo({
                            visibility: new co(mo.layout_heatmap.visibility)
                        })),
                        paint: Xh || (Xh = new fo({
                            "heatmap-radius": new ho(mo.paint_heatmap["heatmap-radius"]),
                            "heatmap-weight": new ho(mo.paint_heatmap["heatmap-weight"]),
                            "heatmap-intensity": new co(mo.paint_heatmap["heatmap-intensity"]),
                            "heatmap-color": new po(mo.paint_heatmap["heatmap-color"]),
                            "heatmap-opacity": new co(mo.paint_heatmap["heatmap-opacity"]),
                            "heatmap-color-use-theme": new ho({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, r, n), this._updateColorRamp();
                }
                _handleSpecialPaintPropertyUpdate(e1) {
                    "heatmap-color" === e1 && this._updateColorRamp();
                }
                _updateColorRamp() {
                    this.colorRamp = rd({
                        expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                        evaluationKey: "heatmapDensity",
                        image: this.colorRamp
                    }), this.colorRampTexture = null;
                }
                resize() {
                    this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null);
                }
                _clear() {
                    this.heatmapFbo && (this.heatmapFbo.destroy(), this.heatmapFbo = null), this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null);
                }
                queryRadius(e1) {
                    return Jc("heatmap-radius", this, e1);
                }
                queryIntersectsFeature(e1, t1, r, n, i, s, a, o) {
                    const l = this.paint.get("heatmap-radius").evaluate(t1, r);
                    return Uh(e1, n, s, a, o, !0, !0, new Me(0, 0), l);
                }
                hasOffscreenPass() {
                    return 0 !== this.paint.get("heatmap-opacity") && "none" !== this.visibility;
                }
                getProgramIds() {
                    return [
                        "heatmap",
                        "heatmapTexture"
                    ];
                }
                getDefaultProgramParams(e1, t1, r) {
                    return "heatmap" === e1 ? {
                        config: new wu(this, {
                            zoom: t1,
                            lut: r
                        }),
                        overrideFog: !1
                    } : {};
                }
            },
            hillshade: class extends Uo {
                constructor(e1, t1, r, n){
                    super(e1, {
                        layout: Zh || (Zh = new fo({
                            visibility: new co(mo.layout_hillshade.visibility)
                        })),
                        paint: Wh || (Wh = new fo({
                            "hillshade-illumination-direction": new co(mo.paint_hillshade["hillshade-illumination-direction"]),
                            "hillshade-illumination-anchor": new co(mo.paint_hillshade["hillshade-illumination-anchor"]),
                            "hillshade-exaggeration": new co(mo.paint_hillshade["hillshade-exaggeration"]),
                            "hillshade-shadow-color": new co(mo.paint_hillshade["hillshade-shadow-color"]),
                            "hillshade-highlight-color": new co(mo.paint_hillshade["hillshade-highlight-color"]),
                            "hillshade-accent-color": new co(mo.paint_hillshade["hillshade-accent-color"]),
                            "hillshade-emissive-strength": new co(mo.paint_hillshade["hillshade-emissive-strength"]),
                            "hillshade-shadow-color-use-theme": new ho({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "hillshade-highlight-color-use-theme": new ho({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "hillshade-accent-color-use-theme": new ho({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, r, n);
                }
                shouldRedrape() {
                    return this.hasOffscreenPass() && "viewport" === this.paint.get("hillshade-illumination-anchor");
                }
                hasOffscreenPass() {
                    return 0 !== this.paint.get("hillshade-exaggeration") && "none" !== this.visibility;
                }
                getProgramIds() {
                    return [
                        "hillshade",
                        "hillshadePrepare"
                    ];
                }
                getDefaultProgramParams(e1, t1, r) {
                    return {
                        overrideFog: !1
                    };
                }
            },
            fill: class extends Uo {
                constructor(e1, t1, r, n){
                    super(e1, {
                        layout: Pp || (Pp = new fo({
                            "fill-sort-key": new ho(mo.layout_fill["fill-sort-key"]),
                            visibility: new co(mo.layout_fill.visibility),
                            "fill-elevation-reference": new co(mo.layout_fill["fill-elevation-reference"]),
                            "fill-construct-bridge-guard-rail": new ho(mo.layout_fill["fill-construct-bridge-guard-rail"])
                        })),
                        paint: Tp || (Tp = new fo({
                            "fill-antialias": new co(mo.paint_fill["fill-antialias"]),
                            "fill-opacity": new ho(mo.paint_fill["fill-opacity"]),
                            "fill-color": new ho(mo.paint_fill["fill-color"]),
                            "fill-outline-color": new ho(mo.paint_fill["fill-outline-color"]),
                            "fill-translate": new co(mo.paint_fill["fill-translate"]),
                            "fill-translate-anchor": new co(mo.paint_fill["fill-translate-anchor"]),
                            "fill-pattern": new ho(mo.paint_fill["fill-pattern"]),
                            "fill-pattern-cross-fade": new co(mo.paint_fill["fill-pattern-cross-fade"]),
                            "fill-emissive-strength": new co(mo.paint_fill["fill-emissive-strength"]),
                            "fill-z-offset": new ho(mo.paint_fill["fill-z-offset"]),
                            "fill-bridge-guard-rail-color": new ho(mo.paint_fill["fill-bridge-guard-rail-color"]),
                            "fill-tunnel-structure-color": new ho(mo.paint_fill["fill-tunnel-structure-color"]),
                            "fill-color-use-theme": new ho({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "fill-outline-color-use-theme": new ho({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "fill-bridge-guard-rail-color-use-theme": new ho({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "fill-tunnel-structure-color-use-theme": new ho({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, r, n);
                }
                getProgramIds() {
                    const e1 = this.paint.get("fill-pattern"), t1 = e1 && e1.constantOr(1), r = [
                        t1 ? "fillPattern" : "fill"
                    ];
                    return this.paint.get("fill-antialias") && r.push(t1 && !this.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline"), r;
                }
                getDefaultProgramParams(e1, t1, r) {
                    return {
                        config: new wu(this, {
                            zoom: t1,
                            lut: r
                        }),
                        overrideFog: !1
                    };
                }
                recalculate(e1, t1) {
                    super.recalculate(e1, t1);
                    const r = this.paint._values["fill-outline-color"];
                    "constant" === r.value.kind && void 0 === r.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
                }
                createBucket(e1) {
                    return new Sp(e1);
                }
                queryRadius() {
                    return Kc(this.paint.get("fill-translate"));
                }
                queryIntersectsFeature(e1, t1, r, n, i, s) {
                    return !e1.queryGeometry.isAboveHorizon && Rc(Qc(e1.tilespaceGeometry, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), s.angle, e1.pixelToTileUnitsFactor), n);
                }
                isTileClipped() {
                    return 0 === this.paint.get("fill-z-offset").constantOr(1);
                }
                is3D(e1) {
                    if (0 !== this.paint.get("fill-z-offset").constantOr(1)) return !0;
                    const t1 = this.layout && "none" !== this.layout.get("fill-elevation-reference");
                    return null != e1 ? t1 && !e1 : t1;
                }
                hasElevation() {
                    return this.layout && "none" !== this.layout.get("fill-elevation-reference");
                }
                hasShadowPass() {
                    return this.layout && "none" !== this.layout.get("fill-elevation-reference");
                }
            },
            "fill-extrusion": class extends Uo {
                constructor(e1, t1, r, n){
                    super(e1, {
                        layout: Rf || (Rf = new fo({
                            visibility: new co(mo["layout_fill-extrusion"].visibility),
                            "fill-extrusion-edge-radius": new co(mo["layout_fill-extrusion"]["fill-extrusion-edge-radius"]),
                            "source-max-zoom": new co(mo["layout_fill-extrusion"]["source-max-zoom"])
                        })),
                        paint: Lf || (Lf = new fo({
                            "fill-extrusion-opacity": new co(mo["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                            "fill-extrusion-color": new ho(mo["paint_fill-extrusion"]["fill-extrusion-color"]),
                            "fill-extrusion-translate": new co(mo["paint_fill-extrusion"]["fill-extrusion-translate"]),
                            "fill-extrusion-translate-anchor": new co(mo["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                            "fill-extrusion-pattern": new ho(mo["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                            "fill-extrusion-pattern-cross-fade": new co(mo["paint_fill-extrusion"]["fill-extrusion-pattern-cross-fade"]),
                            "fill-extrusion-height": new ho(mo["paint_fill-extrusion"]["fill-extrusion-height"]),
                            "fill-extrusion-base": new ho(mo["paint_fill-extrusion"]["fill-extrusion-base"]),
                            "fill-extrusion-height-alignment": new co(mo["paint_fill-extrusion"]["fill-extrusion-height-alignment"]),
                            "fill-extrusion-base-alignment": new co(mo["paint_fill-extrusion"]["fill-extrusion-base-alignment"]),
                            "fill-extrusion-vertical-gradient": new co(mo["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"]),
                            "fill-extrusion-ambient-occlusion-intensity": new co(mo["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-intensity"]),
                            "fill-extrusion-ambient-occlusion-radius": new co(mo["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-radius"]),
                            "fill-extrusion-ambient-occlusion-wall-radius": new co(mo["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-wall-radius"]),
                            "fill-extrusion-ambient-occlusion-ground-radius": new co(mo["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-radius"]),
                            "fill-extrusion-ambient-occlusion-ground-attenuation": new co(mo["paint_fill-extrusion"]["fill-extrusion-ambient-occlusion-ground-attenuation"]),
                            "fill-extrusion-flood-light-color": new co(mo["paint_fill-extrusion"]["fill-extrusion-flood-light-color"]),
                            "fill-extrusion-flood-light-intensity": new co(mo["paint_fill-extrusion"]["fill-extrusion-flood-light-intensity"]),
                            "fill-extrusion-flood-light-wall-radius": new ho(mo["paint_fill-extrusion"]["fill-extrusion-flood-light-wall-radius"]),
                            "fill-extrusion-flood-light-ground-radius": new ho(mo["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-radius"]),
                            "fill-extrusion-flood-light-ground-attenuation": new co(mo["paint_fill-extrusion"]["fill-extrusion-flood-light-ground-attenuation"]),
                            "fill-extrusion-vertical-scale": new co(mo["paint_fill-extrusion"]["fill-extrusion-vertical-scale"]),
                            "fill-extrusion-rounded-roof": new co(mo["paint_fill-extrusion"]["fill-extrusion-rounded-roof"]),
                            "fill-extrusion-cutoff-fade-range": new co(mo["paint_fill-extrusion"]["fill-extrusion-cutoff-fade-range"]),
                            "fill-extrusion-front-cutoff": new co(mo["paint_fill-extrusion"]["fill-extrusion-front-cutoff"]),
                            "fill-extrusion-emissive-strength": new ho(mo["paint_fill-extrusion"]["fill-extrusion-emissive-strength"]),
                            "fill-extrusion-line-width": new ho(mo["paint_fill-extrusion"]["fill-extrusion-line-width"]),
                            "fill-extrusion-cast-shadows": new co(mo["paint_fill-extrusion"]["fill-extrusion-cast-shadows"]),
                            "fill-extrusion-color-use-theme": new ho({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "fill-extrusion-flood-light-color-use-theme": new ho({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, r, n), this._stats = {
                        numRenderedVerticesInShadowPass: 0,
                        numRenderedVerticesInTransparentPass: 0
                    };
                }
                createBucket(e1) {
                    return new Mf(e1);
                }
                queryRadius() {
                    return Kc(this.paint.get("fill-extrusion-translate"));
                }
                is3D(e1) {
                    return !0;
                }
                hasShadowPass() {
                    return this.paint.get("fill-extrusion-cast-shadows");
                }
                cutoffRange() {
                    return this.paint.get("fill-extrusion-cutoff-fade-range");
                }
                canCastShadows() {
                    return !0;
                }
                getProgramIds() {
                    return [
                        this.paint.get("fill-extrusion-pattern").constantOr(1) ? "fillExtrusionPattern" : "fillExtrusion"
                    ];
                }
                queryIntersectsFeature(e1, t1, r, n, i, s, a, o, l) {
                    const u = eh(this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), s.angle, e1.pixelToTileUnitsFactor), c = this.paint.get("fill-extrusion-height").evaluate(t1, r), h = this.paint.get("fill-extrusion-base").evaluate(t1, r), d = [
                        0,
                        0
                    ], p = o && s.elevation, f = s.elevation ? s.elevation.exaggeration() : 1, m = e1.tile.getBucket(this);
                    if (m instanceof Mf) {
                        const e1 = m.centroidData.find((e1)=>l >= e1.vertexArrayOffset && l < e1.vertexArrayOffset + e1.vertexCount);
                        if (e1 && e1.flags & pf) return !1;
                        if (p) {
                            const e1 = m.centroidVertexArray, t1 = l + 1;
                            t1 < e1.length && (d[0] = e1.geta_centroid_pos0(t1), d[1] = e1.geta_centroid_pos1(t1));
                        }
                    }
                    if (0 === d[0] && 1 === d[1]) return !1;
                    "globe" === s.projection.name && (n = Ef([
                        n
                    ], [
                        new Me(0, 0),
                        new Me(qn, qn)
                    ], e1.tileID.canonical).map((e1)=>e1.polygon).flat());
                    const y = p ? o : null, [g, x] = Wf(s, n, h, c, u, a, y, d, f, s.center.lat, e1.tileID.canonical), v = e1.queryGeometry;
                    return Zf(g, x, v.isPointQuery() ? v.screenBounds : v.screenGeometry);
                }
            },
            building: class extends Uo {
                constructor(e1, t1, r, n){
                    super(e1, {
                        layout: Dy || (Dy = new fo({
                            visibility: new co(mo.layout_building.visibility),
                            "building-facade": new ho(mo.layout_building["building-facade"]),
                            "building-facade-floors": new ho(mo.layout_building["building-facade-floors"]),
                            "building-facade-unit-width": new ho(mo.layout_building["building-facade-unit-width"]),
                            "building-facade-window": new ho(mo.layout_building["building-facade-window"]),
                            "building-roof-shape": new ho(mo.layout_building["building-roof-shape"]),
                            "building-height": new ho(mo.layout_building["building-height"]),
                            "building-base": new ho(mo.layout_building["building-base"]),
                            "building-flood-light-wall-radius": new ho(mo.layout_building["building-flood-light-wall-radius"]),
                            "building-flood-light-ground-radius": new ho(mo.layout_building["building-flood-light-ground-radius"]),
                            "building-flip-roof-orientation": new ho(mo.layout_building["building-flip-roof-orientation"])
                        })),
                        paint: Ey || (Ey = new fo({
                            "building-opacity": new co(mo.paint_building["building-opacity"]),
                            "building-ambient-occlusion-intensity": new co(mo.paint_building["building-ambient-occlusion-intensity"]),
                            "building-ambient-occlusion-ground-intensity": new co(mo.paint_building["building-ambient-occlusion-ground-intensity"]),
                            "building-ambient-occlusion-ground-radius": new co(mo.paint_building["building-ambient-occlusion-ground-radius"]),
                            "building-ambient-occlusion-ground-attenuation": new co(mo.paint_building["building-ambient-occlusion-ground-attenuation"]),
                            "building-vertical-scale": new co(mo.paint_building["building-vertical-scale"]),
                            "building-cast-shadows": new co(mo.paint_building["building-cast-shadows"]),
                            "building-color": new ho(mo.paint_building["building-color"]),
                            "building-emissive-strength": new ho(mo.paint_building["building-emissive-strength"]),
                            "building-facade-emissive-chance": new co(mo.paint_building["building-facade-emissive-chance"]),
                            "building-cutoff-fade-range": new co(mo.paint_building["building-cutoff-fade-range"]),
                            "building-front-cutoff": new co(mo.paint_building["building-front-cutoff"]),
                            "building-flood-light-color": new co(mo.paint_building["building-flood-light-color"]),
                            "building-flood-light-intensity": new co(mo.paint_building["building-flood-light-intensity"]),
                            "building-flood-light-ground-attenuation": new co(mo.paint_building["building-flood-light-ground-attenuation"]),
                            "building-color-use-theme": new ho({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "building-flood-light-color-use-theme": new ho({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, r, n), this._stats = {
                        numRenderedVerticesInShadowPass: 0,
                        numRenderedVerticesInTransparentPass: 0
                    };
                }
                createBucket(e1) {
                    return new ky(e1);
                }
                cutoffRange() {
                    return this.paint.get("building-cutoff-fade-range");
                }
                hasShadowPass() {
                    return this.paint.get("building-cast-shadows");
                }
                hasLightBeamPass() {
                    return !0;
                }
                canCastShadows() {
                    return !0;
                }
                is3D(e1) {
                    return !0;
                }
                queryRadius(e1) {
                    return 0;
                }
                queryIntersectsFeature(e1, t1, r, n, i, s, a, o, l, u) {
                    let c = this.layout.get("building-height").evaluate(t1, r);
                    const h = this.layout.get("building-base").evaluate(t1, r), d = e1.tile.getBucket(this).getFootprint(t1);
                    if (d) {
                        if (0 !== d.hiddenFlags) return !1;
                        c = d.height;
                    }
                    const [p, f] = Wf(s, n, h, c, new Me(0, 0), a, null, [
                        0,
                        0
                    ], 1, s.center.lat, e1.tileID.canonical), m = e1.queryGeometry;
                    return Zf(p, f, m.isPointQuery() ? m.screenBounds : m.screenGeometry);
                }
            },
            line: class extends Uo {
                constructor(e1, t1, r, n){
                    const i = sg();
                    super(e1, i, t1, r, n), i.layout && (this.layout = new uo(i.layout)), this.gradientVersion = 0, this.hasElevatedBuckets = !1, this.hasNonElevatedBuckets = !1;
                }
                _handleSpecialPaintPropertyUpdate(e1) {
                    if ("line-gradient" === e1) {
                        const e1 = this._transitionablePaint._values["line-gradient"].value.expression;
                        this.stepInterpolant = e1._styleExpression && e1._styleExpression.expression instanceof ki, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                    }
                }
                gradientExpression() {
                    return this._transitionablePaint._values["line-gradient"].value.expression;
                }
                widthExpression() {
                    return this._transitionablePaint._values["line-width"].value.expression;
                }
                emissiveStrengthExpression() {
                    return this._transitionablePaint._values["line-emissive-strength"].value.expression;
                }
                recalculate(e1, t1) {
                    super.recalculate(e1, t1), this.paint._values["line-floorwidth"] = (()=>{
                        if (og) return og;
                        const e1 = sg();
                        return og = new ag(e1.paint.properties["line-width"].specification), og.useIntegerZoom = !0, og;
                    })().possiblyEvaluate(this._transitioningPaint._values["line-width"].value, e1);
                }
                createBucket(e1) {
                    return new Zy(e1);
                }
                getProgramIds() {
                    const e1 = [
                        this.paint.get("line-pattern").constantOr(1) ? "linePattern" : "line"
                    ];
                    return "default" !== this.paint.get("line-blend-mode") && e1.push("lineBlendComposite"), e1;
                }
                getDefaultProgramParams(e1, t1, r) {
                    if ("lineBlendComposite" === e1) return {};
                    const n = rg(this);
                    return {
                        config: new wu(this, {
                            zoom: t1,
                            lut: r
                        }),
                        defines: n,
                        overrideFog: !1
                    };
                }
                queryRadius(e1) {
                    const t1 = e1, r = lg(Jc("line-width", this, t1), Jc("line-gap-width", this, t1)), n = Jc("line-offset", this, t1);
                    return r / 2 + Math.abs(n) + Kc(this.paint.get("line-translate"));
                }
                queryIntersectsFeature(e1, t1, r, n, i, s) {
                    if (e1.queryGeometry.isAboveHorizon) return !1;
                    const a = Qc(e1.tilespaceGeometry, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), s.angle, e1.pixelToTileUnitsFactor), o = e1.pixelToTileUnitsFactor / 2 * lg(this.paint.get("line-width").evaluate(t1, r), this.paint.get("line-gap-width").evaluate(t1, r)), l = this.paint.get("line-offset").evaluate(t1, r);
                    return l && (n = function(e1, t1) {
                        const r = [], n = new Me(0, 0);
                        for(let i = 0; i < e1.length; i++){
                            const s = e1[i], a = [];
                            for(let e1 = 0; e1 < s.length; e1++){
                                const r = s[e1], i = s[e1 + 1], o = 0 === e1 ? n : r.sub(s[e1 - 1])._unit()._perp(), l = e1 === s.length - 1 ? n : i.sub(r)._unit()._perp(), u = o._add(l)._unit();
                                u._mult(1 / (u.x * l.x + u.y * l.y)), a.push(u._mult(t1)._add(r));
                            }
                            r.push(a);
                        }
                        return r;
                    }(n, l * e1.pixelToTileUnitsFactor)), function(e1, t1, r) {
                        for(let n = 0; n < t1.length; n++){
                            const i = t1[n];
                            if (e1.length >= 3) {
                                for(let t1 = 0; t1 < i.length; t1++)if (Hc(e1, i[t1])) return !0;
                            }
                            if (Lc(e1, i, r)) return !0;
                        }
                        return !1;
                    }(a, n, o);
                }
                isTileClipped() {
                    return this.hasNonElevatedBuckets;
                }
                isDraped(e1) {
                    return !this.hasElevatedBuckets || this.layout && "hd-road-markup" === this.layout.get("line-elevation-reference");
                }
                hasElevation() {
                    return this.layout && "none" !== this.layout.get("line-elevation-reference");
                }
                hasOffscreenPass() {
                    return "default" !== this.paint.get("line-blend-mode") && 0 !== this.paint.get("line-opacity").constantOr(1) && 0 !== this.paint.get("line-width").constantOr(1) && "none" !== this.visibility;
                }
                resize() {
                    this._destroyLineBlendFbo();
                }
                _clear() {
                    this._destroyLineBlendFbo();
                }
                _destroyLineBlendFbo() {
                    this.lineBlendFbo && (this.lineBlendFbo.destroy(), this.lineBlendFbo = null), this.lineBlendStencil = null, this.lineBlendDrapeFbo && (this.lineBlendDrapeFbo.destroy(), this.lineBlendDrapeFbo = null), this.lineBlendDrapeStencil = null;
                }
            },
            symbol: xb,
            background: class extends Uo {
                constructor(e1, t1, r, n){
                    super(e1, {
                        layout: vb || (vb = new fo({
                            visibility: new co(mo.layout_background.visibility)
                        })),
                        paint: bb || (bb = new fo({
                            "background-pitch-alignment": new co(mo.paint_background["background-pitch-alignment"]),
                            "background-color": new co(mo.paint_background["background-color"]),
                            "background-pattern": new co(mo.paint_background["background-pattern"]),
                            "background-opacity": new co(mo.paint_background["background-opacity"]),
                            "background-emissive-strength": new co(mo.paint_background["background-emissive-strength"]),
                            "background-color-use-theme": new ho({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, r, n);
                }
                getProgramIds() {
                    return [
                        this.paint.get("background-pattern") ? "backgroundPattern" : "background"
                    ];
                }
                getDefaultProgramParams(e1, t1, r) {
                    return {
                        overrideFog: !1
                    };
                }
                is3D(e1) {
                    return "viewport" === this.paint.get("background-pitch-alignment");
                }
            },
            raster: zb,
            "raster-particle": Lb,
            sky: class extends Uo {
                constructor(e1, t1, r, n){
                    super(e1, {
                        layout: Fb || (Fb = new fo({
                            visibility: new co(mo.layout_sky.visibility)
                        })),
                        paint: Db || (Db = new fo({
                            "sky-type": new co(mo.paint_sky["sky-type"]),
                            "sky-atmosphere-sun": new co(mo.paint_sky["sky-atmosphere-sun"]),
                            "sky-atmosphere-sun-intensity": new co(mo.paint_sky["sky-atmosphere-sun-intensity"]),
                            "sky-gradient-center": new co(mo.paint_sky["sky-gradient-center"]),
                            "sky-gradient-radius": new co(mo.paint_sky["sky-gradient-radius"]),
                            "sky-gradient": new po(mo.paint_sky["sky-gradient"]),
                            "sky-atmosphere-halo-color": new co(mo.paint_sky["sky-atmosphere-halo-color"]),
                            "sky-atmosphere-color": new co(mo.paint_sky["sky-atmosphere-color"]),
                            "sky-opacity": new co(mo.paint_sky["sky-opacity"]),
                            "sky-gradient-use-theme": new ho({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "sky-atmosphere-halo-color-use-theme": new ho({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            }),
                            "sky-atmosphere-color-use-theme": new ho({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, r, n), this._updateColorRamp();
                }
                _clear() {
                    this.skyboxFbo && (this.skyboxFbo.destroy(), this.skyboxFbo = null), this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null), this._skyboxInvalidated = !0;
                }
                _handleSpecialPaintPropertyUpdate(e1) {
                    "sky-gradient" === e1 ? this._updateColorRamp() : "sky-atmosphere-sun" !== e1 && "sky-atmosphere-halo-color" !== e1 && "sky-atmosphere-color" !== e1 && "sky-atmosphere-sun-intensity" !== e1 || (this._skyboxInvalidated = !0);
                }
                _updateColorRamp() {
                    this.colorRamp = rd({
                        expression: this._transitionablePaint._values["sky-gradient"].value.expression,
                        evaluationKey: "skyRadialProgress"
                    }), this.colorRampTexture && (this.colorRampTexture.destroy(), this.colorRampTexture = null);
                }
                needsSkyboxCapture(e1) {
                    if (this._skyboxInvalidated || !this.skyboxTexture || !this.skyboxGeometry) return !0;
                    if (!this.paint.get("sky-atmosphere-sun")) {
                        const t1 = e1.style.light.properties.get("position");
                        return this._lightPosition.azimuthal !== t1.azimuthal || this._lightPosition.polar !== t1.polar;
                    }
                    return !1;
                }
                getCenter(e1, t1) {
                    if ("atmosphere" === this.paint.get("sky-type")) {
                        const r = this.paint.get("sky-atmosphere-sun"), n = !r, i = e1.style.light, s = i.properties.get("position");
                        return n && "viewport" === i.properties.get("anchor") && Ze("The sun direction is attached to a light with viewport anchor, lighting may behave unexpectedly."), n ? Ub(s.azimuthal, 90 - s.polar, t1) : Ub(r[0], 90 - r[1], t1);
                    }
                    const r = this.paint.get("sky-gradient-center");
                    return Ub(r[0], 90 - r[1], t1);
                }
                isSky() {
                    return !0;
                }
                markSkyboxValid(e1) {
                    this._skyboxInvalidated = !1, this._lightPosition = e1.style.light.properties.get("position");
                }
                hasOffscreenPass() {
                    return !0;
                }
                getProgramIds() {
                    const e1 = this.paint.get("sky-type");
                    return "atmosphere" === e1 ? [
                        "skyboxCapture",
                        "skybox"
                    ] : "gradient" === e1 ? [
                        "skyboxGradient"
                    ] : null;
                }
            },
            slot: class extends Uo {
                constructor(e1, t1, r, n){
                    super(e1, {
                        paint: Eb || (Eb = new fo({}))
                    }, t1, null);
                }
            },
            model: class extends Uo {
                constructor(e1, t1, r, n){
                    super(e1, {
                        layout: Cb || (Cb = new fo({
                            visibility: new co(mo.layout_model.visibility),
                            "model-id": new ho(mo.layout_model["model-id"]),
                            "model-allow-density-reduction": new co(mo.layout_model["model-allow-density-reduction"])
                        })),
                        paint: Rb || (Rb = new fo({
                            "model-opacity": new ho(mo.paint_model["model-opacity"]),
                            "model-rotation": new ho(mo.paint_model["model-rotation"]),
                            "model-scale": new ho(mo.paint_model["model-scale"]),
                            "model-translation": new ho(mo.paint_model["model-translation"]),
                            "model-color": new ho(mo.paint_model["model-color"]),
                            "model-color-mix-intensity": new ho(mo.paint_model["model-color-mix-intensity"]),
                            "model-type": new co(mo.paint_model["model-type"]),
                            "model-cast-shadows": new co(mo.paint_model["model-cast-shadows"]),
                            "model-receive-shadows": new co(mo.paint_model["model-receive-shadows"]),
                            "model-ambient-occlusion-intensity": new co(mo.paint_model["model-ambient-occlusion-intensity"]),
                            "model-emissive-strength": new ho(mo.paint_model["model-emissive-strength"]),
                            "model-roughness": new ho(mo.paint_model["model-roughness"]),
                            "model-height-based-emissive-strength-multiplier": new ho(mo.paint_model["model-height-based-emissive-strength-multiplier"]),
                            "model-cutoff-fade-range": new co(mo.paint_model["model-cutoff-fade-range"]),
                            "model-front-cutoff": new co(mo.paint_model["model-front-cutoff"]),
                            "model-elevation-reference": new co(mo.paint_model["model-elevation-reference"]),
                            "model-ignore-line-cutout": new co(mo.paint_model["model-ignore-line-cutout"]),
                            "model-color-use-theme": new ho({
                                type: "string",
                                default: "default",
                                "property-type": "data-driven"
                            })
                        }))
                    }, t1, r, n), this.layer = e1, this._stats = {
                        numRenderedVerticesInShadowPass: 0,
                        numRenderedVerticesInTransparentPass: 0
                    };
                }
                createBucket(e1) {
                    return new qb(e1);
                }
                getProgramIds() {
                    return [
                        "model"
                    ];
                }
                is3D(e1) {
                    return !0;
                }
                hasShadowPass() {
                    return !0;
                }
                canCastShadows() {
                    return !0;
                }
                hasLightBeamPass() {
                    return !0;
                }
                cutoffRange() {
                    return this.paint.get("model-cutoff-fade-range");
                }
                queryRadius(e1) {
                    return e1 instanceof Qb ? 8191 : 0;
                }
                queryRenderedFeatures(e1, t1, r) {
                    const n = t1.getSource();
                    if (!(n && n instanceof sw)) return {};
                    const i = n, s = {};
                    s[this.id] = [];
                    const a = s[this.id];
                    let o = 0;
                    for (const n of i.models){
                        const i = t1.getFeatureState(this.sourceLayer, n.id), s = {
                            type: "Unknown",
                            id: n.id,
                            properties: n.featureProperties
                        }, l = this.paint.get("model-rotation").evaluate(s, i), u = this.paint.get("model-scale").evaluate(s, i), c = this.paint.get("model-translation").evaluate(s, i), d = this.paint.get("model-elevation-reference");
                        let p = [];
                        Jm(p, n, r, n.position, l, u, c, "ground" === d, "ground" === d, !1), "globe" === r.projection.name && (p = Xm(p, r));
                        const f = h([], r.projMatrix, p), m = Zm(e1.isPointQuery() ? e1.screenBounds : e1.screenGeometry, r, f, n.aabb);
                        if (null != m) {
                            const e1 = new iw(void 0, 0, 0, 0, n.id);
                            e1.layer = this.layer, e1.properties = structuredClone(n.featureProperties), e1.properties.layer = this.id, e1.properties.uri = n.uri, e1.properties.orientation = n.orientation, e1.sourceLayer = this.sourceLayer, e1.geometry = {
                                type: "Point",
                                coordinates: [
                                    n.position.lng,
                                    n.position.lat
                                ]
                            }, e1.state = i, e1.source = this.source, a.push({
                                featureIndex: o,
                                feature: e1,
                                intersectionZ: m
                            });
                        }
                        ++o;
                    }
                    return s;
                }
                queryIntersectsFeature(e1, t1, r, n, i, s, a, o, l, u) {
                    if (!this.modelManager) return !1;
                    const c = this.modelManager, d = e1.tile.getBucket(this);
                    if (!(d && d instanceof qb)) return !1;
                    for(const r in d.instancesPerModel){
                        const n = d.instancesPerModel[r], i = void 0 !== t1.id ? t1.id : t1.properties && t1.properties.hasOwnProperty("id") ? t1.properties.id : void 0;
                        if (n.idToFeaturesIndex.hasOwnProperty(i)) {
                            const t1 = n.features[n.idToFeaturesIndex[i]], a = c.getModel(r, u || this.scope);
                            if (!a) return !1;
                            let o = [];
                            const l = new Ru(0, 0), p = d.canonical;
                            let f = Number.MAX_VALUE;
                            for(let r = 0; r < t1.instancedDataCount; ++r){
                                const i = 16 * (t1.instancedDataOffset + r), u = n.instancedDataArray.float32, c = [
                                    u[i + 4],
                                    u[i + 5],
                                    u[i + 6]
                                ];
                                aw(p, l, Math.floor(u[i]), Math.floor(u[i + 1])), Jm(o, a, s, l, t1.rotation, t1.scale, c, !1, !1, !1), "globe" === s.projection.name && (o = Xm(o, s));
                                const d = h([], s.projMatrix, o), m = e1.queryGeometry, y = Zm(m.isPointQuery() ? m.screenBounds : m.screenGeometry, s, d, a.aabb);
                                null != y && (f = Math.min(y, f));
                            }
                            return f !== Number.MAX_VALUE && f;
                        }
                    }
                    return !1;
                }
                _handleOverridablePaintPropertyUpdate(e1, t1, r) {
                    return !(!this.layout || t1.isDataDriven() || r.isDataDriven() || "model-color" !== e1 && "model-color-mix-intensity" !== e1 && "model-rotation" !== e1 && "model-scale" !== e1 && "model-translation" !== e1 && "model-emissive-strength" !== e1);
                }
                _isPropertyZoomDependent(e1) {
                    const t1 = this._transitionablePaint._values[e1];
                    return null != t1 && null != t1.value && null != t1.value.expression && t1.value.expression instanceof Xs;
                }
                isZoomDependent() {
                    return this._isPropertyZoomDependent("model-scale") || this._isPropertyZoomDependent("model-rotation") || this._isPropertyZoomDependent("model-translation");
                }
            },
            clip: class extends Uo {
                constructor(e1, t1, r, n){
                    super(e1, {
                        layout: zp || (zp = new fo({
                            "clip-layer-types": new co(mo.layout_clip["clip-layer-types"]),
                            "clip-layer-scope": new co(mo.layout_clip["clip-layer-scope"]),
                            visibility: new co(mo.layout_clip.visibility)
                        })),
                        paint: kp || (kp = new fo({}))
                    }, t1, r, n);
                }
                recalculate(e1, t1) {
                    super.recalculate(e1, t1);
                }
                createBucket(e1) {
                    return new Dp(e1);
                }
                is3D(e1) {
                    return !0;
                }
            }
        };
        class uw {
            constructor(e1){
                this._callback = e1, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
                    this._triggered = !1, this._callback();
                });
            }
            trigger() {
                this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(()=>{
                    this._triggered = !1, this._callback();
                }, 0));
            }
            remove() {
                this._channel = void 0, this._callback = ()=>{};
            }
        }
        class cw {
            constructor(e1){
                this._stringToNumber = {}, this._numberToString = [];
                for(let t1 = 0; t1 < e1.length; t1++){
                    const r = e1[t1];
                    this._stringToNumber[r] = t1, this._numberToString[t1] = r;
                }
            }
            encode(e1) {
                return this._stringToNumber[e1];
            }
            decode(e1) {
                return this._numberToString[e1];
            }
        }
        class hw {
            constructor(e1, t1){
                this.tileID = e1, this.x = e1.canonical.x, this.y = e1.canonical.y, this.z = e1.canonical.z, this.grid = new ea(qn, 16, 0), this.featureIndexArray = new Ol, this.promoteId = t1, this.is3DTile = !1, this.serializedLayersCache = new Map;
            }
            insert(e1, t1, r, n, i, s = 0, a = 0) {
                const o = this.featureIndexArray.length;
                this.featureIndexArray.emplaceBack(r, n, i, s);
                const l = this.grid;
                for(let e1 = 0; e1 < t1.length; e1++){
                    const r = t1[e1], n = [
                        1 / 0,
                        1 / 0,
                        -1 / 0,
                        -1 / 0
                    ];
                    for(let e1 = 0; e1 < r.length; e1++){
                        const t1 = r[e1];
                        n[0] = Math.min(n[0], t1.x), n[1] = Math.min(n[1], t1.y), n[2] = Math.max(n[2], t1.x), n[3] = Math.max(n[3], t1.y);
                    }
                    0 !== a && (n[0] -= a, n[1] -= a, n[2] += a, n[3] += a), n[0] < qn && n[1] < qn && n[2] >= 0 && n[3] >= 0 && l.insert(o, n[0], n[1], n[2], n[3]);
                }
            }
            loadVTLayers() {
                if (!this.vtLayers) {
                    this.vtLayers = new dc(new Fg(this.rawTileData)).layers, this.sourceLayerCoder = new cw(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                        "_geojsonTileLayer"
                    ]), this.vtFeatures = {};
                    for(const e1 in this.vtLayers)this.vtFeatures[e1] = [];
                }
                return this.vtLayers;
            }
            query(e1, t1) {
                const { tilespaceGeometry: r, transform: n, tileTransform: i, pixelPosMatrix: s, availableImages: a, worldview: o } = t1;
                this.loadVTLayers(), this.serializedLayersCache.clear();
                const l = t1.queryRadius ? t1.queryRadius : 0, u = r.bufferedTilespaceBounds, c = this.grid.query(u.min.x, u.min.y, u.max.x, u.max.y, (e1, t1, n, i)=>Xc(r.bufferedTilespaceGeometry, e1 - l, t1 - l, n + l, i + l));
                c.sort(pw);
                let h = null;
                n.elevation && c.length > 0 && (h = Hb.create(n.elevation, this.tileID));
                const d = {};
                let p;
                for(let l = 0; l < c.length; l++){
                    const u = c[l];
                    if (u === p) continue;
                    p = u;
                    const f = this.featureIndexArray.get(u);
                    let m = null;
                    this.is3DTile ? this.loadMatchingModelFeature(d, f, e1, r, n, o) : this.loadMatchingFeature(d, f, e1, a, o, (e1, a, o, l = 0)=>(m || (m = sc(e1, this.tileID.canonical, i)), a.queryIntersectsFeature(r, e1, o, m, this.z, n, s, h, l, t1.scope)));
                }
                return d;
            }
            loadMatchingFeature(e1, t1, r, n, i, s) {
                const { featureIndex: a, bucketIndex: o, sourceLayerIndex: l, layoutVertexArrayOffset: u } = t1, c = this.bucketLayerIDs[o], h = r.layers, d = Object.keys(h);
                if (d.length && !He(d, c)) return;
                const p = r.sourceCache, f = this.sourceLayerCoder.decode(l), m = this.vtLayers[f].feature(a), y = this.getId(m, f);
                for(let t1 = 0; t1 < c.length; t1++){
                    const r = c[t1];
                    if (!h[r]) continue;
                    const { styleLayer: o, targets: l } = h[r];
                    let d = {};
                    void 0 !== y && (d = p.getFeatureState(o.sourceLayer, y));
                    const f = !s || s(m, o, d, u);
                    if (!f) continue;
                    const g = new iw(m, this.z, this.x, this.y, y);
                    g.tile = this.tileID.canonical, g.state = d;
                    let x = this.serializedLayersCache.get(r);
                    x || (x = o.serialize(), x.id = r, this.serializedLayersCache.set(r, x)), g.source = x.source, g.sourceLayer = x["source-layer"], g.layer = Object.assign({}, x), g.layer.paint = dw(x.paint, o.paint, m, d, n), g.layer.layout = dw(x.layout, o.layout, m, d, n);
                    let v = !1;
                    for (const e1 of l){
                        this.updateFeatureProperties(g, e1);
                        const { filter: t1 } = e1;
                        if (t1) {
                            if (m.properties = g.properties, t1.needGeometry) {
                                const e1 = ac(m, !0);
                                if (!t1.filter(new to(this.tileID.overscaledZ, {
                                    worldview: i
                                }), e1, this.tileID.canonical)) continue;
                            } else if (!t1.filter(new to(this.tileID.overscaledZ, {
                                worldview: i
                            }), m)) continue;
                        }
                        v = !0, e1.targetId && this.addFeatureVariant(g, e1);
                    }
                    v && this.appendToResult(e1, r, a, g, f);
                }
            }
            loadMatchingModelFeature(e1, t1, r, n, i, s) {
                const { featureIndex: a, bucketIndex: o } = t1, l = this.bucketLayerIDs[o], u = r.layers, c = Object.keys(u);
                if (!c.length || He(c, l)) for(let t1 = 0; t1 < l.length; t1++){
                    const o = l[t1], { styleLayer: c, targets: h } = u[o];
                    if ("model" !== c.type) continue;
                    const d = n.tile, p = d.getBucket(c);
                    if (!(p && p instanceof Qb)) continue;
                    const f = ow(p, a, n, i);
                    if (!f) continue;
                    const { z: m, x: y, y: g } = d.tileID.canonical, { feature: x, intersectionZ: v, position: b } = f;
                    let w = {};
                    void 0 !== x.id && (w = r.sourceCache.getFeatureState(c.sourceLayer, x.id));
                    const _ = new iw({}, m, y, g, x.id);
                    _.tile = this.tileID.canonical, _.state = w, _.properties = x.properties, _.geometry = {
                        type: "Point",
                        coordinates: [
                            b.lng,
                            b.lat
                        ]
                    };
                    let A = this.serializedLayersCache.get(o);
                    A || (A = c.serialize(), A.id = o, this.serializedLayersCache.set(o, A)), _.source = A.source, _.sourceLayer = A["source-layer"], _.layer = Object.assign({}, A);
                    let I = !1;
                    for (const e1 of h){
                        this.updateFeatureProperties(_, e1);
                        const { filter: t1 } = e1;
                        if (t1) {
                            if (x.properties = _.properties, t1.needGeometry) {
                                if (!t1.filter(new to(this.tileID.overscaledZ, {
                                    worldview: s
                                }), x, this.tileID.canonical)) continue;
                            } else if (!t1.filter(new to(this.tileID.overscaledZ, {
                                worldview: s
                            }), x)) continue;
                        }
                        I = !0, e1.targetId && this.addFeatureVariant(_, e1);
                    }
                    I && this.appendToResult(e1, o, a, _, v);
                }
            }
            updateFeatureProperties(e1, t1, r) {
                if (t1.properties) {
                    const n = {};
                    for(const i in t1.properties){
                        const s = t1.properties[i].evaluate({
                            zoom: this.z
                        }, e1._vectorTileFeature, e1.state, e1.tile, r);
                        null != s && (n[i] = s);
                    }
                    e1.properties = n;
                }
            }
            addFeatureVariant(e1, t1, r) {
                const n = {
                    target: t1.target,
                    namespace: t1.namespace,
                    uniqueFeatureID: t1.uniqueFeatureID
                };
                t1.properties && (n.properties = e1.properties), e1.variants = e1.variants || {}, e1.variants[t1.targetId] = e1.variants[t1.targetId] || [], e1.variants[t1.targetId].push(n);
            }
            appendToResult(e1, t1, r, n, i) {
                let s = e1[t1];
                void 0 === s && (s = e1[t1] = []), s.push({
                    featureIndex: r,
                    feature: n,
                    intersectionZ: i
                });
            }
            lookupSymbolFeatures(e1, t1, r, n, i, s) {
                const a = {};
                this.loadVTLayers();
                for (const o of e1)this.loadMatchingFeature(a, {
                    bucketIndex: t1,
                    sourceLayerIndex: r,
                    featureIndex: o,
                    layoutVertexArrayOffset: 0
                }, n, i, s);
                return a;
            }
            loadFeature(e1) {
                const { featureIndex: t1, sourceLayerIndex: r } = e1;
                this.loadVTLayers();
                const n = this.sourceLayerCoder.decode(r), i = this.vtFeatures[n];
                if (i[t1]) return i[t1];
                const s = this.vtLayers[n].feature(t1);
                return i[t1] = s, s;
            }
            hasLayer(e1) {
                for (const t1 of this.bucketLayerIDs)for (const r of t1)if (e1 === r) return !0;
                return !1;
            }
            getId(e1, t1) {
                let r = e1.id;
                if (this.promoteId) {
                    const n = Array.isArray(this.promoteId) || "object" != typeof this.promoteId ? this.promoteId : this.promoteId[t1];
                    if (null != n) {
                        if (Array.isArray(n)) {
                            if (!this.promoteIdExpression) {
                                const e1 = qs(n);
                                if ("success" !== e1.result) {
                                    const t1 = e1.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", ");
                                    return void Ze(`Failed to create expression for promoteId: ${t1}`);
                                }
                                this.promoteIdExpression = e1.value;
                            }
                            r = this.promoteIdExpression.evaluate({
                                zoom: 0
                            }, e1);
                        } else r = e1.properties[n];
                    }
                    "boolean" == typeof r && (r = Number(r));
                }
                return r;
            }
        }
        function dw(e1, t1, r, n, i) {
            return Ge(e1, (e1, s)=>{
                const a = t1 instanceof uo ? t1.get(s) : null;
                return a && a.evaluate ? a.evaluate(r, n, void 0, i) : a;
            });
        }
        function pw(e1, t1) {
            return t1 - e1;
        }
        function fw(e1, t1) {
            const r = {};
            if (!t1) return r;
            for (const n of e1){
                const e1 = n.layerIds.map((e1)=>t1.getLayer(e1)).filter(Boolean);
                if (0 !== e1.length) {
                    n.layers = e1, n.stateDependentLayerIds && (n.stateDependentLayers = n.stateDependentLayerIds.map((t1)=>e1.filter((e1)=>e1.id === t1)[0]));
                    for (const t1 of e1)r[t1.fqid] = n;
                }
            }
            return r;
        }
        ra(hw, "FeatureIndex", {
            omit: [
                "rawTileData",
                "sourceLayerCoder"
            ]
        });
        const mw = 32, yw = 33, gw = new Uint16Array(8184);
        for(let e1 = 0; e1 < 2046; e1++){
            let t1 = e1 + 2, r = 0, n = 0, i = 0, s = 0, a = 0, o = 0;
            for(1 & t1 ? i = s = a = mw : r = n = o = mw; (t1 >>= 1) > 1;){
                const e1 = r + i >> 1, l = n + s >> 1;
                1 & t1 ? (i = r, s = n, r = a, n = o) : (r = i, n = s, i = a, s = o), a = e1, o = l;
            }
            const l = 4 * e1;
            gw[l + 0] = r, gw[l + 1] = n, gw[l + 2] = i, gw[l + 3] = s;
        }
        const xw = new Uint16Array(2178), vw = new Uint8Array(1089), bw = new Uint16Array(1089);
        function ww(e1) {
            return 0 === e1 ? -0.03125 : 32 === e1 ? .03125 : 0;
        }
        const _w = {
            Other: 0,
            Symbol: 1,
            FillExtrusion: 2
        }, Aw = (()=>({
                type: 2,
                extent: qn,
                loadGeometry: ()=>[
                        [
                            new Me(0, 0),
                            new Me(8193, 0),
                            new Me(8193, 8193),
                            new Me(0, 8193),
                            new Me(0, 0)
                        ]
                    ]
            }))();
        class Iw {
            constructor(){
                this.tasks = {}, this.taskQueue = [], je([
                    "process"
                ], this), this.invoker = new uw(this.process), this.nextId = 0;
            }
            add(e1, t1) {
                const r = this.nextId++, n = function({ type: e1, renderSourceType: t1, zoom: r }) {
                    r = r || 0;
                    const n = t1 === _w.Symbol;
                    return "message" === e1 ? 0 : "maybePrepare" !== e1 || n ? "parseTile" !== e1 || n ? "parseTile" === e1 && n ? 300 - r : "maybePrepare" === e1 && n ? 400 - r : 500 : 200 - r : 100 - r;
                }(t1);
                if (0 === n) {
                    e1();
                    return null;
                }
                return this.tasks[r] = {
                    fn: e1,
                    metadata: t1,
                    priority: n,
                    id: r
                }, this.taskQueue.push(r), this.invoker.trigger(), {
                    cancel: ()=>{
                        delete this.tasks[r];
                    }
                };
            }
            process() {
                {
                    if (this.taskQueue = this.taskQueue.filter((e1)=>!!this.tasks[e1]), !this.taskQueue.length) return;
                    const e1 = this.pick();
                    if (null === e1) return;
                    const t1 = this.tasks[e1];
                    if (delete this.tasks[e1], this.taskQueue.length && this.invoker.trigger(), !t1) return;
                    t1.fn();
                }
            }
            pick() {
                let e1 = null, t1 = 1 / 0;
                for(let r = 0; r < this.taskQueue.length; r++){
                    const n = this.tasks[this.taskQueue[r]];
                    n.priority < t1 && (t1 = n.priority, e1 = r);
                }
                if (null === e1) return null;
                const r = this.taskQueue[e1];
                return this.taskQueue.splice(e1, 1), r;
            }
            remove() {
                this.invoker.remove();
            }
        }
        const Mw = new dr(0, 0, 0);
        function Bw(e1, t1, r) {
            1 === e1 && t1.icons.push(function(e1, t1) {
                return function(e1) {
                    if (e1.usvg_tree.height || (e1.usvg_tree.height = e1.usvg_tree.width), !e1.metadata) return e1;
                    const { metadata: t1 } = e1;
                    if (t1.content_area) {
                        const { content_area: r } = t1;
                        null == r.left && (r.left = 0), null == r.top && (r.top = r.left), null == r.width && (r.width = e1.usvg_tree.width), null == r.height && (r.height = r.width);
                    }
                    if (t1.text_placeholder) {
                        const { text_placeholder: e1 } = t1;
                        null == e1.top && (e1.top = e1.left), null == e1.height && (e1.height = e1.width);
                    }
                    return t1.stretch_x && t1.stretch_x.length && Sw(t1, "x"), t1.stretch_y && t1.stretch_y.length && Sw(t1, "y"), e1;
                }(e1.readFields(Pw, {
                    name: void 0
                }, t1));
            }(r, r.readVarint() + r.pos));
        }
        function Sw(e1, t1) {
            const r = [], n = e1[`stretch_${t1}`];
            let i = null;
            for(let e1 = 0; e1 < n.length; e1++)null === i ? i = 0 === r.length ? n[0] : r[r.length - 1][1] + n[e1] : (r.push([
                i,
                i + n[e1]
            ]), i = null);
            e1[`stretch_${t1}_areas`] = r;
        }
        function Pw(e1, t1, r) {
            1 === e1 ? t1.name = r.readString() : 2 === e1 ? t1.metadata = function(e1, t1) {
                return e1.readFields(Tw, {
                    stretch_x: null,
                    stretch_y: null,
                    stretch_x_areas: null,
                    stretch_y_areas: null,
                    variables: []
                }, t1);
            }(r, r.readVarint() + r.pos) : 3 === e1 && (t1.usvg_tree = function(e1, t1) {
                return e1.readFields(Fw, {
                    width: 20,
                    children: [],
                    linear_gradients: [],
                    radial_gradients: [],
                    clip_paths: [],
                    masks: []
                }, t1);
            }(r, r.readVarint() + r.pos), t1.data = "usvg_tree");
        }
        function Tw(e1, t1, r) {
            1 === e1 ? t1.stretch_x = r.readPackedVarint() : 2 === e1 ? t1.stretch_y = r.readPackedVarint() : 3 === e1 ? t1.content_area = zw(r, r.readVarint() + r.pos) : 4 === e1 ? t1.variables.push(function(e1, t1) {
                return e1.readFields(Vw, {
                    name: void 0
                }, t1);
            }(r, r.readVarint() + r.pos)) : 5 === e1 && (t1.text_placeholder = zw(r, r.readVarint() + r.pos));
        }
        function zw(e1, t1) {
            return e1.readFields(kw, {}, t1);
        }
        function kw(e1, t1, r) {
            1 === e1 ? t1.left = r.readVarint() : 2 === e1 ? t1.width = r.readVarint() : 3 === e1 ? t1.top = r.readVarint() : 4 === e1 && (t1.height = r.readVarint());
        }
        function Vw(e1, t1, r) {
            1 === e1 ? t1.name = r.readString() : 2 === e1 && (t1.rgb_color = Nw(r.readVarint()), t1.value = "rgb_color");
        }
        function Fw(e1, t1, r) {
            1 === e1 ? t1.width = t1.height = r.readVarint() : 2 === e1 ? t1.height = r.readVarint() : 3 === e1 ? t1.children.push(Dw(r, r.readVarint() + r.pos)) : 4 === e1 ? t1.linear_gradients.push(function(e1, t1) {
                return e1.readFields(Gw, {
                    spread_method: 1,
                    stops: [],
                    x1: 0,
                    y1: 0,
                    x2: 1,
                    y2: 0
                }, t1);
            }(r, r.readVarint() + r.pos)) : 5 === e1 ? t1.radial_gradients.push(function(e1, t1) {
                return e1.readFields(Hw, {
                    spread_method: 1,
                    stops: [],
                    cx: .5,
                    cy: .5,
                    r: .5,
                    fx: .5,
                    fy: .5,
                    fr: 0
                }, t1);
            }(r, r.readVarint() + r.pos)) : 7 === e1 ? t1.clip_paths.push(function(e1, t1) {
                return e1.readFields(Xw, {
                    children: []
                }, t1);
            }(r, r.readVarint() + r.pos)) : 8 === e1 && t1.masks.push(function(e1, t1) {
                const r = e1.readFields(Zw, {
                    left: 0,
                    width: 20,
                    mask_type: 1,
                    children: []
                }, t1);
                return null == r.height && (r.height = r.width), null == r.top && (r.top = r.left), r;
            }(r, r.readVarint() + r.pos));
        }
        function Dw(e1, t1) {
            return e1.readFields(Ew, {}, t1);
        }
        function Ew(e1, t1, r) {
            1 === e1 ? (t1.group = function(e1, t1) {
                return e1.readFields(Cw, {
                    opacity: 255,
                    children: []
                }, t1);
            }(r, r.readVarint() + r.pos), t1.node = "group") : 2 === e1 && (t1.path = function(e1, t1) {
                return e1.readFields(Ow, {
                    paint_order: 1,
                    commands: [],
                    step: 1,
                    diffs: [],
                    rule: 1
                }, t1);
            }(r, r.readVarint() + r.pos), t1.node = "path");
        }
        function Cw(e1, t1, r) {
            1 === e1 ? t1.transform = Rw(r, r.readVarint() + r.pos) : 2 === e1 ? t1.opacity = r.readVarint() : 5 === e1 ? t1.clip_path_idx = r.readVarint() : 6 === e1 ? t1.mask_idx = r.readVarint() : 7 === e1 && t1.children.push(Dw(r, r.readVarint() + r.pos));
        }
        function Rw(e1, t1) {
            return e1.readFields(Lw, {
                sx: 1,
                ky: 0,
                kx: 0,
                sy: 1,
                tx: 0,
                ty: 0
            }, t1);
        }
        function Lw(e1, t1, r) {
            1 === e1 ? t1.sx = r.readFloat() : 2 === e1 ? t1.ky = r.readFloat() : 3 === e1 ? t1.kx = r.readFloat() : 4 === e1 ? t1.sy = r.readFloat() : 5 === e1 ? t1.tx = r.readFloat() : 6 === e1 && (t1.ty = r.readFloat());
        }
        function Ow(e1, t1, r) {
            1 === e1 ? t1.fill = function(e1, t1) {
                return e1.readFields(Uw, {
                    rgb_color: Mw,
                    paint: "rgb_color",
                    opacity: 255
                }, t1);
            }(r, r.readVarint() + r.pos) : 2 === e1 ? t1.stroke = function(e1, t1) {
                return e1.readFields(jw, {
                    rgb_color: Mw,
                    paint: "rgb_color",
                    dasharray: [],
                    dashoffset: 0,
                    miterlimit: 4,
                    opacity: 255,
                    width: 1,
                    linecap: 1,
                    linejoin: 1
                }, t1);
            }(r, r.readVarint() + r.pos) : 3 === e1 ? t1.paint_order = r.readVarint() : 5 === e1 ? r.readPackedVarint(t1.commands) : 6 === e1 ? t1.step = r.readFloat() : 7 === e1 ? r.readPackedSVarint(t1.diffs) : 8 === e1 && (t1.rule = r.readVarint());
        }
        function Uw(e1, t1, r) {
            1 === e1 ? (t1.rgb_color = Nw(r.readVarint()), t1.paint = "rgb_color") : 2 === e1 ? (t1.linear_gradient_idx = r.readVarint(), t1.paint = "linear_gradient_idx") : 3 === e1 ? (t1.radial_gradient_idx = r.readVarint(), t1.paint = "radial_gradient_idx") : 5 === e1 && (t1.opacity = r.readVarint());
        }
        function Nw(e1) {
            return new dr((e1 >> 16 & 255) / 255, (e1 >> 8 & 255) / 255, (255 & e1) / 255, 1);
        }
        function jw(e1, t1, r) {
            1 === e1 ? (t1.rgb_color = Nw(r.readVarint()), t1.paint = "rgb_color") : 2 === e1 ? (t1.linear_gradient_idx = r.readVarint(), t1.paint = "linear_gradient_idx") : 3 === e1 ? (t1.radial_gradient_idx = r.readVarint(), t1.paint = "radial_gradient_idx") : 5 === e1 ? r.readPackedFloat(t1.dasharray) : 6 === e1 ? t1.dashoffset = r.readFloat() : 7 === e1 ? t1.miterlimit = r.readFloat() : 8 === e1 ? t1.opacity = r.readVarint() : 9 === e1 ? t1.width = r.readFloat() : 10 === e1 ? t1.linecap = r.readVarint() : 11 === e1 && (t1.linejoin = r.readVarint());
        }
        function Gw(e1, t1, r) {
            1 === e1 ? t1.transform = Rw(r, r.readVarint() + r.pos) : 2 === e1 ? t1.spread_method = r.readVarint() : 3 === e1 ? t1.stops.push($w(r, r.readVarint() + r.pos)) : 4 === e1 ? t1.x1 = r.readFloat() : 5 === e1 ? t1.y1 = r.readFloat() : 6 === e1 ? t1.x2 = r.readFloat() : 7 === e1 && (t1.y2 = r.readFloat());
        }
        function $w(e1, t1) {
            return e1.readFields(qw, {
                offset: 0,
                opacity: 255,
                rgb_color: Mw
            }, t1);
        }
        function qw(e1, t1, r) {
            1 === e1 ? t1.offset = r.readFloat() : 2 === e1 ? t1.opacity = r.readVarint() : 3 === e1 && (t1.rgb_color = Nw(r.readVarint()));
        }
        function Hw(e1, t1, r) {
            1 === e1 ? t1.transform = Rw(r, r.readVarint() + r.pos) : 2 === e1 ? t1.spread_method = r.readVarint() : 3 === e1 ? t1.stops.push($w(r, r.readVarint() + r.pos)) : 4 === e1 ? t1.cx = r.readFloat() : 5 === e1 ? t1.cy = r.readFloat() : 6 === e1 ? t1.r = r.readFloat() : 7 === e1 ? t1.fx = r.readFloat() : 8 === e1 ? t1.fy = r.readFloat() : 9 === e1 && (t1.fr = r.readFloat());
        }
        function Xw(e1, t1, r) {
            1 === e1 ? t1.transform = Rw(r, r.readVarint() + r.pos) : 2 === e1 ? t1.clip_path_idx = r.readVarint() : 3 === e1 && t1.children.push(Dw(r, r.readVarint() + r.pos));
        }
        function Zw(e1, t1, r) {
            1 === e1 ? t1.left = t1.top = r.readFloat() : 2 === e1 ? t1.width = t1.height = r.readFloat() : 3 === e1 ? t1.top = r.readFloat() : 4 === e1 ? t1.height = r.readFloat() : 5 === e1 ? t1.mask_type = r.readVarint() : 6 === e1 ? t1.mask_idx = r.readVarint() : 7 === e1 && t1.children.push(Dw(r, r.readVarint() + r.pos));
        }
        class Ww {
            static calculate(e1 = {}, t1 = []) {
                const r = new Map, n = new Map;
                if (0 === Object.keys(e1).length) return r;
                t1.forEach((e1)=>{
                    n.set(e1.name, e1.rgb_color || new dr(0, 0, 0));
                });
                for (const [t1, i] of Object.entries(e1))n.has(t1) ? r.set(n.get(t1).toString(), i) : console.warn(`Ignoring unknown image variable "${t1}"`);
                return r;
            }
        }
        function Yw(e1, t1 = 255, r) {
            const n = t1 / 255, i = e1.toString(), s = r.has(i) ? r.get(i).clone() : e1.clone();
            return s.a *= n, s.toString();
        }
        function Jw(e1, t1) {
            if (!bt()) {
                const r = document.createElement("canvas");
                return r.width = e1, r.height = t1, r;
            }
            return new OffscreenCanvas(e1, t1);
        }
        let Kw, Qw = null;
        function e_(e1, t1, r, n, i) {
            for (const s of n.children)t_(e1, t1, r, s, i);
        }
        function t_(e1, t1, r, n, i) {
            n.group ? (e1.save(), function(e1, t1, r, n, i) {
                const s = null != n.mask_idx ? r.masks[n.mask_idx] : null, a = null != n.clip_path_idx ? r.clip_paths[n.clip_path_idx] : null;
                if (n.transform && (t1 = c_(n.transform).preMultiplySelf(t1)), !function(e1, t1, r) {
                    return 255 !== e1.opacity || t1 || r;
                }(n, null != a, null != s)) return void e_(e1, t1, r, n, i);
                const o = Jw(e1.canvas.width, e1.canvas.height), l = o.getContext("2d");
                e_(l, t1, r, n, i), a && l_(l, t1, r, a), s && u_(l, t1, r, s, i), e1.globalAlpha = n.opacity / 255, e1.drawImage(o, 0, 0);
            }(e1, t1, r, n.group, i), e1.restore()) : n.path && (e1.save(), function(e1, t1, r, n, i) {
                e1.setTransform(t1), 1 === n.paint_order ? (r_(e1, r, n, i), i_(e1, r, n, i)) : (i_(e1, r, n, i), r_(e1, r, n, i));
            }(e1, t1, r, n.path, i), e1.restore());
        }
        function r_(e1, t1, r, n) {
            const i = r.fill;
            if (!i) return;
            const s = i.opacity / 255;
            switch(e1.save(), e1.beginPath(), h_(r, e1), i.paint){
                case "rgb_color":
                    e1.fillStyle = Yw(i.rgb_color, i.opacity, n);
                    break;
                case "linear_gradient_idx":
                    {
                        const r = t1.linear_gradients[i.linear_gradient_idx];
                        r.transform && e1.setTransform(c_(r.transform).preMultiplySelf(e1.getTransform())), e1.fillStyle = s_(e1, r, s, n);
                        break;
                    }
                case "radial_gradient_idx":
                    {
                        const r = t1.radial_gradients[i.radial_gradient_idx];
                        r.transform && e1.setTransform(c_(r.transform).preMultiplySelf(e1.getTransform())), e1.fillStyle = a_(e1, r, s, n);
                    }
            }
            e1.fill(n_(r)), e1.restore();
        }
        function n_(e1) {
            return 1 === e1.rule ? "nonzero" : 2 === e1.rule ? "evenodd" : void 0;
        }
        function i_(e1, t1, r, n) {
            const i = r.stroke;
            if (!i) return;
            const s = d_(r);
            e1.lineWidth = i.width, e1.miterLimit = i.miterlimit, e1.setLineDash(i.dasharray), e1.lineDashOffset = i.dashoffset;
            const a = i.opacity / 255;
            switch(i.paint){
                case "rgb_color":
                    e1.strokeStyle = Yw(i.rgb_color, i.opacity, n);
                    break;
                case "linear_gradient_idx":
                    e1.strokeStyle = s_(e1, t1.linear_gradients[i.linear_gradient_idx], a, n, !0);
                    break;
                case "radial_gradient_idx":
                    e1.strokeStyle = a_(e1, t1.radial_gradients[i.radial_gradient_idx], a, n, !0);
            }
            switch(i.linejoin){
                case 2:
                case 1:
                    e1.lineJoin = "miter";
                    break;
                case 3:
                    e1.lineJoin = "round";
                    break;
                case 4:
                    e1.lineJoin = "bevel";
            }
            switch(i.linecap){
                case 1:
                    e1.lineCap = "butt";
                    break;
                case 2:
                    e1.lineCap = "round";
                    break;
                case 3:
                    e1.lineCap = "square";
            }
            e1.stroke(s);
        }
        function s_(e1, t1, r, n, i = !1) {
            if (1 === t1.stops.length) {
                const e1 = t1.stops[0];
                return Yw(e1.rgb_color, e1.opacity * r, n);
            }
            const { x1: s, y1: a, x2: o, y2: l } = t1;
            let u = new DOMPoint(s, a), c = new DOMPoint(o, l);
            if (i) {
                const e1 = c_(t1.transform);
                u = e1.transformPoint(u), c = e1.transformPoint(c);
            }
            const h = e1.createLinearGradient(u.x, u.y, c.x, c.y);
            for (const e1 of t1.stops)h.addColorStop(e1.offset, Yw(e1.rgb_color, e1.opacity * r, n));
            return h;
        }
        function a_(e1, t1, r, n, i = !1) {
            if (1 === t1.stops.length) {
                const e1 = t1.stops[0];
                return Yw(e1.rgb_color, e1.opacity * r, n);
            }
            const s = c_(t1.transform), { fx: a, fy: o, fr: l, cx: u, cy: c, r: h } = t1;
            let d = new DOMPoint(a, o), p = new DOMPoint(u, c), f = l, m = h;
            if (i) {
                d = s.transformPoint(d), p = s.transformPoint(p);
                const e1 = (s.a + s.d) / 2;
                f = l * e1, m = t1.r * e1;
            }
            const y = e1.createRadialGradient(d.x, d.y, f, p.x, p.y, m);
            for (const e1 of t1.stops)y.addColorStop(e1.offset, Yw(e1.rgb_color, e1.opacity * r, n));
            return y;
        }
        function o_(e1, t1, r, n) {
            const i = n.transform ? c_(n.transform).preMultiplySelf(t1) : t1, s = Jw(e1.canvas.width, e1.canvas.height), a = s.getContext("2d");
            for (const e1 of n.children)if (e1.group) o_(a, i, r, e1.group);
            else if (e1.path) {
                const t1 = e1.path, r = new Path2D;
                r.addPath(d_(t1), i), a.fill(r, n_(t1));
            }
            const o = null != n.clip_path_idx ? r.clip_paths[n.clip_path_idx] : null;
            o && l_(a, i, r, o), e1.globalCompositeOperation = "source-over", e1.drawImage(s, 0, 0);
        }
        function l_(e1, t1, r, n) {
            const i = Jw(e1.canvas.width, e1.canvas.height);
            o_(i.getContext("2d"), t1, r, n), e1.globalCompositeOperation = "destination-in", e1.drawImage(i, 0, 0);
        }
        function u_(e1, t1, r, n, i) {
            if (0 === n.children.length) return;
            const s = null != n.mask_idx ? r.masks[n.mask_idx] : null;
            s && u_(e1, t1, r, s, i);
            const a = e1.canvas.width, o = e1.canvas.height, l = Jw(a, o), u = l.getContext("2d"), c = n.width, h = n.height, d = n.left, p = n.top, f = new Path2D, m = new Path2D;
            m.rect(d, p, c, h), f.addPath(m, t1), u.clip(f);
            for (const e1 of n.children)t_(u, t1, r, e1, i);
            const y = u.getImageData(0, 0, a, o), g = y.data;
            if (1 === n.mask_type) for(let e1 = 0; e1 < g.length; e1 += 4)g[e1 + 3] = g[e1 + 3] / 255 * (.2126 * g[e1] + .7152 * g[e1 + 1] + .0722 * g[e1 + 2]);
            u.putImageData(y, 0, 0), e1.globalCompositeOperation = "destination-in", e1.drawImage(l, 0, 0);
        }
        function c_(e1) {
            return e1 ? new DOMMatrix([
                e1.sx,
                e1.ky,
                e1.kx,
                e1.sy,
                e1.tx,
                e1.ty
            ]) : new DOMMatrix;
        }
        function h_(e1, t1) {
            const r = e1.step;
            let n = e1.diffs[0] * r, i = e1.diffs[1] * r;
            t1.moveTo(n, i);
            for(let s = 0, a = 2; s < e1.commands.length; s++)switch(e1.commands[s]){
                case 1:
                    n += e1.diffs[a++] * r, i += e1.diffs[a++] * r, t1.moveTo(n, i);
                    break;
                case 2:
                    n += e1.diffs[a++] * r, i += e1.diffs[a++] * r, t1.lineTo(n, i);
                    break;
                case 3:
                    {
                        const s = n + e1.diffs[a++] * r, o = i + e1.diffs[a++] * r;
                        n = s + e1.diffs[a++] * r, i = o + e1.diffs[a++] * r, t1.quadraticCurveTo(s, o, n, i);
                        break;
                    }
                case 4:
                    {
                        const s = n + e1.diffs[a++] * r, o = i + e1.diffs[a++] * r, l = s + e1.diffs[a++] * r, u = o + e1.diffs[a++] * r;
                        n = l + e1.diffs[a++] * r, i = u + e1.diffs[a++] * r, t1.bezierCurveTo(s, o, l, u, n, i);
                        break;
                    }
                case 5:
                    t1.closePath();
                    break;
                default:
                    p_();
            }
            return t1;
        }
        function d_(e1) {
            return h_(e1, new Path2D);
        }
        function p_(e1, t1) {}
        class f_ {
            constructor(e1){
                this.capacity = e1, this.cache = new Map;
            }
            get(e1) {
                if (!this.cache.has(e1)) return;
                const t1 = this.cache.get(e1);
                return this.cache.delete(e1), this.cache.set(e1, t1), t1;
            }
            put(e1, t1) {
                this.cache.has(e1) ? this.cache.delete(e1) : this.cache.size === this.capacity && this.cache.delete(this.cache.keys().next().value), this.cache.set(e1, t1);
            }
            delete(e1) {
                this.cache.delete(e1);
            }
        }
        ra(f_, "LRUCache");
        class m_ {
            constructor(){
                this.cacheMap = new Map, this.cacheDependenciesMap = new Map;
            }
            static _getImage(e1) {
                return new ed(e1, e1.data);
            }
            getFromCache(e1, t1, r) {
                return this.cacheMap.has(r) || this.cacheMap.set(r, new f_(150)), this.cacheMap.get(r).get(Vo(e1.toString(), t1));
            }
            setInCache(e1, t1, r, n) {
                this.cacheDependenciesMap.has(n) || this.cacheDependenciesMap.set(n, new Map), this.cacheMap.has(n) || this.cacheMap.set(n, new f_(150));
                const i = this.cacheDependenciesMap.get(n), s = Vo(e1.id.toString(), r);
                i.get(s) || i.set(s, new Set);
                const a = this.cacheMap.get(n), o = e1.toString();
                i.get(s).add(o), a.put(Vo(e1.toString(), r), t1);
            }
            removeImagesFromCacheByIds(e1, t1, r = 0) {
                if (!this.cacheMap.has(r) || !this.cacheDependenciesMap.has(r)) return;
                const n = this.cacheMap.get(r), i = this.cacheDependenciesMap.get(r);
                for (const r of e1){
                    const e1 = Vo(r.toString(), t1);
                    if (i.has(e1)) {
                        for (const t1 of i.get(e1))n.delete(t1);
                        i.delete(e1);
                    }
                }
            }
            rasterize(e1, t1, r, n) {
                const i = this.getFromCache(e1, r, n);
                if (i) return i.clone();
                const s = function(e1, t1) {
                    const r = Ww.calculate(t1.params, e1.metadata ? e1.metadata.variables : []), n = e1.usvg_tree, i = n.width, s = n.height, a = Math.max(1, Math.round(i * t1.sx)), o = Math.max(1, Math.round(s * t1.sy)), l = new DOMMatrix([
                        a / i,
                        0,
                        0,
                        o / s,
                        0,
                        0
                    ]);
                    return null === Qw && (Qw = Jw(10, 10), Kw = Qw.getContext("2d", {
                        willReadFrequently: !0
                    })), Qw.width = a, Qw.height = o, e_(Kw, l, n, n, r), Kw.getImageData(0, 0, a, o);
                }(t1.icon, e1), a = m_._getImage(s);
                return this.setInCache(e1, a, r, n), a.clone();
            }
        }
        class y_ {
            constructor(e1){
                this.size = e1, this.minimums = [], this.maximums = [], this.leaves = [];
            }
            getElevation(e1, t1) {
                const r = this.toIdx(e1, t1);
                return {
                    min: this.minimums[r],
                    max: this.maximums[r]
                };
            }
            isLeaf(e1, t1) {
                return this.leaves[this.toIdx(e1, t1)];
            }
            toIdx(e1, t1) {
                return t1 * this.size + e1;
            }
        }
        function g_(e1, t1, r, n) {
            let i = 0, s = Number.MAX_VALUE;
            for(let a = 0; a < 3; a++)if (Math.abs(n[a]) < 1e-15) {
                if (r[a] < e1[a] || r[a] > t1[a]) return null;
            } else {
                const o = 1 / n[a];
                let l = (e1[a] - r[a]) * o, u = (t1[a] - r[a]) * o;
                if (l > u) {
                    const e1 = l;
                    l = u, u = e1;
                }
                if (l > i && (i = l), u < s && (s = u), i > s) return null;
            }
            return i;
        }
        function x_(e1, t1, r, n, i, s, a, o, l, u, c) {
            const h = n - e1, d = i - t1, p = s - r, f = a - e1, m = o - t1, y = l - r, g = c[1] * y - c[2] * m, x = c[2] * f - c[0] * y, v = c[0] * m - c[1] * f, b = h * g + d * x + p * v;
            if (Math.abs(b) < 1e-15) return null;
            const w = 1 / b, _ = u[0] - e1, A = u[1] - t1, I = u[2] - r, M = (_ * g + A * x + I * v) * w;
            if (M < 0 || M > 1) return null;
            const B = A * p - I * d, S = I * h - _ * p, P = _ * d - A * h, T = (c[0] * B + c[1] * S + c[2] * P) * w;
            return T < 0 || M + T > 1 ? null : (f * B + m * S + y * P) * w;
        }
        function v_(e1, t1, r) {
            return (e1 - t1) / (r - t1);
        }
        function b_(e1, t1, r, n, i, s, a, o, l) {
            const u = 1 << r, c = s - n, h = a - i, d = (e1 + 1) / u * c + n, p = (t1 + 0) / u * h + i, f = (t1 + 1) / u * h + i;
            o[0] = (e1 + 0) / u * c + n, o[1] = p, l[0] = d, l[1] = f;
        }
        class w_ {
            constructor(e1){
                if (this.maximums = [], this.minimums = [], this.leaves = [], this.childOffsets = [], this.nodeCount = 0, this.dem = e1, this._siblingOffset = [
                    [
                        0,
                        0
                    ],
                    [
                        1,
                        0
                    ],
                    [
                        0,
                        1
                    ],
                    [
                        1,
                        1
                    ]
                ], !this.dem) return;
                const t1 = function(e1) {
                    const t1 = Math.ceil(Math.log2(e1.dim / 8)), r = [];
                    let n = Math.ceil(Math.pow(2, t1));
                    const i = 1 / n, s = (e1, t1, r, n, i)=>{
                        const s = n ? 1 : 0, a = (e1 + 1) * r - s, o = t1 * r, l = (t1 + 1) * r - s;
                        i[0] = e1 * r, i[1] = o, i[2] = a, i[3] = l;
                    };
                    let a = new y_(n);
                    const o = [];
                    for(let t1 = 0; t1 < n * n; t1++){
                        s(t1 % n, Math.floor(t1 / n), i, !1, o);
                        const r = A_(o[0], o[1], e1), l = A_(o[2], o[1], e1), u = A_(o[2], o[3], e1), c = A_(o[0], o[3], e1);
                        a.minimums.push(Math.min(r, l, u, c)), a.maximums.push(Math.max(r, l, u, c)), a.leaves.push(1);
                    }
                    for(r.push(a), n /= 2; n >= 1; n /= 2){
                        const e1 = r[r.length - 1];
                        a = new y_(n);
                        for(let t1 = 0; t1 < n * n; t1++){
                            s(t1 % n, Math.floor(t1 / n), 2, !0, o);
                            const r = e1.getElevation(o[0], o[1]), i = e1.getElevation(o[2], o[1]), l = e1.getElevation(o[2], o[3]), u = e1.getElevation(o[0], o[3]), c = e1.isLeaf(o[0], o[1]), h = e1.isLeaf(o[2], o[1]), d = e1.isLeaf(o[2], o[3]), p = e1.isLeaf(o[0], o[3]), f = Math.min(r.min, i.min, l.min, u.min), m = Math.max(r.max, i.max, l.max, u.max), y = c && h && d && p;
                            a.maximums.push(m), a.minimums.push(f), a.leaves.push(m - f <= 5 && y ? 1 : 0);
                        }
                        r.push(a);
                    }
                    return r;
                }(this.dem), r = t1.length - 1, n = t1[r];
                this._addNode(n.minimums[0], n.maximums[0], n.leaves[0]), this._construct(t1, 0, 0, r, 0);
            }
            raycastRoot(e1, t1, r, n, i, s, a = 1) {
                return g_([
                    e1,
                    t1,
                    -100
                ], [
                    r,
                    n,
                    this.maximums[0] * a
                ], i, s);
            }
            raycast(e1, t1, r, n, i, s, a = 1) {
                if (!this.nodeCount) return null;
                const o = this.raycastRoot(e1, t1, r, n, i, s, a);
                if (null == o) return null;
                const l = [], u = [], c = [], h = [], d = [
                    {
                        idx: 0,
                        t: o,
                        nodex: 0,
                        nodey: 0,
                        depth: 0
                    }
                ];
                for(; d.length > 0;){
                    const { idx: o, t: p, nodex: f, nodey: m, depth: y } = d.pop();
                    if (this.leaves[o]) {
                        b_(f, m, y, e1, t1, r, n, c, h);
                        const o = 1 << y, l = (f + 0) / o, u = (f + 1) / o, d = (m + 0) / o, g = (m + 1) / o, x = A_(l, d, this.dem) * a, v = A_(u, d, this.dem) * a, b = A_(u, g, this.dem) * a, w = A_(l, g, this.dem) * a, _ = x_(c[0], c[1], x, h[0], c[1], v, h[0], h[1], b, i, s), A = x_(h[0], h[1], b, c[0], h[1], w, c[0], c[1], x, i, s), I = Math.min(null !== _ ? _ : Number.MAX_VALUE, null !== A ? A : Number.MAX_VALUE);
                        if (I !== Number.MAX_VALUE) return I;
                        {
                            const e1 = F([], i, s, p);
                            if (__(x, v, w, b, v_(e1[0], c[0], h[0]), v_(e1[1], c[1], h[1])) >= e1[2]) return p;
                        }
                        continue;
                    }
                    let g = 0;
                    for(let d = 0; d < this._siblingOffset.length; d++){
                        b_((f << 1) + this._siblingOffset[d][0], (m << 1) + this._siblingOffset[d][1], y + 1, e1, t1, r, n, c, h), c[2] = -100, h[2] = this.maximums[this.childOffsets[o] + d] * a;
                        const p = g_(c, h, i, s);
                        if (null != p) {
                            const e1 = p;
                            l[d] = e1;
                            let t1 = !1;
                            for(let r = 0; r < g && !t1; r++)e1 >= l[u[r]] && (u.splice(r, 0, d), t1 = !0);
                            t1 || (u[g] = d), g++;
                        }
                    }
                    for(let e1 = 0; e1 < g; e1++){
                        const t1 = u[e1];
                        d.push({
                            idx: this.childOffsets[o] + t1,
                            t: l[t1],
                            nodex: (f << 1) + this._siblingOffset[t1][0],
                            nodey: (m << 1) + this._siblingOffset[t1][1],
                            depth: y + 1
                        });
                    }
                }
                return null;
            }
            _addNode(e1, t1, r) {
                return this.minimums.push(e1), this.maximums.push(t1), this.leaves.push(r), this.childOffsets.push(0), this.nodeCount++;
            }
            _construct(e1, t1, r, n, i) {
                if (1 === e1[n].isLeaf(t1, r)) return;
                this.childOffsets[i] || (this.childOffsets[i] = this.nodeCount);
                const s = n - 1, a = e1[s];
                let o = 0, l = 0;
                for(let e1 = 0; e1 < this._siblingOffset.length; e1++){
                    const n = 2 * t1 + this._siblingOffset[e1][0], i = 2 * r + this._siblingOffset[e1][1], s = a.getElevation(n, i), u = a.isLeaf(n, i), c = this._addNode(s.min, s.max, u);
                    u && (o |= 1 << e1), l || (l = c);
                }
                for(let n = 0; n < this._siblingOffset.length; n++)o & 1 << n || this._construct(e1, 2 * t1 + this._siblingOffset[n][0], 2 * r + this._siblingOffset[n][1], s, l + n);
            }
        }
        function __(e1, t1, r, n, i, s) {
            return yr(yr(e1, r, s), yr(t1, n, s), i);
        }
        function A_(e1, t1, r) {
            const n = r.dim, i = Ee(e1 * n - .5, 0, n - 1), s = Ee(t1 * n - .5, 0, n - 1), a = Math.floor(i), o = Math.floor(s), l = Math.min(a + 1, n - 1), u = Math.min(o + 1, n - 1);
            return __(r.get(a, o), r.get(l, o), r.get(a, u), r.get(l, u), i - a, s - o);
        }
        const I_ = {
            mapbox: [
                6553.6,
                25.6,
                .1,
                1e4
            ],
            terrarium: [
                256,
                1,
                1 / 256,
                32768
            ]
        };
        function M_(e1, t1, r) {
            return (256 * e1 * 256 + 256 * t1 + r) / 10 - 1e4;
        }
        function B_(e1, t1, r) {
            return 256 * e1 + t1 + r / 256 - 32768;
        }
        class S_ {
            get tree() {
                return this._tree || this._buildQuadTree(), this._tree;
            }
            constructor(e1, t1, r, n = !1){
                if (this.uid = e1, t1.height !== t1.width) throw new RangeError("DEM tiles must be square");
                if (r && "mapbox" !== r && "terrarium" !== r) return void Ze(`"${r}" is not a valid encoding type. Valid types include "mapbox" and "terrarium".`);
                this.stride = t1.height;
                const i = this.dim = t1.height - 2, s = new Uint32Array(t1.data.buffer);
                if (this.pixels = new Uint8Array(t1.data.buffer), this.floatView = new Float32Array(t1.data.buffer), this.borderReady = n, this._modifiedForSources = {}, !n) {
                    for(let e1 = 0; e1 < i; e1++)s[this._idx(-1, e1)] = s[this._idx(0, e1)], s[this._idx(i, e1)] = s[this._idx(i - 1, e1)], s[this._idx(e1, -1)] = s[this._idx(e1, 0)], s[this._idx(e1, i)] = s[this._idx(e1, i - 1)];
                    s[this._idx(-1, -1)] = s[this._idx(0, 0)], s[this._idx(i, -1)] = s[this._idx(i - 1, 0)], s[this._idx(-1, i)] = s[this._idx(0, i - 1)], s[this._idx(i, i)] = s[this._idx(i - 1, i - 1)];
                }
                const a = "terrarium" === r ? B_ : M_;
                for(let e1 = 0; e1 < s.length; ++e1){
                    const t1 = 4 * e1;
                    this.floatView[e1] = a(this.pixels[t1], this.pixels[t1 + 1], this.pixels[t1 + 2]);
                }
                this._timestamp = wt.now();
            }
            _buildQuadTree() {
                this._tree = new w_(this);
            }
            get(e1, t1, r = !1) {
                r && (e1 = Ee(e1, -1, this.dim), t1 = Ee(t1, -1, this.dim));
                const n = this._idx(e1, t1);
                return this.floatView[n];
            }
            set(e1, t1, r) {
                const n = this._idx(e1, t1), i = this.floatView[n];
                return this.floatView[n] = r, r - i;
            }
            static getUnpackVector(e1) {
                return I_[e1];
            }
            _idx(e1, t1) {
                if (e1 < -1 || e1 >= this.dim + 1 || t1 < -1 || t1 >= this.dim + 1) throw new RangeError("out of range source coordinates for DEM data");
                return (t1 + 1) * this.stride + (e1 + 1);
            }
            static pack(e1, t1) {
                const r = [
                    0,
                    0,
                    0,
                    0
                ], n = S_.getUnpackVector(t1);
                let i = Math.floor((e1 + n[3]) / n[2]);
                return r[2] = i % 256, i = Math.floor(i / 256), r[1] = i % 256, i = Math.floor(i / 256), r[0] = i, r;
            }
            getPixels() {
                return new td({
                    width: this.stride,
                    height: this.stride
                }, this.pixels);
            }
            backfillBorder(e1, t1, r) {
                if (this.dim !== e1.dim) throw new Error("dem dimension mismatch");
                let n = t1 * this.dim, i = t1 * this.dim + this.dim, s = r * this.dim, a = r * this.dim + this.dim;
                switch(t1){
                    case -1:
                        n = i - 1;
                        break;
                    case 1:
                        i = n + 1;
                }
                switch(r){
                    case -1:
                        s = a - 1;
                        break;
                    case 1:
                        a = s + 1;
                }
                const o = -t1 * this.dim, l = -r * this.dim;
                for(let t1 = s; t1 < a; t1++)for(let r = n; r < i; r++){
                    const n = 4 * this._idx(r, t1), i = 4 * this._idx(r + o, t1 + l);
                    this.pixels[n + 0] = e1.pixels[i + 0], this.pixels[n + 1] = e1.pixels[i + 1], this.pixels[n + 2] = e1.pixels[i + 2], this.pixels[n + 3] = e1.pixels[i + 3];
                }
            }
            onDeserialize() {
                this._tree && (this._tree.dem = this);
            }
        }
        function P_(e1, t1, r) {
            1 === e1 ? t1.headerLength = r.readFixed32() : 2 === e1 ? t1.x = r.readVarint() : 3 === e1 ? t1.y = r.readVarint() : 4 === e1 ? t1.z = r.readVarint() : 5 === e1 && t1.layers.push(function(e1, t1) {
                return e1.readFields(F_, {
                    version: 0,
                    name: "",
                    units: "",
                    tileSize: 0,
                    buffer: 0,
                    pixelFormat: 0,
                    dataIndex: []
                }, t1);
            }(r, r.readVarint() + r.pos));
        }
        function T_(e1, t1, r) {
            1 === e1 ? (t1.delta_filter = function(e1, t1) {
                return e1.readFields(z_, {
                    blockSize: 0
                }, t1);
            }(r, r.readVarint() + r.pos), t1.filter = "delta_filter") : 2 === e1 ? (r.readVarint(), t1.filter = "zigzag_filter") : 3 === e1 ? (r.readVarint(), t1.filter = "bitshuffle_filter") : 4 === e1 && (r.readVarint(), t1.filter = "byteshuffle_filter");
        }
        function z_(e1, t1, r) {
            1 === e1 && (t1.blockSize = r.readVarint());
        }
        function k_(e1, t1, r) {
            1 === e1 ? (r.readVarint(), t1.codec = "gzip_data") : 2 === e1 ? (r.readVarint(), t1.codec = "jpeg_image") : 3 === e1 ? (r.readVarint(), t1.codec = "webp_image") : 4 === e1 && (r.readVarint(), t1.codec = "png_image");
        }
        function V_(e1, t1, r) {
            let n = 0, i = 0;
            1 === e1 ? t1.firstByte = r.readFixed64() : 2 === e1 ? t1.lastByte = r.readFixed64() : 3 === e1 ? t1.filters.push(function(e1, t1) {
                return e1.readFields(T_, {}, t1);
            }(r, r.readVarint() + r.pos)) : 4 === e1 ? t1.codec = function(e1, t1) {
                return e1.readFields(k_, {}, t1);
            }(r, r.readVarint() + r.pos) : 5 === e1 ? i = r.readFloat() : 6 === e1 ? n = r.readFloat() : 7 === e1 ? t1.bands.push(r.readString()) : 8 === e1 ? t1.offset = r.readDouble() : 9 === e1 && (t1.scale = r.readDouble()), 0 === t1.offset && (t1.offset = i), 0 === t1.scale && (t1.scale = n);
        }
        function F_(e1, t1, r) {
            1 === e1 ? t1.version = r.readVarint() : 2 === e1 ? t1.name = r.readString() : 3 === e1 ? t1.units = r.readString() : 4 === e1 ? t1.tileSize = r.readVarint() : 5 === e1 ? t1.buffer = r.readVarint() : 6 === e1 ? t1.pixelFormat = r.readVarint() : 7 === e1 && t1.dataIndex.push(function(e1, t1) {
                return e1.readFields(V_, {
                    firstByte: 0,
                    lastByte: 0,
                    filters: [],
                    codec: null,
                    offset: 0,
                    scale: 0,
                    bands: []
                }, t1);
            }(r, r.readVarint() + r.pos));
        }
        function D_(e1, t1, r) {
            if (2 === e1) !function(e1, t1, r) {
                e1.readFields(E_, r, t1);
            }(r, r.readVarint() + r.pos, t1);
            else if (3 === e1) throw new Error("Not implemented");
        }
        function E_(e1, t1, r) {
            if (1 === e1) {
                let e1 = 0;
                const n = r.readVarint() + r.pos;
                for(; r.pos < n;)t1[e1++] = r.readVarint();
            }
        }
        function C_(e1, t1) {
            if (4 !== t1.length) throw new Error(`Expected data of dimension 4 but got ${t1.length}.`);
            let r = t1[3];
            for(let n = 2; n >= 1; n--){
                const i = 1 === n ? 1 : 0, s = 2 === n ? 1 : 0;
                for(let n = 0; n < t1[0]; n++){
                    const a = t1[1] * n;
                    for(let n = i; n < t1[1]; n++){
                        const i = t1[2] * (n + a);
                        for(let n = s; n < t1[2]; n++){
                            const s = t1[3] * (n + i);
                            for(let n = 0; n < t1[3]; n++){
                                const t1 = s + n;
                                e1[t1] += e1[t1 - r];
                            }
                        }
                    }
                }
                r *= t1[n];
            }
            return e1;
        }
        function R_(e1) {
            for(let t1 = 0, r = e1.length; t1 < r; t1++)e1[t1] = e1[t1] >>> 1 ^ -(1 & e1[t1]);
            return e1;
        }
        function L_(e1, t1) {
            switch(t1){
                case "uint32":
                    return e1;
                case "uint16":
                    for(let t1 = 0; t1 < e1.length; t1 += 2){
                        const r = e1[t1], n = e1[t1 + 1];
                        e1[t1] = (240 & r) >> 4 | (61440 & r) >> 8 | (240 & n) << 4 | 61440 & n, e1[t1 + 1] = 15 & r | (3840 & r) >> 4 | (15 & n) << 8 | (3840 & n) << 4;
                    }
                    return e1;
                case "uint8":
                    for(let t1 = 0; t1 < e1.length; t1 += 4){
                        const r = e1[t1], n = e1[t1 + 1], i = e1[t1 + 2], s = e1[t1 + 3];
                        e1[t1 + 0] = (192 & r) >> 6 | (192 & n) >> 4 | (192 & i) >> 2 | 192 & s, e1[t1 + 1] = (48 & r) >> 4 | (48 & n) >> 2 | 48 & i | (48 & s) << 2, e1[t1 + 2] = (12 & r) >> 2 | 12 & n | (12 & i) << 2 | (12 & s) << 4, e1[t1 + 3] = 3 & r | (3 & n) << 2 | (3 & i) << 4 | (3 & s) << 6;
                    }
                    return e1;
                default:
                    throw new Error(`Invalid pixel format, "${t1}"`);
            }
        }
        ra(S_, "DEMData"), ra(w_, "DemMinMaxQuadTree", {
            omit: [
                "dem"
            ]
        });
        var O_ = Uint8Array, U_ = Uint16Array, N_ = Int32Array, j_ = new O_([
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            1,
            1,
            1,
            1,
            2,
            2,
            2,
            2,
            3,
            3,
            3,
            3,
            4,
            4,
            4,
            4,
            5,
            5,
            5,
            5,
            0,
            0,
            0,
            0
        ]), G_ = new O_([
            0,
            0,
            0,
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            4,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            8,
            8,
            9,
            9,
            10,
            10,
            11,
            11,
            12,
            12,
            13,
            13,
            0,
            0
        ]), $_ = new O_([
            16,
            17,
            18,
            0,
            8,
            7,
            9,
            6,
            10,
            5,
            11,
            4,
            12,
            3,
            13,
            2,
            14,
            1,
            15
        ]), q_ = function(e1, t1) {
            for(var r = new U_(31), n = 0; n < 31; ++n)r[n] = t1 += 1 << e1[n - 1];
            var i = new N_(r[30]);
            for(n = 1; n < 30; ++n)for(var s = r[n]; s < r[n + 1]; ++s)i[s] = s - r[n] << 5 | n;
            return {
                b: r,
                r: i
            };
        }, H_ = q_(j_, 2), X_ = H_.b, Z_ = H_.r;
        X_[28] = 258, Z_[258] = 28;
        for(var W_ = q_(G_, 0).b, Y_ = new U_(32768), J_ = 0; J_ < 32768; ++J_){
            var K_ = (43690 & J_) >> 1 | (21845 & J_) << 1;
            Y_[J_] = ((65280 & (K_ = (61680 & (K_ = (52428 & K_) >> 2 | (13107 & K_) << 2)) >> 4 | (3855 & K_) << 4)) >> 8 | (255 & K_) << 8) >> 1;
        }
        var Q_ = function(e1, t1, r) {
            for(var n = e1.length, i = 0, s = new U_(t1); i < n; ++i)e1[i] && ++s[e1[i] - 1];
            var a, o = new U_(t1);
            for(i = 1; i < t1; ++i)o[i] = o[i - 1] + s[i - 1] << 1;
            a = new U_(1 << t1);
            var l = 15 - t1;
            for(i = 0; i < n; ++i)if (e1[i]) for(var u = i << 4 | e1[i], c = t1 - e1[i], h = o[e1[i] - 1]++ << c, d = h | (1 << c) - 1; h <= d; ++h)a[Y_[h] >> l] = u;
            return a;
        }, eA = new O_(288);
        for(J_ = 0; J_ < 144; ++J_)eA[J_] = 8;
        for(J_ = 144; J_ < 256; ++J_)eA[J_] = 9;
        for(J_ = 256; J_ < 280; ++J_)eA[J_] = 7;
        for(J_ = 280; J_ < 288; ++J_)eA[J_] = 8;
        var tA = new O_(32);
        for(J_ = 0; J_ < 32; ++J_)tA[J_] = 5;
        var rA = Q_(eA, 9), nA = Q_(tA, 5), iA = function(e1) {
            for(var t1 = e1[0], r = 1; r < e1.length; ++r)e1[r] > t1 && (t1 = e1[r]);
            return t1;
        }, sA = function(e1, t1, r) {
            var n = t1 / 8 | 0;
            return (e1[n] | e1[n + 1] << 8) >> (7 & t1) & r;
        }, aA = function(e1, t1) {
            var r = t1 / 8 | 0;
            return (e1[r] | e1[r + 1] << 8 | e1[r + 2] << 16) >> (7 & t1);
        }, oA = function(e1) {
            return (e1 + 7) / 8 | 0;
        }, lA = [
            "unexpected EOF",
            "invalid block type",
            "invalid length/literal",
            "invalid distance",
            "stream finished",
            "no stream handler",
            ,
            "no callback",
            "invalid UTF-8 data",
            "extra field too long",
            "date not in range 1980-2099",
            "filename too long",
            "stream finishing",
            "invalid zip data"
        ], uA = function(e1, t1, r) {
            var n = new Error(t1 || lA[e1]);
            if (n.code = e1, Error.captureStackTrace && Error.captureStackTrace(n, uA), !r) throw n;
            return n;
        }, cA = new O_(0);
        var hA = "undefined" != typeof TextDecoder && new TextDecoder;
        try {
            hA.decode(cA, {
                stream: !0
            });
        } catch (e1) {}
        const dA = {
            gzip_data: "gzip"
        };
        class pA extends Error {
            constructor(e1){
                super(e1), this.name = "MRTError";
            }
        }
        const fA = {
            0: "uint32",
            1: "uint32",
            2: "uint16",
            3: "uint8"
        }, mA = {
            uint32: 1,
            uint16: 2,
            uint8: 4
        }, yA = {
            uint32: Uint32Array,
            uint16: Uint16Array,
            uint8: Uint8Array
        };
        let gA;
        class xA {
            constructor(e1 = 5){
                this.x = NaN, this.y = NaN, this.z = NaN, this.layers = {}, this._cacheSize = e1;
            }
            getLayer(e1) {
                const t1 = this.layers[e1];
                if (!t1) throw new pA(`Layer '${e1}' not found`);
                return t1;
            }
            getHeaderLength(e1) {
                const t1 = new Uint8Array(e1), r = new DataView(e1);
                if (13 !== t1[0]) throw new pA("File is not a valid MRT.");
                return r.getUint32(1, !0);
            }
            parseHeader(e1) {
                const t1 = new Uint8Array(e1), r = this.getHeaderLength(e1);
                if (t1.length < r) throw new pA(`Expected header with length >= ${r} but got buffer of length ${t1.length}`);
                const n = new gA(t1.subarray(0, r)).readFields(P_, {
                    headerLength: 0,
                    x: 0,
                    y: 0,
                    z: 0,
                    layers: []
                }, void 0);
                if (!isNaN(this.x) && (this.x !== n.x || this.y !== n.y || this.z !== n.z)) throw new pA(`Invalid attempt to parse header ${n.z}/${n.x}/${n.y} for tile ${this.z}/${this.x}/${this.y}`);
                this.x = n.x, this.y = n.y, this.z = n.z;
                for (const e1 of n.layers)this.layers[e1.name] = new vA(e1, {
                    cacheSize: this._cacheSize
                });
                return this;
            }
            createDecodingTask(e1) {
                const t1 = [], r = this.getLayer(e1.layerName);
                for (let n of e1.blockIndices){
                    const i = r.dataIndex[n], s = i.firstByte - e1.firstByte, a = i.lastByte - e1.firstByte;
                    if (r._blocksInProgress.has(n)) continue;
                    const o = {
                        layerName: r.name,
                        firstByte: s,
                        lastByte: a,
                        pixelFormat: r.pixelFormat,
                        blockIndex: n,
                        blockShape: [
                            i.bands.length
                        ].concat(r.bandShape),
                        buffer: r.buffer,
                        codec: i.codec.codec,
                        filters: i.filters.map((e1)=>e1.filter)
                    };
                    r._blocksInProgress.add(n), t1.push(o);
                }
                return new bA(t1, ()=>{
                    t1.forEach((e1)=>r._blocksInProgress.delete(e1.blockIndex));
                }, (e1, n)=>{
                    if (t1.forEach((e1)=>r._blocksInProgress.delete(e1.blockIndex)), e1) throw e1;
                    n.forEach((e1)=>{
                        this.getLayer(e1.layerName).processDecodedData(e1);
                    });
                });
            }
        }
        class vA {
            constructor({ version: e1, name: t1, units: r, tileSize: n, pixelFormat: i, buffer: s, dataIndex: a }, o){
                if (this.version = e1, 1 !== this.version) throw new pA(`Cannot parse raster layer encoded with MRT version ${e1}`);
                this.name = t1, this.units = r, this.tileSize = n, this.buffer = s, this.pixelFormat = fA[i], this.dataIndex = a, this.bandShape = [
                    n + 2 * s,
                    n + 2 * s,
                    mA[this.pixelFormat]
                ], this._decodedBlocks = new f_(o ? o.cacheSize : 5), this._blocksInProgress = new Set;
            }
            get dimension() {
                return mA[this.pixelFormat];
            }
            get cacheSize() {
                return this._decodedBlocks.capacity;
            }
            getBandList() {
                return this.dataIndex.map(({ bands: e1 })=>e1).flat();
            }
            processDecodedData(e1) {
                const t1 = e1.blockIndex.toString();
                this._decodedBlocks.get(t1) || this._decodedBlocks.put(t1, e1.data);
            }
            getBlockForBand(e1) {
                let t1 = 0;
                switch(typeof e1){
                    case "string":
                        for (const [r, n] of this.dataIndex.entries()){
                            for (const [i, s] of n.bands.entries())if (s === e1) return {
                                bandIndex: t1 + i,
                                blockIndex: r,
                                blockBandIndex: i
                            };
                            t1 += n.bands.length;
                        }
                        break;
                    case "number":
                        for (const [r, n] of this.dataIndex.entries()){
                            if (e1 >= t1 && e1 < t1 + n.bands.length) return {
                                bandIndex: e1,
                                blockIndex: r,
                                blockBandIndex: e1 - t1
                            };
                            t1 += n.bands.length;
                        }
                        break;
                    default:
                        throw new pA(`Invalid band \`${JSON.stringify(e1)}\`. Expected string or integer.`);
                }
                return {
                    blockIndex: -1,
                    blockBandIndex: -1
                };
            }
            getDataRange(e1) {
                let t1 = 1 / 0, r = -1 / 0;
                const n = [], i = new Set;
                for (const s of e1){
                    const { blockIndex: e1 } = this.getBlockForBand(s);
                    if (e1 < 0) throw new pA(`Invalid band: ${JSON.stringify(s)}`);
                    const a = this.dataIndex[e1];
                    n.includes(e1) || n.push(e1), i.add(e1), t1 = Math.min(t1, a.firstByte), r = Math.max(r, a.lastByte);
                }
                if (i.size > this.cacheSize) throw new pA(`Number of blocks to decode (${i.size}) exceeds cache size (${this.cacheSize}).`);
                return {
                    layerName: this.name,
                    firstByte: t1,
                    lastByte: r,
                    blockIndices: n
                };
            }
            hasBand(e1) {
                const { blockIndex: t1 } = this.getBlockForBand(e1);
                return t1 >= 0;
            }
            hasDataForBand(e1) {
                const { blockIndex: t1 } = this.getBlockForBand(e1);
                return t1 >= 0 && !!this._decodedBlocks.get(t1.toString());
            }
            getBandView(e1) {
                const { blockIndex: t1, blockBandIndex: r } = this.getBlockForBand(e1);
                if (t1 < 0) throw new pA(`Band not found: ${JSON.stringify(e1)}`);
                const n = this._decodedBlocks.get(t1.toString());
                if (!n) throw new pA(`Data for band ${JSON.stringify(e1)} of layer "${this.name}" not decoded.`);
                const i = this.dataIndex[t1], s = this.bandShape.reduce((e1, t1)=>e1 * t1, 1), a = r * s, o = n.subarray(a, a + s);
                return {
                    data: o,
                    bytes: new Uint8Array(o.buffer).subarray(o.byteOffset, o.byteOffset + o.byteLength),
                    tileSize: this.tileSize,
                    buffer: this.buffer,
                    pixelFormat: this.pixelFormat,
                    dimension: this.dimension,
                    offset: i.offset,
                    scale: i.scale
                };
            }
        }
        xA.setPbf = function(e1) {
            gA = e1;
        };
        class bA {
            constructor(e1, t1, r){
                this.tasks = e1, this._onCancel = t1, this._onComplete = r, this._finalized = !1;
            }
            cancel() {
                this._finalized || (this._onCancel(), this._finalized = !0);
            }
            complete(e1, t1) {
                this._finalized || (this._onComplete(e1, t1), this._finalized = !0);
            }
        }
        xA.performDecoding = function(e1, t1) {
            const r = new Uint8Array(e1);
            return Promise.all(t1.tasks.map((e1)=>{
                const { layerName: t1, firstByte: n, lastByte: i, pixelFormat: s, blockShape: a, blockIndex: o, filters: l, codec: u } = e1, c = r.subarray(n, i + 1), h = new Uint32Array(a[0] * a[1] * a[2]);
                let d;
                if ("gzip_data" !== u) throw new pA(`Unhandled codec: ${u}`);
                return d = (function(e1, t1) {
                    if (!globalThis.DecompressionStream && "gzip_data" === t1) return Promise.resolve((a = function(e1) {
                        31 == e1[0] && 139 == e1[1] && 8 == e1[2] || uA(6, "invalid gzip data");
                        var t1 = e1[3], r = 10;
                        4 & t1 && (r += 2 + (e1[10] | e1[11] << 8));
                        for(var n = (t1 >> 3 & 1) + (t1 >> 4 & 1); n > 0; n -= !e1[r++]);
                        return r + (2 & t1);
                    }(r = e1), a + 8 > r.length && uA(6, "invalid gzip data"), function(e1, t1, r, n) {
                        var i = e1.length;
                        if (!i || t1.f && !t1.l) return r || new O_(0);
                        var s = !r, a = s || 2 != t1.i, o = t1.i;
                        s && (r = new O_(3 * i));
                        var l = function(e1) {
                            var t1 = r.length;
                            if (e1 > t1) {
                                var n = new O_(Math.max(2 * t1, e1));
                                n.set(r), r = n;
                            }
                        }, u = t1.f || 0, c = t1.p || 0, h = t1.b || 0, d = t1.l, p = t1.d, f = t1.m, m = t1.n, y = 8 * i;
                        do {
                            if (!d) {
                                u = sA(e1, c, 1);
                                var g = sA(e1, c + 1, 3);
                                if (c += 3, !g) {
                                    var x = e1[(T = oA(c) + 4) - 4] | e1[T - 3] << 8, v = T + x;
                                    if (v > i) {
                                        o && uA(0);
                                        break;
                                    }
                                    a && l(h + x), r.set(e1.subarray(T, v), h), t1.b = h += x, t1.p = c = 8 * v, t1.f = u;
                                    continue;
                                }
                                if (1 == g) d = rA, p = nA, f = 9, m = 5;
                                else if (2 == g) {
                                    var b = sA(e1, c, 31) + 257, w = sA(e1, c + 10, 15) + 4, _ = b + sA(e1, c + 5, 31) + 1;
                                    c += 14;
                                    for(var A = new O_(_), I = new O_(19), M = 0; M < w; ++M)I[$_[M]] = sA(e1, c + 3 * M, 7);
                                    c += 3 * w;
                                    var B = iA(I), S = (1 << B) - 1, P = Q_(I, B);
                                    for(M = 0; M < _;){
                                        var T, z = P[sA(e1, c, S)];
                                        if (c += 15 & z, (T = z >> 4) < 16) A[M++] = T;
                                        else {
                                            var k = 0, V = 0;
                                            for(16 == T ? (V = 3 + sA(e1, c, 3), c += 2, k = A[M - 1]) : 17 == T ? (V = 3 + sA(e1, c, 7), c += 3) : 18 == T && (V = 11 + sA(e1, c, 127), c += 7); V--;)A[M++] = k;
                                        }
                                    }
                                    var F = A.subarray(0, b), D = A.subarray(b);
                                    f = iA(F), m = iA(D), d = Q_(F, f), p = Q_(D, m);
                                } else uA(1);
                                if (c > y) {
                                    o && uA(0);
                                    break;
                                }
                            }
                            a && l(h + 131072);
                            for(var E = (1 << f) - 1, C = (1 << m) - 1, R = c;; R = c){
                                var L = (k = d[aA(e1, c) & E]) >> 4;
                                if ((c += 15 & k) > y) {
                                    o && uA(0);
                                    break;
                                }
                                if (k || uA(2), L < 256) r[h++] = L;
                                else {
                                    if (256 == L) {
                                        R = c, d = null;
                                        break;
                                    }
                                    var O = L - 254;
                                    L > 264 && (O = sA(e1, c, (1 << (j = j_[M = L - 257])) - 1) + X_[M], c += j);
                                    var U = p[aA(e1, c) & C], N = U >> 4;
                                    if (U || uA(3), c += 15 & U, D = W_[N], N > 3) {
                                        var j = G_[N];
                                        D += aA(e1, c) & (1 << j) - 1, c += j;
                                    }
                                    if (c > y) {
                                        o && uA(0);
                                        break;
                                    }
                                    a && l(h + 131072);
                                    var G = h + O;
                                    if (h < D) {
                                        var $ = 0 - D, q = Math.min(D, G);
                                        for($ + h < 0 && uA(3); h < q; ++h)r[h] = n[$ + h];
                                    }
                                    for(; h < G; ++h)r[h] = r[h - D];
                                }
                            }
                            t1.l = d, t1.p = R, t1.b = h, t1.f = u, d && (u = 1, t1.m = f, t1.d = p, t1.n = m);
                        }while (!u);
                        return h != r.length && s ? function(e1, t1, r) {
                            return (null == r || r > e1.length) && (r = e1.length), new O_(e1.subarray(0, r));
                        }(r, 0, h) : r.subarray(0, h);
                    }(r.subarray(a, -8), {
                        i: 2
                    }, new O_(((i = r)[(s = i.length) - 4] | i[s - 3] << 8 | i[s - 2] << 16 | i[s - 1] << 24) >>> 0), n)));
                    var r, n, i, s, a;
                    const o = dA[t1];
                    if (!o) throw new Error(`Unhandled codec: ${t1}`);
                    const l = new globalThis.DecompressionStream(o);
                    return new Response(new Blob([
                        e1
                    ]).stream().pipeThrough(l)).arrayBuffer().then((e1)=>new Uint8Array(e1));
                })(c, u).then((e1)=>((function(e1, t1) {
                        e1.readFields(D_, t1);
                    })(new gA(e1), h), new yA[s](h.buffer))), d.then((e1)=>{
                    for(let t1 = l.length - 1; t1 >= 0; t1--)switch(l[t1]){
                        case "delta_filter":
                            C_(e1, a);
                            break;
                        case "zigzag_filter":
                            R_(e1);
                            break;
                        case "bitshuffle_filter":
                            L_(e1, s);
                            break;
                        default:
                            throw new pA(`Unhandled filter "${l[t1]}"`);
                    }
                    return {
                        layerName: t1,
                        blockIndex: o,
                        data: e1
                    };
                }).catch((e1)=>{
                    throw e1;
                });
            }));
        }, ra(bA, "MRTDecodingBatch", {
            omit: [
                "_onCancel",
                "_onComplete"
            ]
        }), ra(xA, "MapboxRasterTile"), ra(vA, "MapboxRasterLayer", {
            omit: [
                "_blocksInProgress"
            ]
        });
        const wA = [
            Int8Array,
            Uint8Array,
            Uint8ClampedArray,
            Int16Array,
            Uint16Array,
            Int32Array,
            Uint32Array,
            Float32Array,
            Float64Array
        ];
        class _A {
            static from(e1) {
                if (!(e1 instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
                const [t1, r] = new Uint8Array(e1, 0, 2);
                if (219 !== t1) throw new Error("Data does not appear to be in a KDBush format.");
                const n = r >> 4;
                if (1 !== n) throw new Error(`Got v${n} data when expected v1.`);
                const i = wA[15 & r];
                if (!i) throw new Error("Unrecognized array type.");
                const [s] = new Uint16Array(e1, 2, 1), [a] = new Uint32Array(e1, 4, 1);
                return new _A(a, s, i, e1);
            }
            constructor(e1, t1 = 64, r = Float64Array, n){
                if (isNaN(e1) || e1 < 0) throw new Error(`Unpexpected numItems value: ${e1}.`);
                this.numItems = +e1, this.nodeSize = Math.min(Math.max(+t1, 2), 65535), this.ArrayType = r, this.IndexArrayType = e1 < 65536 ? Uint16Array : Uint32Array;
                const i = wA.indexOf(this.ArrayType), s = 2 * e1 * this.ArrayType.BYTES_PER_ELEMENT, a = e1 * this.IndexArrayType.BYTES_PER_ELEMENT, o = (8 - a % 8) % 8;
                if (i < 0) throw new Error(`Unexpected typed array class: ${r}.`);
                n && n instanceof ArrayBuffer ? (this.data = n, this.ids = new this.IndexArrayType(this.data, 8, e1), this.coords = new this.ArrayType(this.data, 8 + a + o, 2 * e1), this._pos = 2 * e1, this._finished = !0) : (this.data = new ArrayBuffer(8 + s + a + o), this.ids = new this.IndexArrayType(this.data, 8, e1), this.coords = new this.ArrayType(this.data, 8 + a + o, 2 * e1), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([
                    219,
                    16 + i
                ]), new Uint16Array(this.data, 2, 1)[0] = t1, new Uint32Array(this.data, 4, 1)[0] = e1);
            }
            add(e1, t1) {
                const r = this._pos >> 1;
                return this.ids[r] = r, this.coords[this._pos++] = e1, this.coords[this._pos++] = t1, r;
            }
            finish() {
                const e1 = this._pos >> 1;
                if (e1 !== this.numItems) throw new Error(`Added ${e1} items when expected ${this.numItems}.`);
                return AA(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
            }
            range(e1, t1, r, n) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: i, coords: s, nodeSize: a } = this, o = [
                    0,
                    i.length - 1,
                    0
                ], l = [];
                for(; o.length;){
                    const u = o.pop() || 0, c = o.pop() || 0, h = o.pop() || 0;
                    if (c - h <= a) {
                        for(let a = h; a <= c; a++){
                            const o = s[2 * a], u = s[2 * a + 1];
                            o >= e1 && o <= r && u >= t1 && u <= n && l.push(i[a]);
                        }
                        continue;
                    }
                    const d = h + c >> 1, p = s[2 * d], f = s[2 * d + 1];
                    p >= e1 && p <= r && f >= t1 && f <= n && l.push(i[d]), (0 === u ? e1 <= p : t1 <= f) && (o.push(h), o.push(d - 1), o.push(1 - u)), (0 === u ? r >= p : n >= f) && (o.push(d + 1), o.push(c), o.push(1 - u));
                }
                return l;
            }
            within(e1, t1, r) {
                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                const { ids: n, coords: i, nodeSize: s } = this, a = [
                    0,
                    n.length - 1,
                    0
                ], o = [], l = r * r;
                for(; a.length;){
                    const u = a.pop() || 0, c = a.pop() || 0, h = a.pop() || 0;
                    if (c - h <= s) {
                        for(let r = h; r <= c; r++)SA(i[2 * r], i[2 * r + 1], e1, t1) <= l && o.push(n[r]);
                        continue;
                    }
                    const d = h + c >> 1, p = i[2 * d], f = i[2 * d + 1];
                    SA(p, f, e1, t1) <= l && o.push(n[d]), (0 === u ? e1 - r <= p : t1 - r <= f) && (a.push(h), a.push(d - 1), a.push(1 - u)), (0 === u ? e1 + r >= p : t1 + r >= f) && (a.push(d + 1), a.push(c), a.push(1 - u));
                }
                return o;
            }
        }
        function AA(e1, t1, r, n, i, s) {
            if (i - n <= r) return;
            const a = n + i >> 1;
            IA(e1, t1, a, n, i, s), AA(e1, t1, r, n, a - 1, 1 - s), AA(e1, t1, r, a + 1, i, 1 - s);
        }
        function IA(e1, t1, r, n, i, s) {
            for(; i > n;){
                if (i - n > 600) {
                    const a = i - n + 1, o = r - n + 1, l = Math.log(a), u = .5 * Math.exp(2 * l / 3), c = .5 * Math.sqrt(l * u * (a - u) / a) * (o - a / 2 < 0 ? -1 : 1);
                    IA(e1, t1, r, Math.max(n, Math.floor(r - o * u / a + c)), Math.min(i, Math.floor(r + (a - o) * u / a + c)), s);
                }
                const a = t1[2 * r + s];
                let o = n, l = i;
                for(MA(e1, t1, n, r), t1[2 * i + s] > a && MA(e1, t1, n, i); o < l;){
                    for(MA(e1, t1, o, l), o++, l--; t1[2 * o + s] < a;)o++;
                    for(; t1[2 * l + s] > a;)l--;
                }
                t1[2 * n + s] === a ? MA(e1, t1, n, l) : (l++, MA(e1, t1, l, i)), l <= r && (n = l + 1), r <= l && (i = l - 1);
            }
        }
        function MA(e1, t1, r, n) {
            BA(e1, r, n), BA(t1, 2 * r, 2 * n), BA(t1, 2 * r + 1, 2 * n + 1);
        }
        function BA(e1, t1, r) {
            const n = e1[t1];
            e1[t1] = e1[r], e1[r] = n;
        }
        function SA(e1, t1, r, n) {
            const i = e1 - r, s = t1 - n;
            return i * i + s * s;
        }
        e1.$ = wi, e1.A = class {
            constructor(e1, t1, r){
                this.target = e1, this.parent = t1, this.mapId = r, this.callbacks = {}, this.cancelCallbacks = {}, je([
                    "receive"
                ], this), this.target.addEventListener("message", this.receive, !1), this.scheduler = new Iw;
            }
            send(e1, t1, r, n, i = !1, s) {
                const a = Math.round(1e18 * Math.random()).toString(36).substring(0, 10);
                r && (r.metadata = s, this.callbacks[a] = r);
                const o = new Set;
                return this.target.postMessage({
                    id: a,
                    type: e1,
                    hasCallback: !!r,
                    targetMapId: n,
                    mustQueue: i,
                    sourceMapId: this.mapId,
                    data: ia(t1, o)
                }, o), {
                    cancel: ()=>{
                        r && delete this.callbacks[a], this.target.postMessage({
                            id: a,
                            type: "<cancel>",
                            targetMapId: n,
                            sourceMapId: this.mapId
                        });
                    }
                };
            }
            receive(e1) {
                const t1 = e1.data;
                if (!t1) return;
                const r = t1.id;
                if (r && (!t1.targetMapId || this.mapId === t1.targetMapId)) {
                    if ("<cancel>" === t1.type) {
                        const e1 = this.cancelCallbacks[r];
                        delete this.cancelCallbacks[r], e1 && e1.cancel();
                    } else if (t1.mustQueue || Ke(self)) {
                        const e1 = this.callbacks[r], n = this.scheduler.add(()=>this.processTask(r, t1), e1 && e1.metadata || {
                            type: "message"
                        });
                        n && (this.cancelCallbacks[r] = n);
                    } else this.processTask(r, t1);
                }
            }
            processTask(e1, t1) {
                if (delete this.cancelCallbacks[e1], "<response>" === t1.type) {
                    const r = this.callbacks[e1];
                    delete this.callbacks[e1], r && (t1.error ? r(sa(t1.error)) : r(null, sa(t1.data)));
                } else {
                    const r = new Set, n = t1.hasCallback ? (t1, n)=>{
                        this.target.postMessage({
                            id: e1,
                            type: "<response>",
                            sourceMapId: this.mapId,
                            error: t1 ? ia(t1) : null,
                            data: ia(n, r)
                        }, r);
                    } : ()=>{}, i = sa(t1.data);
                    if (this.parent[t1.type]) this.parent[t1.type](t1.sourceMapId, i, n);
                    else if (this.parent.getWorkerSource) {
                        const e1 = t1.type.split("."), { source: r, scope: s } = i;
                        this.parent.getWorkerSource(t1.sourceMapId, {
                            type: e1[0],
                            source: r,
                            scope: s,
                            uid: 0
                        })[e1[1]](i, n);
                    } else n(new Error(`Could not find function ${t1.type}`));
                }
            }
            remove() {
                this.scheduler.remove(), this.target.removeEventListener("message", this.receive, !1);
            }
        }, e1.B = ir, e1.C = nr, e1.D = Nr, e1.E = or, e1.F = Vo, e1.G = 2, e1.H = kx, e1.I = lr, e1.J = Mx, e1.K = en, e1.L = yo, e1.M = Qr, e1.N = rn, e1.O = Ds, e1.P = Me, e1.Q = ks, e1.R = Ot, e1.S = Fs, e1.T = zm, e1.U = $s, e1.V = Nb, e1.W = go, e1.X = qs, e1.Y = Zs, e1.Z = _i, e1._ = bi, e1.a = function(e1) {
            return lt.API_CDN_URL_REGEX.test(e1);
        }, e1.a$ = xA, e1.a0 = un, e1.a1 = nn, e1.a2 = tn, e1.a3 = hr, e1.a4 = xo, e1.a5 = class extends Nb {
        }, e1.a6 = Es, e1.a7 = Vs, e1.a8 = mo, e1.a9 = function(e1) {
            const t1 = e1.value;
            return t1 ? tn(t1) ? jb(t1, !0) ? [] : [
                new Nb(e1.key, t1, `invalid url "${t1}"`)
            ] : [
                new Nb(e1.key, t1, `string expected, "${Qr(t1)}" found`)
            ] : [];
        }, e1.aA = Ky, e1.aB = function(e1) {
            let t1 = 1 / 0, r = 1 / 0, n = -1 / 0, i = -1 / 0;
            for (const s of e1)t1 = Math.min(t1, s.x), r = Math.min(r, s.y), n = Math.max(n, s.x), i = Math.max(i, s.y);
            return {
                min: new Me(t1, r),
                max: new Me(n, i)
            };
        }, e1.aC = Ee, e1.aD = h, e1.aE = ee, e1.aF = Pu, e1.aG = Hc, e1.aH = Uu, e1.aI = Qu, e1.aJ = function(e1, t1) {
            const r = {};
            for(let n = 0; n < t1.length; n++){
                const i = t1[n];
                i in e1 && (r[i] = e1[i]);
            }
            return r;
        }, e1.aK = Lu, e1.aL = Nu, e1.aM = function(e1) {
            try {
                const t1 = new URL(e1).pathname.split("/").pop() || "", r = t1.lastIndexOf(".");
                return r >= 0 ? t1.slice(r + 1) : "";
            } catch  {
                return "";
            }
        }, e1.aN = class {
            constructor(e1){
                this.entries = {}, this.scheduler = e1;
            }
            request(e1, t1, r, n) {
                const i = this.entries[e1] = this.entries[e1] || {
                    callbacks: []
                };
                if (i.result) {
                    const [e1, r] = i.result;
                    return this.scheduler ? this.scheduler.add(()=>{
                        n(e1, r);
                    }, t1) : n(e1, r), ()=>{};
                }
                return i.callbacks.push(n), i.cancel || (i.cancel = r((r, n)=>{
                    i.result = [
                        r,
                        n
                    ];
                    for (const e1 of i.callbacks)this.scheduler ? this.scheduler.add(()=>{
                        e1(r, n);
                    }, t1) : e1(r, n);
                    setTimeout(()=>delete this.entries[e1], 3e3);
                })), ()=>{
                    i.result || (i.callbacks = i.callbacks.filter((e1)=>e1 !== n), i.callbacks.length || (i.cancel(), delete this.entries[e1]));
                };
            }
        }, e1.aO = function(e1, t1, r) {
            const n = JSON.stringify(e1.request);
            return e1.data && (this.deduped.entries[n] = {
                result: [
                    null,
                    e1.data
                ]
            }), this.deduped.request(n, {
                type: "parseTile",
                renderSourceType: e1.renderSourceType,
                zoom: e1.tileZoom
            }, (t1)=>{
                const n = $t(e1.request, (e1, n, i)=>{
                    e1 ? Nt(e1) ? t1(null, null) : t1(e1) : n && t1(null, {
                        rawData: n,
                        vectorTile: r ? void 0 : new dc(new Fg(n)),
                        responseHeaders: new Map(i.entries())
                    });
                });
                return ()=>{
                    n.cancel(), t1(null, null);
                };
            }, t1);
        }, e1.aP = function(e1) {
            return e1 ? {
                cacheControl: e1.get("cache-control"),
                expires: e1.get("expires")
            } : {
                cacheControl: void 0,
                expires: void 0
            };
        }, e1.aQ = function(e1) {
            kt++, kt > Bt && (e1.getActor().send("enforceCacheSizeLimit", Mt), kt = 0);
        }, e1.aR = function(e1) {
            return e1 <= 1 ? 1 : Math.pow(2, Math.floor(Math.log2(e1)));
        }, e1.aS = sh, e1.aT = zb, e1.aU = Lb, e1.aV = Ru, e1.aW = Sb, e1.aX = function(e1, t1) {
            const r = document.createElement("video");
            r.muted = !0, r.onloadstart = function() {
                t1(null, r);
            };
            for(let t1 = 0; t1 < e1.length; t1++){
                const n = document.createElement("source");
                qt(e1[t1]) || (r.crossOrigin = "Anonymous"), n.src = e1[t1], r.appendChild(n);
            }
            return {
                cancel: ()=>{}
            };
        }, e1.aY = km, e1.aZ = sw, e1.a_ = je, e1.aa = io, e1.ab = fo, e1.ac = co, e1.ad = class {
            constructor(e1){
                this.specification = e1;
            }
            possiblyEvaluate(e1, t1) {
                return Je(e1.expression.evaluate(t1));
            }
            interpolate(e1, t1, r) {
                return {
                    x: yr(e1.x, t1.x, r),
                    y: yr(e1.y, t1.y, r),
                    z: yr(e1.z, t1.z, r),
                    azimuthal: yr(e1.azimuthal, t1.azimuthal, r),
                    polar: yr(e1.polar, t1.polar, r)
                };
            }
        }, e1.ae = to, e1.af = Xs, e1.ag = Ju, e1.ah = j, e1.ai = I, e1.aj = Ce, e1.ak = uo, e1.al = Vh, e1.am = yr, e1.an = qn, e1.ao = gr, e1.ap = Te, e1.aq = dr, e1.ar = class {
            constructor(e1){
                this.specification = e1;
            }
            possiblyEvaluate(e1, t1) {
                return function([e1, t1]) {
                    const r = Je([
                        1,
                        e1,
                        t1
                    ]);
                    return {
                        x: r.x,
                        y: r.y,
                        z: r.z
                    };
                }(e1.expression.evaluate(t1));
            }
            interpolate(e1, t1, r) {
                return {
                    x: yr(e1.x, t1.x, r),
                    y: yr(e1.y, t1.y, r),
                    z: yr(e1.z, t1.z, r)
                };
            }
        }, e1.as = function(e1, t1, r = 0, n = !0) {
            const i = new Me(r, r), s = e1.sub(i), a = t1.add(i), o = [
                s,
                new Me(a.x, s.y),
                a,
                new Me(s.x, a.y)
            ];
            return n && o.push(s.clone()), o;
        }, e1.at = function(e1, t1) {
            const r = [];
            for(let n = 0; n < e1.length; n++){
                const i = Re(n - 1, -1, e1.length - 1), s = Re(n + 1, -1, e1.length - 1), a = e1[n], o = e1[s], l = e1[i].sub(a).unit(), u = o.sub(a).unit(), c = u.angleWithSep(l.x, l.y), h = l.add(u).unit().mult(-1 * t1 / Math.sin(c / 2));
                r.push(a.add(h));
            }
            return r;
        }, e1.au = kv, e1.av = Xc, e1.aw = function(e1, t1, r = 0) {
            return M(((t1.x - r) * e1.scale - e1.x) * qn, (t1.y * e1.scale - e1.y) * qn, qu(t1.z, t1.y));
        }, e1.ax = X, e1.ay = L, e1.az = _c, e1.b = function(e1) {
            return lt.API_FONTS_REGEX.test(e1);
        }, e1.b$ = iu, e1.b0 = Fg, e1.b1 = class {
            constructor(e1, t1, r, n, i, s){
                this.tileID = e1, this.uid = Ue(), this.uses = 0, this.tileSize = t1, this.tileZoom = r, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.isRaster = i, n && n.style && (this._lastUpdatedBrightness = n.style.getBrightness()), this._lastAvailableImagesCount = 0, this._firstPrepareComplete = !1, this.expiredRequestCount = 0, this.state = "loading", n && n.transform && (this.projection = n.transform.projection), this.worldview = s, this._hasAppearances = null;
            }
            registerFadeDuration(e1) {
                const t1 = e1 + this.timeAdded;
                t1 < wt.now() || void 0 !== this.fadeEndTime && t1 < this.fadeEndTime || (this.fadeEndTime = t1);
            }
            wasRequested() {
                return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
            }
            get tileTransform() {
                return this._tileTransform || (this._tileTransform = zv(this.tileID.canonical, this.projection)), this._tileTransform;
            }
            loadVectorData(e1, t1, r) {
                if (this.unloadVectorData(), this.state = "loaded", e1) {
                    e1.featureIndex && (this.latestFeatureIndex = e1.featureIndex, e1.rawTileData ? (this.latestRawTileData = e1.rawTileData, this.latestFeatureIndex.rawTileData = e1.rawTileData) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData)), this.collisionBoxArray = e1.collisionBoxArray, this.buckets = fw(e1.buckets, t1.style), this.hasSymbolBuckets = !1;
                    for(const e1 in this.buckets){
                        const t1 = this.buckets[e1];
                        if (t1 instanceof hb) {
                            if (this.hasSymbolBuckets = !0, !r) break;
                            t1.justReloaded = !0;
                        }
                    }
                    if (this.hasRTLText = !1, this.hasSymbolBuckets) for(const e1 in this.buckets){
                        const t1 = this.buckets[e1];
                        if (t1 instanceof hb && t1.hasRTLText) {
                            this.hasRTLText = !0, eo();
                            break;
                        }
                    }
                    this.queryPadding = 0;
                    for(const e1 in this.buckets){
                        const r = this.buckets[e1], n = t1.style.getOwnLayer(e1);
                        if (!n) continue;
                        const i = n.queryRadius(r);
                        this.queryPadding = Math.max(this.queryPadding, i);
                    }
                    e1.imageAtlas && (this.imageAtlas = t1.style.imageManager.imageAtlasCache.getOrCache(e1.imageAtlas)), e1.glyphAtlasImage && (this.glyphAtlasImage = e1.glyphAtlasImage), e1.lineAtlas && (this.lineAtlas = e1.lineAtlas), this._lastUpdatedBrightness = e1.brightness;
                } else this.collisionBoxArray = new kl;
            }
            unloadVectorData() {
                if (this.hasData()) {
                    for(const e1 in this.buckets)this.buckets[e1].destroy();
                    this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && (this.imageAtlasTexture = null), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.lineAtlasTexture && this.lineAtlasTexture.destroy(), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), this.latestFeatureIndex = null, this.state = "unloaded";
                }
            }
            loadModelData(e1, t1, r) {
                e1 && (e1.resourceTiming && (this.resourceTiming = e1.resourceTiming), this.buckets = Object.assign({}, this.buckets, fw(e1.buckets, t1.style)), e1.featureIndex && (this.latestFeatureIndex = e1.featureIndex));
            }
            getBucket(e1) {
                return this.buckets[e1.fqid];
            }
            upload(e1, t1) {
                for(const r in this.buckets){
                    const n = this.buckets[r];
                    if (n.uploadPending()) {
                        let r = {}, i = [], s = {
                            zoom: 0,
                            pitch: 0,
                            brightness: 0,
                            worldview: ""
                        };
                        if (t1) {
                            if (t1.style) {
                                i = t1.style.listImages();
                                const e1 = n.layers[0], s = e1.sourceLayer || "_geojsonTileLayer", a = t1.style.getLayerSourceCache(e1);
                                a && (r = a._state.getState(s, void 0));
                            }
                            s = {
                                zoom: t1.transform.zoom || 0,
                                pitch: t1.transform.pitch || 0,
                                brightness: t1.style.getBrightness() || 0,
                                worldview: t1.worldview || ""
                            };
                        }
                        n.upload(e1, this.tileID.canonical, r, i, s);
                    }
                }
                const r = e1.gl, n = this.imageAtlas;
                !n || this.imageAtlasTexture && n.uploaded || (this.imageAtlasTexture = null, this.imageAtlasTexture = t1.style.imageManager.imageAtlasCache.getTextureForAtlas(n, e1, r.RGBA8), n.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new zm(e1, this.glyphAtlasImage, r.R8), this.glyphAtlasImage = null), this.lineAtlas && !this.lineAtlas.uploaded && (this.lineAtlasTexture = new zm(e1, this.lineAtlas.image, r.R8), this.lineAtlas.uploaded = !0);
            }
            prepare(e1, t1, r) {
                if (this.imageAtlas && this.imageAtlasTexture && t1) {
                    const n = t1.style.getLut(r);
                    this.imageAtlas.patchUpdatedImages(e1, this.imageAtlasTexture, r, n);
                }
                if (!t1 || !this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData) return;
                const n = t1.style.getBrightness(), i = t1.style.listImages(), s = i.length, a = t1.style._changes.getUpdatedPaintProperties(), o = Object.keys(this.buckets).some((e1)=>this.buckets[e1].layers.some((e1)=>a.has(e1.fqid))), l = Object.keys(this.buckets).some((e1)=>this.buckets[e1].layers.some((e1)=>e1.hasTransition && e1.hasTransition())), u = this._firstPrepareComplete && s !== this._lastAvailableImagesCount;
                null === this._hasAppearances && (this._hasAppearances = this.hasAppearances(t1));
                const c = this._lastUpdatedBrightness !== n;
                this._lastAvailableImagesCount = s, this._firstPrepareComplete = !0, (this._lastUpdatedBrightness || n || this._hasAppearances || o || l || u) && (!(this._hasAppearances || o || l || u) && this._lastUpdatedBrightness && n && Math.abs(this._lastUpdatedBrightness - n) < .001 || (this.updateBuckets(t1, c, void 0, u || o || l, a, i), this._lastUpdatedBrightness = n));
            }
            evaluateQueryRenderedFeaturePadding() {
                let e1 = 0;
                for(const t1 in this.buckets){
                    const r = this.buckets[t1];
                    r.evaluateQueryRenderedFeaturePadding && (e1 = Math.max(e1, r.evaluateQueryRenderedFeaturePadding()));
                }
                return e1;
            }
            queryRenderedFeatures(e1, t1, r, n, i, s, a) {
                if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData && !this.latestFeatureIndex.is3DTile) return {};
                const o = this.evaluateQueryRenderedFeaturePadding(), l = function(e1, t1) {
                    const r = g([], [
                        .5 * e1.width,
                        .5 * -e1.height,
                        1
                    ]);
                    return d(r, r, [
                        1,
                        -1,
                        0
                    ]), h(r, r, e1.calculateProjMatrix(t1.toUnwrapped())), Float32Array.from(r);
                }(i, this.tileID);
                return this.latestFeatureIndex.query(e1, {
                    tilespaceGeometry: t1,
                    pixelPosMatrix: l,
                    transform: n,
                    availableImages: r,
                    tileTransform: this.tileTransform,
                    worldview: this.worldview,
                    queryRadius: o,
                    scope: a
                });
            }
            querySourceFeatures(e1, t1) {
                const r = this.latestFeatureIndex;
                if (!r || !r.rawTileData) return;
                const n = r.loadVTLayers(), i = t1 ? t1.sourceLayer : "", s = n._geojsonTileLayer || n[i];
                if (!s) return;
                const a = vo(t1 && t1.filter), { z: o, x: l, y: u } = this.tileID.canonical, c = {
                    z: o,
                    x: l,
                    y: u
                };
                for(let t1 = 0; t1 < s.length; t1++){
                    const n = s.feature(t1);
                    if (a.needGeometry) {
                        const e1 = ac(n, !0);
                        if (!a.filter(new to(this.tileID.overscaledZ, {
                            worldview: this.worldview
                        }), e1, this.tileID.canonical)) continue;
                    } else if (!a.filter(new to(this.tileID.overscaledZ, {
                        worldview: this.worldview
                    }), n)) continue;
                    const h = r.getId(n, i), d = new iw(n, o, l, u, h);
                    d.tile = c, e1.push(d);
                }
            }
            loaded() {
                return "loaded" === this.state || "errored" === this.state;
            }
            hasData() {
                return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
            }
            patternsLoaded() {
                return !!this.imageAtlas && !!this.imageAtlas.patternPositions.size;
            }
            setExpiryData(e1) {
                const t1 = this.expirationTime;
                if (e1.cacheControl) {
                    const t1 = Qe(e1.cacheControl);
                    t1["max-age"] && (this.expirationTime = Date.now() + 1e3 * t1["max-age"]);
                } else e1.expires && (this.expirationTime = new Date(e1.expires).getTime());
                if (this.expirationTime) {
                    const e1 = Date.now();
                    let r = !1;
                    if (this.expirationTime > e1) r = !1;
                    else if (t1) {
                        if (this.expirationTime < t1) r = !0;
                        else {
                            const n = this.expirationTime - t1;
                            n ? this.expirationTime = e1 + Math.max(n, 3e4) : r = !0;
                        }
                    } else r = !0;
                    r ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                }
            }
            getExpiryTimeout() {
                if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1);
            }
            refreshFeatureState(e1, t1) {
                if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData && !this.latestFeatureIndex.is3DTile || !e1) return;
                const r = e1.style.listImages();
                this.updateBuckets(e1, !1, t1, void 0, void 0, r);
            }
            hasAppearances(e1) {
                for(const t1 in this.buckets)if (e1.style.hasLayer(t1) && this.buckets[t1].layers.some((e1)=>e1.appearances && e1.appearances.length > 0)) return !0;
                return !1;
            }
            updateBuckets(e1, t1, r, n, i, s) {
                if (!this.latestFeatureIndex) return;
                if (!e1.style) return;
                const a = s || e1.style.listImages(), o = e1.style.getBrightness(), l = i || new Set;
                for(const i in this.buckets){
                    if (!e1.style.hasLayer(i)) continue;
                    const s = this.buckets[i], u = s.layers[0], c = u.sourceLayer || "_geojsonTileLayer", h = e1.style.getLayerSourceCache(u), d = s.layers.some((e1)=>l.has(e1.fqid)), p = (n || d) && s instanceof hb ? e1.style.getOwnLayer(i) : void 0;
                    let f = r && r[c] || {};
                    h && !r && (f = h._state.getState(c, void 0));
                    const m = this.imageAtlas ? Object.fromEntries(this.imageAtlas.patternPositions) : {}, y = Object.keys(f).length > 0 && !t1;
                    s.hasAppearances = s.layers.some((e1)=>e1.appearances && e1.appearances.length > 0);
                    const g = y ? s.stateDependentLayers : s.layers;
                    if (y && 0 !== s.stateDependentLayers.length || t1 || d || n) {
                        const r = this.latestFeatureIndex.loadVTLayers()[c];
                        if (s.update(f, r, a, m, g, t1, o, this.tileID.canonical), (n || d) && !t1 && s instanceof hb && p && "symbol" === p.type) {
                            const e1 = s;
                            e1.text && e1.text.uboBinder && e1.text.uboBinder.updateDynamicExpressions(p, r, this.tileID.canonical, a, f, o), e1.icon && e1.icon.uboBinder && e1.icon.uboBinder.updateDynamicExpressions(p, r, this.tileID.canonical, a, f, o);
                        }
                        if (s instanceof hb) {
                            const t1 = s, r = e1.context;
                            t1.text && t1.text.uboBinder && t1.text.uboBinder.upload(r), t1.icon && t1.icon.uboBinder && t1.icon.uboBinder.upload(r);
                        }
                    }
                    if (y && 0 !== s.stateDependentLayers.length || t1 || s.hasAppearances) {
                        const t1 = {
                            zoom: e1.transform.zoom,
                            pitch: e1.transform.pitch,
                            brightness: e1.style.getBrightness() || 0,
                            worldview: e1.worldview
                        }, r = s.updateAppearances(this.tileID.canonical, f, a, t1, e1.imageManager, y && 0 !== s.stateDependentLayers.length);
                        if (r && r.hasUboChanges) {
                            const t1 = e1.context;
                            s instanceof hb && s.text && s.text.uboBinder && s.text.uboBinder.upload(t1), s instanceof hb && s.icon && s.icon.uboBinder && s.icon.uboBinder.upload(t1);
                        }
                    }
                    (s instanceof Zy || s instanceof Sp) && e1._terrain && e1._terrain.enabled && h && s.uploadPending() && e1._terrain._clearRenderCacheForTile(h.id, this.tileID);
                    const x = e1 && e1.style && e1.style.getOwnLayer(i);
                    x && (this.queryPadding = Math.max(this.queryPadding, x.queryRadius(s)));
                }
            }
            holdingForFade() {
                return void 0 !== this.symbolFadeHoldUntil;
            }
            symbolFadeFinished() {
                return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < wt.now();
            }
            clearFadeHold() {
                this.symbolFadeHoldUntil = void 0;
            }
            setHoldDuration(e1) {
                this.symbolFadeHoldUntil = wt.now() + e1;
            }
            setTexture(e1, t1) {
                const r = t1.context, n = r.gl;
                this.texture = this.texture || t1.getTileTexture(e1.width), this.texture && this.texture instanceof zm ? this.texture.update(e1) : (this.texture = new zm(r, e1, n.RGBA8, {
                    useMipmap: !0
                }), this.texture.bind(n.LINEAR, n.CLAMP_TO_EDGE));
            }
            setDependencies(e1, t1) {
                const r = {};
                for (const e1 of t1)r[e1] = !0;
                this.dependencies[e1] = r;
            }
            hasDependency(e1, t1) {
                for (const r of e1){
                    const e1 = this.dependencies[r];
                    if (e1) {
                        for (const r of t1)if (e1[r]) return !0;
                    }
                }
                return !1;
            }
            clearQueryDebugViz() {}
            _makeDebugTileBoundsBuffers(e1, t1) {
                if (!t1 || "mercator" === t1.name || this._tileDebugBuffer) return;
                const r = sc(Aw, this.tileID.canonical, this.tileTransform)[0], n = new Xo, i = new Ml;
                for(let e1 = 0; e1 < r.length; e1++){
                    const { x: t1, y: s } = r[e1];
                    n.emplaceBack(t1, s), i.emplaceBack(e1);
                }
                i.emplaceBack(0), this._tileDebugIndexBuffer = e1.createIndexBuffer(i), this._tileDebugBuffer = e1.createVertexBuffer(n, hh.members), this._tileDebugSegments = Hl.simpleSegment(0, 0, n.length, i.length);
            }
            _makeTileBoundsBuffers(e1, t1) {
                if (this._tileBoundsBuffer || !t1 || "mercator" === t1.name) return;
                const r = sc(Aw, this.tileID.canonical, this.tileTransform)[0];
                let n, i;
                if (this.isRaster) {
                    const e1 = function(e1, t1) {
                        const r = zv(e1, t1), n = Math.pow(2, e1.z);
                        for(let i = 0; i < yw; i++)for(let s = 0; s < yw; s++){
                            const a = Gu((e1.x + (s + ww(s)) / mw) / n), o = $u((e1.y + (i + ww(i)) / mw) / n), l = t1.project(a, o), u = i * yw + s;
                            xw[2 * u + 0] = Math.round((l.x * r.scale - r.x) * qn), xw[2 * u + 1] = Math.round((l.y * r.scale - r.y) * qn);
                        }
                        vw.fill(0), bw.fill(0);
                        for(let e1 = 2045; e1 >= 0; e1--){
                            const t1 = 4 * e1, r = gw[t1 + 0], n = gw[t1 + 1], i = gw[t1 + 2], s = gw[t1 + 3], a = r + i >> 1, o = n + s >> 1, l = a + o - n, u = o + r - a, c = n * yw + r, h = s * yw + i, d = o * yw + a, p = Math.hypot((xw[2 * c + 0] + xw[2 * h + 0]) / 2 - xw[2 * d + 0], (xw[2 * c + 1] + xw[2 * h + 1]) / 2 - xw[2 * d + 1]) >= 16;
                            vw[d] = vw[d] || (p ? 1 : 0), e1 < 1022 && (vw[d] = vw[d] || vw[(n + u >> 1) * yw + (r + l >> 1)] || vw[(s + u >> 1) * yw + (i + l >> 1)]);
                        }
                        const i = new Wo, s = new ml;
                        let a = 0;
                        function o(e1, t1) {
                            const r = t1 * yw + e1;
                            return 0 === bw[r] && (i.emplaceBack(xw[2 * r + 0], xw[2 * r + 1], e1 * qn / mw, t1 * qn / mw), bw[r] = ++a), bw[r] - 1;
                        }
                        function l(e1, t1, r, n, i, a) {
                            const u = e1 + r >> 1, c = t1 + n >> 1;
                            if (Math.abs(e1 - i) + Math.abs(t1 - a) > 1 && vw[c * yw + u]) l(i, a, e1, t1, u, c), l(r, n, i, a, u, c);
                            else {
                                const l = o(e1, t1), u = o(r, n), c = o(i, a);
                                s.emplaceBack(l, u, c);
                            }
                        }
                        return l(0, 0, mw, mw, mw, 0), l(mw, mw, 0, 0, 0, mw), {
                            vertices: i,
                            indices: s
                        };
                    }(this.tileID.canonical, t1);
                    n = e1.vertices, i = e1.indices;
                } else {
                    n = new Wo, i = new ml;
                    for (const { x: e1, y: t1 } of r)n.emplaceBack(e1, t1, 0, 0);
                    const e1 = od(n.int16.subarray(0, 4 * n.length), void 0, 4);
                    for(let t1 = 0; t1 < e1.length; t1 += 3)i.emplaceBack(e1[t1], e1[t1 + 1], e1[t1 + 2]);
                }
                this._tileBoundsBuffer = e1.createVertexBuffer(n, Ab.members), this._tileBoundsIndexBuffer = e1.createIndexBuffer(i), this._tileBoundsSegments = Hl.simpleSegment(0, 0, n.length, i.length);
            }
            _makeGlobeTileDebugBuffers(e1, t1) {
                const r = t1.projection;
                if (!r || "globe" !== r.name || t1.freezeTileCoverage) return;
                const n = this.tileID.canonical, i = Sh(vh(n, t1)), s = Vh(t1.zoom);
                let a;
                s > 0 && (a = c(new Float64Array(16), t1.globeMatrix)), this._makeGlobeTileDebugBorderBuffer(e1, n, t1, i, a, s), this._makeGlobeTileDebugTextBuffer(e1, n, t1, i, a, s);
            }
            _globePoint(e1, t1, r, n, i, s, a) {
                let o = Ih(e1, t1, r);
                if (s) {
                    const i = 1 << r.z, l = Uu(n.center.lng), u = Nu(n.center.lat), c = (r.x + .5) / i - l;
                    let h = 0;
                    c > .5 ? h = -1 : c < -0.5 && (h = 1);
                    let d = (e1 / qn + r.x) / i + h, p = (t1 / qn + r.y) / i;
                    d = (d - l) * n._pixelsPerMercatorPixel + l, p = (p - u) * n._pixelsPerMercatorPixel + u;
                    const f = [
                        d * n.worldSize,
                        p * n.worldSize,
                        0
                    ];
                    j(f, f, s), o = xh(o, f, a);
                }
                return j(o, o, i);
            }
            _makeGlobeTileDebugBorderBuffer(e1, t1, r, n, i, s) {
                const a = new Xo, o = new Ml, l = new Zo, u = (e1, u, c, h, d)=>{
                    const p = (c - e1) / (d - 1), f = (h - u) / (d - 1), m = a.length;
                    for(let c = 0; c < d; c++){
                        const h = e1 + c * p, d = u + c * f;
                        a.emplaceBack(h, d);
                        const y = this._globePoint(h, d, t1, r, n, i, s);
                        l.emplaceBack(y[0], y[1], y[2]), o.emplaceBack(m + c);
                    }
                }, c = qn;
                u(0, 0, c, 0, 16), u(c, 0, c, c, 16), u(c, c, 0, c, 16), u(0, c, 0, 0, 16), this._tileDebugIndexBuffer = e1.createIndexBuffer(o), this._tileDebugBuffer = e1.createVertexBuffer(a, hh.members), this._globeTileDebugBorderBuffer = e1.createVertexBuffer(l, ch.members), this._tileDebugSegments = Hl.simpleSegment(0, 0, a.length, o.length);
            }
            _makeGlobeTileDebugTextBuffer(e1, t1, r, n, i, s) {
                const a = new Xo, o = new ml, l = new Zo, u = 25;
                o.reserve(32), a.reserve(u), l.reserve(u);
                const c = (e1, t1)=>u * e1 + t1;
                for(let e1 = 0; e1 < u; e1++){
                    const o = 2048 * e1;
                    for(let e1 = 0; e1 < u; e1++){
                        const u = 2048 * e1;
                        a.emplaceBack(u, o);
                        const c = this._globePoint(u, o, t1, r, n, i, s);
                        l.emplaceBack(c[0], c[1], c[2]);
                    }
                }
                for(let e1 = 0; e1 < 4; e1++)for(let t1 = 0; t1 < 4; t1++){
                    const r = c(e1, t1), n = c(e1, t1 + 1), i = c(e1 + 1, t1), s = c(e1 + 1, t1 + 1);
                    o.emplaceBack(r, n, i), o.emplaceBack(i, n, s);
                }
                this._tileDebugTextIndexBuffer = e1.createIndexBuffer(o), this._tileDebugTextBuffer = e1.createVertexBuffer(a, hh.members), this._globeTileDebugTextBuffer = e1.createVertexBuffer(l, ch.members), this._tileDebugTextSegments = Hl.simpleSegment(0, 0, u, 32);
            }
            destroy(e1 = !0) {
                for(const t1 in this.buckets)this.buckets[t1].destroy(e1);
                this.buckets = {}, this.imageAtlas && (this.imageAtlas = null), this.lineAtlas && (this.lineAtlas = null), this.imageAtlasTexture && delete this.imageAtlasTexture, this.glyphAtlasTexture && (this.glyphAtlasTexture.destroy(), delete this.glyphAtlasTexture), this.lineAtlasTexture && (this.lineAtlasTexture.destroy(), delete this.lineAtlasTexture), this._tileBoundsBuffer && (this._tileBoundsBuffer.destroy(), this._tileBoundsIndexBuffer.destroy(), this._tileBoundsSegments.destroy(), this._tileBoundsBuffer = null), this._tileDebugBuffer && (this._tileDebugBuffer.destroy(), this._tileDebugSegments.destroy(), this._tileDebugBuffer = null), this._tileDebugIndexBuffer && (this._tileDebugIndexBuffer.destroy(), this._tileDebugIndexBuffer = null), this._globeTileDebugBorderBuffer && (this._globeTileDebugBorderBuffer.destroy(), this._globeTileDebugBorderBuffer = null), this._tileDebugTextBuffer && (this._tileDebugTextBuffer.destroy(), this._tileDebugTextSegments.destroy(), this._tileDebugTextIndexBuffer.destroy(), this._tileDebugTextBuffer = null), this._globeTileDebugTextBuffer && (this._globeTileDebugTextBuffer.destroy(), this._globeTileDebugTextBuffer = null), e1 && this.texture && this.texture instanceof zm && (this.texture.destroy(), delete this.texture), this.emissiveTexture && this.emissiveTexture instanceof zm && (this.emissiveTexture.destroy(), delete this.emissiveTexture), this.hillshadeFBO && (this.hillshadeFBO.destroy(), delete this.hillshadeFBO), this.dem && delete this.dem, this.neighboringTiles && delete this.neighboringTiles, this.demTexture && (this.demTexture.destroy(), delete this.demTexture), this.rasterParticleState && (this.rasterParticleState.destroy(), delete this.rasterParticleState), this.latestFeatureIndex = null, this.state = "unloaded";
            }
        }, e1.b2 = $t, e1.b3 = Nt, e1.b4 = function(e1, t1) {
            const r = [];
            for(const n in e1)n in t1 || r.push(n);
            return r;
        }, e1.b5 = _w, e1.b6 = [
            "type",
            "source",
            "source-layer",
            "minzoom",
            "maxzoom",
            "filter",
            "layout"
        ], e1.b7 = Be, e1.b8 = c, e1.b9 = l, e1.bA = qp, e1.bB = rf, e1.bC = ef, e1.bD = tf, e1.bE = ac, e1.bF = Y, e1.bG = sx, e1.bH = iv, e1.bI = gv, e1.bJ = _A, e1.bK = V, e1.bL = W, e1.bM = re, e1.bN = function(e1, t1, r) {
            r *= .5;
            var n = t1[0], i = t1[1], s = t1[2], a = t1[3], o = Math.sin(r), l = Math.cos(r);
            return e1[0] = n * l + i * o, e1[1] = i * l - n * o, e1[2] = s * l + a * o, e1[3] = a * l - s * o, e1;
        }, e1.bO = ne, e1.bP = rt, e1.bQ = g, e1.bR = function(e1, t1) {
            return e1[0] = -t1[0], e1[1] = -t1[1], e1[2] = -t1[2], e1[3] = t1[3], e1;
        }, e1.bS = b, e1.bT = function(e1, t1, r, n, i) {
            var s = 1 / Math.tan(t1 / 2);
            if (e1[0] = s / r, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = s, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[11] = -1, e1[12] = 0, e1[13] = 0, e1[15] = 0, null != i && i !== 1 / 0) {
                var a = 1 / (n - i);
                e1[10] = (i + n) * a, e1[14] = 2 * i * n * a;
            } else e1[10] = -1, e1[14] = -2 * n;
            return e1;
        }, e1.bU = function(e1, t1, r, n, i, s, a) {
            var o = 1 / (t1 - r), l = 1 / (n - i), u = 1 / (s - a);
            return e1[0] = -2 * o, e1[1] = 0, e1[2] = 0, e1[3] = 0, e1[4] = 0, e1[5] = -2 * l, e1[6] = 0, e1[7] = 0, e1[8] = 0, e1[9] = 0, e1[10] = 2 * u, e1[11] = 0, e1[12] = (t1 + r) * o, e1[13] = (i + n) * l, e1[14] = (a + s) * u, e1[15] = 1, e1;
        }, e1.bV = ju, e1.bW = $u, e1.bX = function(e1, t1, r) {
            e1[4 * t1 + 0] = r[0], e1[4 * t1 + 1] = r[1], e1[4 * t1 + 2] = r[2], e1[4 * t1 + 3] = r[3];
        }, e1.bY = ru, e1.bZ = su, e1.b_ = nu, e1.ba = u, e1.bb = y, e1.bc = o, e1.bd = function(e1, t1) {
            const { x: r, y: n } = e1.point, i = kh(r, n, e1.worldSize / e1._pixelsPerMercatorPixel, 0, 0);
            return h(i, i, Ph(gh(t1)));
        }, e1.be = n, e1.bf = q, e1.bg = D, e1.bh = F, e1.bi = U, e1.bj = O, e1.bk = yx, e1.bl = Zg, e1.bm = mx, e1.bn = function(e1, t1, r, n, i) {
            const s = 5 * t1 + 2;
            e1.float32[s + 0] = r, e1.float32[s + 1] = n, e1.float32[s + 2] = i;
        }, e1.bo = ab, e1.bp = he, e1.bq = me, e1.br = pe, e1.bs = we, e1.bt = Re, e1.bu = function(e1, t1, n, i) {
            var s = new r(4);
            return s[0] = e1, s[1] = t1, s[2] = n, s[3] = i, s;
        }, e1.bv = class {
            isDataAvailableAtPoint(e1) {
                const t1 = this._source();
                if (this.isUsingMockSource() || !t1 || e1.y < 0 || e1.y > 1) return !1;
                const r = t1.getSource().maxzoom, n = 1 << r, i = Math.floor(e1.x), s = Math.floor((e1.x - i) * n), a = Math.floor(e1.y * n), o = this.findDEMTileFor(new sh(r, i, r, s, a));
                return !(!o || !o.dem);
            }
            getAtPointOrZero(e1, t1 = 0) {
                return this.getAtPoint(e1, t1) || 0;
            }
            getAtPoint(e1, t1, r = !0) {
                if (this.isUsingMockSource()) return null;
                null == t1 && (t1 = null);
                const n = this._source();
                if (!n) return t1;
                if (e1.y < 0 || e1.y > 1) return t1;
                const i = n.getSource().maxzoom, s = 1 << i, a = Math.floor(e1.x), o = e1.x - a, l = new sh(i, a, i, Math.floor(o * s), Math.floor(e1.y * s)), u = this.findDEMTileFor(l);
                if (!u || !u.dem) return t1;
                const c = u.dem, h = 1 << u.tileID.canonical.z, d = (o * h - u.tileID.canonical.x) * c.dim, p = (e1.y * h - u.tileID.canonical.y) * c.dim, f = Math.floor(d), m = Math.floor(p);
                return (r ? this.exaggeration() : 1) * yr(yr(c.get(f, m), c.get(f, m + 1), p - m), yr(c.get(f + 1, m), c.get(f + 1, m + 1), p - m), d - f);
            }
            static getAtTileOffset(e1, t1, r, n) {
                const i = 1 << e1.canonical.z;
                return n ? n.pointElevation(t1) : r ? r.getAtPointOrZero(new Ju(e1.wrap + (e1.canonical.x + t1.x / qn) / i, (e1.canonical.y + t1.y / qn) / i)) : 0;
            }
            static getAtTileOffsetFunc(e1, t1, r, n) {
                return (i, s, a)=>{
                    const o = this.getAtTileOffset(e1, i, s, a), l = n.upVector(e1.canonical, i.x, i.y);
                    return V(l, l, o * n.upVectorScale(e1.canonical, t1, r).metersToTile), l;
                };
            }
            getForTilePoints(e1, t1, r, n) {
                if (this.isUsingMockSource()) return !1;
                const i = Hb.create(this, e1, n);
                return !!i && (t1.forEach((e1)=>{
                    e1[2] = this.exaggeration() * i.getElevationAt(e1[0], e1[1], r);
                }), !0);
            }
            getMinMaxForTile(e1) {
                if (this.isUsingMockSource()) return null;
                const t1 = this.findDEMTileFor(e1);
                if (!t1 || !t1.dem) return null;
                const r = t1.dem.tree, n = t1.tileID, i = 1 << e1.canonical.z - n.canonical.z;
                let s = e1.canonical.x / i - n.canonical.x, a = e1.canonical.y / i - n.canonical.y, o = 0;
                for(let t1 = 0; t1 < e1.canonical.z - n.canonical.z && !r.leaves[o]; t1++){
                    s *= 2, a *= 2;
                    const e1 = 2 * Math.floor(a) + Math.floor(s);
                    o = r.childOffsets[o] + e1, s %= 1, a %= 1;
                }
                return {
                    min: this.exaggeration() * r.minimums[o],
                    max: this.exaggeration() * r.maximums[o]
                };
            }
            getMinElevationBelowMSL() {
                throw new Error("Pure virtual method called.");
            }
            raycast(e1, t1, r) {
                throw new Error("Pure virtual method called.");
            }
            pointCoordinate(e1) {
                throw new Error("Pure virtual method called.");
            }
            _source() {
                throw new Error("Pure virtual method called.");
            }
            isUsingMockSource() {
                throw new Error("Pure virtual method called.");
            }
            exaggeration() {
                throw new Error("Pure virtual method called.");
            }
            findDEMTileFor(e1) {
                throw new Error("Pure virtual method called.");
            }
            get visibleDemTiles() {
                throw new Error("Getter must be implemented in subclass.");
            }
            getMinMaxForVisibleTiles() {
                const e1 = this.visibleDemTiles;
                if (0 === e1.length) return null;
                let t1 = !1, r = Number.MAX_VALUE, n = Number.MIN_VALUE;
                for (const i of e1){
                    const e1 = this.getMinMaxForTile(i.tileID);
                    e1 && (r = Math.min(r, e1.min), n = Math.max(n, e1.max), t1 = !0);
                }
                return t1 ? {
                    min: r,
                    max: n
                } : null;
            }
        }, e1.bw = Gf, e1.bx = Ec, e1.by = d, e1.bz = Mg, e1.c = pt, e1.c$ = Ox, e1.c0 = cu, e1.c1 = Kv, e1.c2 = function() {
            var e1 = new r(4);
            return r != Float32Array && (e1[1] = 0, e1[2] = 0), e1[0] = 1, e1[3] = 1, e1;
        }, e1.c3 = function(e1, t1, r) {
            var n = t1[0], i = t1[1], s = t1[2], a = t1[3], o = Math.sin(r), l = Math.cos(r);
            return e1[0] = n * l + s * o, e1[1] = i * l + a * o, e1[2] = n * -o + s * l, e1[3] = i * -o + a * l, e1;
        }, e1.c4 = function(e1, t1) {
            return e1[0] === t1[0] && e1[1] === t1[1] && e1[2] === t1[2] && e1[3] === t1[3];
        }, e1.c5 = H, e1.c6 = function(e1) {
            var t1 = e1[0], r = e1[1], n = e1[2], i = e1[3];
            return Math.sqrt(t1 * t1 + r * r + n * n + i * i);
        }, e1.c7 = le, e1.c8 = $, e1.c9 = ih, e1.cA = function(e1) {
            const { x: t1, y: r } = e1.point, { lng: n, lat: i } = e1._center;
            return kh(t1, r, e1.worldSize, n, i);
        }, e1.cB = T, e1.cC = ze, e1.cD = ah, e1.cE = Zc, e1.cF = 5, e1.cG = function(e1, t1, r) {
            let n = 0;
            for(let r = 0; r < 2; ++r){
                const i = 0;
                e1[r] > i && (n += (e1[r] - i) * (e1[r] - i)), t1[r] < i && (n += (i - t1[r]) * (i - t1[r]));
            }
            return n;
        }, e1.cH = function(e1) {
            return e1 * e1 * e1 * e1 * e1;
        }, e1.cI = Ou, e1.cJ = 45, e1.cK = ou, e1.cL = function(e1, t1, r) {
            const n = Math.sqrt(e1 * e1 + t1 * t1 + r * r), i = n > 0 ? Math.acos(r / n) * Pe : 0;
            let s = 0 !== e1 || 0 !== t1 ? Math.atan2(-t1, -e1) * Pe + 90 : 0;
            return s < 0 && (s += 360), [
                n,
                s,
                i
            ];
        }, e1.cM = M, e1.cN = Je, e1.cO = Yu, e1.cP = S, e1.cQ = Tc, e1.cR = P, e1.cS = function(e1) {
            return [
                Math.pow(e1[0], 1 / 2.2),
                Math.pow(e1[1], 1 / 2.2),
                Math.pow(e1[2], 1 / 2.2)
            ];
        }, e1.cT = Sm, e1.cU = dy, e1.cV = Km, e1.cW = jb, e1.cX = function(e1, t1) {
            return e1.readFields(Bw, {
                icons: []
            }, t1);
        }, e1.cY = Rc, e1.cZ = class {
            static calculate(e1, t1, r) {
                const n = new Set, i = new Map, s = new Set, a = new Set;
                for (const r of Object.values(e1))for (const [e1, o] of Object.entries(r.floors)){
                    s.add(e1), o.isDefault && a.add(e1), o.conflicts && i.set(e1, o.conflicts);
                    const r = e1 === t1, l = o.connections && t1 && o.connections.has(t1);
                    (r || l) && n.add(e1);
                }
                const o = (e1)=>{
                    const t1 = i.get(e1) || new Set;
                    for (const r of n)if ((i.get(r) || new Set).has(e1) || t1.has(r)) return !0;
                    return !1;
                };
                if (r) for (const e1 of r)s.has(e1) && (o(e1) || n.add(e1));
                for (const e1 of a)n.has(e1) || o(e1) || n.add(e1);
                return n;
            }
        }, e1.c_ = Ux, e1.ca = 3, e1.cb = 2, e1.cc = 7, e1.cd = 6, e1.ce = N, e1.cf = _, e1.cg = Pc, e1.ch = Um, e1.ci = nh, e1.cj = wh, e1.ck = function(e1, t1, r, n, i, s, a, o, l) {
            if ("globe" === l.name) return wh(e1, t1, new nh(r, n, i), !1);
            const u = zv({
                z: r,
                x: n,
                y: i
            }, l);
            return new Tc([
                (s + u.x / u.scale) * t1,
                t1 * (u.y / u.scale),
                a
            ], [
                (s + u.x2 / u.scale) * t1,
                t1 * (u.y2 / u.scale),
                o
            ]);
        }, e1.cl = function(e1, t1, r) {
            return e1[0] = Math.min(t1[0], r[0]), e1[1] = Math.min(t1[1], r[1]), e1[2] = Math.min(t1[2], r[2]), e1[3] = Math.min(t1[3], r[3]), e1;
        }, e1.cm = function(e1, t1, r) {
            return e1[0] = Math.max(t1[0], r[0]), e1[1] = Math.max(t1[1], r[1]), e1[2] = Math.max(t1[2], r[2]), e1[3] = Math.max(t1[3], r[3]), e1;
        }, e1.cn = function(e1) {
            const t1 = Math.round((e1 + 45 + 360) % 360 / 90) % 4;
            return ke[t1];
        }, e1.co = Hu, e1.cp = J, e1.cq = 6, e1.cr = function(e1) {
            const t1 = u(new Float64Array(16));
            h(t1, e1.pixelMatrix, e1.globeMatrix);
            const r = [
                0,
                ku,
                0
            ], n = [
                0,
                Vu,
                0
            ];
            return j(r, r, t1), j(n, n, t1), [
                r[0] > 0 && r[0] <= e1.width && r[1] > 0 && r[1] <= e1.height && !Dh(e1, new Ru(e1.center.lat, 90)),
                n[0] > 0 && n[0] <= e1.width && n[1] > 0 && n[1] <= e1.height && !Dh(e1, new Ru(e1.center.lat, -90))
            ];
        }, e1.cs = function(e1, t1) {
            const { scale: r } = e1.tileTransform, n = r * qn / (e1.tileSize * Math.pow(2, t1.zoom - e1.tileID.overscaledZ + e1.tileID.canonical.z));
            return function(e1, t1, r) {
                var n = t1[1], i = t1[2], s = t1[3], a = r[0], o = r[1];
                return e1[0] = t1[0] * a, e1[1] = n * a, e1[2] = i * o, e1[3] = s * o, e1;
            }(new Float32Array(4), t1.inverseAdjustmentMatrix, [
                n,
                n
            ]);
        }, e1.ct = Nm, e1.cu = w, e1.cv = Om, e1.cw = function(e1) {
            const t1 = Om(e1, !0);
            return n([], [
                t1[0],
                t1[1],
                t1[4],
                t1[5]
            ]);
        }, e1.cx = p, e1.cy = Ac, e1.cz = f, e1.d = function(e1) {
            return lt.API_TILEJSON_REGEX.test(e1);
        }, e1.d$ = df, e1.d0 = jt, e1.d1 = function() {
            return {
                API_URL: lt.API_URL,
                DRACO_URL: lt.DRACO_URL,
                MESHOPT_URL: lt.MESHOPT_URL,
                MESHOPT_SIMD_URL: lt.MESHOPT_SIMD_URL,
                BUILDING_GEN_URL: lt.BUILDING_GEN_URL
            };
        }, e1.d2 = Za, e1.d3 = At, e1.d4 = rr, e1.d5 = qe, e1.d6 = function(e1) {
            const t1 = e1.indexOf(ko);
            return t1 >= 0 ? e1.slice(0, t1) : e1;
        }, e1.d7 = function(e1) {
            return e1.indexOf(ko) >= 0;
        }, e1.d8 = function(e1) {
            const t1 = e1.lastIndexOf(ko);
            return t1 >= 0 ? e1.slice(t1 + 1) : "";
        }, e1.d9 = function(e1) {
            const t1 = [], r = e1.id;
            return void 0 === r && t1.push({
                message: `layers.${r}: missing required property "id"`
            }), void 0 === e1.render && t1.push({
                message: `layers.${r}: missing required method "render"`
            }), e1.renderingMode && "2d" !== e1.renderingMode && "3d" !== e1.renderingMode && t1.push({
                message: `layers.${r}: property "renderingMode" must be either "2d" or "3d"`
            }), t1;
        }, e1.dA = i, e1.dB = function(e1, t1) {
            var r = Math.sin(t1), n = Math.cos(t1);
            return e1[0] = n, e1[1] = r, e1[2] = 0, e1[3] = -r, e1[4] = n, e1[5] = 0, e1[6] = 0, e1[7] = 0, e1[8] = 1, e1;
        }, e1.dC = G, e1.dD = zh, e1.dE = st, e1.dF = at, e1.dG = Pb, e1.dH = function(e1, t1) {
            const r = [
                0,
                0,
                0
            ];
            return j(r, r, Sh(gh(t1.canonical))), j(r, r, e1), r;
        }, e1.dI = (e1)=>({
                u_matrix: new cu(e1),
                u_texsize: new iu(e1),
                u_pixels_to_tile_units: new pu(e1),
                u_device_pixel_ratio: new nu(e1),
                u_width_scale: new nu(e1),
                u_floor_width_scale: new nu(e1),
                u_image: new ru(e1),
                u_units_to_pixels: new iu(e1),
                u_tile_units_to_pixels: new nu(e1),
                u_alpha_discard_threshold: new nu(e1),
                u_trim_offset: new iu(e1),
                u_trim_fade_range: new iu(e1),
                u_trim_gradient_mix_range: new iu(e1),
                u_trim_color: new ou(e1),
                u_zbias_factor: new nu(e1),
                u_tile_to_meter: new nu(e1),
                u_ground_shadow_factor: new su(e1),
                u_pattern_transition: new nu(e1)
            }), e1.dJ = (e1)=>({
                u_matrix: new cu(e1),
                u_pixels_to_tile_units: new pu(e1),
                u_device_pixel_ratio: new nu(e1),
                u_width_scale: new nu(e1),
                u_floor_width_scale: new nu(e1),
                u_units_to_pixels: new iu(e1),
                u_dash_image: new ru(e1),
                u_gradient_image: new ru(e1),
                u_image_height: new nu(e1),
                u_texsize: new iu(e1),
                u_tile_units_to_pixels: new nu(e1),
                u_alpha_discard_threshold: new nu(e1),
                u_trim_offset: new iu(e1),
                u_trim_fade_range: new iu(e1),
                u_trim_gradient_mix_range: new iu(e1),
                u_trim_color: new ou(e1),
                u_zbias_factor: new nu(e1),
                u_tile_to_meter: new nu(e1),
                u_ground_shadow_factor: new su(e1)
            }), e1.dK = (e1)=>({
                u_camera_to_center_distance: new nu(e1),
                u_extrude_scale: new pu(e1),
                u_device_pixel_ratio: new nu(e1),
                u_matrix: new cu(e1),
                u_inv_rot_matrix: new cu(e1),
                u_merc_center: new iu(e1),
                u_tile_id: new su(e1),
                u_zoom_transition: new nu(e1),
                u_up_dir: new su(e1),
                u_emissive_strength: new nu(e1)
            }), e1.dL = pl, e1.dM = vg, e1.dN = class {
            constructor(e1, t1, r, n){
                this.context = e1, this.format = n, this.size = r, this.texture = e1.gl.createTexture();
                const [i, s, a] = this.size, { gl: o } = e1;
                o.bindTexture(o.TEXTURE_3D, this.texture), e1.pixelStoreUnpackFlipY.set(!1), e1.pixelStoreUnpack.set(1), e1.pixelStoreUnpackPremultiplyAlpha.set(!1), "data" in t1 && t1.data && o.texImage3D(o.TEXTURE_3D, 0, this.format, i, s, a, 0, Pm(this.format), Tm(this.format), t1.data);
            }
            bind(e1, t1) {
                const { context: r } = this, { gl: n } = r;
                n.bindTexture(n.TEXTURE_3D, this.texture), e1 !== this.minFilter && (n.texParameteri(n.TEXTURE_3D, n.TEXTURE_MAG_FILTER, e1), n.texParameteri(n.TEXTURE_3D, n.TEXTURE_MIN_FILTER, e1), this.minFilter = e1), t1 !== this.wrapS && (n.texParameteri(n.TEXTURE_3D, n.TEXTURE_WRAP_S, t1), n.texParameteri(n.TEXTURE_3D, n.TEXTURE_WRAP_T, t1), this.wrapS = t1);
            }
            destroy() {
                const { gl: e1 } = this.context;
                e1.deleteTexture(this.texture), this.texture = null;
            }
        }, e1.dO = Oh, e1.dP = (e1, t1, r, n, i, s)=>{
            const a = e1.transform, o = "globe" === a.projection.name;
            let l;
            if ("map" === s.paint.get("circle-pitch-alignment")) {
                if (o) {
                    const e1 = zh(a.zoom, t1.canonical) * a._pixelsPerMercatorPixel;
                    l = Float32Array.from([
                        e1,
                        0,
                        0,
                        e1
                    ]);
                } else l = a.calculatePixelsToTileUnitsMatrix(r);
            } else l = new Float32Array([
                a.pixelsToGLUnits[0],
                0,
                0,
                a.pixelsToGLUnits[1]
            ]);
            const u = {
                u_camera_to_center_distance: e1.transform.getCameraToCenterDistance(a.projection),
                u_matrix: e1.translatePosMatrix(t1.projMatrix, r, s.paint.get("circle-translate"), s.paint.get("circle-translate-anchor")),
                u_device_pixel_ratio: wt.devicePixelRatio,
                u_extrude_scale: l,
                u_inv_rot_matrix: Lh,
                u_merc_center: [
                    0,
                    0
                ],
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_up_dir: [
                    0,
                    0,
                    0
                ],
                u_emissive_strength: s.paint.get("circle-emissive-strength")
            };
            if (o) {
                u.u_inv_rot_matrix = n, u.u_merc_center = i, u.u_tile_id = [
                    t1.canonical.x,
                    t1.canonical.y,
                    1 << t1.canonical.z
                ], u.u_zoom_transition = Vh(a.zoom);
                const e1 = i[0] * qn, r = i[1] * qn;
                u.u_up_dir = a.projection.upVector(new nh(0, 0, 0), e1, r);
            }
            return u;
        }, e1.dQ = rg, e1.dR = jr, e1.dS = (e1, t1, r, n, i, s, a, o, l, u)=>{
            const c = e1.transform, h = c.pitch < 15 ? Qy(.07, .7, Ee((14 - c.zoom) / 5, 0, 1)) : .07, d = "none" === r.paint.get("line-trim-color-use-theme").constantOr("default");
            return {
                u_matrix: tg(e1, t1, r, n),
                u_texsize: t1.imageAtlasTexture ? t1.imageAtlasTexture.size : [
                    0,
                    0
                ],
                u_pixels_to_tile_units: c.calculatePixelsToTileUnitsMatrix(t1),
                u_device_pixel_ratio: i,
                u_width_scale: s,
                u_floor_width_scale: a,
                u_image: 0,
                u_tile_units_to_pixels: eg(t1, c),
                u_units_to_pixels: [
                    1 / c.pixelsToGLUnits[0],
                    1 / c.pixelsToGLUnits[1]
                ],
                u_alpha_discard_threshold: 0,
                u_trim_offset: o,
                u_trim_fade_range: r.paint.get("line-trim-fade-range"),
                u_trim_gradient_mix_range: [
                    1,
                    1
                ],
                u_trim_color: r.paint.get("line-trim-color").toPremultipliedRenderColor(d ? null : r.lut).toArray01(),
                u_zbias_factor: h,
                u_tile_to_meter: Yu(t1.tileID.canonical, 0),
                u_ground_shadow_factor: l,
                u_pattern_transition: u
            };
        }, e1.dT = (e1, t1, r, n, i, s, a, o, l, u)=>{
            const c = e1.transform, h = c.calculatePixelsToTileUnitsMatrix(t1), d = "none" === r.paint.get("line-trim-color-use-theme").constantOr("default"), p = c.pitch < 15 ? Qy(.07, .7, Ee((14 - c.zoom) / 5, 0, 1)) : .07;
            return {
                u_matrix: tg(e1, t1, r, n),
                u_pixels_to_tile_units: h,
                u_device_pixel_ratio: s,
                u_width_scale: a,
                u_floor_width_scale: o,
                u_units_to_pixels: [
                    1 / c.pixelsToGLUnits[0],
                    1 / c.pixelsToGLUnits[1]
                ],
                u_dash_image: 0,
                u_gradient_image: 1,
                u_image_height: i,
                u_texsize: ng(r) && t1.lineAtlasTexture ? t1.lineAtlasTexture.size : [
                    0,
                    0
                ],
                u_tile_units_to_pixels: eg(t1, e1.transform),
                u_alpha_discard_threshold: 0,
                u_trim_offset: l,
                u_trim_fade_range: r.paint.get("line-trim-fade-range"),
                u_trim_gradient_mix_range: [
                    1,
                    1
                ],
                u_trim_color: r.paint.get("line-trim-color").toPremultipliedRenderColor(d ? null : r.lut).toArray01(),
                u_zbias_factor: p,
                u_tile_to_meter: Yu(t1.tileID.canonical, 0),
                u_ground_shadow_factor: u
            };
        }, e1.dU = Ne, e1.dV = rd, e1.dW = qu, e1.dX = oh, e1.dY = Mf, e1.dZ = Df, e1.d_ = Zu, e1.da = function(e1, t1, r, n) {
            return "custom" === e1.type ? new Ob(e1, t1) : new lw[e1.type](e1, t1, r, n);
        }, e1.db = $e, e1.dc = vo, e1.dd = function(e1) {
            const t1 = e1.indexOf(ko);
            return t1 >= 0 ? e1.slice(t1 + 1) : "";
        }, e1.de = class extends iw {
            constructor(e1, t1){
                super(e1._vectorTileFeature, e1._z, e1._x, e1._y, e1.id), e1.state && (this.state = Object.assign({}, e1.state)), this.target = t1.target, this.namespace = t1.namespace, t1.properties && (this.properties = t1.properties), this.target && ("featuresetId" in this.target && !this.target.importId || "layerId" in this.target) && (this.source = e1.source, this.sourceLayer = e1.sourceLayer, this.layer = e1.layer);
            }
            toJSON() {
                const e1 = super.toJSON();
                return e1.target = this.target, e1.namespace = this.namespace, e1;
            }
        }, e1.df = Ya, e1.dg = function(e1) {
            return e1({
                pluginStatus: Ha,
                pluginURL: Xa
            }), Ya.on("pluginStateChange", e1), e1;
        }, e1.dh = lu, e1.di = class extends tu {
            constructor(e1){
                super(e1), this.current = hu;
            }
            set(e1, t1, r) {
                if (this.fetchUniformLocation(e1, t1)) {
                    for(let e1 = 0; e1 < 9; e1++)if (r[e1] !== this.current[e1]) {
                        this.current = r, this.gl.uniformMatrix3fv(this.location, !1, r);
                        break;
                    }
                }
            }
        }, e1.dj = Ve, e1.dk = function(e1, t1, r) {
            const n = Vh(r.zoom), i = e1.style.map._antialias, s = e1.terrain && e1.terrain.exaggeration() > 0;
            return 0 === n && !i && !s;
        }, e1.dl = function(e1) {
            const t1 = e1.pixelsPerMeter, r = t1 / ju(1, e1.center.lat), n = u(new Float64Array(16));
            return d(n, n, [
                e1.point.x,
                e1.point.y,
                0
            ]), p(n, n, [
                r,
                r,
                t1
            ]), Float32Array.from(n);
        }, e1.dm = _h, e1.dn = function(e1) {
            const t1 = 80.051129;
            e1 = Ee(e1, -80.051129, t1) / t1 * 90;
            const r = Math.pow(Math.abs(Math.sin(Te(e1))), 3);
            return Math.round(r * (zu.length - 1));
        }, e1.dp = function(e1, t1, r, n) {
            const i = t1.getNorth(), s = t1.getSouth(), o = t1.getWest(), l = t1.getEast(), u = 1 << e1.z, c = l - o, h = i - s, d = c / Tu, p = -h / zu[r], f = [
                0,
                d,
                0,
                p,
                0,
                0,
                i,
                o,
                0
            ];
            if (e1.z > 0) {
                const e1 = 180 / n;
                a(f, f, [
                    e1 / c + 1,
                    0,
                    0,
                    0,
                    e1 / h + 1,
                    0,
                    -0.5 * e1 / d,
                    .5 * e1 / p,
                    1
                ]);
            }
            return f[2] = u, f[5] = e1.x, f[8] = e1.y, f;
        }, e1.dq = Sh, e1.dr = gh, e1.ds = function(e1, t1, r) {
            const n = u(new Float64Array(16)), i = (t1 / (1 << e1) - .5) * Math.PI * 2;
            return m(n, r.globeMatrix, i), Float32Array.from(n);
        }, e1.dt = hh, e1.du = Hl, e1.dv = td, e1.dw = dh, e1.dx = Xo, e1.dy = ml, e1.dz = function(e1, t1) {
            return [
                Math.pow(e1[0], 2.2) * t1,
                Math.pow(e1[1], 2.2) * t1,
                Math.pow(e1[2], 2.2) * t1
            ];
        }, e1.e = lt, e1.e$ = function(e1, t1, r = !1) {
            if (Ha === $a.deferred || Ha === $a.loading || Ha === $a.loaded) throw new Error("setRTLTextPlugin cannot be called multiple times.");
            Xa = wt.resolveURL(e1), Ha = $a.deferred, qa = t1, Wa(), r || Ka();
        }, e1.e0 = 450, e1.e1 = 7, e1.e2 = function(e1, t1) {
            if (e1 === t1) {
                var r = t1[1], n = t1[2], i = t1[3], s = t1[6], a = t1[7], o = t1[11];
                e1[1] = t1[4], e1[2] = t1[8], e1[3] = t1[12], e1[4] = r, e1[6] = t1[9], e1[7] = t1[13], e1[8] = n, e1[9] = s, e1[11] = t1[14], e1[12] = i, e1[13] = a, e1[14] = o;
            } else e1[0] = t1[0], e1[1] = t1[4], e1[2] = t1[8], e1[3] = t1[12], e1[4] = t1[1], e1[5] = t1[5], e1[6] = t1[9], e1[7] = t1[13], e1[8] = t1[2], e1[9] = t1[6], e1[10] = t1[10], e1[11] = t1[14], e1[12] = t1[3], e1[13] = t1[7], e1[14] = t1[11], e1[15] = t1[15];
            return e1;
        }, e1.e3 = Tb, e1.e4 = qo, e1.e5 = Pl, e1.e6 = 256, e1.e7 = function(e1) {
            return e1 >>>= 0, e1 = Math.imul(2747636419 ^ e1, 2654435769) >>> 0, e1 = Math.imul(e1 ^ e1 >>> 16, 2654435769) >>> 0, (e1 = Math.imul(e1 ^ e1 >>> 16, 2654435769) >>> 0) / 4294967296;
        }, e1.e8 = vh, e1.e9 = Ph, e1.eA = _l, e1.eB = wl, e1.eC = class {
            constructor(){
                this._updateTime = 0, this._sourceIds = [], this._activeRegions = [], this._prevRegions = [], this._globalClipBounds = {
                    min: new Me(1 / 0, 1 / 0),
                    max: new Me(-1 / 0, -1 / 0)
                };
            }
            clear() {
                this._activeRegions.length > 0 && ++this._updateTime, this._activeRegions = [], this._prevRegions = [];
            }
            get updateTime() {
                return this._updateTime;
            }
            getReplacementRegionsForTile(e1, t1 = !1) {
                const r = Yp(new Me(0, 0), new Me(qn, qn), e1), n = [];
                if (t1 && !Zp(r, this._globalClipBounds)) return n;
                for (const t1 of this._activeRegions){
                    if (t1.hiddenByOverlap) continue;
                    if (!Zp(r, t1)) continue;
                    const i = Jp(t1.min, t1.max, e1);
                    n.push({
                        min: i.min,
                        max: i.max,
                        sourceId: this._sourceIds[t1.priority],
                        footprint: t1.footprint,
                        footprintTileId: t1.tileId,
                        order: t1.order,
                        clipMask: t1.clipMask,
                        clipScope: t1.clipScope
                    });
                }
                return n;
            }
            setSources(e1) {
                this._setSources(e1.map((e1)=>({
                        getSourceId: ()=>e1.cache.id,
                        getFootprints: ()=>{
                            const t1 = [];
                            for (const r of e1.cache.getVisibleCoordinates()){
                                const n = e1.cache.getTile(r).buckets[e1.layer];
                                n && n.updateFootprints(r.toUnwrapped(), t1);
                            }
                            return t1;
                        },
                        getOrder: ()=>e1.order,
                        getClipMask: ()=>e1.clipMask,
                        getClipScope: ()=>e1.clipScope
                    })));
            }
            _addSource(e1) {
                const t1 = e1.getFootprints();
                if (0 === t1.length) return;
                const r = e1.getOrder(), n = e1.getClipMask(), i = e1.getClipScope();
                for (const e1 of t1){
                    if (!e1.footprint) continue;
                    const t1 = Yp(e1.footprint.min, e1.footprint.max, e1.id);
                    this._activeRegions.push({
                        min: t1.min,
                        max: t1.max,
                        hiddenByOverlap: !1,
                        priority: this._sourceIds.length,
                        tileId: e1.id,
                        footprint: e1.footprint,
                        order: r,
                        clipMask: n,
                        clipScope: i
                    });
                }
                this._sourceIds.push(e1.getSourceId());
            }
            _computeReplacement() {
                this._activeRegions.sort((e1, t1)=>e1.priority - t1.priority || Hp(e1.min, t1.min) || Hp(e1.max, t1.max) || e1.order - t1.order || e1.clipMask - t1.clipMask || function(e1, t1) {
                        const r = (e1, t1)=>e1 + t1;
                        return e1.length - t1.length || e1.reduce(r, "").localeCompare(t1.reduce(r, ""));
                    }(e1.clipScope, t1.clipScope));
                let e1 = this._activeRegions.length !== this._prevRegions.length;
                if (!e1) {
                    let t1 = 0;
                    for(; !e1 && t1 !== this._activeRegions.length;){
                        const r = this._activeRegions[t1], n = this._prevRegions[t1];
                        e1 = r.priority !== n.priority || !Xp(r, n) || r.order !== n.order || r.clipMask !== n.clipMask || !Be(r.clipScope, n.clipScope), this._activeRegions[t1].hiddenByOverlap = n.hiddenByOverlap, ++t1;
                    }
                }
                if (e1) {
                    ++this._updateTime;
                    for (const e1 of this._activeRegions)e1.order !== Gp && (this._globalClipBounds.min.x = Math.min(this._globalClipBounds.min.x, e1.min.x), this._globalClipBounds.min.y = Math.min(this._globalClipBounds.min.y, e1.min.y), this._globalClipBounds.max.x = Math.max(this._globalClipBounds.max.x, e1.max.x), this._globalClipBounds.max.y = Math.max(this._globalClipBounds.max.y, e1.max.y));
                    const e1 = (e1)=>{
                        const t1 = this._activeRegions;
                        if (e1 >= t1.length) return e1;
                        const r = t1[e1].priority;
                        for(; e1 < t1.length && t1[e1].priority === r;)++e1;
                        return e1;
                    };
                    if (this._sourceIds.length > 1) {
                        let t1 = 0, r = e1(t1);
                        for(; t1 !== r;){
                            let n = t1;
                            const i = t1;
                            for(; n !== r;){
                                const e1 = this._activeRegions[n];
                                e1.hiddenByOverlap = !1;
                                for(let t1 = 0; t1 < i; t1++){
                                    const r = this._activeRegions[t1];
                                    if (!r.hiddenByOverlap && e1.order === Gp && Zp(e1, r) && (e1.hiddenByOverlap = Qp(e1.footprint, e1.tileId, r.footprint, r.tileId), e1.hiddenByOverlap)) break;
                                }
                                ++n;
                            }
                            t1 = r, r = e1(t1);
                        }
                    }
                }
            }
            _setSources(e1) {
                [this._prevRegions, this._activeRegions] = [
                    this._activeRegions,
                    []
                ], this._sourceIds = [];
                for(let t1 = e1.length - 1; t1 >= 0; t1--)this._addSource(e1[t1]);
                this._computeReplacement();
            }
        }, e1.eD = Wo, e1.eE = Ab, e1.eF = Ml, e1.eG = Gp, e1.eH = class {
            constructor(e1){
                this._createGrid(e1), this._createPoles(e1);
            }
            destroy() {
                this._poleIndexBuffer.destroy(), this._gridBuffer.destroy(), this._gridIndexBuffer.destroy(), this._poleNorthVertexBuffer.destroy(), this._poleSouthVertexBuffer.destroy();
                for (const e1 of this._poleSegments)e1.destroy();
                for (const e1 of this._gridSegments)e1.withSkirts.destroy(), e1.withoutSkirts.destroy();
            }
            _fillGridMeshWithLods(e1, t1) {
                const r = new Xo, n = new ml, i = [], s = e1 + 1 + 2, a = t1[0] + 1, o = t1[0] + 1 + (1 + t1.length), l = (e1, t1, r)=>{
                    let n = e1 === s - 1 ? e1 - 2 : 0 === e1 ? e1 : e1 - 1;
                    return n += r ? 24575 : 0, [
                        n,
                        t1
                    ];
                };
                for(let e1 = 0; e1 < s; ++e1)r.emplaceBack(...l(e1, 0, !0));
                for(let e1 = 0; e1 < a; ++e1)for(let t1 = 0; t1 < s; ++t1)r.emplaceBack(...l(t1, e1, (0 === t1 || t1 === s - 1) && !0));
                for(let e1 = 0; e1 < t1.length; ++e1){
                    const n = t1[e1];
                    for(let e1 = 0; e1 < s; ++e1)r.emplaceBack(...l(e1, n, !0));
                }
                for(let e1 = 0; e1 < t1.length; ++e1){
                    const a = n.length, l = t1[e1] + 1 + 2, u = new ml;
                    for(let r = 0; r < l - 1; r++){
                        const i = r === l - 2, a = i ? s * (o - t1.length + e1 - r) : s;
                        for(let e1 = 0; e1 < s - 1; e1++){
                            const t1 = r * s + e1;
                            0 === r || i || 0 === e1 || e1 === s - 2 ? (u.emplaceBack(t1 + 1, t1, t1 + a), u.emplaceBack(t1 + a, t1 + a + 1, t1 + 1)) : (n.emplaceBack(t1 + 1, t1, t1 + a), n.emplaceBack(t1 + a, t1 + a + 1, t1 + 1));
                        }
                    }
                    const c = Hl.simpleSegment(0, a, r.length, n.length - a);
                    for(let e1 = 0; e1 < u.uint16.length; e1 += 3)n.emplaceBack(u.uint16[e1], u.uint16[e1 + 1], u.uint16[e1 + 2]);
                    const h = Hl.simpleSegment(0, a, r.length, n.length - a);
                    i.push({
                        withoutSkirts: c,
                        withSkirts: h
                    });
                }
                return {
                    vertices: r,
                    indices: n,
                    segments: i
                };
            }
            _createGrid(e1) {
                const t1 = this._fillGridMeshWithLods(Tu, zu);
                this._gridSegments = t1.segments, this._gridBuffer = e1.createVertexBuffer(t1.vertices, hh.members), this._gridIndexBuffer = e1.createIndexBuffer(t1.indices, !0);
            }
            _createPoles(e1) {
                const t1 = new ml;
                for(let e1 = 0; e1 <= Tu; e1++)t1.emplaceBack(0, e1 + 1, e1 + 2);
                this._poleIndexBuffer = e1.createIndexBuffer(t1, !0);
                const r = new vl, n = new vl, i = new vl, s = new vl;
                this._poleSegments = [];
                for(let e1 = 0, t1 = 0; e1 < 6; e1++){
                    const a = 360 / (1 << e1);
                    r.emplaceBack(0, -Pu, 0, .5, 0), n.emplaceBack(0, -Pu, 0, .5, 1), i.emplaceBack(0, -Pu, 0, .5, .5), s.emplaceBack(0, -Pu, 0, .5, .5);
                    for(let e1 = 0; e1 <= Tu; e1++){
                        let t1 = e1 / Tu, o = 0;
                        const l = yr(0, a, t1), [u, c, h] = Fu(Ch, Rh, l, Pu);
                        r.emplaceBack(u, c, h, t1, o), n.emplaceBack(u, c, h, t1, 1 - o);
                        const d = Te(l);
                        t1 = .5 + .5 * Math.sin(d), o = .5 + .5 * Math.cos(d), i.emplaceBack(u, c, h, t1, o), s.emplaceBack(u, c, h, t1, 1 - o);
                    }
                    this._poleSegments.push(Hl.simpleSegment(t1, 0, 66, 64)), t1 += 66;
                }
                this._poleNorthVertexBuffer = e1.createVertexBuffer(r, uh, !1), this._poleSouthVertexBuffer = e1.createVertexBuffer(n, uh, !1), this._texturedPoleNorthVertexBuffer = e1.createVertexBuffer(i, uh, !1), this._texturedPoleSouthVertexBuffer = e1.createVertexBuffer(s, uh, !1);
            }
            getGridBuffers(e1, t1) {
                return [
                    this._gridBuffer,
                    this._gridIndexBuffer,
                    t1 ? this._gridSegments[e1].withSkirts : this._gridSegments[e1].withoutSkirts
                ];
            }
            getPoleBuffers(e1, t1) {
                return [
                    t1 ? this._texturedPoleNorthVertexBuffer : this._poleNorthVertexBuffer,
                    t1 ? this._texturedPoleSouthVertexBuffer : this._poleSouthVertexBuffer,
                    this._poleIndexBuffer,
                    this._poleSegments[e1]
                ];
            }
        }, e1.eI = $p, e1.eJ = Fe, e1.eK = function() {
            return !!document.fullscreenElement || !!document.webkitFullscreenElement;
        }, e1.eL = De, e1.eM = Wu, e1.eN = function(e1, t1, r) {
            return e1[0] = t1[0] / r[0], e1[1] = t1[1] / r[1], e1[2] = t1[2] / r[2], e1;
        }, e1.eO = Z, e1.eP = Du, e1.eQ = C, e1.eR = B, e1.eS = function([e1, t1, r]) {
            const n = Math.hypot(e1, t1, r), i = Math.atan2(e1, r), s = .5 * Math.PI - Math.acos(-t1 / n);
            return new Ru(ze(i), ze(s));
        }, e1.eT = K, e1.eU = Gm, e1.eV = function(e1) {
            const t1 = e1.navigator ? e1.navigator.userAgent : null;
            return !!function(e1) {
                if (null == tt) {
                    const t1 = e1.navigator ? e1.navigator.userAgent : null;
                    tt = !!e1.safari || !(!t1 || !(/\b(iPad|iPhone|iPod)\b/.test(t1) || t1.match("Safari") && !t1.match("Chrome")));
                }
                return tt;
            }(e1) && !(!t1 || !(t1.match("Version/15.4") || t1.match("Version/15.5") || t1.match(/CPU (OS|iPhone OS) (15_4|15_5) like Mac OS X/)));
        }, e1.eW = function(e1, t1) {
            Mt = e1, Bt = t1;
        }, e1.eX = Dh, e1.eY = Fh, e1.eZ = function(e1) {
            const t1 = [
                0,
                0,
                0
            ], r = u(new Float64Array(16));
            return h(r, e1.pixelMatrix, e1.globeMatrix), j(t1, t1, r), new Me(t1[0], t1[1]);
        }, e1.e_ = Ja, e1.ea = rl, e1.eb = m, e1.ec = function(e1, t1) {
            return e1[0] = t1[0], e1[1] = t1[1], e1[2] = t1[2], e1[3] = t1[4], e1[4] = t1[5], e1[5] = t1[6], e1[6] = t1[8], e1[7] = t1[9], e1[8] = t1[10], e1;
        }, e1.ed = vl, e1.ee = bl, e1.ef = function(e1, t1, r, n, i) {
            return Ee((e1 - t1) / (r - t1) * (i - n) + n, n, i);
        }, e1.eg = ie, e1.eh = function(e1, t1) {
            var r = t1[0], n = t1[1], i = t1[2], s = t1[3], a = t1[4], o = t1[5], l = t1[6], u = t1[7], c = t1[8], h = c * a - o * u, d = -c * s + o * l, p = u * s - a * l, f = r * h + n * d + i * p;
            return f ? (e1[0] = h * (f = 1 / f), e1[1] = (-c * n + i * u) * f, e1[2] = (o * n - i * a) * f, e1[3] = d * f, e1[4] = (c * r - i * l) * f, e1[5] = (-o * r + i * s) * f, e1[6] = p * f, e1[7] = (-u * r + n * l) * f, e1[8] = (a * r - n * s) * f, e1) : null;
        }, e1.ei = vs, e1.ej = 2, e1.ek = R, e1.el = te, e1.em = v, e1.en = function(e1, t1) {
            var n = new r(3);
            v(n, t1);
            var i = 1 / n[0], s = 1 / n[1], a = 1 / n[2], o = t1[0] * i, l = t1[1] * s, u = t1[2] * a, c = t1[4] * i, h = t1[5] * s, d = t1[6] * a, p = t1[8] * i, f = t1[9] * s, m = t1[10] * a, y = o + h + m, g = 0;
            return y > 0 ? (g = 2 * Math.sqrt(y + 1), e1[3] = .25 * g, e1[0] = (d - f) / g, e1[1] = (p - u) / g, e1[2] = (l - c) / g) : o > h && o > m ? (g = 2 * Math.sqrt(1 + o - h - m), e1[3] = (d - f) / g, e1[0] = .25 * g, e1[1] = (l + c) / g, e1[2] = (p + u) / g) : h > m ? (g = 2 * Math.sqrt(1 + h - o - m), e1[3] = (p - u) / g, e1[0] = (l + c) / g, e1[1] = .25 * g, e1[2] = (d + f) / g) : (g = 2 * Math.sqrt(1 + m - o - h), e1[3] = (l - c) / g, e1[0] = (p + u) / g, e1[1] = (d + f) / g, e1[2] = .25 * g), e1;
        }, e1.eo = function(e1, r) {
            var n = 2 * Math.acos(r[3]), i = Math.sin(n / 2);
            return i > t1 ? (e1[0] = r[0] / i, e1[1] = r[1] / i, e1[2] = r[2] / i) : (e1[0] = 1, e1[1] = 0, e1[2] = 0), n;
        }, e1.ep = aw, e1.eq = Jm, e1.er = Xm, e1.es = [
            1,
            1,
            1
        ], e1.et = Hb, e1.eu = function(e1, t1, r, n) {
            var i = t1[0], s = t1[1], a = t1[2], o = t1[3];
            return e1[0] = i + n * (r[0] - i), e1[1] = s + n * (r[1] - s), e1[2] = a + n * (r[2] - a), e1[3] = o + n * (r[3] - o), e1;
        }, e1.ev = Ym, e1.ew = cl, e1.ex = Al, e1.ey = function(e1, t1, n, i, s, a, o, l, u, c, h, d, p, f, m, y) {
            var g = new r(16);
            return g[0] = e1, g[1] = t1, g[2] = n, g[3] = i, g[4] = s, g[5] = a, g[6] = o, g[7] = l, g[8] = u, g[9] = c, g[10] = h, g[11] = d, g[12] = p, g[13] = f, g[14] = m, g[15] = y, g;
        }, e1.ez = Eu, e1.f = function(e1) {
            return btoa(encodeURIComponent(e1).replace(/%([0-9A-F]{2})/g, (e1, t1)=>String.fromCharCode(Number("0x" + t1))));
        }, e1.f0 = ht, e1.f1 = ct, e1.f2 = ut, e1.f3 = function(e1) {
            const t1 = Tt();
            if (!t1) return;
            const r = t1.delete(It);
            e1 && r.then(()=>e1()).catch(e1);
        }, e1.f4 = ra, e1.f5 = Qh, e1.f6 = 2, e1.f7 = ri, e1.f8 = zv, e1.f9 = kl, e1.fA = Qa, e1.fB = $a, e1.fC = function(e1) {
            zt(), null != Pt && Pt.then((t1)=>{
                t1.keys().then((r)=>{
                    for(let n = 0; n < r.length - e1; n++)t1.delete(r[n]).catch((e1)=>Ze(e1.message));
                }).catch((e1)=>Ze(e1.message));
            }).catch((e1)=>Ze(e1.message));
        }, e1.fa = cw, e1.fb = hw, e1.fc = $y, e1.fd = fc, e1.fe = "hd_road_elevation", e1.ff = Vc, e1.fg = Ge, e1.fh = Sp, e1.fi = Ld, e1.fj = Vx, e1.fk = 1, e1.fl = hb, e1.fm = function(e1, t1, r, n, i, s, a, o = 1, l, u, c, h) {
            e1.createArrays(), e1.tilePixelRatio = qn / (512 * e1.overscaling), e1.compareText = {}, e1.iconsNeedLinear = !1;
            const d = e1.layers[0].layout, p = e1.layers[0]._unevaluatedLayout._values, f = {};
            f.scaleFactor = o, f.textSizeScaleRange = d.get("text-size-scale-range"), f.iconSizeScaleRange = d.get("icon-size-scale-range");
            const [m, y] = f.textSizeScaleRange, [g, x] = f.iconSizeScaleRange;
            f.textScaleFactor = Ee(f.scaleFactor, m, y), f.iconScaleFactor = Ee(f.scaleFactor, g, x);
            const v = p["text-size"], b = p["icon-size"];
            if ("composite" === e1.textSizeData.kind) {
                const { minZoom: t1, maxZoom: r } = e1.textSizeData;
                f.compositeTextSizes = [
                    v.possiblyEvaluate(new to(t1, {
                        worldview: c
                    }), s),
                    v.possiblyEvaluate(new to(r, {
                        worldview: c
                    }), s)
                ];
            }
            if ("composite" === e1.iconSizeData.kind) {
                const { minZoom: t1, maxZoom: r } = e1.iconSizeData;
                f.compositeIconSizes = [
                    b.possiblyEvaluate(new to(t1, {
                        worldview: c
                    }), s, h),
                    b.possiblyEvaluate(new to(r, {
                        worldview: c
                    }), s, h)
                ];
            }
            f.layoutTextSize = v.possiblyEvaluate(new to(a + 1, {
                worldview: c
            }), s), f.layoutIconSize = b.possiblyEvaluate(new to(a + 1, {
                worldview: c
            }), s, h), f.textMaxSize = v.possiblyEvaluate(new to(18, {
                worldview: c
            }), s);
            const w = d.get("symbol-placement"), _ = "map" === d.get("text-rotation-alignment") && "point" !== w, A = d.get("text-size");
            let I = !1;
            const M = [];
            for (const a of e1.features){
                const o = d.get("text-font").evaluate(a, {}, s).join(","), m = A.evaluate(a, {}, s) * f.textScaleFactor, y = f.layoutTextSize.evaluate(a, {}, s) * f.textScaleFactor, g = f.layoutIconSize.evaluate(a, {}, s, h) * f.iconScaleFactor, x = {
                    horizontal: {},
                    vertical: void 0
                }, v = a.text;
                let b, B = [
                    0,
                    0
                ];
                if (v) {
                    const n = v.toString(), u = d.get("text-letter-spacing").evaluate(a, {}, s) * Mg, c = d.get("text-line-height").evaluate(a, {}, s) * Mg, h = Da(n) ? u : 0, p = d.get("text-anchor").evaluate(a, {}, s), g = d.get("text-variable-anchor");
                    if (!g) {
                        const e1 = d.get("text-radial-offset").evaluate(a, {}, s);
                        if (e1) B = iv(p, [
                            e1 * Mg,
                            tv
                        ]);
                        else {
                            const e1 = d.get("text-offset").evaluate(a, {}, s);
                            B = [
                                e1[0] * Mg,
                                e1[1] * Mg
                            ];
                        }
                    }
                    let b = _ ? "center" : d.get("text-justify").evaluate(a, {}, s);
                    const A = "point" === w, I = A ? d.get("text-max-width").evaluate(a, {}, s) * Mg : 1 / 0, M = (s)=>{
                        e1.allowVerticalPlacement && Fa(n) && (x.vertical = Jg(v, t1, r, i, o, I, c, p, s, h, B, Zg.vertical, !0, y, m, l, f.textScaleFactor));
                    };
                    if (!_ && g) {
                        const e1 = "auto" === b ? g.map((e1)=>gv(e1)) : [
                            b
                        ];
                        let n = !1;
                        for(let s = 0; s < e1.length; s++){
                            const a = e1[s];
                            if (!x.horizontal[a]) {
                                if (n) x.horizontal[a] = x.horizontal[0];
                                else {
                                    const e1 = Jg(v, t1, r, i, o, I, c, "center", a, h, B, Zg.horizontal, !1, y, m, l, f.textScaleFactor);
                                    e1 && (x.horizontal[a] = e1, n = 1 === e1.positionedLines.length);
                                }
                            }
                        }
                        M("left");
                    } else {
                        if ("auto" === b && (b = gv(p)), A || d.get("text-writing-mode").indexOf("horizontal") >= 0 || !Fa(n)) {
                            const e1 = Jg(v, t1, r, i, o, I, c, p, b, h, B, Zg.horizontal, !1, y, m, l, f.textScaleFactor);
                            e1 && (x.horizontal[b] = e1);
                        }
                        M(A ? "left" : b);
                    }
                }
                let S, P, T, z, k, V, F = !1;
                const D = d.get("icon-text-fit").evaluate(a, {}, s);
                if (a.icon && a.icon.hasPrimary()) {
                    const t1 = dv(a.icon, e1.iconSizeData, p["icon-size"], s, e1.zoom, a, l, f.iconScaleFactor, c, h);
                    S = t1.iconPrimary, T = t1.iconSecondary;
                    const r = S.toString();
                    if (P = n.get(r), P && (k = d.get("icon-offset").evaluate(a, {}, s), V = d.get("icon-anchor").evaluate(a, {}, s), b = lx(i.get(r), T ? i.get(T.toString()) : void 0, k, V), F = P.sdf, void 0 === e1.sdfIcons ? e1.sdfIcons = P.sdf : e1.sdfIcons !== P.sdf && Ze("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (P.pixelRatio !== e1.pixelRatio || 0 !== d.get("icon-rotate").constantOr(1)) && (e1.iconsNeedLinear = !0)), T) {
                        const e1 = T.toString();
                        z = n.get(e1);
                    }
                }
                I = I || !(!a.icon || !a.icon.hasSecondary());
                const E = Mv(x.horizontal) || x.vertical;
                e1.iconsInText || (e1.iconsInText = !!E && E.iconsInText);
                const C = y * f.textScaleFactor / Mg, { defaultShapedIcon: R, verticallyShapedIcon: L } = xv(e1, b, d, a, s, x, C, k, D);
                "none" !== D && b && (cx(b) || hx(b)) && (cv(0, P, S, b, R, D, u, n, i), cv(0, z, T, b, R, D, u, n, i), L && (cv(0, P, S, b, L, D, u, n, i), cv(0, z, T, b, L, D, u, n, i))), b = R;
                const { iconBBox: O, iconVerticalBBox: U, textBBox: N, textVerticalBBox: j } = sv(e1, b, L, d, a, s, g, k, f, i, V, x, y, B, h);
                M.push({
                    feature: a,
                    shapedTextOrientations: x,
                    shapedText: E,
                    shapedIcon: b,
                    iconPrimary: S,
                    iconSecondary: T,
                    iconOffset: k,
                    iconAnchor: V,
                    verticallyShapedIcon: L,
                    layoutTextSize: y,
                    layoutIconSize: g,
                    textOffset: B,
                    isSDFIcon: F,
                    iconTextFit: D,
                    iconCollisionBounds: O,
                    iconVerticalCollisionBounds: U,
                    textCollisionBounds: N,
                    textVerticalCollisionBounds: j
                });
            }
            return {
                featureData: M,
                sizes: f,
                hasAnySecondaryIcon: I,
                textAlongLine: _,
                symbolPlacement: w
            };
        }, e1.fn = Fx, e1.fo = zx, e1.fp = Dx, e1.fq = Ex, e1.fr = function(e1, t1, r, n, i, s, a, o, l, u) {
            e1.iconAtlasPositions = u.iconPositions;
            const { featureData: c, hasAnySecondaryIcon: h, sizes: d, textAlongLine: p, symbolPlacement: f } = t1;
            for (const t1 of c){
                const { shapedIcon: r, verticallyShapedIcon: s, feature: c, shapedTextOrientations: m, shapedText: y, layoutTextSize: g, textOffset: x, isSDFIcon: v, iconPrimary: b, iconSecondary: w, iconTextFit: _, iconOffset: A, iconCollisionBounds: I, iconVerticalCollisionBounds: M, textCollisionBounds: B } = t1;
                fv(r, u.iconPositions, b, w), fv(s, u.iconPositions, b, w), mv(m, u.iconPositions), pv(b, w, u.iconPositions), (y || r) && bv(e1, c, m, r, s, l, d, g, 0, x, v, n, i, a, o, h, _, A, p, f, I, M, B);
            }
            r && e1.generateCollisionDebugBuffers(s, e1.collisionBoxArray, d.textScaleFactor);
        }, e1.fs = Zy, e1.ft = dc, e1.fu = S_, e1.fv = oc, e1.fw = function(e1) {
            let t1 = 0;
            if (new Uint32Array(e1, 0, 1)[0] !== bm) {
                const r = new Uint32Array(e1, 0, 7), [, , n, i, s, a] = r;
                t1 = r.byteLength + i + s + a + s, (n !== e1.byteLength || t1 >= e1.byteLength) && Ze("Invalid b3dm header information.");
            }
            return Bm(e1, t1);
        }, e1.fx = function(e1, t1) {
            const r = dy(e1);
            for (const e1 of r){
                for (const t1 of e1.meshes)py(t1);
                e1.lights && (e1.lightMeshIndex = e1.meshes.length, e1.meshes.push(my(e1.lights, t1)));
            }
            return r;
        }, e1.fy = Qb, e1.fz = Ke, e1.g = function(e1, t1) {
            return Gt(Object.assign(e1, {
                method: "GET"
            }), t1);
        }, e1.h = function(e1) {
            return 0 === e1.indexOf("mapbox:");
        }, e1.i = function(e1) {
            return lt.API_STYLE_REGEX.test(e1) && !pt(e1);
        }, e1.j = dt, e1.k = Vt, e1.l = function(e1) {
            return decodeURIComponent(atob(e1).split("").map((e1)=>"%" + ("00" + e1.charCodeAt(0).toString(16)).slice(-2)).join(""));
        }, e1.m = function(e1, t1) {
            return Gt(Object.assign(e1, {
                type: "json"
            }), t1);
        }, e1.n = Zt, e1.o = wt, e1.p = function(e1, t1) {
            return Gt(Object.assign(e1, {
                method: "POST"
            }), t1);
        }, e1.q = ed, e1.r = Ue, e1.s = function(e1) {
            try {
                const t1 = self[e1];
                return t1.setItem("_mapbox_test_", 1), t1.removeItem("_mapbox_test_"), !0;
            } catch (e1) {
                return !1;
            }
        }, e1.t = Le, e1.u = function() {
            return function e1(t1) {
                return t1 ? (t1 ^ Math.random() * (16 >> t1 / 4)).toString(16) : ([
                    1e7
                ] + -[
                    1e3
                ] + -4000 + -8000 + -100000000000).replace(/[018]/g, e1);
            }();
        }, e1.v = function(e1) {
            return !!e1 && /^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(e1);
        }, e1.w = Ze, e1.x = class {
            constructor(e1){
                this.cache = new Map, this.textures = new Map, this.textureAccessTimes = new Map, this.textureMemoryUsed = 0, this.maxTextureMemory = 1024 * (e1 && e1.maxTextureMemoryMB ? e1.maxTextureMemoryMB : 256) * 1024, this.finalizationRegistry = new FinalizationRegistry((e1)=>{
                    this.cache.delete(e1), this.clearExpiredTextures();
                });
            }
            calculateTextureMemory(e1) {
                return e1.image ? Math.ceil(e1.image.width * e1.image.height * 4 * (e1.patternPositions.size > 0 ? 1.33 : 1)) : 0;
            }
            evictTexture(e1) {
                const t1 = this.textures.get(e1);
                if (t1) {
                    const r = this.calculateTextureMemory(e1);
                    t1.destroy(), this.textures.delete(e1), this.textureAccessTimes.delete(e1), this.textureMemoryUsed -= r;
                }
            }
            evictTexturesIfNeeded(e1) {
                for(; this.textureMemoryUsed + e1 > this.maxTextureMemory && this.textures.size > 0;){
                    let e1 = null, t1 = 1 / 0;
                    for (const [r] of this.textures.entries()){
                        const n = this.textureAccessTimes.get(r) || 0;
                        n < t1 && (t1 = n, e1 = r);
                    }
                    if (!e1) break;
                    this.evictTexture(e1);
                }
            }
            findCachedAtlas(e1) {
                const t1 = this.cache.get(e1.hash);
                if (t1) {
                    const r = t1.deref();
                    if (r && r.contentDescriptor && this.isMipmapCompatible(e1, r.contentDescriptor)) return r;
                }
                for (const [, t1] of this.cache.entries()){
                    const r = t1.deref();
                    if (r && r.contentDescriptor) {
                        const t1 = e1.subsetOf(r.contentDescriptor), n = this.isMipmapCompatible(e1, r.contentDescriptor);
                        if (t1 && n) return r;
                    }
                }
            }
            getTextureForAtlas(e1, t1, r) {
                this.textureAccessTimes.set(e1, performance.now());
                let n = this.textures.get(e1);
                if (n) return n;
                if (e1.image) {
                    const i = this.calculateTextureMemory(e1);
                    return this.evictTexturesIfNeeded(i), n = new zm(t1, e1.image, r, {
                        useMipmap: !!e1.patternPositions.size
                    }), this.textures.set(e1, n), this.textureMemoryUsed += i, n;
                }
                return null;
            }
            clearExpiredTextures() {
                for (const [e1] of this.textures.entries())if (!this.isAtlasCached(e1)) {
                    const t1 = this.textures.get(e1);
                    if (t1) {
                        const r = this.calculateTextureMemory(e1);
                        t1.destroy(), this.textureMemoryUsed -= r;
                    }
                    this.textures.delete(e1), this.textureAccessTimes.delete(e1);
                }
            }
            isAtlasCached(e1) {
                if (!e1.contentDescriptor) return !1;
                const t1 = this.cache.get(e1.contentDescriptor.hash);
                return !!t1 && t1.deref() === e1;
            }
            getOrCache(e1) {
                if (!("image" in e1)) {
                    const t1 = this.cache.get(e1.sourceAtlasHash);
                    if (t1) {
                        const e1 = t1.deref();
                        if (e1) return e1;
                    }
                    return Ze("ImageAtlasReference points to GC'd atlas - atlas may have been evicted"), null;
                }
                if (!e1.contentDescriptor) return e1;
                const t1 = e1.contentDescriptor, r = t1.hash, n = this.cache.get(r);
                if (n) {
                    const e1 = n.deref();
                    if (e1 && e1.contentDescriptor && this.isMipmapCompatible(t1, e1.contentDescriptor)) return e1;
                }
                return this.cache.set(r, new WeakRef(e1)), this.finalizationRegistry.register(e1, r, e1), e1;
            }
            isMipmapCompatible(e1, t1) {
                return !e1.requiresMipMaps || t1.requiresMipMaps;
            }
            destroyTextures() {
                for (const e1 of this.textures.values())e1 && e1.destroy();
                this.textures.clear(), this.textureAccessTimes.clear(), this.textureMemoryUsed = 0;
            }
            clear() {
                for (const e1 of this.textures.values())e1 && e1.destroy();
                this.cache.clear(), this.textures.clear(), this.textureAccessTimes.clear(), this.textureMemoryUsed = 0;
            }
        }, e1.y = bt, e1.z = m_;
    });
    define([
        "require",
        "./shared"
    ], function(e1, t1) {
        function s(e1) {
            const t1 = e1 ? e1.url.toString() : void 0;
            return t1 ? performance.getEntriesByName(t1) : [];
        }
        function i(e1) {
            if ("number" == typeof e1 || "boolean" == typeof e1 || "string" == typeof e1 || null == e1) return JSON.stringify(e1);
            if (Array.isArray(e1)) {
                let t1 = "[";
                for (const s of e1)t1 += `${i(s)},`;
                return `${t1}]`;
            }
            let t1 = "{";
            for (const s of Object.keys(e1).sort())t1 += `${s}:${i(e1[s])},`;
            return `${t1}}`;
        }
        function o(e1) {
            let s = "";
            for (const o of t1.b6)s += `/${i(e1[o])}`;
            return s;
        }
        function n(e1, t1) {
            return function e1(s) {
                return "string" == typeof s && s === t1 || (Array.isArray(s) ? s.some(e1) : !(!s || "object" != typeof s) && Object.values(s).some(e1));
            }(e1);
        }
        class r {
            constructor(e1){
                this.keyCache = Object.create(null), this._layers = Object.create(null), this._layerConfigs = Object.create(null), e1 && this.replace(e1);
            }
            replace(e1, t1) {
                this._layerConfigs = Object.create(null), this._layers = Object.create(null), this.update(e1, [], t1);
            }
            update(e1, s, r) {
                this._options = r;
                for (const s of e1)this._layerConfigs[s.id] = s, (this._layers[s.id] = t1.da(s, this.scope, null, this._options)).compileFilter(r), this.keyCache[s.id] && delete this.keyCache[s.id];
                for (const e1 of s)delete this.keyCache[e1], delete this._layerConfigs[e1], delete this._layers[e1];
                this.familiesBySource = Object.create(null);
                const a = function(e1, t1) {
                    const s = Object.create(null);
                    for(let r = 0; r < e1.length; r++){
                        const a = e1[r];
                        let l = t1 && t1[a.id];
                        l || ("symbol" === a.type ? l = a.id : (l = o(a), "line" === a.type && a.paint && n(a.paint["line-width"], "line-progress") && (l += `/${i(a.paint["line-width"])}`))), t1 && (t1[a.id] = l);
                        let c = s[l];
                        c || (c = s[l] = []), c.push(a);
                    }
                    const r = [];
                    for(const e1 in s)r.push(s[e1]);
                    return r;
                }(Object.values(this._layerConfigs), this.keyCache);
                for (const e1 of a){
                    const t1 = e1.map((e1)=>this._layers[e1.id]), s = t1[0];
                    if ("none" === s.visibility) continue;
                    const i = s.source || "";
                    let o = this.familiesBySource[i];
                    o || (o = this.familiesBySource[i] = Object.create(null));
                    const n = s.sourceLayer || "_geojsonTileLayer";
                    let r = o[n];
                    r || (r = o[n] = []), r.push(t1);
                }
            }
        }
        const a = 1 * t1.f6;
        class l {
            constructor(e1){
                const s = {}, i = [];
                for(const t1 in e1){
                    const o = e1[t1], n = s[t1] = {};
                    for(const e1 in o.glyphs){
                        const t1 = o.glyphs[+e1];
                        if (!t1 || 0 === t1.bitmap.width || 0 === t1.bitmap.height) continue;
                        const s = t1.metrics.localGlyph ? a : 1, r = {
                            x: 0,
                            y: 0,
                            w: t1.bitmap.width + 2 * s,
                            h: t1.bitmap.height + 2 * s
                        };
                        i.push(r), n[e1] = r;
                    }
                }
                const { w: o, h: n } = t1.J(i), r = new t1.f5({
                    width: o || 1,
                    height: n || 1
                });
                for(const i in e1){
                    const o = e1[i];
                    for(const e1 in o.glyphs){
                        const n = o.glyphs[+e1];
                        if (!n || 0 === n.bitmap.width || 0 === n.bitmap.height) continue;
                        const l = s[i][e1], c = n.metrics.localGlyph ? a : 1;
                        t1.f5.copy(n.bitmap, r, {
                            x: 0,
                            y: 0
                        }, {
                            x: l.x + c,
                            y: l.y + c
                        }, n.bitmap);
                    }
                }
                this.image = r, this.positions = s;
            }
        }
        function c(e1, t1, s) {
            e1[t1] ? s && (e1[t1].center = s) : e1[t1] = {
                floorIds: new Set,
                center: s || [
                    0,
                    0
                ],
                floors: {}
            };
        }
        function h(e1, t1, s, i) {
            for (const o of t1)c(e1, o), e1[o].floors[s] = i, e1[o].floorIds.add(s);
        }
        function u(e1) {
            return {
                id: e1.properties.id.toString(),
                center: [
                    e1.properties.center_lon || 0,
                    e1.properties.center_lat || 0
                ]
            };
        }
        function d(e1, s) {
            const i = e1.properties.id.toString(), o = !!e1.properties.is_default && e1.properties.is_default, n = e1.properties.connected_floor_ids ? new Set(e1.properties.connected_floor_ids.toString().split(";")) : new Set, r = e1.properties.conflicted_floor_ids ? new Set(e1.properties.conflicted_floor_ids.toString().split(";")) : new Set, a = e1.properties.structure_ids ? new Set(e1.properties.structure_ids.toString().split(";")) : new Set, l = e1.properties.name.toString(), c = e1.properties.z_index, h = function(e1, s) {
                const i = e1.loadGeometry();
                if (!i || 0 === i.length) return;
                const o = i.map((i)=>i.map((i)=>t1.f7(i, s, e1.extent)));
                return 0 === o.length ? void 0 : {
                    type: "Polygon",
                    coordinates: [
                        o[0]
                    ]
                };
            }(e1, s);
            return {
                id: i,
                isDefault: o,
                connections: n,
                conflicts: r,
                buildings: a,
                name: l,
                zIndex: c,
                geometry: h
            };
        }
        function f(e1, t1) {
            return t1.every((t1)=>e1.properties && null != e1.properties[t1]);
        }
        function p(e1) {
            return f(e1, [
                "type",
                "id",
                "name"
            ]) && "structure" === e1.properties.type;
        }
        function g(e1) {
            return f(e1, [
                "type",
                "id",
                "name",
                "z_index"
            ]) && "floor" === e1.properties.type;
        }
        t1.f4(l, "GlyphAtlas");
        class m {
            constructor(e1){
                this.tileID = new t1.aS(e1.tileID.overscaledZ, e1.tileID.wrap, e1.tileID.canonical.z, e1.tileID.canonical.x, e1.tileID.canonical.y), this.tileZoom = e1.tileZoom, this.uid = e1.uid, this.zoom = e1.zoom, this.lut = e1.lut, this.canonical = e1.tileID.canonical, this.pixelRatio = e1.pixelRatio, this.tileSize = e1.tileSize, this.source = e1.source, this.scope = e1.scope, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = e1.showCollisionBoxes, this.collectResourceTiming = !!e1.request && e1.request.collectResourceTiming, this.promoteId = e1.promoteId, this.renderSourceType = e1.renderSourceType, this.tileTransform = t1.f8(e1.tileID.canonical, e1.projection), this.projection = e1.projection, this.worldview = e1.worldview, this.localizableLayerIds = e1.localizableLayerIds, this.brightness = e1.brightness, this.extraShadowCaster = !!e1.extraShadowCaster, this.tessellationStep = e1.tessellationStep, this.scaleFactor = e1.scaleFactor, this.worldview = e1.worldview, this.indoor = e1.indoor;
            }
            parse(e1, s, i, o, n, r) {
                this.status = "parsing", this.data = e1, this.collisionBoxArray = new t1.f9;
                const a = new t1.fa(Object.keys(e1.layers).sort()), f = new t1.fb(this.tileID, this.promoteId);
                f.bucketLayerIDs = [];
                const m = {}, w = new t1.fc(256, 256), b = {
                    featureIndex: f,
                    iconDependencies: new Map,
                    patternDependencies: new Map,
                    glyphDependencies: {},
                    lineAtlas: w,
                    availableImages: i,
                    brightness: this.brightness,
                    scaleFactor: this.scaleFactor,
                    elevationFeatures: void 0,
                    activeFloors: void 0
                };
                this.indoor && (b.activeFloors = function(e1, s, i, o) {
                    const n = s.indoorState.activeFloorsVisible;
                    if (!s.sourceLayers) return n ? s.indoorState.activeFloors : void 0;
                    const r = function(e1, s) {
                        if (!e1) return t1.w("No source layers defined in indoor specification"), s;
                        if (0 === e1.size) return s;
                        const i = e1.difference(s);
                        for (const e1 of i)t1.w(`Missing source layer required in indoor specification: ${e1}`);
                        return s.intersection(s);
                    }(s.sourceLayers, new Set(Object.keys(e1.layers))), a = s.indoorState, l = function(e1, s, i, o, n) {
                        const r = {};
                        for (const i of s){
                            const s = e1.layers[i];
                            if (s) for(let e1 = 0; e1 < s.length; e1++){
                                const t1 = s.feature(e1);
                                if (p(t1)) {
                                    const { id: e1, center: s } = u(t1);
                                    c(r, e1, s);
                                    continue;
                                }
                                if (g(t1)) {
                                    const e1 = d(t1, n);
                                    h(r, e1.buildings, e1.id, e1);
                                }
                            }
                            else t1.w(`indoor source layer not found: ${i}`);
                        }
                        return {
                            buildings: r,
                            activeFloors: t1.cZ.calculate(r, o, i)
                        };
                    }(e1, r, a.activeFloors, a.selectedFloorId, o);
                    return i.send("setIndoorData", l), n ? l.activeFloors : void 0;
                }(e1, this.indoor, n, this.canonical));
                const x = [], v = s.familiesBySource[this.source];
                for(const s in v){
                    const n = e1.layers[s];
                    if (!n) continue;
                    let r = !1, l = !1, c = !1, h = !1;
                    for (const e1 of v[s])"symbol" === e1[0].type ? r = !0 : "fill-extrusion" === e1[0].type ? l = !0 : c = !0, e1[0].is3D() && "model" !== e1[0].type && (h = !0);
                    if (this.extraShadowCaster && !h) continue;
                    if (this.renderSourceType === t1.b5.Symbol && !r) continue;
                    if (this.renderSourceType === t1.b5.FillExtrusion && !l) continue;
                    if (this.renderSourceType === t1.b5.Other && !c) continue;
                    1 === n.version && t1.w(`Vector tile source "${this.source}" layer "${s}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                    const u = a.encode(s), d = [], p = this.localizableLayerIds && this.localizableLayerIds.has(s);
                    let g = !1;
                    for(let e1 = 0, i = 0; e1 < n.length; e1++){
                        const o = n.feature(e1), r = f.getId(o, s), a = o.properties ? o.properties.worldview : null;
                        if (p && this.worldview && "string" == typeof a) {
                            if ("all" === a) o.properties.$localized = !0;
                            else {
                                if (!a.split(",").includes(this.worldview)) continue;
                                o.properties.$localized = !0, o.properties.worldview = this.worldview;
                            }
                        }
                        !g && o.properties && o.properties.hasOwnProperty(t1.fd) && (g = !0), d.push({
                            feature: o,
                            id: r,
                            index: i,
                            sourceLayerIndex: u
                        }), i++;
                    }
                    g && !b.elevationFeatures && e1.layers.hasOwnProperty(t1.fe) && (b.elevationFeatures = t1.ff.parseFrom(e1.layers[t1.fe], this.canonical));
                    for (const e1 of v[s]){
                        const s = e1[0];
                        if (this.extraShadowCaster && (!s.is3D() || "model" === s.type)) continue;
                        if (this.renderSourceType === t1.b5.Symbol && "symbol" !== s.type) continue;
                        if (this.renderSourceType === t1.b5.FillExtrusion && "fill-extrusion" !== s.type) continue;
                        if (this.renderSourceType === t1.b5.Other && ("symbol" === s.type || "fill-extrusion" === s.type)) continue;
                        if (s.minzoom && this.zoom < Math.floor(s.minzoom)) continue;
                        if (s.maxzoom && this.zoom >= s.maxzoom) continue;
                        if ("none" === s.visibility) continue;
                        y(e1, this.zoom, b.brightness, i, this.worldview, b.activeFloors);
                        const n = m[s.id] = s.createBucket({
                            index: f.bucketLayerIDs.length,
                            layers: e1,
                            zoom: this.zoom,
                            lut: this.lut,
                            canonical: this.canonical,
                            pixelRatio: this.pixelRatio,
                            overscaling: this.overscaling,
                            collisionBoxArray: this.collisionBoxArray,
                            sourceLayerIndex: u,
                            sourceID: this.source,
                            projection: this.projection.spec,
                            tessellationStep: this.tessellationStep,
                            styleDefinedModelURLs: o,
                            worldview: this.worldview,
                            localizable: p,
                            availableImages: i,
                            maxUniformBufferBindings: this.maxUniformBufferBindings,
                            maxUniformBlockSizeDwords: this.maxUniformBlockSizeDwords,
                            disableSymbolUBO: this.disableSymbolUBO
                        });
                        f.bucketLayerIDs.push(e1.map((e1)=>t1.F(e1.id, e1.scope)));
                        let r = n.prepare ? n.prepare() : null;
                        null != r ? (r = r.then(()=>n.populate(d, b, this.tileID.canonical, this.tileTransform)), x.push(r)) : n.populate(d, b, this.tileID.canonical, this.tileTransform);
                    }
                }
                const S = ()=>{
                    let s, o, c, h, u, d, p;
                    w.trim();
                    const g = {
                        type: "maybePrepare",
                        renderSourceType: this.renderSourceType,
                        zoom: this.zoom
                    }, x = ()=>{
                        if (s) return this.status = "done", r(s);
                        if (this.extraShadowCaster) this.status = "done", r(null, {
                            buckets: Object.values(m).filter((e1)=>!e1.isEmpty()),
                            featureIndex: f,
                            collisionBoxArray: null,
                            glyphAtlasImage: null,
                            lineAtlas: null,
                            imageAtlas: null,
                            brightness: b.brightness,
                            glyphMap: null,
                            iconMap: null,
                            glyphPositions: null
                        });
                        else if (o && c && h && p) {
                            const e1 = void 0, s = new l(o), r = new Map;
                            for (const [e1, s] of c.entries()){
                                const { imagePosition: i } = t1.fj(e1, s, t1.fk);
                                r.set(e1, i);
                            }
                            const a = {};
                            for(const e1 in m){
                                const n = m[e1];
                                n instanceof t1.fl && (y(n.layers, this.zoom, b.brightness, i, this.worldview, b.activeFloors), a[e1] = t1.fm(n, o, s.positions, c, r, this.tileID.canonical, this.tileZoom, this.scaleFactor, this.pixelRatio, u, this.worldview, i));
                            }
                            const f = {
                                iconsPending: !0,
                                patternsPending: !0
                            };
                            this.rasterizeIfNeeded(n, c, u, ()=>{
                                f.iconsPending = !1, v(a, s, f, e1, p);
                            }), this.rasterizeIfNeeded(n, h, d, ()=>{
                                f.patternsPending = !1, v(a, s, f, e1, p);
                            });
                        }
                    }, v = (e1, s, o, a, l)=>{
                        if (o.iconsPending || o.patternsPending) return;
                        const u = c.size > 0 || h.size > 0, d = Object.keys(e1).length > 0;
                        if (!u && !d) return this.status = "done", void r(null, {
                            buckets: Object.values(m).filter((e1)=>!e1.isEmpty()),
                            featureIndex: f,
                            collisionBoxArray: this.collisionBoxArray,
                            glyphAtlasImage: s.image,
                            lineAtlas: w,
                            imageAtlas: null,
                            brightness: b.brightness
                        });
                        const p = (o, n)=>{
                            for(const s in m){
                                const o = m[s];
                                if (s in e1) t1.fr(o, e1[s], this.showCollisionBoxes, i, this.tileID.canonical, this.tileZoom, this.projection, this.brightness, c, n);
                                else if (o.hasPattern && (o instanceof t1.fs || o instanceof t1.fh || o instanceof t1.dY)) {
                                    y(o.layers, this.zoom, b.brightness, i, this.worldview, b.activeFloors);
                                    const e1 = Object.fromEntries(n.patternPositions);
                                    o.addFeatures(b, this.tileID.canonical, e1, i, this.tileTransform, this.brightness);
                                }
                            }
                            this.status = "done", r(null, {
                                buckets: Object.values(m).filter((e1)=>!e1.isEmpty()),
                                featureIndex: f,
                                collisionBoxArray: this.collisionBoxArray,
                                glyphAtlasImage: s.image,
                                lineAtlas: w,
                                imageAtlas: o,
                                brightness: b.brightness
                            });
                        };
                        if (u) {
                            const e1 = new Map, s = t1.fn(c, e1), i = t1.fn(h, e1), o = new t1.fo(s, i, l, this.lut, e1);
                            n.send("checkAtlasCache", {
                                descriptor: o,
                                scope: this.scope
                            }, (e1, s)=>{
                                let i, o;
                                if (e1 && t1.w(`[Worker] Error checking atlas cache: ${e1.message}`), s) i = new t1.fp(s.sourceHash), o = s;
                                else {
                                    const e1 = new t1.fq(c, h, this.lut, l);
                                    i = e1, o = e1;
                                }
                                p(i, o);
                            });
                        } else p(null, {
                            iconPositions: new Map,
                            patternPositions: new Map
                        });
                    };
                    if (!this.extraShadowCaster) {
                        const e1 = t1.fg(b.glyphDependencies, (e1)=>Object.keys(e1).map(Number));
                        Object.keys(e1).length ? n.send("getGlyphs", {
                            uid: this.uid,
                            stacks: e1
                        }, (e1, t1)=>{
                            s || (s = e1, o = t1, x());
                        }, void 0, !1, g) : o = {}, p = new Map;
                        const i = Array.from(b.iconDependencies.keys()).map((e1)=>t1.I.parse(e1));
                        i.length ? n.send("getImages", {
                            images: i,
                            source: this.source,
                            scope: this.scope,
                            tileID: this.tileID,
                            type: "icons"
                        }, (e1, t1)=>{
                            if (!s) {
                                s = e1, c = new Map, u = this.updateImageMapAndGetImageTaskQueue(c, t1.images, b.iconDependencies);
                                for (const [e1, s] of t1.versions.entries())p.set(e1, s);
                                x();
                            }
                        }, void 0, !1, g) : (c = new Map, u = new Map);
                        const r = Array.from(b.patternDependencies.keys()).map((e1)=>t1.I.parse(e1));
                        r.length ? n.send("getImages", {
                            images: r,
                            source: this.source,
                            scope: this.scope,
                            tileID: this.tileID,
                            type: "patterns"
                        }, (e1, t1)=>{
                            if (!s) {
                                s = e1, h = new Map, d = this.updateImageMapAndGetImageTaskQueue(h, t1.images, b.patternDependencies);
                                for (const [e1, s] of t1.versions.entries())p.set(e1, s);
                                x();
                            }
                        }, void 0, !1, g) : (h = new Map, d = new Map);
                    }
                    if (b.elevationFeatures && b.elevationFeatures.length > 0) {
                        const s = [];
                        for (const e1 of Object.values(m))if (e1 instanceof t1.fh) {
                            const t1 = e1.getUnevaluatedPortalGraph();
                            t1 && s.push(t1);
                        }
                        const i = t1.fi.evaluate(s);
                        for (const s of Object.values(m))if (s instanceof t1.fh) {
                            const t1 = e1.layers[a.decode(s.sourceLayerIndex)];
                            s.setEvaluatedPortalGraph(i, t1, this.tileID.canonical, b.availableImages, b.brightness);
                        }
                    }
                    x();
                };
                x.length > 0 ? Promise.allSettled(x).then(S).catch(r) : S();
            }
            updateParameters(e1) {
                this.scaleFactor = e1.scaleFactor, this.showCollisionBoxes = e1.showCollisionBoxes, this.projection = e1.projection, this.brightness = e1.brightness, this.tileTransform = t1.f8(e1.tileID.canonical, e1.projection), this.extraShadowCaster = e1.extraShadowCaster, this.lut = e1.lut, this.worldview = e1.worldview, this.indoor = e1.indoor;
            }
            rasterizeIfNeeded(e1, t1, s, i) {
                Array.from(t1.values()).some((e1)=>e1.usvg) ? this.rasterize(e1, t1, s, i) : i();
            }
            updateImageMapAndGetImageTaskQueue(e1, t1, s) {
                const i = new Map;
                for (const o of t1.keys()){
                    const n = s.get(o) || [];
                    for (const s of n){
                        const o = s.toString(), n = t1.get(s.id.toString());
                        n.usvg ? i.has(o) || (i.set(o, s), e1.set(o, Object.assign({}, n))) : e1.set(o, n);
                    }
                }
                return i;
            }
            rasterize(e1, t1, s, i) {
                this.rasterizeTask = e1.send("rasterizeImages", {
                    scope: this.scope,
                    tasks: s
                }, (e1, s)=>{
                    if (!e1) for (const [e1, i] of s.entries()){
                        const s = Object.assign(t1.get(e1), {
                            data: i
                        });
                        t1.set(e1, s);
                    }
                    i();
                });
            }
            cancelRasterize() {
                this.rasterizeTask && this.rasterizeTask.cancel();
            }
        }
        function y(e1, s, i, o, n, r) {
            const a = new t1.ae(s, {
                brightness: i,
                worldview: n,
                activeFloors: r
            });
            for (const t1 of e1)t1.recalculate(a, o);
        }
        class w extends t1.E {
            constructor({ actor: e1, layerIndex: s, availableImages: i, availableModels: o, isSpriteLoaded: n, tileProvider: r, brightness: a, maxUniformBufferBindings: l, maxUniformBlockSizeDwords: c, disableSymbolUBO: h }){
                super(), this.actor = e1, this.layerIndex = s, this.availableImages = i, this.availableModels = o, this.loadVectorData = t1.aO, this.tileProvider = r, this.loading = {}, this.loaded = {}, this.deduped = new t1.aN(e1.scheduler), this.isSpriteLoaded = n, this.scheduler = e1.scheduler, this.brightness = a, this.maxUniformBufferBindings = l, this.maxUniformBlockSizeDwords = c, this.disableSymbolUBO = h;
            }
            loadTileData(e1, t1) {
                if (!this.tileProvider) return this.loadVectorData(e1, t1);
                const s = new AbortController, { z: i, x: o, y: n } = e1.tileID.canonical;
                return this.tileProvider.loadTile({
                    z: i,
                    x: o,
                    y: n
                }, {
                    request: e1.request,
                    signal: s.signal
                }).then((e1)=>{
                    if (s.signal.aborted) return;
                    if (null == e1) {
                        const e1 = new Error("Tile not found");
                        return e1.status = 404, t1(e1);
                    }
                    if (null === e1.data) return t1(null, null);
                    const i = new Map;
                    e1.expires && i.set("expires", e1.expires), e1.cacheControl && i.set("cache-control", e1.cacheControl), t1(null, {
                        rawData: e1.data,
                        responseHeaders: i
                    });
                }).catch((e1)=>{
                    s.signal.aborted || t1(e1 instanceof Error ? e1 : new Error(String(e1)));
                }), ()=>s.abort();
            }
            loadTile(e1, i) {
                const o = e1.uid, n = e1 && e1.request, r = n && n.collectResourceTiming, a = this.loading[o] = new m(e1);
                a.maxUniformBufferBindings = this.maxUniformBufferBindings, a.maxUniformBlockSizeDwords = this.maxUniformBlockSizeDwords, a.disableSymbolUBO = this.disableSymbolUBO, a.abort = this.loadTileData(e1, (l, c)=>{
                    const h = !this.loading[o];
                    if (delete this.loading[o], a.cancelRasterize(), h || l || !c) return a.status = "done", h || (this.loaded[o] = a), i(l);
                    const u = c.rawData, d = {}, f = t1.aP(c.responseHeaders);
                    f && f.expires && (d.expires = f.expires), f && f.cacheControl && (d.cacheControl = f.cacheControl), a.vectorTile = c.vectorTile || new t1.ft(new t1.b0(u));
                    const p = ()=>{
                        a.parse(a.vectorTile, this.layerIndex, this.availableImages, this.availableModels, this.actor, (e1, t1)=>{
                            if (e1 || !t1) return i(e1);
                            const o = {};
                            if (r) {
                                const e1 = s(n);
                                e1.length > 0 && (o.resourceTiming = JSON.parse(JSON.stringify(e1)));
                            }
                            i(null, Object.assign({
                                rawTileData: u.slice(0),
                                responseHeaders: c.responseHeaders
                            }, t1, d, o));
                        });
                    };
                    this.isSpriteLoaded ? p() : this.once("isSpriteLoaded", ()=>{
                        this.scheduler ? this.scheduler.add(p, {
                            type: "parseTile",
                            renderSourceType: e1.renderSourceType,
                            zoom: e1.tileZoom
                        }) : p();
                    }), this.loaded = this.loaded || {}, this.loaded[o] = a;
                });
            }
            reloadTile(e1, t1) {
                const s = this.loaded, i = e1.uid;
                if (s && s[i]) {
                    const o = s[i];
                    o.updateParameters(e1);
                    const n = (e1, s)=>{
                        const i = o.reloadCallback;
                        i && (delete o.reloadCallback, o.parse(o.vectorTile, this.layerIndex, this.availableImages, this.availableModels, this.actor, i)), t1(e1, s);
                    };
                    "parsing" === o.status ? o.reloadCallback = n : "done" === o.status && (o.vectorTile ? o.parse(o.vectorTile, this.layerIndex, this.availableImages, this.availableModels, this.actor, n) : n());
                } else t1(null, void 0);
            }
            abortTile(e1, t1) {
                const s = e1.uid, i = this.loading[s];
                i && (i.abort && i.abort(), delete this.loading[s]), t1();
            }
            removeTile(e1, t1) {
                const s = this.loaded, i = e1.uid;
                s && s[i] && delete s[i], t1();
            }
        }
        class b {
            loadTile(e1, s) {
                const { uid: i, encoding: o, rawImageData: n, padding: r } = e1, a = ImageBitmap && n instanceof ImageBitmap ? this.getImageData(n, r) : n;
                s(null, new t1.fu(i, a, o, r < 1));
            }
            reloadTile(e1, t1) {
                t1(null, null);
            }
            abortTile(e1, t1) {
                t1();
            }
            removeTile(e1, t1) {
                t1();
            }
            getImageData(e1, t1) {
                this.offscreenCanvas && this.offscreenCanvasContext || (this.offscreenCanvas = new OffscreenCanvas(e1.width, e1.height), this.offscreenCanvasContext = this.offscreenCanvas.getContext("2d", {
                    willReadFrequently: !0
                })), this.offscreenCanvas.width = e1.width, this.offscreenCanvas.height = e1.height, this.offscreenCanvasContext.drawImage(e1, 0, 0, e1.width, e1.height);
                const s = this.offscreenCanvasContext.getImageData(-t1, -t1, e1.width + 2 * t1, e1.height + 2 * t1);
                return this.offscreenCanvasContext.clearRect(0, 0, this.offscreenCanvas.width, this.offscreenCanvas.height), s;
            }
        }
        t1.a$.setPbf(t1.b0);
        class x {
            constructor(e1){
                this._mrt = new t1.a$(e1.partial ? 30 : 1 / 0), this._isHeaderLoaded = !1, this.uid = e1.uid, this.tileID = e1.tileID, this.source = e1.source;
            }
            parse(e1, s) {
                const i = this._mrt;
                this.status = "parsing", this._entireBuffer = e1;
                try {
                    i.parseHeader(e1), this._isHeaderLoaded = !0;
                    const o = [];
                    for(const s in i.layers){
                        const n = i.getLayer(s), r = n.getDataRange(n.getBandList()), a = i.createDecodingTask(r), l = e1.slice(r.firstByte, r.lastByte + 1), c = t1.a$.performDecoding(l, a).then((e1)=>a.complete(null, e1)).catch((e1)=>a.complete(e1, null));
                        o.push(c);
                    }
                    Promise.allSettled(o).then(()=>s(null, i)).catch((e1)=>s(e1));
                } catch (e1) {
                    s(e1);
                }
            }
        }
        class v {
            constructor({ actor: e1 }){
                this.actor = e1, this.loading = {}, this.loaded = {};
            }
            loadTile(e1, s) {
                const i = e1.uid, o = e1.request, n = this.loading[i] = new x(e1), { cancel: r } = t1.b2(o, (e1, t1, o)=>{
                    const r = !this.loading[i];
                    if (delete this.loading[i], r || e1 || !t1) return n.status = "done", r || (this.loaded[i] = n), s(e1);
                    n.parse(t1, (e1, t1)=>{
                        if (e1 || !t1) return s(e1);
                        s(null, t1, o);
                    }), this.loaded[i] = n;
                });
                n.abort = r;
            }
            reloadTile(e1, t1) {
                t1(null, void 0);
            }
            abortTile(e1, t1) {
                const s = e1.uid, i = this.loading[s];
                i && (i.abort && i.abort(), delete this.loading[s]), t1();
            }
            removeTile(e1, t1) {
                const s = e1.uid;
                this.loaded[s] && delete this.loaded[s], t1();
            }
            decodeRasterArray(e1, s) {
                t1.a$.performDecoding(e1.buffer, e1.task).then((e1)=>s(null, e1)).catch((e1)=>s(e1));
            }
        }
        const S = t1.fv.prototype.toGeoJSON;
        class I {
            constructor(e1){
                this._feature = e1, this.extent = t1.an, this.type = e1.type, this.properties = e1.tags, "id" in e1 && !isNaN(e1.id) && (this.id = parseInt(e1.id, 10));
            }
            loadGeometry() {
                if (1 === this._feature.type) {
                    const e1 = [];
                    for (const s of this._feature.geometry)e1.push([
                        new t1.P(s[0], s[1])
                    ]);
                    return e1;
                }
                {
                    const e1 = [];
                    for (const s of this._feature.geometry){
                        const i = [];
                        for (const e1 of s)i.push(new t1.P(e1[0], e1[1]));
                        e1.push(i);
                    }
                    return e1;
                }
            }
            toGeoJSON(e1, t1, s) {
                return S.call(this, e1, t1, s);
            }
        }
        class M {
            constructor(e1, s){
                this.name = e1, this.extent = t1.an, this.length = s.length, this._jsonFeatures = s;
            }
            feature(e1) {
                return new I(this._jsonFeatures[e1]);
            }
        }
        class P {
            constructor(e1){
                this.layers = {}, this.extent = t1.an;
                for (const t1 of Object.keys(e1))this.layers[t1] = new M(t1, e1[t1]);
            }
        }
        const k = 64 / 4096;
        class T {
            constructor(){
                this.features = new Map;
            }
            clear() {
                this.features.clear();
            }
            load(e1 = [], t1) {
                for (const s of e1){
                    const e1 = s.id;
                    if (null == e1) continue;
                    let i = this.features.get(e1);
                    i && this.updateCache(i, t1), s.geometry ? (i = z(s), this.updateCache(i, t1), this.features.set(e1, i)) : this.features.delete(e1), this.updateCache(i, t1);
                }
            }
            updateCache(e1, t1) {
                for (const { canonical: s, uid: i } of Object.values(t1)){
                    const { z: o, x: n, y: r } = s;
                    _(e1, Math.pow(2, o), n, r) && delete t1[i];
                }
            }
            getTile(e1, t1, s) {
                const i = Math.pow(2, e1), o = [];
                for (const e1 of this.features.values())_(e1, i, t1, s) && o.push(C(e1, i, t1, s));
                return {
                    features: o
                };
            }
            getFeatures() {
                return [
                    ...this.features.values()
                ];
            }
        }
        function _({ minX: e1, minY: t1, maxX: s, maxY: i }, o, n, r) {
            return e1 < (n + 1 + k) / o && t1 < (r + 1 + k) / o && s > (n - k) / o && i > (r - k) / o;
        }
        function z(e1) {
            const { id: t1, geometry: s, properties: i } = e1;
            if (!s) return;
            if ("GeometryCollection" === s.type) throw new Error("GeometryCollection not supported in dynamic mode.");
            const { type: o, coordinates: n } = s, r = {
                id: t1,
                type: 1,
                geometry: [],
                tags: i,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            }, a = r.geometry;
            if ("Point" === o) D(n, a, r);
            else if ("MultiPoint" === o) for (const e1 of n)D(e1, a, r);
            else if ("LineString" === o) r.type = 2, L(n, a, r);
            else if ("MultiLineString" === o) r.type = 2, O(n, a, r);
            else if ("Polygon" === o) r.type = 3, O(n, a, r, !0);
            else {
                if ("MultiPolygon" !== o) throw new Error("Input data is not a valid GeoJSON object.");
                r.type = 3;
                for (const e1 of n)O(e1, a, r, !0);
            }
            return r;
        }
        function D([e1, s], i, o) {
            const n = t1.aH(e1);
            let r = t1.aL(s);
            r = r < 0 ? 0 : r > 1 ? 1 : r, i.push(n, r), o.minX = Math.min(o.minX, n), o.minY = Math.min(o.minY, r), o.maxX = Math.max(o.maxX, n), o.maxY = Math.max(o.maxY, r);
        }
        function L(e1, t1, s, i = !1, o = !1) {
            const n = [];
            for (const t1 of e1)D(t1, n, s);
            t1.push(n), i && function(e1, t1) {
                let s = 0;
                for(let t1 = 0, i = e1.length, o = i - 2; t1 < i; o = t1, t1 += 2)s += (e1[t1] - e1[o]) * (e1[t1 + 1] + e1[o + 1]);
                if (s > 0 === t1) for(let t1 = 0, s = e1.length; t1 < s / 2; t1 += 2){
                    const i = e1[t1], o = e1[t1 + 1];
                    e1[t1] = e1[s - 2 - t1], e1[t1 + 1] = e1[s - 1 - t1], e1[s - 2 - t1] = i, e1[s - 1 - t1] = o;
                }
            }(n, o);
        }
        function O(e1, t1, s, i = !1) {
            for(let o = 0; o < e1.length; o++)L(e1[o], t1, s, i, 0 === o);
        }
        function C(e1, s, i, o) {
            const { id: n, type: r, geometry: a, tags: l } = e1, c = [];
            if (1 === r) !function(e1, s, i, o, n) {
                for(let r = 0; r < e1.length; r += 2){
                    const a = Math.round(t1.an * (e1[r + 0] * s - i)), l = Math.round(t1.an * (e1[r + 1] * s - o));
                    n.push([
                        a,
                        l
                    ]);
                }
            }(a, s, i, o, c);
            else if (2 === r) for (const e1 of a)j(e1, s, i, o, c);
            else if (3 === r) for (const e1 of a)B(e1, s, i, o, c);
            return {
                id: n,
                type: r,
                geometry: c,
                tags: l
            };
        }
        function j(e1, s, i, o, n) {
            const r = -128, a = t1.an + 128;
            let l;
            for(let c = 0; c < e1.length - 2; c += 2){
                let h = Math.round(t1.an * (e1[c + 0] * s - i)), u = Math.round(t1.an * (e1[c + 1] * s - o)), d = Math.round(t1.an * (e1[c + 2] * s - i)), f = Math.round(t1.an * (e1[c + 3] * s - o));
                const p = d - h, g = f - u;
                h < r && d < r || (h < r ? (u += Math.round(g * ((r - h) / p)), h = r) : d < r && (f = u + Math.round(g * ((r - h) / p)), d = r), u < r && f < r || (u < r ? (h += Math.round(p * ((r - u) / g)), u = r) : f < r && (d = h + Math.round(p * ((r - u) / g)), f = r), h >= a && d >= a || (h >= a ? (u += Math.round(g * ((a - h) / p)), h = a) : d >= a && (f = u + Math.round(g * ((a - h) / p)), d = a), u >= a && f >= a || (u >= a ? (h += Math.round(p * ((a - u) / g)), u = a) : f >= a && (d = h + Math.round(p * ((a - u) / g)), f = a), l && h === l[l.length - 1][0] && u === l[l.length - 1][1] || (l = [
                    [
                        h,
                        u
                    ]
                ], n.push(l)), l.push([
                    d,
                    f
                ])))));
            }
        }
        function B(e1, s, i, o, n) {
            const r = (i - k) / s, a = (o - k) / s, l = (i + 1 + k) / s, c = (o + 1 + k) / s;
            function h(e1, t1) {
                let s = 0;
                return e1 < r ? s |= 1 : e1 > l && (s |= 2), t1 < a ? s |= 4 : t1 > c && (s |= 8), s;
            }
            let u = [];
            for(let t1 = 1; t1 <= 8; t1 *= 2){
                let s = e1[e1.length - 2], i = e1[e1.length - 1], o = !(h(s, i) & t1);
                for(let n = 0; n < e1.length; n += 2){
                    const d = e1[n], f = e1[n + 1], p = !(h(d, f) & t1);
                    p !== o && (8 & t1 ? u.push(s + (d - s) * (c - i) / (f - i), c) : 4 & t1 ? u.push(s + (d - s) * (a - i) / (f - i), a) : 2 & t1 ? u.push(l, i + (f - i) * (l - s) / (d - s)) : 1 & t1 && u.push(r, i + (f - i) * (r - s) / (d - s))), p && u.push(d, f), s = d, i = f, o = p;
                }
                if (!(e1 = u).length || 8 === t1) break;
                u = [];
            }
            const d = [];
            for(let e1 = 0; e1 < u.length; e1 += 2)d.push([
                Math.round(t1.an * (u[e1] * s - i)),
                Math.round(t1.an * (u[e1 + 1] * s - o))
            ]);
            d.length && n.push(d);
        }
        function A({ name: e1, features: s }, i) {
            i.writeStringField(1, e1), i.writeVarintField(5, t1.an);
            const o = new Map, n = new Map, r = {
                keys: o,
                values: n,
                feature: null
            };
            for (const e1 of s)r.feature = e1, i.writeMessage(2, F, r);
            for (const e1 of o.keys())i.writeStringField(3, e1);
            for (const e1 of n.keys())i.writeMessage(4, R, e1);
        }
        function F(e1, t1) {
            const s = e1.feature;
            void 0 !== s.id && Number.isSafeInteger(+s.id) && t1.writeVarintField(1, +s.id), s.tags && t1.writeMessage(2, E, e1), t1.writeVarintField(3, s.type), t1.writeMessage(4, N, s);
        }
        function E({ keys: e1, values: t1, feature: s }, i) {
            for (const o of Object.keys(s.tags)){
                let n = s.tags[o];
                if (null === n) continue;
                let r = e1.get(o);
                void 0 === r && (r = e1.size, e1.set(o, r)), i.writeVarint(r);
                const a = typeof n;
                "string" !== a && "boolean" !== a && "number" !== a && (n = JSON.stringify(n));
                let l = t1.get(n);
                void 0 === l && (l = t1.size, t1.set(n, l)), i.writeVarint(l);
            }
        }
        function U(e1, t1) {
            return (t1 << 3) + (7 & e1);
        }
        function Z(e1) {
            return e1 << 1 ^ e1 >> 31;
        }
        function N(e1, t1) {
            const { geometry: s, type: i } = e1;
            let o = 0, n = 0;
            if (1 === i) {
                t1.writeVarint(U(1, s.length));
                for (const e1 of s){
                    const s = e1[0] - o, i = e1[1] - n;
                    t1.writeVarint(Z(s)), t1.writeVarint(Z(i)), o += s, n += i;
                }
            } else for (const e1 of s){
                if (0 === e1.length) continue;
                t1.writeVarint(U(1, 1));
                const s = e1.length - (3 === i ? 1 : 0);
                for(let i = 0; i < s; i++){
                    1 === i && t1.writeVarint(U(2, s - 1));
                    const r = e1[i][0] - o, a = e1[i][1] - n;
                    t1.writeVarint(Z(r)), t1.writeVarint(Z(a)), o += r, n += a;
                }
                3 === i && t1.writeVarint(U(7, 1));
            }
        }
        function R(e1, t1) {
            const s = typeof e1;
            "string" === s ? t1.writeStringField(1, e1) : "boolean" === s ? t1.writeBooleanField(7, e1) : "number" === s && (e1 % 1 != 0 ? t1.writeDoubleField(3, e1) : e1 < 0 ? t1.writeSVarintField(6, e1) : t1.writeVarintField(5, e1));
        }
        const X = {
            minZoom: 0,
            maxZoom: 16,
            minPoints: 2,
            radius: 40,
            extent: 512,
            nodeSize: 64,
            log: !1,
            generateId: !1,
            reduce: null,
            map: (e1)=>e1
        }, Y = Math.fround || ($ = new Float32Array(1), (e1)=>($[0] = +e1, $[0]));
        var $;
        class J {
            constructor(e1){
                this.options = Object.assign(Object.create(X), e1), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
            }
            load(e1) {
                const { log: t1, minZoom: s, maxZoom: i } = this.options;
                t1 && console.time("total time");
                const o = `prepare ${e1.length} points`;
                t1 && console.time(o), this.points = e1;
                const n = [];
                for(let t1 = 0; t1 < e1.length; t1++){
                    const s = e1[t1];
                    if (!s.geometry) continue;
                    const [i, o] = s.geometry.coordinates, r = Y(q(i)), a = Y(W(o));
                    n.push(r, a, 1 / 0, t1, -1, 1), this.options.reduce && n.push(0);
                }
                let r = this.trees[i + 1] = this._createTree(n);
                t1 && console.timeEnd(o);
                for(let e1 = i; e1 >= s; e1--){
                    const s = +Date.now();
                    r = this.trees[e1] = this._createTree(this._cluster(r, e1)), t1 && console.log("z%d: %d clusters in %dms", e1, r.numItems, +Date.now() - s);
                }
                return t1 && console.timeEnd("total time"), this;
            }
            getClusters(e1, t1) {
                let s = ((e1[0] + 180) % 360 + 360) % 360 - 180;
                const i = Math.max(-90, Math.min(90, e1[1]));
                let o = 180 === e1[2] ? 180 : ((e1[2] + 180) % 360 + 360) % 360 - 180;
                const n = Math.max(-90, Math.min(90, e1[3]));
                if (e1[2] - e1[0] >= 360) s = -180, o = 180;
                else if (s > o) {
                    const e1 = this.getClusters([
                        s,
                        i,
                        180,
                        n
                    ], t1), r = this.getClusters([
                        -180,
                        i,
                        o,
                        n
                    ], t1);
                    return e1.concat(r);
                }
                const r = this.trees[this._limitZoom(t1)], a = r.range(q(s), W(n), q(o), W(i)), l = r.data, c = [];
                for (const e1 of a){
                    const t1 = this.stride * e1;
                    c.push(l[t1 + 5] > 1 ? G(l, t1, this.clusterProps) : this.points[l[t1 + 3]]);
                }
                return c;
            }
            getChildren(e1) {
                const t1 = this._getOriginId(e1), s = this._getOriginZoom(e1), i = "No cluster with the specified id.", o = this.trees[s];
                if (!o) throw new Error(i);
                const n = o.data;
                if (t1 * this.stride >= n.length) throw new Error(i);
                const r = this.options.radius / (this.options.extent * Math.pow(2, s - 1)), a = o.within(n[t1 * this.stride], n[t1 * this.stride + 1], r), l = [];
                for (const t1 of a){
                    const s = t1 * this.stride;
                    n[s + 4] === e1 && l.push(n[s + 5] > 1 ? G(n, s, this.clusterProps) : this.points[n[s + 3]]);
                }
                if (0 === l.length) throw new Error(i);
                return l;
            }
            getLeaves(e1, t1, s) {
                const i = [];
                return this._appendLeaves(i, e1, t1 = t1 || 10, s = s || 0, 0), i;
            }
            getTile(e1, t1, s) {
                const i = this.trees[this._limitZoom(e1)], o = Math.pow(2, e1), { extent: n, radius: r } = this.options, a = r / n, l = (s - a) / o, c = (s + 1 + a) / o, h = {
                    features: []
                };
                return this._addTileFeatures(i.range((t1 - a) / o, l, (t1 + 1 + a) / o, c), i.data, t1, s, o, h), 0 === t1 && this._addTileFeatures(i.range(1 - a / o, l, 1, c), i.data, o, s, o, h), t1 === o - 1 && this._addTileFeatures(i.range(0, l, a / o, c), i.data, -1, s, o, h), h.features.length ? h : null;
            }
            getClusterExpansionZoom(e1) {
                let t1 = this._getOriginZoom(e1) - 1;
                for(; t1 <= this.options.maxZoom;){
                    const s = this.getChildren(e1);
                    if (t1++, 1 !== s.length) break;
                    e1 = s[0].properties.cluster_id;
                }
                return t1;
            }
            _appendLeaves(e1, t1, s, i, o) {
                const n = this.getChildren(t1);
                for (const t1 of n){
                    const n = t1.properties;
                    if (n && n.cluster ? o + n.point_count <= i ? o += n.point_count : o = this._appendLeaves(e1, n.cluster_id, s, i, o) : o < i ? o++ : e1.push(t1), e1.length === s) break;
                }
                return o;
            }
            _createTree(e1) {
                const s = new t1.bJ(e1.length / this.stride | 0, this.options.nodeSize, Float32Array);
                for(let t1 = 0; t1 < e1.length; t1 += this.stride)s.add(e1[t1], e1[t1 + 1]);
                return s.finish(), s.data = e1, s;
            }
            _addTileFeatures(e1, t1, s, i, o, n) {
                for (const r of e1){
                    const e1 = r * this.stride, a = t1[e1 + 5] > 1;
                    let l, c, h;
                    if (a) l = V(t1, e1, this.clusterProps), c = t1[e1], h = t1[e1 + 1];
                    else {
                        const s = this.points[t1[e1 + 3]];
                        l = s.properties;
                        const [i, o] = s.geometry.coordinates;
                        c = q(i), h = W(o);
                    }
                    const u = {
                        type: 1,
                        geometry: [
                            [
                                Math.round(this.options.extent * (c * o - s)),
                                Math.round(this.options.extent * (h * o - i))
                            ]
                        ],
                        tags: l
                    };
                    let d;
                    d = a || this.options.generateId ? t1[e1 + 3] : this.points[t1[e1 + 3]].id, void 0 !== d && (u.id = d), n.features.push(u);
                }
            }
            _limitZoom(e1) {
                return Math.max(this.options.minZoom, Math.min(Math.floor(+e1), this.options.maxZoom + 1));
            }
            _cluster(e1, t1) {
                const { radius: s, extent: i, reduce: o, minPoints: n } = this.options, r = s / (i * Math.pow(2, t1)), a = e1.data, l = [], c = this.stride;
                for(let s = 0; s < a.length; s += c){
                    if (a[s + 2] <= t1) continue;
                    a[s + 2] = t1;
                    const i = a[s], h = a[s + 1], u = e1.within(a[s], a[s + 1], r), d = a[s + 5];
                    let f = d;
                    for (const e1 of u){
                        const s = e1 * c;
                        a[s + 2] > t1 && (f += a[s + 5]);
                    }
                    if (f > d && f >= n) {
                        let e1, n = i * d, r = h * d, p = -1;
                        const g = (s / c << 5) + (t1 + 1) + this.points.length;
                        for (const i of u){
                            const l = i * c;
                            if (a[l + 2] <= t1) continue;
                            a[l + 2] = t1;
                            const h = a[l + 5];
                            n += a[l] * h, r += a[l + 1] * h, a[l + 4] = g, o && (e1 || (e1 = this._map(a, s, !0), p = this.clusterProps.length, this.clusterProps.push(e1)), o(e1, this._map(a, l)));
                        }
                        a[s + 4] = g, l.push(n / f, r / f, 1 / 0, g, -1, f), o && l.push(p);
                    } else {
                        for(let e1 = 0; e1 < c; e1++)l.push(a[s + e1]);
                        if (f > 1) for (const e1 of u){
                            const s = e1 * c;
                            if (!(a[s + 2] <= t1)) {
                                a[s + 2] = t1;
                                for(let e1 = 0; e1 < c; e1++)l.push(a[s + e1]);
                            }
                        }
                    }
                }
                return l;
            }
            _getOriginId(e1) {
                return e1 - this.points.length >> 5;
            }
            _getOriginZoom(e1) {
                return (e1 - this.points.length) % 32;
            }
            _map(e1, t1, s) {
                if (e1[t1 + 5] > 1) {
                    const i = this.clusterProps[e1[t1 + 6]];
                    return s ? Object.assign({}, i) : i;
                }
                const i = this.points[e1[t1 + 3]].properties, o = this.options.map(i);
                return s && o === i ? Object.assign({}, o) : o;
            }
        }
        function G(e1, t1, s) {
            var i;
            return {
                type: "Feature",
                id: e1[t1 + 3],
                properties: V(e1, t1, s),
                geometry: {
                    type: "Point",
                    coordinates: [
                        (i = e1[t1], 360 * (i - .5)),
                        H(e1[t1 + 1])
                    ]
                }
            };
        }
        function V(e1, t1, s) {
            const i = e1[t1 + 5], o = i >= 1e4 ? `${Math.round(i / 1e3)}k` : i >= 1e3 ? Math.round(i / 100) / 10 + "k" : i, n = e1[t1 + 6], r = -1 === n ? {} : Object.assign({}, s[n]);
            return Object.assign(r, {
                cluster: !0,
                cluster_id: e1[t1 + 3],
                point_count: i,
                point_count_abbreviated: o
            });
        }
        function q(e1) {
            return e1 / 360 + .5;
        }
        function W(e1) {
            const t1 = Math.sin(e1 * Math.PI / 180), s = .5 - .25 * Math.log((1 + t1) / (1 - t1)) / Math.PI;
            return s < 0 ? 0 : s > 1 ? 1 : s;
        }
        function H(e1) {
            const t1 = (180 - 360 * e1) * Math.PI / 180;
            return 360 * Math.atan(Math.exp(t1)) / Math.PI - 90;
        }
        function Q(e1, t1, s, i) {
            let o = i;
            const n = t1 + (s - t1 >> 1);
            let r, a = s - t1;
            const l = e1[t1], c = e1[t1 + 1], h = e1[s], u = e1[s + 1];
            for(let i = t1 + 3; i < s; i += 3){
                const t1 = K(e1[i], e1[i + 1], l, c, h, u);
                if (t1 > o) r = i, o = t1;
                else if (t1 === o) {
                    const e1 = Math.abs(i - n);
                    e1 < a && (r = i, a = e1);
                }
            }
            o > i && (r - t1 > 3 && Q(e1, t1, r, i), e1[r + 2] = o, s - r > 3 && Q(e1, r, s, i));
        }
        function K(e1, t1, s, i, o, n) {
            let r = o - s, a = n - i;
            if (0 !== r || 0 !== a) {
                const l = ((e1 - s) * r + (t1 - i) * a) / (r * r + a * a);
                l > 1 ? (s = o, i = n) : l > 0 && (s += r * l, i += a * l);
            }
            return r = e1 - s, a = t1 - i, r * r + a * a;
        }
        function ee(e1, t1, s, i) {
            const o = {
                id: e1 ?? null,
                type: t1,
                geometry: s,
                tags: i,
                minX: 1 / 0,
                minY: 1 / 0,
                maxX: -1 / 0,
                maxY: -1 / 0
            };
            if ("Point" === t1 || "MultiPoint" === t1 || "LineString" === t1) te(o, s);
            else if ("Polygon" === t1) te(o, s[0]);
            else if ("MultiLineString" === t1) for (const e1 of s)te(o, e1);
            else if ("MultiPolygon" === t1) for (const e1 of s)te(o, e1[0]);
            return o;
        }
        function te(e1, t1) {
            for(let s = 0; s < t1.length; s += 3)e1.minX = Math.min(e1.minX, t1[s]), e1.minY = Math.min(e1.minY, t1[s + 1]), e1.maxX = Math.max(e1.maxX, t1[s]), e1.maxY = Math.max(e1.maxY, t1[s + 1]);
        }
        function se(e1, t1, s, i) {
            if (!t1.geometry) return;
            const o = t1.geometry.coordinates;
            if (o && 0 === o.length) return;
            const n = t1.geometry.type, r = Math.pow(s.tolerance / ((1 << s.maxZoom) * s.extent), 2);
            let a = [], l = t1.id;
            if (s.promoteId ? l = t1.properties[s.promoteId] : s.generateId && (l = i || 0), "Point" === n) ie(o, a);
            else if ("MultiPoint" === n) for (const e1 of o)ie(e1, a);
            else if ("LineString" === n) oe(o, a, r, !1);
            else if ("MultiLineString" === n) {
                if (s.lineMetrics) {
                    for (const s of o)a = [], oe(s, a, r, !1), e1.push(ee(l, "LineString", a, t1.properties));
                    return;
                }
                ne(o, a, r, !1);
            } else if ("Polygon" === n) ne(o, a, r, !0);
            else {
                if ("MultiPolygon" !== n) {
                    if ("GeometryCollection" === n) {
                        for (const o of t1.geometry.geometries)se(e1, {
                            id: l,
                            geometry: o,
                            properties: t1.properties
                        }, s, i);
                        return;
                    }
                    throw new Error("Input data is not a valid GeoJSON object.");
                }
                for (const e1 of o){
                    const t1 = [];
                    ne(e1, t1, r, !0), a.push(t1);
                }
            }
            e1.push(ee(l, n, a, t1.properties));
        }
        function ie(e1, t1) {
            t1.push(re(e1[0]), ae(e1[1]), 0);
        }
        function oe(e1, t1, s, i) {
            let o, n, r = 0;
            for(let s = 0; s < e1.length; s++){
                const a = re(e1[s][0]), l = ae(e1[s][1]);
                t1.push(a, l, 0), s > 0 && (r += i ? (o * l - a * n) / 2 : Math.sqrt(Math.pow(a - o, 2) + Math.pow(l - n, 2))), o = a, n = l;
            }
            const a = t1.length - 3;
            t1[2] = 1, Q(t1, 0, a, s), t1[a + 2] = 1, t1.size = Math.abs(r), t1.start = 0, t1.end = t1.size;
        }
        function ne(e1, t1, s, i) {
            for(let o = 0; o < e1.length; o++){
                const n = [];
                oe(e1[o], n, s, i), t1.push(n);
            }
        }
        function re(e1) {
            return e1 / 360 + .5;
        }
        function ae(e1) {
            const t1 = Math.sin(e1 * Math.PI / 180), s = .5 - .25 * Math.log((1 + t1) / (1 - t1)) / Math.PI;
            return s < 0 ? 0 : s > 1 ? 1 : s;
        }
        function le(e1, t1, s, i, o, n, r, a) {
            if (i /= t1, n >= (s /= t1) && r < i) return e1;
            if (r < s || n >= i) return null;
            const l = [];
            for (const t1 of e1){
                const e1 = t1.geometry;
                let n = t1.type;
                const r = 0 === o ? t1.minX : t1.minY, c = 0 === o ? t1.maxX : t1.maxY;
                if (r >= s && c < i) {
                    l.push(t1);
                    continue;
                }
                if (c < s || r >= i) continue;
                let h = [];
                if ("Point" === n || "MultiPoint" === n) ce(e1, h, s, i, o);
                else if ("LineString" === n) he(e1, h, s, i, o, !1, a.lineMetrics);
                else if ("MultiLineString" === n) de(e1, h, s, i, o, !1);
                else if ("Polygon" === n) de(e1, h, s, i, o, !0);
                else if ("MultiPolygon" === n) for (const t1 of e1){
                    const e1 = [];
                    de(t1, e1, s, i, o, !0), e1.length && h.push(e1);
                }
                if (h.length) {
                    if (a.lineMetrics && "LineString" === n) {
                        for (const e1 of h)l.push(ee(t1.id, n, e1, t1.tags));
                        continue;
                    }
                    "LineString" !== n && "MultiLineString" !== n || (1 === h.length ? (n = "LineString", h = h[0]) : n = "MultiLineString"), "Point" !== n && "MultiPoint" !== n || (n = 3 === h.length ? "Point" : "MultiPoint"), l.push(ee(t1.id, n, h, t1.tags));
                }
            }
            return l.length ? l : null;
        }
        function ce(e1, t1, s, i, o) {
            for(let n = 0; n < e1.length; n += 3){
                const r = e1[n + o];
                r >= s && r <= i && fe(t1, e1[n], e1[n + 1], e1[n + 2]);
            }
        }
        function he(e1, t1, s, i, o, n, r) {
            let a = ue(e1);
            const l = 0 === o ? pe : ge;
            let c, h, u = e1.start;
            for(let d = 0; d < e1.length - 3; d += 3){
                const f = e1[d], p = e1[d + 1], g = e1[d + 2], m = e1[d + 3], y = e1[d + 4], w = 0 === o ? f : p, b = 0 === o ? m : y;
                let x = !1;
                r && (c = Math.sqrt(Math.pow(f - m, 2) + Math.pow(p - y, 2))), w < s ? b > s && (h = l(a, f, p, m, y, s), r && (a.start = u + c * h)) : w > i ? b < i && (h = l(a, f, p, m, y, i), r && (a.start = u + c * h)) : fe(a, f, p, g), b < s && w >= s && (h = l(a, f, p, m, y, s), x = !0), b > i && w <= i && (h = l(a, f, p, m, y, i), x = !0), !n && x && (r && (a.end = u + c * h), t1.push(a), a = ue(e1)), r && (u += c);
            }
            let d = e1.length - 3;
            const f = e1[d], p = e1[d + 1], g = 0 === o ? f : p;
            g >= s && g <= i && fe(a, f, p, e1[d + 2]), d = a.length - 3, n && d >= 3 && (a[d] !== a[0] || a[d + 1] !== a[1]) && fe(a, a[0], a[1], a[2]), a.length && t1.push(a);
        }
        function ue(e1) {
            const t1 = [];
            return t1.size = e1.size, t1.start = e1.start, t1.end = e1.end, t1;
        }
        function de(e1, t1, s, i, o, n) {
            for (const r of e1)he(r, t1, s, i, o, n, !1);
        }
        function fe(e1, t1, s, i) {
            e1.push(t1, s, i);
        }
        function pe(e1, t1, s, i, o, n) {
            const r = (n - t1) / (i - t1);
            return fe(e1, n, s + (o - s) * r, 1), r;
        }
        function ge(e1, t1, s, i, o, n) {
            const r = (n - s) / (o - s);
            return fe(e1, t1 + (i - t1) * r, n, 1), r;
        }
        function me(e1, t1) {
            const s = [];
            for(let i = 0; i < e1.length; i++){
                const o = e1[i], n = o.type;
                let r;
                if ("Point" === n || "MultiPoint" === n || "LineString" === n) r = ye(o.geometry, t1);
                else if ("MultiLineString" === n || "Polygon" === n) {
                    r = [];
                    for (const e1 of o.geometry)r.push(ye(e1, t1));
                } else if ("MultiPolygon" === n) {
                    r = [];
                    for (const e1 of o.geometry){
                        const s = [];
                        for (const i of e1)s.push(ye(i, t1));
                        r.push(s);
                    }
                }
                s.push(ee(o.id, n, r, o.tags));
            }
            return s;
        }
        function ye(e1, t1) {
            const s = [];
            s.size = e1.size, void 0 !== e1.start && (s.start = e1.start, s.end = e1.end);
            for(let i = 0; i < e1.length; i += 3)s.push(e1[i] + t1, e1[i + 1], e1[i + 2]);
            return s;
        }
        function we(e1, t1) {
            if (e1.transformed) return e1;
            const s = 1 << e1.z, i = e1.x, o = e1.y;
            for (const n of e1.features){
                const e1 = n.geometry, r = n.type;
                if (n.geometry = [], 1 === r) for(let r = 0; r < e1.length; r += 2)n.geometry.push(be(e1[r], e1[r + 1], t1, s, i, o));
                else for(let r = 0; r < e1.length; r++){
                    const a = [];
                    for(let n = 0; n < e1[r].length; n += 2)a.push(be(e1[r][n], e1[r][n + 1], t1, s, i, o));
                    n.geometry.push(a);
                }
            }
            return e1.transformed = !0, e1;
        }
        function be(e1, t1, s, i, o, n) {
            return [
                Math.round(s * (e1 * i - o)),
                Math.round(s * (t1 * i - n))
            ];
        }
        function xe(e1, t1, s, i, o) {
            const n = t1 === o.maxZoom ? 0 : o.tolerance / ((1 << t1) * o.extent), r = {
                features: [],
                numPoints: 0,
                numSimplified: 0,
                numFeatures: e1.length,
                source: null,
                x: s,
                y: i,
                z: t1,
                transformed: !1,
                minX: 2,
                minY: 1,
                maxX: -1,
                maxY: 0
            };
            for (const t1 of e1)ve(r, t1, n, o);
            return r;
        }
        function ve(e1, t1, s, i) {
            const o = t1.geometry, n = t1.type, r = [];
            if (e1.minX = Math.min(e1.minX, t1.minX), e1.minY = Math.min(e1.minY, t1.minY), e1.maxX = Math.max(e1.maxX, t1.maxX), e1.maxY = Math.max(e1.maxY, t1.maxY), "Point" === n || "MultiPoint" === n) for(let t1 = 0; t1 < o.length; t1 += 3)r.push(o[t1], o[t1 + 1]), e1.numPoints++, e1.numSimplified++;
            else if ("LineString" === n) Se(r, o, e1, s, !1, !1);
            else if ("MultiLineString" === n || "Polygon" === n) for(let t1 = 0; t1 < o.length; t1++)Se(r, o[t1], e1, s, "Polygon" === n, 0 === t1);
            else if ("MultiPolygon" === n) for(let t1 = 0; t1 < o.length; t1++){
                const i = o[t1];
                for(let t1 = 0; t1 < i.length; t1++)Se(r, i[t1], e1, s, !0, 0 === t1);
            }
            if (r.length) {
                let s = t1.tags || null;
                if ("LineString" === n && i.lineMetrics) {
                    s = {};
                    for(const e1 in t1.tags)s[e1] = t1.tags[e1];
                    s.mapbox_clip_start = o.start / o.size, s.mapbox_clip_end = o.end / o.size;
                }
                const a = {
                    geometry: r,
                    type: "Polygon" === n || "MultiPolygon" === n ? 3 : "LineString" === n || "MultiLineString" === n ? 2 : 1,
                    tags: s
                };
                null !== t1.id && (a.id = t1.id), e1.features.push(a);
            }
        }
        function Se(e1, t1, s, i, o, n) {
            const r = i * i;
            if (i > 0 && t1.size < (o ? r : i)) return void (s.numPoints += t1.length / 3);
            const a = [];
            for(let e1 = 0; e1 < t1.length; e1 += 3)(0 === i || t1[e1 + 2] > r) && (s.numSimplified++, a.push(t1[e1], t1[e1 + 1])), s.numPoints++;
            o && function(e1, t1) {
                let s = 0;
                for(let t1 = 0, i = e1.length, o = i - 2; t1 < i; o = t1, t1 += 2)s += (e1[t1] - e1[o]) * (e1[t1 + 1] + e1[o + 1]);
                if (s > 0 === t1) for(let t1 = 0, s = e1.length; t1 < s / 2; t1 += 2){
                    const i = e1[t1], o = e1[t1 + 1];
                    e1[t1] = e1[s - 2 - t1], e1[t1 + 1] = e1[s - 1 - t1], e1[s - 2 - t1] = i, e1[s - 1 - t1] = o;
                }
            }(a, n), e1.push(a);
        }
        const Ie = {
            maxZoom: 14,
            indexMaxZoom: 5,
            indexMaxPoints: 1e5,
            tolerance: 3,
            extent: 4096,
            buffer: 64,
            lineMetrics: !1,
            promoteId: null,
            generateId: !1,
            debug: 0
        };
        class Me {
            constructor(e1, t1){
                const s = (t1 = this.options = function(e1, t1) {
                    for(const s in t1)e1[s] = t1[s];
                    return e1;
                }(Object.create(Ie), t1)).debug;
                if (s && console.time("preprocess data"), t1.maxZoom < 0 || t1.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
                if (t1.promoteId && t1.generateId) throw new Error("promoteId and generateId cannot be used together.");
                let i = function(e1, t1) {
                    const s = [];
                    if ("FeatureCollection" === e1.type) for(let i = 0; i < e1.features.length; i++)se(s, e1.features[i], t1, i);
                    else se(s, "Feature" === e1.type ? e1 : {
                        geometry: e1
                    }, t1);
                    return s;
                }(e1, t1);
                this.tiles = {}, this.tileCoords = [], s && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", t1.indexMaxZoom, t1.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), i = function(e1, t1) {
                    const s = t1.buffer / t1.extent;
                    let i = e1;
                    const o = le(e1, 1, -1 - s, s, 0, -1, 2, t1), n = le(e1, 1, 1 - s, 2 + s, 0, -1, 2, t1);
                    return (o || n) && (i = le(e1, 1, -s, 1 + s, 0, -1, 2, t1) || [], o && (i = me(o, 1).concat(i)), n && (i = i.concat(me(n, -1)))), i;
                }(i, t1), i.length && this.splitTile(i, 0, 0, 0), s && (i.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
            }
            splitTile(e1, t1, s, i, o, n, r) {
                const a = [
                    e1,
                    t1,
                    s,
                    i
                ], l = this.options, c = l.debug;
                for(; a.length;){
                    i = a.pop(), s = a.pop(), t1 = a.pop(), e1 = a.pop();
                    const h = 1 << t1, u = Pe(t1, s, i);
                    let d = this.tiles[u];
                    if (!d && (c > 1 && console.time("creation"), d = this.tiles[u] = xe(e1, t1, s, i, l), this.tileCoords.push({
                        z: t1,
                        x: s,
                        y: i
                    }), c)) {
                        c > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", t1, s, i, d.numFeatures, d.numPoints, d.numSimplified), console.timeEnd("creation"));
                        const e1 = `z${t1}`;
                        this.stats[e1] = (this.stats[e1] || 0) + 1, this.total++;
                    }
                    if (d.source = e1, null == o) {
                        if (t1 === l.indexMaxZoom || d.numPoints <= l.indexMaxPoints) continue;
                    } else {
                        if (t1 === l.maxZoom || t1 === o) continue;
                        if (null != o) {
                            const e1 = o - t1;
                            if (s !== n >> e1 || i !== r >> e1) continue;
                        }
                    }
                    if (d.source = null, 0 === e1.length) continue;
                    c > 1 && console.time("clipping");
                    const f = .5 * l.buffer / l.extent, p = .5 - f, g = .5 + f, m = 1 + f;
                    let y = null, w = null, b = null, x = null, v = le(e1, h, s - f, s + g, 0, d.minX, d.maxX, l), S = le(e1, h, s + p, s + m, 0, d.minX, d.maxX, l);
                    e1 = null, v && (y = le(v, h, i - f, i + g, 1, d.minY, d.maxY, l), w = le(v, h, i + p, i + m, 1, d.minY, d.maxY, l), v = null), S && (b = le(S, h, i - f, i + g, 1, d.minY, d.maxY, l), x = le(S, h, i + p, i + m, 1, d.minY, d.maxY, l), S = null), c > 1 && console.timeEnd("clipping"), a.push(y || [], t1 + 1, 2 * s, 2 * i), a.push(w || [], t1 + 1, 2 * s, 2 * i + 1), a.push(b || [], t1 + 1, 2 * s + 1, 2 * i), a.push(x || [], t1 + 1, 2 * s + 1, 2 * i + 1);
                }
            }
            getTile(e1, t1, s) {
                e1 = +e1, t1 = +t1, s = +s;
                const i = this.options, { extent: o, debug: n } = i;
                if (e1 < 0 || e1 > 24) return null;
                const r = 1 << e1, a = Pe(e1, t1 = t1 + r & r - 1, s);
                if (this.tiles[a]) return we(this.tiles[a], o);
                n > 1 && console.log("drilling down to z%d-%d-%d", e1, t1, s);
                let l, c = e1, h = t1, u = s;
                for(; !l && c > 0;)c--, h >>= 1, u >>= 1, l = this.tiles[Pe(c, h, u)];
                return l && l.source ? (n > 1 && (console.log("found parent tile z%d-%d-%d", c, h, u), console.time("drilling down")), this.splitTile(l.source, c, h, u, e1, t1, s), n > 1 && console.timeEnd("drilling down"), this.tiles[a] ? we(this.tiles[a], o) : null) : null;
            }
        }
        function Pe(e1, t1, s) {
            return 32 * ((1 << e1) * s + t1) + e1;
        }
        function ke(e1, s) {
            const i = e1.tileID.canonical;
            if (!this._geoJSONIndex) return void s(null, null);
            const o = this._geoJSONIndex.getTile(i.z, i.x, i.y);
            if (!o) return void s(null, null);
            const n = (e1)=>e1.tags && "3d_elevation_id" in e1.tags && "source" in e1.tags && "elevation" === e1.tags.source, r = o.features.filter((e1)=>n(e1));
            let a = {
                _geojsonTileLayer: o.features
            };
            r.length > 0 && (a = {
                _geojsonTileLayer: o.features.filter((e1)=>!n(e1)),
                hd_road_elevation: r
            });
            const l = new P(a), c = function(e1) {
                const s = new t1.b0;
                for (const t1 of Object.keys(e1))s.writeMessage(3, A, {
                    name: t1,
                    features: e1[t1]
                });
                return s.finish();
            }(a).buffer;
            s(null, {
                vectorTile: l,
                rawData: c
            });
        }
        class Te extends w {
            constructor(e1){
                super(e1), this.loadVectorData = ke, this._dynamicIndex = new T;
            }
            loadData(e1, i) {
                const o = e1 && e1.request, n = o && o.collectResourceTiming;
                this._geoJSONIndex = null, this.loadGeoJSON(e1, (r, a)=>{
                    if (r || !a) return i(r);
                    if ("object" != typeof a) return i(new Error(`Input data given to '${e1.source}' is not a valid GeoJSON object.`));
                    {
                        try {
                            if (e1.filter) {
                                const s = t1.X(e1.filter, {
                                    type: "boolean",
                                    "property-type": "data-driven",
                                    overridable: !1,
                                    transition: !1
                                });
                                if ("error" === s.result) throw new Error(s.value.map((e1)=>`${e1.key}: ${e1.message}`).join(", "));
                                a.features = a.features.filter((e1)=>s.value.evaluate({
                                        zoom: 0
                                    }, e1));
                            }
                            e1.dynamic ? ("Feature" === a.type && (a = {
                                type: "FeatureCollection",
                                features: [
                                    a
                                ]
                            }), e1.append || (this._dynamicIndex.clear(), this.loaded = {}), this._dynamicIndex.load(a.features, this.loaded), e1.cluster && (a.features = this._dynamicIndex.getFeatures())) : this.loaded = {}, this._geoJSONIndex = e1.cluster ? new J(function({ superclusterOptions: e1, clusterProperties: s }) {
                                if (!s || !e1) return e1;
                                const i = {}, o = {}, n = {
                                    accumulated: null,
                                    zoom: 0
                                }, r = {
                                    properties: null
                                }, a = Object.keys(s);
                                for (const e1 of a){
                                    const [n, r] = s[e1], a = t1.X(r), l = t1.X("string" == typeof n ? [
                                        n,
                                        [
                                            "accumulated"
                                        ],
                                        [
                                            "get",
                                            e1
                                        ]
                                    ] : n);
                                    i[e1] = a.value, o[e1] = l.value;
                                }
                                return e1.map = (e1)=>{
                                    r.properties = e1;
                                    const t1 = {};
                                    for (const e1 of a)t1[e1] = i[e1].evaluate(n, r);
                                    return t1;
                                }, e1.reduce = (e1, t1)=>{
                                    r.properties = t1;
                                    for (const t1 of a)n.accumulated = e1[t1], e1[t1] = o[t1].evaluate(n, r);
                                }, e1;
                            }(e1)).load(a.features) : e1.dynamic ? this._dynamicIndex : function(e1, t1) {
                                return new Me(e1, t1);
                            }(a, e1.geojsonVtOptions);
                        } catch (e1) {
                            return i(e1);
                        }
                        const r = {};
                        if (n) {
                            const t1 = s(o);
                            t1 && (r.resourceTiming = {}, r.resourceTiming[e1.source] = JSON.parse(JSON.stringify(t1)));
                        }
                        i(null, r);
                    }
                });
            }
            reloadTile(e1, t1) {
                const s = this.loaded;
                return s && s[e1.uid] ? e1.partial ? t1(null, void 0) : super.reloadTile(e1, t1) : this.loadTile(e1, t1);
            }
            loadGeoJSON(e1, s) {
                if (e1.request) t1.m(e1.request, s);
                else {
                    if ("string" != typeof e1.data) return s(new Error(`Input data given to '${e1.source}' is not a valid GeoJSON object.`));
                    setTimeout(()=>{
                        try {
                            return s(null, JSON.parse(e1.data));
                        } catch (t1) {
                            return s(new Error(`Input data given to '${e1.source}' is not a valid GeoJSON object.`));
                        }
                    }, 0);
                }
            }
            getClusterExpansionZoom(e1, t1) {
                try {
                    t1(null, this._geoJSONIndex.getClusterExpansionZoom(e1.clusterId));
                } catch (e1) {
                    t1(e1);
                }
            }
            getClusterChildren(e1, t1) {
                try {
                    t1(null, this._geoJSONIndex.getChildren(e1.clusterId));
                } catch (e1) {
                    t1(e1);
                }
            }
            getClusterLeaves(e1, t1) {
                try {
                    t1(null, this._geoJSONIndex.getLeaves(e1.clusterId, e1.limit, e1.offset));
                } catch (e1) {
                    t1(e1);
                }
            }
        }
        class _e {
            constructor(e1, s, i){
                this.tileID = new t1.aS(e1.tileID.overscaledZ, e1.tileID.wrap, e1.tileID.canonical.z, e1.tileID.canonical.x, e1.tileID.canonical.y), this.tileZoom = e1.tileZoom, this.uid = e1.uid, this.zoom = e1.zoom, this.canonical = e1.tileID.canonical, this.pixelRatio = e1.pixelRatio, this.tileSize = e1.tileSize, this.source = e1.source, this.overscaling = this.tileID.overscaleFactor(), this.projection = e1.projection, this.brightness = s, this.worldview = i;
            }
            parse(e1, s, i, o) {
                this.status = "parsing";
                const n = new t1.aS(i.tileID.overscaledZ, i.tileID.wrap, i.tileID.canonical.z, i.tileID.canonical.x, i.tileID.canonical.y), r = [], a = s.familiesBySource[i.source], l = new t1.fb(n, i.promoteId);
                l.bucketLayerIDs = [], l.is3DTile = !0, t1.fw(e1).then((e1)=>{
                    const s = e1.json.extensionsUsed && e1.json.extensionsUsed.includes("MAPBOX_mesh_features") || e1.json.asset.extras && e1.json.asset.extras.MAPBOX_mesh_features, c = e1.json.extensionsUsed && e1.json.extensionsUsed.includes("EXT_meshopt_compression"), h = new t1.ae(this.zoom, {
                        brightness: this.brightness,
                        worldview: this.worldview
                    });
                    for(const o in a)for (const u of a[o]){
                        const o = u[0];
                        l.bucketLayerIDs.push(u.map((e1)=>t1.F(e1.id, e1.scope))), o.recalculate(h, []);
                        const a = t1.fx(e1, 1 / t1.cO(i.tileID.canonical)), d = new t1.fy(u, a, n, s, c, this.brightness, l, this.worldview);
                        s || (d.needsUpload = !0), r.push(d), d.evaluate(o);
                    }
                    this.status = "done", o(null, {
                        buckets: r,
                        featureIndex: l,
                        collisionBoxArray: null,
                        glyphAtlasImage: null,
                        lineAtlas: null,
                        imageAtlas: null,
                        brightness: null
                    });
                }).catch((e1)=>o(new Error(e1.message)));
            }
        }
        class ze {
            constructor({ actor: e1, layerIndex: t1, availableImages: s, availableModels: i, brightness: o, worldview: n }){
                this.actor = e1, this.layerIndex = t1, this.availableImages = s, this.availableModels = i, this.brightness = o, this.loading = {}, this.loaded = {}, this.worldview = n;
            }
            loadTile(e1, s) {
                const i = e1.uid, o = this.loading[i] = new _e(e1, this.brightness, this.worldview);
                t1.b2(e1.request, (t1, n)=>{
                    const r = !this.loading[i];
                    return delete this.loading[i], r || t1 ? (o.status = "done", r || (this.loaded[i] = o), s(t1)) : n && 0 !== n.byteLength ? void o.parse(n, this.layerIndex, e1, (e1, t1)=>{
                        o.status = "done", this.loaded = this.loaded || {}, this.loaded[i] = o, e1 || !t1 ? s(e1) : s(null, t1);
                    }) : (o.status = "done", this.loaded[i] = o, s());
                });
            }
            reloadTile(e1, t1) {
                const s = this.loaded, i = e1.uid;
                if (s && s[i]) {
                    const o = s[i];
                    o.projection = e1.projection, o.brightness = e1.brightness;
                    const n = (s, i)=>{
                        o.reloadCallback && (delete o.reloadCallback, this.loadTile(e1, t1)), t1(s, i);
                    };
                    "parsing" === o.status ? o.reloadCallback = n : "done" === o.status && this.loadTile(e1, t1);
                }
            }
            abortTile(e1, t1) {
                const s = e1.uid;
                this.loading[s] && delete this.loading[s], t1();
            }
            removeTile(e1, t1) {
                const s = this.loaded, i = e1.uid;
                s && s[i] && delete s[i], t1();
            }
        }
        const De = new Map, Le = new Map;
        class Oe {
            constructor(e1){
                this.self = e1, this.actor = new t1.A(e1, this), this.layerIndexes = {}, this.availableImages = {}, this.availableModels = {}, this.isSpriteLoaded = {}, this.imageRasterizer = new t1.z, this.rtlPluginParsingListeners = [], this.projections = {}, this.defaultProjection = t1.c1({
                    name: "mercator"
                }), this.workerSourceTypes = {
                    vector: w,
                    geojson: Te,
                    "raster-dem": b,
                    "raster-array": v,
                    "batched-model": ze
                }, this.workerSources = {}, this.self.registerWorkerSource = (e1, t1)=>{
                    if (this.workerSourceTypes[e1]) throw new Error(`Worker source with name "${e1}" already registered.`);
                    this.workerSourceTypes[e1] = t1;
                }, this.self.registerRTLTextPlugin = (e1)=>{
                    if (t1.fA.isParsed()) throw new Error("RTL text plugin already registered.");
                    t1.fA.setState({
                        pluginStatus: t1.fB.parsed,
                        pluginURL: t1.fA.getPluginURL()
                    }), t1.fA.applyArabicShaping = e1.applyArabicShaping, t1.fA.processBidirectionalText = e1.processBidirectionalText, t1.fA.processStyledBidirectionalText = e1.processStyledBidirectionalText;
                    for (const e1 of this.rtlPluginParsingListeners)e1(null, !0);
                    this.rtlPluginParsingListeners = [];
                };
            }
            clearCaches(e1, t1, s) {
                delete this.layerIndexes[e1], delete this.availableImages[e1], delete this.availableModels[e1], delete this.workerSources[e1], s();
            }
            checkIfReady(e1, t1, s) {
                s();
            }
            setReferrer(e1, t1) {
                this.referrer = t1;
            }
            spriteLoaded(e1, s) {
                this.isSpriteLoaded[e1] || (this.isSpriteLoaded[e1] = {});
                const { scope: i, isLoaded: o } = s;
                if (this.isSpriteLoaded[e1][i] = o, this.workerSources[e1] && this.workerSources[e1][i]) for(const s in this.workerSources[e1][i]){
                    const n = this.workerSources[e1][i][s];
                    for(const e1 in n){
                        const s = n[e1];
                        s instanceof w && (s.isSpriteLoaded = o, s.fire(new t1.C("isSpriteLoaded")));
                    }
                }
            }
            setImages(e1, t1, s) {
                this.availableImages[e1] || (this.availableImages[e1] = {});
                const { scope: i, images: o } = t1;
                if (this.availableImages[e1][i] = o, this.workerSources[e1] && this.workerSources[e1][i]) {
                    for(const t1 in this.workerSources[e1][i]){
                        const s = this.workerSources[e1][i][t1];
                        for(const e1 in s)s[e1].availableImages = o;
                    }
                    s();
                } else s();
            }
            setModels(e1, { scope: t1, models: s }, i) {
                if (this.availableModels[e1] || (this.availableModels[e1] = {}), this.availableModels[e1][t1] = s, this.workerSources[e1] && this.workerSources[e1][t1]) {
                    for(const i in this.workerSources[e1][t1]){
                        const o = this.workerSources[e1][t1][i];
                        for(const e1 in o)o[e1].availableModels = s;
                    }
                    i();
                } else i();
            }
            setProjection(e1, s) {
                this.projections[e1] = t1.c1(s);
            }
            setBrightness(e1, t1, s) {
                this.brightness = t1, s();
            }
            setContextParams(e1, t1, s) {
                this.maxUniformBufferBindings = t1.maxBindingPoints, this.maxUniformBlockSizeDwords = t1.maxUniformBlockSizeDwords, this.disableSymbolUBO = t1.disableSymbolUBO, s();
            }
            setWorldview(e1, t1, s) {
                this.worldview = t1, s();
            }
            setLayers(e1, t1, s) {
                this.getLayerIndex(e1, t1.scope).replace(t1.layers, t1.options), s();
            }
            updateLayers(e1, t1, s) {
                this.getLayerIndex(e1, t1.scope).update(t1.layers, t1.removedIds, t1.options), s();
            }
            loadTile(e1, t1, s) {
                t1.projection = this.projections[e1] || this.defaultProjection, this.getWorkerSource(e1, t1).loadTile(t1, s);
            }
            decodeRasterArray(e1, t1, s) {
                this.getWorkerSource(e1, t1).decodeRasterArray(t1, s);
            }
            reloadTile(e1, t1, s) {
                t1.projection = this.projections[e1] || this.defaultProjection, this.getWorkerSource(e1, t1).reloadTile(t1, s);
            }
            abortTile(e1, t1, s) {
                this.getWorkerSource(e1, t1).abortTile(t1, s);
            }
            removeTile(e1, t1, s) {
                this.getWorkerSource(e1, t1).removeTile(t1, s);
            }
            removeSource(e1, t1, s) {
                if (!(this.workerSources[e1] && this.workerSources[e1][t1.scope] && this.workerSources[e1][t1.scope][t1.type] && this.workerSources[e1][t1.scope][t1.type][t1.source])) return;
                const i = this.workerSources[e1][t1.scope][t1.type][t1.source];
                delete this.workerSources[e1][t1.scope][t1.type][t1.source], void 0 !== i.removeSource ? i.removeSource(t1, s) : s();
            }
            loadTileProvider(e1, t1, s) {
                (async function(e1, t1) {
                    const s = Le.get(e1);
                    if (s) return s;
                    const i = De.get(e1);
                    if (void 0 !== i) return i;
                    const o = import(t1).then((t1)=>{
                        const s = t1.default;
                        if ("function" != typeof s) throw new Error(`TileProvider "${e1}" module must default-export a class`);
                        if ("function" != typeof s.prototype.loadTile) throw new Error(`TileProvider "${e1}" class must have a loadTile method`);
                        return Le.set(e1, s), s;
                    }).finally(()=>{
                        De.delete(e1);
                    });
                    return De.set(e1, o), o;
                })(t1.name, t1.url).then((s)=>{
                    const i = new s(t1.options);
                    return this.getWorkerSource(e1, {
                        type: t1.type,
                        source: t1.source,
                        scope: t1.scope
                    }, i), i.load && t1.request ? i.load({
                        request: t1.request
                    }) : null;
                }).then((e1)=>s(null, e1)).catch((e1)=>s(e1 instanceof Error ? e1 : new Error("string" == typeof e1 ? e1 : "Unknown error")));
            }
            loadWorkerSource(e1, t1, s) {
                try {
                    this.self.importScripts(t1.url), s();
                } catch (e1) {
                    s(e1);
                }
            }
            syncRTLPluginState(e1, s, i) {
                if (t1.fA.isParsed()) i(null, !0);
                else if (t1.fA.isParsing()) this.rtlPluginParsingListeners.push(i);
                else try {
                    t1.fA.setState(s);
                    const e1 = t1.fA.getPluginURL();
                    !t1.fA.isLoaded() || t1.fA.isParsed() || t1.fA.isParsing() || null == e1 || (t1.fA.setState({
                        pluginStatus: t1.fB.parsing,
                        pluginURL: t1.fA.getPluginURL()
                    }), this.self.importScripts(e1), t1.fA.isParsed() ? i(null, !0) : this.rtlPluginParsingListeners.push(i));
                } catch (e1) {
                    i(e1);
                }
            }
            setConfig(e1, s) {
                Object.assign(t1.e, s);
            }
            getAvailableImages(e1, t1) {
                this.availableImages[e1] || (this.availableImages[e1] = {});
                let s = this.availableImages[e1][t1];
                return s || (s = []), s;
            }
            getAvailableModels(e1, t1) {
                this.availableModels[e1] || (this.availableModels[e1] = {});
                let s = this.availableModels[e1][t1];
                return s || (s = {}), s;
            }
            getLayerIndex(e1, t1) {
                this.layerIndexes[e1] || (this.layerIndexes[e1] = {});
                let s = this.layerIndexes[e1][t1];
                return s || (s = this.layerIndexes[e1][t1] = new r, s.scope = t1), s;
            }
            getWorkerSource(e1, t1, s) {
                const { type: i, source: o, scope: n } = t1, r = this.workerSources;
                if (r[e1] || (r[e1] = {}), r[e1][n] || (r[e1][n] = {}), r[e1][n][i] || (r[e1][n][i] = {}), this.isSpriteLoaded[e1] || (this.isSpriteLoaded[e1] = {}), !r[e1][n][i][o]) {
                    const t1 = {
                        send: (t1, s, i, o, n, r)=>this.actor.send(t1, s, i, e1, n, r),
                        scheduler: this.actor.scheduler
                    }, a = this.workerSourceTypes[i];
                    if (!a) throw new Error(`Unknown worker source type "${i}".`);
                    r[e1][n][i][o] = new a({
                        actor: t1,
                        layerIndex: this.getLayerIndex(e1, n),
                        availableImages: this.getAvailableImages(e1, n),
                        availableModels: this.getAvailableModels(e1, n),
                        isSpriteLoaded: this.isSpriteLoaded[e1][n],
                        tileProvider: s,
                        brightness: this.brightness,
                        worldview: this.worldview,
                        maxUniformBufferBindings: this.maxUniformBufferBindings,
                        maxUniformBlockSizeDwords: this.maxUniformBlockSizeDwords,
                        disableSymbolUBO: this.disableSymbolUBO
                    });
                }
                return r[e1][n][i][o];
            }
            rasterizeImagesWorker(e1, t1, s) {
                const i = new Map;
                for (const [s, { image: o, imageVariant: n }] of t1.tasks.entries()){
                    const r = this.imageRasterizer.rasterize(n, o, t1.scope, e1);
                    i.set(s, r);
                }
                s(void 0, i);
            }
            removeRasterizedImages(e1, t1, s) {
                this.imageRasterizer.removeImagesFromCacheByIds(t1.imageIds, t1.scope, e1), s();
            }
            enforceCacheSizeLimit(e1, s) {
                t1.fC(s);
            }
            getWorkerPerformanceMetrics(e1, t1, s) {
                s(void 0, void 0);
            }
        }
        return t1.fz(self) && (self.worker = new Oe(self)), Oe;
    });
    define([
        "./shared"
    ], function(e1) {
        var t1 = "3.21.0";
        const i = {
            create: "create",
            load: "load",
            fullLoad: "fullLoad"
        }, o = {
            mark (e1) {
                performance.mark(e1);
            },
            measure (e1, t1, i) {
                performance.measure(e1, t1, i);
            }
        };
        function r(t1) {
            const i = t1.name.split("?")[0];
            return e1.a(i) && i.includes("mapbox-gl.js") ? "javascript" : e1.a(i) && i.includes("mapbox-gl.css") ? "css" : e1.b(i) ? "fontRange" : e1.c(i) ? "sprite" : e1.i(i) ? "style" : e1.d(i) ? "tilejson" : "other";
        }
        var n, s = {}, a = function() {
            if (n) return s;
            function e1(e1) {
                return !t1(e1);
            }
            function t1(t1) {
                var o;
                return "undefined" == typeof window || "undefined" == typeof document ? "not a browser" : function() {
                    if (!("Worker" in window && "Blob" in window && "URL" in window)) return !1;
                    var e1, t1, i = new Blob([
                        ""
                    ], {
                        type: "text/javascript"
                    }), o = URL.createObjectURL(i);
                    try {
                        t1 = new Worker(o), e1 = !0;
                    } catch (t1) {
                        e1 = !1;
                    }
                    return t1 && t1.terminate(), URL.revokeObjectURL(o), e1;
                }() ? function() {
                    var e1 = document.createElement("canvas");
                    e1.width = e1.height = 1;
                    var t1 = e1.getContext("2d");
                    if (!t1) return !1;
                    var i = t1.getImageData(0, 0, 1, 1);
                    return i && i.width === e1.width;
                }() ? (void 0 === i[o = t1 && t1.failIfMajorPerformanceCaveat] && (i[o] = function(t1) {
                    var i, o = function(t1) {
                        var i = document.createElement("canvas"), o = Object.create(e1.webGLContextAttributes);
                        return o.failIfMajorPerformanceCaveat = t1, i.getContext("webgl2", o);
                    }(t1);
                    if (!o) return !1;
                    try {
                        i = o.createShader(o.VERTEX_SHADER);
                    } catch (e1) {
                        return !1;
                    }
                    return !(!i || o.isContextLost()) && (o.shaderSource(i, "void main() {}"), o.compileShader(i), !0 === o.getShaderParameter(i, o.COMPILE_STATUS));
                }(o)), i[o] ? document.documentMode ? "insufficient ECMAScript 6 support" : void 0 : "insufficient WebGL2 support") : "insufficient Canvas/getImageData support" : "insufficient worker support";
            }
            n = 1, s.supported = e1, s.notSupportedReason = t1;
            var i = {};
            return e1.webGLContextAttributes = {
                antialias: !1,
                alpha: !0,
                stencil: !0,
                depth: !0
            }, s;
        }();
        function l(e1, t1, i) {
            const o = document.createElement(e1);
            return null != t1 && (o.className = t1), i && i.appendChild(o), o;
        }
        function c(e1, t1, i) {
            const o = document.createElementNS("http://www.w3.org/2000/svg", e1);
            for (const e1 of Object.keys(t1))o.setAttributeNS(null, e1, String(t1[e1]));
            return i && i.appendChild(o), o;
        }
        const h = "undefined" != typeof document ? document.documentElement && document.documentElement.style : null, d = h && void 0 !== h.userSelect ? "userSelect" : "WebkitUserSelect";
        let _;
        function u() {
            h && d && (_ = h[d], h[d] = "none");
        }
        function p() {
            h && d && (h[d] = _);
        }
        function f(e1) {
            e1.preventDefault(), e1.stopPropagation(), window.removeEventListener("click", f, !0);
        }
        function m() {
            window.addEventListener("click", f, !0), window.setTimeout(()=>{
                window.removeEventListener("click", f, !0);
            }, 0);
        }
        function g(e1, t1) {
            const i = e1.getBoundingClientRect();
            return x(e1, i, t1);
        }
        function v(e1, t1) {
            const i = e1.getBoundingClientRect(), o = [];
            for(let r = 0; r < t1.length; r++)o.push(x(e1, i, t1[r]));
            return o;
        }
        function y(e1) {
            return /firefox/i.test(navigator.userAgent) && /macintosh/i.test(navigator.userAgent) && 2 === e1.button && e1.ctrlKey ? 0 : e1.button;
        }
        function x(t1, i, o) {
            const r = t1.offsetWidth === i.width ? 1 : t1.offsetWidth / i.width;
            return new e1.P((o.clientX - i.left) * r, (o.clientY - i.top) * r);
        }
        const b = "01", w = "NO_ACCESS_TOKEN";
        class T {
            constructor(e1, t1, i){
                this._transformRequestFn = e1, this._customAccessToken = t1, this._silenceAuthErrors = !!i, this._createSkuToken();
            }
            _createSkuToken() {
                const e1 = function() {
                    let e1 = "";
                    for(let t1 = 0; t1 < 10; t1++)e1 += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62 * Math.random())];
                    return {
                        token: [
                            "1",
                            b,
                            e1
                        ].join(""),
                        tokenExpiresAt: Date.now() + 432e5
                    };
                }();
                this._skuToken = e1.token, this._skuTokenExpiresAt = e1.tokenExpiresAt;
            }
            _isSkuTokenExpired() {
                return Date.now() > this._skuTokenExpiresAt;
            }
            transformRequest(e1, t1) {
                return this._transformRequestFn && this._transformRequestFn(e1, t1) || {
                    url: e1
                };
            }
            normalizeStyleURL(i, o) {
                if (!e1.h(i)) return i;
                const r = S(i);
                return r.params.push(`sdk=js-${t1}`), r.path = `/styles/v1${r.path}`, this._makeAPIURL(r, this._customAccessToken || o);
            }
            normalizeGlyphsURL(t1, i) {
                if (!e1.h(t1)) return t1;
                const o = S(t1);
                return o.path = `/fonts/v1${o.path}`, this._makeAPIURL(o, this._customAccessToken || i);
            }
            normalizeModelURL(t1, i) {
                if (!e1.h(t1)) return t1;
                const o = S(t1);
                return o.path = `/models/v1${o.path}`, this._makeAPIURL(o, this._customAccessToken || i);
            }
            normalizeSourceURL(t1, i, o, r) {
                if (!e1.h(t1)) return t1;
                const n = S(t1);
                return n.path = `/v4/${n.authority}.json`, n.params.push("secure"), o && n.params.push(`language=${o}`), r && n.params.push(`worldview=${r}`), this._makeAPIURL(n, this._customAccessToken || i);
            }
            normalizeIconsetURL(t1, i) {
                const o = S(t1);
                return e1.h(t1) ? (o.path = `/styles/v1${o.path}/iconset.pbf`, this._makeAPIURL(o, this._customAccessToken || i)) : C(o);
            }
            normalizeSpriteURL(t1, i, o, r) {
                const n = S(t1);
                return e1.h(t1) ? (n.path = `/styles/v1${n.path}/sprite${i}${o}`, this._makeAPIURL(n, this._customAccessToken || r)) : (n.path += `${i}${o}`, C(n));
            }
            normalizeTileURL(t1, i, o) {
                if (this._isSkuTokenExpired() && this._createSkuToken(), t1 && !e1.h(t1)) return t1;
                const r = S(t1);
                r.path = r.path.replace(/(\.(png|jpg)\d*)(?=$)/, `${i || o && "raster" !== r.authority && 512 === o ? "@2x" : ""}${e1.k.supported ? ".webp" : "$1"}`), "raster" === r.authority ? r.path = `/${e1.e.RASTER_URL_PREFIX}${r.path}` : "rasterarrays" === r.authority ? r.path = `/${e1.e.RASTERARRAYS_URL_PREFIX}${r.path}` : "3dtiles" === r.authority ? r.path = `/${e1.e.TILES3D_URL_PREFIX}${r.path}` : (r.path = r.path.replace(/^.+\/v4\//, "/"), r.path = `/${e1.e.TILE_URL_VERSION}${r.path}`);
                const n = this._customAccessToken || function(e1) {
                    for (const t1 of e1){
                        const e1 = t1.match(/^access_token=(.*)$/);
                        if (e1) return e1[1];
                    }
                    return null;
                }(r.params) || e1.e.ACCESS_TOKEN;
                return e1.e.REQUIRE_ACCESS_TOKEN && n && this._skuToken && r.params.push(`sku=${this._skuToken}`), this._makeAPIURL(r, n);
            }
            canonicalizeTileURL(t1, i) {
                const o = S(t1);
                if (!o.path.match(/^(\/v4\/|\/(raster|rasterarrays)\/v1\/)/) || !o.path.match(/\.[\w]+$/)) return t1;
                let r = "mapbox://";
                o.path.match(/^\/raster\/v1\//) ? r += `raster/${o.path.replace(`/${e1.e.RASTER_URL_PREFIX}/`, "")}` : o.path.match(/^\/rasterarrays\/v1\//) ? r += `rasterarrays/${o.path.replace(`/${e1.e.RASTERARRAYS_URL_PREFIX}/`, "")}` : r += `tiles/${o.path.replace(`/${e1.e.TILE_URL_VERSION}/`, "")}`;
                let n = o.params;
                return i && (n = n.filter((e1)=>!e1.match(/^access_token=/))), n.length && (r += `?${n.join("&")}`), r;
            }
            canonicalizeTileset(t1, i) {
                const o = !!i && e1.h(i), r = [];
                for (const i of t1.tiles || [])e1.j(i) ? r.push(this.canonicalizeTileURL(i, o)) : r.push(i);
                return r;
            }
            _makeAPIURL(t1, i) {
                const o = "See https://docs.mapbox.com/api/overview/#access-tokens-and-token-scopes", r = S(e1.e.API_URL);
                if (t1.protocol = r.protocol, t1.authority = r.authority, "http" === t1.protocol) {
                    const e1 = t1.params.indexOf("secure");
                    e1 >= 0 && t1.params.splice(e1, 1);
                }
                if ("/" !== r.path && (t1.path = `${r.path}${t1.path}`), !e1.e.REQUIRE_ACCESS_TOKEN) return C(t1);
                if (i = i || e1.e.ACCESS_TOKEN, !this._silenceAuthErrors) {
                    if (!i) throw new Error(`An API access token is required to use Mapbox GL. ${o}`);
                    if ("s" === i[0]) throw new Error(`Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). ${o}`);
                }
                return t1.params = t1.params.filter((e1)=>-1 === e1.indexOf("access_token")), t1.params.push(`access_token=${i || ""}`), C(t1);
            }
        }
        const E = /^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;
        function S(e1) {
            const t1 = e1.match(E);
            if (!t1) throw new Error("Unable to parse URL object");
            return {
                protocol: t1[1],
                authority: t1[2],
                path: t1[3] || "/",
                params: t1[4] ? t1[4].split("&") : []
            };
        }
        function C(e1) {
            const t1 = e1.params.length ? `?${e1.params.join("&")}` : "";
            return `${e1.protocol}://${e1.authority}${e1.path}${t1}`;
        }
        const I = "mapbox.eventData";
        function R(t1) {
            if (!t1) return null;
            const i = t1.split(".");
            if (!i || 3 !== i.length) return null;
            try {
                return JSON.parse(e1.l(i[1]));
            } catch (e1) {
                return null;
            }
        }
        class D {
            constructor(e1){
                this.type = e1, this.anonId = null, this.anonIdTimestamp = null, this.eventData = {}, this.queue = [], this.pendingRequest = null;
            }
            getStorageKey(t1) {
                const i = R(e1.e.ACCESS_TOKEN);
                let o = "";
                return o = i && i.u ? e1.f(i.u) : e1.e.ACCESS_TOKEN || "", t1 ? `${I}.${t1}:${o}` : `${I}:${o}`;
            }
            fetchEventData() {
                const t1 = e1.s("localStorage"), i = this.getStorageKey(), o = this.getStorageKey("uuid"), r = this.getStorageKey("uuidTimestamp");
                if (t1) try {
                    const e1 = localStorage.getItem(i);
                    e1 && (this.eventData = JSON.parse(e1));
                    const t1 = localStorage.getItem(o);
                    t1 && (this.anonId = t1);
                    const n = localStorage.getItem(r);
                    n && (this.anonIdTimestamp = Number(n));
                    const s = Date.now() - 864e5;
                    (!this.anonIdTimestamp || this.anonIdTimestamp < s) && this.refreshUUID();
                } catch (t1) {
                    e1.w("Unable to read from LocalStorage");
                }
            }
            refreshUUID() {
                this.anonId = e1.u(), this.anonIdTimestamp = Date.now();
            }
            saveEventData() {
                const t1 = e1.s("localStorage"), i = this.getStorageKey(), o = this.getStorageKey("uuid"), r = this.getStorageKey("uuidTimestamp"), n = this.anonId, s = this.anonIdTimestamp;
                if (t1 && n) try {
                    localStorage.setItem(o, n), Object.keys(this.eventData).length >= 1 && localStorage.setItem(i, JSON.stringify(this.eventData)), s && localStorage.setItem(r, s.toString());
                } catch (t1) {
                    e1.w("Unable to write to LocalStorage");
                }
            }
            processRequests(e1) {}
            postEvent(t1, i, o, r) {
                if (!e1.e.EVENTS_URL) return;
                const n = S(e1.e.EVENTS_URL);
                n.params.push(`access_token=${r || e1.e.ACCESS_TOKEN || ""}`);
                const s = {
                    event: this.type,
                    created: new Date(t1).toISOString()
                }, a = i ? Object.assign(s, i) : s, l = {
                    url: C(n),
                    headers: {
                        "Content-Type": "text/plain"
                    },
                    body: JSON.stringify([
                        a
                    ])
                };
                this.pendingRequest = e1.p(l, (e1)=>{
                    this.pendingRequest = null, o(e1), this.saveEventData(), this.processRequests(r);
                });
            }
            queueRequest(e1, t1) {
                this.queue.push(e1), this.processRequests(t1);
            }
        }
        class A extends D {
            constructor(e1){
                super("metrics"), e1 && (this.data = e1);
            }
            postMetricsEvent(t1) {
                if (!e1.e.EVENTS_URL || !t1 && !e1.e.ACCESS_TOKEN) return;
                this.anonId || this.fetchEventData(), e1.v(this.anonId) || this.refreshUUID();
                const i = Object.assign({}, this.data, {
                    sessionId: this.anonId
                });
                this.queueRequest({
                    timestamp: Date.now(),
                    payload: i
                }, t1);
            }
            processRequests(e1) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { timestamp: t1, payload: i } = this.queue.shift();
                this.postEvent(t1, i, ()=>{}, e1);
            }
        }
        const L = new class extends D {
            constructor(e1){
                super("appUserTurnstile"), this._customAccessToken = e1;
            }
            postTurnstileEvent(t1, i) {
                e1.e.EVENTS_URL && e1.e.ACCESS_TOKEN && Array.isArray(t1) && t1.some((t1)=>e1.h(t1) || e1.j(t1)) && this.queueRequest(Date.now(), i);
            }
            processRequests(i) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                this.anonId && this.anonIdTimestamp && this.eventData.lastSuccess && this.eventData.tokenU || this.fetchEventData();
                const o = R(e1.e.ACCESS_TOKEN), r = o ? o.u : e1.e.ACCESS_TOKEN;
                let n = r !== this.eventData.tokenU;
                e1.v(this.anonId) || (this.refreshUUID(), n = !0);
                const s = this.queue.shift();
                if (this.eventData.lastSuccess) {
                    const e1 = new Date(this.eventData.lastSuccess), t1 = new Date(s), i = (s - this.eventData.lastSuccess) / 864e5;
                    n = n || i >= 1 || i < -1 || e1.getDate() !== t1.getDate();
                } else n = !0;
                n ? this.postEvent(s, {
                    sdkIdentifier: "mapbox-gl-js",
                    sdkVersion: t1,
                    skuId: b,
                    "enabled.telemetry": !1,
                    userId: this.anonId
                }, (e1)=>{
                    e1 || (this.eventData.lastSuccess = s, this.eventData.tokenU = r);
                }, i) : this.processRequests();
            }
        }, P = L.postTurnstileEvent.bind(L), O = new class extends D {
            constructor(){
                super("map.load"), this.success = {}, this.skuToken = "";
            }
            postMapLoadEvent(t1, i, o, r) {
                this.skuToken = i, this.errorCb = r, e1.e.EVENTS_URL && (o || e1.e.ACCESS_TOKEN ? this.queueRequest({
                    id: t1,
                    timestamp: Date.now()
                }, o) : this.errorCb(new Error(w)));
            }
            processRequests(i) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { id: o, timestamp: r } = this.queue.shift();
                o && this.success[o] || (this.anonId && this.anonIdTimestamp || this.fetchEventData(), e1.v(this.anonId) || this.refreshUUID(), this.postEvent(r, {
                    sdkIdentifier: "mapbox-gl-js",
                    sdkVersion: t1,
                    skuId: b,
                    skuToken: this.skuToken,
                    userId: this.anonId
                }, (e1)=>{
                    e1 ? this.errorCb(e1) : o && (this.success[o] = !0);
                }, i));
            }
            remove() {
                this.errorCb = null;
            }
        }, M = O.postMapLoadEvent.bind(O), z = new class extends D {
            constructor(){
                super("style.load"), this.eventIdPerMapInstanceMap = new Map, this.mapInstanceIdMap = new WeakMap;
            }
            getMapInstanceId(t1) {
                let i = this.mapInstanceIdMap.get(t1);
                return i || (i = e1.u(), this.mapInstanceIdMap.set(t1, i)), i;
            }
            getEventId(e1) {
                const t1 = this.eventIdPerMapInstanceMap.get(e1) || 0;
                return this.eventIdPerMapInstanceMap.set(e1, t1 + 1), t1;
            }
            postStyleLoadEvent(t1, i) {
                const { map: o, style: r, importedStyles: n } = i;
                if (!e1.e.EVENTS_URL || !t1 && !e1.e.ACCESS_TOKEN) return;
                const s = this.getMapInstanceId(o), a = {
                    mapInstanceId: s,
                    eventId: this.getEventId(s),
                    style: r
                };
                n.length && (a.importedStyles = n), this.queueRequest({
                    timestamp: Date.now(),
                    payload: a
                }, t1);
            }
            processRequests(e1) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { timestamp: t1, payload: i } = this.queue.shift();
                this.postEvent(t1, i, ()=>{}, e1);
            }
        }, F = z.postStyleLoadEvent.bind(z), B = new A({
            attributes: [
                {
                    name: "maps/js/layer-animations/style-with-appearances"
                }
            ]
        }), k = B.postMetricsEvent.bind(B), N = new A({
            attributes: [
                {
                    name: "maps/js/layer-animations/runtime-appearances"
                }
            ]
        }), U = N.postMetricsEvent.bind(N), V = new class extends D {
            constructor(){
                super("gljs.performance");
            }
            postPerformanceEvent(t1, i) {
                e1.e.EVENTS_URL && (t1 || e1.e.ACCESS_TOKEN) && this.queueRequest({
                    timestamp: Date.now(),
                    performanceData: i
                }, t1);
            }
            processRequests(o) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { timestamp: n, performanceData: s } = this.queue.shift(), a = function(o) {
                    const n = performance.getEntriesByType("resource"), s = performance.getEntriesByType("mark"), a = function(e1) {
                        const t1 = {};
                        if (e1) {
                            for(const i in e1)if ("other" !== i) for (const o of e1[i]){
                                const e1 = `${i}ResolveRangeMin`, r = `${i}ResolveRangeMax`, n = `${i}RequestCount`, s = `${i}RequestCachedCount`;
                                t1[e1] = Math.min(t1[e1] || 1 / 0, o.startTime), t1[r] = Math.max(t1[r] || -1 / 0, o.responseEnd);
                                const a = (e1)=>{
                                    void 0 === t1[e1] && (t1[e1] = 0), ++t1[e1];
                                };
                                void 0 !== o.transferSize && 0 === o.transferSize && a(s), a(n);
                            }
                        }
                        return t1;
                    }(function(e1, t1) {
                        const i = {};
                        if (e1) for (const o of e1){
                            const e1 = t1(o);
                            void 0 === i[e1] && (i[e1] = []), i[e1].push(o);
                        }
                        return i;
                    }(n, r)), l = window.devicePixelRatio, c = navigator.connection || navigator.mozConnection || navigator.webkitConnection, h = c ? c.effectiveType : void 0, d = {
                        counters: [],
                        metadata: [],
                        attributes: []
                    }, _ = (e1, t1, i)=>{
                        null != i && e1.push({
                            name: t1,
                            value: i.toString()
                        });
                    };
                    for(const e1 in a)_(d.counters, e1, a[e1]);
                    if (o.interactionRange[0] !== 1 / 0 && o.interactionRange[1] !== -1 / 0 && (_(d.counters, "interactionRangeMin", o.interactionRange[0]), _(d.counters, "interactionRangeMax", o.interactionRange[1])), s) for (const e1 of Object.values(i)){
                        const t1 = s.find((t1)=>t1.name === e1);
                        t1 && _(d.counters, e1, t1.startTime);
                    }
                    return _(d.counters, "visibilityHidden", o.visibilityHidden), _(d.attributes, "style", function(t1) {
                        if (t1) for (const i of t1){
                            const t1 = i.name.split("?")[0];
                            if (e1.i(t1)) {
                                const e1 = t1.split("/").slice(-2);
                                if (2 === e1.length) return `mapbox://styles/${e1[0]}/${e1[1]}`;
                            }
                        }
                    }(n)), _(d.attributes, "terrainEnabled", o.terrainEnabled ? "true" : "false"), _(d.attributes, "fogEnabled", o.fogEnabled ? "true" : "false"), _(d.attributes, "projection", o.projection), _(d.attributes, "zoom", o.zoom), _(d.metadata, "devicePixelRatio", l), _(d.metadata, "connectionEffectiveType", h), _(d.metadata, "navigatorUserAgent", navigator.userAgent), _(d.metadata, "screenWidth", window.screen.width), _(d.metadata, "screenHeight", window.screen.height), _(d.metadata, "windowWidth", window.innerWidth), _(d.metadata, "windowHeight", window.innerHeight), _(d.metadata, "mapWidth", o.width / l), _(d.metadata, "mapHeight", o.height / l), _(d.metadata, "webglRenderer", o.renderer), _(d.metadata, "webglVendor", o.vendor), _(d.metadata, "sdkVersion", t1), _(d.metadata, "sdkIdentifier", "mapbox-gl-js"), d;
                }(s);
                for (const e1 of a.metadata);
                for (const e1 of a.counters);
                for (const e1 of a.attributes);
                this.postEvent(n, a, ()=>{}, o);
            }
        }, j = V.postPerformanceEvent.bind(V), G = new class extends D {
            constructor(){
                super("map.auth"), this.success = {}, this.skuToken = "";
            }
            getSession(t1, i, o, r) {
                if (!e1.e.API_URL || !e1.e.SESSION_PATH) return;
                const n = S(e1.e.API_URL + e1.e.SESSION_PATH);
                n.params.push(`sku=${i || ""}`), n.params.push(`access_token=${r || e1.e.ACCESS_TOKEN || ""}`);
                const s = {
                    url: C(n),
                    headers: {
                        "Content-Type": "text/plain"
                    }
                };
                this.pendingRequest = e1.g(s, (e1)=>{
                    this.pendingRequest = null, o(e1), this.saveEventData(), this.processRequests(r);
                });
            }
            getSessionAPI(t1, i, o, r) {
                this.skuToken = i, this.errorCb = r, e1.e.SESSION_PATH && e1.e.API_URL && (o || e1.e.ACCESS_TOKEN ? this.queueRequest({
                    id: t1,
                    timestamp: Date.now()
                }, o) : this.errorCb(new Error(w)));
            }
            processRequests(e1) {
                if (this.pendingRequest || 0 === this.queue.length) return;
                const { id: t1, timestamp: i } = this.queue.shift();
                t1 && this.success[t1] || this.getSession(i, this.skuToken, (e1)=>{
                    e1 ? this.errorCb(e1) : t1 && (this.success[t1] = !0);
                }, e1);
            }
            remove() {
                this.errorCb = null;
            }
        }, q = G.getSessionAPI.bind(G), Z = new Set;
        function H(e1, t1) {
            t1 ? Z.add(e1) : Z.delete(e1);
        }
        class W {
            constructor(){
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSourceCaches = {}, this._updatedPaintProps = new Set, this._updatedImages = {};
            }
            isDirty() {
                return this._changed;
            }
            setDirty() {
                this._changed = !0;
            }
            getUpdatedSourceCaches() {
                return this._updatedSourceCaches;
            }
            updateSourceCache(e1, t1) {
                this._updatedSourceCaches[e1] = t1, this.setDirty();
            }
            discardSourceCacheUpdate(e1) {
                delete this._updatedSourceCaches[e1];
            }
            updateLayer(e1) {
                const t1 = e1.scope;
                this._updatedLayers[t1] = this._updatedLayers[t1] || new Set, this._updatedLayers[t1].add(e1.id), this.setDirty();
            }
            removeLayer(e1) {
                const t1 = e1.scope;
                this._removedLayers[t1] = this._removedLayers[t1] || {}, this._updatedLayers[t1] = this._updatedLayers[t1] || new Set, this._removedLayers[t1][e1.id] = e1, this._updatedLayers[t1].delete(e1.id), this._updatedPaintProps.delete(e1.fqid), this.setDirty();
            }
            getRemovedLayer(e1) {
                return this._removedLayers[e1.scope] ? this._removedLayers[e1.scope][e1.id] : null;
            }
            discardLayerRemoval(e1) {
                this._removedLayers[e1.scope] && delete this._removedLayers[e1.scope][e1.id];
            }
            getLayerUpdatesByScope() {
                const e1 = {};
                for(const t1 in this._updatedLayers)e1[t1] = e1[t1] || {}, e1[t1].updatedIds = Array.from(this._updatedLayers[t1].values());
                for(const t1 in this._removedLayers)e1[t1] = e1[t1] || {}, e1[t1].removedIds = Object.keys(this._removedLayers[t1]);
                return e1;
            }
            getUpdatedPaintProperties() {
                return this._updatedPaintProps;
            }
            updatePaintProperties(e1) {
                this._updatedPaintProps.add(e1.fqid), this.setDirty();
            }
            getUpdatedImages(e1) {
                return this._updatedImages[e1] ? Array.from(this._updatedImages[e1].values()) : [];
            }
            updateImage(t1, i) {
                this._updatedImages[i] = this._updatedImages[i] || new Set, this._updatedImages[i].add(e1.I.toString(t1)), this.setDirty();
            }
            resetUpdatedImages(e1) {
                this._updatedImages[e1] && this._updatedImages[e1].clear();
            }
            reset() {
                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSourceCaches = {}, this._updatedPaintProps.clear(), this._updatedImages = {};
            }
        }
        function $(e1) {
            const { userImage: t1 } = e1;
            return !!(t1 && t1.render && t1.render()) && (e1.data.replace(new Uint8Array(t1.data.buffer)), !0);
        }
        const X = {
            workerUrl: "",
            workerClass: null,
            workerParams: void 0
        };
        function Y(e1) {
            return null != X.workerClass ? new X.workerClass : new self.Worker(X.workerUrl, Object.assign({
                name: e1
            }, X.workerParams));
        }
        const K = "mapboxgl_preloaded_worker_pool";
        class Q {
            constructor(e1){
                this.active = {}, this.name = e1;
            }
            acquire(e1, t1 = Q.workerCount) {
                if (!this.workers) for(this.workers = []; this.workers.length < t1;){
                    const t1 = Y(`${this.name || ""}WorkerPool: ${e1}-${this.workers.length}`);
                    this.workers.push(t1);
                }
                return this.active[e1] = !0, this.workers.slice();
            }
            release(e1) {
                delete this.active[e1], this.workers && 0 === this.numActive() && (this.workers.forEach((e1)=>{
                    e1.terminate();
                }), this.workers = null);
            }
            isPreloaded() {
                return !!this.active[K];
            }
            numActive() {
                return Object.keys(this.active).length;
            }
        }
        Q.workerCount = 2;
        class J {
            constructor(t1, i, o = "Worker", r = Q.workerCount){
                this.workerPool = t1, this.actors = [], this.currentActor = 0, this.id = e1.r();
                const n = this.workerPool.acquire(this.id, r);
                for(let e1 = 0; e1 < n.length; e1++){
                    const t1 = new J.Actor(n[e1], i, this.id);
                    t1.name = `${o} ${e1}`, this.actors.push(t1);
                }
                this.ready = !1, this.broadcast("checkIfReady", null, ()=>{
                    this.ready = !0;
                });
            }
            broadcast(t1, i, o) {
                e1.t(this.actors, (e1, o)=>{
                    e1.send(t1, i, o);
                }, o = o || function() {});
            }
            getActor() {
                return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
            }
            remove() {
                this.actors.forEach((e1)=>{
                    e1.remove();
                }), this.actors = [], this.workerPool.release(this.id);
            }
        }
        let ee, te;
        function ie() {
            return ee || (ee = new Q), ee;
        }
        J.Actor = e1.A;
        class oe extends e1.E {
            constructor(t1){
                super(), this.imageProviders = new Map, this.images = new Map, this.updatedImages = new Map, this.callbackDispatchedThisFrame = new Map, this.imageVersions = new Map, this.loaded = new Map, this.requestors = [], this.patterns = new Map, this.patternsInFlight = new Set, this.atlasImage = new Map, this.atlasTexture = new Map, this.imageAtlasCache = new e1.x, this.dirty = !0, this.spriteFormat = t1, "raster" !== t1 && e1.y() && (this.imageRasterizerDispatcher = new J((te || (te = new Q("ImageRasterizer")), te), this, "Image Rasterizer Worker", 1));
            }
            addScope(t1) {
                this.loaded.set(t1, !1), this.imageProviders.set(t1, new Map), this.images.set(t1, new Map), this.updatedImages.set(t1, new Set), this.callbackDispatchedThisFrame.set(t1, new Set), this.imageVersions.set(t1, new Map), this.patterns.set(t1, new Map), this.atlasImage.set(t1, new e1.q({
                    width: 1,
                    height: 1
                }));
            }
            removeScope(e1) {
                this.loaded.delete(e1), this.imageProviders.delete(e1), this.images.delete(e1), this.updatedImages.delete(e1), this.callbackDispatchedThisFrame.delete(e1), this.imageVersions.delete(e1), this.patterns.delete(e1), this.atlasImage.delete(e1);
                const t1 = this.atlasTexture.get(e1);
                t1 && (t1.destroy(), this.atlasTexture.delete(e1));
            }
            addImageProvider(e1, t1) {
                this.imageProviders.has(t1) || this.imageProviders.set(t1, new Map), this.imageProviders.get(t1).set(e1.id, e1);
            }
            removeImageProvider(e1, t1) {
                this.imageProviders.has(t1) && this.imageProviders.get(t1).delete(e1);
            }
            getPendingImageProviders() {
                const e1 = [];
                for (const t1 of this.imageProviders.values())for (const i of t1.values())i.hasPendingRequests() && e1.push(i);
                return e1;
            }
            get imageRasterizer() {
                return this._imageRasterizer || (this._imageRasterizer = new e1.z), this._imageRasterizer;
            }
            isLoaded() {
                for (const e1 of this.loaded.keys())if (!this.loaded.get(e1)) return !1;
                return !0;
            }
            setLoaded(e1, t1) {
                if (this.loaded.get(t1) !== e1 && (this.loaded.set(t1, e1), e1)) {
                    for (const { ids: e1, callback: i } of this.requestors)this._notify(e1, t1, i);
                    this.requestors = [];
                }
            }
            hasImage(e1, t1) {
                return !!this.getImage(e1, t1);
            }
            getImage(e1, t1) {
                return this.images.get(t1).get(e1.toString());
            }
            addImage(e1, t1, i) {
                if (this._validate(e1, i)) {
                    this.images.get(t1).set(e1.toString(), i);
                    const o = this.imageVersions.get(t1), r = o.get(e1.toString()) || 0;
                    o.set(e1.toString(), r + 1);
                }
            }
            _validate(t1, i) {
                let o = !0;
                return this._validateStretch(i.stretchX, i.data && i.data.width) || (this.fire(new e1.B(new Error(`Image "${t1.name}" has invalid "stretchX" value`))), o = !1), this._validateStretch(i.stretchY, i.data && i.data.height) || (this.fire(new e1.B(new Error(`Image "${t1.name}" has invalid "stretchY" value`))), o = !1), this._validateContent(i.content, i) || (this.fire(new e1.B(new Error(`Image "${t1.name}" has invalid "content" value`))), o = !1), o;
            }
            _validateStretch(e1, t1) {
                if (!e1) return !0;
                let i = 0;
                for (const o of e1){
                    if (o[0] < i || o[1] < o[0] || t1 < o[1]) return !1;
                    i = o[1];
                }
                return !0;
            }
            _validateContent(e1, t1) {
                if (!e1) return !0;
                if (4 !== e1.length) return !1;
                if (!t1.usvg) {
                    if (e1[0] < 0 || t1.data.width < e1[0]) return !1;
                    if (e1[1] < 0 || t1.data.height < e1[1]) return !1;
                    if (e1[2] < 0 || t1.data.width < e1[2]) return !1;
                    if (e1[3] < 0 || t1.data.height < e1[3]) return !1;
                }
                return !(e1[2] < e1[0] || e1[3] < e1[1]);
            }
            updateImage(e1, t1, i) {
                const o = this.images.get(t1).get(e1.toString());
                i.version = o.version + 1, this.images.get(t1).set(e1.toString(), i), this.updatedImages.get(t1).add(e1);
                const r = this.imageVersions.get(t1), n = r.get(e1.toString()) || 0;
                r.set(e1.toString(), n + 1), this.removeFromImageRasterizerCache(e1, t1);
            }
            clearUpdatedImages(e1) {
                this.updatedImages.get(e1).clear();
            }
            removeFromImageRasterizerCache(t1, i) {
                "raster" !== this.spriteFormat && (e1.y() ? this.imageRasterizerDispatcher.getActor().send("removeRasterizedImages", {
                    imageIds: [
                        t1
                    ],
                    scope: i
                }) : this.imageRasterizer.removeImagesFromCacheByIds([
                    t1
                ], i));
            }
            removeImage(e1, t1) {
                const i = this.images.get(t1), o = i.get(e1.toString());
                i.delete(e1.toString());
                const r = this.imageVersions.get(t1), n = r.get(e1.toString()) || 0;
                r.set(e1.toString(), n + 1), this.patterns.get(t1).delete(e1.toString()), this.removeFromImageRasterizerCache(e1, t1), o.userImage && o.userImage.onRemove && o.userImage.onRemove();
            }
            listImages(t1) {
                return Array.from(this.images.get(t1).keys()).map((t1)=>e1.I.from(t1));
            }
            getImageVersions(e1) {
                const t1 = this.imageVersions.get(e1);
                if (t1) return t1;
            }
            getImages(e1, t1, i) {
                const o = [], r = [], n = this.imageProviders.get(t1);
                for (const i of e1){
                    if (!i.iconsetId) {
                        o.push(i);
                        continue;
                    }
                    const e1 = n.get(i.iconsetId);
                    e1 && (this.getImage(i, t1) ? r.push(i) : e1.addPendingRequest(i));
                }
                if (0 === o.length) return void this._notify(r, t1, i);
                let s = !0;
                const a = !!this.loaded.get(t1), l = this.images.get(t1);
                if (!a) for (const e1 of o)l.has(e1.toString()) || (s = !1);
                a || s ? this._notify(o, t1, i) : this.requestors.push({
                    ids: o,
                    scope: t1,
                    callback: i
                });
            }
            rasterizeImages(e1, t1) {
                const i = new Map, { tasks: o, scope: r } = e1;
                for (const [e1, t1] of o.entries()){
                    const o = this.getImage(t1.id, r);
                    o && i.set(e1, {
                        image: o,
                        imageVariant: t1
                    });
                }
                this._rasterizeImages(r, i, t1);
            }
            _rasterizeImages(t1, i, o) {
                if (e1.y()) this.imageRasterizerDispatcher.getActor().send("rasterizeImagesWorker", {
                    tasks: i,
                    scope: t1
                }, o);
                else {
                    const e1 = new Map;
                    for (const [o, { image: r, imageVariant: n }] of i.entries())e1.set(o, this.imageRasterizer.rasterize(n, r, t1, 0));
                    o(void 0, e1);
                }
            }
            getUpdatedImages(e1) {
                return this.updatedImages.get(e1) || new Set;
            }
            _notify(t1, i, o) {
                const r = this.images.get(i), n = new Map;
                for (const i of t1){
                    if (!r.get(i.toString())) {
                        if (i.iconsetId) continue;
                        this.fire(new e1.C("styleimagemissing", {
                            id: i.name
                        }));
                    }
                    const t1 = r.get(i.toString());
                    if (!t1) {
                        e1.w(`Image "${i.name}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
                        continue;
                    }
                    const o = {
                        data: t1.usvg ? null : t1.data.clone(),
                        pixelRatio: t1.pixelRatio,
                        sdf: t1.sdf,
                        usvg: t1.usvg,
                        stretchX: t1.stretchX,
                        stretchY: t1.stretchY,
                        content: t1.content,
                        hasRenderCallback: Boolean(t1.userImage && t1.userImage.render)
                    };
                    t1.usvg && Object.assign(o, {
                        width: t1.icon.usvg_tree.width,
                        height: t1.icon.usvg_tree.height
                    }), n.set(e1.I.toString(i), o);
                }
                o(null, {
                    images: n,
                    versions: this.getImageVersions(i)
                });
            }
            getPixelSize(e1) {
                const { width: t1, height: i } = this.atlasImage.get(e1);
                return {
                    width: t1,
                    height: i
                };
            }
            getPattern(t1, i, o) {
                const r = t1.toString(), n = this.patterns.get(i), s = n.get(r), a = this.getImage(t1, i);
                if (!a) return null;
                if (s) {
                    if (s.position.version === a.version) return s.position;
                    s.position.version = a.version;
                } else {
                    if (a.usvg && !a.data) {
                        const n = this.getPatternInFlightId(r, i);
                        if (this.patternsInFlight.has(n)) return null;
                        this.patternsInFlight.add(n);
                        const s = new e1.D(t1).scaleSelf(e1.o.devicePixelRatio), l = new Map([
                            [
                                s.toString(),
                                {
                                    image: a,
                                    imageVariant: s
                                }
                            ]
                        ]);
                        return this._rasterizeImages(i, l, (e1, t1)=>this.storePatternImage(s, i, a, o, t1)), null;
                    }
                    this.storePattern(t1, i, a);
                }
                return this._updatePatternAtlas(i, o), n.get(r).position;
            }
            getPatternInFlightId(t1, i) {
                return e1.F(t1, i);
            }
            hasPatternsInFlight() {
                return 0 !== this.patternsInFlight.size;
            }
            storePatternImage(e1, t1, i, o, r) {
                const n = e1.toString(), s = r ? r.get(n) : void 0;
                s && (i.data = s, this.storePattern(e1.id, t1, i), this._updatePatternAtlas(t1, o), this.patternsInFlight.delete(this.getPatternInFlightId(e1.id.toString(), t1)));
            }
            storePattern(t1, i, o) {
                const r = {
                    w: o.data.width + 2 * e1.G,
                    h: o.data.height + 2 * e1.G,
                    x: 0,
                    y: 0
                }, n = new e1.H(r, o, e1.G);
                this.patterns.get(i).set(t1.toString(), {
                    bin: r,
                    position: n
                });
            }
            destroyAtlasTextures() {
                for (const e1 of this.atlasTexture.values())e1 && e1.destroy();
                this.atlasTexture.clear();
            }
            bind(t1, i) {
                const o = t1.gl;
                let r = this.atlasTexture.get(i);
                r ? this.dirty && (r.update(this.atlasImage.get(i)), this.dirty = !1) : (r = new e1.T(t1, this.atlasImage.get(i), o.RGBA8), this.atlasTexture.set(i, r)), r.bind(o.LINEAR, o.CLAMP_TO_EDGE);
            }
            _updatePatternAtlas(t1, i) {
                const o = this.patterns.get(t1), r = Array.from(o.values()).map(({ bin: e1 })=>e1), { w: n, h: s } = e1.J(r), a = this.atlasImage.get(t1);
                a.resize({
                    width: n || 1,
                    height: s || 1
                });
                const l = this.images.get(t1);
                for (const [t1, { bin: r, position: n }] of o.entries()){
                    let o = n.padding;
                    const s = r.x + o, c = r.y + o, h = l.get(t1).data, d = h.width, _ = h.height;
                    o = o > 1 ? o - 1 : o, e1.q.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: s,
                        y: c
                    }, {
                        width: d,
                        height: _
                    }, i), e1.q.copy(h, a, {
                        x: 0,
                        y: _ - o
                    }, {
                        x: s,
                        y: c - o
                    }, {
                        width: d,
                        height: o
                    }, i), e1.q.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: s,
                        y: c + _
                    }, {
                        width: d,
                        height: o
                    }, i), e1.q.copy(h, a, {
                        x: d - o,
                        y: 0
                    }, {
                        x: s - o,
                        y: c
                    }, {
                        width: o,
                        height: _
                    }, i), e1.q.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: s + d,
                        y: c
                    }, {
                        width: o,
                        height: _
                    }, i), e1.q.copy(h, a, {
                        x: d - o,
                        y: _ - o
                    }, {
                        x: s - o,
                        y: c - o
                    }, {
                        width: o,
                        height: o
                    }, i), e1.q.copy(h, a, {
                        x: 0,
                        y: _ - o
                    }, {
                        x: s + d,
                        y: c - o
                    }, {
                        width: o,
                        height: o
                    }, i), e1.q.copy(h, a, {
                        x: 0,
                        y: 0
                    }, {
                        x: s + d,
                        y: c + _
                    }, {
                        width: o,
                        height: o
                    }, i), e1.q.copy(h, a, {
                        x: d - o,
                        y: 0
                    }, {
                        x: s - o,
                        y: c + _
                    }, {
                        width: o,
                        height: o
                    }, i);
                }
                this.dirty = !0;
            }
            beginFrame() {
                for (const e1 of this.images.keys())this.callbackDispatchedThisFrame.set(e1, new Set);
            }
            dispatchRenderCallbacks(e1, t1) {
                const i = this.images.get(t1);
                for (const o of e1){
                    if (this.callbackDispatchedThisFrame.get(t1).has(o.toString())) continue;
                    this.callbackDispatchedThisFrame.get(t1).add(o.toString());
                    const e1 = i.get(o.toString());
                    $(e1) && this.updateImage(o, t1, e1);
                }
            }
            destroy() {
                this.imageRasterizerDispatcher && this.imageRasterizerDispatcher.remove();
            }
        }
        function re(t1) {
            const i = t1.value, o = t1.valueSpec, r = t1.style, n = t1.styleSpec, s = t1.key, a = t1.arrayElementValidator || Ce;
            if (!Array.isArray(i)) return [
                new e1.V(s, i, `array expected, ${e1.M(i)} found`)
            ];
            if (o.length && i.length !== o.length) return [
                new e1.V(s, i, `array length ${o.length} expected, length ${i.length} found`)
            ];
            if (o["min-length"] && i.length < o["min-length"]) return [
                new e1.V(s, i, `array length at least ${o["min-length"]} expected, length ${i.length} found`)
            ];
            let l = {
                type: o.value,
                values: o.values,
                minimum: o.minimum,
                maximum: o.maximum,
                function: void 0
            };
            n.$version < 7 && (l.function = o.function), e1.K(o.value) && (l = o.value);
            let c = [];
            for(let e1 = 0; e1 < i.length; e1++)c = c.concat(a({
                array: i,
                arrayIndex: e1,
                value: i[e1],
                valueSpec: l,
                style: r,
                styleSpec: n,
                key: `${s}[${e1}]`
            }, !0));
            return c;
        }
        function ne(t1) {
            const i = t1.key, o = t1.value, r = t1.valueSpec;
            if (!e1.N(o)) return [
                new e1.V(i, o, `number expected, ${e1.M(o)} found`)
            ];
            if (o != o) return [
                new e1.V(i, o, "number expected, NaN found")
            ];
            if ("minimum" in r) {
                let n = r.minimum;
                if (Array.isArray(r.minimum) && (n = r.minimum[t1.arrayIndex]), o < n) return [
                    new e1.V(i, o, `${o} is less than the minimum value ${n}`)
                ];
            }
            if ("maximum" in r) {
                let n = r.maximum;
                if (Array.isArray(r.maximum) && (n = r.maximum[t1.arrayIndex]), o > n) return [
                    new e1.V(i, o, `${o} is greater than the maximum value ${n}`)
                ];
            }
            return [];
        }
        function se(t1) {
            const i = t1.key, o = t1.value;
            if (!e1.K(o)) return [
                new e1.V(i, o, `object expected, ${e1.M(o)} found`)
            ];
            const r = t1.valueSpec, n = e1.L(o.type);
            let s, a, l, c = {};
            const h = "categorical" !== n && void 0 === o.property, d = !h, _ = function(t1) {
                const i = t1.stops;
                return Array.isArray(i) && Array.isArray(i[0]) && e1.K(i[0][0]);
            }(o), u = Ie({
                key: t1.key,
                value: t1.value,
                valueSpec: t1.styleSpec.function,
                style: t1.style,
                styleSpec: t1.styleSpec,
                objectElementValidators: {
                    stops: function(t1) {
                        if ("identity" === n) return [
                            new e1.V(t1.key, t1.value, 'identity function may not have a "stops" property')
                        ];
                        let i = [];
                        const o = t1.value;
                        return i = i.concat(re({
                            key: t1.key,
                            value: o,
                            valueSpec: t1.valueSpec,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            arrayElementValidator: p
                        })), Array.isArray(o) && 0 === o.length && i.push(new e1.V(t1.key, o, "array must have at least one stop")), i;
                    },
                    default: function(e1) {
                        return Ce({
                            key: e1.key,
                            value: e1.value,
                            valueSpec: r,
                            style: e1.style,
                            styleSpec: e1.styleSpec
                        });
                    }
                }
            });
            return "identity" === n && h && u.push(new e1.V(t1.key, t1.value, 'missing required property "property"')), "identity" === n || o.stops || u.push(new e1.V(t1.key, t1.value, 'missing required property "stops"')), "exponential" === n && r.expression && !e1.O(r) && u.push(new e1.V(t1.key, t1.value, "exponential functions not supported")), t1.styleSpec.$version >= 8 && (d && !e1.Q(r) ? u.push(new e1.V(t1.key, t1.value, "property functions not supported")) : h && !e1.S(r) && u.push(new e1.V(t1.key, t1.value, "zoom functions not supported"))), "categorical" !== n && !_ || void 0 !== o.property || u.push(new e1.V(t1.key, t1.value, '"property" property is required')), u;
            function p(t1) {
                let i = [];
                const o = t1.value, n = t1.key;
                if (!Array.isArray(o)) return [
                    new e1.V(n, o, `array expected, ${e1.M(o)} found`)
                ];
                if (2 !== o.length) return [
                    new e1.V(n, o, `array length 2 expected, length ${o.length} found`)
                ];
                if (_) {
                    if (!e1.K(o[0])) return [
                        new e1.V(n, o, `object expected, ${e1.M(o[0])} found`)
                    ];
                    const r = o[0];
                    if (void 0 === r.zoom) return [
                        new e1.V(n, o, "object stop key must have zoom")
                    ];
                    if (void 0 === r.value) return [
                        new e1.V(n, o, "object stop key must have value")
                    ];
                    const s = e1.L(r.zoom);
                    if ("number" != typeof s) return [
                        new e1.V(n, r.zoom, "stop zoom values must be numbers")
                    ];
                    if (l && l > s) return [
                        new e1.V(n, r.zoom, "stop zoom values must appear in ascending order")
                    ];
                    s !== l && (l = s, a = void 0, c = {}), i = i.concat(Ie({
                        key: `${n}[0]`,
                        value: o[0],
                        valueSpec: {
                            zoom: {}
                        },
                        style: t1.style,
                        styleSpec: t1.styleSpec,
                        objectElementValidators: {
                            zoom: ne,
                            value: f
                        }
                    }));
                } else i = i.concat(f({
                    key: `${n}[0]`,
                    value: o[0],
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }, o));
                return e1.U(e1.W(o[1])) ? i.concat([
                    new e1.V(`${n}[1]`, o[1], "expressions are not allowed in function stops.")
                ]) : i.concat(Ce({
                    key: `${n}[1]`,
                    value: o[1],
                    valueSpec: r,
                    style: t1.style,
                    styleSpec: t1.styleSpec
                }));
            }
            function f(t1, i) {
                const o = e1.M(t1.value), l = e1.L(t1.value), h = null !== t1.value ? t1.value : i;
                if (s) {
                    if (o !== s) return [
                        new e1.V(t1.key, h, `${o} stop domain type must match previous stop domain type ${s}`)
                    ];
                } else s = o;
                if ("number" !== o && "string" !== o && "boolean" !== o && "number" != typeof l && "string" != typeof l && "boolean" != typeof l) return [
                    new e1.V(t1.key, h, "stop domain value must be a number, string, or boolean")
                ];
                if ("number" !== o && "categorical" !== n) {
                    let i = `number expected, ${o} found`;
                    return e1.Q(r) && void 0 === n && (i += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                        new e1.V(t1.key, h, i)
                    ];
                }
                return "categorical" !== n || "number" !== o || "number" == typeof l && isFinite(l) && Math.floor(l) === l ? "categorical" !== n && "number" === o && "number" == typeof l && "number" == typeof a && void 0 !== a && l < a ? [
                    new e1.V(t1.key, h, "stop domain values must appear in ascending order")
                ] : (a = l, "categorical" === n && l in c ? [
                    new e1.V(t1.key, h, "stop domain values must be unique")
                ] : (c[l] = !0, [])) : [
                    new e1.V(t1.key, h, `integer expected, found ${String(l)}`)
                ];
            }
        }
        function ae(t1) {
            const i = ("property" === t1.expressionContext ? e1.Y : e1.X)(e1.W(t1.value), t1.valueSpec);
            if ("error" === i.result) return i.value.map((i)=>new e1.V(`${t1.key}${i.key}`, t1.value, i.message));
            const o = i.value.expression || i.value._styleExpression.expression;
            if ("property" === t1.expressionContext && "text-font" === t1.propertyKey && !o.outputDefined()) return [
                new e1.V(t1.key, t1.value, `Invalid data expression for "${t1.propertyKey}". Output values must be contained as literals within the expression.`)
            ];
            if ("property" === t1.expressionContext && "layout" === t1.propertyType && !e1.$(o)) return [
                new e1.V(t1.key, t1.value, '"feature-state" data expressions are not supported with layout properties.')
            ];
            if ("filter" === t1.expressionContext) return le(o, t1);
            if ("appearance" === t1.expressionContext) return ce(o, t1);
            if (t1.expressionContext && 0 === t1.expressionContext.indexOf("cluster")) {
                if (!e1.Z(o, [
                    "zoom",
                    "feature-state"
                ])) return [
                    new e1.V(t1.key, t1.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                ];
                if ("cluster-initial" === t1.expressionContext && !e1._(o)) return [
                    new e1.V(t1.key, t1.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                ];
            }
            return [];
        }
        function le(t1, i) {
            const o = new Set([
                "zoom",
                "feature-state",
                "pitch",
                "distance-from-center"
            ]);
            if (i.valueSpec && i.valueSpec.expression) for (const e1 of i.valueSpec.expression.parameters)o.delete(e1);
            if (0 === o.size) return [];
            const r = [];
            return t1 instanceof e1.a0 && o.has(t1.name) ? [
                new e1.V(i.key, i.value, `["${t1.name}"] expression is not supported in a filter for a ${i.object.type} layer with id: ${i.object.id}`)
            ] : (t1.eachChild((e1)=>{
                r.push(...le(e1, i));
            }), r);
        }
        function ce(t1, i) {
            const o = new Set;
            if (i.valueSpec && i.valueSpec.expression) for (const e1 of i.valueSpec.expression.parameters)o.add(e1);
            if (0 === o.size) return [];
            const r = [];
            return t1 instanceof e1.a0 && !o.has(t1.name) ? [
                new e1.V(i.key, i.value, `["${t1.name}"] is not an allowed parameter`)
            ] : (t1.eachChild((e1)=>{
                r.push(...ce(e1, i));
            }), r);
        }
        function he(t1) {
            const i = t1.key, o = t1.value, r = t1.valueSpec, n = [];
            return Array.isArray(r.values) ? -1 === r.values.indexOf(e1.L(o)) && n.push(new e1.V(i, o, `expected one of [${r.values.join(", ")}], ${JSON.stringify(o)} found`)) : -1 === Object.keys(r.values).indexOf(e1.L(o)) && n.push(new e1.V(i, o, `expected one of [${Object.keys(r.values).join(", ")}], ${JSON.stringify(o)} found`)), n;
        }
        function de(t1) {
            return e1.a4(e1.W(t1.value)) ? ae(Object.assign({}, t1, {
                expressionContext: "filter",
                valueSpec: t1.styleSpec[`filter_${t1.layerType || "fill"}`]
            })) : _e(t1);
        }
        function _e(t1) {
            const i = t1.value, o = t1.key;
            if (!Array.isArray(i)) return [
                new e1.V(o, i, `array expected, ${e1.M(i)} found`)
            ];
            if (i.length < 1) return [
                new e1.V(o, i, "filter array must have at least 1 element")
            ];
            const r = t1.styleSpec;
            let n = he({
                key: `${o}[0]`,
                value: i[0],
                valueSpec: r.filter_operator
            });
            const s = ()=>{
                i.length >= 2 && (e1.a2(i[1]) || n.push(new e1.V(`${o}[1]`, i[1], `string expected, ${e1.M(i[1])} found`)));
                for(let t1 = 2; t1 < i.length; t1++)"$type" === e1.L(i[1]) ? n = n.concat(he({
                    key: `${o}[${t1}]`,
                    value: i[t1],
                    valueSpec: r.geometry_type
                })) : e1.a2(i[t1]) || e1.N(i[t1]) || e1.a1(i[t1]) || n.push(new e1.V(`${o}[${t1}]`, i[t1], `string, number, or boolean expected, ${e1.M(i[t1])} found.`));
            };
            switch(e1.L(i[0])){
                case "<":
                case "<=":
                case ">":
                case ">=":
                    i.length >= 2 && "$type" === e1.L(i[1]) && n.push(new e1.V(o, i, `"$type" cannot be use with operator "${i[0]}"`)), 3 !== i.length && n.push(new e1.V(o, i, `filter array for operator "${i[0]}" must have 3 elements`)), s();
                    break;
                case "==":
                case "!=":
                    3 !== i.length && n.push(new e1.V(o, i, `filter array for operator "${i[0]}" must have 3 elements`)), s();
                    break;
                case "in":
                case "!in":
                    s();
                    break;
                case "any":
                case "all":
                case "none":
                    for(let e1 = 1; e1 < i.length; e1++)n = n.concat(_e({
                        key: `${o}[${e1}]`,
                        value: i[e1],
                        style: t1.style,
                        styleSpec: t1.styleSpec
                    }));
                    break;
                case "has":
                case "!has":
                    2 !== i.length ? n.push(new e1.V(o, i, `filter array for "${i[0]}" operator must have 2 elements`)) : e1.a2(i[1]) || n.push(new e1.V(`${o}[1]`, i[1], `string expected, ${e1.M(i[1])} found`));
            }
            return n;
        }
        function ue(t1, i) {
            const o = t1.key, r = t1.style, n = t1.layer, s = t1.styleSpec, a = t1.value, l = t1.objectKey, c = s[`${i}_${t1.layerType}`];
            if (!c) return [];
            const h = l.match(/^(.*)-use-theme$/);
            if (h && c[h[1]]) return e1.U(e1.W(a)) ? [].concat(Ce({
                key: o,
                value: a,
                valueSpec: {
                    type: "string",
                    expression: {
                        interpolated: !1,
                        parameters: [
                            "zoom",
                            "feature"
                        ]
                    },
                    "property-type": "data-driven"
                },
                style: r,
                styleSpec: s,
                expressionContext: "property",
                propertyType: i,
                propertyKey: l
            })) : Ce({
                key: o,
                value: a,
                valueSpec: {
                    type: "string"
                },
                style: r,
                styleSpec: s
            });
            const d = l.match(/^(.*)-transition$/);
            if ("paint" === i && d && c[d[1]] && c[d[1]].transition) return Ce({
                key: o,
                value: a,
                valueSpec: s.transition,
                style: r,
                styleSpec: s
            });
            const _ = t1.valueSpec || c[l];
            if (!_) return [
                new e1.a5(o, a, `unknown property "${l}"`)
            ];
            let u;
            if (e1.a2(a) && e1.Q(_) && !_.tokens && (u = /^{([^}]+)}$/.exec(a))) {
                const t1 = `\`{ "type": "identity", "property": ${u ? JSON.stringify(u[1]) : '"_"'} }\``;
                return [
                    new e1.V(o, a, `"${l}" does not support interpolation syntax\nUse an identity property function instead: ${t1}.`)
                ];
            }
            const p = [];
            if ("symbol" === t1.layerType) "text-field" !== l || !r || r.glyphs || r.imports || p.push(new e1.V(o, a, 'use of "text-field" requires a style "glyphs" property')), "text-font" === l && e1.a6(e1.W(a)) && "identity" === e1.L(a.type) && p.push(new e1.V(o, a, '"text-font" does not support identity functions'));
            else if ("model" === t1.layerType && "paint" === i && n && n.layout && n.layout.hasOwnProperty("model-id") && e1.Q(_) && (e1.a7(_) || e1.S(_))) {
                const t1 = e1.Y(e1.W(a), _).value, i = "expression" in t1 && t1.expression || "_styleExpression" in t1 && t1._styleExpression && t1._styleExpression.expression;
                i && !e1.Z(i, [
                    "measure-light"
                ]) && ("model-emissive-strength" === l && e1._(i) && e1.$(i) || p.push(new e1.V(o, a, `${l} does not support measure-light expressions when the model layer source is vector tile or GeoJSON.`)));
            }
            return p.concat(Ce({
                key: t1.key,
                value: a,
                valueSpec: _,
                style: r,
                styleSpec: s,
                expressionContext: "property",
                propertyType: i,
                propertyKey: l
            }));
        }
        function pe(e1) {
            return ue(e1, "paint");
        }
        function fe(e1) {
            return ue(e1, "layout");
        }
        function me(t1) {
            let i = [];
            const o = t1.value, r = t1.key, n = t1.style, s = t1.styleSpec;
            if (!e1.K(o)) return [
                new e1.V(r, o, "object expected")
            ];
            o.type || o.ref || i.push(new e1.V(r, o, 'either "type" or "ref" is required'));
            let a = e1.L(o.type);
            const l = e1.L(o.ref);
            if (o.id) {
                const s = e1.L(o.id);
                for(let a = 0; a < t1.arrayIndex; a++){
                    const t1 = n.layers[a];
                    e1.L(t1.id) === s && i.push(new e1.V(r, o.id, `duplicate layer id "${s}", previously used at line ${t1.id.__line__}`));
                }
            }
            if ("ref" in o) {
                let t1;
                [
                    "type",
                    "source",
                    "source-layer",
                    "filter",
                    "layout"
                ].forEach((t1)=>{
                    t1 in o && i.push(new e1.V(r, o[t1], `"${t1}" is prohibited for ref layers`));
                }), n.layers.forEach((i)=>{
                    e1.L(i.id) === l && (t1 = i);
                }), t1 ? t1.ref ? i.push(new e1.V(r, o.ref, "ref cannot reference another ref layer")) : a = e1.L(t1.type) : "string" == typeof l && i.push(new e1.V(r, o.ref, `ref layer "${l}" not found`));
            } else if ("background" !== a && "sky" !== a && "slot" !== a) {
                if (o.source) {
                    if (e1.a2(o.source)) {
                        const t1 = n.sources && n.sources[o.source], s = t1 && e1.L(t1.type);
                        t1 ? "vector" === s && "raster" === a ? i.push(new e1.V(r, o.source, `layer "${o.id}" requires a raster source`)) : "raster" === s && "raster" !== a ? i.push(new e1.V(r, o.source, `layer "${o.id}" requires a vector source`)) : "vector" !== s || o["source-layer"] ? "raster-dem" === s && "hillshade" !== a ? i.push(new e1.V(r, o.source, "raster-dem source can only be used with layer type 'hillshade'.")) : "raster-array" !== s || [
                            "raster",
                            "raster-particle"
                        ].includes(a) ? "line" === a && o.paint && (o.paint["line-gradient"] || o.paint["line-trim-offset"]) && "geojson" === s && !t1.lineMetrics ? i.push(new e1.V(r, o, `layer "${o.id}" specifies a line-gradient, which requires the GeoJSON source to have \`lineMetrics\` enabled.`)) : "raster-particle" === a && "raster-array" !== s && i.push(new e1.V(r, o.source, `layer "${o.id}" requires a 'raster-array' source.`)) : i.push(new e1.V(r, o.source, "raster-array source can only be used with layer type 'raster'.")) : i.push(new e1.V(r, o, `layer "${o.id}" must specify a "source-layer"`)) : i.push(new e1.V(r, o.source, `source "${o.source}" not found`));
                    } else i.push(new e1.V(`${r}.source`, o.source, '"source" must be a string'));
                } else i.push(new e1.V(r, o, 'missing required property "source"'));
            }
            return i = i.concat(Ie({
                key: r,
                value: o,
                valueSpec: s.layer,
                style: t1.style,
                styleSpec: t1.styleSpec,
                objectElementValidators: {
                    "*": ()=>[],
                    type: ()=>Ce({
                            key: `${r}.type`,
                            value: o.type,
                            valueSpec: s.layer.type,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            object: o,
                            objectKey: "type"
                        }),
                    filter: (e1)=>de(Object.assign({
                            layerType: a
                        }, e1)),
                    layout: (e1)=>Ie({
                            layer: o,
                            key: e1.key,
                            value: e1.value,
                            valueSpec: {},
                            style: e1.style,
                            styleSpec: e1.styleSpec,
                            objectElementValidators: {
                                "*": (e1)=>fe(Object.assign({
                                        layerType: a
                                    }, e1))
                            }
                        }),
                    paint: (e1)=>Ie({
                            layer: o,
                            key: e1.key,
                            value: e1.value,
                            valueSpec: {},
                            style: e1.style,
                            styleSpec: e1.styleSpec,
                            objectElementValidators: {
                                "*": (e1)=>pe(Object.assign({
                                        layerType: a,
                                        layer: o
                                    }, e1))
                            }
                        }),
                    appearances (t1) {
                        const i = re({
                            key: t1.key,
                            value: t1.value,
                            valueSpec: t1.valueSpec,
                            style: t1.style,
                            styleSpec: t1.styleSpec,
                            arrayElementValidator: (t1)=>(function(t1) {
                                    const { key: i, layer: o, layerType: r } = t1, n = e1.L(t1.value), s = e1.L(n.name), a = e1.L(n.condition), l = Ie({
                                        key: i,
                                        value: n,
                                        valueSpec: t1.styleSpec.appearance,
                                        style: t1.style,
                                        styleSpec: t1.styleSpec,
                                        objectElementValidators: {
                                            condition: (t1)=>(function(t1) {
                                                    const i = [];
                                                    return i.push(...ae({
                                                        key: t1.key,
                                                        value: t1.object.condition,
                                                        valueSpec: e1.a8.appearance.condition,
                                                        expressionContext: "appearance"
                                                    })), i;
                                                })(Object.assign({
                                                    layer: o,
                                                    layerType: r
                                                }, t1)),
                                            properties: (t1)=>(function(t1) {
                                                    const i = [], { styleSpec: o, layer: r, layerType: n } = t1, s = o[`paint_${n}`], a = o[`layout_${n}`], l = t1.object[t1.objectKey];
                                                    for(const o in l){
                                                        const c = o in s ? "paint" : o in a ? "layout" : void 0;
                                                        if (!c) {
                                                            i.push(new e1.V(t1.key, o, `unknown property "${o}" for layer type "${n}"`));
                                                            continue;
                                                        }
                                                        const h = Object.assign({}, t1, {
                                                            key: `${t1.key}.${o}`,
                                                            object: l,
                                                            objectKey: o,
                                                            layer: r,
                                                            layerType: n,
                                                            value: l[o],
                                                            valueSpec: "paint" === c ? s[o] : a[o]
                                                        });
                                                        i.push(...ue(h, c));
                                                    }
                                                    return i;
                                                })(Object.assign({
                                                    layer: o,
                                                    layerType: r
                                                }, t1))
                                        }
                                    });
                                    return "hidden" !== s && void 0 === a && l.push(new e1.V(t1.key, "name", 'Appearance with name different than "hidden" must have a condition')), l;
                                })(Object.assign({
                                    layerType: a,
                                    layer: o
                                }, t1))
                        }), r = Array.isArray(t1.value) ? t1.value : [], n = new Set;
                        return r.forEach((r, s)=>{
                            const a = e1.L(r.name);
                            if (a) {
                                if (n.has(a)) {
                                    const r = e1.L(o.id);
                                    i.push(new e1.V(t1.key, a, `Duplicated appearance name "${a}" for layer "${r}"`));
                                } else n.add(a);
                            }
                        }), i;
                    }
                }
            })), i;
        }
        function ge({ key: t1, value: i }) {
            return e1.a2(i) ? [] : [
                new e1.V(t1, i, `string expected, ${e1.M(i)} found`)
            ];
        }
        const ve = {
            promoteId: function t1({ key: i, value: o }) {
                if (e1.a2(o)) return ge({
                    key: i,
                    value: o
                });
                if (Array.isArray(o)) {
                    const t1 = [], r = e1.W(o), n = e1.X(r);
                    return "error" === n.result ? (n.value.forEach((o)=>{
                        t1.push(new e1.V(`${i}${o.key}`, null, `${o.message}`));
                    }), t1) : (e1.Z(n.value.expression, [
                        "zoom",
                        "heatmap-density",
                        "line-progress",
                        "raster-value",
                        "sky-radial-progress",
                        "accumulated",
                        "is-supported-script",
                        "pitch",
                        "distance-from-center",
                        "measure-light",
                        "raster-particle-speed"
                    ]) || t1.push(new e1.V(`${i}`, null, "promoteId expression should be only feature dependent")), t1);
                }
                if (!e1.K(o)) return [
                    new e1.V(i, o, `string, expression or object expected, "${e1.M(o)}" found`)
                ];
                const r = [];
                for(const e1 in o)r.push(...t1({
                    key: `${i}.${e1}`,
                    value: o[e1]
                }));
                return r;
            }
        };
        function ye(t1) {
            const i = t1.value, o = t1.key, r = t1.styleSpec, n = t1.style;
            if (!e1.K(i)) return [
                new e1.V(o, i, `object expected, ${e1.M(i)} found`)
            ];
            if (!("type" in i)) return [
                new e1.V(o, i, '"type" is required')
            ];
            const s = e1.L(i.type);
            let a = [];
            switch([
                "vector",
                "raster",
                "raster-dem",
                "raster-array"
            ].includes(s) && ("url" in i || "tiles" in i || a.push(new e1.a5(o, i, 'Either "url" or "tiles" is required.'))), s){
                case "vector":
                case "raster":
                case "raster-dem":
                case "raster-array":
                    return a = a.concat(Ie({
                        key: o,
                        value: i,
                        valueSpec: r[`source_${s.replace("-", "_")}`],
                        style: t1.style,
                        styleSpec: r,
                        objectElementValidators: ve
                    })), a;
                case "geojson":
                    if (a = Ie({
                        key: o,
                        value: i,
                        valueSpec: r.source_geojson,
                        style: n,
                        styleSpec: r,
                        objectElementValidators: ve
                    }), "cluster" in i && "clusterProperties" in i) {
                        if (!e1.K(i.clusterProperties)) return [
                            new e1.V(`${o}.clusterProperties`, i, `object expected, ${e1.M(i)} found`)
                        ];
                        for(const t1 in i.clusterProperties){
                            const r = i.clusterProperties[t1];
                            if (!Array.isArray(r)) return [
                                new e1.V(`${o}.clusterProperties.${t1}`, r, "array expected")
                            ];
                            const [n, s] = r, l = "string" == typeof n ? [
                                n,
                                [
                                    "accumulated"
                                ],
                                [
                                    "get",
                                    t1
                                ]
                            ] : n;
                            a.push(...ae({
                                key: `${o}.${t1}.map`,
                                value: s,
                                expressionContext: "cluster-map"
                            })), a.push(...ae({
                                key: `${o}.${t1}.reduce`,
                                value: l,
                                expressionContext: "cluster-reduce"
                            }));
                        }
                    }
                    return a;
                case "video":
                    return Ie({
                        key: o,
                        value: i,
                        valueSpec: r.source_video,
                        style: n,
                        styleSpec: r
                    });
                case "image":
                    return Ie({
                        key: o,
                        value: i,
                        valueSpec: r.source_image,
                        style: n,
                        styleSpec: r
                    });
                case "canvas":
                    return [
                        new e1.V(o, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                    ];
                default:
                    return he({
                        key: `${o}.type`,
                        value: i.type,
                        valueSpec: {
                            values: xe(r)
                        }
                    });
            }
        }
        function xe(e1) {
            return e1.source.reduce((t1, i)=>{
                const o = e1[i];
                return "enum" === o.type.type && (t1 = t1.concat(Object.keys(o.type.values || {}))), t1;
            }, []);
        }
        function be(t1) {
            const i = t1.value, o = t1.styleSpec, r = o.light, n = t1.style;
            if (void 0 === i) return [];
            if (!e1.K(i)) return [
                new e1.V("light", i, `object expected, ${e1.M(i)} found`)
            ];
            let s = [];
            for(const t1 in i){
                const a = t1.match(/^(.*)-transition$/), l = t1.match(/^(.*)-use-theme$/);
                s = s.concat(l && r[l[1]] ? Ce({
                    key: t1,
                    value: i[t1],
                    valueSpec: {
                        type: "string"
                    },
                    style: n,
                    styleSpec: o
                }) : a && r[a[1]] && r[a[1]].transition ? Ce({
                    key: t1,
                    value: i[t1],
                    valueSpec: o.transition,
                    style: n,
                    styleSpec: o
                }) : r[t1] ? Ce({
                    key: t1,
                    value: i[t1],
                    valueSpec: r[t1],
                    style: n,
                    styleSpec: o
                }) : [
                    new e1.V(t1, i[t1], `unknown property "${t1}"`)
                ]);
            }
            return s;
        }
        function we(t1) {
            const i = t1.value;
            if (!i) return [];
            const o = t1.key;
            if (!e1.K(i)) return [
                new e1.V(o, i, `object expected, ${e1.M(i)} found`)
            ];
            let r = [];
            const n = t1.styleSpec, s = n["light-3d"], a = t1.style, l = t1.style.lights;
            for (const t1 of [
                "type",
                "id"
            ])if (!(t1 in i)) return r = r.concat([
                new e1.V(o, i, `missing property "${t1}"`)
            ]), r;
            if (!e1.a2(i.type)) return r = r.concat([
                new e1.V(`${o}.type`, i.type, "string expected")
            ]), r;
            if (l) for(let n = 0; n < t1.arrayIndex; n++){
                const t1 = e1.L(i.type), s = l[n];
                e1.L(s.type) === t1 && r.push(new e1.V(o, i.id, `duplicate light type "${i.type}", previously defined at line ${s.id.__line__}`));
            }
            const c = `properties_light_${i.type}`;
            if (!(c in n)) return r = r.concat([
                new e1.V(`${o}.type`, i, `Invalid light type ${i.type}`)
            ]), r;
            const h = n[c];
            for(const o in i)if ("properties" === o) {
                const s = i[o];
                if (!e1.K(s)) return r = r.concat([
                    new e1.V("properties", s, `object expected, ${e1.M(s)} found`)
                ]), r;
                for(const l in s){
                    const c = l.match(/^(.*)-transition$/), d = l.match(/^(.*)-use-theme$/);
                    r = r.concat(d && h[d[1]] ? Ce({
                        key: o,
                        value: s[l],
                        valueSpec: {
                            type: "string"
                        },
                        style: a,
                        styleSpec: n
                    }) : c && h[c[1]] && h[c[1]].transition ? Ce({
                        key: o,
                        value: i[o],
                        valueSpec: n.transition,
                        style: a,
                        styleSpec: n
                    }) : h[l] ? Ce({
                        key: l,
                        value: s[l],
                        valueSpec: h[l],
                        style: a,
                        styleSpec: n
                    }) : [
                        new e1.a5(t1.key, s[l], `unknown property "${l}"`)
                    ]);
                }
            } else r = r.concat(s[o] ? Ce({
                key: o,
                value: i[o],
                valueSpec: s[o],
                style: a,
                styleSpec: n
            }) : [
                new e1.a5(o, i[o], `unknown property "${o}"`)
            ]);
            return r;
        }
        function Te(t1) {
            const i = t1.value, o = t1.key, r = t1.style, n = t1.styleSpec, s = n.terrain;
            if (null == i) return [];
            if (!e1.K(i)) return [
                new e1.V("terrain", i, `object expected, ${e1.M(i)} found`)
            ];
            let a = [];
            for(const t1 in i){
                const o = t1.match(/^(.*)-transition$/), l = t1.match(/^(.*)-use-theme$/);
                a = a.concat(l && s[l[1]] ? Ce({
                    key: t1,
                    value: i[t1],
                    valueSpec: {
                        type: "string"
                    },
                    style: r,
                    styleSpec: n
                }) : o && s[o[1]] && s[o[1]].transition ? Ce({
                    key: t1,
                    value: i[t1],
                    valueSpec: n.transition,
                    style: r,
                    styleSpec: n
                }) : s[t1] ? Ce({
                    key: t1,
                    value: i[t1],
                    valueSpec: s[t1],
                    style: r,
                    styleSpec: n
                }) : [
                    new e1.a5(t1, i[t1], `unknown property "${t1}"`)
                ]);
            }
            if (i.source) {
                if (e1.a2(i.source)) {
                    const t1 = r.sources && r.sources[i.source], n = t1 && e1.L(t1.type);
                    t1 ? "raster-dem" !== n && a.push(new e1.V(`${o}.source`, i.source, `terrain cannot be used with a source of type ${n}, it only be used with a "raster-dem" source type`)) : a.push(new e1.V(`${o}.source`, i.source, `source "${i.source}" not found`));
                } else a.push(new e1.V(`${o}.source`, i.source, "source must be a string"));
            } else a.push(new e1.V(o, i, 'terrain is missing required property "source"'));
            return a;
        }
        function Ee(t1) {
            const i = t1.value, o = t1.style, r = t1.styleSpec, n = r.fog;
            if (void 0 === i) return [];
            if (!e1.K(i)) return [
                new e1.V("fog", i, `object expected, ${e1.M(i)} found`)
            ];
            let s = [];
            for(const t1 in i){
                const a = t1.match(/^(.*)-transition$/), l = t1.match(/^(.*)-use-theme$/);
                s = s.concat(l && n[l[1]] ? Ce({
                    key: t1,
                    value: i[t1],
                    valueSpec: {
                        type: "string"
                    },
                    style: o,
                    styleSpec: r
                }) : a && n[a[1]] && n[a[1]].transition ? Ce({
                    key: t1,
                    value: i[t1],
                    valueSpec: r.transition,
                    style: o,
                    styleSpec: r
                }) : n[t1] ? Ce({
                    key: t1,
                    value: i[t1],
                    valueSpec: n[t1],
                    style: o,
                    styleSpec: r
                }) : [
                    new e1.a5(t1, i[t1], `unknown property "${t1}"`)
                ]);
            }
            return s;
        }
        const Se = {
            "*": ()=>[],
            array: re,
            boolean: function(t1) {
                const i = t1.value, o = t1.key;
                return e1.a1(i) ? [] : [
                    new e1.V(o, i, `boolean expected, ${e1.M(i)} found`)
                ];
            },
            number: ne,
            color: function({ key: t1, value: i }) {
                return e1.a2(i) ? null === e1.a3.parseCSSColor(i) ? [
                    new e1.V(t1, i, `color expected, "${i}" found`)
                ] : [] : [
                    new e1.V(t1, i, `color expected, ${e1.M(i)} found`)
                ];
            },
            enum: he,
            filter: de,
            function: se,
            layer: me,
            object: Ie,
            source: ye,
            model: e1.a9,
            light: be,
            "light-3d": we,
            terrain: Te,
            fog: Ee,
            string: ge,
            formatted: function(e1) {
                return 0 === ge(e1).length ? [] : ae(e1);
            },
            resolvedImage: function(e1) {
                return 0 === ge(e1).length ? [] : ae(e1);
            },
            projection: function(t1) {
                const i = t1.value, o = t1.styleSpec, r = o.projection, n = t1.style;
                if (e1.K(i)) {
                    let e1 = [];
                    for(const t1 in i)e1 = e1.concat(Ce({
                        key: t1,
                        value: i[t1],
                        valueSpec: r[t1],
                        style: n,
                        styleSpec: o
                    }));
                    return e1;
                }
                return e1.a2(i) ? [] : [
                    new e1.V("projection", i, `object or string expected, ${e1.M(i)} found`)
                ];
            },
            import: function(t1) {
                const i = t1.key, { value: o, styleSpec: r } = t1;
                if (!e1.K(o)) return [
                    new e1.V(i, o, "import must be an object")
                ];
                const { data: n, ...s } = o;
                Object.defineProperty(s, "__line__", {
                    value: o.__line__,
                    enumerable: !1
                });
                let a = Ie(Object.assign({}, t1, {
                    value: s,
                    valueSpec: r.import
                }));
                return "" === e1.L(s.id) && a.push(new e1.V(`${t1.key}.id`, s, "import id can't be an empty string")), n && (a = a.concat(De(n, r, {
                    key: `${t1.key}.data`
                }))), a;
            },
            iconset: function(t1) {
                const i = t1.value, o = t1.key, r = t1.styleSpec, n = t1.style;
                if (!e1.K(i)) return [
                    new e1.V(o, i, "object expected")
                ];
                if (!i.type) return [
                    new e1.V(o, i, '"type" is required')
                ];
                const s = e1.L(i.type);
                let a = [];
                if (a = a.concat(Ie({
                    key: o,
                    value: i,
                    valueSpec: r[`iconset_${s}`],
                    style: n,
                    styleSpec: r
                })), function(e1, t1) {
                    return !("source" !== e1 || !t1.source);
                }(s, i)) {
                    const t1 = n.sources && n.sources[i.source], r = t1 && e1.L(t1.type);
                    t1 ? "raster-array" !== r && a.push(new e1.V(o, i.source, `iconset cannot be used with a source of type ${String(r)}, it only be used with a "raster-array" source type`)) : a.push(new e1.V(o, i.source, `source "${i.source}" not found`));
                }
                return a;
            }
        };
        function Ce(t1, i = !1) {
            const o = t1.value, r = t1.valueSpec, n = t1.styleSpec;
            if (r.expression) {
                if (e1.a6(e1.L(o))) return se(t1);
                if (e1.U(e1.W(o))) return ae(t1);
            }
            if (r.type && Se[r.type]) {
                const e1 = Se[r.type](t1);
                return !0 === i && e1.length > 0 && Array.isArray(t1.value) ? ae(t1) : e1;
            }
            return Ie(Object.assign({}, t1, {
                valueSpec: r.type ? n[r.type] : r
            }));
        }
        function Ie(t1) {
            const i = t1.key, o = t1.value, r = t1.valueSpec || {}, n = t1.objectElementValidators || {}, s = t1.style, a = t1.styleSpec;
            if (!e1.K(o)) return [
                new e1.V(i, o, `object expected, ${e1.M(o)} found`)
            ];
            let l = [];
            for(const t1 in o){
                const c = t1.split(".")[0];
                let h;
                n[c] ? h = n[c] : r[c] ? h = Ce : n["*"] ? h = n["*"] : r["*"] && (h = Ce), h ? l = l.concat(h({
                    key: (i ? `${i}.` : i) + t1,
                    value: o[t1],
                    valueSpec: r[c] || r["*"],
                    style: s,
                    styleSpec: a,
                    object: o,
                    objectKey: t1
                }, o)) : l.push(new e1.a5(i, o[t1], `unknown property "${t1}"`));
            }
            for(const t1 in r){
                if (n[t1]) continue;
                const s = r[t1];
                s.required && void 0 === s.default && void 0 === o[t1] && l.push(new e1.V(i, o, `missing required property "${t1}"`));
            }
            return l;
        }
        function Re({ key: t1, value: i }) {
            const o = ge({
                key: t1,
                value: i
            });
            if (o.length) return o;
            const r = i;
            return -1 === r.indexOf("{fontstack}") && o.push(new e1.V(t1, i, '"glyphs" url must include a "{fontstack}" token')), -1 === r.indexOf("{range}") && o.push(new e1.V(t1, i, '"glyphs" url must include a "{range}" token')), o;
        }
        function De(t1, i = e1.a8, o = {}) {
            return Ie({
                key: o.key || "",
                value: t1,
                valueSpec: Object.assign(i.$root, {
                    "*": {
                        type: "*"
                    }
                }),
                styleSpec: i,
                style: t1,
                objectElementValidators: {
                    glyphs: Re
                }
            });
        }
        function Ae(t1, i = e1.a8) {
            return Ge(De(t1, i));
        }
        const Le = (e1)=>Ge(ye(e1)), Pe = (e1)=>Ge(be(e1)), Oe = (e1)=>Ge(we(e1)), Me = (e1)=>Ge(Te(e1)), ze = (e1)=>Ge(Ee(e1)), Fe = (t1)=>Ge(function(t1) {
                const i = t1.value, o = t1.style, r = t1.styleSpec, n = r.snow;
                if (void 0 === i) return [];
                if (!e1.K(i)) return [
                    new e1.V("snow", i, `object expected, ${e1.M(i)} found`)
                ];
                let s = [];
                for(const t1 in i){
                    const a = t1.match(/^(.*)-transition$/);
                    s = s.concat(a && n[a[1]] && n[a[1]].transition ? Ce({
                        key: t1,
                        value: i[t1],
                        valueSpec: r.transition,
                        style: o,
                        styleSpec: r
                    }) : n[t1] ? Ce({
                        key: t1,
                        value: i[t1],
                        valueSpec: n[t1],
                        style: o,
                        styleSpec: r
                    }) : [
                        new e1.a5(t1, i[t1], `unknown property "${t1}"`)
                    ]);
                }
                return s;
            }(t1)), Be = (t1)=>Ge(function(t1) {
                const i = t1.value, o = t1.style, r = t1.styleSpec, n = r.rain;
                if (void 0 === i) return [];
                if (!e1.K(i)) return [
                    new e1.V("rain", i, `object expected, ${e1.M(i)} found`)
                ];
                let s = [];
                for(const t1 in i){
                    const a = t1.match(/^(.*)-transition$/);
                    s = s.concat(a && n[a[1]] && n[a[1]].transition ? Ce({
                        key: t1,
                        value: i[t1],
                        valueSpec: r.transition,
                        style: o,
                        styleSpec: r
                    }) : n[t1] ? Ce({
                        key: t1,
                        value: i[t1],
                        valueSpec: n[t1],
                        style: o,
                        styleSpec: r
                    }) : [
                        new e1.a5(t1, i[t1], `unknown property "${t1}"`)
                    ]);
                }
                return s;
            }(t1)), ke = (e1)=>Ge(me(e1)), Ne = (e1)=>Ge(de(e1)), Ue = (e1)=>Ge(pe(e1)), Ve = (e1)=>Ge(fe(e1)), je = (t1)=>Ge(e1.a9(t1));
        function Ge(e1) {
            return e1.slice().sort((e1, t1)=>e1.line && t1.line ? e1.line - t1.line : 0);
        }
        function qe(t1, i) {
            let o = !1;
            if (i && i.length) for (const r of i)r instanceof e1.a5 ? e1.w(r.message) : (t1.fire(new e1.B(new Error(r.message))), o = !0);
            return o;
        }
        const Ze = e1.a8.light;
        let He;
        class We extends e1.E {
            constructor(t1, i = "flat"){
                super(), this._transitionable = new e1.aa(He || (He = new e1.ab({
                    anchor: new e1.ac(Ze.anchor),
                    position: new e1.ad(Ze.position),
                    color: new e1.ac(Ze.color),
                    intensity: new e1.ac(Ze.intensity)
                }))), this.setLight(t1, i), this._transitioning = this._transitionable.untransitioned();
            }
            getLight() {
                return this._transitionable.serialize();
            }
            setLight(e1, t1, i = {}) {
                this._validate(Pe, e1, i) || (this._transitionable.setTransitionOrValue(e1), this.id = t1);
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            _validate(t1, i, o) {
                return (!o || !1 !== o.validate) && qe(this, t1.call(Ae, Object.assign({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e1.a8
                })));
            }
        }
        const $e = e1.a8.terrain;
        let Xe = class extends e1.E {
            constructor(t1, i, o, r, n){
                super(), this.scope = o, this._transitionable = new e1.aa(new e1.ab({
                    source: new e1.ac($e.source),
                    exaggeration: new e1.ac($e.exaggeration)
                }), o, r), this._transitionable.setTransitionOrValue(t1, r), this._transitioning = this._transitionable.untransitioned(), this.drapeRenderMode = i, this.worldview = n;
            }
            get() {
                return this._transitionable.serialize();
            }
            set(e1, t1) {
                this._transitionable.setTransitionOrValue(e1, t1);
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            getExaggeration(t1) {
                return this._transitioning.possiblyEvaluate(new e1.ae(t1, {
                    worldview: this.worldview
                })).get("exaggeration");
            }
            getAttenuationRange() {
                if (!this.isZoomDependent()) return null;
                const t1 = this._transitionable._values.exaggeration;
                if (!t1) return null;
                const i = t1.value.expression;
                if (!i) return null;
                let o = -1, r = -1, n = 1;
                for (const t1 of i.zoomStops)n = i.evaluate(new e1.ae(t1, {
                    worldview: this.worldview
                })), n > .01 ? (o = t1, r = -1) : r = t1;
                return n < .01 && o > 0 && r > o ? [
                    o,
                    r
                ] : null;
            }
            isZoomDependent() {
                const t1 = this._transitionable._values.exaggeration;
                return null != t1 && null != t1.value && null != t1.value.expression && t1.value.expression instanceof e1.af;
            }
        };
        const Ye = .05;
        function Ke(t1, i, o, r) {
            const n = e1.aj(45, 65, o), [s, a] = Qe(t1, r);
            let l = 1 - Math.min(1, Math.exp((i - s) / (a - s) * -6));
            return l *= l * l, l = Math.min(1, 1.00747 * l), l * n * t1.alpha;
        }
        function Qe(e1, t1) {
            const i = .5 / Math.tan(.5 * t1);
            return [
                e1.range[0] + i,
                e1.range[1] + i
            ];
        }
        function Je(t1, i, o, r, n) {
            const s = e1.ah([], [
                i,
                o,
                r
            ], n.mercatorFogMatrix);
            return Ke(t1, e1.ai(s), n.pitch, n._fov);
        }
        function et(t1, i, o, r, n, s, a) {
            const l = [
                [
                    o,
                    r,
                    0
                ],
                [
                    n,
                    r,
                    0
                ],
                [
                    n,
                    s,
                    0
                ],
                [
                    o,
                    s,
                    0
                ]
            ];
            let c = Number.MAX_VALUE, h = -Number.MAX_VALUE;
            for (const t1 of l){
                const o = e1.ah([], t1, i), r = e1.ai(o);
                c = Math.min(c, r), h = Math.max(h, r);
            }
            return [
                Ke(t1, c, a.pitch, a._fov),
                Ke(t1, h, a.pitch, a._fov)
            ];
        }
        const tt = e1.a8.fog;
        class it extends e1.E {
            constructor(t1, i, o, r){
                super();
                const n = new e1.ab({
                    range: new e1.ac(tt.range),
                    color: new e1.ac(tt.color),
                    "color-use-theme": new e1.ac({
                        type: "string",
                        "property-type": "data-constant",
                        default: "default"
                    }),
                    "high-color": new e1.ac(tt["high-color"]),
                    "high-color-use-theme": new e1.ac({
                        type: "string",
                        "property-type": "data-constant",
                        default: "default"
                    }),
                    "space-color": new e1.ac(tt["space-color"]),
                    "space-color-use-theme": new e1.ac({
                        type: "string",
                        "property-type": "data-constant",
                        default: "default"
                    }),
                    "horizon-blend": new e1.ac(tt["horizon-blend"]),
                    "star-intensity": new e1.ac(tt["star-intensity"]),
                    "vertical-range": new e1.ac(tt["vertical-range"])
                });
                this._transitionable = new e1.aa(n, o, new Map(r)), this.set(t1, r), this._transitioning = this._transitionable.untransitioned(), this._transform = i, this.properties = new e1.ak(n), this.scope = o;
            }
            get state() {
                const t1 = this._transform, i = "globe" === t1.projection.name, o = e1.al(t1.zoom), r = this.properties.get("range"), n = [
                    .5,
                    3
                ];
                return {
                    range: i ? [
                        e1.am(n[0], r[0], o),
                        e1.am(n[1], r[1], o)
                    ] : r,
                    horizonBlend: this.properties.get("horizon-blend"),
                    alpha: this.properties.get("color").a
                };
            }
            get() {
                return this._transitionable.serialize();
            }
            set(e1, t1, i = {}) {
                if (this._validate(ze, e1, i)) return;
                const o = Object.assign({}, e1);
                for (const e1 of Object.keys(tt))void 0 === o[e1] && (o[e1] = tt[e1].default);
                this._options = o, this._transitionable.setTransitionOrValue(this._options, t1);
            }
            getOpacity(t1) {
                if (!this._transform.projection.supportsFog) return 0;
                const i = this.properties && this.properties.get("color") || 1;
                return ("globe" === this._transform.projection.name ? 1 : e1.aj(45, 65, t1)) * i.a;
            }
            getOpacityAtLatLng(t1, i) {
                return this._transform.projection.supportsFog ? function(t1, i, o) {
                    const r = e1.ag.fromLngLat(i), n = o.elevation ? o.elevation.getAtPointOrZero(r) : 0;
                    return Je(t1, r.x, r.y, n, o);
                }(this.state, t1, i) : 0;
            }
            getOpacityForTile(t1) {
                if (!this._transform.projection.supportsFog) return [
                    1,
                    1
                ];
                const i = this._transform.calculateFogTileMatrix(t1.toUnwrapped());
                return et(this.state, i, 0, 0, e1.an, e1.an, this._transform);
            }
            getOpacityForBounds(e1, t1, i, o, r) {
                return this._transform.projection.supportsFog ? et(this.state, e1, t1, i, o, r, this._transform) : [
                    1,
                    1
                ];
            }
            getFovAdjustedRange(e1) {
                return this._transform.projection.supportsFog ? Qe(this.state, e1) : [
                    0,
                    1
                ];
            }
            isVisibleOnFrustum(t1) {
                if (!this._transform.projection.supportsFog) return !1;
                const i = [
                    4,
                    5,
                    6,
                    7
                ];
                for (const o of i){
                    const i = t1.points[o];
                    let r;
                    if (i[2] >= 0) r = i;
                    else {
                        const n = t1.points[o - 4];
                        r = e1.ao(n, i, n[2] / (n[2] - i[2]));
                    }
                    if (Je(this.state, r[0], r[1], 0, this._transform) >= Ye) return !0;
                }
                return !1;
            }
            updateConfig(e1) {
                this._transitionable.setTransitionOrValue(this._options, new Map(e1));
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            _validate(t1, i, o) {
                return (!o || !1 !== o.validate) && qe(this, t1.call(Ae, Object.assign({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e1.a8
                })));
            }
        }
        let ot, rt, nt, st = class extends e1.E {
            constructor(t1, i, o, r){
                super();
                const n = ot || (ot = new e1.ab({
                    density: new e1.ac(e1.a8.snow.density),
                    intensity: new e1.ac(e1.a8.snow.intensity),
                    color: new e1.ac(e1.a8.snow.color),
                    opacity: new e1.ac(e1.a8.snow.opacity),
                    vignette: new e1.ac(e1.a8.snow.vignette),
                    "vignette-color": new e1.ac(e1.a8.snow["vignette-color"]),
                    "center-thinning": new e1.ac(e1.a8.snow["center-thinning"]),
                    direction: new e1.ac(e1.a8.snow.direction),
                    "flake-size": new e1.ac(e1.a8.snow["flake-size"])
                }));
                this._transitionable = new e1.aa(n, o, new Map(r)), this.set(t1, r), this._transitioning = this._transitionable.untransitioned(), this.properties = new e1.ak(n), this.scope = o;
            }
            get state() {
                const t1 = this.properties.get("opacity"), i = this.properties.get("color"), o = this.properties.get("direction"), r = e1.ap(o[0]), n = -Math.max(e1.ap(o[1]), .01), s = [
                    Math.cos(r) * Math.cos(n),
                    Math.sin(r) * Math.cos(n),
                    Math.sin(n)
                ], a = this.properties.get("vignette"), l = this.properties.get("vignette-color");
                return l.a = a, {
                    density: this.properties.get("density"),
                    intensity: this.properties.get("intensity"),
                    color: new e1.aq(i.r, i.g, i.b, i.a * t1),
                    direction: s,
                    centerThinning: this.properties.get("center-thinning"),
                    flakeSize: this.properties.get("flake-size"),
                    vignetteColor: l
                };
            }
            get() {
                return this._transitionable.serialize();
            }
            set(t1, i, o = {}) {
                if (this._validate(Fe, t1, o)) return;
                const r = Object.assign({}, t1), n = e1.a8.snow;
                for (const e1 of Object.keys(n))void 0 === r[e1] && (r[e1] = n[e1].default);
                this._options = r, this._transitionable.setTransitionOrValue(this._options, i);
            }
            updateConfig(e1) {
                this._transitionable.setTransitionOrValue(this._options, new Map(e1));
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            _validate(t1, i, o) {
                return (!o || !1 !== o.validate) && qe(this, t1.call(Ae, Object.assign({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e1.a8
                })));
            }
        }, at = class extends e1.E {
            constructor(t1, i, o, r){
                super();
                const n = rt || (rt = new e1.ab({
                    density: new e1.ac(e1.a8.rain.density),
                    intensity: new e1.ac(e1.a8.rain.intensity),
                    color: new e1.ac(e1.a8.rain.color),
                    opacity: new e1.ac(e1.a8.rain.opacity),
                    vignette: new e1.ac(e1.a8.rain.vignette),
                    "vignette-color": new e1.ac(e1.a8.rain["vignette-color"]),
                    "center-thinning": new e1.ac(e1.a8.rain["center-thinning"]),
                    direction: new e1.ac(e1.a8.rain.direction),
                    "droplet-size": new e1.ac(e1.a8.rain["droplet-size"]),
                    "distortion-strength": new e1.ac(e1.a8.rain["distortion-strength"])
                }));
                this._transitionable = new e1.aa(n, o, new Map(r)), this.set(t1, r), this._transitioning = this._transitionable.untransitioned(), this.properties = new e1.ak(n), this.scope = o;
            }
            get state() {
                const t1 = this.properties.get("opacity"), i = this.properties.get("color"), o = this.properties.get("direction"), r = e1.ap(o[0]), n = -Math.max(e1.ap(o[1]), .01), s = [
                    Math.cos(r) * Math.cos(n),
                    Math.sin(r) * Math.cos(n),
                    Math.sin(n)
                ], a = this.properties.get("vignette-color");
                return a.a = this.properties.get("vignette"), {
                    density: this.properties.get("density"),
                    intensity: this.properties.get("intensity"),
                    color: new e1.aq(i.r, i.g, i.b, i.a * t1),
                    direction: s,
                    centerThinning: this.properties.get("center-thinning"),
                    dropletSize: this.properties.get("droplet-size"),
                    distortionStrength: this.properties.get("distortion-strength"),
                    vignetteColor: a
                };
            }
            get() {
                return this._transitionable.serialize();
            }
            set(t1, i, o = {}) {
                if (this._validate(Be, t1, o)) return;
                const r = Object.assign({}, t1), n = e1.a8.rain;
                for (const e1 of Object.keys(n))void 0 === r[e1] && (r[e1] = n[e1].default);
                this._options = r, this._transitionable.setTransitionOrValue(this._options, i);
            }
            updateConfig(e1) {
                this._transitionable.setTransitionOrValue(this._options, new Map(e1));
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            _validate(t1, i, o) {
                return (!o || !1 !== o.validate) && qe(this, t1.call(Ae, Object.assign({
                    value: i,
                    style: {
                        glyphs: !0,
                        sprite: !0
                    },
                    styleSpec: e1.a8
                })));
            }
        };
        class lt extends e1.E {
            constructor(t1, i, o, r){
                super(), this.scope = o, this._options = t1, this.properties = new e1.ak(i), this._transitionable = new e1.aa(i, o, new Map(r)), this._transitionable.setTransitionOrValue(t1.properties), this._transitioning = this._transitionable.untransitioned();
            }
            updateConfig(e1) {
                this._transitionable.setTransitionOrValue(this._options.properties, new Map(e1));
            }
            updateTransitions(e1) {
                this._transitioning = this._transitionable.transitioned(e1, this._transitioning);
            }
            hasTransition() {
                return this._transitioning.hasTransition();
            }
            recalculate(e1) {
                this.properties = this._transitioning.possiblyEvaluate(e1);
            }
            get() {
                return this._options.properties = this._transitionable.serialize(), this._options;
            }
            set(e1, t1) {
                this._options = e1, this._transitionable.setTransitionOrValue(e1.properties, t1);
            }
            shadowsEnabled() {
                return !!this.properties && !0 === this.properties.get("cast-shadows");
            }
        }
        const ct = ()=>nt || (nt = new e1.ab({
                color: new e1.ac(e1.a8.properties_light_ambient.color),
                "color-use-theme": new e1.ac({
                    type: "string",
                    default: "default",
                    "property-type": "data-constant"
                }),
                intensity: new e1.ac(e1.a8.properties_light_ambient.intensity)
            }));
        let ht;
        const dt = ()=>ht || (ht = new e1.ab({
                direction: new e1.ar(e1.a8.properties_light_directional.direction),
                color: new e1.ac(e1.a8.properties_light_directional.color),
                "color-use-theme": new e1.ac({
                    type: "string",
                    default: "default",
                    "property-type": "data-constant"
                }),
                intensity: new e1.ac(e1.a8.properties_light_directional.intensity),
                "cast-shadows": new e1.ac(e1.a8.properties_light_directional["cast-shadows"]),
                "shadow-quality": new e1.ac(e1.a8.properties_light_directional["shadow-quality"]),
                "shadow-intensity": new e1.ac(e1.a8.properties_light_directional["shadow-intensity"]),
                "shadow-draw-before-layer": new e1.ac(e1.a8.properties_light_directional["shadow-draw-before-layer"])
            }));
        class _t {
            constructor(e1, t1, i){
                this.screenBounds = e1, this.cameraPoint = i.getCameraPoint(), this._screenRaycastCache = {}, this._cameraRaycastCache = {}, this.isAboveHorizon = t1, this.screenGeometry = this.bufferedScreenGeometry(0), this.screenGeometryMercator = this._bufferedScreenMercator(0, i);
            }
            static createFromScreenPoints(t1, i) {
                let o, r;
                if (t1 instanceof e1.P || "number" == typeof t1[0]) {
                    const n = e1.P.convert(t1);
                    o = [
                        n
                    ], r = i.isPointAboveHorizon(n);
                } else {
                    const n = e1.P.convert(t1[0]), s = e1.P.convert(t1[1]), a = n.add(s)._div(2);
                    o = [
                        n,
                        s
                    ], r = e1.as(n, s).every((e1)=>i.isPointAboveHorizon(e1)) && i.isPointAboveHorizon(a);
                }
                return new _t(o, r, i);
            }
            isPointQuery() {
                return 1 === this.screenBounds.length;
            }
            bufferedScreenGeometry(t1) {
                return e1.as(this.screenBounds[0], 1 === this.screenBounds.length ? this.screenBounds[0] : this.screenBounds[1], t1);
            }
            bufferedCameraGeometry(t1) {
                const i = this.screenBounds[0], o = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e1.P(1, 1)) : this.screenBounds[1], r = e1.as(i, o, 0, !1);
                return this.cameraPoint.y > o.y && (this.cameraPoint.x > i.x && this.cameraPoint.x < o.x ? r.splice(3, 0, this.cameraPoint) : this.cameraPoint.x >= o.x ? r[2] = this.cameraPoint : this.cameraPoint.x <= i.x && (r[3] = this.cameraPoint)), e1.at(r, t1);
            }
            bufferedCameraGeometryGlobe(t1) {
                const i = this.screenBounds[0], o = 1 === this.screenBounds.length ? this.screenBounds[0].add(new e1.P(1, 1)) : this.screenBounds[1], r = e1.as(i, o, t1), n = this.cameraPoint.clone(), s = Number(n.x > i.x) + Number(n.x > o.x);
                switch(3 * (Number(n.y > i.y) + Number(n.y > o.y)) + s){
                    case 0:
                        r[0] = n, r[4] = n.clone();
                        break;
                    case 1:
                        r.splice(1, 0, n);
                        break;
                    case 2:
                        r[1] = n;
                        break;
                    case 3:
                        r.splice(4, 0, n);
                        break;
                    case 5:
                        r.splice(2, 0, n);
                        break;
                    case 6:
                        r[3] = n;
                        break;
                    case 7:
                        r.splice(3, 0, n);
                        break;
                    case 8:
                        r[2] = n;
                }
                return r;
            }
            containsTile(t1, i, o, r = 0) {
                const n = Math.max(t1.queryPadding, t1.evaluateQueryRenderedFeaturePadding()) / i._pixelsPerMercatorPixel + 1, s = o ? this._bufferedCameraMercator(n, i) : this._bufferedScreenMercator(n, i);
                let a = t1.tileID.wrap + (s.unwrapped ? r : 0);
                const l = s.polygon.map((i)=>e1.au(t1.tileTransform, i, a));
                if (!e1.av(l, 0, 0, e1.an, e1.an)) return;
                a = t1.tileID.wrap + (this.screenGeometryMercator.unwrapped ? r : 0);
                const c = this.screenGeometryMercator.polygon.map((i)=>e1.aw(t1.tileTransform, i, a)), h = c.map((t1)=>new e1.P(t1[0], t1[1])), d = i.getFreeCameraOptions().position || new e1.ag(0, 0, 0), _ = e1.aw(t1.tileTransform, d, a), u = c.map((t1)=>{
                    const i = e1.ax(t1, t1, _);
                    return e1.ay(i, i), new e1.az(_, i);
                }), p = e1.aA(t1, 1, i.zoom) * i._pixelsPerMercatorPixel;
                var f;
                return {
                    queryGeometry: this,
                    tilespaceGeometry: h,
                    tilespaceRays: u,
                    bufferedTilespaceGeometry: l,
                    bufferedTilespaceBounds: (f = e1.aB(l), f.min.x = e1.aC(f.min.x, 0, e1.an), f.min.y = e1.aC(f.min.y, 0, e1.an), f.max.x = e1.aC(f.max.x, 0, e1.an), f.max.y = e1.aC(f.max.y, 0, e1.an), f),
                    tile: t1,
                    tileID: t1.tileID,
                    pixelToTileUnitsFactor: p
                };
            }
            _bufferedScreenMercator(e1, t1) {
                const i = ft(e1);
                if (this._screenRaycastCache[i]) return this._screenRaycastCache[i];
                {
                    let o;
                    return o = "globe" === t1.projection.name ? this._projectAndResample(this.bufferedScreenGeometry(e1), t1) : {
                        polygon: this.bufferedScreenGeometry(e1).map((e1)=>t1.pointCoordinate3D(e1)),
                        unwrapped: !0
                    }, this._screenRaycastCache[i] = o, o;
                }
            }
            _bufferedCameraMercator(e1, t1) {
                const i = ft(e1);
                if (this._cameraRaycastCache[i]) return this._cameraRaycastCache[i];
                {
                    let o;
                    return o = "globe" === t1.projection.name ? this._projectAndResample(this.bufferedCameraGeometryGlobe(e1), t1) : {
                        polygon: this.bufferedCameraGeometry(e1).map((e1)=>t1.pointCoordinate3D(e1)),
                        unwrapped: !0
                    }, this._cameraRaycastCache[i] = o, o;
                }
            }
            _projectAndResample(t1, i) {
                const o = function(t1, i) {
                    const o = e1.aD([], i.pixelMatrix, i.globeMatrix), r = [
                        0,
                        -e1.aF,
                        0,
                        1
                    ], n = [
                        0,
                        e1.aF,
                        0,
                        1
                    ], s = [
                        0,
                        0,
                        0,
                        1
                    ];
                    e1.aE(r, r, o), e1.aE(n, n, o), e1.aE(s, s, o);
                    const a = new e1.P(r[0] / r[3], r[1] / r[3]), l = new e1.P(n[0] / n[3], n[1] / n[3]), c = e1.aG(t1, a) && r[3] < s[3], h = e1.aG(t1, l) && n[3] < s[3];
                    if (!c && !h) return null;
                    const d = function(e1, t1, i) {
                        for(let o = 1; o < e1.length; o++){
                            const r = pt(t1.pointCoordinate3D(e1[o - 1]).x), n = pt(t1.pointCoordinate3D(e1[o]).x);
                            if (i < 0) {
                                if (r < n) return {
                                    idx: o,
                                    t: -r / (n - 1 - r)
                                };
                            } else if (n < r) return {
                                idx: o,
                                t: (1 - r) / (n + 1 - r)
                            };
                        }
                        return null;
                    }(t1, i, c ? -1 : 1);
                    if (!d) return null;
                    const { idx: _, t: u } = d;
                    let p = _ > 1 ? ut(t1.slice(0, _), i) : [], f = _ < t1.length ? ut(t1.slice(_), i) : [];
                    p = p.map((t1)=>new e1.P(pt(t1.x), t1.y)), f = f.map((t1)=>new e1.P(pt(t1.x), t1.y));
                    const m = [
                        ...p
                    ];
                    0 === m.length && m.push(f[f.length - 1]);
                    const g = e1.am(m[m.length - 1].y, (0 === f.length ? p[0] : f[0]).y, u);
                    let v;
                    return v = c ? [
                        new e1.P(0, g),
                        new e1.P(0, 0),
                        new e1.P(1, 0),
                        new e1.P(1, g)
                    ] : [
                        new e1.P(1, g),
                        new e1.P(1, 1),
                        new e1.P(0, 1),
                        new e1.P(0, g)
                    ], m.push(...v), 0 === f.length ? m.push(p[0]) : m.push(...f), {
                        polygon: m.map((t1)=>new e1.ag(t1.x, t1.y)),
                        unwrapped: !1
                    };
                }(t1, i);
                if (o) return o;
                const r = function(t1, i) {
                    let o = !1, r = -1 / 0, n = 0;
                    for(let e1 = 0; e1 < t1.length - 1; e1++)t1[e1].x > r && (r = t1[e1].x, n = e1);
                    for(let e1 = 0; e1 < t1.length - 1; e1++){
                        const i = (n + e1) % (t1.length - 1), r = t1[i], s = t1[i + 1];
                        Math.abs(r.x - s.x) > .5 && (r.x < s.x ? (r.x += 1, 0 === i && (t1[t1.length - 1].x += 1)) : (s.x += 1, i + 1 === t1.length - 1 && (t1[0].x += 1)), o = !0);
                    }
                    const s = e1.aH(i.center.lng);
                    return o && s < Math.abs(s - 1) && t1.forEach((e1)=>{
                        e1.x -= 1;
                    }), {
                        polygon: t1,
                        unwrapped: o
                    };
                }(ut(t1, i).map((t1)=>new e1.P(pt(t1.x), t1.y)), i);
                return {
                    polygon: r.polygon.map((t1)=>new e1.ag(t1.x, t1.y)),
                    unwrapped: r.unwrapped
                };
            }
        }
        function ut(t1, i) {
            return e1.aI(t1, (e1)=>{
                const t1 = i.pointCoordinate3D(e1);
                e1.x = t1.x, e1.y = t1.y;
            }, 1 / 256);
        }
        function pt(e1) {
            return e1 < 0 ? 1 + e1 % 1 : e1 % 1;
        }
        function ft(e1) {
            return 100 * e1 | 0;
        }
        function mt(t1, i, o) {
            try {
                i = function(e1) {
                    if (!e1.variants) return e1;
                    if (!Array.isArray(e1.variants)) throw new Error("variants must be an array");
                    for (const t1 of e1.variants){
                        if (null == t1 || "object" != typeof t1 || t1.constructor !== Object) throw new Error("variant must be an object");
                        if (!Array.isArray(t1.capabilities)) throw new Error("capabilities must be an array");
                        if (1 === t1.capabilities.length && "meshopt" === t1.capabilities[0]) return Object.assign(e1, t1);
                    }
                    return e1;
                }(i);
            } catch (e1) {
                return new Error("Failed to process TileJSON variants", {
                    cause: e1
                });
            }
            const r = e1.aJ(Object.assign({}, i, t1), [
                "tilejson",
                "tiles",
                "minzoom",
                "maxzoom",
                "attribution",
                "mapbox_logo",
                "bounds",
                "extra_bounds",
                "scheme",
                "tileSize",
                "encoding",
                "vector_layers",
                "raster_layers",
                "worldview_options",
                "worldview_default",
                "worldview"
            ]);
            return t1.url && i.tiles && t1.tiles && (r.tiles = i.tiles), r.tiles = o.canonicalizeTileset(r, t1.url), r;
        }
        function gt(t1, i, o, r, n) {
            const s = function(e1, o) {
                if (e1) return n(e1);
                if (o) {
                    t1.url && o.tiles && t1.tiles && delete t1.tiles;
                    const e1 = mt(t1, o, i);
                    if (e1 instanceof Error) return n(e1);
                    n(null, e1);
                }
            }, a = function(e1, t1, i) {
                if (!e1) return null;
                if (!t1 && !i) return e1;
                i = i || e1.worldview_default;
                const o = Object.values(e1.language || {});
                if (0 === o.length) return null;
                const r = Object.values(e1.worldview || {});
                if (0 === r.length) return null;
                const n = o.every((e1)=>e1 === t1), s = r.every((e1)=>e1 === i);
                return n && s ? e1 : t1 in (e1.language_options || {}) || i in (e1.worldview_options || {}) ? null : e1.language_options && e1.worldview_options ? e1 : null;
            }(t1.data, o, r);
            return a ? e1.o.frame(()=>s(null, a)) : t1.url ? e1.m(i.transformRequest(i.normalizeSourceURL(t1.url, null, o, r), e1.R.Source), s) : e1.o.frame(()=>{
                const { data: e1, ...i } = t1;
                s(null, i);
            });
        }
        function vt(t1, i) {
            const o = Math.pow(2, i.z), r = Math.floor(e1.aH(t1.getWest()) * o), n = Math.floor(e1.aL(t1.getNorth()) * o), s = Math.ceil(e1.aH(t1.getEast()) * o), a = Math.ceil(e1.aL(t1.getSouth()) * o);
            return i.x >= r && i.x < s && i.y >= n && i.y < a;
        }
        class yt {
            constructor(t1, i, o){
                this.bounds = t1 ? e1.aK.convert(this.validateBounds(t1)) : null, this.minzoom = i || 0, this.maxzoom = o || 24;
            }
            validateBounds(e1) {
                return Array.isArray(e1) && 4 === e1.length ? [
                    Math.max(-180, e1[0]),
                    Math.max(-90, e1[1]),
                    Math.min(180, e1[2]),
                    Math.min(90, e1[3])
                ] : [
                    -180,
                    -90,
                    180,
                    90
                ];
            }
            addExtraBounds(t1) {
                if (t1) {
                    this.extraBounds || (this.extraBounds = []);
                    for (const i of t1)this.extraBounds.push(e1.aK.convert(this.validateBounds(i)));
                }
            }
            contains(e1) {
                if (e1.z > this.maxzoom || e1.z < this.minzoom) return !1;
                if (this.bounds && !vt(this.bounds, e1)) return !1;
                if (!this.extraBounds) return !0;
                for (const t1 of this.extraBounds)if (vt(t1, e1)) return !0;
                return !1;
            }
            static fromTileJSON(e1) {
                if (!e1.bounds && !e1.extra_bounds) return null;
                const t1 = new yt(e1.bounds, e1.minzoom, e1.maxzoom);
                return t1.addExtraBounds(e1.extra_bounds), t1;
            }
        }
        class xt extends e1.E {
            constructor(t1, i, o, r){
                if (super(), this.id = t1, this.dispatcher = o, this.type = "vector", this.provider = i.provider, this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, Object.assign(this, e1.aJ(i, [
                    "url",
                    "scheme",
                    "tileSize",
                    "promoteId"
                ])), this._options = Object.assign({
                    type: "vector"
                }, i), this._collectResourceTiming = !!i.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                this.setEventedParent(r), this._tileWorkers = {}, this._deduped = new e1.aN;
            }
            load(t1) {
                this._loaded = !1, this.fire(new e1.C("dataloading", {
                    dataType: "source"
                }));
                const i = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, o = this.map.getWorldview(), r = (r, n)=>{
                    this._tileJSONRequest = null, this._loaded = !0, r ? (i && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${i}`), o && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${o}`), this.fire(new e1.B(r))) : n && (this._setTileJSON(n), P(n.tiles, this.map._requestManager._customAccessToken), this.fire(new e1.C("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new e1.C("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }))), t1 && t1(r);
                };
                this.provider = this._options.provider;
                const n = function(t1) {
                    if ("provider" in t1 && !t1.provider) return null;
                    let i = t1.provider;
                    if (!i && "url" in t1 && t1.url && (i = e1.aM(t1.url)), !i) return null;
                    const o = e1.e.TILE_PROVIDER_URLS[i];
                    if (!o) return null;
                    let r;
                    try {
                        r = new URL(o, e1.e.API_URL).href;
                    } catch (t1) {
                        return e1.w(`TileProvider "${i}" has an invalid URL: "${o}"`), null;
                    }
                    return {
                        name: i,
                        url: r
                    };
                }(this._options);
                if (this.provider && !n) return this._loaded = !0, this.fire(new e1.B(new Error(`TileProvider "${this.provider}" is not registered`))), void (t1 && t1());
                this._tileJSONRequest = n ? this._loadWithProvider(n, r) : gt(this._options, this.map._requestManager, i, o, r);
            }
            _loadWithProvider(t1, i) {
                this.provider = t1.name;
                const o = new AbortController, r = this._options.url && !this._options.tiles ? this.map._requestManager.transformRequest(this._options.url, e1.R.Source) : void 0, n = r ? Object.assign({}, this._options, {
                    url: r.url
                }) : this._options;
                return this.dispatcher.broadcast("loadTileProvider", {
                    name: t1.name,
                    url: t1.url,
                    source: this.id,
                    scope: this.scope,
                    type: this.type,
                    options: n,
                    request: r
                }, (e1, t1)=>{
                    if (o.signal.aborted) return;
                    if (e1) return void i(e1);
                    const r = t1 ? t1.find((e1)=>null != e1) : null;
                    if (r) {
                        const e1 = mt(this._options, r, this.map._requestManager);
                        e1 instanceof Error ? i(e1) : i(null, e1);
                    } else i(null, {
                        tiles: this._options.tiles
                    });
                }), {
                    cancel: ()=>{
                        o.abort();
                    }
                };
            }
            _setTileJSON(e1) {
                if (Object.assign(this, e1), this.hasWorldviews = !!e1.worldview_options, e1.worldview_default && (this.worldviewDefault = e1.worldview_default), e1.vector_layers) {
                    this.vectorLayers = e1.vector_layers, this.vectorLayerIds = [], this.localizableLayerIds = new Set;
                    for (const t1 of e1.vector_layers)this.vectorLayerIds.push(t1.id), e1.worldview && e1.worldview[t1.source] && this.localizableLayerIds.add(t1.id);
                }
                this.tileBounds = yt.fromTileJSON(e1);
            }
            loaded() {
                return this._loaded;
            }
            hasTile(e1) {
                return !this.tileBounds || this.tileBounds.contains(e1.canonical);
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            reload() {
                this.cancelTileJSONRequest();
                const t1 = e1.F(this.id, this.scope);
                this.load(()=>this.map.style.clearSource(t1));
            }
            setTiles(e1) {
                return this._options.tiles = e1, this.reload(), this;
            }
            setUrl(e1) {
                return this.url = e1, this._options.url = e1, this.reload(), this;
            }
            onRemove(e1) {
                this.cancelTileJSONRequest();
            }
            serialize() {
                return Object.assign({}, this._options);
            }
            loadTile(t1, i) {
                const o = t1.tileID.canonical.url(this.tiles, this.scheme), r = this.map._requestManager.normalizeTileURL(o), n = this.map._requestManager.transformRequest(r, e1.R.Tile), s = this.map.style ? this.map.style.getLut(this.scope) : null, a = s ? {
                    image: s.image.clone()
                } : null, l = {
                    request: n,
                    data: void 0,
                    uid: t1.uid,
                    tileID: t1.tileID,
                    tileZoom: t1.tileZoom,
                    zoom: t1.tileID.overscaledZ,
                    maxZoom: this.maxzoom,
                    lut: a,
                    tileSize: this.tileSize * t1.tileID.overscaleFactor(),
                    type: this.type,
                    source: this.id,
                    scope: this.scope,
                    pixelRatio: e1.o.devicePixelRatio,
                    showCollisionBoxes: this.map.showCollisionBoxes,
                    promoteId: this.promoteId,
                    renderSourceType: t1.renderSourceType,
                    brightness: this.map.style && this.map.style.getBrightness() || 0,
                    extraShadowCaster: t1.isExtraShadowCaster,
                    tessellationStep: this.map._tessellationStep,
                    scaleFactor: this.map.getScaleFactor(),
                    worldview: this.map.getWorldview() || this.worldviewDefault,
                    indoor: this.map.getIndoorTileOptions(this.id, this.scope)
                };
                if (this.hasWorldviews && e1.h(o) && (l.localizableLayerIds = this.localizableLayerIds), l.request.collectResourceTiming = this._collectResourceTiming, t1.actor && "expired" !== t1.state) "loading" === t1.state ? t1.reloadCallback = i : t1.request = t1.actor.send("reloadTile", l, c.bind(this));
                else if (t1.actor = this._tileWorkers[r] = this._tileWorkers[r] || this.dispatcher.getActor(), this.dispatcher.ready || this.provider) t1.request = t1.actor.send("loadTile", l, c.bind(this), void 0, !0);
                else {
                    const i = e1.aO.call({
                        deduped: this._deduped
                    }, l, (i, o)=>{
                        if (i || !o) c.call(this, i);
                        else {
                            const i = e1.aP(o.responseHeaders);
                            l.data = {
                                rawData: o.rawData.slice(0),
                                expires: i.expires,
                                cacheControl: i.cacheControl
                            }, t1.actor && t1.actor.send("loadTile", l, c.bind(this), void 0, !0);
                        }
                    }, !0);
                    t1.request = {
                        cancel: i
                    };
                }
                function c(o, r) {
                    return delete t1.request, t1.aborted ? i(null) : o ? i(o) : (r && r.resourceTiming && (t1.resourceTiming = r.resourceTiming), this.map._refreshExpiredTiles && r && t1.setExpiryData(r), t1.loadVectorData(r, this.map.painter), e1.aQ(this.dispatcher), i(null, r), void (t1.reloadCallback && (this.loadTile(t1, t1.reloadCallback), t1.reloadCallback = null)));
                }
            }
            abortTile(e1) {
                e1.request && (e1.request.cancel(), delete e1.request), e1.actor && e1.actor.send("abortTile", {
                    uid: e1.uid,
                    type: this.type,
                    source: this.id,
                    scope: this.scope
                });
            }
            unloadTile(e1, t1) {
                e1.actor && e1.actor.send("removeTile", {
                    uid: e1.uid,
                    type: this.type,
                    source: this.id,
                    scope: this.scope
                }), e1.destroy();
            }
            hasTransition() {
                return !1;
            }
            afterUpdate() {
                this._tileWorkers = {};
            }
            cancelTileJSONRequest() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
        }
        class bt extends e1.E {
            constructor(t1, i, o, r){
                super(), this.id = t1, this.dispatcher = o, this.setEventedParent(r), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = Object.assign({
                    type: "raster"
                }, i), Object.assign(this, e1.aJ(i, [
                    "url",
                    "scheme",
                    "tileSize"
                ]));
            }
            load(t1) {
                this._loaded = !1, this.fire(new e1.C("dataloading", {
                    dataType: "source"
                }));
                const i = this.map.getWorldview();
                this._tileJSONRequest = gt(this._options, this.map._requestManager, null, i, (i, o)=>{
                    this._tileJSONRequest = null, this._loaded = !0, i ? this.fire(new e1.B(i)) : o && (Object.assign(this, o), o.raster_layers && (this.rasterLayers = o.raster_layers, this.rasterLayerIds = this.rasterLayers.map((e1)=>e1.id)), this.tileBounds = yt.fromTileJSON(o), P(o.tiles), this.fire(new e1.C("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new e1.C("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }))), t1 && t1(i);
                });
            }
            loaded() {
                return this._loaded;
            }
            onAdd(e1) {
                this.map = e1, this.load();
            }
            reload() {
                this.cancelTileJSONRequest();
                const t1 = e1.F(this.id, this.scope);
                this.load(()=>this.map.style.clearSource(t1));
            }
            setTiles(e1) {
                return this._options.tiles = e1, this.reload(), this;
            }
            setUrl(e1) {
                return this.url = e1, this._options.url = e1, this.reload(), this;
            }
            onRemove(e1) {
                this.cancelTileJSONRequest();
            }
            serialize() {
                return Object.assign({}, this._options);
            }
            hasTile(e1) {
                return !this.tileBounds || this.tileBounds.contains(e1.canonical);
            }
            loadTile(t1, i) {
                const o = e1.o.devicePixelRatio >= 2, r = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), o, this.tileSize);
                t1.request = e1.n(this.map._requestManager.transformRequest(r, e1.R.Tile), (o, r, n)=>{
                    if (delete t1.request, t1.aborted) return t1.state = "unloaded", i(null);
                    if (o) return t1.state = "errored", i(o);
                    if (!r) return i(null);
                    const s = e1.aP(n);
                    this.map._refreshExpiredTiles && t1.setExpiryData(s), t1.setTexture(r, this.map.painter), t1.state = "loaded", e1.aQ(this.dispatcher), i(null);
                });
            }
            abortTile(e1, t1) {
                e1.request && (e1.request.cancel(), delete e1.request), t1 && t1();
            }
            unloadTile(t1, i) {
                t1.texture && t1.texture instanceof e1.T ? (t1.destroy(!1), t1.texture && t1.texture instanceof e1.T && this.map.painter.saveTileTexture(t1.texture)) : t1.destroy(), i && i();
            }
            hasTransition() {
                return !1;
            }
            cancelTileJSONRequest() {
                this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
            }
        }
        function wt([t1, i], o, r, { scaled: n = !0 } = {}) {
            const { tileSize: s, buffer: a } = r, { x: l, y: c, z: h } = o;
            if (!isFinite(l) || !isFinite(c) || !isFinite(h)) throw new Error("Invalid MRT header");
            const d = 2 ** h, _ = d * e1.aH(t1), u = d * e1.aL(i);
            return function([e1, t1], i, { scaled: o = !0 } = {}) {
                if (!i) throw new Error("bandView is undefined");
                const { data: r, tileSize: n, buffer: s, offset: a, scale: l, dimension: c } = i;
                if (e1 < -s || e1 > n + s || t1 < -s || t1 > n + s) throw new Error(`Point (${e1}, ${t1}) out of bounds for tileSize=${n}, buffer=${s}`);
                const h = (t1 + s) * (n + 2 * s) + (e1 + s);
                if (4294967295 === new Uint32Array(r.buffer)[h]) return null;
                let d = [];
                d = o ? [] : new i.data.constructor(c);
                for(let e1 = 0; e1 < c; e1++)d[e1] = Math.round(1e12 * (r[c * h + e1] * l + a)) / 1e12;
                return d;
            }([
                Math.min(Math.max(-a, Math.floor((_ - l) * s)), s - 1 + a),
                Math.min(Math.max(-a, Math.floor((u - c) * s)), s - 1 + a)
            ], r, {
                scaled: n
            });
        }
        class Tt extends bt {
            constructor(e1, t1, i, o){
                super(e1, t1, i, o), this.type = "raster-array", this.maxzoom = 22, this.partial = !0, this._loadTilePending = {}, this._loadTileLoaded = {}, this._options = Object.assign({
                    type: "raster-array"
                }, t1);
            }
            triggerRepaint(e1) {
                const t1 = this.map.painter._terrain, i = this.map.style.getSourceCache(this.id);
                t1 && t1.enabled && i && t1._clearRenderCacheForTile(i.id, e1.tileID), this.map.triggerRepaint();
            }
            loadTile(t1, i) {
                const o = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize), r = this.map._requestManager.transformRequest(o, e1.R.Tile), n = {
                    request: r,
                    uid: t1.uid,
                    tileID: t1.tileID,
                    type: this.type,
                    source: this.id,
                    scope: this.scope,
                    partial: this.partial
                };
                t1.source = this.id, t1.scope = this.scope, t1.requestParams = r, t1.actor || (t1.actor = this.dispatcher.getActor());
                const s = (o, r, n)=>{
                    if (delete t1.request, t1.aborted) return t1.state = "unloaded", i(null);
                    if (o) {
                        if ("AbortError" === o.name) return;
                        return t1.state = "errored", i(o);
                    }
                    if (this.map._refreshExpiredTiles && r) {
                        const i = e1.aP(n);
                        t1.setExpiryData(i);
                    }
                    if (this.partial && "expired" !== t1.state) t1.state = "empty";
                    else if (!this.partial) {
                        if (!r) return i(null);
                        t1.state = "loaded", t1._isHeaderLoaded = !0, t1._mrt = r;
                    }
                    i(null);
                };
                t1.request = this.partial ? t1.fetchHeader(void 0, s.bind(this)) : t1.actor.send("loadTile", n, s.bind(this), void 0, !0);
            }
            abortTile(e1) {
                e1.request && (e1.request.cancel(), delete e1.request), e1.actor && e1.actor.send("abortTile", {
                    uid: e1.uid,
                    type: this.type,
                    source: this.id,
                    scope: this.scope
                });
            }
            unloadTile(e1, t1) {
                const i = e1.texturePerLayer;
                if (e1.flushAllQueues(), i.size) {
                    e1.destroy(!1);
                    for (const e1 of i.values())this.map.painter.saveTileTexture(e1);
                } else e1.destroy();
            }
            prepareTile(t1, i, o, r) {
                t1._isHeaderLoaded && ("empty" !== t1.state && (t1.state = "reloading"), t1.fetchBandForRender(i, o, r, (i, r)=>{
                    i ? (t1.state = "errored", this.fire(new e1.B(i))) : r && (t1._isHeaderLoaded = !0, t1.setTexturePerLayer(o, r, this.map.painter), t1.state = "loaded"), this.triggerRepaint(t1);
                }));
            }
            getInitialBand(e1) {
                if (!this.rasterLayers) return 0;
                const t1 = this.rasterLayers.find(({ id: t1 })=>t1 === e1), i = t1 && t1.fields, o = i && i.bands && i.bands;
                return o ? o[0] : 0;
            }
            getTextureDescriptor(t1, i, o) {
                if (!t1) return;
                const r = i.sourceLayer || this.rasterLayerIds && this.rasterLayerIds[0];
                if (!r) return;
                let n = null;
                i instanceof e1.aT ? n = i.paint.get("raster-array-band") : i instanceof e1.aU && (n = i.paint.get("raster-particle-array-band"));
                const s = n || this.getInitialBand(r);
                if (null == s) return;
                if (!t1.textureDescriptorPerLayer.get(i.id)) return void this.prepareTile(t1, r, i.id, s);
                if (t1.updateNeeded(i.id, s) && !o) return;
                const a = t1.textureDescriptorPerLayer.get(i.id);
                return Object.assign({}, a, {
                    texture: t1.texturePerLayer.get(i.id)
                });
            }
            getImages(t1, i) {
                const o = new Map;
                for (const r of t1)for (const t1 of i){
                    const [i, n] = t1.split("/"), s = r.getLayer(i);
                    if (!s) continue;
                    if (!s.hasBand(n) || !s.hasDataForBand(n)) continue;
                    const { bytes: a, tileSize: l, buffer: c } = s.getBandView(n), h = l + 2 * c, d = {
                        data: new e1.q({
                            width: h,
                            height: h
                        }, a),
                        pixelRatio: 2,
                        sdf: !1,
                        usvg: !1,
                        version: 0
                    };
                    o.set(t1, d);
                }
                return o;
            }
            queryRasterArrayValueByBandId(t1, i, o) {
                const r = i._mrt;
                return new Promise((n)=>{
                    const s = {}, a = new Set;
                    for (const [l, c] of Object.entries(r.layers)){
                        if (o.layerName && l !== o.layerName) continue;
                        const h = {};
                        s[l] = h;
                        for (const { bands: d } of c.dataIndex)for (const _ of d)o.bands && !o.bands.includes(_) || (a.add(e1.F(l, _)), i.fetchBand(l, null, _, (i)=>{
                            e1.o.frame(()=>{
                                h[_] = i ? null : wt([
                                    t1.lng,
                                    t1.lat
                                ], r, c.getBandView(_)), a.delete(e1.F(l, _)), 0 === a.size && n(s);
                            });
                        }, !1));
                    }
                    0 === a.size && n(s);
                });
            }
            _loadTileForQuery(t1, i) {
                if (this._loadTileLoaded[t1.uid]) return void i(null, t1._mrt);
                if (this._loadTilePending[t1.uid]) return void this._loadTilePending[t1.uid].push(i);
                this._loadTilePending[t1.uid] = [
                    i
                ];
                const o = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize), r = this.map._requestManager.transformRequest(o, e1.R.Tile);
                t1.actor.send("loadTile", {
                    request: r,
                    uid: t1.uid,
                    tileID: t1.tileID,
                    type: this.type,
                    source: this.id,
                    scope: this.scope,
                    partial: !1
                }, (i, o, r)=>{
                    if (i) return this._loadTilePending[t1.uid].forEach((e1)=>e1(i, null)), void delete this._loadTilePending[t1.uid];
                    if (!o) return this._loadTilePending[t1.uid].forEach((e1)=>e1(null, null)), void delete this._loadTilePending[t1.uid];
                    if (this.map._refreshExpiredTiles && o) {
                        const i = e1.aP(r);
                        t1.setExpiryData(i);
                    }
                    t1._mrt = o, t1._isHeaderLoaded = !0, t1.state = "loaded", this._loadTilePending[t1.uid].forEach((e1)=>e1(null, o)), this._loadTileLoaded[t1.uid] = !0, delete this._loadTilePending[t1.uid];
                }, void 0, !0);
            }
            queryRasterArrayValueByAllBands(e1, t1, i) {
                return new Promise((o, r)=>{
                    this._loadTileForQuery(t1, (n, s)=>{
                        n ? r(n) : o(s ? this.queryRasterArrayValueByBandId(e1, t1, i) : null);
                    });
                });
            }
            queryRasterArrayValue(t1, i) {
                const o = e1.aV.convert(t1), r = this.findLoadedParent(o);
                return r && r._mrt ? i.bands || !this.partial ? this.queryRasterArrayValueByBandId(o, r, i) : this.queryRasterArrayValueByAllBands(o, r, i) : Promise.resolve(null);
            }
            findLoadedParent(t1) {
                const i = e1.ag.fromLngLat(t1, this.map.transform.tileSize), o = this.maxzoom + 1, r = 1 << o, n = Math.floor(i.x), s = Math.floor((i.x - n) * r), a = Math.floor(i.y * r), l = this.map.style.getSourceCache(this.id), c = new e1.aS(o, n, o, s, a);
                return l.findLoadedParent(c, this.minzoom);
            }
        }
        const Et = {
            vector: xt,
            raster: bt,
            "raster-dem": class extends bt {
                constructor(e1, t1, i, o){
                    super(e1, t1, i, o), this.type = "raster-dem", this.maxzoom = 22, this._options = Object.assign({
                        type: "raster-dem"
                    }, t1), this.encoding = t1.encoding || "mapbox";
                }
                loadTile(t1, i) {
                    const o = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme), !1, this.tileSize);
                    function r(e1, o) {
                        e1 && (t1.state = "errored", i(e1)), o && (t1.dem = o, t1.dem.onDeserialize(), t1.needsHillshadePrepare = !0, t1.needsDEMTextureUpload = !0, t1.state = "loaded", i(null));
                    }
                    t1.request = e1.n(this.map._requestManager.transformRequest(o, e1.R.Tile), (function(o, n, s) {
                        if (delete t1.request, t1.aborted) t1.state = "unloaded", i(null);
                        else if (o) t1.state = "errored", i(o);
                        else if (n) {
                            const i = e1.aP(s);
                            this.map._refreshExpiredTiles && t1.setExpiryData(i);
                            const o = e1.y(), a = 1 - (n.width - e1.aR(n.width)) / 2;
                            a < 1 || t1.neighboringTiles || (t1.neighboringTiles = this._getNeighboringTiles(t1.tileID));
                            const l = o ? n : e1.o.getImageData(n, a), c = {
                                uid: t1.uid,
                                tileID: t1.tileID,
                                source: this.id,
                                type: this.type,
                                scope: this.scope,
                                rawImageData: l,
                                encoding: this.encoding,
                                padding: a
                            };
                            t1.actor && "expired" !== t1.state || (t1.actor = this.dispatcher.getActor(), t1.actor.send("loadTile", c, r.bind(this), void 0, !0));
                        }
                    }).bind(this));
                }
                _getNeighboringTiles(t1) {
                    const i = t1.canonical, o = Math.pow(2, i.z), r = (i.x - 1 + o) % o, n = 0 === i.x ? t1.wrap - 1 : t1.wrap, s = (i.x + 1 + o) % o, a = i.x + 1 === o ? t1.wrap + 1 : t1.wrap, l = {};
                    return l[new e1.aS(t1.overscaledZ, n, i.z, r, i.y).key] = {
                        backfilled: !1
                    }, l[new e1.aS(t1.overscaledZ, a, i.z, s, i.y).key] = {
                        backfilled: !1
                    }, i.y > 0 && (l[new e1.aS(t1.overscaledZ, n, i.z, r, i.y - 1).key] = {
                        backfilled: !1
                    }, l[new e1.aS(t1.overscaledZ, t1.wrap, i.z, i.x, i.y - 1).key] = {
                        backfilled: !1
                    }, l[new e1.aS(t1.overscaledZ, a, i.z, s, i.y - 1).key] = {
                        backfilled: !1
                    }), i.y + 1 < o && (l[new e1.aS(t1.overscaledZ, n, i.z, r, i.y + 1).key] = {
                        backfilled: !1
                    }, l[new e1.aS(t1.overscaledZ, t1.wrap, i.z, i.x, i.y + 1).key] = {
                        backfilled: !1
                    }, l[new e1.aS(t1.overscaledZ, a, i.z, s, i.y + 1).key] = {
                        backfilled: !1
                    }), l;
                }
            },
            "raster-array": Tt,
            geojson: class extends e1.E {
                constructor(t1, i, o, r){
                    super(), this.id = t1, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._loaded = !1, this.actor = o.getActor(), this.setEventedParent(r), this._data = i.data, this._options = Object.assign({}, i), this._collectResourceTiming = i.collectResourceTiming, void 0 !== i.maxzoom && (this.maxzoom = i.maxzoom), void 0 !== i.minzoom && (this.minzoom = i.minzoom), i.type && (this.type = i.type), i.attribution && (this.attribution = i.attribution), this.promoteId = i.promoteId;
                    const n = e1.an / this.tileSize;
                    this.workerOptions = Object.assign({
                        source: this.id,
                        scope: this.scope,
                        cluster: i.cluster || !1,
                        geojsonVtOptions: {
                            buffer: (void 0 !== i.buffer ? i.buffer : 128) * n,
                            tolerance: (void 0 !== i.tolerance ? i.tolerance : .375) * n,
                            extent: e1.an,
                            maxZoom: this.maxzoom,
                            lineMetrics: i.lineMetrics || !1,
                            generateId: i.generateId || !1
                        },
                        superclusterOptions: {
                            maxZoom: void 0 !== i.clusterMaxZoom ? i.clusterMaxZoom : this.maxzoom - 1,
                            minPoints: Math.max(2, i.clusterMinPoints || 2),
                            extent: e1.an,
                            radius: (void 0 !== i.clusterRadius ? i.clusterRadius : 50) * n,
                            log: !1,
                            generateId: i.generateId || !1
                        },
                        clusterProperties: i.clusterProperties,
                        filter: i.filter,
                        dynamic: i.dynamic
                    }, i.workerOptions);
                }
                onAdd(e1) {
                    this.map = e1, this.setData(this._data);
                }
                setData(e1) {
                    return this._data = e1, this._updateWorkerData(), this;
                }
                updateData(t1) {
                    if (!this._options.dynamic) return this.fire(new e1.B(new Error("Can't call updateData on a GeoJSON source with dynamic set to false.")));
                    if ("string" != typeof t1 && ("Feature" === t1.type && (t1 = {
                        type: "FeatureCollection",
                        features: [
                            t1
                        ]
                    }), "FeatureCollection" !== t1.type)) return this.fire(new e1.B(new Error("Data to update should be a feature or a feature collection.")));
                    if (this._coalesce && "string" != typeof t1 && "string" != typeof this._data && "FeatureCollection" === this._data.type) {
                        const e1 = new Map;
                        for (const t1 of this._data.features)e1.set(t1.id, t1);
                        for (const i of t1.features)e1.set(i.id, i);
                        this._data.features = [
                            ...e1.values()
                        ];
                    } else this._data = t1;
                    return this._updateWorkerData(!0), this;
                }
                getClusterExpansionZoom(e1, t1) {
                    return this.actor.send("geojson.getClusterExpansionZoom", {
                        clusterId: e1,
                        source: this.id,
                        scope: this.scope
                    }, t1), this;
                }
                getClusterChildren(e1, t1) {
                    return this.actor.send("geojson.getClusterChildren", {
                        clusterId: e1,
                        source: this.id,
                        scope: this.scope
                    }, t1), this;
                }
                getClusterLeaves(e1, t1, i, o) {
                    return this.actor.send("geojson.getClusterLeaves", {
                        source: this.id,
                        scope: this.scope,
                        clusterId: e1,
                        limit: t1,
                        offset: i
                    }, o), this;
                }
                _updateWorkerData(t1 = !1) {
                    if (this._pendingLoad) return void (this._coalesce = !0);
                    this.fire(new e1.C("dataloading", {
                        dataType: "source"
                    })), this._loaded = !1;
                    const i = Object.assign({
                        append: t1
                    }, this.workerOptions);
                    i.scope = this.scope;
                    const o = this._data;
                    "string" == typeof o ? (i.request = this.map._requestManager.transformRequest(e1.o.resolveURL(o), e1.R.Source), i.request.collectResourceTiming = this._collectResourceTiming) : i.data = JSON.stringify(o), this._pendingLoad = this.actor.send(`${this.type}.loadData`, i, (i, o)=>{
                        if (this._loaded = !0, this._pendingLoad = null, i) this.fire(new e1.B(i));
                        else {
                            const i = {
                                dataType: "source",
                                sourceDataType: this._metadataFired ? "content" : "metadata"
                            };
                            this._collectResourceTiming && o && o.resourceTiming && o.resourceTiming[this.id] && (i.resourceTiming = o.resourceTiming[this.id]), t1 && (this._partialReload = !0), this.fire(new e1.C("data", i)), this._partialReload = !1, this._metadataFired = !0;
                        }
                        this._coalesce && (this._updateWorkerData(t1), this._coalesce = !1);
                    });
                }
                loaded() {
                    return this._loaded;
                }
                reload() {
                    const t1 = e1.F(this.id, this.scope);
                    this.map.style.clearSource(t1), this._updateWorkerData();
                }
                loadTile(t1, i) {
                    const o = t1.actor ? "reloadTile" : "loadTile";
                    t1.actor = this.actor;
                    const r = this.map.style ? this.map.style.getLut(this.scope) : null, n = r ? {
                        image: r.image.clone()
                    } : null, s = this._partialReload, a = {
                        type: this.type,
                        uid: t1.uid,
                        tileID: t1.tileID,
                        tileZoom: t1.tileZoom,
                        zoom: t1.tileID.overscaledZ,
                        maxZoom: this.maxzoom,
                        tileSize: this.tileSize,
                        source: this.id,
                        lut: n,
                        scope: this.scope,
                        pixelRatio: e1.o.devicePixelRatio,
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        promoteId: this.promoteId,
                        brightness: this.map.style && this.map.style.getBrightness() || 0,
                        extraShadowCaster: t1.isExtraShadowCaster,
                        scaleFactor: this.map.getScaleFactor(),
                        partial: s,
                        worldview: this.map.getWorldview(),
                        indoor: this.map.getIndoorTileOptions(this.id, this.scope)
                    };
                    t1.request = this.actor.send(o, a, (e1, r)=>s && !r ? (t1.state = "loaded", i(null)) : (delete t1.request, t1.destroy(!1), t1.aborted ? i(null) : e1 ? i(e1) : (t1.loadVectorData(r, this.map.painter, "reloadTile" === o), i(null))), void 0, "loadTile" === o);
                }
                abortTile(e1) {
                    e1.request && (e1.request.cancel(), delete e1.request), e1.aborted = !0;
                }
                unloadTile(e1, t1) {
                    this.actor.send("removeTile", {
                        uid: e1.uid,
                        type: this.type,
                        source: this.id,
                        scope: this.scope
                    }), e1.destroy();
                }
                onRemove(e1) {
                    this._pendingLoad && this._pendingLoad.cancel();
                }
                serialize() {
                    return Object.assign({}, this._options, {
                        type: this.type,
                        data: this._data
                    });
                }
                hasTransition() {
                    return !1;
                }
            },
            video: class extends e1.aW {
                constructor(e1, t1, i, o){
                    super(e1, t1, i, o), this.roundZoom = !0, this.type = "video", this.options = t1;
                }
                load() {
                    this._loaded = !1;
                    const t1 = this.options;
                    this.urls = [];
                    for (const i of t1.urls)this.urls.push(this.map._requestManager.transformRequest(i, e1.R.Source).url);
                    e1.aX(this.urls, (t1, i)=>{
                        this._loaded = !0, t1 ? this.fire(new e1.B(t1)) : i && (this.video = i, this.video.loop = !0, this.video.setAttribute("playsinline", ""), this.video.addEventListener("playing", ()=>{
                            this.map.triggerRepaint();
                        }), this.map && this.video.play(), this._finishLoading());
                    });
                }
                pause() {
                    this.video && this.video.pause();
                }
                play() {
                    this.video && this.video.play();
                }
                seek(t1) {
                    if (this.video) {
                        const i = this.video.seekable;
                        t1 < i.start(0) || t1 > i.end(0) ? this.fire(new e1.B(new e1.V(`sources.${this.id}`, null, `Playback for this video can be set only between the ${i.start(0)} and ${i.end(0)}-second mark.`))) : this.video.currentTime = t1;
                    }
                }
                getVideo() {
                    return this.video;
                }
                onAdd(e1) {
                    this.map || (this.map = e1, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
                }
                prepare() {
                    if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
                    const t1 = this.map.painter.context, i = t1.gl;
                    this.texture ? this.video.paused || (this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), i.texSubImage2D(i.TEXTURE_2D, 0, 0, 0, i.RGBA, i.UNSIGNED_BYTE, this.video)) : (this.texture = new e1.T(t1, this.video, i.RGBA8), this.texture.bind(i.LINEAR, i.CLAMP_TO_EDGE), this.width = this.video.videoWidth, this.height = this.video.videoHeight), this._prepareData(t1);
                }
                serialize() {
                    return {
                        type: "video",
                        urls: this.urls,
                        coordinates: this.coordinates
                    };
                }
                hasTransition() {
                    return this.video && !this.video.paused;
                }
            },
            image: e1.aW,
            model: e1.aZ,
            "batched-model": class extends e1.E {
                constructor(e1, t1, i, o){
                    super(), this.type = "batched-model", this.id = e1, this.tileSize = 512, this._options = t1, this.tiles = this._options.tiles, this.maxzoom = t1.maxzoom || 19, this.minzoom = t1.minzoom || 0, this.roundZoom = !0, this.usedInConflation = !0, this.dispatcher = i, this.reparseOverscaled = !1, this.scheme = "xyz", this._loaded = !1, this.setEventedParent(o);
                }
                onAdd(e1) {
                    this.map = e1, this.load();
                }
                reload() {
                    this.cancelTileJSONRequest();
                    const t1 = e1.F(this.id, this.scope);
                    this.load(()=>this.map.style.clearSource(t1));
                }
                cancelTileJSONRequest() {
                    this._tileJSONRequest && (this._tileJSONRequest.cancel(), this._tileJSONRequest = null);
                }
                load(t1) {
                    this._loaded = !1, this.fire(new e1.C("dataloading", {
                        dataType: "source"
                    }));
                    const i = Array.isArray(this.map._language) ? this.map._language.join() : this.map._language, o = this.map.getWorldview();
                    this._tileJSONRequest = gt(this._options, this.map._requestManager, i, o, (r, n)=>{
                        this._tileJSONRequest = null, this._loaded = !0, r ? (i && console.warn(`Ensure that your requested language string is a valid BCP-47 code or list of codes. Found: ${i}`), o && 2 !== o.length && console.warn(`Requested worldview strings must be a valid ISO alpha-2 code. Found: ${o}`), this.fire(new e1.B(r))) : n && (Object.assign(this, n), n.bounds && (this.tileBounds = new yt(n.bounds, this.minzoom, this.maxzoom)), P(n.tiles, this.map._requestManager._customAccessToken), this.fire(new e1.C("data", {
                            dataType: "source",
                            sourceDataType: "metadata"
                        })), this.fire(new e1.C("data", {
                            dataType: "source",
                            sourceDataType: "content"
                        }))), t1 && t1(r);
                    });
                }
                hasTransition() {
                    return !1;
                }
                hasTile(e1) {
                    return !this.tileBounds || this.tileBounds.contains(e1.canonical);
                }
                loaded() {
                    return this._loaded;
                }
                loadTile(t1, i) {
                    const o = this.map._requestManager.normalizeTileURL(t1.tileID.canonical.url(this.tiles, this.scheme)), r = {
                        request: this.map._requestManager.transformRequest(o, e1.R.Tile),
                        data: void 0,
                        uid: t1.uid,
                        tileID: t1.tileID,
                        tileZoom: t1.tileZoom,
                        zoom: t1.tileID.overscaledZ,
                        tileSize: this.tileSize * t1.tileID.overscaleFactor(),
                        type: this.type,
                        source: this.id,
                        scope: this.scope,
                        showCollisionBoxes: this.map.showCollisionBoxes,
                        renderSourceType: t1.renderSourceType,
                        brightness: this.map.style && this.map.style.getBrightness() || 0,
                        pixelRatio: e1.o.devicePixelRatio,
                        promoteId: this.promoteId
                    };
                    if (t1.actor && "expired" !== t1.state) {
                        if ("loading" === t1.state) t1.reloadCallback = i;
                        else {
                            if (t1.buckets) {
                                const e1 = Object.values(t1.buckets);
                                for (const t1 of e1)t1.dirty = !0;
                                return void (t1.state = "loaded");
                            }
                            t1.request = t1.actor.send("reloadTile", r, n.bind(this));
                        }
                    } else t1.actor = this.dispatcher.getActor(), t1.request = t1.actor.send("loadTile", r, n.bind(this), void 0, !0);
                    function n(e1, o) {
                        return t1.aborted ? i(null) : e1 && 404 !== e1.status ? i(e1) : (this.map._refreshExpiredTiles && o && t1.setExpiryData(o), t1.loadModelData(o, this.map.painter), t1.state = "loaded", void i(null));
                    }
                }
                serialize() {
                    return Object.assign({}, this._options);
                }
            },
            canvas: class extends e1.aW {
                constructor(t1, i, o, r){
                    super(t1, i, o, r), i.coordinates ? Array.isArray(i.coordinates) && 4 === i.coordinates.length && !i.coordinates.some((e1)=>!Array.isArray(e1) || 2 !== e1.length || e1.some((e1)=>"number" != typeof e1)) || this.fire(new e1.B(new e1.V(`sources.${t1}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new e1.B(new e1.V(`sources.${t1}`, null, 'missing required property "coordinates"'))), i.animate && "boolean" != typeof i.animate && this.fire(new e1.B(new e1.V(`sources.${t1}`, null, 'optional "animate" property must be a boolean value'))), i.canvas ? "string" == typeof i.canvas || i.canvas instanceof HTMLCanvasElement || this.fire(new e1.B(new e1.V(`sources.${t1}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new e1.B(new e1.V(`sources.${t1}`, null, 'missing required property "canvas"'))), this.options = i, this.animate = void 0 === i.animate || i.animate;
                }
                load() {
                    this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new e1.B(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                        this._playing = !0, this.map.triggerRepaint();
                    }, this.pause = function() {
                        this._playing && (this.prepare(), this._playing = !1);
                    }, this._finishLoading());
                }
                getCanvas() {
                    return this.canvas;
                }
                onAdd(e1) {
                    this.map = e1, this.load(), this.canvas && this.animate && this.play();
                }
                onRemove(e1) {
                    this.pause();
                }
                prepare() {
                    let t1 = !1;
                    if (this.canvas.width !== this.width && (this.width = this.canvas.width, t1 = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, t1 = !0), this._hasInvalidDimensions()) return;
                    if (0 === Object.keys(this.tiles).length) return;
                    const i = this.map.painter.context;
                    this.texture ? !t1 && !this._playing || this.texture instanceof e1.aY || this.texture.update(this.canvas, {
                        premultiply: !0
                    }) : this.texture = new e1.T(i, this.canvas, i.gl.RGBA8, {
                        premultiply: !0
                    }), this._prepareData(i);
                }
                serialize() {
                    return {
                        type: "canvas",
                        coordinates: this.coordinates
                    };
                }
                hasTransition() {
                    return this._playing;
                }
                _hasInvalidDimensions() {
                    for (const e1 of [
                        this.canvas.width,
                        this.canvas.height
                    ])if (isNaN(e1) || e1 <= 0) return !0;
                    return !1;
                }
            },
            custom: class extends e1.E {
                constructor(t1, i, o, r){
                    super(), this.id = t1, this.type = "custom", this._dataType = "raster", this._dispatcher = o, this._implementation = i, this.setEventedParent(r), this.scheme = "xyz", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this._loaded = !1, this.roundZoom = !0, this._implementation || this.fire(new e1.B(new Error(`Missing implementation for ${this.id} custom source`))), this._implementation.loadTile || this.fire(new e1.B(new Error(`Missing loadTile implementation for ${this.id} custom source`))), this._implementation.bounds && (this.tileBounds = new yt(this._implementation.bounds, this.minzoom, this.maxzoom));
                    const n = i;
                    n.update = this._update.bind(this), n.clearTiles = this._clearTiles.bind(this), n.coveringTiles = this._coveringTiles.bind(this), Object.assign(this, e1.aJ(i, [
                        "dataType",
                        "scheme",
                        "minzoom",
                        "maxzoom",
                        "tileSize",
                        "attribution",
                        "minTileCacheSize",
                        "maxTileCacheSize"
                    ]));
                }
                serialize() {
                    return e1.aJ(this, [
                        "type",
                        "scheme",
                        "minzoom",
                        "maxzoom",
                        "tileSize",
                        "attribution"
                    ]);
                }
                load() {
                    this._loaded = !0, this.fire(new e1.C("data", {
                        dataType: "source",
                        sourceDataType: "metadata"
                    })), this.fire(new e1.C("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }));
                }
                loaded() {
                    return this._loaded;
                }
                onAdd(t1) {
                    this.map = t1, this._loaded = !1, this.fire(new e1.C("dataloading", {
                        dataType: "source"
                    })), this._implementation.onAdd && this._implementation.onAdd(t1), this.load();
                }
                onRemove(e1) {
                    this._implementation.onRemove && this._implementation.onRemove(e1);
                }
                hasTile(e1) {
                    if (this._implementation.hasTile) {
                        const { x: t1, y: i, z: o } = e1.canonical;
                        return this._implementation.hasTile({
                            x: t1,
                            y: i,
                            z: o
                        });
                    }
                    return !this.tileBounds || this.tileBounds.contains(e1.canonical);
                }
                loadTile(e1, t1) {
                    const { x: i, y: o, z: r } = e1.tileID.canonical, n = new AbortController, s = Promise.resolve(this._implementation.loadTile({
                        x: i,
                        y: o,
                        z: r
                    }, {
                        signal: n.signal
                    })).then((function(i) {
                        return delete e1.request, e1.aborted ? (e1.state = "unloaded", t1(null)) : void 0 === i ? (e1.state = "errored", t1(null)) : null === i ? (this.loadTileData(e1, {
                            width: this.tileSize,
                            height: this.tileSize,
                            data: null
                        }), e1.state = "loaded", t1(null)) : function(e1) {
                            return e1 instanceof ImageData || e1 instanceof HTMLCanvasElement || e1 instanceof ImageBitmap || e1 instanceof HTMLImageElement;
                        }(i) ? (this.loadTileData(e1, i), e1.state = "loaded", void t1(null)) : (e1.state = "errored", t1(new Error(`Can't infer data type for ${this.id}, only raster data supported at the moment`)));
                    }).bind(this)).catch((i)=>{
                        "AbortError" !== i.name && (e1.state = "errored", t1(i));
                    });
                    s.cancel = ()=>n.abort(), e1.request = s;
                }
                loadTileData(e1, t1) {
                    e1.setTexture(t1, this.map.painter);
                }
                unloadTile(t1, i) {
                    if (t1.texture && t1.texture instanceof e1.T ? (t1.destroy(!1), t1.texture && t1.texture instanceof e1.T && this.map.painter.saveTileTexture(t1.texture)) : t1.destroy(), this._implementation.unloadTile) {
                        const { x: e1, y: i, z: o } = t1.tileID.canonical;
                        this._implementation.unloadTile({
                            x: e1,
                            y: i,
                            z: o
                        });
                    }
                    i && i();
                }
                abortTile(e1, t1) {
                    e1.request && e1.request.cancel && (e1.request.cancel(), delete e1.request), t1 && t1();
                }
                hasTransition() {
                    return !1;
                }
                _coveringTiles() {
                    return this.map.transform.coveringTiles({
                        tileSize: this.tileSize,
                        minzoom: this.minzoom,
                        maxzoom: this.maxzoom,
                        roundZoom: this.roundZoom
                    }).map((e1)=>({
                            x: e1.canonical.x,
                            y: e1.canonical.y,
                            z: e1.canonical.z
                        }));
                }
                _clearTiles() {
                    const t1 = e1.F(this.id, this.scope);
                    this.map.style.clearSource(t1);
                }
                _update() {
                    this.fire(new e1.C("data", {
                        dataType: "source",
                        sourceDataType: "content"
                    }));
                }
            }
        }, St = function(t1, i, o, r) {
            const n = new Et[i.type](t1, i, o, r);
            if (n.id !== t1) throw new Error(`Expected Source id to be ${t1} instead of ${n.id}`);
            return e1.a_([
                "load",
                "abort",
                "unload",
                "serialize",
                "prepare"
            ], n), n;
        };
        function Ct(e1, t1, i = "") {
            return `${i}:${t1.id || ""}:${t1.layer.id}:${function(e1) {
                if ("layerId" in e1) return `layer:${e1.layerId}`;
                {
                    const { featuresetId: t1, importId: i } = e1;
                    return `featureset:${t1}${i ? `:import:${i}` : ""}`;
                }
            }(e1.target)}`;
        }
        function It(e1, t1, i, o = "") {
            if (e1.uniqueFeatureID) {
                const r = Ct(e1, t1, o);
                if (i.has(r)) return !0;
                i.add(r);
            }
            return !1;
        }
        function Rt(e1, t1, i, o, r = !1, n) {
            const s = t1.sourceCache.transform, a = t1.sourceCache.tilesIn(e1, t1.has3DLayers, r);
            a.sort(Lt);
            const l = [];
            for (const e1 of a){
                const a = e1.tile.queryRenderedFeatures(t1, e1, i, o, s, r, n);
                Object.keys(a).length && l.push({
                    wrappedTileID: e1.tile.tileID.wrapped().key,
                    queryResults: a
                });
            }
            for(const i in t1.layers){
                const r = t1.layers[i];
                if (r.styleLayer) {
                    const i = r.styleLayer.queryRenderedFeatures(e1, t1.sourceCache, o);
                    Object.keys(i).length && l.push({
                        wrappedTileID: 0,
                        queryResults: i
                    });
                }
            }
            return 0 === l.length ? {} : function(e1) {
                const t1 = {}, i = {};
                for (const o of e1){
                    const e1 = o.queryResults, r = o.wrappedTileID, n = i[r] = i[r] || {};
                    for(const i in e1){
                        const o = e1[i], r = n[i] = n[i] || {}, s = t1[i] = t1[i] || [];
                        for (const e1 of o)r[e1.featureIndex] || (r[e1.featureIndex] = !0, s.push(e1));
                    }
                }
                return t1;
            }(l);
        }
        function Dt(e1, t1, i, o, r, n) {
            const s = {}, a = o.queryRenderedSymbols(e1), l = [];
            for (const e1 of Object.keys(a).map(Number))l.push(r[e1]);
            l.sort(Lt);
            for (const e1 of l){
                const o = e1.featureIndex.lookupSymbolFeatures(a[e1.bucketInstanceId], e1.bucketIndex, e1.sourceLayerIndex, t1, i, n);
                for(const t1 in o){
                    const i = s[t1] = s[t1] || [], r = o[t1];
                    r.sort((t1, i)=>{
                        const o = e1.featureSortOrder;
                        if (o) {
                            const e1 = o.indexOf(t1.featureIndex);
                            return o.indexOf(i.featureIndex) - e1;
                        }
                        return i.featureIndex - t1.featureIndex;
                    });
                    for (const e1 of r)i.push(e1);
                }
            }
            return s;
        }
        function At(e1, t1) {
            const i = e1.getRenderableIds().map((t1)=>e1.getTileByID(t1)), o = [], r = {};
            for(let e1 = 0; e1 < i.length; e1++){
                const n = i[e1], s = n.tileID.canonical.key;
                r[s] || (r[s] = !0, n.querySourceFeatures(o, t1));
            }
            return o;
        }
        function Lt(e1, t1) {
            const i = e1.tileID, o = t1.tileID;
            return i.overscaledZ - o.overscaledZ || i.canonical.y - o.canonical.y || i.wrap - o.wrap || i.canonical.x - o.canonical.x;
        }
        e1.a$.setPbf(e1.b0);
        class Pt extends e1.b1 {
            constructor(e1, t1, i, o, r){
                super(e1, t1, i, o, r), this._workQueuePerLayer = new Map, this._fetchQueuePerLayer = new Map, this._taskQueue = new Map, this._isHeaderLoaded = !1, this.textureDescriptorPerLayer = new Map, this.texturePerLayer = new Map;
            }
            getLayers() {
                return this._mrt ? Object.values(this._mrt.layers) : [];
            }
            getLayer(e1) {
                return this._mrt && this._mrt.getLayer(e1);
            }
            setTexturePerLayer(t1, i, o) {
                const r = o.context, n = r.gl;
                let s = this.texturePerLayer.get(t1) || o.getTileTexture(i.width);
                s && s instanceof e1.T ? s.update(i, {
                    premultiply: !1
                }) : s = new e1.T(r, i, n.RGBA8, {
                    premultiply: !1
                }), this.texturePerLayer.has(t1) || this.texturePerLayer.set(t1, s);
            }
            flushQueues(e1) {
                const t1 = this._workQueuePerLayer.get(e1) || [], i = this._fetchQueuePerLayer.get(e1) || [];
                for(; t1.length;)t1.pop()();
                for(; i.length;)i.pop()();
            }
            flushAllQueues() {
                for (const e1 of this._workQueuePerLayer.keys()){
                    const t1 = this._workQueuePerLayer.get(e1) || [];
                    for(; t1.length;)t1.pop()();
                }
                for (const e1 of this._fetchQueuePerLayer.keys()){
                    const t1 = this._fetchQueuePerLayer.get(e1) || [];
                    for(; t1.length;)t1.pop()();
                }
            }
            fetchHeader(t1 = 16384, i) {
                const o = this._mrt = new e1.a$(30), r = Object.assign({}, this.requestParams, {
                    headers: {
                        Range: "bytes=0-" + (t1 - 1)
                    }
                });
                return this.entireBuffer = null, this.request = e1.b2(r, (e1, r, n)=>{
                    if (e1) i(e1);
                    else try {
                        const e1 = o.getHeaderLength(r);
                        if (e1 > t1) return void (this.request = this.fetchHeader(e1, i));
                        o.parseHeader(r), this._isHeaderLoaded = !0;
                        let s = 0;
                        for (const e1 of Object.values(o.layers))s = Math.max(s, e1.dataIndex[e1.dataIndex.length - 1].lastByte);
                        r.byteLength >= s && (this.entireBuffer = r), i(null, this.entireBuffer || r, n);
                    } catch (e1) {
                        i(e1);
                    }
                }), this.request;
            }
            fetchBandForRender(e1, t1, i, o) {
                this.fetchBand(e1, t1, i, (r)=>{
                    if (r) return void o(r);
                    this.updateTextureDescriptor(e1, t1, i);
                    const n = this.textureDescriptorPerLayer.get(t1);
                    o(null, n ? n.img : null);
                });
            }
            fetchBand(t1, i, o, r, n = !0) {
                const s = this._mrt;
                if (!this._isHeaderLoaded || !s) return void r(new Error("Tile header is not ready"));
                const a = this.actor;
                if (!a) return void r(new Error("Can't fetch tile band without an actor"));
                let l;
                const c = e1.F(String(o), e1.F(this.tileID.key, t1));
                let h = this._taskQueue.get(c);
                h ? h.add(r) : (h = new Set, h.add(r), this._taskQueue.set(c, h));
                const d = (e1, t1)=>{
                    l.complete(e1, t1), e1 ? r(e1) : (h.forEach((e1)=>e1(null, t1)), this._taskQueue.delete(c));
                }, _ = (e1, t1)=>{
                    if (e1) return r(e1);
                    const o = a.send("decodeRasterArray", {
                        type: "raster-array",
                        source: this.source,
                        scope: this.scope,
                        tileID: this.tileID,
                        uid: this.uid,
                        buffer: t1,
                        task: l
                    }, d, void 0, !0);
                    if (null !== i) {
                        const e1 = this._workQueuePerLayer.get(i) || [];
                        e1.push(()=>{
                            o && o.cancel(), l.cancel();
                        }), this._workQueuePerLayer.has(i) || this._workQueuePerLayer.set(i, e1);
                    }
                };
                let u;
                try {
                    u = s.getLayer(t1);
                } catch (e1) {
                    if ("reloading" === this.state) return;
                    throw e1;
                }
                if (!u) return void r(new Error(`Unknown sourceLayer "${t1}"`));
                if (u.hasDataForBand(o)) return h.forEach((e1)=>e1(null, null)), void this._taskQueue.delete(c);
                const p = u.getDataRange([
                    o
                ]);
                if (l = s.createDecodingTask(p), !l || l.tasks.length) {
                    if (null !== i && this.flushQueues(i), this.entireBuffer) _(null, this.entireBuffer.slice(p.firstByte, p.lastByte + 1));
                    else {
                        const t1 = Object.assign({}, this.requestParams, {
                            headers: {
                                Range: `bytes=${p.firstByte}-${p.lastByte}`
                            }
                        }), o = e1.b2(t1, _);
                        if (null !== i) {
                            const e1 = this._fetchQueuePerLayer.get(i) || [];
                            e1.push(()=>{
                                o.cancel(), l.cancel();
                            }), this._fetchQueuePerLayer.has(i) || this._fetchQueuePerLayer.set(i, e1);
                        }
                    }
                }
            }
            updateNeeded(e1, t1) {
                return (!this.textureDescriptorPerLayer.get(e1) || this.textureDescriptorPerLayer.get(e1).band !== t1 || this.refreshedUponExpiration) && "errored" !== this.state;
            }
            updateTextureDescriptor(t1, i, o) {
                if (!this._mrt) return;
                const r = this._mrt.getLayer(t1);
                if (!r || !r.hasBand(o) || !r.hasDataForBand(o)) return;
                const { bytes: n, tileSize: s, buffer: a, offset: l, scale: c } = r.getBandView(o), h = s + 2 * a, d = new e1.q({
                    width: h,
                    height: h
                }, n), _ = this.texturePerLayer.get(i);
                _ && _ instanceof e1.T && _.update(d, {
                    premultiply: !1
                }), this.textureDescriptorPerLayer.set(i, {
                    layer: t1,
                    band: o,
                    img: d,
                    buffer: a,
                    offset: l,
                    tileSize: s,
                    format: r.pixelFormat,
                    mix: [
                        c,
                        256 * c,
                        65536 * c,
                        16777216 * c
                    ]
                });
            }
            destroy(t1 = !1) {
                if (super.destroy(t1), delete this._mrt, !t1) for (const t1 of this.texturePerLayer.values())t1 && t1 instanceof e1.T && t1.destroy();
                this.texturePerLayer.clear(), this.textureDescriptorPerLayer.clear(), this.fbo && (this.fbo.destroy(), delete this.fbo), delete this.request, delete this.requestParams, this._isHeaderLoaded = !1;
            }
        }
        class Ot {
            constructor(e1, t1){
                this.max = e1, this.onRemove = t1, this.reset();
            }
            reset() {
                for(const e1 in this.data)for (const t1 of this.data[e1])t1.timeout && clearTimeout(t1.timeout), this.onRemove(t1.value);
                return this.data = {}, this.order = [], this;
            }
            add(e1, t1, i) {
                const o = e1.wrapped().key;
                void 0 === this.data[o] && (this.data[o] = []);
                const r = {
                    value: t1,
                    timeout: void 0
                };
                if (void 0 !== i && (r.timeout = setTimeout(()=>{
                    this.remove(e1, r);
                }, i)), this.data[o].push(r), this.order.push(o), this.order.length > this.max) {
                    const e1 = this._getAndRemoveByKey(this.order[0]);
                    e1 && this.onRemove(e1);
                }
                return this;
            }
            has(e1) {
                return e1.wrapped().key in this.data;
            }
            getAndRemove(e1) {
                return this.has(e1) ? this._getAndRemoveByKey(e1.wrapped().key) : null;
            }
            _getAndRemoveByKey(e1) {
                const t1 = this.data[e1].shift();
                return t1.timeout && clearTimeout(t1.timeout), 0 === this.data[e1].length && delete this.data[e1], this.order.splice(this.order.indexOf(e1), 1), t1.value;
            }
            getByKey(e1) {
                const t1 = this.data[e1];
                return t1 ? t1[0].value : null;
            }
            get(e1) {
                return this.has(e1) ? this.data[e1.wrapped().key][0].value : null;
            }
            remove(e1, t1) {
                if (!this.has(e1)) return this;
                const i = e1.wrapped().key, o = void 0 === t1 ? 0 : this.data[i].indexOf(t1), r = this.data[i][o];
                return this.data[i].splice(o, 1), r.timeout && clearTimeout(r.timeout), 0 === this.data[i].length && delete this.data[i], this.onRemove(r.value), this.order.splice(this.order.indexOf(i), 1), this;
            }
            setMaxSize(e1) {
                for(this.max = e1; this.order.length > this.max;){
                    const e1 = this._getAndRemoveByKey(this.order[0]);
                    e1 && this.onRemove(e1);
                }
                return this;
            }
            filter(e1) {
                const t1 = [];
                for(const i in this.data)for (const o of this.data[i])e1(o.value) || t1.push(o);
                for (const e1 of t1)this.remove(e1.value.tileID, e1);
            }
        }
        class Mt {
            constructor(){
                this.state = {}, this.stateChanges = {}, this.deletedStates = {};
            }
            updateState(e1, t1, i) {
                const o = String(t1);
                if (this.stateChanges[e1] = this.stateChanges[e1] || {}, this.stateChanges[e1][o] = this.stateChanges[e1][o] || {}, Object.assign(this.stateChanges[e1][o], i), null === this.deletedStates[e1]) {
                    this.deletedStates[e1] = {};
                    for(const t1 in this.state[e1])t1 !== o && (this.deletedStates[e1][t1] = null);
                } else if (this.deletedStates[e1] && null === this.deletedStates[e1][o]) {
                    this.deletedStates[e1][o] = {};
                    for(const t1 in this.state[e1][o])i[t1] || (this.deletedStates[e1][o][t1] = null);
                } else for(const t1 in i)this.deletedStates[e1] && this.deletedStates[e1][o] && null === this.deletedStates[e1][o][t1] && delete this.deletedStates[e1][o][t1];
            }
            removeFeatureState(e1, t1, i) {
                if (null === this.deletedStates[e1]) return;
                const o = String(t1);
                if (this.deletedStates[e1] = this.deletedStates[e1] || {}, i && void 0 !== t1) null !== this.deletedStates[e1][o] && (this.deletedStates[e1][o] = this.deletedStates[e1][o] || {}, this.deletedStates[e1][o][i] = null);
                else if (void 0 !== t1) {
                    if (this.stateChanges[e1] && this.stateChanges[e1][o]) for(i in this.deletedStates[e1][o] = {}, this.stateChanges[e1][o])this.deletedStates[e1][o][i] = null;
                    else this.deletedStates[e1][o] = null;
                } else this.deletedStates[e1] = null;
            }
            getState(e1, t1) {
                const i = this.state[e1] || {}, o = this.stateChanges[e1] || {}, r = this.deletedStates[e1];
                if (null === r) return {};
                if (void 0 !== t1) {
                    const e1 = String(t1), n = Object.assign({}, i[e1], o[e1]);
                    if (r) {
                        const e1 = r[t1];
                        if (null === e1) return {};
                        for(const t1 in e1)delete n[t1];
                    }
                    return n;
                }
                const n = Object.assign({}, i, o);
                if (r) for(const e1 in r)delete n[e1];
                return n;
            }
            initializeTileState(e1, t1) {
                e1.refreshFeatureState(t1);
            }
            coalesceChanges(e1, t1) {
                const i = {};
                for(const e1 in this.stateChanges){
                    this.state[e1] = this.state[e1] || {};
                    const t1 = {};
                    for(const i in this.stateChanges[e1])this.state[e1][i] || (this.state[e1][i] = {}), Object.assign(this.state[e1][i], this.stateChanges[e1][i]), t1[i] = this.state[e1][i];
                    i[e1] = t1;
                }
                for(const e1 in this.deletedStates){
                    this.state[e1] = this.state[e1] || {};
                    const t1 = {};
                    if (null === this.deletedStates[e1]) for(const i in this.state[e1])t1[i] = {}, this.state[e1][i] = {};
                    else for(const i in this.deletedStates[e1]){
                        if (null === this.deletedStates[e1][i]) this.state[e1][i] = {};
                        else if (this.state[e1][i]) for (const t1 of Object.keys(this.deletedStates[e1][i]))delete this.state[e1][i][t1];
                        t1[i] = this.state[e1][i];
                    }
                    i[e1] = i[e1] || {}, Object.assign(i[e1], t1);
                }
                if (this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(i).length) for(const o in e1)e1[o].refreshFeatureState(t1, i);
            }
        }
        class zt extends e1.E {
            constructor(e1, t1, i){
                super(), this.id = e1, this._renderSourceType = i, this._maxzoomOverride = null, t1.on("data", (e1)=>{
                    "source" === e1.dataType && "metadata" === e1.sourceDataType && (this._sourceLoaded = !0), this._sourceLoaded && !this._paused && "source" === e1.dataType && "content" === e1.sourceDataType && (this.reload(), this.transform && this.update(this.transform));
                }), t1.on("error", ()=>{
                    this._sourceErrored = !0;
                }), this._source = t1, this._tiles = {}, this._cache = new Ot(0, this._unloadTile.bind(this)), this._timers = {}, this._cacheTimers = {}, this._minTileCacheSize = t1.minTileCacheSize, this._maxTileCacheSize = t1.maxTileCacheSize, this._loadedParentTiles = {}, this.castsShadows = !1, this.tileCoverLift = 0, this._coveredTiles = {}, this._shadowCasterTiles = {}, this._state = new Mt, this._isRaster = "raster" === this._source.type || "raster-dem" === this._source.type || "raster-array" === this._source.type || "custom" === this._source.type && "_dataType" in this._source && "raster" === this._source._dataType, this._supportsFading = "raster" === this._source.type || "raster-array" === this._source.type || "image" === this._source.type || "video" === this._source.type || "custom" === this._source.type, this._isRasterElevatedOverTerrain = !1;
            }
            onAdd(e1) {
                this.map = e1, this._minTileCacheSize = void 0 === this._minTileCacheSize && e1 ? e1._minTileCacheSize : this._minTileCacheSize, this._maxTileCacheSize = void 0 === this._maxTileCacheSize && e1 ? e1._maxTileCacheSize : this._maxTileCacheSize;
            }
            loaded() {
                if (this._sourceErrored) return !0;
                if (!this._sourceLoaded) return !1;
                if (!this._source.loaded()) return !1;
                for(const e1 in this._tiles)if (!this._tiles[e1].loaded()) return !1;
                return !0;
            }
            getSource() {
                return this._source;
            }
            pause() {
                this._paused = !0;
            }
            resume() {
                if (!this._paused) return;
                const e1 = this._shouldReloadOnResume;
                this._paused = !1, this._shouldReloadOnResume = !1, e1 && this.reload(), this.transform && this.update(this.transform);
            }
            setMaxzoomOverride(e1) {
                this._maxzoomOverride = e1;
            }
            _loadTile(e1, t1) {
                return e1.renderSourceType = this._renderSourceType, e1.isExtraShadowCaster = this._shadowCasterTiles[e1.tileID.key], this._source.loadTile(e1, t1);
            }
            _unloadTile(e1) {
                if (this._source.unloadTile) return this._source.unloadTile(e1);
            }
            _abortTile(e1) {
                if (this._source.abortTile) return this._source.abortTile(e1);
            }
            serialize() {
                return this._source.serialize();
            }
            prepare(e1) {
                this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._tiles, this.map ? this.map.painter : null);
                for(const t1 in this._tiles){
                    const i = this._tiles[t1];
                    i.upload(e1, this.map ? this.map.painter : void 0), i.prepare(this.map.style.imageManager, this.map ? this.map.painter : null, this._source.scope);
                }
            }
            getIds() {
                return Object.values(this._tiles).map((e1)=>e1.tileID).sort(Ft).map((e1)=>e1.key);
            }
            getRenderableIds(t1, i) {
                const o = [];
                for(const e1 in this._tiles)this._isIdRenderable(+e1, t1, i) && o.push(this._tiles[e1]);
                return t1 ? o.sort((t1, i)=>{
                    const o = t1.tileID, r = i.tileID, n = new e1.P(o.canonical.x, o.canonical.y)._rotate(this.transform.angle), s = new e1.P(r.canonical.x, r.canonical.y)._rotate(this.transform.angle);
                    return o.overscaledZ - r.overscaledZ || s.y - n.y || s.x - n.x;
                }).map((e1)=>e1.tileID.key) : o.map((e1)=>e1.tileID).sort(Ft).map((e1)=>e1.key);
            }
            hasRenderableParent(e1) {
                const t1 = this.findLoadedParent(e1, 0);
                return !!t1 && this._isIdRenderable(t1.tileID.key);
            }
            _isIdRenderable(e1, t1, i) {
                return this._tiles[e1] && this._tiles[e1].hasData() && !this._coveredTiles[e1] && (t1 || !this._tiles[e1].holdingForFade()) && (i || !this._shadowCasterTiles[e1]);
            }
            reload() {
                if (this._paused) this._shouldReloadOnResume = !0;
                else {
                    this._cache.reset();
                    for(const e1 in this._tiles)"errored" !== this._tiles[e1].state && this._reloadTile(+e1, "reloading");
                }
            }
            _reloadTile(e1, t1) {
                const i = this._tiles[e1];
                i && ("loading" !== i.state && (i.state = t1), this._loadTile(i, this._tileLoaded.bind(this, i, e1, t1)));
            }
            _tileLoaded(t1, i, o, r, n) {
                if (r) {
                    if (t1.state = "errored", e1.b3(r)) {
                        if (this._source.fire(new e1.C("data", {
                            dataType: "source",
                            sourceDataType: "error",
                            sourceId: this._source.id,
                            tile: t1
                        })), !(t1.tileID.key in this._loadedParentTiles)) return;
                        if ("raster-dem" === this._source.type && this.usedForTerrain && this.map.painter.terrain) {
                            const e1 = this.map.painter.terrain;
                            this.update(this.transform, e1.getScaledDemTileSize(), !0), e1.resetTileLookupCache(this.id);
                        } else this.update(this.transform);
                    } else this._source.fire(new e1.B(r, {
                        tile: t1
                    }));
                    return;
                }
                t1.timeAdded = e1.o.now(), "expired" === o && (t1.refreshedUponExpiration = !0), this._setTileReloadTimer(i, t1), "raster-dem" === this._source.type && t1.dem && this._backfillDEM(t1), this._state.initializeTileState(t1, this.map ? this.map.painter : null);
                let s = new Map;
                n && n.responseHeaders && (s = n.responseHeaders), this._source.fire(new e1.C("data", {
                    dataType: "source",
                    tile: t1,
                    coord: t1.tileID,
                    sourceCacheId: this.id,
                    responseHeaders: s
                }));
            }
            _backfillDEM(e1) {
                const t1 = this.getRenderableIds();
                for(let o = 0; o < t1.length; o++){
                    const r = t1[o];
                    if (e1.neighboringTiles && e1.neighboringTiles[r]) {
                        const t1 = this.getTileByID(r);
                        i(e1, t1), i(t1, e1);
                    }
                }
                function i(e1, t1) {
                    if (!e1.dem || e1.dem.borderReady) return;
                    e1.needsHillshadePrepare = !0, e1.needsDEMTextureUpload = !0;
                    let i = t1.tileID.canonical.x - e1.tileID.canonical.x;
                    const o = t1.tileID.canonical.y - e1.tileID.canonical.y, r = Math.pow(2, e1.tileID.canonical.z), n = t1.tileID.key;
                    0 === i && 0 === o || Math.abs(o) > 1 || (Math.abs(i) > 1 && (1 === Math.abs(i + r) ? i += r : 1 === Math.abs(i - r) && (i -= r)), t1.dem && e1.dem && (e1.dem.backfillBorder(t1.dem, i, o), e1.neighboringTiles && e1.neighboringTiles[n] && (e1.neighboringTiles[n].backfilled = !0)));
                }
            }
            getTile(e1) {
                return this.getTileByID(e1.key);
            }
            getTileByID(e1) {
                return this._tiles[e1];
            }
            _retainLoadedChildren(e1, t1, i, o) {
                for(const r in this._tiles){
                    let n = this._tiles[r];
                    if (o[r] || !n.hasData() || n.tileID.overscaledZ <= t1 || n.tileID.overscaledZ > i) continue;
                    let s = n.tileID;
                    for(; n && n.tileID.overscaledZ > t1 + 1;){
                        const e1 = n.tileID.scaledTo(n.tileID.overscaledZ - 1);
                        n = this._tiles[e1.key], n && n.hasData() && (s = e1);
                    }
                    let a = s;
                    for(; a.overscaledZ > t1;)if (a = a.scaledTo(a.overscaledZ - 1), e1[a.key]) {
                        o[s.key] = s;
                        break;
                    }
                }
            }
            findLoadedParent(e1, t1) {
                if (e1.key in this._loadedParentTiles) {
                    const i = this._loadedParentTiles[e1.key];
                    return i && i.tileID.overscaledZ >= t1 ? i : null;
                }
                for(let i = e1.overscaledZ - 1; i >= t1; i--){
                    const t1 = e1.scaledTo(i), o = this._getLoadedTile(t1);
                    if (o) return o;
                }
            }
            _getLoadedTile(e1) {
                const t1 = this._tiles[e1.key];
                return t1 && t1.hasData() ? t1 : this._cache.getByKey(this._source.reparseOverscaled ? e1.wrapped().key : e1.canonical.key);
            }
            updateCacheSize(e1, t1) {
                t1 = t1 || this._source.tileSize;
                const i = Math.ceil(e1.width / t1) + 1, o = Math.ceil(e1.height / t1) + 1, r = Math.floor(i * o * 5), n = "number" == typeof this._minTileCacheSize ? Math.max(this._minTileCacheSize, r) : r, s = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, n) : n;
                this._cache.setMaxSize(s);
            }
            handleWrapJump(e1) {
                const t1 = Math.round((e1 - (void 0 === this._prevLng ? e1 : this._prevLng)) / 360);
                if (this._prevLng = e1, t1) {
                    const e1 = {};
                    for(const i in this._tiles){
                        const o = this._tiles[i];
                        o.tileID = o.tileID.unwrapTo(o.tileID.wrap + t1), e1[o.tileID.key] = o;
                    }
                    this._tiles = e1;
                    for(const e1 in this._timers)clearTimeout(this._timers[e1]), delete this._timers[e1];
                    for(const e1 in this._tiles)this._setTileReloadTimer(+e1, this._tiles[e1]);
                }
            }
            update(t1, i, o, r, n) {
                if (this.transform = t1, !this._sourceLoaded || this._paused || this.transform.freezeTileCoverage) return;
                if (this.usedForTerrain && !o) return;
                this.updateCacheSize(t1, i), "globe" !== this.transform.projection.name && this.handleWrapJump(this.transform.center.lng), this._shadowCasterTiles = {}, this._coveredTiles = {};
                const s = "batched-model" === this._source.type;
                let a, l = this._source.maxzoom;
                null !== this._maxzoomOverride && (l = Math.min(l, this._maxzoomOverride));
                const c = this.map && this.map.painter ? this.map.painter._terrain : null;
                if (c && c.sourceCache === this && c.attenuationRange()) {
                    const e1 = c.attenuationRange()[0], t1 = Math.floor(e1) - Math.log2(c.getDemUpscale());
                    l > t1 && (l = t1);
                }
                const h = null === this._maxzoomOverride && this._source.reparseOverscaled;
                if (this.used || this.usedForTerrain) {
                    if (this._source.tileID) a = t1.getVisibleUnwrappedCoordinates(this._source.tileID).map((t1)=>new e1.aS(t1.canonical.z, t1.wrap, t1.canonical.z, t1.canonical.x, t1.canonical.y));
                    else if (0 !== this.tileCoverLift) {
                        const r = t1.clone();
                        r.tileCoverLift = this.tileCoverLift, a = r.coveringTiles({
                            tileSize: i || this._source.tileSize,
                            minzoom: this._source.minzoom,
                            maxzoom: l,
                            roundZoom: this._source.roundZoom && !o,
                            reparseOverscaled: h,
                            isTerrainDEM: this.usedForTerrain,
                            calculateQuadrantVisibility: s
                        }), this._source.minzoom <= 1 && "globe" === t1.projection.name && (a.push(new e1.aS(1, 0, 1, 0, 0)), a.push(new e1.aS(1, 0, 1, 1, 0)), a.push(new e1.aS(1, 0, 1, 0, 1)), a.push(new e1.aS(1, 0, 1, 1, 1)));
                    } else if (a = t1.coveringTiles({
                        tileSize: i || this._source.tileSize,
                        minzoom: this._source.minzoom,
                        maxzoom: l,
                        roundZoom: this._source.roundZoom && !o,
                        reparseOverscaled: h,
                        isTerrainDEM: this.usedForTerrain,
                        calculateQuadrantVisibility: s
                    }), this._source.hasTile) {
                        const e1 = this._source.hasTile.bind(this._source);
                        a = a.filter((t1)=>e1(t1));
                    }
                } else a = [];
                if (a.length > 0 && "globe" !== this.transform.projection.name && !this.usedForTerrain && !this._supportsFading) {
                    const e1 = t1.coveringZoomLevel({
                        tileSize: i || this._source.tileSize,
                        roundZoom: this._source.roundZoom && !o
                    }), c = Math.min(e1, l);
                    if (s) {
                        const e1 = t1.extendTileCover(a, c);
                        for (const t1 of e1)a.push(t1);
                    } else if (n) {
                        const e1 = t1.extendTileCoverToNearPlane(a, this.transform.getFrustum(c), c);
                        for (const t1 of e1)a.push(t1);
                    } else if (this.castsShadows && r) {
                        const e1 = t1.extendTileCover(a, c, r, 16);
                        for (const t1 of e1)this._shadowCasterTiles[t1.key] = !0, a.push(t1);
                    }
                }
                const d = this._updateRetainedTiles(a);
                if (this._supportsFading && 0 !== a.length) {
                    const t1 = {}, i = {}, o = e1.o.now(), r = Object.keys(d);
                    for (const e1 of r){
                        const r = d[e1], n = this._tiles[e1];
                        if (!n || void 0 !== n.fadeEndTime && n.fadeEndTime <= o) continue;
                        const s = this.findLoadedParent(r, Math.max(r.overscaledZ - zt.maxOverzooming, this._source.minzoom));
                        s && (this._addTile(s.tileID), t1[s.tileID.key] = s.tileID), i[e1] = r;
                    }
                    const n = a[a.length - 1].overscaledZ;
                    for(const e1 in this._tiles){
                        const t1 = this._tiles[e1];
                        if (d[e1] || !t1.hasData()) continue;
                        let o = t1.tileID;
                        for(; o.overscaledZ > n;){
                            o = o.scaledTo(o.overscaledZ - 1);
                            const r = this._tiles[o.key];
                            if (r && r.hasData() && i[o.key]) {
                                d[e1] = t1.tileID;
                                break;
                            }
                        }
                    }
                    for(const e1 in t1)d[e1] || (this._coveredTiles[e1] = !0, d[e1] = t1[e1]);
                }
                for(const e1 in d)this._tiles[e1].clearFadeHold();
                const _ = e1.b4(this._tiles, d);
                for (const e1 of _){
                    const t1 = this._tiles[e1];
                    t1.hasSymbolBuckets && !t1.holdingForFade() ? t1.setHoldDuration(this.map._fadeDuration) : t1.hasSymbolBuckets && !t1.symbolFadeFinished() || this._removeTile(+e1);
                }
                this._updateLoadedParentTileCache(), this._renderSourceType === e1.b5.Symbol && this._source.afterUpdate && this._source.afterUpdate();
            }
            releaseSymbolFadeTiles() {
                for(const e1 in this._tiles)this._tiles[e1].holdingForFade() && this._removeTile(+e1);
            }
            _updateRetainedTiles(e1) {
                const t1 = {};
                if (0 === e1.length) return t1;
                const i = {}, o = e1.reduce((e1, t1)=>Math.min(e1, t1.overscaledZ), 1 / 0), r = e1[0].overscaledZ, n = Math.max(r - zt.maxOverzooming, this._source.minzoom), s = Math.max(r + zt.maxUnderzooming, this._source.minzoom), a = {};
                for (const i of e1){
                    const e1 = this._addTile(i);
                    t1[i.key] = i, e1.hasData() || o < this._source.maxzoom && (a[i.key] = i);
                }
                this._retainLoadedChildren(a, o, s, t1);
                for (const o of e1){
                    let e1 = this._tiles[o.key];
                    if (e1.hasData()) continue;
                    if (o.canonical.z >= this._source.maxzoom) {
                        const e1 = o.children(this._source.maxzoom)[0], i = this.getTile(e1);
                        if (i && i.hasData()) {
                            t1[e1.key] = e1;
                            continue;
                        }
                    } else {
                        const e1 = o.children(this._source.maxzoom);
                        if (t1[e1[0].key] && t1[e1[1].key] && t1[e1[2].key] && t1[e1[3].key]) continue;
                    }
                    let r = e1.wasRequested();
                    for(let s = o.overscaledZ - 1; s >= n; --s){
                        const n = o.scaledTo(s);
                        if (i[n.key]) break;
                        if (i[n.key] = !0, e1 = this.getTile(n), !e1 && r && (e1 = this._addTile(n)), e1 && (t1[n.key] = n, r = e1.wasRequested(), e1.hasData())) break;
                    }
                }
                return t1;
            }
            _updateLoadedParentTileCache() {
                this._loadedParentTiles = {};
                for(const e1 in this._tiles){
                    const t1 = [];
                    let i, o = this._tiles[e1].tileID;
                    for(; o.overscaledZ > 0;){
                        if (o.key in this._loadedParentTiles) {
                            i = this._loadedParentTiles[o.key];
                            break;
                        }
                        t1.push(o.key);
                        const e1 = o.scaledTo(o.overscaledZ - 1);
                        if (i = this._getLoadedTile(e1), i) break;
                        o = e1;
                    }
                    for (const e1 of t1)this._loadedParentTiles[e1] = i;
                }
            }
            _addTile(t1) {
                let i = this._tiles[t1.key];
                if (i) return !0 !== i.isExtraShadowCaster || !!this._shadowCasterTiles[t1.key] || this._reloadTile(t1.key, "reloading"), i;
                i = this._cache.getAndRemove(t1), i && (this._setTileReloadTimer(t1.key, i), i.tileID = t1, this._state.initializeTileState(i, this.map ? this.map.painter : null), this._cacheTimers[t1.key] && (clearTimeout(this._cacheTimers[t1.key]), delete this._cacheTimers[t1.key], this._setTileReloadTimer(t1.key, i)));
                const o = Boolean(i);
                if (!o) {
                    const o = this.map ? this.map.painter : null, r = this._source.tileSize * t1.overscaleFactor();
                    i = "raster-array" === this._source.type ? new Pt(t1, r, this.transform.tileZoom, o, this._isRaster) : new e1.b1(t1, r, this.transform.tileZoom, o, this._isRaster, this._source.worldview), this._loadTile(i, this._tileLoaded.bind(this, i, t1.key, i.state));
                }
                return i.uses++, this._tiles[t1.key] = i, o || this._source.fire(new e1.C("dataloading", {
                    tile: i,
                    coord: i.tileID,
                    dataType: "source"
                })), i;
            }
            _setTileReloadTimer(e1, t1) {
                e1 in this._timers && (clearTimeout(this._timers[e1]), delete this._timers[e1]);
                const i = t1.getExpiryTimeout();
                i && (this._timers[e1] = setTimeout(()=>{
                    this._reloadTile(e1, "expired"), delete this._timers[e1];
                }, i));
            }
            _removeTile(e1) {
                const t1 = this._tiles[e1];
                t1 && (t1.uses--, delete this._tiles[e1], this._timers[e1] && (clearTimeout(this._timers[e1]), delete this._timers[e1]), t1.uses > 0 || (t1.hasData() && "reloading" !== t1.state || "empty" === t1.state ? this._cache.add(t1.tileID, t1, t1.getExpiryTimeout()) : (t1.aborted = !0, this._abortTile(t1), this._unloadTile(t1))));
            }
            clearTiles() {
                this._shouldReloadOnResume = !1, this._paused = !1;
                for(const e1 in this._tiles)this._removeTile(+e1);
                this._source._clear && this._source._clear(), this._cache.reset(), this.map && this.usedForTerrain && this.map.painter.terrain && this.map.painter.terrain.resetTileLookupCache(this.id);
            }
            tilesIn(t1, i, o) {
                const r = [], n = this.transform;
                if (!n) return r;
                const s = "globe" === n.projection.name, a = e1.aH(n.center.lng);
                for(const l in this._tiles){
                    const c = this._tiles[l];
                    if (o && c.clearQueryDebugViz(), c.holdingForFade()) continue;
                    let h;
                    if (s) {
                        const t1 = c.tileID.canonical;
                        if (0 === t1.z) {
                            const i = [
                                Math.abs(e1.aC(a, ...Bt(t1, -1)) - a),
                                Math.abs(e1.aC(a, ...Bt(t1, 1)) - a)
                            ];
                            h = [
                                0,
                                2 * i.indexOf(Math.min(...i)) - 1
                            ];
                        } else {
                            const i = [
                                Math.abs(e1.aC(a, ...Bt(t1, -1)) - a),
                                Math.abs(e1.aC(a, ...Bt(t1, 0)) - a),
                                Math.abs(e1.aC(a, ...Bt(t1, 1)) - a)
                            ];
                            h = [
                                i.indexOf(Math.min(...i)) - 1
                            ];
                        }
                    } else h = [
                        0
                    ];
                    for (const e1 of h){
                        const o = t1.containsTile(c, n, i, e1);
                        o && r.push(o);
                    }
                }
                return r;
            }
            getShadowCasterCoordinates() {
                return this._getRenderableCoordinates(!1, !0);
            }
            getVisibleCoordinates(e1) {
                return this._getRenderableCoordinates(e1);
            }
            _getRenderableCoordinates(e1, t1) {
                const i = this.getRenderableIds(e1, t1).map((e1)=>this._tiles[e1].tileID), o = "globe" === this.transform.projection.name;
                for (const e1 of i)e1.projMatrix = this.transform.calculateProjMatrix(e1.toUnwrapped()), e1.expandedProjMatrix = o ? this.transform.calculateProjMatrix(e1.toUnwrapped(), !1, !0) : e1.projMatrix;
                return i;
            }
            sortCoordinatesByDistance(e1) {
                const t1 = e1.slice(), i = this.transform._camera.position, o = this.transform._camera.forward(), r = {};
                for (const e1 of t1){
                    const t1 = 1 / (1 << e1.canonical.z);
                    r[e1.key] = ((e1.canonical.x + .5) * t1 + e1.wrap - i[0]) * o[0] + ((e1.canonical.y + .5) * t1 - i[1]) * o[1] - i[2] * o[2];
                }
                return t1.sort((e1, t1)=>r[e1.key] - r[t1.key]), t1;
            }
            hasTransition() {
                if (this._source.hasTransition()) return !0;
                if (this._supportsFading) {
                    const t1 = e1.o.now();
                    for(const e1 in this._tiles){
                        const i = this._tiles[e1];
                        if (void 0 !== i.fadeEndTime && i.fadeEndTime >= t1) return !0;
                    }
                }
                return !1;
            }
            setFeatureState(e1, t1, i) {
                this._state.updateState(e1 = e1 || "_geojsonTileLayer", t1, i);
            }
            removeFeatureState(e1, t1, i) {
                this._state.removeFeatureState(e1 = e1 || "_geojsonTileLayer", t1, i);
            }
            getFeatureState(e1, t1) {
                return this._state.getState(e1 = e1 || "_geojsonTileLayer", t1);
            }
            setDependencies(e1, t1, i) {
                const o = this._tiles[e1];
                o && o.setDependencies(t1, i);
            }
            reloadTilesForDependencies(e1, t1) {
                for(const i in this._tiles)this._tiles[i].hasDependency(e1, t1) && this._reloadTile(+i, "reloading");
                this._cache.filter((i)=>!i.hasDependency(e1, t1));
            }
            _preloadTiles(t1, i) {
                if (!this._sourceLoaded) {
                    const e1 = ()=>{
                        this._sourceLoaded && (this._source.off("data", e1), this._preloadTiles(t1, i));
                    };
                    return void this._source.on("data", e1);
                }
                const o = new Map, r = Array.isArray(t1) ? t1 : [
                    t1
                ], n = this.map.painter.terrain, s = this.usedForTerrain && n ? n.getScaledDemTileSize() : this._source.tileSize;
                for (const e1 of r){
                    const t1 = e1.coveringTiles({
                        tileSize: s,
                        minzoom: this._source.minzoom,
                        maxzoom: this._source.maxzoom,
                        roundZoom: this._source.roundZoom && !this.usedForTerrain,
                        reparseOverscaled: this._source.reparseOverscaled,
                        isTerrainDEM: this.usedForTerrain
                    });
                    for (const e1 of t1)o.set(e1.key, e1);
                    this.usedForTerrain && e1.updateElevation(!1);
                }
                const a = Array.from(o.values());
                e1.t(a, (t1, i)=>{
                    const o = new e1.b1(t1, this._source.tileSize * t1.overscaleFactor(), this.transform.tileZoom, this.map.painter, this._isRaster, this._source.worldview);
                    this._loadTile(o, (e1)=>{
                        "raster-dem" === this._source.type && o.dem && this._backfillDEM(o), i(e1, o);
                    });
                }, i);
            }
        }
        function Ft(e1, t1) {
            const i = Math.abs(2 * e1.wrap) - +(e1.wrap < 0), o = Math.abs(2 * t1.wrap) - +(t1.wrap < 0);
            return e1.overscaledZ - t1.overscaledZ || o - i || t1.canonical.y - e1.canonical.y || t1.canonical.x - e1.canonical.x;
        }
        function Bt(e1, t1) {
            const i = 1 << e1.z;
            return [
                e1.x / i + t1,
                (e1.x + 1) / i + t1
            ];
        }
        zt.maxOverzooming = 10, zt.maxUnderzooming = 3;
        class kt {
            constructor(e1){
                this.style = e1, this.layersGotHidden = !1, this.layers = [];
            }
            processLayersChanged() {
                this.layers = [];
                const e1 = !1, t1 = !1;
                for(const i in this.style._mergedLayers){
                    const o = this.style._mergedLayers[i];
                    if ("fill-extrusion" === o.type || "building" === o.type) this.layers.push({
                        layer: o,
                        visible: e1,
                        visibilityChanged: t1
                    });
                    else if ("model" === o.type) {
                        const i = this.style.getLayerSource(o);
                        i && "batched-model" === i.type && this.layers.push({
                            layer: o,
                            visible: e1,
                            visibilityChanged: t1
                        });
                    }
                }
            }
            onNewFrame(e1) {
                this.layersGotHidden = !1;
                for (const t1 of this.layers){
                    const i = t1.layer;
                    let o = !1;
                    "fill-extrusion" === i.type ? o = !i.isHidden(e1) && i.paint.get("fill-extrusion-opacity") > 0 : "building" === i.type ? o = !i.isHidden(e1) && i.paint.get("building-opacity") > 0 : "model" === i.type && (o = !i.isHidden(e1) && i.paint.get("model-opacity").constantOr(1) > 0), this.layersGotHidden = this.layersGotHidden || !o && t1.visible, t1.visible = o;
                }
            }
            updateZOffset(e1, t1) {
                this.currentBuildingBuckets = [];
                for (const e1 of this.layers){
                    const i = e1.layer, o = this.style.getLayerSourceCache(i);
                    let r = 1;
                    "fill-extrusion" === i.type ? r = e1.visible ? i.paint.get("fill-extrusion-vertical-scale") : 0 : "building" === i.type && (r = e1.visible ? i.paint.get("building-vertical-scale") : 0);
                    let n = o ? o.getTile(t1) : null;
                    if (!n && o) for(const e1 in o._tiles){
                        const i = o._tiles[e1];
                        if (t1.canonical.isChildOf(i.tileID.canonical)) {
                            n = i;
                            break;
                        }
                    }
                    this.currentBuildingBuckets.push({
                        bucket: n ? n.getBucket(i) : null,
                        tileID: n ? n.tileID : t1,
                        verticalScale: r
                    });
                }
                e1.hasAnyZOffset = !1;
                let i = !1;
                for(let o = 0; o < e1.symbolInstances.length; o++){
                    const r = e1.symbolInstances.get(o), n = r.zOffset, s = this._getHeightAtTileOffset(t1, r.tileAnchorX, r.tileAnchorY);
                    r.zOffset = s !== Number.NEGATIVE_INFINITY ? s : n, i || n === r.zOffset || (i = !0), e1.hasAnyZOffset || 0 === r.zOffset || (e1.hasAnyZOffset = !0);
                }
                i && (e1.zOffsetBuffersNeedUpload = !0, e1.zOffsetSortDirty = !0);
            }
            _mapCoordToOverlappingTile(t1, i, o, r) {
                let n = i, s = o;
                if (t1.canonical.z !== r.canonical.z) {
                    const a = r.canonical, l = 1 / (1 << t1.canonical.z - a.z);
                    n = (i + t1.canonical.x * e1.an) * l - a.x * e1.an | 0, s = (o + t1.canonical.y * e1.an) * l - a.y * e1.an | 0;
                }
                return {
                    tileX: n,
                    tileY: s
                };
            }
            _getHeightAtTileOffset(e1, t1, i) {
                let o, r;
                for(let n = 0; n < this.layers.length; ++n){
                    const s = this.layers[n].layer;
                    if ("fill-extrusion" !== s.type && "building" !== s.type) continue;
                    const { bucket: a, tileID: l, verticalScale: c } = this.currentBuildingBuckets[n];
                    if (!a) continue;
                    const { tileX: h, tileY: d } = this._mapCoordToOverlappingTile(e1, t1, i, l), _ = a.getHeightAtTileCoord(h, d);
                    _ && void 0 !== _.height && (_.hidden ? o = _.height : r = Math.max(_.height * c, r || 0));
                }
                if (void 0 !== r) return r;
                for(let r = 0; r < this.layers.length; ++r){
                    const n = this.layers[r];
                    if ("model" !== n.layer.type || !n.visible) continue;
                    const { bucket: s, tileID: a } = this.currentBuildingBuckets[r];
                    if (!s) continue;
                    const { tileX: l, tileY: c } = this._mapCoordToOverlappingTile(e1, t1, i, a), h = s.getHeightAtTileCoord(l, c);
                    if (h && !h.hidden) return void 0 === h.height && void 0 !== o ? Math.min(h.maxHeight, o) * h.verticalScale : h.height ? h.height * h.verticalScale : Number.NEGATIVE_INFINITY;
                }
                return this.layersGotHidden ? 0 : Number.NEGATIVE_INFINITY;
            }
        }
        function Nt(t1, i) {
            const o = {};
            for(const e1 in t1)"ref" !== e1 && (o[e1] = t1[e1]);
            return e1.b6.forEach((e1)=>{
                e1 in i && (o[e1] = i[e1]);
            }), o;
        }
        function Ut(e1) {
            e1 = e1.slice();
            const t1 = Object.create(null);
            for(let i = 0; i < e1.length; i++)t1[e1[i].id] = e1[i];
            for(let i = 0; i < e1.length; i++)"ref" in e1[i] && (e1[i] = Nt(e1[i], t1[e1[i].ref]));
            return e1;
        }
        const Vt = {
            setStyle: "setStyle",
            addLayer: "addLayer",
            removeLayer: "removeLayer",
            setPaintProperty: "setPaintProperty",
            setLayoutProperty: "setLayoutProperty",
            setSlot: "setSlot",
            setFilter: "setFilter",
            addSource: "addSource",
            removeSource: "removeSource",
            setGeoJSONSourceData: "setGeoJSONSourceData",
            setLayerZoomRange: "setLayerZoomRange",
            setLayerProperty: "setLayerProperty",
            setCenter: "setCenter",
            setZoom: "setZoom",
            setBearing: "setBearing",
            setPitch: "setPitch",
            setSprite: "setSprite",
            setGlyphs: "setGlyphs",
            setTransition: "setTransition",
            setLight: "setLight",
            setTerrain: "setTerrain",
            setFog: "setFog",
            setSnow: "setSnow",
            setRain: "setRain",
            setCamera: "setCamera",
            setLights: "setLights",
            setProjection: "setProjection",
            addImport: "addImport",
            removeImport: "removeImport",
            updateImport: "updateImport",
            addIconset: "addIconset",
            removeIconset: "removeIconset"
        };
        function jt(e1, t1, i) {
            i.push({
                command: Vt.addSource,
                args: [
                    e1,
                    t1[e1]
                ]
            });
        }
        function Gt(e1, t1, i) {
            t1.push({
                command: Vt.removeSource,
                args: [
                    e1
                ]
            }), i[e1] = !0;
        }
        function qt(e1, t1, i, o) {
            Gt(e1, i, o), jt(e1, t1, i);
        }
        function Zt(t1, i, o) {
            let r;
            for(r in t1[o])if (t1[o].hasOwnProperty(r) && "data" !== r && !e1.b7(t1[o][r], i[o][r])) return !1;
            for(r in i[o])if (i[o].hasOwnProperty(r) && "data" !== r && !e1.b7(t1[o][r], i[o][r])) return !1;
            return !0;
        }
        function Ht(t1, i, o, r, n, s) {
            let a;
            for(a in i = i || {}, t1 = t1 || {})t1.hasOwnProperty(a) && (e1.b7(t1[a], i[a]) || o.push({
                command: s,
                args: [
                    r,
                    a,
                    i[a],
                    n
                ]
            }));
            for(a in i)i.hasOwnProperty(a) && !t1.hasOwnProperty(a) && (e1.b7(t1[a], i[a]) || o.push({
                command: s,
                args: [
                    r,
                    a,
                    i[a],
                    n
                ]
            }));
        }
        function Wt(e1) {
            return e1.id;
        }
        function $t(e1, t1) {
            return e1[t1.id] = t1, e1;
        }
        function Xt(t1, i, o) {
            const r = i.createTileMatrix(t1, t1.worldSize, o.toUnwrapped());
            return e1.aD(new Float32Array(16), t1.projMatrix, r);
        }
        function Yt(e1, t1, i) {
            if (t1.projection.name === i.projection.name) return e1.projMatrix;
            const o = i.clone();
            return o.setProjection(t1.projection), Xt(o, t1.getProjection(), e1);
        }
        function Kt(e1, t1, i) {
            return t1.name === i.projection.name ? e1.projMatrix : Xt(i, t1, e1);
        }
        class Qt {
            constructor(e1, t1){
                this.reset(e1, t1);
            }
            reset(e1, t1) {
                this.points = e1 || [], this._distances = [
                    0
                ];
                for(let e1 = 1; e1 < this.points.length; e1++)this._distances[e1] = this._distances[e1 - 1] + this.points[e1].dist(this.points[e1 - 1]);
                this.length = this._distances[this._distances.length - 1], this.padding = Math.min(t1 || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
            }
            lerp(t1) {
                if (1 === this.points.length) return this.points[0];
                t1 = e1.aC(t1, 0, 1);
                let i = 1, o = this._distances[i];
                const r = t1 * this.paddedLength + this.padding;
                for(; o < r && i < this._distances.length;)o = this._distances[++i];
                const n = i - 1, s = this._distances[n], a = o - s, l = a > 0 ? (r - s) / a : 0;
                return this.points[n].mult(1 - l).add(this.points[i].mult(l));
            }
        }
        class Jt {
            constructor(e1, t1, i){
                const o = this.boxCells = [], r = this.circleCells = [];
                this.xCellCount = Math.ceil(e1 / i), this.yCellCount = Math.ceil(t1 / i);
                for(let e1 = 0; e1 < this.xCellCount * this.yCellCount; e1++)o.push([]), r.push([]);
                this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = e1, this.height = t1, this.xScale = this.xCellCount / e1, this.yScale = this.yCellCount / t1, this.boxUid = 0, this.circleUid = 0;
            }
            keysLength() {
                return this.boxKeys.length + this.circleKeys.length;
            }
            insert(e1, t1, i, o, r) {
                this._forEachCell(t1, i, o, r, this._insertBoxCell, this.boxUid++), this.boxKeys.push(e1), this.bboxes.push(t1), this.bboxes.push(i), this.bboxes.push(o), this.bboxes.push(r);
            }
            insertCircle(e1, t1, i, o) {
                this._forEachCell(t1 - o, i - o, t1 + o, i + o, this._insertCircleCell, this.circleUid++), this.circleKeys.push(e1), this.circles.push(t1), this.circles.push(i), this.circles.push(o);
            }
            _insertBoxCell(e1, t1, i, o, r, n) {
                this.boxCells[r].push(n);
            }
            _insertCircleCell(e1, t1, i, o, r, n) {
                this.circleCells[r].push(n);
            }
            _query(e1, t1, i, o, r, n) {
                if (i < 0 || e1 > this.width || o < 0 || t1 > this.height) return !r && [];
                const s = [];
                if (e1 <= 0 && t1 <= 0 && this.width <= i && this.height <= o) {
                    if (r) return !0;
                    for(let e1 = 0; e1 < this.boxKeys.length; e1++)s.push({
                        key: this.boxKeys[e1],
                        x1: this.bboxes[4 * e1],
                        y1: this.bboxes[4 * e1 + 1],
                        x2: this.bboxes[4 * e1 + 2],
                        y2: this.bboxes[4 * e1 + 3]
                    });
                    for(let e1 = 0; e1 < this.circleKeys.length; e1++){
                        const t1 = this.circles[3 * e1], i = this.circles[3 * e1 + 1], o = this.circles[3 * e1 + 2];
                        s.push({
                            key: this.circleKeys[e1],
                            x1: t1 - o,
                            y1: i - o,
                            x2: t1 + o,
                            y2: i + o
                        });
                    }
                    return n ? s.filter(n) : s;
                }
                return this._forEachCell(e1, t1, i, o, this._queryCell, s, {
                    hitTest: r,
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, n), r ? s.length > 0 : s;
            }
            _queryCircle(e1, t1, i, o, r) {
                const n = e1 - i, s = e1 + i, a = t1 - i, l = t1 + i;
                if (s < 0 || n > this.width || l < 0 || a > this.height) return !o && [];
                const c = [];
                return this._forEachCell(n, a, s, l, this._queryCellCircle, c, {
                    hitTest: o,
                    circle: {
                        x: e1,
                        y: t1,
                        radius: i
                    },
                    seenUids: {
                        box: {},
                        circle: {}
                    }
                }, r), o ? c.length > 0 : c;
            }
            query(e1, t1, i, o, r) {
                return this._query(e1, t1, i, o, !1, r);
            }
            hitTest(e1, t1, i, o, r) {
                return this._query(e1, t1, i, o, !0, r);
            }
            hitTestCircle(e1, t1, i, o) {
                return this._queryCircle(e1, t1, i, !0, o);
            }
            _queryCell(e1, t1, i, o, r, n, s, a) {
                const l = s.seenUids, c = this.boxCells[r];
                if (null !== c) {
                    const r = this.bboxes;
                    for (const h of c)if (!l.box[h]) {
                        l.box[h] = !0;
                        const c = 4 * h;
                        if (e1 <= r[c + 2] && t1 <= r[c + 3] && i >= r[c + 0] && o >= r[c + 1] && (!a || a(this.boxKeys[h]))) {
                            if (s.hitTest) return n.push(!0), !0;
                            n.push({
                                key: this.boxKeys[h],
                                x1: r[c],
                                y1: r[c + 1],
                                x2: r[c + 2],
                                y2: r[c + 3]
                            });
                        }
                    }
                }
                const h = this.circleCells[r];
                if (null !== h) {
                    const r = this.circles;
                    for (const c of h)if (!l.circle[c]) {
                        l.circle[c] = !0;
                        const h = 3 * c;
                        if (this._circleAndRectCollide(r[h], r[h + 1], r[h + 2], e1, t1, i, o) && (!a || a(this.circleKeys[c]))) {
                            if (s.hitTest) return n.push(!0), !0;
                            {
                                const e1 = r[h], t1 = r[h + 1], i = r[h + 2];
                                n.push({
                                    key: this.circleKeys[c],
                                    x1: e1 - i,
                                    y1: t1 - i,
                                    x2: e1 + i,
                                    y2: t1 + i
                                });
                            }
                        }
                    }
                }
            }
            _queryCellCircle(e1, t1, i, o, r, n, s, a) {
                const l = s.circle, c = s.seenUids, h = this.boxCells[r];
                if (null !== h) {
                    const e1 = this.bboxes;
                    for (const t1 of h)if (!c.box[t1]) {
                        c.box[t1] = !0;
                        const i = 4 * t1;
                        if (this._circleAndRectCollide(l.x, l.y, l.radius, e1[i + 0], e1[i + 1], e1[i + 2], e1[i + 3]) && (!a || a(this.boxKeys[t1]))) return n.push(!0), !0;
                    }
                }
                const d = this.circleCells[r];
                if (null !== d) {
                    const e1 = this.circles;
                    for (const t1 of d)if (!c.circle[t1]) {
                        c.circle[t1] = !0;
                        const i = 3 * t1;
                        if (this._circlesCollide(e1[i], e1[i + 1], e1[i + 2], l.x, l.y, l.radius) && (!a || a(this.circleKeys[t1]))) return n.push(!0), !0;
                    }
                }
            }
            _forEachCell(e1, t1, i, o, r, n, s, a) {
                const l = this._convertToXCellCoord(e1), c = this._convertToYCellCoord(t1), h = this._convertToXCellCoord(i), d = this._convertToYCellCoord(o);
                for(let _ = l; _ <= h; _++)for(let l = c; l <= d; l++)if (r.call(this, e1, t1, i, o, this.xCellCount * l + _, n, s, a)) return;
            }
            _convertToXCellCoord(e1) {
                return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(e1 * this.xScale)));
            }
            _convertToYCellCoord(e1) {
                return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(e1 * this.yScale)));
            }
            _circlesCollide(e1, t1, i, o, r, n) {
                const s = o - e1, a = r - t1, l = i + n;
                return l * l > s * s + a * a;
            }
            _circleAndRectCollide(e1, t1, i, o, r, n, s) {
                const a = (n - o) / 2, l = Math.abs(e1 - (o + a));
                if (l > a + i) return !1;
                const c = (s - r) / 2, h = Math.abs(t1 - (r + c));
                if (h > c + i) return !1;
                if (l <= a || h <= c) return !0;
                const d = l - a, _ = h - c;
                return d * d + _ * _ <= i * i;
            }
        }
        const ei = Math.tan(85 * Math.PI / 180);
        function ti(t1, i, o, r, n, s, a) {
            const l = e1.bc();
            if (o) {
                if ("globe" === s.name) {
                    const t1 = e1.bd(n, i);
                    e1.aD(l, l, t1);
                } else {
                    const t1 = e1.be([], a);
                    l[0] = t1[0], l[1] = t1[1], l[4] = t1[2], l[5] = t1[3], r || e1.bb(l, l, n.angle);
                }
            } else e1.aD(l, n.labelPlaneMatrix, t1);
            return l;
        }
        function ii(e1, t1, i, o, r, n, s) {
            const a = ti(e1, t1, i, o, r, n, s);
            return "globe" === n.name && i || (a[2] = a[6] = a[10] = a[14] = 0), a;
        }
        function oi(t1, i, o, r, n, s, a) {
            if (o) {
                if ("globe" === s.name) {
                    const l = ti(t1, i, o, r, n, s, a);
                    return e1.b8(l, l), e1.aD(l, t1, l), l;
                }
                {
                    const i = e1.b9(t1), o = e1.ba([]);
                    return o[0] = a[0], o[1] = a[1], o[4] = a[2], o[5] = a[3], e1.aD(i, i, o), r || e1.bb(i, i, -n.angle), i;
                }
            }
            return n.glCoordMatrix;
        }
        function ri(t1, i, o, r) {
            const n = [
                t1,
                i,
                o,
                1
            ];
            o ? e1.aE(n, n, r) : fi(n, n, r);
            const s = n[3];
            return n[0] /= s, n[1] /= s, n[2] /= s, n;
        }
        function ni(e1, t1) {
            return Math.min(.5 + e1 / t1 * .5, 1.5);
        }
        function si(e1, t1) {
            const i = e1[0] / e1[3], o = e1[1] / e1[3];
            return i >= -t1[0] && i <= t1[0] && o >= -t1[1] && o <= t1[1];
        }
        function ai(t1, i, o, r, n, s, a, l, c, h, d = 1) {
            const _ = o.transform, u = r ? t1.textSizeData : t1.iconSizeData, p = e1.bk(u, o.transform.zoom, d), f = "globe" === _.projection.name, m = [
                256 / o.width * 2 + 1,
                256 / o.height * 2 + 1
            ], g = r ? t1.text.dynamicLayoutVertexArray : t1.icon.dynamicLayoutVertexArray;
            g.clear();
            let v = null;
            f && (v = r ? t1.text.globeExtVertexArray : t1.icon.globeExtVertexArray);
            const y = t1.lineVertexArray, x = r ? t1.text.placedSymbolArray : t1.icon.placedSymbolArray, b = o.transform.width / o.transform.height;
            let w, T = !1;
            for(let r = 0; r < x.length; r++){
                const d = x.get(r), { numGlyphs: f, writingMode: E } = d;
                if (E !== e1.bl.vertical || T || w === e1.bl.horizontal || (T = !0), w = E, (d.hidden || E === e1.bl.vertical) && !T) {
                    pi(f, g);
                    continue;
                }
                T = !1;
                const S = new e1.P(d.tileAnchorX, d.tileAnchorY), C = "road" === t1.elevationType, I = !!_.elevation || C;
                let { x: R, y: D, z: A } = _.projection.projectTilePoint(S.x, S.y, h.canonical), L = null;
                if (I) {
                    const e1 = C ? t1.getElevationFeatureForText(r) : null;
                    L = {
                        getElevation: c,
                        elevation: _.elevation,
                        elevationFeature: e1
                    };
                    const [i, o, n] = c(S, _.elevation, e1);
                    R += i, D += o, A += n;
                }
                const P = [
                    R,
                    D,
                    A,
                    1
                ];
                if (e1.aE(P, P, i), !si(P, m)) {
                    pi(f, g);
                    continue;
                }
                const O = P[3], M = ni(o.transform.getCameraToCenterDistance(_.projection), O), z = e1.bm(u, p, d), F = a ? z / M : z * M, B = ri(R, D, A, n);
                if (B[3] <= 0) {
                    pi(f, g);
                    continue;
                }
                let k = {};
                const N = e1.ap(t1.layers[0].layout.get("text-max-angle")), U = Math.cos(N), V = a ? null : L, j = hi(d, F, !1, l, i, n, s, t1.glyphOffsetArray, y, g, v, B, S, k, b, V, _.projection, h, a, U);
                T = j.useVertical, V && j.needsFlipping && (k = {}), (j.notEnoughRoom || T || j.needsFlipping && hi(d, F, !0, l, i, n, s, t1.glyphOffsetArray, y, g, v, B, S, k, b, V, _.projection, h, a, U).notEnoughRoom) && pi(f, g);
            }
            r ? (t1.text.dynamicLayoutVertexBuffer.updateData(g), v && t1.text.globeExtVertexBuffer && t1.text.globeExtVertexBuffer.updateData(v)) : (t1.icon.dynamicLayoutVertexBuffer.updateData(g), v && t1.icon.globeExtVertexBuffer && t1.icon.globeExtVertexBuffer.updateData(v));
        }
        function li(e1, t1, i, o, r, n, s, a, l, c, h, d, _, u, p, f, m) {
            const { lineStartIndex: g, glyphStartIndex: v, segment: y } = a, x = v + a.numGlyphs, b = g + a.lineLength, w = t1.getoffsetX(v), T = t1.getoffsetX(x - 1), E = ui(e1 * w, i, o, r, n, s, y, g, b, l, c, h, d, _, !0, u, p, f, m);
            if (!E) return null;
            const S = ui(e1 * T, i, o, r, n, s, y, g, b, l, c, h, d, _, !0, u, p, f, m);
            return S ? {
                first: E,
                last: S
            } : null;
        }
        function ci(t1, i, o, r) {
            return t1 === e1.bl.horizontal && Math.abs(r) > Math.abs(o) ? {
                useVertical: !0
            } : t1 === e1.bl.vertical ? r > 0 ? {
                needsFlipping: !0
            } : null : 0 !== i && function(e1, t1) {
                return 0 === e1 || Math.abs(t1 / e1) > ei;
            }(o, r) ? 1 === i ? {
                needsFlipping: !0
            } : null : o < 0 ? {
                needsFlipping: !0
            } : null;
        }
        function hi(t1, i, o, r, n, s, a, l, c, h, d, _, u, p, f, m, g, v, y, x) {
            const b = i / 24, w = t1.lineOffsetX * b, T = t1.lineOffsetY * b, { lineStartIndex: E, glyphStartIndex: S, numGlyphs: C, segment: I, writingMode: R, flipState: D } = t1, A = E + t1.lineLength, L = (t1)=>{
                if (d) {
                    const [i, o, r] = t1.up, n = h.length;
                    e1.bn(d, n + 0, i, o, r), e1.bn(d, n + 1, i, o, r), e1.bn(d, n + 2, i, o, r), e1.bn(d, n + 3, i, o, r);
                }
                const [i, o, r] = t1.point;
                e1.bo(h, i, o, r, t1.angle);
            };
            if (C > 1) {
                const e1 = li(b, l, w, T, o, _, u, t1, c, s, p, m, !1, g, v, y, x);
                if (!e1) return {
                    notEnoughRoom: !0
                };
                if (r && !o) {
                    let [i, o, r] = e1.first.point, [n, s, l] = e1.last.point;
                    [i, o] = ri(i, o, r, a), [n, s] = ri(n, s, l, a);
                    const c = ci(R, D, (n - i) * f, s - o);
                    if (t1.flipState = c && c.needsFlipping ? 1 : 2, c) return c;
                }
                L(e1.first);
                for(let e1 = S + 1; e1 < S + C - 1; e1++){
                    const t1 = ui(b * l.getoffsetX(e1), w, T, o, _, u, I, E, A, c, s, p, m, !1, !1, g, v, y, x);
                    if (!t1) return h.length -= 4 * (e1 - S), {
                        notEnoughRoom: !0
                    };
                    L(t1);
                }
                L(e1.last);
            } else {
                if (r && !o) {
                    const i = ri(u.x, u.y, 0, n), o = E + I + 1, r = new e1.P(c.getx(o), c.gety(o)), s = ri(r.x, r.y, 0, n), a = s[3] > 0 ? s : _i(u, r, i, 1, n, void 0, g, v.canonical), l = ci(R, D, (a[0] - i[0]) * f, a[1] - i[1]);
                    if (t1.flipState = l && l.needsFlipping ? 1 : 2, l) return l;
                }
                const i = ui(b * l.getoffsetX(S), w, T, o, _, u, I, E, A, c, s, p, m, !1, !1, g, v, y, x);
                if (!i) return {
                    notEnoughRoom: !0
                };
                L(i);
            }
            return {};
        }
        function di(e1, t1, i, o, r) {
            const { x: n, y: s, z: a } = o.projectTilePoint(e1.x, e1.y, t1);
            if (!r) return ri(n, s, a, i);
            const [l, c, h] = r.getElevation(e1, r.elevation, r.elevationFeature);
            return ri(n + l, s + c, a + h, i);
        }
        function _i(t1, i, o, r, n, s, a, l) {
            const c = di(t1.sub(i)._unit()._add(t1), l, n, a, s);
            return e1.ax(c, o, c), e1.ay(c, c), e1.bh(c, o, c, r);
        }
        function ui(t1, i, o, r, n, s, a, l, c, h, d, _, u, p, f, m, g, v, y) {
            const x = r ? t1 - i : t1 + i;
            let b = x > 0 ? 1 : -1, w = 0;
            r && (b *= -1, w = Math.PI), b < 0 && (w += Math.PI);
            let T = l + a + (b > 0 ? 0 : 1) | 0, E = n, S = n, C = 0, I = 0;
            const R = Math.abs(x), D = [], A = [];
            let L = s, P = L, O = e1.bf([]);
            const M = ()=>_i(P, L, S, R - C + 1, d, u, m, g.canonical);
            for(; C + I <= R;){
                if (T += b, T < l || T >= c) return null;
                if (S = E, P = L, D.push(S), p && A.push(P), L = new e1.P(h.getx(T), h.gety(T)), E = _[T], !E) {
                    const e1 = di(L, g.canonical, d, m, u);
                    E = e1[3] > 0 ? _[T] = e1 : M();
                }
                C += I;
                const t1 = e1.ax([], E, S), i = e1.bg(S, E);
                if (o && i > 0 && I > 0 && e1.bj(O, t1) / (I * i) < y) return null;
                I = i, O = t1;
            }
            f && u && (_[T] && (E = M(), I = e1.bg(S, E), O = e1.ax([], E, S)), _[T] = E);
            const z = (R - C) / I, F = L.sub(P)._mult(z)._add(P), B = e1.bh([], S, O, z);
            let k = [
                0,
                0,
                1
            ], N = O[0], U = O[1];
            if (v && (k = m.upVector(g.canonical, F.x, F.y), 0 !== k[0] || 0 !== k[1] || 1 !== k[2])) {
                const t1 = [
                    k[2],
                    0,
                    -k[0]
                ], i = e1.bi([], k, t1);
                e1.ay(t1, t1), e1.ay(i, i), N = e1.bj(O, t1), U = e1.bj(O, i);
            }
            if (o) {
                const t1 = e1.bi([], k, O);
                e1.ay(t1, t1), e1.bh(B, B, t1, o * b);
            }
            const V = w + Math.atan2(U, N);
            return D.push(B), p && A.push(F), {
                point: B,
                angle: V,
                path: D,
                tilePath: A,
                up: k
            };
        }
        function pi(e1, t1) {
            const i = t1.length, o = i + 4 * e1;
            t1.resize(o), t1.float32.fill(-1 / 0, 4 * i, 4 * o);
        }
        function fi(e1, t1, i) {
            const o = t1[0], r = t1[1];
            return e1[0] = i[0] * o + i[4] * r + i[12], e1[1] = i[1] * o + i[5] * r + i[13], e1[3] = i[3] * o + i[7] * r + i[15], e1;
        }
        const mi = 100;
        class gi {
            constructor(e1, t1, i = new Jt(e1.width + 200, e1.height + 200, 25), o = new Jt(e1.width + 200, e1.height + 200, 25)){
                this.transform = e1, this.grid = i, this.ignoredGrid = o, this.pitchfactor = Math.cos(e1._pitch) * e1.cameraToCenterDistance, this.screenRightBoundary = e1.width + mi, this.screenBottomBoundary = e1.height + mi, this.gridRightBoundary = e1.width + 200, this.gridBottomBoundary = e1.height + 200, this.fogState = t1, this.clippedSymbols = new Map;
            }
            clearClippedSymbolsForBucket(e1) {
                this.clippedSymbols.delete(e1);
            }
            markSymbolAsClipped(e1, t1) {
                let i = this.clippedSymbols.get(e1);
                i || (i = new Set, this.clippedSymbols.set(e1, i)), i.add(t1);
            }
            placeCollisionBox(t1, i, o, r, n, s, a, l, c, h, d) {
                let _ = o.projectedAnchorX, u = o.projectedAnchorY, p = o.projectedAnchorZ;
                const f = o.tileAnchorX, m = o.tileAnchorY, g = o.elevation, v = o.tileID, y = t1.getProjection();
                if (g && v) {
                    const [e1, t1, i] = y.upVector(v.canonical, o.tileAnchorX, o.tileAnchorY), r = y.upVectorScale(v.canonical, this.transform.center.lat, this.transform.worldSize).metersToTile;
                    _ += e1 * g * r, u += t1 * g * r, p += i * g * r;
                }
                const x = "globe" === t1.projection.name, b = "globe" === t1.projection.name ? e1.al(this.transform.zoom) : 0;
                if (v && x && b < 1 && !s) {
                    const t1 = 1 << v.canonical.z, i = e1.bp(f, m);
                    e1.bq(i, i, 1 / e1.an), e1.br(i, i, e1.bp(v.canonical.x, v.canonical.y)), e1.bq(i, i, 1 / t1), e1.bs(i, i, e1.bp(r[0], r[1])), i[0] = e1.bt(i[0], -0.5, .5), e1.bq(i, i, e1.an);
                    const o = e1.bu(i[0], i[1], e1.an / (2 * Math.PI), 1);
                    e1.aE(o, o, n), _ = e1.am(_, o[0], b), u = e1.am(u, o[1], b), p = e1.am(p, o[2], b);
                }
                const w = this.projectAndGetPerspectiveRatio(h, _, u, p, o.tileID, "globe" === y.name || !!g || this.transform.pitch > 0, y), T = c * w.perspectiveRatio, E = (o.x1 * i + a.x - o.padding) * T + w.point.x, S = (o.y1 * i + a.y - o.padding) * T + w.point.y, C = (o.x2 * i + a.x + o.padding) * T + w.point.x, I = (o.y2 * i + a.y + o.padding) * T + w.point.y, R = w.perspectiveRatio <= .55 || w.occluded;
                return !this.isInsideGrid(E, S, C, I) || !l && this.grid.hitTest(E, S, C, I, d) || R ? {
                    box: [],
                    offscreen: !1,
                    occluded: w.occluded
                } : {
                    box: [
                        E,
                        S,
                        C,
                        I
                    ],
                    offscreen: this.isOffscreen(E, S, C, I),
                    occluded: !1
                };
            }
            placeCollisionCircles(t1, i, o, r, n, s, a, l, c, h, d, _, u, p, f, m) {
                const g = [], v = this.transform.elevation, y = t1.getProjection(), x = "road" === t1.elevationType, b = !!v || x, w = e1.bv.getAtTileOffsetFunc(m, this.transform.center.lat, this.transform.worldSize, y), T = new e1.P(o.tileAnchorX, o.tileAnchorY), E = new e1.P(o.tileAnchorX, o.tileAnchorY);
                let { x: S, y: C, z: I } = y.projectTilePoint(E.x, E.y, m.canonical), R = null;
                if (b) {
                    const e1 = x ? t1.getElevationFeatureForText(r) : null;
                    R = {
                        getElevation: w,
                        elevation: v,
                        elevationFeature: e1
                    };
                    const [i, o, n] = w(T, v, e1);
                    S += i, C += o, I += n;
                }
                const D = "globe" === y.name, A = this.projectAndGetPerspectiveRatio(l, S, C, I, m, D || !!v || this.transform.pitch > 0, y), { perspectiveRatio: L } = A, P = (_ ? a / L : a * L) / e1.bz, O = ri(S, C, I, c), M = o.lineOffsetX * P, z = o.lineOffsetY * P, F = e1.ap(t1.layers[0].layout.get("text-max-angle")), B = Math.cos(F), k = A.signedDistanceFromCamera > 0 ? li(P, s, M, z, x && 1 === o.flipState, O, E, o, n, c, {}, b && !_ ? R : null, _ && b, y, m, _, B) : null;
                let N = !1, U = !1, V = !0;
                if (k && !A.occluded) {
                    const t1 = .5 * p * L + f, o = new e1.P(-100, -100), r = new e1.P(this.screenRightBoundary, this.screenBottomBoundary), n = new Qt, { first: s, last: a } = k, l = s.path.length;
                    let c = [];
                    for(let e1 = l - 1; e1 >= 1; e1--)c.push(s.path[e1]);
                    for(let e1 = 1; e1 < a.path.length; e1++)c.push(a.path[e1]);
                    const _ = 2.5 * t1;
                    h && (c = c.map(([e1, t1, i], o)=>(b && !D && (i = w(o < l - 1 ? s.tilePath[l - 1 - o] : a.tilePath[o - l + 2], v, R.elevationFeature)[2]), ri(e1, t1, i, h))), c.some((e1)=>e1[3] <= 0) && (c = []));
                    let m = [];
                    if (c.length > 0) {
                        let t1 = 1 / 0, i = -1 / 0, n = 1 / 0, s = -1 / 0;
                        for (const e1 of c)t1 = Math.min(t1, e1[0]), n = Math.min(n, e1[1]), i = Math.max(i, e1[0]), s = Math.max(s, e1[1]);
                        i >= o.x && t1 <= r.x && s >= o.y && n <= r.y && (m = [
                            c.map((t1)=>new e1.P(t1[0], t1[1]))
                        ], (t1 < o.x || i > r.x || n < o.y || s > r.y) && (m = e1.bw(m, o.x, o.y, r.x, r.y)));
                    }
                    for (const e1 of m){
                        n.reset(e1, .25 * t1);
                        let o = 0;
                        o = n.length <= .5 * t1 ? 1 : Math.ceil(n.paddedLength / _) + 1;
                        for(let e1 = 0; e1 < o; e1++){
                            const r = e1 / Math.max(o - 1, 1), s = n.lerp(r), a = s.x + mi, l = s.y + mi;
                            g.push(a, l, t1, 0);
                            const c = a - t1, h = l - t1, _ = a + t1, p = l + t1;
                            if (V = V && this.isOffscreen(c, h, _, p), U = U || this.isInsideGrid(c, h, _, p), !i && this.grid.hitTestCircle(a, l, t1, u) && (N = !0, !d)) return {
                                circles: [],
                                offscreen: !1,
                                collisionDetected: N,
                                occluded: !1
                            };
                        }
                    }
                }
                return {
                    circles: !d && N || !U ? [] : g,
                    offscreen: V,
                    collisionDetected: N,
                    occluded: A.occluded
                };
            }
            queryRenderedSymbols(t1) {
                if (0 === t1.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
                const i = [];
                let o = 1 / 0, r = 1 / 0, n = -1 / 0, s = -1 / 0;
                for (const a of t1){
                    const t1 = new e1.P(a.x + mi, a.y + mi);
                    o = Math.min(o, t1.x), r = Math.min(r, t1.y), n = Math.max(n, t1.x), s = Math.max(s, t1.y), i.push(t1);
                }
                const a = this.grid.query(o, r, n, s).concat(this.ignoredGrid.query(o, r, n, s)), l = {}, c = {};
                for (const t1 of a){
                    const o = t1.key;
                    if (void 0 === l[o.bucketInstanceId] && (l[o.bucketInstanceId] = {}), l[o.bucketInstanceId][o.featureIndex]) continue;
                    const r = this.clippedSymbols.get(o.bucketInstanceId);
                    if (r && r.has(o.featureIndex)) continue;
                    const n = [
                        new e1.P(t1.x1, t1.y1),
                        new e1.P(t1.x2, t1.y1),
                        new e1.P(t1.x2, t1.y2),
                        new e1.P(t1.x1, t1.y2)
                    ];
                    e1.bx(i, n) && (l[o.bucketInstanceId][o.featureIndex] = !0, void 0 === c[o.bucketInstanceId] && (c[o.bucketInstanceId] = []), c[o.bucketInstanceId].push(o.featureIndex));
                }
                return c;
            }
            insertCollisionBox(e1, t1, i, o, r) {
                (t1 ? this.ignoredGrid : this.grid).insert({
                    bucketInstanceId: i,
                    featureIndex: o,
                    collisionGroupID: r
                }, e1[0], e1[1], e1[2], e1[3]);
            }
            insertCollisionCircles(e1, t1, i, o, r) {
                const n = t1 ? this.ignoredGrid : this.grid, s = {
                    bucketInstanceId: i,
                    featureIndex: o,
                    collisionGroupID: r
                };
                for(let t1 = 0; t1 < e1.length; t1 += 4)n.insertCircle(s, e1[t1], e1[t1 + 1], e1[t1 + 2]);
            }
            projectAndGetPerspectiveRatio(t1, i, o, r, n, s, a) {
                const l = [
                    i,
                    o,
                    r,
                    1
                ];
                let c = !1;
                if (r || this.transform.pitch > 0) {
                    if (e1.aE(l, l, t1), this.fogState && n && "globe" !== a.name) {
                        const t1 = function(t1, i, o, r, n, s) {
                            const a = s.calculateFogTileMatrix(n), l = [
                                i,
                                o,
                                r
                            ];
                            return e1.ah(l, l, a), Ke(t1, e1.ai(l), s.pitch, s._fov);
                        }(this.fogState, i, o, r, n.toUnwrapped(), this.transform);
                        c = t1 > .9;
                    }
                } else fi(l, l, t1);
                const h = l[3];
                return {
                    point: new e1.P((l[0] / h + 1) / 2 * this.transform.width + mi, (-l[1] / h + 1) / 2 * this.transform.height + mi),
                    perspectiveRatio: Math.min(.5 + this.transform.getCameraToCenterDistance(a) / h * .5, 1.5),
                    signedDistanceFromCamera: h,
                    occluded: s && l[2] > h || c
                };
            }
            isOffscreen(e1, t1, i, o) {
                return i < mi || e1 >= this.screenRightBoundary || o < mi || t1 > this.screenBottomBoundary;
            }
            isInsideGrid(e1, t1, i, o) {
                return i >= 0 && e1 < this.gridRightBoundary && o >= 0 && t1 < this.gridBottomBoundary;
            }
            getViewportMatrix() {
                const t1 = e1.ba([]);
                return e1.by(t1, t1, [
                    -100,
                    -100,
                    0
                ]), t1;
            }
        }
        class vi {
            constructor(e1, t1, i, o){
                this.opacity = e1 ? Math.max(0, Math.min(1, e1.opacity + (e1.placed ? t1 : -t1))) : o && i ? 1 : 0, this.placed = i;
            }
            isHidden() {
                return 0 === this.opacity && !this.placed;
            }
        }
        class yi {
            constructor(e1, t1, i, o, r, n = !1){
                this.text = new vi(e1 ? e1.text : null, t1, i, r), this.icon = new vi(e1 ? e1.icon : null, t1, o, r), this.clipped = n;
            }
            isHidden() {
                return this.text.isHidden() && this.icon.isHidden();
            }
        }
        class xi {
            constructor(e1, t1, i, o = !1){
                this.text = e1, this.icon = t1, this.skipFade = i, this.clipped = o;
            }
        }
        class bi {
            constructor(){
                this.invProjMatrix = e1.bc(), this.viewportMatrix = e1.bc(), this.circles = [];
            }
        }
        class wi {
            constructor(e1, t1, i, o, r){
                this.bucketInstanceId = e1, this.featureIndex = t1, this.sourceLayerIndex = i, this.bucketIndex = o, this.tileID = r;
            }
        }
        class Ti {
            constructor(e1){
                this.crossSourceCollisions = e1, this.maxGroupID = 0, this.collisionGroups = {};
            }
            get(e1) {
                if (this.crossSourceCollisions) return {
                    ID: 0,
                    predicate: null
                };
                if (!this.collisionGroups[e1]) {
                    const t1 = ++this.maxGroupID;
                    this.collisionGroups[e1] = {
                        ID: t1,
                        predicate: (e1)=>e1.collisionGroupID === t1
                    };
                }
                return this.collisionGroups[e1];
            }
        }
        function Ei(t1, i, o, r, n) {
            const { horizontalAlign: s, verticalAlign: a } = e1.bG(t1), l = -(s - .5) * i, c = -(a - .5) * o, h = e1.bH(t1, r);
            return new e1.P(l + h[0] * n, c + h[1] * n);
        }
        function Si(t1, i, o, r, n) {
            const s = new e1.P(t1, i);
            return o && s._rotate(r ? n : -n), s;
        }
        class Ci {
            constructor(e1, t1, i, o, r, n){
                this.transform = e1.clone(), this.projection = e1.projection.name, this.collisionIndex = new gi(this.transform, r), this.buildingIndex = n, this.frontCutoffStart = 0, this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = t1, this.retainedQueryData = {}, this.collisionGroups = new Ti(i), this.collisionCircleArrays = {}, this.prevPlacement = o, o && (o.prevPlacement = void 0), this.placedOrientations = {}, this.lastReplacementSourceUpdateTime = 0;
            }
            getBucketParts(t1, i, o, r, n = 1) {
                const s = o.getBucket(i), a = o.latestFeatureIndex;
                if (!s || !a || i.fqid !== s.layerIds[0]) return;
                const l = s.layers[0].layout, c = s.layers[0].paint, h = o.collisionBoxArray, d = Math.pow(2, this.transform.zoom - o.tileID.overscaledZ), _ = o.tileSize / e1.an, u = o.tileID.toUnwrapped();
                this.transform.setProjection(s.projection);
                const p = (f = o.tileID, m = s.getProjection(), g = this.transform, m.name === this.projection ? g.calculateProjMatrix(f.toUnwrapped()) : Xt(g, m, f));
                var f, m, g;
                const v = "map" === l.get("text-pitch-alignment"), y = "map" === l.get("text-rotation-alignment");
                i.compileFilter(i.options);
                const x = i.dynamicFilter(), b = i.dynamicFilterNeedsFeature(), w = i.dynamicFilterNeedsGeometry(), T = this.transform.calculatePixelsToTileUnitsMatrix(o), E = ii(p, o.tileID.canonical, v, y, this.transform, s.getProjection(), T);
                let S = null;
                const C = s.getProjection().createInversionMatrix(this.transform, o.tileID.canonical);
                if (v) {
                    const t1 = oi(p, o.tileID.canonical, v, y, this.transform, s.getProjection(), T);
                    S = e1.aD([], this.transform.labelPlaneMatrix, t1);
                }
                let I = null;
                x && o.latestFeatureIndex && (I = {
                    unwrappedTileID: u,
                    dynamicFilter: x,
                    dynamicFilterNeedsFeature: b,
                    needGeometry: w
                }), this.retainedQueryData[s.bucketInstanceId] = new wi(s.bucketInstanceId, a, s.sourceLayerIndex, s.index, o.tileID);
                const [R, D] = s.layers[0].layout.get("text-size-scale-range"), A = e1.aC(n, R, D), [L, P] = l.get("icon-size-scale-range"), O = e1.aC(n, L, P), M = {
                    bucket: s,
                    layout: l,
                    paint: c,
                    posMatrix: p,
                    invMatrix: C,
                    mercatorCenter: [
                        e1.aH(this.transform.center.lng),
                        e1.aL(this.transform.center.lat)
                    ],
                    textLabelPlaneMatrix: E,
                    labelToScreenMatrix: S,
                    clippingData: I,
                    scale: d,
                    textPixelRatio: _,
                    holdingForFade: o.holdingForFade(),
                    collisionBoxArray: h,
                    partiallyEvaluatedTextSize: e1.bk(s.textSizeData, this.transform.zoom, A),
                    partiallyEvaluatedIconSize: e1.bk(s.iconSizeData, this.transform.zoom, O),
                    collisionGroup: this.collisionGroups.get(s.sourceID),
                    latestFeatureIndex: o.latestFeatureIndex
                };
                if (r) for (const e1 of s.sortKeyRanges){
                    const { sortKey: i, symbolInstanceStart: o, symbolInstanceEnd: r } = e1;
                    t1.push({
                        sortKey: i,
                        symbolInstanceStart: o,
                        symbolInstanceEnd: r,
                        parameters: M
                    });
                }
                else t1.push({
                    symbolInstanceStart: 0,
                    symbolInstanceEnd: s.symbolInstances.length,
                    parameters: M
                });
            }
            attemptAnchorPlacement(e1, t1, i, o, r, n, s, a, l, c, h, d, _, u, p, f, m, g, v, y, x) {
                const { textOffset0: b, textOffset1: w, crossTileID: T } = p, E = [
                    b,
                    w
                ], S = Ei(e1, n, s, E, a), C = this.collisionIndex.placeCollisionBox(m, a, t1, i, o, r, Si(S.x, S.y, l, c, this.transform.angle), u, h, d, _.predicate);
                if (v) {
                    const e1 = m.getSymbolInstanceIconSize(x, this.transform.zoom, p.placedIconSymbolIndex);
                    if (0 === this.collisionIndex.placeCollisionBox(m, e1, v, i, o, r, Si(S.x, S.y, l, c, this.transform.angle), u, h, d, _.predicate).box.length) return;
                }
                if (C.box.length > 0) {
                    let t1;
                    return this.prevPlacement && this.prevPlacement.variableOffsets[T] && this.prevPlacement.placements[T] && this.prevPlacement.placements[T].text && (t1 = this.prevPlacement.variableOffsets[T].anchor), this.variableOffsets[T] = {
                        textOffset: E,
                        width: n,
                        height: s,
                        anchor: e1,
                        textScale: a,
                        prevAnchor: t1
                    }, this.markUsedJustification(m, e1, p, g), m.allowVerticalPlacement && (this.markUsedOrientation(m, g, p), this.placedOrientations[T] = g), {
                        shift: S,
                        placedGlyphBoxes: C
                    };
                }
            }
            placeLayerBucketPart(t1, i, o, r, n = 1) {
                const { bucket: s, layout: a, paint: l, posMatrix: c, textLabelPlaneMatrix: h, labelToScreenMatrix: d, clippingData: _, textPixelRatio: u, mercatorCenter: p, invMatrix: f, holdingForFade: m, collisionBoxArray: g, partiallyEvaluatedTextSize: v, partiallyEvaluatedIconSize: y, collisionGroup: x, latestFeatureIndex: b } = t1.parameters, w = a.get("text-optional"), T = a.get("icon-optional"), E = a.get("text-allow-overlap"), S = a.get("icon-allow-overlap"), C = "map" === a.get("text-rotation-alignment"), I = "map" === a.get("icon-rotation-alignment"), R = "map" === a.get("text-pitch-alignment"), D = l.get("symbol-z-offset"), A = "sea" === a.get("symbol-elevation-reference"), L = a.get("symbol-placement"), [P, O] = a.get("text-size-scale-range"), [M, z] = a.get("icon-size-scale-range"), F = e1.aC(n, P, O), B = e1.aC(n, M, z), k = a.get("text-variable-anchor"), N = C && "point" !== L, U = I && "point" !== L, V = k && s.hasTextData(), j = s.hasIconTextFit() && V && s.hasIconData();
                this.transform.setProjection(s.projection);
                const G = V || N, q = U || j;
                let Z = E && (S || !s.hasIconData() || T), H = S && (E || !s.hasTextData() || w);
                const W = !D.isConstant();
                !s.collisionArrays && g && s.deserializeCollisionBoxes(g), o && r && s.updateCollisionDebugBuffers(this.transform.zoom, g, F, B);
                const $ = (t1, r, n)=>{
                    const { crossTileID: l, numVerticalGlyphVertices: g } = t1;
                    let I = null;
                    if (_ && _.dynamicFilterNeedsFeature || W) {
                        const i = this.retainedQueryData[s.bucketInstanceId], o = b.loadFeature({
                            featureIndex: t1.featureIndex,
                            bucketIndex: i.bucketIndex,
                            sourceLayerIndex: i.sourceLayerIndex,
                            layoutVertexArrayOffset: 0
                        }), r = o.properties ? o.properties.worldview : null;
                        if (s.localizable && s.worldview && "string" == typeof r) {
                            if ("all" === r) o.properties.$localized = !0;
                            else {
                                if (!r.split(",").includes(s.worldview)) return;
                                o.properties.$localized = !0, o.properties.worldview = s.worldview;
                            }
                        }
                        I = _ && _.needGeometry ? e1.bE(o, !0) : o;
                    }
                    if (_ && !(0, _.dynamicFilter)({
                        zoom: this.transform.zoom,
                        pitch: this.transform.pitch,
                        worldview: s.worldview
                    }, I, this.retainedQueryData[s.bucketInstanceId].tileID.canonical, new e1.P(t1.tileAnchorX, t1.tileAnchorY), this.transform.calculateDistanceTileData(_.unwrappedTileID))) return this.placements[l] = new xi(!1, !1, !1, !0), void i.add(l);
                    const L = D.evaluate(I, {});
                    if ((t1.zOffset || 0) + (L || 0) > 0 && this.frontCutoffStart > 0) {
                        const o = 2 * this.frontCutoffStart - 1, r = [
                            t1.tileAnchorX,
                            t1.tileAnchorY,
                            0,
                            1
                        ], n = e1.aE(e1.bF(), r, c);
                        if (n[1] / n[3] < o) return this.placements[l] = new xi(!1, !1, !1, !0), void i.add(l);
                    }
                    if (i.has(l)) return;
                    if (m) return void (this.placements[l] = new xi(!1, !1, !1));
                    let P = !1, O = !1, M = !0, z = !1, F = !1, B = null, N = {
                        box: null,
                        offscreen: null,
                        occluded: null
                    }, U = {
                        box: null
                    }, V = null, j = null, $ = null, X = 0, Y = 0, K = 0;
                    n.textFeatureIndex ? X = n.textFeatureIndex : t1.useRuntimeCollisionCircles && (X = t1.featureIndex), n.verticalTextFeatureIndex && (Y = n.verticalTextFeatureIndex);
                    const Q = s.elevationFeatures ? s.elevationFeatures[t1.elevationFeatureIndex] : void 0, J = (i)=>{
                        i.tileID = this.retainedQueryData[s.bucketInstanceId].tileID;
                        const o = this.transform.elevation;
                        i.elevation = A ? L : L + e1.bv.getAtTileOffset(i.tileID, new e1.P(i.tileAnchorX, i.tileAnchorY), o, Q), i.elevation += t1.zOffset;
                    }, ee = n.textBox;
                    if (ee) {
                        J(ee);
                        const i = (i)=>{
                            let o = e1.bl.horizontal;
                            if (s.allowVerticalPlacement && !i && this.prevPlacement) {
                                const e1 = this.prevPlacement.placedOrientations[l];
                                e1 && (this.placedOrientations[l] = e1, o = e1, this.markUsedOrientation(s, o, t1));
                            }
                            return o;
                        }, o = (t1, i)=>{
                            if (s.allowVerticalPlacement && g > 0 && n.verticalTextBox) {
                                for (const o of s.writingModes)if (o === e1.bl.vertical ? (N = i(), U = N) : N = t1(), N && N.box && N.box.length) break;
                            } else N = t1();
                        };
                        if (k) {
                            let a = k;
                            if (this.prevPlacement && this.prevPlacement.variableOffsets[l]) {
                                const e1 = this.prevPlacement.variableOffsets[l];
                                a.indexOf(e1.anchor) > 0 && (a = a.filter((t1)=>t1 !== e1.anchor), a.unshift(e1.anchor));
                            }
                            const h = (e1, i, o)=>{
                                const n = s.getSymbolInstanceTextSize(v, t1, this.transform.zoom, r), l = (e1.x2 - e1.x1) * n + 2 * e1.padding, h = (e1.y2 - e1.y1) * n + 2 * e1.padding, d = t1.hasIconTextFit && !S ? i : null;
                                d && J(d);
                                let _ = {
                                    box: [],
                                    offscreen: !1,
                                    occluded: !1
                                };
                                const m = E ? 2 * a.length : a.length;
                                for(let i = 0; i < m; ++i){
                                    const m = this.attemptAnchorPlacement(a[i % a.length], e1, p, f, G, l, h, n, C, R, u, c, x, i >= a.length, t1, r, s, o, d, v, y);
                                    if (m && (_ = m.placedGlyphBoxes, _ && _.box && _.box.length)) {
                                        P = !0, B = m.shift;
                                        break;
                                    }
                                }
                                return _;
                            };
                            o(()=>h(ee, n.iconBox, e1.bl.horizontal), ()=>{
                                const t1 = n.verticalTextBox;
                                return t1 && J(t1), s.allowVerticalPlacement && !(N && N.box && N.box.length) && g > 0 && t1 ? h(t1, n.verticalIconBox, e1.bl.vertical) : {
                                    box: null,
                                    offscreen: null,
                                    occluded: null
                                };
                            }), N && (P = N.box, M = N.offscreen, z = N.occluded);
                            const d = i(!(!N || !N.box));
                            if (!P && this.prevPlacement) {
                                const e1 = this.prevPlacement.variableOffsets[l];
                                e1 && (this.variableOffsets[l] = e1, this.markUsedJustification(s, e1.anchor, t1, d));
                            }
                        } else {
                            const a = (i, o)=>{
                                const n = s.getSymbolInstanceTextSize(v, t1, this.transform.zoom, r), a = this.collisionIndex.placeCollisionBox(s, n, i, p, f, G, new e1.P(0, 0), E, u, c, x.predicate);
                                return a && a.box && a.box.length && (this.markUsedOrientation(s, o, t1), this.placedOrientations[l] = o), a;
                            };
                            o(()=>a(ee, e1.bl.horizontal), ()=>{
                                const t1 = n.verticalTextBox;
                                return s.allowVerticalPlacement && g > 0 && t1 ? (J(t1), a(t1, e1.bl.vertical)) : {
                                    box: null,
                                    offscreen: null,
                                    occluded: null
                                };
                            }), i(!!(N && N.box && N.box.length));
                        }
                    }
                    if (V = N, P = V && V.box && V.box.length > 0, M = V && V.offscreen, z = V && V.occluded, t1.useRuntimeCollisionCircles) {
                        const i = t1.centerJustifiedTextSymbolIndex >= 0 ? t1.centerJustifiedTextSymbolIndex : t1.verticalPlacedTextSymbolIndex, r = s.text.placedSymbolArray.get(i), n = e1.bm(s.textSizeData, v, r), l = a.get("text-padding");
                        j = this.collisionIndex.placeCollisionCircles(s, E, r, i, s.lineVertexArray, s.glyphOffsetArray, n, c, h, d, o, R, x.predicate, t1.collisionCircleDiameter * n / e1.bz, l, this.retainedQueryData[s.bucketInstanceId].tileID), P = E || j.circles.length > 0 && !j.collisionDetected, M = M && j.offscreen, z = j.occluded;
                    }
                    if (n.iconFeatureIndex && (K = n.iconFeatureIndex), n.iconBox) {
                        const i = (i)=>{
                            J(i);
                            const o = t1.hasIconTextFit && B ? Si(B.x, B.y, C, R, this.transform.angle) : new e1.P(0, 0), r = s.getSymbolInstanceIconSize(y, this.transform.zoom, t1.placedIconSymbolIndex);
                            return this.collisionIndex.placeCollisionBox(s, r, i, p, f, q, o, S, u, c, x.predicate);
                        };
                        U && U.box && U.box.length && n.verticalIconBox ? ($ = i(n.verticalIconBox), O = $.box.length > 0) : ($ = i(n.iconBox), O = $.box.length > 0), M = M && $.offscreen, F = $.occluded;
                    }
                    const te = w || 0 === t1.numHorizontalGlyphVertices && 0 === g, ie = T || 0 === t1.numIconVertices;
                    if (te || ie ? ie ? te || (O = O && P) : P = O && P : O = P = O && P, P && V && V.box && this.collisionIndex.insertCollisionBox(V.box, a.get("text-ignore-placement"), s.bucketInstanceId, U && U.box && Y ? Y : X, x.ID), O && $ && this.collisionIndex.insertCollisionBox($.box, a.get("icon-ignore-placement"), s.bucketInstanceId, K, x.ID), j && (P && this.collisionIndex.insertCollisionCircles(j.circles, a.get("text-ignore-placement"), s.bucketInstanceId, X, x.ID), o)) {
                        const e1 = s.bucketInstanceId;
                        let t1 = this.collisionCircleArrays[e1];
                        void 0 === t1 && (t1 = this.collisionCircleArrays[e1] = new bi);
                        for(let e1 = 0; e1 < j.circles.length; e1 += 4)t1.circles.push(j.circles[e1 + 0]), t1.circles.push(j.circles[e1 + 1]), t1.circles.push(j.circles[e1 + 2]), t1.circles.push(j.collisionDetected ? 1 : 0);
                    }
                    const oe = "globe" !== s.projection.name;
                    Z = Z && (oe || !z), H = H && (oe || !F), this.placements[l] = new xi(P || Z, O || H, M || s.justReloaded), i.add(l);
                }, X = this.retainedQueryData[s.bucketInstanceId].tileID;
                if ("offset" === s.elevationType && this.buildingIndex && this.buildingIndex.updateZOffset(s, X), "road" === s.elevationType && s.updateRoadElevation(X.canonical), s.updateZOffset(), s.sortFeaturesByY) {
                    const t1 = s.getSortedSymbolIndexes(this.transform.angle);
                    for(let e1 = t1.length - 1; e1 >= 0; --e1){
                        const i = t1[e1];
                        $(s.symbolInstances.get(i), i, s.collisionArrays[i]);
                    }
                    s.hasAnyZOffset && e1.w(`${s.layerIds[0]} layer symbol-z-elevate: symbols are not sorted by elevation if symbol-z-order is evaluated to viewport-y`);
                } else if (s.hasAnyZOffset) {
                    const e1 = s.getSortedIndexesByZOffset();
                    for(let t1 = 0; t1 < e1.length; ++t1){
                        const i = e1[t1];
                        $(s.symbolInstances.get(i), i, s.collisionArrays[i]);
                    }
                } else for(let e1 = t1.symbolInstanceStart; e1 < t1.symbolInstanceEnd; e1++)$(s.symbolInstances.get(e1), e1, s.collisionArrays[e1]);
                if (o && s.bucketInstanceId in this.collisionCircleArrays) {
                    const t1 = this.collisionCircleArrays[s.bucketInstanceId];
                    e1.b8(t1.invProjMatrix, c), t1.viewportMatrix = this.collisionIndex.getViewportMatrix();
                }
                s.justReloaded = !1;
            }
            markUsedJustification(t1, i, o, r) {
                const { leftJustifiedTextSymbolIndex: n, centerJustifiedTextSymbolIndex: s, rightJustifiedTextSymbolIndex: a, verticalPlacedTextSymbolIndex: l, crossTileID: c } = o, h = e1.bI(i), d = r === e1.bl.vertical ? l : "left" === h ? n : "center" === h ? s : "right" === h ? a : -1;
                n >= 0 && (t1.text.placedSymbolArray.get(n).crossTileID = d >= 0 && n !== d ? 0 : c), s >= 0 && (t1.text.placedSymbolArray.get(s).crossTileID = d >= 0 && s !== d ? 0 : c), a >= 0 && (t1.text.placedSymbolArray.get(a).crossTileID = d >= 0 && a !== d ? 0 : c), l >= 0 && (t1.text.placedSymbolArray.get(l).crossTileID = d >= 0 && l !== d ? 0 : c);
            }
            markUsedOrientation(t1, i, o) {
                const r = i === e1.bl.horizontal || i === e1.bl.horizontalOnly ? i : 0, n = i === e1.bl.vertical ? i : 0, { leftJustifiedTextSymbolIndex: s, centerJustifiedTextSymbolIndex: a, rightJustifiedTextSymbolIndex: l, verticalPlacedTextSymbolIndex: c } = o, h = t1.text.placedSymbolArray;
                s >= 0 && (h.get(s).placedOrientation = r), a >= 0 && (h.get(a).placedOrientation = r), l >= 0 && (h.get(l).placedOrientation = r), c >= 0 && (h.get(c).placedOrientation = n);
            }
            commit(e1) {
                this.commitTime = e1, this.zoomAtLastRecencyCheck = this.transform.zoom;
                const t1 = this.prevPlacement;
                let i = !1;
                this.prevZoomAdjustment = t1 ? t1.zoomAdjustment(this.transform.zoom) : 0;
                const o = t1 ? t1.symbolFadeChange(e1) : 1, r = t1 ? t1.opacities : {}, n = t1 ? t1.variableOffsets : {}, s = t1 ? t1.placedOrientations : {};
                for(const e1 in this.placements){
                    const t1 = this.placements[e1], n = r[e1];
                    n ? (this.opacities[e1] = new yi(n, o, t1.text, t1.icon, null, t1.clipped), i = i || t1.text !== n.text.placed || t1.icon !== n.icon.placed) : (this.opacities[e1] = new yi(null, o, t1.text, t1.icon, t1.skipFade, t1.clipped), i = i || t1.text || t1.icon);
                }
                for(const e1 in r){
                    const t1 = r[e1];
                    if (!this.opacities[e1]) {
                        const r = new yi(t1, o, !1, !1);
                        r.isHidden() || (this.opacities[e1] = r, i = i || t1.text.placed || t1.icon.placed);
                    }
                }
                for(const e1 in n)this.variableOffsets[e1] || !this.opacities[e1] || this.opacities[e1].isHidden() || (this.variableOffsets[e1] = n[e1]);
                for(const e1 in s)this.placedOrientations[e1] || !this.opacities[e1] || this.opacities[e1].isHidden() || (this.placedOrientations[e1] = s[e1]);
                i ? this.lastPlacementChangeTime = e1 : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = t1 ? t1.lastPlacementChangeTime : e1);
            }
            updateLayerOpacities(e1, t1, i, o) {
                o && (this.lastReplacementSourceUpdateTime = o.updateTime);
                const r = new Set;
                for (const n of t1){
                    const t1 = n.getBucket(e1);
                    t1 && n.latestFeatureIndex && e1.fqid === t1.layerIds[0] && (this.updateBucketOpacities(t1, r, n, n.collisionBoxArray, i, o, n.tileID, e1.scope), "offset" === t1.elevationType && this.buildingIndex && this.buildingIndex.updateZOffset(t1, n.tileID), "road" === t1.elevationType && t1.updateRoadElevation(n.tileID.canonical), t1.updateZOffset());
                }
            }
            updateBucketOpacities(t1, i, o, r, n, s, a, l) {
                t1.hasTextData() && t1.text.opacityVertexArray.clear(), t1.hasIconData() && t1.icon.opacityVertexArray.clear(), t1.hasIconCollisionBoxData() && t1.iconCollisionBox.collisionVertexArray.clear(), t1.hasTextCollisionBoxData() && t1.textCollisionBox.collisionVertexArray.clear();
                const c = t1.layers[0].layout, h = t1.layers[0].paint, d = !!t1.layers[0].dynamicFilter(), _ = new yi(null, 0, !1, !1, !0), u = c.get("text-allow-overlap"), p = c.get("icon-allow-overlap"), f = c.get("text-variable-anchor"), m = "map" === c.get("text-rotation-alignment"), g = "map" === c.get("text-pitch-alignment"), v = h.get("symbol-z-offset"), y = "sea" === c.get("symbol-elevation-reference"), x = !v.isConstant(), b = new yi(null, 0, u && (p || !t1.hasIconData() || c.get("icon-optional")), p && (u || !t1.hasTextData() || c.get("text-optional")), !0);
                !t1.collisionArrays && r && (t1.hasIconCollisionBoxData() || t1.hasTextCollisionBoxData()) && t1.deserializeCollisionBoxes(r);
                const w = (e1, t1, i)=>{
                    for(let o = 0; o < t1 / 4; o++)e1.opacityVertexArray.emplaceBack(i);
                };
                let T = 0;
                s && t1.updateReplacement(a, s), this.collisionIndex.clearClippedSymbolsForBucket(t1.bucketInstanceId);
                for(let r = 0; r < t1.symbolInstances.length; r++){
                    const c = t1.symbolInstances.get(r), { numHorizontalGlyphVertices: h, numVerticalGlyphVertices: u, crossTileID: p, numIconVertices: E, tileAnchorX: S, tileAnchorY: C } = c;
                    let I = null;
                    const R = this.retainedQueryData[t1.bucketInstanceId];
                    x && c && R && (I = o.latestFeatureIndex.loadFeature({
                        featureIndex: c.featureIndex,
                        bucketIndex: R.bucketIndex,
                        sourceLayerIndex: R.sourceLayerIndex,
                        layoutVertexArrayOffset: 0
                    }));
                    const D = v.evaluate(I, {}), A = i.has(p);
                    let L = this.opacities[p];
                    A ? L = _ : L || (L = b, this.opacities[p] = L), i.add(p);
                    const P = h > 0 || u > 0, O = E > 0, M = this.placedOrientations[p], z = M === e1.bl.vertical, F = M === e1.bl.horizontal || M === e1.bl.horizontalOnly;
                    !P && !O || L.isHidden() || T++;
                    let B = !1;
                    if ((P || O) && s) for (const i of t1.activeReplacements){
                        if (e1.bA(i, n, e1.bB.Symbol, l)) continue;
                        if (i.min.x > S || S > i.max.x || i.min.y > C || C > i.max.y) continue;
                        const t1 = e1.bC(S, C, a.canonical, i.footprintTileId.canonical);
                        if (B = e1.bD(t1, i.footprint), B) break;
                    }
                    if (B && this.collisionIndex.markSymbolAsClipped(t1.bucketInstanceId, c.featureIndex), P) {
                        const e1 = B ? Fi : zi(L.text);
                        w(t1.text, h, z ? Fi : e1), w(t1.text, u, F ? Fi : e1);
                        const i = L.text.isHidden(), { leftJustifiedTextSymbolIndex: o, centerJustifiedTextSymbolIndex: r, rightJustifiedTextSymbolIndex: n, verticalPlacedTextSymbolIndex: s } = c, a = t1.text.placedSymbolArray, l = i || z ? 1 : 0;
                        o >= 0 && (a.get(o).hidden = l), r >= 0 && (a.get(r).hidden = l), n >= 0 && (a.get(n).hidden = l), s >= 0 && (a.get(s).hidden = i || F ? 1 : 0);
                        const d = this.variableOffsets[p];
                        d && this.markUsedJustification(t1, d.anchor, c, M);
                        const _ = this.placedOrientations[p];
                        _ && (this.markUsedJustification(t1, "left", c, _), this.markUsedOrientation(t1, _, c));
                    }
                    if (O) {
                        const e1 = B ? Fi : zi(L.icon), { placedIconSymbolIndex: i, verticalPlacedIconSymbolIndex: o } = c, r = t1.icon.placedSymbolArray, n = L.icon.isHidden() ? 1 : 0;
                        i >= 0 && (w(t1.icon, E, z ? Fi : e1), r.get(i).hidden = n), o >= 0 && (w(t1.icon, c.numVerticalIconVertices, F ? Fi : e1), r.get(o).hidden = n);
                    }
                    if (t1.hasIconCollisionBoxData() || t1.hasTextCollisionBoxData()) {
                        const i = t1.collisionArrays[r];
                        if (i) {
                            let o = new e1.P(0, 0), r = !0;
                            if (i.textBox || i.verticalTextBox) {
                                if (f) {
                                    const e1 = this.variableOffsets[p];
                                    e1 ? (o = Ei(e1.anchor, e1.width, e1.height, e1.textOffset, e1.textScale), m && o._rotate(g ? this.transform.angle : -this.transform.angle)) : r = !1;
                                }
                                d && (r = !L.clipped), i.textBox && Ii(t1.textCollisionBox.collisionVertexArray, L.text.placed, !r || z, D, y, o.x, o.y), i.verticalTextBox && Ii(t1.textCollisionBox.collisionVertexArray, L.text.placed, !r || F, D, y, o.x, o.y);
                            }
                            const n = r && Boolean(!F && i.verticalIconBox);
                            i.iconBox && Ii(t1.iconCollisionBox.collisionVertexArray, L.icon.placed, n, D, y, c.hasIconTextFit ? o.x : 0, c.hasIconTextFit ? o.y : 0), i.verticalIconBox && Ii(t1.iconCollisionBox.collisionVertexArray, L.icon.placed, !n, D, y, c.hasIconTextFit ? o.x : 0, c.hasIconTextFit ? o.y : 0);
                        }
                    }
                }
                if (t1.fullyClipped = 0 === T, t1.sortFeatures(this.transform.angle), this.retainedQueryData[t1.bucketInstanceId] && (this.retainedQueryData[t1.bucketInstanceId].featureSortOrder = t1.featureSortOrder), t1.hasTextData() && t1.text.opacityVertexBuffer && t1.text.opacityVertexBuffer.updateData(t1.text.opacityVertexArray), t1.hasIconData() && t1.icon.opacityVertexBuffer && t1.icon.opacityVertexBuffer.updateData(t1.icon.opacityVertexArray), t1.hasIconCollisionBoxData() && t1.iconCollisionBox.collisionVertexBuffer && t1.iconCollisionBox.collisionVertexBuffer.updateData(t1.iconCollisionBox.collisionVertexArray), t1.hasTextCollisionBoxData() && t1.textCollisionBox.collisionVertexBuffer && t1.textCollisionBox.collisionVertexBuffer.updateData(t1.textCollisionBox.collisionVertexArray), t1.bucketInstanceId in this.collisionCircleArrays) {
                    const e1 = this.collisionCircleArrays[t1.bucketInstanceId];
                    t1.placementInvProjMatrix = e1.invProjMatrix, t1.placementViewportMatrix = e1.viewportMatrix, t1.collisionCircleArray = e1.circles, delete this.collisionCircleArrays[t1.bucketInstanceId];
                }
            }
            symbolFadeChange(e1) {
                return 0 === this.fadeDuration ? 1 : (e1 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
            }
            zoomAdjustment(e1) {
                return Math.max(0, (this.transform.zoom - e1) / 1.5);
            }
            hasTransitions(e1) {
                return e1 - this.lastPlacementChangeTime < this.fadeDuration;
            }
            stillRecent(e1, t1) {
                const i = this.zoomAtLastRecencyCheck === t1 ? 1 - this.zoomAdjustment(t1) : 1;
                return this.zoomAtLastRecencyCheck = t1, this.commitTime + this.fadeDuration * i > e1;
            }
            isStale() {
                return this.stale;
            }
            setStale() {
                this.stale = !0;
            }
        }
        function Ii(e1, t1, i, o, r, n, s) {
            e1.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, n || 0, s || 0, o, r ? 1 : 0), e1.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, n || 0, s || 0, o, r ? 1 : 0), e1.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, n || 0, s || 0, o, r ? 1 : 0), e1.emplaceBack(t1 ? 1 : 0, i ? 1 : 0, n || 0, s || 0, o, r ? 1 : 0);
        }
        const Ri = Math.pow(2, 25), Di = Math.pow(2, 24), Ai = Math.pow(2, 17), Li = Math.pow(2, 16), Pi = Math.pow(2, 9), Oi = Math.pow(2, 8), Mi = Math.pow(2, 1);
        function zi(e1) {
            if (0 === e1.opacity && !e1.placed) return 0;
            if (1 === e1.opacity && e1.placed) return 4294967295;
            const t1 = e1.placed ? 1 : 0, i = Math.floor(127 * e1.opacity);
            return i * Ri + t1 * Di + i * Ai + t1 * Li + i * Pi + t1 * Oi + i * Mi + t1;
        }
        const Fi = 0;
        class Bi {
            constructor(e1){
                this._sortAcrossTiles = "viewport-y" !== e1.layout.get("symbol-z-order") && void 0 !== e1.layout.get("symbol-sort-key").constantOr(1), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = new Set, this._bucketParts = [];
            }
            continuePlacement(e1, t1, i, o, r, n) {
                const s = this._bucketParts;
                for(; this._currentTileIndex < e1.length;)if (t1.getBucketParts(s, o, e1[this._currentTileIndex], this._sortAcrossTiles, n), this._currentTileIndex++, r()) return !0;
                for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, s.sort((e1, t1)=>e1.sortKey - t1.sortKey)); this._currentPartIndex < s.length;){
                    const e1 = s[this._currentPartIndex];
                    if (t1.placeLayerBucketPart(e1, this._seenCrossTileIDs, i, 0 === e1.symbolInstanceStart, n), this._currentPartIndex++, r()) return !0;
                }
                return !1;
            }
        }
        class ki {
            startNewPlacement(e1, t1, i, o, r, n, s, a) {
                return this.placement = new Ci(e1, o, r, n, s, a), this._currentPlacementIndex = t1.length - 1, this._forceFullPlacement = !1, this._showCollisionBoxes = i, this._fadeDuration = o, this._done = !1, this._inProgressLayer = null, this;
            }
            requestFullPlacement() {
                this._forceFullPlacement = !0;
            }
            isFullPlacementRequested() {
                return this._forceFullPlacement;
            }
            setStale() {
                this.placement && (this.placement.stale = !0);
            }
            isStale() {
                return !!this.placement && this.placement.stale;
            }
            isDone() {
                return this._done;
            }
            continuePlacement(t1, i, o, r, n) {
                const s = e1.o.now(), a = ()=>{
                    const t1 = e1.o.now() - s;
                    return !this.isFullPlacementRequested() && 0 !== this._fadeDuration && t1 > 2;
                };
                for(; this._currentPlacementIndex >= 0;){
                    const s = i[t1[this._currentPlacementIndex]], l = this.placement.collisionIndex.transform.zoom;
                    if ("symbol" === s.type && "none" !== s.visibility && (!s.minzoom || s.minzoom <= l) && (!s.maxzoom || s.maxzoom > l)) {
                        const t1 = s, i = t1.layout.get("symbol-z-elevate"), l = void 0 !== t1.layout.get("symbol-sort-key").constantOr(1), c = t1.layout.get("symbol-z-order"), h = "viewport-y" === c || "auto" === c && !("viewport-y" !== c && l), d = t1.layout.get("text-allow-overlap") || t1.layout.get("icon-allow-overlap") || t1.layout.get("text-ignore-placement") || t1.layout.get("icon-ignore-placement"), _ = h && d, u = this._inProgressLayer = this._inProgressLayer || new Bi(t1), p = e1.F(s.source, s.scope);
                        if (u.continuePlacement(i || _ ? r[p] : o[p], this.placement, this._showCollisionBoxes, s, a, n)) return;
                        delete this._inProgressLayer;
                    }
                    this._currentPlacementIndex--;
                }
                this._forceFullPlacement = !1, this._done = !0;
            }
            commit(e1) {
                return this.placement.commit(e1), this.placement;
            }
        }
        const Ni = 512 / e1.an / 2;
        class Ui {
            constructor(t1, i, o){
                this.tileID = t1, this.bucketInstanceId = o, this.index = new e1.bJ(i.length, 16, Int32Array), this.keys = [], this.crossTileIDs = [];
                const r = t1.canonical.x * e1.an, n = t1.canonical.y * e1.an;
                for(let e1 = 0; e1 < i.length; e1++){
                    const { key: t1, crossTileID: o, tileAnchorX: s, tileAnchorY: a } = i.get(e1), l = Math.floor((r + s) * Ni), c = Math.floor((n + a) * Ni);
                    this.index.add(l, c), this.keys.push(t1), this.crossTileIDs.push(o);
                }
                this.index.finish();
            }
            findMatches(t1, i, o) {
                const r = this.tileID.canonical.z < i.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - i.canonical.z), n = Ni / Math.pow(2, i.canonical.z - this.tileID.canonical.z), s = i.canonical.x * e1.an, a = i.canonical.y * e1.an;
                for(let e1 = 0; e1 < t1.length; e1++){
                    const i = t1.get(e1);
                    if (i.crossTileID) continue;
                    const { key: l, tileAnchorX: c, tileAnchorY: h } = i, d = Math.floor((s + c) * n), _ = Math.floor((a + h) * n), u = this.index.range(d - r, _ - r, d + r, _ + r).sort((e1, t1)=>e1 - t1);
                    for (const e1 of u){
                        const t1 = this.crossTileIDs[e1];
                        if (this.keys[e1] === l && !o.has(t1)) {
                            o.add(t1), i.crossTileID = t1;
                            break;
                        }
                    }
                }
            }
        }
        class Vi {
            constructor(){
                this.maxCrossTileID = 0;
            }
            generate() {
                return ++this.maxCrossTileID;
            }
        }
        class ji {
            constructor(){
                this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
            }
            handleWrapJump(e1) {
                const t1 = Math.round((e1 - this.lng) / 360);
                if (0 !== t1) for(const e1 in this.indexes){
                    const i = this.indexes[e1], o = {};
                    for(const e1 in i){
                        const r = i[e1];
                        r.tileID = r.tileID.unwrapTo(r.tileID.wrap + t1), o[r.tileID.key] = r;
                    }
                    this.indexes[e1] = o;
                }
                this.lng = e1;
            }
            addBucket(e1, t1, i) {
                if (this.indexes[e1.overscaledZ] && this.indexes[e1.overscaledZ][e1.key]) {
                    if (this.indexes[e1.overscaledZ][e1.key].bucketInstanceId === t1.bucketInstanceId) return !1;
                    this.removeBucketCrossTileIDs(e1.overscaledZ, this.indexes[e1.overscaledZ][e1.key]);
                }
                for(let e1 = 0; e1 < t1.symbolInstances.length; e1++)t1.symbolInstances.get(e1).crossTileID = 0;
                this.usedCrossTileIDs[e1.overscaledZ] || (this.usedCrossTileIDs[e1.overscaledZ] = new Set);
                const o = this.usedCrossTileIDs[e1.overscaledZ];
                for(const i in this.indexes){
                    const r = this.indexes[i];
                    if (Number(i) > e1.overscaledZ) for(const i in r){
                        const n = r[i];
                        n.tileID.isChildOf(e1) && n.findMatches(t1.symbolInstances, e1, o);
                    }
                    else {
                        const n = r[e1.scaledTo(Number(i)).key];
                        n && n.findMatches(t1.symbolInstances, e1, o);
                    }
                }
                for(let e1 = 0; e1 < t1.symbolInstances.length; e1++){
                    const r = t1.symbolInstances.get(e1);
                    r.crossTileID || (r.crossTileID = i.generate(), o.add(r.crossTileID));
                }
                return void 0 === this.indexes[e1.overscaledZ] && (this.indexes[e1.overscaledZ] = {}), this.indexes[e1.overscaledZ][e1.key] = new Ui(e1, t1.symbolInstances, t1.bucketInstanceId), !0;
            }
            removeBucketCrossTileIDs(e1, t1) {
                for (const i of t1.crossTileIDs)this.usedCrossTileIDs[e1].delete(i);
            }
            removeStaleBuckets(e1) {
                let t1 = !1;
                for(const i in this.indexes){
                    const o = this.indexes[i];
                    for(const r in o)e1[o[r].bucketInstanceId] || (this.removeBucketCrossTileIDs(i, o[r]), delete o[r], t1 = !0);
                }
                return t1;
            }
        }
        class Gi {
            constructor(){
                this.layerIndexes = {}, this.crossTileIDs = new Vi, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
            }
            addLayer(e1, t1, i, o) {
                let r = this.layerIndexes[e1.fqid];
                void 0 === r && (r = this.layerIndexes[e1.fqid] = new ji);
                let n = !1;
                const s = {};
                "globe" !== o.name && r.handleWrapJump(i);
                for (const i of t1){
                    const t1 = i.getBucket(e1);
                    t1 && e1.fqid === t1.layerIds[0] && (t1.bucketInstanceId || (t1.bucketInstanceId = ++this.maxBucketInstanceId), r.addBucket(i.tileID, t1, this.crossTileIDs) && (n = !0), s[t1.bucketInstanceId] = !0);
                }
                return r.removeStaleBuckets(s) && (n = !0), n;
            }
            pruneUnusedLayers(e1) {
                const t1 = {};
                e1.forEach((e1)=>{
                    t1[e1] = !0;
                });
                for(const e1 in this.layerIndexes)t1[e1] || delete this.layerIndexes[e1];
            }
        }
        const qi = 771;
        class Zi {
            constructor(e1, t1, i, o){
                this.blendFunction = e1, this.blendColor = t1.toNonPremultipliedRenderColor(null), this.mask = i, this.blendEquation = o;
            }
        }
        Zi.Replace = [
            1,
            0,
            1,
            0
        ], Zi.disabled = new Zi(Zi.Replace, e1.aq.transparent, [
            !1,
            !1,
            !1,
            !1
        ]), Zi.unblended = new Zi(Zi.Replace, e1.aq.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Zi.alphaBlended = new Zi([
            1,
            qi,
            1,
            qi
        ], e1.aq.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Zi.alphaBlendedNonPremultiplied = new Zi([
            770,
            qi,
            770,
            qi
        ], e1.aq.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Zi.multiply = new Zi([
            774,
            0,
            774,
            0
        ], e1.aq.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Zi.multiplyAccumulateAlpha = new Zi([
            774,
            0,
            1,
            qi
        ], e1.aq.transparent, [
            !0,
            !0,
            !0,
            !0
        ]), Zi.additive = new Zi([
            1,
            1,
            1,
            1
        ], e1.aq.transparent, [
            !0,
            !0,
            !0,
            !0
        ]);
        class Hi {
            constructor(e1, t1, i){
                this.func = e1, this.mask = t1, this.range = i;
            }
        }
        Hi.ReadOnly = !1, Hi.ReadWrite = !0, Hi.disabled = new Hi(519, Hi.ReadOnly, [
            0,
            1
        ]);
        const Wi = 7680;
        class $i {
            constructor(e1, t1, i, o, r, n){
                this.test = e1, this.ref = t1, this.mask = i, this.fail = o, this.depthFail = r, this.pass = n;
            }
        }
        $i.disabled = new $i({
            func: 519,
            mask: 0
        }, 0, 0, Wi, Wi, Wi);
        const Xi = 1029, Yi = 2305;
        class Ki {
            constructor(e1, t1, i){
                this.enable = e1, this.mode = t1, this.frontFace = i;
            }
        }
        function Qi(t1, i) {
            const o = e1.bP(t1, 3);
            e1.bS(t1, i), e1.bX(t1, 3, o);
        }
        function Ji(t1, i) {
            const o = e1.bM([]);
            return e1.bN(o, o, -i), e1.bO(o, o, -t1), o;
        }
        function eo(t1, i) {
            const o = [
                t1[0],
                t1[1],
                0
            ], r = [
                i[0],
                i[1],
                0
            ];
            if (e1.ai(o) >= 1e-15) {
                const t1 = e1.ay([], o);
                e1.bK(r, t1, e1.bj(r, t1)), i[0] = r[0], i[1] = r[1];
            }
            const n = e1.bi([], i, t1);
            if (e1.bL(n) < 1e-15) return null;
            const s = Math.atan2(-n[1], n[0]);
            return Ji(Math.atan2(Math.sqrt(t1[0] * t1[0] + t1[1] * t1[1]), -t1[2]), s);
        }
        Ki.disabled = new Ki(!1, Xi, Yi), Ki.backCCW = new Ki(!0, Xi, Yi), Ki.backCW = new Ki(!0, Xi, 2304), Ki.frontCW = new Ki(!0, 1028, 2304), Ki.frontCCW = new Ki(!0, 1028, Yi);
        class to {
            constructor(e1, t1){
                this.position = e1, this.orientation = t1;
            }
            get position() {
                return this._position;
            }
            set position(t1) {
                if (t1) {
                    const i = t1 instanceof e1.ag ? t1 : new e1.ag(t1[0], t1[1], t1[2]);
                    this._renderWorldCopies && (i.x = e1.bt(i.x, 0, 1)), this._position = i;
                } else this._position = null;
            }
            lookAtPoint(t1, i, o) {
                if (this.orientation = null, !this.position) return;
                const r = this.position, n = o || (this._elevation ? this._elevation.getAtPointOrZero(e1.ag.fromLngLat(t1)) : 0), s = e1.ag.fromLngLat(t1, n), a = [
                    s.x - r.x,
                    s.y - r.y,
                    s.z - r.z
                ];
                i || (i = [
                    0,
                    0,
                    1
                ]), i[2] = Math.abs(i[2]), this.orientation = eo(a, i);
            }
            setPitchBearing(t1, i) {
                this.orientation = Ji(e1.ap(t1), e1.ap(-i));
            }
        }
        class io {
            constructor(t1, i){
                this._transform = e1.ba([]), this.orientation = i, this.position = t1;
            }
            get mercatorPosition() {
                const t1 = this.position;
                return new e1.ag(t1[0], t1[1], t1[2]);
            }
            get position() {
                const t1 = e1.bP(this._transform, 3);
                return [
                    t1[0],
                    t1[1],
                    t1[2]
                ];
            }
            set position(t1) {
                var i;
                t1 && e1.bX(this._transform, 3, [
                    (i = t1)[0],
                    i[1],
                    i[2],
                    1
                ]);
            }
            get orientation() {
                return this._orientation;
            }
            set orientation(t1) {
                this._orientation = t1 || e1.bM([]), t1 && Qi(this._transform, this._orientation);
            }
            getPitchBearing() {
                const e1 = this.forward(), t1 = this.right();
                return {
                    bearing: Math.atan2(-t1[1], t1[0]),
                    pitch: Math.atan2(Math.sqrt(e1[0] * e1[0] + e1[1] * e1[1]), -e1[2])
                };
            }
            setPitchBearing(e1, t1) {
                this._orientation = Ji(e1, t1), Qi(this._transform, this._orientation);
            }
            forward() {
                const t1 = e1.bP(this._transform, 2);
                return [
                    -t1[0],
                    -t1[1],
                    -t1[2]
                ];
            }
            up() {
                const t1 = e1.bP(this._transform, 1);
                return [
                    -t1[0],
                    -t1[1],
                    -t1[2]
                ];
            }
            right() {
                const t1 = e1.bP(this._transform, 0);
                return [
                    t1[0],
                    t1[1],
                    t1[2]
                ];
            }
            getCameraToWorld(t1, i) {
                const o = new Float64Array(16);
                return e1.b8(o, this.getWorldToCamera(t1, i)), o;
            }
            getCameraToWorldMercator() {
                return this._transform;
            }
            getWorldToCameraPosition(t1, i, o) {
                const r = this.position;
                e1.bK(r, r, -t1);
                const n = new Float64Array(16);
                return e1.bQ(n, [
                    o,
                    o,
                    o
                ]), e1.by(n, n, r), n[10] *= i, n;
            }
            getWorldToCamera(t1, i) {
                const o = new Float64Array(16), r = new Float64Array(4), n = this.position;
                return e1.bR(r, this._orientation), e1.bK(n, n, -t1), e1.bS(o, r), e1.by(o, o, n), o[1] *= -1, o[5] *= -1, o[9] *= -1, o[13] *= -1, o[8] *= i, o[9] *= i, o[10] *= i, o[11] *= i, o;
            }
            getCameraToClipPerspective(t1, i, o, r) {
                const n = new Float64Array(16);
                return e1.bT(n, t1, i, o, r), n;
            }
            getCameraToClipOrthographic(t1, i, o, r, n, s) {
                const a = new Float64Array(16);
                return e1.bU(a, t1, i, o, r, n, s), a;
            }
            getDistanceToElevation(t1, i = !1) {
                const o = 0 === t1 ? 0 : e1.bV(t1, i ? e1.bW(this.position[1]) : this.position[1]), r = this.forward();
                return (o - this.position[2]) / r[2];
            }
            clone() {
                return new io([
                    ...this.position
                ], [
                    ...this.orientation
                ]);
            }
        }
        const oo = (e1, t1)=>({
                u_matrix: e1,
                u_ground_shadow_factor: t1
            });
        class ro {
            constructor(e1 = 0, t1 = 0, i = 0, o = 0){
                if (isNaN(e1) || e1 < 0 || isNaN(t1) || t1 < 0 || isNaN(i) || i < 0 || isNaN(o) || o < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                this.top = e1, this.bottom = t1, this.left = i, this.right = o;
            }
            interpolate(t1, i, o) {
                return null != i.top && null != t1.top && (this.top = e1.am(t1.top, i.top, o)), null != i.bottom && null != t1.bottom && (this.bottom = e1.am(t1.bottom, i.bottom, o)), null != i.left && null != t1.left && (this.left = e1.am(t1.left, i.left, o)), null != i.right && null != t1.right && (this.right = e1.am(t1.right, i.right, o)), this;
            }
            getCenter(t1, i) {
                const o = e1.aC((this.left + t1 - this.right) / 2, 0, t1), r = e1.aC((this.top + i - this.bottom) / 2, 0, i);
                return new e1.P(o, r);
            }
            equals(e1) {
                return this.top === e1.top && this.bottom === e1.bottom && this.left === e1.left && this.right === e1.right;
            }
            clone() {
                return new ro(this.top, this.bottom, this.left, this.right);
            }
            toJSON() {
                return {
                    top: this.top,
                    bottom: this.bottom,
                    left: this.left,
                    right: this.right
                };
            }
        }
        const no = 15;
        class so {
            constructor(t1, i, o, r, n, s, a){
                this.tileSize = 512, this._renderWorldCopies = void 0 === n || n, this._minZoom = t1 || 0, this._maxZoom = i || 22, this._minPitch = o ?? 0, this._maxPitch = r ?? 60, this.setProjection(s), this.setMaxBounds(a), this.width = 0, this.height = 0, this._center = new e1.aV(0, 0), this.zoom = 0, this.angle = 0, this._fov = .6435011087932844, this._pitch = 0, this._nearZ = 0, this._farZ = 0, this._nearClipOffset = 0, this._unmodified = !0, this._edgeInsets = new ro, this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._fogTileMatrixCache = {}, this._expandedProjMatrixCache = {}, this._distanceTileDataCache = {}, this._camera = new io, this._centerAltitude = 0, this._averageElevation = 0, this.cameraElevationReference = "ground", this._pixelsPerMercatorPixel = 1, this.globeRadius = 0, this.globeCenterInViewSpace = [
                    0,
                    0,
                    0
                ], this._tileCoverLift = 0, this.freezeTileCoverage = !1, this._horizonShift = .1, this._orthographicProjectionAtLowPitch = !1, this._allowWorldUnderZoom = !1;
            }
            clone() {
                const e1 = new so(this._minZoom, this._maxZoom, this._minPitch, this.maxPitch, this._renderWorldCopies, this.getProjection(), this.maxBounds);
                return e1._elevation = this._elevation, e1._centerAltitude = this._centerAltitude, e1._centerAltitudeValidForExaggeration = this._centerAltitudeValidForExaggeration, e1.tileSize = this.tileSize, e1.mercatorFromTransition = this.mercatorFromTransition, e1.width = this.width, e1.height = this.height, e1.cameraElevationReference = this.cameraElevationReference, e1._center = this._center, e1._setZoom(this.zoom), e1._seaLevelZoom = this._seaLevelZoom, e1.angle = this.angle, e1._fov = this._fov, e1._pitch = this._pitch, e1._nearZ = this._nearZ, e1._farZ = this._farZ, e1._nearClipOffset = this._nearClipOffset, e1._averageElevation = this._averageElevation, e1._orthographicProjectionAtLowPitch = this._orthographicProjectionAtLowPitch, e1._unmodified = this._unmodified, e1._edgeInsets = this._edgeInsets.clone(), e1._camera = this._camera.clone(), e1._calcMatrices(), e1.freezeTileCoverage = this.freezeTileCoverage, e1.frustumCorners = this.frustumCorners, e1._allowWorldUnderZoom = this._allowWorldUnderZoom, e1;
            }
            get isOrthographic() {
                return "globe" !== this.projection.name && this._orthographicProjectionAtLowPitch && this.pitch < no;
            }
            get elevation() {
                return this._elevation;
            }
            set elevation(e1) {
                this._elevation !== e1 && (this._elevation = e1, this._updateCameraOnTerrain(), this._calcMatrices());
            }
            get nearClipOffset() {
                return this._nearClipOffset;
            }
            set nearClipOffset(e1) {
                this._nearClipOffset = e1, this._calcMatrices();
            }
            get depthOcclusionForSymbolsAndCircles() {
                return "globe" !== this.projection.name && !this.isOrthographic;
            }
            updateElevation(e1, t1 = !1) {
                const i = this._elevation && this._elevation.exaggeration() !== this._centerAltitudeValidForExaggeration;
                (null == this._seaLevelZoom || i) && this._updateCameraOnTerrain(), (e1 || i) && this._constrainCamera(t1), this._calcMatrices();
            }
            getProjection() {
                return e1.aJ(this.projection, [
                    "name",
                    "center",
                    "parallels"
                ]);
            }
            setProjection(t1) {
                this.projectionOptions = t1 || {
                    name: "mercator"
                };
                const i = this.projection ? this.getProjection() : void 0;
                this.projection = e1.c1(this.projectionOptions);
                const o = this.getProjection(), r = !e1.b7(i, o);
                return r && this._calcMatrices(), this.mercatorFromTransition = !1, r;
            }
            setOrthographicProjectionAtLowPitch(e1) {
                return this._orthographicProjectionAtLowPitch !== e1 && (this._orthographicProjectionAtLowPitch = e1, this._calcMatrices(), !0);
            }
            setMercatorFromTransition() {
                const t1 = this.projection.name;
                this.mercatorFromTransition = !0, this.projectionOptions = {
                    name: "mercator"
                }, this.projection = e1.c1({
                    name: "mercator"
                });
                const i = t1 !== this.projection.name;
                return i && this._calcMatrices(), i;
            }
            get minZoom() {
                return this._minZoom;
            }
            set minZoom(e1) {
                this._minZoom !== e1 && (this._minZoom = e1, this.zoom = Math.max(this.zoom, e1));
            }
            get maxZoom() {
                return this._maxZoom;
            }
            set maxZoom(e1) {
                this._maxZoom !== e1 && (this._maxZoom = e1, this.zoom = Math.min(this.zoom, e1));
            }
            get minPitch() {
                return this._minPitch;
            }
            set minPitch(e1) {
                this._minPitch !== e1 && (this._minPitch = e1, this.pitch = Math.max(this.pitch, e1));
            }
            get maxPitch() {
                return this._maxPitch;
            }
            set maxPitch(e1) {
                this._maxPitch !== e1 && (this._maxPitch = e1, this.pitch = Math.min(this.pitch, e1));
            }
            get renderWorldCopies() {
                return this._renderWorldCopies && !0 === this.projection.supportsWorldCopies;
            }
            set renderWorldCopies(e1) {
                void 0 === e1 ? e1 = !0 : null === e1 && (e1 = !1), this._renderWorldCopies = e1;
            }
            get worldSize() {
                return this.tileSize * this.scale;
            }
            get cameraWorldSizeForFog() {
                const e1 = Math.max(this._camera.getDistanceToElevation(this._averageElevation), Number.EPSILON);
                return this._worldSizeFromZoom(this._zoomFromMercatorZ(e1));
            }
            get cameraWorldSize() {
                const e1 = Math.max(this._camera.getDistanceToElevation(this._averageElevation, !0), Number.EPSILON);
                return this._worldSizeFromZoom(this._zoomFromMercatorZ(e1));
            }
            get pixelsPerMeter() {
                return this.projection.pixelsPerMeter(this.center.lat, this.worldSize);
            }
            get cameraPixelsPerMeter() {
                return e1.bV(1, this.center.lat) * this.cameraWorldSizeForFog;
            }
            get centerOffset() {
                return this.centerPoint._sub(this.size._div(2));
            }
            get size() {
                return new e1.P(this.width, this.height);
            }
            get bearing() {
                return e1.bt(this.rotation, -180, 180);
            }
            set bearing(e1) {
                this.rotation = e1;
            }
            get rotation() {
                return -this.angle / Math.PI * 180;
            }
            set rotation(t1) {
                const i = -t1 * Math.PI / 180;
                this.angle !== i && (this._unmodified = !1, this.angle = i, this._calcMatrices(), this.rotationMatrix = e1.c2(), e1.c3(this.rotationMatrix, this.rotationMatrix, this.angle));
            }
            get pitch() {
                return this._pitch / Math.PI * 180;
            }
            set pitch(t1) {
                const i = e1.aC(t1, this.minPitch, this.maxPitch) / 180 * Math.PI;
                this._pitch !== i && (this._unmodified = !1, this._pitch = i, this._calcMatrices());
            }
            get aspect() {
                return this.width / this.height;
            }
            get fov() {
                return this._fov / Math.PI * 180;
            }
            set fov(t1) {
                t1 = Math.max(.01, Math.min(60, t1)), this._fov !== t1 && (this._unmodified = !1, this._fov = e1.ap(t1), this._calcMatrices());
            }
            get fovX() {
                return this._fov;
            }
            get fovY() {
                const e1 = 1 / Math.tan(.5 * this.fovX);
                return 2 * Math.atan(1 / this.aspect / e1);
            }
            get averageElevation() {
                return this._averageElevation;
            }
            set averageElevation(e1) {
                this._averageElevation = e1, this._calcFogMatrices(), this._distanceTileDataCache = {};
            }
            get zoom() {
                return this._zoom;
            }
            set zoom(e1) {
                const t1 = Math.min(Math.max(e1, this.minZoom), this.maxZoom);
                this._zoom !== t1 && (this._unmodified = !1, this._setZoom(t1), this._updateSeaLevelZoom(), this._constrain(), this._calcMatrices());
            }
            _setZoom(e1) {
                this._zoom = e1, this.scale = this.zoomScale(e1), this.tileZoom = Math.floor(e1), this.zoomFraction = e1 - this.tileZoom;
            }
            get tileCoverLift() {
                return this._tileCoverLift;
            }
            set tileCoverLift(e1) {
                this._tileCoverLift !== e1 && (this._tileCoverLift = e1);
            }
            _updateCameraOnTerrain() {
                const e1 = this.elevation ? this.elevation.getAtPoint(this.locationCoordinate(this.center), Number.NEGATIVE_INFINITY) : Number.NEGATIVE_INFINITY, t1 = this.elevation && e1 === Number.NEGATIVE_INFINITY && this.elevation.visibleDemTiles.length > 0 && this.elevation.exaggeration() > 0 && this._centerAltitudeValidForExaggeration;
                if (!this._elevation || e1 === Number.NEGATIVE_INFINITY && (!t1 || !this._centerAltitude)) return this._centerAltitude = 0, this._seaLevelZoom = null, void (this._centerAltitudeValidForExaggeration = void 0);
                const i = this._elevation;
                t1 || this._centerAltitude && this._centerAltitudeValidForExaggeration && i.exaggeration() && this._centerAltitudeValidForExaggeration !== i.exaggeration() ? (this._centerAltitude = this._centerAltitude / this._centerAltitudeValidForExaggeration * i.exaggeration(), this._centerAltitudeValidForExaggeration = i.exaggeration()) : (this._centerAltitude = e1 || 0, this._centerAltitudeValidForExaggeration = i.exaggeration()), this._updateSeaLevelZoom();
            }
            _updateSeaLevelZoom() {
                if (void 0 === this._centerAltitudeValidForExaggeration) return;
                const e1 = Math.max(0, (this.pixelsPerMeter * this._centerAltitude + this.cameraToCenterDistance) / this.worldSize);
                this._seaLevelZoom = this._zoomFromMercatorZ(e1);
            }
            sampleAverageElevation() {
                if (!this._elevation) return 0;
                const t1 = this._elevation, i = [
                    [
                        .5,
                        .2
                    ],
                    [
                        .3,
                        .5
                    ],
                    [
                        .5,
                        .5
                    ],
                    [
                        .7,
                        .5
                    ],
                    [
                        .5,
                        .8
                    ]
                ], o = this.horizonLineFromTop();
                let r = 0, n = 0;
                for(let s = 0; s < i.length; s++){
                    const a = new e1.P(i[s][0] * this.width, o + i[s][1] * (this.height - o)), l = t1.pointCoordinate(a);
                    if (!l) continue;
                    const c = 1 / Math.hypot(l[0] - this._camera.position[0], l[1] - this._camera.position[1]);
                    r += l[3] * c, n += c;
                }
                return 0 === n ? NaN : r / n;
            }
            get center() {
                return this._center;
            }
            set center(e1) {
                e1.lat === this._center.lat && e1.lng === this._center.lng || (this._unmodified = !1, this._center = e1, this._terrainEnabled() && ("ground" === this.cameraElevationReference ? this._updateCameraOnTerrain() : this._updateZoomFromElevation()), this._constrain(), this._calcMatrices());
            }
            _updateZoomFromElevation() {
                if (null == this._seaLevelZoom || !this._elevation) return;
                const e1 = this._seaLevelZoom, t1 = this._elevation.getAtPointOrZero(this.locationCoordinate(this.center)), i = this.pixelsPerMeter / this.worldSize * t1, o = this._mercatorZfromZoom(e1), r = this._mercatorZfromZoom(this._maxZoom), n = Math.max(o - i, r);
                this._setZoom(this._zoomFromMercatorZ(n));
            }
            get padding() {
                return this._edgeInsets.toJSON();
            }
            set padding(e1) {
                this._edgeInsets.equals(e1) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, e1, 1), this._calcMatrices());
            }
            equals(e1) {
                const t1 = this.elevation, i = e1.elevation, o = null != t1 != (null != i) || t1 && i && t1.exaggeration() !== i.exaggeration();
                return this.width === e1.width && this.height === e1.height && this.center.lng === e1.center.lng && this.center.lat === e1.center.lat && this.zoom === e1.zoom && this.bearing === e1.bearing && this.pitch === e1.pitch && this.fov === e1.fov && this.projection.name === e1.projection.name && this._edgeInsets.equals(e1.padding) && !o;
            }
            computeZoomRelativeTo(t1) {
                const i = this.rayIntersectionCoordinate(this.pointRayIntersection(this.centerPoint, t1.toAltitude()));
                let o;
                o = t1.z < this._camera.position[2] ? [
                    i.x,
                    i.y,
                    i.z
                ] : [
                    t1.x,
                    t1.y,
                    t1.z
                ];
                const r = e1.ai(e1.ax([], this._camera.position, o));
                return e1.aC(this._zoomFromMercatorZ(r), this._minZoom, this._maxZoom);
            }
            setFreeCameraOptions(t1) {
                if (!this.height) return;
                if (!t1.position && !t1.orientation) return;
                this._updateCameraState();
                let i = !1;
                if (t1.orientation && !e1.c4(t1.orientation, this._camera.orientation) && (i = this._setCameraOrientation(t1.orientation)), t1.position) {
                    const o = [
                        t1.position.x,
                        t1.position.y,
                        t1.position.z
                    ];
                    e1.c5(o, this._camera.position) || (this._setCameraPosition(o), i = !0);
                }
                i && (this._updateStateFromCamera(), this.recenterOnTerrain());
            }
            getFreeCameraOptions() {
                this._updateCameraState();
                const t1 = this._camera.position, i = new to;
                return i.position = new e1.ag(t1[0], t1[1], t1[2]), i.orientation = this._camera.orientation, i._elevation = this.elevation, i._renderWorldCopies = this.renderWorldCopies, i;
            }
            _setCameraOrientation(t1) {
                if (!e1.c6(t1)) return !1;
                e1.c7(t1, t1);
                const i = e1.c8([], [
                    0,
                    0,
                    -1
                ], t1), o = e1.c8([], [
                    0,
                    -1,
                    0
                ], t1);
                if (o[2] < 0) return !1;
                const r = eo(i, o);
                return !!r && (this._camera.orientation = r, !0);
            }
            _setCameraPosition(t1) {
                const i = this.zoomScale(this.minZoom) * this.tileSize, o = this.zoomScale(this.maxZoom) * this.tileSize, r = this.cameraToCenterDistance;
                t1[2] = e1.aC(t1[2], r / o, r / i), this._camera.position = t1;
            }
            get centerPoint() {
                return this._edgeInsets.getCenter(this.width, this.height);
            }
            get fovAboveCenter() {
                return this._fov * (.5 + this.centerOffset.y / this.height);
            }
            isPaddingEqual(e1) {
                return this._edgeInsets.equals(e1);
            }
            interpolatePadding(e1, t1, i) {
                this._unmodified = !1, this._edgeInsets.interpolate(e1, t1, i), this._constrain(), this._calcMatrices();
            }
            coveringZoomLevel(e1) {
                const t1 = (e1.roundZoom ? Math.round : Math.floor)(this.zoom + this.scaleZoom(this.tileSize / e1.tileSize));
                return Math.max(0, t1);
            }
            getVisibleUnwrappedCoordinates(t1) {
                const i = [
                    new e1.c9(0, t1)
                ];
                if (this.renderWorldCopies) {
                    const o = this.pointCoordinate(new e1.P(0, 0)), r = this.pointCoordinate(new e1.P(this.width, 0)), n = this.pointCoordinate(new e1.P(this.width, this.height)), s = this.pointCoordinate(new e1.P(0, this.height)), a = Math.floor(Math.min(o.x, r.x, n.x, s.x)), l = Math.floor(Math.max(o.x, r.x, n.x, s.x)), c = 1;
                    for(let o = a - c; o <= l + c; o++)0 !== o && i.push(new e1.c9(o, t1));
                }
                return i;
            }
            isLODDisabled(e1) {
                return (!e1 || this.pitch <= 60) && this._edgeInsets.top <= this._edgeInsets.bottom && !this._elevation && !this.projection.isReprojectedInTileSpace;
            }
            extendTileCover(t1, i, o, r) {
                let n = [];
                const s = null != o, a = !s;
                if (a && this.zoom < i) return n;
                if (s && 0 === o[0] && 0 === o[1]) return n;
                const l = new Set, c = (t1, i, o, r, s)=>{
                    const a = e1.cD(i, t1, o, r, s);
                    l.has(a) || (n.push(new e1.aS(t1, i, o, r, s)), l.add(a));
                };
                for(let e1 = 0; e1 < t1.length; e1++){
                    const n = t1[e1];
                    if (a && n.canonical.z !== i) continue;
                    if (s && void 0 !== r && r > n.canonical.z) continue;
                    const l = n.canonical, h = n.overscaledZ, d = n.wrap, _ = 1 << l.z, u = l.x + 1 < _, p = l.x > 0, f = l.y + 1 < _, m = l.y > 0, g = n.wrap - (p ? 0 : 1), v = n.wrap + (u ? 0 : 1), y = p ? l.x - 1 : _ - 1, x = u ? l.x + 1 : 0;
                    if (s) o[0] < 0 ? (c(h, v, l.z, x, l.y), o[1] < 0 && f && (c(h, d, l.z, l.x, l.y + 1), c(h, v, l.z, x, l.y + 1)), o[1] > 0 && m && (c(h, d, l.z, l.x, l.y - 1), c(h, v, l.z, x, l.y - 1))) : o[0] > 0 ? (c(h, g, l.z, y, l.y), o[1] < 0 && f && (c(h, d, l.z, l.x, l.y + 1), c(h, g, l.z, y, l.y + 1)), o[1] > 0 && m && (c(h, d, l.z, l.x, l.y - 1), c(h, g, l.z, y, l.y - 1))) : o[1] < 0 && f ? c(h, d, l.z, l.x, l.y + 1) : m && c(h, d, l.z, l.x, l.y - 1);
                    else {
                        const e1 = n.visibleQuadrants;
                        1 & e1 && (c(h, g, l.z, y, l.y), m && (c(h, d, l.z, l.x, l.y - 1), c(h, g, l.z, y, l.y - 1))), 2 & e1 && (c(h, v, l.z, x, l.y), m && (c(h, d, l.z, l.x, l.y - 1), c(h, v, l.z, x, l.y - 1))), 4 & e1 && (c(h, g, l.z, y, l.y), f && (c(h, d, l.z, l.x, l.y + 1), c(h, g, l.z, y, l.y + 1))), 8 & e1 && (c(h, v, l.z, x, l.y), f && (c(h, d, l.z, l.x, l.y + 1), c(h, v, l.z, x, l.y + 1)));
                    }
                }
                const h = [];
                for (const e1 of n)n.some((t1)=>e1.isChildOf(t1)) || h.push(e1);
                if (n = h.filter((e1)=>!t1.some((t1)=>!!(e1.overscaledZ < i && t1.isChildOf(e1)) || e1.equals(t1) || e1.isChildOf(t1))), a) {
                    const e1 = 1 << i, t1 = "globe" === this.projection.name ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), o = [
                        e1 * t1.x,
                        e1 * t1.y
                    ], r = 4, s = r * r;
                    n = n.filter((e1)=>{
                        const t1 = e1.canonical.x + .5 - o[0], i = e1.canonical.y + .5 - o[1];
                        return t1 * t1 + i * i < s;
                    });
                }
                return n;
            }
            extendTileCoverToNearPlane(t1, i, o) {
                const r = [], n = new Set;
                for (const e1 of t1)n.add(e1.key);
                const s = (t1, i, o, s, a)=>{
                    const l = e1.cD(i, t1, o, s, a);
                    n.has(l) || (r.push(new e1.aS(t1, i, o, s, a)), n.add(l));
                }, a = t1.reduce((e1, t1)=>Math.max(e1, t1.overscaledZ), o), l = 1 << o, c = [
                    new e1.P(0, 0),
                    new e1.P(e1.an, 0),
                    new e1.P(e1.an, e1.an),
                    new e1.P(0, e1.an)
                ], h = new e1.P(0, 0), d = new e1.P(0, 0), _ = (t1, i)=>{
                    const r = Math.floor(t1[0]), n = Math.floor(t1[1]), _ = (t1[0] - r) * e1.an, u = (t1[1] - n) * e1.an, p = Math.floor(i[0]), f = Math.floor(i[1]), m = (i[0] - p) * e1.an, g = (i[1] - f) * e1.an;
                    for(let t1 = -1; t1 <= 1; t1++){
                        const i = r + t1;
                        if (!(i < 0 || i >= l)) {
                            h.x = _ - t1 * e1.an, d.x = m - (i - p) * e1.an;
                            for(let t1 = -1; t1 <= 1; t1++){
                                const r = n + t1;
                                h.y = u - t1 * e1.an, d.y = g - (r - f) * e1.an, e1.cE(h, d, c) && s(a, 0, o, i, r);
                            }
                        }
                    }
                }, u = i.points, p = u[e1.ca], f = u[e1.cb], m = this._projectToGround(p, u[e1.cc]), g = this._projectToGround(f, u[e1.cd]);
                return _(p, m), _(f, g), r;
            }
            _projectToGround(t1, i) {
                return e1.ce(e1.cf(), t1, i, t1[2] / (t1[2] - i[2]));
            }
            coveringTiles(t1) {
                let i = this.coveringZoomLevel(t1);
                const o = i, r = this.elevation && this.elevation.exaggeration(), n = r && !t1.isTerrainDEM, s = "mercator" === this.projection.name;
                if (void 0 !== t1.minzoom && i < t1.minzoom) return [];
                void 0 !== t1.maxzoom && i > t1.maxzoom && (i = t1.maxzoom);
                const a = this.locationCoordinate(this.center), l = this.center.lat, c = 1 << i, h = [
                    c * a.x,
                    c * a.y,
                    0
                ], d = "globe" === this.projection.name, _ = !d, u = e1.cg.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, i, _), p = d ? this._camera.mercatorPosition : this.pointCoordinate(this.getCameraPoint()), f = c * e1.bV(1, this.center.lat), m = this._camera.position[2] / e1.bV(1, this.center.lat), g = [
                    c * p.x,
                    c * p.y,
                    m * (_ ? 1 : f)
                ], v = d || r, y = this.cameraToCenterDistance / t1.tileSize * (t1.roundZoom ? 1 : .502), x = this.isLODDisabled(!0) ? i : 0;
                let b;
                if (this._elevation && t1.isTerrainDEM) b = 1e4 * this._elevation.exaggeration();
                else if (this._elevation) {
                    const e1 = this._elevation.getMinMaxForVisibleTiles();
                    b = e1 ? e1.max : this._centerAltitude;
                } else b = this._centerAltitude;
                const w = t1.isTerrainDEM ? -b : this._elevation ? this._elevation.getMinElevationBelowMSL() : 0, T = this.projection.isReprojectedInTileSpace ? e1.ch(this) : 1, E = (t1)=>{
                    const i = 1 / 4e4, o = new e1.ag(t1.x + i, t1.y, t1.z), r = new e1.ag(t1.x, t1.y + i, t1.z), n = t1.toLngLat(), s = o.toLngLat(), a = r.toLngLat(), l = this.locationCoordinate(n), c = this.locationCoordinate(s), h = this.locationCoordinate(a), d = Math.hypot(c.x - l.x, c.y - l.y), _ = Math.hypot(h.x - l.x, h.y - l.y);
                    return Math.sqrt(d * _) * T / i;
                }, S = (t1)=>{
                    const i = b, o = w;
                    return {
                        aabb: e1.ck(this, c, 0, 0, 0, t1, o, i, this.projection),
                        zoom: 0,
                        x: 0,
                        y: 0,
                        minZ: o,
                        maxZ: i,
                        wrap: t1,
                        fullyVisible: !1
                    };
                }, C = [];
                let I = [];
                const R = i, D = t1.reparseOverscaled ? o : i, A = (m - this._centerAltitude) * f, L = (e1)=>{
                    if (!this._elevation || !e1.tileID || !s) return;
                    const t1 = this._elevation.getMinMaxForTile(e1.tileID), i = e1.aabb;
                    t1 ? (i.min[2] = t1.min, i.max[2] = t1.max, i.center[2] = (i.min[2] + i.max[2]) / 2) : (e1.shouldSplit = O(e1), e1.shouldSplit || (i.min[2] = i.max[2] = i.center[2] = this._centerAltitude));
                }, P = (e1, t1)=>{
                    if (.707 * t1 < e1) return 1;
                    const i = t1 / e1;
                    return i / (1.4144271570014144 + (Math.pow(1.1, i - 1.4144271570014144 + 1) - 1) / (1.1 - 1) - 1);
                }, O = (t1)=>{
                    if (t1.zoom < x) return !0;
                    if (t1.zoom === R) return !1;
                    if (null != t1.shouldSplit) return t1.shouldSplit;
                    const i = t1.aabb.distanceX(g), r = t1.aabb.distanceY(g);
                    let a = A, c = 1;
                    if (d) {
                        a = t1.aabb.distanceZ(g);
                        const i = Math.pow(2, t1.zoom), o = e1.bW((t1.y + 1) / i), r = e1.bW(t1.y / i), n = Math.min(Math.max(l, o), r), s = e1.cI(n) / e1.cI(l);
                        if (c = n === l ? 1 / Math.max(1, this._mercatorScaleRatio - .3) : Math.min(1, s / this._mercatorScaleRatio), this.zoom <= e1.cF && t1.zoom === R - 1 && s >= .9) return !0;
                    } else if (n && (a = t1.aabb.distanceZ(g) * f), this.projection.isReprojectedInTileSpace && o <= 5) {
                        const i = Math.pow(2, t1.zoom), o = E(new e1.ag((t1.x + .5) / i, (t1.y + .5) / i));
                        c = o > .85 ? 1 : o;
                    }
                    if (!s && !d) {
                        const e1 = Math.sqrt(i * i + r * r + a * a);
                        let o = (1 << R - t1.zoom) * y * c;
                        return o *= P(Math.max(a, A), e1), e1 < o;
                    }
                    let _ = Number.MAX_VALUE, u = 0;
                    const p = t1.aabb.getCorners(), m = [];
                    for (const t1 of p){
                        e1.ax(m, t1, g), d || (n ? m[2] *= f : m[2] = A);
                        const i = e1.bj(m, this._camera.forward());
                        i < _ && (_ = i, u = Math.abs(m[2]));
                    }
                    let v = (1 << R - t1.zoom) * y * c;
                    if (v *= P(Math.max(u, A), _), _ < v) return !0;
                    const b = t1.aabb.closestPoint(h);
                    return b[0] === h[0] && b[1] === h[1];
                };
                if (this.renderWorldCopies) for(let e1 = 1; e1 <= 3; e1++)C.push(S(-e1)), C.push(S(e1));
                for(C.push(S(0)); C.length > 0;){
                    const o = C.pop(), r = o.x, a = o.y;
                    let l = o.fullyVisible;
                    const _ = ()=>"globe" === this.projection.name && (0 === o.y || o.y === (1 << o.zoom) - 1);
                    if (!l) {
                        let t1 = v ? o.aabb.intersects(u) : o.aabb.intersectsFlat(u);
                        if (0 === t1 && _()) {
                            const i = new e1.ci(o.zoom, r, a);
                            t1 = e1.cj(this, c, i, !0).intersects(u);
                        }
                        if (0 === t1) continue;
                        l = 2 === t1;
                    }
                    if (o.zoom === R || !O(o)) {
                        const n = o.zoom === R ? D : o.zoom;
                        if (t1.minzoom && t1.minzoom > n) continue;
                        let s = 0;
                        if (!l) {
                            let i = v ? o.aabb.intersectsPrecise(u) : o.aabb.intersectsPreciseFlat(u);
                            if (0 === i && _()) {
                                const t1 = new e1.ci(o.zoom, r, a);
                                i = e1.cj(this, c, t1, !0).intersectsPrecise(u);
                            }
                            if (0 === i) continue;
                            if (t1.calculateQuadrantVisibility) {
                                if (u.containsPoint(o.aabb.center)) s = 15;
                                else for(let e1 = 0; e1 < 4; e1++)0 !== o.aabb.quadrant(e1).intersects(u) && (s |= 1 << e1);
                            }
                        }
                        const d = h[0] - (.5 + r + (o.wrap << o.zoom)) * (1 << i - o.zoom), p = h[1] - .5 - a, f = o.tileID ? o.tileID : new e1.aS(n, o.wrap, o.zoom, r, a);
                        t1.calculateQuadrantVisibility && (f.visibleQuadrants = s), I.push({
                            tileID: f,
                            distanceSq: d * d + p * p
                        });
                        continue;
                    }
                    for(let t1 = 0; t1 < 4; t1++){
                        const i = (r << 1) + t1 % 2, h = (a << 1) + (t1 >> 1), _ = {
                            aabb: s ? o.aabb.quadrant(t1) : e1.ck(this, c, o.zoom + 1, i, h, o.wrap, o.minZ, o.maxZ, this.projection),
                            zoom: o.zoom + 1,
                            x: i,
                            y: h,
                            wrap: o.wrap,
                            fullyVisible: l,
                            tileID: void 0,
                            shouldSplit: void 0,
                            minZ: o.minZ,
                            maxZ: o.maxZ
                        };
                        n && !d && (_.tileID = new e1.aS(o.zoom + 1 === R ? D : o.zoom + 1, o.wrap, o.zoom + 1, i, h), L(_)), C.push(_);
                    }
                }
                if (this.fogCullDistSq) {
                    const i = this.fogCullDistSq, o = this.horizonLineFromTop();
                    I = I.filter((r)=>{
                        const n = [
                            0,
                            0,
                            0,
                            1
                        ], s = [
                            e1.an,
                            e1.an,
                            0,
                            1
                        ], a = this.calculateFogTileMatrix(r.tileID.toUnwrapped());
                        e1.aE(n, n, a), e1.aE(s, s, a);
                        const l = e1.cl([], n, s), c = e1.cm([], n, s), h = e1.cG(l, c);
                        if (0 === h) return !0;
                        let d = !1;
                        const _ = this._elevation;
                        if (_ && h > i && 0 !== o) {
                            const i = this.calculateProjMatrix(r.tileID.toUnwrapped());
                            let n;
                            t1.isTerrainDEM || (n = _.getMinMaxForTile(r.tileID)), n || (n = {
                                min: w,
                                max: b
                            });
                            const s = e1.cn(this.rotation), a = [
                                s[0] * e1.an,
                                s[1] * e1.an,
                                n.max
                            ];
                            e1.ah(a, a, i), d = (1 - a[1]) * this.height * .5 < o;
                        }
                        return h < i || d;
                    });
                }
                return I.sort((e1, t1)=>e1.distanceSq - t1.distanceSq).map((e1)=>e1.tileID);
            }
            resize(e1, t1) {
                this.width = e1, this.height = t1, this.pixelsToGLUnits = [
                    2 / e1,
                    -2 / t1
                ], this._constrain(), this._calcMatrices();
            }
            get unmodified() {
                return this._unmodified;
            }
            zoomScale(e1) {
                return Math.pow(2, e1);
            }
            scaleZoom(e1) {
                return Math.log2(e1);
            }
            project(t1) {
                const i = e1.aC(t1.lat, -e1.co, e1.co), o = this.projection.project(t1.lng, i);
                return new e1.P(o.x * this.worldSize, o.y * this.worldSize);
            }
            unproject(e1) {
                return this.projection.unproject(e1.x / this.worldSize, e1.y / this.worldSize);
            }
            get point() {
                return this.project(this.center);
            }
            get pointMerc() {
                return this.point._div(this.worldSize);
            }
            get pixelsPerMeterRatio() {
                return this.pixelsPerMeter / e1.bV(1, this.center.lat) / this.worldSize;
            }
            setLocationAtPoint(t1, i) {
                let o, r;
                const n = this.centerPoint;
                if ("globe" === this.projection.name) {
                    const e1 = this.worldSize;
                    o = (i.x - n.x) / e1, r = (i.y - n.y) / e1;
                } else {
                    const e1 = this.pointCoordinate(i), t1 = this.pointCoordinate(n);
                    o = e1.x - t1.x, r = e1.y - t1.y;
                }
                const s = this.locationCoordinate(t1);
                this.setLocation(new e1.ag(s.x - o, s.y - r));
            }
            setLocation(e1) {
                this.center = this.coordinateLocation(e1), this.projection.wrap && (this.center = this.center.wrap());
            }
            locationPoint(e1, t1) {
                return this.projection.locationPoint(this, e1, t1);
            }
            locationPoint3D(e1, t1) {
                return this.projection.locationPoint(this, e1, t1, !0);
            }
            pointLocation(e1) {
                return this.coordinateLocation(this.pointCoordinate(e1));
            }
            pointLocation3D(e1, t1) {
                return this.coordinateLocation(this.pointCoordinate3D(e1, t1));
            }
            locationCoordinate(t1, i) {
                const o = i ? e1.bV(i, t1.lat) : void 0, r = this.projection.project(t1.lng, t1.lat);
                return new e1.ag(r.x, r.y, o);
            }
            coordinateLocation(e1) {
                return this.projection.unproject(e1.x, e1.y);
            }
            pointRayIntersection(t1, i) {
                const o = null != i ? i : this._centerAltitude, r = [
                    t1.x,
                    t1.y,
                    0,
                    1
                ], n = [
                    t1.x,
                    t1.y,
                    1,
                    1
                ];
                e1.aE(r, r, this.pixelMatrixInverse), e1.aE(n, n, this.pixelMatrixInverse);
                const s = n[3];
                e1.cp(r, r, 1 / r[3]), e1.cp(n, n, 1 / s);
                const a = r[2], l = n[2];
                return {
                    p0: r,
                    p1: n,
                    t: a === l ? 0 : (o - a) / (l - a)
                };
            }
            screenPointToMercatorRay(t1) {
                const i = [
                    t1.x,
                    t1.y,
                    0,
                    1
                ], o = [
                    t1.x,
                    t1.y,
                    1,
                    1
                ];
                return e1.aE(i, i, this.pixelMatrixInverse), e1.aE(o, o, this.pixelMatrixInverse), e1.cp(i, i, 1 / i[3]), e1.cp(o, o, 1 / o[3]), i[2] = e1.bV(i[2], this._center.lat) * this.worldSize, o[2] = e1.bV(o[2], this._center.lat) * this.worldSize, e1.cp(i, i, 1 / this.worldSize), e1.cp(o, o, 1 / this.worldSize), new e1.az([
                    i[0],
                    i[1],
                    i[2]
                ], e1.ay([], e1.ax([], o, i)));
            }
            rayIntersectionCoordinate(t1) {
                const { p0: i, p1: o, t: r } = t1, n = e1.bV(i[2], this._center.lat), s = e1.bV(o[2], this._center.lat);
                return new e1.ag(e1.am(i[0], o[0], r) / this.worldSize, e1.am(i[1], o[1], r) / this.worldSize, e1.am(n, s, r));
            }
            pointCoordinate(e1, t1 = this._centerAltitude) {
                return this.projection.pointCoordinate(this, e1.x, e1.y, t1);
            }
            pointCoordinate3D(t1, i) {
                if (!this.elevation) return this.pointCoordinate(t1, i);
                let o = this.projection.pointCoordinate3D(this, t1.x, t1.y);
                if (o) return new e1.ag(o[0], o[1], o[2]);
                let r = 0, n = this.horizonLineFromTop();
                if (t1.y > n) return this.pointCoordinate(t1, i);
                const s = .02 * n, a = t1.clone();
                for(let t1 = 0; t1 < 10 && n - r > s; t1++){
                    a.y = e1.am(r, n, .66);
                    const t1 = this.projection.pointCoordinate3D(this, a.x, a.y);
                    t1 ? (n = a.y, o = t1) : r = a.y;
                }
                return o ? new e1.ag(o[0], o[1], o[2]) : this.pointCoordinate(t1);
            }
            isPointAboveHorizon(e1) {
                return this.projection.isPointAboveHorizon(this, e1);
            }
            isPointOnSurface(t1) {
                if (t1.y < 0 || t1.y > this.height || t1.x < 0 || t1.x > this.width) return !1;
                if (this.elevation || this.zoom >= e1.cq) return !this.isPointAboveHorizon(t1);
                const i = this.pointCoordinate(t1);
                return i.y >= 0 && i.y <= 1;
            }
            _coordinatePoint(t1, i) {
                const o = i && this.elevation ? this.elevation.getAtPointOrZero(t1, this._centerAltitude) : this._centerAltitude, r = [
                    t1.x * this.worldSize,
                    t1.y * this.worldSize,
                    o + t1.toAltitude(),
                    1
                ];
                return e1.aE(r, r, this.pixelMatrix), r[3] > 0 ? new e1.P(r[0] / r[3], r[1] / r[3]) : new e1.P(Number.MAX_VALUE, Number.MAX_VALUE);
            }
            _getBoundsNonRectangular() {
                const { top: t1, left: i } = this._edgeInsets, o = this.height - this._edgeInsets.bottom, r = this.width - this._edgeInsets.right, n = this.pointLocation3D(new e1.P(i, t1)), s = this.pointLocation3D(new e1.P(r, t1)), a = this.pointLocation3D(new e1.P(r, o)), l = this.pointLocation3D(new e1.P(i, o));
                let c = Math.min(n.lng, s.lng, a.lng, l.lng), h = Math.max(n.lng, s.lng, a.lng, l.lng), d = Math.min(n.lat, s.lat, a.lat, l.lat), _ = Math.max(n.lat, s.lat, a.lat, l.lat);
                const u = Math.pow(2, -this.zoom) / 16 * 270, p = "globe" === this.projection.name ? 1 : 4, f = (t1, i, o, r, n)=>{
                    const s = (t1 + o) / 2, a = (i + r) / 2, l = new e1.P(s, a), { lng: m, lat: g } = this.pointLocation3D(l), v = Math.max(0, c - m, d - g, m - h, g - _);
                    c = Math.min(c, m), h = Math.max(h, m), d = Math.min(d, g), _ = Math.max(_, g), (n < p || v > u) && (f(t1, i, s, a, n + 1), f(s, a, o, r, n + 1));
                };
                if (f(i, t1, r, t1, 1), f(r, t1, r, o, 1), f(r, o, i, o, 1), f(i, o, i, t1, 1), "globe" === this.projection.name) {
                    const [t1, i] = e1.cr(this);
                    t1 ? (_ = 90, h = 180, c = -180) : i && (d = -90, h = 180, c = -180);
                }
                return new e1.aK(new e1.aV(c, d), new e1.aV(h, _));
            }
            _getBoundsRectangular(t1, i) {
                const { top: o, left: r } = this._edgeInsets, n = this.height - this._edgeInsets.bottom, s = this.width - this._edgeInsets.right, a = new e1.P(r, o), l = new e1.P(s, o), c = new e1.P(s, n), h = new e1.P(r, n);
                let d = this.pointCoordinate(a, t1), _ = this.pointCoordinate(l, t1);
                const u = this.pointCoordinate(c, i), p = this.pointCoordinate(h, i), f = (e1, t1)=>(t1.y - e1.y) / (t1.x - e1.x);
                return d.y > 1 && _.y >= 0 ? d = new e1.ag((1 - p.y) / f(p, d) + p.x, 1) : d.y < 0 && _.y <= 1 && (d = new e1.ag(-p.y / f(p, d) + p.x, 0)), _.y > 1 && d.y >= 0 ? _ = new e1.ag((1 - u.y) / f(u, _) + u.x, 1) : _.y < 0 && d.y <= 1 && (_ = new e1.ag(-u.y / f(u, _) + u.x, 0)), (new e1.aK).extend(this.coordinateLocation(d)).extend(this.coordinateLocation(_)).extend(this.coordinateLocation(p)).extend(this.coordinateLocation(u));
            }
            _getBoundsRectangularTerrain() {
                const e1 = this.elevation;
                if (!e1.visibleDemTiles.length || e1.isUsingMockSource()) return this._getBoundsRectangular(0, 0);
                const t1 = e1.visibleDemTiles.reduce((e1, t1)=>{
                    if (t1.dem) {
                        const i = t1.dem.tree;
                        e1.min = Math.min(e1.min, i.minimums[0]), e1.max = Math.max(e1.max, i.maximums[0]);
                    }
                    return e1;
                }, {
                    min: Number.MAX_VALUE,
                    max: 0
                });
                return this._getBoundsRectangular(t1.min * e1.exaggeration(), t1.max * e1.exaggeration());
            }
            getBounds() {
                return "mercator" === this.projection.name || "equirectangular" === this.projection.name ? this._terrainEnabled() ? this._getBoundsRectangularTerrain() : this._getBoundsRectangular(0, 0) : this._getBoundsNonRectangular();
            }
            horizonLineFromTop(e1 = !0) {
                const t1 = this.height / 2 / Math.tan(this._fov / 2) / Math.tan(Math.max(this._pitch, .1)) - this.centerOffset.y, i = this.height / 2 - t1 * (1 - this._horizonShift);
                return e1 ? Math.max(0, i) : i;
            }
            getMaxBounds() {
                return this.maxBounds;
            }
            setMaxBounds(t1) {
                this.maxBounds = t1, this.minLat = -e1.co, this.maxLat = e1.co, this.minLng = -180, this.maxLng = 180, t1 && (this.minLat = t1.getSouth(), this.maxLat = t1.getNorth(), this.minLng = t1.getWest(), this.maxLng = t1.getEast(), this.maxLng < this.minLng && (this.maxLng += 360)), this.worldMinX = e1.aH(this.minLng) * this.tileSize, this.worldMaxX = e1.aH(this.maxLng) * this.tileSize, this.worldMinY = e1.aL(this.maxLat) * this.tileSize, this.worldMaxY = e1.aL(this.minLat) * this.tileSize, this._constrain();
            }
            calculatePosMatrix(e1, t1) {
                return this.projection.createTileMatrix(this, t1, e1);
            }
            calculateDistanceTileData(t1) {
                const i = t1.key, o = this._distanceTileDataCache;
                if (o[i]) return o[i];
                const r = t1.canonical, n = 1 / this.height, s = this.cameraWorldSize, a = s / this.zoomScale(r.z), l = (r.x + Math.pow(2, r.z) * t1.wrap) * a, c = r.y * a, h = this.point;
                h.x *= s / this.worldSize, h.y *= s / this.worldSize;
                const d = this.angle, _ = Math.sin(-d), u = -Math.cos(-d);
                return o[i] = {
                    bearing: [
                        _,
                        u
                    ],
                    center: [
                        (h.x - l) * n,
                        (h.y - c) * n
                    ],
                    scale: a / e1.an * n
                }, o[i];
            }
            calculateFogTileMatrix(t1) {
                const i = t1.key, o = this._fogTileMatrixCache;
                if (o[i]) return o[i];
                const r = this.projection.createTileMatrix(this, this.cameraWorldSizeForFog, t1);
                return e1.aD(r, this.worldToFogMatrix, r), o[i] = new Float32Array(r), o[i];
            }
            calculateProjMatrix(t1, i = !1, o = !1) {
                const r = t1.key;
                let n;
                if (n = o ? this._expandedProjMatrixCache : i ? this._alignedProjMatrixCache : this._projMatrixCache, n[r]) return n[r];
                const s = this.calculatePosMatrix(t1, this.worldSize);
                let a;
                return a = this.projection.isReprojectedInTileSpace ? this.mercatorMatrix : o ? this.expandedFarZProjMatrix : i ? this.alignedProjMatrix : this.projMatrix, e1.aD(s, a, s), n[r] = new Float32Array(s), n[r];
            }
            calculatePixelsToTileUnitsMatrix(t1) {
                const i = t1.tileID.key, o = this._pixelsToTileUnitsCache;
                if (o[i]) return o[i];
                const r = e1.cs(t1, this);
                return o[i] = r, o[i];
            }
            customLayerMatrix() {
                return this.mercatorMatrix.slice();
            }
            globeToMercatorMatrix() {
                if ("globe" === this.projection.name) {
                    const t1 = 1 / this.worldSize, i = e1.bQ([], [
                        t1,
                        t1,
                        t1
                    ]);
                    return e1.aD(i, i, this.globeMatrix), i;
                }
            }
            recenterOnTerrain() {
                if (!this._elevation || "globe" === this.projection.name) return;
                const t1 = this._elevation;
                this._updateCameraState();
                const i = e1.bV(1, this._center.lat) * this.worldSize, o = this._computeCameraPosition(i), r = this._camera.forward(), n = e1.bV(1, this._center.lat);
                o[2] /= n, r[2] /= n, e1.ay(r, r);
                const s = t1.raycast(o, r, t1.exaggeration());
                if (s) {
                    const t1 = e1.bh([], o, r, s), i = new e1.ag(t1[0], t1[1], e1.bV(t1[2], e1.bW(t1[1]))), a = (i.z + e1.ai([
                        i.x - o[0],
                        i.y - o[1],
                        i.z - o[2] * n
                    ])) * this._pixelsPerMercatorPixel;
                    this._seaLevelZoom = this._zoomFromMercatorZ(a), this._centerAltitude = i.toAltitude(), this._center = this.coordinateLocation(i), this._updateZoomFromElevation(), this._constrain(), this._calcMatrices();
                }
            }
            _constrainCamera(t1 = !1) {
                if (!this._elevation) return;
                const i = this._elevation, o = e1.bV(1, this._center.lat) * this.worldSize, r = this._computeCameraPosition(o), n = i.getAtPointOrZero(new e1.ag(...r)), s = this.pixelsPerMeter / this.worldSize * n, a = this._minimumHeightOverTerrain(), l = r[2] - s;
                if (l <= a) {
                    if (l < 0 || t1) {
                        const t1 = this.locationCoordinate(this._center, this._centerAltitude), i = [
                            r[0],
                            r[1],
                            t1.z - r[2]
                        ], o = e1.ai(i);
                        i[2] -= (a - l) / this._pixelsPerMercatorPixel;
                        const n = e1.ai(i);
                        if (0 === n) return;
                        e1.bK(i, i, o / n * this._pixelsPerMercatorPixel), this._camera.position = [
                            r[0],
                            r[1],
                            t1.z * this._pixelsPerMercatorPixel - i[2]
                        ], this._updateStateFromCamera();
                    } else this._isCameraConstrained = !0;
                }
            }
            _constrain() {
                if (!this.center || !this.width || !this.height || this._constraining) return;
                this._constraining = !0;
                const t1 = "globe" === this.projection.name || this.mercatorFromTransition;
                if (this.projection.isReprojectedInTileSpace || t1) {
                    const i = this.center;
                    return i.lat = e1.aC(i.lat, this.minLat, this.maxLat), (this.maxBounds || !this.renderWorldCopies && !t1) && (i.lng = e1.aC(i.lng, this.minLng, this.maxLng)), this.center = i, void (this._constraining = !1);
                }
                const i = this._unmodified, { x: o, y: r } = this.point;
                let n = 0, s = o, a = r;
                const l = this.width / 2, c = this.height / 2, h = this.worldMinY * this.scale, d = this.worldMaxY * this.scale;
                if (r - c < h && (a = h + c), r + c > d && (a = d - c), d - h < this.height && (n = Math.max(n, this.height / (d - h)), a = (d + h) / 2), this.maxBounds || !this._renderWorldCopies || !this.projection.wrap) {
                    const e1 = this.worldMinX * this.scale, t1 = this.worldMaxX * this.scale, i = this.worldSize / 2 - (e1 + t1) / 2;
                    s = (o + i + this.worldSize) % this.worldSize - i, s - l < e1 && (s = e1 + l), s + l > t1 && (s = t1 - l), t1 - e1 < this.width && (n = Math.max(n, this.width / (t1 - e1)), s = (t1 + e1) / 2);
                }
                s === o && a === r || this._allowWorldUnderZoom || (this.center = this.unproject(new e1.P(s, a))), n && !this._allowWorldUnderZoom && (this.zoom += this.scaleZoom(n)), this._constrainCamera(), this._unmodified = i, this._constraining = !1;
            }
            _minZoomForBounds() {
                let e1 = Math.max(0, this.scaleZoom(Math.max(0, this.height) / (this.worldMaxY - this.worldMinY)));
                return this.maxBounds && (e1 = Math.max(e1, this.scaleZoom(this.width / (this.worldMaxX - this.worldMinX)))), e1;
            }
            _maxCameraBoundsDistance() {
                return this._mercatorZfromZoom(this._minZoomForBounds());
            }
            _calcMatrices() {
                if (!this.height) return;
                const t1 = this.centerOffset, i = "globe" === this.projection.name, o = this.pixelsPerMeter;
                "globe" === this.projection.name && (this._mercatorScaleRatio = e1.bV(1, this.center.lat) / e1.bV(1, e1.cJ));
                const r = e1.ct(this.projection, this.zoom, this.width, this.height, 1024);
                this._pixelsPerMercatorPixel = this.projection.pixelSpaceConversion(this.center.lat, this.worldSize, r), this.cameraToCenterDistance = .5 / Math.tan(.5 * this._fov) * this.height * this._pixelsPerMercatorPixel, this._updateCameraState(), this._farZ = this.projection.farthestPixelDistance(this), this._nearZ = this.height / 50;
                const n = "meters" === this.projection.zAxisUnit ? o : 1, s = this._camera.getWorldToCamera(this.worldSize, n);
                let a;
                const l = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, this._farZ);
                if (l[8] = 2 * -t1.x / this.width, l[9] = 2 * t1.y / this.height, this.isOrthographic) {
                    let i = .5 * this.height / Math.tan(this._fov / 2) * 1 * Math.tan(.5 * this._fov), o = i * this.aspect, r = -o, n = -i;
                    o -= t1.x, r -= t1.x, i += t1.y, n += t1.y, a = this._camera.getCameraToClipOrthographic(r, o, n, i, this._nearZ + this._nearClipOffset, this._farZ), ((t1, i, o, r)=>{
                        for(let n = 0; n < 16; n++)t1[n] = e1.am(i[n], o[n], r);
                    })(a, a, l, e1.cH(this.pitch >= no ? 1 : this.pitch / no));
                } else a = l;
                const c = e1.cu([], l, s);
                let h = e1.cu([], a, s);
                if (this.projection.isReprojectedInTileSpace) {
                    const t1 = this.locationCoordinate(this.center), i = e1.ba([]);
                    e1.by(i, i, [
                        t1.x * this.worldSize,
                        t1.y * this.worldSize,
                        0
                    ]), e1.aD(i, i, e1.cv(this)), e1.by(i, i, [
                        -t1.x * this.worldSize,
                        -t1.y * this.worldSize,
                        0
                    ]), e1.aD(h, h, i), e1.aD(c, c, i), this.inverseAdjustmentMatrix = e1.cw(this);
                } else this.inverseAdjustmentMatrix = [
                    1,
                    0,
                    0,
                    1
                ];
                if (this.mercatorMatrix = e1.cx([], h, [
                    this.worldSize,
                    this.worldSize,
                    this.worldSize / n,
                    1
                ]), this.projMatrix = h, this.invProjMatrix = e1.b8(new Float64Array(16), this.projMatrix), i) {
                    const i = this._camera.getCameraToClipPerspective(this._fov, this.width / this.height, this._nearZ, 1 / 0);
                    i[8] = 2 * -t1.x / this.width, i[9] = 2 * t1.y / this.height, this.expandedFarZProjMatrix = e1.cu([], i, s);
                } else this.expandedFarZProjMatrix = this.projMatrix;
                const d = e1.b8([], a);
                this.frustumCorners = e1.cy.fromInvProjectionMatrix(d, this.horizonLineFromTop(), this.height), this.cameraFrustum = e1.cg.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, 0, !i);
                const _ = new Float32Array(16);
                e1.ba(_), e1.cx(_, _, [
                    1,
                    -1,
                    1
                ]), e1.cz(_, _, this._pitch), e1.bb(_, _, this.angle);
                const u = e1.bT(new Float32Array(16), this._fov, this.width / this.height, this._nearZ, this._farZ);
                this.starsProjMatrix = e1.b9(u);
                const p = (Math.PI / 2 - this._pitch) * (this.height / this._fov) * this._horizonShift;
                u[8] = 2 * -t1.x / this.width, u[9] = 2 * (t1.y + p) / this.height, this.skyboxMatrix = e1.aD(_, u, _);
                const f = this.point, m = f.x, g = f.y, v = this.width % 2 / 2, y = this.height % 2 / 2, x = Math.cos(this.angle), b = Math.sin(this.angle), w = m - Math.round(m) + x * v + b * y, T = g - Math.round(g) + x * y + b * v, E = new Float64Array(h);
                if (e1.by(E, E, [
                    w > .5 ? w - 1 : w,
                    T > .5 ? T - 1 : T,
                    0
                ]), this.alignedProjMatrix = E, h = e1.bc(), e1.cx(h, h, [
                    this.width / 2,
                    -this.height / 2,
                    1
                ]), e1.by(h, h, [
                    1,
                    -1,
                    0
                ]), this.labelPlaneMatrix = h, h = e1.bc(), e1.cx(h, h, [
                    1,
                    -1,
                    1
                ]), e1.by(h, h, [
                    -1,
                    -1,
                    0
                ]), e1.cx(h, h, [
                    2 / this.width,
                    2 / this.height,
                    1
                ]), this.glCoordMatrix = h, this.pixelMatrix = e1.aD(new Float64Array(16), this.labelPlaneMatrix, c), this._calcFogMatrices(), this._distanceTileDataCache = {}, h = e1.b8(new Float64Array(16), this.pixelMatrix), !h) throw new Error("failed to invert matrix");
                if (this.pixelMatrixInverse = h, "globe" === this.projection.name || this.mercatorFromTransition) {
                    this.globeMatrix = e1.cA(this);
                    const t1 = [
                        this.globeMatrix[12],
                        this.globeMatrix[13],
                        this.globeMatrix[14]
                    ];
                    this.globeCenterInViewSpace = e1.ah(t1, t1, s), this.globeRadius = this.worldSize / 2 / Math.PI - 1;
                } else this.globeMatrix = h;
                this._projMatrixCache = {}, this._alignedProjMatrixCache = {}, this._pixelsToTileUnitsCache = {}, this._expandedProjMatrixCache = {};
            }
            _calcFogMatrices() {
                this._fogTileMatrixCache = {};
                const t1 = this.cameraWorldSizeForFog, i = this.cameraPixelsPerMeter, o = this._camera.position, r = 1 / this.height / this._pixelsPerMercatorPixel, n = [
                    t1,
                    t1,
                    i
                ];
                e1.bK(n, n, r), e1.bK(o, o, -1), e1.cB(o, o, n);
                const s = e1.bc();
                e1.by(s, s, o), e1.cx(s, s, n), this.mercatorFogMatrix = s, this.worldToFogMatrix = this._camera.getWorldToCameraPosition(t1, i, r);
            }
            _computeCameraPosition(e1) {
                const t1 = (e1 = e1 || this.pixelsPerMeter) / this.pixelsPerMeter, i = this._camera.forward(), o = this.point, r = this._mercatorZfromZoom(this._seaLevelZoom ? this._seaLevelZoom : this._zoom) * t1 - e1 / this.worldSize * this._centerAltitude;
                return [
                    o.x / this.worldSize - i[0] * r,
                    o.y / this.worldSize - i[1] * r,
                    e1 / this.worldSize * this._centerAltitude - i[2] * r
                ];
            }
            _updateCameraState() {
                this.height && (this._camera.setPitchBearing(this._pitch, this.angle), this._camera.position = this._computeCameraPosition());
            }
            _translateCameraConstrained(t1) {
                const i = this._maxCameraBoundsDistance() * Math.cos(this._pitch), o = this._camera.position[2], r = t1[2];
                let n = 1;
                this.projection.wrap && (this.center = this.center.wrap()), r > 0 && (n = Math.min((i - o) / r, 1)), this._camera.position = e1.bh([], this._camera.position, t1, n), this._updateStateFromCamera();
            }
            _updateStateFromCamera() {
                const t1 = this._camera.position, i = this._camera.forward(), { pitch: o, bearing: r } = this._camera.getPitchBearing(), n = e1.bV(this._centerAltitude, this.center.lat) * this._pixelsPerMercatorPixel, s = this._mercatorZfromZoom(this._maxZoom) * Math.cos(e1.ap(this._maxPitch)), a = Math.max((t1[2] - n) / Math.cos(o), s), l = this._zoomFromMercatorZ(a);
                e1.bh(t1, t1, i, a), this._pitch = e1.aC(o, e1.ap(this.minPitch), e1.ap(this.maxPitch)), this.angle = e1.bt(r, -Math.PI, Math.PI), this._setZoom(e1.aC(l, this._minZoom, this._maxZoom)), this._updateSeaLevelZoom(), this._center = this.coordinateLocation(new e1.ag(t1[0], t1[1], t1[2])), this._unmodified = !1, this._constrain(), this._calcMatrices();
            }
            _worldSizeFromZoom(e1) {
                return Math.pow(2, e1) * this.tileSize;
            }
            _mercatorZfromZoom(e1) {
                return this.cameraToCenterDistance / this._worldSizeFromZoom(e1);
            }
            _minimumHeightOverTerrain() {
                const e1 = Math.min(null != this._seaLevelZoom ? this._seaLevelZoom : this._zoom, this._maxZoom) + 4;
                return this._mercatorZfromZoom(e1);
            }
            _zoomFromMercatorZ(e1) {
                return this.scaleZoom(this.cameraToCenterDistance / (Math.max(0, e1) * this.tileSize));
            }
            zoomFromMercatorZAdjusted(t1) {
                let i = 0, o = e1.cq, r = 0, n = 1 / 0;
                for(; o - i > 1e-6 && o > i;){
                    const e1 = i + .5 * (o - i), s = this.tileSize * Math.pow(2, e1), a = this.getCameraToCenterDistance(this.projection, e1, s), l = this.scaleZoom(a / (Math.max(0, t1) * this.tileSize)), c = Math.abs(e1 - l);
                    c < n && (n = c, r = e1), e1 < l ? i = e1 : o = e1;
                }
                return r;
            }
            _terrainEnabled() {
                return !(!this._elevation || !this.projection.supportsTerrain && (e1.w("Terrain is not yet supported with alternate projections. Use mercator or globe to enable terrain."), 1));
            }
            anyCornerOffEdge(t1, i) {
                const o = Math.min(t1.x, i.x), r = Math.max(t1.x, i.x), n = Math.min(t1.y, i.y), s = Math.max(t1.y, i.y);
                if (n < this.horizonLineFromTop(!1)) return !0;
                if ("mercator" !== this.projection.name) return !1;
                const a = [
                    new e1.P(o, n),
                    new e1.P(r, s),
                    new e1.P(o, s),
                    new e1.P(r, n)
                ], l = this.renderWorldCopies ? -3 : 0, c = this.renderWorldCopies ? 4 : 1;
                for (const e1 of a){
                    const t1 = this.pointRayIntersection(e1);
                    if (t1.t < 0) return !0;
                    const i = this.rayIntersectionCoordinate(t1);
                    if (i.x < l || i.y < 0 || i.x > c || i.y > 1) return !0;
                }
                return !1;
            }
            isHorizonVisible() {
                return this.pitch + e1.cC(this.fovAboveCenter) > 88 || this.anyCornerOffEdge(new e1.P(0, 0), new e1.P(this.width, this.height));
            }
            zoomDeltaToMovement(t1, i) {
                const o = e1.ai(e1.ax([], this._camera.position, t1)), r = this._zoomFromMercatorZ(o) + i;
                return o - this._mercatorZfromZoom(r);
            }
            getCameraPoint() {
                if ("globe" === this.projection.name) {
                    const t1 = function([t1, i, o], r) {
                        const n = [
                            t1,
                            i,
                            o,
                            1
                        ];
                        e1.aE(n, n, r);
                        const s = n[3] = Math.max(n[3], 1e-6);
                        return n[0] /= s, n[1] /= s, n[2] /= s, n;
                    }([
                        this.globeMatrix[12],
                        this.globeMatrix[13],
                        this.globeMatrix[14]
                    ], this.pixelMatrix);
                    return new e1.P(t1[0], t1[1]);
                }
                {
                    const t1 = Math.tan(this._pitch) * (this.cameraToCenterDistance || 1);
                    return this.centerPoint.add(new e1.P(0, t1));
                }
            }
            getCameraToCenterDistance(t1, i = this.zoom, o = this.worldSize) {
                const r = e1.ct(t1, i, this.width, this.height, 1024), n = t1.pixelSpaceConversion(this.center.lat, o, r);
                let s = .5 / Math.tan(.5 * this._fov) * this.height * n;
                return this.isOrthographic && (s = e1.am(1, s, e1.cH(this.pitch >= no ? 1 : this.pitch / no))), s;
            }
            getWorldToCameraMatrix() {
                const t1 = this._camera.getWorldToCamera(this.worldSize, "meters" === this.projection.zAxisUnit ? this.pixelsPerMeter : 1);
                return "globe" === this.projection.name && e1.aD(t1, t1, this.globeMatrix), t1;
            }
            getFrustum(t1) {
                return e1.cg.fromInvProjectionMatrix(this.invProjMatrix, this.worldSize, t1, "meters" === this.projection.zAxisUnit);
            }
        }
        const ao = (t1, i)=>{
            if (i > 0 && t1.terrain && e1.w("Cutoff is currently disabled on terrain"), i <= 0 || t1.terrain) return {
                shouldRenderCutoff: !1,
                uniformValues: {
                    u_cutoff_params: [
                        0,
                        0,
                        0,
                        1
                    ]
                }
            };
            const o = t1.transform, r = o.pitch, n = o.isLODDisabled(!1) ? 60 : 30;
            if (r < n - 15) return {
                shouldRenderCutoff: !1,
                uniformValues: {
                    u_cutoff_params: [
                        0,
                        0,
                        0,
                        1
                    ]
                }
            };
            const s = o._farZ - o._nearZ, a = i * o.height * 1.3, l = Math.pow(2, .85 * Math.max(o._zoom - t1.minCutoffZoom, 0)), c = 1.4 * o.cameraToCenterDistance * l, h = e1.aj(n - 15, n, r), d = (1 - (_ = h)) * (o._farZ + a) + _ * c;
            var _;
            const u = Math.min(a, d - o._nearZ);
            return {
                shouldRenderCutoff: h > 0,
                uniformValues: {
                    u_cutoff_params: [
                        o._nearZ,
                        o._farZ,
                        (d - o._nearZ) / s,
                        (d - u - o._nearZ) / s
                    ]
                }
            };
        }, lo = 2048;
        class co {
            constructor(e1, t1){
                this.aabb = e1, this.lastCascade = t1;
            }
        }
        class ho {
            add(e1, t1) {
                const i = this.receivers[e1.key];
                void 0 !== i ? (i.aabb.min[0] = Math.min(i.aabb.min[0], t1.min[0]), i.aabb.min[1] = Math.min(i.aabb.min[1], t1.min[1]), i.aabb.min[2] = Math.min(i.aabb.min[2], t1.min[2]), i.aabb.max[0] = Math.max(i.aabb.max[0], t1.max[0]), i.aabb.max[1] = Math.max(i.aabb.max[1], t1.max[1]), i.aabb.max[2] = Math.max(i.aabb.max[2], t1.max[2])) : this.receivers[e1.key] = new co(t1, null);
            }
            clear() {
                this.receivers = {};
            }
            get(e1) {
                return this.receivers[e1.key];
            }
            computeRequiredCascades(t1, i, o) {
                const r = e1.cQ.fromPoints(t1.points);
                let n = 0;
                for(const t1 in this.receivers){
                    const s = this.receivers[t1];
                    if (!s) continue;
                    if (!r.intersectsAabb(s.aabb)) continue;
                    s.aabb.min = r.closestPoint(s.aabb.min), s.aabb.max = r.closestPoint(s.aabb.max);
                    const a = s.aabb.getCorners();
                    for(let t1 = 0; t1 < o.length; t1++){
                        let r = !0;
                        for (const n of a){
                            const s = [
                                n[0] * i,
                                n[1] * i,
                                n[2]
                            ];
                            if (e1.ah(s, s, o[t1].matrix), s[0] < -1 || s[0] > 1 || s[1] < -1 || s[1] > 1) {
                                r = !1;
                                break;
                            }
                        }
                        if (s.lastCascade = t1, n = Math.max(n, t1), r) break;
                    }
                }
                return n + 1;
            }
        }
        class _o {
            constructor(e1){
                this.painter = e1, this._enabled = !1, this._drawShadowAfterLayer = -1, this._numCascadesToRender = 0, this._cascades = [], this._groundShadowTiles = [], this._receivers = new ho, this._depthMode = new Hi(e1.context.gl.LEQUAL, Hi.ReadWrite, [
                    0,
                    1
                ]), this._uniformValues = {
                    u_light_matrix_0: new Float32Array(16),
                    u_light_matrix_1: new Float32Array(16),
                    u_shadow_intensity: 0,
                    u_fade_range: [
                        0,
                        0
                    ],
                    u_shadow_normal_offset: [
                        1,
                        1,
                        1
                    ],
                    u_shadow_texel_size: 1,
                    u_shadow_map_resolution: 1,
                    u_shadow_direction: [
                        0,
                        0,
                        1
                    ],
                    u_shadow_bias: [
                        36e-5,
                        .0012,
                        .012
                    ],
                    u_shadowmap_0: 0,
                    u_shadowmap_1: 0
                }, this._forceDisable = !1, this.useNormalOffset = !1;
            }
            destroy() {
                for (const e1 of this._cascades)e1.texture.destroy(), e1.framebuffer.destroy();
                this._cascades = [];
            }
            updateShadowParameters(t1, i) {
                const o = this.painter;
                if (this._enabled = !1, this._drawShadowAfterLayer = -1, this._receivers.clear(), !i || !i.properties) return;
                const r = i.properties.get("shadow-intensity"), n = i.properties.get("shadow-draw-before-layer");
                if (!i.shadowsEnabled() || r <= 0) return;
                let s = -1, a = 0;
                for (const e1 of o.style.order){
                    const i = o.style._mergedLayers[e1];
                    i.hasShadowPass() && !i.isHidden(t1.zoom) && (s = a), !n || n !== e1 && n !== i.slot || (this._drawShadowAfterLayer = a > 0 ? a - 1 : 0), a += 1;
                }
                if (this._enabled = s >= 0, !this.enabled) return;
                this._drawShadowAfterLayer < 0 && (this._drawShadowAfterLayer = s);
                const l = o.context, c = lo, h = lo;
                if (0 === this._cascades.length || lo !== this._cascades[0].texture.size[0]) {
                    this._cascades = [];
                    for(let t1 = 0; t1 < 2; ++t1){
                        const t1 = l.gl, i = l.createFramebuffer(c, h, 0, "texture"), o = new e1.T(l, {
                            width: c,
                            height: h,
                            data: null
                        }, t1.DEPTH_COMPONENT16);
                        i.depthAttachment.set(o.texture), this._cascades.push({
                            framebuffer: i,
                            texture: o,
                            matrix: [],
                            far: 0,
                            boundingSphereRadius: 0,
                            frustum: new e1.cg,
                            scale: 0
                        });
                    }
                }
                this.shadowDirection = po(i);
                let d = 0;
                if (t1.elevation) {
                    const e1 = t1.elevation, i = [
                        1e4,
                        -10000
                    ];
                    e1.visibleDemTiles.filter((e1)=>e1.dem).forEach((e1)=>{
                        const t1 = e1.dem.tree;
                        i[0] = Math.min(i[0], t1.minimums[0]), i[1] = Math.max(i[1], t1.maximums[0]);
                    }), 1e4 !== i[0] && (d = (i[1] - i[0]) * e1.exaggeration());
                }
                const _ = 1.5 * t1.cameraToCenterDistance, u = 3 * _, p = new Float64Array(16);
                for(let i = 0; i < this._cascades.length; ++i){
                    const o = this._cascades[i];
                    let r = t1.height / 50, n = 1;
                    0 === i ? n = _ : (r = _, n = u);
                    const [s, a] = mo(t1, this.shadowDirection, r, n, lo, d);
                    o.scale = t1.scale, o.matrix = s, o.boundingSphereRadius = a, e1.b8(p, o.matrix), o.frustum = e1.cg.fromInvProjectionMatrix(p, 1, 0, !0), o.far = n;
                }
                const f = this._cascades.length - 1;
                this._uniformValues.u_fade_range = [
                    .75 * this._cascades[f].far,
                    this._cascades[f].far
                ], this._uniformValues.u_shadow_intensity = r, this._uniformValues.u_shadow_direction = [
                    this.shadowDirection[0],
                    this.shadowDirection[1],
                    this.shadowDirection[2]
                ], this._uniformValues.u_shadow_texel_size = .00048828125, this._uniformValues.u_shadow_map_resolution = lo, this._uniformValues.u_shadowmap_0 = 11, this._uniformValues.u_shadowmap_1 = 12, this._groundShadowTiles = o.transform.coveringTiles({
                    tileSize: 512,
                    renderWorldCopies: !0
                });
                const m = o.transform.elevation;
                for (const e1 of this._groundShadowTiles){
                    let t1 = {
                        min: 0,
                        max: 0
                    };
                    if (m) {
                        const i = m.getMinMaxForTile(e1);
                        i && (t1 = i);
                    }
                    this.addShadowReceiver(e1.toUnwrapped(), t1.min, t1.max);
                }
            }
            get enabled() {
                return this._enabled && !this._forceDisable;
            }
            set enabled(e1) {
                this._enabled = e1;
            }
            drawShadowPass(t1, i) {
                if (!this.enabled) return;
                const o = this.painter, r = o.context;
                this._numCascadesToRender = this._receivers.computeRequiredCascades(o.transform.getFrustum(0), o.transform.worldSize, this._cascades), r.viewport.set([
                    0,
                    0,
                    lo,
                    lo
                ]);
                for(let n = 0; n < this._numCascadesToRender; ++n){
                    o.currentShadowCascade = n, r.bindFramebuffer.set(this._cascades[n].framebuffer.framebuffer), r.clear({
                        color: e1.aq.white,
                        depth: 1
                    });
                    for (const e1 of t1.order){
                        const r = t1._mergedLayers[e1];
                        if (!r.hasShadowPass() || r.isHidden(o.transform.zoom)) continue;
                        const n = t1.getLayerSourceCache(r), s = n ? i[n.id] : void 0;
                        ("model" === r.type || s && s.length) && o.renderLayer(o, n, r, s);
                    }
                }
                o.currentShadowCascade = 0;
            }
            drawGroundShadows() {
                if (!this.enabled) return;
                const e1 = this.painter, t1 = e1.style, i = e1.context, o = i.gl, r = t1.directionalLight, n = t1.ambientLight;
                if (!r || !n) return;
                const s = [], a = ao(e1, e1.longestCutoffRange);
                a.shouldRenderCutoff && s.push("RENDER_CUTOFF"), s.push("RENDER_SHADOWS"), this.useNormalOffset && s.push("NORMAL_OFFSET");
                const l = fo(t1, r, n), c = new Hi(o.LEQUAL, Hi.ReadOnly, e1.depthRangeFor3D), h = new $i({
                    func: o.EQUAL,
                    mask: 255
                }, 0, 255, o.KEEP, o.KEEP, o.KEEP);
                for (const t1 of this._groundShadowTiles){
                    const r = t1.toUnwrapped(), n = e1.isTileAffectedByFog(t1), d = e1.getOrCreateProgram("groundShadow", {
                        defines: s,
                        overrideFog: n
                    });
                    this.setupShadows(r, d), e1.uploadCommonUniforms(i, d, r, null, a);
                    const _ = oo(e1.transform.calculateProjMatrix(r), l);
                    d.draw(e1, o.TRIANGLES, c, h, Zi.multiply, Ki.disabled, _, "ground_shadow", e1.tileExtentBuffer, e1.quadTriangleIndexBuffer, e1.tileExtentSegments, null, e1.transform.zoom, null, null);
                }
            }
            getShadowPassDepthMode() {
                return this._depthMode;
            }
            getGroundShadowLayerIndex() {
                return this._drawShadowAfterLayer;
            }
            calculateShadowPassMatrixFromTile(t1) {
                const i = this.painter.transform, o = i.calculatePosMatrix(t1, i.worldSize);
                return e1.aD(o, this._cascades[this.painter.currentShadowCascade].matrix, o), Float32Array.from(o);
            }
            calculateShadowPassMatrixFromMatrix(t1) {
                const i = e1.b9(t1);
                return e1.aD(i, this._cascades[this.painter.currentShadowCascade].matrix, t1), i;
            }
            setupShadows(t1, i, o) {
                if (!this.enabled) return;
                const r = this.painter.transform, n = this.painter.context, s = n.gl, a = this._uniformValues, l = new Float64Array(16), c = r.calculatePosMatrix(t1, r.worldSize);
                for(let t1 = 0; t1 < this._cascades.length; t1++)e1.aD(l, this._cascades[t1].matrix, c), a[0 === t1 ? "u_light_matrix_0" : "u_light_matrix_1"] = Float32Array.from(l), n.activeTexture.set(s.TEXTURE0 + 11 + t1), this._cascades[t1].texture.bindExtraParam(s.LINEAR, s.LINEAR, s.CLAMP_TO_EDGE, s.CLAMP_TO_EDGE, s.GREATER);
                if (this.useNormalOffset = !!o, this.useNormalOffset) {
                    const i = e1.cO(t1.canonical), n = 2 / r.tileSize * e1.an / lo, s = n * this._cascades[0].boundingSphereRadius, l = n * this._cascades[this._cascades.length - 1].boundingSphereRadius, c = ("vector-tile" === o ? 1 : 3) * function(t1) {
                        const i = e1.aC((t1 - 22) / -22, 0, 1);
                        return .125 * (1 - i) + 4 * i;
                    }(r.zoom);
                    a.u_shadow_normal_offset = [
                        i,
                        s * c,
                        l * c
                    ], a.u_shadow_bias = [
                        1e-4,
                        .0012,
                        .012
                    ];
                } else a.u_shadow_bias = [
                    36e-5,
                    .0012,
                    .012
                ];
                i.setShadowUniformValues(n, a);
            }
            setupShadowsFromMatrix(t1, i, o = !1) {
                if (!this.enabled) return;
                const r = this.painter.context, n = r.gl, s = this._uniformValues, a = new Float64Array(16);
                for(let i = 0; i < 2; i++)e1.aD(a, this._cascades[i].matrix, t1), s[0 === i ? "u_light_matrix_0" : "u_light_matrix_1"] = Float32Array.from(a), r.activeTexture.set(n.TEXTURE0 + 11 + i), this._cascades[i].texture.bindExtraParam(n.LINEAR, n.LINEAR, n.CLAMP_TO_EDGE, n.CLAMP_TO_EDGE, n.GREATER);
                this.useNormalOffset = o, o ? (s.u_shadow_normal_offset = [
                    1,
                    3,
                    3
                ], s.u_shadow_bias = [
                    6e-5,
                    .0012,
                    .012
                ]) : s.u_shadow_bias = [
                    36e-5,
                    .0012,
                    .012
                ], i.setShadowUniformValues(r, s);
            }
            getShadowUniformValues() {
                return this._uniformValues;
            }
            getCurrentCascadeFrustum() {
                return this._cascades[this.painter.currentShadowCascade].frustum;
            }
            computeSimplifiedTileShadowVolume(t1, i, o, r) {
                if (r[2] >= 0) return {};
                const n = (function(t1, i, o) {
                    const r = o / (1 << t1.canonical.z);
                    return new e1.cQ([
                        t1.canonical.x * r + t1.wrap * o,
                        t1.canonical.y * r + t1.wrap * o,
                        0
                    ], [
                        (t1.canonical.x + 1) * r + t1.wrap * o,
                        (t1.canonical.y + 1) * r + t1.wrap * o,
                        i
                    ]);
                })(t1, i, o).getCorners(), s = i / -r[2];
                r[0] < 0 ? (e1.cP(n[0], n[0], [
                    r[0] * s,
                    0,
                    0
                ]), e1.cP(n[3], n[3], [
                    r[0] * s,
                    0,
                    0
                ])) : r[0] > 0 && (e1.cP(n[1], n[1], [
                    r[0] * s,
                    0,
                    0
                ]), e1.cP(n[2], n[2], [
                    r[0] * s,
                    0,
                    0
                ])), r[1] < 0 ? (e1.cP(n[0], n[0], [
                    0,
                    r[1] * s,
                    0
                ]), e1.cP(n[1], n[1], [
                    0,
                    r[1] * s,
                    0
                ])) : r[1] > 0 && (e1.cP(n[2], n[2], [
                    0,
                    r[1] * s,
                    0
                ]), e1.cP(n[3], n[3], [
                    0,
                    r[1] * s,
                    0
                ]));
                const a = {};
                return a.vertices = n, a.planes = [
                    uo(n[1], n[0], n[4]),
                    uo(n[2], n[1], n[5]),
                    uo(n[3], n[2], n[6]),
                    uo(n[0], n[3], n[7])
                ], a;
            }
            addShadowReceiver(t1, i, o) {
                this._receivers.add(t1, e1.cQ.fromTileIdAndHeight(t1, i, o));
            }
            getMaxCascadeForTile(e1) {
                const t1 = this._receivers.get(e1);
                return t1 && t1.lastCascade ? t1.lastCascade : 0;
            }
        }
        function uo(t1, i, o) {
            const r = e1.ax([], o, i), n = e1.ax([], t1, i), s = e1.bi([], r, n), a = e1.ai(s);
            return 0 === a ? [
                0,
                0,
                1,
                0
            ] : (e1.bK(s, s, 1 / a), [
                s[0],
                s[1],
                s[2],
                -e1.bj(s, i)
            ]);
        }
        function po(t1) {
            const i = t1.properties.get("direction"), o = e1.cL(i.x, i.y, i.z);
            o[2] = e1.aC(o[2], 0, 75);
            const r = e1.cN([
                o[0],
                o[1],
                o[2]
            ]);
            return e1.cM(r.x, r.y, r.z);
        }
        function fo(t1, i, o) {
            const r = "none" === i.properties.get("color-use-theme"), n = i.properties.get("color"), s = i.properties.get("intensity"), a = i.properties.get("direction"), l = [
                a.x,
                a.y,
                a.z
            ], c = "none" === o.properties.get("color-use-theme"), h = o.properties.get("color"), d = o.properties.get("intensity"), _ = Math.max(e1.bj([
                0,
                0,
                1
            ], l), 0), u = [
                0,
                0,
                0
            ];
            e1.bK(u, h.toPremultipliedRenderColor(c ? null : t1.getLut(i.scope)).toArray01Linear().slice(0, 3), d);
            const p = [
                0,
                0,
                0
            ];
            return e1.bK(p, n.toPremultipliedRenderColor(r ? null : t1.getLut(o.scope)).toArray01Linear().slice(0, 3), _ * s), e1.cS([
                u[0] > 0 ? u[0] / (u[0] + p[0]) : 0,
                u[1] > 0 ? u[1] / (u[1] + p[1]) : 0,
                u[2] > 0 ? u[2] / (u[2] + p[2]) : 0
            ]);
        }
        function mo(t1, i, o, r, n, s) {
            const a = t1.zoom, l = t1.scale, c = t1.worldSize, h = 1 / c, d = t1.aspect, _ = Math.sqrt(1 + d * d) * Math.tan(.5 * t1.fovX), u = _ * _, p = r - o, f = r + o;
            let m, g;
            u > p / f ? (m = r, g = r * _) : (m = .5 * f * (1 + u), g = .5 * Math.sqrt(p * p + 2 * (r * r + o * o) * u + f * f * u * u));
            const v = t1.projection.pixelsPerMeter(t1.center.lat, c), y = t1._camera.getCameraToWorldMercator(), x = [
                0,
                0,
                -m * h
            ];
            e1.ah(x, x, y);
            let b = g * h;
            const w = function(i) {
                return i[0] /= l, i[1] /= l, i[2] = e1.bV(i[2], t1._center.lat), i;
            }, T = t1._edgeInsets;
            if (!(0 === T.left && 0 === T.top && 0 === T.right && 0 === T.bottom || T.left === T.right && T.top === T.bottom)) {
                const i = t1._camera.getWorldToCamera(t1.worldSize, "meters" === t1.projection.zAxisUnit ? v : 1), n = t1._camera.getCameraToClipPerspective(t1._fov, t1.width / t1.height, o, r);
                n[8] = 2 * -t1.centerOffset.x / t1.width, n[9] = 2 * t1.centerOffset.y / t1.height;
                const s = new Float64Array(16);
                e1.cu(s, n, i);
                const l = new Float64Array(16);
                e1.b8(l, s);
                const h = e1.cg.fromInvProjectionMatrix(l, c, a, !0);
                for (const t1 of h.points){
                    const i = w(t1);
                    b = Math.max(b, e1.bL(e1.cR([], x, i)));
                }
            }
            b *= n / (n - 1);
            const E = Math.acos(i[2]), S = Math.atan2(-i[0], -i[1]), C = new io;
            C.position = x, C.setPitchBearing(E, S);
            const I = C.getWorldToCamera(c, v), R = b * c, D = Math.min(t1._mercatorZfromZoom(17) * c * -2, -2 * R), A = C.getCameraToClipOrthographic(-R, R, -R, R, D, (R + s * v) / i[2]), L = new Float64Array(16);
            e1.aD(L, A, I);
            const P = e1.cM(Math.floor(1e6 * x[0]) / 1e6 * c, Math.floor(1e6 * x[1]) / 1e6 * c, 0), O = .5 * n, M = [
                0,
                0,
                0
            ];
            e1.ah(M, P, L), e1.bK(M, M, O);
            const z = [
                Math.floor(M[0]),
                Math.floor(M[1]),
                Math.floor(M[2])
            ], F = [
                0,
                0,
                0
            ];
            e1.ax(F, M, z), e1.bK(F, F, -1 / O);
            const B = new Float64Array(16);
            return e1.ba(B), e1.by(B, B, F), e1.aD(L, B, L), [
                L,
                R
            ];
        }
        class go extends e1.E {
            constructor(e1){
                super(), this.requestManager = e1, this.models = {
                    "": {}
                }, this.modelUris = {
                    "": {}
                }, this.modelByURL = {}, this.numModelsLoading = {};
            }
            loadModel(t1, i) {
                return e1.cT(this.requestManager.transformRequest(i, e1.R.Model).url).then((o)=>{
                    const r = e1.cU(o), n = new e1.cV(t1, i, void 0, void 0, r);
                    return n.computeBoundsAndApplyParent(), n;
                }).catch((o)=>{
                    if (o && 404 === o.status) return null;
                    this.fire(new e1.B(new Error(`Could not load model ${t1} from ${i}: ${o.message}`)));
                });
            }
            load(t1, i, o = {
                forceReload: !1
            }) {
                this.models[i] || (this.models[i] = {});
                const r = Object.keys(t1), n = [], s = [];
                for (const e1 of r){
                    const r = t1[e1];
                    this.hasURLBeenRequested(r) && !o.forceReload || (this.modelByURL[r] = {
                        modelId: e1,
                        scope: i
                    }, n.push(this.loadModel(e1, r)), s.push(e1)), this.models[i][e1] || (this.models[i][e1] = {
                        model: null,
                        numReferences: 1
                    });
                }
                this.numModelsLoading[i] = (this.numModelsLoading[i] || 0) + s.length, Promise.allSettled(n).then((t1)=>{
                    for(let e1 = 0; e1 < t1.length; e1++){
                        const { status: o } = t1[e1];
                        if ("rejected" === o) continue;
                        const { value: r } = t1[e1];
                        this.models[i][s[e1]] || (this.models[i][s[e1]] = {
                            model: null,
                            numReferences: 1
                        }), this.models[i][s[e1]].model = r;
                    }
                    this.numModelsLoading[i] -= s.length, this.fire(new e1.C("data", {
                        dataType: "style"
                    }));
                }).catch((t1)=>{
                    this.fire(new e1.B(new Error(`Could not load models: ${t1.message}`)));
                });
            }
            isLoaded() {
                for(const e1 in this.numModelsLoading)if (this.numModelsLoading[e1] > 0) return !1;
                return !0;
            }
            hasModel(e1, t1, i = {
                exactIdMatch: !1
            }) {
                return !!(i.exactIdMatch ? this.getModel(e1, t1) : this.getModelByURL(this.modelUris[t1][e1]));
            }
            getModel(e1, t1) {
                return this.models[t1] || (this.models[t1] = {}), this.models[t1][e1] ? this.models[t1][e1].model : void 0;
            }
            getModelByURL(e1) {
                if (!e1) return null;
                const t1 = this.modelByURL[e1];
                return t1 ? this.models[t1.scope][t1.modelId].model : null;
            }
            hasModelBeenAdded(e1, t1) {
                return this.models[t1] && void 0 !== this.models[t1][e1];
            }
            getModelURIs(e1) {
                return this.modelUris[e1] || {};
            }
            addModel(e1, t1, i) {
                this.models[i] || (this.models[i] = {}), this.modelUris[i] || (this.modelUris[i] = {});
                const o = this.requestManager.normalizeModelURL(t1);
                if ((this.hasModel(e1, i, {
                    exactIdMatch: !0
                }) || this.hasModelBeenAdded(e1, i)) && this.modelUris[i][e1] === o) this.models[i][e1].numReferences++;
                else if (this.hasURLBeenRequested(o)) {
                    const { scope: e1, modelId: t1 } = this.modelByURL[o];
                    this.models[e1][t1].numReferences++;
                } else this.modelUris[i][e1] = o, this.load({
                    [e1]: this.modelUris[i][e1]
                }, i);
            }
            addModelURLs(e1, t1) {
                this.models[t1] || (this.models[t1] = {}), this.modelUris[t1] || (this.modelUris[t1] = {});
                const i = this.modelUris[t1];
                for(const t1 in e1)i[t1] = this.requestManager.normalizeModelURL(e1[t1]);
            }
            reloadModels(e1) {
                this.load(this.modelUris[e1], e1, {
                    forceReload: !0
                });
            }
            addModelsFromBucket(t1, i) {
                this.models[i] || (this.models[i] = {}), this.modelUris[i] || (this.modelUris[i] = {});
                const o = {};
                for (const r of t1)this.hasModel(r, i, {
                    exactIdMatch: !0
                }) || this.hasURLBeenRequested(r) ? this.models[i][r].numReferences++ : this.modelUris[i][r] && !this.hasURLBeenRequested(r) ? o[r] = this.modelUris[i][r] : !this.hasURLBeenRequested(r) && e1.cW(r, !1) && (this.modelUris[i][r] = this.requestManager.normalizeModelURL(r), o[r] = this.modelUris[i][r]);
                this.load(o, i);
            }
            hasURLBeenRequested(e1) {
                return void 0 !== this.modelByURL[e1];
            }
            removeModel(e1, t1, i = !1, o = !1) {
                if (this.models[t1] && this.models[t1][e1] && (this.models[t1][e1].numReferences--, 0 === this.models[t1][e1].numReferences || o)) {
                    const o = this.modelUris[t1][e1];
                    i || delete this.modelUris[t1][e1], delete this.modelByURL[o];
                    const r = this.models[t1][e1].model;
                    if (!r) return;
                    delete this.models[t1][e1], r.destroy();
                }
            }
            destroy() {
                for (const e1 of Object.keys(this.models))for (const t1 of Object.keys(this.models[e1])){
                    const i = this.models[e1][t1].model;
                    delete this.models[e1][t1], i && i.destroy();
                }
                this.models = {
                    "": {}
                }, this.modelUris = {
                    "": {}
                }, this.modelByURL = {}, this.numModelsLoading = {};
            }
            listModels(e1) {
                return this.models[e1] || (this.models[e1] = {}), Object.keys(this.models[e1]);
            }
            upload(e1, t1) {
                this.models[t1] || (this.models[t1] = {});
                for(const i in this.models[t1])this.models[t1][i].model && this.models[t1][i].model.upload(e1.context);
            }
        }
        const vo = e1.a8.colorTheme, yo = new e1.ab({
            data: new e1.ac(vo.data)
        });
        function xo(t1) {
            if (!t1.metadata || !t1.metadata.content_area) return;
            const i = e1.o.devicePixelRatio, { left: o, top: r, width: n, height: s } = t1.metadata.content_area, a = o * i, l = r * i;
            return [
                a,
                l,
                a + n * i,
                l + s * i
            ];
        }
        function bo(t1) {
            if (t1) return t1.map(([t1, i])=>[
                    t1 * e1.o.devicePixelRatio,
                    i * e1.o.devicePixelRatio
                ]);
        }
        class wo {
            constructor(e1, t1, i){
                this.id = e1, this.scope = t1, this.sourceCache = i, this.pendingRequests = new Set, this.missingRequests = new Set;
            }
            addPendingRequest(e1) {
                this.missingRequests.has(e1.name) || this.pendingRequests.has(e1.name) || this.pendingRequests.add(e1.name);
            }
            hasPendingRequests() {
                return this.pendingRequests.size > 0;
            }
            resolvePendingRequests() {
                const t1 = new Map;
                if (!this.sourceCache.loaded()) return t1;
                const i = this.sourceCache.getVisibleCoordinates();
                if (0 === i.length) return t1;
                const o = this.sourceCache.getSource();
                if (!(o instanceof Tt)) return t1;
                const r = i.map((e1)=>this.sourceCache.getTile(e1)), n = o.getImages(r, Array.from(this.pendingRequests));
                for (const [i, o] of n)t1.set(e1.I.from({
                    name: i,
                    iconsetId: this.id
                }), o), this.pendingRequests.delete(i);
                for (const e1 of this.pendingRequests)this.missingRequests.add(e1);
                return this.pendingRequests.clear(), t1;
            }
        }
        class To {
            constructor(){
                this._previousClosestBuildingId = null, this._hysteresisRatio = .8, this._indoorMinimumZoom = 16;
            }
            findClosestBuilding(e1, t1, i, o, r) {
                if (i < this._indoorMinimumZoom) return this._previousClosestBuildingId = null, null;
                let n = null, s = Number.MAX_VALUE, a = Number.MAX_VALUE, l = !1;
                const c = this._previousClosestBuildingId ? e1[this._previousClosestBuildingId] : null;
                this._previousClosestBuildingId && c && this._isBuildingVisible(c, o, r) && (l = !0, a = this._calculateDistance(t1, c));
                for (const [i, a] of Object.entries(e1)){
                    if (!this._isBuildingVisible(a, o, r)) continue;
                    const e1 = this._calculateDistance(t1, a);
                    e1 < s && (s = e1, n = i);
                }
                return l && n && this._previousClosestBuildingId && n !== this._previousClosestBuildingId ? s > a * this._hysteresisRatio && (n = this._previousClosestBuildingId) : l && !n && (n = this._previousClosestBuildingId), this._previousClosestBuildingId = n, n;
            }
            _calculateDistance(e1, t1) {
                if (!t1.center) return Number.MAX_VALUE;
                const i = e1.lat - t1.center[1], o = e1.lng - t1.center[0];
                return i * i + o * o;
            }
            _isBuildingVisible(t1, i, o) {
                if (!o) return !1;
                for (const i of t1.floorIds){
                    const r = t1.floors[i];
                    if (!r.geometry) continue;
                    const n = r.geometry;
                    if ("Polygon" === n.type) {
                        const t1 = this._convertRingToPoints(n.coordinates[0]);
                        if (e1.bx(t1, o)) return !0;
                    } else if ("MultiPolygon" === n.type) {
                        const t1 = this._convertMultiPolygonToPoints(n.coordinates);
                        if (e1.cY(o, t1)) return !0;
                    }
                }
                return !1;
            }
            _convertRingToPoints(t1) {
                return t1.map((t1)=>new e1.P(t1[0], t1[1]));
            }
            _convertMultiPolygonToPoints(t1) {
                return t1.map((t1)=>0 === t1.length ? [] : t1[0].map((t1)=>new e1.P(t1[0], t1[1])));
            }
        }
        class Eo extends e1.E {
            constructor(t1){
                super(), this._style = t1, this._buildings = {}, this._activeFloors = new Set, this._closestBuildingId = null, this._indoorState = {
                    selectedFloorId: null,
                    activeFloorsVisible: !0,
                    activeFloors: this._activeFloors
                }, this._buildingDetectionStrategy = new To, this._initialLoadDone = !1, e1.a_([
                    "_updateUI"
                ], this), this._style.on("style.load", ()=>{
                    this._style.isIndoorEnabled() && (this._style.map.on("load", ()=>{
                        this._initialLoadDone = !0, this._indoorState && this._indoorState.needsUpdate && (this._indoorState.needsUpdate = !1, this._style.updateIndoorDependentLayers()), this._updateUI();
                    }), this._style.map.on("move", this._updateUI), this._style.map.on("idle", this._updateUI));
                });
            }
            destroy() {
                this._buildings = {}, this._activeFloors = new Set, this._indoorState = null;
            }
            selectFloor(e1) {
                e1 === this._selectedFloorId && this._indoorState && this._indoorState.activeFloorsVisible || (this._selectedFloorId = e1, this._recalculateActiveFloors());
            }
            setActiveFloorsVisibility(e1) {
                this._updateActiveFloors(e1), this._updateIndoorSelector();
            }
            setIndoorData(e1) {
                let t1 = !1;
                for (const [i, o] of Object.entries(e1.buildings))if (this._buildings[i]) for (const e1 of o.floorIds)this._buildings[i].floorIds.add(e1), this._buildings[i].floors[e1] ? this._mergeFloors(this._buildings[i].floors[e1], o.floors[e1]) : (this._buildings[i].floors[e1] = o.floors[e1], this._buildings[i].floorIds.add(e1), t1 = !0);
                else this._buildings[i] = o, t1 = !0;
                t1 && this._recalculateActiveFloors();
            }
            getIndoorTileOptions(e1, t1) {
                return this._indoorState ? {
                    sourceLayers: this._style.getIndoorSourceLayers(e1, t1),
                    indoorState: this._indoorState
                } : null;
            }
            getControlState() {
                const e1 = this._buildings, t1 = this._closestBuildingId, i = t1 && e1 ? e1[t1] : void 0;
                if (!i) return {
                    selectedFloorId: null,
                    activeFloorsVisible: !!this._indoorState && this._indoorState.activeFloorsVisible,
                    floors: []
                };
                let o = null;
                for (const e1 of i.floorIds)if (this._activeFloors && this._activeFloors.has(e1)) {
                    o = e1;
                    break;
                }
                const r = Array.from(i.floorIds).map((e1)=>({
                        id: e1,
                        name: i.floors[e1].name,
                        zIndex: i.floors[e1].zIndex
                    })).sort((e1, t1)=>t1.zIndex - e1.zIndex).filter((e1, t1, i)=>0 === t1 || e1.zIndex !== i[t1 - 1].zIndex);
                return {
                    selectedFloorId: o,
                    activeFloorsVisible: !!this._indoorState && this._indoorState.activeFloorsVisible,
                    floors: r
                };
            }
            _updateUI() {
                this._initialLoadDone = !0;
                const e1 = this._style.map.transform, t1 = this._buildingDetectionStrategy.findClosestBuilding(this._buildings, e1.center, e1.zoom, e1.getBounds(), this._makeViewportPolygon());
                if (t1 !== this._closestBuildingId) {
                    const e1 = this._closestBuildingId;
                    this._closestBuildingId = t1, this._onBuildingTransition(e1, t1), this._updateIndoorSelector();
                }
            }
            _onBuildingTransition(e1, t1) {
                if (!this._indoorState) return;
                const i = !!t1 && !e1;
                !t1 && e1 ? (this._indoorState.activeFloors = new Set, this._indoorState.activeFloorsVisible = !1, this._style.updateIndoorDependentLayers()) : i && (this._recalculateActiveFloors(), this._updateActiveFloors(!0));
            }
            _updateIndoorSelector() {
                this.fire(new e1.C("selector-update", this.getControlState()));
            }
            _updateActiveFloors(e1) {
                this._indoorState = {
                    selectedFloorId: this._selectedFloorId,
                    activeFloorsVisible: e1,
                    activeFloors: this._activeFloors
                }, this._initialLoadDone ? this._style.updateIndoorDependentLayers() : this._indoorState.needsUpdate = !0;
            }
            _recalculateActiveFloors() {
                if (!this._buildings) return;
                const t1 = e1.cZ.calculate(this._buildings, this._selectedFloorId, this._activeFloors);
                (function(e1, t1) {
                    if (e1 === t1) return !0;
                    if (!e1 || !t1) return !1;
                    if (e1.size !== t1.size) return !1;
                    for (const i of e1)if (!t1.has(i)) return !1;
                    return !0;
                })(t1, this._activeFloors) || (this._activeFloors = t1, this._updateActiveFloors(!!this._indoorState && this._indoorState.activeFloorsVisible), this._updateIndoorSelector());
            }
            _mergeFloors(e1, t1) {
                t1.geometry && (e1.geometry ? ("Polygon" === e1.geometry.type && (e1.geometry = {
                    type: "MultiPolygon",
                    coordinates: [
                        e1.geometry.coordinates
                    ]
                }), "Polygon" === t1.geometry.type ? e1.geometry.coordinates.push(t1.geometry.coordinates) : "MultiPolygon" === t1.geometry.type && e1.geometry.coordinates.push(...t1.geometry.coordinates)) : e1.geometry = t1.geometry);
            }
            _makeViewportPolygon() {
                const t1 = this._style.map.transform, i = t1.width, o = t1.height;
                return [
                    t1.pointLocation(new e1.P(0, 0)),
                    t1.pointLocation(new e1.P(i, 0)),
                    t1.pointLocation(new e1.P(i, o)),
                    t1.pointLocation(new e1.P(0, o))
                ].map((t1)=>new e1.P(t1.lng, t1.lat));
            }
        }
        const So = (e1, t1)=>qe(e1, t1 && t1.filter((e1)=>"source.canvas" !== e1.identifier)), Co = e1.aJ(Vt, [
            "addLayer",
            "removeLayer",
            "setLights",
            "setPaintProperty",
            "setLayoutProperty",
            "setLayerProperty",
            "setSlot",
            "setFilter",
            "addSource",
            "removeSource",
            "setLayerZoomRange",
            "setLight",
            "setTransition",
            "setGeoJSONSourceData",
            "setTerrain",
            "setFog",
            "setSnow",
            "setRain",
            "setProjection",
            "setCamera",
            "addImport",
            "removeImport",
            "updateImport",
            "addIconset",
            "removeIconset"
        ]), Io = e1.aJ(Vt, [
            "setCenter",
            "setZoom",
            "setBearing",
            "setPitch"
        ]), Ro = new Set([
            "background",
            "sky",
            "slot",
            "custom"
        ]), Do = {
            version: 8,
            layers: [],
            sources: {}
        }, Ao = {
            duration: 300,
            delay: 0
        };
        class Lo extends e1.E {
            constructor(t1, i = {}){
                if (super(), this.map = t1, this.scope = i.scope || "", this.globalId = null, this.fragments = [], this.importDepth = i.importDepth || 0, this.importsCache = i.importsCache || new Map, this.resolvedImports = i.resolvedImports || new Set, this.transition = Object.assign({}, Ao), this._buildingIndex = new kt(this), this.crossTileSymbolIndex = new Gi, this._mergedOrder = [], this._drapedFirstOrder = [], this._mergedLayers = {}, this._mergedIndoor = {}, this._mergedSourceCaches = {}, this._mergedOtherSourceCaches = {}, this._mergedSymbolSourceCaches = {}, this._mergedFillExtrusionSourceCaches = {}, this._clipLayerPresent = !1, this._hasAppearances = !1, this._has3DLayers = !1, this._hasCircleLayers = !1, this._hasSymbolLayers = !1, this._importedAsBasemap = !1, this._changes = i.styleChanges || new W, this._hasDataDrivenEmissive = !1, this.indoorManager = new Eo(this), this.dispatcher = i.dispatcher ? i.dispatcher : new J(ie(), this), this.map.painter && this.map.painter.context) {
                    const e1 = this.map.painter.context.maxUniformBufferBindings, t1 = Math.floor(this.map.painter.context.maxUniformBlockSize / 4);
                    this.dispatcher.broadcast("setContextParams", {
                        maxBindingPoints: e1,
                        maxUniformBlockSizeDwords: t1,
                        disableSymbolUBO: this.map.painter.context.disableSymbolUBO
                    });
                }
                i.imageManager ? this.imageManager = i.imageManager : (this.imageManager = new oe(this.map._spriteFormat), this.imageManager.setEventedParent(this)), this.imageManager.addScope(this.scope), this.glyphManager = i.glyphManager ? i.glyphManager : new e1.c_(t1._requestManager, i.localFontFamily ? e1.c$.all : i.localIdeographFontFamily ? e1.c$.ideographs : e1.c$.none, i.localFontFamily || i.localIdeographFontFamily), i.modelManager ? this.modelManager = i.modelManager : (this.modelManager = new go(t1._requestManager), this.modelManager.setEventedParent(this)), this._layers = {}, this._sourceCaches = {}, this._otherSourceCaches = {}, this._symbolSourceCaches = {}, this._fillExtrusionSourceCaches = {}, this._loaded = !1, this._precompileDone = !1, this._shouldPrecompile = !1, this._availableImages = [], this._availableModels = {}, this._order = [], this._markersNeedUpdate = !1, this.options = i.configOptions ? i.configOptions : new Map, this._configDependentLayers = i.configDependentLayers ? i.configDependentLayers : new Set, this._indoorDependentLayers = i.indoorDependentLayers ? i.indoorDependentLayers : new Set, this._config = i.config, this._styleColorTheme = {
                    lut: null,
                    lutLoading: !1,
                    lutLoadingCorrelationID: 0,
                    colorTheme: null,
                    colorThemeOverride: i.colorThemeOverride
                }, this._styleColorThemeForScope = {}, this._initialConfig = i.initialConfig, this.dispatcher.broadcast("setReferrer", e1.d0()), this.dispatcher.broadcast("setConfig", e1.d1());
                const o = this;
                this._rtlTextPluginCallback = Lo.registerForPluginStateChange((t1)=>{
                    o.dispatcher.broadcast("syncRTLPluginState", {
                        pluginStatus: t1.pluginStatus,
                        pluginURL: t1.pluginURL
                    }, (t1, i)=>{
                        if (e1.d2(t1), i && i.every((e1)=>e1)) for(const e1 in o._sourceCaches){
                            const t1 = o._sourceCaches[e1], i = t1.getSource().type;
                            "vector" !== i && "geojson" !== i || t1.reload();
                        }
                    });
                }), this.on("data", (e1)=>{
                    if ("source" !== e1.dataType || "metadata" !== e1.sourceDataType) return;
                    const t1 = this.getOwnSource(e1.sourceId);
                    if (t1 && t1.vectorLayerIds) for(const e1 in this._layers){
                        const i = this._layers[e1];
                        i.source === t1.id && this._validateLayer(i);
                    }
                });
            }
            load(e1) {
                return e1 ? ("string" == typeof e1 ? this.loadURL(e1) : this.loadJSON(e1), this) : this;
            }
            _getGlobalId(t1) {
                if (!t1) return null;
                if ("string" == typeof t1) {
                    if (e1.h(t1)) return t1;
                    const i = e1.d3(t1);
                    if (!i.startsWith("http")) try {
                        return new URL(i, location.href).toString();
                    } catch (e1) {
                        return i;
                    }
                    return i;
                }
                return `json://${e1.d4(JSON.stringify(t1))}`;
            }
            _diffStyle(t1, i, o) {
                this.globalId = this._getGlobalId(t1);
                const r = (e1, t1)=>{
                    try {
                        t1(null, this.setState(e1, o));
                    } catch (e1) {
                        t1(e1, !1);
                    }
                };
                if ("string" == typeof t1) {
                    const o = this.map._requestManager.normalizeStyleURL(t1), n = this.map._requestManager.transformRequest(o, e1.R.Style);
                    e1.m(n, (t1, o)=>{
                        t1 ? this.fire(new e1.B(t1)) : o && r(o, i);
                    });
                } else "object" == typeof t1 && r(t1, i);
            }
            loadURL(t1, i = {}) {
                this.fire(new e1.C("dataloading", {
                    dataType: "style"
                }));
                const o = "boolean" == typeof i.validate ? i.validate : !e1.h(t1);
                this.globalId = this._getGlobalId(t1), t1 = this.map._requestManager.normalizeStyleURL(t1, i.accessToken), this.resolvedImports.add(t1);
                const r = this.importsCache.get(t1);
                if (r) return this._load(r, o);
                const n = this.map._requestManager.transformRequest(t1, e1.R.Style);
                this._request = e1.m(n, (i, r)=>{
                    if (this._request = null, i) this.fire(new e1.B(i));
                    else if (r) return this.importsCache.set(t1, r), this._load(r, o);
                });
            }
            loadJSON(t1, i = {}) {
                this.fire(new e1.C("dataloading", {
                    dataType: "style"
                })), this.globalId = this._getGlobalId(t1), this._request = e1.o.frame(()=>{
                    this._request = null, this._load(t1, !1 !== i.validate);
                });
            }
            loadEmpty() {
                this.fire(new e1.C("dataloading", {
                    dataType: "style"
                })), this._load(Do, !1);
            }
            _loadImports(t1, i, o) {
                if (this.importDepth >= 4) return e1.w("Style doesn't support nesting deeper than 5"), Promise.resolve();
                const r = [];
                for (const n of t1){
                    const t1 = this._createFragmentStyle(n), s = new Promise((e1)=>{
                        t1.once("style.import.load", e1), t1.once("error", e1);
                    }).then(()=>{
                        this.mergeAll(), this.fire(new e1.C("data", {
                            dataType: "style"
                        }));
                    });
                    if (r.push(s), this.resolvedImports.has(n.url)) {
                        t1.loadEmpty();
                        continue;
                    }
                    const a = n.data || this.importsCache.get(n.url);
                    a ? (n.data ? (t1.fire(new e1.C("dataloading", {
                        dataType: "style"
                    })), t1.globalId = t1._getGlobalId(a), queueMicrotask(()=>t1._load(a, i))) : t1.loadJSON(a, {
                        validate: i
                    }), this._isInternalStyle(a) && (t1.globalId = null)) : n.url ? t1.loadURL(n.url, {
                        validate: i
                    }) : t1.loadEmpty();
                    const l = {
                        style: t1,
                        id: n.id,
                        config: n.config
                    };
                    if (o) {
                        const e1 = this.fragments.findIndex(({ id: e1 })=>e1 === o);
                        this.fragments = this.fragments.slice(0, e1).concat(l).concat(this.fragments.slice(e1));
                    } else this.fragments.push(l);
                }
                return Promise.allSettled(r);
            }
            getImportGlobalIds(e1 = this, t1 = new Set) {
                for (const i of e1.fragments)i.style.globalId && t1.add(i.style.globalId), this.getImportGlobalIds(i.style, t1);
                return [
                    ...t1.values()
                ];
            }
            _createFragmentStyle(t1) {
                const i = this.scope ? e1.F(t1.id, this.scope) : t1.id;
                let o;
                const r = this._initialConfig && this._initialConfig[i];
                (t1.config || r) && (o = Object.assign({}, t1.config, r));
                const n = new Lo(this.map, {
                    scope: i,
                    styleChanges: this._changes,
                    importDepth: this.importDepth + 1,
                    importsCache: this.importsCache,
                    resolvedImports: new Set(this.resolvedImports),
                    dispatcher: this.dispatcher,
                    imageManager: this.imageManager,
                    glyphManager: this.glyphManager,
                    modelManager: this.modelManager,
                    config: o,
                    configOptions: this.options,
                    colorThemeOverride: t1["color-theme"],
                    configDependentLayers: this._configDependentLayers,
                    indoorDependentLayers: this._indoorDependentLayers
                });
                return n.setEventedParent(this.map, {
                    style: n
                }), n;
            }
            _reloadImports() {
                this.mergeAll(), this._updateMapProjection(), this.updateConfigDependencies(), this._updateLayers(this._indoorDependentLayers), this.map._triggerCameraUpdate(this.camera), this.dispatcher.broadcast("setLayers", {
                    layers: this._serializeLayers(this._order),
                    scope: this.scope,
                    options: this.options
                }), this._shouldPrecompile = this.map._precompilePrograms && this.isRootStyle();
            }
            _isInternalStyle(e1) {
                return this.isRootStyle() && (e1.fragment || !!e1.schema && !1 !== e1.fragment);
            }
            _load(t1, i) {
                if (this._isInternalStyle(t1)) {
                    const e1 = Object.assign({}, Do, {
                        imports: [
                            {
                                id: "basemap",
                                data: t1,
                                url: ""
                            }
                        ]
                    }, t1.center ? {
                        center: t1.center
                    } : {}, t1.bearing ? {
                        bearing: t1.bearing
                    } : {}, t1.pitch ? {
                        pitch: t1.pitch
                    } : {}, t1.zoom ? {
                        zoom: t1.zoom
                    } : {}, t1.light ? {
                        light: t1.light
                    } : {});
                    return this._importedAsBasemap = !0, void this._load(e1, i);
                }
                if (this.updateConfig(this._config, t1.schema), i && So(this, Ae(t1))) return;
                this._loaded = !0;
                for(const e1 in t1.sources)this.addSource(e1, t1.sources[e1], {
                    validate: !1,
                    isInitialLoad: !0
                });
                this.stylesheet = e1.d5(t1);
                const o = ()=>{
                    if (t1.iconsets) for(const e1 in t1.iconsets)this.addIconset(e1, t1.iconsets[e1]);
                    t1.sprite ? this._loadIconset(t1.sprite) : (this.imageManager.setLoaded(!0, this.scope), this.dispatcher.broadcast("spriteLoaded", {
                        scope: this.scope,
                        isLoaded: !0
                    })), !this.glyphManager.url && t1.glyphs && this.glyphManager.setURL(t1.glyphs);
                    const o = Ut(this.stylesheet.layers);
                    if (this._order = o.map((e1)=>e1.id), this.stylesheet.light && e1.w("The `light` root property is deprecated, prefer using `lights` with `flat` light type instead."), this.stylesheet.lights) {
                        if (1 === this.stylesheet.lights.length && "flat" === this.stylesheet.lights[0].type) {
                            const e1 = this.stylesheet.lights[0];
                            this.light = new We(e1.properties, e1.id);
                        } else this.setLights(this.stylesheet.lights);
                    }
                    this.light || (this.light = new We(this.stylesheet.light)), this._layers = {};
                    for (const t1 of o){
                        const i = e1.da(t1, this.scope, this._styleColorTheme.lut, this.options);
                        0 !== i.expressionDependencies.configDependencies.size && this._configDependentLayers.add(i.fqid), i.expressionDependencies.isIndoorDependent && this._indoorDependentLayers.add(i.fqid), this._hasAppearances = this._hasAppearances || 0 !== i.getAppearances().length, i.setEventedParent(this, {
                            layer: {
                                id: i.id
                            }
                        }), this._layers[i.id] = i;
                        const o = this.getOwnLayerSourceCache(i), r = !!this.directionalLight && this.directionalLight.shadowsEnabled();
                        o && i.canCastShadows() && r && (o.castsShadows = !0);
                    }
                    if (this.glyphManager.url) {
                        const e1 = new Set;
                        for(const t1 in this._layers){
                            const i = this._layers[t1];
                            if ("symbol" === i.type && i.layout) {
                                const t1 = i.layout.get("text-font");
                                t1 && t1.value && "constant" === t1.value.kind && e1.add(t1.value.value.join(","));
                            }
                        }
                        for (const t1 of e1)this.glyphManager.prefetchRange(t1, 0);
                    }
                    this.stylesheet.featuresets && this.setFeaturesetSelectors(this.stylesheet.featuresets), this.stylesheet.models && this.addModelURLs(this.stylesheet.models);
                    const r = this.stylesheet.terrain;
                    r && (this.checkCanvasFingerprintNoise(), this.disableElevatedTerrain || this.terrainSetForDrapingOnly() || this._createTerrain(r, 1)), this.stylesheet.fog && this._createFog(this.stylesheet.fog), this.stylesheet.snow && this._createSnow(this.stylesheet.snow), this.stylesheet.rain && this._createRain(this.stylesheet.rain), this.stylesheet.transition && this.setTransition(this.stylesheet.transition), this.fire(new e1.C("data", {
                        dataType: "style"
                    }));
                    const n = this.isRootStyle();
                    t1.imports ? this._loadImports(t1.imports, i).then(()=>{
                        this._reloadImports(), this.fire(new e1.C(n ? "style.load" : "style.import.load"));
                    }).catch((t1)=>{
                        this.fire(new e1.B(new Error("Failed to load imports", t1))), this.fire(new e1.C(n ? "style.load" : "style.import.load"));
                    }) : (this._reloadImports(), this.fire(new e1.C(n ? "style.load" : "style.import.load")));
                };
                this._styleColorTheme.colorTheme = this.stylesheet["color-theme"];
                const r = this._styleColorTheme.colorThemeOverride ? this._styleColorTheme.colorThemeOverride : this._styleColorTheme.colorTheme;
                if (r) {
                    const t1 = this._evaluateColorThemeData(r);
                    this._loadColorTheme(t1).then(()=>{
                        o();
                    }).catch((t1)=>{
                        e1.w(`Couldn't load color theme from the stylesheet: ${t1}`), o();
                    });
                } else this._styleColorTheme.lut = null, o();
            }
            isRootStyle() {
                return 0 === this.importDepth;
            }
            hasAppearances() {
                return this._hasAppearances || this.fragments.some((e1)=>e1.style.hasAppearances());
            }
            mergeAll() {
                let e1, t1, i, o, r, n, s, a, l, c;
                const h = {};
                this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((d)=>{
                    if (d.stylesheet) {
                        if (null != d.light && (e1 = d.light), d.stylesheet.lights) for (const e1 of d.stylesheet.lights)"ambient" === e1.type && null != d.ambientLight && (t1 = d.ambientLight), "directional" === e1.type && null != d.directionalLight && (i = d.directionalLight);
                        o = this._prioritizeTerrain(o, d.terrain, d.stylesheet.terrain), d.stylesheet.fog && null != d.fog && (r = d.fog), d.stylesheet.snow && null != d.snow && (n = d.snow), d.stylesheet.rain && null != d.rain && (s = d.rain), null != d.stylesheet.camera && (c = d.stylesheet.camera), null != d.stylesheet.projection && (a = d.stylesheet.projection), null != d.stylesheet.transition && (l = d.stylesheet.transition), h[d.scope] = d._styleColorTheme;
                    }
                }), this.light = e1, this.ambientLight = t1, this.directionalLight = i, this.fog = r, this.snow = n, this.rain = s, this._styleColorThemeForScope = h, null === o ? delete this.terrain : this.terrain = o, this.camera = c || {
                    "camera-projection": "perspective"
                }, this.projection = a || {
                    name: "mercator"
                }, this.transition = Object.assign({}, Ao, l), this.mergeSources(), this.mergeLayers(), this.mergeIndoor();
            }
            forEachFragmentStyle(e1) {
                const t1 = (i)=>{
                    for (const e1 of i.fragments)t1(e1.style);
                    e1(i);
                };
                t1(this);
            }
            _prioritizeTerrain(e1, t1, i) {
                const o = e1 && 0 === e1.drapeRenderMode;
                return null === i ? t1 && 0 === t1.drapeRenderMode ? t1 : o ? e1 : null : null != t1 && (!e1 || o || t1 && 1 === t1.drapeRenderMode) ? t1 : e1;
            }
            mergeTerrain() {
                let e1;
                this.terrain && this.terrain.scope !== this.scope && delete this.terrain, this.forEachFragmentStyle((t1)=>{
                    e1 = this._prioritizeTerrain(e1, t1.terrain, t1.stylesheet.terrain);
                }), null === e1 ? delete this.terrain : this.terrain = e1;
            }
            mergeProjection() {
                let e1;
                this.forEachFragmentStyle((t1)=>{
                    null != t1.stylesheet.projection && (e1 = t1.stylesheet.projection);
                }), this.projection = e1 || {
                    name: "mercator"
                };
            }
            mergeSources() {
                const t1 = {}, i = {}, o = {}, r = {};
                this.forEachFragmentStyle((n)=>{
                    for(const i in n._sourceCaches){
                        const o = e1.F(i, n.scope);
                        t1[o] = n._sourceCaches[i];
                    }
                    for(const t1 in n._otherSourceCaches){
                        const o = e1.F(t1, n.scope);
                        i[o] = n._otherSourceCaches[t1];
                    }
                    for(const t1 in n._symbolSourceCaches){
                        const i = e1.F(t1, n.scope);
                        o[i] = n._symbolSourceCaches[t1];
                    }
                    for(const t1 in n._fillExtrusionSourceCaches){
                        const i = e1.F(t1, n.scope);
                        r[i] = n._fillExtrusionSourceCaches[t1];
                    }
                }), this._mergedSourceCaches = t1, this._mergedOtherSourceCaches = i, this._mergedSymbolSourceCaches = o, this._mergedFillExtrusionSourceCaches = r;
            }
            mergeIndoor() {
                this.forEachFragmentStyle((t1)=>{
                    if (t1.stylesheet && t1.stylesheet.indoor) for (const i of Object.values(t1.stylesheet.indoor)){
                        const o = i, r = e1.F(o.sourceId, t1.scope);
                        this._mergedIndoor[r] = new Set(o.sourceLayers || []);
                    }
                });
            }
            mergeLayers() {
                const t1 = {}, i = [], o = {};
                this._mergedSlots = [], this._has3DLayers = !1, this._hasCircleLayers = !1, this._hasSymbolLayers = !1, this.forEachFragmentStyle((o)=>{
                    for (const r of o._order){
                        const n = o._layers[r];
                        if ("slot" === n.type) {
                            const i = e1.d6(r);
                            if (t1[i]) continue;
                            t1[i] = [];
                        }
                        n.slot && t1[n.slot] ? t1[n.slot].push(n) : i.push(n);
                    }
                }), this._mergedOrder = [];
                let r = -1;
                const n = (i = [])=>{
                    for (const s of i)if ("slot" === s.type) {
                        const i = e1.d6(s.id);
                        t1[i] && n(t1[i]), this._mergedSlots.push(i);
                    } else {
                        const t1 = e1.F(s.id, s.scope);
                        this._mergedOrder.push(t1), o[t1] = s, s.is3D(!!this.terrain) && (this._has3DLayers = !0, r = this._mergedOrder.length - 1), "circle" === s.type && (this._hasCircleLayers = !0), "symbol" === s.type && (this._hasSymbolLayers = !0), "clip" === s.type && (this._clipLayerPresent = !0);
                    }
                };
                if (n(i), this._has3DLayers) {
                    const e1 = {};
                    for(let t1 = 0; t1 < this._mergedOrder.length; ++t1){
                        const i = this._mergedOrder[t1];
                        e1[i] = t1 === r ? 1 : t1 < r ? o[i].hasOcclusionOpacityProperties ? 2 : 0 : 4;
                    }
                    this._mergedOrder.sort((t1, i)=>e1[t1] - e1[i]);
                }
                this._mergedLayers = o, this.updateDrapeFirstLayers(), this._buildingIndex.processLayersChanged(), this._updateDataDrivenEmissiveStrength();
            }
            terrainSetForDrapingOnly() {
                return !!this.terrain && 0 === this.terrain.drapeRenderMode;
            }
            getCamera() {
                return this.stylesheet.camera;
            }
            setCamera(e1) {
                return this.stylesheet.camera = Object.assign({}, this.stylesheet.camera, e1), this.camera = this.stylesheet.camera, this;
            }
            _evaluateColorThemeData(t1) {
                return t1.data ? (function(t1, i, o) {
                    const r = Object.assign({}, i);
                    for (const e1 of Object.keys(vo))void 0 === r[e1] && (r[e1] = vo[e1].default);
                    const n = new e1.aa(yo, t1, new Map(o));
                    return n.setTransitionOrValue(r, o), n.untransitioned().possiblyEvaluate(new e1.ae(0, {
                        worldview: void 0
                    }));
                })(this.scope, t1, this.options).get("data") : null;
            }
            _loadColorTheme(t1) {
                this._styleColorTheme.lutLoading = !0, this._styleColorTheme.lutLoadingCorrelationID += 1;
                const i = this._styleColorTheme.lutLoadingCorrelationID;
                return new Promise((o, r)=>{
                    const n = "data:image/png;base64,";
                    if (!t1 || 0 === t1.length) return this._styleColorTheme.lut = null, this._styleColorTheme.lutLoading = !1, void o();
                    let s = t1;
                    s.startsWith(n) || (s = n + s);
                    const a = e1.I.from("mapbox-reserved-lut"), l = new Image;
                    l.src = s, l.onerror = ()=>{
                        this._styleColorTheme.lutLoading = !1, r(new Error("Failed to load image data"));
                    }, l.onload = ()=>{
                        if (this._styleColorTheme.lutLoadingCorrelationID !== i) return void o();
                        this._styleColorTheme.lutLoading = !1;
                        const { width: n, height: s, data: c } = e1.o.getImageData(l);
                        if (s > 32) return void r(new Error("The height of the image must be less than or equal to 32 pixels."));
                        if (n !== s * s) return void r(new Error("The width of the image must be equal to the height squared."));
                        this.getImage(a) && this.removeImage(a), this.addImage(a, {
                            data: new e1.q({
                                width: n,
                                height: s
                            }, c),
                            pixelRatio: 1,
                            sdf: !1,
                            usvg: !1,
                            version: 0
                        });
                        const h = this.imageManager.getImage(a, this.scope);
                        h ? (this._styleColorTheme.lut = {
                            image: h.data,
                            data: t1
                        }, o()) : r(new Error("Missing LUT image."));
                    };
                });
            }
            getLut(e1) {
                const t1 = this._styleColorThemeForScope[e1];
                return t1 ? t1.lut : null;
            }
            setProjection(e1) {
                e1 ? this.stylesheet.projection = e1 : delete this.stylesheet.projection, this.mergeProjection(), this._updateMapProjection();
            }
            applyProjectionUpdate() {
                this._loaded && (this.dispatcher.broadcast("setProjection", this.map.transform.projectionOptions), this.map.transform.projection.requiresDraping ? (this.getTerrain() || this.stylesheet.terrain) && !this.disableElevatedTerrain || this.setTerrainForDraping() : this.terrainSetForDrapingOnly() && this.setTerrain(null, 0));
            }
            _updateMapProjection() {
                this.isRootStyle() && (this.map._useExplicitProjection ? this.applyProjectionUpdate() : this.map._prioritizeAndUpdateProjection(null, this.projection));
            }
            _loadSprite(t1) {
                this._spriteRequest = function(t1, i, o) {
                    let r, n, s;
                    const a = e1.o.devicePixelRatio > 1 ? "@2x" : "";
                    let l = e1.m(i.transformRequest(i.normalizeSpriteURL(t1, a, ".json"), e1.R.SpriteJSON), (e1, t1)=>{
                        l = null, s || (s = e1, r = t1, h());
                    }), c = e1.n(i.transformRequest(i.normalizeSpriteURL(t1, a, ".png"), e1.R.SpriteImage), (e1, t1)=>{
                        c = null, s || (s = e1, n = t1, h());
                    });
                    function h() {
                        if (s) o(s);
                        else if (r && n) {
                            const t1 = e1.o.getImageData(n), i = {};
                            for(const o in r){
                                const { width: n, height: s, x: a, y: l, sdf: c, pixelRatio: h, stretchX: d, stretchY: _, content: u } = r[o], p = new e1.q({
                                    width: n,
                                    height: s
                                });
                                e1.q.copy(t1, p, {
                                    x: a,
                                    y: l
                                }, {
                                    x: 0,
                                    y: 0
                                }, {
                                    width: n,
                                    height: s
                                }, null), i[o] = {
                                    data: p,
                                    pixelRatio: void 0 !== h ? h : 1,
                                    sdf: void 0 !== c && c,
                                    stretchX: d,
                                    stretchY: _,
                                    content: u,
                                    usvg: !1,
                                    version: 0
                                };
                            }
                            o(null, i);
                        }
                    }
                    return {
                        cancel () {
                            l && (l.cancel(), l = null), c && (c.cancel(), c = null);
                        }
                    };
                }(t1, this.map._requestManager, (t1, i)=>{
                    if (this._spriteRequest = null, t1) this.fire(new e1.B(t1));
                    else if (i) {
                        const t1 = new Map;
                        for(const o in i)t1.set(e1.I.from(o), i[o]);
                        this.addImages(t1);
                    }
                    this.imageManager.setLoaded(!0, this.scope), this.dispatcher.broadcast("spriteLoaded", {
                        scope: this.scope,
                        isLoaded: !0
                    }), this.fire(new e1.C("data", {
                        dataType: "style"
                    }));
                });
            }
            addIconset(t1, i) {
                if ("sprite" === i.type) return void this._loadSprite(i.url);
                const o = this.getOwnSourceCache(i.source);
                if (!o) return void this.fire(new e1.B(new Error(`Source "${i.source}" as specified by iconset "${t1}" does not exist and cannot be used as an iconset source`)));
                const r = o.getSource();
                if ("raster-array" !== r.type) return void this.fire(new e1.B(new Error(`Source "${i.source}" as specified by iconset "${t1}" is not a "raster-array" source and cannot be used as an iconset source`)));
                r.partial = !1;
                const n = new wo(t1, this.scope, o);
                this.imageManager.addImageProvider(n, this.scope);
            }
            removeIconset(e1) {
                this.imageManager.removeImageProvider(e1, this.scope);
            }
            _loadIconset(t1) {
                if (!e1.h(t1) && "icon_set" !== this.map._spriteFormat || "raster" === this.map._spriteFormat) return void this._loadSprite(t1);
                const i = "auto" === this.map._spriteFormat;
                var o, r;
                this._spriteRequest = (r = (o, r)=>{
                    if (this._spriteRequest = null, o) i ? this._loadSprite(t1) : this.fire(new e1.B(o));
                    else if (r) {
                        const t1 = new Map;
                        for(const i in r)t1.set(e1.I.from(i), r[i]);
                        this.addImages(t1);
                    }
                    this.imageManager.setLoaded(!0, this.scope), this.dispatcher.broadcast("spriteLoaded", {
                        scope: this.scope,
                        isLoaded: !0
                    }), this.fire(new e1.C("data", {
                        dataType: "style"
                    }));
                }, e1.b2((o = this.map._requestManager).transformRequest(o.normalizeIconsetURL(t1), e1.R.Iconset), (t1, i)=>{
                    if (t1) return void r(t1);
                    const o = {}, n = e1.cX(new e1.b0(i));
                    for (const t1 of n.icons){
                        const i = {
                            version: 1,
                            pixelRatio: e1.o.devicePixelRatio,
                            content: xo(t1),
                            stretchX: t1.metadata ? bo(t1.metadata.stretch_x_areas) : void 0,
                            stretchY: t1.metadata ? bo(t1.metadata.stretch_y_areas) : void 0,
                            sdf: !1,
                            usvg: !0,
                            icon: t1
                        };
                        o[t1.name] = i;
                    }
                    r(null, o);
                }));
            }
            _validateLayer(t1) {
                const i = this.getOwnSource(t1.source);
                if (!i) return;
                const o = t1.sourceLayer;
                o && ("geojson" === i.type || i.vectorLayerIds && -1 === i.vectorLayerIds.indexOf(o)) && this.fire(new e1.B(new Error(`Source layer "${o}" does not exist on source "${i.id}" as specified by style layer "${t1.id}"`)));
            }
            loaded() {
                if (!this._loaded) return !1;
                if (Object.keys(this._changes.getUpdatedSourceCaches()).length) return !1;
                for(const e1 in this._sourceCaches)if (!this._sourceCaches[e1].loaded()) return !1;
                if (!this.imageManager.isLoaded()) return !1;
                if (this.imageManager.hasPatternsInFlight()) return !1;
                if (!this.modelManager.isLoaded()) return !1;
                if (this._styleColorTheme.lutLoading) return !1;
                for (const { style: e1 } of this.fragments)if (!e1.loaded()) return !1;
                return !0;
            }
            _serializeImports() {
                if (this.stylesheet.imports) return this.stylesheet.imports.map((e1, t1)=>{
                    const i = this.fragments[t1];
                    return i && i.style && (e1.data = i.style.serialize()), e1;
                });
            }
            _serializeSources() {
                const e1 = {};
                for(const t1 in this._sourceCaches){
                    const i = this._sourceCaches[t1].getSource();
                    e1[i.id] || (e1[i.id] = i.serialize());
                }
                return e1;
            }
            _serializeLayers(e1) {
                const t1 = [];
                for (const i of e1){
                    const e1 = this._layers[i];
                    e1 && "custom" !== e1.type && t1.push(e1.serialize());
                }
                return t1;
            }
            hasLightTransitions() {
                return !(!this.light || !this.light.hasTransition()) || !(!this.ambientLight || !this.ambientLight.hasTransition()) || !(!this.directionalLight || !this.directionalLight.hasTransition());
            }
            hasFogTransition() {
                return !!this.fog && this.fog.hasTransition();
            }
            hasSnowTransition() {
                return !!this.snow && this.snow.hasTransition();
            }
            hasRainTransition() {
                return !!this.rain && this.rain.hasTransition();
            }
            hasTransitions() {
                if (this.hasLightTransitions()) return !0;
                if (this.hasFogTransition()) return !0;
                if (this.hasSnowTransition()) return !0;
                if (this.hasRainTransition()) return !0;
                for(const e1 in this._sourceCaches)if (this._sourceCaches[e1].hasTransition()) return !0;
                for(const e1 in this._layers)if (this._layers[e1].hasTransition()) return !0;
                return !1;
            }
            _updateDataDrivenEmissiveStrength() {
                for(const e1 in this._mergedLayers){
                    const t1 = this._mergedLayers[e1];
                    if (t1._transitionablePaint && t1._transitionablePaint._values) {
                        const e1 = t1._transitionablePaint._values["line-emissive-strength"];
                        if (e1 && e1.value && e1.value.isDataDriven()) return void (this._hasDataDrivenEmissive = !0);
                    }
                }
                this._hasDataDrivenEmissive = !1;
            }
            hasDataDrivenEmissiveStrength() {
                return this._hasDataDrivenEmissive;
            }
            get order() {
                return this.terrain ? this._drapedFirstOrder : this._mergedOrder;
            }
            _getOrder(e1) {
                return e1 ? this.order : this._mergedOrder;
            }
            isLayerDraped(e1) {
                return !!this.terrain && e1.isDraped(this.getLayerSourceCache(e1));
            }
            _checkLoaded() {
                if (!this._loaded) throw new Error("Style is not done loading");
            }
            _checkLayer(t1) {
                const i = this.getOwnLayer(t1);
                if (i) return i;
                this.fire(new e1.B(new Error(`The layer '${t1}' does not exist in the map's style.`)));
            }
            _checkSource(t1) {
                const i = this.getOwnSource(t1);
                if (i) return i;
                this.fire(new e1.B(new Error(`The source '${t1}' does not exist in the map's style.`)));
            }
            precompilePrograms(e1, t1) {
                const i = this.map.painter;
                if (i) for(let o = e1.minzoom || 0; o < (e1.maxzoom || 25.5); o++){
                    const o = e1.getProgramIds();
                    if (o) for (const r of o){
                        const o = e1.getDefaultProgramParams(r, t1.zoom, this._styleColorTheme.lut);
                        o && (i.style = this, this.fog && (i._fogVisible = !0, o.overrideFog = !0, i.getOrCreateProgram(r, o)), i._fogVisible = !1, o.overrideFog = !1, i.getOrCreateProgram(r, o), (this.stylesheet.terrain || this.stylesheet.projection && "globe" === this.stylesheet.projection.name) && (o.overrideRtt = !0, i.getOrCreateProgram(r, o)));
                    }
                }
            }
            update(t1) {
                if (!this._loaded) return;
                this.ambientLight && this.ambientLight.recalculate(t1), this.directionalLight && this.directionalLight.recalculate(t1);
                const i = this.calculateLightsBrightness();
                t1.brightness = i || 0, i !== this._brightness && (this._brightness = i, this.dispatcher.broadcast("setBrightness", i)), t1.worldview !== this._worldview && (this._worldview = t1.worldview, this.dispatcher.broadcast("setWorldview", this._worldview));
                const o = this._changes.isDirty();
                let r = !1;
                if (this._changes.isDirty()) {
                    const e1 = this._changes.getLayerUpdatesByScope();
                    for(const t1 in e1){
                        const { updatedIds: i, removedIds: o } = e1[t1];
                        (i || o) && (this._updateWorkerLayers(t1, i, o), r = !0);
                    }
                    this.updateSourceCaches(), this._updateTilesForChangedImages(), this.updateLayers(t1), this.light && this.light.updateTransitions(t1), this.ambientLight && this.ambientLight.updateTransitions(t1), this.directionalLight && this.directionalLight.updateTransitions(t1), this.fog && this.fog.updateTransitions(t1), this.snow && this.snow.updateTransitions(t1), this.rain && this.rain.updateTransitions(t1), this._changes.reset();
                }
                const n = {};
                for(const e1 in this._mergedSourceCaches){
                    const t1 = this._mergedSourceCaches[e1];
                    n[e1] = t1.used, t1.used = !1, t1.tileCoverLift = 0;
                }
                const s = {};
                for (const i of this._mergedOrder){
                    const o = this._mergedLayers[i];
                    if (("none" !== o.visibility || o.hasTransition()) && o.recalculate(t1, this._availableImages), !o.isHidden(t1.zoom)) {
                        const e1 = this.getLayerSourceCache(o);
                        e1 && (e1.used = !0, e1.tileCoverLift = Math.max(e1.tileCoverLift, o.tileCoverLift()));
                    }
                    if ("fill-extrusion" === o.type) {
                        const t1 = e1.F(o.source, o.scope);
                        if (t1 in this._mergedFillExtrusionSourceCaches) {
                            const e1 = o.layout && o.layout.get("source-max-zoom");
                            if (null != e1) {
                                const i = s[t1];
                                s[t1] = null == i ? e1 : Math.min(i, e1);
                            }
                        }
                    }
                    !this._precompileDone && this._shouldPrecompile && ("requestIdleCallback" in window ? requestIdleCallback(()=>{
                        this.precompilePrograms(o, t1);
                    }) : this.precompilePrograms(o, t1));
                }
                this._shouldPrecompile && (this._precompileDone = !0);
                for(const e1 in this._mergedFillExtrusionSourceCaches)this._mergedFillExtrusionSourceCaches[e1].setMaxzoomOverride(null != s[e1] ? s[e1] : null);
                this.terrain && r && this.mergeLayers();
                const a = this.imageManager.getPendingImageProviders();
                for (const e1 of a)e1.sourceCache.used = !0;
                for(const t1 in n){
                    const i = this._mergedSourceCaches[t1];
                    n[t1] !== i.used && i.getSource().fire(new e1.C("data", {
                        sourceDataType: "visibility",
                        dataType: "source",
                        sourceId: i.getSource().id
                    }));
                }
                this.light && this.light.recalculate(t1), this.terrain && this.terrain.recalculate(t1), this.fog && this.fog.recalculate(t1), this.snow && this.snow.recalculate(t1), this.rain && this.rain.recalculate(t1), this.z = t1.zoom, this._markersNeedUpdate && (this._updateMarkersOpacity(), this._markersNeedUpdate = !1), this.imageManager.clearUpdatedImages(this.scope), o && this.fire(new e1.C("data", {
                    dataType: "style"
                }));
            }
            updateImageProviders() {
                const e1 = this.imageManager.getPendingImageProviders();
                for (const t1 of e1){
                    const e1 = t1.resolvePendingRequests(), i = this.getFragmentStyle(t1.scope);
                    i && i.addImages(e1);
                }
            }
            _updateTilesForChangedImages() {
                const e1 = {};
                for(const t1 in this._mergedSourceCaches){
                    const i = this._mergedSourceCaches[t1].getSource().scope;
                    e1[i] = e1[i] || this._changes.getUpdatedImages(i), 0 !== e1[i].length && this._mergedSourceCaches[t1].reloadTilesForDependencies([
                        "icons",
                        "patterns"
                    ], e1[i]);
                }
                for(const t1 in e1)this._changes.resetUpdatedImages(t1);
            }
            _updateWorkerLayers(e1, t1, i) {
                const o = this.getFragmentStyle(e1);
                o && this.dispatcher.broadcast("updateLayers", {
                    layers: t1 ? o._serializeLayers(t1) : [],
                    scope: e1,
                    removedIds: i || [],
                    options: o.options
                });
            }
            setState(t1, i) {
                if (this._checkLoaded(), So(this, Ae(t1))) return !1;
                (t1 = e1.d5(t1)).layers = Ut(t1.layers);
                const o = (function(t1, i) {
                    if (!t1) return [
                        {
                            command: Vt.setStyle,
                            args: [
                                i
                            ]
                        }
                    ];
                    let o = [];
                    try {
                        if (!e1.b7(t1.version, i.version)) return [
                            {
                                command: Vt.setStyle,
                                args: [
                                    i
                                ]
                            }
                        ];
                        if (e1.b7(t1.center, i.center) || o.push({
                            command: Vt.setCenter,
                            args: [
                                i.center
                            ]
                        }), e1.b7(t1.zoom, i.zoom) || o.push({
                            command: Vt.setZoom,
                            args: [
                                i.zoom
                            ]
                        }), e1.b7(t1.bearing, i.bearing) || o.push({
                            command: Vt.setBearing,
                            args: [
                                i.bearing
                            ]
                        }), e1.b7(t1.pitch, i.pitch) || o.push({
                            command: Vt.setPitch,
                            args: [
                                i.pitch
                            ]
                        }), e1.b7(t1.sprite, i.sprite) || o.push({
                            command: Vt.setSprite,
                            args: [
                                i.sprite
                            ]
                        }), e1.b7(t1.glyphs, i.glyphs) || o.push({
                            command: Vt.setGlyphs,
                            args: [
                                i.glyphs
                            ]
                        }), e1.b7(t1.imports, i.imports) || function(t1 = [], i = [], o) {
                            i = i || [];
                            const r = (t1 = t1 || []).map(Wt), n = i.map(Wt), s = t1.reduce($t, {}), a = i.reduce($t, {}), l = r.slice();
                            let c, h, d, _;
                            for(c = 0, h = 0; c < r.length; c++)d = r[c], a.hasOwnProperty(d) ? h++ : (o.push({
                                command: Vt.removeImport,
                                args: [
                                    d
                                ]
                            }), l.splice(l.indexOf(d, h), 1));
                            for(c = 0, h = 0; c < n.length; c++)d = n[n.length - 1 - c], l[l.length - 1 - c] !== d && (s.hasOwnProperty(d) ? (o.push({
                                command: Vt.removeImport,
                                args: [
                                    d
                                ]
                            }), l.splice(l.lastIndexOf(d, l.length - h), 1)) : h++, _ = l[l.length - c], o.push({
                                command: Vt.addImport,
                                args: [
                                    a[d],
                                    _
                                ]
                            }), l.splice(l.length - c, 0, d));
                            for (const t1 of i){
                                const i = s[t1.id];
                                i && (delete i.data, e1.b7(i, t1) || o.push({
                                    command: Vt.updateImport,
                                    args: [
                                        t1.id,
                                        t1
                                    ]
                                }));
                            }
                        }(t1.imports, i.imports, o), e1.b7(t1.transition, i.transition) || o.push({
                            command: Vt.setTransition,
                            args: [
                                i.transition
                            ]
                        }), e1.b7(t1.light, i.light) || o.push({
                            command: Vt.setLight,
                            args: [
                                i.light
                            ]
                        }), e1.b7(t1.fog, i.fog) || o.push({
                            command: Vt.setFog,
                            args: [
                                i.fog
                            ]
                        }), e1.b7(t1.snow, i.snow) || o.push({
                            command: Vt.setSnow,
                            args: [
                                i.snow
                            ]
                        }), e1.b7(t1.rain, i.rain) || o.push({
                            command: Vt.setRain,
                            args: [
                                i.rain
                            ]
                        }), e1.b7(t1.projection, i.projection) || o.push({
                            command: Vt.setProjection,
                            args: [
                                i.projection
                            ]
                        }), e1.b7(t1.lights, i.lights) || o.push({
                            command: Vt.setLights,
                            args: [
                                i.lights
                            ]
                        }), e1.b7(t1.camera, i.camera) || o.push({
                            command: Vt.setCamera,
                            args: [
                                i.camera
                            ]
                        }), e1.b7(t1.iconsets, i.iconsets) || function(t1, i, o) {
                            let r;
                            for(r in i = i || {}, t1 = t1 || {})t1.hasOwnProperty(r) && (i.hasOwnProperty(r) || o.push({
                                command: Vt.removeIconset,
                                args: [
                                    r
                                ]
                            }));
                            for(r in i){
                                if (!i.hasOwnProperty(r)) continue;
                                const n = i[r];
                                t1.hasOwnProperty(r) ? e1.b7(t1[r], n) || (o.push({
                                    command: Vt.removeIconset,
                                    args: [
                                        r
                                    ]
                                }), o.push({
                                    command: Vt.addIconset,
                                    args: [
                                        r,
                                        n
                                    ]
                                })) : o.push({
                                    command: Vt.addIconset,
                                    args: [
                                        r,
                                        n
                                    ]
                                });
                            }
                        }(t1.iconsets, i.iconsets, o), !e1.b7(t1["color-theme"], i["color-theme"])) return [
                            {
                                command: Vt.setStyle,
                                args: [
                                    i
                                ]
                            }
                        ];
                        const r = {}, n = [];
                        !function(t1, i, o, r) {
                            let n;
                            for(n in i = i || {}, t1 = t1 || {})t1.hasOwnProperty(n) && (i.hasOwnProperty(n) || Gt(n, o, r));
                            for(n in i){
                                if (!i.hasOwnProperty(n)) continue;
                                const s = i[n];
                                t1.hasOwnProperty(n) ? e1.b7(t1[n], s) || ("geojson" === t1[n].type && "geojson" === s.type && Zt(t1, i, n) ? o.push({
                                    command: Vt.setGeoJSONSourceData,
                                    args: [
                                        n,
                                        s.data
                                    ]
                                }) : qt(n, i, o, r)) : jt(n, i, o);
                            }
                        }(t1.sources, i.sources, n, r);
                        const s = [];
                        t1.layers && t1.layers.forEach((e1)=>{
                            e1.source && r[e1.source] ? o.push({
                                command: Vt.removeLayer,
                                args: [
                                    e1.id
                                ]
                            }) : s.push(e1);
                        });
                        let a = t1.terrain;
                        a && r[a.source] && (o.push({
                            command: Vt.setTerrain,
                            args: [
                                void 0
                            ]
                        }), a = void 0), o = o.concat(n), e1.b7(a, i.terrain) || o.push({
                            command: Vt.setTerrain,
                            args: [
                                i.terrain
                            ]
                        }), function(t1, i, o) {
                            i = i || [];
                            const r = (t1 = t1 || []).map(Wt), n = i.map(Wt), s = t1.reduce($t, {}), a = i.reduce($t, {}), l = r.slice(), c = Object.create(null);
                            let h, d, _, u, p, f, m;
                            for(h = 0, d = 0; h < r.length; h++)_ = r[h], a.hasOwnProperty(_) ? d++ : (o.push({
                                command: Vt.removeLayer,
                                args: [
                                    _
                                ]
                            }), l.splice(l.indexOf(_, d), 1));
                            for(h = 0, d = 0; h < n.length; h++)_ = n[n.length - 1 - h], l[l.length - 1 - h] !== _ && (s.hasOwnProperty(_) ? (o.push({
                                command: Vt.removeLayer,
                                args: [
                                    _
                                ]
                            }), l.splice(l.lastIndexOf(_, l.length - d), 1)) : d++, f = l[l.length - h], o.push({
                                command: Vt.addLayer,
                                args: [
                                    a[_],
                                    f
                                ]
                            }), l.splice(l.length - h, 0, _), c[_] = !0);
                            for(h = 0; h < n.length; h++)if (_ = n[h], u = s[_], p = a[_], !c[_] && !e1.b7(u, p)) {
                                if (e1.b7(u.source, p.source) && e1.b7(u["source-layer"], p["source-layer"]) && e1.b7(u.type, p.type)) {
                                    for(m in Ht(u.layout, p.layout, o, _, null, Vt.setLayoutProperty), Ht(u.paint, p.paint, o, _, null, Vt.setPaintProperty), e1.b7(u.slot, p.slot) || o.push({
                                        command: Vt.setSlot,
                                        args: [
                                            _,
                                            p.slot
                                        ]
                                    }), e1.b7(u.filter, p.filter) || o.push({
                                        command: Vt.setFilter,
                                        args: [
                                            _,
                                            p.filter
                                        ]
                                    }), e1.b7(u.minzoom, p.minzoom) && e1.b7(u.maxzoom, p.maxzoom) || o.push({
                                        command: Vt.setLayerZoomRange,
                                        args: [
                                            _,
                                            p.minzoom,
                                            p.maxzoom
                                        ]
                                    }), u)u.hasOwnProperty(m) && "layout" !== m && "paint" !== m && "filter" !== m && "metadata" !== m && "minzoom" !== m && "maxzoom" !== m && "slot" !== m && (0 === m.indexOf("paint.") ? Ht(u[m], p[m], o, _, m.slice(6), Vt.setPaintProperty) : e1.b7(u[m], p[m]) || o.push({
                                        command: Vt.setLayerProperty,
                                        args: [
                                            _,
                                            m,
                                            p[m]
                                        ]
                                    }));
                                    for(m in p)p.hasOwnProperty(m) && !u.hasOwnProperty(m) && "layout" !== m && "paint" !== m && "filter" !== m && "metadata" !== m && "minzoom" !== m && "maxzoom" !== m && "slot" !== m && (0 === m.indexOf("paint.") ? Ht(u[m], p[m], o, _, m.slice(6), Vt.setPaintProperty) : e1.b7(u[m], p[m]) || o.push({
                                        command: Vt.setLayerProperty,
                                        args: [
                                            _,
                                            m,
                                            p[m]
                                        ]
                                    }));
                                } else o.push({
                                    command: Vt.removeLayer,
                                    args: [
                                        _
                                    ]
                                }), f = l[l.lastIndexOf(_) + 1], o.push({
                                    command: Vt.addLayer,
                                    args: [
                                        p,
                                        f
                                    ]
                                });
                            }
                        }(s, i.layers, o);
                    } catch (e1) {
                        console.warn("Unable to compute style diff:", e1), o = [
                            {
                                command: Vt.setStyle,
                                args: [
                                    i
                                ]
                            }
                        ];
                    }
                    return o;
                })(this.serialize(), t1).filter((e1)=>!(e1.command in Io));
                if (0 === o.length) return !1;
                const r = o.filter((e1)=>!(e1.command in Co));
                if (r.length > 0) throw new Error(`Unimplemented: ${r.map((e1)=>e1.command).join(", ")}.`);
                const n = [];
                return o.forEach((e1)=>{
                    n.push(this[e1.command](...e1.args));
                }), i && Promise.all(n).then(i).catch(i), this.stylesheet = t1, this.mergeAll(), this.dispatcher.broadcast("setLayers", {
                    layers: this._serializeLayers(this._order),
                    scope: this.scope,
                    options: this.options
                }), !0;
            }
            _updateWorkerImages() {
                this._availableImages = this.imageManager.listImages(this.scope), this.dispatcher.broadcast("setImages", {
                    scope: this.scope,
                    images: this._availableImages
                });
            }
            _updateWorkerModels() {
                this._availableModels = this.modelManager.getModelURIs(this.scope), this.dispatcher.broadcast("setModels", {
                    scope: this.scope,
                    models: this._availableModels
                });
            }
            addImages(t1) {
                if (0 === t1.size) return this;
                for (const [i, o] of t1.entries()){
                    if (this.getImage(i)) return this.fire(new e1.B(new Error(`An image with the name "${i.name}" already exists.`)));
                    this.imageManager.addImage(i, this.scope, o), this._changes.updateImage(i, this.scope);
                }
                return this._updateWorkerImages(), this.fire(new e1.C("data", {
                    dataType: "style"
                })), this;
            }
            addImage(t1, i) {
                return this.getImage(t1) ? this.fire(new e1.B(new Error(`An image with the name "${t1.name}" already exists.`))) : (this.imageManager.addImage(t1, this.scope, i), this._changes.updateImage(t1, this.scope), this._updateWorkerImages(), this.fire(new e1.C("data", {
                    dataType: "style"
                })), this);
            }
            updateImage(t1, i, o = !1) {
                this.imageManager.updateImage(t1, this.scope, i), o && (this._changes.updateImage(t1, this.scope), this._updateWorkerImages(), this.fire(new e1.C("data", {
                    dataType: "style"
                })));
            }
            getImage(e1) {
                return this.imageManager.getImage(e1, this.scope);
            }
            removeImage(t1) {
                return this.getImage(t1) ? (this.imageManager.removeImage(t1, this.scope), this._changes.updateImage(t1, this.scope), this._updateWorkerImages(), this.fire(new e1.C("data", {
                    dataType: "style"
                })), this) : this.fire(new e1.B(new Error("No image with this name exists.")));
            }
            listImages() {
                return this._checkLoaded(), this._availableImages.slice();
            }
            getActualScope() {
                return this._importedAsBasemap ? "basemap" : this.scope;
            }
            addModelURLs(t1) {
                return this.modelManager.addModelURLs(t1, this.getActualScope()), this._updateWorkerModels(), this.fire(new e1.C("data", {
                    dataType: "style"
                })), this;
            }
            addModel(t1, i, o = {}) {
                return this._checkLoaded(), this._validate(je, `models.${t1}`, i, null, o) || (this.modelManager.addModel(t1, i, this.getActualScope()), this.fire(new e1.C("data", {
                    dataType: "style"
                }))), this;
            }
            hasModel(e1) {
                return this.modelManager.hasModel(e1, this.getActualScope());
            }
            removeModel(t1) {
                return this.hasModel(t1) ? (this.modelManager.removeModel(t1, this.getActualScope(), !1, !0), this.fire(new e1.C("data", {
                    dataType: "style"
                })), this) : this.fire(new e1.B(new Error("No model with this ID exists.")));
            }
            listModels() {
                return this._checkLoaded(), this.modelManager.listModels(this.getActualScope());
            }
            addSource(t1, i, o = {}) {
                if (this._checkLoaded(), void 0 !== this.getOwnSource(t1)) throw new Error(`There is already a source with ID "${t1}".`);
                if (!i.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(i).join(", ")}.`);
                if ([
                    "vector",
                    "raster",
                    "geojson",
                    "video",
                    "image"
                ].indexOf(i.type) >= 0 && this._validate(Le, `sources.${t1}`, i, null, o)) return;
                this.map && this.map._collectResourceTiming && (i.collectResourceTiming = !0);
                const r = St(t1, i, this.dispatcher, this);
                r.scope = this.scope, r.setEventedParent(this, ()=>({
                        isSourceLoaded: this._isSourceCacheLoaded(r.id),
                        source: r.serialize(),
                        sourceId: r.id
                    }));
                const n = (t1)=>{
                    const i = (t1 === e1.b5.Symbol ? "symbol:" : t1 === e1.b5.FillExtrusion ? "fill-extrusion:" : "other:") + r.id, o = e1.F(i, this.scope), n = this._sourceCaches[i] = new zt(o, r, t1);
                    t1 === e1.b5.Symbol ? this._symbolSourceCaches[r.id] = n : t1 === e1.b5.FillExtrusion ? this._fillExtrusionSourceCaches[r.id] = n : this._otherSourceCaches[r.id] = n, n.onAdd(this.map);
                };
                n(e1.b5.Other), "vector" !== i.type && "geojson" !== i.type || (n(e1.b5.Symbol), "vector" === i.type && n(e1.b5.FillExtrusion)), r.onAdd && r.onAdd(this.map), o.isInitialLoad || (this.mergeSources(), this._changes.setDirty());
            }
            removeSource(t1) {
                this._checkLoaded();
                const i = this.getOwnSource(t1);
                if (!i) throw new Error("There is no source with this ID");
                for(const i in this._layers)if (this._layers[i].source === t1) return this.fire(new e1.B(new Error(`Source "${t1}" cannot be removed while layer "${i}" is using it.`)));
                if (this.terrain && this.terrain.scope === this.scope && this.terrain.get().source === t1) return this.fire(new e1.B(new Error(`Source "${t1}" cannot be removed while terrain is using it.`)));
                if (this.stylesheet.iconsets) {
                    const i = Object.entries(this.stylesheet.iconsets).find(([e1, i])=>"source" === i.type && i.source === t1);
                    if (i) return this.fire(new e1.B(new Error(`Source "${t1}" cannot be removed while iconset "${i[0]}" is using it.`)));
                }
                const o = this.getOwnSourceCaches(t1);
                for (const t1 of o){
                    const i = e1.d6(t1.id);
                    delete this._sourceCaches[i], this._changes.discardSourceCacheUpdate(t1.id), t1.fire(new e1.C("data", {
                        sourceDataType: "metadata",
                        dataType: "source",
                        sourceId: t1.getSource().id
                    })), t1.setEventedParent(null), t1.clearTiles();
                }
                return delete this._otherSourceCaches[t1], delete this._symbolSourceCaches[t1], delete this._fillExtrusionSourceCaches[t1], this.mergeSources(), i.setEventedParent(null), i.onRemove && i.onRemove(this.map), this._changes.setDirty(), this;
            }
            setGeoJSONSourceData(e1, t1) {
                this._checkLoaded(), this.getOwnSource(e1).setData(t1), this._changes.setDirty();
            }
            getOwnSource(e1) {
                const t1 = this.getOwnSourceCache(e1);
                return t1 && t1.getSource();
            }
            getOwnSources() {
                const e1 = [];
                for(const t1 in this._otherSourceCaches){
                    const i = this.getOwnSourceCache(t1);
                    i && e1.push(i.getSource());
                }
                return e1;
            }
            areTilesLoaded() {
                const e1 = this._mergedSourceCaches;
                for(const t1 in e1){
                    const i = e1[t1]._tiles;
                    for(const e1 in i){
                        const t1 = i[e1];
                        if ("loaded" !== t1.state && "errored" !== t1.state) return !1;
                    }
                }
                return !0;
            }
            setLights(t1) {
                if (this._checkLoaded(), !t1) return delete this.ambientLight, void delete this.directionalLight;
                const i = this._getTransitionParameters();
                for (const e1 of t1){
                    if (this._validate(Oe, "lights", e1)) return;
                    switch(e1.type){
                        case "ambient":
                            if (this.ambientLight) {
                                const t1 = this.ambientLight;
                                t1.set(e1), t1.updateTransitions(i);
                            } else this.ambientLight = new lt(e1, ct(), this.scope, this.options);
                            break;
                        case "directional":
                            if (this.directionalLight) {
                                const t1 = this.directionalLight;
                                t1.set(e1), t1.updateTransitions(i);
                            } else this.directionalLight = new lt(e1, dt(), this.scope, this.options);
                    }
                }
                const o = Object.assign(i, {
                    worldview: this.map.getWorldview()
                }), r = new e1.ae(this.z || 0, o);
                this.ambientLight && this.ambientLight.recalculate(r), this.directionalLight && this.directionalLight.recalculate(r), this._brightness = this.calculateLightsBrightness(), this.dispatcher.broadcast("setBrightness", this._brightness);
            }
            calculateLightsBrightness() {
                const t1 = this.directionalLight, i = this.ambientLight;
                if (!t1 || !i) return;
                const o = (e1)=>.2126 * (e1[0] <= .03928 ? e1[0] / 12.92 : Math.pow((e1[0] + .055) / 1.055, 2.4)) + .7152 * (e1[1] <= .03928 ? e1[1] / 12.92 : Math.pow((e1[1] + .055) / 1.055, 2.4)) + .0722 * (e1[2] <= .03928 ? e1[2] / 12.92 : Math.pow((e1[2] + .055) / 1.055, 2.4)), r = t1.properties.get("color").toNonPremultipliedRenderColor(null).toArray01(), n = t1.properties.get("intensity"), s = t1.properties.get("direction"), a = 1 - e1.cL(s.x, s.y, s.z)[2] / 90, l = o(r) * n * a, c = i.properties.get("color").toNonPremultipliedRenderColor(null).toArray01(), h = i.properties.get("intensity"), d = o(c) * h;
                return Number(((l + d) / 2).toFixed(6));
            }
            getBrightness() {
                return this._brightness;
            }
            getLights() {
                if (!this.enable3dLights()) return null;
                const e1 = [];
                return this.directionalLight && e1.push(this.directionalLight.get()), this.ambientLight && e1.push(this.ambientLight.get()), e1;
            }
            enable3dLights() {
                return !!this.ambientLight && !!this.directionalLight;
            }
            getFragmentStyle(t1) {
                if (null == t1 || "" === t1 && this.isRootStyle()) return this;
                if (e1.d7(t1)) {
                    const i = e1.d8(t1), o = this.fragments.find(({ id: e1 })=>e1 === i);
                    if (!o) return;
                    const r = e1.d6(t1);
                    return o.style.getFragmentStyle(r);
                }
                {
                    const e1 = this.fragments.find(({ id: e1 })=>e1 === t1);
                    return e1 ? e1.style : void 0;
                }
            }
            setFeaturesetSelectors(t1) {
                if (!t1) return;
                const i = (e1, t1 = "")=>`${e1}::${t1}`;
                this._featuresetSelectors = {};
                for(const o in t1){
                    const r = {}, n = this._featuresetSelectors[o] = [];
                    for (const s of t1[o].selectors){
                        if (s.featureNamespace) {
                            const t1 = this.getOwnLayer(s.layer);
                            if (!t1) {
                                e1.w(`Layer is undefined for selector: ${s.layer}`);
                                continue;
                            }
                            const n = i(t1.source, t1.sourceLayer);
                            if (n in r && r[n] !== s.featureNamespace) {
                                e1.w(`"featureNamespace ${s.featureNamespace} of featureset ${o}'s selector is not associated to the same source, skip this selector`);
                                continue;
                            }
                            r[n] = s.featureNamespace;
                        }
                        let t1;
                        if (s.properties) for(const i in s.properties){
                            const o = e1.X(s.properties[i]);
                            "success" === o.result && (t1 = t1 || {}, t1[i] = o.value);
                        }
                        n.push({
                            layerId: s.layer,
                            namespace: s.featureNamespace,
                            properties: t1,
                            uniqueFeatureID: s._uniqueFeatureID
                        });
                    }
                }
            }
            getFeaturesetDescriptors(e1) {
                const t1 = this.getFragmentStyle(e1);
                if (!t1 || !t1.stylesheet.featuresets) return [];
                const i = [];
                for(const e1 in t1.stylesheet.featuresets)i.push({
                    featuresetId: e1,
                    importId: t1.scope ? t1.scope : void 0
                });
                return i;
            }
            getFeaturesetLayers(t1, i) {
                const o = this.getFragmentStyle(i), r = o.stylesheet.featuresets;
                if (!r || !r[t1]) return this.fire(new e1.B(new Error(`The featureset '${t1}' does not exist in the map's style and cannot be queried.`))), [];
                const n = [];
                for (const e1 of r[t1].selectors){
                    const t1 = o.getOwnLayer(e1.layer);
                    t1 && n.push(t1);
                }
                return n;
            }
            getConfigProperty(t1, i) {
                const o = this.getFragmentStyle(t1);
                if (!o) return null;
                const r = e1.F(i, o.scope), n = o.options.get(r), s = n ? n.value || n.default : null;
                return s ? s.serialize() : null;
            }
            isIndoorEnabled() {
                return Object.keys(this._mergedIndoor).length > 0;
            }
            getIndoorSourceLayers(t1, i) {
                const o = e1.F(t1, i);
                return this._mergedIndoor[o];
            }
            setIndoorData(e1, t1) {
                this.indoorManager.setIndoorData(t1);
            }
            updateIndoorDependentLayers() {
                this._updateLayers(this._indoorDependentLayers), this.map._styleDirty = !0, this.map.triggerRepaint();
            }
            setConfigProperty(t1, i, o) {
                const r = this.getFragmentStyle(t1);
                if (!r) return;
                const n = r.stylesheet.schema;
                if (!n || !n[i]) return;
                const s = e1.X(o);
                if ("success" !== s.result) return void So(this, s.value);
                const a = s.value.expression, l = e1.F(i, r.scope), c = r.options.get(l);
                if (!c) return;
                let h;
                const { minValue: d, maxValue: _, stepValue: u, type: p, values: f } = n[i], m = e1.X(n[i].default);
                "success" === m.result && (h = m.value.expression), h ? (this.options.set(l, Object.assign({}, c, {
                    value: a,
                    default: h,
                    minValue: d,
                    maxValue: _,
                    stepValue: u,
                    type: p,
                    values: f
                })), this.updateConfigDependencies(i)) : this.fire(new e1.B(new Error(`No schema defined for the config option "${i}" in the "${t1}" fragment.`)));
            }
            getConfig(t1) {
                const i = this.getFragmentStyle(t1);
                if (!i) return null;
                const o = i.stylesheet.schema;
                if (!o) return null;
                const r = {};
                for(const t1 in o){
                    const o = e1.F(t1, i.scope), n = i.options.get(o), s = n ? n.value || n.default : null;
                    r[t1] = s ? s.serialize() : null;
                }
                return r;
            }
            setConfig(e1, t1) {
                const i = this.getFragmentStyle(e1);
                i && (i.updateConfig(t1, i.stylesheet.schema), this.updateConfigDependencies());
            }
            getSchema(e1) {
                const t1 = this.getFragmentStyle(e1);
                return t1 ? t1.stylesheet.schema : null;
            }
            setSchema(e1, t1) {
                const i = this.getFragmentStyle(e1);
                i && (i.stylesheet.schema = t1, i.updateConfig(i._config, t1), this.updateConfigDependencies());
            }
            updateConfig(t1, i) {
                if (this._config = t1, t1 || i) {
                    if (i) for(const o in i){
                        let r, n;
                        const s = e1.X(i[o].default);
                        if ("success" === s.result && (r = s.value.expression), t1 && void 0 !== t1[o]) {
                            const i = e1.X(t1[o]);
                            "success" === i.result && (n = i.value.expression);
                        }
                        const { minValue: a, maxValue: l, stepValue: c, type: h, values: d } = i[o];
                        if (r) {
                            const t1 = e1.F(o, this.scope);
                            this.options.set(t1, {
                                default: r,
                                value: n,
                                minValue: a,
                                maxValue: l,
                                stepValue: c,
                                type: h,
                                values: d
                            });
                        } else this.fire(new e1.B(new Error(`No schema defined for config option "${o}".`)));
                    }
                    else this.fire(new e1.B(new Error("Attempting to set config for a style without schema.")));
                }
            }
            _updateLayers(e1, t1 = ()=>!0) {
                for (const i of e1){
                    const e1 = this.getLayer(i);
                    e1 && t1(e1) && (e1.possiblyEvaluateVisibility(), this._updateLayer(e1), this._changes.setDirty());
                }
            }
            updateConfigDependencies(e1) {
                this._updateLayers(this._configDependentLayers, (t1)=>!e1 || t1.expressionDependencies.configDependencies.has(e1)), this.ambientLight && this.ambientLight.updateConfig(this.options), this.directionalLight && this.directionalLight.updateConfig(this.options), this.fog && this.fog.updateConfig(this.options), this.snow && this.snow.updateConfig(this.options), this.rain && this.rain.updateConfig(this.options), this.forEachFragmentStyle((e1)=>{
                    const t1 = e1._styleColorTheme.colorThemeOverride ? e1._styleColorTheme.colorThemeOverride : e1._styleColorTheme.colorTheme;
                    if (t1) {
                        const i = e1._evaluateColorThemeData(t1);
                        (!e1._styleColorTheme.lut && "" !== i || e1._styleColorTheme.lut && i !== e1._styleColorTheme.lut.data) && e1.setColorTheme(t1);
                    }
                }), this._changes.setDirty();
            }
            addLayer(t1, i, o = {}) {
                this._checkLoaded();
                const r = t1.id;
                if (this._layers[r]) return void this.fire(new e1.B(new Error(`Layer with id "${r}" already exists on this map`)));
                let n;
                if ("custom" === t1.type) {
                    if (So(this, e1.d9(t1))) return;
                    n = e1.da(t1, this.scope, this._styleColorTheme.lut, this.options);
                } else {
                    if ("object" == typeof t1.source && (this.addSource(r, t1.source), t1 = e1.d5(t1), t1 = Object.assign(t1, {
                        source: r
                    })), this._validate(ke, `layers.${r}`, t1, {
                        arrayIndex: -1
                    }, o)) return;
                    n = e1.da(t1, this.scope, this._styleColorTheme.lut, this.options), this._validateLayer(n), n.setEventedParent(this, {
                        layer: {
                            id: r
                        }
                    });
                }
                const s = e1.F(n.source, n.scope);
                0 !== n.expressionDependencies.configDependencies.size && this._configDependentLayers.add(s), n.expressionDependencies.isIndoorDependent && this._indoorDependentLayers.add(s);
                let a = this._order.length;
                if (i) {
                    const t1 = this._order.indexOf(i);
                    if (-1 === t1) return void this.fire(new e1.B(new Error(`Layer with id "${i}" does not exist on this map.`)));
                    n.slot && n.slot !== this._layers[i].slot ? e1.w(`Layer with id "${i}" has a different slot. Layers can only be rearranged within the same slot.`) : a = t1;
                }
                this._order.splice(a, 0, r), this._handleLayerOrderChange(), this._layers[r] = n;
                const l = this.getOwnLayerSourceCache(n), c = !!this.directionalLight && this.directionalLight.shadowsEnabled();
                l && n.canCastShadows() && c && (l.castsShadows = !0);
                const h = this._changes.getRemovedLayer(n);
                if (h && n.source && l && "custom" !== n.type) {
                    this._changes.discardLayerRemoval(n);
                    const t1 = e1.F(n.source, n.scope);
                    h.type !== n.type ? this._changes.updateSourceCache(t1, "clear") : (this._changes.updateSourceCache(t1, "reload"), l.pause());
                }
                this._updateLayer(n), n.onAdd && n.onAdd(this.map), n.scope = this.scope, this.mergeLayers();
            }
            moveLayer(t1, i) {
                this._checkLoaded();
                const o = this._checkLayer(t1);
                if (!o) return;
                if (t1 === i) return;
                const r = this._order.indexOf(t1);
                this._order.splice(r, 1);
                let n = this._order.length;
                if (i) {
                    const t1 = this._order.indexOf(i);
                    if (-1 === t1) return void this.fire(new e1.B(new Error(`Layer with id "${i}" does not exist on this map.`)));
                    o.slot && o.slot !== this._layers[i].slot ? e1.w(`Layer with id "${i}" has a different slot. Layers can only be rearranged within the same slot.`) : n = t1;
                }
                this._order.splice(n, 0, t1), this._changes.setDirty(), this._handleLayerOrderChange(), this.mergeLayers();
            }
            removeLayer(e1) {
                this._checkLoaded();
                const t1 = this._checkLayer(e1);
                if (!t1) return;
                t1.setEventedParent(null);
                const i = this._order.indexOf(e1);
                this._order.splice(i, 1), delete this._layers[e1], this._changes.setDirty(), this._handleLayerOrderChange(), this._configDependentLayers.delete(t1.fqid), this._indoorDependentLayers.delete(t1.fqid), this._changes.removeLayer(t1);
                const o = this.getOwnLayerSourceCache(t1);
                if (o && o.castsShadows) {
                    let e1 = !1;
                    for(const i in this._layers)if (this._layers[i].source === t1.source && this._layers[i].canCastShadows()) {
                        e1 = !0;
                        break;
                    }
                    o.castsShadows = e1;
                }
                t1.onRemove && t1.onRemove(this.map), this.mergeLayers();
            }
            getOwnLayer(e1) {
                return this._layers[e1];
            }
            hasLayer(e1) {
                return e1 in this._mergedLayers;
            }
            hasLayerType(e1) {
                for(const t1 in this._layers)if (this._layers[t1].type === e1) return !0;
                return !1;
            }
            setLayerZoomRange(e1, t1, i) {
                this._checkLoaded();
                const o = this._checkLayer(e1);
                o && (o.minzoom === t1 && o.maxzoom === i || (null != t1 && (o.minzoom = t1), null != i && (o.maxzoom = i), this._updateLayer(o)));
            }
            getSlots() {
                return this._checkLoaded(), this._mergedSlots;
            }
            setSlot(e1, t1) {
                this._checkLoaded();
                const i = this._checkLayer(e1);
                i && i.slot !== t1 && (i.slot = t1, this._updateLayer(i));
            }
            setFilter(t1, i, o = {}) {
                this._checkLoaded();
                const r = this._checkLayer(t1);
                if (r && !e1.b7(r.filter, i)) return null == i ? (r.filter = void 0, void this._updateLayer(r)) : void (this._validate(Ne, `layers.${r.id}.filter`, i, {
                    layerType: r.type
                }, o) || (r.filter = e1.d5(i), this._updateLayer(r)));
            }
            getFilter(t1) {
                const i = this._checkLayer(t1);
                if (i) return e1.d5(i.filter);
            }
            setLayoutProperty(t1, i, o, r = {}) {
                this._checkLoaded();
                const n = this._checkLayer(t1);
                if (n && !e1.b7(n.getLayoutProperty(i), o)) {
                    if (null != o && (!r || !1 !== r.validate) && So(n, Ve.call(Ae, {
                        key: `layers.${t1}.layout.${i}`,
                        layerType: n.type,
                        objectKey: i,
                        value: o,
                        styleSpec: e1.a8,
                        style: {
                            glyphs: !0,
                            sprite: !0
                        }
                    }))) return;
                    n.setLayoutProperty(i, o), 0 !== n.expressionDependencies.configDependencies.size && this._configDependentLayers.add(n.fqid), n.expressionDependencies.isIndoorDependent && this._indoorDependentLayers.add(n.fqid), this._updateLayer(n);
                }
            }
            setLayerProperty(e1, t1, i, o = {}) {
                this._checkLoaded();
                const r = this._checkLayer(e1);
                r && ("appearances" === t1 ? (r.setAppearances(i), this._updateLayer(r)) : r.isPaintProperty(t1) ? this.setPaintProperty(e1, t1, i, o) : this.setLayoutProperty(e1, t1, i, o));
            }
            getLayoutProperty(e1, t1) {
                const i = this._checkLayer(e1);
                if (i) return i.getLayoutProperty(t1);
            }
            setPaintProperty(t1, i, o, r = {}) {
                this._checkLoaded();
                const n = this._checkLayer(t1);
                if (!n) return;
                if (e1.b7(n.getPaintProperty(i), o)) return;
                if (null != o && (!r || !1 !== r.validate) && So(n, Ue.call(Ae, {
                    key: `layers.${t1}.paint.${i}`,
                    layerType: n.type,
                    objectKey: i,
                    value: o,
                    styleSpec: e1.a8
                }))) return;
                const s = n.setPaintProperty(i, o);
                0 !== n.expressionDependencies.configDependencies.size && this._configDependentLayers.add(n.fqid), n.expressionDependencies.isIndoorDependent && this._indoorDependentLayers.add(n.fqid), s && this._updateLayer(n), this._changes.updatePaintProperties(n);
            }
            getPaintProperty(e1, t1) {
                const i = this._checkLayer(e1);
                if (i) return i.getPaintProperty(t1);
            }
            setFeatureState(t1, i) {
                if (this._checkLoaded(), "target" in t1) {
                    if ("featuresetId" in t1.target) {
                        const { featuresetId: e1, importId: o } = t1.target, r = this.getFragmentStyle(o), n = r.getFeaturesetLayers(e1);
                        for (const { source: e1, sourceLayer: o } of n)r.setFeatureState({
                            id: t1.id,
                            source: e1,
                            sourceLayer: o
                        }, i);
                    } else if ("layerId" in t1.target) {
                        const { layerId: e1 } = t1.target, o = this.getLayer(e1);
                        this.setFeatureState({
                            id: t1.id,
                            source: o.source,
                            sourceLayer: o.sourceLayer
                        }, i);
                    }
                    return;
                }
                const o = t1.source, r = t1.sourceLayer, n = this._checkSource(o);
                if (!n) return;
                const s = n.type;
                if ("geojson" === s && r) return void this.fire(new e1.B(new Error("GeoJSON sources cannot have a sourceLayer parameter.")));
                if ("vector" === s && !r) return void this.fire(new e1.B(new Error("The sourceLayer parameter must be provided for vector source types.")));
                void 0 === t1.id && this.fire(new e1.B(new Error("The feature id parameter must be provided.")));
                const a = this.getOwnSourceCaches(o);
                for (const e1 of a)e1.setFeatureState(r, t1.id, i);
            }
            removeFeatureState(t1, i) {
                if (this._checkLoaded(), "target" in t1) {
                    if ("featuresetId" in t1.target) {
                        const { featuresetId: e1, importId: o } = t1.target, r = this.getFragmentStyle(o), n = r.getFeaturesetLayers(e1);
                        for (const { source: e1, sourceLayer: o } of n)r.removeFeatureState({
                            id: t1.id,
                            source: e1,
                            sourceLayer: o
                        }, i);
                    } else if ("layerId" in t1.target) {
                        const { layerId: e1 } = t1.target, o = this.getLayer(e1);
                        this.removeFeatureState({
                            id: t1.id,
                            source: o.source,
                            sourceLayer: o.sourceLayer
                        }, i);
                    }
                    return;
                }
                const o = t1.source, r = this._checkSource(o);
                if (!r) return;
                const n = r.type, s = "vector" === n ? t1.sourceLayer : void 0;
                if ("vector" === n && !s) return void this.fire(new e1.B(new Error("The sourceLayer parameter must be provided for vector source types.")));
                if (i && "string" != typeof t1.id && "number" != typeof t1.id) return void this.fire(new e1.B(new Error("A feature id is required to remove its specific state property.")));
                const a = this.getOwnSourceCaches(o);
                for (const e1 of a)e1.removeFeatureState(s, t1.id, i);
            }
            getFeatureState(t1) {
                if (this._checkLoaded(), "target" in t1) {
                    let i;
                    if ("featuresetId" in t1.target) {
                        const { featuresetId: o, importId: r } = t1.target, n = this.getFragmentStyle(r), s = n.getFeaturesetLayers(o);
                        for (const { source: o, sourceLayer: r } of s){
                            const s = n.getFeatureState({
                                id: t1.id,
                                source: o,
                                sourceLayer: r
                            });
                            if (s && !i) i = s;
                            else if (!e1.b7(i, s)) return void this.fire(new e1.B(new Error("The same feature id exists in multiple sources in the featureset, but their feature states are not consistent through the sources.")));
                        }
                    } else if ("layerId" in t1.target) {
                        const { layerId: e1 } = t1.target, o = this.getLayer(e1);
                        i = this.getFeatureState({
                            id: t1.id,
                            source: o.source,
                            sourceLayer: o.sourceLayer
                        });
                    }
                    return i;
                }
                const i = t1.source, o = t1.sourceLayer, r = this._checkSource(i);
                if (r) {
                    if ("vector" !== r.type || o) return void 0 === t1.id && this.fire(new e1.B(new Error("The feature id parameter must be provided."))), this.getOwnSourceCaches(i)[0].getFeatureState(o, t1.id);
                    this.fire(new e1.B(new Error("The sourceLayer parameter must be provided for vector source types.")));
                }
            }
            setTransition(e1) {
                return this.stylesheet.transition = Object.assign({}, this.stylesheet.transition, e1), this.transition = this.stylesheet.transition, this;
            }
            getTransition() {
                return Object.assign({}, this.stylesheet.transition);
            }
            setWorldview(e1) {
                e1 !== this._worldview && (this._worldview = e1, this.dispatcher.broadcast("setWorldview", this._worldview), this.reloadSources());
            }
            serialize() {
                this._checkLoaded();
                const t1 = this.getTerrain(), i = t1 && this.terrain && this.terrain.scope === this.scope ? t1 : this.stylesheet.terrain;
                return e1.db({
                    version: this.stylesheet.version,
                    name: this.stylesheet.name,
                    metadata: this.stylesheet.metadata,
                    fragment: this.stylesheet.fragment,
                    iconsets: this.stylesheet.iconsets,
                    featuresets: this.stylesheet.featuresets,
                    imports: this._serializeImports(),
                    schema: this.stylesheet.schema,
                    camera: this.stylesheet.camera,
                    light: this.stylesheet.light,
                    lights: this.stylesheet.lights,
                    terrain: i,
                    fog: this.stylesheet.fog,
                    snow: this.stylesheet.snow,
                    rain: this.stylesheet.rain,
                    indoor: this.stylesheet.indoor,
                    center: this.stylesheet.center,
                    "color-theme": this.stylesheet["color-theme"],
                    zoom: this.stylesheet.zoom,
                    bearing: this.stylesheet.bearing,
                    pitch: this.stylesheet.pitch,
                    sprite: this.stylesheet.sprite,
                    glyphs: this.stylesheet.glyphs,
                    transition: this.stylesheet.transition,
                    projection: this.stylesheet.projection,
                    sources: this._serializeSources(),
                    layers: this._serializeLayers(this._order)
                }, (e1)=>void 0 !== e1);
            }
            _updateFilteredLayers(e1) {
                for (const t1 of Object.values(this._mergedLayers))e1(t1) && this._updateLayer(t1);
            }
            _updateLayer(t1) {
                this._changes.updateLayer(t1);
                const i = this.getLayerSourceCache(t1), o = e1.F(t1.source, t1.scope), r = this._changes.getUpdatedSourceCaches();
                t1.source && !r[o] && i && "raster" !== i.getSource().type && (this._changes.updateSourceCache(o, "reload"), i.pause()), t1.invalidateCompiledFilter();
            }
            _flattenAndSortRenderedFeatures(e1) {
                const t1 = (e1)=>this._mergedLayers[e1].is3D(!!this.terrain), i = this.order, o = {}, r = [];
                for(let n = i.length - 1; n >= 0; n--){
                    const s = i[n];
                    if (t1(s)) {
                        o[s] = n;
                        for (const t1 of e1){
                            const e1 = t1[s];
                            if (e1) for (const t1 of e1)r.push(t1);
                        }
                    }
                }
                r.sort((e1, t1)=>t1.intersectionZ - e1.intersectionZ);
                const n = [];
                for(let s = i.length - 1; s >= 0; s--){
                    const a = i[s];
                    if (t1(a)) for(let e1 = r.length - 1; e1 >= 0; e1--){
                        const t1 = r[e1].feature;
                        if (t1.layer && o[t1.layer.id] < s) break;
                        n.push(t1), r.pop();
                    }
                    else for (const t1 of e1){
                        const e1 = t1[a];
                        if (e1) for (const t1 of e1)n.push(t1.feature);
                    }
                }
                return n;
            }
            queryRasterValue(t1, i, o) {
                const r = this.getOwnSource(t1);
                return r ? "raster-array" !== r.type ? (this.fire(new e1.B(new Error('queryRasterValue support only "raster-array" sources.'))), Promise.resolve(null)) : r.queryRasterArrayValue(i, o) : (this.fire(new e1.B(new Error(`Source with id "${t1}" does not exist in the style.`))), Promise.resolve(null));
            }
            queryRenderedFeatures(t1, i, o) {
                let r;
                i && !Array.isArray(i) && i.filter && (this._validate(Ne, "queryRenderedFeatures.filter", i.filter, null, i), r = e1.dc(i.filter));
                const n = {}, s = (e1)=>{
                    if (Ro.has(e1.type)) return;
                    const t1 = this.getOwnLayerSourceCache(e1), i = n[t1.id] = n[t1.id] || {
                        sourceCache: t1,
                        layers: {},
                        has3DLayers: !1
                    };
                    e1.is3D(!!this.terrain) && (i.has3DLayers = !0), i.layers[e1.fqid] = i.layers[e1.fqid] || {
                        styleLayer: e1,
                        targets: []
                    }, i.layers[e1.fqid].targets.push({
                        filter: r
                    });
                };
                if (i && i.layers) {
                    if (!Array.isArray(i.layers)) return this.fire(new e1.B(new Error("parameters.layers must be an Array."))), [];
                    for (const t1 of i.layers){
                        const i = this._layers[t1];
                        if (!i) return this.fire(new e1.B(new Error(`The layer '${t1}' does not exist in the map's style and cannot be queried for features.`))), [];
                        s(i);
                    }
                } else for(const e1 in this._layers)s(this._layers[e1]);
                const a = this._queryRenderedFeatures(t1, n, o), l = this._flattenAndSortRenderedFeatures(a), c = [];
                for (const t1 of l)e1.dd(t1.layer.id) === this.scope && c.push(t1);
                return c;
            }
            queryRenderedFeatureset(t1, i, o) {
                let r;
                i && !Array.isArray(i) && i.filter && (this._validate(Ne, "queryRenderedFeatures.filter", i.filter, null, i), r = e1.dc(i.filter));
                const n = "mock", s = [];
                if (i && i.target) s.push(Object.assign({}, i, {
                    targetId: n,
                    filter: r
                }));
                else {
                    const e1 = this.getFeaturesetDescriptors();
                    for (const t1 of e1)s.push({
                        targetId: n,
                        filter: r,
                        target: t1
                    });
                    for (const { style: e1 } of this.fragments){
                        const t1 = e1.getFeaturesetDescriptors();
                        for (const e1 of t1)s.push({
                            targetId: n,
                            filter: r,
                            target: e1
                        });
                    }
                }
                const a = this.queryRenderedTargets(t1, s, o), l = [], c = new Set;
                for (const t1 of a)for (const i of t1.variants[n])It(i, t1, c) || l.push(new e1.de(t1, i));
                return l;
            }
            queryRenderedTargets(t1, i, o) {
                const r = {}, n = (e1, t1, i, o)=>{
                    const n = r[t1.id] = r[t1.id] || {
                        sourceCache: t1,
                        layers: {},
                        has3DLayers: !1
                    };
                    if (n.layers[e1.fqid] = n.layers[e1.fqid] || {
                        styleLayer: e1,
                        targets: []
                    }, e1.is3D(!!this.terrain) && (n.has3DLayers = !0), !o) return i.uniqueFeatureID = !1, void n.layers[e1.fqid].targets.push(i);
                    n.layers[e1.fqid].targets.push(Object.assign({}, i, {
                        namespace: o.namespace,
                        properties: o.properties,
                        uniqueFeatureID: o.uniqueFeatureID
                    }));
                };
                for (const t1 of i)if ("featuresetId" in t1.target) {
                    const { featuresetId: i, importId: o } = t1.target, r = this.getFragmentStyle(o);
                    if (!r || !r._featuresetSelectors) continue;
                    const s = r._featuresetSelectors[i];
                    if (!s) {
                        this.fire(new e1.B(new Error(`The featureset '${i}' does not exist in the map's style and cannot be queried for features.`)));
                        continue;
                    }
                    for (const e1 of s){
                        const i = r.getOwnLayer(e1.layerId);
                        i && !Ro.has(i.type) && n(i, r.getOwnLayerSourceCache(i), t1, e1);
                    }
                } else if ("layerId" in t1.target) {
                    const { layerId: e1 } = t1.target, i = this.getLayer(e1);
                    if (!i || Ro.has(i.type)) continue;
                    n(i, this.getLayerSourceCache(i), t1);
                }
                const s = this._queryRenderedFeatures(t1, r, o);
                return this._flattenAndSortRenderedFeatures(s);
            }
            _queryRenderedFeatures(t1, i, o) {
                const r = [], n = !!this.map._showQueryGeometry, s = _t.createFromScreenPoints(t1, o);
                for(const e1 in i){
                    const t1 = Rt(s, i[e1], this._availableImages, o, n, this.getActualScope());
                    Object.keys(t1).length && r.push(t1);
                }
                if (this.placement) for(const t1 in i){
                    if (i[t1].sourceCache._renderSourceType !== e1.b5.Symbol) continue;
                    const o = Dt(s.screenGeometry, i[t1], this._availableImages, this.placement.collisionIndex, this.placement.retainedQueryData, this.map.getWorldview());
                    Object.keys(o).length && r.push(o);
                }
                return r;
            }
            querySourceFeatures(e1, t1) {
                const i = t1 && t1.filter;
                i && this._validate(Ne, "querySourceFeatures.filter", i, null, t1);
                let o = [];
                const r = this.getOwnSourceCaches(e1);
                for (const e1 of r)o = o.concat(At(e1, t1));
                return o;
            }
            addSourceType(e1, t1, i) {
                return Lo.getSourceType(e1) ? i(new Error(`A source type called "${e1}" already exists.`)) : (Lo.setSourceType(e1, t1), t1.workerSourceURL ? void this.dispatcher.broadcast("loadWorkerSource", {
                    name: e1,
                    url: t1.workerSourceURL
                }, i) : i(null, null));
            }
            getFlatLight() {
                return this.light.getLight();
            }
            setFlatLight(t1, i, o = {}) {
                this._checkLoaded();
                const r = this.light.getLight();
                let n = !1;
                for(const i in t1)if (!e1.b7(t1[i], r[i])) {
                    n = !0;
                    break;
                }
                if (!n) return;
                const s = this._getTransitionParameters();
                this.light.setLight(t1, i, o), this.light.updateTransitions(s);
            }
            getTerrain() {
                return this.terrain && 1 === this.terrain.drapeRenderMode ? this.terrain.get() : null;
            }
            setTerrainForDraping() {
                this.setTerrain({
                    source: "",
                    exaggeration: 0
                }, 0);
            }
            checkCanvasFingerprintNoise() {
                void 0 === this.disableElevatedTerrain && (this.disableElevatedTerrain = e1.o.hasCanvasFingerprintNoise(), this.disableElevatedTerrain && e1.w("Terrain and hillshade are disabled because of Canvas2D limitations when fingerprinting protection is enabled (e.g. in private browsing mode)."));
            }
            setTerrain(t1, i = 1) {
                if (this._checkLoaded(), !t1) return this.terrainSetForDrapingOnly() || (delete this.terrain, this.map.transform.projection.requiresDraping && this.setTerrainForDraping()), 0 === i && delete this.terrain, null === t1 ? this.stylesheet.terrain = null : delete this.stylesheet.terrain, this._force3DLayerUpdate(), void (this._markersNeedUpdate = !0);
                this.checkCanvasFingerprintNoise();
                let o = t1;
                const r = !("source" in t1) || null == t1.source;
                if (1 === i) {
                    if (this.disableElevatedTerrain) return;
                    if ("source" in o && "object" == typeof o.source) {
                        const t1 = "terrain-dem-src";
                        this.addSource(t1, o.source), o = e1.d5(o), o = Object.assign(o, {
                            source: t1
                        });
                    }
                    const t1 = Object.assign({}, o), i = {};
                    if (this.terrain && r) {
                        t1.source = this.terrain.get().source;
                        const e1 = this.terrain ? this.getFragmentStyle(this.terrain.scope) : null;
                        e1 && (i.style = e1.serialize());
                    }
                    if (this._validate(Me, "terrain", t1, i)) return;
                }
                if (!this.terrain || this.terrain.scope !== this.scope && !r || this.terrain && i !== this.terrain.drapeRenderMode) {
                    if (!o) return;
                    this._createTerrain(o, i), this.fire(new e1.C("data", {
                        dataType: "style"
                    }));
                } else {
                    const i = this.terrain, r = i.get();
                    for (const t1 of Object.keys(e1.a8.terrain))!o.hasOwnProperty(t1) && e1.a8.terrain[t1].default && (o[t1] = e1.a8.terrain[t1].default);
                    for(const o in t1)if (!e1.b7(t1[o], r[o])) {
                        i.set(t1, this.options), this.stylesheet.terrain = t1;
                        const o = this._getTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(o), this.fire(new e1.C("data", {
                            dataType: "style"
                        }));
                        break;
                    }
                }
                this.mergeTerrain(), this.updateDrapeFirstLayers(), this._markersNeedUpdate = !0;
            }
            _createFog(e1) {
                const t1 = this.fog = new it(e1, this.map.transform, this.scope, this.options);
                this.stylesheet.fog = t1.get();
                const i = this._getTransitionParameters({
                    duration: 0
                });
                t1.updateTransitions(i);
            }
            _createSnow(e1) {
                const t1 = this.snow = new st(e1, this.map.transform, this.scope, this.options);
                this.stylesheet.snow = t1.get();
                const i = this._getTransitionParameters({
                    duration: 0
                });
                t1.updateTransitions(i);
            }
            _createRain(e1) {
                const t1 = this.rain = new at(e1, this.map.transform, this.scope, this.options);
                this.stylesheet.rain = t1.get();
                const i = this._getTransitionParameters({
                    duration: 0
                });
                t1.updateTransitions(i);
            }
            _updateMarkersOpacity() {
                0 !== this.map._markers.length && this.map._requestDomTask(()=>{
                    for (const e1 of this.map._markers)e1._evaluateOpacity();
                });
            }
            getFog() {
                return this.fog ? this.fog.get() : null;
            }
            setFog(t1) {
                if (this._checkLoaded(), !t1) return delete this.fog, delete this.stylesheet.fog, void (this._markersNeedUpdate = !0);
                if (this.fog) {
                    const i = this.fog;
                    if (!e1.b7(i.get(), t1)) {
                        i.set(t1, this.options), this.stylesheet.fog = i.get();
                        const e1 = this._getTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(e1);
                    }
                } else this._createFog(t1);
                this._markersNeedUpdate = !0;
            }
            getSnow() {
                return this.snow ? this.snow.get() : null;
            }
            setSnow(t1) {
                if (this._checkLoaded(), !t1) return delete this.snow, void delete this.stylesheet.snow;
                if (this.snow) {
                    const i = this.snow;
                    if (!e1.b7(i.get(), t1)) {
                        i.set(t1, this.options), this.stylesheet.snow = i.get();
                        const e1 = this._getTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(e1);
                    }
                } else this._createSnow(t1);
                this._markersNeedUpdate = !0;
            }
            getRain() {
                return this.rain ? this.rain.get() : null;
            }
            setRain(t1) {
                if (this._checkLoaded(), !t1) return delete this.rain, void delete this.stylesheet.rain;
                if (this.rain) {
                    const i = this.rain;
                    if (!e1.b7(i.get(), t1)) {
                        i.set(t1, this.options), this.stylesheet.rain = i.get();
                        const e1 = this._getTransitionParameters({
                            duration: 0
                        });
                        i.updateTransitions(e1);
                    }
                } else this._createRain(t1);
                this._markersNeedUpdate = !0;
            }
            _reloadColorTheme() {
                const t1 = ()=>{
                    for(const e1 in this._layers)this._layers[e1].lut = this._styleColorTheme.lut;
                    for(const e1 in this._sourceCaches)this._sourceCaches[e1].clearTiles();
                }, i = this._styleColorTheme.colorThemeOverride ? this._styleColorTheme.colorThemeOverride : this._styleColorTheme.colorTheme;
                if (!i) return this._styleColorTheme.lut = null, void t1();
                const o = this._evaluateColorThemeData(i);
                this._loadColorTheme(o).then(()=>{
                    this.fire(new e1.C("colorthemeset")), t1();
                }).catch((t1)=>{
                    e1.w(`Couldn't set color theme: ${t1}`);
                });
            }
            setColorTheme(t1) {
                this._checkLoaded(), this._styleColorTheme.colorThemeOverride && e1.w("Note: setColorTheme is called on a style with a color-theme override, the passed color-theme won't be visible."), this._styleColorTheme.colorTheme = t1, this._reloadColorTheme();
            }
            setImportColorTheme(e1, t1) {
                const i = this.getFragmentStyle(e1);
                i && (i._styleColorTheme.colorThemeOverride = t1, i._reloadColorTheme());
            }
            _getTransitionParameters(t1) {
                return {
                    now: e1.o.now(),
                    transition: Object.assign(this.transition, t1)
                };
            }
            updateDrapeFirstLayers() {
                if (!this.terrain) return;
                const e1 = [], t1 = [];
                for (const i of this._mergedOrder)this.isLayerDraped(this._mergedLayers[i]) ? e1.push(i) : t1.push(i);
                this._drapedFirstOrder = [], this._drapedFirstOrder.push(...e1), this._drapedFirstOrder.push(...t1);
            }
            _createTerrain(e1, t1) {
                const i = this.terrain = new Xe(e1, t1, this.scope, this.options, this.map.getWorldview());
                1 === t1 && (this.stylesheet.terrain = e1), this.mergeTerrain(), this.updateDrapeFirstLayers(), this._force3DLayerUpdate();
                const o = this._getTransitionParameters({
                    duration: 0
                });
                i.updateTransitions(o);
            }
            _force3DLayerUpdate() {
                for(const e1 in this._layers){
                    const t1 = this._layers[e1];
                    "fill-extrusion" === t1.type && this._updateLayer(t1);
                }
            }
            _forceSymbolLayerUpdate() {
                for(const e1 in this._layers){
                    const t1 = this._layers[e1];
                    "symbol" === t1.type && this._updateLayer(t1);
                }
            }
            _validate(t1, i, o, r, n = {}) {
                if (n && !1 === n.validate) return !1;
                const s = Object.assign({}, this.serialize());
                return So(this, t1.call(Ae, Object.assign({
                    key: i,
                    style: s,
                    value: o,
                    styleSpec: e1.a8
                }, r)));
            }
            _remove() {
                this._request && (this._request.cancel(), this._request = null), this._spriteRequest && (this._spriteRequest.cancel(), this._spriteRequest = null), e1.df.off("pluginStateChange", this._rtlTextPluginCallback);
                for(const e1 in this._mergedLayers)this._mergedLayers[e1].setEventedParent(null);
                for(const e1 in this._mergedSourceCaches)this._mergedSourceCaches[e1].clearTiles(), this._mergedSourceCaches[e1].setEventedParent(null);
                this.imageManager.removeScope(this.scope), this.imageManager.imageAtlasCache.clear(), this.setEventedParent(null), delete this.fog, delete this.snow, delete this.rain, delete this.terrain, delete this.ambientLight, delete this.directionalLight, this.indoorManager.destroy(), this.isRootStyle() && (this.imageManager.setEventedParent(null), this.imageManager.destroy(), this.modelManager.setEventedParent(null), this.modelManager.destroy(), this.dispatcher.remove());
            }
            clearSource(e1) {
                const t1 = this.getSourceCaches(e1);
                for (const e1 of t1)e1.clearTiles();
            }
            clearSources() {
                for(const e1 in this._mergedSourceCaches)this._mergedSourceCaches[e1].clearTiles();
            }
            clearLayers() {
                for(const e1 in this._mergedLayers){
                    const t1 = this._mergedLayers[e1];
                    t1._clear && t1._clear();
                }
            }
            reloadSource(e1) {
                const t1 = this.getSourceCaches(e1);
                for (const e1 of t1)e1.resume(), e1.reload();
            }
            reloadSources() {
                for (const e1 of this.getSources())e1.reload && e1.reload();
            }
            reloadModels() {
                this.modelManager.reloadModels(""), this.forEachFragmentStyle((e1)=>{
                    e1.modelManager.reloadModels(e1.scope);
                });
            }
            updateSources(e1) {
                let t1;
                this.directionalLight && (t1 = po(this.directionalLight));
                const i = new Set, o = new Set, r = new Set;
                for(const e1 in this._mergedLayers){
                    const t1 = this._mergedLayers[e1];
                    "building" === t1.type ? i.add(t1.source) : "raster" === t1.type && t1.paint && "ground" === t1.paint.get("raster-elevation-reference") && r.add(t1.source), t1.hasElevation() && !o.has(t1.source) && o.add(t1.source);
                }
                for(const n in this._mergedSourceCaches){
                    const s = this._mergedSourceCaches[n], a = o.has(s._source.id);
                    s._isRasterElevatedOverTerrain = r.has(s._source.id), i.has(s._source.id) && (s._source.reparseOverscaled = !1), s.update(e1, void 0, void 0, t1, a);
                }
            }
            _generateCollisionBoxes() {
                for(const e1 in this._sourceCaches){
                    const t1 = this._sourceCaches[e1];
                    t1.resume(), t1.reload();
                }
            }
            _handleLayerOrderChange() {
                this._requestFullLabelPlacement(), this.fire(new e1.C("neworder"));
            }
            _requestFullLabelPlacement() {
                this.pauseablePlacement || (this.pauseablePlacement = new ki), this.pauseablePlacement.requestFullPlacement();
            }
            _setLabelPlacementStale() {
                this.placement && this.placement.setStale();
            }
            _updatePlacement(t1, i, o, r, n) {
                this.pauseablePlacement || (this.pauseablePlacement = new ki);
                let s = !1, a = !1;
                const l = {}, c = {};
                for (const i of this._mergedOrder){
                    const o = this._mergedLayers[i];
                    if ("symbol" !== o.type) continue;
                    const r = e1.F(o.source, o.scope);
                    let n = l[r];
                    if (!n) {
                        const e1 = this.getLayerSourceCache(o);
                        if (!e1) continue;
                        const t1 = e1.getRenderableIds(!0).map((t1)=>e1.getTileByID(t1));
                        c[r] = t1.slice(), n = l[r] = t1.sort((e1, t1)=>t1.tileID.overscaledZ - e1.tileID.overscaledZ || (e1.tileID.isLessThan(t1.tileID) ? -1 : 1));
                    }
                    const a = this.crossTileSymbolIndex.addLayer(o, n, t1.center.lng, t1.projection);
                    s = s || a;
                }
                this.crossTileSymbolIndex.pruneUnusedLayers(this._mergedOrder);
                const h = Boolean(this.placement && !t1.equals(this.placement.transform)), d = Boolean(this.placement && (0 !== this.placement.lastReplacementSourceUpdateTime && !n || this.placement.lastReplacementSourceUpdateTime !== n.updateTime)), _ = h || d || s, u = (_ || this.pauseablePlacement.isStale()) && 0 === o, p = this.pauseablePlacement.isDone() && !this.placement.stillRecent(e1.o.now(), t1.zoom) && 0 !== o;
                if ((this.pauseablePlacement.isFullPlacementRequested() || !this.pauseablePlacement.placement || u || p) && (this.pauseablePlacement = this.pauseablePlacement.startNewPlacement(t1, this._mergedOrder, i, o, r, this.placement, this.fog && t1.projection.supportsFog ? this.fog.state : null, this._buildingIndex), this.map.painter)) {
                    const e1 = this.map.painter.maxFrontCutoffRawStart;
                    if (e1 > 0) {
                        const i = 180 * t1.pitch / Math.PI;
                        if (i >= 15) {
                            const t1 = Math.min(1, Math.max(0, (i - 15) / 5)), o = t1 * t1 * (3 - 2 * t1);
                            this.pauseablePlacement.placement.frontCutoffStart = -0.5 * (1 - o) + e1 * o;
                        }
                    }
                }
                if (this.pauseablePlacement.isDone() ? _ && 0 !== o && this.pauseablePlacement.setStale() : (this.pauseablePlacement.continuePlacement(this._mergedOrder, this._mergedLayers, l, c, this.map.painter.scaleFactor), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(e1.o.now()), a = !0), s && this.pauseablePlacement.setStale()), a || s) {
                    this._buildingIndex.onNewFrame(t1.zoom);
                    for(let t1 = 0; t1 < this._mergedOrder.length; t1++){
                        const i = this._mergedLayers[this._mergedOrder[t1]];
                        if ("symbol" !== i.type) continue;
                        if ("none" === i.visibility) continue;
                        const o = this.isLayerClipped(i);
                        this.placement.updateLayerOpacities(i, l[e1.F(i.source, i.scope)], t1, o ? n : null);
                    }
                }
                return !this.pauseablePlacement.isDone() || this.placement.isStale() || this.placement.hasTransitions(e1.o.now());
            }
            _releaseSymbolFadeTiles() {
                for(const e1 in this._sourceCaches)this._sourceCaches[e1].releaseSymbolFadeTiles();
            }
            addImport(t1, i) {
                this._checkLoaded();
                const o = this.stylesheet.imports = this.stylesheet.imports || [];
                if (-1 !== o.findIndex(({ id: e1 })=>e1 === t1.id)) return void this.fire(new e1.B(new Error(`Import with id '${t1.id}' already exists in the map's style.`)));
                if (!i) return o.push(t1), this._loadImports([
                    t1
                ], !0);
                const r = o.findIndex(({ id: e1 })=>e1 === i);
                return -1 === r && this.fire(new e1.B(new Error(`Import with id "${i}" does not exist on this map.`))), this.stylesheet.imports = o.slice(0, r).concat(t1).concat(o.slice(r)), this._loadImports([
                    t1
                ], !0, i);
            }
            updateImport(t1, i) {
                this._checkLoaded();
                const o = this.stylesheet.imports || [], r = this.getImportIndex(t1);
                return -1 === r ? this : "string" == typeof i ? (this.setImportUrl(t1, i), this) : (i.url && i.url !== o[r].url && this.setImportUrl(t1, i.url), e1.b7(i.config, o[r].config) || this.setImportConfig(t1, i.config, i.data.schema), e1.b7(i.data, o[r].data) || this.setImportData(t1, i.data), this);
            }
            moveImport(e1, t1) {
                this._checkLoaded();
                let i = this.stylesheet.imports || [];
                const o = this.getImportIndex(e1);
                if (-1 === o) return this;
                const r = this.getImportIndex(t1);
                if (-1 === r) return this;
                const n = i[o], s = this.fragments[o];
                return i = i.filter(({ id: t1 })=>t1 !== e1), this.fragments = this.fragments.filter(({ id: t1 })=>t1 !== e1), this.stylesheet.imports = i.slice(0, r).concat(n).concat(i.slice(r)), this.fragments = this.fragments.slice(0, r).concat(s).concat(this.fragments.slice(r)), this.mergeLayers(), this;
            }
            setImportUrl(e1, t1) {
                this._checkLoaded();
                const i = this.stylesheet.imports || [], o = this.getImportIndex(e1);
                if (-1 === o) return this;
                i[o].url = t1;
                const r = this.fragments[o];
                return r.style = this._createFragmentStyle(i[o]), r.style.on("style.import.load", ()=>this.mergeAll()), r.style.loadURL(t1), this;
            }
            setImportData(e1, t1) {
                this._checkLoaded();
                const i = this.getImportIndex(e1), o = this.stylesheet.imports || [];
                return -1 === i ? this : t1 ? (this.fragments[i].style.setState(t1), this._reloadImports(), this) : (delete o[i].data, this.setImportUrl(e1, o[i].url));
            }
            setImportConfig(e1, t1, i) {
                this._checkLoaded();
                const o = this.getImportIndex(e1), r = this.stylesheet.imports || [];
                if (-1 === o) return this;
                t1 ? r[o].config = t1 : delete r[o].config;
                const n = this.fragments[o];
                i && n.style.stylesheet && (n.style.stylesheet.schema = i);
                const s = n.style.stylesheet && n.style.stylesheet.schema;
                return n.config = t1, n.style.updateConfig(t1, s), this.updateConfigDependencies(), this;
            }
            removeImport(e1) {
                this._checkLoaded();
                const t1 = this.stylesheet.imports || [], i = this.getImportIndex(e1);
                -1 !== i && (t1.splice(i, 1), this.fragments[i].style._remove(), this.fragments.splice(i, 1), this._reloadImports());
            }
            getImportIndex(t1) {
                const i = (this.stylesheet.imports || []).findIndex((e1)=>e1.id === t1);
                return -1 === i && this.fire(new e1.B(new Error(`Import '${t1}' does not exist in the map's style and cannot be updated.`))), i;
            }
            getLayer(e1) {
                return this._mergedLayers[e1];
            }
            getSources() {
                const e1 = [];
                for(const t1 in this._mergedOtherSourceCaches){
                    const i = this._mergedOtherSourceCaches[t1];
                    i && e1.push(i.getSource());
                }
                return e1;
            }
            getSource(e1, t1) {
                const i = this.getSourceCache(e1, t1);
                return i && i.getSource();
            }
            getLayerSource(e1) {
                const t1 = this.getLayerSourceCache(e1);
                return t1 && t1.getSource();
            }
            getSourceCache(t1, i) {
                const o = e1.F(t1, i);
                return this._mergedOtherSourceCaches[o];
            }
            getLayerSourceCache(t1) {
                const i = e1.F(t1.source, t1.scope);
                return "symbol" === t1.type ? this._mergedSymbolSourceCaches[i] : "fill-extrusion" === t1.type && this._mergedFillExtrusionSourceCaches[i] || this._mergedOtherSourceCaches[i];
            }
            getSourceCaches(e1) {
                if (null == e1) return Object.values(this._mergedSourceCaches);
                const t1 = [];
                return this._mergedOtherSourceCaches[e1] && t1.push(this._mergedOtherSourceCaches[e1]), this._mergedSymbolSourceCaches[e1] && t1.push(this._mergedSymbolSourceCaches[e1]), this._mergedFillExtrusionSourceCaches[e1] && t1.push(this._mergedFillExtrusionSourceCaches[e1]), t1;
            }
            updateSourceCaches() {
                const e1 = this._changes.getUpdatedSourceCaches();
                for(const t1 in e1){
                    const i = e1[t1];
                    "reload" === i ? this.reloadSource(t1) : "clear" === i && this.clearSource(t1);
                }
            }
            updateLayers(e1) {
                const t1 = this._changes.getUpdatedPaintProperties();
                for (const i of t1){
                    const t1 = this.getLayer(i);
                    t1 && t1.updateTransitions(e1);
                }
            }
            getGlyphsUrl() {
                return this.stylesheet.glyphs;
            }
            setGlyphsUrl(e1) {
                this.stylesheet.glyphs = e1, this.glyphManager.setURL(e1);
            }
            getImages(t1, i, o) {
                this.imageManager.getImages(i.images, i.scope, o), this._updateTilesForChangedImages();
                const r = (t1)=>{
                    if (t1) {
                        const o = i.images.map((t1)=>e1.I.toString(t1));
                        t1.setDependencies(i.tileID.key, i.type, o);
                    }
                }, n = e1.F(i.source, i.scope);
                r(this._mergedOtherSourceCaches[n]), r(this._mergedSymbolSourceCaches[n]), i.images.some((e1)=>e1.iconsetId) && this.fire(new e1.C("data", {
                    dataType: "style"
                }));
            }
            rasterizeImages(e1, t1, i) {
                this.imageManager.rasterizeImages(t1, i);
            }
            checkAtlasCache(e1, t1, i) {
                const o = this.imageManager.imageAtlasCache.findCachedAtlas(t1.descriptor);
                i(null, o && o.contentDescriptor ? {
                    iconPositions: o.iconPositions,
                    patternPositions: o.patternPositions,
                    sourceHash: o.contentDescriptor.hash
                } : null);
            }
            getGlyphs(e1, t1, i) {
                this.glyphManager.getGlyphs(t1.stacks, i);
            }
            getOwnSourceCache(e1) {
                return this._otherSourceCaches[e1];
            }
            getOwnLayerSourceCache(e1) {
                return "symbol" === e1.type ? this._symbolSourceCaches[e1.source] : "fill-extrusion" === e1.type && this._fillExtrusionSourceCaches[e1.source] || this._otherSourceCaches[e1.source];
            }
            getOwnSourceCaches(e1) {
                const t1 = [];
                return this._otherSourceCaches[e1] && t1.push(this._otherSourceCaches[e1]), this._symbolSourceCaches[e1] && t1.push(this._symbolSourceCaches[e1]), this._fillExtrusionSourceCaches[e1] && t1.push(this._fillExtrusionSourceCaches[e1]), t1;
            }
            _isSourceCacheLoaded(t1) {
                const i = this.getOwnSourceCaches(t1);
                return 0 === i.length ? (this.fire(new e1.B(new Error(`There is no source with ID '${t1}'`))), !1) : i.every((e1)=>e1.loaded());
            }
            has3DLayers() {
                return this._has3DLayers;
            }
            hasSymbolLayers() {
                return this._hasSymbolLayers;
            }
            hasCircleLayers() {
                return this._hasCircleLayers;
            }
            isLayerClipped(e1, t1) {
                if (!this._clipLayerPresent && "fill-extrusion" !== e1.type && "building" !== e1.type) return !1;
                const i = "fill-extrusion" === e1.type && ("building" === e1.sourceLayer || "procedural_buildings" === e1.sourceLayer), o = "building" === e1.type;
                if (e1.is3D(!!this.terrain)) {
                    if (i || o || t1 && "batched-model" === t1.type) return !0;
                    if ("model" === e1.type) return !0;
                } else if ("symbol" === e1.type) return !0;
                return !1;
            }
            _clearWorkerCaches() {
                this.dispatcher.broadcast("clearCaches");
            }
            getBOMObject() {}
            destroy() {
                this._clearWorkerCaches(), this.imageManager.imageAtlasCache.clear(), this.fragments.forEach((e1)=>{
                    e1.style._remove();
                }), this.terrainSetForDrapingOnly() && (delete this.terrain, delete this.stylesheet.terrain);
            }
        }
        Lo.getSourceType = function(e1) {
            return Et[e1];
        }, Lo.setSourceType = function(e1, t1) {
            Et[e1] = t1;
        }, Lo.registerForPluginStateChange = e1.dg;
        var Po = "\n#define EPSILON 0.0000001\n#define PI 3.141592653589793\n#ifdef RENDER_CUTOFF\nfloat cutoff_opacity(vec4 cutoff_params,float depth) {float near=cutoff_params.x;float far=cutoff_params.y;float cutoffStart=cutoff_params.z;float cutoffEnd=cutoff_params.w;float linearDepth=(depth-near)/(far-near);return clamp((linearDepth-cutoffStart)/(cutoffEnd-cutoffStart),0.0,1.0);}\n#endif", Oo = "\n#ifdef DUAL_SOURCE_BLENDING\nlayout(location=0,index=0) out vec4 glFragColor;layout(location=0,index=1) out vec4 glFragColorSrc1;\n#else\nlayout(location=0) out vec4 glFragColor;\n#endif\n#ifdef USE_MRT1\nlayout(location=1) out vec4 out_Target1;\n#endif\nhighp float unpack_depth(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}highp vec4 pack_depth(highp float ndc_z) {highp float depth=ndc_z*0.5+0.5;const highp vec4 bit_shift=vec4(255.0*255.0*255.0,255.0*255.0,255.0,1.0);const highp vec4 bit_mask =vec4(0.0,1.0/255.0,1.0/255.0,1.0/255.0);highp vec4 res=fract(depth*bit_shift);res-=res.xxyz*bit_mask;return res;}\n#ifdef INDICATOR_CUTOUT\nuniform vec3 u_indicator_cutout_centers;uniform vec4 u_indicator_cutout_params;\n#endif\nconst float DITHER_THRESHOLDS[16]=float[16](\n1.0/17.0, 9.0/17.0, 3.0/17.0,11.0/17.0,13.0/17.0, 5.0/17.0,15.0/17.0, 7.0/17.0,4.0/17.0,12.0/17.0, 2.0/17.0,10.0/17.0,16.0/17.0, 8.0/17.0,14.0/17.0, 6.0/17.0\n);vec4 applyCutout(vec4 color,float height) {\n#ifdef INDICATOR_CUTOUT\nfloat verticalFadeRange=u_indicator_cutout_centers.z*0.25;float holeMinOpacity=mix(1.0,u_indicator_cutout_params.x,smoothstep(u_indicator_cutout_centers.z,u_indicator_cutout_centers.z+verticalFadeRange,height));float holeRadius=max(u_indicator_cutout_params.y,0.0);float holeAspectRatio=u_indicator_cutout_params.z;float fadeStart=u_indicator_cutout_params.w;float distA=distance(vec2(gl_FragCoord.x,gl_FragCoord.y*holeAspectRatio),vec2(u_indicator_cutout_centers[0],u_indicator_cutout_centers[1]*holeAspectRatio));return color*min(smoothstep(fadeStart,holeRadius,distA)+holeMinOpacity,1.0);\n#else\nreturn color;\n#endif\n}float cutoutGroundRoofOpacity(vec4 groundRoof) {\n#ifdef INDICATOR_CUTOUT\nfloat fadeStartX=u_indicator_cutout_params.w;float holeRadius=u_indicator_cutout_params.y;float holeMinOpacity=mix(u_indicator_cutout_params.x,1.0,smoothstep(u_indicator_cutout_params.z,u_indicator_cutout_centers.z,groundRoof.y));float distX=abs(u_indicator_cutout_centers.x-groundRoof.x);float roofOpacity=mix(holeMinOpacity,1.0,smoothstep(fadeStartX,holeRadius,u_indicator_cutout_centers.y-groundRoof.w));float groundOpacity=min(smoothstep(fadeStartX,holeRadius,distX)+holeMinOpacity,1.0);return max(roofOpacity,groundOpacity);\n#else\nreturn 1.0;\n#endif\n}\n#ifdef DEBUG_WIREFRAME\n#define HANDLE_WIREFRAME_DEBUG \\\nglFragColor=vec4(0.7,0.0,0.0,0.7); \\\ngl_FragDepth=gl_FragCoord.z-0.0001;\n#else\n#define HANDLE_WIREFRAME_DEBUG\n#endif\n#ifdef RENDER_CUTOFF\nuniform highp vec4 u_cutoff_params;in float v_cutoff_opacity;\n#endif\nvec4 textureLodCustom(sampler2D image,highp vec2 pos,highp vec2 lod_coord) {highp vec2 size=vec2(textureSize(image,0));highp vec2 dx=dFdx(lod_coord.xy*size);highp vec2 dy=dFdy(lod_coord.xy*size);highp float delta_max_sqr=max(dot(dx,dx),dot(dy,dy));highp float lod=0.5*log2(delta_max_sqr);return textureLod(image,pos,lod);}vec4 applyLUT(highp sampler3D lut,vec4 col) {vec3 size=vec3(textureSize(lut,0));vec3 uvw=(col.rbg*float(size-1.0)+0.5)/size;return vec4(texture(lut,uvw).rgb*col.a,col.a);}vec3 applyLUT(highp sampler3D lut,vec3 col) {return applyLUT(lut,vec4(col,1.0)).rgb;}", Mo = "\n#define EXTENT 8192.0\n#define RAD_TO_DEG 180.0/PI\n#define DEG_TO_RAD PI/180.0\n#define GLOBE_RADIUS EXTENT/PI/2.0\nfloat wrap(float n,float min,float max) {float d=max-min;float w=mod(mod(n-min,d)+d,d)+min;return (w==min) ? max : w;}\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 mercator_tile_position(mat4 matrix,vec2 tile_anchor,vec3 tile_id,vec2 mercator_center) {\n#ifndef PROJECTED_POS_ON_VIEWPORT\nfloat tiles=tile_id.z;vec2 mercator=(tile_anchor/EXTENT+tile_id.xy)/tiles;mercator-=mercator_center;mercator.x=wrap(mercator.x,-0.5,0.5);vec4 mercator_tile=vec4(mercator.xy*EXTENT,EXTENT/(2.0*PI),1.0);mercator_tile=matrix*mercator_tile;return mercator_tile.xyz;\n#else\nreturn vec3(0.0);\n#endif\n}vec3 mix_globe_mercator(vec3 globe,vec3 mercator,float t) {return mix(globe,mercator,t);}mat3 globe_mercator_surface_vectors(vec3 pos_normal,vec3 up_dir,float zoom_transition) {vec3 normal=zoom_transition==0.0 ? pos_normal : normalize(mix(pos_normal,up_dir,zoom_transition));vec3 xAxis=normalize(vec3(normal.z,0.0,-normal.x));vec3 yAxis=normalize(cross(normal,xAxis));return mat3(xAxis,yAxis,normal);}\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec4 decode_color(const vec2 encodedColor) {return vec4(\nunpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const vec2 units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (units_to_pixels*pos+offset)/pattern_size;}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {return get_pattern_pos(pixel_coord_upper,pixel_coord_lower,pattern_size,vec2(tile_units_to_pixels),pos);}float mercatorXfromLng(float lng) {return (180.0+lng)/360.0;}float mercatorYfromLat(float lat) {return (180.0-(RAD_TO_DEG*log(tan(PI/4.0+lat/2.0*DEG_TO_RAD))))/360.0;}vec3 latLngToECEF(vec2 latLng) {latLng=DEG_TO_RAD*latLng;float cosLat=cos(latLng[0]);float sinLat=sin(latLng[0]);float cosLng=cos(latLng[1]);float sinLng=sin(latLng[1]);float sx=cosLat*sinLng*GLOBE_RADIUS;float sy=-sinLat*GLOBE_RADIUS;float sz=cosLat*cosLng*GLOBE_RADIUS;return vec3(sx,sy,sz);}\n#ifdef RENDER_CUTOFF\nuniform vec4 u_cutoff_params;out float v_cutoff_opacity;\n#endif\nconst vec4 AWAY=vec4(-1000.0,-1000.0,-1000.0,1);const float skirtOffset=24575.0;vec3 decomposeToPosAndSkirt(ivec2 posWithComposedSkirt)\n{float skirt=float(float(posWithComposedSkirt.x) >=skirtOffset);vec2 pos=vec2(posWithComposedSkirt)-vec2(skirt*skirtOffset,0.0);return vec3(pos,skirt);}\n#ifndef HAS_SHADER_STORAGE_BLOCK_material_buffer\n#define GET_ATTRIBUTE_float(attrib,matInfo,attrib_id) attrib\n#define GET_ATTRIBUTE_vec4(attrib,matInfo,attrib_id) attrib\n#define GET_ATTRIBUTE_vec2(attrib,matInfo,attrib_id) attrib\n#define DECLARE_MATERIAL_TABLE_INFO\n#endif", zo = "in highp vec3 a_pos_3f;uniform lowp mat4 u_matrix;out highp vec3 v_uv;void main() {const mat3 half_neg_pi_around_x=mat3(1.0,0.0, 0.0,0.0,0.0,-1.0,0.0,1.0, 0.0);v_uv=half_neg_pi_around_x*a_pos_3f;vec4 pos=u_matrix*vec4(a_pos_3f,1.0);gl_Position=pos.xyww;}", Fo = "\n#define ELEVATION_SCALE 7.0\n#define ELEVATION_OFFSET 450.0\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_tl_up;uniform vec3 u_tile_tr_up;uniform vec3 u_tile_br_up;uniform vec3 u_tile_bl_up;uniform float u_tile_up_scale;vec3 elevationVector(vec2 pos) {vec2 uv=pos/EXTENT;vec3 up=normalize(mix(\nmix(u_tile_tl_up,u_tile_tr_up,uv.xxx),mix(u_tile_bl_up,u_tile_br_up,uv.xxx),uv.yyy));return up*u_tile_up_scale;}\n#else\nvec3 elevationVector(vec2 pos) { return vec3(0,0,1); }\n#endif\n#ifdef TERRAIN\nuniform highp sampler2D u_dem;uniform highp sampler2D u_dem_prev;uniform vec2 u_dem_tl;uniform vec2 u_dem_tl_prev;uniform float u_dem_scale;uniform float u_dem_scale_prev;uniform float u_dem_size;uniform float u_dem_lerp;uniform float u_exaggeration;uniform float u_meter_to_dem;uniform mat4 u_label_plane_matrix_inv;vec4 tileUvToDemSample(vec2 uv,float dem_size,float dem_scale,vec2 dem_tl) {vec2 pos=dem_size*(uv*dem_scale+dem_tl)+1.0;vec2 f=fract(pos);return vec4((pos-f+0.5)/(dem_size+2.0),f);}float currentElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale+u_dem_tl)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale,u_dem_tl);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(dd,0)).r;float bl=texture(u_dem,pos+vec2(0,dd)).r;float br=texture(u_dem,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}float prevElevation(vec2 apos) {\n#ifdef TERRAIN_DEM_FLOAT_FORMAT\nvec2 pos=(u_dem_size*(apos/8192.0*u_dem_scale_prev+u_dem_tl_prev)+1.5)/(u_dem_size+2.0);return u_exaggeration*texture(u_dem_prev,pos).r;\n#else\nfloat dd=1.0/(u_dem_size+2.0);vec4 r=tileUvToDemSample(apos/8192.0,u_dem_size,u_dem_scale_prev,u_dem_tl_prev);vec2 pos=r.xy;vec2 f=r.zw;float tl=texture(u_dem_prev,pos).r;float tr=texture(u_dem_prev,pos+vec2(dd,0)).r;float bl=texture(u_dem_prev,pos+vec2(0,dd)).r;float br=texture(u_dem_prev,pos+vec2(dd,dd)).r;return u_exaggeration*mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);\n#endif\n}\n#ifdef TERRAIN_VERTEX_MORPHING\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nfloat nextElevation=currentElevation(apos);float prevElevation=prevElevation(apos);return mix(prevElevation,nextElevation,u_dem_lerp);}\n#else\nfloat elevation(vec2 apos) {\n#ifdef ZERO_EXAGGERATION\nreturn 0.0;\n#endif\nreturn currentElevation(apos);}\n#endif\nvec4 fourSample(vec2 pos,vec2 off) {float tl=texture(u_dem,pos).r;float tr=texture(u_dem,pos+vec2(off.x,0.0)).r;float bl=texture(u_dem,pos+vec2(0.0,off.y)).r;float br=texture(u_dem,pos+off).r;return vec4(tl,tr,bl,br);}float flatElevation(vec2 pack) {vec2 apos=floor(pack/8.0);vec2 span=10.0*(pack-apos*8.0);vec2 uvTex=(apos-vec2(1.0,1.0))/8190.0;float size=u_dem_size+2.0;float dd=1.0/size;vec2 pos=u_dem_size*(uvTex*u_dem_scale+u_dem_tl)+1.0;vec2 f=fract(pos);pos=(pos-f+0.5)*dd;vec4 h=fourSample(pos,vec2(dd));float z=mix(mix(h.x,h.y,f.x),mix(h.z,h.w,f.x),f.y);vec2 w=floor(0.5*(span*u_meter_to_dem-1.0));vec2 d=dd*w;h=fourSample(pos-d,2.0*d+vec2(dd));vec4 diff=abs(h.xzxy-h.ywzw);vec2 slope=min(vec2(0.25),u_meter_to_dem*0.5*(diff.xz+diff.yw)/(2.0*w+vec2(1.0)));vec2 fix=slope*span;float base=z+max(fix.x,fix.y);return u_exaggeration*base;}float elevationFromUint16(float word) {return u_exaggeration*(word/ELEVATION_SCALE-ELEVATION_OFFSET);}\n#else\nfloat elevation(vec2 pos) { return 0.0; }\n#endif\n#ifdef DEPTH_OCCLUSION\nuniform highp sampler2D u_depth;uniform highp vec2 u_depth_size_inv;uniform highp vec2 u_depth_range_unpack;uniform highp float u_occluder_half_size;uniform highp float u_occlusion_depth_offset;\n#ifdef DEPTH_D24\nfloat unpack_depth(float depth) {return depth*u_depth_range_unpack.x+u_depth_range_unpack.y;}vec4 unpack_depth4(vec4 depth) {return depth*u_depth_range_unpack.x+vec4(u_depth_range_unpack.y);}\n#else\nhighp float unpack_depth_rgba(vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}\n#endif\nbool isOccluded(vec4 frag) {vec3 coord=frag.xyz/frag.w;\n#ifdef CLIP_ZERO_TO_ONE\ncoord.z=-1.0+2.0*coord.z; \n#endif\n#ifdef DEPTH_D24\nfloat depth=unpack_depth(texture(u_depth,(coord.xy+1.0)*0.5).r);\n#else\nfloat depth=unpack_depth_rgba(texture(u_depth,(coord.xy+1.0)*0.5));\n#endif\nreturn coord.z+u_occlusion_depth_offset > depth;}highp vec4 getCornerDepths(vec2 coord) {highp vec3 df=vec3(u_occluder_half_size*u_depth_size_inv,0.0);highp vec2 uv=0.5*coord.xy+0.5;\n#ifdef DEPTH_D24\nhighp vec4 depth=vec4(\ntexture(u_depth,uv-df.xz).r,texture(u_depth,uv+df.xz).r,texture(u_depth,uv-df.zy).r,texture(u_depth,uv+df.zy).r\n);depth=unpack_depth4(depth);\n#else\nhighp vec4 depth=vec4(\nunpack_depth_rgba(texture(u_depth,uv-df.xz)),unpack_depth_rgba(texture(u_depth,uv+df.xz)),unpack_depth_rgba(texture(u_depth,uv-df.zy)),unpack_depth_rgba(texture(u_depth,uv+df.zy))\n);\n#endif\nreturn depth;}highp float occlusionFadeMultiSample(vec4 frag) {highp vec3 coord=frag.xyz/frag.w;highp vec2 uv=0.5*coord.xy+0.5;\n#ifdef CLIP_ZERO_TO_ONE\ncoord.z=-1.0+2.0*coord.z; \n#endif\nint NX=3;int NY=4;highp vec2 df=u_occluder_half_size*u_depth_size_inv;highp vec2 oneStep=2.0*u_occluder_half_size*u_depth_size_inv/vec2(NX-1,NY-1);highp float res=0.0;for (int y=0; y < NY;++y) {for (int x=0; x < NX;++x) {\n#ifdef DEPTH_D24\nhighp float depth=unpack_depth(texture(u_depth,uv-df+vec2(float(x)*oneStep.x,float(y)*oneStep.y)).r);\n#else\nhighp float depth=unpack_depth_rgba(texture(u_depth,uv-df+vec2(float(x)*oneStep.x,float(y)*oneStep.y)));\n#endif\nres+=1.0-clamp(300.0*(coord.z+u_occlusion_depth_offset-depth),0.0,1.0);}}res=clamp(2.0*res/float(NX*NY)-0.5,0.0,1.0);return res;}highp float occlusionFade(vec4 frag) {highp vec3 coord=frag.xyz/frag.w;\n#ifdef CLIP_ZERO_TO_ONE\ncoord.z=-1.0+2.0*coord.z; \n#endif\nhighp vec4 depth=getCornerDepths(coord.xy);return dot(vec4(0.25),vec4(1.0)-clamp(300.0*(vec4(coord.z+u_occlusion_depth_offset)-depth),0.0,1.0));}\n#else\nbool isOccluded(vec4 frag) { return false; }highp float occlusionFade(vec4 frag) { return 1.0; }highp float occlusionFadeMultiSample(vec4 frag) { return 1.0; }\n#endif", Bo = "#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump mat4 u_fog_matrix;out vec3 v_fog_pos;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}vec3 fog_position(vec3 pos) {return (u_fog_matrix*vec4(pos,1.0)).xyz;}vec3 fog_position(vec2 pos) {return fog_position(vec3(pos,0.0));}float fog(vec3 pos) {float depth=length(pos);float opacity=fog_opacity(fog_range(depth));return opacity*fog_horizon_blending(pos/depth);}\n#endif", ko = "#ifdef FOG\nuniform mediump vec4 u_fog_color;uniform mediump vec2 u_fog_range;uniform mediump float u_fog_horizon_blend;uniform mediump vec2 u_fog_vertical_limit;uniform mediump float u_fog_temporal_offset;in vec3 v_fog_pos;uniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform highp vec2 u_viewport;uniform float u_globe_transition;uniform int u_is_globe;float fog_range(float depth) {return (depth-u_fog_range[0])/(u_fog_range[1]-u_fog_range[0]);}float fog_horizon_blending(vec3 camera_dir) {float t=max(0.0,camera_dir.z/u_fog_horizon_blend);return u_fog_color.a*exp(-3.0*t*t);}float fog_opacity(float t) {const float decay=6.0;float falloff=1.0-min(1.0,exp(-decay*t));falloff*=falloff*falloff;return u_fog_color.a*min(1.0,1.00747*falloff);}float globe_glow_progress() {highp vec2 uv=gl_FragCoord.xy/u_viewport;\n#ifdef FLIP_Y\nuv.y=1.0-uv.y;\n#endif\nhighp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);highp vec3 dir=normalize(ray_dir);highp vec3 closest_point=dot(u_globe_pos,dir)*dir;highp float sdf=length(closest_point-u_globe_pos)/u_globe_radius;return sdf+PI*0.5;}float fog_opacity(vec3 pos) {float depth=length(pos);return fog_opacity(fog_range(depth));}vec3 fog_apply(vec3 color,vec3 pos,float opacity_limit) {float depth=length(pos);float opacity;if (u_is_globe==1) {float glow_progress=globe_glow_progress();float t=mix(glow_progress,depth,u_globe_transition);opacity=fog_opacity(fog_range(t));} else {opacity=fog_opacity(fog_range(depth));opacity*=fog_horizon_blending(pos/depth);}return mix(color,u_fog_color.rgb,min(opacity,opacity_limit));}vec3 fog_apply(vec3 color,vec3 pos) {return fog_apply(color,pos,1.0);}vec4 fog_apply_from_vert(vec4 color,float fog_opac) {float alpha=EPSILON+color.a;color.rgb=mix(color.rgb/alpha,u_fog_color.rgb,fog_opac)*alpha;return color;}vec3 fog_apply_sky_gradient(vec3 camera_ray,vec3 sky_color) {float horizon_blend=fog_horizon_blending(normalize(camera_ray));return mix(sky_color,u_fog_color.rgb,horizon_blend);}vec4 fog_apply_premultiplied(vec4 color,vec3 pos) {float alpha=EPSILON+color.a;color.rgb=fog_apply(color.rgb/alpha,pos)*alpha;return color;}vec4 fog_apply_premultiplied(vec4 color,vec3 pos,float heightMeters) {float verticalProgress=(u_fog_vertical_limit.x > 0.0 || u_fog_vertical_limit.y > 0.0) ? smoothstep(u_fog_vertical_limit.x,u_fog_vertical_limit.y,heightMeters) : 0.0;float opacityLimit=1.0-smoothstep(0.9,1.0,fog_opacity(pos));return mix(fog_apply_premultiplied(color,pos),color,min(verticalProgress,opacityLimit));}vec3 fog_dither(vec3 color) {return color;}vec4 fog_dither(vec4 color) {return vec4(fog_dither(color.rgb),color.a);}\n#endif", No = "#ifdef RASTER_ARRAY\nuniform highp sampler2D u_image0;uniform sampler2D u_image1;const vec4 NODATA=vec4(1);ivec4 _raTexLinearCoord(highp vec2 texCoord,highp vec2 texResolution,out highp vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return ivec4(texCoord.xxyy+vec2(1.5,0.5).xyxy);}vec2 _raTexLinearMix(highp vec2 fxy,highp vec4 colorMix,highp float colorOffset,highp vec4 t00,highp vec4 t10,highp vec4 t01,highp vec4 t11) {vec2 c00=t00==NODATA ? vec2(0) : vec2(colorOffset+dot(t00,colorMix),1);vec2 c10=t10==NODATA ? vec2(0) : vec2(colorOffset+dot(t10,colorMix),1);vec2 c01=t01==NODATA ? vec2(0) : vec2(colorOffset+dot(t01,colorMix),1);vec2 c11=t11==NODATA ? vec2(0) : vec2(colorOffset+dot(t11,colorMix),1);return mix(mix(c01,c11,fxy.x),mix(c00,c10,fxy.x),fxy.y);}vec2 raTexture2D_image0_linear(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec2 fxy;ivec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texelFetch(u_image0,c.yz,0),texelFetch(u_image0,c.xz,0),texelFetch(u_image0,c.yw,0),texelFetch(u_image0,c.xw,0)\n);}vec2 raTexture2D_image1_linear(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec2 fxy;ivec4 c=_raTexLinearCoord(texCoord,texResolution,fxy);return _raTexLinearMix(fxy,colorMix,colorOffset,texelFetch(u_image1,c.yz,0),texelFetch(u_image1,c.xz,0),texelFetch(u_image1,c.yw,0),texelFetch(u_image1,c.xw,0)\n);}vec2 raTexture2D_image0_nearest(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec4 t=texelFetch(u_image0,ivec2(texCoord*texResolution),0);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}vec2 raTexture2D_image1_nearest(highp vec2 texCoord,highp vec2 texResolution,highp vec4 colorMix,highp float colorOffset) {vec4 t=texelFetch(u_image1,ivec2(texCoord*texResolution),0);return t==NODATA ? vec2(0) : vec2(colorOffset+dot(t,colorMix),1);}\n#endif", Uo = "#ifdef RASTER_ARRAY\nuniform sampler2D u_velocity;uniform mediump vec2 u_velocity_res;uniform mediump float u_max_speed;const vec4 NO_DATA=vec4(1);const vec2 INVALID_VELOCITY=vec2(-1);uniform highp vec2 u_uv_offset;uniform highp float u_data_offset;uniform highp vec2 u_data_scale;ivec4 rasterArrayLinearCoord(highp vec2 texCoord,highp vec2 texResolution,out highp vec2 fxy) {texCoord=texCoord*texResolution-0.5;fxy=fract(texCoord);texCoord-=fxy;return ivec4(texCoord.xxyy+vec2(1.5,0.5).xyxy);}highp vec2 lookup_velocity(highp vec2 uv) {uv=u_uv_offset.x+u_uv_offset.y*uv;highp vec2 fxy;ivec4 c=rasterArrayLinearCoord(uv,u_velocity_res,fxy);highp vec4 tl=texelFetch(u_velocity,c.yz,0);highp vec4 tr=texelFetch(u_velocity,c.xz,0);highp vec4 bl=texelFetch(u_velocity,c.yw,0);highp vec4 br=texelFetch(u_velocity,c.xw,0);if (tl==NO_DATA) {return INVALID_VELOCITY;}if (tr==NO_DATA) {return INVALID_VELOCITY;}if (bl==NO_DATA) {return INVALID_VELOCITY;}if (br==NO_DATA) {return INVALID_VELOCITY;}highp vec4 t=mix(mix(bl,br,fxy.x),mix(tl,tr,fxy.x),fxy.y);highp vec2 velocity=u_data_offset+vec2(dot(t.rg,u_data_scale),dot(t.ba,u_data_scale));velocity.y=-velocity.y;velocity/=max(u_max_speed,length(velocity));return velocity;}\n#endif\nuniform highp float u_particle_pos_scale;uniform highp vec2 u_particle_pos_offset;highp vec4 pack_pos_to_rgba(highp vec2 p) {highp vec2 v=(p+u_particle_pos_offset)/u_particle_pos_scale;highp vec4 r=vec4(v.x,fract(v.x*255.0),v.y,fract(v.y*255.0));return vec4(r.x-r.y/255.0,r.y,r.z-r.w/255.0,r.w);}highp vec2 unpack_pos_from_rgba(highp vec4 v) {v=floor(v*255.0+0.5)/255.0;highp vec2 p=vec2(v.x+(v.y/255.0),v.z+(v.w/255.0));return u_particle_pos_scale*p-u_particle_pos_offset;}", Vo = "#ifdef RENDER_SHADOWS\nuniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_normal_offset;vec3 shadow_normal_offset(vec3 normal) {float tileInMeters=u_shadow_normal_offset[0];vec3 n=vec3(-normal.xy,tileInMeters*normal.z);float dotScale=min(1.0-dot(normal,u_shadow_direction),1.0)*0.5+0.5;return n*dotScale;}vec3 shadow_normal_offset_model(vec3 normal) {vec3 transformed_normal=vec3(-normal.xy,normal.z);float NDotL=dot(normalize(transformed_normal),u_shadow_direction);float dotScale=min(1.0-NDotL,1.0)*0.5+0.5;return normal*dotScale;}float shadow_normal_offset_multiplier0() {return u_shadow_normal_offset[1];}float shadow_normal_offset_multiplier1() {return u_shadow_normal_offset[2];}\n#endif", jo = "#ifdef RENDER_SHADOWS\nprecision highp sampler2DShadow;uniform sampler2DShadow u_shadowmap_0;uniform sampler2DShadow u_shadowmap_1;uniform float u_shadow_intensity;uniform float u_shadow_map_resolution;uniform float u_shadow_texel_size;uniform highp vec3 u_shadow_normal_offset;uniform vec2 u_fade_range;uniform mediump vec3 u_shadow_direction;uniform highp vec3 u_shadow_bias;float shadow_sample(sampler2DShadow shadowmap,highp vec3 pos,highp float bias) {\n#ifdef CLIP_ZERO_TO_ONE\nhighp vec3 coord=vec3(pos.xy*0.5+0.5,pos.z-bias);\n#else\nhighp vec3 coord=vec3(pos.xy*0.5+0.5,pos.z*0.5+0.5-bias);\n#endif\nreturn texture(shadowmap,coord);}float shadow_occlusion(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,highp float bias) {light_view_pos0.xyz/=light_view_pos0.w;\n#ifdef SHADOWS_SINGLE_CASCADE\nvec2 abs_bounds=abs(light_view_pos0.xy);if (abs_bounds.x >=1.0 || abs_bounds.y >=1.0) {return 0.0;}return shadow_sample(u_shadowmap_0,light_view_pos0.xyz,bias);\n#else\nlight_view_pos1.xyz/=light_view_pos1.w;vec4 abs_bounds=abs(vec4(light_view_pos0.xy,light_view_pos1.xy));if (abs_bounds.x < 1.0 && abs_bounds.y < 1.0) {return shadow_sample(u_shadowmap_0,light_view_pos0.xyz,bias);}if (abs_bounds.z >=1.0 || abs_bounds.w >=1.0) {return 0.0;}float occlusion1=shadow_sample(u_shadowmap_1,light_view_pos1.xyz,bias);return clamp(mix(occlusion1,0.0,smoothstep(u_fade_range.x,u_fade_range.y,view_depth)),0.0,1.0);\n#endif\n}highp float calculate_shadow_bias(float NDotL) {\n#ifdef NORMAL_OFFSET\nreturn 0.5*u_shadow_bias.x;\n#else\nreturn 0.5*(u_shadow_bias.x+clamp(u_shadow_bias.y*tan(acos(NDotL)),0.0,u_shadow_bias.z));\n#endif\n}float shadowed_light_factor_normal(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_opacity(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth,float shadow_opacity) {float NDotL=dot(N,u_shadow_direction);float bias=calculate_shadow_bias(NDotL);float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias)*shadow_opacity;return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}float shadowed_light_factor_normal_unbiased(vec3 N,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float NDotL=dot(N,u_shadow_direction);float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return mix(0.0,(1.0-(u_shadow_intensity*occlusion))*NDotL,step(0.0,NDotL));}highp vec2 compute_receiver_plane_depth_bias(highp vec3 pos_dx,highp vec3 pos_dy)\n{highp vec2 biasUV=vec2(\npos_dy.y*pos_dx.z-pos_dx.y*pos_dy.z,pos_dx.x*pos_dy.z-pos_dy.x*pos_dx.z);biasUV*=1.0/((pos_dx.x*pos_dy.y)-(pos_dx.y*pos_dy.x));return biasUV;}float shadowed_light_factor_plane_bias(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {highp vec3 light_view_pos0_xyz=light_view_pos0.xyz/light_view_pos0.w*0.5+0.5;highp vec3 light_view_pos0_ddx=dFdx(light_view_pos0_xyz);highp vec3 light_view_pos0_ddy=dFdy(light_view_pos0_xyz);highp vec2 plane_depth_bias=compute_receiver_plane_depth_bias(light_view_pos0_ddx,light_view_pos0_ddy);highp float bias=dot(vec2(u_shadow_texel_size,u_shadow_texel_size),plane_depth_bias)+0.0001;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return 1.0-(u_shadow_intensity*occlusion);}float shadowed_light_factor(highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=0.0;float occlusion=shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);return 1.0-(u_shadow_intensity*occlusion);}float shadow_occlusion(float ndotl,highp vec4 light_view_pos0,highp vec4 light_view_pos1,float view_depth) {float bias=calculate_shadow_bias(ndotl);return shadow_occlusion(light_view_pos0,light_view_pos1,view_depth,bias);}\n#endif";
        const Go = /#include\s+"([^"]+)"/g, qo = /#pragma mapbox: ([\w\-]+) ([\w]+) ([\w]+) ([\w]+)/g, Zo = /\b[A-Za-z_][A-Za-z0-9_]*\b/g, Ho = new Set([
            "ifdef",
            "ifndef",
            "elif",
            "if",
            "defined"
        ]), Wo = new Set;
        tr(Po, Wo), tr(Mo, Wo), tr(Oo, Wo);
        const $o = {
            "_prelude_fog.vertex.glsl": Bo,
            "_prelude_terrain.vertex.glsl": Fo,
            "_prelude_shadow.vertex.glsl": Vo,
            "_prelude_material_table.vertex.glsl": "#ifdef HAS_SHADER_STORAGE_BLOCK_material_buffer\n#define MATERIAL_TABLE_DEBUG 0\nuniform int u_material_offset;uniform int u_vertex_offset;layout(std140,binding=0)readonly buffer material_buffer{uvec4 material_data[];};struct MaterialInfo{uint dataOffset;\n#if MATERIAL_TABLE_DEBUG\nvec4 colorDebug;\n#endif\n};uint read_buf_no_offset(uint iDword) {return material_data[iDword/4u][iDword % 4u];}uint read_buf(uint iDword) {iDword+=uint(u_material_offset/4);return read_buf_no_offset(iDword);}float read_buf_float(uint iDword){return uintBitsToFloat(read_buf(iDword));}uint read_buf_uint8(uint iDword,uint iUint8){uint dwordOffset=iDword+(iUint8/4u);uint byteOffset=iUint8 & 3u;uint bitOffset=8u*byteOffset;uint mask=0xffu << bitOffset;uint dwordVal=read_buf(dwordOffset);return (dwordVal & mask) >> bitOffset;}uint read_buf_uint16(uint iDword,uint iUint16){uint dwordOffset=iDword+(iUint16 >> 1u);uint bitOffset=(iUint16 & 1u)*16u;uint mask=0xffffu << bitOffset;uint dwordVal=read_buf(dwordOffset);return (dwordVal & mask) >> bitOffset;}uint nrDwordsForVertexIdEntries(uint nrMaterialLookupEntries) {return nrMaterialLookupEntries;}uint nrDwordsForMaterialIdEntries(uint nrMaterialLookupEntries) {return (nrMaterialLookupEntries*2u+3u)/4u;}uint findRangeBinarySearch(uint vertexId,uint numRanges,uint dwordOffset) {uint left=0u;uint right=numRanges-1u;for (uint i=0u; i < 16u; i++) { \nif (left > right) {break;}uint mid=(left+right)/2u;uint start=read_buf(dwordOffset+mid);uint nextStart=(mid+1u < numRanges) ? read_buf(dwordOffset+mid+1u) : 0xffffffffu;if (vertexId >=start && vertexId < nextStart) {return mid;} else if (vertexId < start) {if (mid==0u) {break;}right=mid-1u;} else {left=mid+1u;}}return 0u; \n}uint readVertexId(uint dwordOffset,uint iMaterialLookupEntry) {return read_buf(dwordOffset+iMaterialLookupEntry);}uint findRange(uint vertexId,uint numRanges,uint dwordOffset) {uint iRange;if(numRanges <=64u){uint vertexBegin;for(iRange=0u; iRange < numRanges;++iRange) {vertexBegin=readVertexId(dwordOffset,iRange);if(vertexBegin > vertexId) {break;}}iRange=iRange==0u? 0u : iRange-1u;} else { \niRange=findRangeBinarySearch(vertexId,numRanges,dwordOffset);}return iRange;}MaterialInfo read_material_info(uint vertex_id) {MaterialInfo info;\n#if MATERIAL_TABLE_DEBUG\nconst vec4 red=vec4(1.0,0.0,0.0,1.0);const vec4 orange=vec4(1.0,0.5,0.0,1.0);const vec4 yellow=vec4(1.0,1.0,0.0,1.0);const vec4 green=vec4(0.0,1.0,0.0,1.0);const vec4 indigo=vec4(0.294,0.0,0.510,1.0);const vec4 blue=vec4(0.0,0.0,1.0,1.0);const vec4 purple=vec4(0.5,0.0,0.5,1.0);const vec4 pink=vec4(1.0,0.0,1.0,1.0);info.colorDebug=green;\n#endif\nuint offset=0u;\n#if MATERIAL_TABLE_DEBUG\nbool keepFinding=true;uint magic=read_buf(offset);if(magic !=0xCAFEBABEu) {info.colorDebug=red;keepFinding=false;return info;}\n#endif\noffset++;\n#if MATERIAL_TABLE_DEBUG\nuint nrMaterials=read_buf(offset);uint nrVertices=read_buf(offset+1u);if(keepFinding && vertex_id >=nrVertices) {info.colorDebug=red;keepFinding=false;}\n#endif\noffset+=2u;uint nrMaterialLookupEntries=read_buf(offset++);uint perMaterialEntrySizeDwords=read_buf(offset++);\n#if MATERIAL_TABLE_DEBUG\nif(keepFinding && perMaterialEntrySizeDwords !=1u) {info.colorDebug=red;keepFinding=false;}\n#endif\nuint iMaterialLookup=findRange(vertex_id,nrMaterialLookupEntries,offset);\n#if MATERIAL_TABLE_DEBUG\nif(keepFinding)\n{uint vertexBeginCheck=readVertexId(offset,iMaterialLookup);if(vertexBeginCheck > vertex_id) {info.colorDebug=red;keepFinding=false;}if(iMaterialLookup < nrMaterialLookupEntries-1u) {uint vertexEndCheck=readVertexId(offset,iMaterialLookup+1u);if(vertexEndCheck <=vertex_id) {info.colorDebug=red;keepFinding=false;}}}\n#endif\noffset+=nrDwordsForVertexIdEntries(nrMaterialLookupEntries);uint materialId=iMaterialLookup;\n#if MATERIAL_TABLE_DEBUG\nif(keepFinding) {if(materialId >=nrMaterialLookupEntries) {info.colorDebug=red;}}\n#endif\ninfo.dataOffset=offset+materialId*perMaterialEntrySizeDwords;return info;}uint get_data_location(const MaterialInfo matInfo,uint attribOffsetBytes)\n{uint attribFieldOffsetDwords=attribOffsetBytes/4u;return matInfo.dataOffset+attribFieldOffsetDwords;}vec4 read_material_vec4(const MaterialInfo matInfo,uint attribOffsetBytes){uint loc=get_data_location(matInfo,attribOffsetBytes);return vec4(read_buf_float(loc),read_buf_float(loc+1u),read_buf_float(loc+2u),read_buf_float(loc+3u));}vec2 read_material_vec2(const MaterialInfo matInfo,uint attribOffsetBytes){uint loc=get_data_location(matInfo,attribOffsetBytes);return vec2(read_buf_float(loc),read_buf_float(loc+1u));}float read_material_float(const MaterialInfo matInfo,uint attribOffsetBytes){uint loc=get_data_location(matInfo,attribOffsetBytes);return read_buf_float(loc);}\n#define GET_ATTRIBUTE_float(attrib,matInfo,attrib_offset) read_material_float(matInfo,attrib_offset)\n#define GET_ATTRIBUTE_vec4(attrib,matInfo,attrib_offset) read_material_vec4(matInfo,attrib_offset)\n#define GET_ATTRIBUTE_vec2(attrib,matInfo,attrib_offset) read_material_vec2(matInfo,attrib_offset)\n#define DECLARE_MATERIAL_TABLE_INFO MaterialInfo materialInfo=read_material_info(uint(gl_VertexID));\n#define DECLARE_MATERIAL_TABLE_INFO_DEBUG(dbgColor) MaterialInfo materialInfo=read_material_info(uint(gl_VertexID)); dbgColor=materialInfo.colorDebug;\n#endif",
            "_prelude_fog.fragment.glsl": ko,
            "_prelude_shadow.fragment.glsl": jo,
            "_prelude_lighting.glsl": "\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec3 u_lighting_ambient_color;uniform mediump vec3 u_lighting_directional_dir;uniform mediump vec3 u_lighting_directional_color;uniform mediump vec3 u_ground_radiance;float calculate_ambient_directional_factor(vec3 normal) {float NdotL=dot(normal,u_lighting_directional_dir);const float factor_reduction_max=0.3;float dir_luminance=dot(u_lighting_directional_color,vec3(0.2126,0.7152,0.0722));float directional_factor_min=1.0-factor_reduction_max*min(dir_luminance,1.0);float ambient_directional_factor=mix(directional_factor_min,1.0,min((NdotL+1.0),1.0));const float vertical_factor_min=0.92;float vertical_factor=mix(vertical_factor_min,1.0,normal.z*0.5+0.5);return vertical_factor*ambient_directional_factor;}vec3 linearProduct(vec3 srgbIn,vec3 k) {return srgbIn*pow(k,vec3(1./2.2));}vec3 apply_lighting(vec3 color,vec3 normal,float dir_factor) {float ambient_directional_factor=calculate_ambient_directional_factor(normal);vec3 ambient_contrib=ambient_directional_factor*u_lighting_ambient_color;vec3 directional_contrib=u_lighting_directional_color*dir_factor;return linearProduct(color,ambient_contrib+directional_contrib);}vec4 apply_lighting(vec4 color,vec3 normal,float dir_factor) {return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting(vec3 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return apply_lighting(color.rgb,normal,dir_factor);}vec4 apply_lighting(vec4 color,vec3 normal) {float dir_factor=max(dot(normal,u_lighting_directional_dir),0.0);return vec4(apply_lighting(color.rgb,normal,dir_factor),color.a);}vec3 apply_lighting_ground(vec3 color) {return color*u_ground_radiance;}vec4 apply_lighting_ground(vec4 color) {return vec4(apply_lighting_ground(color.rgb),color.a);}float calculate_NdotL(vec3 normal) {const float ext=0.70710678118;return (clamp(dot(normal,u_lighting_directional_dir),-ext,1.0)+ext)/(1.0+ext);}vec4 apply_lighting_with_emission_ground(vec4 color,float emissive_strength) {return mix(apply_lighting_ground(color),color,emissive_strength);}vec3 compute_flood_lighting(vec3 flood_light_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=flood_light_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);float occlusion_ramp=smoothstep(0.0,0.2,1.0-occlusion);return mix(fully_occluded_color,flood_light_color,occlusion_ramp);}vec3 compute_emissive_draped(vec3 unlit_color,float fully_occluded_factor,float occlusion,vec3 ground_shadow_factor) {vec3 fully_occluded_color=unlit_color*mix(ground_shadow_factor,vec3(1.0),fully_occluded_factor);return mix(fully_occluded_color,unlit_color,1.0-occlusion);}\n#endif",
            "_prelude_raster_array.glsl": No,
            "_prelude_raster_particle.glsl": Uo
        }, Xo = {};
        or("", Fo), or(ko, Bo), or(jo, Vo), or(No, ""), or(Uo, "");
        const Yo = or(Oo, Mo), Ko = Po, Qo = [
            "\n#if defined(GL_EXT_blend_func_extended) && defined(DUAL_SOURCE_BLENDING)\n#extension GL_EXT_blend_func_extended : require\n#endif",
            "precision mediump float;",
            Ko,
            Yo.fragmentSource
        ].join("\n"), Jo = [
            "precision highp float;",
            Ko,
            Yo.vertexSource
        ].join("\n");
        var er = {
            background: or('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec4 u_color;uniform float u_opacity;uniform mediump float u_emissive_strength;\n#ifdef LIGHTING_3D_MODE\nin vec4 v_color;\n#endif\nvoid main() {vec4 out_color;\n#ifdef FEATURE_CUTOUT\nvec2 uv=gl_FragCoord.xy*u_inv_viewport_size.xy;\n#ifdef FLIP_Y\nuv.y=1.0-uv.y;\n#endif\nfloat factorTex=min(texture(u_cutout_factor_image,uv).r,1.0);float cutoutFactor=(1.0-u_feature_cutout_params.x)*factorTex;out_color=u_color*(1.0-cutoutFactor);\n#else\n#ifdef LIGHTING_3D_MODE\nout_color=v_color;\n#else\nout_color=u_color;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\n#endif\nglFragColor=out_color*u_opacity;\n#ifdef USE_MRT1\nout_Target1=vec4(u_emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_lighting.glsl"\nin ivec2 a_pos;uniform mat4 u_matrix;uniform mediump float u_emissive_strength;\n#ifdef LIGHTING_3D_MODE\nuniform mediump vec4 u_color;out vec4 v_color;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0,1);\n#ifndef FEATURE_CUTOUT\n#ifdef LIGHTING_3D_MODE\nv_color=apply_lighting_with_emission_ground(u_color,u_emissive_strength);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(vec2(a_pos));\n#endif\n#endif\n}'),
            backgroundPattern: or('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_pattern_tl;uniform vec2 u_pattern_br;uniform vec2 u_texsize;uniform float u_opacity;uniform float u_emissive_strength;uniform sampler2D u_image;in highp vec2 v_pos;void main() {highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(u_pattern_tl/u_texsize,u_pattern_br/u_texsize,imagecoord);vec4 out_color=textureLodCustom(u_image,pos,v_pos);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*u_opacity;\n#ifdef USE_MRT1\nout_Target1=vec4(u_emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pattern_size;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec2 u_pattern_units_to_pixels;in ivec2 a_pos;out highp vec2 v_pos;void main() {vec2 pos=vec2(a_pos);gl_Position=u_matrix*vec4(pos,0,1);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_pattern_size,u_pattern_units_to_pixels,pos);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            building: or('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nconst float window_depth=0.5;const float ao_radius=0.2;in vec4 v_color;in highp vec3 v_normal;in highp vec3 v_pos;\n#ifdef RENDER_FRONT_CUTOFF\nin float v_front_cutoff_opacity;\n#endif\n#ifdef INDICATOR_CUTOUT\n#ifdef FEATURE_CUTOUT\nin vec4 v_ground_roof;\n#endif\n#endif\n#ifdef BUILDING_FAUX_FACADE\nin lowp float v_faux_facade;in highp float v_faux_facade_ed;in highp vec2 v_faux_facade_window;in highp vec2 v_faux_facade_floor;in highp vec2 v_faux_facade_range;in highp float v_aspect;in highp vec3 v_tbn_0;in highp vec3 v_tbn_1;in highp vec3 v_tbn_2;in highp vec4 v_faux_color_emissive;uniform float u_faux_facade_ao_intensity;\n#endif\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;\n#endif\n#ifdef FLOOD_LIGHT\nin highp float v_flood_radius;in float v_has_flood_light;\n#endif\nuniform lowp float u_opacity;uniform vec3 u_camera_pos;uniform highp float u_tile_to_meter;uniform float u_facade_emissive_chance;uniform vec3 u_flood_light_color;uniform float u_flood_light_intensity;vec3 linearTosRGB(in vec3 color) {return pow(color,vec3(1./2.2));}\n#ifdef BUILDING_FAUX_FACADE\nhighp float hash12(in highp vec2 p) {highp vec3 p3 =fract(vec3(p.xyx)*0.1031);p3+=dot(p3,p3.yzx+33.33);return fract((p3.x+p3.y)*p3.z);}float min3(in vec3 v) {return min(min(v.x,v.y),v.z);}highp vec2 get_uv_mask_id(in highp vec2 q,out highp float mask,out highp vec2 id) {highp vec2 p=q;mask=step(v_faux_facade_range.x,p.y)*step(p.y,v_faux_facade_range.y);p.y=p.y-v_faux_facade_range.x;highp vec2 uv=modf(p/v_faux_facade_floor,id);highp vec4 d=(v_faux_facade_floor.xyxy+vec4(-v_faux_facade_window,v_faux_facade_window))*0.5;highp vec4 edge=d/v_faux_facade_floor.xyxy;highp vec2 m=step(edge.xy,uv)*step(uv,edge.zw);mask*=m.x*m.y;uv-=vec2(0.5);uv*=vec2(0.5)/(vec2(0.5)-edge.xy);uv+=vec2(0.5);return uv;}highp float ray_unit_box(in highp vec3 ray_o,in highp vec3 ray_d,in highp vec3 bmin,in highp vec3 bmax) {highp vec3 planes=mix(bmin,bmax,step(0.0,ray_d));highp vec3 t=(planes-ray_o)/ray_d;return min3(t);}float get_emissive(in vec2 id) {if (u_facade_emissive_chance > 0.0) {return (step(hash12(id),u_facade_emissive_chance)+0.05)*v_faux_color_emissive.a;}return 0.0;}vec3 get_shade_info(in highp vec3 v,in highp vec3 v_normalized,in vec3 color,in vec2 id,in mat3 tbn,inout vec3 out_normal,inout float out_emissive) {vec3 out_color=color;highp vec3 abs_v=abs(v_normalized);bool x_major=abs_v.x >=abs_v.y && abs_v.x >=abs_v.z;bool y_major=abs_v.y >=abs_v.x && abs_v.y >=abs_v.z;bool z_major=abs_v.z >=abs_v.x && abs_v.z >=abs_v.y;\n#if 0\nif (x_major) {out_color=v.x > 0.0 ? vec3(1.0,0.0,0.0) : vec3(0.0,1.0,1.0);} else if (y_major) {out_color=v.y > 0.0 ? vec3(0.0,1.0,0.0) : vec3(1.0,0.0,1.0);} else if (z_major) {out_color=v.z > 0.0 ? vec3(0.0,0.0,1.0) : vec3(1.0,1.0,0.0);}out_emissive=1.0;\n#else\nif (x_major) {out_normal=-sign(v.x)*tbn[0];} else if (y_major) {out_normal=vec3(0.0,0.0,-sign(v.y));} else if (z_major) {out_color=v_faux_color_emissive.rgb;out_emissive=v.z <=0.0 ? get_emissive(id) : out_emissive;}float ao=1.0;if (u_faux_facade_ao_intensity > 0.0) {vec4 ao_range=v_faux_facade_window.xxyy*0.5-vec4(0,ao_radius,0,ao_radius);vec2 ao_range_z=vec2(window_depth*0.5)-vec2(0.0,ao_radius);if (x_major || y_major) {ao*=smoothstep(-ao_range_z.x,-ao_range_z.y,v.z);} else if (z_major) {ao*=smoothstep(-ao_range.x,-ao_range.y,v.x)*(1.0-smoothstep(ao_range.y,ao_range.x,v.x));ao*=smoothstep(-ao_range.z,-ao_range.w,v.y)*(1.0-smoothstep(ao_range.w,ao_range.z,v.y));}ao=mix(1.0,min(1.0,ao+0.25),u_faux_facade_ao_intensity);}out_color*=ao;\n#endif\nreturn out_color;}\n#endif\nvec3 apply_lighting_linear(in vec3 color,in vec3 normal,in float dir_factor) {float ambient_directional_factor=calculate_ambient_directional_factor(normal);vec3 ambient_contrib=ambient_directional_factor*u_lighting_ambient_color;vec3 directional_contrib=u_lighting_directional_color*dir_factor;return color*(ambient_contrib+directional_contrib);}void main() {vec3 normal=normalize(v_normal);vec3 base_color=v_color.rgb;float emissive=v_color.a;\n#ifdef BUILDING_FAUX_FACADE\nif (v_faux_facade > 0.0) {highp mat3 tbn=mat3(v_tbn_0,v_tbn_1,v_tbn_2);highp vec3 v=vec3(v_pos.xy,v_pos.z/u_tile_to_meter)-u_camera_pos;highp vec3 view_tangent=transpose(tbn)*v;highp vec2 q=vec2(v_faux_facade_ed,v_pos.z);float mask=0.0;vec2 id=vec2(0.0);highp vec2 uv=get_uv_mask_id(q,mask,id);uv*=v_faux_facade_window;highp vec3 bmin=vec3(0.0,0.0,-window_depth);highp vec3 bmax=bmin+vec3(v_faux_facade_window,window_depth);highp vec3 ray_o=vec3(uv,0.0);highp vec3 ray_d=normalize(view_tangent);highp float t_min=ray_unit_box(ray_o,ray_d,bmin,bmax);highp vec3 hit=ray_o+t_min*ray_d;highp vec3 r=vec3(v_faux_facade_window,-window_depth);hit-=r*0.5;highp vec3 normalized=hit/r;vec3 out_normal=normal;float out_emissive=emissive;vec3 room_color=get_shade_info(hit,normalized,base_color,id,tbn,out_normal,out_emissive);base_color=mix(base_color,room_color,mask);normal=mix(normal,out_normal,mask);emissive=mix(emissive,out_emissive,mask);}\n#endif\nvec4 color=vec4(base_color,1.0);vec3 xy_flipped_normal=vec3(-normal.xy,normal.z);float shadowed_lighting_factor=0.0;\n#ifdef RENDER_SHADOWS\n#ifdef RENDER_CUTOFF\nshadowed_lighting_factor=shadowed_light_factor_normal_opacity(xy_flipped_normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,v_cutoff_opacity);if (v_cutoff_opacity==0.0) {discard;}\n#else\nshadowed_lighting_factor=shadowed_light_factor_normal(xy_flipped_normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);\n#endif\n#else\nshadowed_lighting_factor=max(0.0,dot(xy_flipped_normal,u_lighting_directional_dir));\n#endif\ncolor.rgb=apply_lighting_linear(color.rgb,xy_flipped_normal,shadowed_lighting_factor);color.rgb=linearTosRGB(color.rgb);\n#ifdef FLOOD_LIGHT\nfloat flood_radiance=(1.0-min(v_pos.z/v_flood_radius,1.0))*u_flood_light_intensity*v_has_flood_light;color.rgb=mix(color.rgb,u_flood_light_color,flood_radiance);\n#endif\ncolor.rgb=mix(color.rgb,linearTosRGB(base_color.rgb),emissive);\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos,v_pos.z));\n#endif\ncolor*=u_opacity;\n#ifdef INDICATOR_CUTOUT\n#ifdef FEATURE_CUTOUT\n{float ditherOpacity=cutoutGroundRoofOpacity(v_ground_roof);if (ditherOpacity < 1.0) {int index=(int(gl_FragCoord.x) % 4)*4+(int(gl_FragCoord.y) % 4);if (ditherOpacity < DITHER_THRESHOLDS[index]) {discard;}}}\n#else\ncolor=applyCutout(color,v_pos.z);\n#endif\n#endif\n#ifdef RENDER_FRONT_CUTOFF\nif (v_front_cutoff_opacity < 1.0) {int index=(int(gl_FragCoord.x) % 4)*4+(int(gl_FragCoord.y) % 4);if (v_front_cutoff_opacity < DITHER_THRESHOLDS[index]) {discard;}}\n#endif\n#ifdef FEATURE_CUTOUT\ncolor=apply_feature_cutout(color,gl_FragCoord,get_cutout_factors(gl_FragCoord).x);\n#endif\nglFragColor=color;\n#ifdef DEBUG_SHOW_NORMALS\ncolor.rgb=xy_flipped_normal*0.5+vec3(0.5,0.5,0.5);color.a=1.0;glFragColor=color;\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec3 a_pos_3f;in ivec4 a_normal_3;in ivec4 a_centroid_3;\n#ifdef FLOOD_LIGHT\nin int a_flood_light_wall_radius_1i16;\n#endif\n#ifdef BUILDING_FAUX_FACADE\nin uvec4 a_faux_facade_data;in uvec2 a_faux_facade_vertical_range;\n#endif\nuniform mat4 u_matrix;uniform mat4 u_normal_matrix;uniform highp float u_tile_to_meter;\n#ifdef RENDER_FRONT_CUTOFF\nuniform vec3 u_front_cutoff_params;out float v_front_cutoff_opacity;\n#endif\n#ifdef INDICATOR_CUTOUT\n#ifdef FEATURE_CUTOUT\nout vec4 v_ground_roof;\n#endif\n#endif\nout vec4 v_color;out vec3 v_normal;out highp vec3 v_pos;\n#ifdef BUILDING_FAUX_FACADE\nout lowp float v_faux_facade;out highp float v_faux_facade_ed;out highp vec2 v_faux_facade_window;out highp vec2 v_faux_facade_floor;out highp vec2 v_faux_facade_range;out highp float v_aspect;out highp vec3 v_tbn_0;out highp vec3 v_tbn_1;out highp vec3 v_tbn_2;out highp vec4 v_faux_color_emissive;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;\n#endif\n#ifdef FLOOD_LIGHT\nout highp float v_flood_radius;out float v_has_flood_light;\n#endif\nconst float MAX_UINT_16=65535.0;const float MAX_INT_16=32767.0;const float MAX_UINT_8=255.0;const float TWO_POW_8=256.0;const float FLOOD_LIGHT_MAX_RADIUS_METER=2048.0;vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}\n#ifdef BUILDING_FAUX_FACADE\nmat3 get_tbn(in vec3 normal) {const vec3 bitangent=vec3(0.0,0.0,1.0);vec3 tangent=normalize(vec3(normal.y,-normal.x,0.0));return mat3(tangent,bitangent,normal);}\n#endif\n#pragma mapbox: define-attribute-vertex-shader-only highp uvec2 part_color_emissive\n#pragma mapbox: define-attribute-vertex-shader-only highp uvec2 faux_facade_color_emissive\nvoid main() {\n#pragma mapbox: initialize-attribute-custom highp uvec2 part_color_emissive\n#pragma mapbox: initialize-attribute-custom highp uvec2 faux_facade_color_emissive\n#ifdef FLOOD_LIGHT\nv_flood_radius=(float(a_flood_light_wall_radius_1i16)/MAX_INT_16*FLOOD_LIGHT_MAX_RADIUS_METER);v_has_flood_light=step(0.0,v_flood_radius);\n#endif\nvec4 color_emissive=decode_color(vec2(part_color_emissive));v_color=vec4(sRGBToLinear(color_emissive.rgb),color_emissive.a);vec3 a_normal_3f=vec3(a_normal_3)/MAX_INT_16;v_normal=vec3(u_normal_matrix*vec4(a_normal_3f,0.0));float hidden=0.0;float depth_offset=0.0;vec2 centroid_xy=vec2(a_centroid_3.xy >> 2);vec2 spanBits=vec2(a_centroid_3.xy & 3);\n#ifdef BUILDING_FAUX_FACADE\nvec4 faux_facade_data=vec4(a_faux_facade_data);v_faux_facade=faux_facade_data.x;if (v_faux_facade > 0.0) {v_faux_facade_ed=faux_facade_data.x *u_tile_to_meter;float window_x_perc=floor(faux_facade_data.y/TWO_POW_8);float window_y_perc=faux_facade_data.y-TWO_POW_8*window_x_perc;vec2 window_perc=vec2(window_x_perc,window_y_perc)/MAX_UINT_8;v_faux_facade_floor=(faux_facade_data.zw/MAX_UINT_16*EXTENT)*u_tile_to_meter;v_faux_facade_window=window_perc*v_faux_facade_floor;v_faux_facade_range=(vec2(a_faux_facade_vertical_range)/MAX_UINT_16*EXTENT)*u_tile_to_meter;v_aspect=v_faux_facade_window.x/v_faux_facade_window.y;mat3 tbn=get_tbn(normalize(v_normal));v_tbn_0=tbn[0];v_tbn_1=tbn[1];v_tbn_2=tbn[2];v_faux_color_emissive=decode_color(vec2(faux_facade_color_emissive));v_faux_color_emissive.rgb=sRGBToLinear(v_faux_color_emissive.rgb);depth_offset=min(1000.0,float(a_centroid_3.z))*0.0000002;}\n#endif\nv_pos=a_pos_3f;\n#if defined(RENDER_CUTOFF) || defined(RENDER_FRONT_CUTOFF)\nfloat halfSpanX=spanBits.x*10.0/u_tile_to_meter;float halfSpanY=spanBits.y*10.0/u_tile_to_meter;vec2 screenUpInTile=vec2(u_matrix[0][1],u_matrix[1][1]);vec2 spanOffset=vec2(halfSpanX,halfSpanY)*sign(screenUpInTile);vec2 cutoff_highestCorner=centroid_xy+spanOffset;vec2 cutoff_lowestCorner=centroid_xy-spanOffset;\n#endif\n#if defined(RENDER_CUTOFF) || defined(RENDER_FRONT_CUTOFF)\nvec4 ground=u_matrix*vec4(centroid_xy,0.0,1.0);\n#endif\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,ground.z);hidden=float(v_cutoff_opacity==0.0);v_pos.z*=v_cutoff_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nvec3 shadow_pos=v_pos;\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset_model(v_normal);shadow_pos+=offset*shadow_normal_offset_multiplier0();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shadow_pos,1.0);v_pos_light_view_1=u_light_matrix_1*vec4(shadow_pos,1.0);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(v_pos);\n#endif\n#ifdef RENDER_FRONT_CUTOFF\nv_front_cutoff_opacity=1.0;{hidden=max(hidden,float(ground.w <=0.0));float ndc_y=ground.y/max(ground.w,0.001);float threshold=u_front_cutoff_params.x*2.0-1.0;float range_ndc=u_front_cutoff_params.y*2.0;hidden=max(hidden,float(ndc_y < threshold-range_ndc));float t=clamp((ndc_y-(threshold-range_ndc))/max(range_ndc,0.001),0.0,1.0);v_front_cutoff_opacity=mix(u_front_cutoff_params.z,1.0,t);}\n#endif\ngl_Position=mix(u_matrix*vec4(v_pos,1),AWAY,hidden);gl_Position.z-=depth_offset*gl_Position.w;\n#ifdef INDICATOR_CUTOUT\n#ifdef FEATURE_CUTOUT\nvec4 ic_ground=u_matrix*vec4(v_pos.xy,0.0,1.0);vec4 ic_roof=u_matrix*vec4(v_pos.xy,v_pos.z,1.0);v_ground_roof=vec4(ic_ground.xy/ic_ground.w,ic_roof.xy/ic_roof.w);\n#endif\n#endif\n}'),
            buildingBloom: or("in vec4 v_color_emissive;\n#pragma mapbox: define-attribute highp vec4 bloom_attenuation\n#pragma mapbox: initialize-attribute highp vec4 bloom_attenuation\nfloat saturate(float val) {return clamp(val,0.0,1.0);}void main() {float emission=v_color_emissive.a;float opacity=1.0;\n#ifdef HAS_ATTRIBUTE_a_bloom_attenuation\nfloat distance=length(vec2(1.3*max(0.0,abs(bloom_attenuation.x)-bloom_attenuation.z),bloom_attenuation.y));distance+= mix(0.5,0.0,clamp(emission-1.0,0.0,1.0));opacity*=saturate(1.0-distance*distance);\n#endif\n#ifdef RENDER_CUTOFF\nopacity*=v_cutoff_opacity;\n#endif\nglFragColor=vec4(v_color_emissive.rgb,1.0)*opacity;}", "in vec3 a_pos_3f;\n#pragma mapbox: define-attribute-vertex-shader-only highp uvec2 part_color_emissive\n#pragma mapbox: define-attribute highp vec4 bloom_attenuation\nout vec4 v_color_emissive;uniform mat4 u_matrix;vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}void main() {\n#pragma mapbox: initialize-attribute-custom highp uvec2 part_color_emissive\n#pragma mapbox: initialize-attribute highp vec4 bloom_attenuation\n#ifdef HAS_ATTRIBUTE_a_part_color_emissive\nvec4 color_emissive=decode_color(vec2(part_color_emissive));float part_emissive=color_emissive.a*5.0;v_color_emissive=vec4(sRGBToLinear(color_emissive.rgb),part_emissive);\n#else\nv_color_emissive=vec4(1.0);\n#endif\ngl_Position=u_matrix*vec4(a_pos_3f,1.0);\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n}"),
            buildingDepth: or("void main() {}", "in vec3 a_pos_3f;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos_3f,1.0);}"),
            circle: or('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec3 v_data;in float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nuniform float u_emissive_strength;void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float blur_positive=blur < 0.0 ? 0.0 : 1.0;lowp float antialiasblur=v_data.z;float extrude_length=length(extrude)+antialiasblur*(1.0-blur_positive);float antialiased_blur=-max(abs(blur),antialiasblur);float antialiase_blur_opacity=smoothstep(0.0,antialiasblur,extrude_length-1.0);float opacity_t=blur_positive==1.0 ? \nsmoothstep(0.0,-antialiased_blur,1.0-extrude_length) : \nsmoothstep(antialiased_blur,0.0,extrude_length-1.0)-antialiase_blur_opacity;float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(\nantialiased_blur,0.0,extrude_length-radius/(radius+stroke_width)\n);vec4 out_color=mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#endif\n#ifdef FOG\nout_color=fog_apply_premultiplied(out_color,v_fog_pos);\n#endif\nglFragColor=out_color*(v_visibility*opacity_t);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define NUM_VISIBILITY_RINGS 2\n#define INV_SQRT2 0.70710678\n#define ELEVATION_BIAS 0.0001\n#define NUM_SAMPLES_PER_RING 16\nuniform mat4 u_matrix;uniform mat2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;in ivec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin ivec4 a_pos_3;in ivec4 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\n#ifdef ELEVATED_ROADS\nin float a_circle_z_offset;\n#endif\nout vec3 v_data;out float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvec2 calc_offset(vec2 extrusion,float radius,float stroke_width, float view_scale) {return extrusion*(radius+stroke_width)*u_extrude_scale*view_scale;}float cantilevered_elevation(vec2 pos,float radius,float stroke_width,float view_scale) {vec2 c1=pos+calc_offset(vec2(-1.0,-1.0),radius,stroke_width,view_scale);vec2 c2=pos+calc_offset(vec2(1.0,-1.0),radius,stroke_width,view_scale);vec2 c3=pos+calc_offset(vec2(1.0,1.0),radius,stroke_width,view_scale);vec2 c4=pos+calc_offset(vec2(-1.0,1.0),radius,stroke_width,view_scale);float h1=elevation(c1)+ELEVATION_BIAS;float h2=elevation(c2)+ELEVATION_BIAS;float h3=elevation(c3)+ELEVATION_BIAS;float h4=elevation(c4)+ELEVATION_BIAS;return max(h4,max(h3,max(h1,h2)));}float circle_elevation(vec2 pos) {\n#if defined(TERRAIN)\nreturn elevation(pos)+ELEVATION_BIAS;\n#else\nreturn 0.0;\n#endif\n}vec4 project_vertex(vec2 extrusion,vec4 world_center,vec4 projected_center,float radius,float stroke_width, float view_scale,mat3 surface_vectors) {vec2 sample_offset=calc_offset(extrusion,radius,stroke_width,view_scale);\n#ifdef PITCH_WITH_MAP\n#ifdef PROJECTION_GLOBE_VIEW\nreturn u_matrix*( world_center+vec4(sample_offset.x*surface_vectors[0]+sample_offset.y*surface_vectors[1],0) );\n#else\nreturn u_matrix*( world_center+vec4(sample_offset,0,0) );\n#endif\n#else\nreturn projected_center+vec4(sample_offset,0,0);\n#endif\n}float get_sample_step() {\n#ifdef PITCH_WITH_MAP\nreturn 2.0*PI/float(NUM_SAMPLES_PER_RING);\n#else\nreturn PI/float(NUM_SAMPLES_PER_RING);\n#endif\n}void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 pos2=vec2(a_pos);vec2 extrude=vec2(mod(pos2,2.0)*2.0-1.0);vec2 circle_center=floor(pos2*0.5);float height=circle_elevation(circle_center);vec4 world_center;mat3 surface_vectors;\n#ifdef PROJECTION_GLOBE_VIEW\nsurface_vectors=globe_mercator_surface_vectors(vec3(a_pos_normal_3)/16384.0,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(circle_center)*height;vec3 globe_pos=vec3(a_pos_3)+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*height;vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,circle_center,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;vec3 pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);world_center=vec4(pos,1);\n#else \nsurface_vectors=mat3(1.0);world_center=vec4(circle_center,height,1);\n#endif\n#ifdef ELEVATED_ROADS\nworld_center.z+=a_circle_z_offset+ELEVATION_BIAS;\n#endif\nvec4 projected_center=u_matrix*world_center;float view_scale=0.0;\n#ifdef PITCH_WITH_MAP\n#ifdef SCALE_WITH_MAP\nview_scale=1.0;\n#else\nview_scale=projected_center.w/u_camera_to_center_distance;\n#endif\n#else\n#ifdef SCALE_WITH_MAP\nview_scale=u_camera_to_center_distance;\n#else\nview_scale=projected_center.w;\n#endif\n#endif\ngl_Position=project_vertex(extrude,world_center,projected_center,radius,stroke_width,view_scale,surface_vectors);float visibility=0.0;\n#ifdef TERRAIN\nfloat step=get_sample_step();vec4 occlusion_world_center;vec4 occlusion_projected_center;\n#ifdef PITCH_WITH_MAP\nfloat cantilevered_height=cantilevered_elevation(circle_center,radius,stroke_width,view_scale);occlusion_world_center=vec4(circle_center,cantilevered_height,1);occlusion_projected_center=u_matrix*occlusion_world_center;\n#else\nocclusion_world_center=world_center;occlusion_projected_center=projected_center;\n#endif\nfor(int ring=0; ring < NUM_VISIBILITY_RINGS; ring++) {float scale=(float(ring)+1.0)/float(NUM_VISIBILITY_RINGS);for(int i=0; i < NUM_SAMPLES_PER_RING; i++) {vec2 extrusion=vec2(cos(step*float(i)),-sin(step*float(i)))*scale;vec4 frag_pos=project_vertex(extrusion,occlusion_world_center,occlusion_projected_center,radius,stroke_width,view_scale,surface_vectors);visibility+=float(!isOccluded(frag_pos));}}visibility/=float(NUM_VISIBILITY_RINGS)*float(NUM_SAMPLES_PER_RING);\n#else\nvisibility=1.0;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nvisibility=1.0;\n#endif\nv_visibility=visibility;lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);\n#ifdef FOG\nv_fog_pos=fog_position(world_center.xyz);\n#endif\n}'),
            clippingMask: or("void main() {glFragColor=vec4(1.0);}", "in ivec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),
            heatmap: or('#include "_prelude_fog.fragment.glsl"\nuniform highp float u_intensity;in vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);glFragColor=vec4(val,1.0,1.0,1.0);\n#ifdef FOG\nif (u_is_globe==0) {glFragColor.r*=pow(1.0-fog_opacity(v_fog_pos),2.0);}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;in ivec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin ivec4 a_pos_3;in ivec4 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;\n#endif\nout vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(vec2(a_pos),2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 tilePos=floor(vec2(a_pos)*0.5);vec3 pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 pos_normal_3=vec3(a_pos_normal_3)/16384.0;mat3 surface_vectors=globe_mercator_surface_vectors(pos_normal_3,u_up_dir,u_zoom_transition);vec3 surface_extrusion=extrude.x*surface_vectors[0]+extrude.y*surface_vectors[1];vec3 globe_elevation=elevationVector(tilePos)*elevation(tilePos);vec3 globe_pos=vec3(a_pos_3)+surface_extrusion+globe_elevation;vec3 mercator_elevation=u_up_dir*u_tile_up_scale*elevation(tilePos);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,tilePos,u_tile_id,u_merc_center)+surface_extrusion+mercator_elevation;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#else\npos=vec3(tilePos+extrude,elevation(tilePos));\n#endif\ngl_Position=u_matrix*vec4(pos,1);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            heatmapTexture: or("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;in vec2 v_pos;void main() {float t=texture(u_image,v_pos).r;vec4 color=texture(u_color_ramp,vec2(t,0.5));glFragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(0.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}", "in ivec2 a_pos;out vec2 v_pos;void main() {gl_Position=vec4(a_pos,0,1);v_pos=vec2(a_pos)*0.5+0.5;}"),
            collisionBox: or("in float v_placed;in float v_notUsed;void main() {vec4 red =vec4(1.0,0.0,0.0,1.0);vec4 blue=vec4(0.0,0.0,1.0,0.5);glFragColor =mix(red,blue,step(0.5,v_placed))*0.5;glFragColor*=mix(1.0,0.1,step(0.5,v_notUsed));}", '#include "_prelude_terrain.vertex.glsl"\nin ivec4 a_pos;in ivec2 a_anchor_pos;in ivec2 a_extrude;in uvec2 a_placed;in vec2 a_shift;in vec2 a_elevation_from_sea;in float a_size_scale;in vec2 a_padding;in float a_auto_z_offset;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform float u_zoom_transition;\n#endif\nout float v_placed;out float v_notUsed;void main() {vec2 anchor_pos=vec2(a_anchor_pos);float feature_elevation=a_elevation_from_sea.x+a_auto_z_offset;float terrain_elevation=(a_elevation_from_sea.y==1.0 ? 0.0 : elevation(anchor_pos));vec3 proj_pos=vec3(a_pos)+elevationVector(anchor_pos)*(feature_elevation+terrain_elevation);\n#ifdef PROJECTION_GLOBE_VIEW\n#ifndef PROJECTED_POS_ON_VIEWPORT\nvec3 globe_pos=proj_pos;vec3 mercator_pos=mercator_tile_position(u_inv_rot_matrix,anchor_pos,u_tile_id,u_merc_center);proj_pos=mix_globe_mercator(globe_pos,mercator_pos,u_zoom_transition);\n#endif\n#endif\nvec4 projectedPoint=u_matrix*vec4(proj_pos,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,1.5);gl_Position=projectedPoint;gl_Position.xy+=(vec2(a_extrude)*a_size_scale+a_shift+a_padding)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=float(a_placed.x);v_notUsed=float(a_placed.y);}'),
            collisionCircle: or("in float v_radius;in vec2 v_extrude;in float v_perspective_ratio;in float v_collision;void main() {float alpha=0.5*min(v_perspective_ratio,1.0);float stroke_radius=0.9*max(v_perspective_ratio,1.0);float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);glFragColor=color*alpha*opacity_t;}", "in vec2 a_pos_2f;in float a_radius;in ivec2 a_flags;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform vec2 u_viewport_size;uniform float u_camera_to_center_distance;out float v_radius;out vec2 v_extrude;out float v_perspective_ratio;out float v_collision;vec3 toTilePosition(vec2 screenPos) {vec4 rayStart=u_inv_matrix*vec4(screenPos,-1.0,1.0);vec4 rayEnd  =u_inv_matrix*vec4(screenPos, 1.0,1.0);rayStart.xyz/=rayStart.w;rayEnd.xyz  /=rayEnd.w;highp float t=(0.0-rayStart.z)/(rayEnd.z-rayStart.z);return mix(rayStart.xyz,rayEnd.xyz,t);}void main() {vec2 quadCenterPos=a_pos_2f;float radius=a_radius;int vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(\nmix(-1.0,1.0,float(vertexIdx >=2)),mix(-1.0,1.0,float(vertexIdx >=1 && vertexIdx <=2)));vec2 quadVertexExtent=quadVertexOffset*radius;vec3 tilePos=toTilePosition(quadCenterPos);vec4 clipPos=u_matrix*vec4(tilePos,1.0);highp float camera_to_anchor_distance=clipPos.w;highp float collision_perspective_ratio=clamp(\n0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_perspective_ratio=collision_perspective_ratio;v_collision=float(a_flags.x);gl_Position=vec4(clipPos.xyz/clipPos.w,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
            debug: or("uniform highp vec4 u_color;uniform sampler2D u_overlay;in vec2 v_uv;void main() {vec4 overlay_color=texture(u_overlay,v_uv);glFragColor=mix(u_color,overlay_color,overlay_color.a);}", '#include "_prelude_terrain.vertex.glsl"\nin ivec2 a_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nin ivec4 a_pos_3;\n#endif\nout vec2 v_uv;uniform mat4 u_matrix;uniform float u_overlay_scale;void main() {vec2 pos=vec2(a_pos);float h=elevation(pos);v_uv=pos/8192.0;\n#ifdef PROJECTION_GLOBE_VIEW\ngl_Position=u_matrix*vec4(vec3(a_pos_3)+elevationVector(pos)*h,1);\n#else\ngl_Position=u_matrix*vec4(pos*u_overlay_scale,h,1);\n#endif\n}'),
            elevatedStructuresDepth: or("void main() {}", "in ivec2 a_pos;in float a_height;uniform mat4 u_matrix;uniform float u_depth_bias;void main() {gl_Position=u_matrix*vec4(a_pos,a_height,1);gl_Position.z=gl_Position.z+u_depth_bias;}"),
            elevatedStructuresDepthReconstruct: or("#ifdef DEPTH_RECONSTRUCTION\nin float v_height;\n#endif\nvoid main() {\n#ifdef DEPTH_RECONSTRUCTION\nif (v_height >=0.0)\ndiscard;\n#else\n#ifdef FEATURE_CUTOUT\napply_feature_cutout(vec4(0.0,0.0,0.0,1.0),gl_FragCoord,get_cutout_factors(gl_FragCoord).x);\n#endif\n#endif\nglFragColor=vec4(1.0,0.0,0.0,1.0);}", "in ivec2 a_pos;in float a_height;uniform mat4 u_matrix;uniform vec3 u_camera_pos;uniform highp float u_depth_bias;uniform lowp float u_height_scale;uniform lowp float u_reset_depth;\n#ifdef DEPTH_RECONSTRUCTION\nout float v_height;\n#endif\nvoid main() {vec3 vpos=vec3(a_pos,a_height*u_height_scale);\n#ifdef DEPTH_RECONSTRUCTION\nif (u_camera_pos.z > vpos.z) {vpos-=(u_camera_pos-vpos)*(vpos.z/(u_camera_pos.z-vpos.z));}v_height=a_height;\n#endif\ngl_Position=u_matrix*vec4(vpos,1);gl_Position.z=u_reset_depth==1.0 ? gl_Position.w : gl_Position.z+u_depth_bias;}"),
            elevatedStructures: or('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nin vec3 v_normal;in float v_height;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in float v_depth;\n#endif\nvec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}vec3 compute_view_dependent_emissive_color(float ndotl,float emissive_strength,vec3 color)\n{color=sRGBToLinear(color);color=color*(ndotl+(1.0-min(ndotl*57.29,1.0))*emissive_strength);color=linearTosRGB(color.rgb);return color;}uniform float u_emissive_strength;\n#pragma mapbox: define highp vec4 structure_color\nvoid main() {\n#pragma mapbox: initialize highp vec4 structure_color\nvec3 color=structure_color.xyz;vec2 cutout_factors=vec2(0.0);\n#ifdef FEATURE_CUTOUT\ncutout_factors=get_cutout_factors(gl_FragCoord);\n#endif\n#ifdef LIGHTING_3D_MODE\nvec3 normal=normalize(v_normal);vec3 transformed_normal=vec3(-normal.xy,normal.z);float ndotl=calculate_NdotL(transformed_normal);float emissive_strength=u_emissive_strength;emissive_strength=0.0;vec3 emissive_color=compute_view_dependent_emissive_color(ndotl,emissive_strength,color.xyz);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth);light=mix(light,1.0,cutout_factors.y);color.rgb=apply_lighting(color.rgb,transformed_normal,light);\n#else\ncolor=apply_lighting(color,transformed_normal);\n#endif\ncolor=mix(color,emissive_color,emissive_strength);if (v_height < 0.0) {float penetration=max(v_height+7.5,0.0);float occlusion=1.0-1.0/PI*acos(1.0-penetration/4.0);color=color*(1.0-pow(occlusion,2.0)*0.3);}\n#endif\n#ifdef FOG\ncolor=fog_apply(color,v_fog_pos);\n#endif\nvec4 out_color=vec4(color,1.0);\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color,v_height);\n#endif\n#ifdef FEATURE_CUTOUT\nout_color=apply_feature_cutout(out_color,gl_FragCoord,cutout_factors.x);\n#endif\nglFragColor=out_color;HANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin ivec2 a_pos;in float a_height;in ivec4 a_pos_normal_3;uniform mat4 u_matrix;out vec3 v_normal;out float v_height;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out float v_depth;\n#endif\n#pragma mapbox: define highp vec4 structure_color\nvoid main() {\n#pragma mapbox: initialize highp vec4 structure_color\nv_normal=vec3(a_pos_normal_3)/16384.0;v_height=a_height;vec3 pos=vec3(vec2(a_pos),a_height);gl_Position=u_matrix*vec4(pos,1);\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=pos;vec3 shd_pos1=pos;\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(-v_normal.xy,v_normal.z));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(vec2(a_pos));\n#endif\n}'),
            fill: or('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nuniform float u_emissive_strength;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#ifdef INDICATOR_CUTOUT\nin highp float v_z_offset;\n#endif\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\nvec2 cutout_factors=vec2(0.0);\n#ifdef FEATURE_CUTOUT\ncutout_factors=get_cutout_factors(gl_FragCoord);\n#endif\nvec4 out_color=color;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);light=mix(light,1.0,cutout_factors.y);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nout_color*=opacity;\n#ifdef INDICATOR_CUTOUT\nif (v_z_offset >=0.0) {out_color=applyCutout(out_color,v_z_offset);}\n#endif\n#ifdef FEATURE_CUTOUT\nout_color=apply_feature_cutout(out_color,gl_FragCoord,cutout_factors.x);\n#endif\nglFragColor=out_color;\n#ifdef USE_MRT1\nout_Target1=vec4(u_emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin ivec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;out highp float v_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#ifdef INDICATOR_CUTOUT\nout highp float v_z_offset;\n#endif\nuniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp float z_offset\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;v_road_z_offset=z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(vec2(a_pos));\n#endif\n#ifdef INDICATOR_CUTOUT\nv_z_offset=z_offset;\n#endif\n}'),
            fillOutline: or('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nin highp vec2 v_pos;uniform float u_emissive_strength;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=outline_color;vec2 cutout_factors=vec2(0.0);\n#ifdef FEATURE_CUTOUT\ncutout_factors=get_cutout_factors(gl_FragCoord);\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);light=mix(light,1.0,cutout_factors.y);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\n#ifdef FEATURE_CUTOUT\nout_color=apply_feature_cutout(out_color,gl_FragCoord,cutout_factors.x);\n#endif\nglFragColor=out_color*(alpha*opacity);\n#ifdef USE_MRT1\nout_Target1=vec4(u_emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin ivec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nuniform mat4 u_matrix;uniform vec2 u_world;out highp vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp float z_offset\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;\n#endif\nfloat hidden=float(opacity==0.0);gl_Position=mix(u_matrix*vec4(a_pos,z_offset,1),AWAY,hidden);\n#ifdef FLIP_Y\nv_pos=(vec2(gl_Position.x,-gl_Position.y)/gl_Position.w+1.0)/2.0*u_world;\n#else\nv_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#endif\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(a_pos,z_offset);vec3 shd_pos1=vec3(a_pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(vec2(a_pos));\n#endif\n}'),
            fillOutlinePattern: or('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FILL_PATTERN_TRANSITION\nuniform float u_pattern_transition;\n#endif\nuniform float u_emissive_strength;\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\nin highp vec2 v_pos;in highp vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp uvec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: define mediump uvec4 pattern_b\n#endif\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump uvec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump uvec4 pattern_b\n#endif\nvec2 pattern_tl=vec2(pattern.xy);vec2 pattern_br=vec2(pattern.zw);highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);float dist=length(v_pos_world-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef APPLY_LUT_ON_GPU\nout_color=applyLUT(u_lutTexture,out_color);\n#endif\n#ifdef FILL_PATTERN_TRANSITION\nvec2 pattern_b_tl=pattern_b.xy;vec2 pattern_b_br=pattern_b.zw;highp vec2 pos_b=mix(pattern_b_tl/u_texsize,pattern_b_br/u_texsize,imagecoord);vec4 color_b=textureLodCustom(u_image,pos_b,lod_pos);out_color=out_color*(1.0-u_pattern_transition)+color_b*u_pattern_transition;\n#endif\nvec2 cutout_factors=vec2(0.0);\n#ifdef FEATURE_CUTOUT\ncutout_factors=get_cutout_factors(gl_FragCoord);\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);light=mix(light,1.0,cutout_factors.y);out_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#ifdef FEATURE_CUTOUT\nout_color=apply_feature_cutout(out_color,gl_FragCoord,cutout_factors.x);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*(alpha*opacity);\n#ifdef USE_MRT1\nout_Target1=vec4(u_emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in ivec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nout highp vec2 v_pos;out highp vec2 v_pos_world;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp uvec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: define mediump uvec4 pattern_b\n#endif\n#pragma mapbox: define lowp float pixel_ratio\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump uvec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump uvec4 pattern_b\n#endif\n#pragma mapbox: initialize lowp float pixel_ratio\n#pragma mapbox: initialize highp float z_offset\nvec2 pattern_tl=vec2(pattern.xy);vec2 pattern_br=vec2(pattern.zw);\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;\n#endif\nfloat hidden=float(opacity==0.0);vec2 pos=vec2(a_pos);gl_Position=mix(u_matrix*vec4(pos,z_offset,1),AWAY,hidden);vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,pos);\n#ifdef FLIP_Y\nv_pos_world=(vec2(gl_Position.x,-gl_Position.y)/gl_Position.w+1.0)/2.0*u_world;\n#else\nv_pos_world=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#endif\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(pos,z_offset);vec3 shd_pos1=vec3(pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            fillPattern: or('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FILL_PATTERN_TRANSITION\nuniform float u_pattern_transition;\n#endif\nin highp vec2 v_pos;uniform float u_emissive_strength;\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp uvec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: define mediump uvec4 pattern_b\n#endif\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump uvec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump uvec4 pattern_b\n#endif\nvec2 pattern_tl=vec2(pattern.xy);vec2 pattern_br=vec2(pattern.zw);highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef APPLY_LUT_ON_GPU\nout_color=applyLUT(u_lutTexture,out_color);\n#endif\n#ifdef FILL_PATTERN_TRANSITION\nvec2 pattern_b_tl=vec2(pattern_b.xy);vec2 pattern_b_br=vec2(pattern_b.zw);highp vec2 pos_b=mix(pattern_b_tl/u_texsize,pattern_b_br/u_texsize,imagecoord);vec4 color_b=textureLodCustom(u_image,pos_b,lod_pos);out_color=out_color*(1.0-u_pattern_transition)+color_b*u_pattern_transition;\n#endif\nvec2 cutout_factors=vec2(0.0);\n#ifdef FEATURE_CUTOUT\ncutout_factors=get_cutout_factors(gl_FragCoord);\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,u_emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);light=mix(light,1.0,cutout_factors.y);\n#ifdef ELEVATED_ROADS\nout_color.rgb*=mix(v_road_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#else\nout_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef FEATURE_CUTOUT\nout_color=apply_feature_cutout(out_color,gl_FragCoord,cutout_factors.x);\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nglFragColor=out_color*opacity;\n#ifdef USE_MRT1\nout_Target1=vec4(u_emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_tile_units_to_pixels;in ivec2 a_pos;\n#ifdef ELEVATED_ROADS\nin float a_road_z_offset;out highp float v_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\nout highp vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp uvec4 pattern\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: define mediump uvec4 pattern_b\n#endif\n#pragma mapbox: define lowp float pixel_ratio\n#pragma mapbox: define highp float z_offset\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump uvec4 pattern\n#pragma mapbox: initialize lowp float pixel_ratio\n#pragma mapbox: initialize highp float z_offset\n#ifdef FILL_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump uvec4 pattern_b\n#endif\nvec2 pattern_tl=vec2(pattern.xy);vec2 pattern_br=vec2(pattern.zw);vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;\n#ifdef ELEVATED_ROADS\nz_offset+=a_road_z_offset;v_road_z_offset=z_offset;\n#endif\nfloat hidden=float(opacity==0.0);vec2 pos=vec2(a_pos);gl_Position=mix(u_matrix*vec4(pos,z_offset,1),AWAY,hidden);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,pos);\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=vec3(pos,z_offset);vec3 shd_pos1=vec3(pos,z_offset);\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n}'),
            lineBlendComposite: or("uniform sampler2D u_image;uniform float u_opacity;uniform int u_blend_mode;in vec2 v_pos;\n#define ADDITIVE 1\nvoid main() {vec4 color=texture(u_image,v_pos);if (u_blend_mode==ADDITIVE) {if (color.a <=0.0) {discard;}float density=color.a;vec3 avgColor=color.rgb/max(density,0.001);float t=density/(1.0+density);glFragColor=vec4(avgColor*t*u_opacity,t*u_opacity);} else {vec3 multiplyFactor=color.rgb*u_opacity+(1.0-u_opacity);glFragColor=vec4(multiplyFactor,1.0);}\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(0.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}", "in ivec2 a_pos;out vec2 v_pos;void main() {gl_Position=vec4(a_pos,0,1);v_pos=vec2(a_pos)*0.5+0.5;}"),
            fillExtrusion: or('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nin vec4 v_color;in vec4 v_flat;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;\n#endif\nuniform lowp float u_opacity;\n#ifdef RENDER_FRONT_CUTOFF\nin float v_front_cutoff_opacity;\n#endif\n#ifdef INDICATOR_CUTOUT\n#ifdef FEATURE_CUTOUT\nin vec4 v_ground_roof;\n#endif\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec2 v_ao;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nin vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nin highp vec3 v_normal;\n#endif\nuniform vec3 u_flood_light_color;uniform highp float u_vertical_scale;uniform float u_flood_light_intensity;uniform vec3 u_ground_shadow_factor;\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nin float v_flood_radius;in float v_has_floodlight;\n#endif\nin float v_height;\n#pragma mapbox: define highp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize highp float emissive_strength\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nvec3 normal=normalize(v_normal);\n#endif\nfloat z;vec4 color=v_color;\n#ifdef ZERO_ROOF_RADIUS\nz=float(normal.z > 0.00001);\n#ifdef LIGHTING_3D_MODE\nnormal=mix(normal,vec3(0.0,0.0,1.0),z);\n#else\ncolor=mix(v_color,v_roof_color,z);\n#endif\n#endif\nfloat h=max(0.0,v_height);float ao_shade=1.0;\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h_floors=h/(u_ao[1]*u_vertical_scale);float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);ao_shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;\n#ifdef ZERO_ROOF_RADIUS\nconcave*=(1.0-z);\n#endif\nfloat x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);ao_shade*=mix(1.0,x_shade*x_shade*x_shade,concave);\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\ncolor.rgb*=mix(ao_shade,1.0,v_has_floodlight);\n#else\ncolor.rgb*=ao_shade;\n#endif\n#else\ncolor.rgb*=ao_shade;\n#endif\n#endif\n#ifdef LIGHTING_3D_MODE\nfloat flood_radiance=0.0;\n#ifdef FLOOD_LIGHT\nflood_radiance=(1.0-min(h/v_flood_radius,1.0))*u_flood_light_intensity*v_has_floodlight;\n#endif\n#ifdef RENDER_SHADOWS\n#ifdef FLOOD_LIGHT\nfloat ndotl_unclamped=dot(normal,u_shadow_direction);float ndotl=max(0.0,ndotl_unclamped);float occlusion=ndotl_unclamped < 0.0 ? 1.0 : shadow_occlusion(ndotl,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);vec3 litColor=apply_lighting(color.rgb,normal,(1.0-u_shadow_intensity*occlusion)*ndotl);vec3 floodLitColor=compute_flood_lighting(u_flood_light_color*u_opacity,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=mix(litColor,floodLitColor,flood_radiance);\n#else\nfloat shadowed_lighting_factor;\n#ifdef RENDER_CUTOFF\nshadowed_lighting_factor=shadowed_light_factor_normal_opacity(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,v_cutoff_opacity);if (v_cutoff_opacity==0.0) {discard;}\n#else\nshadowed_lighting_factor=shadowed_light_factor_normal(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);\n#endif\ncolor.rgb=apply_lighting(color.rgb,normal,shadowed_lighting_factor);\n#endif\n#else\ncolor.rgb=apply_lighting(color.rgb,normal);\n#ifdef FLOOD_LIGHT\ncolor.rgb=mix(color.rgb,u_flood_light_color*u_opacity,flood_radiance);\n#endif\n#endif\ncolor.rgb=mix(color.rgb,v_flat.rgb,emissive_strength);color*=u_opacity;\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos,h));\n#endif\n#ifdef INDICATOR_CUTOUT\n#ifdef FEATURE_CUTOUT\n{float ditherOpacity=cutoutGroundRoofOpacity(v_ground_roof);if (ditherOpacity < 1.0) {int index=(int(gl_FragCoord.x) % 4)*4+(int(gl_FragCoord.y) % 4);if (ditherOpacity < DITHER_THRESHOLDS[index]) {discard;}}}\n#else\ncolor=applyCutout(color,h);\n#endif\n#endif\n#ifdef RENDER_FRONT_CUTOFF\nif (v_front_cutoff_opacity < 1.0) {int index=(int(gl_FragCoord.x) % 4)*4+(int(gl_FragCoord.y) % 4);if (v_front_cutoff_opacity < DITHER_THRESHOLDS[index]) {discard;}}\n#endif\n#ifdef FEATURE_CUTOUT\ncolor=apply_feature_cutout(color,gl_FragCoord,get_cutout_factors(gl_FragCoord).x);\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_material_table.vertex.glsl"\nuniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_edge_radius;uniform float u_width_scale;in ivec4 a_pos_normal_ed;\n#if defined(HAS_CENTROID) || defined(TERRAIN)\nin uvec2 a_centroid_pos;\n#endif\n#ifdef RENDER_WALL_MODE\nin ivec4 a_join_normal_inside;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin ivec4 a_pos_3;in ivec4 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\n#ifdef TERRAIN\nuniform int u_height_type;uniform int u_base_type;\n#endif\nuniform highp float u_vertical_scale;\n#ifdef RENDER_FRONT_CUTOFF\nuniform vec3 u_front_cutoff_params;out float v_front_cutoff_opacity;\n#endif\nout vec4 v_color;out vec4 v_flat;\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nout vec4 v_roof_color;\n#endif\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nout highp vec3 v_normal;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec2 v_ao;\n#endif\n#if defined(LIGHTING_3D_MODE) && defined(FLOOD_LIGHT)\nout float v_flood_radius;out float v_has_floodlight;\n#endif\nout float v_height;\n#ifdef INDICATOR_CUTOUT\n#ifdef FEATURE_CUTOUT\nout vec4 v_ground_roof;\n#endif\n#endif\nvec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define highp float flood_light_wall_radius\n#pragma mapbox: define highp float line_width\n#pragma mapbox: define highp float emissive_strength\nvoid main() {DECLARE_MATERIAL_TABLE_INFO\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize highp float flood_light_wall_radius\n#pragma mapbox: initialize highp float line_width\n#pragma mapbox: initialize highp float emissive_strength\nbase*=u_vertical_scale;height*=u_vertical_scale;vec4 top_up_ny_start=vec4(a_pos_normal_ed & 1);vec4 pos_nx=vec4(a_pos_normal_ed >> 1);float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny_start.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny_start.z-1.0)*(1.0-abs(x_normal)),0.0));\n#if defined(ZERO_ROOF_RADIUS) || defined(RENDER_SHADOWS) || defined(LIGHTING_3D_MODE)\nv_normal=normal;\n#endif\nbase=max(0.0,base);float attr_height=height;height=max(0.0,top_up_ny_start.y==0.0 && top_up_ny_start.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny_start.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=vec2(a_centroid_pos);\n#endif\nfloat ele=0.0;float h=0.0;float c_ele=0.0;vec3 pos;\n#ifdef TERRAIN\nbool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;ele=elevation(pos_nx.xy);bool is_elevation_encoded=centroid_pos.y==0.0 || (centroid_pos.y > 0.0 && (int(centroid_pos.y) & 7)==7);c_ele=is_flat_height || is_flat_base ? (is_elevation_encoded ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);h=t > 0.0 ? max(h_base,h_height) : h_base;\n#else\nh=t > 0.0 ? height : base;\n#endif\npos=vec3(pos_nx.xy,h);\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(vec3(a_pos_normal_3)/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=vec3(a_pos_3)+globe_normal*(u_tile_up_scale*h);vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,pos.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*pos.z;pos=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\nfloat cutoff=1.0;vec3 scaled_pos=pos;\n#if defined(RENDER_CUTOFF) || defined(RENDER_FRONT_CUTOFF)\nvec2 centroid_decoded=pos.xy;bool isBorderCentroid=false;if (centroid_pos.x > 0.0 && centroid_pos.y > 0.0) {int iy=int(centroid_pos.y);int spanYbits=iy & 7;if (spanYbits==7) {isBorderCentroid=true;int borderID=(iy >> 3) & 3;float coordAlongBorder=float(iy >> 5)*4.0;if (borderID==0) centroid_decoded=vec2(0.0,coordAlongBorder);else if (borderID==1) centroid_decoded=vec2(EXTENT,coordAlongBorder);else if (borderID==2) centroid_decoded=vec2(coordAlongBorder,0.0);else centroid_decoded=vec2(coordAlongBorder,EXTENT);} else {centroid_decoded=floor(centroid_pos/8.0);}}\n#endif\n#if defined(RENDER_CUTOFF) || defined(RENDER_FRONT_CUTOFF)\nvec4 ground=u_matrix*vec4(centroid_decoded,ele,1.0);\n#endif\n#ifdef RENDER_CUTOFF\n#ifdef CLIP_ZERO_TO_ONE\ncutoff=cutoff_opacity(u_cutoff_params,ground.z*2.0-ground.w);\n#else\ncutoff=cutoff_opacity(u_cutoff_params,ground.z);\n#endif\nif (centroid_pos.y !=0.0 && centroid_pos.x !=0.0) {vec3 centroid_random=vec3(centroid_pos.xy,centroid_pos.x+centroid_pos.y+1.0);vec3 ground_pos=centroid_random/8.0;vec3 g=floor(ground_pos);vec3 mod_=centroid_random-g*8.0;float seed=min(1.0,0.1*(min(3.5,max(mod_.x+mod_.y,0.2*attr_height))*0.35+mod_.z));if (cutoff < 0.8-seed) {cutoff=0.0;}}float cutoff_scale=cutoff;v_cutoff_opacity=cutoff;scaled_pos.z=mix(c_ele,h,cutoff_scale);\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (cutoff==0.0 && centroid_pos.x !=0.0) || (color.a==0.0));\n#ifdef RENDER_FRONT_CUTOFF\nv_front_cutoff_opacity=1.0;if (centroid_pos.x > 0.0 && centroid_pos.y > 0.0) {hidden=max(hidden,float(ground.w <=0.0));float ndc_y=ground.y/max(ground.w,0.001);float threshold=u_front_cutoff_params.x*2.0-1.0;float range_ndc=u_front_cutoff_params.y*2.0;if (!isBorderCentroid) {hidden=max(hidden,float(ndc_y < threshold-range_ndc));}float t=clamp((ndc_y-(threshold-range_ndc))/max(range_ndc,0.001),0.0,1.0);v_front_cutoff_opacity=mix(u_front_cutoff_params.z,1.0,t);}\n#endif\n#ifdef RENDER_WALL_MODE\nvec3 join_normal_inside=vec3(a_join_normal_inside);vec2 wall_offset=u_width_scale*line_width*(join_normal_inside.xy/EXTENT);scaled_pos.xy+=(1.0-join_normal_inside.z)*wall_offset*0.5;scaled_pos.xy-=join_normal_inside.z*wall_offset*0.5;\n#endif\ngl_Position=mix(u_matrix*vec4(scaled_pos,1),AWAY,hidden);h=h-ele;v_height=h;\n#ifdef RENDER_SHADOWS\nvec3 shd_pos0=pos;vec3 shd_pos1=pos;\n#ifdef NORMAL_OFFSET\nvec3 offset=shadow_normal_offset(normal);shd_pos0+=offset*shadow_normal_offset_multiplier0();shd_pos1+=offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);\n#endif\nfloat NdotL=0.0;float colorvalue=0.0;\n#ifndef LIGHTING_3D_MODE\ncolorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;NdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),NdotL);if (normal.y !=0.0) {float r=0.84;r=mix(0.7,0.98,1.0-u_lightintensity);NdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#endif\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec2(mix(concave,-concave,start),y_ground);NdotL*=(1.0+0.05*(1.0-top_up_ny_start.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\n#ifdef FLOOD_LIGHT\nfloat is_wall=1.0-float(t > 0.0 && top_up_ny_start.y > 0.0);v_has_floodlight=float(flood_light_wall_radius > 0.0 && is_wall > 0.0);v_flood_radius=flood_light_wall_radius*u_vertical_scale;\n#endif\nv_color=vec4(color.rgb,1.0);float ndotl=calculate_NdotL(normal);v_flat.rgb=sRGBToLinear(color.rgb);v_flat.rgb=v_flat.rgb*(ndotl+(1.0-min(ndotl*57.29,1.0))*emissive_strength);v_flat=vec4(linearTosRGB(v_flat.rgb),1.0);\n#else\nv_color=vec4(0.0,0.0,0.0,1.0);v_color.rgb+=clamp(color.rgb*NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_color*=u_opacity;\n#endif\n#if defined(ZERO_ROOF_RADIUS) && !defined(LIGHTING_3D_MODE)\nfloat roofNdotL=clamp(u_lightpos.z,0.0,1.0);roofNdotL=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),roofNdotL);v_roof_color=vec4(0.0,0.0,0.0,1.0);v_roof_color.rgb+=clamp(color.rgb*roofNdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_roof_color*=u_opacity;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n#ifdef INDICATOR_CUTOUT\n#ifdef FEATURE_CUTOUT\nvec4 pos_ground=u_matrix*vec4(pos.xy,ele,1.0);vec4 pos_roof=u_matrix*vec4(pos.xy,ele+height,1.0);v_ground_roof=vec4(pos_ground.xy/pos_ground.w,pos_roof.xy/pos_roof.w);\n#endif\n#endif\n}'),
            fillExtrusionDepth: or("void main() {}", '#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_material_table.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_edge_radius;uniform float u_width_scale;uniform float u_vertical_scale;\n#ifdef TERRAIN\nuniform int u_height_type;uniform int u_base_type;\n#endif\nin ivec4 a_pos_normal_ed;\n#if defined(HAS_CENTROID) || defined(TERRAIN)\nin uvec2 a_centroid_pos;\n#endif\n#ifdef RENDER_WALL_MODE\nin ivec4 a_join_normal_inside;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp float line_width\n#pragma mapbox: define highp vec4 color\nvoid main() {DECLARE_MATERIAL_TABLE_INFO\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp float line_width\n#pragma mapbox: initialize highp vec4 color\nbase*=u_vertical_scale;height*=u_vertical_scale;vec3 top_up_ny=vec3(a_pos_normal_ed.xyz & 1);vec3 pos_nx=vec3(a_pos_normal_ed.xyz >> 1);base=max(0.0,base);height=max(0.0,top_up_ny.y==0.0 && top_up_ny.x==1.0 ? height-u_edge_radius : height);float t=top_up_ny.x;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=vec2(a_centroid_pos);\n#endif\nvec3 pos;\n#ifdef TERRAIN\nbool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;float ele=elevation(pos_nx.xy);bool is_elevation_encoded=centroid_pos.y==0.0 || (centroid_pos.y > 0.0 && int(centroid_pos.y)-(int(centroid_pos.y)/8)*8==7);float c_ele=is_flat_height || is_flat_base ? (is_elevation_encoded ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);float h=t > 0.0 ? max(h_base,h_height) : h_base;pos=vec3(pos_nx.xy,h);\n#else\npos=vec3(pos_nx.xy,t > 0.0 ? height : base);\n#endif\n#ifdef RENDER_WALL_MODE\nvec3 join_normal_inside=vec3(a_join_normal_inside);vec2 wall_offset=u_width_scale*line_width*(join_normal_inside.xy/EXTENT);pos.xy+=(1.0-join_normal_inside.z)*wall_offset*0.5;pos.xy-=join_normal_inside.z*wall_offset*0.5;\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (color.a==0.0));gl_Position=mix(u_matrix*vec4(pos,1),AWAY,hidden);}'),
            fillExtrusionPattern: or('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform vec2 u_texsize;uniform sampler2D u_image;\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\nuniform float u_pattern_transition;\n#endif\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;in vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nin vec3 v_normal;\n#endif\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\nin highp vec2 v_pos;in vec4 v_lighting;uniform lowp float u_opacity;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define mediump uvec4 pattern\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\n#pragma mapbox: define mediump uvec4 pattern_b\n#endif\n#pragma mapbox: define highp float pixel_ratio\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize mediump uvec4 pattern\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump uvec4 pattern_b\n#endif\n#pragma mapbox: initialize highp float pixel_ratio\nvec2 pattern_tl=vec2(pattern.xy);vec2 pattern_br=vec2(pattern.zw);highp vec2 imagecoord=mod(v_pos,1.0);highp vec2 pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,imagecoord);highp vec2 lod_pos=mix(pattern_tl/u_texsize,pattern_br/u_texsize,v_pos);vec4 out_color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef APPLY_LUT_ON_GPU\nout_color=applyLUT(u_lutTexture,out_color);\n#endif\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\nvec2 pattern_b_tl=vec2(pattern_b.xy);vec2 pattern_b_br=vec2(pattern_b.zw);highp vec2 pos_b=mix(pattern_b_tl/u_texsize,pattern_b_br/u_texsize,imagecoord);vec4 color_b=textureLodCustom(u_image,pos_b,lod_pos);out_color=out_color*(1.0-u_pattern_transition)+color_b*u_pattern_transition;\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting(out_color,normalize(v_normal))*u_opacity;\n#else\nout_color=out_color*v_lighting;\n#endif\n#ifdef FAUX_AO\nfloat intensity=u_ao[0];float h=max(0.0,v_ao.z);float h_floors=h/u_ao[1];float y_shade=1.0-0.9*intensity*min(v_ao.y,1.0);float shade=(1.0-0.08*intensity)*(y_shade+(1.0-y_shade)*(1.0-pow(1.0-min(h_floors/16.0,1.0),16.0)))+0.08*intensity*min(h_floors/160.0,1.0);float concave=v_ao.x*v_ao.x;float x_shade=mix(1.0,mix(0.6,0.75,min(h_floors/30.0,1.0)),intensity)+0.1*intensity*min(h,1.0);shade*=mix(1.0,x_shade*x_shade*x_shade,concave);out_color.rgb=out_color.rgb*shade;\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color,height);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_material_table.vertex.glsl"\nuniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform float u_tile_units_to_pixels;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform float u_width_scale;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;in ivec4 a_pos_normal_ed;\n#if defined(HAS_CENTROID) || defined(TERRAIN)\nin uvec2 a_centroid_pos;\n#endif\n#ifdef RENDER_WALL_MODE\nin ivec4 a_join_normal_inside;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin ivec4 a_pos_3;in ivec4 a_pos_normal_3;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_tile_id;uniform float u_zoom_transition;uniform vec3 u_up_dir;uniform float u_height_lift;\n#endif\n#ifdef TERRAIN\nuniform int u_height_type;uniform int u_base_type;\n#endif\nout highp vec2 v_pos;out vec4 v_lighting;\n#ifdef FAUX_AO\nuniform lowp vec2 u_ao;out vec3 v_ao;\n#endif\n#ifdef LIGHTING_3D_MODE\nout vec3 v_normal;\n#endif\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump uvec4 pattern\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\n#pragma mapbox: define mediump uvec4 pattern_b\n#endif\n#pragma mapbox: define highp float pixel_ratio\n#pragma mapbox: define highp float line_width\nvoid main() {DECLARE_MATERIAL_TABLE_INFO\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump uvec4 pattern\n#ifdef FILL_EXTRUSION_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump uvec4 pattern_b\n#endif\n#pragma mapbox: initialize highp float pixel_ratio\n#pragma mapbox: initialize highp float line_width\nvec2 pattern_tl=vec2(pattern.xy);vec2 pattern_br=vec2(pattern.zw);vec4 top_up_ny_start=vec4(a_pos_normal_ed & 1);vec4 pos_nx=vec4(a_pos_normal_ed >> 1);float x_normal=pos_nx.z/8192.0;vec3 normal=top_up_ny_start.y==1.0 ? vec3(0.0,0.0,1.0) : normalize(vec3(x_normal,(2.0*top_up_ny_start.z-1.0)*(1.0-abs(x_normal)),0.0));float edgedistance=float(a_pos_normal_ed.w);vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;base=max(0.0,base);height=max(0.0,height);float t=top_up_ny_start.x;float z=t > 0.0 ? height : base;vec2 centroid_pos=vec2(0.0);\n#if defined(HAS_CENTROID) || defined(TERRAIN)\ncentroid_pos=vec2(a_centroid_pos);\n#endif\nfloat ele=0.0;float h=z;vec3 p;float c_ele;\n#ifdef TERRAIN\nbool is_flat_height=centroid_pos.x !=0.0 && u_height_type==1;bool is_flat_base=centroid_pos.x !=0.0 && u_base_type==1;ele=elevation(pos_nx.xy);bool is_elevation_encoded=centroid_pos.y==0.0 || (centroid_pos.y > 0.0 && int(centroid_pos.y)-(int(centroid_pos.y)/8)*8==7);c_ele=is_flat_height || is_flat_base ? (is_elevation_encoded ? elevationFromUint16(centroid_pos.x) : flatElevation(centroid_pos)) : ele;float h_height=is_flat_height ? max(c_ele+height,ele+base+2.0) : ele+height;float h_base=is_flat_base ? max(c_ele+base,ele+base) : ele+(base==0.0 ?-5.0 : base);h=t > 0.0 ? max(h_base,h_height) : h_base;p=vec3(pos_nx.xy,h);\n#else\np=vec3(pos_nx.xy,z);\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nfloat lift=float((t+base) > 0.0)*u_height_lift;h+=lift;vec3 globe_normal=normalize(mix(vec3(a_pos_normal_3)/16384.0,u_up_dir,u_zoom_transition));vec3 globe_pos=vec3(a_pos_3)+globe_normal*(u_tile_up_scale*(p.z+lift));vec3 merc_pos=mercator_tile_position(u_inv_rot_matrix,p.xy,u_tile_id,u_merc_center)+u_up_dir*u_tile_up_scale*p.z;p=mix_globe_mercator(globe_pos,merc_pos,u_zoom_transition);\n#endif\n#ifdef RENDER_WALL_MODE\nvec3 join_normal_inside=vec3(a_join_normal_inside);vec2 wall_offset=u_width_scale*line_width*(join_normal_inside.xy/EXTENT);p.xy+=(1.0-join_normal_inside.z)*wall_offset*0.5;p.xy-=join_normal_inside.z*wall_offset*0.5;\n#endif\nfloat hidden=float((centroid_pos.x==0.0 && centroid_pos.y==1.0) || (color.a==0.0));gl_Position=mix(u_matrix*vec4(p,1),AWAY,hidden);vec2 pos=normal.z==1.0\n? pos_nx.xy\n: vec2(edgedistance,z*u_height_factor);v_pos=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,display_size,u_tile_units_to_pixels,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float NdotL=0.0;\n#ifdef LIGHTING_3D_MODE\nNdotL=calculate_NdotL(normal);\n#else\nNdotL=clamp(dot(normal,u_lightpos),0.0,1.0);NdotL=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),NdotL);\n#endif\nif (normal.y !=0.0) {float r=0.84;\n#ifndef LIGHTING_3D_MODE\nr=mix(0.7,0.98,1.0-u_lightintensity);\n#endif\nNdotL*=(\n(1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),r,1.0)));}\n#ifdef FAUX_AO\nfloat concave=pos_nx.w-floor(pos_nx.w*0.5)*2.0;float start=top_up_ny_start.w;float y_ground=1.0-clamp(t+base,0.0,1.0);float top_height=height;\n#ifdef TERRAIN\ntop_height=mix(max(c_ele+height,ele+base+2.0),ele+height,float(centroid_pos.x==0.0))-ele;y_ground+=y_ground*5.0/max(3.0,top_height);\n#endif\nv_ao=vec3(mix(concave,-concave,start),y_ground,h-ele);NdotL*=(1.0+0.05*(1.0-top_up_ny_start.y)*u_ao[0]);\n#ifdef PROJECTION_GLOBE_VIEW\ntop_height+=u_height_lift;\n#endif\ngl_Position.z-=(0.0000006*(min(top_height,500.)+2.0*min(base,500.0)+60.0*concave+3.0*start))*gl_Position.w;\n#endif\n#ifdef LIGHTING_3D_MODE\nv_normal=normal;\n#else\nv_lighting.rgb+=clamp(NdotL*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(p);\n#endif\n}'),
            groundShadow: or('#include "_prelude_shadow.fragment.glsl"\nprecision highp float;uniform vec3 u_ground_shadow_factor;in vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\nvoid main() {float light=shadowed_light_factor_plane_bias(v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);vec3 shadow=mix(u_ground_shadow_factor,vec3(1.0),light);\n#ifdef RENDER_CUTOFF\nshadow=mix(vec3(1.0),shadow,cutoff_opacity(u_cutoff_params,1.0/gl_FragCoord.w));\n#endif\n#ifdef FOG\nshadow=mix(shadow,vec3(1.0),v_fog_opacity);\n#endif\n#ifdef INDICATOR_CUTOUT\nshadow=mix(shadow,vec3(1.0),1.0-applyCutout(vec4(1.0),0.0).r);\n#endif\n#ifdef FEATURE_CUTOUT\nshadow=mix(shadow,vec3(1.0),get_cutout_factors(gl_FragCoord).y);\n#endif\nglFragColor=vec4(shadow,1.0);}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;in ivec2 a_pos;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\nvoid main() {gl_Position=u_matrix*vec4(a_pos,0.0,1.0);v_pos_light_view_0=u_light_matrix_0*vec4(a_pos,0.0,1.0);v_pos_light_view_1=u_light_matrix_1*vec4(a_pos,0.0,1.0);\n#ifdef FOG\nv_fog_pos=fog_position(vec2(a_pos));v_fog_opacity=fog(v_fog_pos);\n#endif\n}'),
            fillExtrusionGroundEffect: or("uniform highp float u_ao_pass;uniform highp float u_opacity;uniform highp float u_flood_light_intensity;uniform highp vec3 u_flood_light_color;uniform highp float u_attenuation;uniform sampler2D u_fb;uniform float u_fb_size;\n#ifdef SDF_SUBPASS\nin highp vec2 v_pos;in highp vec4 v_line_segment;in highp float v_flood_light_radius_tile;in highp vec2 v_ao;float line_df(highp vec2 a,highp vec2 b,highp vec2 p) {highp vec2 ba=b-a;highp vec2 pa=p-a;highp float r=clamp(dot(pa,ba)/dot(ba,ba),0.0,1.0);return length(pa-r*ba);}\n#ifdef FOG\nin highp float v_fog;\n#endif\n#endif\nvoid main() {\n#ifdef CLEAR_SUBPASS\nvec4 color=vec4(1.0);\n#ifdef CLEAR_FROM_TEXTURE\ncolor=texture(u_fb,gl_FragCoord.xy/vec2(u_fb_size));\n#endif\nglFragColor=color;\n#else\n#ifdef SDF_SUBPASS\nhighp float d=line_df(v_line_segment.xy,v_line_segment.zw,v_pos);highp float effect_radius=mix(v_flood_light_radius_tile,v_ao.y,u_ao_pass);d/=effect_radius;d=min(d,1.0);d=1.0-pow(1.0-d,u_attenuation);highp float effect_intensity=mix(u_flood_light_intensity,v_ao.x,u_ao_pass);highp float fog=1.0;\n#ifdef FOG\nfog=v_fog;\n#endif\n#ifdef RENDER_CUTOFF\nfog*=v_cutoff_opacity;\n#endif\nglFragColor=vec4(vec3(0.0),mix(1.0,d,effect_intensity*u_opacity*fog));\n#else\n#ifdef USE_MRT1\nout_Target1=vec4(1.0-texture(u_fb,gl_FragCoord.xy/vec2(u_fb_size)).a,0.0,0.0,0.0);\n#else\nvec4 color=mix(vec4(u_flood_light_color,1.0),vec4(vec3(0.0),1.0),u_ao_pass);\n#ifdef OVERDRAW_INSPECTOR\ncolor=vec4(1.0);\n#endif\nglFragColor=color;\n#endif\n#endif\nHANDLE_WIREFRAME_DEBUG;\n#endif\n}", '#include "_prelude_fog.vertex.glsl"\nin highp ivec4 a_pos_end;in highp int a_angular_offset_factor;in highp uint a_hidden_by_landmark;\n#ifdef SDF_SUBPASS\nout highp vec2 v_pos;out highp vec4 v_line_segment;out highp float v_flood_light_radius_tile;out highp vec2 v_ao;\n#ifdef FOG\nout highp float v_fog;\n#endif\n#endif\nuniform highp float u_flood_light_intensity;uniform highp mat4 u_matrix;uniform highp float u_ao_pass;uniform highp float u_meter_to_tile;uniform highp float u_edge_radius;uniform highp float u_dynamic_offset;uniform highp vec2 u_ao;\n#pragma mapbox: define highp float flood_light_ground_radius\nconst float TANGENT_CUTOFF=4.0;const float NORM=32767.0;void main() {\n#pragma mapbox: initialize highp float flood_light_ground_radius\nvec4 pos_end=vec4(a_pos_end);vec2 p=pos_end.xy;vec2 q=floor(pos_end.zw*0.5);vec2 start_bottom=pos_end.zw-q*2.0;float fl_ground_radius=abs(flood_light_ground_radius);float direction=flood_light_ground_radius < 0.0 ?-1.0 : 1.0;float flood_radius_tile=fl_ground_radius*u_meter_to_tile;vec2 v=normalize(q-p);float ao_radius=u_ao.y/3.5;float effect_radius=mix(flood_radius_tile,ao_radius,u_ao_pass)+u_edge_radius;float angular_offset_factor=float(a_angular_offset_factor)/NORM*TANGENT_CUTOFF;float angular_offset=direction*angular_offset_factor*effect_radius;float top=1.0-start_bottom.y;float side=(0.5-start_bottom.x)*2.0;vec2 extrusion_parallel=v*side*mix(u_dynamic_offset,angular_offset,top);vec2 perp=vec2(v.y,-v.x);vec2 extrusion_perp=direction*perp*effect_radius*top;vec3 pos=vec3(mix(q,p,start_bottom.x),0.0);pos.xy+=extrusion_parallel+extrusion_perp;\n#ifdef SDF_SUBPASS\nv_pos=pos.xy;v_line_segment=vec4(p,q)+perp.xyxy*u_edge_radius;v_flood_light_radius_tile=flood_radius_tile;v_ao=vec2(u_ao.x,ao_radius);\n#ifdef FOG\nv_fog_pos=fog_position(pos);v_fog=1.0-fog(v_fog_pos);\n#endif\n#endif\nfloat hidden_by_landmark=0.0;\n#ifdef HAS_CENTROID\nhidden_by_landmark=float(a_hidden_by_landmark);\n#endif\nfloat isFloodlit=float(fl_ground_radius > 0.0 && u_flood_light_intensity > 0.0);float hidden=mix(1.0-isFloodlit,isFloodlit,u_ao_pass);hidden+=hidden_by_landmark;gl_Position=mix(u_matrix*vec4(pos,1.0),AWAY,float(hidden > 0.0));\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n}'),
            hillshadePrepare: or("precision highp float;uniform highp sampler2D u_image;in vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;float getElevation(vec2 coord) {return texture(u_image,coord).r/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y));float b=getElevation(v_pos+vec2(0,-epsilon.y));float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y));float d=getElevation(v_pos+vec2(-epsilon.x,0));float e=getElevation(v_pos+vec2(epsilon.x,0));float f=getElevation(v_pos+vec2(-epsilon.x,epsilon.y));float g=getElevation(v_pos+vec2(0,epsilon.y));float h=getElevation(v_pos+vec2(epsilon.x,epsilon.y));float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2(\n(c+e+e+h)-(a+d+d+f),(f+g+g+h)-(a+b+b+c)\n)/pow(2.0,exaggeration+(19.2562-u_zoom));glFragColor=clamp(vec4(\nderiv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);}", "uniform mat4 u_matrix;uniform vec2 u_dimension;in ivec2 a_pos;in uvec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(vec2(a_texture_pos)/8192.0)*scale+epsilon;}"),
            hillshade: or('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;uniform float u_emissive_strength;void main() {vec4 pixel=texture(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);glFragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef LIGHTING_3D_MODE\nglFragColor=apply_lighting_with_emission_ground(glFragColor,u_emissive_strength);\n#endif\n#ifdef FOG\nglFragColor=fog_dither(fog_apply_premultiplied(glFragColor,v_fog_pos));\n#endif\n#ifdef USE_MRT1\nout_Target1=vec4(u_emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;in ivec2 a_pos;in uvec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=vec2(a_texture_pos)/8192.0;\n#ifdef FOG\nv_fog_pos=fog_position(vec2(a_pos));\n#endif\n}'),
            line: or('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nuniform lowp float u_device_pixel_ratio;uniform highp float u_width_scale;uniform highp float u_floor_width_scale;uniform float u_alpha_discard_threshold;uniform highp vec2 u_trim_offset;uniform highp vec2 u_trim_fade_range;uniform highp vec2 u_trim_gradient_mix_range;uniform lowp vec4 u_trim_color;uniform bool u_emissive_in_shadows;in vec4 v_width2_dilute;in vec2 v_normal;in float v_gamma_scale;in highp vec3 v_uv;\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#ifdef VARIABLE_LINE_WIDTH\nin float stub_side;\n#endif\n#ifdef RENDER_LINE_DASH\nuniform sampler2D u_dash_image;in vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform sampler2D u_gradient_image;\n#endif\n#ifdef INDICATOR_CUTOUT\nin highp float v_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\nfloat luminance(vec3 c) {return (c.r+c.r+c.b+c.g+c.g+c.g)*0.1667;}\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define mediump uvec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float side_z_offset\n#pragma mapbox: define lowp float border_width\n#pragma mapbox: define lowp vec4 border_color\n#pragma mapbox: define lowp float emissive_strength\nfloat linearstep(float edge0,float edge1,float x) {return  clamp((x-edge0)/(edge1-edge0),0.0,1.0);}void main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump uvec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float side_z_offset\n#pragma mapbox: initialize lowp float border_width\n#pragma mapbox: initialize lowp vec4 border_color\n#pragma mapbox: initialize lowp float emissive_strength\nfloat dist=length(v_normal)*v_width2_dilute.x;\n#ifdef VARIABLE_LINE_WIDTH\nblur=mix(blur,0.0,stub_side);\n#endif\nfloat diluted_opacity=opacity*v_width2_dilute.z;float blur2=(u_width_scale*blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2_dilute.y-blur2),v_width2_dilute.x-dist)/blur2,0.0,1.0);\n#ifdef VARIABLE_LINE_WIDTH\nalpha=mix(alpha,1.0,stub_side);\n#endif\nalpha=side_z_offset > 0.0 ? 1.0-alpha : alpha;\n#ifdef RENDER_LINE_DASH\nfloat sdfdist=texture(u_dash_image,v_tex).r;float sdfgamma=1.0/(2.0*u_device_pixel_ratio)/float(dash.z);float scaled_floorwidth=(floorwidth*u_floor_width_scale);alpha*=linearstep(0.5-sdfgamma/scaled_floorwidth,0.5+sdfgamma/scaled_floorwidth,sdfdist);\n#endif\nhighp vec4 out_color;\n#ifdef RENDER_LINE_GRADIENT\nout_color=texture(u_gradient_image,v_uv.xy);\n#else\nout_color=color;\n#endif\nfloat trim_alpha=1.0;\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=v_uv[2];if (trim_end > trim_start) {highp float start_transition=max(0.0,min(1.0,(line_progress-trim_start)/max(u_trim_fade_range[0],1.0e-9)));highp float end_transition=max(0.0,min(1.0,(trim_end-line_progress)/max(u_trim_fade_range[1],1.0e-9)));highp float transition_factor=min(start_transition,end_transition);highp float gradient_trim_color_mix_factor=0.0;\n#ifdef RENDER_LINE_GRADIENT\ngradient_trim_color_mix_factor=smoothstep(u_trim_gradient_mix_range.x,u_trim_gradient_mix_range.y,line_progress);\n#endif\nhighp vec4 trim_color=mix(u_trim_color,out_color,gradient_trim_color_mix_factor);out_color=mix(u_trim_gradient_mix_range.x < 1.0 ? color : out_color,trim_color,transition_factor);trim_alpha=1.0-transition_factor;}\n#endif\nif (u_alpha_discard_threshold !=0.0) {if (alpha < u_alpha_discard_threshold) {discard;}}\n#ifdef RENDER_LINE_BORDER\n#ifndef VARIABLE_LINE_WIDTH\nfloat edgeBlur=((border_width*u_width_scale)+1.0/u_device_pixel_ratio);float alpha2=clamp(min(dist-(v_width2_dilute.y-edgeBlur),v_width2_dilute.x-dist)/edgeBlur,0.0,1.0);if (alpha2 < 1.) {float smoothAlpha=smoothstep(0.6,1.0,alpha2);if (border_color.a==0.0) {float Y=(out_color.a > 0.01) ? luminance(out_color.rgb/out_color.a) : 1.;float adjustment=(Y > 0.) ? 0.5/Y : 0.45;if (out_color.a > 0.25 && Y < 0.25) {vec3 borderColor=(Y > 0.) ? out_color.rgb : vec3(1,1,1)*out_color.a;out_color.rgb=out_color.rgb+borderColor*(adjustment*(1.0-smoothAlpha));} else {out_color.rgb*=(0.6 +0.4*smoothAlpha);}} else {out_color=mix(border_color*trim_alpha,out_color,smoothAlpha);}out_color*=v_width2_dilute.w;}\n#endif\n#endif\nvec2 cutout_factors=vec2(0.0);\n#ifdef FEATURE_CUTOUT\ncutout_factors=get_cutout_factors(gl_FragCoord);\n#endif\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);light=mix(light,1.0,cutout_factors.y);light=u_emissive_in_shadows ? mix(light,1.0,emissive_strength) : light;\n#ifdef ELEVATED_ROADS\nout_color.rgb*=mix(v_road_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#else\nout_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef FOG\nout_color=fog_dither(fog_apply_premultiplied(out_color,v_fog_pos));\n#endif\nout_color*=(alpha*diluted_opacity);\n#ifdef LINE_BLEND_MULTIPLY\nglFragColor=vec4(out_color.rgb+(1.0-out_color.a),1.0);HANDLE_WIREFRAME_DEBUG;return;\n#endif\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color,v_z_offset);\n#endif\n#ifdef FEATURE_CUTOUT\nout_color=apply_feature_cutout(out_color,gl_FragCoord,cutout_factors.x);\n#endif\nglFragColor=out_color;\n#ifdef DUAL_SOURCE_BLENDING\nglFragColorSrc1=vec4(vec3(0.0),emissive_strength);\n#else\n#ifdef USE_MRT1\nout_Target1=vec4(emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define EXTRUDE_SCALE 0.015873016\nin ivec2 a_pos_normal;in uvec4 a_data;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS) || defined(VARIABLE_LINE_WIDTH)\nin vec3 a_z_offset_width;\n#endif\n#ifdef ELEVATION_GROUND_SCALE\nin float a_elevation_ground_scale;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET) || defined(RENDER_LINE_CURVE)\nin highp vec3 a_packed;\n#endif\n#ifdef RENDER_LINE_DASH\nin float a_linesofar;\n#endif\nuniform mat4 u_matrix;uniform mat2 u_pixels_to_tile_units;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;uniform float u_width_scale;uniform highp float u_floor_width_scale;\n#ifdef RENDER_LINE_CURVE\nuniform mat3 u_curve_points_x;uniform mat3 u_curve_points_y;uniform mat3 u_curve_points_z;uniform float u_curve_point_count;\n#endif\n#ifdef ELEVATED\nuniform lowp float u_zbias_factor;uniform lowp float u_tile_to_meter;float sample_elevation(vec2 apos) {\n#ifdef ELEVATION_REFERENCE_SEA\nreturn 0.0;\n#else\nreturn elevation(apos);\n#endif\n}\n#endif\nout vec2 v_normal;out vec4 v_width2_dilute;out float v_gamma_scale;out highp vec3 v_uv;\n#ifdef ELEVATED_ROADS\nout highp float v_road_z_offset;\n#endif\n#ifdef VARIABLE_LINE_WIDTH\nout float stub_side;\n#endif\n#ifdef RENDER_LINE_DASH\nuniform vec2 u_texsize;uniform float u_tile_units_to_pixels;out vec2 v_tex;\n#endif\n#ifdef RENDER_LINE_GRADIENT\nuniform float u_image_height;\n#endif\n#ifdef INDICATOR_CUTOUT\nout highp float v_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define mediump uvec4 dash\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define mediump float side_z_offset\n#pragma mapbox: define lowp float border_width\n#pragma mapbox: define lowp vec4 border_color\n#pragma mapbox: define lowp float emissive_strength\n#ifdef RENDER_LINE_CURVE\nvec3 getCurvePoint(int index) {int row=index/3;int col=index-row*3;float x=u_curve_points_x[row][col];float y=u_curve_points_y[row][col];float z=u_curve_points_z[row][col];return vec3(x,y,z);}vec3 catmullRom(vec3 p0,vec3 p1,vec3 p2,vec3 p3,float t) {float t2=t*t;float t3=t2*t;return 0.5*(\n2.0*p1+(-p0+p2)*t+(2.0*p0-5.0*p1+4.0*p2-p3)*t2+(-p0+3.0*p1-3.0*p2+p3)*t3\n);}vec2 catmullRomTangent(vec2 p0,vec2 p1,vec2 p2,vec2 p3,float t) {float t2=t*t;return 0.5*(\n(-p0+p2)+(2.0*p0-5.0*p1+4.0*p2-p3)*2.0*t+(-p0+3.0*p1-3.0*p2+p3)*3.0*t2\n);}struct CurveResult {vec3 point;vec2 tangent;};CurveResult calculateCurve(float line_progress) {float curve_progress=line_progress*(u_curve_point_count-1.0);float curve_progress_local=fract(curve_progress);float curve_segment=floor(curve_progress);int seg=int(curve_segment);vec3 p1=getCurvePoint(seg);vec3 p2=getCurvePoint(seg+1);float is_first_seg=step(curve_segment,0.5);vec3 p0_extrapolated=p1-(p2-p1);vec3 p0_fetched=getCurvePoint(max(seg-1,0));vec3 p0=mix(p0_fetched,p0_extrapolated,is_first_seg);int last_seg=int(u_curve_point_count)-2;float is_last_seg=step(float(last_seg)-0.5,curve_segment);vec3 p3_extrapolated=p2+(p2-p1);vec3 p3_fetched=getCurvePoint(min(seg+2,int(u_curve_point_count)-1));vec3 p3=mix(p3_fetched,p3_extrapolated,is_last_seg);vec3 point=catmullRom(p0,p1,p2,p3,curve_progress_local);vec2 tangent=catmullRomTangent(p0.xy,p1.xy,p2.xy,p3.xy,curve_progress_local)*(u_curve_point_count-1.0);CurveResult result;result.point=point;result.tangent=tangent;return result;}\n#endif\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump uvec4 dash\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize mediump float side_z_offset\n#pragma mapbox: initialize lowp float border_width\n#pragma mapbox: initialize lowp vec4 border_color\n#pragma mapbox: initialize lowp float emissive_strength\nfloat a_z_offset;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS)\na_z_offset=a_z_offset_width.x;\n#endif\nhighp float line_progress=0.0;\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET) || defined(RENDER_LINE_CURVE)\nline_progress=a_packed[2];\n#endif\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=vec2(a_data.xy)-128.0;float a_direction=float(a_data.z & 3u)-1.0;vec2 pos_normal=vec2(a_pos_normal);vec2 pos=floor(pos_normal*0.5);mediump vec2 normal=pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;offset=-1.0*offset*u_width_scale;bool left=normal.y==1.0;\n#ifdef RENDER_LINE_CURVE\nCurveResult curve=calculateCurve(line_progress);pos=curve.point.xy*8192.0;a_extrude=length(a_extrude)*normalize(curve.tangent);a_extrude=left ? vec2(-a_extrude.y,a_extrude.x) : vec2(a_extrude.y,-a_extrude.x);a_z_offset+=curve.point.z;\n#endif\ngapwidth=gapwidth/2.0;float halfwidth;float dilute_scale=1.0;float dilute_border_scale=1.0;\n#ifdef VARIABLE_LINE_WIDTH\nfloat left_width=a_z_offset_width.y;float right_width=a_z_offset_width.z;halfwidth=(u_width_scale*(left ? left_width : right_width))/2.0;if (side_z_offset !=0.0) {float left_f=step(1.0,normal.y);float is_negative=step(side_z_offset,0.0);float apply=mix(1.0-left_f,left_f,is_negative);a_extrude*=apply;a_z_offset+=abs(side_z_offset)*apply;v_normal*=left_f;}offset=border_width > 0.0 ? (left_width+right_width)*u_width_scale*0.5 : offset;halfwidth=border_width > 0.0 ? border_width*u_width_scale*0.5 : halfwidth;bool zero_right_width=border_width==0.0 && right_width==0.0;stub_side=zero_right_width ?-normal.y : 0.0;v_normal=!left && zero_right_width ? vec2(0.0) : v_normal;ANTIALIASING=!left && zero_right_width ? 0.0 : ANTIALIASING;\n#else\nhalfwidth=(u_width_scale*width)/2.0;\n#endif\nfloat inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*EXTRUDE_SCALE;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*EXTRUDE_SCALE*normal.y*mat2(t,-u,u,t);float hidden=float(opacity==0.0);vec2 extrude=dist*u_pixels_to_tile_units;vec4 projected_extrude=u_matrix*vec4(extrude,0.0,0.0);vec2 projected_extrude_xy=projected_extrude.xy;\n#ifdef ELEVATED_ROADS\nv_road_z_offset=a_z_offset;gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,a_z_offset,1.0);\n#else\n#ifdef ELEVATED\nvec2 offsetTile=offset2*u_pixels_to_tile_units;vec2 offset_pos=pos+offsetTile;float ele=0.0;float scaled_z_offset=a_z_offset;\n#ifdef ELEVATION_GROUND_SCALE\nscaled_z_offset=a_z_offset*mix(1.0,u_exaggeration,a_elevation_ground_scale);\n#endif\n#ifdef CROSS_SLOPE_VERTICAL\nfloat top=pos_normal.y-2.0*floor(pos_normal.y*0.5);float line_height=2.0*u_tile_to_meter*outset*top*u_pixels_to_tile_units[1][1]+scaled_z_offset;ele=sample_elevation(offset_pos)+line_height;projected_extrude=vec4(0);\n#else\n#ifdef CROSS_SLOPE_HORIZONTAL\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,max(ele1,ele2));ele=ele_max+scaled_z_offset;\n#else\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,0.5*(ele1+ele2));ele=ele_max-ele0+ele1+scaled_z_offset;\n#endif\n#endif\ngl_Position=u_matrix*vec4(offset_pos,ele,1.0)+projected_extrude;float z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*u_zbias_factor*u_exaggeration);gl_Position.z-=(gl_Position.w*zbias);gl_Position=mix(gl_Position,AWAY,hidden);\n#else\ngl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0);\n#endif\n#endif\n#ifndef ELEVATED\n#ifndef VARIABLE_LINE_WIDTH\n#ifndef RENDER_TO_TEXTURE\nfloat base_w=gl_Position.w;vec2 screen_width=abs(projected_extrude.xy/base_w*u_units_to_pixels);float max_extrude_component=max(screen_width.x,screen_width.y);if (base_w > 0.0 && max_extrude_component > 0.0001) {float min_pixel=1.05;if (max_extrude_component < min_pixel) {vec2 abs_pos=abs(gl_Position.xy);float is_out=max(abs_pos.x,abs_pos.y)/base_w;dilute_scale=mix(max_extrude_component/min_pixel,1.0,smoothstep(2.5,4.5,is_out));projected_extrude/=dilute_scale;}else\n{\n#ifdef RENDER_LINE_BORDER\nfloat border_ratio=(border_width*u_width_scale+ANTIALIASING)/outset;screen_width*=border_ratio;float max_border_component=max(screen_width.x,screen_width.y);dilute_border_scale=min(1.0,max_border_component/min_pixel);\n#endif\n}}\n#endif\n#endif\n#ifdef ELEVATED_ROADS\ngl_Position=gl_Position+projected_extrude;\n#else\ngl_Position=mix(gl_Position+projected_extrude,AWAY,hidden);\n#endif\n#endif\n#ifdef ELEVATED_ROADS\n#ifdef RENDER_SHADOWS\nvec3 shd_pos=vec3(pos+(offset2+dist)*u_pixels_to_tile_units,a_z_offset);vec3 shd_pos0=shd_pos;vec3 shd_pos1=shd_pos;\n#ifdef NORMAL_OFFSET\nvec3 shd_pos_offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=shd_pos_offset*shadow_normal_offset_multiplier0();shd_pos1+=shd_pos_offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#endif\n#ifndef RENDER_TO_TEXTURE\nfloat epsilon=0.0001;float extrude_length_without_perspective=max(length(dist),epsilon);float extrude_length_with_perspective=max(length(projected_extrude_xy/gl_Position.w*u_units_to_pixels),epsilon);v_gamma_scale=mix(extrude_length_without_perspective/extrude_length_with_perspective,1.0,step(0.01,blur));\n#else\nv_gamma_scale=1.0;\n#endif\n#if defined(RENDER_LINE_GRADIENT) || defined(RENDER_LINE_TRIM_OFFSET)\nhighp float a_uv_x=a_packed[0];float a_split_index=a_packed[1];\n#ifdef RENDER_LINE_GRADIENT\nhighp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec3(a_uv_x,a_split_index*texel_height-half_texel_height,line_progress);\n#else\nv_uv=vec3(a_uv_x,0.0,line_progress);\n#endif\n#endif\n#ifdef RENDER_LINE_DASH\nvec4 dashf=vec4(dash);float totalLength=dashf.z+dashf.w/65535.0;float scale=totalLength==0.0 ? 0.0 : u_tile_units_to_pixels/totalLength;v_tex=vec2(a_linesofar*scale/(floorwidth*u_floor_width_scale),(-normal.y*dashf.y+dashf.x+0.5)/u_texsize.y);\n#endif\nv_width2_dilute=vec4(outset,inset,dilute_scale,dilute_border_scale);\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n#ifdef INDICATOR_CUTOUT\nv_z_offset=a_z_offset;\n#endif\n}'),
            linePattern: or('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\nuniform highp float u_device_pixel_ratio;uniform highp float u_width_scale;uniform highp float u_alpha_discard_threshold;uniform highp vec2 u_texsize;uniform highp float u_tile_units_to_pixels;uniform highp vec2 u_trim_offset;uniform highp vec2 u_trim_fade_range;uniform lowp vec4 u_trim_color;uniform sampler2D u_image;\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\n#ifdef LINE_PATTERN_TRANSITION\nuniform float u_pattern_transition;\n#endif\nin vec2 v_normal;in vec2 v_width2;in highp float v_linesofar;in float v_gamma_scale;in float v_width;\n#ifdef RENDER_LINE_TRIM_OFFSET\nin highp vec3 v_uv;\n#endif\n#ifdef ELEVATED_ROADS\nin highp float v_road_z_offset;\n#endif\n#ifdef LINE_JOIN_NONE\nin vec2 v_pattern_data;\n#endif\n#ifdef INDICATOR_CUTOUT\nin highp float v_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#pragma mapbox: define mediump uvec4 pattern\n#ifdef LINE_PATTERN_TRANSITION\n#pragma mapbox: define mediump uvec4 pattern_b\n#endif\n#pragma mapbox: define mediump float pixel_ratio\n#pragma mapbox: define mediump float blur\n#pragma mapbox: define mediump float opacity\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize mediump uvec4 pattern\n#ifdef LINE_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump uvec4 pattern_b\n#endif\n#pragma mapbox: initialize mediump float pixel_ratio\n#pragma mapbox: initialize mediump float blur\n#pragma mapbox: initialize mediump float opacity\n#pragma mapbox: initialize lowp float emissive_strength\nvec2 pattern_tl=vec2(pattern.xy);vec2 pattern_br=vec2(pattern.zw);vec2 display_size=(pattern_br-pattern_tl)/pixel_ratio;highp float pattern_size=display_size.x/u_tile_units_to_pixels;float aspect=display_size.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(u_width_scale*blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);highp float pattern_x=v_linesofar/pattern_size*aspect;highp float x=mod(pattern_x,1.0);highp float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;highp vec2 pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(x,y));highp vec2 lod_pos=mix(pattern_tl*texel_size-texel_size,pattern_br*texel_size+texel_size,vec2(pattern_x,y));vec4 color=textureLodCustom(u_image,pos,lod_pos);\n#ifdef APPLY_LUT_ON_GPU\ncolor=applyLUT(u_lutTexture,color);\n#endif\n#ifdef LINE_PATTERN_TRANSITION\nvec2 pattern_b_tl=vec2(pattern_b.xy);vec2 pattern_b_br=vec2(pattern_b.zw);highp vec2 pos_b=mix(pattern_b_tl*texel_size-texel_size,pattern_b_br*texel_size+texel_size,vec2(x,y));vec4 color_b=textureLodCustom(u_image,pos_b,lod_pos);color=color*(1.0-u_pattern_transition)+color_b*u_pattern_transition;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float trim_start=u_trim_offset[0];highp float trim_end=u_trim_offset[1];highp float line_progress=v_uv[2];if (trim_end > trim_start) {highp float start_transition=max(0.0,min(1.0,(line_progress-trim_start)/max(u_trim_fade_range[0],1.0e-9)));highp float end_transition=max(0.0,min(1.0,(trim_end-line_progress)/max(u_trim_fade_range[1],1.0e-9)));highp float transition_factor=min(start_transition,end_transition);color=mix(color,color.a*u_trim_color,transition_factor);}\n#endif\n#ifdef LINE_JOIN_NONE\nhighp float pattern_len=pattern_size/aspect;highp float segment_phase=pattern_len-mod(v_linesofar-v_pattern_data.x+pattern_len,pattern_len);highp float visible_start=segment_phase-step(pattern_len*0.5,segment_phase)*pattern_len;highp float visible_end=floor((v_pattern_data.y-segment_phase)/pattern_len)*pattern_len+segment_phase;visible_end+=step(pattern_len*0.5,v_pattern_data.y-visible_end)*pattern_len;if (v_pattern_data.x < visible_start || v_pattern_data.x >=visible_end) {color=vec4(0.0);}\n#endif\n#ifdef LIGHTING_3D_MODE\ncolor=apply_lighting_with_emission_ground(color,emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);\n#ifdef ELEVATED_ROADS\ncolor.rgb*=mix(v_road_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#else\ncolor.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ncolor*=(alpha*opacity);if (u_alpha_discard_threshold !=0.0) {if (color.a < u_alpha_discard_threshold) {discard;}}\n#ifdef INDICATOR_CUTOUT\ncolor=applyCutout(color,v_z_offset);\n#endif\nglFragColor=color;\n#ifdef DUAL_SOURCE_BLENDING\nglFragColorSrc1=vec4(vec3(0.0),emissive_strength);\n#else\n#ifdef USE_MRT1\nout_Target1=vec4(emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\n#define scale 0.015873016\nin ivec2 a_pos_normal;in uvec4 a_data;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS)\nin vec3 a_z_offset_width;\n#endif\n#ifdef ELEVATION_GROUND_SCALE\nin float a_elevation_ground_scale;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nin highp vec3 a_packed;\n#endif\nin highp float a_linesofar;\n#ifdef LINE_JOIN_NONE\nin highp vec3 a_pattern_data;out vec2 v_pattern_data;\n#endif\n#ifdef INDICATOR_CUTOUT\nout highp float v_z_offset;\n#endif\nuniform mat4 u_matrix;uniform float u_tile_units_to_pixels;uniform vec2 u_units_to_pixels;uniform mat2 u_pixels_to_tile_units;uniform float u_device_pixel_ratio;uniform float u_width_scale;uniform float u_floor_width_scale;\n#ifdef ELEVATED\nuniform lowp float u_zbias_factor;uniform lowp float u_tile_to_meter;float sample_elevation(vec2 apos) {\n#ifdef ELEVATION_REFERENCE_SEA\nreturn 0.0;\n#else\nreturn elevation(apos);\n#endif\n}\n#endif\nout vec2 v_normal;out vec2 v_width2;out highp float v_linesofar;out float v_gamma_scale;out float v_width;\n#ifdef RENDER_LINE_TRIM_OFFSET\nout highp vec3 v_uv;\n#endif\n#ifdef ELEVATED_ROADS\nout highp float v_road_z_offset;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#pragma mapbox: define mediump float blur\n#pragma mapbox: define mediump float opacity\n#pragma mapbox: define mediump float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define mediump float floorwidth\n#pragma mapbox: define mediump uvec4 pattern\n#ifdef LINE_PATTERN_TRANSITION\n#pragma mapbox: define mediump uvec4 pattern_b\n#endif\n#pragma mapbox: define mediump float pixel_ratio\n#pragma mapbox: define lowp float emissive_strength\nvoid main() {\n#pragma mapbox: initialize mediump float blur\n#pragma mapbox: initialize mediump float opacity\n#pragma mapbox: initialize mediump float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize mediump float floorwidth\n#pragma mapbox: initialize mediump uvec4 pattern\n#ifdef LINE_PATTERN_TRANSITION\n#pragma mapbox: initialize mediump uvec4 pattern_b\n#endif\n#pragma mapbox: initialize mediump float pixel_ratio\n#pragma mapbox: initialize lowp float emissive_strength\nfloat a_z_offset;\n#if defined(ELEVATED) || defined(ELEVATED_ROADS)\na_z_offset=a_z_offset_width.x;\n#endif\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=vec2(a_data.xy)-128.0;float a_direction=float(a_data.z & 3u)-1.0;vec2 pos_normal=vec2(a_pos_normal);vec2 pos=floor(pos_normal*0.5);vec2 normal=pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=(u_width_scale*width)/2.0;offset=-1.0*offset*u_width_scale;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);vec2 dist=outset*a_extrude*scale;float u=0.5*a_direction;float t=1.0-abs(u);vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float hidden=float(opacity==0.0);vec2 extrude=dist*u_pixels_to_tile_units;vec4 projected_extrude=u_matrix*vec4(extrude,0.0,0.0);vec2 projected_extrude_xy=projected_extrude.xy;\n#ifdef ELEVATED_ROADS\nv_road_z_offset=a_z_offset;gl_Position=u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,a_z_offset,1.0)+projected_extrude;\n#else\n#ifdef ELEVATED\nvec2 offsetTile=offset2*u_pixels_to_tile_units;vec2 offset_pos=pos+offsetTile;float ele=0.0;float scaled_z_offset=a_z_offset;\n#ifdef ELEVATION_GROUND_SCALE\nscaled_z_offset=a_z_offset*mix(1.0,u_exaggeration,a_elevation_ground_scale);\n#endif\n#ifdef CROSS_SLOPE_VERTICAL\nfloat top=pos_normal.y-2.0*floor(pos_normal.y*0.5);float line_height=2.0*u_tile_to_meter*outset*top*u_pixels_to_tile_units[1][1]+scaled_z_offset;ele=sample_elevation(offset_pos)+line_height;projected_extrude=vec4(0);\n#else\n#ifdef CROSS_SLOPE_HORIZONTAL\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,max(ele1,ele2));ele=ele_max+scaled_z_offset;\n#else\nfloat ele0=sample_elevation(offset_pos);float ele1=max(sample_elevation(offset_pos+extrude),sample_elevation(offset_pos+extrude/2.0));float ele2=max(sample_elevation(offset_pos-extrude),sample_elevation(offset_pos-extrude/2.0));float ele_max=max(ele0,0.5*(ele1+ele2));ele=ele_max-ele0+ele1+scaled_z_offset;\n#endif\n#endif\ngl_Position=u_matrix*vec4(offset_pos,ele,1.0)+projected_extrude;float z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*u_zbias_factor*u_exaggeration);gl_Position.z-=(gl_Position.w*zbias);gl_Position=mix(gl_Position,AWAY,hidden);\n#else\ngl_Position=mix(u_matrix*vec4(pos+offset2*u_pixels_to_tile_units,0.0,1.0)+projected_extrude,AWAY,hidden);\n#endif\n#endif\n#ifdef ELEVATED_ROADS\n#ifdef RENDER_SHADOWS\nvec3 shd_pos=vec3(pos+(offset2+dist)*u_pixels_to_tile_units,a_z_offset);vec3 shd_pos0=shd_pos;vec3 shd_pos1=shd_pos;\n#ifdef NORMAL_OFFSET\nvec3 shd_pos_offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=shd_pos_offset*shadow_normal_offset_multiplier0();shd_pos1+=shd_pos_offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#endif\n#ifndef RENDER_TO_TEXTURE\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude_xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=mix(extrude_length_without_perspective/extrude_length_with_perspective,1.0,step(0.01,blur));\n#else\nv_gamma_scale=1.0;\n#endif\n#ifdef RENDER_LINE_TRIM_OFFSET\nhighp float a_uv_x=a_packed[0];highp float line_progress=a_packed[2];v_uv=vec3(a_uv_x,0.0,line_progress);\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=(floorwidth*u_floor_width_scale);\n#ifdef LINE_JOIN_NONE\nv_width=(floorwidth*u_floor_width_scale)+ANTIALIASING;mediump float pixels_to_tile_units=1.0/u_tile_units_to_pixels;mediump float pixel_ratio_inverse=1.0/pixel_ratio;mediump float aspect=v_width/(float(pattern.w-pattern.y)*pixel_ratio_inverse);highp float subt_multiple=float(pattern.z-pattern.x)*pixel_ratio_inverse*pixels_to_tile_units*aspect*32.0;highp float subt=floor(a_pattern_data.z/subt_multiple)*subt_multiple;float offset_sign=(fract(a_pattern_data.x)-0.5)*4.0;float line_progress_offset=offset_sign*v_width*0.5*pixels_to_tile_units;v_linesofar=(a_pattern_data.z-subt)+a_linesofar+line_progress_offset;v_pattern_data=vec2(a_pattern_data.x+line_progress_offset,a_pattern_data.y);\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(pos);\n#endif\n#ifdef INDICATOR_CUTOUT\nv_z_offset=a_z_offset;\n#endif\n}'),
            raster: or('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\n#include "_prelude_raster_array.glsl"\nuniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;uniform highp float u_zoom_transition;in vec2 v_pos0;in vec2 v_pos1;in float v_depth;\n#ifdef PROJECTION_GLOBE_VIEW\nin float v_split_fade;\n#endif\nuniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;uniform float u_emissive_strength;\n#ifndef RASTER_ARRAY\nuniform highp sampler2D u_image0;uniform sampler2D u_image1;\n#endif\n#ifdef RASTER_COLOR\nuniform sampler2D u_color_ramp;uniform highp vec4 u_colorization_mix;uniform highp float u_colorization_offset;uniform vec2 u_texture_res;\n#endif\nvoid main() {vec4 color0,color1,color;vec2 value;\n#ifdef RASTER_COLOR\n#ifdef RASTER_ARRAY\n#ifdef RASTER_ARRAY_LINEAR\nvalue=mix(\nraTexture2D_image0_linear(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_linear(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#else\nvalue=mix(\nraTexture2D_image0_nearest(v_pos0,u_texture_res,u_colorization_mix,u_colorization_offset),raTexture2D_image1_nearest(v_pos1,u_texture_res,u_colorization_mix,u_colorization_offset),u_fade_t\n);\n#endif\nif (value.y > 0.0) value.x/=value.y;\n#else\ncolor=mix(texture(u_image0,v_pos0),texture(u_image1,v_pos1),u_fade_t);value=vec2(u_colorization_offset+dot(color.rgb,u_colorization_mix.rgb),color.a);\n#endif\ncolor=texture(u_color_ramp,vec2(value.x,0.5));if (color.a > 0.0) color.rgb/=color.a;color.a*=value.y;\n#else\ncolor0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);\n#endif\ncolor.a*=u_opacity;\n#ifdef GLOBE_POLES\ncolor.a*=1.0-smoothstep(0.0,0.05,u_zoom_transition);\n#endif\nvec3 rgb=color.rgb;rgb=vec3(\ndot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);vec3 out_color=mix(u_high_vec,u_low_vec,rgb);\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),u_emissive_strength).rgb;\n#endif\n#ifdef FOG\nhighp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));\n#endif\nglFragColor=vec4(out_color*color.a,color.a);\n#ifdef PROJECTION_GLOBE_VIEW\nglFragColor*=mix(1.0,1.0-smoothstep(0.0,0.05,u_zoom_transition),smoothstep(0.8,0.9,v_split_fade));\n#endif\n#ifdef RENDER_CUTOFF\nglFragColor=glFragColor*cutoff_opacity(u_cutoff_params,v_depth);\n#endif\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n#ifdef USE_MRT1\nout_Target1=vec4(u_emissive_strength*glFragColor.a,0.0,0.0,glFragColor.a);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform vec2 u_perspective_transform;uniform vec2 u_texture_offset;uniform float u_raster_elevation;uniform float u_zoom_transition;uniform vec2 u_merc_center;\n#ifdef ELEVATED\nuniform lowp float u_zbias_factor;\n#endif\n#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#else\nin ivec2 a_pos;in uvec2 a_texture_pos;\n#endif\nout vec2 v_pos0;out vec2 v_pos1;out float v_depth;\n#ifdef PROJECTION_GLOBE_VIEW\nout float v_split_fade;\n#endif\nvoid main() {vec2 uv;\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;uv=a_uv;float ele=u_raster_elevation;\n#ifdef ELEVATION_REFERENCE_GROUND\nele+=elevation(uv*EXTENT);\n#endif\nglobe_pos+=normalize(globe_pos)*ele*GLOBE_UPSCALE;gl_Position=u_matrix*u_globe_matrix*vec4(globe_pos,1.0);\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(a_globe_pos,1.0)).xyz);\n#endif\n#else\nvec4 world_pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec2 texture_pos=vec2(a_texture_pos);uv=texture_pos/8192.0;vec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float mercatorX=mercatorXfromLng(latLng[1]);  \nfloat tiles=u_grid_matrix[0][2];if (tiles > 0.0) {float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];float uvY=mercatorY*tiles-idy;float uvX=mercatorX*tiles-idx;uv=vec2(uvX,uvY);}float ele=u_raster_elevation;\n#ifdef ELEVATION_REFERENCE_GROUND\nele+=elevation(uv*EXTENT)-decomposed_pos_and_skirt.z;\n#endif\nvec4 merc_world_pos=vec4(0.0);   \nv_split_fade=0.0;if (u_zoom_transition > 0.0) {vec2 merc_pos=vec2(mercatorX,mercatorY);merc_world_pos=vec4(merc_pos,ele,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;float opposite_merc_center=mod(u_merc_center.x+0.5,1.0);float dist_from_poles=(abs(mercatorY-0.5)*2.0);float range=0.1;v_split_fade=abs(opposite_merc_center-mercatorX);v_split_fade=clamp(1.0-v_split_fade,0.0,1.0);v_split_fade=max(smoothstep(1.0-range,1.0,dist_from_poles),max(smoothstep(1.0-range,1.0,v_split_fade),smoothstep(1.0-range,1.0,1.0-v_split_fade)));}vec3 globe_pos=latLngToECEF(latLng.xy);globe_pos+=normalize(globe_pos)*ele*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);world_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition),1.0);\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n#else\nfloat ele=0.0;vec2 decodedPos=vec2(a_pos);\n#ifdef ELEVATION_REFERENCE_GROUND\nvec3 decomposedPosAndSkirt=decomposeToPosAndSkirt(a_pos);float skirt=decomposedPosAndSkirt.z;decodedPos=decomposedPosAndSkirt.xy;uv=decodedPos/8192.0;ele=elevation(decodedPos)-skirt;\n#else\nuv=vec2(a_texture_pos)/8192.0;\n#endif\nworld_pos=vec4(decodedPos,(u_raster_elevation+ele),1.0);\n#ifdef FOG\nv_fog_pos=fog_position(decodedPos);\n#endif\n#endif\nfloat w=1.0+dot(uv*EXTENT,u_perspective_transform);gl_Position=u_matrix*world_pos*w;\n#endif\nv_pos0=uv;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;v_pos0=u_texture_offset.x+u_texture_offset.y*v_pos0;v_pos1=u_texture_offset.x+u_texture_offset.y*v_pos1;\n#ifdef ELEVATED\nfloat z=clamp(gl_Position.z/gl_Position.w,0.5,1.0);float zbias=max(0.00005,(pow(z,0.8)-z)*u_zbias_factor);gl_Position.z-=(gl_Position.w*zbias);\n#endif\n#ifdef RENDER_CUTOFF\nv_depth=gl_Position.z;\n#endif\n}'),
            rasterParticle: or('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform float u_fade_t;uniform float u_opacity;uniform highp float u_raster_elevation;in vec2 v_pos0;in vec2 v_pos1;uniform sampler2D u_image0;uniform sampler2D u_image1;void main() {vec4 color0,color1,color;color0=texture(u_image0,v_pos0);color1=texture(u_image1,v_pos1);if (color0.a > 0.0) color0.rgb/=color0.a;if (color1.a > 0.0) color1.rgb/=color1.a;color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 out_color=color.rgb;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(vec4(out_color,1.0),1.0).rgb;\n#endif\n#ifdef FOG\nhighp float fog_limit_high_meters=1000000.0;highp float fog_limit_low_meters=600000.0;float fog_limit=1.0-smoothstep(fog_limit_low_meters,fog_limit_high_meters,u_raster_elevation);out_color=fog_dither(fog_apply(out_color,v_fog_pos,fog_limit));\n#endif\nglFragColor=vec4(out_color*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\nuniform mat4 u_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform mat3 u_grid_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_raster_elevation;uniform float u_zoom_transition;uniform vec2 u_merc_center;\n#define GLOBE_UPSCALE GLOBE_RADIUS/6371008.8\nin ivec2 a_pos;in uvec2 a_texture_pos;out vec2 v_pos0;out vec2 v_pos1;void main() {float w=1.0;vec2 uv;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float mercatorX=mercatorXfromLng(latLng[1]);float tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];float uvX=mercatorX*tiles-idx;float uvY=mercatorY*tiles-idy;uv=vec2(uvX,uvY);vec3 globe_pos=latLngToECEF(latLng.xy);globe_pos+=normalize(globe_pos)*u_raster_elevation*GLOBE_UPSCALE;vec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {vec2 merc_pos=vec2(mercatorX,mercatorY);merc_world_pos=vec4(merc_pos,u_raster_elevation,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition)*w,w);gl_Position=u_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n#else\nuv=vec2(a_texture_pos)/8192.0;gl_Position=u_matrix*vec4(vec2(a_pos)*w,u_raster_elevation*w,w);\n#ifdef FOG\nv_fog_pos=fog_position(vec2(a_pos));\n#endif\n#endif\nv_pos0=uv;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}'),
            rasterParticleDraw: or("uniform sampler2D u_color_ramp;in float v_particle_speed;void main() {glFragColor=texture(u_color_ramp,vec2(v_particle_speed,0.5));}", '#include "_prelude_raster_particle.glsl"\nin int a_index;uniform sampler2D u_particle_texture;uniform float u_particle_texture_side_len;uniform vec2 u_tile_offset;out float v_particle_speed;void main() {ivec2 pixel_coord=ivec2(\nmod(float(a_index),u_particle_texture_side_len),float(a_index)/u_particle_texture_side_len);vec4 pixel=texelFetch(u_particle_texture,pixel_coord,0);vec2 pos=unpack_pos_from_rgba(pixel)+u_tile_offset;vec2 tex_coord=fract(pos);vec2 velocity=lookup_velocity(tex_coord);if (velocity==INVALID_VELOCITY) {gl_Position=AWAY;v_particle_speed=0.0;} else {gl_Position=vec4(2.0*pos-1.0,0,1);v_particle_speed=length(velocity);}gl_PointSize=1.0;}'),
            rasterParticleTexture: or("uniform sampler2D u_texture;uniform float u_opacity;in vec2 v_tex_pos;void main() {vec4 color=texture(u_texture,v_tex_pos);glFragColor=vec4(floor(255.0*color*u_opacity)/255.0);}", "in ivec2 a_pos;out vec2 v_tex_pos;void main() {vec2 uv=0.5*vec2(a_pos)+vec2(0.5);v_tex_pos=uv;gl_Position=vec4(a_pos,0.0,1.0);}"),
            rasterParticleUpdate: or('#include "_prelude_raster_particle.glsl"\nuniform sampler2D u_particle_texture;uniform mediump float u_particle_texture_side_len;uniform mediump float u_speed_factor;uniform highp float u_reset_rate;uniform highp float u_rand_seed;in highp vec2 v_tex_coord;vec2 linearstep(vec2 edge0,vec2 edge1,vec2 x) {return  clamp((x-edge0)/(edge1-edge0),vec2(0),vec2(1));}const highp vec3 rand_constants=vec3(12.9898,78.233,4375.85453);highp float rand(const highp vec2 co) {highp float t=dot(rand_constants.xy,co);return fract(sin(t)*(rand_constants.z+t));}void main() {ivec2 pixel_coord=ivec2(v_tex_coord*u_particle_texture_side_len);highp vec4 pixel=texelFetch(u_particle_texture,pixel_coord,0);highp vec2 pos=unpack_pos_from_rgba(pixel);highp vec2 velocity=lookup_velocity(clamp(pos,0.0,1.0));highp vec2 dp=velocity==INVALID_VELOCITY ? vec2(0) : velocity*u_speed_factor;pos=pos+dp;highp vec2 seed=(pos+v_tex_coord)*u_rand_seed;highp vec2 random_pos=vec2(rand(seed+1.3),rand(seed+2.1));highp vec2 persist_rate=pow(\nlinearstep(vec2(-u_particle_pos_offset),vec2(0),pos)*linearstep(vec2(1.0+u_particle_pos_offset),vec2(1),pos),vec2(4)\n);highp vec2 per_frame_persist=pow(persist_rate,abs(dp)/u_particle_pos_offset);highp float drop_rate=1.0-per_frame_persist.x*per_frame_persist.y;drop_rate=any(greaterThanEqual(abs(pos-0.5),vec2(0.5+u_particle_pos_offset))) ? 1.0 : drop_rate;highp float drop=step(1.0-drop_rate-u_reset_rate,rand(seed));highp vec2 next_pos=mix(pos,random_pos,drop);glFragColor=pack_pos_to_rgba(next_pos);}', "in ivec2 a_pos;out vec2 v_tex_coord;void main() {v_tex_coord=0.5*vec2(a_pos+ivec2(1));gl_Position=vec4(a_pos,0.0,1.0);}"),
            symbol: or('#include "_prelude_lighting.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;uniform bool u_is_halo;uniform lowp float u_scale_factor;\n#ifdef ICON_TRANSITION\nuniform float u_icon_transition;\n#endif\n#ifdef COLOR_ADJUSTMENT\nuniform mat4 u_color_adj_mat;\n#endif\n#ifdef INDICATOR_CUTOUT\nin highp float v_z_offset;\n#else\n#ifdef RENDER_SHADOWS\nin highp float v_z_offset;\n#endif\n#endif\nin vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nin vec2 v_tex_b;\n#endif\nin float v_draw_halo;in vec3 v_gamma_scale_size_fade_opacity;\n#ifdef RENDER_TEXT_AND_SYMBOL\nin float is_sdf;in vec2 v_tex_a_icon;\n#endif\n#ifdef RENDER_SHADOWS\nuniform vec3 u_ground_shadow_factor;in highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in highp float v_depth;\n#endif\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\n#ifdef USE_PAINT_PROPERTIES_UBO\nin lowp float opacity;\n#ifdef RENDER_SDF\nin lowp vec4 fill_np_color;in lowp vec4 halo_np_color;in lowp float halo_width;in lowp float halo_blur;\n#endif\n#ifdef LIGHTING_3D_MODE\nin lowp float emissive_strength;\n#endif\n#else\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\n#endif\nvoid main() {\n#ifdef USE_PAINT_PROPERTIES_UBO\nvec4 fill_color;vec4 halo_color;\n#ifdef RENDER_SDF\nfill_color=vec4(fill_np_color.rgb*fill_np_color.a,fill_np_color.a);halo_color=vec4(halo_np_color.rgb*halo_np_color.a,halo_np_color.a);\n#endif\n#else\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\n#endif\nvec4 out_color;float fade_opacity=v_gamma_scale_size_fade_opacity[2];\n#ifdef RENDER_TEXT_AND_SYMBOL\nif (is_sdf==ICON) {vec2 tex_icon=v_tex_a_icon;lowp float alpha=opacity*fade_opacity;glFragColor=texture(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nreturn;}\n#endif\nvec2 cutout_factors=vec2(0.0);\n#ifdef FEATURE_CUTOUT\ncutout_factors=get_cutout_factors(gl_FragCoord);\n#endif\n#ifdef RENDER_SDF\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_gamma_scale_size_fade_opacity.x;float size=v_gamma_scale_size_fade_opacity.y;float fontScale=u_is_text ? size/24.0 : size;out_color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;bool draw_halo=v_draw_halo > 0.0;if (draw_halo) {out_color=halo_color;gamma=(halo_blur*u_scale_factor*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width*u_scale_factor/fontScale)/SDF_PX;}lowp float dist=texture(u_texture,v_tex_a).r;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);out_color*=alpha;\n#else\n#ifdef ICON_TRANSITION\nvec4 a=texture(u_texture,v_tex_a)*(1.0-u_icon_transition);vec4 b=texture(u_texture,v_tex_b)*u_icon_transition;out_color=(a+b);\n#else\nout_color=texture(u_texture,v_tex_a);\n#endif\n#ifdef APPLY_LUT_ON_GPU\nout_color=applyLUT(u_lutTexture,out_color);\n#endif\n#ifdef COLOR_ADJUSTMENT\nout_color=u_color_adj_mat*out_color;\n#endif\n#endif\nout_color*=opacity*fade_opacity;\n#ifdef LIGHTING_3D_MODE\nout_color=apply_lighting_with_emission_ground(out_color,emissive_strength);\n#ifdef RENDER_SHADOWS\nfloat light=shadowed_light_factor(v_pos_light_view_0,v_pos_light_view_1,v_depth);light=mix(light,1.0,cutout_factors.y);\n#ifdef TERRAIN\nout_color.rgb*=mix(u_ground_shadow_factor,vec3(1.0),light);\n#else\nout_color.rgb*=mix(v_z_offset !=0.0 ? u_ground_shadow_factor : vec3(1.0),vec3(1.0),light);\n#endif\n#endif\n#endif\n#ifdef INDICATOR_CUTOUT\nout_color=applyCutout(out_color,v_z_offset);\n#endif\n#ifdef FEATURE_CUTOUT\nout_color=apply_feature_cutout(out_color,gl_FragCoord,cutout_factors.x);\n#endif\nglFragColor=out_color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_terrain.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\n#define USING_APPEARANCE 1.0\nin ivec4 a_pos_offset;in uvec4 a_tex_size;in ivec4 a_pixeloffset;in vec4 a_projected_pos;in uint a_fade_opacity;\n#ifdef Z_OFFSET\nin float a_auto_z_offset;\n#endif\n#ifdef PROJECTION_GLOBE_VIEW\nin ivec4 a_globe_anchor;in vec3 a_globe_normal;\n#endif\n#ifdef ICON_TRANSITION\nin uvec2 a_texb;\n#endif\n#ifdef OCCLUSION_QUERIES\nin float a_occlusion_query_opacity;\n#endif\n#ifdef ELEVATED_ROADS\nin vec3 a_x_axis;in vec3 a_y_axis;uniform float u_normal_scale;\n#endif\n#ifdef INDICATOR_CUTOUT\nout highp float v_z_offset;\n#else\n#ifdef RENDER_SHADOWS\nout highp float v_z_offset;\n#endif\n#endif\nuniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_inv_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_elevation_from_sea;uniform bool u_pitch_with_map;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec3 u_up_vector;uniform vec2 u_texsize_icon;uniform bool u_is_halo;\n#ifdef PROJECTION_GLOBE_VIEW\nuniform vec3 u_tile_id;uniform mat4 u_inv_rot_matrix;uniform vec2 u_merc_center;uniform vec3 u_camera_forward;uniform float u_zoom_transition;uniform vec3 u_ecef_origin;uniform mat4 u_tile_matrix;\n#endif\nout vec2 v_tex_a;\n#ifdef ICON_TRANSITION\nout vec2 v_tex_b;\n#endif\nout float v_draw_halo;out vec3 v_gamma_scale_size_fade_opacity;\n#ifdef RENDER_TEXT_AND_SYMBOL\nout float is_sdf;out vec2 v_tex_a_icon;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out highp float v_depth;\n#endif\n#ifdef USE_PAINT_PROPERTIES_UBO\n#ifndef MAX_UBO_SIZE_VEC4\n#define MAX_UBO_SIZE_VEC4 1024u\n#endif\n#define SPP_HEADER_SIZE_VEC4 3u\n#define DWORDS_PER_VEC4 4u\nstruct SymbolPaintProperties {vec4 fill_np_color;vec4 halo_np_color;float opacity;float halo_width;float halo_blur;float emissive_strength;float occlusion_opacity;float z_offset;vec2 translate;};struct PropertyType {bool isDataDriven;bool isZoomDependent;uint offsetDwords;};struct SymbolPropertyHeader {uint dataDrivenBlockSizeVec4;PropertyType fill_np_color;PropertyType halo_np_color;PropertyType opacity;PropertyType halo_width;PropertyType halo_blur;PropertyType emissive_strength;PropertyType occlusion_opacity;PropertyType z_offset;PropertyType translate;};uniform float u_zoom;uniform lowp vec4 u_spp_fill_np_color;uniform lowp vec4 u_spp_halo_np_color;uniform lowp float u_spp_opacity;uniform lowp float u_spp_halo_width;uniform lowp float u_spp_halo_blur;uniform lowp float u_spp_emissive_strength;uniform lowp float u_spp_occlusion_opacity;uniform lowp float u_spp_z_offset;uniform lowp vec2 u_spp_translate_rotation;in float a_feature_index;layout(std140) uniform SymbolPaintPropertiesHeaderUniform {uvec4 header[SPP_HEADER_SIZE_VEC4];} u_spp_header;layout(std140) uniform SymbolPaintPropertiesUniform {vec4 properties[MAX_UBO_SIZE_VEC4];} u_spp_properties;layout(std140) uniform SymbolPaintPropertiesIndexUniform {uvec4 block_indices[MAX_UBO_SIZE_VEC4];} u_spp_index;out lowp float opacity;\n#ifdef RENDER_SDF\nout lowp vec4 fill_np_color;out lowp vec4 halo_np_color;out lowp float halo_width;out lowp float halo_blur;\n#endif\n#ifdef LIGHTING_3D_MODE\nout lowp float emissive_strength;\n#endif\nPropertyType getPropertyType(uint propertyIndex,uint dataDrivenMask,uint zoomDependentMask,uint offsetDwords) {PropertyType type;type.isDataDriven=(dataDrivenMask & (1u << propertyIndex)) !=0u;type.isZoomDependent=(zoomDependentMask & (1u << propertyIndex)) !=0u;type.offsetDwords=offsetDwords;return type;}SymbolPropertyHeader readSymbolPropertiesHeader() {SymbolPropertyHeader header;uint dataDrivenMask=u_spp_header.header[0][0];uint zoomDependentMask=u_spp_header.header[0][1];header.dataDrivenBlockSizeVec4=u_spp_header.header[0][2];header.fill_np_color       =getPropertyType(0u,dataDrivenMask,zoomDependentMask,u_spp_header.header[0][3]);header.halo_np_color       =getPropertyType(1u,dataDrivenMask,zoomDependentMask,u_spp_header.header[1][0]);header.opacity             =getPropertyType(2u,dataDrivenMask,zoomDependentMask,u_spp_header.header[1][1]);header.halo_width          =getPropertyType(3u,dataDrivenMask,zoomDependentMask,u_spp_header.header[1][2]);header.halo_blur           =getPropertyType(4u,dataDrivenMask,zoomDependentMask,u_spp_header.header[1][3]);header.emissive_strength   =getPropertyType(5u,dataDrivenMask,zoomDependentMask,u_spp_header.header[2][0]);header.occlusion_opacity   =getPropertyType(6u,dataDrivenMask,zoomDependentMask,u_spp_header.header[2][1]);header.z_offset            =getPropertyType(7u,dataDrivenMask,zoomDependentMask,u_spp_header.header[2][2]);header.translate           =getPropertyType(8u,dataDrivenMask,zoomDependentMask,u_spp_header.header[2][3]);return header;}uint uvec4At(uvec4 v,uint index) {return (index==0u) ? v.x :\n(index==1u) ? v.y :\n(index==2u) ? v.z : v.w;}float vec4At(vec4 v,uint index) {return (index==0u) ? v.x :\n(index==1u) ? v.y :\n(index==2u) ? v.z : v.w;}vec4 readVec4(uint baseOffsetVec4,uint propertyOffsetDwords) {return u_spp_properties.properties[baseOffsetVec4+propertyOffsetDwords/DWORDS_PER_VEC4];}float readFloat(vec4 slot,uint propertyOffsetDwords) {return slot[propertyOffsetDwords % DWORDS_PER_VEC4];}uint readUint(uvec4 slot,uint offset) {return slot[offset % DWORDS_PER_VEC4];}vec2 readVec2(vec4 slot,uint propertyOffsetDwords) {float x=vec4At(slot,propertyOffsetDwords % DWORDS_PER_VEC4);float y=vec4At(slot,propertyOffsetDwords % DWORDS_PER_VEC4+1u);return vec2(x,y);}uint getDataDrivenBlockOffsetVec4(uint dataDrivenBlockSizeVec4) {uint featureIndex=uint(a_feature_index);uvec4 slot=u_spp_index.block_indices[featureIndex/DWORDS_PER_VEC4];uint blockIndex=uvec4At(slot,featureIndex % DWORDS_PER_VEC4);return blockIndex*dataDrivenBlockSizeVec4;}vec4 readColorProperty(PropertyType propertyType,uint dataDrivenBlockSizeVec4) {uint blockOffsetVec4=getDataDrivenBlockOffsetVec4(dataDrivenBlockSizeVec4);vec4 color=readVec4(blockOffsetVec4,propertyType.offsetDwords);if (propertyType.isZoomDependent) {color=unpack_mix_color(color,u_zoom);} else {vec2 packedColor=readVec2(color,propertyType.offsetDwords);color=decode_color(packedColor);}return color;}vec2 readVec2Property(PropertyType propertyType,uint dataDrivenBlockSizeVec4) {uint blockOffsetVec4=getDataDrivenBlockOffsetVec4(dataDrivenBlockSizeVec4);vec4 slot=readVec4(blockOffsetVec4,propertyType.offsetDwords);if (propertyType.isZoomDependent) {vec2 minVal=slot.xy;vec2 maxVal=slot.zw;return mix(minVal,maxVal,u_zoom);}return readVec2(slot,propertyType.offsetDwords);}float readFloatProperty(PropertyType propertyType,uint dataDrivenBlockSizeVec4) {uint blockOffsetVec4=getDataDrivenBlockOffsetVec4(dataDrivenBlockSizeVec4);vec4 slot=readVec4(blockOffsetVec4,propertyType.offsetDwords);float value;if (propertyType.isZoomDependent) {vec2 packedValues=readVec2(slot,propertyType.offsetDwords);value=unpack_mix_vec2(packedValues,u_zoom);} else {value=readFloat(slot,propertyType.offsetDwords);}return value;}SymbolPaintProperties readSymbolPaintProperties() {SymbolPropertyHeader header=readSymbolPropertiesHeader();uint sizeVec4=header.dataDrivenBlockSizeVec4;SymbolPaintProperties props;props.fill_np_color       =header.fill_np_color.isDataDriven     ? readColorProperty(header.fill_np_color,sizeVec4)     : u_spp_fill_np_color;props.halo_np_color       =header.halo_np_color.isDataDriven     ? readColorProperty(header.halo_np_color,sizeVec4)     : u_spp_halo_np_color;props.opacity             =header.opacity.isDataDriven           ? readFloatProperty(header.opacity,sizeVec4)           : u_spp_opacity;props.halo_width          =header.halo_width.isDataDriven        ? readFloatProperty(header.halo_width,sizeVec4)        : u_spp_halo_width;props.halo_blur           =header.halo_blur.isDataDriven         ? readFloatProperty(header.halo_blur,sizeVec4)         : u_spp_halo_blur;props.emissive_strength   =header.emissive_strength.isDataDriven ? readFloatProperty(header.emissive_strength,sizeVec4) : u_spp_emissive_strength;props.occlusion_opacity   =header.occlusion_opacity.isDataDriven ? readFloatProperty(header.occlusion_opacity,sizeVec4) : u_spp_occlusion_opacity;props.z_offset            =header.z_offset.isDataDriven          ? readFloatProperty(header.z_offset,sizeVec4)          : u_spp_z_offset;props.translate           =header.translate.isDataDriven          ? readVec2Property(header.translate,sizeVec4)           : vec2(0.0);return props;}\n#else\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\n#pragma mapbox: define lowp float emissive_strength\n#pragma mapbox: define lowp float occlusion_opacity\n#pragma mapbox: define lowp float z_offset\n#endif\nvec2 unpack_opacity(uint packedOpacity) {return vec2(float(packedOpacity/2u)/127.0,float(packedOpacity & 1u));}void main() {\n#ifdef USE_PAINT_PROPERTIES_UBO\nSymbolPaintProperties paint_properties=readSymbolPaintProperties();opacity=paint_properties.opacity;\n#ifdef RENDER_SDF\nfill_np_color=paint_properties.fill_np_color;halo_np_color=paint_properties.halo_np_color;halo_width=paint_properties.halo_width;halo_blur=paint_properties.halo_blur;\n#endif\n#ifdef LIGHTING_3D_MODE\nemissive_strength=paint_properties.emissive_strength;\n#endif\nlowp float occlusion_opacity=paint_properties.occlusion_opacity;lowp float z_offset=paint_properties.z_offset;\n#else\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\n#pragma mapbox: initialize lowp float emissive_strength\n#pragma mapbox: initialize lowp float occlusion_opacity\n#pragma mapbox: initialize lowp float z_offset\n#endif\nvec2 a_pos=vec2(a_pos_offset.xy);vec2 a_offset=vec2(a_pos_offset.zw);vec2 a_tex=vec2(a_tex_size.xy);vec2 a_size=vec2(a_tex_size.zw);float a_size_min=floor(a_size[0]*0.5);float a_size_max= floor(a_size[1]*0.5);float a_apperance=a_size[1]-2.0*a_size_max;vec2 a_pxoffset=vec2(a_pixeloffset.xy);vec2 a_min_font_scale=vec2(a_pixeloffset.zw)/256.0;highp float segment_angle=-a_projected_pos[3];float size;if (a_apperance==USING_APPEARANCE) {size=a_size_max/128.0;} else if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size_max,u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 tile_anchor=a_pos;float e=u_elevation_from_sea ? z_offset : z_offset+elevation(tile_anchor);\n#ifdef Z_OFFSET\ne+=a_auto_z_offset;\n#endif\nvec3 h=elevationVector(tile_anchor)*e;float globe_occlusion_fade;vec3 world_pos;vec3 mercator_pos;vec3 world_pos_globe;\n#ifdef PROJECTION_GLOBE_VIEW\nmercator_pos=mercator_tile_position(u_inv_rot_matrix,tile_anchor,u_tile_id,u_merc_center);world_pos_globe=vec3(a_globe_anchor)+h;world_pos=mix_globe_mercator(world_pos_globe,mercator_pos,u_zoom_transition);vec4 ecef_point=u_tile_matrix*vec4(world_pos,1.0);vec3 origin_to_point=ecef_point.xyz-u_ecef_origin;globe_occlusion_fade=dot(origin_to_point,u_camera_forward) >=0.0 ? 0.0 : 1.0;\n#else\nworld_pos=vec3(tile_anchor,0)+h;globe_occlusion_fade=1.0;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1);highp float camera_to_anchor_distance=projected_point.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(\n0.5+0.5*distance_ratio,0.0,1.5);size*=perspective_ratio;float font_scale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetprojected_point;vec2 a;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 displacement=vec3(a_globe_normal.z,0,-a_globe_normal.x);offsetprojected_point=u_matrix*vec4(vec3(a_globe_anchor)+displacement,1);vec4 projected_point_globe=u_matrix*vec4(world_pos_globe,1);a=projected_point_globe.xy/projected_point_globe.w;\n#else\noffsetprojected_point=u_matrix*vec4(tile_anchor+vec2(1,0),0,1);a=projected_point.xy/projected_point.w;\n#endif\nvec2 b=offsetprojected_point.xy/offsetprojected_point.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}vec4 projected_pos;\n#ifdef PROJECTION_GLOBE_VIEW\n#ifdef PROJECTED_POS_ON_VIEWPORT\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xyz+h,1.0);\n#else\nvec3 proj_pos=mix_globe_mercator(a_projected_pos.xyz,mercator_pos,u_zoom_transition)+h;projected_pos=u_label_plane_matrix*vec4(proj_pos,1.0);    \n#endif\n#else\nprojected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,h.z,1.0);\n#endif\nhighp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);float z=0.0;vec2 offset=rotation_matrix*(a_offset/32.0*max(a_min_font_scale,font_scale)+a_pxoffset/16.0);\n#ifdef TERRAIN\n#ifdef PITCH_WITH_MAP_TERRAIN\nvec4 tile_pos=u_label_plane_matrix_inv*vec4(a_projected_pos.xy+offset,0.0,1.0);z=elevation(tile_pos.xy);\n#endif\n#endif\n#ifdef Z_OFFSET\nz+=u_pitch_with_map ? a_auto_z_offset+z_offset : 0.0;\n#else\nz+=u_pitch_with_map ? z_offset : 0.0;\n#endif\nfloat occlusion_fade=globe_occlusion_fade;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float out_fade_opacity=max(0.0,min(occlusion_fade,fade_opacity[0]+fade_change));\n#ifdef DEPTH_OCCLUSION\nfloat depth_occlusion=occlusionFadeMultiSample(projected_point);float depth_occlusion_multplier=mix(occlusion_opacity,1.0,depth_occlusion);out_fade_opacity*=depth_occlusion_multplier;\n#endif\n#ifdef OCCLUSION_QUERIES\nfloat occludedFadeMultiplier=mix(occlusion_opacity,1.0,a_occlusion_query_opacity);out_fade_opacity*=occludedFadeMultiplier;\n#endif\n#ifdef Z_TEST_OCCLUSION\nout_fade_opacity*=occlusion_opacity;\n#endif\nfloat alpha=opacity*out_fade_opacity;float hidden=float(alpha==0.0 || projected_point.w <=0.0 || occlusion_fade==0.0);vec3 pos;\n#ifdef PROJECTION_GLOBE_VIEW\nvec3 xAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,u_up_vector)) : vec3(1,0,0);vec3 yAxis=u_pitch_with_map ? normalize(cross(a_globe_normal,xAxis)) : vec3(0,1,0);pos=projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y;\n#else\n#ifdef ELEVATED_ROADS\nvec3 xAxis=vec3(a_x_axis.xy,a_x_axis.z*u_normal_scale);vec3 yAxis=vec3(a_y_axis.xy,a_y_axis.z*u_normal_scale);pos=projected_pos.xyz/projected_pos.w+xAxis*offset.x+yAxis*offset.y;\n#else\npos=vec3(projected_pos.xy/projected_pos.w+offset,z);\n#endif\n#endif\ngl_Position=mix(u_coord_matrix*vec4(pos,1.0),AWAY,hidden);\n#ifdef USE_PAINT_PROPERTIES_UBO\n{vec2 tr=paint_properties.translate;vec2 rotated_tr=vec2(\nu_spp_translate_rotation.x*tr.x-u_spp_translate_rotation.y*tr.y,u_spp_translate_rotation.y*tr.x+u_spp_translate_rotation.x*tr.y\n);gl_Position.xy+=(u_coord_matrix*vec4(rotated_tr,0.0,0.0)).xy;}\n#endif\nfloat gamma_scale=gl_Position.w;v_draw_halo=(u_is_halo && float(gl_InstanceID)==0.0) ? 1.0 : 0.0;v_gamma_scale_size_fade_opacity=vec3(gamma_scale,size,out_fade_opacity);v_tex_a=a_tex/u_texsize;\n#ifdef RENDER_TEXT_AND_SYMBOL\nis_sdf=a_size[0]-2.0*a_size_min;v_tex_a_icon=a_tex/u_texsize_icon;\n#endif\n#ifdef ICON_TRANSITION\nv_tex_b=vec2(a_texb)/u_texsize;\n#endif\n#ifdef RENDER_SHADOWS\nvec4 shd_pos=u_inv_matrix*vec4(pos,1.0);vec3 shd_pos0=shd_pos.xyz;vec3 shd_pos1=shd_pos.xyz;\n#ifdef NORMAL_OFFSET\nvec3 shd_pos_offset=shadow_normal_offset(vec3(0.0,0.0,1.0));shd_pos0+=shd_pos_offset*shadow_normal_offset_multiplier0();shd_pos1+=shd_pos_offset*shadow_normal_offset_multiplier1();\n#endif\nv_pos_light_view_0=u_light_matrix_0*vec4(shd_pos0,1);v_pos_light_view_1=u_light_matrix_1*vec4(shd_pos1,1);v_depth=gl_Position.w;\n#endif\n#ifdef INDICATOR_CUTOUT\nv_z_offset=e;\n#else\n#ifdef RENDER_SHADOWS\nv_z_offset=e;\n#endif\n#endif\n}'),
            terrainRaster: or('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nuniform sampler2D u_image1;uniform float u_emissive_texture_available;\n#endif\nin vec2 v_pos0;\n#ifdef FOG\nin float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nin vec4 v_pos_light_view_0;in vec4 v_pos_light_view_1;\n#endif\nuniform vec3 u_ground_shadow_factor;void main() {vec4 image_color=texture(u_image0,v_pos0);vec4 color;\n#ifdef LIGHTING_3D_MODE\nconst vec3 normal=vec3(0.0,0.0,1.0);\n#ifdef RENDER_SHADOWS\nfloat cutoffOpacity=1.0;\n#ifdef RENDER_CUTOFF\ncutoffOpacity=cutoff_opacity(u_cutoff_params,1.0/gl_FragCoord.w);\n#endif\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nfloat emissive_strength=u_emissive_texture_available > 0.5 ? texture(u_image1,v_pos0).r : image_color.a;vec3 unlit_base=image_color.rgb*(1.0-emissive_strength);vec3 emissive_base=image_color.rgb*emissive_strength;float ndotl=u_shadow_direction.z;float occlusion=ndotl < 0.0 ? 1.0 : shadow_occlusion(v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w,0.0);ndotl=max(0.0,ndotl);vec3 lit=apply_lighting(unlit_base,normal,mix(1.0,(1.0-(u_shadow_intensity*occlusion))*ndotl,cutoffOpacity));vec3 emissive=compute_emissive_draped(emissive_base,1.0-u_shadow_intensity,occlusion,u_ground_shadow_factor);color.rgb=lit+emissive;color.a=1.0;\n#else\nfloat lighting_factor=shadowed_light_factor_normal_unbiased(normal,v_pos_light_view_0,v_pos_light_view_1,1.0/gl_FragCoord.w);color=apply_lighting(image_color,normal,mix(1.0,lighting_factor,cutoffOpacity));\n#endif\n#else\nfloat lighting_factor=u_lighting_directional_dir.z;color=apply_lighting(image_color,normal,lighting_factor);\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nfloat emissive_strength=u_emissive_texture_available > 0.5 ? texture(u_image1,v_pos0).r : image_color.a;color.rgb=mix(color.rgb,image_color.rgb,emissive_strength);color.a=1.0;\n#endif\n#endif\n#else\ncolor=image_color;\n#endif\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#else\ncolor=fog_dither(fog_apply_from_vert(color,v_fog_opacity));\n#endif\n#endif\nglFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;uniform float u_skirt_height;in ivec2 a_pos;out vec2 v_pos0;\n#ifdef FOG\nout float v_fog_opacity;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out vec4 v_pos_light_view_0;out vec4 v_pos_light_view_1;\n#endif\nvoid main() {vec3 decomposedPosAndSkirt=decomposeToPosAndSkirt(a_pos);float skirt=decomposedPosAndSkirt.z;vec2 decodedPos=decomposedPosAndSkirt.xy;float elevation=elevation(decodedPos)-skirt*u_skirt_height;v_pos0=decodedPos/8192.0;gl_Position=u_matrix*vec4(decodedPos,elevation,1.0);\n#ifdef FOG\n#ifdef ZERO_EXAGGERATION\nv_fog_pos=fog_position(decodedPos);\n#else\nv_fog_opacity=fog(fog_position(vec3(decodedPos,elevation)));\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec3 pos=vec3(decodedPos,elevation);v_pos_light_view_0=u_light_matrix_0*vec4(pos,1.);v_pos_light_view_1=u_light_matrix_1*vec4(pos,1.);\n#endif\n}'),
            terrainDepth: or("precision highp float;in float v_depth;void main() {glFragColor=pack_depth(v_depth);}", '#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_matrix;in ivec2 a_pos;out float v_depth;void main() {float elevation=elevation(vec2(a_pos));gl_Position=u_matrix*vec4(a_pos,elevation,1.0);v_depth=gl_Position.z/gl_Position.w;}'),
            skybox: or('#include "_prelude_fog.fragment.glsl"\nin lowp vec3 v_uv;uniform lowp samplerCube u_cubemap;uniform lowp float u_opacity;uniform highp float u_temporal_offset;uniform highp vec3 u_sun_direction;float sun_disk(highp vec3 ray_direction,highp vec3 sun_direction) {highp float cos_angle=dot(normalize(ray_direction),sun_direction);const highp float cos_sun_angular_diameter=0.99996192306;const highp float smoothstep_delta=1e-5;return smoothstep(\ncos_sun_angular_diameter-smoothstep_delta,cos_sun_angular_diameter+smoothstep_delta,cos_angle);}float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec3 uv=v_uv;const float y_bias=0.015;uv.y+=y_bias;uv.y=pow(abs(uv.y),1.0/5.0);uv.y=map(uv.y,0.0,1.0,-1.0,1.0);vec3 sky_color=texture(u_cubemap,uv).rgb;\n#ifdef FOG\nsky_color=fog_apply_sky_gradient(v_uv.xzy,sky_color);\n#endif\nsky_color+=0.1*sun_disk(v_uv,u_sun_direction);glFragColor=vec4(sky_color*u_opacity,u_opacity);\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', zo),
            skyboxGradient: or('#include "_prelude_fog.fragment.glsl"\nin highp vec3 v_uv;uniform lowp sampler2D u_color_ramp;uniform highp vec3 u_center_direction;uniform lowp float u_radius;uniform lowp float u_opacity;uniform highp float u_temporal_offset;void main() {float progress=acos(dot(normalize(v_uv),u_center_direction))/u_radius;vec4 color=texture(u_color_ramp,vec2(progress,0.5));\n#ifdef FOG\ncolor.rgb=fog_apply_sky_gradient(v_uv.xzy,color.rgb/color.a)*color.a;\n#endif\ncolor*=u_opacity;glFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\n}', zo),
            skyboxCapture: or("\nin highp vec3 v_position;uniform highp float u_sun_intensity;uniform highp float u_luminance;uniform lowp vec3 u_sun_direction;uniform highp vec4 u_color_tint_r;uniform highp vec4 u_color_tint_m;precision highp float;\n#define BETA_R                  vec3(5.5e-6,13.0e-6,22.4e-6)\n#define BETA_M                  vec3(21e-6,21e-6,21e-6)\n#define MIE_G                   0.76\n#define DENSITY_HEIGHT_SCALE_R  8000.0\n#define DENSITY_HEIGHT_SCALE_M  1200.0\n#define PLANET_RADIUS           6360e3\n#define ATMOSPHERE_RADIUS       6420e3\n#define SAMPLE_STEPS            10\n#define DENSITY_STEPS           4\nfloat ray_sphere_exit(vec3 orig,vec3 dir,float radius) {float a=dot(dir,dir);float b=2.0*dot(dir,orig);float c=dot(orig,orig)-radius*radius;float d=sqrt(b*b-4.0*a*c);return (-b+d)/(2.0*a);}vec3 extinction(vec2 density) {return exp(-vec3(BETA_R*u_color_tint_r.a*density.x+BETA_M*u_color_tint_m.a*density.y));}vec2 local_density(vec3 point) {float height=max(length(point)-PLANET_RADIUS,0.0);float exp_r=exp(-height/DENSITY_HEIGHT_SCALE_R);float exp_m=exp(-height/DENSITY_HEIGHT_SCALE_M);return vec2(exp_r,exp_m);}float phase_ray(float cos_angle) {return (3.0/(16.0*PI))*(1.0+cos_angle*cos_angle);}float phase_mie(float cos_angle) {return (3.0/(8.0*PI))*((1.0-MIE_G*MIE_G)*(1.0+cos_angle*cos_angle))/((2.0+MIE_G*MIE_G)*pow(1.0+MIE_G*MIE_G-2.0*MIE_G*cos_angle,1.5));}vec2 density_to_atmosphere(vec3 point,vec3 light_dir) {float ray_len=ray_sphere_exit(point,light_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(DENSITY_STEPS);vec2 density_point_to_atmosphere=vec2(0.0);for (int i=0; i < DENSITY_STEPS;++i) {vec3 point_on_ray=point+light_dir*((float(i)+0.5)*step_len);density_point_to_atmosphere+=local_density(point_on_ray)*step_len;;}return density_point_to_atmosphere;}vec3 atmosphere(vec3 ray_dir,vec3 sun_direction,float sun_intensity) {vec2 density_orig_to_point=vec2(0.0);vec3 scatter_r=vec3(0.0);vec3 scatter_m=vec3(0.0);vec3 origin=vec3(0.0,PLANET_RADIUS,0.0);float ray_len=ray_sphere_exit(origin,ray_dir,ATMOSPHERE_RADIUS);float step_len=ray_len/float(SAMPLE_STEPS);for (int i=0; i < SAMPLE_STEPS;++i) {vec3 point_on_ray=origin+ray_dir*((float(i)+0.5)*step_len);vec2 density=local_density(point_on_ray)*step_len;density_orig_to_point+=density;vec2 density_point_to_atmosphere=density_to_atmosphere(point_on_ray,sun_direction);vec2 density_orig_to_atmosphere=density_orig_to_point+density_point_to_atmosphere;vec3 extinction=extinction(density_orig_to_atmosphere);scatter_r+=density.x*extinction;scatter_m+=density.y*extinction;}float cos_angle=dot(ray_dir,sun_direction);float phase_r=phase_ray(cos_angle);float phase_m=phase_mie(cos_angle);vec3 beta_r=BETA_R*u_color_tint_r.rgb*u_color_tint_r.a;vec3 beta_m=BETA_M*u_color_tint_m.rgb*u_color_tint_m.a;return (scatter_r*phase_r*beta_r+scatter_m*phase_m*beta_m)*sun_intensity;}const float A=0.15;const float B=0.50;const float C=0.10;const float D=0.20;const float E=0.02;const float F=0.30;vec3 uncharted2_tonemap(vec3 x) {return ((x*(A*x+C*B)+D*E)/(x*(A*x+B)+D*F))-E/F;}void main() {vec3 ray_direction=v_position;ray_direction.y=pow(ray_direction.y,5.0);const float y_bias=0.015;ray_direction.y+=y_bias;vec3 color=atmosphere(normalize(ray_direction),u_sun_direction,u_sun_intensity);float white_scale=1.0748724675633854;color=uncharted2_tonemap((log2(2.0/pow(u_luminance,4.0)))*color)*white_scale;glFragColor=vec4(color,1.0);}", "in highp vec3 a_pos_3f;uniform mat3 u_matrix_3f;out highp vec3 v_position;float map(float value,float start,float end,float new_start,float new_end) {return ((value-start)*(new_end-new_start))/(end-start)+new_start;}void main() {vec4 pos=vec4(u_matrix_3f*a_pos_3f,1.0);v_position=pos.xyz;v_position.y*=-1.0;v_position.y=map(v_position.y,-1.0,1.0,0.0,1.0);gl_Position=vec4(a_pos_3f.xy,0.0,1.0);}"),
            globeRaster: or('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform sampler2D u_image0;\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nuniform sampler2D u_image1;uniform float u_emissive_texture_available;\n#endif\nuniform float u_far_z_cutoff;in vec2 v_pos0;\n#ifndef FOG\nuniform highp vec3 u_frustum_tl;uniform highp vec3 u_frustum_tr;uniform highp vec3 u_frustum_br;uniform highp vec3 u_frustum_bl;uniform highp vec3 u_globe_pos;uniform highp float u_globe_radius;uniform vec2 u_viewport;\n#endif\nvoid main() {vec4 color;\n#ifdef CUSTOM_ANTIALIASING\nhighp vec2 uv=gl_FragCoord.xy/u_viewport;\n#ifdef FLIP_Y\nuv.y=1.0-uv.y;\n#endif\nhighp vec3 ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,uv.x),mix(u_frustum_bl,u_frustum_br,uv.x),1.0-uv.y);highp vec3 dir=normalize(ray_dir);highp vec3 closest_point=dot(u_globe_pos,dir)*dir;highp float norm_dist_from_center=1.0-length(closest_point-u_globe_pos)/u_globe_radius;const float antialias_pixel=2.0;highp float antialias_factor=antialias_pixel*fwidth(norm_dist_from_center);highp float antialias=smoothstep(0.0,antialias_factor,norm_dist_from_center);vec4 raster=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nfloat emissive_strength=u_emissive_texture_available > 0.5 ? texture(u_image1,v_pos0).r : raster.a;raster=apply_lighting_with_emission_ground(raster,emissive_strength);color=vec4(clamp(raster.rgb,vec3(0),vec3(1))*antialias,antialias);\n#else\nraster=apply_lighting_ground(raster);color=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=vec4(raster.rgb*antialias,raster.a*antialias);\n#endif\n#else\ncolor=texture(u_image0,v_pos0);\n#ifdef LIGHTING_3D_MODE\n#ifdef LIGHTING_3D_ALPHA_EMISSIVENESS\nfloat emissive_strength=u_emissive_texture_available > 0.5 ? texture(u_image1,v_pos0).r : color.a;color=apply_lighting_with_emission_ground(color,emissive_strength);color.a=1.0;\n#else\ncolor=apply_lighting_ground(color);\n#endif\n#endif\n#endif\n#ifdef FOG\ncolor=fog_dither(fog_apply_premultiplied(color,v_fog_pos));\n#endif\ncolor*=1.0-step(u_far_z_cutoff,1.0/gl_FragCoord.w);glFragColor=color;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_terrain.vertex.glsl"\nuniform mat4 u_proj_matrix;uniform mat4 u_normalize_matrix;uniform mat4 u_globe_matrix;uniform mat4 u_merc_matrix;uniform float u_zoom_transition;uniform vec2 u_merc_center;uniform mat3 u_grid_matrix;uniform float u_skirt_height;\n#ifdef GLOBE_POLES\nin vec3 a_globe_pos;in vec2 a_uv;\n#else\nin ivec2 a_pos;\n#endif\nout vec2 v_pos0;void main() {\n#ifdef GLOBE_POLES\nvec3 globe_pos=a_globe_pos;vec2 uv=a_uv;\n#else\nfloat tiles=u_grid_matrix[0][2];float idx=u_grid_matrix[1][2];float idy=u_grid_matrix[2][2];vec3 decomposed_pos_and_skirt=decomposeToPosAndSkirt(a_pos);vec3 latLng=u_grid_matrix*vec3(decomposed_pos_and_skirt.xy,1.0);float mercatorY=mercatorYfromLat(latLng[0]);float uvY=mercatorY*tiles-idy;float mercatorX=mercatorXfromLng(latLng[1]);float uvX=mercatorX*tiles-idx;vec3 globe_pos=latLngToECEF(latLng.xy);vec2 merc_pos=vec2(mercatorX,mercatorY);vec2 uv=vec2(uvX,uvY);\n#endif\nv_pos0=uv;vec2 tile_pos=uv*EXTENT;vec3 globe_derived_up_vector=normalize(globe_pos)*u_tile_up_scale;\n#ifdef GLOBE_POLES\nvec3 up_vector=globe_derived_up_vector;\n#else\nvec3 up_vector=elevationVector(tile_pos);\n#endif\nfloat height=elevation(tile_pos);globe_pos+=up_vector*height;\n#ifndef GLOBE_POLES\nglobe_pos-=globe_derived_up_vector*u_skirt_height*decomposed_pos_and_skirt.z;\n#endif\n#ifdef GLOBE_POLES\nvec4 interpolated_pos=u_globe_matrix*vec4(globe_pos,1.0);\n#else\nvec4 globe_world_pos=u_globe_matrix*vec4(globe_pos,1.0);vec4 merc_world_pos=vec4(0.0);if (u_zoom_transition > 0.0) {merc_world_pos=vec4(merc_pos,height-u_skirt_height*decomposed_pos_and_skirt.z,1.0);merc_world_pos.xy-=u_merc_center;merc_world_pos.x=wrap(merc_world_pos.x,-0.5,0.5);merc_world_pos=u_merc_matrix*merc_world_pos;}vec4 interpolated_pos=vec4(mix(globe_world_pos.xyz,merc_world_pos.xyz,u_zoom_transition),1.0);\n#endif\ngl_Position=u_proj_matrix*interpolated_pos;\n#ifdef FOG\nv_fog_pos=fog_position((u_normalize_matrix*vec4(globe_pos,1.0)).xyz);\n#endif\n}'),
            globeAtmosphere: or('#include "_prelude_fog.fragment.glsl"\nuniform float u_transition;uniform highp float u_fadeout_range;uniform highp float u_temporal_offset;uniform vec4 u_atmosphere_fog_color;uniform vec4 u_high_color;uniform vec4 u_space_color;uniform float u_horizon_angle;in highp vec3 v_ray_dir;in highp vec3 v_horizon_dir;void main() {highp vec3 dir=normalize(v_ray_dir);float globe_pos_dot_dir;\n#ifdef PROJECTION_GLOBE_VIEW\nglobe_pos_dot_dir=dot(u_globe_pos,dir);highp vec3 closest_point_forward=abs(globe_pos_dot_dir)*dir;float norm_dist_from_center=length(closest_point_forward-u_globe_pos)/u_globe_radius;if (norm_dist_from_center < 0.98) {\n#ifdef ALPHA_PASS\nglFragColor=vec4(0,0,0,0);return;\n#else\n#ifdef NATIVE\nglFragColor=vec4(1,1,1,1);\n#else\nglFragColor=vec4(0,0,0,1);\n#endif\nreturn;\n#endif\n}\n#endif\nhighp vec3 horizon_dir=normalize(v_horizon_dir);float horizon_angle_mercator=dir.y < horizon_dir.y ?\n0.0 : max(acos(clamp(dot(dir,horizon_dir),-1.0,1.0)),0.0);float horizon_angle;\n#ifdef PROJECTION_GLOBE_VIEW\nhighp vec3 closest_point=globe_pos_dot_dir*dir;highp float closest_point_to_center=length(closest_point-u_globe_pos);highp float theta=asin(clamp(closest_point_to_center/length(u_globe_pos),-1.0,1.0));horizon_angle=globe_pos_dot_dir < 0.0 ?\nPI-theta-u_horizon_angle : theta-u_horizon_angle;float angle_t=pow(u_transition,10.0);horizon_angle=mix(horizon_angle,horizon_angle_mercator,angle_t);\n#else\nhorizon_angle=horizon_angle_mercator;\n#endif\nhorizon_angle/=PI;float t=exp(-horizon_angle/u_fadeout_range);float alpha_0=u_atmosphere_fog_color.a;float alpha_1=u_high_color.a;float alpha_2=u_space_color.a;vec3 color_stop_0=u_atmosphere_fog_color.rgb;vec3 color_stop_1=u_high_color.rgb;vec3 color_stop_2=u_space_color.rgb;\n#ifdef ALPHA_PASS\nfloat a0=mix(alpha_2,1.0,alpha_1);float a1=mix(a0,1.0,alpha_0);float a2=mix(a0,a1,t);float a =mix(alpha_2,a2,t);glFragColor=vec4(1.0,1.0,1.0,a);\n#else\nvec3 c0=mix(color_stop_2,color_stop_1,alpha_1);vec3 c1=mix(c0,color_stop_0,alpha_0);vec3 c2=mix(c0,c1,t);vec3 c=c2;glFragColor=vec4(c*t,t);\n#endif\n}', "in vec3 a_pos;in vec2 a_uv;uniform vec3 u_frustum_tl;uniform vec3 u_frustum_tr;uniform vec3 u_frustum_br;uniform vec3 u_frustum_bl;uniform float u_horizon;out highp vec3 v_ray_dir;out highp vec3 v_horizon_dir;void main() {v_ray_dir=mix(\nmix(u_frustum_tl,u_frustum_tr,a_uv.x),mix(u_frustum_bl,u_frustum_br,a_uv.x),a_uv.y);v_horizon_dir=mix(\nmix(u_frustum_tl,u_frustum_bl,u_horizon),mix(u_frustum_tr,u_frustum_br,u_horizon),a_uv.x);gl_Position=vec4(a_pos,1.0);}"),
            model: or('#include "_prelude_fog.fragment.glsl"\n#include "_prelude_shadow.fragment.glsl"\n#include "_prelude_lighting.glsl"\nuniform float u_opacity;\n#ifdef DITHERED_DISCARD\nuniform float u_dithered_discard_threshold;\n#endif\nuniform vec3 u_lightcolor;uniform vec3 u_lightpos;uniform float u_lightintensity;uniform vec4 u_baseColorFactor;uniform vec4 u_emissiveFactor;uniform float u_metallicFactor;uniform float u_roughnessFactor;uniform float u_emissive_strength;in highp vec4 v_position_height;in lowp vec4 v_color_mix;\n#ifdef RENDER_SHADOWS\nin highp vec4 v_pos_light_view_0;in highp vec4 v_pos_light_view_1;in float v_depth_shadows;\n#endif\n#ifdef OCCLUSION_TEXTURE_TRANSFORM\nuniform vec4 u_occlusionTextureTransform;\n#endif\n#pragma mapbox: define-attribute highp vec3 normal_3f\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec3 normal_3f\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#ifdef HAS_ATTRIBUTE_a_pbr\nin lowp vec4 v_roughness_metallic_emissive_alpha;in mediump vec4 v_height_based_emission_params;\n#endif\n#ifdef HAS_TEXTURE_u_baseColorTexture\nuniform sampler2D u_baseColorTexture;uniform bool u_baseTextureIsAlpha;uniform bool u_alphaMask;uniform float u_alphaCutoff;\n#endif\n#ifdef HAS_TEXTURE_u_metallicRoughnessTexture\nuniform sampler2D u_metallicRoughnessTexture;\n#endif\n#ifdef HAS_TEXTURE_u_occlusionTexture\nuniform sampler2D u_occlusionTexture;uniform float u_aoIntensity;\n#endif\n#ifdef HAS_TEXTURE_u_normalTexture\nuniform sampler2D u_normalTexture;\n#endif\n#ifdef HAS_TEXTURE_u_emissionTexture\nuniform sampler2D u_emissionTexture;\n#endif\n#ifdef APPLY_LUT_ON_GPU\nuniform highp sampler3D u_lutTexture;\n#endif\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nin highp float v_depth;uniform highp sampler2D u_depthTexture;uniform highp vec2 u_inv_depth_size;uniform highp vec2 u_depth_range_unpack;\n#ifdef DEPTH_D24\nhighp float unpack_depth(highp float depth) {return  depth*u_depth_range_unpack.x+u_depth_range_unpack.y;}\n#else\nhighp float unpack_depth_rgba(highp vec4 rgba_depth)\n{const highp vec4 bit_shift=vec4(1.0/(255.0*255.0*255.0),1.0/(255.0*255.0),1.0/255.0,1.0);return dot(rgba_depth,bit_shift)*2.0-1.0;}\n#endif\nbool isOccluded() {highp vec2 coord=gl_FragCoord.xy*u_inv_depth_size;\n#ifdef FLIP_Y\ncoord.y=1.0-coord.y;\n#endif\n#ifdef DEPTH_D24\nhighp float depth=unpack_depth(texture(u_depthTexture,coord).r);\n#else\nhighp float depth=unpack_depth_rgba(texture(u_depthTexture,coord));\n#endif\nreturn v_depth > depth+0.0005;}\n#endif\n#define saturate(_x) clamp(_x,0.,1.)\nvec3 linearTosRGB(vec3 color) {return pow(color,vec3(1./2.2));}vec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}float calculate_NdotL(vec3 normal,vec3 lightDir) {const float ext=0.70710678118;return (clamp(dot(normal,lightDir),-ext,1.0)+ext)/(1.0+ext);}vec3 getDiffuseShadedColor(vec3 albedo,vec3 normal,vec3 lightDir,vec3 lightColor)\n{\n#ifdef LIGHTING_3D_MODE\nvec3 transformed_normal=vec3(-normal.xy,normal.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=saturate(dot(transformed_normal,u_lighting_directional_dir));\n#endif\nreturn apply_lighting(albedo,transformed_normal,lighting_factor);\n#else\nvec3 n=normal;float colorvalue=((albedo.x*0.2126)+(albedo.y*0.7152))+(albedo.z*0.0722);vec3 c=vec3(0.03,0.03,0.03);float directional=clamp(dot(n,vec3(lightDir)),0.0,1.0);directional=mix(1.0-u_lightintensity,max((1.0-colorvalue)+u_lightintensity,1.0),directional);vec3 c3=c+clamp((albedo*directional)*lightColor,mix(vec3(0.0),vec3(0.3),vec3(1.0)-lightColor),vec3(1.0));return c3;\n#endif\n}vec4 getBaseColor() {vec4 albedo=u_baseColorFactor;\n#ifdef HAS_ATTRIBUTE_a_color_3f\nalbedo*=vec4(color_3f,1.0);\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\n#else\n#ifdef HAS_ATTRIBUTE_a_color_4f\nalbedo*=color_4f;\n#endif\n#endif\n#if defined (HAS_TEXTURE_u_baseColorTexture) && defined (HAS_ATTRIBUTE_a_uv_2f)\nvec4 texColor=texture(u_baseColorTexture,uv_2f);if(u_alphaMask) {if (texColor.w < u_alphaCutoff) {discard;}}\n#ifdef UNPREMULT_TEXTURE_IN_SHADER\nif(texColor.w > 0.0) {texColor.rgb/=texColor.w;}texColor.w=1.0;\n#endif\nif(u_baseTextureIsAlpha) {if (texColor.r < 0.5) {discard;}} else {texColor.rgb=sRGBToLinear(texColor.rgb);albedo*=texColor;}\n#endif\nvec4 color=vec4(mix(albedo.rgb,v_color_mix.rgb,v_color_mix.a),albedo.a);\n#ifdef APPLY_LUT_ON_GPU\ncolor=applyLUT(u_lutTexture,color);\n#endif\nreturn color;}highp mat3 cotangentFrame(highp vec3 N,highp vec3 p,highp vec2 uv ) {\n#ifdef HAS_TEXTURE_u_normalTexture\nhighp vec3 dp1=vec3(dFdx(p.x),dFdx(p.y),dFdx(p.z));highp vec3 dp2=vec3(dFdy(p.x),dFdy(p.y),dFdy(p.z));highp vec2 duv1=vec2(dFdx(uv.x),dFdx(uv.y));highp vec2 duv2=vec2(dFdy(uv.x),dFdy(uv.y));highp vec3 dp2perp=cross( dp2,N );highp vec3 dp1perp=cross( N,dp1 );highp vec3 T=dp2perp*duv1.x+dp1perp*duv2.x;highp vec3 B=dp2perp*duv1.y+dp1perp*duv2.y;\n#ifdef FLIP_Y\nT=-T;B=-B;\n#endif\nhighp float lengthT=dot(T,T);highp float lengthB=dot(B,B);highp float maxLength=max(lengthT,lengthB);highp float invmax=inversesqrt( maxLength );highp mat3 res=mat3( T*invmax,B*invmax,N );return res;\n#else\nreturn mat3(1.0);\n#endif\n}highp vec3 getNormal(){highp vec3 n;\n#ifdef HAS_ATTRIBUTE_a_normal_3f\nn=normalize(normal_3f);\n#else\nhighp vec3 fdx=vec3(dFdx(v_position_height.x),dFdx(v_position_height.y),dFdx(v_position_height.z));highp vec3 fdy=vec3(dFdy(v_position_height.x),dFdy(v_position_height.y),dFdy(v_position_height.z));\n#ifdef FLIP_Y\nn=normalize(cross(fdx,fdy));\n#else\nn=normalize(cross(fdx,fdy))*-1.0;\n#endif\n#endif\n#if defined(HAS_TEXTURE_u_normalTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nvec3 nMap=texture( u_normalTexture,uv_2f).xyz;nMap=normalize(2.0*nMap-vec3(1.0));highp vec3 v=normalize(-v_position_height.xyz);highp mat3 TBN=cotangentFrame(n,v,uv_2f);n=normalize(TBN*nMap);\n#endif\nreturn n;}struct Material {float perceptualRoughness;float alphaRoughness;float metallic;vec3 f90;vec4 baseColor;vec3 diffuseColor;vec3 specularColor;highp vec3 normal;};Material getPBRMaterial() {Material mat;mat.baseColor=getBaseColor();mat.perceptualRoughness=u_roughnessFactor;mat.metallic=u_metallicFactor;\n#ifdef HAS_ATTRIBUTE_a_pbr\nmat.perceptualRoughness=v_roughness_metallic_emissive_alpha.x;mat.metallic=v_roughness_metallic_emissive_alpha.y;mat.baseColor.w*=v_roughness_metallic_emissive_alpha.w;\n#endif\n#if defined(HAS_TEXTURE_u_metallicRoughnessTexture) && defined(HAS_ATTRIBUTE_a_uv_2f) \nvec4 mrSample=texture(u_metallicRoughnessTexture,uv_2f);mat.perceptualRoughness*=mrSample.g;mat.metallic*=mrSample.b;\n#endif\nconst float c_minRoughness=0.04;mat.perceptualRoughness=clamp(mat.perceptualRoughness,c_minRoughness,1.0);mat.metallic=saturate(mat.metallic);mat.alphaRoughness=mat.perceptualRoughness*mat.perceptualRoughness;const vec3 f0=vec3(0.04);mat.diffuseColor=mat.baseColor.rgb*(vec3(1.0)-f0);mat.diffuseColor*=1.0-mat.metallic;mat.specularColor=mix(f0,mat.baseColor.rgb,mat.metallic);highp float reflectance=max(max(mat.specularColor.r,mat.specularColor.g),mat.specularColor.b);highp float reflectance90=saturate(reflectance*25.0);mat.f90=vec3(reflectance90);mat.normal=getNormal();return mat;}float V_GGX(float NdotL,float NdotV,float roughness)\n{float a2=roughness*roughness;float GGXV=NdotL*sqrt(NdotV*NdotV*(1.0-a2)+a2);float GGXL=NdotV*sqrt(NdotL*NdotL*(1.0-a2)+a2);return 0.5/(GGXV+GGXL);}float V_GGXFast(float NdotL,float NdotV,float roughness) {float a=roughness;float GGXV=NdotL*(NdotV*(1.0-a)+a);float GGXL=NdotV*(NdotL*(1.0-a)+a);return 0.5/(GGXV+GGXL);}vec3 F_Schlick(vec3 specularColor,vec3 f90,float VdotH)\n{return specularColor+(f90-specularColor)*pow(clamp(1.0-VdotH,0.0,1.0),5.0);}vec3 F_SchlickFast(vec3 specularColor,float VdotH)\n{float x=1.0-VdotH;float x4=x*x*x*x;return specularColor+(1.0-specularColor)*x4*x;}float D_GGX(highp float NdotH,float alphaRoughness)\n{highp float a4=alphaRoughness*alphaRoughness;highp float f=(NdotH*a4-NdotH)*NdotH+1.0;return a4/(PI*f*f);}vec3 diffuseBurley(Material mat,float LdotH,float NdotL,float NdotV)\n{float f90=2.0*LdotH*LdotH*mat.alphaRoughness-0.5;return (mat.diffuseColor/PI)*(1.0+f90*pow((1.0-NdotL),5.0))*(1.0+f90*pow((1.0-NdotV),5.0));}vec3 diffuseLambertian(Material mat)\n{\n#ifdef LIGHTING_3D_MODE\nreturn mat.diffuseColor;\n#else\nreturn mat.diffuseColor/PI;\n#endif\n}vec3 EnvBRDFApprox(vec3 specularColor,float roughness,highp float NdotV)\n{vec4 c0=vec4(-1,-0.0275,-0.572,0.022);vec4 c1=vec4(1,0.0425,1.04,-0.04);highp vec4 r=roughness*c0+c1;highp float a004=min(r.x*r.x,exp2(-9.28*NdotV))*r.x+r.y;vec2 AB=vec2(-1.04,1.04)*a004+r.zw;return specularColor*AB.x+AB.y;}vec3 computeIndirectLightContribution(Material mat,float NdotV,vec3 normal)\n{vec3 env_light=vec3(0.65,0.65,0.65);\n#ifdef LIGHTING_3D_MODE\nfloat ambient_factor=calculate_ambient_directional_factor(normal);env_light=u_lighting_ambient_color*ambient_factor;\n#endif\nvec3 envBRDF=EnvBRDFApprox(mat.specularColor,mat.perceptualRoughness,NdotV);vec3 indirectSpecular= envBRDF*env_light;vec3 indirectDiffuse=mat.diffuseColor*env_light;return indirectSpecular+indirectDiffuse;}vec3 computeLightContribution(Material mat,vec3 lightPosition,vec3 lightColor)\n{highp vec3 n=mat.normal;highp vec3 v=normalize(-v_position_height.xyz);highp vec3 l=normalize(lightPosition);highp vec3 h=normalize(v+l);float NdotV=clamp(abs(dot(n,v)),0.001,1.0);float NdotL=saturate(dot(n,l));highp float NdotH=saturate(dot(n,h));float VdotH=saturate(dot(v,h));vec3 f=F_SchlickFast(mat.specularColor,VdotH);float g=V_GGXFast(NdotL,NdotV,mat.alphaRoughness);float d=D_GGX(NdotH,mat.alphaRoughness);vec3 diffuseTerm=(1.0-f)*diffuseLambertian(mat);vec3 specularTerm=f*g*d;vec3 transformed_normal=vec3(-n.xy,n.z);float lighting_factor;\n#ifdef RENDER_SHADOWS\nlighting_factor=shadowed_light_factor_normal(transformed_normal,v_pos_light_view_0,v_pos_light_view_1,v_depth_shadows);\n#else\nlighting_factor=NdotL;\n#endif\nvec3 directLightColor=(specularTerm+diffuseTerm)*lighting_factor*lightColor;vec3 indirectLightColor=computeIndirectLightContribution(mat,NdotV,transformed_normal);vec3 color=(saturate(directLightColor)+indirectLightColor);float intensityFactor=1.0;\n#if !defined(LIGHTING_3D_MODE)\nconst vec3 luminosityFactor=vec3(0.2126,0.7152,0.0722);float luminance=dot(diffuseTerm,luminosityFactor);intensityFactor=mix((1.0-u_lightintensity),max((1.0-luminance+u_lightintensity),1.0),NdotL);\n#endif\ncolor*=intensityFactor;return color;}void main() {\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nif (isOccluded()) {discard;}\n#endif\nvec3 lightDir=u_lightpos;vec3 lightColor=u_lightcolor;\n#ifdef LIGHTING_3D_MODE\nlightDir=u_lighting_directional_dir;lightDir.xy=-lightDir.xy;lightColor=u_lighting_directional_color;\n#endif\nvec4 finalColor;\n#ifdef DIFFUSE_SHADED\nvec3 N=getNormal();vec3 baseColor=getBaseColor().rgb;vec3 diffuse=getDiffuseShadedColor(baseColor,N,lightDir,lightColor);\n#ifdef HAS_TEXTURE_u_occlusionTexture\nfloat ao=(texture(u_occlusionTexture,uv_2f).r-1.0)*u_aoIntensity+1.0;diffuse*=ao;\n#endif\nfinalColor=vec4(mix(diffuse,baseColor,u_emissive_strength),1.0)*u_opacity;\n#else\nMaterial mat=getPBRMaterial();vec3 color=computeLightContribution(mat,lightDir,lightColor);float ao=1.0;\n#if defined (HAS_TEXTURE_u_occlusionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\n#ifdef OCCLUSION_TEXTURE_TRANSFORM\nvec2 uv=uv_2f.xy*u_occlusionTextureTransform.zw+u_occlusionTextureTransform.xy;\n#else\nvec2 uv=uv_2f;\n#endif\nao=(texture(u_occlusionTexture,uv).x-1.0)*u_aoIntensity+1.0;color*=ao;\n#endif\nvec4 emissive=u_emissiveFactor;\n#if defined(HAS_TEXTURE_u_emissionTexture) && defined(HAS_ATTRIBUTE_a_uv_2f)\nemissive.rgb*=sRGBToLinear(texture(u_emissionTexture,uv_2f).rgb);\n#endif\n#ifdef APPLY_LUT_ON_GPU\nfloat emissiveFactorLength=max(length(u_emissiveFactor.rgb),0.001);emissive.rgb=sRGBToLinear(applyLUT(u_lutTexture,linearTosRGB(emissive.rgb/emissiveFactorLength).rbg))*emissiveFactorLength;\n#endif\ncolor+=emissive.rgb;float opacity=mat.baseColor.w*u_opacity;\n#ifdef HAS_ATTRIBUTE_a_pbr\nfloat resEmission=v_roughness_metallic_emissive_alpha.z;resEmission*=v_height_based_emission_params.z+v_height_based_emission_params.w*pow(clamp(v_height_based_emission_params.x,0.0,1.0),v_height_based_emission_params.y);vec3 color_mix=v_color_mix.rgb;\n#ifdef APPLY_LUT_ON_GPU\ncolor_mix=applyLUT(u_lutTexture,color_mix);\n#endif\ncolor=mix(color,color_mix,min(1.0,resEmission));\n#ifdef HAS_ATTRIBUTE_a_color_4f\nfloat distance=length(vec2(1.3*max(0.0,abs(color_4f.x)-color_4f.z),color_4f.y));distance+= mix(0.5,0.0,clamp(resEmission-1.0,0.0,1.0));opacity*=v_roughness_metallic_emissive_alpha.w*saturate(1.0-distance*distance);\n#endif\n#endif\nvec3 unlitColor=mat.baseColor.rgb*ao+emissive.rgb;color=mix(color,unlitColor,u_emissive_strength);color=linearTosRGB(color);color*=opacity;finalColor=vec4(color,opacity);\n#endif\n#ifdef DITHERED_DISCARD\nif (abs(u_dithered_discard_threshold) < 1.0) {float ditherValue=fract(52.9829189*fract(0.06711056*gl_FragCoord.x+0.00583715*gl_FragCoord.y));float compareValue=mix(1.0-ditherValue,ditherValue,step(0.0,u_dithered_discard_threshold));if (abs(u_dithered_discard_threshold) < compareValue) {discard;}}\n#endif\n#ifdef FOG\nfinalColor=fog_dither(fog_apply_premultiplied(finalColor,v_fog_pos,v_position_height.w));\n#endif\n#ifdef RENDER_CUTOFF\nfinalColor*=v_cutoff_opacity;\n#endif\n#ifdef INDICATOR_CUTOUT\nfinalColor=applyCutout(finalColor,v_position_height.w);\n#endif\n#ifdef FEATURE_CUTOUT\nfinalColor=apply_feature_cutout(finalColor,gl_FragCoord,get_cutout_factors(gl_FragCoord).x);\n#endif\nglFragColor=finalColor;\n#ifdef OVERDRAW_INSPECTOR\nglFragColor=vec4(1.0);\n#endif\nHANDLE_WIREFRAME_DEBUG;}', '#include "_prelude_fog.vertex.glsl"\n#include "_prelude_shadow.vertex.glsl"\nin vec3 a_pos_3f;\n#pragma mapbox: define-attribute highp vec3 normal_3f\n#pragma mapbox: define-attribute highp vec2 uv_2f\n#pragma mapbox: define-attribute highp vec3 color_3f\n#pragma mapbox: define-attribute highp vec4 color_4f\n#pragma mapbox: define-attribute-vertex-shader-only highp uvec4 pbr\n#pragma mapbox: define-attribute-vertex-shader-only highp vec3 heightBasedEmissiveStrength\nuniform mat4 u_matrix;uniform mat4 u_node_matrix;uniform mat4 u_lighting_matrix;uniform vec3 u_camera_pos;uniform vec4 u_color_mix;\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_normal_matrix;\n#endif\n#ifdef RENDER_SHADOWS\nuniform mat4 u_light_matrix_0;uniform mat4 u_light_matrix_1;out highp vec4 v_pos_light_view_0;out highp vec4 v_pos_light_view_1;out float v_depth_shadows;\n#endif\nout vec4 v_position_height;out lowp vec4 v_color_mix;\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nout highp float v_depth;\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\nout lowp vec4 v_roughness_metallic_emissive_alpha;out mediump vec4 v_height_based_emission_params;\n#endif\nvec3 sRGBToLinear(vec3 srgbIn) {return pow(srgbIn,vec3(2.2));}void main() {\n#pragma mapbox: initialize-attribute highp vec3 normal_3f\n#pragma mapbox: initialize-attribute highp vec2 uv_2f\n#pragma mapbox: initialize-attribute highp vec3 color_3f\n#pragma mapbox: initialize-attribute highp vec4 color_4f\n#pragma mapbox: initialize-attribute-custom highp uvec4 pbr\n#pragma mapbox: initialize-attribute-custom highp vec3 heightBasedEmissiveStrength\nhighp mat4 normal_matrix;\n#ifdef INSTANCED_ARRAYS\nnormal_matrix=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\nnormal_matrix=u_normal_matrix;\n#endif\nvec3 local_pos;mat3 rs;\n#ifdef MODEL_POSITION_ON_GPU\nvec3 pos_color=normal_matrix[0].xyz;vec4 translate=normal_matrix[1];vec3 pos_a=floor(pos_color);vec3 rgb=1.05*(pos_color-pos_a);float hidden=float(pos_a.x > EXTENT);float color_mix=pos_a.z/100.0;v_color_mix=vec4(sRGBToLinear(rgb),color_mix);float meter_to_tile=normal_matrix[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);rs[0].x=normal_matrix[1].w;rs[0].yz=normal_matrix[2].xy;rs[1].xy=normal_matrix[2].zw;rs[1].z=normal_matrix[3].x;rs[2].xyz=normal_matrix[3].yzw;vec4 pos_node=u_lighting_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;local_pos=pos.xyz;gl_Position=mix(u_matrix*pos,AWAY,hidden);pos.z*=meter_to_tile;v_position_height.xyz=pos.xyz-u_camera_pos;\n#else\nlocal_pos=a_pos_3f;gl_Position=u_matrix*vec4(a_pos_3f,1);v_position_height.xyz=vec3(u_lighting_matrix*vec4(a_pos_3f,1));v_color_mix=vec4(sRGBToLinear(u_color_mix.rgb),u_color_mix.a);\n#endif\nv_position_height.w=a_pos_3f.z;\n#ifdef HAS_ATTRIBUTE_a_pbr\nvec4 albedo_c=decode_color(vec2(pbr.xy));vec2 e_r_m=unpack_float(float(pbr.z));vec2 r_m= unpack_float(e_r_m.y*16.0);r_m.r=r_m.r*16.0;v_color_mix=vec4(albedo_c.rgb,1.0);v_roughness_metallic_emissive_alpha=vec4(vec3(r_m,e_r_m.x)/255.0,albedo_c.a);v_roughness_metallic_emissive_alpha.z*=2.0;float heightBasedRelativeIntepolation=a_pos_3f.z*heightBasedEmissiveStrength.x+heightBasedEmissiveStrength.y;v_height_based_emission_params.x=heightBasedRelativeIntepolation;v_height_based_emission_params.y=heightBasedEmissiveStrength.z;vec2 emissionMultiplierValues=unpack_float(float(pbr.w))/256.0;v_height_based_emission_params.z=emissionMultiplierValues.x;v_height_based_emission_params.w=emissionMultiplierValues.y-emissionMultiplierValues.x;\n#endif\n#ifdef FOG\nv_fog_pos=fog_position(local_pos);\n#endif\n#ifdef RENDER_CUTOFF\nv_cutoff_opacity=cutoff_opacity(u_cutoff_params,gl_Position.z);\n#endif\n#ifdef TERRAIN_FRAGMENT_OCCLUSION\nv_depth=gl_Position.z/gl_Position.w;\n#ifdef CLIP_ZERO_TO_ONE\nv_depth=-1.0+2.0*v_depth; \n#endif\n#endif\n#ifdef HAS_ATTRIBUTE_a_normal_3f\n#ifdef MODEL_POSITION_ON_GPU\nfloat x_squared_scale=dot(rs[0],rs[0]);float y_squared_scale=dot(rs[1],rs[1]);float z_squared_scale=dot(rs[2],rs[2]);vec3 squared_scale=vec3(x_squared_scale,y_squared_scale,z_squared_scale);normal_3f=rs*((u_lighting_matrix*vec4(normal_3f,0.0)).xyz/squared_scale);normal_3f=normalize(normal_3f);\n#else\nnormal_3f=vec3(normal_matrix*vec4(normal_3f,0));\n#endif\n#endif\n#ifdef HAS_ATTRIBUTE_a_pbr\n#ifdef HAS_ATTRIBUTE_a_color_4f\nv_roughness_metallic_emissive_alpha.w=clamp(color_4f.a*v_roughness_metallic_emissive_alpha.w*(v_roughness_metallic_emissive_alpha.z-1.0),0.0,1.0);\n#endif\n#endif\n#ifdef RENDER_SHADOWS\nvec4 shadow_pos=u_node_matrix*vec4(local_pos,1.0);\n#ifdef NORMAL_OFFSET\n#ifdef HAS_ATTRIBUTE_a_normal_3f\n#ifdef MODEL_POSITION_ON_GPU\nvec3 offset=shadow_normal_offset(vec3(-normal_3f.xy,normal_3f.z));shadow_pos.xyz+=offset*shadow_normal_offset_multiplier0();\n#else\nvec3 offset=shadow_normal_offset_model(normal_3f);shadow_pos.xyz+=offset*shadow_normal_offset_multiplier0();\n#endif\n#endif\n#endif\nv_pos_light_view_0=u_light_matrix_0*shadow_pos;v_pos_light_view_1=u_light_matrix_1*shadow_pos;v_depth_shadows=gl_Position.w;\n#endif\n}'),
            modelDepth: or("void main() {}", "in vec3 a_pos_3f;uniform mat4 u_matrix;\n#ifdef MODEL_POSITION_ON_GPU\n#ifdef INSTANCED_ARRAYS\nin vec4 a_normal_matrix0;in vec4 a_normal_matrix1;in vec4 a_normal_matrix2;in vec4 a_normal_matrix3;\n#else\nuniform highp mat4 u_instance;\n#endif\nuniform highp mat4 u_node_matrix;\n#endif\nvoid main() {\n#ifdef MODEL_POSITION_ON_GPU\nhighp mat4 instance;\n#ifdef INSTANCED_ARRAYS\ninstance=mat4(a_normal_matrix0,a_normal_matrix1,a_normal_matrix2,a_normal_matrix3);\n#else\ninstance=u_instance;\n#endif\nvec3 pos_color=instance[0].xyz;vec4 translate=instance[1];vec3 pos_a=floor(pos_color);float hidden=float(pos_a.x > EXTENT);float meter_to_tile=instance[0].w;vec4 pos=vec4(pos_a.xy,translate.z,1.0);mat3 rs;rs[0].x=instance[1].w;rs[0].yz=instance[2].xy;rs[1].xy=instance[2].zw;rs[1].z=instance[3].x;rs[2].xyz=instance[3].yzw;vec4 pos_node=u_node_matrix*vec4(a_pos_3f,1.0);vec3 rotated_pos_node=rs*pos_node.xyz;vec3 pos_model_tile=(rotated_pos_node+vec3(translate.xy,0.0))*vec3(meter_to_tile,meter_to_tile,1.0);pos.xyz+=pos_model_tile;gl_Position=mix(u_matrix*pos,AWAY,hidden);\n#else\ngl_Position=u_matrix*vec4(a_pos_3f,1);\n#endif\n}"),
            stars: or("in highp vec2 v_uv;in mediump float v_intensity;float shapeCircle(in vec2 uv)\n{float beginFade=0.6;float lengthFromCenter=length(v_uv);return 1.0-clamp((lengthFromCenter-beginFade)/(1.0-beginFade),0.0,1.0);}void main() {float alpha=shapeCircle(v_uv);vec3 color=vec3(1.0,1.0,1.0);alpha*=v_intensity;glFragColor=vec4(color*alpha,alpha);HANDLE_WIREFRAME_DEBUG;}", "\nin vec3 a_pos_3f;in vec2 a_uv;in float a_size_scale;in float a_opacity;uniform mat4 u_matrix;uniform vec3 u_up;uniform vec3 u_right;uniform float u_intensity_multiplier;out highp vec2 v_uv;out mediump float v_intensity;void main() {v_uv=a_uv;v_intensity=a_opacity*u_intensity_multiplier;vec3 pos=a_pos_3f;pos+=a_uv.x*u_right*a_size_scale;pos+=a_uv.y*u_up*a_size_scale;gl_Position=u_matrix*vec4(pos,1.0);}"),
            snowParticle: or("in highp vec2 uv;in highp float alphaMultiplier;uniform vec4 u_particleColor;uniform vec2 u_simpleShapeParameters;void main() {float t=clamp((length(uv)-u_simpleShapeParameters.x)/(1.0-u_simpleShapeParameters.x),0.0,1.0);float alpha=1.0-pow(t,pow(10.0,u_simpleShapeParameters.y));alpha*=alphaMultiplier;alpha*=u_particleColor.a;vec3 color=u_particleColor.rgb*alpha;glFragColor=vec4(color,alpha) ;HANDLE_WIREFRAME_DEBUG;}", "\nin highp vec3 a_pos_3f;in highp vec2 a_uv;in highp vec4 a_snowParticleData;in highp vec4 a_snowParticleDataHorizontalOscillation;uniform mat4 u_modelview;uniform mat4 u_projection;uniform vec3 u_cam_pos;uniform vec2 u_screenSize;uniform float u_time;uniform float u_boxSize;uniform float u_velocityConeAperture; \nuniform float u_velocity;uniform vec3 u_direction;uniform float u_horizontalOscillationRadius; \nuniform float u_horizontalOscillationRate; \nuniform float u_billboardSize;uniform vec2 u_thinningCenterPos;uniform vec3 u_thinningShape;uniform float u_thinningAffectedRatio;uniform float u_thinningParticleOffset;out highp vec2 uv;out highp float alphaMultiplier;void main() {vec3 pos=a_pos_3f;float halfBoxSize=0.5*u_boxSize;pos.xyz*=halfBoxSize;pos+=u_cam_pos;float velocityConeApertureRad=radians(u_velocityConeAperture*0.5);float coneAnglePichRad=velocityConeApertureRad*a_snowParticleData.z;float coneAngleHeadingRad=a_snowParticleData.w*radians(360.0);vec3 localZ=normalize(u_direction);vec3 localX=normalize(cross(localZ,vec3(1,0,0)));vec3 localY=normalize(cross(localZ,localX));vec3 direction;direction.x=cos(coneAngleHeadingRad)*sin(coneAnglePichRad);direction.y=sin(coneAngleHeadingRad)*sin(coneAnglePichRad);direction.z=cos(coneAnglePichRad);direction=normalize(direction);vec3 simPosLocal=vec3(0,0,0);float velocityScale=(1.0+3.0*a_snowParticleData.y)*u_velocity;simPosLocal+=direction*velocityScale*u_time;float horizontalOscillationRadius=u_horizontalOscillationRadius*a_snowParticleDataHorizontalOscillation.x;float horizontalOscillationAngle=u_horizontalOscillationRate*u_time*(-1.0+2.0*a_snowParticleDataHorizontalOscillation.y);simPosLocal.xy+=horizontalOscillationRadius*vec2(cos(horizontalOscillationAngle),sin(horizontalOscillationAngle));vec3 simPos=localX*simPosLocal.x+\nlocalY*simPosLocal.y+localZ*simPosLocal.z;pos+=simPos;pos=fract((pos+vec3(halfBoxSize))/vec3(u_boxSize))*u_boxSize-vec3(halfBoxSize);float clipZ=-u_cam_pos.z+pos.z;vec4 posView=u_modelview*vec4(pos,1.0);float size=u_billboardSize;alphaMultiplier=1.0;vec4 posScreen=u_projection*posView;posScreen/=posScreen.w;posScreen.xy=vec2(0.5)+posScreen.xy*0.5;posScreen.xy*=u_screenSize;vec2 thinningCenterPos=u_thinningCenterPos.xy;thinningCenterPos.y=u_screenSize.y-thinningCenterPos.y;float screenDist=length((thinningCenterPos-posScreen.xy)/(0.5*u_screenSize));screenDist+=a_snowParticleData.x*u_thinningParticleOffset;float scaleFactorMode=0.0;float thinningShapeDist=u_thinningShape.x+u_thinningShape.y;if (screenDist < thinningShapeDist) {float thinningFadeRatio=clamp((screenDist-u_thinningShape.x)/u_thinningShape.y,0.0,1.0);thinningFadeRatio=pow(thinningFadeRatio,u_thinningShape.z);if (a_snowParticleData.x < u_thinningAffectedRatio) {scaleFactorMode=1.0-thinningFadeRatio;alphaMultiplier=thinningFadeRatio;}}vec4 posScreen1=u_projection*vec4(posView.x-size,posView.yzw);posScreen1/=posScreen1.w;vec4 posScreen2=u_projection*vec4(posView.x+size,posView.yzw);posScreen2/=posScreen2.w;posScreen1.xy=vec2(0.5)+posScreen1.xy*0.5;posScreen1.xy*=u_screenSize;posScreen2.xy=vec2(0.5)+posScreen2.xy*0.5;posScreen2.xy*=u_screenSize;float screenLength=length(posScreen1.xy-posScreen2.xy);float screenEpsilon=3.0;float scaleFactor=1.0;if (screenLength < screenEpsilon) {scaleFactor=screenEpsilon/max(screenLength,0.01);scaleFactor=mix(scaleFactor,1.0,scaleFactorMode);}float screenEpsilon2=15.0;if (screenLength > screenEpsilon2) {scaleFactor=screenEpsilon2/max(screenLength,0.01);}size*=scaleFactor;vec2 right=size*vec2(1,0);vec2 up=size*vec2(0,1);posView.xy+=right*a_uv.x;posView.xy+=up*a_uv.y;uv=a_uv;gl_Position=u_projection*posView;}"),
            rainParticle: or("in highp vec2 uv;in highp float particleRandomValue;uniform sampler2D u_texScreen;uniform float u_distortionStrength;uniform vec4 u_color;uniform vec2 u_thinningCenterPos;uniform vec3 u_thinningShape;uniform float u_thinningAffectedRatio;uniform float u_thinningParticleOffset;uniform float u_shapeDirectionalPower;uniform float u_mode;void main() {vec2 st=uv*0.5+vec2(0.5);vec2 uvm=uv;uvm.y=-1.0+2.0*pow(st.y,u_shapeDirectionalPower);float shape=clamp(1.0-length(uvm),0.0,1.0);float alpha=abs(shape)*u_color.a;vec2 screenSize=vec2(textureSize(u_texScreen,0));vec2 thinningCenterPos=u_thinningCenterPos.xy;thinningCenterPos.y=screenSize.y-thinningCenterPos.y;float screenDist=length((thinningCenterPos-gl_FragCoord.xy)/(0.5*screenSize));screenDist+=(0.5+0.5*particleRandomValue)*u_thinningParticleOffset;float thinningShapeDist=u_thinningShape.x+u_thinningShape.y;float thinningAlpha=1.0;if (screenDist < thinningShapeDist) {float thinningFadeRatio=clamp((screenDist-u_thinningShape.x)/u_thinningShape.y,0.0,1.0);thinningFadeRatio=pow(thinningFadeRatio,u_thinningShape.z);thinningAlpha*=thinningFadeRatio;}vec2 offsetXY=normalize(uvm)*abs(shape);vec2 stScreen=(gl_FragCoord.xy+offsetXY*u_distortionStrength*thinningAlpha)/screenSize;vec3 colorScreen=texture(u_texScreen,stScreen).rgb;alpha*=thinningAlpha;glFragColor=mix(vec4(colorScreen,1.0),vec4(u_color.rgb*alpha,alpha),u_mode);HANDLE_WIREFRAME_DEBUG;}", "\nin highp vec3 a_pos_3f;in highp vec2 a_uv;in highp vec4 a_rainParticleData;uniform mat4 u_modelview;uniform mat4 u_projection;uniform vec3 u_cam_pos;uniform float u_time;uniform float u_boxSize;uniform float u_velocityConeAperture; \nuniform float u_velocity; \nuniform vec2 u_rainDropletSize;uniform vec3 u_rainDirection;out highp vec2 uv;out highp float particleRandomValue;void main() {vec3 pos=a_pos_3f;float halfBoxSize=0.5*u_boxSize;pos*=halfBoxSize; \npos+=u_cam_pos;float velocityConeApertureRad=radians(u_velocityConeAperture*0.5);float coneAnglePichRad=velocityConeApertureRad*a_rainParticleData.z;float coneAngleHeadingRad=a_rainParticleData.w*radians(360.0);vec3 localZ=normalize(u_rainDirection);vec3 localX=normalize(cross(localZ,vec3(1,0,0)));vec3 localY=normalize(cross(localZ,localX));vec3 directionLocal;directionLocal.x=cos(coneAngleHeadingRad)*sin(coneAnglePichRad);directionLocal.y=sin(coneAngleHeadingRad)*sin(coneAnglePichRad);directionLocal.z=cos(coneAnglePichRad);directionLocal=normalize(directionLocal);vec3 directionWorld=localX*directionLocal.x+localY*directionLocal.y+localZ*directionLocal.z;float velocityScale=(1.0+3.0*a_rainParticleData.y)*u_velocity;vec3 simPosLocal=vec3(0,0,0);simPosLocal+=directionLocal*velocityScale*u_time;vec3 simPos=localX*simPosLocal.x+\nlocalY*simPosLocal.y+localZ*simPosLocal.z;pos+=simPos;pos=fract((pos+vec3(halfBoxSize))/vec3(u_boxSize))*u_boxSize-vec3(halfBoxSize);vec4 posView=u_modelview*vec4(pos,1.0);vec3 directionView=normalize((u_modelview*vec4(directionWorld,0.0)).xyz);vec3 side=cross(directionView,normalize(posView.xyz));posView.xyz+=side*a_uv.x*u_rainDropletSize.x;posView.xyz+=directionView*a_uv.y*u_rainDropletSize.y;uv=a_uv;particleRandomValue=a_rainParticleData.x;gl_Position=u_projection*posView;}"),
            vignette: or("uniform vec3 u_vignetteShape;uniform vec4 u_vignetteColor;in vec2 st;void main() {float screenDist=length(st);float alpha=clamp((screenDist-u_vignetteShape.x)/u_vignetteShape.y,0.0,1.0);alpha=pow(alpha,u_vignetteShape.z)*u_vignetteColor.a;vec3 color=u_vignetteColor.rgb;glFragColor=vec4(color*alpha,alpha) ;}", "in vec2 a_pos_2f;out vec2 st;void main() {st=a_pos_2f;gl_Position=vec4(a_pos_2f,0,1);}"),
            occlusion: or("uniform vec4 u_color;void main() {glFragColor=u_color;}", '#include "_prelude_terrain.vertex.glsl"\nin highp vec2 a_offset_xy;uniform highp vec3 u_anchorPos;uniform mat4 u_matrix;uniform vec2 u_screenSizePx;uniform vec2 u_occluderSizePx;void main() {vec3 world_pos=u_anchorPos;\n#ifdef TERRAIN\nfloat e=elevation(world_pos.xy);world_pos.z+=e;\n#endif\nvec4 projected_point=u_matrix*vec4(world_pos,1.0);projected_point.xy+=projected_point.w*a_offset_xy*0.5*u_occluderSizePx/u_screenSizePx;gl_Position=projected_point;}')
        };
        function tr(e1, t1) {
            const i = e1.split("\n");
            for (let e1 of i){
                if (e1 = e1.trimStart(), "#" !== e1[0]) continue;
                if (!e1.includes("if")) continue;
                if (e1.startsWith("#endif")) continue;
                const i = e1.match(Zo);
                if (i) for (const e1 of i)Ho.has(e1) || t1.add(e1);
            }
        }
        function ir(e1) {
            return new Set([
                "uint",
                "int",
                "uvec2",
                "ivec2",
                "uvec3",
                "ivec3",
                "uvec4",
                "ivec4"
            ]).has(e1);
        }
        function or(e1, t1) {
            const i = new Set, o = [], r = [];
            e1 = e1.replace(Go, (e1, t1)=>(r.push(t1), "")), t1 = t1.replace(Go, (e1, t1)=>(o.push(t1), ""));
            let n = new Set(Wo);
            tr(e1, n), tr(t1, n);
            for (const e1 of [
                ...o,
                ...r
            ])Xo[e1] || (Xo[e1] = new Set, tr($o[e1], Xo[e1])), n = new Set([
                ...n,
                ...Xo[e1]
            ]);
            return {
                fragmentSource: e1 = e1.replace(qo, (e1, t1, o, r, n)=>(i.add(n), "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${n}\n${ir(r) ? "flat " : ""}in ${o} ${r} ${n};\n#else\nuniform ${o} ${r} u_${n};\n#endif\n` : "initialize" === t1 ? `\n#ifdef HAS_UNIFORM_u_${n}\n    ${o} ${r} ${n} = u_${n};\n#endif\n` : "define-attribute" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${n}\n    in ${o} ${r} ${n};\n#endif\n` : "initialize-attribute" === t1 ? "" : void 0)),
                vertexSource: t1 = t1.replace(qo, (e1, t1, o, r, n)=>{
                    const s = `MATERIAL_ATTRIBUTE_OFFSET_${n}`, a = "float" === r ? "vec2" : r, l = `GET_ATTRIBUTE_${a}(a_${n}, materialInfo, ${s})`, c = n.match(/color/) ? "color" : a;
                    return "define-attribute-vertex-shader-only" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${n}\nin ${o} ${r} a_${n};\n#endif\n` : i.has(n) ? "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${n}\nuniform lowp float u_${n}_t;\n    #if !defined(${s})\n        in ${o} ${a} a_${n};\n    #endif\n${ir(r) ? "flat " : ""}out ${o} ${r} ${n};\n#else\nuniform ${o} ${r} u_${n};\n#endif\n` : "initialize" === t1 ? "vec4" === c || "uvec4" === c ? `\n#ifndef HAS_UNIFORM_u_${n}\n    ${n} = a_${n};\n#else\n    ${o} ${r} ${n} = u_${n};\n#endif\n` : `\n#if !defined(HAS_UNIFORM_u_${n})\n    #ifdef ${s}\n        ${n} = unpack_mix_${c}(${l}, u_${n}_t);\n    #else\n        ${n} = unpack_mix_${c}(a_${n}, u_${n}_t);\n    #endif\n#else\n    ${o} ${r} ${n} = u_${n};\n#endif\n` : "define-attribute" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${n}\n    in ${o} ${r} a_${n};\n    out ${o} ${r} ${n};\n#endif\n` : "initialize-attribute" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${n}\n    ${n} = a_${n};\n#endif\n` : void 0 : "define" === t1 ? `\n#ifndef HAS_UNIFORM_u_${n}\nuniform lowp float u_${n}_t;\n    #if !defined(${s})\n        in ${o} ${a} a_${n};\n    #endif\n#else\nuniform ${o} ${r} u_${n};\n#endif\n` : "define-instanced" === t1 ? "mat4" === c ? `\n#ifdef INSTANCED_ARRAYS\nin vec4 a_${n}0;\nin vec4 a_${n}1;\nin vec4 a_${n}2;\nin vec4 a_${n}3;\n#else\nuniform ${o} ${r} u_${n};\n#endif\n` : `\n#ifdef INSTANCED_ARRAYS\nin ${o} ${a} a_${n};\n#else\nuniform ${o} ${r} u_${n};\n#endif\n` : "initialize-attribute-custom" === t1 ? `\n#ifdef HAS_ATTRIBUTE_a_${n}\n    ${o} ${r} ${n} = a_${n};\n#endif\n` : "vec4" === c || "uvec4" === c ? `\n#ifndef HAS_UNIFORM_u_${n}\n    #ifdef ${s}\n        ${o} ${r} ${n} = ${l};\n    #else\n        ${o} ${r} ${n} = a_${n};\n    #endif\n#else\n    ${o} ${r} ${n} = u_${n};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${n}\n    #ifdef ${s}\n        ${o} ${r} ${n} = unpack_mix_${c}(${l}, u_${n}_t);\n    #else\n        ${o} ${r} ${n} = unpack_mix_${c}(a_${n}, u_${n}_t);\n    #endif\n#else\n    ${o} ${r} ${n} = u_${n};\n#endif\n`;
                }),
                usedDefines: n,
                vertexIncludes: o,
                fragmentIncludes: r
            };
        }
        class rr {
            constructor(){
                this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffers = [], this.vao = null;
            }
            bind(e1, t1, i, o, r, n, s, a) {
                this.context = e1;
                let l = this.boundPaintVertexBuffers.length !== o.length;
                for(let e1 = 0; !l && e1 < o.length; e1++)this.boundPaintVertexBuffers[e1] !== o[e1] && (l = !0);
                let c = this.boundDynamicVertexBuffers.length !== s.length;
                for(let e1 = 0; !c && e1 < s.length; e1++)this.boundDynamicVertexBuffers[e1] !== s[e1] && (c = !0);
                if (!this.vao || this.boundProgram !== t1 || this.boundLayoutVertexBuffer !== i || l || c || this.boundIndexBuffer !== r || this.boundVertexOffset !== n) this.freshBind(t1, i, o, r, n, s, a);
                else {
                    e1.bindVertexArrayOES.set(this.vao);
                    for (const i of s)i && (i.bind(), a && i.instanceCount && i.setVertexAttribDivisor(e1.gl, t1, a));
                    r && r.dynamicDraw && r.bind();
                }
            }
            freshBind(e1, t1, i, o, r, n, s) {
                const a = this.context, l = a.gl;
                this.vao && this.destroy(), this.vao = a.gl.createVertexArray(), a.bindVertexArrayOES.set(this.vao), this.boundProgram = e1, this.boundLayoutVertexBuffer = t1, this.boundPaintVertexBuffers = i, this.boundIndexBuffer = o, this.boundVertexOffset = r, this.boundDynamicVertexBuffers = n, t1.enableAttributes(l, e1), t1.bind(), t1.setVertexAttribPointers(l, e1, r);
                for (const t1 of i)t1.enableAttributes(l, e1), t1.bind(), t1.setVertexAttribPointers(l, e1, r);
                for (const t1 of n)t1 && (t1.enableAttributes(l, e1), t1.bind(), t1.setVertexAttribPointers(l, e1, r), s && t1.instanceCount && t1.setVertexAttribDivisor(l, e1, s));
                o && o.bind();
            }
            destroy() {
                this.vao && (this.context.gl.deleteVertexArray(this.vao), this.vao = null);
            }
        }
        function nr(t1, i) {
            const o = Math.pow(2, i.canonical.z), r = i.canonical.y;
            return [
                new e1.ag(0, r / o).toLngLat().lat,
                new e1.ag(0, (r + 1) / o).toLngLat().lat
            ];
        }
        function sr(t1, i, o, r, n, s, a) {
            const l = t1.context, c = l.gl, h = o.hillshadeFBO;
            if (!h) return;
            t1.prepareDrawTile();
            const d = t1.isTileAffectedByFog(i), _ = [];
            t1.terrain && t1.terrain.renderingToTexture && "mrt-fallback" === t1.emissiveMode && _.push("USE_MRT1");
            const u = t1.getOrCreateProgram("hillshade", {
                overrideFog: d,
                defines: _
            });
            l.activeTexture.set(c.TEXTURE0), c.bindTexture(c.TEXTURE_2D, h.colorAttachment0.get());
            const p = ((t1, i, o, r)=>{
                const n = o.paint.get("hillshade-shadow-color"), s = "none" === o.paint.get("hillshade-shadow-color-use-theme").constantOr("default"), a = o.paint.get("hillshade-highlight-color"), l = "none" === o.paint.get("hillshade-highlight-color-use-theme").constantOr("default"), c = o.paint.get("hillshade-accent-color"), h = "none" === o.paint.get("hillshade-accent-color-use-theme").constantOr("default"), d = o.paint.get("hillshade-emissive-strength");
                let _ = e1.ap(o.paint.get("hillshade-illumination-direction"));
                if ("viewport" === o.paint.get("hillshade-illumination-anchor")) _ -= t1.transform.angle;
                else if (t1.style && t1.style.enable3dLights() && t1.style.directionalLight) {
                    const i = t1.style.directionalLight.properties.get("direction"), o = e1.cL(i.x, i.y, i.z);
                    _ = e1.ap(o[1]);
                }
                const u = !t1.options.moving;
                return {
                    u_matrix: r || t1.transform.calculateProjMatrix(i.tileID.toUnwrapped(), u),
                    u_image: 0,
                    u_latrange: nr(0, i.tileID),
                    u_light: [
                        o.paint.get("hillshade-exaggeration"),
                        _
                    ],
                    u_shadow: n.toPremultipliedRenderColor(s ? null : o.lut),
                    u_highlight: a.toPremultipliedRenderColor(l ? null : o.lut),
                    u_emissive_strength: d,
                    u_accent: c.toPremultipliedRenderColor(h ? null : o.lut)
                };
            })(t1, o, r, t1.terrain ? i.projMatrix : null);
            t1.uploadCommonUniforms(l, u, i.toUnwrapped());
            const { tileBoundsBuffer: f, tileBoundsIndexBuffer: m, tileBoundsSegments: g } = t1.getTileBoundsBuffers(o);
            u.draw(t1, c.TRIANGLES, n, s, a, Ki.disabled, p, r.id, f, m, g);
        }
        function ar(t1, i, o) {
            if (!i.needsDEMTextureUpload) return;
            const r = t1.context, n = r.gl;
            r.pixelStoreUnpackPremultiplyAlpha.set(!1), i.demTexture = i.demTexture || t1.getTileTexture(o.stride);
            const s = o.getPixels();
            i.demTexture ? i.demTexture.update(s, {
                premultiply: !1
            }) : i.demTexture = new e1.T(r, s, n.R32F, {
                premultiply: !1
            }), i.needsDEMTextureUpload = !1;
        }
        function lr(t1, i, o) {
            const r = t1.context, n = r.gl;
            if (!i.dem) return;
            const s = i.dem;
            if (r.activeTexture.set(n.TEXTURE1), ar(t1, i, s), !i.demTexture) return;
            i.demTexture.bind(n.NEAREST, n.CLAMP_TO_EDGE);
            const a = s.dim;
            r.activeTexture.set(n.TEXTURE0);
            let l = i.hillshadeFBO;
            if (!l) {
                const t1 = new e1.T(r, {
                    width: a,
                    height: a,
                    data: null
                }, n.RGBA8);
                t1.bind(n.LINEAR, n.CLAMP_TO_EDGE), l = i.hillshadeFBO = r.createFramebuffer(a, a, 1, "renderbuffer"), l.colorAttachment0.set(t1.texture);
            }
            r.bindFramebuffer.set(l.framebuffer), r.viewport.set([
                0,
                0,
                a,
                a
            ]);
            const { tileBoundsBuffer: c, tileBoundsIndexBuffer: h, tileBoundsSegments: d } = t1.getMercatorTileBoundsBuffers(), _ = [];
            t1.linearFloatFilteringSupported() && _.push("TERRAIN_DEM_FLOAT_FORMAT"), t1.terrain && t1.terrain.renderingToTexture && "mrt-fallback" === t1.emissiveMode && _.push("USE_MRT1"), t1.getOrCreateProgram("hillshadePrepare", {
                defines: _
            }).draw(t1, n.TRIANGLES, Hi.disabled, $i.disabled, Zi.unblended, Ki.disabled, ((t1, i)=>{
                const o = i.stride, r = e1.bc();
                return e1.bU(r, 0, e1.an, -e1.an, 0, 0, 1), e1.by(r, r, [
                    0,
                    -e1.an,
                    0
                ]), {
                    u_matrix: r,
                    u_image: 1,
                    u_dimension: [
                        o,
                        o
                    ],
                    u_zoom: t1.overscaledZ
                };
            })(i.tileID, s), o.id, c, h, d), i.needsHillshadePrepare = !1;
        }
        class cr {
            constructor(e1){
                this.gl = e1.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
            }
            get() {
                return this.current;
            }
            set(e1) {}
            getDefault() {
                return this.default;
            }
            setDefault() {
                this.set(this.default);
            }
        }
        class hr extends cr {
            getDefault() {
                return e1.aq.transparent.toNonPremultipliedRenderColor(null);
            }
            set(e1) {
                const t1 = this.current;
                (e1.r !== t1.r || e1.g !== t1.g || e1.b !== t1.b || e1.a !== t1.a || this.dirty) && (this.gl.clearColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
            }
        }
        class dr extends cr {
            getDefault() {
                return 1;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.clearDepth(e1), this.current = e1, this.dirty = !1);
            }
        }
        class _r extends cr {
            getDefault() {
                return 0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.clearStencil(e1), this.current = e1, this.dirty = !1);
            }
        }
        class ur extends cr {
            getDefault() {
                return [
                    !0,
                    !0,
                    !0,
                    !0
                ];
            }
            set(e1) {
                const t1 = this.current;
                (e1[0] !== t1[0] || e1[1] !== t1[1] || e1[2] !== t1[2] || e1[3] !== t1[3] || this.dirty) && (this.gl.colorMask(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
            }
        }
        class pr extends cr {
            getDefault() {
                return !0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.depthMask(e1), this.current = e1, this.dirty = !1);
            }
        }
        class fr extends cr {
            getDefault() {
                return 255;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.stencilMask(e1), this.current = e1, this.dirty = !1);
            }
        }
        class mr extends cr {
            getDefault() {
                return {
                    func: this.gl.ALWAYS,
                    ref: 0,
                    mask: 255
                };
            }
            set(e1) {
                const t1 = this.current;
                (e1.func !== t1.func || e1.ref !== t1.ref || e1.mask !== t1.mask || this.dirty) && (this.gl.stencilFunc(e1.func, e1.ref, e1.mask), this.current = e1, this.dirty = !1);
            }
        }
        class gr extends cr {
            getDefault() {
                const e1 = this.gl;
                return [
                    e1.KEEP,
                    e1.KEEP,
                    e1.KEEP
                ];
            }
            set(e1) {
                const t1 = this.current;
                (e1[0] !== t1[0] || e1[1] !== t1[1] || e1[2] !== t1[2] || this.dirty) && (this.gl.stencilOp(e1[0], e1[1], e1[2]), this.current = e1, this.dirty = !1);
            }
        }
        class vr extends cr {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                e1 ? t1.enable(t1.STENCIL_TEST) : t1.disable(t1.STENCIL_TEST), this.current = e1, this.dirty = !1;
            }
        }
        class yr extends cr {
            getDefault() {
                return [
                    0,
                    1
                ];
            }
            set(e1) {
                const t1 = this.current;
                (e1[0] !== t1[0] || e1[1] !== t1[1] || this.dirty) && (this.gl.depthRange(e1[0], e1[1]), this.current = e1, this.dirty = !1);
            }
        }
        class xr extends cr {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                e1 ? t1.enable(t1.DEPTH_TEST) : t1.disable(t1.DEPTH_TEST), this.current = e1, this.dirty = !1;
            }
        }
        class br extends cr {
            getDefault() {
                return this.gl.LESS;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.depthFunc(e1), this.current = e1, this.dirty = !1);
            }
        }
        class wr extends cr {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                e1 ? t1.enable(t1.BLEND) : t1.disable(t1.BLEND), this.current = e1, this.dirty = !1;
            }
        }
        class Tr extends cr {
            getDefault() {
                const e1 = this.gl;
                return [
                    e1.ONE,
                    e1.ZERO,
                    e1.ONE,
                    e1.ZERO
                ];
            }
            set(e1) {
                const t1 = this.current;
                (e1[0] !== t1[0] || e1[1] !== t1[1] || e1[2] !== t1[2] || e1[3] !== t1[3] || this.dirty) && (this.gl.blendFuncSeparate(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
            }
        }
        class Er extends cr {
            getDefault() {
                return e1.aq.transparent.toNonPremultipliedRenderColor(null);
            }
            set(e1) {
                const t1 = this.current;
                (e1.r !== t1.r || e1.g !== t1.g || e1.b !== t1.b || e1.a !== t1.a || this.dirty) && (this.gl.blendColor(e1.r, e1.g, e1.b, e1.a), this.current = e1, this.dirty = !1);
            }
        }
        class Sr extends cr {
            getDefault() {
                return this.gl.FUNC_ADD;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.blendEquationSeparate(e1, e1), this.current = e1, this.dirty = !1);
            }
        }
        class Cr extends cr {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                e1 ? t1.enable(t1.CULL_FACE) : t1.disable(t1.CULL_FACE), this.current = e1, this.dirty = !1;
            }
        }
        class Ir extends cr {
            getDefault() {
                return this.gl.BACK;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.cullFace(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Rr extends cr {
            getDefault() {
                return this.gl.CCW;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.frontFace(e1), this.current = e1, this.dirty = !1);
            }
        }
        let Dr = class extends cr {
            getDefault() {
                return null;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.useProgram(e1), this.current = e1, this.dirty = !1);
            }
        };
        class Ar extends cr {
            getDefault() {
                return this.gl.TEXTURE0;
            }
            set(e1) {
                (e1 !== this.current || this.dirty) && (this.gl.activeTexture(e1), this.current = e1, this.dirty = !1);
            }
        }
        class Lr extends cr {
            getDefault() {
                const e1 = this.gl;
                return [
                    0,
                    0,
                    e1.drawingBufferWidth,
                    e1.drawingBufferHeight
                ];
            }
            set(e1) {
                const t1 = this.current;
                (e1[0] !== t1[0] || e1[1] !== t1[1] || e1[2] !== t1[2] || e1[3] !== t1[3] || this.dirty) && (this.gl.viewport(e1[0], e1[1], e1[2], e1[3]), this.current = e1, this.dirty = !1);
            }
        }
        class Pr extends cr {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindFramebuffer(t1.FRAMEBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Or extends cr {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindRenderbuffer(t1.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Mr extends cr {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindTexture(t1.TEXTURE_2D, e1), this.current = e1, this.dirty = !1;
            }
        }
        class zr extends cr {
            getDefault() {
                return null;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.bindBuffer(t1.ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Fr extends cr {
            getDefault() {
                return null;
            }
            set(e1) {
                const t1 = this.gl;
                t1.bindBuffer(t1.ELEMENT_ARRAY_BUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Br extends cr {
            getDefault() {
                return null;
            }
            set(e1) {
                this.gl && (e1 !== this.current || this.dirty) && (this.gl.bindVertexArray(e1), this.current = e1, this.dirty = !1);
            }
        }
        class kr extends cr {
            getDefault() {
                return 4;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_ALIGNMENT, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Nr extends cr {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Ur extends cr {
            getDefault() {
                return !1;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                const t1 = this.gl;
                t1.pixelStorei(t1.UNPACK_FLIP_Y_WEBGL, e1), this.current = e1, this.dirty = !1;
            }
        }
        class Vr extends cr {
            constructor(e1, t1){
                super(e1), this.context = e1, this.parent = t1;
            }
            getDefault() {
                return null;
            }
        }
        class jr extends Vr {
            constructor(e1, t1, i = 0){
                super(e1, t1), this.attachmentPoint = e1.gl.COLOR_ATTACHMENT0 + i;
            }
            setDirty() {
                this.dirty = !0;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t1 = this.gl;
                t1.framebufferTexture2D(t1.FRAMEBUFFER, this.attachmentPoint, t1.TEXTURE_2D, e1, 0), this.current = e1, this.dirty = !1;
            }
        }
        class Gr extends Vr {
            attachment() {
                return this.gl.DEPTH_ATTACHMENT;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t1 = this.gl;
                t1.framebufferRenderbuffer(t1.FRAMEBUFFER, this.attachment(), t1.RENDERBUFFER, e1), this.current = e1, this.dirty = !1;
            }
        }
        class qr extends Vr {
            attachment() {
                return this.gl.DEPTH_ATTACHMENT;
            }
            set(e1) {
                if (e1 === this.current && !this.dirty) return;
                this.context.bindFramebuffer.set(this.parent);
                const t1 = this.gl;
                t1.framebufferTexture2D(t1.FRAMEBUFFER, this.attachment(), t1.TEXTURE_2D, e1, 0), this.current = e1, this.dirty = !1;
            }
        }
        class Zr extends Gr {
            attachment() {
                return this.gl.DEPTH_STENCIL_ATTACHMENT;
            }
        }
        const Hr = (e1, t1, i, o)=>({
                u_matrix: e1,
                u_image0: 0,
                u_image1: 1,
                u_skirt_height: t1,
                u_ground_shadow_factor: i,
                u_emissive_texture_available: o
            }), Wr = (e1, t1, i, o, r, n, s, a, l, c, h, d, _, u, p, f, m)=>({
                u_proj_matrix: Float32Array.from(e1),
                u_globe_matrix: t1,
                u_normalize_matrix: Float32Array.from(o),
                u_merc_matrix: i,
                u_zoom_transition: r,
                u_merc_center: n,
                u_image0: 0,
                u_image1: 1,
                u_frustum_tl: s,
                u_frustum_tr: a,
                u_frustum_br: l,
                u_frustum_bl: c,
                u_globe_pos: h,
                u_globe_radius: d,
                u_viewport: _,
                u_grid_matrix: m ? Float32Array.from(m) : new Float32Array(9),
                u_skirt_height: u,
                u_far_z_cutoff: p,
                u_emissive_texture_available: f
            });
        function $r(e1, t1) {
            return null != e1 && null != t1 && !(!e1.hasData() || !t1.hasData()) && null != e1.demTexture && null != t1.demTexture && e1.tileID.key !== t1.tileID.key;
        }
        const Xr = new class {
            constructor(){
                this.operations = {};
            }
            newMorphing(e1, t1, i, o, r) {
                if (e1 in this.operations) {
                    const t1 = this.operations[e1];
                    t1.to.tileID.key !== i.tileID.key && (t1.queued = i);
                } else this.operations[e1] = {
                    startTime: o,
                    phase: 0,
                    duration: r,
                    from: t1,
                    to: i,
                    queued: null
                };
            }
            getMorphValuesForProxy(e1) {
                if (!(e1 in this.operations)) return null;
                const t1 = this.operations[e1];
                return {
                    from: t1.from,
                    to: t1.to,
                    phase: t1.phase
                };
            }
            update(e1) {
                for(const t1 in this.operations){
                    const i = this.operations[t1];
                    for(i.phase = (e1 - i.startTime) / i.duration; i.phase >= 1 || !this._validOp(i);)if (!this._nextOp(i, e1)) {
                        delete this.operations[t1];
                        break;
                    }
                }
            }
            _nextOp(e1, t1) {
                return !!e1.queued && (e1.from = e1.to, e1.to = e1.queued, e1.queued = null, e1.phase = 0, e1.startTime = t1, !0);
            }
            _validOp(e1) {
                return e1.from.hasData() && e1.to.hasData();
            }
        }, Yr = {
            0: null,
            1: "TERRAIN_VERTEX_MORPHING"
        };
        function Kr(e1, t1, i) {
            if (0 === t1) return 0;
            const o = t1 < 1 && 514 === i ? .25 / t1 : 1;
            return 6 * Math.pow(1.5, 22 - e1) * Math.max(t1, 1) * o;
        }
        function Qr(e1, t1) {
            const i = 1 << e1.z;
            return !t1 && (0 === e1.x || e1.x === i - 1) || 0 === e1.y || e1.y === i - 1;
        }
        function Jr(e1, t1) {
            if (!e1.style || !e1.style.enable3dLights()) return;
            const i = e1.context, o = i.gl;
            i.activeTexture.set(o.TEXTURE1), t1 ? t1.bind(o.LINEAR, o.CLAMP_TO_EDGE) : e1.emptyTexture.bind(o.LINEAR, o.CLAMP_TO_EDGE);
        }
        const en = (e1)=>({
                u_matrix: e1
            });
        function tn(t1, i, o, r, n) {
            if (n > 0) {
                const s = e1.o.now(), a = (s - t1.timeAdded) / n, l = i ? (s - i.timeAdded) / n : -1, c = o.getSource(), h = r.coveringZoomLevel({
                    tileSize: c.tileSize,
                    roundZoom: c.roundZoom
                }), d = !i || Math.abs(i.tileID.overscaledZ - h) > Math.abs(t1.tileID.overscaledZ - h), _ = d && t1.refreshedUponExpiration ? 1 : e1.aC(d ? a : 1 - l, 0, 1);
                return i ? {
                    opacity: 1,
                    mix: 1 - _,
                    isFading: a < 1
                } : {
                    opacity: _,
                    mix: 0,
                    isFading: a < 1
                };
            }
            return {
                opacity: 1,
                mix: 0,
                isFading: !1
            };
        }
        class on extends zt {
            constructor(e1){
                const t1 = {
                    type: "raster-dem",
                    maxzoom: Math.ceil(e1.transform.maxZoom)
                }, i = St("mock-dem", t1, e1.style.dispatcher, e1.style);
                super("mock-dem", i, null), i.setEventedParent(this), this._sourceLoaded = !0;
            }
            _loadTile(e1, t1) {
                e1.state = "loaded", t1(null);
            }
        }
        class rn extends zt {
            constructor(e1){
                const t1 = St("proxy", {
                    type: "geojson",
                    maxzoom: Math.ceil(e1.transform.maxZoom)
                }, e1.style.dispatcher, e1.style);
                super("proxy", t1, null), t1.setEventedParent(this), this.map = this.getSource().map = e1, this.used = this._sourceLoaded = !0, this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
            }
            update(t1, i, o) {
                if (t1.freezeTileCoverage) return;
                this.transform = t1;
                const r = t1.coveringTiles({
                    tileSize: this._source.tileSize,
                    minzoom: this._source.minzoom,
                    maxzoom: this._source.maxzoom,
                    roundZoom: this._source.roundZoom,
                    reparseOverscaled: this._source.reparseOverscaled
                }).reduce((i, o)=>{
                    if (i[o.key] = "", !this._tiles[o.key]) {
                        const i = new e1.b1(o, this._source.tileSize * o.overscaleFactor(), t1.tileZoom, void 0, void 0, this._source.worldview);
                        i.state = "loaded", this._tiles[o.key] = i;
                    }
                    return i;
                }, {});
                for(const e1 in this._tiles)e1 in r || (this.freeFBO(e1), this._tiles[e1].unloadVectorData(), delete this._tiles[e1]);
            }
            freeFBO(e1) {
                const t1 = this.proxyCachedFBO[e1];
                if (void 0 !== t1) {
                    const i = Object.values(t1);
                    this.renderCachePool.push(...i), delete this.proxyCachedFBO[e1];
                }
            }
            deallocRenderCache() {
                this.renderCache.forEach((e1)=>e1.fb.destroy()), this.renderCache = [], this.renderCachePool = [], this.proxyCachedFBO = {};
            }
        }
        class nn extends e1.aS {
            constructor(e1, t1, i){
                super(e1.overscaledZ, e1.wrap, e1.canonical.z, e1.canonical.x, e1.canonical.y), this.proxyTileKey = t1, this.projMatrix = i;
            }
        }
        class sn extends e1.bv {
            constructor(t1, i){
                super(), this._debugParams = {
                    sortTilesHiZFirst: !0,
                    disableRenderCache: !1
                }, this.painter = t1, this.terrainTileForTile = {}, this.prevTerrainTileForTile = {};
                const [o, r, n] = function() {
                    const t1 = new e1.dx, i = new e1.dy, o = 131;
                    t1.reserve(17161), i.reserve(33800);
                    const r = e1.an / 128, n = e1.an + r / 2, s = n + r;
                    for(let i = -r; i < s; i += r)for(let o = -r; o < s; o += r){
                        const r = o < 0 || o > n || i < 0 || i > n ? 24575 : 0, s = e1.aC(Math.round(o), 0, e1.an), a = e1.aC(Math.round(i), 0, e1.an);
                        t1.emplaceBack(s + r, a);
                    }
                    const a = (e1, t1)=>{
                        const r = t1 * o + e1;
                        i.emplaceBack(r + 1, r, r + o), i.emplaceBack(r + o, r + o + 1, r + 1);
                    };
                    for(let e1 = 1; e1 < 129; e1++)for(let t1 = 1; t1 < 129; t1++)a(t1, e1);
                    return [
                        0,
                        129
                    ].forEach((e1)=>{
                        for(let t1 = 0; t1 < 130; t1++)a(t1, e1), a(e1, t1);
                    }), [
                        t1,
                        i,
                        32768
                    ];
                }(), s = t1.context;
                this.gridBuffer = s.createVertexBuffer(o, e1.dt.members), this.gridIndexBuffer = s.createIndexBuffer(r), this.gridSegments = e1.du.simpleSegment(0, 0, o.length, r.length), this.gridNoSkirtSegments = e1.du.simpleSegment(0, 0, o.length, n), this.proxyCoords = [], this.proxiedCoords = {}, this._visibleDemTiles = [], this._drapedRenderBatches = [], this._sourceTilesOverlap = {}, this.proxySourceCache = new rn(i.map), this.orthoMatrix = e1.bc(), e1.bU(this.orthoMatrix, "globe" === this.painter.transform.projection.name ? .015 : 0, e1.an, 0, e1.an, 0, 1);
                const a = s.gl;
                this._overlapStencilMode = new $i({
                    func: a.GEQUAL,
                    mask: 255
                }, 0, 255, a.KEEP, a.KEEP, a.REPLACE), this._previousZoom = t1.transform.zoom, this.pool = [], this._findCoveringTileCache = {}, this._tilesDirty = {}, this.style = i, this._useVertexMorphing = !0, this._exaggeration = 1, this._mockSourceCache = new on(i.map), this._pendingGroundEffectLayers = [], this._emissiveTexture = !1;
            }
            set style(e1) {
                e1.on("data", this._onStyleDataEvent.bind(this)), this._style = e1, this._style.map.on("moveend", ()=>{
                    this._clearLineLayersFromRenderCache();
                });
            }
            update(t1, i, o) {
                if (t1 && t1.terrain) {
                    this._style !== t1 && (this.style = t1, this._evaluationZoom = void 0);
                    const r = t1.terrain.properties, n = 0 === t1.terrain.drapeRenderMode, s = t1.terrain.isZoomDependent();
                    this._previousUpdateTimestamp = this.enabled ? this._updateTimestamp : void 0, this._updateTimestamp = e1.o.now();
                    const a = t1.terrain && t1.terrain.scope, l = r.get("source"), c = n ? this._mockSourceCache : t1.getSourceCache(l, a);
                    if (!c) return void e1.w(`Couldn't find terrain source "${l}".`);
                    if (this.sourceCache = c, this._attenuationRange = t1.terrain.getAttenuationRange(), this._exaggeration = s ? this.calculateExaggeration(i) : r.get("exaggeration"), !i.projection.requiresDraping && s && 0 === this._exaggeration) return void this._disable();
                    this.enabled = !0;
                    const h = ()=>{
                        this.sourceCache.used && e1.w(`Raster DEM source '${this.sourceCache.id}' is used both for terrain and as layer source.\nThis leads to lower resolution of hillshade. For full hillshade resolution but higher memory consumption, define another raster DEM source.`);
                        const t1 = this.getScaledDemTileSize();
                        this.sourceCache.update(i, t1, !0), this.resetTileLookupCache(this.sourceCache.id);
                    };
                    this.sourceCache.usedForTerrain || (this.resetTileLookupCache(this.sourceCache.id), this.sourceCache.usedForTerrain = !0, h(), this._initializing = !0), h(), i.updateElevation(!0, o), this.resetTileLookupCache(this.proxySourceCache.id), this.proxySourceCache.update(i), this._emptyDEMTextureDirty = !0, this._previousZoom = i.zoom;
                } else this._disable();
            }
            calculateExaggeration(t1) {
                if (this._attenuationRange && t1.zoom >= Math.ceil(this._attenuationRange[1])) return this._style.terrain.getExaggeration(t1.zoom);
                const i = this._previousCameraAltitude, o = t1.getFreeCameraOptions().position.z / t1.pixelsPerMeter * t1.worldSize;
                this._previousCameraAltitude = o;
                const r = null != i ? o - i : Number.MAX_VALUE;
                if (Math.abs(r) < 2) return this._exaggeration;
                const n = t1.zoom, s = this._style.terrain;
                if (!this._previousUpdateTimestamp) return s.getExaggeration(n);
                let a = n - this._previousZoom;
                const l = this._previousUpdateTimestamp;
                let c = n;
                null != this._evaluationZoom && (c = this._evaluationZoom, Math.abs(n - c) > .5 && (a = .5 * (n - c + a)), a * r < 0 && (c += a)), this._evaluationZoom = c;
                const h = s.getExaggeration(c), d = h === s.getExaggeration(Math.max(0, c - .1));
                if (d && Math.abs(h - this._exaggeration) < .01) return h;
                let _ = Math.min(.1, .00375 * (this._updateTimestamp - l));
                return (d || h < .1 || Math.abs(a) < 1e-4) && (_ = Math.min(.2, 4 * _)), e1.am(this._exaggeration, h, _);
            }
            resetTileLookupCache(e1) {
                this._findCoveringTileCache[e1] = {};
            }
            attenuationRange() {
                return this._attenuationRange;
            }
            getDemUpscale() {
                return this.proxySourceCache.getSource().tileSize / 128;
            }
            getScaledDemTileSize() {
                return this.sourceCache.getSource().tileSize / 128 * this.proxySourceCache.getSource().tileSize;
            }
            _onStyleDataEvent(e1) {
                "source" === e1.dataType && e1.coord ? this._clearRenderCacheForTile(e1.sourceCacheId, e1.coord) : "style" === e1.dataType && (this.invalidateRenderCache = !0, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this._previousCameraAltitude = void 0);
            }
            _disable() {
                if (this.enabled && (this.enabled = !1, this._emptyDEMTextureDirty = !0, this._sharedDepthStencil = void 0, this._evaluationZoom = void 0, this._previousUpdateTimestamp = void 0, this.proxySourceCache.deallocRenderCache(), this._style)) for(const e1 in this._style._mergedSourceCaches)this._style._mergedSourceCaches[e1].usedForTerrain = !1;
            }
            destroy() {
                this._disable(), this._emptyDEMTexture && this._emptyDEMTexture.destroy(), this.pool.forEach((e1)=>e1.fb.destroy()), this.pool = [], this.framebufferCopyTexture && this.framebufferCopyTexture.destroy();
            }
            _source() {
                return this.enabled ? this.sourceCache : null;
            }
            isUsingMockSource() {
                return this.sourceCache === this._mockSourceCache;
            }
            exaggeration() {
                return this.enabled ? this._exaggeration : 0;
            }
            get visibleDemTiles() {
                return this._visibleDemTiles;
            }
            get drapeBufferSize() {
                const e1 = 2 * this.proxySourceCache.getSource().tileSize;
                return [
                    e1,
                    e1
                ];
            }
            set useVertexMorphing(e1) {
                this._useVertexMorphing = e1;
            }
            updateTileBinding(t1) {
                if (!this.enabled) return;
                this.prevTerrainTileForTile = this.terrainTileForTile;
                const i = this.proxySourceCache, o = this.painter.transform;
                this._initializing && (this._initializing = 0 === o._centerAltitude && -1 === this.getAtPointOrZero(e1.ag.fromLngLat(o.center), -1), this._emptyDEMTextureDirty = !this._initializing);
                const r = this.proxyCoords = i.getIds().map((e1)=>{
                    const t1 = i.getTileByID(e1).tileID;
                    return t1.projMatrix = o.calculateProjMatrix(t1.toUnwrapped()), t1;
                });
                !function(t1, i) {
                    const o = i.transform.pointCoordinate(i.transform.getCameraPoint()), r = new e1.P(o.x, o.y);
                    t1.sort((t1, i)=>{
                        if (i.overscaledZ - t1.overscaledZ) return i.overscaledZ - t1.overscaledZ;
                        const o = new e1.P(t1.canonical.x + (1 << t1.canonical.z) * t1.wrap, t1.canonical.y), n = new e1.P(i.canonical.x + (1 << i.canonical.z) * i.wrap, i.canonical.y), s = r.mult(1 << t1.canonical.z);
                        return s.x -= .5, s.y -= .5, s.distSqr(o) - s.distSqr(n);
                    });
                }(r, this.painter);
                const n = this.proxyToSource || {};
                this.proxyToSource = {}, r.forEach((e1)=>{
                    this.proxyToSource[e1.key] = {};
                }), this.terrainTileForTile = {};
                const s = this._style._mergedSourceCaches;
                for(const e1 in s){
                    const i = s[e1];
                    if (!i.used) continue;
                    if (i !== this.sourceCache && this.resetTileLookupCache(i.id), this._setupProxiedCoordsForOrtho(i, t1[e1], n), i.usedForTerrain) continue;
                    const o = t1[e1];
                    (i.getSource().reparseOverscaled || i._isRasterElevatedOverTerrain) && this._assignTerrainTiles(o);
                }
                this.proxiedCoords[i.id] = r.map((e1)=>new nn(e1, e1.key, this.orthoMatrix)), this._assignTerrainTiles(r), this._prepareDEMTextures(), this._setupDrapedRenderBatches(), this._initFBOPool(), this._setupRenderCache(n), this.renderingToTexture = !1;
                const a = {};
                this._visibleDemTiles = [];
                for (const e1 of this.proxyCoords){
                    const t1 = this.terrainTileForTile[e1.key];
                    if (!t1) continue;
                    const i = t1.tileID.key;
                    i in a || (this._visibleDemTiles.push(t1), a[i] = i);
                }
            }
            _assignTerrainTiles(e1) {
                this._initializing || e1.forEach((e1)=>{
                    if (this.terrainTileForTile[e1.key]) return;
                    const t1 = this._findTileCoveringTileID(e1, this.sourceCache);
                    t1 && (this.terrainTileForTile[e1.key] = t1);
                });
            }
            _prepareDEMTextures() {
                const e1 = this.painter.context, t1 = e1.gl;
                for(const i in this.terrainTileForTile){
                    const o = this.terrainTileForTile[i], r = o.dem;
                    !r || o.demTexture && !o.needsDEMTextureUpload || (e1.activeTexture.set(t1.TEXTURE1), ar(this.painter, o, r));
                }
            }
            _prepareDemTileUniforms(e1, t1, i, o) {
                if (!t1 || null == t1.demTexture) return !1;
                const r = e1.tileID.canonical, n = Math.pow(2, t1.tileID.canonical.z - r.z), s = o || "";
                return i[`u_dem_tl${s}`] = [
                    r.x * n % 1,
                    r.y * n % 1
                ], i[`u_dem_scale${s}`] = n, !0;
            }
            get emptyDEMTexture() {
                return !this._emptyDEMTextureDirty && this._emptyDEMTexture ? this._emptyDEMTexture : this._updateEmptyDEMTexture();
            }
            _getLoadedAreaMinimum() {
                if (!this.enabled) return 0;
                let e1 = 0;
                const t1 = this._visibleDemTiles.reduce((t1, i)=>{
                    if (!i.dem) return t1;
                    const o = i.dem.tree.minimums[0];
                    return o > 0 && e1++, t1 + o;
                }, 0);
                return e1 ? t1 / e1 : 0;
            }
            _updateEmptyDEMTexture() {
                const t1 = this.painter.context, i = t1.gl;
                t1.activeTexture.set(i.TEXTURE2);
                const o = this._getLoadedAreaMinimum(), r = new e1.dv({
                    width: 1,
                    height: 1
                }, new Float32Array([
                    o
                ]));
                this._emptyDEMTextureDirty = !1;
                let n = this._emptyDEMTexture;
                return n ? n.update(r, {
                    premultiply: !1
                }) : n = this._emptyDEMTexture = new e1.T(t1, r, i.R32F, {
                    premultiply: !1
                }), n;
            }
            setupElevationDraw(t1, i, o) {
                const r = this.painter.context, n = r.gl, s = {
                    u_dem: 2,
                    u_dem_prev: 4,
                    u_dem_tl: [
                        0,
                        0
                    ],
                    u_dem_tl_prev: [
                        0,
                        0
                    ],
                    u_dem_scale: 0,
                    u_dem_scale_prev: 0,
                    u_dem_size: 0,
                    u_dem_lerp: 1,
                    u_depth: 3,
                    u_depth_size_inv: [
                        0,
                        0
                    ],
                    u_depth_range_unpack: [
                        0,
                        1
                    ],
                    u_occluder_half_size: 16,
                    u_occlusion_depth_offset: -0.0001,
                    u_exaggeration: 0
                };
                s.u_exaggeration = this.exaggeration();
                let a = null, l = null, c = 1;
                if (o && o.morphing && this._useVertexMorphing) {
                    const e1 = o.morphing.srcDemTile, i = o.morphing.dstDemTile;
                    c = o.morphing.phase, e1 && i && (this._prepareDemTileUniforms(t1, e1, s, "_prev") && (l = e1), this._prepareDemTileUniforms(t1, i, s) && (a = i));
                }
                const h = (e1)=>e1 && e1.demTexture && this.painter.linearFloatFilteringSupported() ? n.LINEAR : n.NEAREST;
                let d = null;
                var _;
                if (this.enabled ? l && a ? (d = a.demTexture, r.activeTexture.set(n.TEXTURE4), l.demTexture.bind(h(l), n.CLAMP_TO_EDGE), s.u_dem_lerp = c) : (a = this.terrainTileForTile[t1.tileID.key], d = this._prepareDemTileUniforms(t1, a, s) ? a.demTexture : this.emptyDEMTexture) : d = this.emptyDEMTexture, r.activeTexture.set(n.TEXTURE2), d && (s.u_dem_size = 1 === (_ = d).size[0] ? 1 : _.size[0] - 2, d.bind(h(a), n.CLAMP_TO_EDGE)), this.painter.setupDepthForOcclusion(o && o.useDepthForOcclusion, i, s), o && o.useMeterToDem && a) {
                    const t1 = (1 << a.tileID.canonical.z) * e1.bV(1, this.painter.transform.center.lat) * this.sourceCache.getSource().tileSize;
                    s.u_meter_to_dem = t1;
                }
                if (o && o.labelPlaneMatrixInv && (s.u_label_plane_matrix_inv = o.labelPlaneMatrixInv), i.setTerrainUniformValues(r, s), "globe" === this.painter.transform.projection.name) {
                    const e1 = this.globeUniformValues(this.painter.transform, t1.tileID.canonical, o && o.useDenormalizedUpVectorScale);
                    i.setGlobeUniformValues(r, e1);
                }
            }
            globeUniformValues(t1, i, o) {
                const r = t1.projection;
                return {
                    u_tile_tl_up: r.upVector(i, 0, 0),
                    u_tile_tr_up: r.upVector(i, e1.an, 0),
                    u_tile_br_up: r.upVector(i, e1.an, e1.an),
                    u_tile_bl_up: r.upVector(i, 0, e1.an),
                    u_tile_up_scale: o ? e1.dw(1) : r.upVectorScale(i, t1.center.lat, t1.worldSize).metersToTile
                };
            }
            renderToBackBuffer(t1) {
                const i = this.painter, o = this.painter.context;
                0 !== t1.length && (o.bindFramebuffer.set(null), o.viewport.set([
                    0,
                    0,
                    i.width,
                    i.height
                ]), i.gpuTimingDeferredRenderStart(), this.renderingToTexture = !1, function(t1, i, o, r, n) {
                    if ("globe" === t1.transform.projection.name) !function(t1, i, o, r, n) {
                        const s = t1.context, a = s.gl;
                        let l, c;
                        const h = t1.transform, d = e1.dk(t1, s, h), _ = (e1, i)=>{
                            if (c === i) return;
                            const o = [
                                Yr[i],
                                "PROJECTION_GLOBE_VIEW"
                            ];
                            d && o.push("CUSTOM_ANTIALIASING");
                            const r = t1.isTileAffectedByFog(e1);
                            l = t1.getOrCreateProgram("globeRaster", {
                                defines: o,
                                overrideFog: r
                            }), c = i;
                        }, u = t1.colorModeForRenderPass(), p = new Hi(a.LEQUAL, Hi.ReadWrite, t1.depthRangeFor3D);
                        Xr.update(n);
                        const f = e1.dl(h), m = [
                            e1.aH(h.center.lng),
                            e1.aL(h.center.lat)
                        ], g = t1.globeSharedBuffers, v = [
                            h.width * e1.o.devicePixelRatio,
                            h.height * e1.o.devicePixelRatio
                        ], y = Float32Array.from(h.globeMatrix), x = {
                            useDenormalizedUpVectorScale: !0
                        };
                        {
                            const h = t1.transform, d = Kr(h.zoom, i.exaggeration(), i.sourceCache._source.tileSize);
                            c = -1;
                            const b = a.TRIANGLES;
                            for (const c of r){
                                const r = o.getTile(c), w = $i.disabled, T = i.prevTerrainTileForTile[c.key], E = i.terrainTileForTile[c.key];
                                $r(T, E) && Xr.newMorphing(c.key, T, E, n, 250), Jr(t1, r.emissiveTexture), s.activeTexture.set(a.TEXTURE0), r.texture && r.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                                const S = Xr.getMorphValuesForProxy(c.key), C = S ? 1 : 0;
                                S && Object.assign(x, {
                                    morphing: {
                                        srcDemTile: S.from,
                                        dstDemTile: S.to,
                                        phase: e1.dj(S.phase)
                                    }
                                });
                                const I = e1.dm(c.canonical), R = e1.dn(I.getCenter().lat), D = e1.dp(c.canonical, I, R, h.worldSize / h._pixelsPerMercatorPixel), A = e1.dq(e1.dr(c.canonical)), L = "mrt-fallback" === t1.emissiveMode ? 1 : 0, P = Wr(h.expandedFarZProjMatrix, y, f, A, e1.al(h.zoom), m, h.frustumCorners.TL, h.frustumCorners.TR, h.frustumCorners.BR, h.frustumCorners.BL, h.globeCenterInViewSpace, h.globeRadius, v, d, h._farZ, L, D);
                                if (_(c, C), l && (i.setupElevationDraw(r, l, x), t1.uploadCommonUniforms(s, l, c.toUnwrapped()), g)) {
                                    const [e1, i, o] = g.getGridBuffers(R, 0 !== d);
                                    l.draw(t1, b, p, w, u, Ki.backCCW, P, "globe_raster", e1, i, o);
                                }
                            }
                        }
                        if (g && (t1.renderDefaultNorthPole || t1.renderDefaultSouthPole)) {
                            const n = [
                                "GLOBE_POLES",
                                "PROJECTION_GLOBE_VIEW"
                            ];
                            d && n.push("CUSTOM_ANTIALIASING"), l = t1.getOrCreateProgram("globeRaster", {
                                defines: n
                            });
                            for (const n of r){
                                const { x: r, y: c, z: d } = n.canonical, _ = 0 === c, f = c === (1 << d) - 1, [y, b, w, T] = g.getPoleBuffers(d, !1);
                                if (T && (_ || f)) {
                                    const c = o.getTile(n);
                                    Jr(t1, c.emissiveTexture), s.activeTexture.set(a.TEXTURE0), c.texture && c.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                                    let g = e1.ds(d, r, h);
                                    const E = e1.dq(e1.dr(n.canonical)), S = "mrt-fallback" === t1.emissiveMode ? 1 : 0, C = (e1, i)=>e1.draw(t1, a.TRIANGLES, p, $i.disabled, u, Ki.disabled, Wr(h.expandedFarZProjMatrix, g, g, E, 0, m, h.frustumCorners.TL, h.frustumCorners.TR, h.frustumCorners.BR, h.frustumCorners.BL, h.globeCenterInViewSpace, h.globeRadius, v, 0, h._farZ, S), "globe_pole_raster", i, w, T);
                                    i.setupElevationDraw(c, l, x), t1.uploadCommonUniforms(s, l, n.toUnwrapped()), _ && t1.renderDefaultNorthPole && C(l, y), f && t1.renderDefaultSouthPole && (g = e1.cx(e1.bc(), g, [
                                        1,
                                        -1,
                                        1
                                    ]), C(l, b));
                                }
                            }
                        }
                    }(t1, i, o, r, n);
                    else {
                        const s = t1.context, a = s.gl;
                        let l, c;
                        const h = t1.shadowRenderer, d = ao(t1, t1.longestCutoffRange), _ = (e1)=>{
                            if (c === e1) return;
                            const i = [];
                            i.push(Yr[e1]), d.shouldRenderCutoff && i.push("RENDER_CUTOFF"), h && (i.push("RENDER_SHADOWS"), h.useNormalOffset && i.push("NORMAL_OFFSET")), l = t1.getOrCreateProgram("terrainRaster", {
                                defines: i
                            }), c = e1;
                        }, u = t1.colorModeForRenderPass(), p = new Hi(a.LEQUAL, Hi.ReadWrite, t1.depthRangeFor3D);
                        Xr.update(n);
                        const f = t1.transform, m = Kr(f.zoom, i.exaggeration(), i.sourceCache._source.tileSize);
                        let g = [
                            0,
                            0,
                            0
                        ];
                        if (h) {
                            const e1 = t1.style.directionalLight, i = t1.style.ambientLight;
                            e1 && i && (g = fo(t1.style, e1, i));
                        }
                        {
                            c = -1;
                            const v = a.TRIANGLES, [y, x] = [
                                i.gridIndexBuffer,
                                i.gridSegments
                            ];
                            for (const c of r){
                                const r = o.getTile(c), b = $i.disabled, w = i.prevTerrainTileForTile[c.key], T = i.terrainTileForTile[c.key];
                                $r(w, T) && Xr.newMorphing(c.key, w, T, n, 250), Jr(t1, r.emissiveTexture), s.activeTexture.set(a.TEXTURE0), r.texture && r.texture.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                                const E = Xr.getMorphValuesForProxy(c.key), S = E ? 1 : 0;
                                let C;
                                E && (C = {
                                    morphing: {
                                        srcDemTile: E.from,
                                        dstDemTile: E.to,
                                        phase: e1.dj(E.phase)
                                    }
                                });
                                const I = "mrt-fallback" === t1.emissiveMode ? 1 : 0, R = Hr(c.projMatrix, Qr(c.canonical, f.renderWorldCopies) ? m / 10 : m, g, I);
                                if (_(S), !l) continue;
                                i.setupElevationDraw(r, l, C);
                                const D = c.toUnwrapped();
                                h && h.setupShadows(D, l), t1.uploadCommonUniforms(s, l, D, null, d), l.draw(t1, v, p, b, u, Ki.backCCW, R, "terrain_raster", i.gridBuffer, y, x);
                            }
                        }
                    }
                }(i, this, this.proxySourceCache, t1, this._updateTimestamp), this.renderingToTexture = !0, i.gpuTimingDeferredRenderEnd(), t1.splice(0, t1.length));
            }
            renderBatch(t1) {
                if (0 === this._drapedRenderBatches.length) return t1 + 1;
                this.renderingToTexture = !0;
                const i = this.painter, o = this.painter.context, r = this.proxySourceCache, n = this.proxiedCoords[r.id], s = this._drapedRenderBatches.shift(), a = i.style.order, l = [];
                this._updateFBOs("mrt-fallback" === i.emissiveMode);
                let c = 0;
                for (const h of n){
                    const n = r.getTileByID(h.proxyTileKey), d = r.proxyCachedFBO[h.key] ? r.proxyCachedFBO[h.key][t1] : void 0, _ = void 0 !== d ? r.renderCache[d] : this.pool[c++], u = void 0 !== d;
                    if (n.texture = _.tex, n.emissiveTexture = _.emissiveTex, u && !_.dirty) {
                        l.push(n.tileID);
                        continue;
                    }
                    o.bindFramebuffer.set(_.fb.framebuffer);
                    const p = o.gl;
                    let f;
                    p.drawBuffers("mrt-fallback" === i.emissiveMode ? [
                        p.COLOR_ATTACHMENT0,
                        p.COLOR_ATTACHMENT1
                    ] : [
                        p.COLOR_ATTACHMENT0
                    ]), this.renderedToTile = !1, _.dirty && (o.clear({
                        color: e1.aq.transparent,
                        stencil: 0
                    }), _.dirty = !1);
                    for(let e1 = s.start; e1 <= s.end; ++e1){
                        const t1 = i.style._mergedLayers[a[e1]];
                        if (t1.isHidden(i.transform.zoom)) continue;
                        const r = i.style.getLayerSourceCache(t1), n = r ? this.proxyToSource[h.key][r.id] : [
                            h
                        ];
                        if (!n) continue;
                        const s = n;
                        o.viewport.set([
                            0,
                            0,
                            _.fb.width,
                            _.fb.height
                        ]), f !== (r ? r.id : null) && (this._setupStencil(_, n, t1, r), f = r ? r.id : null), i.renderLayer(i, r, t1, s);
                    }
                    if (p.drawBuffers([
                        p.COLOR_ATTACHMENT0
                    ]), 0 === this._drapedRenderBatches.length) for (const e1 of this._pendingGroundEffectLayers){
                        const t1 = i.style._mergedLayers[a[e1]];
                        if (t1.isHidden(i.transform.zoom)) continue;
                        const r = i.style.getLayerSourceCache(t1), n = r ? this.proxyToSource[h.key][r.id] : [
                            h
                        ];
                        if (!n) continue;
                        const s = n;
                        o.viewport.set([
                            0,
                            0,
                            _.fb.width,
                            _.fb.height
                        ]), f !== (r ? r.id : null) && (this._setupStencil(_, n, t1, r), f = r ? r.id : null), i.renderLayer(i, r, t1, s);
                    }
                    this.renderedToTile ? (_.dirty = !0, l.push(n.tileID)) : u || --c, 5 === c && (c = 0, this.renderToBackBuffer(l));
                }
                return this.renderToBackBuffer(l), this.renderingToTexture = !1, o.bindFramebuffer.set(null), o.viewport.set([
                    0,
                    0,
                    i.width,
                    i.height
                ]), s.end + 1;
            }
            postRender() {}
            isLayerOrderingCorrect(e1) {
                const t1 = e1.order.length;
                let i = -1, o = t1;
                for(let r = 0; r < t1; ++r)this._style.isLayerDraped(e1._mergedLayers[e1.order[r]]) ? i = Math.max(i, r) : o = Math.min(o, r);
                return o > i;
            }
            getMinElevationBelowMSL() {
                let e1 = 0;
                return this._visibleDemTiles.filter((e1)=>e1.dem).forEach((t1)=>{
                    e1 = Math.min(e1, t1.dem.tree.minimums[0]);
                }), 0 === e1 ? e1 : (e1 - 30) * this._exaggeration;
            }
            raycast(e1, t1, i) {
                if (!this._visibleDemTiles) return null;
                const o = this._visibleDemTiles.filter((e1)=>e1.dem).map((o)=>{
                    const r = o.tileID, n = 1 << r.overscaledZ, { x: s, y: a } = r.canonical, l = s / n, c = (s + 1) / n, h = a / n, d = (a + 1) / n;
                    return {
                        minx: l,
                        miny: h,
                        maxx: c,
                        maxy: d,
                        t: o.dem.tree.raycastRoot(l, h, c, d, e1, t1, i),
                        tile: o
                    };
                });
                o.sort((e1, t1)=>(null !== e1.t ? e1.t : Number.MAX_VALUE) - (null !== t1.t ? t1.t : Number.MAX_VALUE));
                for (const r of o){
                    if (null == r.t) return null;
                    const o = r.tile.dem.tree.raycast(r.minx, r.miny, r.maxx, r.maxy, e1, t1, i);
                    if (null != o) return o;
                }
                return null;
            }
            _createFBO() {
                const t1 = this.painter.context, i = t1.gl, o = this.drapeBufferSize;
                t1.activeTexture.set(i.TEXTURE0);
                const r = new e1.T(t1, {
                    width: o[0],
                    height: o[1],
                    data: null
                }, i.RGBA8);
                r.bind(i.LINEAR, i.CLAMP_TO_EDGE);
                const n = t1.createFramebuffer(o[0], o[1], 1, null);
                let s;
                return n.colorAttachment0.set(r.texture), this._emissiveTexture && (s = new e1.T(t1, {
                    width: o[0],
                    height: o[1],
                    data: null
                }, i.R8), s.bind(i.LINEAR, i.CLAMP_TO_EDGE), n.createColorAttachment(t1, 1), n.colorAttachment1.set(s.texture)), n.depthAttachment = new Zr(t1, n.framebuffer), void 0 === this._sharedDepthStencil ? (this._sharedDepthStencil = t1.createRenderbuffer(t1.gl.DEPTH_STENCIL, o[0], o[1]), this._stencilRef = 0, n.depthAttachment.set(this._sharedDepthStencil), t1.clear({
                    stencil: 0
                })) : n.depthAttachment.set(this._sharedDepthStencil), t1.extTextureFilterAnisotropic && i.texParameterf(i.TEXTURE_2D, t1.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, t1.extTextureFilterAnisotropicMax), {
                    fb: n,
                    tex: r,
                    emissiveTex: s,
                    dirty: !1
                };
            }
            _updateFBOs(e1) {
                if (this._emissiveTexture !== e1) {
                    for (const t1 of this.pool)this._updateFBO(t1, e1);
                    for (const t1 of this.proxySourceCache.renderCache)this._updateFBO(t1, e1);
                    this._emissiveTexture = e1;
                }
            }
            _updateFBO(t1, i) {
                const o = t1.fb, r = this.painter.context, n = r.gl, s = this.drapeBufferSize;
                if (i) {
                    const i = new e1.T(r, {
                        width: s[0],
                        height: s[1],
                        data: null
                    }, n.R8);
                    i.bind(n.LINEAR, n.CLAMP_TO_EDGE), t1.emissiveTex = i, o.createColorAttachment(r, 1), o.colorAttachment1.set(i.texture);
                } else t1.emissiveTex = void 0, o.removeColorAttachment(r, 1);
                t1.dirty = !0;
            }
            _initFBOPool() {
                for(; this.pool.length < Math.min(5, this.proxyCoords.length);)this.pool.push(this._createFBO());
            }
            _shouldDisableRenderCache() {
                if (this._debugParams.disableRenderCache) return !0;
                if (this._style.hasLightTransitions()) return !0;
                for(const e1 in this._style._mergedSourceCaches)if (this._style._mergedSourceCaches[e1].hasTransition()) return !0;
                return this._style.order.some((e1)=>{
                    const t1 = this._style._mergedLayers[e1], i = t1.isHidden(this.painter.transform.zoom);
                    return "hillshade" === t1.type || "custom" === t1.type ? !i && t1.shouldRedrape() : !i && t1.hasTransition();
                });
            }
            _clearLineLayersFromRenderCache() {
                let t1 = !1;
                for (const e1 of this._style.getSources())if (e1 instanceof xt) {
                    t1 = !0;
                    break;
                }
                if (!t1) return;
                const i = {};
                for(let t1 = 0; t1 < this._style.order.length; ++t1){
                    const o = this._style._mergedLayers[this._style.order[t1]], r = this._style.getLayerSourceCache(o);
                    if (!r || i[r.id]) continue;
                    if (o.isHidden(this.painter.transform.zoom) || "line" !== o.type) continue;
                    const n = o.widthExpression(), s = o.emissiveStrengthExpression();
                    if (n instanceof e1.af || s instanceof e1.af) {
                        i[r.id] = !0;
                        for (const e1 of this.proxyCoords){
                            const t1 = this.proxyToSource[e1.key][r.id];
                            if (t1) for (const e1 of t1)this._clearRenderCacheForTile(r.id, e1);
                        }
                    }
                }
            }
            _clearRasterLayersFromRenderCache() {
                let e1 = !1;
                for(const t1 in this._style._mergedSourceCaches)if (this._style._mergedSourceCaches[t1]._source instanceof bt) {
                    e1 = !0;
                    break;
                }
                if (!e1) return;
                const t1 = {};
                for(let e1 = 0; e1 < this._style.order.length; ++e1){
                    const i = this._style._mergedLayers[this._style.order[e1]], o = this._style.getLayerSourceCache(i);
                    if (!o || t1[o.id]) continue;
                    if (i.isHidden(this.painter.transform.zoom) || "raster" !== i.type) continue;
                    const r = i.paint.get("raster-fade-duration");
                    for (const e1 of this.proxyCoords){
                        const t1 = this.proxyToSource[e1.key][o.id];
                        if (t1) for (const e1 of t1){
                            const t1 = tn(o.getTile(e1), o.findLoadedParent(e1, 0), o, this.painter.transform, r);
                            (1 !== t1.opacity || 0 !== t1.mix) && this._clearRenderCacheForTile(o.id, e1);
                        }
                    }
                }
            }
            _setupDrapedRenderBatches() {
                this._style.updateDrapeFirstLayers();
                const t1 = this._style.order, i = t1.length;
                if (0 === i) return;
                const o = [];
                this._pendingGroundEffectLayers = [];
                let r, n = 0, s = this._style._mergedLayers[t1[n]];
                for(; !this._style.isLayerDraped(s) && s.isHidden(this.painter.transform.zoom) && ++n < i;)s = this._style._mergedLayers[t1[n]];
                for(; n < i; ++n){
                    const e1 = this._style._mergedLayers[t1[n]];
                    e1.isHidden(this.painter.transform.zoom) || (this._style.isLayerDraped(e1) ? void 0 === r && (r = n) : ("fill-extrusion" === e1.type && this._pendingGroundEffectLayers.push(n), void 0 !== r && (o.push({
                        start: r,
                        end: n - 1
                    }), r = void 0)));
                }
                if (void 0 !== r && o.push({
                    start: r,
                    end: n - 1
                }), 0 !== o.length) {
                    const t1 = o[o.length - 1];
                    this._pendingGroundEffectLayers.every((e1)=>e1 > t1.end) || e1.w("fill-extrusion with flood lighting and/or ground ambient occlusion should be moved to be on top of all draped layers.");
                }
                this._drapedRenderBatches = o;
            }
            _setupRenderCache(e1) {
                const t1 = this.proxySourceCache;
                if (this._shouldDisableRenderCache() || this.invalidateRenderCache) {
                    if (this.invalidateRenderCache = !1, t1.renderCache.length > t1.renderCachePool.length) {
                        const e1 = Object.values(t1.proxyCachedFBO);
                        t1.proxyCachedFBO = {};
                        for(let i = 0; i < e1.length; ++i){
                            const o = Object.values(e1[i]);
                            t1.renderCachePool.push(...o);
                        }
                    }
                    return;
                }
                this._clearRasterLayersFromRenderCache();
                const i = this.proxyCoords, o = this._tilesDirty;
                for(let r = i.length - 1; r >= 0; r--){
                    const n = i[r];
                    if (t1.getTileByID(n.key), void 0 !== t1.proxyCachedFBO[n.key]) {
                        const i = e1[n.key], r = this.proxyToSource[n.key];
                        let s = 0;
                        for(const e1 in r){
                            const t1 = r[e1], n = i[e1];
                            if (!n || n.length !== t1.length || t1.some((t1, i)=>t1 !== n[i] || o[e1] && o[e1].hasOwnProperty(t1.key))) {
                                s = -1;
                                break;
                            }
                            ++s;
                        }
                        for(const e1 in t1.proxyCachedFBO[n.key])t1.renderCache[t1.proxyCachedFBO[n.key][e1]].dirty = s < 0 || s !== Object.values(i).length;
                    }
                }
                const r = [
                    ...this._drapedRenderBatches
                ];
                r.sort((e1, t1)=>t1.end - t1.start - (e1.end - e1.start));
                for (const e1 of r)for (const o of i){
                    if (t1.proxyCachedFBO[o.key]) continue;
                    let i = t1.renderCachePool.pop();
                    void 0 === i && t1.renderCache.length < 50 && (i = t1.renderCache.length, t1.renderCache.push(this._createFBO())), void 0 !== i && (t1.proxyCachedFBO[o.key] = {}, t1.proxyCachedFBO[o.key][e1.start] = i, t1.renderCache[i].dirty = !0);
                }
                this._tilesDirty = {};
            }
            _setupStencil(e1, t1, i, o) {
                if (!o || !this._sourceTilesOverlap[o.id]) return void (this._overlapStencilType && (this._overlapStencilType = !1));
                const r = this.painter.context, n = r.gl;
                if (t1.length <= 1) return void (this._overlapStencilType = !1);
                let s;
                if (i.isTileClipped()) s = t1.length, this._overlapStencilMode.test = {
                    func: n.EQUAL,
                    mask: 255
                }, this._overlapStencilType = "Clip";
                else {
                    if (!(t1[0].overscaledZ > t1[t1.length - 1].overscaledZ)) return void (this._overlapStencilType = !1);
                    s = 1, this._overlapStencilMode.test = {
                        func: n.GREATER,
                        mask: 255
                    }, this._overlapStencilType = "Mask";
                }
                this._stencilRef + s > 255 && (r.clear({
                    stencil: 0
                }), this._stencilRef = 0), this._stencilRef += s, this._overlapStencilMode.ref = this._stencilRef, i.isTileClipped() && this._renderTileClippingMasks(t1, this._overlapStencilMode.ref);
            }
            clipOrMaskOverlapStencilType() {
                return "Clip" === this._overlapStencilType || "Mask" === this._overlapStencilType;
            }
            stencilModeForRTTOverlap(e1) {
                return this.renderingToTexture && this._overlapStencilType ? ("Clip" === this._overlapStencilType && (this._overlapStencilMode.ref = this.painter._tileClippingMaskIDs[e1.key]), this._overlapStencilMode) : $i.disabled;
            }
            _renderTileClippingMasks(e1, t1) {
                const i = this.painter, o = this.painter.context, r = o.gl;
                i._tileClippingMaskIDs = {}, o.setColorMode(Zi.disabled), o.setDepthMode(Hi.disabled);
                const n = i.getOrCreateProgram("clippingMask");
                for (const o of e1){
                    const e1 = i._tileClippingMaskIDs[o.key] = --t1;
                    n.draw(i, r.TRIANGLES, Hi.disabled, new $i({
                        func: r.ALWAYS,
                        mask: 0
                    }, e1, 255, r.KEEP, r.KEEP, r.REPLACE), Zi.disabled, Ki.disabled, en(o.projMatrix), "$clipping", i.tileExtentBuffer, i.quadTriangleIndexBuffer, i.tileExtentSegments);
                }
            }
            pointCoordinate(t1) {
                const i = this.painter.transform;
                if (t1.x < 0 || t1.x > i.width || t1.y < 0 || t1.y > i.height) return null;
                const o = [
                    t1.x,
                    t1.y,
                    1,
                    1
                ];
                e1.aE(o, o, i.pixelMatrixInverse), e1.cp(o, o, 1 / o[3]), o[0] /= i.worldSize, o[1] /= i.worldSize;
                const r = i._camera.position, n = e1.bV(1, i.center.lat), s = [
                    r[0],
                    r[1],
                    r[2] / n,
                    0
                ], a = e1.cR([], o.slice(0, 3), s);
                e1.ay(a, a);
                const l = this.raycast(s, a, this._exaggeration);
                return null !== l && l ? (e1.bh(s, s, a, l), s[3] = s[2], s[2] *= n, s) : null;
            }
            _setupProxiedCoordsForOrtho(t1, i, o) {
                if (t1.getSource() instanceof e1.aW) return this._setupProxiedCoordsForImageSource(t1, i, o);
                this._findCoveringTileCache[t1.id] = this._findCoveringTileCache[t1.id] || {};
                const r = this.proxiedCoords[t1.id] = [], n = this.proxyCoords;
                for(let e1 = 0; e1 < n.length; e1++){
                    const i = n[e1], s = this._findTileCoveringTileID(i, t1);
                    if (s) {
                        const e1 = this._createProxiedId(i, s, o[i.key] && o[i.key][t1.id]);
                        r.push(e1), this.proxyToSource[i.key][t1.id] = [
                            e1
                        ];
                    }
                }
                let s = !1;
                const a = new Set;
                for(let e1 = 0; e1 < i.length; e1++){
                    const n = t1.getTile(i[e1]);
                    if (!n || !n.hasData()) continue;
                    const l = this._findTileCoveringTileID(n.tileID, this.proxySourceCache);
                    if (l && l.tileID.canonical.z !== n.tileID.canonical.z) {
                        const e1 = this.proxyToSource[l.tileID.key][t1.id], i = this._createProxiedId(l.tileID, n, o[l.tileID.key] && o[l.tileID.key][t1.id]);
                        e1 ? e1.splice(e1.length - 1, 0, i) : this.proxyToSource[l.tileID.key][t1.id] = [
                            i
                        ];
                        const c = this.proxyToSource[l.tileID.key][t1.id];
                        a.has(c) || a.add(c), r.push(i), s = !0;
                    }
                }
                if (this._sourceTilesOverlap[t1.id] = s, s && this._debugParams.sortTilesHiZFirst) for (const e1 of a)e1.sort((e1, t1)=>t1.overscaledZ - e1.overscaledZ);
            }
            _setupProxiedCoordsForImageSource(t1, i, o) {
                if (!t1.getSource().loaded()) return;
                const r = this.proxiedCoords[t1.id] = [], n = this.proxyCoords, s = t1.getSource(), a = s.tileID;
                if (!a) return;
                const l = new e1.P(a.x, a.y)._div(1 << a.z), c = s.coordinates.map(e1.ag.fromLngLat).reduce((e1, t1)=>(e1.min.x = Math.min(e1.min.x, t1.x - l.x), e1.min.y = Math.min(e1.min.y, t1.y - l.y), e1.max.x = Math.max(e1.max.x, t1.x - l.x), e1.max.y = Math.max(e1.max.y, t1.y - l.y), e1), {
                    min: new e1.P(Number.MAX_VALUE, Number.MAX_VALUE),
                    max: new e1.P(-Number.MAX_VALUE, -Number.MAX_VALUE)
                }), h = (t1, i)=>{
                    const o = t1.wrap + t1.canonical.x / (1 << t1.canonical.z), r = t1.canonical.y / (1 << t1.canonical.z), n = e1.an / (1 << t1.canonical.z), s = i.wrap + i.canonical.x / (1 << i.canonical.z), a = i.canonical.y / (1 << i.canonical.z);
                    return o + n < s + c.min.x || o > s + c.max.x || r + n < a + c.min.y || r > a + c.max.y;
                };
                for(let e1 = 0; e1 < n.length; e1++){
                    const s = n[e1];
                    for(let e1 = 0; e1 < i.length; e1++){
                        const n = t1.getTile(i[e1]);
                        if (!n || !n.hasData()) continue;
                        if (h(s, n.tileID)) continue;
                        const a = this._createProxiedId(s, n, o[s.key] && o[s.key][t1.id]), l = this.proxyToSource[s.key][t1.id];
                        l ? l.push(a) : this.proxyToSource[s.key][t1.id] = [
                            a
                        ], r.push(a);
                    }
                }
            }
            _createProxiedId(t1, i, o) {
                let r = this.orthoMatrix;
                if (o) {
                    const e1 = o.find((e1)=>e1.key === i.tileID.key);
                    if (e1) return e1;
                }
                if (i.tileID.key !== t1.key) {
                    const o = t1.canonical.z - i.tileID.canonical.z;
                    let n, s, a;
                    r = e1.bc();
                    const l = i.tileID.wrap - t1.wrap << t1.overscaledZ;
                    o > 0 ? (n = e1.an >> o, s = n * ((i.tileID.canonical.x << o) - t1.canonical.x + l), a = n * ((i.tileID.canonical.y << o) - t1.canonical.y)) : (n = e1.an << -o, s = e1.an * (i.tileID.canonical.x - (t1.canonical.x + l << -o)), a = e1.an * (i.tileID.canonical.y - (t1.canonical.y << -o))), e1.bU(r, 0, n, 0, n, 0, 1), e1.by(r, r, [
                        s,
                        a,
                        0
                    ]);
                }
                return new nn(i.tileID, t1.key, r);
            }
            _findTileCoveringTileID(t1, i) {
                let o = i.getTile(t1);
                if (o && o.hasData()) return o;
                const r = this._findCoveringTileCache[i.id], n = r[t1.key];
                if (o = n ? i.getTileByID(n) : null, o && o.hasData() || null === n) return o;
                let s = o ? o.tileID : t1, a = s.overscaledZ;
                const l = i.getSource().minzoom, c = [];
                if (!n) {
                    const r = i.getSource().maxzoom;
                    if (t1.canonical.z >= r) {
                        const o = t1.canonical.z - r;
                        i.getSource().reparseOverscaled ? (a = Math.max(t1.canonical.z + 2, i.transform.tileZoom), s = new e1.aS(a, t1.wrap, r, t1.canonical.x >> o, t1.canonical.y >> o)) : 0 !== o && (a = r, s = new e1.aS(a, t1.wrap, r, t1.canonical.x >> o, t1.canonical.y >> o));
                    }
                    s.key !== t1.key && (c.push(s.key), o = i.getTile(s));
                }
                const h = (e1)=>{
                    c.forEach((t1)=>{
                        r[t1] = e1;
                    }), c.length = 0;
                };
                for(a -= 1; a >= l && (!o || !o.hasData()); a--){
                    o && h(o.tileID.key);
                    const e1 = s.calculateScaledKey(a);
                    if (o = i.getTileByID(e1), o && o.hasData()) break;
                    const t1 = r[e1];
                    if (null === t1) break;
                    void 0 === t1 ? c.push(e1) : o = i.getTileByID(t1);
                }
                return h(o ? o.tileID.key : null), o && o.hasData() ? o : null;
            }
            findDEMTileFor(e1) {
                return this.enabled ? this._findTileCoveringTileID(e1, this.sourceCache) : null;
            }
            prepareDrawTile() {
                this.renderedToTile = !0;
            }
            _clearRenderCacheForTile(e1, t1) {
                let i = this._tilesDirty[e1];
                i || (i = this._tilesDirty[e1] = {}), i[t1.key] = !0;
            }
        }
        function an(t1, i, o) {
            const r = function(t1, i, o) {
                const r = e1.bj(i, t1), n = e1.bj(o, [
                    .2126,
                    .7152,
                    .0722
                ]), s = (e1, t1, i)=>(1 - i) * e1 + i * t1, a = s(1 - .3 * Math.min(n, 1), 1, Math.min(r + 1, 1));
                return s(.92, 1, Math.asin(e1.aC(i[2], -1, 1)) / Math.PI + .5) * a;
            }(t1, [
                0,
                0,
                1
            ], i), n = [
                0,
                0,
                0
            ];
            e1.bK(n, o.slice(0, 3), r);
            const s = [
                0,
                0,
                0
            ];
            e1.bK(s, i.slice(0, 3), t1[2]);
            const a = [
                0,
                0,
                0
            ];
            return e1.cP(a, n, s), e1.cS(a);
        }
        const ln = [
            "fill",
            "fillOutline",
            "fillPattern",
            "line",
            "linePattern",
            "background",
            "backgroundPattern",
            "hillshade",
            "raster"
        ], cn = [
            "stars",
            "rainParticle",
            "snowParticle",
            "fillExtrusion",
            "fillExtrusionGroundEffect",
            "building",
            "buildingBloom",
            "elevatedStructures",
            "model",
            "symbol"
        ];
        class hn {
            static cacheKey(e1, t1, i, o) {
                const r = [
                    t1
                ];
                o && r.push(o.cacheKey);
                for (const t1 of i)("string" == typeof t1 && t1.includes(" ") || e1.usedDefines.has(t1)) && r.push(t1);
                return r.join("/");
            }
            constructor(t1, i, o, r, n, s){
                const a = t1.gl;
                this.program = a.createProgram(), this.configuration = r, this.name = i, this.fixedDefines = [
                    ...s
                ];
                const l = `#version 300 es\n${(r ? r.defines() : []).concat(s.map((e1)=>`#define ${e1}`)).join("\n")}`, c = [
                    l,
                    Qo
                ];
                for (const e1 of o.fragmentIncludes)c.push($o[e1]);
                c.push(o.fragmentSource);
                const h = c.join("\n"), d = [
                    l,
                    Jo
                ];
                for (const e1 of o.vertexIncludes)d.push($o[e1]);
                this.forceManualRenderingForInstanceIDShaders = t1.forceManualRenderingForInstanceIDShaders && o.vertexSource.includes("gl_InstanceID"), this.forceManualRenderingForInstanceIDShaders && d.push("uniform int u_instanceID;"), d.push(o.vertexSource);
                let _ = d.join("\n");
                this.forceManualRenderingForInstanceIDShaders && (_ = _.replaceAll("gl_InstanceID", "u_instanceID"));
                const u = a.createShader(a.FRAGMENT_SHADER);
                if (a.isContextLost()) return void (this.failedToCreate = !0);
                a.shaderSource(u, h), a.compileShader(u), a.attachShader(this.program, u);
                const p = a.createShader(a.VERTEX_SHADER);
                a.isContextLost() ? this.failedToCreate = !0 : (a.shaderSource(p, _), a.compileShader(p), a.attachShader(this.program, p), this.attributes = {}, a.linkProgram(this.program), a.deleteShader(p), a.deleteShader(u), this.fixedUniforms = n(t1), this.fixedUniformsEntries = Object.entries(this.fixedUniforms), this.binderUniforms = r ? r.getUniforms(t1) : [], this.forceManualRenderingForInstanceIDShaders && (this.instancingUniforms = ((t1)=>({
                        u_instanceID: new e1.bY(t1)
                    }))(t1)), (s.includes("TERRAIN") || s.includes("ELEVATED") || i.includes("symbol") || i.includes("circle")) && (this.terrainUniforms = ((t1)=>({
                        u_dem: new e1.bY(t1),
                        u_dem_prev: new e1.bY(t1),
                        u_dem_tl: new e1.b$(t1),
                        u_dem_scale: new e1.b_(t1),
                        u_dem_tl_prev: new e1.b$(t1),
                        u_dem_scale_prev: new e1.b_(t1),
                        u_dem_size: new e1.b_(t1),
                        u_dem_lerp: new e1.b_(t1),
                        u_exaggeration: new e1.b_(t1),
                        u_depth: new e1.bY(t1),
                        u_depth_size_inv: new e1.b$(t1),
                        u_depth_range_unpack: new e1.b$(t1),
                        u_occluder_half_size: new e1.b_(t1),
                        u_occlusion_depth_offset: new e1.b_(t1),
                        u_meter_to_dem: new e1.b_(t1),
                        u_label_plane_matrix_inv: new e1.c0(t1)
                    }))(t1)), s.includes("GLOBE") && (this.globeUniforms = ((t1)=>({
                        u_tile_tl_up: new e1.bZ(t1),
                        u_tile_tr_up: new e1.bZ(t1),
                        u_tile_br_up: new e1.bZ(t1),
                        u_tile_bl_up: new e1.bZ(t1),
                        u_tile_up_scale: new e1.b_(t1)
                    }))(t1)), s.includes("FOG") && (this.fogUniforms = ((t1)=>({
                        u_fog_matrix: new e1.c0(t1),
                        u_fog_range: new e1.b$(t1),
                        u_fog_color: new e1.cK(t1),
                        u_fog_horizon_blend: new e1.b_(t1),
                        u_fog_vertical_limit: new e1.b$(t1),
                        u_fog_temporal_offset: new e1.b_(t1),
                        u_frustum_tl: new e1.bZ(t1),
                        u_frustum_tr: new e1.bZ(t1),
                        u_frustum_br: new e1.bZ(t1),
                        u_frustum_bl: new e1.bZ(t1),
                        u_globe_pos: new e1.bZ(t1),
                        u_globe_radius: new e1.b_(t1),
                        u_globe_transition: new e1.b_(t1),
                        u_is_globe: new e1.bY(t1),
                        u_viewport: new e1.b$(t1)
                    }))(t1)), s.includes("RENDER_CUTOFF") && (this.cutoffUniforms = ((t1)=>({
                        u_cutoff_params: new e1.cK(t1)
                    }))(t1)), s.includes("LIGHTING_3D_MODE") && (this.lightsUniforms = ((t1)=>({
                        u_lighting_ambient_color: new e1.bZ(t1),
                        u_lighting_directional_dir: new e1.bZ(t1),
                        u_lighting_directional_color: new e1.bZ(t1),
                        u_ground_radiance: new e1.bZ(t1)
                    }))(t1)), s.includes("RENDER_SHADOWS") && (this.shadowUniforms = ((t1)=>({
                        u_light_matrix_0: new e1.c0(t1),
                        u_light_matrix_1: new e1.c0(t1),
                        u_fade_range: new e1.b$(t1),
                        u_shadow_normal_offset: new e1.bZ(t1),
                        u_shadow_intensity: new e1.b_(t1),
                        u_shadow_texel_size: new e1.b_(t1),
                        u_shadow_map_resolution: new e1.b_(t1),
                        u_shadow_direction: new e1.bZ(t1),
                        u_shadow_bias: new e1.bZ(t1),
                        u_shadowmap_0: new e1.bY(t1),
                        u_shadowmap_1: new e1.bY(t1)
                    }))(t1)));
            }
            getAttributeLocation(e1, t1) {
                let i = this.attributes[t1];
                return void 0 === i && (i = this.attributes[t1] = e1.getAttribLocation(this.program, t1)), i;
            }
            setTerrainUniformValues(e1, t1) {
                if (!this.terrainUniforms) return;
                const i = this.terrainUniforms;
                if (!this.failedToCreate) {
                    e1.program.set(this.program);
                    for(const e1 in t1)i[e1] && i[e1].set(this.program, e1, t1[e1]);
                }
            }
            setGlobeUniformValues(e1, t1) {
                if (!this.globeUniforms) return;
                const i = this.globeUniforms;
                if (!this.failedToCreate) {
                    e1.program.set(this.program);
                    for(const e1 in t1)i[e1] && i[e1].set(this.program, e1, t1[e1]);
                }
            }
            setFogUniformValues(e1, t1) {
                if (!this.fogUniforms) return;
                const i = this.fogUniforms;
                if (!this.failedToCreate) {
                    e1.program.set(this.program);
                    for(const e1 in t1)i[e1].set(this.program, e1, t1[e1]);
                }
            }
            setCutoffUniformValues(e1, t1) {
                if (!this.cutoffUniforms) return;
                const i = this.cutoffUniforms;
                if (!this.failedToCreate) {
                    e1.program.set(this.program);
                    for(const e1 in t1)i[e1].set(this.program, e1, t1[e1]);
                }
            }
            setLightsUniformValues(e1, t1) {
                if (!this.lightsUniforms) return;
                const i = this.lightsUniforms;
                if (!this.failedToCreate) {
                    e1.program.set(this.program);
                    for(const e1 in t1)i[e1].set(this.program, e1, t1[e1]);
                }
            }
            setShadowUniformValues(e1, t1) {
                if (this.failedToCreate || !this.shadowUniforms) return;
                const i = this.shadowUniforms;
                e1.program.set(this.program);
                for(const e1 in t1)i[e1].set(this.program, e1, t1[e1]);
            }
            _drawDebugWireframe(t1, i, o, r, n, s, a, l, c, h) {
                const d = t1.options.wireframe;
                if (!1 === d.terrain && !1 === d.layers2D && !1 === d.layers3D) return;
                const _ = t1.context;
                if (!(()=>!(!d.terrain || "terrainRaster" !== this.name && "globeRaster" !== this.name) || !(!d.layers2D || t1._terrain && t1._terrain.renderingToTexture || !ln.includes(this.name)) || !(!d.layers3D || !cn.includes(this.name)))()) return;
                const u = _.gl, p = t1.wireframeDebugCache.getLinesFromTrianglesBuffer(t1.frameCounter, n, _);
                if (!p) return;
                const f = [
                    ...this.fixedDefines,
                    "DEBUG_WIREFRAME"
                ], m = t1.getOrCreateProgram(this.name, {
                    config: this.configuration,
                    defines: f
                });
                _.program.set(m.program);
                const g = (e1, t1, i)=>{
                    if (t1[e1] && i[e1]) for(const o in t1[e1])i[e1][o] && i[e1][o].set(i.program, o, t1[e1][o].current);
                };
                c && c.setUniforms(m.program, _, m.binderUniforms, a, {
                    zoom: l
                }), g("fixedUniforms", this, m), g("terrainUniforms", this, m), g("globeUniforms", this, m), g("fogUniforms", this, m), g("lightsUniforms", this, m), g("shadowUniforms", this, m), p.bind(), _.setColorMode(new Zi([
                    u.ONE,
                    u.ONE_MINUS_SRC_ALPHA,
                    u.ZERO,
                    u.ONE
                ], e1.aq.transparent, [
                    !0,
                    !0,
                    !0,
                    !1
                ])), _.setDepthMode(new Hi(i.func === u.LESS ? u.LEQUAL : i.func, Hi.ReadOnly, i.range)), _.setStencilMode($i.disabled);
                const v = 3 * s.primitiveLength * 2, y = 3 * s.primitiveOffset * 4;
                if (this.forceManualRenderingForInstanceIDShaders) {
                    const e1 = h || 1;
                    for(let t1 = 0; t1 < e1; ++t1)m.instancingUniforms.u_instanceID.set(this.program, "u_instanceID", t1), u.drawElements(u.LINES, v, u.UNSIGNED_SHORT, y);
                } else h && h > 1 ? u.drawElementsInstanced(u.LINES, v, u.UNSIGNED_SHORT, y, h) : u.drawElements(u.LINES, v, u.UNSIGNED_SHORT, y);
                n.bind(), _.program.set(this.program), _.setDepthMode(i), _.setStencilMode(o), _.setColorMode(r);
            }
            checkUniforms(e1, t1, i) {
                if (this.fixedDefines.includes(t1)) {
                    for (const o of Object.keys(i))if (!i[o].initialized) throw new Error(`Program '${this.name}', from draw '${e1}': uniform ${o} not set but required by ${t1} being defined`);
                }
            }
            draw(e1, t1, i, o, r, n, s, a, l, c, h, d, _, u, p, f) {
                const m = e1.context, g = m.gl;
                if (this.failedToCreate) return;
                m.program.set(this.program), m.setDepthMode(i), m.setStencilMode(o), m.setColorMode(r), m.setCullFace(n);
                for (const [e1, t1] of this.fixedUniformsEntries)t1.set(this.program, e1, s[e1]);
                u && u.setUniforms(this.program, m, this.binderUniforms, d, {
                    zoom: _
                });
                const v = {
                    [g.POINTS]: 1,
                    [g.LINES]: 2,
                    [g.TRIANGLES]: 3,
                    [g.LINE_STRIP]: 1
                }[t1];
                this.checkUniforms(a, "RENDER_SHADOWS", this.shadowUniforms);
                const y = p || [], x = u ? u.getPaintVertexBuffers() : [], b = t1 === g.TRIANGLES && c, w = f && f > 0 ? 1 : void 0;
                for (const n of h.get()){
                    const s = n.vaos || (n.vaos = {});
                    if ((s[a] || (s[a] = new rr)).bind(m, this, l, x, c, n.vertexOffset, y, w), this.forceManualRenderingForInstanceIDShaders) {
                        const e1 = f || 1;
                        for(let i = 0; i < e1; ++i)this.instancingUniforms.u_instanceID.set(this.program, "u_instanceID", i), c ? g.drawElements(t1, n.primitiveLength * v, g.UNSIGNED_SHORT, n.primitiveOffset * v * 2) : g.drawArrays(t1, n.vertexOffset, n.vertexLength);
                    } else f && f > 1 ? g.drawElementsInstanced(t1, n.primitiveLength * v, g.UNSIGNED_SHORT, n.primitiveOffset * v * 2, f) : c ? g.drawElements(t1, n.primitiveLength * v, g.UNSIGNED_SHORT, n.primitiveOffset * v * 2) : g.drawArrays(t1, n.vertexOffset, n.vertexLength);
                    b && this._drawDebugWireframe(e1, i, o, r, c, n, d, _, u, f);
                }
            }
        }
        function dn(t1, i, o = 0) {
            const r = Math.pow(2, i.tileID.overscaledZ), n = i.tileSize * Math.pow(2, t1.transform.tileZoom) / r, s = n * (i.tileID.canonical.x + i.tileID.wrap * r), a = n * i.tileID.canonical.y;
            return {
                u_image: 0,
                u_texsize: i.imageAtlasTexture ? i.imageAtlasTexture.size : [
                    0,
                    0
                ],
                u_tile_units_to_pixels: 1 / e1.aA(i, 1, t1.transform.tileZoom),
                u_pixel_coord_upper: [
                    s >> 16,
                    a >> 16
                ],
                u_pixel_coord_lower: [
                    65535 & s,
                    65535 & a
                ],
                u_pattern_transition: o
            };
        }
        const _n = {
            terrain: 0,
            flat: 1
        }, un = e1.bc(), pn = (t1, i, o, r, n, s, a, l, c, h, d, _, u, p, f, m, g, v, y = [
            0,
            0,
            1
        ])=>{
            const x = i.style.light, b = x.properties.get("position"), w = [
                b.x,
                b.y,
                b.z
            ], T = e1.dA();
            "viewport" === x.properties.get("anchor") && (e1.dB(T, -i.transform.angle), e1.dC(w, w, T));
            const E = x.properties.get("color").toPremultipliedRenderColor(null), S = i.transform, C = {
                u_matrix: t1,
                u_lightpos: w,
                u_lightintensity: x.properties.get("intensity"),
                u_lightcolor: [
                    E.r,
                    E.g,
                    E.b
                ],
                u_vertical_gradient: +o,
                u_opacity: r,
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_inv_rot_matrix: un,
                u_merc_center: [
                    0,
                    0
                ],
                u_up_dir: [
                    0,
                    0,
                    0
                ],
                u_height_lift: 0,
                u_height_type: _n[h],
                u_base_type: _n[d],
                u_ao: n,
                u_edge_radius: s,
                u_width_scale: a,
                u_flood_light_color: f,
                u_vertical_scale: m,
                u_flood_light_intensity: g,
                u_ground_shadow_factor: v,
                u_front_cutoff_params: y
            };
            return "globe" === S.projection.name && (C.u_tile_id = [
                l.canonical.x,
                l.canonical.y,
                1 << l.canonical.z
            ], C.u_zoom_transition = _, C.u_inv_rot_matrix = p, C.u_merc_center = u, C.u_up_dir = S.projection.upVector(new e1.ci(0, 0, 0), u[0] * e1.an, u[1] * e1.an), C.u_height_lift = c), C;
        }, fn = (e1, t1, i, o, r, n)=>({
                u_matrix: e1,
                u_edge_radius: t1,
                u_width_scale: i,
                u_vertical_scale: o,
                u_height_type: _n[r],
                u_base_type: _n[n]
            }), mn = (e1, t1, i, o, r, n, s, a, l, c, h, d, _, u, p, f, m, g)=>{
            const v = pn(e1, t1, i, o, r, n, s, a, c, h, d, _, u, p, f, m, 1, [
                0,
                0,
                0
            ]), y = {
                u_height_factor: -Math.pow(2, a.overscaledZ) / l.tileSize / 8
            };
            return Object.assign(v, dn(t1, l, g), y);
        }, gn = (e1, t1, i)=>({
                u_matrix: e1,
                u_emissive_strength: t1,
                u_ground_shadow_factor: i
            }), vn = (e1, t1, i, o, r, n = 0)=>Object.assign(gn(e1, t1, r), dn(i, o, n)), yn = (e1, t1, i, o)=>({
                u_matrix: e1,
                u_world: i,
                u_emissive_strength: t1,
                u_ground_shadow_factor: o
            }), xn = (e1, t1, i, o, r, n, s = 0)=>Object.assign(vn(e1, t1, i, o, n, s), {
                u_world: r
            }), bn = (e1, t1)=>({
                u_matrix: e1,
                u_depth_bias: t1
            }), wn = (e1, t1)=>({
                u_matrix: e1,
                u_ground_shadow_factor: t1
            }), Tn = (e1, t1, i, o, r)=>({
                u_matrix: e1,
                u_camera_pos: [
                    t1[0],
                    t1[1],
                    t1[2]
                ],
                u_depth_bias: i,
                u_height_scale: o,
                u_reset_depth: r
            }), En = (e1, t1, i)=>({
                u_image: e1,
                u_opacity: t1,
                u_blend_mode: i
            }), Sn = (e1, t1, i, o, r, n, s, a, l, c = [
            0,
            0,
            1
        ])=>({
                u_matrix: e1,
                u_normal_matrix: t1,
                u_opacity: i,
                u_faux_facade_ao_intensity: o,
                u_camera_pos: r,
                u_tile_to_meter: n,
                u_facade_emissive_chance: s,
                u_flood_light_color: a,
                u_flood_light_intensity: l,
                u_front_cutoff_params: c
            }), Cn = (e1)=>({
                u_matrix: e1
            }), In = (e1)=>({
                u_matrix: e1
            }), Rn = (t1, i, o, r, n, s, a, l)=>{
            const c = e1.an / s.tileSize;
            return {
                u_matrix: t1,
                u_inv_rot_matrix: i,
                u_camera_to_center_distance: o.getCameraToCenterDistance(l),
                u_extrude_scale: [
                    o.pixelsToGLUnits[0] / c,
                    o.pixelsToGLUnits[1] / c
                ],
                u_zoom_transition: r,
                u_tile_id: a,
                u_merc_center: n
            };
        }, Dn = (e1, t1, i, o)=>({
                u_matrix: e1,
                u_inv_matrix: t1,
                u_camera_to_center_distance: i.getCameraToCenterDistance(o),
                u_viewport_size: [
                    i.width,
                    i.height
                ]
            }), An = (e1, t1, i = 1)=>({
                u_matrix: e1,
                u_color: t1,
                u_overlay: 0,
                u_overlay_scale: i
            }), Ln = e1.bc(), Pn = (t1, i, o, r, n, s, a)=>{
            const l = t1.transform, c = "globe" === l.projection.name, h = c ? e1.dD(l.zoom, i.canonical) * l._pixelsPerMercatorPixel : e1.aA(o, 1, s), d = {
                u_matrix: i.projMatrix,
                u_extrude_scale: h,
                u_intensity: a,
                u_inv_rot_matrix: Ln,
                u_merc_center: [
                    0,
                    0
                ],
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_up_dir: [
                    0,
                    0,
                    0
                ]
            };
            if (c) {
                d.u_inv_rot_matrix = r, d.u_merc_center = n, d.u_tile_id = [
                    i.canonical.x,
                    i.canonical.y,
                    1 << i.canonical.z
                ], d.u_zoom_transition = e1.al(l.zoom);
                const t1 = n[0] * e1.an, o = n[1] * e1.an;
                d.u_up_dir = l.projection.upVector(new e1.ci(0, 0, 0), t1, o);
            }
            return d;
        };
        function On(e1, [t1, i, o, r], [n, s]) {
            if (n === s) return [
                0,
                0,
                0,
                0
            ];
            const a = 255 * (e1 - 1) / (e1 * (s - n));
            return [
                t1 * a,
                i * a,
                o * a,
                r * a
            ];
        }
        function Mn(e1, t1, [i, o]) {
            return i === o ? 0 : .5 / e1 + (t1 - i) * (e1 - 1) / (e1 * (o - i));
        }
        function zn(t1) {
            const i = t1.terrain ? t1.terrain.exaggeration() : 1;
            var o;
            return (t1.transform.pitch < 15 ? .07 * (1 - (o = e1.aC((14 - t1.transform.zoom) / 5, 0, 1))) + .7 * o : .07) * i;
        }
        const Fn = (t1, i, o, r, n, s, a, l, c, h, d, _, u, p, f, m, g, v, y, x, b, w)=>({
                u_matrix: i,
                u_normalize_matrix: o,
                u_globe_matrix: r,
                u_merc_matrix: n,
                u_grid_matrix: s,
                u_tl_parent: a,
                u_scale_parent: d,
                u_fade_t: _.mix,
                u_opacity: _.opacity * u.paint.get("raster-opacity"),
                u_image0: 0,
                u_image1: 1,
                u_brightness_low: u.paint.get("raster-brightness-min"),
                u_brightness_high: u.paint.get("raster-brightness-max"),
                u_saturation_factor: e1.dF(u.paint.get("raster-saturation")),
                u_contrast_factor: e1.dE(u.paint.get("raster-contrast")),
                u_spin_weights: Bn(u.paint.get("raster-hue-rotate")),
                u_perspective_transform: p,
                u_raster_elevation: f,
                u_zoom_transition: l,
                u_merc_center: c,
                u_cutoff_params: h,
                u_colorization_mix: On(e1.dG, g, y),
                u_colorization_offset: Mn(e1.dG, v, y),
                u_color_ramp: m,
                u_texture_offset: [
                    b / (x + 2 * b),
                    x / (x + 2 * b)
                ],
                u_texture_res: [
                    x + 2 * b,
                    x + 2 * b
                ],
                u_emissive_strength: w,
                u_zbias_factor: zn(t1)
            });
        function Bn(e1) {
            e1 *= Math.PI / 180;
            const t1 = Math.sin(e1), i = Math.cos(e1);
            return [
                (2 * i + 1) / 3,
                (-Math.sqrt(3) * t1 - i + 1) / 3,
                (Math.sqrt(3) * t1 - i + 1) / 3
            ];
        }
        const kn = .05, Nn = (e1, t1, i, o, r, n, s, a, l, c, h, d)=>({
                u_matrix: e1,
                u_normalize_matrix: t1,
                u_globe_matrix: i,
                u_merc_matrix: o,
                u_grid_matrix: r,
                u_tl_parent: n,
                u_scale_parent: c,
                u_fade_t: h.mix,
                u_opacity: h.opacity,
                u_image0: 0,
                u_image1: 1,
                u_raster_elevation: d,
                u_zoom_transition: s,
                u_merc_center: a,
                u_cutoff_params: l
            }), Un = (e1, t1, i, o, r, n, s, a, l, c)=>({
                u_particle_texture: e1,
                u_particle_texture_side_len: t1,
                u_tile_offset: i,
                u_velocity: o,
                u_color_ramp: n,
                u_velocity_res: r,
                u_max_speed: s,
                u_uv_offset: a,
                u_data_scale: [
                    255 * l[0],
                    255 * l[1]
                ],
                u_data_offset: c,
                u_particle_pos_scale: 1.1,
                u_particle_pos_offset: [
                    kn,
                    kn
                ]
            }), Vn = (e1, t1, i, o, r, n, s, a, l, c)=>({
                u_particle_texture: e1,
                u_particle_texture_side_len: t1,
                u_velocity: i,
                u_velocity_res: o,
                u_max_speed: r,
                u_speed_factor: n,
                u_reset_rate: s,
                u_rand_seed: Math.random(),
                u_uv_offset: a,
                u_data_scale: [
                    255 * l[0],
                    255 * l[1]
                ],
                u_data_offset: c,
                u_particle_pos_scale: 1.1,
                u_particle_pos_offset: [
                    kn,
                    kn
                ]
            }), jn = e1.bc(), Gn = (t1, i, o, r, n, s, a, l, c, h, d, _, u, p, f, m, g, v, y, x, b, w, T, E)=>{
            const S = n.transform, C = {
                u_is_size_zoom_constant: +("constant" === t1 || "source" === t1),
                u_is_size_feature_constant: +("constant" === t1 || "camera" === t1),
                u_size_t: i ? i.uSizeT : 0,
                u_size: i ? i.uSize : 0,
                u_camera_to_center_distance: S.getCameraToCenterDistance(y),
                u_rotate_symbol: +o,
                u_aspect_ratio: S.width / S.height,
                u_fade_change: n.options.fadeDuration ? n.symbolFadeChange : 1,
                u_matrix: s,
                u_label_plane_matrix: a,
                u_coord_matrix: l,
                u_is_text: +h,
                u_elevation_from_sea: c ? 1 : 0,
                u_pitch_with_map: +r,
                u_texsize: d,
                u_texsize_icon: _,
                u_texture: 0,
                u_texture_icon: 1,
                u_tile_id: [
                    0,
                    0,
                    0
                ],
                u_zoom_transition: 0,
                u_inv_rot_matrix: jn,
                u_merc_center: [
                    0,
                    0
                ],
                u_camera_forward: [
                    0,
                    0,
                    0
                ],
                u_ecef_origin: [
                    0,
                    0,
                    0
                ],
                u_tile_matrix: jn,
                u_up_vector: [
                    0,
                    -1,
                    0
                ],
                u_color_adj_mat: w,
                u_icon_transition: T || 0,
                u_gamma_scale: r ? n.transform.getCameraToCenterDistance(y) * Math.cos(n.terrain ? 0 : n.transform._pitch) : 1,
                u_device_pixel_ratio: e1.o.devicePixelRatio,
                u_is_halo: 1,
                u_scale_factor: E || 1,
                u_ground_shadow_factor: x,
                u_inv_matrix: e1.b8(e1.bc(), a),
                u_normal_scale: b,
                u_lutTexture: 10,
                u_zoom: S.zoom - Math.floor(S.zoom),
                u_spp_fill_np_color: [
                    0,
                    0,
                    0,
                    1
                ],
                u_spp_halo_np_color: [
                    0,
                    0,
                    0,
                    0
                ],
                u_spp_opacity: 1,
                u_spp_halo_width: 0,
                u_spp_halo_blur: 0,
                u_spp_emissive_strength: 0,
                u_spp_occlusion_opacity: 1,
                u_spp_z_offset: 0,
                u_spp_translate_rotation: [
                    1,
                    0
                ]
            };
            return "globe" === y.name && (C.u_tile_id = [
                p.canonical.x,
                p.canonical.y,
                1 << p.canonical.z
            ], C.u_zoom_transition = f, C.u_inv_rot_matrix = g, C.u_merc_center = m, C.u_camera_forward = S._camera.forward(), C.u_ecef_origin = e1.dH(S.globeMatrix, p.toUnwrapped()), C.u_tile_matrix = Float32Array.from(S.globeMatrix), C.u_up_vector = v), C;
        }, qn = (e1, t1, i, o)=>({
                u_matrix: e1,
                u_emissive_strength: t1,
                u_opacity: i,
                u_color: o
            }), Zn = (t1, i, o, r, n, s, a, l, c)=>Object.assign(function(t1, i, o, r, n, s) {
                const { width: a, height: l } = r.imageManager.getPixelSize(i), c = Math.pow(2, s.tileID.overscaledZ), h = s.tileSize * Math.pow(2, r.transform.tileZoom) / c, d = h * (s.tileID.canonical.x + s.tileID.wrap * c), _ = h * s.tileID.canonical.y;
                return {
                    u_image: 0,
                    u_pattern_tl: o.tl,
                    u_pattern_br: o.br,
                    u_texsize: [
                        a,
                        l
                    ],
                    u_pattern_size: o.displaySize,
                    u_pattern_units_to_pixels: n ? [
                        r.transform.width,
                        -1 * r.transform.height
                    ] : [
                        1 / e1.aA(s, 1, r.transform.tileZoom),
                        1 / e1.aA(s, 1, r.transform.tileZoom)
                    ],
                    u_pixel_coord_upper: [
                        d >> 16,
                        _ >> 16
                    ],
                    u_pixel_coord_lower: [
                        65535 & d,
                        65535 & _
                    ]
                };
            }(0, s, a, r, l, c), {
                u_matrix: t1,
                u_emissive_strength: i,
                u_opacity: o
            }), Hn = new Float32Array(e1.ba([])), Wn = (t1, i, o, r, n, s, a, l, c, h, d, _, u, p = [
            0,
            0,
            0
        ], f, m, g)=>{
            const v = n.style.light, y = v.properties.get("position"), x = [
                -y.x,
                -y.y,
                y.z
            ], b = e1.dA();
            "viewport" === v.properties.get("anchor") && (e1.dB(b, -n.transform.angle), e1.dC(x, x, b));
            const w = "MASK" === d.alphaMode, T = v.properties.get("color").toNonPremultipliedRenderColor(null), E = u.paint.get("model-ambient-occlusion-intensity"), S = u.paint.get("model-color").constantOr(e1.aq.white).toNonPremultipliedRenderColor(null);
            return S.a = u.paint.get("model-color-mix-intensity").constantOr(0), g && (S.r = g[0], S.g = g[1], S.b = g[2], S.a = g[3]), m && (S.r = m.color.r, S.g = m.color.g, S.b = m.color.b, S.a = m.colorMix, _ = m.emissionStrength, s *= m.opacity), {
                u_matrix: t1,
                u_lighting_matrix: i,
                u_normal_matrix: o,
                u_node_matrix: r || Hn,
                u_lightpos: x,
                u_lightintensity: v.properties.get("intensity"),
                u_lightcolor: [
                    T.r,
                    T.g,
                    T.b
                ],
                u_camera_pos: p,
                u_opacity: s,
                u_baseTextureIsAlpha: 0,
                u_alphaMask: +w,
                u_alphaCutoff: d.alphaCutoff,
                u_baseColorFactor: a.toNonPremultipliedRenderColor(null).toArray01(),
                u_emissiveFactor: l.toNonPremultipliedRenderColor(null).toArray01(),
                u_metallicFactor: c,
                u_roughnessFactor: h,
                u_baseColorTexture: 5,
                u_metallicRoughnessTexture: 6,
                u_normalTexture: 7,
                u_occlusionTexture: 8,
                u_emissionTexture: 9,
                u_lutTexture: 10,
                u_color_mix: S.toArray01(),
                u_aoIntensity: E,
                u_emissive_strength: _,
                u_occlusionTextureTransform: f || [
                    0,
                    0,
                    0,
                    0
                ]
            };
        }, $n = (e1, t1 = Hn, i = Hn)=>({
                u_matrix: e1,
                u_instance: t1,
                u_node_matrix: i
            }), Xn = {
            fillExtrusion: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_lightpos: new e1.bZ(t1),
                    u_lightintensity: new e1.b_(t1),
                    u_lightcolor: new e1.bZ(t1),
                    u_vertical_gradient: new e1.b_(t1),
                    u_opacity: new e1.b_(t1),
                    u_edge_radius: new e1.b_(t1),
                    u_width_scale: new e1.b_(t1),
                    u_ao: new e1.b$(t1),
                    u_height_type: new e1.bY(t1),
                    u_base_type: new e1.bY(t1),
                    u_tile_id: new e1.bZ(t1),
                    u_zoom_transition: new e1.b_(t1),
                    u_inv_rot_matrix: new e1.c0(t1),
                    u_merc_center: new e1.b$(t1),
                    u_up_dir: new e1.bZ(t1),
                    u_height_lift: new e1.b_(t1),
                    u_flood_light_color: new e1.bZ(t1),
                    u_vertical_scale: new e1.b_(t1),
                    u_flood_light_intensity: new e1.b_(t1),
                    u_ground_shadow_factor: new e1.bZ(t1),
                    u_front_cutoff_params: new e1.bZ(t1)
                }),
            fillExtrusionDepth: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_edge_radius: new e1.b_(t1),
                    u_width_scale: new e1.b_(t1),
                    u_vertical_scale: new e1.b_(t1),
                    u_height_type: new e1.bY(t1),
                    u_base_type: new e1.bY(t1)
                }),
            fillExtrusionPattern: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_lightpos: new e1.bZ(t1),
                    u_lightintensity: new e1.b_(t1),
                    u_lightcolor: new e1.bZ(t1),
                    u_vertical_gradient: new e1.b_(t1),
                    u_height_factor: new e1.b_(t1),
                    u_edge_radius: new e1.b_(t1),
                    u_width_scale: new e1.b_(t1),
                    u_ao: new e1.b$(t1),
                    u_height_type: new e1.bY(t1),
                    u_base_type: new e1.bY(t1),
                    u_tile_id: new e1.bZ(t1),
                    u_zoom_transition: new e1.b_(t1),
                    u_inv_rot_matrix: new e1.c0(t1),
                    u_merc_center: new e1.b$(t1),
                    u_up_dir: new e1.bZ(t1),
                    u_height_lift: new e1.b_(t1),
                    u_image: new e1.bY(t1),
                    u_texsize: new e1.b$(t1),
                    u_pixel_coord_upper: new e1.b$(t1),
                    u_pixel_coord_lower: new e1.b$(t1),
                    u_tile_units_to_pixels: new e1.b_(t1),
                    u_opacity: new e1.b_(t1),
                    u_pattern_transition: new e1.b_(t1)
                }),
            fillExtrusionGroundEffect: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_opacity: new e1.b_(t1),
                    u_ao_pass: new e1.b_(t1),
                    u_meter_to_tile: new e1.b_(t1),
                    u_ao: new e1.b$(t1),
                    u_flood_light_intensity: new e1.b_(t1),
                    u_flood_light_color: new e1.bZ(t1),
                    u_attenuation: new e1.b_(t1),
                    u_edge_radius: new e1.b_(t1),
                    u_fb: new e1.bY(t1),
                    u_fb_size: new e1.b_(t1),
                    u_dynamic_offset: new e1.b_(t1)
                }),
            fill: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_emissive_strength: new e1.b_(t1),
                    u_ground_shadow_factor: new e1.bZ(t1)
                }),
            fillPattern: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_emissive_strength: new e1.b_(t1),
                    u_image: new e1.bY(t1),
                    u_texsize: new e1.b$(t1),
                    u_pixel_coord_upper: new e1.b$(t1),
                    u_pixel_coord_lower: new e1.b$(t1),
                    u_tile_units_to_pixels: new e1.b_(t1),
                    u_ground_shadow_factor: new e1.bZ(t1),
                    u_pattern_transition: new e1.b_(t1)
                }),
            fillOutline: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_emissive_strength: new e1.b_(t1),
                    u_world: new e1.b$(t1),
                    u_ground_shadow_factor: new e1.bZ(t1)
                }),
            fillOutlinePattern: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_emissive_strength: new e1.b_(t1),
                    u_world: new e1.b$(t1),
                    u_image: new e1.bY(t1),
                    u_texsize: new e1.b$(t1),
                    u_pixel_coord_upper: new e1.b$(t1),
                    u_pixel_coord_lower: new e1.b$(t1),
                    u_tile_units_to_pixels: new e1.b_(t1),
                    u_ground_shadow_factor: new e1.bZ(t1),
                    u_pattern_transition: new e1.b_(t1)
                }),
            lineBlendComposite: (t1)=>({
                    u_image: new e1.bY(t1),
                    u_opacity: new e1.b_(t1),
                    u_blend_mode: new e1.bY(t1)
                }),
            building: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_normal_matrix: new e1.c0(t1),
                    u_opacity: new e1.b_(t1),
                    u_faux_facade_ao_intensity: new e1.b_(t1),
                    u_camera_pos: new e1.bZ(t1),
                    u_tile_to_meter: new e1.b_(t1),
                    u_facade_emissive_chance: new e1.b_(t1),
                    u_flood_light_color: new e1.bZ(t1),
                    u_flood_light_intensity: new e1.b_(t1),
                    u_front_cutoff_params: new e1.bZ(t1)
                }),
            buildingBloom: (t1)=>({
                    u_matrix: new e1.c0(t1)
                }),
            buildingDepth: (t1)=>({
                    u_matrix: new e1.c0(t1)
                }),
            elevatedStructuresDepth: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_depth_bias: new e1.b_(t1)
                }),
            elevatedStructures: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_ground_shadow_factor: new e1.bZ(t1)
                }),
            elevatedStructuresDepthReconstruct: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_camera_pos: new e1.bZ(t1),
                    u_depth_bias: new e1.b_(t1),
                    u_height_scale: new e1.b_(t1),
                    u_reset_depth: new e1.b_(t1)
                }),
            circle: e1.dK,
            collisionBox: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_inv_rot_matrix: new e1.c0(t1),
                    u_camera_to_center_distance: new e1.b_(t1),
                    u_extrude_scale: new e1.b$(t1),
                    u_zoom_transition: new e1.b_(t1),
                    u_merc_center: new e1.b$(t1),
                    u_tile_id: new e1.bZ(t1)
                }),
            collisionCircle: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_inv_matrix: new e1.c0(t1),
                    u_camera_to_center_distance: new e1.b_(t1),
                    u_viewport_size: new e1.b$(t1)
                }),
            debug: (t1)=>({
                    u_color: new e1.dh(t1),
                    u_matrix: new e1.c0(t1),
                    u_overlay: new e1.bY(t1),
                    u_overlay_scale: new e1.b_(t1)
                }),
            clippingMask: (t1)=>({
                    u_matrix: new e1.c0(t1)
                }),
            heatmap: (t1)=>({
                    u_extrude_scale: new e1.b_(t1),
                    u_intensity: new e1.b_(t1),
                    u_matrix: new e1.c0(t1),
                    u_inv_rot_matrix: new e1.c0(t1),
                    u_merc_center: new e1.b$(t1),
                    u_tile_id: new e1.bZ(t1),
                    u_zoom_transition: new e1.b_(t1),
                    u_up_dir: new e1.bZ(t1)
                }),
            heatmapTexture: (t1)=>({
                    u_image: new e1.bY(t1),
                    u_color_ramp: new e1.bY(t1),
                    u_opacity: new e1.b_(t1)
                }),
            hillshade: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_image: new e1.bY(t1),
                    u_latrange: new e1.b$(t1),
                    u_light: new e1.b$(t1),
                    u_shadow: new e1.dh(t1),
                    u_highlight: new e1.dh(t1),
                    u_emissive_strength: new e1.b_(t1),
                    u_accent: new e1.dh(t1)
                }),
            hillshadePrepare: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_image: new e1.bY(t1),
                    u_dimension: new e1.b$(t1),
                    u_zoom: new e1.b_(t1)
                }),
            line: e1.dJ,
            linePattern: e1.dI,
            raster: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_normalize_matrix: new e1.c0(t1),
                    u_globe_matrix: new e1.c0(t1),
                    u_merc_matrix: new e1.c0(t1),
                    u_grid_matrix: new e1.di(t1),
                    u_tl_parent: new e1.b$(t1),
                    u_scale_parent: new e1.b_(t1),
                    u_fade_t: new e1.b_(t1),
                    u_opacity: new e1.b_(t1),
                    u_image0: new e1.bY(t1),
                    u_image1: new e1.bY(t1),
                    u_brightness_low: new e1.b_(t1),
                    u_brightness_high: new e1.b_(t1),
                    u_saturation_factor: new e1.b_(t1),
                    u_contrast_factor: new e1.b_(t1),
                    u_spin_weights: new e1.bZ(t1),
                    u_perspective_transform: new e1.b$(t1),
                    u_raster_elevation: new e1.b_(t1),
                    u_zoom_transition: new e1.b_(t1),
                    u_merc_center: new e1.b$(t1),
                    u_cutoff_params: new e1.cK(t1),
                    u_colorization_mix: new e1.cK(t1),
                    u_colorization_offset: new e1.b_(t1),
                    u_color_ramp: new e1.bY(t1),
                    u_texture_offset: new e1.b$(t1),
                    u_texture_res: new e1.b$(t1),
                    u_emissive_strength: new e1.b_(t1),
                    u_zbias_factor: new e1.b_(t1)
                }),
            rasterParticle: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_normalize_matrix: new e1.c0(t1),
                    u_globe_matrix: new e1.c0(t1),
                    u_merc_matrix: new e1.c0(t1),
                    u_grid_matrix: new e1.di(t1),
                    u_tl_parent: new e1.b$(t1),
                    u_scale_parent: new e1.b_(t1),
                    u_fade_t: new e1.b_(t1),
                    u_opacity: new e1.b_(t1),
                    u_image0: new e1.bY(t1),
                    u_image1: new e1.bY(t1),
                    u_raster_elevation: new e1.b_(t1),
                    u_zoom_transition: new e1.b_(t1),
                    u_merc_center: new e1.b$(t1),
                    u_cutoff_params: new e1.cK(t1)
                }),
            rasterParticleTexture: (t1)=>({
                    u_texture: new e1.bY(t1),
                    u_opacity: new e1.b_(t1)
                }),
            rasterParticleDraw: (t1)=>({
                    u_particle_texture: new e1.bY(t1),
                    u_particle_texture_side_len: new e1.b_(t1),
                    u_tile_offset: new e1.b$(t1),
                    u_velocity: new e1.bY(t1),
                    u_color_ramp: new e1.bY(t1),
                    u_velocity_res: new e1.b$(t1),
                    u_max_speed: new e1.b_(t1),
                    u_uv_offset: new e1.b$(t1),
                    u_data_scale: new e1.b$(t1),
                    u_data_offset: new e1.b_(t1),
                    u_particle_pos_scale: new e1.b_(t1),
                    u_particle_pos_offset: new e1.b$(t1)
                }),
            rasterParticleUpdate: (t1)=>({
                    u_particle_texture: new e1.bY(t1),
                    u_particle_texture_side_len: new e1.b_(t1),
                    u_velocity: new e1.bY(t1),
                    u_velocity_res: new e1.b$(t1),
                    u_max_speed: new e1.b_(t1),
                    u_speed_factor: new e1.b_(t1),
                    u_reset_rate: new e1.b_(t1),
                    u_rand_seed: new e1.b_(t1),
                    u_uv_offset: new e1.b$(t1),
                    u_data_scale: new e1.b$(t1),
                    u_data_offset: new e1.b_(t1),
                    u_particle_pos_scale: new e1.b_(t1),
                    u_particle_pos_offset: new e1.b$(t1)
                }),
            symbol: (t1)=>({
                    u_is_size_zoom_constant: new e1.bY(t1),
                    u_is_size_feature_constant: new e1.bY(t1),
                    u_size_t: new e1.b_(t1),
                    u_size: new e1.b_(t1),
                    u_camera_to_center_distance: new e1.b_(t1),
                    u_rotate_symbol: new e1.bY(t1),
                    u_aspect_ratio: new e1.b_(t1),
                    u_fade_change: new e1.b_(t1),
                    u_matrix: new e1.c0(t1),
                    u_label_plane_matrix: new e1.c0(t1),
                    u_coord_matrix: new e1.c0(t1),
                    u_is_text: new e1.bY(t1),
                    u_elevation_from_sea: new e1.bY(t1),
                    u_pitch_with_map: new e1.bY(t1),
                    u_texsize: new e1.b$(t1),
                    u_texsize_icon: new e1.b$(t1),
                    u_texture: new e1.bY(t1),
                    u_texture_icon: new e1.bY(t1),
                    u_gamma_scale: new e1.b_(t1),
                    u_device_pixel_ratio: new e1.b_(t1),
                    u_tile_id: new e1.bZ(t1),
                    u_zoom_transition: new e1.b_(t1),
                    u_inv_rot_matrix: new e1.c0(t1),
                    u_merc_center: new e1.b$(t1),
                    u_camera_forward: new e1.bZ(t1),
                    u_tile_matrix: new e1.c0(t1),
                    u_up_vector: new e1.bZ(t1),
                    u_ecef_origin: new e1.bZ(t1),
                    u_is_halo: new e1.bY(t1),
                    u_icon_transition: new e1.b_(t1),
                    u_color_adj_mat: new e1.c0(t1),
                    u_scale_factor: new e1.b_(t1),
                    u_ground_shadow_factor: new e1.bZ(t1),
                    u_inv_matrix: new e1.c0(t1),
                    u_normal_scale: new e1.b_(t1),
                    u_lutTexture: new e1.bY(t1),
                    u_zoom: new e1.b_(t1),
                    u_spp_fill_np_color: new e1.cK(t1),
                    u_spp_halo_np_color: new e1.cK(t1),
                    u_spp_opacity: new e1.b_(t1),
                    u_spp_halo_width: new e1.b_(t1),
                    u_spp_halo_blur: new e1.b_(t1),
                    u_spp_emissive_strength: new e1.b_(t1),
                    u_spp_occlusion_opacity: new e1.b_(t1),
                    u_spp_z_offset: new e1.b_(t1),
                    u_spp_translate_rotation: new e1.b$(t1)
                }),
            background: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_emissive_strength: new e1.b_(t1),
                    u_opacity: new e1.b_(t1),
                    u_color: new e1.dh(t1)
                }),
            backgroundPattern: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_emissive_strength: new e1.b_(t1),
                    u_opacity: new e1.b_(t1),
                    u_image: new e1.bY(t1),
                    u_pattern_tl: new e1.b$(t1),
                    u_pattern_br: new e1.b$(t1),
                    u_texsize: new e1.b$(t1),
                    u_pattern_size: new e1.b$(t1),
                    u_pixel_coord_upper: new e1.b$(t1),
                    u_pixel_coord_lower: new e1.b$(t1),
                    u_pattern_units_to_pixels: new e1.b$(t1)
                }),
            terrainRaster: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_image0: new e1.bY(t1),
                    u_image1: new e1.bY(t1),
                    u_skirt_height: new e1.b_(t1),
                    u_ground_shadow_factor: new e1.bZ(t1),
                    u_emissive_texture_available: new e1.b_(t1)
                }),
            skybox: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_sun_direction: new e1.bZ(t1),
                    u_cubemap: new e1.bY(t1),
                    u_opacity: new e1.b_(t1),
                    u_temporal_offset: new e1.b_(t1)
                }),
            skyboxGradient: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_color_ramp: new e1.bY(t1),
                    u_center_direction: new e1.bZ(t1),
                    u_radius: new e1.b_(t1),
                    u_opacity: new e1.b_(t1),
                    u_temporal_offset: new e1.b_(t1)
                }),
            skyboxCapture: (t1)=>({
                    u_matrix_3f: new e1.di(t1),
                    u_sun_direction: new e1.bZ(t1),
                    u_sun_intensity: new e1.b_(t1),
                    u_color_tint_r: new e1.cK(t1),
                    u_color_tint_m: new e1.cK(t1),
                    u_luminance: new e1.b_(t1)
                }),
            globeRaster: (t1)=>({
                    u_proj_matrix: new e1.c0(t1),
                    u_globe_matrix: new e1.c0(t1),
                    u_normalize_matrix: new e1.c0(t1),
                    u_merc_matrix: new e1.c0(t1),
                    u_zoom_transition: new e1.b_(t1),
                    u_merc_center: new e1.b$(t1),
                    u_image0: new e1.bY(t1),
                    u_image1: new e1.bY(t1),
                    u_grid_matrix: new e1.di(t1),
                    u_skirt_height: new e1.b_(t1),
                    u_far_z_cutoff: new e1.b_(t1),
                    u_frustum_tl: new e1.bZ(t1),
                    u_frustum_tr: new e1.bZ(t1),
                    u_frustum_br: new e1.bZ(t1),
                    u_frustum_bl: new e1.bZ(t1),
                    u_globe_pos: new e1.bZ(t1),
                    u_globe_radius: new e1.b_(t1),
                    u_viewport: new e1.b$(t1),
                    u_emissive_texture_available: new e1.b_(t1)
                }),
            globeAtmosphere: (t1)=>({
                    u_frustum_tl: new e1.bZ(t1),
                    u_frustum_tr: new e1.bZ(t1),
                    u_frustum_br: new e1.bZ(t1),
                    u_frustum_bl: new e1.bZ(t1),
                    u_horizon: new e1.b_(t1),
                    u_transition: new e1.b_(t1),
                    u_fadeout_range: new e1.b_(t1),
                    u_atmosphere_fog_color: new e1.cK(t1),
                    u_high_color: new e1.cK(t1),
                    u_space_color: new e1.cK(t1),
                    u_temporal_offset: new e1.b_(t1),
                    u_horizon_angle: new e1.b_(t1)
                }),
            model: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_lighting_matrix: new e1.c0(t1),
                    u_normal_matrix: new e1.c0(t1),
                    u_node_matrix: new e1.c0(t1),
                    u_lightpos: new e1.bZ(t1),
                    u_lightintensity: new e1.b_(t1),
                    u_lightcolor: new e1.bZ(t1),
                    u_camera_pos: new e1.bZ(t1),
                    u_opacity: new e1.b_(t1),
                    u_baseColorFactor: new e1.cK(t1),
                    u_emissiveFactor: new e1.cK(t1),
                    u_metallicFactor: new e1.b_(t1),
                    u_roughnessFactor: new e1.b_(t1),
                    u_baseTextureIsAlpha: new e1.bY(t1),
                    u_alphaMask: new e1.bY(t1),
                    u_alphaCutoff: new e1.b_(t1),
                    u_baseColorTexture: new e1.bY(t1),
                    u_metallicRoughnessTexture: new e1.bY(t1),
                    u_normalTexture: new e1.bY(t1),
                    u_occlusionTexture: new e1.bY(t1),
                    u_emissionTexture: new e1.bY(t1),
                    u_lutTexture: new e1.bY(t1),
                    u_color_mix: new e1.cK(t1),
                    u_aoIntensity: new e1.b_(t1),
                    u_emissive_strength: new e1.b_(t1),
                    u_occlusionTextureTransform: new e1.cK(t1)
                }),
            modelDepth: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_instance: new e1.c0(t1),
                    u_node_matrix: new e1.c0(t1)
                }),
            groundShadow: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_ground_shadow_factor: new e1.bZ(t1)
                }),
            stars: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_up: new e1.bZ(t1),
                    u_right: new e1.bZ(t1),
                    u_intensity_multiplier: new e1.b_(t1)
                }),
            snowParticle: (t1)=>({
                    u_modelview: new e1.c0(t1),
                    u_projection: new e1.c0(t1),
                    u_time: new e1.b_(t1),
                    u_cam_pos: new e1.bZ(t1),
                    u_velocityConeAperture: new e1.b_(t1),
                    u_velocity: new e1.b_(t1),
                    u_horizontalOscillationRadius: new e1.b_(t1),
                    u_horizontalOscillationRate: new e1.b_(t1),
                    u_boxSize: new e1.b_(t1),
                    u_billboardSize: new e1.b_(t1),
                    u_simpleShapeParameters: new e1.b$(t1),
                    u_screenSize: new e1.b$(t1),
                    u_thinningCenterPos: new e1.b$(t1),
                    u_thinningShape: new e1.bZ(t1),
                    u_thinningAffectedRatio: new e1.b_(t1),
                    u_thinningParticleOffset: new e1.b_(t1),
                    u_particleColor: new e1.cK(t1),
                    u_direction: new e1.bZ(t1)
                }),
            rainParticle: (t1)=>({
                    u_modelview: new e1.c0(t1),
                    u_projection: new e1.c0(t1),
                    u_time: new e1.b_(t1),
                    u_cam_pos: new e1.bZ(t1),
                    u_texScreen: new e1.bY(t1),
                    u_velocityConeAperture: new e1.b_(t1),
                    u_velocity: new e1.b_(t1),
                    u_boxSize: new e1.b_(t1),
                    u_rainDropletSize: new e1.b$(t1),
                    u_distortionStrength: new e1.b_(t1),
                    u_rainDirection: new e1.bZ(t1),
                    u_color: new e1.cK(t1),
                    u_screenSize: new e1.b$(t1),
                    u_thinningCenterPos: new e1.b$(t1),
                    u_thinningShape: new e1.bZ(t1),
                    u_thinningAffectedRatio: new e1.b_(t1),
                    u_thinningParticleOffset: new e1.b_(t1),
                    u_shapeDirectionalPower: new e1.b_(t1),
                    u_shapeNormalPower: new e1.b_(t1),
                    u_mode: new e1.b_(t1)
                }),
            vignette: (t1)=>({
                    u_vignetteShape: new e1.bZ(t1),
                    u_vignetteColor: new e1.cK(t1)
                }),
            occlusion: (t1)=>({
                    u_matrix: new e1.c0(t1),
                    u_anchorPos: new e1.bZ(t1),
                    u_screenSizePx: new e1.b$(t1),
                    u_occluderSizePx: new e1.b$(t1),
                    u_color: new e1.cK(t1)
                })
        };
        class Yn {
            constructor(e1, t1, i, o){
                this.id = Yn.uniqueIdxCounter, Yn.uniqueIdxCounter++, this.context = e1;
                const r = e1.gl;
                this.buffer = r.createBuffer(), this.dynamicDraw = Boolean(i), this.context.unbindVAO(), e1.bindElementBuffer.set(this.buffer), r.bufferData(r.ELEMENT_ARRAY_BUFFER, t1.arrayBuffer, this.dynamicDraw ? r.DYNAMIC_DRAW : r.STATIC_DRAW), this.dynamicDraw || o || t1.destroy();
            }
            bind() {
                this.context.bindElementBuffer.set(this.buffer);
            }
            updateData(e1) {
                this.id = Yn.uniqueIdxCounter, Yn.uniqueIdxCounter++;
                const t1 = this.context.gl;
                this.context.unbindVAO(), this.bind(), t1.bufferSubData(t1.ELEMENT_ARRAY_BUFFER, 0, e1.arrayBuffer);
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        Yn.uniqueIdxCounter = 0;
        const Kn = {
            Int8: "BYTE",
            Uint8: "UNSIGNED_BYTE",
            Int16: "SHORT",
            Uint16: "UNSIGNED_SHORT",
            Int32: "INT",
            Uint32: "UNSIGNED_INT",
            Float32: "FLOAT"
        };
        class Qn {
            constructor(e1, t1, i, o, r, n){
                this.length = t1.length, this.attributes = i, this.itemSize = t1.bytesPerElement, this.dynamicDraw = o, this.instanceCount = n, this.context = e1;
                const s = e1.gl;
                this.buffer = s.createBuffer(), e1.bindVertexBuffer.set(this.buffer), s.bufferData(s.ARRAY_BUFFER, t1.arrayBuffer, this.dynamicDraw ? s.DYNAMIC_DRAW : s.STATIC_DRAW), this.dynamicDraw || r || t1.destroy();
            }
            bind() {
                this.context.bindVertexBuffer.set(this.buffer);
            }
            updateData(e1) {
                const t1 = this.context.gl;
                this.bind(), t1.bufferSubData(t1.ARRAY_BUFFER, 0, e1.arrayBuffer);
            }
            enableAttributes(e1, t1) {
                for (const i of this.attributes){
                    const o = t1.getAttributeLocation(e1, i.name);
                    -1 !== o && e1.enableVertexAttribArray(o);
                }
            }
            setVertexAttribPointers(e1, t1, i) {
                for (const o of this.attributes){
                    const r = t1.getAttributeLocation(e1, o.name);
                    if (-1 !== r) {
                        const t1 = o.offset + this.itemSize * (i || 0);
                        "Float32" === o.type ? e1.vertexAttribPointer(r, o.components, e1.FLOAT, !1, this.itemSize, t1) : e1.vertexAttribIPointer(r, o.components, e1[Kn[o.type]], this.itemSize, t1);
                    }
                }
            }
            setVertexAttribDivisor(e1, t1, i) {
                for(let o = 0; o < this.attributes.length; o++){
                    const r = t1.getAttributeLocation(e1, this.attributes[o].name);
                    -1 !== r && this.instanceCount && this.instanceCount > 0 && e1.vertexAttribDivisor(r, i);
                }
            }
            destroy() {
                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
            }
        }
        class Jn {
            constructor(e1, t1, i, o, r){
                this.context = e1, this.width = t1, this.height = i;
                const n = this.framebuffer = e1.gl.createFramebuffer();
                o > 0 && (this.colorAttachment0 = new jr(e1, n, 0)), o > 1 && (this.colorAttachment1 = new jr(e1, n, 1)), r && (this.depthAttachmentType = r, this.depthAttachment = "renderbuffer" === r ? new Gr(e1, n) : new qr(e1, n));
            }
            static createWithTexture(t1, i, o, r, n) {
                const s = t1.gl;
                if (t1.activeTexture.set(s.TEXTURE1), t1.viewport.set([
                    0,
                    0,
                    o,
                    r
                ]), i && i.width === o && i.height === r) return s.bindTexture(s.TEXTURE_2D, i.colorAttachment0.get()), t1.bindFramebuffer.set(i.framebuffer), i;
                i && i.destroy();
                const a = new e1.T(t1, {
                    width: o,
                    height: r,
                    data: null
                }, t1.extRenderToTextureHalfFloat ? t1.gl.RGBA16F : t1.gl.RGBA8);
                a.bind(s.LINEAR, s.CLAMP_TO_EDGE);
                const l = t1.createFramebuffer(o, r, 1, null);
                if (l.colorAttachment0.set(a.texture), n) {
                    const e1 = t1.createRenderbuffer(s.DEPTH24_STENCIL8, o, r);
                    t1.bindFramebuffer.set(l.framebuffer), s.framebufferRenderbuffer(s.FRAMEBUFFER, s.DEPTH_STENCIL_ATTACHMENT, s.RENDERBUFFER, e1), l._stencilRbo = e1;
                }
                return l;
            }
            createColorAttachment(e1, t1) {
                0 === t1 ? this.colorAttachment0 = new jr(e1, this.framebuffer, 0) : 1 === t1 && (this.colorAttachment1 = new jr(e1, this.framebuffer, 1));
            }
            removeColorAttachment(e1, t1) {
                const i = this.context.gl;
                let o;
                0 === t1 ? (o = this.colorAttachment0.get(), this.colorAttachment0 = void 0) : 1 === t1 && (o = this.colorAttachment1.get(), this.colorAttachment1 = void 0), o && i.deleteTexture(o);
            }
            destroy() {
                const e1 = this.context.gl;
                if (this.colorAttachment0) {
                    const t1 = this.colorAttachment0.get();
                    t1 && e1.deleteTexture(t1);
                }
                if (this.colorAttachment1) {
                    const t1 = this.colorAttachment1.get();
                    t1 && e1.deleteTexture(t1);
                }
                if (this.depthAttachment && this.depthAttachmentType) {
                    if ("renderbuffer" === this.depthAttachmentType) {
                        const t1 = this.depthAttachment.get();
                        t1 && e1.deleteRenderbuffer(t1);
                    } else {
                        const t1 = this.depthAttachment.get();
                        t1 && e1.deleteTexture(t1);
                    }
                }
                this._stencilRbo && (e1.deleteRenderbuffer(this._stencilRbo), this._stencilRbo = null), e1.deleteFramebuffer(this.framebuffer);
            }
        }
        class es {
            constructor(e1, t1){
                this.gl = e1, this.clearColor = new hr(this), this.clearDepth = new dr(this), this.clearStencil = new _r(this), this.colorMask = new ur(this), this.depthMask = new pr(this), this.stencilMask = new fr(this), this.stencilFunc = new mr(this), this.stencilOp = new gr(this), this.stencilTest = new vr(this), this.depthRange = new yr(this), this.depthTest = new xr(this), this.depthFunc = new br(this), this.blend = new wr(this), this.blendFunc = new Tr(this), this.blendColor = new Er(this), this.blendEquation = new Sr(this), this.cullFace = new Cr(this), this.cullFaceSide = new Ir(this), this.frontFace = new Rr(this), this.program = new Dr(this), this.activeTexture = new Ar(this), this.viewport = new Lr(this), this.bindFramebuffer = new Pr(this), this.bindRenderbuffer = new Or(this), this.bindTexture = new Mr(this), this.bindVertexBuffer = new zr(this), this.bindElementBuffer = new Fr(this), this.bindVertexArrayOES = new Br(this), this.pixelStoreUnpack = new kr(this), this.pixelStoreUnpackPremultiplyAlpha = new Nr(this), this.pixelStoreUnpackFlipY = new Ur(this), this.options = t1 ? Object.assign({}, t1) : {}, this.options.extTextureFilterAnisotropicForceOff || (this.extTextureFilterAnisotropic = e1.getExtension("EXT_texture_filter_anisotropic") || e1.getExtension("MOZ_EXT_texture_filter_anisotropic") || e1.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = e1.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT))), this.extDebugRendererInfo = e1.getExtension("WEBGL_debug_renderer_info"), this.extDebugRendererInfo && (this.renderer = e1.getParameter(this.extDebugRendererInfo.UNMASKED_RENDERER_WEBGL), this.vendor = e1.getParameter(this.extDebugRendererInfo.UNMASKED_VENDOR_WEBGL)), this.forceManualRenderingForInstanceIDShaders = t1 && !!t1.forceManualRenderingForInstanceIDShaders || this.renderer && -1 !== this.renderer.indexOf("PowerVR"), this.disableSymbolUBO = t1 && !!t1.forceDisableSymbolUBO || this.renderer && -1 !== this.renderer.indexOf("PowerVR"), this.options.extTextureFloatLinearForceOff || (this.extTextureFloatLinear = e1.getExtension("OES_texture_float_linear")), this.extRenderToTextureHalfFloat = e1.getExtension("EXT_color_buffer_half_float"), this.extTimerQuery = e1.getExtension("EXT_disjoint_timer_query_webgl2"), this.maxTextureSize = e1.getParameter(e1.MAX_TEXTURE_SIZE), this.maxUniformBlockSize = e1.getParameter(e1.MAX_UNIFORM_BLOCK_SIZE), this.maxUniformBufferBindings = e1.getParameter(e1.MAX_UNIFORM_BUFFER_BINDINGS), this.extBlendFuncExtended = e1.getExtension("WEBGL_blend_func_extended");
            }
            setDefault() {
                this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
            }
            setDirty() {
                this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArrayOES.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
            }
            createIndexBuffer(e1, t1, i) {
                return new Yn(this, e1, t1, i);
            }
            createVertexBuffer(e1, t1, i, o, r) {
                return new Qn(this, e1, t1, i, o, r);
            }
            createRenderbuffer(e1, t1, i) {
                const o = this.gl, r = o.createRenderbuffer();
                return this.bindRenderbuffer.set(r), o.renderbufferStorage(o.RENDERBUFFER, e1, t1, i), this.bindRenderbuffer.set(null), r;
            }
            createFramebuffer(e1, t1, i, o) {
                return new Jn(this, e1, t1, i, o);
            }
            clear({ color: e1, depth: t1, stencil: i, colorMask: o }) {
                const r = this.gl;
                let n = 0;
                e1 && (n |= r.COLOR_BUFFER_BIT, this.clearColor.set(e1.toNonPremultipliedRenderColor(null)), this.colorMask.set(o || [
                    !0,
                    !0,
                    !0,
                    !0
                ])), void 0 !== t1 && (n |= r.DEPTH_BUFFER_BIT, this.depthRange.set([
                    0,
                    1
                ]), this.clearDepth.set(t1), this.depthMask.set(!0)), void 0 !== i && (n |= r.STENCIL_BUFFER_BIT, this.clearStencil.set(i), this.stencilMask.set(255)), r.clear(n);
            }
            setCullFace(e1) {
                !1 === e1.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(e1.mode), this.frontFace.set(e1.frontFace));
            }
            setDepthMode(e1) {
                e1.func !== this.gl.ALWAYS || e1.mask ? (this.depthTest.set(!0), this.depthFunc.set(e1.func), this.depthMask.set(e1.mask), this.depthRange.set(e1.range)) : this.depthTest.set(!1);
            }
            setStencilMode(e1) {
                e1.test.func !== this.gl.ALWAYS || e1.mask ? (this.stencilTest.set(!0), this.stencilMask.set(e1.mask), this.stencilOp.set([
                    e1.fail,
                    e1.depthFail,
                    e1.pass
                ]), this.stencilFunc.set({
                    func: e1.test.func,
                    ref: e1.ref,
                    mask: e1.test.mask
                })) : this.stencilTest.set(!1);
            }
            setColorMode(t1) {
                e1.b7(t1.blendFunction, Zi.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(t1.blendFunction), this.blendColor.set(t1.blendColor), t1.blendEquation ? this.blendEquation.set(t1.blendEquation) : this.blendEquation.setDefault()), this.colorMask.set(t1.mask);
            }
            unbindVAO() {
                this.bindVertexArrayOES.set(null);
            }
        }
        let ts;
        function is(t1, i, o, r, n, s, a) {
            const l = t1.context, c = l.gl, h = t1.transform, d = [
                e1.aH(h.center.lng),
                e1.aL(h.center.lat)
            ], _ = o.layout.get("symbol-placement"), u = o.layout.get("text-variable-anchor"), p = "map" === o.layout.get("icon-rotation-alignment"), f = "map" === o.layout.get("text-rotation-alignment"), m = "point" !== _, g = [];
            let v = 0, y = 0;
            for(let l = 0; l < r.length; l++){
                const _ = r[l], x = i.getTile(_), b = x.getBucket(o);
                if (!b) continue;
                const w = b.getProjection().createInversionMatrix(h, _.canonical), T = [], E = Yt(_, b, h), S = !a && p && m, C = a && f && m, I = u && b.hasTextData(), R = b.hasIconTextFit() && I && b.hasIconData(), D = S || C || a && I || R, A = "globe" === b.projection.name, L = A ? e1.al(h.zoom) : 0;
                A && (T.push("PROJECTION_GLOBE_VIEW"), D && T.push("PROJECTED_POS_ON_VIEWPORT"));
                const P = t1.getOrCreateProgram("collisionBox", {
                    defines: T
                });
                let O = E;
                0 === n[0] && 0 === n[1] || (O = t1.translatePosMatrix(E, x, n, s));
                const M = a ? b.textCollisionBox : b.iconCollisionBox, z = b.collisionCircleArray;
                if (z.length > 0) {
                    const t1 = e1.bc(), i = O;
                    e1.cu(t1, b.placementInvProjMatrix, h.glCoordMatrix), e1.cu(t1, t1, b.placementViewportMatrix), g.push({
                        circleArray: z,
                        circleOffset: y,
                        transform: i,
                        invTransform: t1,
                        projection: b.getProjection()
                    }), v += z.length / 4, y = v;
                }
                if (!M) continue;
                t1.terrain && t1.terrain.setupElevationDraw(x, P);
                const F = A ? [
                    _.canonical.x,
                    _.canonical.y,
                    1 << _.canonical.z
                ] : [
                    0,
                    0,
                    0
                ];
                P.draw(t1, c.LINES, Hi.disabled, $i.disabled, t1.colorModeForRenderPass(), Ki.disabled, Rn(O, w, h, L, d, x, F, b.getProjection()), o.id, M.layoutVertexBuffer, M.indexBuffer, M.segments, null, h.zoom, null, [
                    M.collisionVertexBuffer,
                    M.collisionVertexBufferExt
                ]);
            }
            if (!a || !g.length) return;
            const x = t1.getOrCreateProgram("collisionCircle"), b = new e1.dL;
            b.resize(4 * v), b._trim();
            let w = 0;
            for (const e1 of g)for(let t1 = 0; t1 < e1.circleArray.length / 4; t1++){
                const i = 4 * t1, o = e1.circleArray[i + 0], r = e1.circleArray[i + 1], n = e1.circleArray[i + 2], s = e1.circleArray[i + 3];
                b.emplace(w++, o, r, n, s, 0), b.emplace(w++, o, r, n, s, 1), b.emplace(w++, o, r, n, s, 2), b.emplace(w++, o, r, n, s, 3);
            }
            (!ts || ts.length < 2 * v) && (ts = function(t1) {
                const i = 2 * t1, o = new e1.dy;
                o.resize(i), o._trim();
                for(let e1 = 0; e1 < i; e1++){
                    const t1 = 6 * e1;
                    o.uint16[t1 + 0] = 4 * e1 + 0, o.uint16[t1 + 1] = 4 * e1 + 1, o.uint16[t1 + 2] = 4 * e1 + 2, o.uint16[t1 + 3] = 4 * e1 + 2, o.uint16[t1 + 4] = 4 * e1 + 3, o.uint16[t1 + 5] = 4 * e1 + 0;
                }
                return o;
            }(v));
            const T = l.createIndexBuffer(ts, !0), E = l.createVertexBuffer(b, e1.dM.members, !0);
            for (const i of g){
                const r = Dn(i.transform, i.invTransform, h, i.projection);
                x.draw(t1, c.TRIANGLES, Hi.disabled, $i.disabled, t1.colorModeForRenderPass(), Ki.disabled, r, o.id, E, T, e1.du.simpleSegment(0, 2 * i.circleOffset, i.circleArray.length, i.circleArray.length / 2), null, h.zoom);
            }
            E.destroy(), T.destroy();
        }
        const os = e1.bc();
        function rs(t1) {
            const i = t1._camera.getWorldToCamera(t1.worldSize, 1), o = e1.aD([], i, t1.globeMatrix);
            e1.b8(o, o);
            const r = [
                0,
                0,
                0
            ], n = [
                0,
                1,
                0,
                0
            ];
            return e1.aE(n, n, o), r[0] = n[0], r[1] = n[1], r[2] = n[2], e1.ay(r, r), r;
        }
        function ns({ width: t1, height: i, anchor: o, textOffset: r, textScale: n }, s) {
            const { horizontalAlign: a, verticalAlign: l } = e1.bG(o), c = -(a - .5) * t1, h = -(l - .5) * i, d = e1.bH(o, r);
            return new e1.P((c / n + d[0]) * s, (h / n + d[1]) * s);
        }
        function ss(t1, i, o, r, n, s, a, l, c, h) {
            const d = t1.text.placedSymbolArray, _ = t1.text.dynamicLayoutVertexArray, u = t1.icon.dynamicLayoutVertexArray, p = {}, f = t1.getProjection(), m = Kt(a, f, n), g = n.elevation, v = f.upVectorScale(a.canonical, n.center.lat, n.worldSize).metersToTile;
            _.clear();
            for(let u = 0; u < d.length; u++){
                const y = d.get(u), { tileAnchorX: x, tileAnchorY: b, numGlyphs: w } = y, T = y.hidden || !y.crossTileID || t1.allowVerticalPlacement && !y.placedOrientation ? null : r[y.crossTileID];
                if (T) {
                    let r = 0, d = 0, E = 0;
                    const S = "road" === t1.elevationType;
                    if (g || S) {
                        const i = S ? t1.getElevationFeatureForText(u) : null, o = e1.bv.getAtTileOffset(a, new e1.P(x, b), g, i), [n, s, l] = f.upVector(a.canonical, x, b);
                        r = o * n * v, d = o * s * v, E = o * l * v;
                    }
                    let [C, I, R, D] = ri(y.projectedAnchorX + r, y.projectedAnchorY + d, y.projectedAnchorZ + E, o ? m : s);
                    const A = ni(n.getCameraToCenterDistance(f), D);
                    let L = e1.bm(t1.textSizeData, c, y) * A / e1.bz;
                    o && (L *= t1.tilePixelRatio / l);
                    const P = ns(T, L);
                    o ? ({ x: C, y: I, z: R } = f.projectTilePoint(x + P.x, b + P.y, a.canonical), [C, I, R] = ri(C + r, I + d, R + E, s)) : (i && P._rotate(-n.angle), C += P.x, I += P.y, R = 0);
                    const O = t1.allowVerticalPlacement && y.placedOrientation === e1.bl.vertical ? Math.PI / 2 : 0;
                    for(let t1 = 0; t1 < w; t1++)e1.bo(_, C, I, R, O);
                    h && y.associatedIconIndex >= 0 && (p[y.associatedIconIndex] = {
                        x: C,
                        y: I,
                        z: R,
                        angle: O
                    });
                } else pi(w, _);
            }
            if (h) {
                u.clear();
                const i = t1.icon.placedSymbolArray;
                for(let t1 = 0; t1 < i.length; t1++){
                    const o = i.get(t1), { numGlyphs: r } = o, n = p[t1];
                    if (o.hidden || !n) pi(r, u);
                    else {
                        const { x: t1, y: i, z: o, angle: s } = n;
                        for(let n = 0; n < r; n++)e1.bo(u, t1, i, o, s);
                    }
                }
                t1.icon.dynamicLayoutVertexBuffer.updateData(u);
            }
            t1.text.dynamicLayoutVertexBuffer.updateData(_);
        }
        function as(t1, i, o, r, n, s, a = {}) {
            const l = o.paint.get("icon-translate"), c = o.paint.get("text-translate"), h = o.paint.get("icon-translate-anchor"), d = o.paint.get("text-translate-anchor"), _ = o.layout.get("icon-rotation-alignment"), u = o.layout.get("text-rotation-alignment"), p = o.layout.get("icon-pitch-alignment"), f = o.layout.get("text-pitch-alignment"), m = o.layout.get("icon-keep-upright"), g = o.layout.get("text-keep-upright"), v = o.paint.get("icon-color-saturation"), y = o.paint.get("icon-color-contrast"), x = o.paint.get("icon-color-brightness-min"), b = o.paint.get("icon-color-brightness-max"), w = "sea" === o.layout.get("symbol-elevation-reference"), T = "none" === o.layout.get("icon-image-use-theme"), E = t1.context, S = E.gl, C = t1.transform, I = "map" === _, R = "map" === u, D = "map" === p, A = "map" === f, L = void 0 !== o.layout.get("symbol-sort-key").constantOr(1);
            let P = !1;
            const O = t1.depthModeForSublayer(0, Hi.ReadOnly), M = new Hi(t1.context.gl.LEQUAL, Hi.ReadOnly, t1.depthRangeFor3D), z = [
                e1.aH(C.center.lng),
                e1.aL(C.center.lat)
            ], F = o.layout.get("text-variable-anchor"), B = "globe" === C.projection.name, k = [], N = [
                0,
                -1,
                0
            ];
            for (const n of r){
                const r = i.getTile(n), s = r.getBucket(o);
                if (!s) continue;
                if ("mercator" === s.projection.name && B) continue;
                if (s.fullyClipped) continue;
                const _ = "globe" === s.projection.name, u = _ ? e1.al(C.zoom) : 0, p = Kt(n, s.getProjection(), C), f = C.calculatePixelsToTileUnitsMatrix(r), U = F && s.hasTextData(), V = s.hasIconTextFit() && U && s.hasIconData(), j = s.getProjection().createInversionMatrix(C, n.canonical), G = (1 << r.tileID.canonical.z) * e1.an / t1.transform.worldSize, q = (e1)=>{
                    let i = [
                        0,
                        0,
                        0
                    ];
                    if (e1) {
                        const e1 = t1.style.directionalLight, o = t1.style.ambientLight;
                        e1 && o && (i = fo(t1.style, e1, o));
                    }
                    return i;
                }, Z = (e1)=>{
                    if (t1.context.disableSymbolUBO) return;
                    e1.push("USE_PAINT_PROPERTIES_UBO");
                    const i = Math.floor(t1.context.maxUniformBlockSize / 4), o = Math.floor(i / 4);
                    e1.push(`MAX_UBO_SIZE_VEC4 ${o}u`);
                }, H = (e1)=>{
                    C.depthOcclusionForSymbolsAndCircles && (o.hasOcclusionOpacityProperties || t1.terrain) && (e1.push("DEPTH_D24"), e1.push("DEPTH_OCCLUSION"));
                }, W = (i)=>{
                    o.lut && !T && (o.lut.texture || (o.lut.texture = new e1.dN(t1.context, o.lut.image, [
                        o.lut.image.height,
                        o.lut.image.height,
                        o.lut.image.height
                    ], E.gl.RGBA8)), E.activeTexture.set(E.gl.TEXTURE0 + 10), o.lut.texture && o.lut.texture.bind(E.gl.LINEAR, E.gl.CLAMP_TO_EDGE), i.push("APPLY_LUT_ON_GPU"));
                }, $ = ()=>{
                    const i = I && "point" !== o.layout.get("symbol-placement"), a = [];
                    H(a), W(a);
                    const c = i || V, d = "road" === s.elevationType, g = t1.shadowRenderer, T = d && D && !!g && g.enabled, R = q(T), A = d && D && !t1.terrain ? M : O, L = o.paint.get("icon-image-cross-fade");
                    t1.terrainRenderModeElevated() && D && a.push("PITCH_WITH_MAP_TERRAIN"), _ && (a.push("PROJECTION_GLOBE_VIEW"), c && a.push("PROJECTED_POS_ON_VIEWPORT")), L > 0 && s.hasAnySecondaryIcon && a.push("ICON_TRANSITION"), !s.icon.zOffsetVertexBuffer || d && t1.terrain || a.push("Z_OFFSET"), 0 === v && 0 === y && 0 === x && 1 === b || a.push("COLOR_ADJUSTMENT"), s.sdfIcons && a.push("RENDER_SDF"), T && a.push("RENDER_SHADOWS", "NORMAL_OFFSET"), d && D && !t1.terrain && s.icon.orientationVertexBuffer && a.push("ELEVATED_ROADS"), Z(a);
                    const P = E.disableSymbolUBO ? s.icon.programConfigurations.get(o.id) : null, F = t1.getOrCreateProgram("symbol", {
                        config: P,
                        defines: a
                    }), k = r.imageAtlasTexture ? r.imageAtlasTexture.size : [
                        0,
                        0
                    ], U = s.iconSizeData, $ = e1.bk(U, C.zoom), X = D || !C.isOrthographic, Y = ti(p, r.tileID.canonical, D, I, C, s.getProjection(), f), K = oi(p, r.tileID.canonical, D, I, C, s.getProjection(), f), Q = s.icon.uboBinder && s.icon.uboBinder.cachedHeader && 256 & s.icon.uboBinder.cachedHeader.dataDrivenMask ? [
                        0,
                        0
                    ] : l, J = t1.translatePosMatrix(K, r, Q, h, !0), ee = t1.translatePosMatrix(p, r, Q, h), te = c ? os : Y, ie = I && !D && !i;
                    let oe = N;
                    !B && !C.mercatorFromTransition || I || (oe = rs(C));
                    const re = _ ? oe : N, ne = o.getColorAdjustmentMatrix(v, y, x, b), se = Gn(U.kind, $, ie, D, t1, ee, te, J, w, !1, k, [
                        0,
                        0
                    ], 0, n, u, z, j, re, s.getProjection(), R, G, ne, L, null), ae = r.imageAtlasTexture ? r.imageAtlasTexture : null, le = 1 !== o.layout.get("icon-size").constantOr(0) || s.iconsNeedLinear, ce = s.sdfIcons || t1.options.rotating || t1.options.zooming || le || X ? S.LINEAR : S.NEAREST, he = s.sdfIcons && 0 !== o.paint.get("icon-halo-width").constantOr(1), de = t1.terrain && D && i ? e1.b8(e1.bc(), Y) : os;
                    if (i && s.icon) {
                        const i = e1.bv.getAtTileOffsetFunc(n, C.center.lat, C.worldSize, s.getProjection()), a = ii(p, r.tileID.canonical, D, I, C, s.getProjection(), f), l = o.layout.get("icon-size-scale-range"), c = e1.aC(t1.scaleFactor, l[0], l[1]);
                        ai(s, p, t1, !1, a, K, D, m, i, n, c);
                    }
                    return {
                        program: F,
                        buffers: s.icon,
                        uniformValues: se,
                        atlasTexture: ae,
                        atlasTextureIcon: null,
                        atlasInterpolation: ce,
                        atlasInterpolationIcon: null,
                        isSDF: s.sdfIcons,
                        hasHalo: he,
                        depthMode: A,
                        tile: r,
                        renderWithShadows: T,
                        labelPlaneMatrixInv: de
                    };
                }, X = ()=>{
                    const i = R && "point" !== o.layout.get("symbol-placement"), a = [], l = i || F || V, h = "road" === s.elevationType, m = t1.shadowRenderer, v = h && A && !!m && m.enabled, y = q(v), x = h && A && !t1.terrain ? M : O;
                    t1.terrainRenderModeElevated() && A && a.push("PITCH_WITH_MAP_TERRAIN"), _ && (a.push("PROJECTION_GLOBE_VIEW"), l && a.push("PROJECTED_POS_ON_VIEWPORT")), !s.text.zOffsetVertexBuffer || h && t1.terrain || a.push("Z_OFFSET"), s.iconsInText && a.push("RENDER_TEXT_AND_SYMBOL"), a.push("RENDER_SDF"), v && a.push("RENDER_SHADOWS", "NORMAL_OFFSET"), h && A && !t1.terrain && s.text.orientationVertexBuffer && a.push("ELEVATED_ROADS"), H(a), Z(a);
                    const b = E.disableSymbolUBO ? s.text.programConfigurations.get(o.id) : null, T = t1.getOrCreateProgram("symbol", {
                        config: b,
                        defines: a
                    });
                    let I, D = [
                        0,
                        0
                    ], L = null;
                    const P = s.textSizeData;
                    s.iconsInText && (D = r.imageAtlasTexture ? r.imageAtlasTexture.size : [
                        0,
                        0
                    ], L = r.imageAtlasTexture ? r.imageAtlasTexture : null, I = A || !C.isOrthographic || t1.options.rotating || t1.options.zooming || "composite" === P.kind || "camera" === P.kind ? S.LINEAR : S.NEAREST);
                    const k = r.glyphAtlasTexture ? r.glyphAtlasTexture.size : [
                        0,
                        0
                    ], U = o.layout.get("text-size-scale-range"), W = e1.aC(t1.scaleFactor, U[0], U[1]), $ = e1.bk(P, C.zoom, W), X = ti(p, r.tileID.canonical, A, R, C, s.getProjection(), f), Y = oi(p, r.tileID.canonical, A, R, C, s.getProjection(), f), K = s.text.uboBinder && s.text.uboBinder.cachedHeader && 256 & s.text.uboBinder.cachedHeader.dataDrivenMask ? [
                        0,
                        0
                    ] : c, Q = t1.translatePosMatrix(Y, r, K, d, !0), J = t1.translatePosMatrix(p, r, K, d), ee = l ? os : X, te = R && !A && !i;
                    let ie = N;
                    !B && !C.mercatorFromTransition || R || (ie = rs(C));
                    const oe = Gn(P.kind, $, te, A, t1, J, ee, Q, w, !0, k, D, 0, n, u, z, j, _ ? ie : N, s.getProjection(), y, G, null, null, W), re = r.glyphAtlasTexture ? r.glyphAtlasTexture : null, ne = S.LINEAR, se = 0 !== o.paint.get("text-halo-width").constantOr(1), ae = t1.terrain && A && i ? e1.b8(e1.bc(), X) : os;
                    if (i && s.text) {
                        const i = e1.bv.getAtTileOffsetFunc(n, C.center.lat, C.worldSize, s.getProjection()), o = ii(p, r.tileID.canonical, A, R, C, s.getProjection(), f);
                        ai(s, p, t1, !0, o, Y, A, g, i, n, W);
                    }
                    return {
                        program: T,
                        buffers: s.text,
                        uniformValues: oe,
                        atlasTexture: re,
                        atlasTextureIcon: L,
                        atlasInterpolation: ne,
                        atlasInterpolationIcon: I,
                        isSDF: !0,
                        hasHalo: se,
                        depthMode: x,
                        tile: r,
                        renderWithShadows: v,
                        labelPlaneMatrixInv: ae
                    };
                }, Y = s.icon.segments.get().length, K = s.text.segments.get().length, Q = Y && !a.onlyText ? $() : null, J = K && !a.onlyIcons ? X() : null, ee = o.paint.get("icon-opacity").constantOr(1), te = o.paint.get("text-opacity").constantOr(1);
                if (L && s.canOverlap) {
                    P = !0;
                    const t1 = ee && !a.onlyText ? s.icon.segments.get() : [], i = te && !a.onlyIcons ? s.text.segments.get() : [];
                    for (const i of t1)k.push({
                        segments: new e1.du([
                            i
                        ]),
                        sortKey: i.sortKey,
                        state: Q
                    });
                    for (const t1 of i)k.push({
                        segments: new e1.du([
                            t1
                        ]),
                        sortKey: t1.sortKey,
                        state: J
                    });
                } else a.onlyText || k.push({
                    segments: ee ? s.icon.segments : new e1.du([]),
                    sortKey: 0,
                    state: Q
                }), a.onlyIcons || k.push({
                    segments: te ? s.text.segments : new e1.du([]),
                    sortKey: 0,
                    state: J
                });
            }
            P && k.sort((e1, t1)=>e1.sortKey - t1.sortKey);
            for (const e1 of k){
                const i = e1.state;
                if (i) {
                    if (t1.terrain ? t1.terrain.setupElevationDraw(i.tile, i.program, {
                        useDepthForOcclusion: C.depthOcclusionForSymbolsAndCircles,
                        labelPlaneMatrixInv: i.labelPlaneMatrixInv
                    }) : t1.setupDepthForOcclusion(C.depthOcclusionForSymbolsAndCircles, i.program), E.activeTexture.set(S.TEXTURE0), i.atlasTexture && i.atlasTexture.bind(i.atlasInterpolation, S.CLAMP_TO_EDGE, !0), i.atlasTextureIcon && (E.activeTexture.set(S.TEXTURE1), i.atlasTextureIcon && i.atlasTextureIcon.bind(i.atlasInterpolationIcon, S.CLAMP_TO_EDGE, !0)), i.renderWithShadows && t1.shadowRenderer.setupShadows(i.tile.tileID.toUnwrapped(), i.program, "vector-tile"), t1.uploadCommonLightUniforms(t1.context, i.program), i.hasHalo) {
                        const r = i.uniformValues;
                        r.u_is_halo = 1, ls(i.buffers, e1.segments, o, t1, i.program, i.depthMode, n, s, r, 2), r.u_is_halo = 0;
                    } else {
                        if (i.isSDF) {
                            const r = i.uniformValues;
                            i.hasHalo && (r.u_is_halo = 1, ls(i.buffers, e1.segments, o, t1, i.program, i.depthMode, n, s, r, 1)), r.u_is_halo = 0;
                        }
                        ls(i.buffers, e1.segments, o, t1, i.program, i.depthMode, n, s, i.uniformValues, 1);
                    }
                }
            }
        }
        function ls(e1, t1, i, o, r, n, s, a, l, c) {
            const h = o.context, d = h.gl, _ = [
                e1.dynamicLayoutVertexBuffer,
                e1.opacityVertexBuffer,
                e1.iconTransitioningVertexBuffer,
                e1.globeExtVertexBuffer,
                e1.zOffsetVertexBuffer,
                e1.orientationVertexBuffer
            ];
            e1.featureIdBuffer && _.push(e1.featureIdBuffer);
            const u = e1.uboBinder ? null : e1.programConfigurations.get(i.id);
            if (e1.uboBinder) {
                e1.uboBinder.layer = i;
                const t1 = o.transform.zoom, r = o.style.getBrightness ? o.style.getBrightness() : null, n = e1.uboBinder.getConstantUniformValues(t1, r);
                l.u_spp_fill_np_color = n.fill_np_color, l.u_spp_halo_np_color = n.halo_np_color, l.u_spp_opacity = n.opacity, l.u_spp_halo_width = n.halo_width, l.u_spp_halo_blur = n.halo_blur, l.u_spp_emissive_strength = n.emissive_strength, l.u_spp_occlusion_opacity = n.occlusion_opacity, l.u_spp_z_offset = n.z_offset;
                const s = i.paint.get(e1.uboBinder.isText ? "text-translate-anchor" : "icon-translate-anchor"), a = e1.uboBinder.cachedHeader && 256 & e1.uboBinder.cachedHeader.dataDrivenMask && "map" === s ? o.transform.angle : 0;
                l.u_spp_translate_rotation = [
                    Math.cos(a),
                    Math.sin(a)
                ];
            }
            const { batchIndices: p, batchSegments: f } = e1.getBatchGrouping(t1);
            for (const t1 of p){
                const p = f.get(t1);
                e1.uboBinder && e1.uboBinder.bind(h, r.program, t1), r.draw(o, d.TRIANGLES, n, s, a, Ki.disabled, l, i.id, e1.layoutVertexBuffer, e1.indexBuffer, p, i.paint, o.transform.zoom, u, _, c);
            }
        }
        function cs(t1, i, o, r, n, s) {
            const a = o.paint.get("line-width"), l = o.paint.get("line-emissive-strength").isConstant(), c = o.paint.get("line-emissive-strength").constantOr(0), h = o.paint.get("line-occlusion-opacity"), d = o.layout.get("line-elevation-reference"), _ = "meters" === o.layout.get("line-width-unit"), u = "sea" === d, p = !(!t1.terrain || !t1.terrain.enabled), f = t1.context, m = f.gl;
            if (o.hasElevatedBuckets && "globe" === t1.transform.projection.name) return;
            const g = o.layout.get("line-cross-slope"), v = void 0 !== g, y = g < 1, x = n || t1.colorModeForDrapableLayerRenderPass(l ? c : null), b = t1.terrain && t1.terrain.renderingToTexture || s, w = b ? 1 : e1.o.devicePixelRatio, T = o.paint.get("line-dasharray"), E = T.constantOr(1), S = o.layout.get("line-cap"), C = T.constantOr(null), I = S.constantOr(null), R = o.paint.get("line-pattern"), D = R.constantOr(1), A = o.paint.get("line-pattern-cross-fade"), L = R.constantOr(null), P = o.paint.get("line-opacity").constantOr(1);
            let O = !D && 1 !== P || t1.depthOcclusion && h > 0 && h < 1;
            const M = o.paint.get("line-gradient"), z = D ? "linePattern" : "line", F = e1.dQ(o);
            let B;
            if (b && t1.terrain && t1.terrain.clipOrMaskOverlapStencilType() && (O = !1), 0 !== h && t1.depthOcclusion) {
                const t1 = o.paint._values["line-opacity"];
                t1 && t1.value && "constant" === t1.value.kind ? B = t1.value : e1.w(`Occlusion opacity for layer ${o.id} is supported only when line-opacity isn't data-driven.`);
            }
            "constant" !== a.value.kind && !1 === a.value.isLineProgressConstant && F.push("VARIABLE_LINE_WIDTH"), b && ("dual-source-blending" !== t1.emissiveMode || l ? "mrt-fallback" === t1.emissiveMode && F.push("USE_MRT1") : F.push("DUAL_SOURCE_BLENDING"));
            const k = {}, N = (r, n, s, a, l, c)=>{
                for (const d of r){
                    const r = i.getTile(d);
                    if (D && !r.patternsLoaded()) continue;
                    const u = r.getBucket(o);
                    if (!u) continue;
                    if ("none" !== u.elevationType && !l || "none" === u.elevationType && l) continue;
                    t1.prepareDrawTile();
                    const p = [
                        ...n
                    ], g = t1.shadowRenderer, v = "road" === u.elevationType && !!g && g.enabled;
                    let y = [
                        0,
                        0,
                        0
                    ];
                    if (v) {
                        const e1 = t1.style.directionalLight, i = t1.style.ambientLight;
                        e1 && i && (y = fo(t1.style, e1, i)), p.push("RENDER_SHADOWS", "NORMAL_OFFSET");
                    }
                    const T = u.programConfigurations.get(o.id);
                    let S = !1;
                    if (L && r.imageAtlas) {
                        const t1 = e1.dR.from(L), i = t1.getPrimary().scaleSelf(w).toString(), o = r.imageAtlas.patternPositions.get(i), n = t1.getSecondary(), s = n ? r.imageAtlas.patternPositions.get(n.scaleSelf(w).toString()) : null;
                        S = !!o && !!s, o && T.setConstantPatternPositions(o, s);
                    }
                    A > 0 && (S || T.getPatternTransitionVertexBuffer("line-pattern")) && p.push("LINE_PATTERN_TRANSITION"), u.elevationGroundScaleVertexBuffer && p.push("ELEVATION_GROUND_SCALE");
                    const R = t1.isTileAffectedByFog(d), F = t1.getOrCreateProgram(z, {
                        config: T,
                        defines: p,
                        overrideFog: R
                    });
                    if (!D && C && I && r.lineAtlas) {
                        const e1 = r.lineAtlas.getDash(C, I);
                        e1 && T.setConstantPatternPositions(e1);
                    }
                    v && g.setupShadows(r.tileID.toUnwrapped(), F, "vector-tile");
                    let [N, U] = o.paint.get("line-trim-offset");
                    if ("round" === I || "square" === I) {
                        const e1 = 1;
                        N !== U && (0 === N && (N -= e1), 1 === U && (U += e1));
                    }
                    const V = b ? d.projMatrix : null, j = _ ? 1 / u.tileToMeter / e1.aA(r, 1, t1.transform.zoom) : 1, G = _ ? 1 / u.tileToMeter / e1.aA(r, 1, Math.floor(t1.transform.zoom)) : 1, q = E ? o.paint._values["line-floorwidth"] : null;
                    let Z;
                    if (q && "constant" === q.value.kind) {
                        const e1 = u.zoom;
                        e1 in k || (k[e1] = Math.max(.01, o.widthExpression().evaluate({
                            zoom: e1
                        }))), Z = q.value.value;
                        const i = Math.floor(t1.transform.zoom);
                        q.value.value = k[e1] * Math.pow(2, i - r.tileID.overscaledZ);
                    }
                    const H = D ? e1.dS(t1, r, o, V, w, j, G, [
                        N,
                        U
                    ], y, A) : e1.dT(t1, r, o, V, u.lineClipsArray.length, w, j, G, [
                        N,
                        U
                    ], y);
                    if (M) {
                        const r = u.gradients[o.id];
                        let n = r.texture;
                        if (o.gradientVersion !== r.version) {
                            let s = 256;
                            if (o.stepInterpolant) {
                                const o = i.getSource().maxzoom, r = d.canonical.z === o ? Math.ceil(1 << t1.transform.maxZoom - d.canonical.z) : 1;
                                s = e1.aC(e1.dU(u.maxLineLength / e1.an * 1024 * r), 256, f.maxTextureSize);
                            }
                            r.gradient = e1.dV({
                                expression: o.gradientExpression(),
                                evaluationKey: "lineProgress",
                                resolution: s,
                                image: r.gradient || void 0,
                                clips: u.lineClipsArray
                            }), r.texture ? r.texture.update(r.gradient) : r.texture = new e1.T(f, r.gradient, m.RGBA8), r.version = o.gradientVersion, n = r.texture;
                        }
                        f.activeTexture.set(m.TEXTURE1), n.bind(o.stepInterpolant ? m.NEAREST : m.LINEAR, m.CLAMP_TO_EDGE);
                    }
                    E && (f.activeTexture.set(m.TEXTURE0), r.lineAtlasTexture && r.lineAtlasTexture.bind(m.LINEAR, m.REPEAT), T.updatePaintBuffers()), D && (f.activeTexture.set(m.TEXTURE0), r.imageAtlasTexture && r.imageAtlasTexture.bind(m.LINEAR, m.CLAMP_TO_EDGE), T.updatePaintBuffers()), l && t1.terrain.setupElevationDraw(r, F), t1.uploadCommonUniforms(f, F, d.toUnwrapped());
                    const W = (e1)=>{
                        null != B && (B.value = P * h), F.draw(t1, m.TRIANGLES, s, e1, x, Ki.disabled, H, o.id, u.layoutVertexBuffer, u.indexBuffer, u.segments, o.paint, t1.transform.zoom, T, [
                            u.layoutVertexBuffer2,
                            u.patternVertexBuffer,
                            u.zOffsetVertexBuffer,
                            u.elevationGroundScaleVertexBuffer
                        ]), null != B && (B.value = P);
                    };
                    if (O && !l) {
                        const e1 = t1.stencilModeForClipping(d).ref;
                        0 === e1 && b && f.clear({
                            stencil: 0
                        });
                        const i = {
                            func: m.EQUAL,
                            mask: 255
                        };
                        H.u_alpha_discard_threshold = .8, W(new $i(i, e1, 255, m.KEEP, m.KEEP, m.INVERT)), H.u_alpha_discard_threshold = 0, W(new $i(i, e1, 255, m.KEEP, m.KEEP, m.KEEP));
                    } else H.u_alpha_discard_threshold = O && l && c ? .8 : 0, W(l ? a : t1.stencilModeForClipping(d));
                    void 0 !== Z && (q.value.value = Z);
                }
            };
            let U = t1.depthModeForSublayer(0, Hi.ReadOnly);
            const V = new Hi(t1.depthOcclusion ? m.GREATER : m.LEQUAL, Hi.ReadOnly, t1.depthRangeFor3D);
            if (o.hasNonElevatedBuckets) {
                const i = !b && t1.terrain;
                0 !== h && i ? e1.w(`Occlusion opacity for layer ${o.id} is supported on terrain only if the layer has line-z-offset enabled.`) : i ? e1.w(`Cannot render non-elevated lines in immediate mode when terrain is enabled. Layer: ${o.id}.`) : N(r, F, U, $i.disabled, !1, !0);
            }
            if (o.hasElevatedBuckets) {
                "hd-road-markup" === d ? p || (U = V, F.push("ELEVATED_ROADS")) : (F.push("ELEVATED"), U = V, v && F.push(y ? "CROSS_SLOPE_HORIZONTAL" : "CROSS_SLOPE_VERTICAL"), u && F.push("ELEVATION_REFERENCE_SEA"));
                const e1 = O ? t1.stencilModeFor3D() : $i.disabled;
                t1.forceTerrainMode = !0, N(r, F, U, e1, !0, !0), O && N(r, F, U, e1, !0, !1), t1.forceTerrainMode = !1;
            }
            O && (t1.resetStencilClippingMasks(), b && f.clear({
                stencil: 0
            })), 0 === h || t1.depthOcclusion || b || t1.layersWithOcclusionOpacity.push(t1.currentLayer);
        }
        const hs = {
            additive: {
                clearColor: new e1.aq(0, 0, 0, 0),
                colorMode: Zi.additive,
                compositeUniformValue: 1
            },
            multiply: {
                clearColor: new e1.aq(1, 1, 1, 1),
                colorMode: Zi.multiply,
                compositeUniformValue: 0
            }
        };
        function ds(t1, i) {
            const o = 1 << t1.canonical.z, r = (i.x * o - t1.canonical.x - t1.wrap * o) * e1.an, n = (i.y * o - t1.canonical.y) * e1.an, s = e1.dW(i.z, i.y);
            return e1.cM(r, n, s);
        }
        function _s(t1, i, o, r, n) {
            if (!o.layout || "none" === o.layout.get("fill-elevation-reference") || 0 === o.paint.get("fill-opacity").constantOr(1)) return;
            const s = t1.context.gl, a = new Hi(t1.context.gl.LEQUAL, Hi.ReadWrite, t1.depthRangeFor3D), l = new Hi(t1.context.gl.GREATER, Hi.ReadWrite, t1.depthRangeFor3D), c = function(t1) {
                let i = .01;
                return t1.isOrthographic && (i = e1.am(1e-4, i, e1.cH(t1.pitch >= no ? 1 : t1.pitch / no))), 2 * i;
            }(t1.transform), h = t1.transform.getFreeCameraOptions().position, d = "elevatedStructuresDepthReconstruct", _ = t1.getOrCreateProgram(d, {
                defines: [
                    "DEPTH_RECONSTRUCTION"
                ]
            }), u = t1.getOrCreateProgram(d);
            for (const e1 of r){
                const r = i.getTile(e1), d = r.getBucket(o);
                if (!d) continue;
                const p = d.elevatedStructures;
                if (!p) continue;
                const f = d.elevationBufferData.heightRange, m = ds(e1.toUnwrapped(), h), g = t1.translatePosMatrix(e1.projMatrix, r, o.paint.get("fill-translate"), o.paint.get("fill-translate-anchor"));
                let v, y, x, b;
                if ("initialize" === n) {
                    if (!f || f.min >= 1 || 0 === p.depthSegments.segments[0].primitiveLength) continue;
                    v = Tn(g, m, c, 1, 0), y = a, x = p.depthSegments, b = _;
                } else if ("reset" === n) {
                    if (!f || f.min >= 0 || 0 === p.maskSegments.segments[0].primitiveLength) continue;
                    v = Tn(g, m, 0, 0, 1), y = l, x = p.maskSegments, b = _;
                } else if ("geometry" === n) {
                    if (0 === p.depthSegments.segments[0].primitiveLength) continue;
                    v = Tn(g, m, c, 1, 0), y = a, x = p.depthSegments, b = u;
                }
                b.draw(t1, s.TRIANGLES, y, $i.disabled, Zi.disabled, Ki.disabled, v, o.id, p.vertexBuffer, p.indexBuffer, x, o.paint, t1.transform.zoom);
            }
        }
        function us(t1, i, o, r) {
            const { painter: n, sourceCache: s, layer: a, coords: l, colorMode: c, elevationType: h, terrainEnabled: d, pass: _ } = t1, u = n.context.gl, p = a.paint.get("fill-pattern"), f = a.paint.get("fill-pattern-cross-fade"), m = p.constantOr(null);
            let g = h;
            "road" !== h || i && !d || (g = "none");
            const v = "road" === g, y = t1.painter.shadowRenderer, x = v && !!y && y.enabled, b = new Hi(n.context.gl.LEQUAL, Hi.ReadOnly, n.depthRangeFor3D);
            let w = [
                0,
                0,
                0
            ];
            if (x) {
                const e1 = n.style.directionalLight, t1 = n.style.ambientLight;
                e1 && t1 && (w = fo(n.style, e1, t1));
            }
            const T = p && p.constantOr(1), E = n.terrain && n.terrain.renderingToTexture, S = (t1, _)=>{
                let p, g, S, C, I;
                _ ? (p = T && !a.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", S = u.LINES) : (p = T ? "fillPattern" : "fill", S = u.TRIANGLES);
                for (const R of l){
                    const l = s.getTile(R);
                    if (T && !l.patternsLoaded()) continue;
                    const D = l.getBucket(a);
                    if (!D) continue;
                    const A = i ? D.elevationBufferData : D.bufferData;
                    if (A.isEmpty()) continue;
                    n.prepareDrawTile();
                    const L = A.programConfigurations.get(a.id), P = n.isTileAffectedByFog(R), O = [], M = [];
                    v && (O.push("ELEVATED_ROADS"), M.push(A.elevatedLayoutVertexBuffer)), x && O.push("RENDER_SHADOWS", "NORMAL_OFFSET"), E && o && O.push("USE_MRT1"), T && (n.context.activeTexture.set(u.TEXTURE0), l.imageAtlasTexture && l.imageAtlasTexture.bind(u.LINEAR, u.CLAMP_TO_EDGE), L.updatePaintBuffers());
                    let z = !1;
                    if (m && l.imageAtlas) {
                        const t1 = l.imageAtlas, i = e1.dR.from(m), o = i.getPrimary().scaleSelf(e1.o.devicePixelRatio).toString(), r = i.getSecondary(), n = t1.patternPositions.get(o), s = r ? t1.patternPositions.get(r.scaleSelf(e1.o.devicePixelRatio).toString()) : null;
                        z = !!n && !!s, n && L.setConstantPatternPositions(n, s);
                    }
                    f > 0 && (z || L.getPatternTransitionVertexBuffer("fill-pattern")) && O.push("FILL_PATTERN_TRANSITION");
                    const F = n.getOrCreateProgram(p, {
                        config: L,
                        overrideFog: P,
                        defines: O
                    }), B = n.translatePosMatrix(R.projMatrix, l, a.paint.get("fill-translate"), a.paint.get("fill-translate-anchor"));
                    x && y.setupShadows(l.tileID.toUnwrapped(), F, "vector-tile");
                    const k = a.paint.get("fill-emissive-strength");
                    if (_) {
                        C = A.lineIndexBuffer, I = A.lineSegments;
                        const e1 = n.terrain && n.terrain.renderingToTexture ? n.terrain.drapeBufferSize : [
                            u.drawingBufferWidth,
                            u.drawingBufferHeight
                        ];
                        g = "fillOutlinePattern" === p && T ? xn(B, k, n, l, e1, w, f) : yn(B, k, e1, w);
                    } else C = A.indexBuffer, I = A.triangleSegments, g = T ? vn(B, k, n, l, w, f) : gn(B, k, w);
                    n.uploadCommonUniforms(n.context, F, R.toUnwrapped());
                    let N = t1;
                    ("road" === h && !d || "offset" === h) && (N = b), F.draw(n, S, N, r || n.stencilModeForClipping(R), c, Ki.disabled, g, a.id, A.layoutVertexBuffer, C, I, a.paint, n.transform.zoom, L, M);
                }
            };
            n.renderPass === _ && S(n.depthModeForSublayer(1, "opaque" === n.renderPass ? Hi.ReadWrite : Hi.ReadOnly), !1), "none" === g && "translucent" === n.renderPass && a.paint.get("fill-antialias") && S(n.depthModeForSublayer(a.getPaintProperty("fill-outline-color") ? 2 : 0, Hi.ReadOnly), !0);
        }
        function ps(t1, i, o, r, n, s, a, l) {
            o.resetLayerRenderingStats(t1);
            const c = t1.context, h = c.gl, d = t1.transform, _ = o.paint.get("fill-extrusion-pattern"), u = o.paint.get("fill-extrusion-pattern-cross-fade"), p = _.constantOr(null), f = _.constantOr(1), m = o.paint.get("fill-extrusion-opacity"), g = t1.style.enable3dLights(), v = o.paint.get(g && !f ? "fill-extrusion-ambient-occlusion-wall-radius" : "fill-extrusion-ambient-occlusion-radius"), y = [
                o.paint.get("fill-extrusion-ambient-occlusion-intensity"),
                v
            ], x = o.layout.get("fill-extrusion-edge-radius"), b = x > 0 && !o.paint.get("fill-extrusion-rounded-roof"), w = b ? 0 : x, T = "globe" === d.projection.name ? e1.dZ() : 0, E = "globe" === d.projection.name, S = E ? e1.al(d.zoom) : 0, C = [
                e1.aH(d.center.lng),
                e1.aL(d.center.lat)
            ], I = "none" === o.paint.get("fill-extrusion-flood-light-color-use-theme").constantOr("default"), R = o.paint.get("fill-extrusion-flood-light-color").toNonPremultipliedRenderColor(I ? null : o.lut).toArray01().slice(0, 3), D = o.paint.get("fill-extrusion-flood-light-intensity"), A = o.paint.get("fill-extrusion-vertical-scale"), L = 0 !== o.paint.get("fill-extrusion-line-width").constantOr(1), P = o.paint.get("fill-extrusion-height-alignment"), O = o.paint.get("fill-extrusion-base-alignment"), M = ao(t1, o.paint.get("fill-extrusion-cutoff-fade-range")), z = o.paint.get("fill-extrusion-front-cutoff"), F = ms(d.pitch, z, !!t1.terrain), B = F[2] < 1;
            B && (t1.maxFrontCutoffRawStart = Math.max(t1.maxFrontCutoffRawStart, z[0]));
            const k = [];
            let N;
            E && k.push("PROJECTION_GLOBE_VIEW"), y[0] > 0 && k.push("FAUX_AO"), b && k.push("ZERO_ROOF_RADIUS"), l && k.push("HAS_CENTROID"), D > 0 && k.push("FLOOD_LIGHT"), M.shouldRenderCutoff && k.push("RENDER_CUTOFF"), B && k.push("RENDER_FRONT_CUTOFF"), L && k.push("RENDER_WALL_MODE");
            const U = "shadow" === t1.renderPass, V = t1.shadowRenderer, j = U && !!V, G = U ? Ki.disabled : Ki.backCCW;
            t1.shadowRenderer && (t1.shadowRenderer.useNormalOffset = !0);
            let q = [
                0,
                0,
                0
            ];
            if (V) {
                const e1 = t1.style.directionalLight, i = t1.style.ambientLight;
                e1 && i && (q = fo(t1.style, e1, i)), U || (k.push("RENDER_SHADOWS"), V.useNormalOffset && k.push("NORMAL_OFFSET")), N = k.concat([
                    "SHADOWS_SINGLE_CASCADE"
                ]);
            }
            const Z = j ? "fillExtrusionDepth" : f ? "fillExtrusionPattern" : "fillExtrusion", H = o.getLayerRenderingStats();
            for (const _ of r){
                const r = i.getTile(_), g = r.getBucket(o);
                if (!g || g.projection.name !== d.projection.name) continue;
                let v = !1;
                V && (v = 0 === V.getMaxCascadeForTile(_.toUnwrapped()));
                const x = t1.isTileAffectedByFog(_), b = g.programConfigurations.get(o.id);
                let I = !1;
                if (p && r.imageAtlas) {
                    const t1 = r.imageAtlas, i = e1.dR.from(p), o = i.getPrimary().scaleSelf(e1.o.devicePixelRatio).toString(), n = i.getSecondary(), s = t1.patternPositions.get(o), a = n ? t1.patternPositions.get(n.scaleSelf(e1.o.devicePixelRatio).toString()) : null;
                    I = !!s && !!a, s && b.setConstantPatternPositions(s, a);
                }
                u > 0 && (I || b.getPatternTransitionVertexBuffer("fill-extrusion-pattern")) && k.push("FILL_EXTRUSION_PATTERN_TRANSITION");
                const z = t1.getOrCreateProgram(Z, {
                    config: b,
                    defines: v ? N : k,
                    overrideFog: x
                });
                if (t1.terrain && t1.terrain.setupElevationDraw(r, z, {
                    useMeterToDem: !0
                }), !g.centroidVertexBuffer) {
                    const e1 = z.getAttributeLocation(h, "a_centroid_pos");
                    -1 !== e1 && h.vertexAttribI4ui(e1, 0, 0, 0, 0);
                }
                !U && V && V.setupShadows(r.tileID.toUnwrapped(), z, "vector-tile"), f && (t1.context.activeTexture.set(h.TEXTURE0), r.imageAtlasTexture && r.imageAtlasTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), b.updatePaintBuffers());
                const B = o.paint.get("fill-extrusion-vertical-gradient"), j = 1 / g.tileToMeter;
                let W;
                if (U && V) {
                    if (ws(r.tileID, g.maxHeight, t1)) continue;
                    const e1 = V.calculateShadowPassMatrixFromTile(r.tileID.toUnwrapped());
                    W = fn(e1, w, j, A, P, O);
                } else {
                    const e1 = t1.translatePosMatrix(_.expandedProjMatrix, r, o.paint.get("fill-extrusion-translate"), o.paint.get("fill-extrusion-translate-anchor")), i = d.projection.createInversionMatrix(d, _.canonical);
                    W = f ? mn(e1, t1, B, m, y, w, j, _, r, T, P, O, S, C, i, R, A, u) : pn(e1, t1, B, m, y, w, j, _, T, P, O, S, C, i, R, A, D, q, F);
                }
                t1.uploadCommonUniforms(c, z, _.toUnwrapped(), null, M);
                let $ = g.segments;
                if ("mercator" === d.projection.name && !U && ($ = g.getVisibleSegments(r.tileID, t1.terrain, t1.transform.getFrustum(0)), !$.get().length)) continue;
                if (H) {
                    if (U) for (const e1 of $.get())H.numRenderedVerticesInShadowPass += e1.primitiveLength;
                    else for (const e1 of $.get())H.numRenderedVerticesInTransparentPass += e1.primitiveLength;
                }
                const X = [];
                (t1.terrain || l) && X.push(g.centroidVertexBuffer), E && X.push(g.layoutVertexExtBuffer), L && X.push(g.wallVertexBuffer), z.draw(t1, c.gl.TRIANGLES, n, s, a, G, W, o.id, g.layoutVertexBuffer, g.indexBuffer, $, o.paint, t1.transform.zoom, b, X);
            }
            t1.shadowRenderer && (t1.shadowRenderer.useNormalOffset = !1);
        }
        class fs {
            constructor(){
                this.translate = [
                    0,
                    0
                ], this.translateAnchor = "map", this.edgeRadius = 0, this.cutoffFadeRange = 0;
            }
        }
        function ms(e1, t1, i) {
            if (!(t1[2] < 1) || i) return [
                0,
                0,
                1
            ];
            const o = 180 * e1 / Math.PI;
            if (o < 15) return [
                -0.5,
                t1[1],
                t1[2]
            ];
            const r = Math.min(1, Math.max(0, (o - 15) / 5)), n = r * r * (3 - 2 * r);
            return [
                -0.5 * (1 - n) + t1[0] * n,
                t1[1],
                t1[2]
            ];
        }
        function gs(t1, i, o, r, n, s, a, l, c, h, d, _, u, p, f, m, g, v, y, x, b) {
            const w = i.context, T = w.gl, E = i.transform, S = i.transform.zoom, C = [], I = t1.translate, R = t1.translateAnchor, D = t1.edgeRadius, A = ao(i, t1.cutoffFadeRange);
            "clear" === d ? (C.push("CLEAR_SUBPASS"), x && (C.push("CLEAR_FROM_TEXTURE"), w.activeTexture.set(T.TEXTURE0), x.bind(T.LINEAR, T.CLAMP_TO_EDGE))) : "sdf" === d ? C.push("SDF_SUBPASS") : "emissive" === d && (C.push("USE_MRT1"), w.activeTexture.set(T.TEXTURE0), x.bind(T.LINEAR, T.CLAMP_TO_EDGE)), v && C.push("HAS_CENTROID"), A.shouldRenderCutoff && C.push("RENDER_CUTOFF");
            const L = (e1, t1, o, n, d)=>{
                let y = C;
                null != t1.groundRadiusBuffer && (y = C.concat("HAS_ATTRIBUTE_a_flood_light_ground_radius"));
                const b = t1.programConfigurations.get(r.id), T = i.isTileAffectedByFog(e1), E = i.getOrCreateProgram("fillExtrusionGroundEffect", {
                    config: b,
                    defines: y,
                    overrideFog: T
                }), I = ((e1, t1, i, o, r, n, s, a, l, c, h)=>({
                        u_matrix: t1,
                        u_opacity: i,
                        u_ao_pass: o ? 1 : 0,
                        u_meter_to_tile: r,
                        u_ao: n,
                        u_flood_light_intensity: s,
                        u_flood_light_color: a,
                        u_attenuation: l,
                        u_edge_radius: c,
                        u_fb: 0,
                        u_fb_size: h,
                        u_dynamic_offset: 1
                    }))(0, n, _, h, d, [
                    u,
                    p * d
                ], f, m, g, S >= 17 ? 0 : D * d, x ? x.size[0] : 0), R = [];
                v && R.push(t1.hiddenByLandmarkVertexBuffer), null != t1.groundRadiusBuffer && R.push(t1.groundRadiusBuffer), i.uploadCommonUniforms(w, E, e1.toUnwrapped(), null, A), E.draw(i, w.gl.TRIANGLES, s, a, l, c, I, r.id, t1.vertexBuffer, t1.indexBuffer, o, r.paint, S, b, R);
            };
            for (const t1 of n){
                const n = o.getTile(t1), s = n.getBucket(r);
                if (!s || s.projection.name !== E.projection.name || !s.groundEffect || s.groundEffect && !s.groundEffect.hasData()) continue;
                const a = s.groundEffect, l = 1 / s.tileToMeter;
                {
                    const e1 = i.translatePosMatrix(t1.projMatrix, n, I, R), o = a.getDefaultSegment();
                    L(t1, a, o, e1, l);
                }
                if (y) for(let s = 0; s < 4; s++){
                    const a = e1.dX[s](t1), c = o.getTile(a);
                    if (!c) continue;
                    const h = c.getBucket(r);
                    if (!h || h.projection.name !== E.projection.name || !h.groundEffect || h.groundEffect && !h.groundEffect.hasData()) continue;
                    const d = h.groundEffect;
                    let _, u;
                    0 === s ? (_ = [
                        -e1.an,
                        0,
                        0
                    ], u = 1) : 1 === s ? (_ = [
                        e1.an,
                        0,
                        0
                    ], u = 0) : 2 === s ? (_ = [
                        0,
                        -e1.an,
                        0
                    ], u = 3) : (_ = [
                        0,
                        e1.an,
                        0
                    ], u = 2);
                    const p = d.regionSegments[u];
                    if (!p) continue;
                    const f = new Float32Array(16);
                    e1.by(f, t1.projMatrix, _), L(t1, d, p, i.translatePosMatrix(f, n, I, R), l);
                }
            }
        }
        function vs(t1, i, o, r, n, s, a) {
            0 === r.centroidVertexArray.length && r.createCentroidsBuffer();
            const l = s ? s.findDEMTileFor(o) : null;
            if (!(l && l.dem || a)) return;
            s && l && l.dem && r.selfDEMTileTimestamp !== l.dem._timestamp && (r.borderDoneWithNeighborZ = [
                -1,
                -1,
                -1,
                -1
            ], r.selfDEMTileTimestamp = l.dem._timestamp);
            const c = (t1, i)=>{
                (t1.flags | i.flags) & e1.d$ ? (t1.flags |= e1.d$, i.flags |= e1.d$) : (t1.flags &= ~e1.d$, i.flags &= ~e1.d$);
            }, h = (t1)=>new e1.P(Math.ceil((t1 + e1.e0) * e1.e1), 0), d = (t1, i, o)=>{
                const r = Math.ceil((t1 + e1.e0) * e1.e1), n = Math.floor(Math.max(0, Math.min(e1.an - 1, o)) / 4);
                return new e1.P(r, n << 5 | (3 & i) << 3 | 7);
            }, _ = (e1)=>{
                const t1 = i.getSource().minzoom, o = (e1)=>{
                    const t1 = i.getTileByID(e1);
                    if (t1 && t1.hasData()) return t1.getBucket(n);
                }, r = [
                    0,
                    -1,
                    1
                ];
                for (const i of r){
                    if (e1.overscaledZ + i < t1) continue;
                    const r = o(e1.calculateScaledKey(e1.overscaledZ + i));
                    if (r) return r;
                }
            }, u = [
                0,
                0,
                0
            ], p = (t1, i)=>(u[0] = Math.min(t1.min.y, i.min.y), u[1] = Math.max(t1.max.y, i.max.y), u[2] = e1.an - i.min.x > t1.max.x ? i.min.x - e1.an : t1.max.x, u), f = (t1, i)=>(u[0] = Math.min(t1.min.x, i.min.x), u[1] = Math.max(t1.max.x, i.max.x), u[2] = e1.an - i.min.y > t1.max.y ? i.min.y - e1.an : t1.max.y, u), m = [
                (e1, t1)=>p(e1, t1),
                (e1, t1)=>p(t1, e1),
                (e1, t1)=>f(e1, t1),
                (e1, t1)=>f(t1, e1)
            ], g = (t1, i, r, n, a, c, h)=>{
                if (!s) return 0;
                const d = [
                    [
                        c ? r : t1,
                        c ? t1 : r,
                        0
                    ],
                    [
                        c ? r : i,
                        c ? i : r,
                        0
                    ]
                ], _ = h < 0 ? e1.an + h : h, u = [
                    c ? _ : (t1 + i) / 2,
                    c ? (t1 + i) / 2 : _,
                    0
                ];
                return 0 === r && h < 0 || 0 !== r && h > 0 ? s.getForTilePoints(a, [
                    u
                ], !0, n) : d.push(u), s.getForTilePoints(o, d, !0, l), Math.max(d[0][2], d[1][2], u[2]) / s.exaggeration();
            };
            for(let t1 = 0; t1 < 4; t1++){
                const i = r.borderFeatureIndices[t1];
                if (0 === i.length) continue;
                const n = e1.dX[t1](o), l = _(n);
                if (!(l && l instanceof e1.dY)) continue;
                const u = s ? s.findDEMTileFor(n) : null;
                if (!(u && u.dem || a)) continue;
                if (s && u && u.dem && r.borderDEMTileTimestamp[t1] !== u.dem._timestamp && (r.borderDoneWithNeighborZ[t1] = -1, r.borderDEMTileTimestamp[t1] = u.dem._timestamp), r.borderDoneWithNeighborZ[t1] === l.canonical.z) continue;
                0 === l.centroidVertexArray.length && l.createCentroidsBuffer();
                const p = (t1 < 2 ? 1 : 5) - t1, f = l.borderDoneWithNeighborZ[p] !== r.canonical.z, v = l.borderFeatureIndices[p];
                let y = 0;
                if (r.canonical.z !== l.canonical.z) {
                    for (const e1 of i)r.showCentroid(r.featuresOnBorder[e1]);
                    if (f) for (const e1 of v)l.showCentroid(l.featuresOnBorder[e1]);
                    r.borderDoneWithNeighborZ[t1] = l.canonical.z, l.borderDoneWithNeighborZ[p] = r.canonical.z;
                    continue;
                }
                const x = new Map, b = new Set, w = new Set;
                for(let e1 = 0; e1 < v.length; e1++){
                    const t1 = l.featuresOnBorder[v[e1]];
                    void 0 !== t1.buildingId && x.set(t1.buildingId, e1);
                }
                for (const o of i){
                    const i = r.featuresOnBorder[o], s = r.centroidData[i.centroidDataIndex];
                    if (void 0 === i.buildingId) continue;
                    const h = x.get(i.buildingId);
                    if (void 0 === h) continue;
                    const _ = l.featuresOnBorder[v[h]], f = l.centroidData[_.centroidDataIndex];
                    b.add(o), w.add(h), a && c(s, f);
                    const y = 0 !== s.groupCentroidPos.x || 0 !== s.groupCentroidPos.y ? s.groupCentroidPos : i.centroid(), T = 0 !== f.groupCentroidPos.x || 0 !== f.groupCentroidPos.y ? f.groupCentroidPos : _.centroid(), E = t1 < 2 ? Math.round((y.y + T.y) / 2) : Math.round((y.x + T.x) / 2), S = i.intersectsCount() > 1 || _.intersectsCount() > 1;
                    {
                        let i = 0;
                        if (u && u.dem && !S) {
                            const o = m[t1](s, f), r = t1 % 2 ? e1.an - 1 : 0;
                            i = g(o[0], Math.min(e1.an - 1, o[1]), r, u, n, t1 < 2, o[2]);
                        }
                        s.centroidXY = d(i, t1, E), f.centroidXY = d(i, p, E);
                    }
                    if (r.writeCentroidToBuffer(s), l.writeCentroidToBuffer(f), void 0 !== i.buildingId) {
                        for (const e1 of r.centroidData)e1.buildingId === i.buildingId && e1 !== s && (e1.centroidXY = s.centroidXY, r.writeCentroidToBuffer(e1));
                        for (const e1 of l.centroidData)e1.buildingId === i.buildingId && e1 !== f && (e1.centroidXY = f.centroidXY, l.writeCentroidToBuffer(e1));
                    }
                }
                for (const o of i){
                    if (b.has(o)) continue;
                    const i = r.featuresOnBorder[o], s = r.centroidData[i.centroidDataIndex], d = i.borders[t1];
                    let _;
                    for(; y < v.length;){
                        if (w.has(y)) {
                            y++;
                            continue;
                        }
                        _ = l.featuresOnBorder[v[y]];
                        const e1 = _.borders[p];
                        if (e1[1] > d[0] + 3 || e1[0] > d[0] - 3) break;
                        l.showCentroid(_), y++;
                    }
                    if (_ && y < v.length) {
                        let o = y, f = 0;
                        for(;;)if (w.has(y)) {
                            if (++y === v.length) break;
                            _ = l.featuresOnBorder[v[y]];
                        } else {
                            if (_.borders[p][0] > d[1] - 3) break;
                            if (f++, ++y === v.length) break;
                            _ = l.featuresOnBorder[v[y]];
                        }
                        for(; o < v.length && w.has(o);)o++;
                        if (o >= v.length) {
                            r.showCentroid(i);
                            continue;
                        }
                        _ = l.featuresOnBorder[v[o]];
                        let x = !1;
                        if (f >= 1) {
                            const e1 = _.borders[p];
                            Math.abs(d[0] - e1[0]) < 3 && Math.abs(d[1] - e1[1]) < 3 && (f = 1, x = !0, y = o + 1);
                        } else if (0 === f) {
                            r.showCentroid(i);
                            continue;
                        }
                        const b = l.centroidData[_.centroidDataIndex];
                        a && x && c(s, b);
                        const T = i.intersectsCount() > 1 || _.intersectsCount() > 1;
                        if (f > 1) y = o, s.centroidXY = b.centroidXY = new e1.P(0, 0);
                        else if (u && u.dem && !T) {
                            const i = m[t1](s, b), o = t1 % 2 ? e1.an - 1 : 0, r = g(i[0], Math.min(e1.an - 1, i[1]), o, u, n, t1 < 2, i[2]);
                            s.centroidXY = b.centroidXY = h(r);
                        } else T ? s.centroidXY = b.centroidXY = new e1.P(0, 0) : (s.centroidXY = r.encodeBorderCentroid(i), b.centroidXY = l.encodeBorderCentroid(_));
                        r.writeCentroidToBuffer(s), l.writeCentroidToBuffer(b);
                    } else r.showCentroid(i);
                }
                r.borderDoneWithNeighborZ[t1] = l.canonical.z, l.borderDoneWithNeighborZ[p] = r.canonical.z;
            }
            (r.needsCentroidUpdate || !r.centroidVertexBuffer && 0 !== r.centroidVertexArray.length) && r.uploadCentroid(t1);
        }
        const ys = [
            1,
            0,
            0
        ], xs = [
            0,
            1,
            0
        ], bs = [
            0,
            0,
            1
        ];
        function ws(t1, i, o) {
            const r = o.transform, n = o.shadowRenderer;
            if (!n) return !0;
            const s = t1.toUnwrapped(), a = r.tileSize * n._cascades[o.currentShadowCascade].scale;
            let l = i;
            if (r.elevation) {
                const e1 = r.elevation.getMinMaxForTile(t1);
                e1 && (l += e1.max);
            }
            const c = r.scaleZoom(a);
            l /= e1.d_(r.center.lat, c);
            const h = [
                ...n.shadowDirection
            ];
            h[2] = -h[2];
            const d = n.computeSimplifiedTileShadowVolume(s, l, a, h);
            if (!d) return !1;
            const _ = [
                ys,
                xs,
                bs,
                h,
                [
                    h[0],
                    0,
                    h[2]
                ],
                [
                    0,
                    h[1],
                    h[2]
                ]
            ], u = e1.cg.fromInvProjectionMatrix(r.invProjMatrix, r.worldSize, c, !("globe" === r.projection.name)), p = n.getCurrentCascadeFrustum();
            return 0 === u.intersectsPrecise(d.vertices, d.planes, _) || 0 === p.intersectsPrecise(d.vertices, d.planes, _);
        }
        function Ts(t1) {
            const { painter: i, source: o, layer: r, coords: n } = t1;
            let s = t1.defines;
            const a = i.context, l = "shadow" === i.renderPass, c = "light-beam" === i.renderPass, h = i.shadowRenderer, d = e1.d_(i.transform.center.lat, i.transform.zoom), _ = ao(i, r.paint.get("building-cutoff-fade-range"));
            _.shouldRenderCutoff && (s = s.concat("RENDER_CUTOFF"));
            const u = r.paint.get("building-front-cutoff"), p = u[2] < 1 && !i.terrain, f = ms(i.transform.pitch, u, !!i.terrain);
            p && (s = s.concat("RENDER_FRONT_CUTOFF"), i.maxFrontCutoffRawStart = Math.max(i.maxFrontCutoffRawStart, u[0])), t1.floodLightIntensity > 0 && (s = s.concat("FLOOD_LIGHT"));
            for (const u of n){
                const n = o.getTile(u), p = n.getBucket(r);
                if (!p) continue;
                h && 0 === h.getMaxCascadeForTile(u.toUnwrapped()) && (s = s.concat("SHADOWS_SINGLE_CASCADE"));
                const m = p.programConfigurations.get(r.id);
                let g, v, y, x = i.translatePosMatrix(u.expandedProjMatrix, n, [
                    0,
                    0
                ], "map");
                if (x = e1.cx(e1.bc(), x, [
                    1,
                    1,
                    t1.verticalScale
                ]), l && h) {
                    if (ws(n.tileID, p.maxHeight * d, i)) continue;
                    let o = h.calculateShadowPassMatrixFromTile(n.tileID.toUnwrapped());
                    o = e1.cx(e1.bc(), o, [
                        1,
                        1,
                        t1.verticalScale
                    ]), y = In(o), g = v = i.getOrCreateProgram("buildingDepth", {
                        config: m,
                        defines: s,
                        overrideFog: !1
                    });
                } else if (c) g = v = i.getOrCreateProgram("buildingBloom", {
                    config: m,
                    defines: s,
                    overrideFog: !1
                }), y = Cn(x);
                else {
                    const o = i.transform.calculatePosMatrix(u.toUnwrapped(), i.transform.worldSize);
                    e1.cx(o, o, [
                        1,
                        1,
                        t1.verticalScale
                    ]);
                    const r = e1.bc();
                    e1.cx(r, o, [
                        1,
                        -1,
                        1 / d
                    ]), e1.b8(r, r), e1.e2(r, r);
                    const n = i.transform.getFreeCameraOptions().position, a = 1 << u.canonical.z;
                    if (y = Sn(x, r, t1.opacity, t1.facadeAOIntensity, [
                        ((n.x - u.wrap) * a - u.canonical.x) * e1.an,
                        (n.y * a - u.canonical.y) * e1.an,
                        n.z * a * e1.an
                    ], p.tileToMeter, t1.facadeEmissiveChance, t1.floodLightColor, t1.floodLightIntensity, f), v = i.getOrCreateProgram("building", {
                        config: m,
                        defines: s,
                        overrideFog: !1
                    }), !0 === t1.depthOnly) g = v;
                    else {
                        const e1 = s.concat([
                            "BUILDING_FAUX_FACADE",
                            "HAS_ATTRIBUTE_a_faux_facade_color_emissive"
                        ]);
                        g = i.getOrCreateProgram("building", {
                            config: m,
                            defines: e1,
                            overrideFog: !1
                        });
                    }
                    h && (h.setupShadowsFromMatrix(o, v, !0), g !== v && h.setupShadowsFromMatrix(o, g, !0));
                }
                const b = (e1, o)=>{
                    if (c) {
                        const n = e1.entranceBloom;
                        o.draw(i, a.gl.TRIANGLES, t1.depthMode, $i.disabled, t1.blendMode, Ki.disabled, y, r.id, n.layoutVertexBuffer, n.indexBuffer, n.segmentsBucket, r.paint, i.transform.zoom, m, [
                            n.layoutAttenuationBuffer,
                            n.layoutColorBuffer
                        ]);
                    } else {
                        const n = e1.segmentsBucket;
                        let s = [
                            e1.layoutNormalBuffer,
                            e1.layoutCentroidBuffer,
                            e1.layoutColorBuffer,
                            e1.layoutFloodLightDataBuffer
                        ];
                        e1.layoutFacadePaintBuffer && (s = s.concat([
                            e1.layoutFacadeDataBuffer,
                            e1.layoutFacadeVerticalRangeBuffer,
                            e1.layoutFacadePaintBuffer
                        ])), o.draw(i, a.gl.TRIANGLES, t1.depthMode, $i.disabled, t1.blendMode, l ? Ki.disabled : Ki.backCW, y, r.id, e1.layoutVertexBuffer, e1.indexBuffer, n, r.paint, i.transform.zoom, m, s);
                    }
                };
                i.uploadCommonUniforms(a, v, u.toUnwrapped(), null, _), p.buildingWithoutFacade && b(p.buildingWithoutFacade, v), p.buildingWithFacade && (g !== v && i.uploadCommonUniforms(a, g, u.toUnwrapped(), null, _), b(p.buildingWithFacade, g));
            }
        }
        function Es(t1, i, o, r, n, s, a, l, c, h, d, _, u, p) {
            const f = t1.context.gl, m = t1.depthModeForSublayer(1, Hi.ReadOnly, f.LEQUAL, !0), g = .1 * (1 - (v = d)) + 3 * v;
            var v;
            const y = t1._showOverdrawInspector, x = _, b = new fs;
            y || gs(b, t1, i, o, r, m, new $i({
                func: f.ALWAYS,
                mask: 255
            }, 255, 255, f.KEEP, f.KEEP, f.REPLACE), new Zi([
                f.ONE,
                f.ONE,
                f.ONE,
                f.ONE
            ], e1.aq.transparent, [
                !1,
                !1,
                !1,
                !0
            ], f.MIN), Ki.disabled, n, "sdf", s, a, l, c, h, g, x, !1, void 0);
            {
                const d = y ? $i.disabled : new $i({
                    func: f.EQUAL,
                    mask: 255
                }, 255, 255, f.KEEP, f.DECR, f.DECR), _ = y ? t1.colorModeForRenderPass() : new Zi([
                    f.ONE_MINUS_DST_ALPHA,
                    f.DST_ALPHA,
                    f.ONE,
                    f.ONE
                ], e1.aq.transparent, [
                    !0,
                    !0,
                    !0,
                    !0
                ]);
                gs(b, t1, i, o, r, m, d, _, Ki.disabled, n, "color", s, a, l, c, h, g, x, !1, void 0);
            }
        }
        function Ss(t1) {
            return [
                t1[0] * e1.e3,
                t1[1] * e1.e3,
                t1[2] * e1.e3,
                0
            ];
        }
        function Cs(t1, i, o, r, n, s, a, l, c) {
            const h = r.getSource(), d = o.globeSharedBuffers;
            if (!d) return;
            let _, u, p;
            if (i && (_ = r.getTile(i)), h instanceof e1.aW ? (u = h.texture, p = e1.ds(0, 0, o.transform)) : _ && i && (u = _.texture, p = e1.ds(i.canonical.z, i.canonical.x, o.transform)), !u || !p) return;
            t1 || (p = e1.cx(e1.bc(), p, [
                1,
                -1,
                1
            ]));
            const f = o.context, m = f.gl, g = "nearest" === n.paint.get("raster-resampling") ? m.NEAREST : m.LINEAR, v = o.colorModeForDrapableLayerRenderPass(s), y = a.defines;
            y.push("GLOBE_POLES");
            const x = new Hi(m.LEQUAL, Hi.ReadWrite, o.depthRangeFor3D), b = Float32Array.from(o.transform.expandedFarZProjMatrix), w = Float32Array.from(e1.dq(e1.dr(new e1.ci(0, 0, 0))));
            o.terrain && o.terrain.prepareDrawTile(), f.activeTexture.set(m.TEXTURE0), u.bind(g, m.CLAMP_TO_EDGE), f.activeTexture.set(m.TEXTURE1), u.bind(g, m.CLAMP_TO_EDGE), "useMipmap" in u && f.extTextureFilterAnisotropic && o.transform.pitch > 20 && m.texParameterf(m.TEXTURE_2D, f.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, f.extTextureFilterAnisotropicMax);
            const [T, E, S, C] = i ? d.getPoleBuffers(i.canonical.z, !1) : d.getPoleBuffers(0, !0), I = n.paint.get("raster-elevation");
            let R;
            t1 ? (R = T, o.renderDefaultNorthPole = 0 !== I) : (R = E, o.renderDefaultSouthPole = 0 !== I);
            const D = Ss(a.mix), A = ((e1, t1, i, o, r, n, s, a, l, c, h, d, _, u)=>Fn(e1, t1, i, o, new Float32Array(16), new Float32Array(9), [
                    0,
                    0
                ], r, [
                    0,
                    0
                ], [
                    0,
                    0,
                    0,
                    0
                ], 1, {
                    opacity: 1,
                    mix: 0
                }, s, [
                    0,
                    0
                ], l, 2, h, d, _, 1, 0, u))(o, b, w, p, e1.al(o.transform.zoom), 0, n, 0, I, 0, D, a.offset, a.range, s), L = o.getOrCreateProgram("raster", {
                defines: y
            });
            o.uploadCommonUniforms(f, L, null), L.draw(o, m.TRIANGLES, x, c, v, l, A, n.id, R, S, C);
        }
        function Is(e1) {
            if (e1.isOrthographic) return [
                0,
                0,
                0,
                0
            ];
            const t1 = e1._nearZ, i = e1.projection.farthestPixelDistance(e1), o = i - t1, r = .2 * e1.height, n = t1 + r;
            return [
                t1,
                i,
                (n - r - t1) / o,
                (n - t1) / o
            ];
        }
        function Rs(e1, t1, i, o) {
            if (e1) return t1 instanceof Tt && e1 instanceof Pt ? t1.getTextureDescriptor(e1, i, !0) : {
                texture: e1.texture,
                mix: Ss(o.mix),
                offset: o.offset,
                buffer: 0,
                tileSize: 1
            };
        }
        var Ds = e1.e4([
            {
                name: "a_index",
                type: "Int16",
                components: 1
            }
        ]);
        class As {
            constructor(t1, i, o, r){
                const n = {
                    width: o[0],
                    height: o[1],
                    data: null
                }, s = t1.gl;
                this.targetColorTexture = new e1.T(t1, n, s.RGBA8, {
                    useMipmap: !1
                }), this.backgroundColorTexture = new e1.T(t1, n, s.RGBA8, {
                    useMipmap: !1
                }), this.context = t1, this.updateParticleTexture(i, r), this.lastInvalidatedAt = 0;
            }
            updateParticleTexture(t1, i) {
                if (this.particleTextureDimension === i.width) return;
                (this.particleTexture0 || this.particleTexture1 || this.particleIndexBuffer || this.particleSegment) && (this.particleTexture0.destroy(), this.particleTexture1.destroy(), this.particleIndexBuffer.destroy(), this.particleSegment.destroy());
                const o = this.context.gl, r = i.width * i.height;
                this.particleTexture0 = new e1.T(this.context, i, o.RGBA8, {
                    premultiply: !1,
                    useMipmap: !1
                }), this.particleTexture1 = new e1.T(this.context, i, o.RGBA8, {
                    premultiply: !1,
                    useMipmap: !1
                });
                const n = new e1.e5;
                n.reserve(r);
                for(let e1 = 0; e1 < r; e1++)n.emplaceBack(e1);
                this.particleIndexBuffer = this.context.createVertexBuffer(n, Ds.members, !0), this.particleSegment = e1.du.simpleSegment(0, 0, this.particleIndexBuffer.length, 0), this.particleTextureDimension = i.width;
            }
            update(t1) {
                return !(this.lastInvalidatedAt < t1 && (this.lastInvalidatedAt = e1.o.now(), 1));
            }
            destroy() {
                this.targetColorTexture.destroy(), this.backgroundColorTexture.destroy(), this.particleIndexBuffer.destroy(), this.particleTexture0.destroy(), this.particleTexture1.destroy(), this.particleSegment.destroy();
            }
        }
        function Ls(t1, i, o) {
            if (!t1) return null;
            const r = i.getTextureDescriptor(t1, o, !0);
            if (!r) return null;
            let { texture: n, mix: s, offset: a, tileSize: l, buffer: c, format: h } = r;
            if (!n || !h) return null;
            let d = !1;
            return "uint32" === h && (d = !0, s[3] = 0, s = On(e1.e6, s, [
                0,
                o.paint.get("raster-particle-max-speed")
            ]), a = Mn(e1.e6, a, [
                0,
                o.paint.get("raster-particle-max-speed")
            ])), {
                texture: n,
                textureOffset: [
                    c / (l + 2 * c),
                    l / (l + 2 * c)
                ],
                tileSize: l,
                scalarData: d,
                scale: s,
                offset: a,
                defines: [
                    "RASTER_ARRAY",
                    {
                        uint8: "DATA_FORMAT_UINT8",
                        uint16: "DATA_FORMAT_UINT16",
                        uint32: "DATA_FORMAT_UINT32"
                    }[h]
                ]
            };
        }
        function Ps(e1) {
            const t1 = e1._nearZ, i = e1.projection.farthestPixelDistance(e1), o = i - t1, r = .2 * e1.height, n = t1 + r;
            return [
                t1,
                i,
                (n - r - t1) / o,
                (n - t1) / o
            ];
        }
        const Os = new e1.aq(1, 0, 0, 1), Ms = new e1.aq(0, 1, 0, 1), zs = new e1.aq(0, 0, 1, 1), Fs = new e1.aq(1, 0, 1, 1), Bs = new e1.aq(0, 1, 1, 1);
        function ks(t1, i, o, r, n, s) {
            for(let a = 0; a < o.length; a++)if (n) {
                const n = 1, l = .8, c = new e1.aq(r.r * l, r.g * l, r.b * l, 1);
                Ns(t1, i, o[a], r, -n, -n, s), Ns(t1, i, o[a], r, -n, n, s), Ns(t1, i, o[a], r, n, n, s), Ns(t1, i, o[a], r, n, -n, s), Ns(t1, i, o[a], c, 0, 0, s);
            } else Ns(t1, i, o[a], r, 0, 0, s);
        }
        function Ns(t1, i, o, r, n, s, a) {
            const l = t1.context, c = t1.transform, h = l.gl, d = "globe" === c.projection.name, _ = d ? [
                "PROJECTION_GLOBE_VIEW"
            ] : [];
            let u = e1.b9(o.projMatrix);
            if (d && e1.al(c.zoom) > 0) {
                const t1 = e1.e8(o.canonical, c), i = e1.e9(t1);
                u = e1.aD(new Float32Array(16), c.globeMatrix, i), e1.aD(u, c.projMatrix, u);
            }
            const p = e1.bc();
            p[12] += 2 * n / (e1.o.devicePixelRatio * c.width), p[13] += 2 * s / (e1.o.devicePixelRatio * c.height), e1.aD(u, p, u);
            const f = t1.getOrCreateProgram("debug", {
                defines: _
            }), m = i.getTileByID(o.key);
            t1.terrain && t1.terrain.setupElevationDraw(m, f);
            const g = Hi.disabled, v = $i.disabled, y = t1.colorModeForRenderPass(), x = "$debug";
            l.activeTexture.set(h.TEXTURE0), t1.emptyTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), d ? m._makeGlobeTileDebugBuffers(t1.context, c) : m._makeDebugTileBoundsBuffers(t1.context, c.projection);
            const b = m._tileDebugBuffer || t1.debugBuffer, w = m._tileDebugIndexBuffer || t1.debugIndexBuffer, T = m._tileDebugSegments || t1.debugSegments;
            if (f.draw(t1, h.LINE_STRIP, g, v, y, Ki.disabled, An(u, r.toPremultipliedRenderColor(null)), x, b, w, T, null, null, null, [
                m._globeTileDebugBorderBuffer
            ]), a) {
                const e1 = m.latestRawTileData, i = Math.floor((e1 && e1.byteLength || 0) / 1024);
                let r = o.canonical.toString();
                o.overscaledZ !== o.canonical.z && (r += ` => ${o.overscaledZ}`), r += ` ${m.state}`, r += ` ${i}kb`, function(e1, t1) {
                    e1.initDebugOverlayCanvas();
                    const i = e1.debugOverlayCanvas, o = e1.context.gl, r = e1.debugOverlayCanvas.getContext("2d");
                    r.clearRect(0, 0, i.width, i.height), r.shadowColor = "white", r.shadowBlur = 2, r.lineWidth = 1.5, r.strokeStyle = "white", r.textBaseline = "top", r.font = "bold 36px Open Sans, sans-serif", r.fillText(t1, 5, 5), r.strokeText(t1, 5, 5), e1.debugOverlayTexture.update(i), e1.debugOverlayTexture.bind(o.LINEAR, o.CLAMP_TO_EDGE);
                }(t1, r);
            }
            const E = i.getTile(o).tileSize, S = 512 / Math.min(E, 512) * (o.overscaledZ / c.zoom) * .5, C = m._tileDebugTextBuffer || t1.debugBuffer, I = m._tileDebugTextIndexBuffer || t1.quadTriangleIndexBuffer, R = m._tileDebugTextSegments || t1.debugSegments;
            f.draw(t1, h.TRIANGLES, g, v, Zi.alphaBlended, Ki.disabled, An(u, e1.aq.transparent.toPremultipliedRenderColor(null), S), x, C, I, R, null, null, null, [
                m._globeTileDebugTextBuffer
            ]);
        }
        function Us(e1, t1, i, o) {
            js(e1, 0, t1 + i / 2, e1.transform.width, i, o);
        }
        function Vs(e1, t1, i, o) {
            js(e1, t1 - i / 2, 0, i, e1.transform.height, o);
        }
        function js(t1, i, o, r, n, s) {
            const a = t1.context, l = a.gl;
            l.enable(l.SCISSOR_TEST), l.scissor(i * e1.o.devicePixelRatio, o * e1.o.devicePixelRatio, r * e1.o.devicePixelRatio, n * e1.o.devicePixelRatio), a.clear({
                color: s
            }), l.disable(l.SCISSOR_TEST);
        }
        const Gs = e1.e4([
            {
                name: "a_pos_3f",
                components: 3,
                type: "Float32"
            }
        ]), { members: qs } = Gs;
        function Zs(e1, t1, i, o) {
            e1.emplaceBack(t1, i, o);
        }
        class Hs {
            constructor(t1){
                this.vertexArray = new e1.ea, this.indices = new e1.dy, Zs(this.vertexArray, -1, -1, 1), Zs(this.vertexArray, 1, -1, 1), Zs(this.vertexArray, -1, 1, 1), Zs(this.vertexArray, 1, 1, 1), Zs(this.vertexArray, -1, -1, -1), Zs(this.vertexArray, 1, -1, -1), Zs(this.vertexArray, -1, 1, -1), Zs(this.vertexArray, 1, 1, -1), this.indices.emplaceBack(5, 1, 3), this.indices.emplaceBack(3, 7, 5), this.indices.emplaceBack(6, 2, 0), this.indices.emplaceBack(0, 4, 6), this.indices.emplaceBack(2, 6, 7), this.indices.emplaceBack(7, 3, 2), this.indices.emplaceBack(5, 4, 0), this.indices.emplaceBack(0, 1, 5), this.indices.emplaceBack(0, 2, 3), this.indices.emplaceBack(3, 1, 0), this.indices.emplaceBack(7, 6, 4), this.indices.emplaceBack(4, 5, 7), this.vertexBuffer = t1.createVertexBuffer(this.vertexArray, qs), this.indexBuffer = t1.createIndexBuffer(this.indices), this.segment = e1.du.simpleSegment(0, 0, 36, 12);
            }
        }
        function Ws(t1, i, o, r, n, s) {
            const a = t1.context.gl, l = i.paint.get("sky-atmosphere-color"), c = i.paint.get("sky-atmosphere-halo-color"), h = i.paint.get("sky-atmosphere-sun-intensity"), d = ((e1, t1, i, o, r)=>({
                    u_matrix_3f: e1,
                    u_sun_direction: t1,
                    u_sun_intensity: i,
                    u_color_tint_r: [
                        o.r,
                        o.g,
                        o.b,
                        o.a
                    ],
                    u_color_tint_m: [
                        r.r,
                        r.g,
                        r.b,
                        r.a
                    ],
                    u_luminance: 5e-5
                }))(e1.ec(e1.dA(), r), n, h, l.toPremultipliedRenderColor(null), c.toPremultipliedRenderColor(null));
            a.framebufferTexture2D(a.FRAMEBUFFER, a.COLOR_ATTACHMENT0, a.TEXTURE_CUBE_MAP_POSITIVE_X + s, i.skyboxTexture, 0), o.draw(t1, a.TRIANGLES, Hi.disabled, $i.disabled, Zi.unblended, Ki.frontCW, d, "skyboxCapture", i.skyboxGeometry.vertexBuffer, i.skyboxGeometry.indexBuffer, i.skyboxGeometry.segment);
        }
        const $s = e1.e4([
            {
                type: "Float32",
                name: "a_pos",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            }
        ]);
        class Xs {
            constructor(t1){
                const i = new e1.ed;
                i.emplaceBack(-1, 1, 1, 0, 0), i.emplaceBack(1, 1, 1, 1, 0), i.emplaceBack(1, -1, 1, 1, 1), i.emplaceBack(-1, -1, 1, 0, 1);
                const o = new e1.dy;
                o.emplaceBack(0, 1, 2), o.emplaceBack(2, 3, 0), this.vertexBuffer = t1.createVertexBuffer(i, $s.members), this.indexBuffer = t1.createIndexBuffer(o), this.segments = e1.du.simpleSegment(0, 0, 4, 2);
            }
            destroy() {
                this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy();
            }
        }
        const Ys = e1.e4([
            {
                type: "Float32",
                name: "a_pos_3f",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            },
            {
                type: "Float32",
                name: "a_size_scale",
                components: 1
            },
            {
                type: "Float32",
                name: "a_opacity",
                components: 1
            }
        ]);
        class Ks {
            constructor(){
                this.starsCount = 16e3, this.sizeMultiplier = .15, this.sizeRange = 100, this.intensityRange = 200;
            }
        }
        class Qs {
            constructor(t1){
                this.colorModeAlphaBlendedWriteRGB = new Zi([
                    1,
                    qi,
                    1,
                    qi
                ], e1.aq.transparent, [
                    !0,
                    !0,
                    !0,
                    !1
                ]), this.colorModeWriteAlpha = new Zi([
                    1,
                    0,
                    1,
                    0
                ], e1.aq.transparent, [
                    !1,
                    !1,
                    !1,
                    !0
                ]), this.params = new Ks, this.updateNeeded = !0;
            }
            update(t1) {
                const i = t1.context;
                if (!this.atmosphereBuffer || this.updateNeeded) {
                    this.updateNeeded = !1, this.atmosphereBuffer = new Xs(i);
                    const t1 = this.params.sizeRange, o = this.params.intensityRange, r = function(t1) {
                        const i = e1.ei(30), o = [];
                        for(let r = 0; r < t1; ++r){
                            const t1 = 2 * Math.PI * i(), r = Math.acos(1 - 2 * i()) - .5 * Math.PI;
                            o.push(e1.cM(Math.cos(r) * Math.cos(t1), Math.cos(r) * Math.sin(t1), Math.sin(r)));
                        }
                        return o;
                    }(this.params.starsCount), n = e1.ei(300), s = new e1.ee, a = new e1.dy;
                    let l = 0;
                    for(let i = 0; i < r.length; ++i){
                        const c = e1.bK([], r[i], 200), h = Math.max(0, 1 + .01 * t1 * (1 * n() - .5)), d = Math.max(0, 1 + .01 * o * (1 * n() - .5));
                        s.emplaceBack(c[0], c[1], c[2], -1, -1, h, d), s.emplaceBack(c[0], c[1], c[2], 1, -1, h, d), s.emplaceBack(c[0], c[1], c[2], 1, 1, h, d), s.emplaceBack(c[0], c[1], c[2], -1, 1, h, d), a.emplaceBack(l + 0, l + 1, l + 2), a.emplaceBack(l + 0, l + 2, l + 3), l += 4;
                    }
                    this.starsVx = i.createVertexBuffer(s, Ys.members), this.starsIdx = i.createIndexBuffer(a), this.starsSegments = e1.du.simpleSegment(0, 0, s.length, a.length);
                }
            }
            destroy() {
                this.atmosphereBuffer && this.atmosphereBuffer.destroy(), this.starsVx && this.starsVx.destroy(), this.starsIdx && this.starsIdx.destroy();
            }
            drawAtmosphereGlow(t1, i) {
                const o = t1.context, r = o.gl, n = t1.transform, s = new Hi(r.LEQUAL, Hi.ReadOnly, [
                    0,
                    1
                ]), a = e1.al(n.zoom), l = t1.style.getLut(i.scope), c = "none" === i.properties.get("color-use-theme"), h = i.properties.get("color").toNonPremultipliedRenderColor(c ? null : l), d = "none" === i.properties.get("high-color-use-theme"), _ = i.properties.get("high-color").toNonPremultipliedRenderColor(d ? null : l), u = "none" === i.properties.get("space-color-use-theme"), p = i.properties.get("space-color").toNonPremultipliedRenderColor(u ? null : l), f = 5e-4, m = e1.ef(i.properties.get("horizon-blend"), 0, 1, f, .25), g = e1.dk(t1, o, n) && m === f ? n.worldSize / (2 * Math.PI * 1.025) - 1 : n.globeRadius, v = t1.frameCounter / 1e3 % 1, y = e1.ai(n.globeCenterInViewSpace), x = Math.sqrt(Math.pow(y, 2) - Math.pow(g, 2)), b = Math.acos(x / y), w = (e1)=>{
                    const i = "globe" === n.projection.name ? [
                        "PROJECTION_GLOBE_VIEW",
                        "FOG"
                    ] : [
                        "FOG"
                    ];
                    e1 && i.push("ALPHA_PASS");
                    const l = t1.getOrCreateProgram("globeAtmosphere", {
                        defines: i
                    }), c = ((e1, t1, i, o, r, n, s, a, l, c, h, d)=>({
                            u_frustum_tl: e1,
                            u_frustum_tr: t1,
                            u_frustum_br: i,
                            u_frustum_bl: o,
                            u_horizon: r,
                            u_transition: n,
                            u_fadeout_range: s,
                            u_atmosphere_fog_color: a.toArray01(),
                            u_high_color: l.toArray01(),
                            u_space_color: c.toArray01(),
                            u_temporal_offset: h,
                            u_horizon_angle: d
                        }))(n.frustumCorners.TL, n.frustumCorners.TR, n.frustumCorners.BR, n.frustumCorners.BL, n.frustumCorners.horizon, a, m, h, _, p, v, b);
                    t1.uploadCommonUniforms(o, l);
                    const d = this.atmosphereBuffer;
                    d && l.draw(t1, r.TRIANGLES, s, $i.disabled, e1 ? this.colorModeWriteAlpha : this.colorModeAlphaBlendedWriteRGB, Ki.backCW, c, e1 ? "atmosphere_glow_alpha" : "atmosphere_glow", d.vertexBuffer, d.indexBuffer, d.segments);
                };
                w(!1), w(!0);
            }
            drawStars(t1, i) {
                const o = e1.aC(i.properties.get("star-intensity"), 0, 1);
                if (0 === o) return;
                const r = t1.context, n = r.gl, s = t1.transform, a = t1.getOrCreateProgram("stars"), l = e1.bM([]);
                e1.bO(l, l, -s._pitch), e1.bN(l, l, -s.angle), e1.bO(l, l, e1.ap(s._center.lat)), e1.eg(l, l, -e1.ap(s._center.lng));
                const c = e1.bS(new Float32Array(16), l), h = e1.aD([], s.starsProjMatrix, c), d = e1.ec([], c), _ = e1.eh([], d), u = [
                    0,
                    1,
                    0
                ];
                e1.dC(u, u, _), e1.bK(u, u, this.params.sizeMultiplier);
                const p = [
                    1,
                    0,
                    0
                ];
                e1.dC(p, p, _), e1.bK(p, p, this.params.sizeMultiplier);
                const f = (m = u, g = p, v = o, {
                    u_matrix: Float32Array.from(h),
                    u_up: m,
                    u_right: g,
                    u_intensity_multiplier: v
                });
                var m, g, v;
                t1.uploadCommonUniforms(r, a), this.starsVx && this.starsIdx && a.draw(t1, n.TRIANGLES, Hi.disabled, $i.disabled, this.colorModeAlphaBlendedWriteRGB, Ki.disabled, f, "atmosphere_stars", this.starsVx, this.starsIdx, this.starsSegments);
            }
        }
        class Js {
            constructor(){
                this.visibleTiles = [];
            }
            updateBorders(t1, i) {
                const o = [], r = [], n = t1._getRenderableCoordinates(!1, !0);
                for (const e1 of n){
                    const n = t1.getTile(e1);
                    if (!n.hasData()) continue;
                    const s = n.getBucket(i);
                    s && (s.isEmpty() || (o.push(e1.key), r.push({
                        bucket: s,
                        tileID: e1.canonical
                    })));
                }
                let s = o.length !== this.visibleTiles.length;
                if (!s) {
                    o.sort();
                    for(let e1 = 0; e1 < o.length; e1++)if (o[e1] !== this.visibleTiles[e1]) {
                        s = !0;
                        break;
                    }
                }
                if (!s) return;
                const a = new Set;
                this.visibleTiles = o, r.sort((e1, t1)=>e1.tileID.z - t1.tileID.z || e1.tileID.x - t1.tileID.x || e1.tileID.y - t1.tileID.y);
                for (const t1 of r){
                    const i = new Array, o = new Array, r = t1.bucket;
                    for (const e1 of r.featuresOnBorder)a.has(e1.featureId) ? o.push(e1.footprintIndex) : (a.add(e1.featureId), i.push(e1.footprintIndex));
                    r.updateFootprintHiddenFlags(i, e1.ej, !1), r.updateFootprintHiddenFlags(o, e1.ej, !0);
                }
            }
        }
        function ea(t1, i) {
            const o = [
                ...t1
            ], r = i.cameraWorldSizeForFog / i.worldSize, n = e1.ba([]);
            return e1.cx(n, n, [
                r,
                r,
                1
            ]), e1.aD(o, n, o), e1.aD(o, i.worldToFogMatrix, o), o;
        }
        function ta(t1, i, o, r, n) {
            const s = o.material, a = r.context, { baseColorTexture: l, metallicRoughnessTexture: c } = s.pbrMetallicRoughness, { normalTexture: h, occlusionTexture: d, emissionTexture: _ } = s;
            function u(e1, i, o) {
                if (e1 && (t1.push(i), a.activeTexture.set(a.gl.TEXTURE0 + o), e1.gfxTexture)) {
                    const { minFilter: t1, magFilter: i, wrapS: o, wrapT: r } = e1.sampler;
                    e1.gfxTexture.bindExtraParam(t1, i, o, r);
                }
            }
            u(l, "HAS_TEXTURE_u_baseColorTexture", 5), u(c, "HAS_TEXTURE_u_metallicRoughnessTexture", 6), u(h, "HAS_TEXTURE_u_normalTexture", 7), u(d, "HAS_TEXTURE_u_occlusionTexture", 8), u(_, "HAS_TEXTURE_u_emissionTexture", 9), n && (n.texture || (n.texture = new e1.dN(r.context, n.image, [
                n.image.height,
                n.image.height,
                n.image.height
            ], a.gl.RGBA8)), a.activeTexture.set(a.gl.TEXTURE0 + 10), n.texture && n.texture.bind(a.gl.LINEAR, a.gl.CLAMP_TO_EDGE), t1.push("APPLY_LUT_ON_GPU")), o.texcoordBuffer && (t1.push("HAS_ATTRIBUTE_a_uv_2f"), i.push(o.texcoordBuffer)), o.colorBuffer && (t1.push(12 === o.colorBuffer.itemSize ? "HAS_ATTRIBUTE_a_color_3f" : "HAS_ATTRIBUTE_a_color_4f"), i.push(o.colorBuffer)), o.normalBuffer && (t1.push("HAS_ATTRIBUTE_a_normal_3f"), i.push(o.normalBuffer)), o.pbrBuffer && (t1.push("HAS_ATTRIBUTE_a_pbr"), t1.push("HAS_ATTRIBUTE_a_heightBasedEmissiveStrength"), i.push(o.pbrBuffer)), "OPAQUE" !== s.alphaMode && "MASK" !== s.alphaMode || t1.push("UNPREMULT_TEXTURE_IN_SHADER"), s.defined || t1.push("DIFFUSE_SHADED");
            const p = r.shadowRenderer;
            p && (t1.push("RENDER_SHADOWS"), p.useNormalOffset && t1.push("NORMAL_OFFSET"));
        }
        function ia(t1, i, o, r, n, s) {
            const a = t1.modelOpacity, l = i.context, c = new Hi(i.context.gl.LEQUAL, t1.isLightMesh ? Hi.ReadOnly : Hi.ReadWrite, i.depthRangeFor3D), h = i.transform, d = t1.mesh, _ = d.material, u = _.pbrMetallicRoughness, p = i.style.fog;
            let f;
            f = "pixels" === i.transform.projection.zAxisUnit ? [
                ...t1.nodeModelMatrix
            ] : e1.aD([], r.zScaleMatrix, t1.nodeModelMatrix), e1.aD(f, r.negCameraPosMatrix, f);
            const m = e1.b8([], f);
            e1.e2(m, m);
            const g = "none" === o.paint.get("model-color-use-theme").constantOr("default"), v = o.paint.get("model-emissive-strength").constantOr(0), y = Wn(new Float32Array(t1.worldViewProjection), new Float32Array(f), new Float32Array(m), null, i, a, u.baseColorFactor, _.emissiveFactor, u.metallicFactor, u.roughnessFactor, _, v, o, void 0, void 0, t1.materialOverride, t1.modelColor), x = {
                defines: []
            }, b = [], w = i.shadowRenderer;
            w && (w.useNormalOffset = !1), ta(x.defines, b, d, i, g ? null : o.lut);
            let T = null;
            if (p) {
                const e1 = ea(t1.nodeModelMatrix, i.transform);
                if (T = new Float32Array(e1), "globe" !== h.projection.name) {
                    const t1 = d.aabb.min, i = d.aabb.max, [o, r] = p.getOpacityForBounds(e1, t1[0], t1[1], i[0], i[1]);
                    x.overrideFog = o >= Ye || r >= Ye;
                }
            }
            const E = ao(i, o.paint.get("model-cutoff-fade-range"));
            E.shouldRenderCutoff && x.defines.push("RENDER_CUTOFF");
            const S = i.getOrCreateProgram("model", x);
            i.uploadCommonUniforms(l, S, null, T, E), "shadow" !== i.renderPass && w && w.setupShadowsFromMatrix(t1.nodeModelMatrix, S), S.draw(i, l.gl.TRIANGLES, c, n, s, d.material.doubleSided ? Ki.disabled : Ki.backCCW, y, o.id, d.vertexBuffer, d.indexBuffer, d.segments, o.paint, i.transform.zoom, void 0, b);
        }
        function oa(e1, t1) {
            return e1.style._importedAsBasemap ? "basemap" : t1.scope;
        }
        function ra(t1, i, o, r, n, s, a, l, c, h) {
            const d = t1.transform, _ = !!i.isGeometryBloom && i.isGeometryBloom;
            if (_ && "shadow" === t1.renderPass) return;
            const u = "globe" === d.projection.name ? e1.er(o, d) : [
                ...o
            ];
            e1.aD(u, u, i.globalMatrix);
            const p = e1.aD([], r, u);
            if (i.meshes) for (const t1 of i.meshes){
                const r = l.get(t1.material.name);
                if (r && r.opacity <= 0) continue;
                if ("BLEND" !== t1.material.alphaMode) {
                    a.push({
                        mesh: t1,
                        depth: 0,
                        modelIndex: n,
                        worldViewProjection: p,
                        nodeModelMatrix: u,
                        isLightMesh: _,
                        materialOverride: r,
                        modelOpacity: c,
                        modelColor: h,
                        node: i,
                        modelMatrix: o
                    });
                    continue;
                }
                const f = e1.ah([], t1.centroid, p);
                !d.isOrthographic && f[2] <= 0 || s.push({
                    mesh: t1,
                    depth: f[2],
                    modelIndex: n,
                    worldViewProjection: p,
                    nodeModelMatrix: u,
                    isLightMesh: _,
                    materialOverride: r,
                    modelOpacity: c,
                    modelColor: h,
                    node: i,
                    modelMatrix: o
                });
            }
            if (i.children) for (const e1 of i.children)ra(t1, e1, o, r, n, s, a, l, c, h);
        }
        function na(e1, t1, i, o) {
            const r = i.shadowRenderer;
            if (!r) return;
            const n = r.getShadowPassDepthMode(), s = r.calculateShadowPassMatrixFromMatrix(t1), a = $n(s);
            i.getOrCreateProgram("modelDepth").draw(i, i.context.gl.TRIANGLES, n, $i.disabled, Zi.disabled, Ki.disabled, a, o.id, e1.vertexBuffer, e1.indexBuffer, e1.segments, o.paint, i.transform.zoom, void 0, void 0);
        }
        function sa(t1, i, o, r) {
            const n = function(t1, i) {
                if (i.footprintDebugMesh) return i.footprintDebugMesh;
                if (!i.footprint) return null;
                const o = t1.context, r = i.footprint.vertices, n = i.footprint.indices, s = new e1.dx;
                s.reserve(r.length);
                for (const e1 of r)s.emplaceBack(e1.x, e1.y);
                const a = new e1.dy;
                a.reserve(n.length);
                for(let e1 = 0; e1 < n.length; e1 += 3)a.emplaceBack(n[e1], n[e1 + 1], n[e1 + 2]);
                const l = o.createVertexBuffer(s, e1.dt.members), c = o.createIndexBuffer(a), h = e1.du.simpleSegment(0, 0, r.length, n.length), d = i.id || i.name || "footprint";
                let _;
                const u = parseInt(d, 10);
                _ = isNaN(u) ? function(e1) {
                    let t1 = 0;
                    for(let i = 0; i < e1.length; i++)t1 = (t1 << 5) - t1 + e1.charCodeAt(i) | 0;
                    return t1;
                }(d) : u;
                const p = e1.e7(_), f = e1.e7(_ + 1), m = e1.e7(_ + 2);
                return i.footprintDebugMesh = {
                    vertexBuffer: l,
                    indexBuffer: c,
                    segments: h,
                    color: new e1.aq(p, f, m, .5)
                }, i.footprintDebugMesh;
            }(t1, o);
            if (!n) return;
            const s = t1.context, a = s.gl, l = t1.getOrCreateProgram("debug"), c = n.color, h = Hi.disabled;
            s.activeTexture.set(a.TEXTURE0), t1.emptyTexture.bind(a.LINEAR, a.CLAMP_TO_EDGE), l.draw(t1, a.TRIANGLES, h, $i.disabled, Zi.alphaBlended, Ki.disabled, An(r, c.toPremultipliedRenderColor(null)), "$debug", n.vertexBuffer, n.indexBuffer, n.segments);
        }
        function aa(e1, t1, i, o, r, n) {
            for (const s of r){
                const r = Object.assign({}, o);
                r.part = s;
                const a = {
                    type: "Unknown",
                    id: t1,
                    properties: r
                }, l = {
                    orientation: e1.paint.get("model-rotation").evaluate(a, i)
                };
                n.set(s, l);
            }
        }
        function la(e1, t1, i, o, r, n) {
            for (const s of r){
                const r = Object.assign({}, o);
                r.part = s;
                const a = {
                    type: "Unknown",
                    id: t1,
                    properties: r
                }, l = {
                    color: e1.paint.get("model-color").evaluate(a, i),
                    colorMix: e1.paint.get("model-color-mix-intensity").evaluate(a, i),
                    opacity: e1.paint.get("model-opacity").evaluate(a, i),
                    emissionStrength: e1.paint.get("model-emissive-strength").evaluate(a, i)
                };
                n.set(s, l);
            }
        }
        function ca(e1, t1, i, o, r) {
            let n = !1;
            for (const i of o)1 !== i.modelOpacity && (ia(i, e1, t1, r[i.modelIndex], $i.disabled, Zi.disabled), n = !0);
            for (const i of o)ia(i, e1, t1, r[i.modelIndex], 1 !== i.modelOpacity ? e1.stencilModeFor3D() : $i.disabled, e1.colorModeForRenderPass());
            n && e1.resetStencilClippingMasks();
            const s = Zi.additive;
            for (const o of i)ia(o, e1, t1, r[o.modelIndex], $i.disabled, o.isLightMesh ? s : e1.colorModeForRenderPass());
        }
        function ha(t1, i, o) {
            const r = i.updateZoomBasedPaintProperties(), n = function(t1, i, o) {
                let r, n, s, a = t1.terrain ? t1.terrain.exaggeration() : 0;
                if (t1.terrain && a > 0) {
                    const i = t1.terrain, n = i.findDEMTileFor(o);
                    n && n.dem ? r = e1.et.create(i, o, n) : a = 0;
                }
                if (0 === a && (i.terrainElevationMin = 0, i.terrainElevationMax = 0), a === i.validForExaggeration && (0 === a || r && r._demTile && r._demTile.tileID === i.validForDEMTile.id && r._dem._timestamp === i.validForDEMTile.timestamp)) return !1;
                for(const e1 in i.instancesPerModel){
                    const t1 = i.instancesPerModel[e1];
                    for(let e1 = 0; e1 < t1.instancedDataArray.length; ++e1){
                        const o = (r ? a * r.getElevationAt(0 | t1.instancedDataArray.float32[16 * e1], 0 | t1.instancedDataArray.float32[16 * e1 + 1], !0, !0) : 0) + t1.instancesEvaluatedElevation[e1];
                        t1.instancedDataArray.float32[16 * e1 + 6] = o, n = n ? Math.min(i.terrainElevationMin, o) : o, s = s ? Math.max(i.terrainElevationMax, o) : o;
                    }
                }
                return i.terrainElevationMin = n || 0, i.terrainElevationMax = s || 0, i.validForExaggeration = a, i.validForDEMTile = r && r._demTile ? {
                    id: r._demTile.tileID,
                    timestamp: r._dem._timestamp
                } : {
                    id: void 0,
                    timestamp: 0
                }, !0;
            }(t1, i, o);
            (r || n) && (i.uploaded = !1, i.upload(t1.context));
        }
        const da = {
            shadowUniformsInitialized: !1,
            useSingleShadowCascade: !1,
            tileMatrix: new Float64Array(16),
            shadowTileMatrix: new Float32Array(16),
            aabb: new e1.cQ([
                0,
                0,
                0
            ], [
                e1.an,
                e1.an,
                0
            ])
        };
        function _a(t1, i) {
            const o = 1 << t1.canonical.z, r = i.getFreeCameraOptions().position, n = i.elevation, s = t1.canonical.x / o, a = (t1.canonical.x + 1) / o, l = t1.canonical.y / o, c = (t1.canonical.y + 1) / o;
            let h = i._centerAltitude;
            if (n) {
                const e1 = n.getMinMaxForTile(t1);
                e1 && e1.max > h && (h = e1.max);
            }
            const d = e1.aC(r.x, s, a) - r.x, _ = e1.aC(r.y, l, c) - r.y, u = e1.bV(h, i.center.lat) - r.z;
            return i._zoomFromMercatorZ(Math.sqrt(d * d + _ * _ + u * u));
        }
        function ua(e1, t1, i, o, r, n, s) {
            const a = e1.context, l = "shadow" === e1.renderPass, c = e1.shadowRenderer, h = l && c ? c.getShadowPassDepthMode() : new Hi(a.gl.LEQUAL, Hi.ReadWrite, e1.depthRangeFor3D), d = e1.isTileAffectedByFog(n), _ = "globe" === e1.transform.projection.name;
            if (i.meshes) for (const u of i.meshes){
                const p = _ ? [] : [
                    "MODEL_POSITION_ON_GPU"
                ], f = [];
                let m, g, v;
                const y = !_ && o.instancedDataArray.length > 20;
                y && p.push("INSTANCED_ARRAYS");
                const x = ao(e1, t1.paint.get("model-cutoff-fade-range"));
                if (x.shouldRenderCutoff && p.push("RENDER_CUTOFF"), l && c) m = e1.getOrCreateProgram("modelDepth", {
                    defines: p
                }), g = $n(s.shadowTileMatrix, s.shadowTileMatrix, Float32Array.from(i.globalMatrix)), v = Zi.disabled;
                else {
                    ta(p, f, u, e1, "none" === t1.paint.get("model-color-use-theme").constantOr("default") ? null : t1.lut), m = e1.getOrCreateProgram("model", {
                        defines: p,
                        overrideFog: d
                    });
                    const o = u.material, l = o.pbrMetallicRoughness, h = t1.paint.get("model-opacity").constantOr(1), _ = t1.paint.get("model-emissive-strength").constantOr(0);
                    g = Wn(n.expandedProjMatrix, Float32Array.from(i.globalMatrix), new Float32Array(16), null, e1, h, l.baseColorFactor, o.emissiveFactor, l.metallicFactor, l.roughnessFactor, o, _, t1, r), c && (s.shadowUniformsInitialized ? m.setShadowUniformValues(a, c.getShadowUniformValues()) : (c.setupShadows(n.toUnwrapped(), m, "model-tile"), s.shadowUniformsInitialized = !0)), v = x.shouldRenderCutoff || h < 1 || "OPAQUE" !== o.alphaMode ? Zi.alphaBlended : Zi.unblended;
                }
                e1.uploadCommonUniforms(a, m, n.toUnwrapped(), null, x);
                const b = u.material.doubleSided ? Ki.disabled : Ki.backCCW;
                if (y) f.push(o.instancedDataBuffer), m.draw(e1, a.gl.TRIANGLES, h, $i.disabled, v, b, g, t1.id, u.vertexBuffer, u.indexBuffer, u.segments, t1.paint, e1.transform.zoom, void 0, f, o.instancedDataArray.length);
                else {
                    const i = l ? "u_instance" : "u_normal_matrix";
                    for(let r = 0; r < o.instancedDataArray.length; ++r)g[i] = new Float32Array(o.instancedDataArray.arrayBuffer, 64 * r, 16), m.draw(e1, a.gl.TRIANGLES, h, $i.disabled, v, b, g, t1.id, u.vertexBuffer, u.indexBuffer, u.segments, t1.paint, e1.transform.zoom, void 0, f);
                }
            }
            if (i.children) for (const a of i.children)ua(e1, t1, a, o, r, n, s);
        }
        const pa = [
            1,
            -1,
            1
        ];
        function fa(t1, i, o, r) {
            if (!o.modelManager) return !0;
            const n = o.modelManager;
            if (!o.shadowRenderer) return !0;
            const s = o.shadowRenderer, a = i.aabb;
            let l = !0, c = t1.maxHeight;
            if (0 === c) {
                let e1 = 0;
                for(const i in t1.instancesPerModel){
                    const t1 = n.getModel(i, r);
                    t1 ? e1 = Math.max(e1, Math.max(Math.max(t1.aabb.max[0], t1.aabb.max[1]), t1.aabb.max[2])) : l = !1;
                }
                c = t1.maxScale * e1 * 1.41 + t1.maxVerticalOffset, l && (t1.maxHeight = c);
            }
            a.max[2] = c, a.min[2] += t1.terrainElevationMin, a.max[2] += t1.terrainElevationMax, e1.ah(a.min, a.min, i.tileMatrix), e1.ah(a.max, a.max, i.tileMatrix);
            const h = a.intersects(s.getCurrentCascadeFrustum());
            return 0 === o.currentShadowCascade && (t1.isInsideFirstShadowMapFrustum = 2 === h), 0 === h;
        }
        function ma(t1, i) {
            const o = t1.uniformValues.u_cutoff_params[0], r = t1.uniformValues.u_cutoff_params[1], n = t1.uniformValues.u_cutoff_params[2], s = t1.uniformValues.u_cutoff_params[3];
            return r === o || s === n ? 1 : e1.aC(((i - o) / (r - o) - n) / (s - n), 0, 1);
        }
        function ga(t1, i, o, r) {
            if (i.pitch < 20) return 1;
            const n = i.getWorldToCameraMatrix();
            e1.aD(n, n, t1);
            const s = e1.bu(o.min[0], o.min[1], o.min[2], 1);
            let a = e1.aE(e1.bF(), s, n), l = a, c = a;
            s[1] = o.max[1], a = e1.aE(e1.bF(), s, n), l = a[1] < l[1] ? a : l, c = a[1] > c[1] ? a : c, s[0] = o.max[0], a = e1.aE(e1.bF(), s, n), l = a[1] < l[1] ? a : l, c = a[1] > c[1] ? a : c, s[1] = o.min[1], a = e1.aE(e1.bF(), s, n), l = a[1] < l[1] ? a : l, c = a[1] > c[1] ? a : c;
            const h = e1.aC(r[0], 0, 1), d = 100 * i.pixelsPerMeter * e1.aC(r[1], 0, 1), _ = e1.aC(r[2], 0, 1), u = e1.eu(e1.bF(), l, c, h), p = Math.tan(.5 * i.fovX), f = -u[2] * p;
            if (0 === d) return u[1] < -Math.abs(f) ? _ : 1;
            const m = (-Math.abs(f) - u[1]) / d, g = (e1, t1, i)=>(1 - i) * e1 + i * t1, v = e1.aC(g(1, _, m), _, 1);
            return g(1, v, e1.aC((i.pitch - 20) / 20, 0, 1));
        }
        class va {
        }
        class ya {
            constructor(){
                this._storage = new Map;
            }
            getLinesFromTrianglesBuffer(t1, i, o) {
                {
                    const e1 = this._storage.get(i.id);
                    if (e1) return e1.lastUsedFrameIdx = t1, e1.buf;
                }
                const r = o.gl, n = r.getBufferParameter(r.ELEMENT_ARRAY_BUFFER, r.BUFFER_SIZE), s = new ArrayBuffer(n), a = new Int16Array(s);
                r.getBufferSubData(r.ELEMENT_ARRAY_BUFFER, 0, new Int16Array(s));
                const l = new e1.ew;
                for(let e1 = 0; e1 < n / 2; e1 += 3){
                    const t1 = a[e1], i = a[e1 + 1], o = a[e1 + 2];
                    l.emplaceBack(t1, i), l.emplaceBack(i, o), l.emplaceBack(o, t1);
                }
                const c = o.bindVertexArrayOES.current, h = new va;
                return h.buf = new Yn(o, l), h.lastUsedFrameIdx = t1, this._storage.set(i.id, h), o.bindVertexArrayOES.set(c), h.buf;
            }
            update(e1) {
                for (const [t1, i] of this._storage)e1 - i.lastUsedFrameIdx > 30 && (i.buf.destroy(), this._storage.delete(t1));
            }
            destroy() {
                for (const [e1, t1] of this._storage)t1.buf.destroy(), this._storage.delete(e1);
            }
        }
        class xa {
            constructor(){
                this.occluderSize = 30, this.depthOffset = -0.0001;
            }
        }
        const ba = e1.e4([
            {
                type: "Float32",
                name: "a_pos_3f",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            },
            {
                type: "Float32",
                name: "a_rainParticleData",
                components: 4
            }
        ]);
        class wa {
            constructor(e1){
                this.revealStart = 11, this.revealRange = 2;
            }
        }
        const Ta = e1.e4([
            {
                type: "Float32",
                name: "a_pos_2f",
                components: 2
            }
        ]);
        class Ea {
            destroy() {
                this.vignetteVx && this.vignetteVx.destroy(), this.vignetteIdx && this.vignetteIdx.destroy();
            }
            draw(t1, i) {
                const o = t1.getOrCreateProgram("vignette");
                if (!this.vignetteVx || !this.vignetteIdx) {
                    const i = new e1.ex, o = new e1.dy;
                    i.emplaceBack(-1, -1), i.emplaceBack(1, -1), i.emplaceBack(1, 1), i.emplaceBack(-1, 1), o.emplaceBack(0, 1, 2), o.emplaceBack(0, 2, 3), this.vignetteVx = t1.context.createVertexBuffer(i, Ta.members), this.vignetteIdx = t1.context.createIndexBuffer(o);
                }
                const r = e1.du.simpleSegment(0, 0, 4, 6);
                if (this.vignetteVx && this.vignetteIdx) {
                    t1.uploadCommonUniforms(t1.context, o);
                    const e1 = {
                        u_vignetteShape: (n = {
                            vignetteShape: [
                                i.start,
                                i.range,
                                Math.pow(10, i.fadePower)
                            ],
                            vignetteColor: [
                                i.color.r,
                                i.color.g,
                                i.color.b,
                                i.color.a * i.strength
                            ]
                        }).vignetteShape,
                        u_vignetteColor: n.vignetteColor
                    };
                    o.draw(t1, t1.context.gl.TRIANGLES, Hi.disabled, $i.disabled, Zi.alphaBlended, Ki.disabled, e1, "vignette", this.vignetteVx, this.vignetteIdx, r);
                }
                var n;
            }
        }
        class Sa {
            constructor(){
                this._accumulatedOffsetX = 0, this._accumulatedOffsetY = 0, this._accumulatedElevation = 0;
            }
            update(t1, i) {
                const o = t1.getFreeCameraOptions().position, r = o.toAltitude(), n = o.toLngLat(), s = e1.ap(n.lng), a = e1.ap(n.lat), l = t1.pixelsPerMeter / i, c = s * e1.ez, h = e1.ez * Math.log(Math.tan(Math.PI / 4 + a / 2));
                if (void 0 === this._offsetXPrev) this._offsetXPrev = 0, this._offsetYPrev = 0, this._elevationPrev = 0, this._accumulatedOffsetX = 0, this._accumulatedOffsetY = 0, this._accumulatedElevation = 0;
                else {
                    const e1 = -this._offsetYPrev + h, t1 = -this._elevationPrev + r;
                    this._accumulatedOffsetX += (-this._offsetXPrev + c) * l, this._accumulatedOffsetY += e1 * l, this._accumulatedElevation += t1 * l, this._offsetXPrev = c, this._offsetYPrev = h, this._elevationPrev = r;
                }
            }
            getPosition() {
                return [
                    this._accumulatedOffsetX,
                    this._accumulatedOffsetY,
                    this._accumulatedElevation
                ];
            }
        }
        function Ca(e1, t1) {
            return [
                -(e1[0] - Math.floor(e1[0] / t1) * t1),
                -(e1[1] - Math.floor(e1[1] / t1) * t1),
                -(e1[2] - Math.floor(e1[2] / t1) * t1)
            ];
        }
        function Ia(t1) {
            const i = e1.ei(1323123451230), o = [];
            for(let r = 0; r < t1; ++r){
                const t1 = 2 * i() - 1, r = 2 * i() - 1, n = 2 * i() - 1;
                o.push(e1.cM(t1, r, n));
            }
            return o;
        }
        function Ra(t1, i, o, r, n) {
            const s = e1.aC((n - o) / (r - o), 0, 1);
            return (1 - s) * t1 + s * i;
        }
        class Da {
            constructor(e1){
                this._movement = new Sa, this._accumulatedTimeFromStart = 0, this._prevTime = Date.now() / 1e3, this._vignette = new Ea, this._ppmScaleFactor = e1;
            }
            destroy() {
                this.particlesVx && this.particlesVx.destroy(), this.particlesIdx && this.particlesIdx.destroy(), this._vignette && this._vignette.destroy();
            }
            updateOnRender(t1, i) {
                const o = t1.transform;
                this._movement.update(o, this._ppmScaleFactor);
                const r = o.starsProjMatrix, n = e1.bM([]);
                e1.bO(n, n, e1.ap(90) - o._pitch), e1.bN(n, n, -o.angle);
                const s = e1.bS(new Float32Array(16), n), a = e1.ey(1, 0, 0, 0, 0, 0, 1, 0, 0, -1, 0, 0, 0, 0, 0, 1), l = e1.e2([], a), c = e1.aD([], l, s), h = Date.now() / 1e3;
                return this._accumulatedTimeFromStart += (h - this._prevTime) * i, this._prevTime = h, {
                    projectionMatrix: r,
                    modelviewMatrix: c
                };
            }
        }
        class Aa extends Da {
            constructor(e1){
                super(4.25), this._params = {
                    overrideStyleParameters: !1,
                    intensity: .5,
                    timeFactor: 1,
                    velocityConeAperture: 0,
                    velocity: 300,
                    boxSize: 2500,
                    dropletSizeX: 1,
                    dropletSizeYScale: 10,
                    distortionStrength: 70,
                    screenThinning: {
                        intensity: .57,
                        start: .46,
                        range: 1.17,
                        fadePower: .17,
                        affectedRatio: 1,
                        particleOffset: -0.2
                    },
                    color: {
                        r: .66,
                        g: .68,
                        b: .74,
                        a: .7
                    },
                    direction: {
                        x: -50,
                        y: -35
                    },
                    shapeDirPower: 2,
                    shapeNormalPower: 1
                }, this._revealParams = new wa("Precipitation > Rain"), this._vignetteParams = {
                    strength: 1,
                    start: .7,
                    range: 1,
                    fadePower: .4,
                    color: {
                        r: .27,
                        g: .27,
                        b: .27,
                        a: 1
                    }
                }, this.particlesCount = 16e3;
            }
            update(t1) {
                const i = t1.context;
                if (!this.particlesVx) {
                    const t1 = Ia(this.particlesCount), o = new e1.eA, r = new e1.dy;
                    let n = 0;
                    const s = e1.ei(1323123451230);
                    for(let e1 = 0; e1 < t1.length; ++e1){
                        const i = t1[e1], a = [
                            2 * s() - 1,
                            s(),
                            s(),
                            s()
                        ];
                        o.emplaceBack(i[0], i[1], i[2], -1, -1, ...a), o.emplaceBack(i[0], i[1], i[2], 1, -1, ...a), o.emplaceBack(i[0], i[1], i[2], 1, 1, ...a), o.emplaceBack(i[0], i[1], i[2], -1, 1, ...a), r.emplaceBack(n + 0, n + 1, n + 2), r.emplaceBack(n + 0, n + 2, n + 3), n += 4;
                    }
                    this.particlesVx = i.createVertexBuffer(o, ba.members), this.particlesIdx = i.createIndexBuffer(r);
                }
            }
            draw(t1) {
                if (!this._params.overrideStyleParameters && !t1.style.rain) return;
                const i = this._params.overrideStyleParameters ? this._revealParams : {
                    revealStart: 0,
                    revealRange: .01
                }, o = t1.transform.zoom;
                if (i.revealStart > o) return;
                const r = Ra(0, 1, i.revealStart, i.revealStart + i.revealRange, o);
                if (!this.particlesVx || !this.particlesIdx) return;
                const n = structuredClone(this._params);
                let s = [
                    -n.direction.x,
                    n.direction.y,
                    -100
                ];
                e1.ay(s, s);
                const a = structuredClone(this._vignetteParams);
                a.strength *= r, n.overrideStyleParameters || (n.intensity = t1.style.rain.state.density, n.timeFactor = t1.style.rain.state.intensity, n.color = structuredClone(t1.style.rain.state.color), s = structuredClone(t1.style.rain.state.direction), n.screenThinning.intensity = t1.style.rain.state.centerThinning, n.dropletSizeX = t1.style.rain.state.dropletSize[0], n.dropletSizeYScale = t1.style.rain.state.dropletSize[1] / t1.style.rain.state.dropletSize[0], n.distortionStrength = 100 * t1.style.rain.state.distortionStrength, a.strength = 1, a.color = structuredClone(t1.style.rain.state.vignetteColor));
                const l = this.updateOnRender(t1, n.timeFactor), c = t1.context, h = c.gl, d = t1.transform;
                this.screenTexture && this.screenTexture.size[0] === t1.width && this.screenTexture.size[1] === t1.height || (this.screenTexture = new e1.T(c, {
                    width: t1.width,
                    height: t1.height,
                    data: null
                }, h.RGBA8)), n.distortionStrength > 0 && (c.activeTexture.set(h.TEXTURE0), this.screenTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE), h.copyTexSubImage2D(h.TEXTURE_2D, 0, 0, 0, 0, 0, t1.width, t1.height));
                const _ = t1.getOrCreateProgram("rainParticle");
                t1.uploadCommonUniforms(c, _), c.activeTexture.set(h.TEXTURE0), this.screenTexture.bind(h.LINEAR, h.CLAMP_TO_EDGE);
                const u = [
                    n.color.r,
                    n.color.g,
                    n.color.b,
                    n.color.a
                ], p = (i, o)=>{
                    const r = Ca(this._movement.getPosition(), i), a = n.dropletSizeX, c = n.dropletSizeX * n.dropletSizeYScale, p = t1.width / 2, f = t1.height / 2, m = Ra(0, n.screenThinning.start, 0, 1, n.screenThinning.intensity), g = Ra(.001, n.screenThinning.range, 0, 1, n.screenThinning.intensity), v = Ra(0, n.screenThinning.particleOffset, 0, 1, n.screenThinning.intensity), y = (x = {
                        modelview: l.modelviewMatrix,
                        projection: l.projectionMatrix,
                        time: this._accumulatedTimeFromStart,
                        camPos: r,
                        velocityConeAperture: n.velocityConeAperture,
                        velocity: n.velocity,
                        boxSize: i,
                        rainDropletSize: [
                            a,
                            c
                        ],
                        distortionStrength: n.distortionStrength,
                        rainDirection: s,
                        color: u,
                        screenSize: [
                            d.width,
                            d.height
                        ],
                        thinningCenterPos: [
                            p,
                            f
                        ],
                        thinningShape: [
                            m,
                            g,
                            Math.pow(10, n.screenThinning.fadePower)
                        ],
                        thinningAffectedRatio: n.screenThinning.affectedRatio,
                        thinningParticleOffset: v,
                        shapeDirectionalPower: n.shapeDirPower,
                        shapeNormalPower: n.shapeNormalPower,
                        mode: o ? 0 : 1
                    }, {
                        u_modelview: Float32Array.from(x.modelview),
                        u_projection: Float32Array.from(x.projection),
                        u_time: x.time,
                        u_cam_pos: x.camPos,
                        u_texScreen: 0,
                        u_velocityConeAperture: x.velocityConeAperture,
                        u_velocity: x.velocity,
                        u_boxSize: x.boxSize,
                        u_rainDropletSize: x.rainDropletSize,
                        u_distortionStrength: x.distortionStrength,
                        u_rainDirection: x.rainDirection,
                        u_color: x.color,
                        u_screenSize: x.screenSize,
                        u_thinningCenterPos: x.thinningCenterPos,
                        u_thinningShape: x.thinningShape,
                        u_thinningAffectedRatio: x.thinningAffectedRatio,
                        u_thinningParticleOffset: x.thinningParticleOffset,
                        u_shapeDirectionalPower: x.shapeDirectionalPower,
                        u_shapeNormalPower: x.shapeNormalPower,
                        u_mode: x.mode
                    });
                    var x;
                    const b = Math.round(n.intensity * this.particlesCount), w = e1.du.simpleSegment(0, 0, 4 * b, 2 * b);
                    _.draw(t1, h.TRIANGLES, Hi.disabled, $i.disabled, Zi.alphaBlended, Ki.disabled, y, "rain_particles", this.particlesVx, this.particlesIdx, w);
                };
                n.distortionStrength > 0 && p(n.boxSize, !0), p(n.boxSize, !1), this._vignette.draw(t1, a);
            }
        }
        const La = e1.e4([
            {
                type: "Float32",
                name: "a_pos_3f",
                components: 3
            },
            {
                type: "Float32",
                name: "a_uv",
                components: 2
            },
            {
                type: "Float32",
                name: "a_snowParticleData",
                components: 4
            },
            {
                type: "Float32",
                name: "a_snowParticleDataHorizontalOscillation",
                components: 2
            }
        ]);
        class Pa extends Da {
            constructor(e1){
                super(2.25), this._params = {
                    overrideStyleParameters: !1,
                    intensity: .85,
                    timeFactor: .75,
                    velocityConeAperture: 70,
                    velocity: 40,
                    horizontalOscillationRadius: 4,
                    horizontalOscillationRate: 1.5,
                    boxSize: 2e3,
                    billboardSize: 2,
                    shapeFadeStart: .27,
                    shapeFadePower: .21,
                    screenThinning: {
                        intensity: .4,
                        start: .15,
                        range: 1.4,
                        fadePower: .24,
                        affectedRatio: 1,
                        particleOffset: -0.2
                    },
                    color: {
                        r: 1,
                        g: 1,
                        b: 1,
                        a: 1
                    },
                    direction: {
                        x: -50,
                        y: -35
                    }
                }, this._revealParams = new wa("Precipitation > Snow"), this._vignetteParams = {
                    strength: .3,
                    start: .78,
                    range: .46,
                    fadePower: .2,
                    color: {
                        r: 1,
                        g: 1,
                        b: 1,
                        a: 1
                    }
                }, this.particlesCount = 16e3;
            }
            update(t1) {
                const i = t1.context;
                if (!this.particlesVx) {
                    const t1 = Ia(this.particlesCount), o = new e1.eB, r = new e1.dy;
                    let n = 0;
                    const s = e1.ei(1323123451230);
                    for(let e1 = 0; e1 < t1.length; ++e1){
                        const i = t1[e1], a = s(), l = s(), c = s(), h = [
                            e1 / t1.length,
                            a,
                            l,
                            c
                        ], d = [
                            s(),
                            s()
                        ];
                        o.emplaceBack(i[0], i[1], i[2], -1, -1, ...h, ...d), o.emplaceBack(i[0], i[1], i[2], 1, -1, ...h, ...d), o.emplaceBack(i[0], i[1], i[2], 1, 1, ...h, ...d), o.emplaceBack(i[0], i[1], i[2], -1, 1, ...h, ...d), r.emplaceBack(n + 0, n + 1, n + 2), r.emplaceBack(n + 0, n + 2, n + 3), n += 4;
                    }
                    this.particlesVx = i.createVertexBuffer(o, La.members), this.particlesIdx = i.createIndexBuffer(r);
                }
            }
            draw(t1) {
                if (!this._params.overrideStyleParameters && !t1.style.snow) return;
                const i = structuredClone(this._params);
                let o = [
                    -i.direction.x,
                    i.direction.y,
                    -100
                ];
                e1.ay(o, o);
                const r = structuredClone(this._vignetteParams), n = i.overrideStyleParameters ? this._revealParams : {
                    revealStart: 0,
                    revealRange: .01
                }, s = t1.transform.zoom;
                if (n.revealStart > s) return;
                const a = Ra(0, 1, n.revealStart, n.revealStart + n.revealRange, s);
                r.strength *= a, i.overrideStyleParameters || (i.intensity = t1.style.snow.state.density, i.timeFactor = t1.style.snow.state.intensity, i.color = structuredClone(t1.style.snow.state.color), o = structuredClone(t1.style.snow.state.direction), i.screenThinning.intensity = t1.style.snow.state.centerThinning, i.billboardSize = 2.79 * t1.style.snow.state.flakeSize, r.strength = 1, r.color = structuredClone(t1.style.snow.state.vignetteColor));
                const l = this.updateOnRender(t1, i.timeFactor);
                if (!this.particlesVx || !this.particlesIdx) return;
                const c = t1.context, h = c.gl, d = t1.transform, _ = t1.getOrCreateProgram("snowParticle");
                t1.uploadCommonUniforms(c, _), ((i, r, n)=>{
                    const s = Ca(this._movement.getPosition(), i), a = d.width / 2, c = d.height / 2, u = Ra(0, n.screenThinning.start, 0, 1, n.screenThinning.intensity), p = Ra(.001, n.screenThinning.range, 0, 1, n.screenThinning.intensity), f = Ra(0, n.screenThinning.particleOffset, 0, 1, n.screenThinning.intensity), m = (g = {
                        modelview: l.modelviewMatrix,
                        projection: l.projectionMatrix,
                        time: this._accumulatedTimeFromStart,
                        camPos: s,
                        velocityConeAperture: n.velocityConeAperture,
                        velocity: n.velocity,
                        horizontalOscillationRadius: n.horizontalOscillationRadius,
                        horizontalOscillationRate: n.horizontalOscillationRate,
                        boxSize: i,
                        billboardSize: 1 * n.billboardSize,
                        simpleShapeParameters: [
                            n.shapeFadeStart,
                            n.shapeFadePower
                        ],
                        screenSize: [
                            d.width,
                            d.height
                        ],
                        thinningCenterPos: [
                            a,
                            c
                        ],
                        thinningShape: [
                            u,
                            p,
                            Math.pow(10, n.screenThinning.fadePower)
                        ],
                        thinningAffectedRatio: n.screenThinning.affectedRatio,
                        thinningParticleOffset: f,
                        color: [
                            n.color.r,
                            n.color.g,
                            n.color.b,
                            n.color.a
                        ],
                        direction: o
                    }, {
                        u_modelview: Float32Array.from(g.modelview),
                        u_projection: Float32Array.from(g.projection),
                        u_time: g.time,
                        u_cam_pos: g.camPos,
                        u_velocityConeAperture: g.velocityConeAperture,
                        u_velocity: g.velocity,
                        u_horizontalOscillationRadius: g.horizontalOscillationRadius,
                        u_horizontalOscillationRate: g.horizontalOscillationRate,
                        u_boxSize: g.boxSize,
                        u_billboardSize: g.billboardSize,
                        u_simpleShapeParameters: g.simpleShapeParameters,
                        u_screenSize: g.screenSize,
                        u_thinningCenterPos: g.thinningCenterPos,
                        u_thinningShape: g.thinningShape,
                        u_thinningAffectedRatio: g.thinningAffectedRatio,
                        u_thinningParticleOffset: g.thinningParticleOffset,
                        u_particleColor: g.color,
                        u_direction: g.direction
                    });
                    var g;
                    const v = Math.round(n.intensity * this.particlesCount), y = e1.du.simpleSegment(0, 0, 4 * v, 2 * v);
                    this.particlesVx && this.particlesIdx && _.draw(t1, h.TRIANGLES, Hi.disabled, $i.disabled, Zi.alphaBlended, Ki.disabled, m, "snow_particles", this.particlesVx, this.particlesIdx, y);
                })(i.boxSize, 0, i), this._vignette.draw(t1, r);
            }
        }
        const Oa = {
            symbol: function(t1, i, o, r, n) {
                if ("translucent" !== t1.renderPass) return;
                const s = $i.disabled, a = t1.colorModeForRenderPass(), l = o.layout.get("text-variable-anchor"), c = o.layout.get("text-size-scale-range"), h = e1.aC(t1.scaleFactor, c[0], c[1]);
                l && function(t1, i, o, r, n, s, a, l) {
                    const c = i.transform, h = "map" === n, d = "map" === s;
                    for (const i of t1){
                        const t1 = r.getTile(i), n = t1.getBucket(o);
                        if (!n || !n.text || !n.text.segments.get().length) continue;
                        const s = e1.bk(n.textSizeData, c.zoom, l), _ = Kt(i, n.getProjection(), c), u = c.calculatePixelsToTileUnitsMatrix(t1), p = ti(_, t1.tileID.canonical, d, h, c, n.getProjection(), u), f = n.hasIconTextFit() && n.hasIconData();
                        s && ss(n, h, d, a, c, p, i, Math.pow(2, c.zoom - t1.tileID.overscaledZ), s, f);
                    }
                }(r, t1, o, i, o.layout.get("text-rotation-alignment"), o.layout.get("text-pitch-alignment"), n, h);
                const d = 0 !== o.paint.get("icon-opacity").constantOr(1), _ = 0 !== o.paint.get("text-opacity").constantOr(1);
                void 0 !== o.layout.get("symbol-sort-key").constantOr(1) && (d || _) ? as(t1, i, o, r, s, a) : (d && as(t1, i, o, r, s, a, {
                    onlyIcons: !0
                }), _ && as(t1, i, o, r, s, a, {
                    onlyText: !0
                })), i.map.showCollisionBoxes && (is(t1, i, o, r, o.paint.get("text-translate"), o.paint.get("text-translate-anchor"), !0), is(t1, i, o, r, o.paint.get("icon-translate"), o.paint.get("icon-translate-anchor"), !1));
            },
            circle: function(t1, i, o, r) {
                if ("translucent" !== t1.renderPass) return;
                const n = o.paint.get("circle-opacity"), s = o.paint.get("circle-stroke-width"), a = o.paint.get("circle-stroke-opacity"), l = void 0 !== o.layout.get("circle-sort-key").constantOr(1), c = o.paint.get("circle-emissive-strength");
                if (0 === n.constantOr(1) && (0 === s.constantOr(1) || 0 === a.constantOr(1))) return;
                const h = t1.context, d = h.gl, _ = t1.transform, u = !(!t1.terrain || !t1.terrain.enabled), p = o.layout.get("circle-elevation-reference"), f = t1.depthModeForSublayer(0, Hi.ReadOnly), m = new Hi(t1.context.gl.LEQUAL, Hi.ReadOnly, t1.depthRangeFor3D), g = "none" === p || u ? f : m, v = $i.disabled, y = t1.colorModeForDrapableLayerRenderPass(c), x = "globe" === _.projection.name, b = [
                    e1.aH(_.center.lng),
                    e1.aL(_.center.lat)
                ], w = [];
                for(let n = 0; n < r.length; n++){
                    const s = r[n], a = i.getTile(s), c = a.getBucket(o);
                    if (!c || c.projection.name !== _.projection.name) continue;
                    const h = c.programConfigurations.get(o.id), d = c.layoutVertexBuffer, u = c.globeExtVertexBuffer, p = c.indexBuffer, f = e1.dO(o), m = [
                        u
                    ], g = t1.isTileAffectedByFog(s);
                    x && f.push("PROJECTION_GLOBE_VIEW"), f.push("DEPTH_D24"), t1.terrain && _.depthOcclusionForSymbolsAndCircles && f.push("DEPTH_OCCLUSION"), c.hasElevation && !t1.terrain && (f.push("ELEVATED_ROADS"), m.push(c.elevatedLayoutVertexBuffer));
                    const v = t1.getOrCreateProgram("circle", {
                        config: h,
                        defines: f,
                        overrideFog: g
                    }), y = _.projection.createInversionMatrix(_, s.canonical), T = {
                        programConfiguration: h,
                        program: v,
                        layoutVertexBuffer: d,
                        dynamicBuffers: m,
                        indexBuffer: p,
                        uniformValues: e1.dP(t1, s, a, y, b, o),
                        tile: a
                    };
                    if (l) {
                        const t1 = c.segments.get();
                        for (const i of t1)w.push({
                            segments: new e1.du([
                                i
                            ]),
                            sortKey: i.sortKey,
                            state: T
                        });
                    } else w.push({
                        segments: c.segments,
                        sortKey: 0,
                        state: T
                    });
                }
                l && w.sort((e1, t1)=>e1.sortKey - t1.sortKey);
                const T = {
                    useDepthForOcclusion: _.depthOcclusionForSymbolsAndCircles
                };
                for (const e1 of w){
                    const { programConfiguration: i, program: r, layoutVertexBuffer: n, dynamicBuffers: s, indexBuffer: a, uniformValues: l, tile: c } = e1.state, u = e1.segments;
                    t1.terrain && t1.terrain.setupElevationDraw(c, r, T), t1.uploadCommonUniforms(h, r, c.tileID.toUnwrapped()), r.draw(t1, d.TRIANGLES, g, v, y, Ki.disabled, l, o.id, n, a, u, o.paint, _.zoom, i, s);
                }
            },
            heatmap: function(t1, i, o, r) {
                if (0 !== o.paint.get("heatmap-opacity")) {
                    if ("offscreen" === t1.renderPass) {
                        const n = t1.context, s = n.gl, a = $i.disabled, l = new Zi([
                            s.ONE,
                            s.ONE,
                            s.ONE,
                            s.ONE
                        ], e1.aq.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]), c = "globe" === t1.transform.projection.name ? .5 : .25;
                        o.heatmapFbo = Jn.createWithTexture(n, o.heatmapFbo, t1.width * c, t1.height * c), n.clear({
                            color: e1.aq.transparent
                        });
                        const h = t1.transform, d = "globe" === h.projection.name, _ = d ? [
                            "PROJECTION_GLOBE_VIEW"
                        ] : [], u = d ? Ki.frontCCW : Ki.disabled, p = [
                            e1.aH(h.center.lng),
                            e1.aL(h.center.lat)
                        ];
                        for(let e1 = 0; e1 < r.length; e1++){
                            const c = r[e1];
                            if (i.hasRenderableParent(c)) continue;
                            const f = i.getTile(c), m = f.getBucket(o);
                            if (!m || m.projection.name !== h.projection.name) continue;
                            const g = t1.isTileAffectedByFog(c), v = m.programConfigurations.get(o.id), y = t1.getOrCreateProgram("heatmap", {
                                config: v,
                                defines: _,
                                overrideFog: g
                            }), { zoom: x } = t1.transform;
                            t1.terrain && t1.terrain.setupElevationDraw(f, y), t1.uploadCommonUniforms(n, y, c.toUnwrapped());
                            const b = h.projection.createInversionMatrix(h, c.canonical);
                            y.draw(t1, s.TRIANGLES, Hi.disabled, a, l, u, Pn(t1, c, f, b, p, x, o.paint.get("heatmap-intensity")), o.id, m.layoutVertexBuffer, m.indexBuffer, m.segments, o.paint, t1.transform.zoom, v, d ? [
                                m.globeExtVertexBuffer
                            ] : null);
                        }
                        n.viewport.set([
                            0,
                            0,
                            t1.width,
                            t1.height
                        ]);
                    } else "translucent" === t1.renderPass && (t1.context.setColorMode(t1.colorModeForRenderPass()), function(t1, i) {
                        const o = t1.context, r = o.gl, n = i.heatmapFbo;
                        if (!n) return;
                        o.activeTexture.set(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D, n.colorAttachment0.get()), o.activeTexture.set(r.TEXTURE1);
                        let s = i.colorRampTexture;
                        s || (s = i.colorRampTexture = new e1.T(o, i.colorRamp, r.RGBA8)), s.bind(r.LINEAR, r.CLAMP_TO_EDGE), t1.getOrCreateProgram("heatmapTexture").draw(t1, r.TRIANGLES, Hi.disabled, $i.disabled, t1.colorModeForRenderPass(), Ki.disabled, ((e1, t1)=>({
                                u_image: 0,
                                u_color_ramp: 1,
                                u_opacity: t1.paint.get("heatmap-opacity")
                            }))(0, i), i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments, i.paint, t1.transform.zoom);
                    }(t1, o));
                }
            },
            line: function(e1, t1, i, o) {
                const r = i.paint.get("line-opacity"), n = i.paint.get("line-width");
                if (0 === r.constantOr(1) || 0 === n.constantOr(1)) return;
                const s = i.paint.get("line-blend-mode");
                if ("default" !== s && "globe" !== e1.transform.projection.name) return e1.terrain && e1.terrain.renderingToTexture ? void function(e1, t1, i, o, r) {
                    if ("translucent" !== e1.renderPass) return;
                    const n = e1.context, s = n.gl, a = e1.terrain;
                    if (!a) return;
                    const l = n.bindFramebuffer.current, c = "mrt-fallback" === e1.emissiveMode;
                    i.lineBlendDrapeFbo = Jn.createWithTexture(n, i.lineBlendDrapeFbo, a.drapeBufferSize[0], a.drapeBufferSize[1], !0), i.lineBlendDrapeStencil = i.lineBlendDrapeFbo._stencilRbo, c && s.drawBuffers([
                        s.COLOR_ATTACHMENT0
                    ]), n.clear({
                        color: hs[r].clearColor,
                        depth: 1,
                        stencil: 0
                    });
                    const h = e1.currentStencilSource, d = e1._tileClippingMaskIDs, _ = e1.nextStencilID;
                    e1.currentStencilSource = void 0, e1._tileClippingMaskIDs = {}, e1.nextStencilID = 1;
                    const u = e1._terrain;
                    e1._terrain = null, e1._renderTileClippingMasks(i, t1, o), cs(e1, t1, i, o, hs[r].colorMode, !0), e1._terrain = u, e1.currentStencilSource = h, e1._tileClippingMaskIDs = d, e1.nextStencilID = _, n.bindFramebuffer.set(l), c && s.drawBuffers([
                        s.COLOR_ATTACHMENT0,
                        s.COLOR_ATTACHMENT1
                    ]);
                    const p = a.drapeBufferSize;
                    n.viewport.set([
                        0,
                        0,
                        p[0],
                        p[1]
                    ]);
                    const f = i.lineBlendDrapeFbo;
                    if (!f) return;
                    n.activeTexture.set(s.TEXTURE0), s.bindTexture(s.TEXTURE_2D, f.colorAttachment0.get());
                    const m = "additive" === r ? 1 : i.paint.get("line-opacity").constantOr(1), g = i.paint.get("line-emissive-strength").constantOr(0), v = "additive" === r ? e1.colorModeForDrapableLayerRenderPass(g) : hs[r].colorMode;
                    e1.getOrCreateProgram("lineBlendComposite").draw(e1, s.TRIANGLES, Hi.disabled, $i.disabled, v, Ki.disabled, En(0, m, hs[r].compositeUniformValue), i.id, e1.viewportBuffer, e1.quadTriangleIndexBuffer, e1.viewportSegments, i.paint, e1.transform.zoom);
                }(e1, t1, i, o, s) : "offscreen" === e1.renderPass ? void function(e1, t1, i, o, r) {
                    const n = e1.context, s = Math.ceil(e1.width), a = Math.ceil(e1.height);
                    i.lineBlendFbo = Jn.createWithTexture(n, i.lineBlendFbo, s, a, !0), i.lineBlendStencil = i.lineBlendFbo._stencilRbo, n.clear({
                        color: hs[r].clearColor,
                        depth: 1,
                        stencil: 0
                    });
                    const l = e1.currentStencilSource, c = e1._tileClippingMaskIDs, h = e1.nextStencilID;
                    e1.currentStencilSource = void 0, e1._tileClippingMaskIDs = {}, e1.nextStencilID = 1, e1._renderTileClippingMasks(i, t1, o);
                    const d = e1.renderPass;
                    e1.renderPass = "translucent", cs(e1, t1, i, o, hs[r].colorMode), e1.renderPass = d, e1.currentStencilSource = l, e1._tileClippingMaskIDs = c, e1.nextStencilID = h, n.viewport.set([
                        0,
                        0,
                        e1.width,
                        e1.height
                    ]);
                }(e1, t1, i, o, s) : "translucent" === e1.renderPass ? void function(e1, t1, i) {
                    const o = e1.context, r = o.gl, n = t1.lineBlendFbo;
                    if (!n) return;
                    o.activeTexture.set(r.TEXTURE0), r.bindTexture(r.TEXTURE_2D, n.colorAttachment0.get());
                    const s = "additive" === i ? 1 : t1.paint.get("line-opacity").constantOr(1), a = "additive" === i ? e1.colorModeForDrapableLayerRenderPass(t1.paint.get("line-emissive-strength").constantOr(0)) : hs[i].colorMode;
                    e1.getOrCreateProgram("lineBlendComposite").draw(e1, r.TRIANGLES, Hi.disabled, $i.disabled, a, Ki.disabled, En(0, s, hs[i].compositeUniformValue), t1.id, e1.viewportBuffer, e1.quadTriangleIndexBuffer, e1.viewportSegments, t1.paint, e1.transform.zoom);
                }(e1, i, s) : void 0;
                "translucent" === e1.renderPass && cs(e1, t1, i, o);
            },
            fill: function(t1, i, o, r) {
                const n = o.paint.get("fill-color"), s = o.paint.get("fill-opacity");
                if (0 === s.constantOr(1)) return;
                const a = o.paint.get("fill-emissive-strength"), l = t1.colorModeForDrapableLayerRenderPass(a), c = o.paint.get("fill-pattern"), h = t1.opaquePassEnabledForLayer() && !c.constantOr(1) && 1 === n.constantOr(e1.aq.transparent).a && 1 === s.constantOr(0) ? "opaque" : "translucent";
                let d = "none";
                "none" !== o.layout.get("fill-elevation-reference") ? d = "road" : 0 !== o.paint.get("fill-z-offset").constantOr(1) && (d = "offset");
                const _ = !(!t1.terrain || !t1.terrain.enabled), u = {
                    painter: t1,
                    sourceCache: i,
                    layer: o,
                    coords: r,
                    colorMode: l,
                    elevationType: d,
                    terrainEnabled: _,
                    pass: h
                };
                if ("shadow" === t1.renderPass) return void (t1.shadowRenderer && "road" === d && !_ && function(e1) {
                    const { painter: t1, sourceCache: i, layer: o, coords: r } = e1, n = t1.context.gl, s = e1.painter.shadowRenderer;
                    for (const e1 of r){
                        const r = i.getTile(e1), a = r.getBucket(o);
                        if (!a) continue;
                        const l = a.elevatedStructures;
                        if (!l) continue;
                        if (!l.shadowCasterSegments || 0 === l.shadowCasterSegments.segments[0].primitiveLength) continue;
                        t1.prepareDrawTile();
                        const c = a.bufferData.programConfigurations.get(o.id), h = t1.isTileAffectedByFog(e1), d = t1.getOrCreateProgram("elevatedStructuresDepth", {
                            config: c,
                            overrideFog: h
                        }), _ = s.calculateShadowPassMatrixFromTile(r.tileID.toUnwrapped());
                        t1.uploadCommonUniforms(t1.context, d, e1.toUnwrapped());
                        const u = bn(_, 0);
                        d.draw(t1, n.TRIANGLES, s.getShadowPassDepthMode(), $i.disabled, Zi.disabled, Ki.disabled, u, o.id, l.vertexBuffer, l.indexBuffer, l.shadowCasterSegments, o.paint, t1.transform.zoom, c);
                    }
                }(u));
                const p = "mrt-fallback" === t1.emissiveMode;
                if ("offset" !== d) {
                    if (us(u, !1, p), "road" === d) {
                        const e1 = !_ && "translucent" === t1.renderPass;
                        e1 && _s(t1, i, o, r, "geometry"), us(u, !0, p, $i.disabled), e1 && function(e1) {
                            const { painter: t1, sourceCache: i, layer: o, coords: r, colorMode: n } = e1, s = t1.context.gl, a = e1.painter.shadowRenderer, l = !!a && a.enabled, c = new Hi(t1.context.gl.LEQUAL, Hi.ReadOnly, t1.depthRangeFor3D);
                            let h = [
                                0,
                                0,
                                0
                            ];
                            if (l) {
                                const e1 = t1.style.directionalLight, i = t1.style.ambientLight;
                                e1 && i && (h = fo(t1.style, e1, i));
                            }
                            const d = (e1)=>{
                                for (const d of r){
                                    const r = i.getTile(d), _ = r.getBucket(o);
                                    if (!_) continue;
                                    const u = _.elevatedStructures;
                                    if (!u) continue;
                                    let p, f;
                                    if (e1 ? (p = u.renderableBridgeSegments, f = u.bridgeProgramConfigurations.get(o.id)) : (p = u.renderableTunnelSegments, f = u.tunnelProgramConfigurations.get(o.id)), !p || 0 === p.segments[0].primitiveLength) continue;
                                    f.updatePaintBuffers(), t1.prepareDrawTile();
                                    const m = t1.isTileAffectedByFog(d), g = [];
                                    l && g.push("RENDER_SHADOWS", "NORMAL_OFFSET");
                                    const v = t1.getOrCreateProgram("elevatedStructures", {
                                        config: f,
                                        overrideFog: m,
                                        defines: g
                                    }), y = t1.translatePosMatrix(d.projMatrix, r, o.paint.get("fill-translate"), o.paint.get("fill-translate-anchor"));
                                    l && a.setupShadows(r.tileID.toUnwrapped(), v, "vector-tile");
                                    const x = wn(y, h);
                                    t1.uploadCommonUniforms(t1.context, v, d.toUnwrapped()), v.draw(t1, s.TRIANGLES, c, $i.disabled, n, Ki.backCCW, x, o.id, u.vertexBuffer, u.indexBuffer, p, o.paint, t1.transform.zoom, f, [
                                        u.vertexBufferNormal
                                    ]);
                                }
                            };
                            d(!0), d(!1);
                        }(u);
                    }
                } else us(u, !1, p, t1.stencilModeFor3D());
            },
            "fill-extrusion": function(t1, i, o, r) {
                const n = o.paint.get("fill-extrusion-opacity"), s = t1.context, a = s.gl, l = t1.terrain, c = l && l.renderingToTexture;
                if (0 === n) return;
                const h = "mrt-fallback" === t1.emissiveMode, d = t1.conflationActive && t1.style.isLayerClipped(o, i.getSource()), _ = t1.style.order.indexOf(o.fqid);
                if (d && function(e1, t1, i, o, r) {
                    for (const n of o){
                        const o = t1.getTile(n).getBucket(i);
                        o && (o.updateReplacement(n, e1.replacementSource, r), o.uploadCentroid(e1.context));
                    }
                }(t1, i, o, r, _), l || d) for (const e1 of r){
                    const r = i.getTile(e1).getBucket(o);
                    r && vs(t1.context, i, e1, r, o, l, d);
                }
                if ("shadow" === t1.renderPass && t1.shadowRenderer) {
                    if (l && n < .65 && o._transitionablePaint._values["fill-extrusion-opacity"].value.expression instanceof e1.af) return;
                    const s = t1.shadowRenderer.getShadowPassDepthMode();
                    ps(t1, i, o, r, s, $i.disabled, Zi.disabled, d);
                } else if ("translucent" === t1.renderPass) {
                    const _ = !o.paint.get("fill-extrusion-pattern").constantOr(1), u = o.paint.get("fill-extrusion-color").constantOr(e1.aq.white);
                    if (!c && 0 !== u.a) {
                        const e1 = new Hi(t1.context.gl.LEQUAL, Hi.ReadWrite, t1.depthRangeFor3D);
                        1 === n && _ ? ps(t1, i, o, r, e1, $i.disabled, Zi.unblended, d) : (ps(t1, i, o, r, e1, $i.disabled, Zi.disabled, d), ps(t1, i, o, r, e1, t1.stencilModeFor3D(), t1.colorModeForRenderPass(), d), t1.resetStencilClippingMasks());
                    }
                    if (t1.style.enable3dLights() && _ && (!l && "globe" !== t1.transform.projection.name || c)) {
                        const n = o.paint.get("fill-extrusion-opacity"), _ = o.paint.get("fill-extrusion-ambient-occlusion-intensity"), u = o.paint.get("fill-extrusion-ambient-occlusion-ground-radius"), p = o.paint.get("fill-extrusion-flood-light-intensity"), f = "none" === o.paint.get("fill-extrusion-flood-light-color-use-theme").constantOr("default"), m = o.paint.get("fill-extrusion-flood-light-color").toNonPremultipliedRenderColor(f ? null : o.lut).toArray01().slice(0, 3), g = _ > 0 && u > 0, v = p > 0, y = (e1, t1, i)=>(1 - i) * e1 + i * t1, x = new fs;
                        x.translate = o.paint.get("fill-extrusion-translate"), x.translateAnchor = o.paint.get("fill-extrusion-translate-anchor"), x.edgeRadius = o.layout.get("fill-extrusion-edge-radius"), x.cutoffFadeRange = o.paint.get("fill-extrusion-cutoff-fade-range");
                        const b = (s)=>{
                            const l = t1.depthModeForSublayer(1, Hi.ReadOnly, a.LEQUAL, !0), c = o.paint.get(s ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), h = y(.1, 3, c), f = t1._showOverdrawInspector;
                            if (!f) {
                                const c = new $i({
                                    func: a.ALWAYS,
                                    mask: 255
                                }, 255, 255, a.KEEP, a.KEEP, a.REPLACE), f = new Zi([
                                    a.ONE,
                                    a.ONE,
                                    a.ONE,
                                    a.ONE
                                ], e1.aq.transparent, [
                                    !1,
                                    !1,
                                    !1,
                                    !0
                                ], a.MIN);
                                gs(x, t1, i, o, r, l, c, f, Ki.disabled, s, "sdf", n, _, u, p, m, h, d, !1);
                            }
                            {
                                const c = f ? $i.disabled : new $i({
                                    func: a.EQUAL,
                                    mask: 255
                                }, 255, 255, a.KEEP, a.DECR, a.DECR), g = f ? t1.colorModeForRenderPass() : new Zi([
                                    a.ONE_MINUS_DST_ALPHA,
                                    a.DST_ALPHA,
                                    a.ONE,
                                    a.ONE
                                ], e1.aq.transparent, [
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ]);
                                gs(x, t1, i, o, r, l, c, g, Ki.disabled, s, "color", n, _, u, p, m, h, d, !1);
                            }
                        };
                        if (c) {
                            const c = ()=>{
                                const t1 = l.drapeBufferSize[0], i = l.drapeBufferSize[1];
                                let o = l.framebufferCopyTexture;
                                return o && (!o || o.size[0] === t1 && o.size[1] === i) || (o && o.destroy(), o = l.framebufferCopyTexture = new e1.T(s, new e1.q({
                                    width: t1,
                                    height: i
                                }), a.RGBA8)), o.bind(a.LINEAR, a.CLAMP_TO_EDGE), a.copyTexSubImage2D(a.TEXTURE_2D, 0, 0, 0, 0, 0, t1, i), o;
                            }, f = (s, l, f)=>{
                                const g = t1.depthModeForSublayer(1, Hi.ReadOnly, a.LEQUAL, !1), v = o.paint.get(s ? "fill-extrusion-ambient-occlusion-ground-attenuation" : "fill-extrusion-flood-light-ground-attenuation"), b = y(.1, 3, v);
                                {
                                    const c = new Zi([
                                        a.ONE,
                                        a.ONE,
                                        a.ONE,
                                        a.ONE
                                    ], e1.aq.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ]);
                                    gs(x, t1, i, o, r, g, $i.disabled, c, Ki.disabled, s, "clear", n, _, u, p, m, b, d, l);
                                }
                                {
                                    const c = new $i({
                                        func: a.ALWAYS,
                                        mask: 255
                                    }, 255, 255, a.KEEP, a.KEEP, a.REPLACE), h = new Zi([
                                        a.ONE,
                                        a.ONE,
                                        a.ONE,
                                        a.ONE
                                    ], e1.aq.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ], a.MIN);
                                    gs(x, t1, i, o, r, g, c, h, Ki.disabled, s, "sdf", n, _, u, p, m, b, d, l);
                                }
                                h && !s && (f = c());
                                {
                                    const c = s ? a.ZERO : a.ONE_MINUS_DST_ALPHA, h = new $i({
                                        func: a.EQUAL,
                                        mask: 255
                                    }, 255, 255, a.KEEP, a.DECR, a.DECR), f = new Zi([
                                        c,
                                        a.DST_ALPHA,
                                        a.ONE_MINUS_DST_ALPHA,
                                        a.ZERO
                                    ], e1.aq.transparent, [
                                        !0,
                                        !0,
                                        !0,
                                        !0
                                    ]);
                                    gs(x, t1, i, o, r, g, h, f, Ki.disabled, s, "color", n, _, u, p, m, b, d, l);
                                }
                                if (!h || s) {
                                    const c = new Zi([
                                        a.ONE,
                                        a.ONE,
                                        a.ONE,
                                        s ? a.ZERO : a.ONE
                                    ], e1.aq.transparent, [
                                        !1,
                                        !1,
                                        !1,
                                        !0
                                    ], s ? a.FUNC_ADD : a.MAX);
                                    gs(x, t1, i, o, r, g, $i.disabled, c, Ki.disabled, s, "clear", n, _, u, p, m, b, d, l, f);
                                } else {
                                    a.drawBuffers([
                                        a.NONE,
                                        a.COLOR_ATTACHMENT1
                                    ]);
                                    const c = new $i({
                                        func: a.EQUAL,
                                        mask: 255
                                    }, 254, 255, a.KEEP, a.DECR, a.DECR), h = new Zi([
                                        a.ONE,
                                        a.ONE,
                                        a.ONE,
                                        a.ONE
                                    ], e1.aq.transparent, [
                                        !0,
                                        !1,
                                        !1,
                                        !1
                                    ], a.MAX);
                                    gs(x, t1, i, o, r, g, c, h, Ki.disabled, s, "emissive", n, _, u, p, m, b, d, l, f), a.drawBuffers([
                                        a.COLOR_ATTACHMENT0
                                    ]);
                                }
                            };
                            if (g || v) {
                                let e1;
                                t1.prepareDrawTile(), h && !g || (e1 = c()), g && f(!0, !1, e1), v && f(!1, !0, e1);
                            }
                        } else g && b(!0), v && b(!1), (g || v) && t1.resetStencilClippingMasks();
                    }
                }
            },
            building: function(e1, t1, i, o) {
                e1.currentLayer < e1.firstLightBeamLayer && (e1.firstLightBeamLayer = e1.currentLayer);
                const r = i.paint.get("building-ambient-occlusion-ground-intensity"), n = i.paint.get("building-ambient-occlusion-ground-radius"), s = i.paint.get("building-ambient-occlusion-ground-attenuation"), a = i.paint.get("building-opacity");
                if (a <= 0) return;
                let l = r > 0 && n > 0, c = !0;
                const h = i.paint.get("building-vertical-scale");
                if (h <= 0) return;
                e1.shadowRenderer || (c = !1);
                const d = e1.conflationActive && e1.style.isLayerClipped(i, t1.getSource()), _ = e1.style.order.indexOf(i.fqid);
                if (function(e1, t1, i, o, r, n) {
                    for (const s of n){
                        const n = t1.getTile(s).getBucket(i);
                        n && (r && n.updateReplacement(s, e1.replacementSource, o), n.uploadUpdatedIndexBuffer(e1.context));
                    }
                }(e1, t1, i, _, d, o), function(e1, t1, i, o) {
                    for (const r of o){
                        const o = t1.getTile(r).getBucket(i);
                        o && o.needsEvaluation() && o.uploadUpdatedColorBuffer(e1.context);
                    }
                }(e1, t1, i, o), i.resetLayerRenderingStats(e1), e1.shadowRenderer && (e1.shadowRenderer.useNormalOffset = !0), "shadow" === e1.renderPass && e1.shadowRenderer) {
                    const r = [], n = e1.shadowRenderer.getShadowPassDepthMode();
                    Ts({
                        painter: e1,
                        source: t1,
                        layer: i,
                        coords: o,
                        defines: r,
                        blendMode: Zi.disabled,
                        depthMode: n,
                        opacity: a,
                        verticalScale: h,
                        facadeEmissiveChance: 0,
                        facadeAOIntensity: 0,
                        floodLightIntensity: 0,
                        floodLightColor: [
                            0,
                            0,
                            0
                        ]
                    });
                } else if ("translucent" === e1.renderPass) {
                    let _ = [
                        "HAS_ATTRIBUTE_a_part_color_emissive",
                        "LIGHTING_3D_MODE"
                    ];
                    c && (_ = _.concat("RENDER_SHADOWS")), e1.shadowRenderer && e1.shadowRenderer.useNormalOffset && (_ = _.concat("NORMAL_OFFSET"));
                    const u = i.paint.get("building-facade-emissive-chance"), p = i.paint.get("building-ambient-occlusion-intensity"), f = i.paint.get("building-flood-light-intensity"), m = "none" === i.paint.get("building-flood-light-color-use-theme").constantOr("default"), g = i.paint.get("building-flood-light-color").toNonPremultipliedRenderColor(m ? null : i.lut).toArray01().slice(0, 3), v = i.paint.get("building-flood-light-ground-attenuation"), y = f > 0, x = new Hi(e1.context.gl.LEQUAL, Hi.ReadWrite, e1.depthRangeFor3D);
                    a < 1 && Ts({
                        painter: e1,
                        source: t1,
                        layer: i,
                        coords: o,
                        defines: _,
                        blendMode: Zi.disabled,
                        depthMode: x,
                        opacity: a,
                        verticalScale: h,
                        facadeEmissiveChance: u,
                        facadeAOIntensity: p,
                        floodLightIntensity: f,
                        floodLightColor: g,
                        depthOnly: !0
                    });
                    const b = e1.colorModeForRenderPass();
                    Ts({
                        painter: e1,
                        source: t1,
                        layer: i,
                        coords: o,
                        defines: _,
                        blendMode: b,
                        depthMode: x,
                        opacity: a,
                        verticalScale: h,
                        facadeEmissiveChance: u,
                        facadeAOIntensity: p,
                        floodLightIntensity: f,
                        floodLightColor: g
                    });
                    const w = i.paint.get("building-front-cutoff");
                    ms(e1.transform.pitch, w, !!e1.terrain), l && Es(e1, t1, i, o, !0, a, r, n, f, g, s, d), y && Es(e1, t1, i, o, !1, a, r, n, f, g, v, d);
                } else if ("light-beam" === e1.renderPass) {
                    const r = [
                        "HAS_ATTRIBUTE_a_part_color_emissive",
                        "HAS_ATTRIBUTE_a_bloom_attenuation"
                    ], n = new Hi(e1.context.gl.LEQUAL, Hi.ReadOnly, e1.depthRangeFor3D);
                    Ts({
                        painter: e1,
                        source: t1,
                        layer: i,
                        coords: o,
                        defines: r,
                        blendMode: Zi.alphaBlended,
                        depthMode: n,
                        opacity: a,
                        verticalScale: h,
                        facadeEmissiveChance: 0,
                        facadeAOIntensity: 0,
                        floodLightIntensity: 0,
                        floodLightColor: [
                            0,
                            0,
                            0
                        ]
                    });
                }
                e1.shadowRenderer && (e1.shadowRenderer.useNormalOffset = !1), e1.resetStencilClippingMasks();
            },
            hillshade: function(e1, t1, i, o) {
                if ("offscreen" !== e1.renderPass && "translucent" !== e1.renderPass) return;
                if (e1.style.disableElevatedTerrain) return;
                const r = e1.context, n = e1.terrain && e1.terrain.renderingToTexture, [s, a] = "translucent" !== e1.renderPass || n ? [
                    {},
                    o
                ] : e1.stencilConfigForOverlap(o);
                for (const o of a){
                    const r = t1.getTile(o);
                    if (r.needsHillshadePrepare && "offscreen" === e1.renderPass) lr(e1, r, i);
                    else if ("translucent" === e1.renderPass) {
                        const t1 = e1.depthModeForSublayer(0, Hi.ReadOnly), a = i.paint.get("hillshade-emissive-strength"), l = e1.colorModeForDrapableLayerRenderPass(a), c = n && e1.terrain ? e1.terrain.stencilModeForRTTOverlap(o) : s[o.overscaledZ];
                        sr(e1, o, r, i, t1, c, l);
                    }
                }
                r.viewport.set([
                    0,
                    0,
                    e1.width,
                    e1.height
                ]), e1.resetStencilClippingMasks();
            },
            raster: function(t1, i, o, r, n, s) {
                if ("translucent" !== t1.renderPass) return;
                const a = o.paint.get("raster-opacity");
                if (0 === a) return;
                const l = "globe" === t1.transform.projection.name, c = 0 !== o.paint.get("raster-elevation"), h = c && l, d = t1.terrain && t1.terrain.exaggeration() > 0 && c && "ground" === o.paint.get("raster-elevation-reference"), _ = !l && d;
                if (t1.renderElevatedRasterBackface && !h) return;
                const u = t1.context, p = u.gl, f = i.getSource(), m = function(t1, i, o, r, n) {
                    const s = i.paint.get("raster-color"), a = "raster-array" === t1.type, l = [], c = i.paint.get("raster-resampling"), h = i.paint.get("raster-color-mix");
                    let d = i.paint.get("raster-color-range");
                    const _ = [
                        h[0],
                        h[1],
                        h[2],
                        0
                    ], u = h[3];
                    let p = "nearest" === c ? r.NEAREST : r.LINEAR;
                    if (a && (l.push("RASTER_ARRAY"), s || l.push("RASTER_COLOR"), "linear" === c && l.push("RASTER_ARRAY_LINEAR"), p = r.NEAREST, !d && t1.rasterLayers)) {
                        const e1 = t1.rasterLayers.find(({ id: e1 })=>e1 === i.sourceLayer);
                        e1 && e1.fields && e1.fields.range && (d = e1.fields.range);
                    }
                    if (d = d || [
                        0,
                        1
                    ], s) {
                        l.push("RASTER_COLOR"), o.activeTexture.set(r.TEXTURE2), i.updateColorRamp(d);
                        let t1 = i.colorRampTexture;
                        t1 || (t1 = i.colorRampTexture = new e1.T(o, i.colorRamp, r.RGBA8)), t1.bind(p, r.CLAMP_TO_EDGE);
                    }
                    return n && l.push("USE_MRT1"), {
                        mix: _,
                        range: d,
                        offset: u,
                        defines: l,
                        resampling: p
                    };
                }(f, o, u, p, t1.terrain && t1.terrain.renderingToTexture && "mrt-fallback" === t1.emissiveMode);
                if (f instanceof e1.aW && !r.length && !l) return;
                const g = o.paint.get("raster-emissive-strength"), v = t1.colorModeForDrapableLayerRenderPass(g), y = t1.terrain && t1.terrain.renderingToTexture, x = !t1.options.moving, b = "nearest" === o.paint.get("raster-resampling") ? p.NEAREST : p.LINEAR;
                if (f instanceof e1.aW && !r.length && (f.onNorthPole || f.onSouthPole)) {
                    const e1 = c ? t1.stencilModeFor3D() : $i.disabled;
                    return void Cs(!!f.onNorthPole, null, t1, i, o, g, m, Ki.disabled, e1);
                }
                if (!r.length) return;
                const [w, T] = f instanceof e1.aW || y ? [
                    {},
                    r
                ] : t1.stencilConfigForOverlap(r), E = T[T.length - 1].overscaledZ;
                h && m.defines.push("PROJECTION_GLOBE_VIEW"), c && m.defines.push("RENDER_CUTOFF", "ELEVATED"), d && m.defines.push("ELEVATION_REFERENCE_GROUND");
                const S = (r, n, T)=>{
                    for (const S of r){
                        const r = S.toUnwrapped(), C = i.getTile(S);
                        if (y && (!C || !C.hasData())) continue;
                        u.activeTexture.set(p.TEXTURE0);
                        const I = Rs(C, f, o, m);
                        if (!I || !I.texture) continue;
                        const { texture: R, mix: D, offset: A, tileSize: L, buffer: P } = I;
                        let O, M;
                        y ? (O = Hi.disabled, M = S.projMatrix) : c ? (O = new Hi(p.LEQUAL, Hi.ReadWrite, t1.depthRangeFor3D), M = l ? Float32Array.from(t1.transform.expandedFarZProjMatrix) : t1.transform.calculateProjMatrix(r, x)) : (O = t1.depthModeForSublayer(S.overscaledZ - E, 1 === a ? Hi.ReadWrite : Hi.ReadOnly, p.LESS), M = t1.transform.calculateProjMatrix(r, x));
                        const z = t1.terrain && y ? t1.terrain.stencilModeForRTTOverlap(S) : w[S.overscaledZ], F = s ? 0 : o.paint.get("raster-fade-duration");
                        C.registerFadeDuration(F);
                        const B = i.findLoadedParent(S, 0), k = tn(C, B, i, t1.transform, F);
                        let N, U;
                        !k.isFading && C.refreshedUponExpiration && (C.refreshedUponExpiration = !1), t1.terrain && t1.terrain.prepareDrawTile(), u.activeTexture.set(p.TEXTURE0), R.bind(b, p.CLAMP_TO_EDGE), u.activeTexture.set(p.TEXTURE1), B ? (B.texture && B.texture.bind(b, p.CLAMP_TO_EDGE), N = Math.pow(2, B.tileID.overscaledZ - C.tileID.overscaledZ), U = [
                            C.tileID.canonical.x * N % 1,
                            C.tileID.canonical.y * N % 1
                        ]) : R.bind(b, p.CLAMP_TO_EDGE), "useMipmap" in R && u.extTextureFilterAnisotropic && t1.transform.pitch > 20 && p.texParameterf(p.TEXTURE_2D, u.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, u.extTextureFilterAnisotropicMax);
                        const V = t1.transform;
                        let j;
                        const G = c ? Is(V) : [
                            0,
                            0,
                            0,
                            0
                        ];
                        let q, Z, H, W, $, X = 0;
                        if (h && f instanceof e1.aW && f.coordinates.length > 3) q = Float32Array.from(e1.dq(e1.dr(new e1.ci(0, 0, 0)))), Z = Float32Array.from(V.globeMatrix), H = Float32Array.from(e1.dl(V)), W = [
                            e1.aH(V.center.lng),
                            e1.aL(V.center.lat)
                        ], j = f.elevatedGlobePerspectiveTransform, $ = f.elevatedGlobeGridMatrix || new Float32Array(9);
                        else if (h) {
                            const t1 = e1.dm(S.canonical);
                            X = e1.dn(t1.getCenter().lat), q = Float32Array.from(e1.dq(e1.dr(S.canonical))), Z = Float32Array.from(V.globeMatrix), H = Float32Array.from(e1.dl(V)), W = [
                                e1.aH(V.center.lng),
                                e1.aL(V.center.lat)
                            ], j = [
                                0,
                                0
                            ], $ = Float32Array.from(e1.dp(S.canonical, t1, X, V.worldSize / V._pixelsPerMercatorPixel));
                        } else j = f instanceof e1.aW ? f.perspectiveTransform : [
                            0,
                            0
                        ], q = new Float32Array(16), Z = new Float32Array(9), H = new Float32Array(16), W = [
                            0,
                            0
                        ], $ = new Float32Array(9);
                        const Y = Fn(t1, M, q, Z, H, $, U || [
                            0,
                            0
                        ], e1.al(t1.transform.zoom), W, G, N || 1, k, o, j, c ? o.paint.get("raster-elevation") : 0, 2, D, A, m.range, L, P, g), K = t1.isTileAffectedByFog(S), Q = t1.getOrCreateProgram("raster", {
                            defines: m.defines,
                            overrideFog: K
                        });
                        if (t1.uploadCommonUniforms(u, Q, r), f instanceof e1.aW) {
                            const i = f.elevatedGlobeVertexBuffer, r = f.elevatedGlobeIndexBuffer;
                            if (y || !l) f.boundsBuffer && f.boundsSegments && Q.draw(t1, p.TRIANGLES, O, $i.disabled, v, Ki.disabled, Y, o.id, f.boundsBuffer, t1.quadTriangleIndexBuffer, f.boundsSegments);
                            else if (i && r) {
                                const s = V.zoom <= e1.cF ? f.elevatedGlobeSegments : f.getSegmentsForLongitude(V.center.lng);
                                s && Q.draw(t1, p.TRIANGLES, O, $i.disabled, v, n, Y, o.id, i, r, s);
                            }
                        } else if (h) {
                            O = new Hi(p.LEQUAL, Hi.ReadOnly, t1.depthRangeFor3D);
                            const e1 = t1.globeSharedBuffers;
                            if (e1) {
                                d && (t1.terrain.setupElevationDraw(C, Q), t1.uploadCommonUniforms(u, Q, C.tileID.toUnwrapped()));
                                const [i, r, s] = e1.getGridBuffers(X, !1), a = Q.getAttributeLocation(p, "a_texture_pos");
                                -1 !== a && p.vertexAttribI4ui(a, 0, 0, 0, 0), Q.draw(t1, p.TRIANGLES, O, T || z, t1.colorModeForRenderPass(), n, Y, o.id, i, r, s);
                            }
                        } else if (_) O = new Hi(p.LEQUAL, Hi.ReadWrite, t1.depthRangeFor3D), t1.terrain.setupElevationDraw(C, Q), t1.uploadCommonUniforms(u, Q, C.tileID.toUnwrapped()), V.pitch > 20 && Q.draw(t1, p.TRIANGLES, O, $i.disabled, Zi.disabled, Ki.frontCCW, Y, o.id, t1.terrain.gridBuffer, t1.terrain.gridIndexBuffer, t1.terrain.gridSegments), Q.draw(t1, p.TRIANGLES, O, z, v, Ki.backCCW, Y, o.id, t1.terrain.gridBuffer, t1.terrain.gridIndexBuffer, t1.terrain.gridSegments);
                        else {
                            const { tileBoundsBuffer: e1, tileBoundsIndexBuffer: i, tileBoundsSegments: r } = t1.getTileBoundsBuffers(C);
                            Q.draw(t1, p.TRIANGLES, O, z, v, Ki.disabled, Y, o.id, e1, i, r);
                        }
                    }
                    if (!(f instanceof e1.aW) && h) for (const e1 of r){
                        const r = e1.canonical.y === (1 << e1.canonical.z) - 1;
                        0 === e1.canonical.y && Cs(!0, e1, t1, i, o, g, m, n, T || $i.disabled), r && Cs(!1, e1, t1, i, o, g, m, n === Ki.frontCW ? Ki.backCW : Ki.frontCW, T || $i.disabled);
                    }
                };
                h ? S(T, t1.renderElevatedRasterBackface ? Ki.backCW : Ki.frontCW, t1.stencilModeFor3D()) : S(T, Ki.disabled, void 0), t1.resetStencilClippingMasks();
            },
            "raster-particle": function(t1, i, o, r, n, s) {
                "offscreen" === t1.renderPass && function(t1, i, o, r) {
                    if (!r.length) return;
                    const n = t1.context, s = n.gl, a = i.getSource();
                    if (!(a instanceof Tt)) return;
                    const l = Math.ceil(Math.sqrt(o.paint.get("raster-particle-count")));
                    let c = o.particlePositionRGBAImage;
                    if (!c || c.width !== l) {
                        const t1 = function(t1) {
                            const i = t1 * t1, o = new Uint8Array(4 * i), r = .9090909090909091;
                            for(let t1 = 0; t1 < i; t1++){
                                const i = r * (e1.e7(2 * t1 + 0) + kn), n = r * (e1.e7(2 * t1 + 1) + kn), s = 255 * i % 1, a = 255 * n % 1, l = s, c = n - a / 255, h = a;
                                o[4 * t1 + 0] = 255 * (i - s / 255), o[4 * t1 + 1] = 255 * l, o[4 * t1 + 2] = 255 * c, o[4 * t1 + 3] = 255 * h;
                            }
                            return o;
                        }(l);
                        c = o.particlePositionRGBAImage = new e1.q({
                            width: l,
                            height: l
                        }, t1);
                    }
                    let h = o.particleFramebuffer;
                    h ? h.width !== l && (h.destroy(), h = o.particleFramebuffer = n.createFramebuffer(l, l, 1, null)) : h = o.particleFramebuffer = n.createFramebuffer(l, l, 1, null);
                    const d = [];
                    for (const e1 of r){
                        const t1 = i.getTile(e1);
                        if (!(t1 instanceof Pt)) continue;
                        const r = Ls(t1, a, o);
                        if (!r) continue;
                        const s = [
                            t1.tileSize,
                            t1.tileSize
                        ];
                        let h = o.tileFramebuffer;
                        h || (h = o.tileFramebuffer = n.createFramebuffer(s[0], s[1], 1, null));
                        let _ = t1.rasterParticleState;
                        _ || (_ = t1.rasterParticleState = new As(n, e1, s, c));
                        const u = _.update(o.lastInvalidatedAt);
                        _.particleTextureDimension !== l && _.updateParticleTexture(e1, c);
                        const p = _.targetColorTexture;
                        _.targetColorTexture = _.backgroundColorTexture, _.backgroundColorTexture = p;
                        const f = _.particleTexture0;
                        _.particleTexture0 = _.particleTexture1, _.particleTexture1 = f, d.push([
                            e1,
                            r,
                            _,
                            u
                        ]);
                    }
                    if (0 === d.length) return;
                    const _ = e1.o.now(), u = o.previousDrawTimestamp ? .001 * (_ - o.previousDrawTimestamp) : .0167;
                    if (o.previousDrawTimestamp = _, o.hasColorMap()) {
                        n.activeTexture.set(s.TEXTURE0 + 2);
                        let t1 = o.colorRampTexture;
                        t1 || (t1 = o.colorRampTexture = new e1.T(n, o.colorRamp, s.RGBA8)), t1.bind(s.LINEAR, s.CLAMP_TO_EDGE);
                    }
                    n.bindFramebuffer.set(o.tileFramebuffer.framebuffer), function(t1, i, o) {
                        const r = t1.context, n = r.gl, s = i.tileFramebuffer;
                        r.activeTexture.set(n.TEXTURE0);
                        const a = {
                            u_texture: 0,
                            u_opacity: 1.05 * (c = i.paint.get("raster-particle-fade-opacity-factor")) / (c + .05)
                        }, l = t1.getOrCreateProgram("rasterParticleTexture", {
                            defines: [],
                            overrideFog: !1
                        });
                        var c;
                        for (const c of o){
                            const [, , o, h] = c;
                            s.colorAttachment0.set(o.targetColorTexture.texture), r.viewport.set([
                                0,
                                0,
                                s.width,
                                s.height
                            ]), r.clear({
                                color: e1.aq.transparent
                            }), h && (o.backgroundColorTexture.bind(n.NEAREST, n.CLAMP_TO_EDGE), l.draw(t1, n.TRIANGLES, Hi.disabled, $i.disabled, Zi.alphaBlended, Ki.disabled, a, i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments));
                        }
                    }(t1, o, d), function(t1, i, o, r) {
                        const n = t1.context, s = n.gl, a = o.tileFramebuffer, l = "globe" === t1.transform.projection.name, c = o.paint.get("raster-particle-max-speed");
                        for (const h of r){
                            const [r, d, _] = h;
                            n.activeTexture.set(s.TEXTURE0 + 0), d.texture.bind(s.LINEAR, s.CLAMP_TO_EDGE), a.colorAttachment0.set(_.targetColorTexture.texture);
                            const u = t1.getOrCreateProgram("rasterParticleDraw", {
                                defines: d.defines,
                                overrideFog: !1
                            });
                            n.activeTexture.set(s.TEXTURE0 + 1);
                            const p = d.scalarData ? [] : [
                                0,
                                1,
                                2,
                                3
                            ].map((t1)=>e1.dX[t1](r));
                            p.push(r);
                            const f = r.canonical.x, m = r.canonical.y;
                            for (const e1 of p){
                                const n = i.getTile(l ? e1.wrapped() : e1);
                                if (!n) continue;
                                const a = n.rasterParticleState;
                                if (!a) continue;
                                const h = e1.canonical.x + (1 << e1.canonical.z) * (e1.wrap - r.wrap), _ = e1.canonical.y;
                                a.particleTexture0.bind(s.NEAREST, s.CLAMP_TO_EDGE);
                                const p = Un(1, a.particleTexture0.size[0], [
                                    h - f,
                                    _ - m
                                ], 0, d.texture.size, 2, c, d.textureOffset, d.scale, d.offset);
                                u.draw(t1, s.POINTS, Hi.disabled, $i.disabled, Zi.alphaBlended, Ki.disabled, p, o.id, a.particleIndexBuffer, void 0, a.particleSegment);
                            }
                        }
                    }(t1, i, o, d), n.bindFramebuffer.set(o.particleFramebuffer.framebuffer), function(t1, i, o, r) {
                        const n = t1.context, s = n.gl, a = i.paint.get("raster-particle-max-speed"), l = r * i.paint.get("raster-particle-speed-factor") * .15, c = function(e1) {
                            return Math.pow(e1, 6);
                        }(.01 + 1 * i.paint.get("raster-particle-reset-rate-factor")), h = i.particleFramebuffer;
                        n.viewport.set([
                            0,
                            0,
                            h.width,
                            h.height
                        ]);
                        for (const r of o){
                            const [, o, d] = r;
                            n.activeTexture.set(s.TEXTURE0 + 0), o.texture.bind(s.LINEAR, s.CLAMP_TO_EDGE), n.activeTexture.set(s.TEXTURE0 + 1);
                            const _ = d.particleTexture0;
                            _.bind(s.NEAREST, s.CLAMP_TO_EDGE);
                            const u = Vn(1, _.size[0], 0, o.texture.size, a, l, c, o.textureOffset, o.scale, o.offset);
                            h.colorAttachment0.set(d.particleTexture1.texture), n.clear({
                                color: e1.aq.transparent
                            }), t1.getOrCreateProgram("rasterParticleUpdate", {
                                defines: o.defines
                            }).draw(t1, s.TRIANGLES, Hi.disabled, $i.disabled, Zi.unblended, Ki.disabled, u, i.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments);
                        }
                    }(t1, o, d, u);
                }(t1, i, o, r), "translucent" === t1.renderPass && (function(t1, i, o, r) {
                    const n = t1.context, s = n.gl, a = i.getSource().tileSize, l = 5 * (1 - e1.aj(e1.cq, e1.cq + 1, t1.transform.zoom)) * a + o.paint.get("raster-particle-elevation"), c = !t1.options.moving, h = "globe" === t1.transform.projection.name;
                    if (!r.length) return;
                    const [d, _] = t1.stencilConfigForOverlap(r), u = [];
                    h && u.push("PROJECTION_GLOBE_VIEW");
                    const p = t1.stencilModeFor3D();
                    for (const r of _){
                        const a = r.toUnwrapped(), _ = i.getTile(r);
                        if (!_.rasterParticleState) continue;
                        const f = _.rasterParticleState, m = 100;
                        _.registerFadeDuration(m);
                        const g = i.findLoadedParent(r, 0), v = tn(_, g, i, t1.transform, m);
                        let y, x;
                        t1.terrain && t1.terrain.prepareDrawTile(), n.activeTexture.set(s.TEXTURE0), f.targetColorTexture.bind(s.LINEAR, s.CLAMP_TO_EDGE), n.activeTexture.set(s.TEXTURE1), g && g.rasterParticleState ? (g.rasterParticleState.targetColorTexture.bind(s.LINEAR, s.CLAMP_TO_EDGE), y = Math.pow(2, g.tileID.overscaledZ - _.tileID.overscaledZ), x = [
                            _.tileID.canonical.x * y % 1,
                            _.tileID.canonical.y * y % 1
                        ]) : f.targetColorTexture.bind(s.LINEAR, s.CLAMP_TO_EDGE);
                        const b = h ? Float32Array.from(t1.transform.expandedFarZProjMatrix) : t1.transform.calculateProjMatrix(a, c), w = t1.transform, T = Ps(w), E = e1.dm(r.canonical), S = e1.dn(E.getCenter().lat);
                        let C, I, R, D, A;
                        h ? (C = Float32Array.from(e1.dq(e1.dr(r.canonical))), I = Float32Array.from(w.globeMatrix), R = Float32Array.from(e1.dl(w)), D = [
                            e1.aH(w.center.lng),
                            e1.aL(w.center.lat)
                        ], A = Float32Array.from(e1.dp(r.canonical, E, S, w.worldSize / w._pixelsPerMercatorPixel))) : (C = new Float32Array(16), I = new Float32Array(9), R = new Float32Array(16), D = [
                            0,
                            0
                        ], A = new Float32Array(9));
                        const L = Nn(b, C, I, R, A, x || [
                            0,
                            0
                        ], e1.al(t1.transform.zoom), D, T, y || 1, v, l), P = t1.isTileAffectedByFog(r), O = t1.getOrCreateProgram("rasterParticle", {
                            defines: u,
                            overrideFog: P
                        });
                        if (t1.uploadCommonUniforms(n, O, a), h) {
                            const e1 = new Hi(s.LEQUAL, Hi.ReadOnly, t1.depthRangeFor3D), i = 0, r = t1.globeSharedBuffers;
                            if (r) {
                                const [n, a, l] = r.getGridBuffers(S, 0 !== i);
                                O.draw(t1, s.TRIANGLES, e1, p, Zi.alphaBlended, t1.renderElevatedRasterBackface ? Ki.frontCCW : Ki.backCCW, L, o.id, n, a, l);
                            }
                        } else {
                            const e1 = t1.depthModeForSublayer(0, Hi.ReadOnly), i = d[r.overscaledZ], { tileBoundsBuffer: n, tileBoundsIndexBuffer: a, tileBoundsSegments: l } = t1.getTileBoundsBuffers(_);
                            O.draw(t1, s.TRIANGLES, e1, i, Zi.alphaBlended, Ki.disabled, L, o.id, n, a, l);
                        }
                    }
                    t1.resetStencilClippingMasks();
                }(t1, i, o, r), t1.style.map.triggerRepaint());
            },
            background: function(t1, i, o, r) {
                const n = o.paint.get("background-color"), s = "none" === o.paint.get("background-color-use-theme").constantOr("default"), a = o.paint.get("background-opacity"), l = o.paint.get("background-emissive-strength"), c = "viewport" === o.paint.get("background-pitch-alignment");
                if (0 === a) return;
                const h = t1.context, d = h.gl, _ = t1.transform, u = _.tileSize, p = o.paint.get("background-pattern");
                let f;
                if (void 0 !== p) {
                    if (null === p) return;
                    if (f = t1.imageManager.getPattern(e1.I.from(p.toString()), o.scope, t1.style.getLut(o.scope)), !f) return;
                }
                const m = !p && 1 === n.a && 1 === a && t1.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                if (t1.renderPass !== m) return;
                const g = $i.disabled, v = t1.depthModeForSublayer(0, "opaque" === m ? Hi.ReadWrite : Hi.ReadOnly), y = t1.colorModeForDrapableLayerRenderPass(l), x = p ? "backgroundPattern" : "background";
                let b, w = r;
                w || (b = t1.getBackgroundTiles(), w = Object.values(b).map((e1)=>e1.tileID)), p && (h.activeTexture.set(d.TEXTURE0), t1.imageManager.bind(t1.context, o.scope));
                const T = [];
                if (t1.terrain && t1.terrain.renderingToTexture && "mrt-fallback" === t1.emissiveMode && T.push("USE_MRT1"), c) {
                    const i = t1.getOrCreateProgram(x, {
                        overrideFog: !1,
                        overrideRtt: !0,
                        defines: T
                    }), r = new Float32Array(e1.ba([])), h = new e1.aS(0, 0, 0, 0, 0), _ = p ? Zn(r, l, a, t1, 0, o.scope, f, c, {
                        tileID: h,
                        tileSize: u
                    }) : qn(r, l, a, n.toPremultipliedRenderColor(s ? null : o.lut));
                    return void i.draw(t1, d.TRIANGLES, v, g, y, Ki.disabled, _, o.id, t1.viewportBuffer, t1.quadTriangleIndexBuffer, t1.viewportSegments);
                }
                for (const m of w){
                    const w = t1.isTileAffectedByFog(m), E = t1.getOrCreateProgram(x, {
                        overrideFog: w,
                        defines: T
                    }), S = m.toUnwrapped(), C = r ? m.projMatrix : t1.transform.calculateProjMatrix(S);
                    t1.prepareDrawTile();
                    const I = i ? i.getTile(m) : b ? b[m.key] : new e1.b1(m, u, _.zoom, t1), R = p ? Zn(C, l, a, t1, 0, o.scope, f, c, {
                        tileID: m,
                        tileSize: u
                    }) : qn(C, l, a, n.toPremultipliedRenderColor(s ? null : o.lut));
                    t1.uploadCommonUniforms(h, E, S);
                    const { tileBoundsBuffer: D, tileBoundsIndexBuffer: A, tileBoundsSegments: L } = t1.getTileBoundsBuffers(I);
                    E.draw(t1, d.TRIANGLES, v, g, y, Ki.disabled, R, o.id, D, A, L);
                }
            },
            sky: function(t1, i, o) {
                const r = t1._atmosphere ? e1.al(t1.transform.zoom) : 1, n = o.paint.get("sky-opacity") * r;
                if (0 === n) return;
                const s = t1.context, a = o.paint.get("sky-type"), l = new Hi(s.gl.LEQUAL, Hi.ReadOnly, [
                    0,
                    1
                ]), c = t1.frameCounter / 1e3 % 1;
                "atmosphere" === a ? "offscreen" === t1.renderPass ? o.needsSkyboxCapture(t1) && (function(t1, i) {
                    const o = t1.context, r = o.gl;
                    let n = i.skyboxFbo;
                    if (!n) {
                        n = i.skyboxFbo = o.createFramebuffer(32, 32, 1, null), i.skyboxGeometry = new Hs(o), i.skyboxTexture = o.gl.createTexture(), r.bindTexture(r.TEXTURE_CUBE_MAP, i.skyboxTexture), r.texParameteri(r.TEXTURE_CUBE_MAP, r.TEXTURE_WRAP_S, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_CUBE_MAP, r.TEXTURE_WRAP_T, r.CLAMP_TO_EDGE), r.texParameteri(r.TEXTURE_CUBE_MAP, r.TEXTURE_MIN_FILTER, r.LINEAR), r.texParameteri(r.TEXTURE_CUBE_MAP, r.TEXTURE_MAG_FILTER, r.LINEAR);
                        for(let e1 = 0; e1 < 6; ++e1)r.texImage2D(r.TEXTURE_CUBE_MAP_POSITIVE_X + e1, 0, r.RGBA, 32, 32, 0, r.RGBA, r.UNSIGNED_BYTE, null);
                    }
                    o.bindFramebuffer.set(n.framebuffer), o.viewport.set([
                        0,
                        0,
                        32,
                        32
                    ]);
                    const s = i.getCenter(t1, !0), a = t1.getOrCreateProgram("skyboxCapture"), l = new Float64Array(16);
                    e1.ba(l), e1.eb(l, l, .5 * -Math.PI), Ws(t1, i, a, l, s, 0), e1.ba(l), e1.eb(l, l, .5 * Math.PI), Ws(t1, i, a, l, s, 1), e1.ba(l), e1.cz(l, l, .5 * -Math.PI), Ws(t1, i, a, l, s, 2), e1.ba(l), e1.cz(l, l, .5 * Math.PI), Ws(t1, i, a, l, s, 3), e1.ba(l), Ws(t1, i, a, l, s, 4), e1.ba(l), e1.eb(l, l, Math.PI), Ws(t1, i, a, l, s, 5), o.viewport.set([
                        0,
                        0,
                        t1.width,
                        t1.height
                    ]);
                }(t1, o), o.markSkyboxValid(t1)) : "sky" === t1.renderPass && function(e1, t1, i, o, r) {
                    const n = e1.context, s = n.gl, a = e1.transform, l = e1.getOrCreateProgram("skybox");
                    n.activeTexture.set(s.TEXTURE0), s.bindTexture(s.TEXTURE_CUBE_MAP, t1.skyboxTexture);
                    const c = ((e1, t1, i, o, r)=>({
                            u_matrix: e1,
                            u_sun_direction: t1,
                            u_cubemap: 0,
                            u_opacity: o,
                            u_temporal_offset: r
                        }))(a.skyboxMatrix, t1.getCenter(e1, !1), 0, o, r);
                    e1.uploadCommonUniforms(n, l), l.draw(e1, s.TRIANGLES, i, $i.disabled, e1.colorModeForRenderPass(), Ki.backCW, c, "skybox", t1.skyboxGeometry.vertexBuffer, t1.skyboxGeometry.indexBuffer, t1.skyboxGeometry.segment);
                }(t1, o, l, n, c) : "gradient" === a && "sky" === t1.renderPass && function(t1, i, o, r, n) {
                    const s = t1.context, a = s.gl, l = t1.transform, c = t1.getOrCreateProgram("skyboxGradient");
                    i.skyboxGeometry || (i.skyboxGeometry = new Hs(s)), s.activeTexture.set(a.TEXTURE0);
                    let h = i.colorRampTexture;
                    h || (h = i.colorRampTexture = new e1.T(s, i.colorRamp, a.RGBA8)), h.bind(a.LINEAR, a.CLAMP_TO_EDGE);
                    const d = ((t1, i, o, r, n)=>({
                            u_matrix: t1,
                            u_color_ramp: 0,
                            u_center_direction: i,
                            u_radius: e1.ap(o),
                            u_opacity: r,
                            u_temporal_offset: n
                        }))(l.skyboxMatrix, i.getCenter(t1, !1), i.paint.get("sky-gradient-radius"), r, n);
                    t1.uploadCommonUniforms(s, c), c.draw(t1, a.TRIANGLES, o, $i.disabled, t1.colorModeForRenderPass(), Ki.backCW, d, "skyboxGradient", i.skyboxGeometry.vertexBuffer, i.skyboxGeometry.indexBuffer, i.skyboxGeometry.segment);
                }(t1, o, l, n, c);
            },
            custom: function(t1, i, o, r) {
                const n = t1.context, s = o.implementation;
                if (!t1.transform.projection.unsupportedLayers || !t1.transform.projection.unsupportedLayers.includes("custom") || t1.terrain && (t1.terrain.renderingToTexture || "offscreen" === t1.renderPass) && o.isDraped(i)) {
                    if ("offscreen" === t1.renderPass) {
                        const i = s.prerender;
                        if (i) {
                            if (t1.setCustomLayerDefaults(), n.setColorMode(t1.colorModeForRenderPass()), "globe" === t1.transform.projection.name) {
                                const o = t1.transform.pointMerc;
                                i.call(s, n.gl, t1.transform.customLayerMatrix(), t1.transform.getProjection(), t1.transform.globeToMercatorMatrix(), e1.al(t1.transform.zoom), [
                                    o.x,
                                    o.y
                                ], t1.transform.pixelsPerMeterRatio);
                            } else i.call(s, n.gl, t1.transform.customLayerMatrix());
                            n.setDirty(), t1.setBaseState();
                        }
                    } else if ("translucent" === t1.renderPass) {
                        if (t1.terrain && t1.terrain.renderingToTexture) {
                            const e1 = s.renderToTile;
                            if (e1) {
                                const i = r[0].canonical, o = {
                                    x: i.x + r[0].wrap * (s.wrapTileId ? 0 : 1 << i.z),
                                    y: i.y,
                                    z: i.z
                                };
                                n.setDepthMode(Hi.disabled), n.setStencilMode($i.disabled), n.setColorMode(t1.colorModeForRenderPass()), t1.setCustomLayerDefaults(), e1.call(s, n.gl, o), n.setDirty(), t1.setBaseState();
                            }
                            return;
                        }
                        t1.setCustomLayerDefaults(), n.setColorMode(t1.colorModeForRenderPass()), n.setStencilMode($i.disabled);
                        const i = "3d" === s.renderingMode ? new Hi(t1.context.gl.LEQUAL, Hi.ReadWrite, t1.depthRangeFor3D) : t1.depthModeForSublayer(0, Hi.ReadOnly);
                        if (n.setDepthMode(i), "globe" === t1.transform.projection.name) {
                            const i = t1.transform.pointMerc;
                            s.render(n.gl, t1.transform.customLayerMatrix(), t1.transform.getProjection(), t1.transform.globeToMercatorMatrix(), e1.al(t1.transform.zoom), [
                                i.x,
                                i.y
                            ], t1.transform.pixelsPerMeterRatio);
                        } else s.render(n.gl, t1.transform.customLayerMatrix());
                        n.setDirty(), t1.setBaseState(), n.bindFramebuffer.set(null);
                    }
                } else e1.w("Custom layers are not yet supported with this projection. Use mercator or globe to enable usage of custom layers.");
            },
            model: function(t1, i, o, r) {
                if ("opaque" === t1.renderPass) return;
                const n = o.paint.get("model-opacity").constantOr(1), s = o.paint.get("model-elevation-reference"), a = "ground" === s, l = "ground" === s;
                if (0 === n) return;
                const c = o.paint.get("model-cast-shadows");
                if ("shadow" === t1.renderPass) {
                    if (!c) return;
                    if (t1.terrain && n < .65 && o._transitionablePaint._values["model-opacity"].value.expression instanceof e1.af) return;
                }
                const h = t1.shadowRenderer, d = o.paint.get("model-receive-shadows");
                h && (h.useNormalOffset = !0, d || (h.enabled = !1));
                const _ = ()=>{
                    h && (h.useNormalOffset = !0, d || (h.enabled = !0));
                }, u = i.getSource();
                if ("light-beam" === t1.renderPass && "batched-model" !== u.type) return;
                if ("vector" === u.type || "geojson" === u.type) return function(t1, i, o, r, n) {
                    const s = t1.transform, a = "globe" === s.projection.name, l = s.getFreeCameraOptions().position;
                    if (!t1.modelManager) return;
                    const c = t1.modelManager;
                    o.modelManager = c;
                    const h = t1.shadowRenderer;
                    if (!o._unevaluatedLayout._values.hasOwnProperty("model-id")) return;
                    const d = o._unevaluatedLayout._values["model-id"], _ = Object.assign({}, o.layout.get("model-id").parameters), u = t1.style.order.indexOf(o.fqid), p = o.paint.get("model-opacity").constantOr(1);
                    for (const f of r){
                        const r = i.getTile(f).getBucket(o);
                        if (!r || r.projection.name !== s.projection.name) continue;
                        const m = r.getModelUris();
                        if (m && !r.modelsRequested && (c.addModelsFromBucket(m, n), r.modelsRequested = !0), a) _.zoom = f.overscaledZ;
                        else {
                            const e1 = _a(f, s);
                            _.zoom = e1;
                        }
                        const g = d.possiblyEvaluate(_);
                        if (ha(t1, r, f), da.shadowUniformsInitialized = !1, da.useSingleShadowCascade = !!h && 0 === h.getMaxCascadeForTile(f.toUnwrapped()), "shadow" === t1.renderPass && h) {
                            if (1 === t1.currentShadowCascade && r.isInsideFirstShadowMapFrustum) continue;
                            const i = s.calculatePosMatrix(f.toUnwrapped(), s.worldSize);
                            if (da.tileMatrix.set(i), da.shadowTileMatrix = Float32Array.from(h.calculateShadowPassMatrixFromMatrix(i)), da.aabb.min = [
                                0,
                                0,
                                0
                            ], da.aabb.max[0] = da.aabb.max[1] = e1.an, da.aabb.max[2] = 0, fa(r, da, t1, o.scope)) continue;
                        }
                        const v = 1 << f.canonical.z, y = [
                            ((l.x - f.wrap) * v - f.canonical.x) * e1.an,
                            (l.y * v - f.canonical.y) * e1.an,
                            l.z * v * e1.an
                        ];
                        t1.conflationActive && Object.keys(r.instancesPerModel).length > 0 && t1.style.isLayerClipped(o, i.getSource()) && r.updateReplacement(f, t1.replacementSource, u, o.scope) && (r.uploaded = !1, r.upload(t1.context));
                        let x = 0;
                        const b = new Array, w = new Array, T = new Array;
                        for(let i in r.instancesPerModel){
                            const s = r.instancesPerModel[i];
                            s.features.length > 0 && !a && (i = g.evaluate(s.features[0].feature, {}));
                            const h = c.getModel(i, n);
                            if (h || c.hasURLBeenRequested(i) || r.modelUris.includes(i) || (r.modelUris.push(i), r.modelsRequested = !1), h && h.uploaded) {
                                if (a) {
                                    const i = e1.bK([], [
                                        l.x,
                                        l.y,
                                        l.z
                                    ], t1.transform.worldSize);
                                    e1.ek(i, i);
                                    for(let o = 0; o < s.instancedDataArray.length; ++o){
                                        const n = [
                                            0,
                                            0,
                                            0
                                        ], a = [
                                            1,
                                            1,
                                            1
                                        ], l = e1.el(), c = s.tileCoordinatesForInstance(o), d = s.transformForInstance(o);
                                        e1.em(a, d), e1.en(l, d), e1.eo(n, l);
                                        const _ = s.translationForInstance(o), u = new e1.aV(0, 0);
                                        e1.ep(r.canonical, u, c.x, c.y);
                                        const f = e1.bc();
                                        e1.eq(f, h, t1.transform, u, n, a, _, !0, !1, !1);
                                        const m = s.colorForInstance(o), g = e1.ba([]), v = e1.d_(u.lat, t1.transform.zoom), y = e1.bQ([], [
                                            1,
                                            1,
                                            1 / v
                                        ]);
                                        e1.by(g, g, i), T.push({
                                            zScaleMatrix: y,
                                            negCameraPosMatrix: g
                                        });
                                        for (const e1 of h.nodes)ra(t1, e1, f, t1.transform.expandedFarZProjMatrix, x, b, w, h.materialOverrides, p, m);
                                        ++x;
                                    }
                                } else for (const e1 of h.nodes)ua(t1, o, e1, s, y, f, da);
                            }
                        }
                        if (a) {
                            if ("shadow" === t1.renderPass) {
                                for (const e1 of w)na(e1.mesh, e1.nodeModelMatrix, t1, o);
                                for (const e1 of b)na(e1.mesh, e1.nodeModelMatrix, t1, o);
                            } else ca(t1, o, b, w, T);
                        }
                    }
                }(t1, i, o, r, oa(t1, o)), void _();
                if (!u.loaded()) return;
                if ("batched-model" === u.type) return function(t1, i, o, r) {
                    o.resetLayerRenderingStats(t1);
                    const n = t1.context, s = t1.transform, a = t1.style.fog, l = t1.shadowRenderer;
                    if ("mercator" !== s.projection.name) return void e1.w(`Drawing 3D landmark models for ${s.projection.name} projection is not yet implemented`);
                    const c = t1.transform.getFreeCameraOptions().position, h = e1.bK([], [
                        c.x,
                        c.y,
                        c.z
                    ], t1.transform.worldSize), d = e1.ek([], h), _ = e1.ba([]), u = e1.d_(s.center.lat, s.zoom), p = e1.bQ([], [
                        1,
                        1,
                        1 / u
                    ]);
                    e1.by(_, _, d);
                    const f = o.paint.get("model-opacity").constantOr(1), m = new Hi(n.gl.LEQUAL, Hi.ReadWrite, t1.depthRangeFor3D), g = new Hi(n.gl.LEQUAL, Hi.ReadOnly, t1.depthRangeFor3D), v = new e1.cQ([
                        1 / 0,
                        1 / 0,
                        1 / 0
                    ], [
                        -1 / 0,
                        -1 / 0,
                        -1 / 0
                    ]), y = "shadow" === t1.renderPass, x = y && l ? l.getCurrentCascadeFrustum() : s.getFrustum(s.scaleZoom(s.worldSize)), b = o.paint.get("model-front-cutoff"), w = b[2] < 1, T = ao(t1, o.paint.get("model-cutoff-fade-range")), E = o.getLayerRenderingStats();
                    (function(e1, t1, i, o) {
                        const r = e1.terrain ? e1.terrain.exaggeration() : 0, n = e1.transform.zoom;
                        for (const s of o){
                            const o = t1.getTile(s).getBucket(i);
                            o && (o.setFilter(i.filter), e1.conflationActive && o.updateReplacement(s, e1.replacementSource), o.evaluateTransform(e1, i), e1.terrain && r > 0 && o.elevationUpdate(e1.terrain, r, s, i.source), o.needsReEvaluation(e1, n, i) && o.evaluate(i));
                        }
                    })(t1, i, o, r), function() {
                        const c = new Map;
                        let d, S, C;
                        w ? (d = r.length - 1, S = -1, C = -1) : (d = 0, S = r.length, C = 1);
                        const I = new Float64Array(16), R = e1.cf(), D = new e1.P(0, 0);
                        for(let A = d; A !== S; A += C){
                            const d = r[A], S = i.getTile(d).getBucket(o);
                            if (!S || !S.uploaded) continue;
                            let C = !1;
                            l && (C = 0 === l.getMaxCascadeForTile(d.toUnwrapped()));
                            const L = s.calculatePosMatrix(d.toUnwrapped(), s.worldSize), P = S.modelTraits;
                            !y && w && (e1.b8(I, L), e1.ah(R, h, I), D.x = R[0], D.y = R[1]);
                            const O = [];
                            S.setFilter(o.filter);
                            for (const i of S.getNodesInfo()){
                                if (i.hiddenByReplacement) continue;
                                if (!i.node.meshes) continue;
                                const o = i.node;
                                let r = 0;
                                t1.terrain && o.elevation && (r = o.elevation * t1.terrain.exaggeration());
                                const n = (()=>{
                                    const t1 = i.aabb;
                                    return v.min = [
                                        ...t1.min
                                    ], v.max = [
                                        ...t1.max
                                    ], v.min[2] += r, v.max[2] += r, e1.ah(v.min, v.min, L), e1.ah(v.max, v.max, L), v;
                                })(), a = i.evaluatedScale;
                                if (a[0] <= 1 && a[1] <= 1 && a[2] <= 1 && 0 === n.intersects(x)) continue;
                                if (!y && w) {
                                    const t1 = 1 / 6;
                                    i.cameraCollisionOpacity = h[0] > n.min[0] && h[0] < n.max[0] && h[1] > n.min[1] && h[1] < n.max[1] && h[2] * u < n.max[2] && o.footprint && e1.bD(D, o.footprint) ? Math.max(i.cameraCollisionOpacity - t1, 0) : Math.min(1, i.cameraCollisionOpacity + t1);
                                }
                                const l = [
                                    ...L
                                ], c = 1 / e1.cO(d.canonical), _ = o.anchor ? o.anchor[0] : 0, p = o.anchor ? o.anchor[1] : 0;
                                e1.by(l, l, [
                                    _ * (a[0] - 1) + i.evaluatedTranslation[0] * c,
                                    p * (a[1] - 1) + i.evaluatedTranslation[1] * c,
                                    r + i.evaluatedTranslation[2]
                                ]), e1.c5(a, e1.es) || e1.cx(l, l, a);
                                const m = e1.aD([], l, o.globalMatrix), g = e1.aD([], s.expandedFarZProjMatrix, m), E = e1.aD([], s.expandedFarZProjMatrix, l), S = e1.aE([], [
                                    _,
                                    p,
                                    r,
                                    1
                                ], g)[2];
                                o.hidden = !1;
                                let C = f;
                                y || (w && (C *= i.cameraCollisionOpacity, C *= ga(l, s, i.aabb, b)), C *= ma(T, S)), 0 !== C ? O.push({
                                    nodeInfo: i,
                                    depth: S,
                                    opacity: C,
                                    wvpForNode: g,
                                    wvpForTile: E,
                                    nodeModelMatrix: m,
                                    tileModelMatrix: l
                                }) : o.hidden = !0;
                            }
                            y || O.sort((e1, t1)=>!w || 1 === e1.opacity && 1 === t1.opacity ? e1.depth < t1.depth ? -1 : 1 : 1 === e1.opacity ? -1 : 1 === t1.opacity ? 1 : e1.depth > t1.depth ? -1 : 1);
                            for (const i of O){
                                const r = i.nodeInfo, h = r.node;
                                if (t1._debugParams.show3DModelFootprints && h.footprint) {
                                    const e1 = h.id || h.name || "footprint";
                                    c.has(e1) || c.set(e1, {
                                        node: h,
                                        mvp: i.wvpForTile
                                    });
                                }
                                let d = e1.aD([], p, i.tileModelMatrix);
                                e1.aD(d, _, d);
                                const u = e1.b8([], d);
                                e1.e2(u, u), e1.cx(u, u, pa), d = e1.aD(d, d, h.globalMatrix);
                                const f = "light-beam" === t1.renderPass, v = "none" === o.paint.get("model-color-use-theme").constantOr("default"), x = P & e1.ev.HasMapboxMeshFeatures, b = x ? 0 : r.evaluatedRMEA[0][2];
                                for(let e1 = 0; e1 < h.meshes.length; ++e1){
                                    const c = h.meshes[e1], _ = e1 === h.lightMeshIndex;
                                    let p = i.wvpForNode;
                                    if (_) {
                                        if (!f && !t1.terrain && t1.shadowRenderer) {
                                            t1.currentLayer < t1.firstLightBeamLayer && (t1.firstLightBeamLayer = t1.currentLayer);
                                            continue;
                                        }
                                        p = i.wvpForTile;
                                    } else if (f) continue;
                                    const w = {
                                        defines: []
                                    }, T = [];
                                    if (!y && l && (l.useNormalOffset = !!c.normalBuffer), ta(w.defines, T, c, t1, v ? null : o.lut), x || w.defines.push("DIFFUSE_SHADED"), C && w.defines.push("SHADOWS_SINGLE_CASCADE"), E && (y ? E.numRenderedVerticesInShadowPass += c.vertexArray.length : E.numRenderedVerticesInTransparentPass += c.vertexArray.length), y) {
                                        na(c, i.nodeModelMatrix, t1, o);
                                        continue;
                                    }
                                    let S = null;
                                    if (a) {
                                        const e1 = ea(i.nodeModelMatrix, t1.transform);
                                        if (S = new Float32Array(e1), "globe" !== s.projection.name) {
                                            const t1 = c.aabb.min, i = c.aabb.max, [o, r] = a.getOpacityForBounds(e1, t1[0], t1[1], i[0], i[1]);
                                            w.overrideFog = o >= Ye || r >= Ye;
                                        }
                                    }
                                    const I = c.material;
                                    let R;
                                    I.occlusionTexture && I.occlusionTexture.offsetScale && (R = I.occlusionTexture.offsetScale, w.defines.push("OCCLUSION_TEXTURE_TRANSFORM"));
                                    const D = t1.getOrCreateProgram("model", w);
                                    !y && l && l.setupShadowsFromMatrix(i.tileModelMatrix, D, l.useNormalOffset), t1.uploadCommonUniforms(n, D, null, S);
                                    const A = I.pbrMetallicRoughness;
                                    A.metallicFactor = .9, A.roughnessFactor = .5;
                                    const L = Wn(new Float32Array(p), new Float32Array(d), new Float32Array(u), new Float32Array(h.globalMatrix), t1, i.opacity, A.baseColorFactor, I.emissiveFactor, A.metallicFactor, A.roughnessFactor, I, b, o, [
                                        0,
                                        0,
                                        0
                                    ], R);
                                    !_ && (r.hasTranslucentParts || i.opacity < 1) && D.draw(t1, n.gl.TRIANGLES, m, $i.disabled, Zi.disabled, Ki.backCCW, L, o.id, c.vertexBuffer, c.indexBuffer, c.segments, o.paint, t1.transform.zoom, void 0, T), D.draw(t1, n.gl.TRIANGLES, _ ? g : m, $i.disabled, _ || i.opacity < 1 || r.hasTranslucentParts ? Zi.alphaBlended : Zi.unblended, Ki.backCCW, L, o.id, c.vertexBuffer, c.indexBuffer, c.segments, o.paint, t1.transform.zoom, void 0, T);
                                }
                            }
                        }
                        if (t1._debugParams.show3DModelFootprints && c.size > 0) {
                            const e1 = Array.from(c.keys()).sort();
                            for (const i of e1){
                                const { node: e1, mvp: o } = c.get(i);
                                sa(t1, 0, e1, o);
                            }
                        }
                    }();
                }(t1, i, o, r), void _();
                if ("model" !== u.type) return;
                const p = u.getModels(), f = [], m = t1.transform.getFreeCameraOptions().position, g = e1.bK([], [
                    m.x,
                    m.y,
                    m.z
                ], t1.transform.worldSize);
                e1.ek(g, g);
                const v = [], y = [];
                let x = 0;
                for (const r of p){
                    const n = i.getFeatureState("", r.id), s = {
                        type: "Unknown",
                        id: r.id,
                        properties: r.featureProperties
                    }, c = o.paint.get("model-rotation").evaluate(s, n), h = o.paint.get("model-scale").evaluate(s, n), d = o.paint.get("model-translation").evaluate(s, n), _ = o.paint.get("model-opacity").evaluate(s, n);
                    aa(o, r.id, n, r.featureProperties, r.nodeOverrideNames, r.nodeOverrides), la(o, r.id, n, r.featureProperties, r.materialOverrideNames, r.materialOverrides), r.nodeOverrides.size > 0 && r.computeBoundsAndApplyParent(), r.computeModelMatrix(t1, c, h, d, l, a, !1);
                    const u = e1.ba([]), p = e1.d_(r.position.lat, t1.transform.zoom), m = e1.bQ([], [
                        1,
                        1,
                        1 / p
                    ]);
                    e1.by(u, u, g), f.push({
                        zScaleMatrix: m,
                        negCameraPosMatrix: u
                    });
                    for (const e1 of r.nodes)ra(t1, e1, r.matrix, t1.transform.expandedFarZProjMatrix, x, v, y, r.materialOverrides, _);
                    x++;
                }
                if (v.sort((e1, t1)=>t1.depth - e1.depth), "shadow" !== t1.renderPass) {
                    if (t1._debugParams.show3DModelFootprints) {
                        const i = t1.transform.projMatrix, o = new Map, r = (t1, r)=>{
                            if (t1.footprint) {
                                const n = t1.id || t1.name || "footprint";
                                if (!o.has(n)) {
                                    const s = e1.aD([], i, r);
                                    o.set(n, {
                                        node: t1,
                                        mvp: s
                                    });
                                }
                            }
                        };
                        for (const e1 of y)r(e1.node, e1.modelMatrix);
                        for (const e1 of v)r(e1.node, e1.modelMatrix);
                        const n = Array.from(o.keys()).sort();
                        for (const e1 of n){
                            const { node: i, mvp: r } = o.get(e1);
                            sa(t1, 0, i, r);
                        }
                    }
                    ca(t1, o, v, y, f), _();
                } else {
                    for (const e1 of y)na(e1.mesh, e1.nodeModelMatrix, t1, o);
                    for (const e1 of v)na(e1.mesh, e1.nodeModelMatrix, t1, o);
                    _();
                }
            }
        }, Ma = {
            line: function(e1, t1, i) {
                if (e1.hasElevatedBuckets = !1, e1.hasNonElevatedBuckets = !1, void 0 !== e1._unevaluatedLayout.getValue("line-elevation-reference") || void 0 !== e1._unevaluatedLayout.getValue("line-z-offset")) {
                    if (t1) {
                        const i = t1.getVisibleCoordinates();
                        for (const o of i){
                            const i = t1.getTile(o).getBucket(e1);
                            if (i && ("none" !== i.elevationType ? e1.hasElevatedBuckets = !0 : e1.hasNonElevatedBuckets = !0, e1.hasElevatedBuckets && e1.hasNonElevatedBuckets)) break;
                        }
                    }
                } else e1.hasNonElevatedBuckets = !0;
            },
            model: function(e1, t1, i) {
                const o = t1.getSource();
                if (!o.loaded()) return;
                if ("vector" === o.type || "geojson" === o.type) return void (i.modelManager && i.modelManager.upload(i, oa(i, e1)));
                if ("batched-model" === o.type) return;
                if ("model" !== o.type) return;
                const r = o.getModels();
                for (const e1 of r)e1.upload(i.context);
            },
            raster: function(e1, t1, i) {
                const o = t1.getSource();
                if (!(o instanceof Tt && o.loaded())) return;
                const r = e1.sourceLayer || o.rasterLayerIds && o.rasterLayerIds[0];
                if (!r) return;
                const n = e1.paint.get("raster-array-band") || o.getInitialBand(r);
                if (null == n) return;
                const s = t1.getIds().map((e1)=>t1.getTileByID(e1));
                for (const t1 of s)t1.updateNeeded(e1.id, n) && o.prepareTile(t1, r, e1.id, n);
            },
            "raster-particle": function(e1, t1, i) {
                const o = t1.getSource();
                if (!(o instanceof Tt && o.loaded())) return;
                const r = e1.sourceLayer || o.rasterLayerIds && o.rasterLayerIds[0];
                if (!r) return;
                const n = e1.paint.get("raster-particle-array-band") || o.getInitialBand(r);
                if (null == n) return;
                const s = t1.getIds().map((e1)=>t1.getTileByID(e1));
                for (const t1 of s)t1.updateNeeded(e1.id, n) && o.prepareTile(t1, r, e1.id, n);
            }
        }, za = {
            fill: _s
        }, Fa = {
            fill: function(e1, t1, i, o) {
                if (!i.layout || "none" === i.layout.get("fill-elevation-reference") || 0 === i.paint.get("fill-opacity").constantOr(1)) return;
                const r = e1.context.gl, n = new Hi(r.LEQUAL, Hi.ReadOnly, e1.depthRangeFor3D), s = new $i({
                    func: r.ALWAYS,
                    mask: 255
                }, 255, 255, r.KEEP, r.KEEP, r.REPLACE), a = e1.transform.getFreeCameraOptions().position, l = e1.getOrCreateProgram("elevatedStructuresDepthReconstruct");
                for (const c of o){
                    const o = t1.getTile(c), h = o.getBucket(i);
                    if (!h) continue;
                    const d = h.elevatedStructures;
                    if (!d || 0 === d.depthSegments.segments[0].primitiveLength) continue;
                    const _ = ds(c.toUnwrapped(), a), u = e1.translatePosMatrix(c.projMatrix, o, i.paint.get("fill-translate"), i.paint.get("fill-translate-anchor")), p = Tn(u, _, 0, 1, 0);
                    l.draw(e1, r.TRIANGLES, n, s, Zi.disabled, Ki.disabled, p, i.id, d.vertexBuffer, d.indexBuffer, d.depthSegments, i.paint, e1.transform.zoom);
                }
            }
        };
        class Ba {
            constructor(t1, i, o, r, n){
                this.context = new es(t1, i), this.transform = o, this._tileTextures = {}, this.frameCopies = [], this.loadTimeStamps = [], this._timeStamp = e1.o.now(), this._averageFPS = 0, this._fpsHistory = [], this._dt = 0, this._debugParams = {
                    forceEnablePrecipitation: !1,
                    showTerrainProxyTiles: !1,
                    fpsWindow: 30,
                    continousRedraw: !1,
                    show3DModelFootprints: !1,
                    enabledLayers: {}
                };
                const s = [
                    "fill",
                    "line",
                    "symbol",
                    "circle",
                    "heatmap",
                    "fill-extrusion",
                    "building",
                    "raster",
                    "raster-particle",
                    "hillshade",
                    "model",
                    "background",
                    "sky"
                ];
                for (const e1 of s)this._debugParams.enabledLayers[e1] = !0;
                for (const e1 of s);
                this.occlusionParams = new xa, this.setup(), this.numSublayers = zt.maxUnderzooming + zt.maxOverzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.deferredRenderGpuTimeQueries = [], this.gpuTimers = {}, this.frameCounter = 0, this._backgroundTiles = {}, this.conflationActive = !1, this.replacementSource = new e1.eC, this.longestCutoffRange = 0, this.minCutoffZoom = 0, this._fogVisible = !1, this._cachedTileFogOpacities = {}, this._shadowRenderer = new _o(this), this._wireframeDebugCache = new ya, this.renderDefaultNorthPole = !0, this.renderDefaultSouthPole = !0, this.layersWithOcclusionOpacity = [];
                const a = new e1.q({
                    width: 1,
                    height: 1
                }, Uint8Array.of(0, 0, 0, 0));
                this.emptyDepthTexture = new e1.T(this.context, a, t1.RGBA8), this._clippingActiveLastFrame = !1, this.scaleFactor = r, this.maxFrontCutoffRawStart = 0, this.worldview = n, this._forceEmissiveMode = !1, this.emissiveMode = "constant";
            }
            updateTerrain(e1, t1) {
                const i = !!e1 && !!e1.terrain && this.transform.projection.supportsTerrain;
                if (!(i || this._terrain && this._terrain.enabled)) return;
                this._terrain || (this._terrain = new sn(this, e1));
                const o = this._terrain;
                this.transform.elevation = i ? o : null, o.update(e1, this.transform, t1), this.transform.elevation && !o.enabled && (this.transform.elevation = null);
            }
            _updateFog(e1) {
                const t1 = e1.fog;
                if (!t1 || "globe" === this.transform.projection.name || t1.getOpacity(this.transform.pitch) < 1 || t1.properties.get("horizon-blend") < .03) return void (this.transform.fogCullDistSq = null);
                const [i, o] = t1.getFovAdjustedRange(this.transform._fov);
                if (i > o) return void (this.transform.fogCullDistSq = null);
                const r = i + .78 * (o - i);
                this.transform.fogCullDistSq = r * r;
            }
            get terrain() {
                return this.transform._terrainEnabled() && this._terrain && this._terrain.enabled || this._forceTerrainMode ? this._terrain : null;
            }
            get forceTerrainMode() {
                return this._forceTerrainMode;
            }
            set forceTerrainMode(e1) {
                e1 && !this._terrain && (this._terrain = new sn(this, this.style)), this._forceTerrainMode = e1;
            }
            get shadowRenderer() {
                return this._shadowRenderer && this._shadowRenderer.enabled ? this._shadowRenderer : null;
            }
            get wireframeDebugCache() {
                return this._wireframeDebugCache;
            }
            resize(t1, i) {
                if (this.width = t1 * e1.o.devicePixelRatio, this.height = i * e1.o.devicePixelRatio, this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.style) for (const e1 of this.style.order)this.style._mergedLayers[e1].resize();
            }
            setup() {
                const t1 = this.context, i = new e1.dx;
                i.emplaceBack(0, 0), i.emplaceBack(e1.an, 0), i.emplaceBack(0, e1.an), i.emplaceBack(e1.an, e1.an), this.tileExtentBuffer = t1.createVertexBuffer(i, e1.dt.members), this.tileExtentSegments = e1.du.simpleSegment(0, 0, 4, 2);
                const o = new e1.dx;
                o.emplaceBack(0, 0), o.emplaceBack(e1.an, 0), o.emplaceBack(0, e1.an), o.emplaceBack(e1.an, e1.an), this.debugBuffer = t1.createVertexBuffer(o, e1.dt.members), this.debugSegments = e1.du.simpleSegment(0, 0, 4, 5);
                const r = new e1.dx;
                r.emplaceBack(-1, -1), r.emplaceBack(1, -1), r.emplaceBack(-1, 1), r.emplaceBack(1, 1), this.viewportBuffer = t1.createVertexBuffer(r, e1.dt.members), this.viewportSegments = e1.du.simpleSegment(0, 0, 4, 2);
                const n = new e1.eD;
                n.emplaceBack(0, 0, 0, 0), n.emplaceBack(e1.an, 0, e1.an, 0), n.emplaceBack(0, e1.an, 0, e1.an), n.emplaceBack(e1.an, e1.an, e1.an, e1.an), this.mercatorBoundsBuffer = t1.createVertexBuffer(n, e1.eE.members), this.mercatorBoundsSegments = e1.du.simpleSegment(0, 0, 4, 2);
                const s = new e1.dy;
                s.emplaceBack(0, 1, 2), s.emplaceBack(2, 1, 3), this.quadTriangleIndexBuffer = t1.createIndexBuffer(s);
                const a = new e1.eF;
                for (const e1 of [
                    0,
                    1,
                    3,
                    2,
                    0
                ])a.emplaceBack(e1);
                this.debugIndexBuffer = t1.createIndexBuffer(a), this.emptyTexture = new e1.T(t1, new e1.q({
                    width: 1,
                    height: 1
                }, Uint8Array.of(0, 0, 0, 0)), t1.gl.RGBA8), this.identityMat = e1.bc();
                const l = this.context.gl;
                this.stencilClearMode = new $i({
                    func: l.ALWAYS,
                    mask: 0
                }, 0, 255, l.ZERO, l.ZERO, l.ZERO), this.loadTimeStamps.push(performance.now());
            }
            getMercatorTileBoundsBuffers() {
                return {
                    tileBoundsBuffer: this.mercatorBoundsBuffer,
                    tileBoundsIndexBuffer: this.quadTriangleIndexBuffer,
                    tileBoundsSegments: this.mercatorBoundsSegments
                };
            }
            getTileBoundsBuffers(e1) {
                return e1._makeTileBoundsBuffers(this.context, this.transform.projection), e1._tileBoundsBuffer ? {
                    tileBoundsBuffer: e1._tileBoundsBuffer,
                    tileBoundsIndexBuffer: e1._tileBoundsIndexBuffer,
                    tileBoundsSegments: e1._tileBoundsSegments
                } : this.getMercatorTileBoundsBuffers();
            }
            clearStencil() {
                const e1 = this.context.gl;
                this.nextStencilID = 1, this.currentStencilSource = void 0, this._tileClippingMaskIDs = {}, this.getOrCreateProgram("clippingMask").draw(this, e1.TRIANGLES, Hi.disabled, this.stencilClearMode, Zi.disabled, Ki.disabled, en(this.identityMat), "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
            }
            resetStencilClippingMasks() {
                this.terrain || (this.currentStencilSource = void 0, this._tileClippingMaskIDs = {});
            }
            _renderTileClippingMasks(e1, t1, i) {
                if (!t1 || this.currentStencilSource === t1.id || !e1.isTileClipped() || !i || 0 === i.length) return;
                if (this._tileClippingMaskIDs && !this.terrain) {
                    let e1 = !1;
                    for (const t1 of i)if (void 0 === this._tileClippingMaskIDs[t1.key]) {
                        e1 = !0;
                        break;
                    }
                    if (!e1) return;
                }
                this.currentStencilSource = t1.id;
                const o = this.context, r = o.gl;
                this.nextStencilID + i.length > 256 && this.clearStencil(), o.setColorMode(Zi.disabled), o.setDepthMode(Hi.disabled);
                const n = this.getOrCreateProgram("clippingMask");
                this._tileClippingMaskIDs = {};
                for (const e1 of i){
                    const i = t1.getTile(e1), o = this._tileClippingMaskIDs[e1.key] = this.nextStencilID++, { tileBoundsBuffer: s, tileBoundsIndexBuffer: a, tileBoundsSegments: l } = this.getTileBoundsBuffers(i);
                    n.draw(this, r.TRIANGLES, Hi.disabled, new $i({
                        func: r.ALWAYS,
                        mask: 0
                    }, o, 255, r.KEEP, r.KEEP, r.REPLACE), Zi.disabled, Ki.disabled, en(e1.projMatrix), "$clipping", s, a, l);
                }
            }
            stencilModeFor3D() {
                this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                const e1 = this.nextStencilID++, t1 = this.context.gl;
                return new $i({
                    func: t1.NOTEQUAL,
                    mask: 255
                }, e1, 255, t1.KEEP, t1.KEEP, t1.REPLACE);
            }
            stencilModeForClipping(e1) {
                if (this.terrain) return this.terrain.stencilModeForRTTOverlap(e1);
                const t1 = this.context.gl;
                return new $i({
                    func: t1.EQUAL,
                    mask: 255
                }, this._tileClippingMaskIDs[e1.key], 0, t1.KEEP, t1.KEEP, t1.REPLACE);
            }
            stencilConfigForOverlap(e1) {
                const t1 = this.context.gl, i = e1.sort((e1, t1)=>t1.overscaledZ - e1.overscaledZ), o = i[i.length - 1].overscaledZ, r = i[0].overscaledZ - o + 1;
                if (r > 1) {
                    this.currentStencilSource = void 0, this.nextStencilID + r > 256 && this.clearStencil();
                    const e1 = {};
                    for(let i = 0; i < r; i++)e1[i + o] = new $i({
                        func: t1.GEQUAL,
                        mask: 255
                    }, i + this.nextStencilID, 255, t1.KEEP, t1.KEEP, t1.REPLACE);
                    return this.nextStencilID += r, [
                        e1,
                        i
                    ];
                }
                return [
                    {
                        [o]: $i.disabled
                    },
                    i
                ];
            }
            colorModeForRenderPass() {
                const t1 = this.context.gl;
                if (this._showOverdrawInspector) {
                    const i = 1 / 8;
                    return new Zi([
                        t1.CONSTANT_COLOR,
                        t1.ONE,
                        t1.CONSTANT_COLOR,
                        t1.ONE
                    ], new e1.aq(i, i, i, 0), [
                        !0,
                        !0,
                        !0,
                        !0
                    ]);
                }
                return "opaque" === this.renderPass ? Zi.unblended : Zi.alphaBlended;
            }
            colorModeForDrapableLayerRenderPass(t1) {
                const i = this.context.gl;
                return (()=>this.style && this.style.enable3dLights() && this.terrain && this.terrain.renderingToTexture)() && "translucent" === this.renderPass ? null != t1 && "mrt-fallback" !== this.emissiveMode || "constant" === this.emissiveMode ? new Zi([
                    i.ONE,
                    i.ONE_MINUS_SRC_ALPHA,
                    i.CONSTANT_ALPHA,
                    i.ONE_MINUS_SRC_ALPHA
                ], new e1.aq(0, 0, 0, null != t1 ? t1 : 0), [
                    !0,
                    !0,
                    !0,
                    !0
                ]) : "dual-source-blending" === this.emissiveMode ? new Zi([
                    i.ONE,
                    i.ONE_MINUS_SRC_ALPHA,
                    this.context.extBlendFuncExtended.SRC1_ALPHA_WEBGL,
                    i.ONE_MINUS_SRC_ALPHA
                ], e1.aq.transparent, [
                    !0,
                    !0,
                    !0,
                    !0
                ]) : this.colorModeForRenderPass() : this.colorModeForRenderPass();
            }
            depthModeForSublayer(e1, t1, i, o = !1) {
                if (this.depthOcclusion) return new Hi(this.context.gl.GREATER, Hi.ReadOnly, this.depthRangeFor3D);
                if (!this.opaquePassEnabledForLayer() && !o) return Hi.disabled;
                const r = 1 - ((1 + this.currentLayer) * this.numSublayers + e1) * this.depthEpsilon;
                return new Hi(i || this.context.gl.LEQUAL, t1, [
                    r,
                    r
                ]);
            }
            opaquePassEnabledForLayer() {
                return this.currentLayer < this.opaquePassCutoff;
            }
            blitDepth() {
                const t1 = this.context.gl, i = Math.ceil(this.width), o = Math.ceil(this.height), r = this.context.bindFramebuffer.get(), n = t1.getParameter(t1.TEXTURE_BINDING_2D);
                this.depthFBO && this.depthFBO.width === i && this.depthFBO.height === o || (this.depthFBO && (this.depthFBO.destroy(), this.depthFBO = void 0, this.depthTexture = void 0), 0 !== i && 0 !== o && (this.depthFBO = new Jn(this.context, i, o, 0, "texture"), this.depthTexture = new e1.T(this.context, {
                    width: i,
                    height: o,
                    data: null
                }, t1.DEPTH24_STENCIL8), this.depthFBO.depthAttachment.set(this.depthTexture.texture))), this.context.bindFramebuffer.set(r), t1.bindTexture(t1.TEXTURE_2D, n), this.depthFBO && (t1.bindFramebuffer(t1.READ_FRAMEBUFFER, null), t1.bindFramebuffer(t1.DRAW_FRAMEBUFFER, this.depthFBO.framebuffer), t1.blitFramebuffer(0, 0, i, o, 0, 0, i, o, t1.DEPTH_BUFFER_BIT, t1.NEAREST), t1.bindFramebuffer(t1.FRAMEBUFFER, this.context.bindFramebuffer.current));
            }
            updateAverageFPS() {
                this._fpsHistory.push(0 === this._dt ? 0 : 1e3 / this._dt), this._fpsHistory.length > this._debugParams.fpsWindow && this._fpsHistory.splice(0, this._fpsHistory.length - this._debugParams.fpsWindow), this._averageFPS = Math.round(this._fpsHistory.reduce((e1, t1)=>e1 + t1 / this._fpsHistory.length, 0));
            }
            render(t1, i) {
                const o = e1.o.now();
                this._dt = o - this._timeStamp, this._timeStamp = o, this._wireframeDebugCache.update(this.frameCounter), this._debugParams.continousRedraw = t1.map.repaint, this.style = t1, this.options = i;
                const r = this.style._mergedLayers, n = !(!this.terrain || !this.terrain.enabled), s = ()=>this.style._getOrder(n).filter((e1)=>{
                        const t1 = r[e1];
                        return !(t1.type in this._debugParams.enabledLayers) || this._debugParams.enabledLayers[t1.type];
                    });
                let a = s(), l = !1, c = !1, h = null, d = 0, _ = !1;
                for (const e1 of a){
                    const t1 = r[e1];
                    "none" !== t1.visibility && ("circle" === t1.type ? l = !0 : "building" === t1.type ? (h = t1, ++d) : "symbol" === t1.type && (t1.hasOcclusionOpacityProperties ? c = !0 : l = !0));
                }
                this.updateEmissiveMode();
                let u = a.map((e1)=>r[e1]);
                const p = this.style._mergedSourceCaches;
                this.imageManager = t1.imageManager, this.modelManager = t1.modelManager, this.symbolFadeChange = t1.placement.symbolFadeChange(e1.o.now()), this.imageManager.beginFrame();
                for(const e1 in p){
                    const t1 = p[e1];
                    t1.used && (t1.prepare(this.context), t1.getSource().usedInConflation && ++d);
                }
                let f = !1;
                for (const e1 of u)e1.isHidden(this.transform.zoom) || ("clip" === e1.type && (f = !0), this.prepareLayer(e1));
                const m = {}, g = {}, v = {}, y = {}, x = {};
                for(const e1 in p){
                    const t1 = p[e1];
                    m[e1] = t1.getVisibleCoordinates(), g[e1] = m[e1].slice().reverse(), v[e1] = t1.getVisibleCoordinates(!0).reverse(), y[e1] = t1.getShadowCasterCoordinates(), x[e1] = t1.sortCoordinatesByDistance(m[e1]);
                }
                const b = (e1)=>{
                    const t1 = this.style.getLayerSourceCache(e1);
                    return t1 && t1.used ? t1.getSource() : null;
                };
                if (d || f || this._clippingActiveLastFrame) {
                    const t1 = [], i = [];
                    let o = 0;
                    for (const e1 of u)this.isSourceForClippingOrConflation(e1, b(e1)) && (t1.push(e1), i.push(o)), o++;
                    if (t1 && (f || t1.length > 1) || this._clippingActiveLastFrame) {
                        f = !1;
                        const o = [];
                        for(let r = 0; r < t1.length; r++){
                            const n = t1[r], s = i[r], a = this.style.getLayerSourceCache(n);
                            if (!a || !a.used || !a.getSource().usedInConflation && "clip" !== n.type && "building" !== n.type) continue;
                            let l = e1.eG, c = e1.bB.None;
                            const h = [];
                            let d = !0;
                            if ("building" === n.type) l = e1.eI;
                            else if ("clip" === n.type) {
                                if (l = s, n.isHidden(this.transform.zoom)) d = !1;
                                else {
                                    if (!n.layout) {
                                        d = !1;
                                        continue;
                                    }
                                    for (const t1 of n.layout.get("clip-layer-types"))c |= "model" === t1 ? e1.bB.Model : "symbol" === t1 ? e1.bB.Symbol : e1.bB.FillExtrusion;
                                    for (const e1 of n.layout.get("clip-layer-scope"))h.push(e1);
                                    f = !0;
                                }
                            }
                            d && o.push({
                                layer: n.fqid,
                                cache: a,
                                order: l,
                                clipMask: c,
                                clipScope: h
                            });
                        }
                        this.replacementSource.setSources(o), _ = !0;
                    }
                }
                this._clippingActiveLastFrame = f, _ || this.replacementSource.clear(), this.conflationActive = _, this.minCutoffZoom = 0, this.longestCutoffRange = 0, this.maxFrontCutoffRawStart = 0, this.opaquePassCutoff = 1 / 0, this._lastOcclusionLayer = -1, this.layersWithOcclusionOpacity = [];
                for(let e1 = 0; e1 < u.length; e1++){
                    const t1 = u[e1];
                    if ("none" === t1.visibility) continue;
                    const i = t1.cutoffRange();
                    if (this.longestCutoffRange = Math.max(i, this.longestCutoffRange), i > 0) {
                        const e1 = b(t1);
                        e1 && (this.minCutoffZoom = Math.max(e1.minzoom, this.minCutoffZoom)), t1.minzoom && (this.minCutoffZoom = Math.max(t1.minzoom, this.minCutoffZoom));
                    }
                    t1.is3D(n) && (this.opaquePassCutoff === 1 / 0 && (this.opaquePassCutoff = e1), this._lastOcclusionLayer = e1);
                }
                const w = this.style && this.style.fog;
                w ? (this._fogVisible = 0 !== w.getOpacity(this.transform.pitch), this._fogVisible && "globe" !== this.transform.projection.name && (this._fogVisible = w.isVisibleOnFrustum(this.transform.cameraFrustum))) : this._fogVisible = !1, this._cachedTileFogOpacities = {}, this.terrain && (this.terrain.updateTileBinding(v), this.opaquePassCutoff = 0, a = s(), u = a.map((e1)=>r[e1]));
                const T = this._shadowRenderer;
                if (T) {
                    T.updateShadowParameters(this.transform, this.style.directionalLight);
                    for(const e1 in p)for (const t1 of m[e1]){
                        let e1 = {
                            min: 0,
                            max: 0
                        };
                        this.terrain && (e1 = this.terrain.getMinMaxForTile(t1) || e1), T.addShadowReceiver(t1.toUnwrapped(), e1.min, e1.max);
                    }
                }
                "globe" !== this.transform.projection.name || this.globeSharedBuffers || (this.globeSharedBuffers = new e1.eH(this.context)), this.style.fog && this.transform.projection.supportsFog ? (this._atmosphere || (this._atmosphere = new Qs(this)), this._atmosphere.update(this)) : this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0);
                const E = this._debugParams.forceEnablePrecipitation || !(!this.style || !this.style.snow), S = this._debugParams.forceEnablePrecipitation || !(!this.style || !this.style.rain);
                if (E && !this._snow && (this._snow = new Pa(this)), !E && this._snow && (this._snow.destroy(), delete this._snow), S && !this._rain && (this._rain = new Aa(this)), !S && this._rain && (this._rain.destroy(), delete this._rain), this._snow && this._snow.update(this), this._rain && this._rain.update(this), h) {
                    this.buildingTileBorderManager || (this.buildingTileBorderManager = new Js);
                    const e1 = this.style.getLayerSourceCache(h);
                    this.buildingTileBorderManager.updateBorders(e1, h);
                }
                if (!Z.has(this.context.gl)) return;
                this.renderPass = "offscreen";
                for (const e1 of u){
                    const i = t1.getLayerSourceCache(e1);
                    if (!e1.hasOffscreenPass() || e1.isHidden(this.transform.zoom)) continue;
                    const o = i ? g[i.id] : void 0;
                    ("custom" === e1.type || "raster" === e1.type || "raster-particle" === e1.type || e1.isSky() || o && o.length) && this.renderLayer(this, i, e1, o);
                }
                this.depthRangeFor3D = [
                    0,
                    1 - (u.length + 2) * this.numSublayers * this.depthEpsilon
                ], this._shadowRenderer && (this.renderPass = "shadow", this._shadowRenderer.drawShadowPass(this.style, y)), this.context.bindFramebuffer.set(null), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]);
                const C = "globe" === this.transform.projection.name || this.transform.isHorizonVisible(), I = (()=>{
                    if (i.showOverdrawInspector) return e1.aq.black;
                    const t1 = this.style.fog;
                    if (t1 && this.transform.projection.supportsFog) {
                        const i = this.style.getLut(t1.scope);
                        if (!C) {
                            const o = "none" === t1.properties.get("color-use-theme"), r = t1.properties.get("color").toNonPremultipliedRenderColor(o ? null : i).toArray01();
                            return new e1.aq(...r);
                        }
                        if (C) {
                            const o = "none" === t1.properties.get("space-color-use-theme"), r = t1.properties.get("space-color").toNonPremultipliedRenderColor(o ? null : i).toArray01();
                            return new e1.aq(...r);
                        }
                    }
                    return e1.aq.transparent;
                })();
                if (this.context.clear({
                    color: I,
                    depth: 1
                }), this.clearStencil(), this._showOverdrawInspector = i.showOverdrawInspector, this.renderPass = "opaque", this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && C && this._atmosphere.drawStars(this, this.style.fog), !this.terrain) for(this.currentLayer = a.length - 1; this.currentLayer >= 0; this.currentLayer--){
                    const e1 = u[this.currentLayer], i = t1.getLayerSourceCache(e1);
                    if (e1.isSky()) continue;
                    const o = i ? (e1.is3D(n) ? x : g)[i.id] : void 0;
                    this._renderTileClippingMasks(e1, i, o), this.renderLayer(this, i, e1, o);
                }
                if (this.style.fog && this.transform.projection.supportsFog && this._atmosphere && !this._showOverdrawInspector && C && this._atmosphere.drawAtmosphereGlow(this, this.style.fog), this.renderPass = "sky", (!this._atmosphere || e1.al(this.transform.zoom) > 0) && ("globe" === this.transform.projection.name || this.transform.isHorizonVisible())) for(this.currentLayer = 0; this.currentLayer < a.length; this.currentLayer++){
                    const e1 = u[this.currentLayer], i = t1.getLayerSourceCache(e1);
                    e1.isSky() && this.renderLayer(this, i, e1, i ? g[i.id] : void 0);
                }
                function R(e1, t1) {
                    let i;
                    return t1 && (i = ("symbol" === e1.type ? v : e1.is3D(n) ? x : g)[t1.id]), i;
                }
                if (this.renderPass = "translucent", "globe" === this.transform.projection.name) {
                    for(this.renderElevatedRasterBackface = !0, this.currentLayer = 0; this.currentLayer < a.length;){
                        const e1 = u[this.currentLayer];
                        if ("raster" === e1.type || "raster-particle" === e1.type) {
                            const i = t1.getLayerSourceCache(e1);
                            this.renderLayer(this, i, e1, R(e1, i));
                        }
                        ++this.currentLayer;
                    }
                    this.renderElevatedRasterBackface = !1;
                }
                this.currentLayer = 0, this.firstLightBeamLayer = Number.MAX_SAFE_INTEGER;
                const D = T ? T.getGroundShadowLayerIndex() : -1;
                let A = !1, L = -1;
                for(let e1 = 0; e1 < a.length; ++e1){
                    const t1 = u[e1];
                    t1.isHidden(this.transform.zoom) || t1.is3D(n) && (L = e1);
                }
                c && -1 === L && (l = !0);
                let P = !1;
                for(; this.currentLayer < a.length;){
                    const e1 = u[this.currentLayer], i = t1.getLayerSourceCache(e1);
                    if (e1.isSky()) ++this.currentLayer;
                    else if (this.terrain && this.style.isLayerDraped(e1)) {
                        if (e1.isHidden(this.transform.zoom)) {
                            ++this.currentLayer;
                            continue;
                        }
                        this.currentLayer = this.terrain.renderBatch(this.currentLayer), this._lastOcclusionLayer = Math.max(this.currentLayer, this._lastOcclusionLayer);
                    } else {
                        if (!P && e1.is3D(n) && !n) {
                            const e1 = this.currentLayer, t1 = (e1)=>{
                                for(this.currentLayer = 0; this.currentLayer < u.length; this.currentLayer++){
                                    const t1 = u[this.currentLayer];
                                    if (za[t1.type]) {
                                        const i = this.style.getLayerSourceCache(t1);
                                        za[t1.type](this, i, t1, R(t1, i), e1);
                                    }
                                }
                            };
                            t1("initialize"), t1("reset"), this.currentLayer = e1, P = !0;
                        }
                        if (l && !A && this.terrain && !this.transform.isOrthographic && (A = !0, this.blitDepth()), c && -1 !== L && this.currentLayer === L + 1 && !this.transform.isOrthographic && this.blitDepth(), this.terrain || this._renderTileClippingMasks(e1, i, i ? m[i.id] : void 0), this.renderLayer(this, i, e1, R(e1, i)), !this.terrain && T && this.currentLayer === D) {
                            {
                                this.clearStencil(), this.resetStencilClippingMasks();
                                const e1 = this.currentLayer;
                                for(this.currentLayer = 0; this.currentLayer < u.length; this.currentLayer++){
                                    const e1 = u[this.currentLayer];
                                    if (Fa[e1.type]) {
                                        const t1 = this.style.getLayerSourceCache(e1);
                                        Fa[e1.type](this, t1, e1, R(e1, t1));
                                    }
                                }
                                this.currentLayer = e1;
                            }
                            if (T.drawGroundShadows(), this.firstLightBeamLayer <= this.currentLayer) {
                                const e1 = this.currentLayer;
                                for(this.renderPass = "light-beam", this.currentLayer = this.firstLightBeamLayer; this.currentLayer <= e1; this.currentLayer++){
                                    const e1 = u[this.currentLayer];
                                    if (!e1.hasLightBeamPass()) continue;
                                    const i = t1.getLayerSourceCache(e1);
                                    this.renderLayer(this, i, e1, i ? g[i.id] : void 0);
                                }
                                this.currentLayer = e1, this.renderPass = "translucent";
                            }
                        }
                        if (this.currentLayer >= this._lastOcclusionLayer && this.layersWithOcclusionOpacity.length > 0) {
                            const e1 = this.currentLayer;
                            this.depthOcclusion = !0;
                            for (const e1 of this.layersWithOcclusionOpacity){
                                this.currentLayer = e1;
                                const i = u[this.currentLayer], o = t1.getLayerSourceCache(i), r = o ? g[o.id] : void 0;
                                this.terrain || this._renderTileClippingMasks(i, o, o ? m[o.id] : void 0), this.renderLayer(this, o, i, r);
                            }
                            this.depthOcclusion = !1, this.currentLayer = e1, this.renderPass = "translucent", this.layersWithOcclusionOpacity = [];
                        }
                        ++this.currentLayer;
                    }
                }
                if (this.terrain && this.terrain.postRender(), this._snow && this._snow.draw(this), this._rain && this._rain.draw(this), this.options.showTileBoundaries || this.options.showQueryGeometry || this.options.showTileAABBs) {
                    let i = null;
                    u.forEach((e1)=>{
                        const o = t1.getLayerSourceCache(e1);
                        o && !e1.isHidden(this.transform.zoom) && o.getVisibleCoordinates().length && (!i || i.getSource().maxzoom < o.getSource().maxzoom) && (i = o);
                    }), i && this.options.showTileBoundaries && ks(this, i, i.getVisibleCoordinates(), e1.aq.red, !1, this.options.showParseStatus);
                }
                this.terrain && this._debugParams.showTerrainProxyTiles && ks(this, this.terrain.proxySourceCache, this.terrain.proxyCoords, new e1.aq(1, .8, .1, 1), !0, this.options.showParseStatus), this.options.showPadding && function(e1) {
                    const t1 = e1.transform.padding;
                    Us(e1, e1.transform.height - (t1.top || 0), 3, Os), Us(e1, t1.bottom || 0, 3, Ms), Vs(e1, t1.left || 0, 3, zs), Vs(e1, e1.transform.width - (t1.right || 0), 3, Fs);
                    const i = e1.transform.centerPoint;
                    !function(e1, t1, i, o) {
                        js(e1, t1 - 1, i - 10, 2, 20, o), js(e1, t1 - 10, i - 1, 20, 2, o);
                    }(e1, i.x, e1.transform.height - i.y, Bs);
                }(this), this.context.setDefault(), this.frameCounter = (this.frameCounter + 1) % Number.MAX_SAFE_INTEGER, this.tileLoaded && this.options.speedIndexTiming && (this.loadTimeStamps.push(performance.now()), this.saveCanvasCopy()), _ || (this.conflationActive = !1);
            }
            prepareLayer(e1) {
                this.gpuTimingStart(e1);
                const { unsupportedLayers: t1 } = this.transform.projection, i = !t1 || !t1.includes(e1.type);
                if (Ma[e1.type] && (i || this.terrain && "custom" === e1.type)) {
                    const t1 = this.style.getLayerSourceCache(e1);
                    Ma[e1.type](e1, t1, this);
                }
                this.gpuTimingEnd();
            }
            renderLayer(e1, t1, i, o) {
                i.isHidden(this.transform.zoom) || ("background" === i.type || "sky" === i.type || "custom" === i.type || "model" === i.type || "raster" === i.type || "raster-particle" === i.type || o && o.length) && (this.id = i.id, this.gpuTimingStart(i), e1.transform.projection.unsupportedLayers && e1.transform.projection.unsupportedLayers.includes(i.type) && (!e1.terrain || "custom" !== i.type) || "clip" === i.type || Oa[i.type](e1, t1, i, o, this.style.placement.variableOffsets, this.options.isInitialLoad), this.gpuTimingEnd());
            }
            gpuTimingStart(e1) {
                if (!this.options.gpuTiming) return;
                const t1 = this.context.extTimerQuery, i = this.context.gl;
                let o = this.gpuTimers[e1.id];
                o || (o = this.gpuTimers[e1.id] = {
                    calls: 0,
                    cpuTime: 0,
                    query: i.createQuery()
                }), o.calls++, i.beginQuery(t1.TIME_ELAPSED_EXT, o.query);
            }
            gpuTimingDeferredRenderStart() {
                if (this.options.gpuTimingDeferredRender) {
                    const e1 = this.context.extTimerQuery, t1 = this.context.gl, i = t1.createQuery();
                    this.deferredRenderGpuTimeQueries.push(i), t1.beginQuery(e1.TIME_ELAPSED_EXT, i);
                }
            }
            gpuTimingDeferredRenderEnd() {
                this.options.gpuTimingDeferredRender && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
            }
            gpuTimingEnd() {
                this.options.gpuTiming && this.context.gl.endQuery(this.context.extTimerQuery.TIME_ELAPSED_EXT);
            }
            collectGpuTimers() {
                const e1 = this.gpuTimers;
                return this.gpuTimers = {}, e1;
            }
            collectDeferredRenderGpuQueries() {
                const e1 = this.deferredRenderGpuTimeQueries;
                return this.deferredRenderGpuTimeQueries = [], e1;
            }
            queryGpuTimers(e1) {
                const t1 = {};
                for(const i in e1){
                    const o = e1[i], r = this.context.extTimerQuery, n = r.getQueryParameter(o.query, this.context.gl.QUERY_RESULT) / 1e6;
                    r.deleteQueryEXT(o.query), t1[i] = n;
                }
                return t1;
            }
            queryGpuTimeDeferredRender(e1) {
                if (!this.options.gpuTimingDeferredRender) return 0;
                const t1 = this.context.gl;
                let i = 0;
                for (const o of e1)i += t1.getQueryParameter(o, t1.QUERY_RESULT) / 1e6, t1.deleteQuery(o);
                return i;
            }
            translatePosMatrix(t1, i, o, r, n) {
                if (!o[0] && !o[1]) return t1;
                const s = n ? "map" === r ? this.transform.angle : 0 : "viewport" === r ? -this.transform.angle : 0;
                if (s) {
                    const e1 = Math.sin(s), t1 = Math.cos(s);
                    o = [
                        o[0] * t1 - o[1] * e1,
                        o[0] * e1 + o[1] * t1
                    ];
                }
                const a = [
                    n ? o[0] : e1.aA(i, o[0], this.transform.zoom),
                    n ? o[1] : e1.aA(i, o[1], this.transform.zoom),
                    0
                ], l = new Float32Array(16);
                return e1.by(l, t1, a), l;
            }
            saveTileTexture(e1) {
                if (e1.context !== this.context) return;
                const t1 = e1.size[0], i = this._tileTextures[t1];
                i ? i.push(e1) : this._tileTextures[t1] = [
                    e1
                ];
            }
            getTileTexture(e1) {
                const t1 = this._tileTextures[e1];
                return t1 && t1.length > 0 ? t1.pop() : null;
            }
            terrainRenderModeElevated() {
                return this.style && !!this.style.getTerrain() && !!this.terrain && !this.terrain.renderingToTexture || this.forceTerrainMode;
            }
            linearFloatFilteringSupported() {
                return null != this.context.extTextureFloatLinear;
            }
            currentGlobalDefines(e1, t1, i) {
                const o = void 0 === i ? this.terrain && this.terrain.renderingToTexture : i, r = [];
                return this.style && this.style.enable3dLights() && ("globeRaster" === e1 || "terrainRaster" === e1 ? (r.push("LIGHTING_3D_MODE"), r.push("LIGHTING_3D_ALPHA_EMISSIVENESS")) : o || r.push("LIGHTING_3D_MODE")), this.terrainRenderModeElevated() && (r.push("TERRAIN"), this.linearFloatFilteringSupported() && r.push("TERRAIN_DEM_FLOAT_FORMAT")), "globe" === this.transform.projection.name && r.push("GLOBE"), !this._fogVisible || o || void 0 !== t1 && !t1 || r.push("FOG"), o && r.push("RENDER_TO_TEXTURE"), this._showOverdrawInspector && r.push("OVERDRAW_INSPECTOR"), r;
            }
            getOrCreateProgram(e1, t1) {
                this.cache = this.cache || {};
                const i = t1 && t1.defines || [], o = t1 && t1.config, r = this.currentGlobalDefines(e1, t1 && t1.overrideFog, t1 && t1.overrideRtt).concat(i), n = hn.cacheKey(er[e1], e1, r, o);
                return this.cache[n] || (this.cache[n] = new hn(this.context, e1, er[e1], o, Xn[e1], r)), this.cache[n];
            }
            setCustomLayerDefaults() {
                this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.frontFace.setDefault(), this.context.cullFaceSide.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
            }
            setBaseState() {
                const e1 = this.context.gl;
                this.context.cullFace.set(!1), this.context.viewport.set([
                    0,
                    0,
                    this.width,
                    this.height
                ]), this.context.blendEquation.set(e1.FUNC_ADD);
            }
            initDebugOverlayCanvas() {
                null == this.debugOverlayCanvas && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new e1.T(this.context, this.debugOverlayCanvas, this.context.gl.RGBA8));
            }
            destroy() {
                this._terrain && this._terrain.destroy(), this._atmosphere && (this._atmosphere.destroy(), this._atmosphere = void 0), this.globeSharedBuffers && this.globeSharedBuffers.destroy(), this.emptyTexture.destroy(), this.debugOverlayTexture && this.debugOverlayTexture.destroy(), this._wireframeDebugCache.destroy(), this.depthFBO && (this.depthFBO.destroy(), this.depthFBO = void 0, this.depthTexture = void 0), this.emptyDepthTexture && this.emptyDepthTexture.destroy();
            }
            prepareDrawTile() {
                this.terrain && this.terrain.prepareDrawTile();
            }
            uploadCommonLightUniforms(t1, i) {
                if (this.style.enable3dLights()) {
                    const o = this.style.directionalLight, r = this.style.ambientLight;
                    if (o && r) {
                        const n = ((t1, i, o)=>{
                            const r = t1.properties.get("direction"), n = "none" === t1.properties.get("color-use-theme"), s = t1.properties.get("color").toNonPremultipliedRenderColor(n ? null : o.getLut(t1.scope)).toArray01(), a = t1.properties.get("intensity"), l = "none" === i.properties.get("color-use-theme"), c = i.properties.get("color").toNonPremultipliedRenderColor(l ? null : o.getLut(i.scope)).toArray01(), h = i.properties.get("intensity"), d = [
                                r.x,
                                r.y,
                                r.z
                            ], _ = e1.dz(c, h), u = e1.dz(s, a);
                            return {
                                u_lighting_ambient_color: _,
                                u_lighting_directional_dir: d,
                                u_lighting_directional_color: u,
                                u_ground_radiance: an(d, u, _)
                            };
                        })(o, r, this.style);
                        i.setLightsUniformValues(t1, n);
                    }
                }
            }
            uploadCommonUniforms(t1, i, o, r, n) {
                if (this.uploadCommonLightUniforms(t1, i), this.terrain && this.terrain.renderingToTexture) return;
                const s = this.style.fog;
                if (s) {
                    const n = s.getOpacity(this.transform.pitch), a = ((t1, i, o, r, n, s, a, l, c, h, d, _)=>{
                        const u = t1.transform, p = "none" === i.properties.get("color-use-theme"), f = i.properties.get("color").toNonPremultipliedRenderColor(p ? null : t1.style.getLut(i.scope)).toArray01();
                        f[3] = r;
                        const m = t1.frameCounter / 1e3 % 1, [g, v] = i.properties.get("vertical-range");
                        return {
                            u_fog_matrix: o ? u.calculateFogTileMatrix(o) : _ || t1.identityMat,
                            u_fog_range: i.getFovAdjustedRange(u._fov),
                            u_fog_color: f,
                            u_fog_horizon_blend: i.properties.get("horizon-blend"),
                            u_fog_vertical_limit: [
                                Math.min(g, v),
                                v
                            ],
                            u_fog_temporal_offset: m,
                            u_frustum_tl: n,
                            u_frustum_tr: s,
                            u_frustum_br: a,
                            u_frustum_bl: l,
                            u_globe_pos: c,
                            u_globe_radius: h,
                            u_viewport: d,
                            u_globe_transition: e1.al(u.zoom),
                            u_is_globe: +("globe" === u.projection.name)
                        };
                    })(this, s, o, n, this.transform.frustumCorners.TL, this.transform.frustumCorners.TR, this.transform.frustumCorners.BR, this.transform.frustumCorners.BL, this.transform.globeCenterInViewSpace, this.transform.globeRadius, [
                        this.transform.width * e1.o.devicePixelRatio,
                        this.transform.height * e1.o.devicePixelRatio
                    ], r);
                    i.setFogUniformValues(t1, a);
                }
                n && i.setCutoffUniformValues(t1, n.uniformValues);
            }
            setTileLoadedFlag(e1) {
                this.tileLoaded = e1;
            }
            saveCanvasCopy() {
                const e1 = this.canvasCopy();
                e1 && (this.frameCopies.push(e1), this.tileLoaded = !1);
            }
            canvasCopy() {
                const e1 = this.context.gl, t1 = e1.createTexture();
                return e1.bindTexture(e1.TEXTURE_2D, t1), e1.copyTexImage2D(e1.TEXTURE_2D, 0, e1.RGBA, 0, 0, e1.drawingBufferWidth, e1.drawingBufferHeight, 0), t1;
            }
            getCanvasCopiesAndTimestamps() {
                return {
                    canvasCopies: this.frameCopies,
                    timeStamps: this.loadTimeStamps
                };
            }
            averageElevationNeedsEasing() {
                if (!this.transform._elevation) return !1;
                const e1 = this.style && this.style.fog;
                return !!e1 && 0 !== e1.getOpacity(this.transform.pitch);
            }
            getBackgroundTiles() {
                const t1 = this._backgroundTiles, i = this._backgroundTiles = {}, o = this.transform.coveringTiles({
                    tileSize: 512
                });
                for (const r of o)i[r.key] = t1[r.key] || new e1.b1(r, 512, this.transform.tileZoom, this, void 0, this.worldview);
                return i;
            }
            clearBackgroundTiles() {
                this._backgroundTiles = {};
            }
            isSourceForClippingOrConflation(e1, t1) {
                return !(!e1.is3D(!(!this.terrain || !this.terrain.enabled)) || "clip" !== e1.type && "building" !== e1.type && (e1.minzoom && e1.minzoom > this.transform.zoom || (this.style._clipLayerPresent || "building" !== e1.sourceLayer && "procedural_buildings" !== e1.sourceLayer) && (!t1 || "batched-model" !== t1.type)));
            }
            isTileAffectedByFog(e1) {
                if (!this.style || !this.style.fog) return !1;
                if ("globe" === this.transform.projection.name) return !0;
                let t1 = this._cachedTileFogOpacities[e1.key];
                return t1 || (this._cachedTileFogOpacities[e1.key] = t1 = this.style.fog.getOpacityForTile(e1)), t1[0] >= Ye || t1[1] >= Ye;
            }
            setupDepthForOcclusion(e1, t1, i) {
                const o = this.context, r = o.gl, n = !!i;
                var s;
                i || (i = {
                    u_dem: 2,
                    u_dem_prev: 4,
                    u_dem_tl: [
                        0,
                        0
                    ],
                    u_dem_tl_prev: [
                        0,
                        0
                    ],
                    u_dem_scale: 0,
                    u_dem_scale_prev: 0,
                    u_dem_size: 0,
                    u_dem_lerp: 1,
                    u_depth: 3,
                    u_depth_size_inv: [
                        0,
                        0
                    ],
                    u_depth_range_unpack: [
                        0,
                        1
                    ],
                    u_occluder_half_size: 16,
                    u_occlusion_depth_offset: -0.0001,
                    u_exaggeration: 0
                }), o.activeTexture.set(r.TEXTURE3), e1 && this.depthFBO && this.depthTexture ? (this.depthTexture.bind(r.NEAREST, r.CLAMP_TO_EDGE), i.u_depth_size_inv = [
                    1 / this.depthFBO.width,
                    1 / this.depthFBO.height
                ], i.u_depth_range_unpack = [
                    2 / ((s = this.depthRangeFor3D)[1] - s[0]),
                    -1 - 2 * s[0] / (s[1] - s[0])
                ], i.u_occluder_half_size = .5 * this.occlusionParams.occluderSize, i.u_occlusion_depth_offset = this.occlusionParams.depthOffset) : this.emptyDepthTexture.bind(r.NEAREST, r.CLAMP_TO_EDGE), o.activeTexture.set(r.TEXTURE0), n || t1.setTerrainUniformValues(o, i);
            }
            updateEmissiveMode() {
                if (this._forceEmissiveMode) return;
                const e1 = this.style.hasDataDrivenEmissiveStrength();
                this.emissiveMode = e1 ? this.context.extBlendFuncExtended ? "dual-source-blending" : "mrt-fallback" : "constant";
            }
        }
        function ka(e1, t1) {
            let i = !1, o = null;
            const r = ()=>{
                o = null, i && (e1(), o = setTimeout(r, t1), i = !1);
            };
            return ()=>(i = !0, o || r(), o);
        }
        class Na {
            constructor(t1){
                this._hashName = t1 && encodeURIComponent(t1), e1.a_([
                    "_getCurrentHash",
                    "_onHashChange",
                    "_updateHash"
                ], this), this._updateHash = ka(this._updateHashUnthrottled.bind(this), 300);
            }
            addTo(e1) {
                return this._map = e1, window.addEventListener("hashchange", this._onHashChange, !1), e1.on("moveend", this._updateHash), this;
            }
            remove() {
                return this._map ? (this._map.off("moveend", this._updateHash), window.removeEventListener("hashchange", this._onHashChange, !1), clearTimeout(this._updateHash()), this._map = void 0, this) : this;
            }
            getHashString() {
                const e1 = this._map;
                if (!e1) return "";
                const t1 = Ua(e1);
                if (this._hashName) {
                    const e1 = this._hashName;
                    let i = !1;
                    const o = location.hash.slice(1).split("&").map((o)=>{
                        const r = o.split("=")[0];
                        return r === e1 ? (i = !0, `${r}=${t1}`) : o;
                    }).filter((e1)=>e1);
                    return i || o.push(`${e1}=${t1}`), `#${o.join("&")}`;
                }
                return `#${t1}`;
            }
            _getCurrentHash() {
                const e1 = location.hash.replace("#", "");
                if (this._hashName) {
                    let t1;
                    return e1.split("&").map((e1)=>e1.split("=")).forEach((e1)=>{
                        e1[0] === this._hashName && (t1 = e1);
                    }), (t1 && t1[1] || "").split("/");
                }
                return e1.split("/");
            }
            _onHashChange() {
                const e1 = this._map;
                if (!e1) return !1;
                const t1 = this._getCurrentHash();
                if (t1.length >= 3 && !t1.some((e1)=>isNaN(Number(e1)))) {
                    const i = e1.dragRotate.isEnabled() && e1.touchZoomRotate.isEnabled() ? +(t1[3] || 0) : e1.getBearing();
                    return e1.jumpTo({
                        center: [
                            +t1[2],
                            +t1[1]
                        ],
                        zoom: +t1[0],
                        bearing: i,
                        pitch: +(t1[4] || 0)
                    }), !0;
                }
                return !1;
            }
            _updateHashUnthrottled() {
                history.replaceState(history.state, "", location.href.replace(/(#.+)?$/, this.getHashString()));
            }
        }
        function Ua(e1, t1) {
            const i = e1.getCenter(), o = Math.round(100 * e1.getZoom()) / 100, r = Math.ceil((o * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), n = Math.pow(10, r), s = Math.round(i.lng * n) / n, a = Math.round(i.lat * n) / n, l = e1.getBearing(), c = e1.getPitch();
            let h = t1 ? `/${s}/${a}/${o}` : `${o}/${a}/${s}`;
            return (l || c) && (h += "/" + Math.round(10 * l) / 10), c && (h += `/${Math.round(c)}`), h;
        }
        const Va = {
            linearity: .3,
            easing: e1.eJ(0, 0, .3, 1)
        }, ja = Object.assign({
            deceleration: 2500,
            maxSpeed: 1400
        }, Va), Ga = Object.assign({
            deceleration: 20,
            maxSpeed: 1400
        }, Va), qa = Object.assign({
            deceleration: 1e3,
            maxSpeed: 360
        }, Va), Za = Object.assign({
            deceleration: 1e3,
            maxSpeed: 90
        }, Va);
        class Ha {
            constructor(e1){
                this._map = e1, this.clear();
            }
            clear() {
                this._inertiaBuffer = [];
            }
            record(t1) {
                this._drainInertiaBuffer(), this._inertiaBuffer.push({
                    time: e1.o.now(),
                    settings: t1
                });
            }
            _drainInertiaBuffer() {
                const t1 = this._inertiaBuffer, i = e1.o.now();
                for(; t1.length > 0 && i - t1[0].time > 160;)t1.shift();
            }
            _onMoveEnd(t1) {
                if (this._map._prefersReducedMotion()) return;
                if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
                const i = {
                    zoom: 0,
                    bearing: 0,
                    pitch: 0,
                    pan: new e1.P(0, 0),
                    pinchAround: void 0,
                    around: void 0
                };
                for (const { settings: e1 } of this._inertiaBuffer)i.zoom += e1.zoomDelta || 0, i.bearing += e1.bearingDelta || 0, i.pitch += e1.pitchDelta || 0, e1.panDelta && i.pan._add(e1.panDelta), e1.around && (i.around = e1.around), e1.pinchAround && (i.pinchAround = e1.pinchAround);
                const o = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, r = {};
                if (i.pan.mag()) {
                    const e1 = $a(i.pan.mag(), o, Object.assign({}, ja, t1 || {}));
                    r.offset = i.pan.mult(e1.amount / i.pan.mag()), r.center = this._map.transform.center, Wa(r, e1);
                }
                if (i.zoom) {
                    const e1 = $a(i.zoom, o, Ga);
                    r.zoom = this._map.transform.zoom + e1.amount, Wa(r, e1);
                }
                if (i.bearing) {
                    const t1 = $a(i.bearing, o, qa);
                    r.bearing = this._map.transform.bearing + e1.aC(t1.amount, -179, 179), Wa(r, t1);
                }
                if (i.pitch) {
                    const e1 = $a(i.pitch, o, Za);
                    r.pitch = this._map.transform.pitch + e1.amount, Wa(r, e1);
                }
                if (r.zoom || r.bearing) {
                    const e1 = void 0 === i.pinchAround ? i.around : i.pinchAround;
                    r.around = e1 ? this._map.unproject(e1) : this._map.getCenter();
                }
                return this.clear(), r.noMoveStart = !0, r;
            }
        }
        function Wa(e1, t1) {
            (!e1.duration || e1.duration < t1.duration) && (e1.duration = t1.duration, e1.easing = t1.easing);
        }
        function $a(t1, i, o) {
            const { maxSpeed: r, linearity: n, deceleration: s } = o, a = e1.aC(t1 * n / (i / 1e3), -r, r), l = Math.abs(a) / (s * n);
            return {
                easing: o.easing,
                duration: 1e3 * l,
                amount: a * (l / 2)
            };
        }
        class Xa extends e1.C {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e1, t1, i, o = {}){
                const r = g(t1.getCanvasContainer(), i), n = t1.unproject(r);
                super(e1, Object.assign({
                    point: r,
                    lngLat: n,
                    originalEvent: i
                }, o)), this._defaultPrevented = !1, this.target = t1;
            }
        }
        class Ya extends e1.C {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(t1, i, o){
                const r = "touchend" === t1 ? o.changedTouches : o.touches, n = v(i.getCanvasContainer(), r), s = n.map((e1)=>i.unproject(e1)), a = n.reduce((e1, t1, i, o)=>e1.add(t1.div(o.length)), new e1.P(0, 0));
                super(t1, {
                    points: n,
                    point: a,
                    lngLats: s,
                    lngLat: i.unproject(a),
                    originalEvent: o
                }), this._defaultPrevented = !1;
            }
        }
        class Ka extends e1.C {
            preventDefault() {
                this._defaultPrevented = !0;
            }
            get defaultPrevented() {
                return this._defaultPrevented;
            }
            constructor(e1, t1){
                super("wheel", {
                    originalEvent: t1
                }), this._defaultPrevented = !1;
            }
        }
        class Qa {
            constructor(e1, t1){
                this._map = e1, this._clickTolerance = t1.clickTolerance;
            }
            reset() {
                this._mousedownPos = void 0;
            }
            wheel(e1) {
                return this._firePreventable(new Ka(this._map, e1));
            }
            mousedown(e1, t1) {
                return this._mousedownPos = t1, this._firePreventable(new Xa(e1.type, this._map, e1));
            }
            mouseup(e1) {
                this._map.fire(new Xa(e1.type, this._map, e1));
            }
            preclick(e1) {
                const t1 = new MouseEvent("preclick", e1);
                this._map.fire(new Xa(t1.type, this._map, t1));
            }
            click(e1, t1) {
                this._mousedownPos && this._mousedownPos.dist(t1) >= this._clickTolerance || (this.preclick(e1), this._map.fire(new Xa(e1.type, this._map, e1)));
            }
            dblclick(e1) {
                return this._firePreventable(new Xa(e1.type, this._map, e1));
            }
            mouseover(e1) {
                this._map.fire(new Xa(e1.type, this._map, e1));
            }
            mouseout(e1) {
                this._map.fire(new Xa(e1.type, this._map, e1));
            }
            touchstart(e1) {
                return this._firePreventable(new Ya(e1.type, this._map, e1));
            }
            touchmove(e1) {
                this._map.fire(new Ya(e1.type, this._map, e1));
            }
            touchend(e1) {
                this._map.fire(new Ya(e1.type, this._map, e1));
            }
            touchcancel(e1) {
                this._map.fire(new Ya(e1.type, this._map, e1));
            }
            _firePreventable(e1) {
                if (this._map.fire(e1), e1.defaultPrevented) return {};
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class Ja {
            constructor(e1){
                this._map = e1;
            }
            reset() {
                this._delayContextMenu = !1, this._contextMenuEvent = void 0;
            }
            mousemove(e1) {
                this._map.fire(new Xa(e1.type, this._map, e1));
            }
            mousedown() {
                this._delayContextMenu = !0;
            }
            mouseup() {
                this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new Xa("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
            }
            contextmenu(e1) {
                this._delayContextMenu ? this._contextMenuEvent = e1 : this._map.fire(new Xa(e1.type, this._map, e1)), this._map.listens("contextmenu") && e1.preventDefault();
            }
            isEnabled() {
                return !0;
            }
            isActive() {
                return !1;
            }
            enable() {}
            disable() {}
        }
        class el {
            constructor(e1, t1){
                this._map = e1, this._el = e1.getCanvasContainer(), this._container = e1.getContainer(), this._clickTolerance = t1.clickTolerance || 1;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            enable() {
                this.isEnabled() || (this._enabled = !0);
            }
            disable() {
                this.isEnabled() && (this._enabled = !1);
            }
            mousedown(e1, t1) {
                this.isEnabled() && e1.shiftKey && 0 === e1.button && (u(), this._startPos = this._lastPos = t1, this._active = !0);
            }
            mousemoveWindow(e1, t1) {
                if (!this._active) return;
                const i = t1, o = this._startPos, r = this._lastPos;
                if (!o || !r || r.equals(i) || !this._box && i.dist(o) < this._clickTolerance) return;
                this._lastPos = i, this._box || (this._box = l("div", "mapboxgl-boxzoom", this._container), this._container.classList.add("mapboxgl-crosshair"), this._fireEvent("boxzoomstart", e1));
                const n = Math.min(o.x, i.x), s = Math.max(o.x, i.x), a = Math.min(o.y, i.y), c = Math.max(o.y, i.y);
                this._map._requestDomTask(()=>{
                    this._box && (this._box.style.transform = `translate(${n}px,${a}px)`, this._box.style.width = s - n + "px", this._box.style.height = c - a + "px");
                });
            }
            mouseupWindow(t1, i) {
                if (!this._active) return;
                const o = this._startPos, r = i;
                if (o && 0 === t1.button) {
                    if (this.reset(), m(), o.x !== r.x || o.y !== r.y) return this._map.fire(new e1.C("boxzoomend", {
                        originalEvent: t1
                    })), {
                        cameraAnimation: (e1)=>e1.fitScreenCoordinates(o, r, this._map.getBearing(), {
                                linear: !1
                            })
                    };
                    this._fireEvent("boxzoomcancel", t1);
                }
            }
            keydown(e1) {
                this._active && 27 === e1.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", e1));
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1, this._container.classList.remove("mapboxgl-crosshair"), this._box && (this._box.remove(), this._box = null), p(), delete this._startPos, delete this._lastPos;
            }
            _fireEvent(t1, i) {
                return this._map.fire(new e1.C(t1, {
                    originalEvent: i
                }));
            }
        }
        function tl(e1, t1) {
            const i = {};
            for(let o = 0; o < e1.length; o++)i[e1[o].identifier] = t1[o];
            return i;
        }
        class il {
            constructor(e1){
                this.reset(), this.numTouches = e1.numTouches;
            }
            reset() {
                this.centroid = void 0, this.startTime = 0, this.touches = {}, this.aborted = !1;
            }
            touchstart(t1, i, o) {
                (this.centroid || o.length > this.numTouches) && (this.aborted = !0), this.aborted || (0 === this.startTime && (this.startTime = t1.timeStamp), o.length === this.numTouches && (this.centroid = function(t1) {
                    const i = new e1.P(0, 0);
                    for (const e1 of t1)i._add(e1);
                    return i.div(t1.length);
                }(i), this.touches = tl(o, i)));
            }
            touchmove(e1, t1, i) {
                if (this.aborted || !this.centroid) return;
                const o = tl(i, t1);
                for(const e1 in this.touches){
                    const t1 = o[e1];
                    (!t1 || t1.dist(this.touches[e1]) > 30) && (this.aborted = !0);
                }
            }
            touchend(e1, t1, i) {
                if ((!this.centroid || e1.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === i.length) {
                    const e1 = !this.aborted && this.centroid;
                    if (this.reset(), e1) return e1;
                }
            }
        }
        class ol {
            constructor(e1){
                this.singleTap = new il(e1), this.numTaps = e1.numTaps, this.reset();
            }
            reset() {
                this.lastTime = 1 / 0, this.lastTap = void 0, this.count = 0, this.singleTap.reset();
            }
            touchstart(e1, t1, i) {
                this.singleTap.touchstart(e1, t1, i);
            }
            touchmove(e1, t1, i) {
                this.singleTap.touchmove(e1, t1, i);
            }
            touchend(e1, t1, i) {
                const o = this.singleTap.touchend(e1, t1, i);
                if (o) {
                    const t1 = e1.timeStamp - this.lastTime < 500, i = !this.lastTap || this.lastTap.dist(o) < 30;
                    if (t1 && i || this.reset(), this.count++, this.lastTime = e1.timeStamp, this.lastTap = o, this.count === this.numTaps) return this.reset(), o;
                }
            }
        }
        class rl {
            constructor(){
                this._zoomIn = new ol({
                    numTouches: 1,
                    numTaps: 2
                }), this._zoomOut = new ol({
                    numTouches: 2,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
            }
            touchstart(e1, t1, i) {
                this._zoomIn.touchstart(e1, t1, i), this._zoomOut.touchstart(e1, t1, i);
            }
            touchmove(e1, t1, i) {
                this._zoomIn.touchmove(e1, t1, i), this._zoomOut.touchmove(e1, t1, i);
            }
            touchend(e1, t1, i) {
                const o = this._zoomIn.touchend(e1, t1, i), r = this._zoomOut.touchend(e1, t1, i);
                return o ? (this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t1)=>t1.easeTo({
                            duration: 300,
                            zoom: t1.getZoom() + 1,
                            around: t1.unproject(o)
                        }, {
                            originalEvent: e1
                        })
                }) : r ? (this._active = !0, e1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                    cameraAnimation: (t1)=>t1.easeTo({
                            duration: 300,
                            zoom: t1.getZoom() - 1,
                            around: t1.unproject(r)
                        }, {
                            originalEvent: e1
                        })
                }) : void 0;
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        const nl = 0, sl = 2, al = {
            [nl]: 1,
            [sl]: 2
        }, ll = {
            Control: "ctrlKey",
            Alt: "altKey",
            Shift: "shiftKey",
            Meta: "metaKey"
        };
        class cl {
            constructor(e1){
                this.reset(), this._clickTolerance = e1.clickTolerance || 1;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1, this._moved = !1, this._lastPoint = void 0, this._eventButton = void 0;
            }
            _correctButton(e1, t1) {
                return !1;
            }
            _move(e1, t1) {
                return {};
            }
            mousedown(e1, t1) {
                if (this._lastPoint) return;
                const i = y(e1);
                this._correctButton(e1, i) && (this._lastPoint = t1, this._eventButton = i);
            }
            mousemoveWindow(e1, t1) {
                const i = this._lastPoint;
                if (i) {
                    if (e1.preventDefault(), null != this._eventButton && function(e1, t1) {
                        const i = al[t1];
                        return void 0 === e1.buttons || (e1.buttons & i) !== i;
                    }(e1, this._eventButton)) this.reset();
                    else if (this._moved || !(t1.dist(i) < this._clickTolerance)) return this._moved = !0, this._lastPoint = t1, this._move(i, t1);
                }
            }
            mouseupWindow(e1) {
                this._lastPoint && y(e1) === this._eventButton && (this._moved && m(), this.reset());
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class hl extends cl {
            mousedown(e1, t1) {
                super.mousedown(e1, t1), this._lastPoint && (this._active = !0);
            }
            _correctButton(e1, t1) {
                return 0 === t1 && !e1.ctrlKey;
            }
            _move(e1, t1) {
                return {
                    around: t1,
                    panDelta: t1.sub(e1)
                };
            }
        }
        class dl extends cl {
            constructor(e1){
                super(e1), this._pitchRotateKey = e1.pitchRotateKey ? ll[e1.pitchRotateKey] : void 0;
            }
            _correctButton(e1, t1) {
                return this._pitchRotateKey ? 0 === t1 && e1[this._pitchRotateKey] : 0 === t1 && e1.ctrlKey || 2 === t1;
            }
            _move(e1, t1) {
                const i = .8 * (t1.x - e1.x);
                if (i) return this._active = !0, {
                    bearingDelta: i
                };
            }
            contextmenu(e1) {
                this._pitchRotateKey || e1.preventDefault();
            }
        }
        class _l extends cl {
            constructor(e1){
                super(e1), this._pitchRotateKey = e1.pitchRotateKey ? ll[e1.pitchRotateKey] : void 0;
            }
            _correctButton(e1, t1) {
                return this._pitchRotateKey ? 0 === t1 && e1[this._pitchRotateKey] : 0 === t1 && e1.ctrlKey || 2 === t1;
            }
            _move(e1, t1) {
                const i = -0.5 * (t1.y - e1.y);
                if (i) return this._active = !0, {
                    pitchDelta: i
                };
            }
            contextmenu(e1) {
                this._pitchRotateKey || e1.preventDefault();
            }
        }
        class ul {
            constructor(t1, i){
                this._map = t1, this._el = t1.getCanvasContainer(), this._minTouches = 1, this._clickTolerance = i.clickTolerance || 1, this.reset(), e1.a_([
                    "_addTouchPanBlocker",
                    "_showTouchPanBlockerAlert"
                ], this);
            }
            reset() {
                this._active = !1, this._touches = {}, this._sum = new e1.P(0, 0);
            }
            touchstart(e1, t1, i) {
                return this._calculateTransform(e1, t1, i);
            }
            touchmove(t1, i, o) {
                if (this._active && !(o.length < this._minTouches)) {
                    if (this._map._cooperativeGestures && !this._map.isMoving()) {
                        if (1 === o.length && !e1.eK()) return void this._showTouchPanBlockerAlert();
                        "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
                    }
                    return t1.cancelable && t1.preventDefault(), this._calculateTransform(t1, i, o);
                }
            }
            touchend(e1, t1, i) {
                this._calculateTransform(e1, t1, i), this._active && i.length < this._minTouches && this.reset();
            }
            touchcancel() {
                this.reset();
            }
            _calculateTransform(t1, i, o) {
                o.length > 0 && (this._active = !0);
                const r = tl(o, i), n = new e1.P(0, 0), s = new e1.P(0, 0);
                let a = 0;
                for(const e1 in r){
                    const t1 = r[e1], i = this._touches[e1];
                    i && (n._add(t1), s._add(t1.sub(i)), a++, r[e1] = t1);
                }
                if (this._touches = r, a < this._minTouches || !s.mag()) return;
                const l = s.div(a);
                return this._sum._add(l), this._sum.mag() < this._clickTolerance ? void 0 : {
                    around: n.div(a),
                    panDelta: l
                };
            }
            enable() {
                this._enabled = !0, this._map._cooperativeGestures && (this._addTouchPanBlocker(), this._el.classList.add("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page"));
            }
            disable() {
                this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove(), this._el.classList.remove("mapboxgl-touch-pan-blocker-override", "mapboxgl-scrollable-page")), this.reset();
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return !!this._active;
            }
            _addTouchPanBlocker() {
                this._map && !this._alertContainer && (this._alertContainer = l("div", "mapboxgl-touch-pan-blocker", this._map._container), this._alertContainer.textContent = this._map._getUIString("TouchPanBlocker.Message"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(.05 * this._el.clientWidth)))}px`);
            }
            _showTouchPanBlockerAlert() {
                this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-touch-pan-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = window.setTimeout(()=>{
                    this._alertContainer.classList.remove("mapboxgl-touch-pan-blocker-show"), this._alertContainer.removeAttribute("role");
                }, 500);
            }
        }
        class pl {
            constructor(){
                this.reset();
            }
            reset() {
                this._active = !1, this._firstTwoTouches = void 0;
            }
            _start(e1) {}
            _move(e1, t1, i) {
                return {};
            }
            touchstart(e1, t1, i) {
                this._firstTwoTouches || i.length < 2 || (this._firstTwoTouches = [
                    i[0].identifier,
                    i[1].identifier
                ], this._start([
                    t1[0],
                    t1[1]
                ]));
            }
            touchmove(e1, t1, i) {
                const o = this._firstTwoTouches;
                if (!o) return;
                e1.preventDefault();
                const [r, n] = o, s = fl(i, t1, r), a = fl(i, t1, n);
                if (!s || !a) return;
                const l = this._aroundCenter ? null : s.add(a).div(2);
                return this._move([
                    s,
                    a
                ], l, e1);
            }
            touchend(e1, t1, i) {
                if (!this._firstTwoTouches) return;
                const [o, r] = this._firstTwoTouches, n = fl(i, t1, o), s = fl(i, t1, r);
                n && s || (this._active && m(), this.reset());
            }
            touchcancel() {
                this.reset();
            }
            enable(e1) {
                this._enabled = !0, this._aroundCenter = !!e1 && "center" === e1.around;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        function fl(e1, t1, i) {
            for(let o = 0; o < e1.length; o++)if (e1[o].identifier === i) return t1[o];
        }
        function ml(e1, t1) {
            return Math.log2(e1 / t1);
        }
        class gl extends pl {
            reset() {
                super.reset(), this._distance = 0, this._startDistance = 0;
            }
            _start(e1) {
                this._startDistance = this._distance = e1[0].dist(e1[1]);
            }
            _move(e1, t1) {
                const i = this._distance;
                if (this._distance = e1[0].dist(e1[1]), this._active || !(Math.abs(ml(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                    zoomDelta: ml(this._distance, i),
                    pinchAround: t1
                };
            }
        }
        function vl(e1, t1) {
            return 180 * e1.angleWith(t1) / Math.PI;
        }
        class yl extends pl {
            reset() {
                super.reset(), this._minDiameter = 0, this._startVector = void 0, this._vector = void 0;
            }
            _start(e1) {
                this._startVector = this._vector = e1[0].sub(e1[1]), this._minDiameter = e1[0].dist(e1[1]);
            }
            _move(e1, t1) {
                const i = this._vector;
                if (this._vector = e1[0].sub(e1[1]), i && (this._active || !this._isBelowThreshold(this._vector))) return this._active = !0, {
                    bearingDelta: vl(this._vector, i),
                    pinchAround: t1
                };
            }
            _isBelowThreshold(e1) {
                this._minDiameter = Math.min(this._minDiameter, e1.mag());
                const t1 = 25 / (Math.PI * this._minDiameter) * 360, i = this._startVector;
                if (!i) return !1;
                const o = vl(e1, i);
                return Math.abs(o) < t1;
            }
        }
        function xl(e1) {
            return Math.abs(e1.y) > Math.abs(e1.x);
        }
        class bl extends pl {
            constructor(e1){
                super(), this._map = e1;
            }
            reset() {
                super.reset(), this._valid = void 0, this._firstMove = void 0, this._lastPoints = void 0;
            }
            _start(e1) {
                this._lastPoints = e1, xl(e1[0].sub(e1[1])) && (this._valid = !1);
            }
            _move(t1, i, o) {
                const r = this._lastPoints;
                if (!r) return;
                const n = t1[0].sub(r[0]), s = t1[1].sub(r[1]);
                return this._map._cooperativeGestures && !e1.eK() && o.touches.length < 3 || (this._valid = this.gestureBeginsVertically(n, s, o.timeStamp), !this._valid) ? void 0 : (this._lastPoints = t1, this._active = !0, {
                    pitchDelta: (n.y + s.y) / 2 * -0.5
                });
            }
            gestureBeginsVertically(e1, t1, i) {
                if (void 0 !== this._valid) return this._valid;
                const o = e1.mag() >= 2, r = t1.mag() >= 2;
                if (!o && !r) return;
                if (!o || !r) return null == this._firstMove && (this._firstMove = i), i - this._firstMove < 100 && void 0;
                const n = e1.y > 0 == t1.y > 0;
                return xl(e1) && xl(t1) && n;
            }
        }
        const wl = {
            panStep: 100,
            bearingStep: 15,
            pitchStep: 10
        };
        class Tl {
            constructor(){
                const e1 = wl;
                this._panStep = e1.panStep, this._bearingStep = e1.bearingStep, this._pitchStep = e1.pitchStep, this._rotationDisabled = !1;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            keydown(e1) {
                if (e1.altKey || e1.ctrlKey || e1.metaKey) return;
                let t1 = 0, i = 0, o = 0, r = 0, n = 0;
                switch(e1.keyCode){
                    case 61:
                    case 107:
                    case 171:
                    case 187:
                        t1 = 1;
                        break;
                    case 189:
                    case 109:
                    case 173:
                        t1 = -1;
                        break;
                    case 37:
                        e1.shiftKey ? i = -1 : (e1.preventDefault(), r = -1);
                        break;
                    case 39:
                        e1.shiftKey ? i = 1 : (e1.preventDefault(), r = 1);
                        break;
                    case 38:
                        e1.shiftKey ? o = 1 : (e1.preventDefault(), n = -1);
                        break;
                    case 40:
                        e1.shiftKey ? o = -1 : (e1.preventDefault(), n = 1);
                        break;
                    default:
                        return;
                }
                return this._rotationDisabled && (i = 0, o = 0), {
                    cameraAnimation: (s)=>{
                        const a = s.getZoom();
                        s.easeTo({
                            duration: 300,
                            easeId: "keyboardHandler",
                            easing: El,
                            zoom: t1 ? Math.round(a) + t1 * (e1.shiftKey ? 2 : 1) : a,
                            bearing: s.getBearing() + i * this._bearingStep,
                            pitch: s.getPitch() + o * this._pitchStep,
                            offset: [
                                -r * this._panStep,
                                -n * this._panStep
                            ],
                            center: s.getCenter()
                        }, {
                            originalEvent: e1
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
            disableRotation() {
                this._rotationDisabled = !0;
            }
            enableRotation() {
                this._rotationDisabled = !1;
            }
        }
        function El(e1) {
            return e1 * (2 - e1);
        }
        const Sl = 4.000244140625, Cl = 1 / 450;
        class Il {
            constructor(t1, i){
                this._map = t1, this._el = t1.getCanvasContainer(), this._handler = i, this._delta = 0, this._lastDelta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = Cl, e1.a_([
                    "_onTimeout",
                    "_addScrollZoomBlocker",
                    "_showBlockerAlert"
                ], this);
            }
            setZoomRate(e1) {
                this._defaultZoomRate = e1;
            }
            setWheelZoomRate(e1) {
                this._wheelZoomRate = e1;
            }
            isEnabled() {
                return !!this._enabled;
            }
            isActive() {
                return this._active || void 0 !== this._finishTimeout;
            }
            isZooming() {
                return !!this._zooming;
            }
            enable(e1) {
                this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!e1 && "center" === e1.around, this._map._cooperativeGestures && this._addScrollZoomBlocker());
            }
            disable() {
                this.isEnabled() && (this._enabled = !1, this._map._cooperativeGestures && (clearTimeout(this._alertTimer), this._alertContainer.remove()));
            }
            wheel(t1) {
                if (!this.isEnabled()) return;
                if (this._map._cooperativeGestures) {
                    if (!(t1.ctrlKey || t1.metaKey || this.isZooming() || e1.eK())) return void this._showBlockerAlert();
                    "hidden" !== this._alertContainer.style.visibility && (this._alertContainer.style.visibility = "hidden", clearTimeout(this._alertTimer));
                }
                let i = t1.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * t1.deltaY : t1.deltaY;
                const o = e1.o.now(), r = o - (this._lastWheelEventTime || 0);
                this._lastWheelEventTime = o, 0 !== i && i % Sl === 0 ? this._type = "wheel" : 0 !== i && Math.abs(i) < 4 ? this._type = "trackpad" : r > 400 ? (this._type = null, this._lastValue = i, this._timeout = window.setTimeout(this._onTimeout, 40, t1)) : this._type || (this._type = Math.abs(r * i) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, i += this._lastValue)), t1.shiftKey && i && (i /= 4), this._type && (this._lastWheelEvent = t1, this._delta -= i, this._active || this._start(t1)), t1.preventDefault();
            }
            _onTimeout(e1) {
                this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(e1);
            }
            _start(e1) {
                if (!this._delta) return;
                this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                const t1 = g(this._el, e1);
                this._aroundPoint = this._aroundCenter ? this._map.transform.centerPoint : t1, this._aroundCoord = this._map.transform.pointCoordinate3D(this._aroundPoint), this._targetZoom = void 0, this._frameId || (this._frameId = !0, this._handler._triggerRenderFrame());
            }
            renderFrame() {
                if (!this._frameId) return;
                if (this._frameId = null, !this.isActive()) return;
                const t1 = this._map.transform;
                "wheel" === this._type && t1.projection.wrap && (t1._center.lng >= 180 || t1._center.lng <= -180) && (this._prevEase = null, this._easing = null, this._lastWheelEvent = null, this._lastWheelEventTime = 0);
                const i = ()=>t1._terrainEnabled() && this._aroundCoord ? t1.computeZoomRelativeTo(this._aroundCoord) : t1.zoom;
                if (0 !== this._delta) {
                    const e1 = "wheel" === this._type && Math.abs(this._delta) > Sl ? this._wheelZoomRate : this._defaultZoomRate;
                    let o = 2 / (1 + Math.exp(-Math.abs(this._delta * e1)));
                    this._delta < 0 && 0 !== o && (o = 1 / o);
                    const r = i(), n = Math.pow(2, r), s = "number" == typeof this._targetZoom ? t1.zoomScale(this._targetZoom) : n;
                    this._targetZoom = Math.min(t1.maxZoom, Math.max(t1.minZoom, t1.scaleZoom(s * o))), "wheel" === this._type && (this._startZoom = r, this._easing = this._smoothOutEasing(200)), this._lastDelta = this._delta, this._delta = 0;
                }
                const o = "number" == typeof this._targetZoom ? this._targetZoom : i(), r = this._startZoom, n = this._easing;
                let s, a = !1;
                if ("wheel" === this._type && r && n) {
                    const t1 = Math.min((e1.o.now() - this._lastWheelEventTime) / 200, 1), i = n(t1);
                    s = e1.am(r, o, i), t1 < 1 ? this._frameId || (this._frameId = !0) : a = !0;
                } else s = o, a = !0;
                this._active = !0, a && (this._active = !1, this._finishTimeout = window.setTimeout(()=>{
                    this._zooming = !1, this._handler._triggerRenderFrame(), delete this._targetZoom, delete this._finishTimeout;
                }, 200));
                let l = s - i();
                return l * this._lastDelta < 0 && (l = 0), {
                    noInertia: !0,
                    needsRenderFrame: !a,
                    zoomDelta: l,
                    around: this._aroundPoint,
                    aroundCoord: this._aroundCoord,
                    originalEvent: this._lastWheelEvent
                };
            }
            _smoothOutEasing(t1) {
                let i = e1.eL;
                if (this._prevEase) {
                    const t1 = this._prevEase, o = (e1.o.now() - t1.start) / t1.duration, r = t1.easing(o + .01) - t1.easing(o), n = .27 / Math.sqrt(r * r + 1e-4) * .01, s = Math.sqrt(.0729 - n * n);
                    i = e1.eJ(n, s, .25, 1);
                }
                return this._prevEase = {
                    start: e1.o.now(),
                    duration: t1,
                    easing: i
                }, i;
            }
            blur() {
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            _addScrollZoomBlocker() {
                this._map && !this._alertContainer && (this._alertContainer = l("div", "mapboxgl-scroll-zoom-blocker", this._map._container), this._alertContainer.textContent = /(Mac|iPad)/i.test(navigator.userAgent) ? this._map._getUIString("ScrollZoomBlocker.CmdMessage") : this._map._getUIString("ScrollZoomBlocker.CtrlMessage"), this._alertContainer.style.fontSize = `${Math.max(10, Math.min(24, Math.floor(.05 * this._el.clientWidth)))}px`);
            }
            _showBlockerAlert() {
                this._alertContainer.style.visibility = "visible", this._alertContainer.classList.add("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.setAttribute("role", "alert"), clearTimeout(this._alertTimer), this._alertTimer = window.setTimeout(()=>{
                    this._alertContainer.classList.remove("mapboxgl-scroll-zoom-blocker-show"), this._alertContainer.removeAttribute("role");
                }, 200);
            }
        }
        class Rl {
            constructor(e1, t1){
                this._clickZoom = e1, this._tapZoom = t1;
            }
            enable() {
                this._clickZoom.enable(), this._tapZoom.enable();
            }
            disable() {
                this._clickZoom.disable(), this._tapZoom.disable();
            }
            isEnabled() {
                return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
            }
            isActive() {
                return this._clickZoom.isActive() || this._tapZoom.isActive();
            }
        }
        class Dl {
            constructor(){
                this.reset();
            }
            reset() {
                this._active = !1;
            }
            blur() {
                this.reset();
            }
            dblclick(e1, t1) {
                return e1.preventDefault(), {
                    cameraAnimation: (i)=>{
                        i.easeTo({
                            duration: 300,
                            zoom: i.getZoom() + (e1.shiftKey ? -1 : 1),
                            around: i.unproject(t1)
                        }, {
                            originalEvent: e1
                        });
                    }
                };
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Al {
            constructor(){
                this._tap = new ol({
                    numTouches: 1,
                    numTaps: 1
                }), this.reset();
            }
            reset() {
                this._active = !1, this._swipePoint = void 0, this._swipeTouch = 0, this._tapTime = 0, this._tap.reset();
            }
            touchstart(e1, t1, i) {
                this._swipePoint || (this._tapTime && e1.timeStamp - this._tapTime > 500 && this.reset(), this._tapTime ? i.length > 0 && (this._swipePoint = t1[0], this._swipeTouch = i[0].identifier) : this._tap.touchstart(e1, t1, i));
            }
            touchmove(e1, t1, i) {
                if (this._tapTime) {
                    if (this._swipePoint) {
                        if (i[0].identifier !== this._swipeTouch) return;
                        const o = t1[0], r = o.y - this._swipePoint.y;
                        return this._swipePoint = o, e1.preventDefault(), this._active = !0, {
                            zoomDelta: r / 128
                        };
                    }
                } else this._tap.touchmove(e1, t1, i);
            }
            touchend(e1, t1, i) {
                this._tapTime ? this._swipePoint && 0 === i.length && this.reset() : this._tap.touchend(e1, t1, i) && (this._tapTime = e1.timeStamp);
            }
            touchcancel() {
                this.reset();
            }
            enable() {
                this._enabled = !0;
            }
            disable() {
                this._enabled = !1, this.reset();
            }
            isEnabled() {
                return this._enabled;
            }
            isActive() {
                return this._active;
            }
        }
        class Ll {
            constructor(e1, t1, i){
                this._el = e1, this._mousePan = t1, this._touchPan = i;
            }
            enable(e1) {
                this._inertiaOptions = e1 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("mapboxgl-touch-drag-pan");
            }
            disable() {
                this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("mapboxgl-touch-drag-pan");
            }
            isEnabled() {
                return this._mousePan.isEnabled() && this._touchPan.isEnabled();
            }
            isActive() {
                return this._mousePan.isActive() || this._touchPan.isActive();
            }
        }
        class Pl {
            constructor(e1, t1, i){
                this._pitchWithRotate = e1.pitchWithRotate, this._mouseRotate = t1, this._mousePitch = i;
            }
            enable() {
                this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable();
            }
            disable() {
                this._mouseRotate.disable(), this._mousePitch.disable();
            }
            isEnabled() {
                return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled());
            }
            isActive() {
                return this._mouseRotate.isActive() || this._mousePitch.isActive();
            }
        }
        class Ol {
            constructor(e1, t1, i, o){
                this._el = e1, this._touchZoom = t1, this._touchRotate = i, this._tapDragZoom = o, this._rotationDisabled = !1, this._enabled = !0;
            }
            enable(e1) {
                this._touchZoom.enable(e1), this._rotationDisabled || this._touchRotate.enable(e1), this._tapDragZoom.enable(), this._el.classList.add("mapboxgl-touch-zoom-rotate");
            }
            disable() {
                this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("mapboxgl-touch-zoom-rotate");
            }
            isEnabled() {
                return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
            }
            isActive() {
                return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
            }
            disableRotation() {
                this._rotationDisabled = !0, this._touchRotate.disable();
            }
            enableRotation() {
                this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
            }
        }
        const Ml = (e1)=>e1.zoom || e1.drag || e1.pitch || e1.rotate;
        class zl extends e1.C {
        }
        class Fl {
            constructor(){
                this.constants = [
                    1,
                    1,
                    .01
                ], this.radius = 0;
            }
            setup(t1, i) {
                const o = e1.ax([], i, t1);
                this.radius = e1.ai(o[2] < 0 ? e1.eN([], o, this.constants) : [
                    o[0],
                    o[1],
                    0
                ]);
            }
            projectRay(t1) {
                e1.eN(t1, t1, this.constants), e1.ay(t1, t1), e1.eO(t1, t1, this.constants);
                const i = e1.bK([], t1, this.radius);
                if (i[2] > 0) {
                    const t1 = e1.bK([], [
                        0,
                        0,
                        1
                    ], e1.bj(i, [
                        0,
                        0,
                        1
                    ])), o = e1.bK([], e1.ay([], [
                        i[0],
                        i[1],
                        0
                    ]), this.radius), r = e1.cP([], i, e1.bK([], e1.ax([], e1.cP([], o, t1), i), 2));
                    i[0] = r[0], i[1] = r[1];
                }
                return i;
            }
        }
        function Bl(e1) {
            return e1.panDelta && e1.panDelta.mag() || e1.zoomDelta || e1.bearingDelta || e1.pitchDelta;
        }
        class kl {
            constructor(t1, i){
                this._map = t1, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new Ha(t1), this._bearingSnap = i.bearingSnap, this._previousActiveHandlers = {}, this._trackingEllipsoid = new Fl, this._dragOrigin = null, this._eventsInProgress = {}, this._addDefaultHandlers(i), e1.a_([
                    "handleEvent",
                    "handleWindowEvent"
                ], this);
                const o = this._el;
                this._listeners = [
                    [
                        o,
                        "touchstart",
                        {
                            passive: !0
                        }
                    ],
                    [
                        o,
                        "touchmove",
                        {
                            passive: !1
                        }
                    ],
                    [
                        o,
                        "touchend",
                        void 0
                    ],
                    [
                        o,
                        "touchcancel",
                        void 0
                    ],
                    [
                        o,
                        "mousedown",
                        void 0
                    ],
                    [
                        o,
                        "mousemove",
                        void 0
                    ],
                    [
                        o,
                        "mouseup",
                        void 0
                    ],
                    [
                        document,
                        "mousemove",
                        {
                            capture: !0
                        }
                    ],
                    [
                        document,
                        "mouseup",
                        void 0
                    ],
                    [
                        o,
                        "mouseover",
                        void 0
                    ],
                    [
                        o,
                        "mouseout",
                        void 0
                    ],
                    [
                        o,
                        "dblclick",
                        void 0
                    ],
                    [
                        o,
                        "click",
                        void 0
                    ],
                    [
                        o,
                        "keydown",
                        {
                            capture: !1
                        }
                    ],
                    [
                        o,
                        "keyup",
                        void 0
                    ],
                    [
                        o,
                        "wheel",
                        {
                            passive: !1
                        }
                    ],
                    [
                        o,
                        "contextmenu",
                        void 0
                    ],
                    [
                        window,
                        "blur",
                        void 0
                    ]
                ];
                for (const [e1, t1, i] of this._listeners){
                    const o = e1 === document ? this.handleWindowEvent : this.handleEvent;
                    e1.addEventListener(t1, o, i);
                }
            }
            destroy() {
                for (const [e1, t1, i] of this._listeners){
                    const o = e1 === document ? this.handleWindowEvent : this.handleEvent;
                    e1.removeEventListener(t1, o, i);
                }
            }
            _addDefaultHandlers(e1) {
                const t1 = this._map, i = t1.getCanvasContainer();
                this._add("mapEvent", new Qa(t1, e1));
                const o = t1.boxZoom = new el(t1, e1);
                this._add("boxZoom", o);
                const r = new rl, n = new Dl;
                t1.doubleClickZoom = new Rl(n, r), this._add("tapZoom", r), this._add("clickZoom", n);
                const s = new Al;
                this._add("tapDragZoom", s);
                const a = t1.touchPitch = new bl(t1);
                this._add("touchPitch", a);
                const l = new dl(e1), c = new _l(e1);
                t1.dragRotate = new Pl(e1, l, c), this._add("mouseRotate", l, [
                    "mousePitch"
                ]), this._add("mousePitch", c, [
                    "mouseRotate"
                ]);
                const h = new hl(e1), d = new ul(t1, e1);
                t1.dragPan = new Ll(i, h, d), this._add("mousePan", h), this._add("touchPan", d, [
                    "touchZoom",
                    "touchRotate"
                ]);
                const _ = new yl, u = new gl;
                t1.touchZoomRotate = new Ol(i, u, _, s), this._add("touchRotate", _, [
                    "touchPan",
                    "touchZoom"
                ]), this._add("touchZoom", u, [
                    "touchPan",
                    "touchRotate"
                ]), this._add("blockableMapEvent", new Ja(t1));
                const p = t1.scrollZoom = new Il(t1, this);
                this._add("scrollZoom", p, [
                    "mousePan"
                ]);
                const f = t1.keyboard = new Tl;
                this._add("keyboard", f);
                for (const i of [
                    "boxZoom",
                    "doubleClickZoom",
                    "tapDragZoom",
                    "touchPitch",
                    "dragRotate",
                    "dragPan",
                    "touchZoomRotate",
                    "scrollZoom",
                    "keyboard"
                ])e1.interactive && e1[i] && t1[i].enable(e1[i]);
            }
            _add(e1, t1, i) {
                this._handlers.push({
                    handlerName: e1,
                    handler: t1,
                    allowed: i
                }), this._handlersById[e1] = t1;
            }
            stop(e1) {
                if (!this._updatingCamera) {
                    for (const { handler: e1 } of this._handlers)e1.reset();
                    this._inertia.clear(), this._fireEvents({}, {}, e1), this._changes = [], this._originalZoom = void 0;
                }
            }
            isActive() {
                for (const { handler: e1 } of this._handlers)if (e1.isActive()) return !0;
                return !1;
            }
            isZooming() {
                return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
            }
            isRotating() {
                return !!this._eventsInProgress.rotate;
            }
            isMoving() {
                return !!Ml(this._eventsInProgress) || this.isZooming();
            }
            _isDragging() {
                return !!this._eventsInProgress.drag;
            }
            _blockedByActive(e1, t1, i) {
                for(const o in e1)if (o !== i && (!t1 || t1.indexOf(o) < 0)) return !0;
                return !1;
            }
            handleWindowEvent(e1) {
                this.handleEvent(e1, `${e1.type}Window`);
            }
            _getMapTouches(e1) {
                const t1 = [];
                for (const i of e1)this._el.contains(i.target) && t1.push(i);
                return t1;
            }
            handleEvent(e1, t1) {
                this._updatingCamera = !0;
                const i = "renderFrame" === e1.type, o = i ? void 0 : e1, r = {
                    needsRenderFrame: !1
                }, n = {}, s = {}, a = e1.touches ? this._getMapTouches(e1.touches) : void 0, l = a ? v(this._el, a) : i ? void 0 : g(this._el, e1);
                for (const { handlerName: i, handler: c, allowed: h } of this._handlers){
                    if (!c.isEnabled()) continue;
                    let d;
                    this._blockedByActive(s, h, i) ? c.reset() : c[t1 || e1.type] && (d = c[t1 || e1.type](e1, l, a), this.mergeHandlerResult(r, n, d, i, o), d && d.needsRenderFrame && this._triggerRenderFrame()), (d || c.isActive()) && (s[i] = c);
                }
                const c = {};
                for(const e1 in this._previousActiveHandlers)s[e1] || (c[e1] = o);
                this._previousActiveHandlers = s, (Object.keys(c).length || Bl(r)) && (this._changes.push([
                    r,
                    n,
                    c
                ]), this._triggerRenderFrame()), (Object.keys(s).length || Bl(r)) && this._map._stop(!0), this._updatingCamera = !1;
                const { cameraAnimation: h } = r;
                h && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], h(this._map));
            }
            mergeHandlerResult(e1, t1, i, o, r) {
                if (!i) return;
                Object.assign(e1, i);
                const n = {
                    handlerName: o,
                    originalEvent: i.originalEvent || r
                };
                void 0 !== i.zoomDelta && (t1.zoom = n), void 0 !== i.panDelta && (t1.drag = n), void 0 !== i.pitchDelta && (t1.pitch = n), void 0 !== i.bearingDelta && (t1.rotate = n);
            }
            _applyChanges() {
                const t1 = {}, i = {}, o = {};
                for (const [r, n, s] of this._changes)r.panDelta && (t1.panDelta = (t1.panDelta || new e1.P(0, 0))._add(r.panDelta)), r.zoomDelta && (t1.zoomDelta = (t1.zoomDelta || 0) + r.zoomDelta), r.bearingDelta && (t1.bearingDelta = (t1.bearingDelta || 0) + r.bearingDelta), r.pitchDelta && (t1.pitchDelta = (t1.pitchDelta || 0) + r.pitchDelta), void 0 !== r.around && (t1.around = r.around), void 0 !== r.aroundCoord && (t1.aroundCoord = r.aroundCoord), void 0 !== r.pinchAround && (t1.pinchAround = r.pinchAround), r.noInertia && (t1.noInertia = r.noInertia), Object.assign(i, n), Object.assign(o, s);
                this._updateMapTransform(t1, i, o), this._changes = [];
            }
            _updateMapTransform(t1, i, o) {
                const r = this._map, n = r.transform, s = (e1)=>[
                        e1.x,
                        e1.y,
                        e1.z
                    ];
                if ((()=>{
                    const e1 = this._eventsInProgress.drag;
                    return e1 && !this._handlersById[e1.handlerName].isActive();
                })() && !Bl(t1)) {
                    const e1 = n.zoom;
                    n.cameraElevationReference = "sea", null != this._originalZoom && n._orthographicProjectionAtLowPitch && "globe" !== n.projection.name && 0 === n.pitch ? (n.cameraElevationReference = "ground", n.zoom = this._originalZoom) : (n.recenterOnTerrain(), n.cameraElevationReference = "ground"), e1 !== n.zoom && this._map._update(!0);
                }
                if (n._isCameraConstrained && r._stop(!0), !Bl(t1)) return void this._fireEvents(i, o, !0);
                let { panDelta: a, zoomDelta: l, bearingDelta: c, pitchDelta: h, around: d, aroundCoord: _, pinchAround: u } = t1;
                n._isCameraConstrained && (l > 0 && (l = 0), n._isCameraConstrained = !1), void 0 !== u && (d = u), (l || ((e1)=>i[e1] && !this._eventsInProgress[e1])("drag")) && d && (this._dragOrigin = s(n.pointCoordinate3D(d)), this._originalZoom = n.zoom, this._trackingEllipsoid.setup(n._camera.position, this._dragOrigin)), n.cameraElevationReference = "sea", r._stop(!0), d = d || r.transform.centerPoint, c && (n.bearing += c), h && (n.pitch += h), n._updateCameraState();
                const p = [
                    0,
                    0,
                    0
                ];
                if (a) {
                    if ("mercator" === n.projection.name) {
                        const e1 = this._trackingEllipsoid.projectRay(n.screenPointToMercatorRay(d).dir), t1 = this._trackingEllipsoid.projectRay(n.screenPointToMercatorRay(d.sub(a)).dir);
                        p[0] = t1[0] - e1[0], p[1] = t1[1] - e1[1];
                    } else {
                        const t1 = n.pointCoordinate(d);
                        if ("globe" === n.projection.name) {
                            a = a.rotate(-n.angle);
                            const i = n._pixelsPerMercatorPixel / n.worldSize;
                            p[0] = -a.x * e1.eM(e1.bW(t1.y)) * i, p[1] = -a.y * e1.eM(n.center.lat) * i;
                        } else {
                            const e1 = n.pointCoordinate(d.sub(a));
                            t1 && e1 && (p[0] = e1.x - t1.x, p[1] = e1.y - t1.y);
                        }
                    }
                }
                const f = n.zoom, m = [
                    0,
                    0,
                    0
                ];
                if (l) {
                    const t1 = s(_ || n.pointCoordinate3D(d)), i = {
                        dir: e1.ay([], e1.ax([], t1, n._camera.position))
                    };
                    if (i.dir[2] < 0) {
                        const o = n.zoomDeltaToMovement(t1, l);
                        e1.bK(m, i.dir, o);
                    }
                }
                const g = e1.cP(p, p, m);
                n._translateCameraConstrained(g), l && Math.abs(n.zoom - f) > 1e-4 && n.recenterOnTerrain(), n.cameraElevationReference = "ground", this._map._update(), t1.noInertia || this._inertia.record(t1), this._fireEvents(i, o, !0);
            }
            _fireEvents(t1, i, o) {
                const r = Ml(this._eventsInProgress), n = Ml(t1), s = {};
                for(const e1 in t1){
                    const { originalEvent: i } = t1[e1];
                    this._eventsInProgress[e1] || (s[`${e1}start`] = i), this._eventsInProgress[e1] = t1[e1];
                }
                !r && n && this._fireEvent("movestart", n.originalEvent);
                for(const e1 in s)this._fireEvent(e1, s[e1]);
                n && this._fireEvent("move", n.originalEvent);
                for(const e1 in t1){
                    const { originalEvent: i } = t1[e1];
                    this._fireEvent(e1, i);
                }
                const a = {};
                let l;
                for(const e1 in this._eventsInProgress){
                    const { handlerName: t1, originalEvent: o } = this._eventsInProgress[e1];
                    this._handlersById[t1].isActive() || (delete this._eventsInProgress[e1], l = i[t1] || o, a[`${e1}end`] = l);
                }
                for(const e1 in a)this._fireEvent(e1, a[e1]);
                const c = Ml(this._eventsInProgress);
                if (o && (r || n) && !c) {
                    this._updatingCamera = !0;
                    const t1 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), i = (e1)=>0 !== e1 && -this._bearingSnap < e1 && e1 < this._bearingSnap;
                    t1 ? (i(t1.bearing || this._map.getBearing()) && (t1.bearing = 0), this._map.easeTo(t1, {
                        originalEvent: l
                    })) : (this._map.fire(new e1.C("moveend", {
                        originalEvent: l
                    })), i(this._map.getBearing()) && this._map.resetNorth()), this._updatingCamera = !1;
                }
            }
            _fireEvent(t1, i) {
                this._map.fire(new e1.C(t1, i ? {
                    originalEvent: i
                } : {}));
            }
            _requestFrame() {
                return this._map.triggerRepaint(), this._map._renderTaskQueue.add((e1)=>{
                    this._frameId = void 0, this.handleEvent(new zl("renderFrame", {
                        timeStamp: e1
                    })), this._applyChanges();
                });
            }
            _triggerRenderFrame() {
                void 0 === this._frameId && (this._frameId = this._requestFrame());
            }
        }
        const Nl = "map.setFreeCameraOptions(...) and map.getFreeCameraOptions() are not yet supported for non-mercator projections.";
        class Ul extends e1.E {
            constructor(t1, i){
                super(), this._moving = !1, this._zooming = !1, this.transform = t1, this._bearingSnap = i.bearingSnap, this._respectPrefersReducedMotion = !1 !== i.respectPrefersReducedMotion, e1.a_([
                    "_renderFrameCallback"
                ], this);
            }
            getCenter() {
                return new e1.aV(this.transform.center.lng, this.transform.center.lat);
            }
            setCenter(e1, t1) {
                return this.jumpTo({
                    center: e1
                }, t1);
            }
            panBy(t1, i, o) {
                return t1 = e1.P.convert(t1).mult(-1), this.panTo(this.transform.center, Object.assign({
                    offset: t1
                }, i), o);
            }
            panTo(e1, t1, i) {
                return this.easeTo(Object.assign({
                    center: e1
                }, t1), i);
            }
            getZoom() {
                return this.transform.zoom;
            }
            setZoom(e1, t1) {
                return this.jumpTo({
                    zoom: e1
                }, t1), this;
            }
            zoomTo(e1, t1, i) {
                return this.easeTo(Object.assign({
                    zoom: e1
                }, t1), i);
            }
            zoomIn(e1, t1) {
                return this.zoomTo(this.getZoom() + 1, e1, t1), this;
            }
            zoomOut(e1, t1) {
                return this.zoomTo(this.getZoom() - 1, e1, t1), this;
            }
            getBearing() {
                return this.transform.bearing;
            }
            setBearing(e1, t1) {
                return this.jumpTo({
                    bearing: e1
                }, t1), this;
            }
            getPadding() {
                return this.transform.padding;
            }
            setPadding(e1, t1) {
                return this.jumpTo({
                    padding: e1
                }, t1), this;
            }
            rotateTo(e1, t1, i) {
                return this.easeTo(Object.assign({
                    bearing: e1
                }, t1), i);
            }
            resetNorth(e1, t1) {
                return this.rotateTo(0, Object.assign({
                    duration: 1e3
                }, e1), t1), this;
            }
            resetNorthPitch(e1, t1) {
                return this.easeTo(Object.assign({
                    bearing: 0,
                    pitch: 0,
                    duration: 1e3
                }, e1), t1), this;
            }
            snapToNorth(e1, t1) {
                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(e1, t1) : this;
            }
            getPitch() {
                return this.transform.pitch;
            }
            setPitch(e1, t1) {
                return this.jumpTo({
                    pitch: e1
                }, t1), this;
            }
            cameraForBounds(t1, i) {
                t1 = e1.aK.convert(t1);
                const o = i && i.bearing || 0, r = i && i.pitch || 0, n = t1.getNorthWest(), s = t1.getSouthEast();
                return this._cameraForBounds(this.transform, n, s, o, r, i);
            }
            _extendPadding(e1) {
                const t1 = {
                    top: 0,
                    right: 0,
                    bottom: 0,
                    left: 0
                };
                return null == e1 ? Object.assign({}, t1, this.transform.padding) : "number" == typeof e1 ? {
                    top: e1,
                    bottom: e1,
                    right: e1,
                    left: e1
                } : Object.assign({}, t1, e1);
            }
            _extendCameraOptions(e1) {
                return (e1 = Object.assign({
                    offset: [
                        0,
                        0
                    ],
                    maxZoom: this.transform.maxZoom
                }, e1)).padding = this._extendPadding(e1.padding), e1;
            }
            _minimumAABBFrustumDistance(e1, t1) {
                const i = t1.max[0] - t1.min[0], o = t1.max[1] - t1.min[1];
                return i / o > e1.aspect ? i / (2 * Math.tan(.5 * e1.fovX) * e1.aspect) : o / (2 * Math.tan(.5 * e1.fovY) * e1.aspect);
            }
            _cameraForBoundsOnGlobe(t1, i, o, r, n, s) {
                const a = t1.clone(), l = this._extendCameraOptions(s);
                a.bearing = r, a.pitch = n;
                const c = e1.aV.convert(i), h = e1.aV.convert(o), d = .5 * (c.lat + h.lat), _ = .5 * (c.lng + h.lng), u = e1.eP(d, _), p = e1.ay([], u), f = e1.ay([], e1.bi([], p, [
                    0,
                    1,
                    0
                ])), m = e1.bi([], f, p), g = [
                    f[0],
                    f[1],
                    f[2],
                    0,
                    m[0],
                    m[1],
                    m[2],
                    0,
                    p[0],
                    p[1],
                    p[2],
                    0,
                    0,
                    0,
                    0,
                    1
                ], v = [
                    u,
                    e1.eP(c.lat, c.lng),
                    e1.eP(h.lat, c.lng),
                    e1.eP(h.lat, h.lng),
                    e1.eP(c.lat, h.lng),
                    e1.eP(d, c.lng),
                    e1.eP(d, h.lng),
                    e1.eP(c.lat, _),
                    e1.eP(h.lat, _)
                ];
                let y = e1.cQ.fromPoints(v.map((t1)=>[
                        e1.bj(f, t1),
                        e1.bj(m, t1),
                        e1.bj(p, t1)
                    ]));
                const x = e1.ah([], y.center, g);
                0 === e1.eQ(x) && e1.eR(x, 0, 0, 1), e1.ay(x, x), e1.bK(x, x, e1.aF), a.center = e1.eS(x);
                const b = a.getWorldToCameraMatrix(), w = e1.b8(new Float64Array(16), b);
                y = e1.cQ.applyTransform(y, e1.aD([], b, g));
                const T = this._extendAABB(y, a, l, r);
                if (!T) return void e1.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                y = T, e1.ah(x, x, b);
                const E = .5 * (y.max[2] - y.min[2]), S = this._minimumAABBFrustumDistance(a, y), C = e1.bK([], [
                    0,
                    0,
                    1
                ], E), I = e1.cP(C, x, C), R = S + (0 === a.pitch ? 0 : e1.bg(x, I)), D = a.globeCenterInViewSpace, A = e1.ax([], x, [
                    D[0],
                    D[1],
                    D[2]
                ]);
                e1.ay(A, A), e1.bK(A, A, R);
                const L = e1.cP([], x, A);
                e1.ah(L, L, w);
                const P = e1.ez / e1.aF, O = e1.ai(L), M = e1.bV(Math.max(O * P - e1.ez, Number.EPSILON), 0), z = Math.min(a.zoomFromMercatorZAdjusted(M), l.maxZoom);
                return z > .5 * (e1.cF + e1.cq) ? (a.setProjection({
                    name: "mercator"
                }), a.zoom = z, this._cameraForBounds(a, i, o, r, n, s)) : {
                    center: a.center,
                    zoom: z,
                    bearing: r,
                    pitch: n
                };
            }
            _extendAABB(t1, i, o, r) {
                const n = .5 * ((o.padding.left || 0) + (o.padding.right || 0)), s = .5 * ((o.padding.top || 0) + (o.padding.bottom || 0)), a = s, l = n, c = n, h = s, d = i.width - (l + c), _ = i.height - (a + h), u = e1.ax([], t1.max, t1.min), p = Math.min(d / u[0], _ / u[1]), f = Math.min(i.scaleZoom(i.scale * p), o.maxZoom);
                if (isNaN(f)) return null;
                const m = i.scale / i.zoomScale(f), g = new e1.cQ([
                    t1.min[0] - l * m,
                    t1.min[1] - h * m,
                    t1.min[2]
                ], [
                    t1.max[0] + c * m,
                    t1.max[1] + a * m,
                    t1.max[2]
                ]), v = ("number" == typeof o.offset.x && "number" == typeof o.offset.y ? new e1.P(o.offset.x, o.offset.y) : e1.P.convert(o.offset)).rotate(-e1.ap(r));
                return g.center[0] -= v.x * m, g.center[1] += v.y * m, g;
            }
            queryTerrainElevation(t1, i) {
                const o = this.transform.elevation;
                return o ? (i = Object.assign({}, {
                    exaggerated: !0
                }, i), o.getAtPoint(e1.ag.fromLngLat(t1), null, i.exaggerated)) : null;
            }
            _cameraForBounds(t1, i, o, r, n, s) {
                if ("globe" === t1.projection.name) return this._cameraForBoundsOnGlobe(t1, i, o, r, n, s);
                const a = t1.clone(), l = this._extendCameraOptions(s);
                a.bearing = r, a.pitch = n;
                const c = e1.aV.convert(i), h = e1.aV.convert(o), d = new e1.aV(c.lng, h.lat), _ = new e1.aV(h.lng, c.lat), u = a.project(c), p = a.project(h), f = this.queryTerrainElevation(c), m = this.queryTerrainElevation(h), g = this.queryTerrainElevation(d), v = this.queryTerrainElevation(_), y = [
                    [
                        u.x,
                        u.y,
                        Math.min(f || 0, m || 0, g || 0, v || 0)
                    ],
                    [
                        p.x,
                        p.y,
                        Math.max(f || 0, m || 0, g || 0, v || 0)
                    ]
                ];
                let x = e1.cQ.fromPoints(y);
                const b = a.getWorldToCameraMatrix(), w = e1.b8(new Float64Array(16), b);
                x = e1.cQ.applyTransform(x, b);
                const T = this._extendAABB(x, a, l, r);
                if (!T) return void e1.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                x = T;
                const E = .5 * e1.ax([], x.max, x.min)[2], S = this._minimumAABBFrustumDistance(a, x), C = [
                    0,
                    0,
                    1,
                    0
                ];
                e1.aE(C, C, b), e1.eT(C, C);
                const I = e1.bK([], C, S + E), R = e1.cP([], x.center, I);
                e1.ah(x.center, x.center, w), e1.ah(R, R, w);
                const D = a.unproject(new e1.P(x.center[0], x.center[1])), A = e1.eU(a.projection, D), L = Math.pow(2, A), P = Math.min(a._zoomFromMercatorZ(R[2] * a.pixelsPerMeter * L / a.worldSize), l.maxZoom);
                return a.mercatorFromTransition && P < .5 * (e1.cF + e1.cq) ? (a.setProjection({
                    name: "globe"
                }), a.zoom = P, this._cameraForBounds(a, i, o, r, n, s)) : {
                    center: D,
                    zoom: P,
                    bearing: r,
                    pitch: n
                };
            }
            fitBounds(e1, t1, i) {
                const o = this.cameraForBounds(e1, t1);
                return this._fitInternal(o, t1, i);
            }
            fitScreenCoordinates(t1, i, o, r, n) {
                const s = e1.P.convert(t1), a = e1.P.convert(i), l = new e1.P(Math.min(s.x, a.x), Math.min(s.y, a.y)), c = new e1.P(Math.max(s.x, a.x), Math.max(s.y, a.y));
                if ("mercator" === this.transform.projection.name && this.transform.anyCornerOffEdge(s, a)) return this;
                const h = this.transform.pointLocation3D(l), d = this.transform.pointLocation3D(c), _ = this.transform.pointLocation3D(new e1.P(l.x, c.y)), u = this.transform.pointLocation3D(new e1.P(c.x, l.y)), p = [
                    Math.min(h.lng, d.lng, _.lng, u.lng),
                    Math.min(h.lat, d.lat, _.lat, u.lat)
                ], f = [
                    Math.max(h.lng, d.lng, _.lng, u.lng),
                    Math.max(h.lat, d.lat, _.lat, u.lat)
                ], m = r && r.pitch ? r.pitch : this.getPitch(), g = this._cameraForBounds(this.transform, p, f, o, m, r);
                return this._fitInternal(g, r, n);
            }
            _fitInternal(e1, t1, i) {
                return e1 ? (t1 = Object.assign(e1, t1)).linear ? this.easeTo(t1, i) : this.flyTo(t1, i) : this;
            }
            jumpTo(t1, i) {
                this.stop();
                const o = t1.preloadOnly ? this.transform.clone() : this.transform;
                let r = !1, n = !1, s = !1;
                "zoom" in t1 && o.zoom !== +t1.zoom && (r = !0, o.zoom = +t1.zoom), void 0 !== t1.center && (o.center = e1.aV.convert(t1.center)), "bearing" in t1 && o.bearing !== +t1.bearing && (n = !0, o.bearing = +t1.bearing), "pitch" in t1 && o.pitch !== +t1.pitch && (s = !0, o.pitch = +t1.pitch);
                const a = "number" == typeof t1.padding ? this._extendPadding(t1.padding) : t1.padding;
                if (null != t1.padding && !o.isPaddingEqual(a)) {
                    if (!1 === t1.retainPadding) {
                        const e1 = o.clone();
                        e1.padding = a, o.setLocationAtPoint(o.center, e1.centerPoint);
                    } else o.padding = a;
                }
                return t1.preloadOnly ? (this._preloadTiles(o), this) : (this.fire(new e1.C("movestart", i)).fire(new e1.C("move", i)), r && this.fire(new e1.C("zoomstart", i)).fire(new e1.C("zoom", i)).fire(new e1.C("zoomend", i)), n && this.fire(new e1.C("rotatestart", i)).fire(new e1.C("rotate", i)).fire(new e1.C("rotateend", i)), s && this.fire(new e1.C("pitchstart", i)).fire(new e1.C("pitch", i)).fire(new e1.C("pitchend", i)), this.fire(new e1.C("moveend", i)));
            }
            getFreeCameraOptions() {
                return this.transform.projection.supportsFreeCamera || e1.w(Nl), this.transform.getFreeCameraOptions();
            }
            setFreeCameraOptions(t1, i) {
                const o = this.transform;
                if (!o.projection.supportsFreeCamera) return e1.w(Nl), this;
                this.stop();
                const r = o.zoom, n = o.pitch, s = o.bearing;
                o.setFreeCameraOptions(t1);
                const a = r !== o.zoom, l = n !== o.pitch, c = s !== o.bearing;
                return this.fire(new e1.C("movestart", i)).fire(new e1.C("move", i)), a && this.fire(new e1.C("zoomstart", i)).fire(new e1.C("zoom", i)).fire(new e1.C("zoomend", i)), c && this.fire(new e1.C("rotatestart", i)).fire(new e1.C("rotate", i)).fire(new e1.C("rotateend", i)), l && this.fire(new e1.C("pitchstart", i)).fire(new e1.C("pitch", i)).fire(new e1.C("pitchend", i)), this.fire(new e1.C("moveend", i)), this;
            }
            easeTo(t1, i) {
                this._stop(!1, t1.easeId), (!1 === (t1 = Object.assign({
                    offset: [
                        0,
                        0
                    ],
                    duration: 500,
                    easing: e1.eL
                }, t1)).animate || this._prefersReducedMotion(t1)) && (t1.duration = 0);
                const o = this.transform, r = this.getZoom(), n = this.getBearing(), s = this.getPitch(), a = this.getPadding(), l = "zoom" in t1 ? +t1.zoom : r, c = "bearing" in t1 ? this._normalizeBearing(t1.bearing, n) : n, h = "pitch" in t1 ? +t1.pitch : s, d = this._extendPadding(t1.padding), _ = e1.P.convert(t1.offset);
                let u, p, f;
                if ("globe" === o.projection.name) {
                    const i = e1.ag.fromLngLat(o.center), r = _.rotate(-o.angle);
                    i.x += r.x / o.worldSize, i.y += r.y / o.worldSize;
                    const n = i.toLngLat(), s = e1.aV.convert(t1.center || n);
                    this._normalizeCenter(s), u = o.centerPoint.add(r), p = new e1.P(i.x, i.y).mult(o.worldSize), f = new e1.P(e1.aH(s.lng), e1.aL(s.lat)).mult(o.worldSize).sub(p);
                } else {
                    u = o.centerPoint.add(_);
                    const i = o.pointLocation(u), r = e1.aV.convert(t1.center || i);
                    this._normalizeCenter(r), p = o.project(i), f = o.project(r).sub(p);
                }
                const m = o.zoomScale(l - r);
                let g, v;
                t1.around && (g = e1.aV.convert(t1.around), v = o.locationPoint(g));
                const y = this._zooming || l !== r, x = this._rotating || n !== c, b = this._pitching || h !== s, w = !o.isPaddingEqual(d), T = !1 === t1.retainPadding ? o.clone() : o, E = (o)=>(E)=>{
                        if (y && (o.zoom = e1.am(r, l, E)), x && (o.bearing = e1.am(n, c, E)), b && (o.pitch = e1.am(s, h, E)), w && (T.interpolatePadding(a, d, E), u = T.centerPoint.add(_)), g) o.setLocationAtPoint(g, v);
                        else {
                            const e1 = o.zoomScale(o.zoom - r), t1 = l > r ? Math.min(2, m) : Math.max(.5, m), i = Math.pow(t1, 1 - E), n = o.unproject(p.add(f.mult(E * i)).mult(e1));
                            o.setLocationAtPoint(o.renderWorldCopies ? n.wrap() : n, u);
                        }
                        return t1.preloadOnly || this._fireMoveEvents(i), o;
                    };
                if (t1.preloadOnly) {
                    const e1 = this._emulate(E, t1.duration, o);
                    return this._preloadTiles(e1), this;
                }
                const S = {
                    moving: this._moving,
                    zooming: this._zooming,
                    rotating: this._rotating,
                    pitching: this._pitching
                };
                return this._zooming = y, this._rotating = x, this._pitching = b, this._padding = w, this._easeId = t1.easeId, this._prepareEase(i, t1.noMoveStart, S), this._ease(E(o), (e1)=>{
                    "sea" === o.cameraElevationReference && o.recenterOnTerrain(), this._afterEase(i, e1);
                }, t1), this;
            }
            _prepareEase(t1, i, o = {}) {
                this._moving = !0, this.transform.cameraElevationReference = "sea", this.transform._orthographicProjectionAtLowPitch && 0 === this.transform.pitch && "globe" !== this.transform.projection.name && (this.transform.cameraElevationReference = "ground"), i || o.moving || this.fire(new e1.C("movestart", t1)), this._zooming && !o.zooming && this.fire(new e1.C("zoomstart", t1)), this._rotating && !o.rotating && this.fire(new e1.C("rotatestart", t1)), this._pitching && !o.pitching && this.fire(new e1.C("pitchstart", t1));
            }
            _fireMoveEvents(t1) {
                this.fire(new e1.C("move", t1)), this._zooming && this.fire(new e1.C("zoom", t1)), this._rotating && this.fire(new e1.C("rotate", t1)), this._pitching && this.fire(new e1.C("pitch", t1));
            }
            _afterEase(t1, i) {
                if (this._easeId && i && this._easeId === i) return;
                this._easeId = void 0, this.transform.cameraElevationReference = "ground";
                const o = this._zooming, r = this._rotating, n = this._pitching;
                this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._padding = !1, o && this.fire(new e1.C("zoomend", t1)), r && this.fire(new e1.C("rotateend", t1)), n && this.fire(new e1.C("pitchend", t1)), this.fire(new e1.C("moveend", t1));
            }
            flyTo(t1, i) {
                if (this._prefersReducedMotion(t1)) {
                    const o = e1.aJ(t1, [
                        "center",
                        "zoom",
                        "bearing",
                        "pitch",
                        "around",
                        "padding",
                        "retainPadding"
                    ]);
                    return this.jumpTo(o, i);
                }
                this.stop(), t1 = Object.assign({
                    offset: [
                        0,
                        0
                    ],
                    speed: 1.2,
                    curve: 1.42,
                    easing: e1.eL
                }, t1);
                const o = this.transform, r = this.getZoom(), n = this.getBearing(), s = this.getPitch(), a = this.getPadding(), l = "zoom" in t1 ? e1.aC(+t1.zoom, o.minZoom, o.maxZoom) : r, c = "bearing" in t1 ? this._normalizeBearing(t1.bearing, n) : n, h = "pitch" in t1 ? +t1.pitch : s, d = this._extendPadding(t1.padding), _ = o.zoomScale(l - r), u = e1.P.convert(t1.offset);
                let p = o.centerPoint.add(u);
                const f = o.pointLocation(p), m = e1.aV.convert(t1.center || f);
                this._normalizeCenter(m);
                const g = o.project(f), v = o.project(m).sub(g);
                let y = t1.curve;
                const x = Math.max(o.width, o.height), b = x / _, w = v.mag();
                if ("minZoom" in t1) {
                    const i = e1.aC(Math.min(t1.minZoom, r, l), o.minZoom, o.maxZoom), n = x / o.zoomScale(i - r);
                    y = Math.sqrt(n / w * 2);
                }
                const T = y * y;
                function E(e1) {
                    const t1 = (b * b - x * x + (e1 ? -1 : 1) * T * T * w * w) / (2 * (e1 ? b : x) * T * w);
                    return Math.log(Math.sqrt(t1 * t1 + 1) - t1);
                }
                function S(e1) {
                    return (Math.exp(e1) - Math.exp(-e1)) / 2;
                }
                function C(e1) {
                    return (Math.exp(e1) + Math.exp(-e1)) / 2;
                }
                const I = E(0);
                let R = function(e1) {
                    return C(I) / C(I + y * e1);
                }, D = function(e1) {
                    var t1;
                    return x * ((C(I) * (S(t1 = I + y * e1) / C(t1)) - S(I)) / T) / w;
                }, A = (E(1) - I) / y;
                if (Math.abs(w) < 1e-6 || !isFinite(A)) {
                    if (Math.abs(x - b) < 1e-6) return this.easeTo(t1, i);
                    const e1 = b < x ? -1 : 1;
                    A = Math.abs(Math.log(b / x)) / y, D = function() {
                        return 0;
                    }, R = function(t1) {
                        return Math.exp(e1 * y * t1);
                    };
                }
                t1.duration = "duration" in t1 ? +t1.duration : 1e3 * A / ("screenSpeed" in t1 ? +t1.screenSpeed / y : +t1.speed), t1.maxDuration && t1.duration > t1.maxDuration && (t1.duration = 0);
                const L = n !== c, P = h !== s, O = !o.isPaddingEqual(d), M = !1 === t1.retainPadding ? o.clone() : o, z = (o)=>(_)=>{
                        const f = _ * A, y = 1 / R(f);
                        o.zoom = 1 === _ ? l : r + o.scaleZoom(y), L && (o.bearing = e1.am(n, c, _)), P && (o.pitch = e1.am(s, h, _)), O && (M.interpolatePadding(a, d, _), p = M.centerPoint.add(u));
                        const x = 1 === _ ? m : o.unproject(g.add(v.mult(D(f))).mult(y));
                        return o.setLocationAtPoint(o.renderWorldCopies ? x.wrap() : x, p), o._updateCameraOnTerrain(), t1.preloadOnly || this._fireMoveEvents(i), o;
                    };
                if (t1.preloadOnly) {
                    const e1 = this._emulate(z, t1.duration, o);
                    return this._preloadTiles(e1), this;
                }
                return this._zooming = !0, this._rotating = L, this._pitching = P, this._padding = O, this._prepareEase(i, !1), this._ease(z(o), ()=>this._afterEase(i), t1), this;
            }
            isEasing() {
                return !!this._easeFrameId;
            }
            stop() {
                return this._stop();
            }
            _requestRenderFrame(e1) {}
            _cancelRenderFrame(e1) {}
            _stop(e1, t1) {
                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), this._easeFrameId = void 0, this._onEaseFrame = void 0), this._onEaseEnd) {
                    const e1 = this._onEaseEnd;
                    this._onEaseEnd = void 0, e1.call(this, t1);
                }
                if (!e1) {
                    const e1 = this.handlers;
                    e1 && e1.stop(!1);
                }
                return this;
            }
            _ease(t1, i, o) {
                !1 === o.animate || 0 === o.duration ? (t1(1), i()) : (this._easeStart = e1.o.now(), this._easeOptions = o, this._onEaseFrame = t1, this._onEaseEnd = i, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
            }
            _renderFrameCallback() {
                const t1 = Math.min((e1.o.now() - this._easeStart) / this._easeOptions.duration, 1), i = this._onEaseFrame;
                i && i(this._easeOptions.easing(t1)), t1 < 1 ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
            }
            _normalizeBearing(t1, i) {
                t1 = e1.bt(t1, -180, 180);
                const o = Math.abs(t1 - i);
                return Math.abs(t1 - 360 - i) < o && (t1 -= 360), Math.abs(t1 + 360 - i) < o && (t1 += 360), t1;
            }
            _normalizeCenter(e1) {
                const t1 = this.transform;
                if (t1.maxBounds) return;
                if ("globe" !== t1.projection.name && !t1.renderWorldCopies) return;
                const i = e1.lng - t1.center.lng;
                e1.lng += i > 180 ? -360 : i < -180 ? 360 : 0;
            }
            _prefersReducedMotion(t1) {
                return this._respectPrefersReducedMotion && e1.o.prefersReducedMotion && !(t1 && t1.essential);
            }
            _emulate(e1, t1, i) {
                const o = Math.ceil(15 * t1 / 1e3), r = [], n = e1(i.clone());
                for(let e1 = 0; e1 <= o; e1++){
                    const t1 = n(e1 / o);
                    r.push(t1.clone());
                }
                return r;
            }
            _preloadTiles(e1, t1) {}
        }
        class Vl {
            constructor(t1 = {}){
                this.options = t1, e1.a_([
                    "_toggleAttribution",
                    "_updateEditLink",
                    "_updateData",
                    "_updateCompact"
                ], this);
            }
            getDefaultPosition() {
                return "bottom-right";
            }
            onAdd(e1) {
                const t1 = this.options && this.options.compact, i = e1._getUIString("AttributionControl.ToggleAttribution");
                this._map = e1, this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-attrib"), this._compactButton = l("button", "mapboxgl-ctrl-attrib-button", this._container), this._compactButton.type = "button", this._compactButton.addEventListener("click", this._toggleAttribution), this._compactButton.setAttribute("aria-label", i);
                const o = l("span", "mapboxgl-ctrl-icon", this._compactButton);
                return o.setAttribute("aria-hidden", "true"), o.setAttribute("title", i), this._innerContainer = l("div", "mapboxgl-ctrl-attrib-inner", this._container), t1 && this._container.classList.add("mapboxgl-compact"), this._updateAttributions(), this._updateEditLink(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("moveend", this._updateEditLink), void 0 === t1 && (this._map.on("resize", this._updateCompact), this._updateCompact()), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("moveend", this._updateEditLink), this._map.off("resize", this._updateCompact), this._map = void 0, this._attribHTML = void 0;
            }
            _toggleAttribution() {
                this._container.classList.contains("mapboxgl-compact-show") ? (this._container.classList.remove("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "false")) : (this._container.classList.add("mapboxgl-compact-show"), this._compactButton.setAttribute("aria-expanded", "true"));
            }
            _updateEditLink() {
                let t1 = this._editLink;
                t1 || (t1 = this._editLink = this._container.querySelector(".mapbox-improve-map"));
                const i = [
                    {
                        key: "owner",
                        value: this.styleOwner
                    },
                    {
                        key: "id",
                        value: this.styleId
                    },
                    {
                        key: "access_token",
                        value: this._map._requestManager._customAccessToken || e1.e.ACCESS_TOKEN
                    }
                ];
                if (t1) {
                    const o = i.reduce((e1, t1, o)=>(t1.value && (e1 += `${t1.key}=${t1.value}${o < i.length - 1 ? "&" : ""}`), e1), "?");
                    t1.href = `${e1.e.FEEDBACK_URL}/${o}#${Ua(this._map, !0)}`, t1.rel = "noopener nofollow";
                }
            }
            _updateData(e1) {
                !e1 || ("source" !== e1.dataType || "metadata" !== e1.sourceDataType && "visibility" !== e1.sourceDataType) && "style" !== e1.dataType || (this._updateAttributions(), this._updateEditLink());
            }
            _updateAttributions() {
                if (!this._map.style) return;
                let e1 = [];
                if (this._map.style.stylesheet) {
                    const e1 = this._map.style.stylesheet;
                    this.styleOwner = e1.owner, this.styleId = e1.id;
                }
                const t1 = this._map.style._mergedSourceCaches;
                for(const i in t1){
                    const o = t1[i];
                    if (o.used) {
                        const t1 = o.getSource();
                        t1.attribution && e1.indexOf(t1.attribution) < 0 && e1.push(t1.attribution);
                    }
                }
                e1.sort((e1, t1)=>e1.length - t1.length), e1 = e1.filter((t1, i)=>{
                    for(let o = i + 1; o < e1.length; o++)if (e1[o].indexOf(t1) >= 0) return !1;
                    return !0;
                }), this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? e1 = [
                    ...this.options.customAttribution,
                    ...e1
                ] : e1.unshift(this.options.customAttribution));
                const i = e1.map((e1)=>(function(e1) {
                        const t1 = (new DOMParser).parseFromString(e1, "text/html");
                        return Array.from(t1.body.querySelectorAll("*")).reverse().forEach((e1)=>{
                            const i = e1.textContent || "";
                            if ("A" !== e1.tagName) return void e1.replaceWith(...e1.childNodes);
                            const o = e1.getAttribute("href");
                            if (!o || !/^(https?:|mailto:)/i.test(o)) return void e1.replaceWith(t1.createTextNode(i));
                            const r = t1.createElement("a");
                            r.href = o, r.textContent = i, r.rel = "noopener nofollow";
                            const n = e1.getAttribute("class");
                            n && (r.className = n), e1.replaceWith(r);
                        }), t1.body.innerHTML;
                    })(e1)).join(" | ");
                i !== this._attribHTML && (this._attribHTML = i, e1.length ? (this._innerContainer.innerHTML = i, this._container.classList.remove("mapboxgl-attrib-empty")) : this._container.classList.add("mapboxgl-attrib-empty"), this._editLink = null);
            }
            _updateCompact() {
                this._map.getCanvasContainer().offsetWidth <= 640 ? this._container.classList.add("mapboxgl-compact") : this._container.classList.remove("mapboxgl-compact", "mapboxgl-compact-show");
            }
        }
        class jl {
            constructor(){
                e1.a_([
                    "_updateLogo",
                    "_updateCompact"
                ], this);
            }
            onAdd(e1) {
                this._map = e1, this._container = l("div", "mapboxgl-ctrl");
                const t1 = l("a", "mapboxgl-ctrl-logo");
                return t1.target = "_blank", t1.rel = "noopener nofollow", t1.href = "https://www.mapbox.com/", t1.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), t1.setAttribute("rel", "noopener nofollow"), this._container.appendChild(t1), this._container.style.display = "none", this._map.on("sourcedata", this._updateLogo), this._updateLogo(), this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
            }
            onRemove() {
                this._container.remove(), this._map.off("sourcedata", this._updateLogo), this._map.off("resize", this._updateCompact);
            }
            getDefaultPosition() {
                return "bottom-left";
            }
            _updateLogo(e1) {
                e1 && "metadata" !== e1.sourceDataType || (this._container.style.display = this._logoRequired() ? "block" : "none");
            }
            _logoRequired() {
                if (!this._map.style) return !0;
                const e1 = this._map.style._sourceCaches;
                if (0 === Object.entries(e1).length) return !0;
                for(const t1 in e1){
                    const i = e1[t1].getSource();
                    if (i.hasOwnProperty("mapbox_logo") && !i.mapbox_logo) return !1;
                }
                return !0;
            }
            _updateCompact() {
                const e1 = this._container.children;
                if (e1.length) {
                    const t1 = e1[0];
                    this._map.getCanvasContainer().offsetWidth < 250 ? t1.classList.add("mapboxgl-compact") : t1.classList.remove("mapboxgl-compact");
                }
            }
        }
        class Gl {
            constructor(){
                this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
            }
            add(e1) {
                const t1 = ++this._id;
                return this._queue.push({
                    callback: e1,
                    id: t1,
                    cancelled: !1
                }), t1;
            }
            remove(e1) {
                const t1 = this._currentlyRunning, i = t1 ? this._queue.concat(t1) : this._queue;
                for (const t1 of i)if (t1.id === e1) return void (t1.cancelled = !0);
            }
            run(e1 = 0) {
                const t1 = this._currentlyRunning = this._queue;
                this._queue = [];
                for (const i of t1)if (!i.cancelled && (i.callback(e1), this._cleared)) break;
                this._cleared = !1, this._currentlyRunning = !1;
            }
            clear() {
                this._currentlyRunning && (this._cleared = !0), this._queue = [];
            }
        }
        class ql {
            constructor(e1){
                this.jumpTo(e1);
            }
            getValue(t1) {
                if (t1 <= this._startTime) return this._start;
                if (t1 >= this._endTime) return this._end;
                const i = e1.dj((t1 - this._startTime) / (this._endTime - this._startTime));
                return this._start * (1 - i) + this._end * i;
            }
            isEasing(e1) {
                return e1 >= this._startTime && e1 <= this._endTime;
            }
            jumpTo(e1) {
                this._startTime = -1 / 0, this._endTime = -1 / 0, this._start = e1, this._end = e1;
            }
            easeTo(e1, t1, i) {
                this._start = this.getValue(t1), this._end = e1, this._startTime = t1, this._endTime = t1 + i;
            }
        }
        const Zl = {
            "AttributionControl.ToggleAttribution": "Toggle attribution",
            "FullscreenControl.Enter": "Enter fullscreen",
            "FullscreenControl.Exit": "Exit fullscreen",
            "GeolocateControl.FindMyLocation": "Find my location",
            "GeolocateControl.LocationNotAvailable": "Location not available",
            "LogoControl.Title": "Mapbox homepage",
            "Map.Title": "Map",
            "NavigationControl.ResetBearing": "Reset bearing to north",
            "NavigationControl.ZoomIn": "Zoom in",
            "NavigationControl.ZoomOut": "Zoom out",
            "ScrollZoomBlocker.CtrlMessage": "Use ctrl + scroll to zoom the map",
            "ScrollZoomBlocker.CmdMessage": "Use \u2318 + scroll to zoom the map",
            "TouchPanBlocker.Message": "Use two fingers to move the map"
        };
        class Hl extends e1.C {
            constructor(e1, t1, i, o){
                const { point: r, lngLat: n, originalEvent: s, target: a } = e1;
                super(e1.type, {
                    point: r,
                    lngLat: n,
                    originalEvent: s,
                    target: a
                }), this.preventDefault = ()=>{
                    e1.preventDefault();
                }, this.id = t1, this.interaction = i, this.feature = o;
            }
        }
        class Wl {
            constructor(e1){
                this.map = e1, this.interactionsByType = new Map, this.delegatedInteractions = new Map, this.typeById = new Map, this.filters = new Map, this.handleType = this.handleType.bind(this), this.handleMove = this.handleMove.bind(this), this.handleOut = this.handleOut.bind(this), this.hoveredFeatures = new Map, this.prevHoveredFeatures = new Map;
            }
            add(t1, i) {
                if (this.typeById.has(t1)) throw new Error(`Interaction id "${t1}" already exists.`);
                const o = i.filter;
                let r = i.type;
                o && this.filters.set(t1, e1.dc(o)), "mouseover" === r && (r = "mouseenter"), "mouseout" === r && (r = "mouseleave");
                const n = this.interactionsByType.get(r) || new Map;
                "mouseenter" === r || "mouseleave" === r ? (0 === this.delegatedInteractions.size && (this.map.on("mousemove", this.handleMove), this.map.on("mouseout", this.handleOut)), this.delegatedInteractions.set(t1, i)) : 0 === n.size && this.map.on(r, this.handleType), 0 === n.size && this.interactionsByType.set(r, n), n.set(t1, i), this.typeById.set(t1, r);
            }
            get(e1) {
                const t1 = this.typeById.get(e1);
                if (!t1) return;
                const i = this.interactionsByType.get(t1);
                return i ? i.get(e1) : void 0;
            }
            remove(e1) {
                const t1 = this.typeById.get(e1);
                if (!t1) return;
                this.typeById.delete(e1), this.filters.delete(e1);
                const i = this.interactionsByType.get(t1);
                i && (i.delete(e1), "mouseenter" === t1 || "mouseleave" === t1 ? (this.delegatedInteractions.delete(e1), 0 === this.delegatedInteractions.size && (this.map.off("mousemove", this.handleMove), this.map.off("mouseout", this.handleOut))) : 0 === i.size && this.map.off(t1, this.handleType));
            }
            queryTargets(e1, t1) {
                const i = [];
                for (const [e1, o] of t1)o.target && i.push({
                    targetId: e1,
                    target: o.target,
                    filter: this.filters.get(e1)
                });
                return this.map.style.queryRenderedTargets(e1, i, this.map.transform);
            }
            handleMove(e1) {
                this.prevHoveredFeatures = this.hoveredFeatures, this.hoveredFeatures = new Map;
                const t1 = this.queryTargets(e1.point, Array.from(this.delegatedInteractions).reverse());
                t1.length && (e1.type = "mouseenter", this.handleType(e1, t1));
                const i = new Map;
                for (const [e1, { feature: t1 }] of this.prevHoveredFeatures)this.hoveredFeatures.has(e1) || i.set(t1.id, t1);
                i.size && (e1.type = "mouseleave", this.handleType(e1, Array.from(i.values())));
            }
            handleOut(e1) {
                const t1 = Array.from(this.hoveredFeatures.values()).map(({ feature: e1 })=>e1);
                t1.length && (e1.type = "mouseleave", this.handleType(e1, t1)), this.hoveredFeatures.clear();
            }
            handleType(t1, i) {
                const o = "mouseenter" === t1.type;
                if (o && !this.interactionsByType.has(t1.type)) return void e1.w("mouseenter interaction required for mouseleave to work.");
                const r = Array.from(this.interactionsByType.get(t1.type)).reverse(), n = !!i;
                i = i || this.queryTargets(t1.point, r);
                let s = !1;
                const a = new Set;
                for (const l of i){
                    for (const [i, c] of r){
                        if (!c.target) continue;
                        const r = l.variants ? l.variants[i] : null;
                        if (r) {
                            for (const h of r){
                                if (It(h, l, a, i)) continue;
                                const r = new e1.de(l, h), d = Ct(h, l, i);
                                n && void 0 !== r.id && (r.state = this.map.getFeatureState(r));
                                const _ = o ? this.prevHoveredFeatures.get(d) : null, u = new Hl(t1, i, c, r), p = _ ? _.stop : c.handler(u);
                                if (o && this.hoveredFeatures.set(d, {
                                    feature: l,
                                    stop: p
                                }), !1 !== p) {
                                    s = !0;
                                    break;
                                }
                            }
                            if (s) break;
                        }
                    }
                    if (s) break;
                }
                if (!s) for (const [e1, i] of r){
                    const { handler: o, target: r } = i;
                    if (!r && !1 !== o(new Hl(t1, e1, i, null))) break;
                }
            }
        }
        function $l(t1, i) {
            if (Array.isArray(t1) && Array.isArray(i)) {
                const e1 = new Set(t1), o = new Set(i);
                return e1.size === o.size && t1.every((e1)=>o.has(e1));
            }
            return e1.b7(t1, i);
        }
        const Xl = {
            center: [
                0,
                0
            ],
            zoom: 0,
            bearing: 0,
            pitch: 0,
            minZoom: -2,
            maxZoom: 22,
            minPitch: 0,
            maxPitch: 85,
            interactive: !0,
            scrollZoom: !0,
            boxZoom: !0,
            dragRotate: !0,
            dragPan: !0,
            keyboard: !0,
            doubleClickZoom: !0,
            touchZoomRotate: !0,
            touchPitch: !0,
            cooperativeGestures: !1,
            performanceMetricsCollection: !0,
            bearingSnap: 7,
            clickTolerance: 3,
            pitchWithRotate: !0,
            hash: !1,
            attributionControl: !0,
            antialias: !1,
            failIfMajorPerformanceCaveat: !1,
            preserveDrawingBuffer: !1,
            trackResize: !0,
            renderWorldCopies: !0,
            refreshExpiredTiles: !0,
            minTileCacheSize: null,
            maxTileCacheSize: null,
            localIdeographFontFamily: "sans-serif",
            localFontFamily: null,
            transformRequest: null,
            accessToken: null,
            fadeDuration: 300,
            respectPrefersReducedMotion: !0,
            crossSourceCollisions: !0,
            collectResourceTiming: !1,
            testMode: !1,
            precompilePrograms: !0,
            scaleFactor: 1,
            spriteFormat: "auto"
        }, Yl = {
            showCompass: !0,
            showZoom: !0,
            visualizePitch: !1
        };
        class Kl {
            constructor(t1, i, o = !1){
                this._clickTolerance = 10, this.element = i, this.mouseRotate = new dl({
                    clickTolerance: t1.dragRotate._mouseRotate._clickTolerance
                }), this.map = t1, o && (this.mousePitch = new _l({
                    clickTolerance: t1.dragRotate._mousePitch._clickTolerance
                })), e1.a_([
                    "mousedown",
                    "mousemove",
                    "mouseup",
                    "touchstart",
                    "touchmove",
                    "touchend",
                    "reset"
                ], this), i.addEventListener("mousedown", this.mousedown), i.addEventListener("touchstart", this.touchstart, {
                    passive: !1
                }), i.addEventListener("touchmove", this.touchmove), i.addEventListener("touchend", this.touchend), i.addEventListener("touchcancel", this.reset);
            }
            down(e1, t1) {
                this.mouseRotate.mousedown(e1, t1), this.mousePitch && this.mousePitch.mousedown(e1, t1), u();
            }
            move(e1, t1) {
                const i = this.map, o = this.mouseRotate.mousemoveWindow(e1, t1), r = o && o.bearingDelta;
                if (r && i.setBearing(i.getBearing() + r), this.mousePitch) {
                    const o = this.mousePitch.mousemoveWindow(e1, t1), r = o && o.pitchDelta;
                    r && i.setPitch(i.getPitch() + r);
                }
            }
            off() {
                const e1 = this.element;
                e1.removeEventListener("mousedown", this.mousedown), e1.removeEventListener("touchstart", this.touchstart), e1.removeEventListener("touchmove", this.touchmove), e1.removeEventListener("touchend", this.touchend), e1.removeEventListener("touchcancel", this.reset), this.offTemp();
            }
            offTemp() {
                p(), window.removeEventListener("mousemove", this.mousemove), window.removeEventListener("mouseup", this.mouseup);
            }
            mousedown(e1) {
                this.down(Object.assign({}, e1, {
                    button: e1.button,
                    type: e1.type,
                    ctrlKey: !0,
                    preventDefault: ()=>e1.preventDefault()
                }), g(this.element, e1)), window.addEventListener("mousemove", this.mousemove), window.addEventListener("mouseup", this.mouseup);
            }
            mousemove(e1) {
                this.move(e1, g(this.element, e1));
            }
            mouseup(e1) {
                this.mouseRotate.mouseupWindow(e1), this.mousePitch && this.mousePitch.mouseupWindow(e1), this.offTemp();
            }
            touchstart(e1) {
                1 !== e1.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = v(this.element, e1.targetTouches)[0], this.down({
                    type: "mousedown",
                    button: 0,
                    ctrlKey: !0,
                    preventDefault: ()=>e1.preventDefault()
                }, this._startPos));
            }
            touchmove(e1) {
                1 !== e1.targetTouches.length ? this.reset() : (this._lastPos = v(this.element, e1.targetTouches)[0], this.move({
                    buttons: 1,
                    preventDefault: ()=>e1.preventDefault()
                }, this._lastPos));
            }
            touchend(e1) {
                0 === e1.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), this.reset();
            }
            reset() {
                this.mouseRotate.reset(), this.mousePitch && this.mousePitch.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
            }
        }
        function Ql(t1, i, o) {
            if (t1 = new e1.aV(t1.lng, t1.lat), i) {
                const r = new e1.aV(t1.lng - 360, t1.lat), n = new e1.aV(t1.lng + 360, t1.lat), s = 360 * Math.ceil(Math.abs(t1.lng - o.center.lng) / 360), a = o.locationPoint3D(t1).distSqr(i), l = i.x < 0 || i.y < 0 || i.x > o.width || i.y > o.height;
                o.locationPoint3D(r).distSqr(i) < a && (l || Math.abs(r.lng - o.center.lng) < s) ? t1 = r : o.locationPoint3D(n).distSqr(i) < a && (l || Math.abs(n.lng - o.center.lng) < s) && (t1 = n);
            }
            for(; Math.abs(t1.lng - o.center.lng) > 180;){
                const e1 = o.locationPoint3D(t1);
                if (e1.x >= 0 && e1.y >= 0 && e1.x <= o.width && e1.y <= o.height) break;
                t1.lng > o.center.lng ? t1.lng -= 360 : t1.lng += 360;
            }
            return t1;
        }
        const Jl = {
            center: "translate(-50%,-50%)",
            top: "translate(-50%,0)",
            "top-left": "translate(0,0)",
            "top-right": "translate(-100%,0)",
            bottom: "translate(-50%,-100%)",
            "bottom-left": "translate(0,-100%)",
            "bottom-right": "translate(-100%,-100%)",
            left: "translate(0,-50%)",
            right: "translate(-100%,-50%)"
        }, ec = {
            rotation: 0,
            rotationAlignment: "auto",
            pitchAlignment: "auto",
            occludedOpacity: .2,
            altitude: 0
        };
        class tc extends e1.E {
            constructor(t1, i){
                super(), (t1 instanceof HTMLElement || i) && (t1 = Object.assign({
                    element: t1
                }, i)), e1.a_([
                    "_update",
                    "_onMove",
                    "_onUp",
                    "_addDragHandler",
                    "_onMapClick",
                    "_onKeyPress",
                    "_clearFadeTimer"
                ], this);
                const { anchor: o = "center", color: r = "#3FB1CE", scale: n = 1, draggable: s = !1, clickTolerance: a = 0, rotation: l = ec.rotation, rotationAlignment: c = ec.rotationAlignment, pitchAlignment: h = ec.pitchAlignment, occludedOpacity: d = ec.occludedOpacity, altitude: _ = ec.altitude } = t1 || {};
                this._anchor = o, this._color = r, this._scale = n, this._draggable = s, this._clickTolerance = a, this._rotation = l, this._rotationAlignment = c, this._pitchAlignment = h, this._occludedOpacity = d, this._altitude = _, this._state = "inactive", this._isDragging = !1, this._updateMoving = ()=>this._update(!0), t1 && t1.element ? (this._element = t1.element, this._offset = e1.P.convert(t1 && t1.offset || [
                    0,
                    0
                ])) : (this._defaultMarker = !0, this._element = this._createDefaultMarker(), this._offset = e1.P.convert(t1 && t1.offset || [
                    0,
                    -14
                ])), this._element.hasAttribute("aria-label") || this._element.setAttribute("aria-label", "Map marker"), this._element.hasAttribute("role") || this._element.setAttribute("role", "img"), this._element.classList.add("mapboxgl-marker"), this._element.addEventListener("dragstart", (e1)=>{
                    e1.preventDefault();
                }), this._element.addEventListener("mousedown", (e1)=>{
                    e1.preventDefault();
                });
                const u = this._element.classList;
                for(const e1 in Jl)u.remove(`mapboxgl-marker-anchor-${e1}`);
                u.add(`mapboxgl-marker-anchor-${this._anchor}`);
                const p = t1 && t1.className ? t1.className.trim().split(/\s+/) : [];
                u.add(...p), this._popup = null;
            }
            _createDefaultMarker() {
                const e1 = l("div"), t1 = c("svg", {
                    display: "block",
                    height: 41 * this._scale + "px",
                    width: 27 * this._scale + "px",
                    viewBox: "0 0 27 41"
                }, e1);
                if (0 === this._altitude) {
                    const e1 = c("radialGradient", {
                        id: "shadowGradient"
                    }, c("defs", {}, t1));
                    c("stop", {
                        offset: "10%",
                        "stop-opacity": .4
                    }, e1), c("stop", {
                        offset: "100%",
                        "stop-opacity": .05
                    }, e1), c("ellipse", {
                        cx: 13.5,
                        cy: 34.8,
                        rx: 10.5,
                        ry: 5.25,
                        fill: "url(#shadowGradient)"
                    }, t1);
                }
                return c("path", {
                    fill: this._color,
                    d: "M27,13.5C27,19.07 20.25,27 14.75,34.5C14.02,35.5 12.98,35.5 12.25,34.5C6.75,27 0,19.22 0,13.5C0,6.04 6.04,0 13.5,0C20.96,0 27,6.04 27,13.5Z"
                }, t1), c("path", {
                    opacity: .25,
                    d: "M13.5,0C6.04,0 0,6.04 0,13.5C0,19.22 6.75,27 12.25,34.5C13,35.52 14.02,35.5 14.75,34.5C20.25,27 27,19.07 27,13.5C27,6.04 20.96,0 13.5,0ZM13.5,1C20.42,1 26,6.58 26,13.5C26,15.9 24.5,19.18 22.22,22.74C19.95,26.3 16.71,30.14 13.94,33.91C13.74,34.18 13.61,34.32 13.5,34.44C13.39,34.32 13.26,34.18 13.06,33.91C10.28,30.13 7.41,26.31 5.02,22.77C2.62,19.23 1,15.95 1,13.5C1,6.58 6.58,1 13.5,1Z"
                }, t1), c("circle", {
                    fill: "white",
                    cx: 13.5,
                    cy: 13.5,
                    r: 5.5
                }, t1), e1;
            }
            addTo(e1) {
                return e1 === this._map || (this.remove(), this._map = e1, e1.getCanvasContainer().appendChild(this._element), e1.on("move", this._updateMoving), e1.on("moveend", this._update), e1.on("remove", this._clearFadeTimer), e1._addMarker(this), this.setDraggable(this._draggable), this._update(), e1.on("click", this._onMapClick)), this;
            }
            remove() {
                const e1 = this._map;
                return e1 && (e1.off("click", this._onMapClick), e1.off("move", this._updateMoving), e1.off("moveend", this._update), e1.off("mousedown", this._addDragHandler), e1.off("touchstart", this._addDragHandler), e1.off("mouseup", this._onUp), e1.off("touchend", this._onUp), e1.off("mousemove", this._onMove), e1.off("touchmove", this._onMove), e1.off("remove", this._clearFadeTimer), e1._removeMarker(this), this._map = void 0), this._clearFadeTimer(), this._element.remove(), this._popup && this._popup.remove(), this;
            }
            getLngLat() {
                return this._lngLat;
            }
            setLngLat(t1) {
                return this._lngLat = e1.aV.convert(t1), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(!0), this;
            }
            setAltitude(e1) {
                return e1 === this._altitude || (this._defaultMarker && (0 === this._altitude && 0 !== e1 || 0 !== this._altitude && 0 === e1) && (this._element = this._createDefaultMarker()), this._altitude = e1 || ec.altitude, this._update()), this;
            }
            getAltitude() {
                return this._altitude;
            }
            getElement() {
                return this._element;
            }
            setPopup(e1) {
                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeAttribute("role"), this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), e1) {
                    if (!("offset" in e1.options)) {
                        const t1 = 38.1, i = 13.5, o = Math.sqrt(Math.pow(i, 2) / 2);
                        e1.options.offset = this._defaultMarker ? {
                            top: [
                                0,
                                0
                            ],
                            "top-left": [
                                0,
                                0
                            ],
                            "top-right": [
                                0,
                                0
                            ],
                            bottom: [
                                0,
                                -t1
                            ],
                            "bottom-left": [
                                o,
                                -1 * (t1 - i + o)
                            ],
                            "bottom-right": [
                                -o,
                                -1 * (t1 - i + o)
                            ],
                            left: [
                                i,
                                -1 * (t1 - i)
                            ],
                            right: [
                                -i,
                                -1 * (t1 - i)
                            ]
                        } : this._offset;
                    }
                    this._popup = e1, e1._marker = this, e1._altitude = this._altitude, this._lngLat && this._popup.setLngLat(this._lngLat), this._element.setAttribute("role", "button"), this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress), this._element.setAttribute("aria-expanded", "false");
                }
                return this;
            }
            _onKeyPress(e1) {
                const t1 = e1.code, i = e1.charCode || e1.keyCode;
                "Space" !== t1 && "Enter" !== t1 && 32 !== i && 13 !== i || this.togglePopup();
            }
            _onMapClick(e1) {
                const t1 = e1.originalEvent.target, i = this._element;
                this._popup && (t1 === i || i.contains(t1)) && this.togglePopup();
            }
            getPopup() {
                return this._popup;
            }
            togglePopup() {
                const e1 = this._popup;
                return e1 ? (e1.isOpen() ? (e1.remove(), this._element.setAttribute("aria-expanded", "false")) : this._map && (e1.addTo(this._map), this._element.setAttribute("aria-expanded", "true")), this) : this;
            }
            _behindTerrain() {
                const e1 = this._map, t1 = this._pos;
                if (!e1 || !t1) return !1;
                const i = e1.unproject(t1, this._altitude), o = e1.getFreeCameraOptions();
                if (!o.position) return !1;
                const r = o.position.toLngLat();
                return r.distanceTo(i) < .9 * r.distanceTo(this._lngLat);
            }
            _evaluateOpacity() {
                const t1 = this._map;
                if (!t1) return;
                const i = this._pos;
                if (!i || i.x < 0 || i.x > t1.transform.width || i.y < 0 || i.y > t1.transform.height) return void this._clearFadeTimer();
                const o = t1.unproject(i, this._altitude);
                let r;
                t1._showingGlobe() && e1.eX(t1.transform, this._lngLat) ? r = 0 : (r = 1 - t1._queryFogOpacity(o), t1.transform._terrainEnabled() && t1.getTerrain() && this._behindTerrain() && (r *= this._occludedOpacity)), this._element.style.opacity = `${r}`, this._element.style.pointerEvents = r > 0 ? "auto" : "none", this._popup && this._popup._setOpacity(r), this._fadeTimer = null;
            }
            _clearFadeTimer() {
                this._fadeTimer && (clearTimeout(this._fadeTimer), this._fadeTimer = null);
            }
            _updateDOM() {
                const e1 = this._pos;
                if (!e1 || !this._map) return;
                const t1 = this._offset.mult(this._scale);
                this._element.style.transform = `\n            translate(${e1.x}px,${e1.y}px)\n            ${Jl[this._anchor]}\n            ${this._calculateXYTransform()} ${this._calculateZTransform()}\n            translate(${t1.x}px,${t1.y}px)\n        `;
            }
            _calculateXYTransform() {
                const t1 = this._pos, i = this._map, o = this.getPitchAlignment();
                if (!i || !t1 || "map" !== o) return "";
                if (!i._showingGlobe()) {
                    const e1 = i.getPitch();
                    return e1 ? `rotateX(${e1}deg)` : "";
                }
                const r = e1.cC(e1.eY(i.transform, this._lngLat)), n = t1.sub(e1.eZ(i.transform)), s = Math.abs(n.x) + Math.abs(n.y);
                if (0 === s) return "";
                const a = r / s;
                return `rotateX(${-n.y * a}deg) rotateY(${n.x * a}deg)`;
            }
            _calculateZTransform() {
                const t1 = this._pos, i = this._map;
                if (!i || !t1) return "";
                let o = 0;
                const r = this.getRotationAlignment();
                if ("map" === r) {
                    if (i._showingGlobe()) {
                        const t1 = i.project(new e1.aV(this._lngLat.lng, this._lngLat.lat + .001), this._altitude), r = i.project(new e1.aV(this._lngLat.lng, this._lngLat.lat - .001), this._altitude).sub(t1);
                        o = e1.cC(Math.atan2(r.y, r.x)) - 90;
                    } else o = -i.getBearing();
                } else if ("horizon" === r) {
                    const r = e1.aj(4, 6, i.getZoom()), n = e1.eZ(i.transform);
                    n.y += r * i.transform.height;
                    const s = t1.sub(n), a = e1.cC(Math.atan2(s.y, s.x));
                    o = (a > 90 ? a - 270 : a + 90) * (1 - r);
                }
                return o += this._rotation, o ? `rotateZ(${o}deg)` : "";
            }
            _update(e1) {
                cancelAnimationFrame(this._updateFrameId);
                const t1 = this._map;
                t1 && (t1.transform.renderWorldCopies && (this._lngLat = Ql(this._lngLat, this._pos, t1.transform)), this._pos = t1.project(this._lngLat, this._altitude), !0 === e1 ? this._updateFrameId = requestAnimationFrame(()=>{
                    this._element && this._pos && this._anchor && (this._pos = this._pos.round(), this._updateDOM());
                }) : this._pos = this._pos.round(), t1._requestDomTask(()=>{
                    this._map && (this._element && this._pos && this._anchor && this._updateDOM(), (t1._showingGlobe() || t1.getTerrain() || t1.getFog()) && !this._fadeTimer && (this._fadeTimer = window.setTimeout(this._evaluateOpacity.bind(this), 60)));
                }));
            }
            getOffset() {
                return this._offset;
            }
            setOffset(t1) {
                return this._offset = e1.P.convert(t1), this._update(), this;
            }
            addClassName(e1) {
                return this._element.classList.add(e1), this;
            }
            removeClassName(e1) {
                return this._element.classList.remove(e1), this;
            }
            toggleClassName(e1) {
                return this._element.classList.toggle(e1);
            }
            _onMove(t1) {
                const i = this._map;
                if (!i) return;
                const o = this._pointerdownPos, r = this._positionDelta;
                if (o && r) {
                    if (!this._isDragging) {
                        const e1 = this._clickTolerance || i._clickTolerance;
                        if (t1.point.dist(o) < e1) return;
                        this._isDragging = !0;
                    }
                    this._pos = t1.point.sub(r), this._lngLat = i.unproject(this._pos, this._altitude), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new e1.C("dragstart"))), this.fire(new e1.C("drag"));
                }
            }
            _onUp() {
                this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1;
                const t1 = this._map;
                t1 && (t1.off("mousemove", this._onMove), t1.off("touchmove", this._onMove)), "active" === this._state && this.fire(new e1.C("dragend")), this._state = "inactive";
            }
            _addDragHandler(e1) {
                const t1 = this._map, i = this._pos;
                t1 && i && this._element.contains(e1.originalEvent.target) && (e1.preventDefault(), this._positionDelta = e1.point.sub(i), this._pointerdownPos = e1.point, this._state = "pending", t1.on("mousemove", this._onMove), t1.on("touchmove", this._onMove), t1.once("mouseup", this._onUp), t1.once("touchend", this._onUp));
            }
            setDraggable(e1) {
                this._draggable = !!e1;
                const t1 = this._map;
                return t1 && (e1 ? (t1.on("mousedown", this._addDragHandler), t1.on("touchstart", this._addDragHandler)) : (t1.off("mousedown", this._addDragHandler), t1.off("touchstart", this._addDragHandler))), this;
            }
            isDraggable() {
                return this._draggable;
            }
            setRotation(e1) {
                return this._rotation = e1 || ec.rotation, this._update(), this;
            }
            getRotation() {
                return this._rotation;
            }
            setRotationAlignment(e1) {
                return this._rotationAlignment = e1 || ec.rotationAlignment, this._update(), this;
            }
            getRotationAlignment() {
                return "auto" === this._rotationAlignment || "horizon" === this._rotationAlignment && this._map && !this._map._showingGlobe() ? "viewport" : this._rotationAlignment;
            }
            setPitchAlignment(e1) {
                return this._pitchAlignment = e1 || ec.pitchAlignment, this._update(), this;
            }
            getPitchAlignment() {
                return "auto" === this._pitchAlignment ? this.getRotationAlignment() : this._pitchAlignment;
            }
            setOccludedOpacity(e1) {
                return this._occludedOpacity = e1 || ec.occludedOpacity, this._update(), this;
            }
            getOccludedOpacity() {
                return this._occludedOpacity;
            }
        }
        const ic = {
            positionOptions: {
                enableHighAccuracy: !1,
                maximumAge: 0,
                timeout: 6e3
            },
            fitBoundsOptions: {
                maxZoom: 15
            },
            trackUserLocation: !1,
            showAccuracyCircle: !0,
            showUserLocation: !0,
            showUserHeading: !1,
            showButton: !0,
            followUserLocation: !0
        }, oc = {
            maxWidth: 100,
            unit: "metric"
        }, rc = {
            kilometer: "km",
            meter: "m",
            mile: "mi",
            foot: "ft",
            "nautical-mile": "nm"
        }, nc = {
            closeButton: !0,
            closeOnClick: !0,
            focusAfterOpen: !0,
            className: "",
            maxWidth: "240px",
            altitude: 0
        }, sc = [
            "a[href]",
            "[tabindex]:not([tabindex='-1'])",
            "[contenteditable]:not([contenteditable='false'])",
            "button:not([disabled])",
            "input:not([disabled])",
            "select:not([disabled])",
            "textarea:not([disabled])"
        ].join(", ");
        function ac(t1 = new e1.P(0, 0), i = "bottom") {
            if ("number" == typeof t1) {
                const o = Math.round(Math.sqrt(.5 * Math.pow(t1, 2)));
                switch(i){
                    case "top":
                        return new e1.P(0, t1);
                    case "top-left":
                        return new e1.P(o, o);
                    case "top-right":
                        return new e1.P(-o, o);
                    case "bottom":
                        return new e1.P(0, -t1);
                    case "bottom-left":
                        return new e1.P(o, -o);
                    case "bottom-right":
                        return new e1.P(-o, -o);
                    case "left":
                        return new e1.P(t1, 0);
                    case "right":
                        return new e1.P(-t1, 0);
                }
                return new e1.P(0, 0);
            }
            return t1 instanceof e1.P || Array.isArray(t1) ? e1.P.convert(t1) : e1.P.convert(t1[i] || [
                0,
                0
            ]);
        }
        const lc = {
            version: t1,
            supported: a.supported,
            setRTLTextPlugin: e1.e$,
            getRTLTextPluginStatus: e1.e_,
            addTileProvider: function(t1, i) {
                if (!t1 || !i) throw new Error("TileProvider name and URL are required");
                e1.e.TILE_PROVIDER_URLS[t1] = e1.o.resolveURL(i);
            },
            Map: class extends Ul {
                constructor(t1){
                    o.mark(i.create);
                    const r = t1;
                    if (null != (t1 = Object.assign({}, Xl, t1)).minZoom && null != t1.maxZoom && t1.minZoom > t1.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                    if (null != t1.minPitch && null != t1.maxPitch && t1.minPitch > t1.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                    if (null != t1.minPitch && t1.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (null != t1.maxPitch && t1.maxPitch > 85) throw new Error("maxPitch must be less than or equal to 85");
                    if (t1.antialias && e1.eV(window) && (t1.antialias = !1, e1.w("Antialiasing is disabled for this WebGL context to avoid browser bug: https://github.com/mapbox/mapbox-gl-js/issues/11609")), super(new so(t1.minZoom, t1.maxZoom, t1.minPitch, t1.maxPitch, t1.renderWorldCopies, null, null), t1), this._repaint = !!t1.repaint, this._interactive = t1.interactive, this._minTileCacheSize = t1.minTileCacheSize, this._maxTileCacheSize = t1.maxTileCacheSize, this._failIfMajorPerformanceCaveat = t1.failIfMajorPerformanceCaveat, this._preserveDrawingBuffer = t1.preserveDrawingBuffer, this._antialias = t1.antialias, this._trackResize = t1.trackResize, this._bearingSnap = t1.bearingSnap, this._refreshExpiredTiles = t1.refreshExpiredTiles, this._fadeDuration = t1.fadeDuration, this._isInitialLoad = !0, this._crossSourceCollisions = t1.crossSourceCollisions, this._collectResourceTiming = t1.collectResourceTiming, this._language = this._parseLanguage(t1.language), this._worldview = t1.worldview, this._renderTaskQueue = new Gl, this._domRenderTaskQueue = new Gl, this._controls = [], this._markers = [], this._popups = [], this._mapId = e1.r(), this._locale = Object.assign({}, Zl, t1.locale), this._clickTolerance = t1.clickTolerance, this._cooperativeGestures = t1.cooperativeGestures, this._performanceMetricsCollection = t1.performanceMetricsCollection, this._tessellationStep = t1.tessellationStep, this._containerWidth = 0, this._containerHeight = 0, this._showParseStatus = !0, this._precompilePrograms = t1.precompilePrograms, this._averageElevationLastSampledAt = -1 / 0, this._averageElevationExaggeration = 0, this._averageElevation = new ql(0), this._interactionRange = [
                        1 / 0,
                        -1 / 0
                    ], this._visibilityHidden = 0, this._useExplicitProjection = !1, this._frameId = 0, this._scaleFactor = t1.scaleFactor, this._requestManager = new T(t1.transformRequest, t1.accessToken, t1.testMode), this._silenceAuthErrors = !!t1.testMode, this._contextCreateOptions = t1.contextCreateOptions ? Object.assign({}, t1.contextCreateOptions) : {}, "string" == typeof t1.container) {
                        const e1 = document.getElementById(t1.container);
                        if (!e1) throw new Error(`Container '${t1.container.toString()}' not found.`);
                        this._container = e1;
                    } else {
                        if (!(t1.container instanceof HTMLElement)) throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                        this._container = t1.container;
                    }
                    if (this._container.childNodes.length > 0 && e1.w("The map container element should be empty, otherwise the map's interactivity will be negatively impacted. If you want to display a message when WebGL is not supported, use the Mapbox GL Supported plugin instead."), t1.maxBounds && this.setMaxBounds(t1.maxBounds), this._spriteFormat = t1.spriteFormat, e1.a_([
                        "_onWindowOnline",
                        "_onWindowResize",
                        "_onVisibilityChange",
                        "_onMapScroll",
                        "_contextLost",
                        "_contextRestored"
                    ], this), this._setupContainer(), this._setupPainter(), void 0 === this.painter) throw new Error("Failed to initialize WebGL.");
                    if (this.on("move", ()=>this._update(!1)), this.on("moveend", ()=>this._update(!1)), this.on("zoom", ()=>this._update(!0)), this._fullscreenchangeEvent = "onfullscreenchange" in document ? "fullscreenchange" : "webkitfullscreenchange", window.addEventListener("online", this._onWindowOnline, !1), window.addEventListener("resize", this._onWindowResize, !1), window.addEventListener("orientationchange", this._onWindowResize, !1), window.addEventListener(this._fullscreenchangeEvent, this._onWindowResize, !1), window.addEventListener("visibilitychange", this._onVisibilityChange, !1), this.handlers = new kl(this, t1), this._localFontFamily = t1.localFontFamily, this._localIdeographFontFamily = t1.localIdeographFontFamily, (t1.style || !t1.testMode) && this.setStyle(t1.style || e1.e.DEFAULT_STYLE, {
                        config: t1.config,
                        localFontFamily: this._localFontFamily,
                        localIdeographFontFamily: this._localIdeographFontFamily
                    }), t1.projection && this.setProjection(t1.projection), t1.hash && (this._hash = new Na("string" == typeof t1.hash && t1.hash || void 0).addTo(this)), !this._hash || !this._hash._onHashChange()) {
                        null == r.center && null == r.zoom || (this.transform._unmodified = !1), this.jumpTo({
                            center: t1.center,
                            zoom: t1.zoom,
                            bearing: t1.bearing,
                            pitch: t1.pitch
                        });
                        const e1 = t1.bounds;
                        e1 && (this.resize(), this.fitBounds(e1, Object.assign({}, t1.fitBoundsOptions, {
                            duration: 0
                        })));
                    }
                    this.resize(), t1.attributionControl && this.addControl(new Vl({
                        customAttribution: t1.customAttribution
                    })), this._logoControl = new jl, this.addControl(this._logoControl, t1.logoPosition), this.on("style.load", ()=>{
                        this.transform.unmodified && this.jumpTo(this.style.stylesheet), this._postStyleLoadEvent(), this._postStyleWithAppearanceEvent();
                    }), this.on("data", (t1)=>{
                        this._update("style" === t1.dataType), this.fire(new e1.C(`${t1.dataType}data`, t1));
                    }), this.on("dataloading", (t1)=>{
                        this.fire(new e1.C(`${t1.dataType}dataloading`, t1));
                    }), this._interactions = new Wl(this);
                }
                _getMapId() {
                    return this._mapId;
                }
                addControl(t1, i) {
                    if (void 0 === i && (i = t1.getDefaultPosition ? t1.getDefaultPosition() : "top-right"), !t1 || !t1.onAdd) return this.fire(new e1.B(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const o = t1.onAdd(this);
                    this._controls.push(t1);
                    const r = this._controlPositions[i];
                    return -1 !== i.indexOf("bottom") ? r.insertBefore(o, r.firstChild) : r.appendChild(o), this;
                }
                removeControl(t1) {
                    if (!t1 || !t1.onRemove) return this.fire(new e1.B(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                    const i = this._controls.indexOf(t1);
                    return i > -1 && this._controls.splice(i, 1), t1.onRemove(this), this;
                }
                hasControl(e1) {
                    return this._controls.indexOf(e1) > -1;
                }
                getContainer() {
                    return this._container;
                }
                getCanvasContainer() {
                    return this._canvasContainer;
                }
                getCanvas() {
                    return this._canvas;
                }
                resize(t1) {
                    if (this._updateContainerDimensions(), this._containerWidth === this.transform.width && this._containerHeight === this.transform.height) return this;
                    this._resizeCanvas(this._containerWidth, this._containerHeight), this.transform.resize(this._containerWidth, this._containerHeight), this.painter.resize(Math.ceil(this._containerWidth), Math.ceil(this._containerHeight));
                    const i = !this._moving;
                    return i && this.fire(new e1.C("movestart", t1)).fire(new e1.C("move", t1)), this.fire(new e1.C("resize", t1)), i && this.fire(new e1.C("moveend", t1)), this;
                }
                getBounds() {
                    return this.transform.getBounds();
                }
                getMaxBounds() {
                    return this.transform.getMaxBounds() || null;
                }
                setMaxBounds(t1) {
                    return this.transform.setMaxBounds(e1.aK.convert(t1)), this._update();
                }
                setMinZoom(t1) {
                    if ((t1 = t1 ?? -2) >= -2 && t1 <= this.transform.maxZoom) return this.transform.minZoom = t1, this._update(), this.getZoom() < t1 ? this.setZoom(t1) : this.fire(new e1.C("zoomstart")).fire(new e1.C("zoom")).fire(new e1.C("zoomend")), this;
                    throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
                }
                getMinZoom() {
                    return this.transform.minZoom;
                }
                setMaxZoom(t1) {
                    if ((t1 = t1 ?? 22) >= this.transform.minZoom) return this.transform.maxZoom = t1, this._update(), this.getZoom() > t1 ? this.setZoom(t1) : this.fire(new e1.C("zoomstart")).fire(new e1.C("zoom")).fire(new e1.C("zoomend")), this;
                    throw new Error("maxZoom must be greater than the current minZoom");
                }
                getMaxZoom() {
                    return this.transform.maxZoom;
                }
                setMinPitch(t1) {
                    if ((t1 = t1 ?? 0) < 0) throw new Error("minPitch must be greater than or equal to 0");
                    if (t1 >= 0 && t1 <= this.transform.maxPitch) return this.transform.minPitch = t1, this._update(), this.getPitch() < t1 ? this.setPitch(t1) : this.fire(new e1.C("pitchstart")).fire(new e1.C("pitch")).fire(new e1.C("pitchend")), this;
                    throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
                }
                getMinPitch() {
                    return this.transform.minPitch;
                }
                setMaxPitch(t1) {
                    if ((t1 = t1 ?? 85) > 85) throw new Error("maxPitch must be less than or equal to 85");
                    if (t1 >= this.transform.minPitch) return this.transform.maxPitch = t1, this._update(), this.getPitch() > t1 ? this.setPitch(t1) : this.fire(new e1.C("pitchstart")).fire(new e1.C("pitch")).fire(new e1.C("pitchend")), this;
                    throw new Error("maxPitch must be greater than or equal to minPitch");
                }
                getMaxPitch() {
                    return this.transform.maxPitch;
                }
                getScaleFactor() {
                    return this._scaleFactor;
                }
                setScaleFactor(e1) {
                    return this._scaleFactor = e1, this.painter.scaleFactor = e1, this.style && this.style._setLabelPlacementStale(), this.style._updateFilteredLayers((e1)=>"symbol" === e1.type), this._update(!0), this;
                }
                getRenderWorldCopies() {
                    return this.transform.renderWorldCopies;
                }
                setRenderWorldCopies(e1) {
                    return this.transform.renderWorldCopies = e1, this.transform.renderWorldCopies || this._forceMarkerAndPopupUpdate(!0), this._update();
                }
                getLanguage() {
                    return this._language;
                }
                _parseLanguage(e1) {
                    return "auto" === e1 ? navigator.language : Array.isArray(e1) ? 0 === e1.length ? void 0 : e1.map((e1)=>"auto" === e1 ? navigator.language : e1) : e1;
                }
                setLanguage(e1) {
                    const t1 = this._parseLanguage(e1);
                    if (!this.style || t1 === this._language) return this;
                    this._language = t1, this.style.reloadSources();
                    for (const e1 of this._controls)e1._setLanguage && e1._setLanguage(this._language);
                    return this;
                }
                getWorldview() {
                    return this._worldview;
                }
                setWorldview(e1) {
                    return this.style && e1 !== this._worldview ? (this._worldview = e1, this._styleDirty = !0, this.style.setWorldview(e1), this) : this;
                }
                getProjection() {
                    return this.transform.mercatorFromTransition ? {
                        name: "globe",
                        center: [
                            0,
                            0
                        ]
                    } : this.transform.getProjection();
                }
                _showingGlobe() {
                    return "globe" === this.transform.projection.name;
                }
                setProjection(e1) {
                    return this._lazyInitEmptyStyle(), e1 ? "string" == typeof e1 && (e1 = {
                        name: e1
                    }) : e1 = null, this._useExplicitProjection = !!e1, this._prioritizeAndUpdateProjection(e1, this.style.projection);
                }
                _updateProjectionTransition() {
                    if ("globe" !== this.getProjection().name) return;
                    const t1 = this.transform, i = t1.projection.name;
                    let o;
                    "globe" === i && t1.zoom >= e1.cq ? (t1.setMercatorFromTransition(), o = !0) : "mercator" === i && t1.zoom < e1.cq && (t1.setProjection({
                        name: "globe"
                    }), o = !0), o && (this.style.applyProjectionUpdate(), this.style._forceSymbolLayerUpdate(), this._update(!0));
                }
                _prioritizeAndUpdateProjection(e1, t1) {
                    return this._updateProjection(e1 || t1 || {
                        name: "mercator"
                    });
                }
                _updateProjection(t1) {
                    let i;
                    const o = this.transform.mercatorFromTransition;
                    i = "globe" === t1.name && this.transform.zoom >= e1.cq ? this.transform.setMercatorFromTransition() : this.transform.setProjection(t1), this.style.applyProjectionUpdate();
                    const r = "mercator" === this.transform.getProjection().name && o !== this.transform.mercatorFromTransition;
                    return (i || r) && (this.painter.clearBackgroundTiles(), this.style.clearSources(), this._update(!0), this._forceMarkerAndPopupUpdate(!0)), this;
                }
                project(t1, i) {
                    return this.transform.locationPoint3D(e1.aV.convert(t1), i);
                }
                unproject(t1, i) {
                    return this.transform.pointLocation3D(e1.P.convert(t1), i);
                }
                isMoving() {
                    return this._moving || this.handlers && this.handlers.isMoving() || !1;
                }
                isZooming() {
                    return this._zooming || this.handlers && this.handlers.isZooming() || !1;
                }
                isRotating() {
                    return this._rotating || this.handlers && this.handlers.isRotating() || !1;
                }
                _isDragging() {
                    return this.handlers && this.handlers._isDragging() || !1;
                }
                _createDelegatedListener(e1, t1, i) {
                    const o = (e1)=>{
                        let i = [];
                        if (Array.isArray(t1)) {
                            const o = t1.filter((e1)=>this.getLayer(e1));
                            i = o.length ? this.queryRenderedFeatures(e1, {
                                layers: o
                            }) : [];
                        } else i = this.queryRenderedFeatures(e1, {
                            target: t1
                        });
                        return i;
                    };
                    if ("mouseenter" === e1 || "mouseover" === e1) {
                        let r = !1;
                        const n = (t1)=>{
                            const n = o(t1.point);
                            n.length ? r || (r = !0, i.call(this, new Xa(e1, this, t1.originalEvent, {
                                features: n
                            }))) : r = !1;
                        };
                        return {
                            listener: i,
                            targets: t1,
                            delegates: {
                                mousemove: n,
                                mouseout: ()=>{
                                    r = !1;
                                }
                            }
                        };
                    }
                    if ("mouseleave" === e1 || "mouseout" === e1) {
                        let r = !1;
                        const n = (t1)=>{
                            o(t1.point).length ? r = !0 : r && (r = !1, i.call(this, new Xa(e1, this, t1.originalEvent)));
                        }, s = (t1)=>{
                            r && (r = !1, i.call(this, new Xa(e1, this, t1.originalEvent)));
                        };
                        return {
                            listener: i,
                            targets: t1,
                            delegates: {
                                mousemove: n,
                                mouseout: s
                            }
                        };
                    }
                    {
                        const r = (e1)=>{
                            const t1 = o(e1.point);
                            t1.length && (e1.features = t1, i.call(this, e1), delete e1.features);
                        };
                        return {
                            listener: i,
                            targets: t1,
                            delegates: {
                                [e1]: r
                            }
                        };
                    }
                }
                on(e1, t1, i) {
                    if ("function" == typeof t1 || void 0 === i) return super.on(e1, t1);
                    if ("string" == typeof t1 && (t1 = [
                        t1
                    ]), !this._areTargetsValid(t1)) return this;
                    const o = this._createDelegatedListener(e1, t1, i);
                    this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[e1] = this._delegatedListeners[e1] || [], this._delegatedListeners[e1].push(o);
                    for(const e1 in o.delegates)this.on(e1, o.delegates[e1]);
                    return this;
                }
                once(e1, t1, i) {
                    if ("function" == typeof t1 || void 0 === i) return super.once(e1, t1);
                    if ("string" == typeof t1 && (t1 = [
                        t1
                    ]), !this._areTargetsValid(t1)) return this;
                    const o = this._createDelegatedListener(e1, t1, i);
                    for(const e1 in o.delegates)this.once(e1, o.delegates[e1]);
                    return this;
                }
                off(e1, t1, i) {
                    if ("function" == typeof t1 || void 0 === i) return super.off(e1, t1);
                    if ("string" == typeof t1 && (t1 = [
                        t1
                    ]), !this._areTargetsValid(t1)) return this;
                    const o = this._delegatedListeners ? this._delegatedListeners[e1] : void 0;
                    return o && ((e1)=>{
                        for(let o = 0; o < e1.length; o++){
                            const r = e1[o];
                            if (r.listener === i && $l(r.targets, t1)) {
                                for(const e1 in r.delegates)this.off(e1, r.delegates[e1]);
                                return e1.splice(o, 1), this;
                            }
                        }
                    })(o), this;
                }
                queryRenderedFeatures(t1, i) {
                    if (!this.style) return [];
                    if (void 0 === t1 || t1 instanceof e1.P || Array.isArray(t1) || void 0 !== i || (i = t1, t1 = void 0), t1 = t1 || [
                        [
                            0,
                            0
                        ],
                        [
                            this.transform.width,
                            this.transform.height
                        ]
                    ], !i) {
                        const e1 = this.style.queryRenderedFeatures(t1, void 0, this.transform), i = this.style.queryRenderedFeatureset(t1, void 0, this.transform);
                        return e1.concat(i);
                    }
                    let o = !0;
                    if (i.target && (o = this._isTargetValid(i.target), o && !i.layers)) return this.style.queryRenderedFeatureset(t1, i, this.transform);
                    let r = !0;
                    if (i.layers && Array.isArray(i.layers)) {
                        for (const e1 of i.layers)if (!this._isValidId(e1)) {
                            r = !1;
                            break;
                        }
                        if (r && !i.target) return this.style.queryRenderedFeatures(t1, i, this.transform);
                    }
                    let n = [];
                    return r && (n = n.concat(this.style.queryRenderedFeatures(t1, i, this.transform))), o && (n = n.concat(this.style.queryRenderedFeatureset(t1, i, this.transform))), n;
                }
                querySourceFeatures(e1, t1) {
                    return !e1 || "string" == typeof e1 && !this._isValidId(e1) ? [] : this.style.querySourceFeatures(e1, t1);
                }
                queryRasterValue(e1, t1, i) {
                    return this._isValidId(e1) ? this.style.queryRasterValue(e1, t1, i) : Promise.resolve(null);
                }
                isPointOnSurface(t1) {
                    const { name: i } = this.transform.projection;
                    return "globe" !== i && "mercator" !== i && e1.w(`${i} projection does not support isPointOnSurface, this API may behave unexpectedly.`), this.transform.isPointOnSurface(e1.P.convert(t1));
                }
                addInteraction(e1, t1) {
                    return this._interactions.add(e1, t1), this;
                }
                removeInteraction(e1) {
                    return this._interactions.remove(e1), this;
                }
                getCooperativeGestures() {
                    return this._cooperativeGestures;
                }
                setCooperativeGestures(e1) {
                    return this._cooperativeGestures = e1, this;
                }
                setStyle(t1, i) {
                    return i = Object.assign({}, {
                        localIdeographFontFamily: this._localIdeographFontFamily,
                        localFontFamily: this._localFontFamily
                    }, i), this.style && t1 && !1 !== i.diff && i.localFontFamily === this._localFontFamily && i.localIdeographFontFamily === this._localIdeographFontFamily && !i.config ? (this.style._diffStyle(t1, (o, r)=>{
                        if (o) {
                            const r = "string" == typeof o ? o : o instanceof Error ? o.message : o.error;
                            e1.w(`Unable to perform style diff: ${r}. Rebuilding the style from scratch.`), this._updateStyle(t1, i);
                        } else r && this._update(!0);
                    }, ()=>this._postStyleLoadEvent()), this) : (this._localIdeographFontFamily = i.localIdeographFontFamily, this._localFontFamily = i.localFontFamily, this._updateStyle(t1, i));
                }
                _getUIString(e1) {
                    const t1 = this._locale[e1];
                    if (null == t1) throw new Error(`Missing UI string '${e1}'`);
                    return t1;
                }
                _updateStyle(e1, t1) {
                    if (this.style && (this.style.setEventedParent(null), this.style._remove(), this.style = void 0), e1) {
                        const i = Object.assign({}, t1);
                        t1 && t1.config && (i.initialConfig = t1.config, delete i.config), this.style = new Lo(this, i).load(e1), this.style.setEventedParent(this, {
                            style: this.style
                        });
                    }
                    return this._updateTerrain(), this;
                }
                _lazyInitEmptyStyle() {
                    this.style || (this.style = new Lo(this, {}), this.style.setEventedParent(this, {
                        style: this.style
                    }), this.style.loadEmpty());
                }
                getStyle() {
                    if (this.style) return this.style.serialize();
                }
                isStyleLoaded() {
                    return this.style ? this.style.loaded() : (e1.w("There is no style added to the map."), !1);
                }
                _isValidId(t1) {
                    return null == t1 ? (this.fire(new e1.B(new Error("IDs can't be empty."))), !1) : !e1.d7(t1) || (this.fire(new e1.B(new Error(`IDs can't contain special symbols: "${t1}".`))), !1);
                }
                _isTargetValid(e1) {
                    return "featuresetId" in e1 ? this._isValidId("importId" in e1 ? e1.importId : e1.featuresetId) : "layerId" in e1 && this._isValidId(e1.layerId);
                }
                _areTargetsValid(e1) {
                    if (Array.isArray(e1)) {
                        for (const t1 of e1)if (!this._isValidId(t1)) return !1;
                        return !0;
                    }
                    return this._isTargetValid(e1);
                }
                addSource(e1, t1) {
                    return this._isValidId(e1) ? (this._lazyInitEmptyStyle(), this.style.addSource(e1, t1), this._update(!0)) : this;
                }
                isSourceLoaded(e1) {
                    return !!this._isValidId(e1) && !!this.style && this.style._isSourceCacheLoaded(e1);
                }
                areTilesLoaded() {
                    return this.style.areTilesLoaded();
                }
                addSourceType(e1, t1, i) {
                    this._lazyInitEmptyStyle(), this.style.addSourceType(e1, t1, i);
                }
                removeSource(e1) {
                    return this._isValidId(e1) ? (this.style.removeSource(e1), this._updateTerrain(), this._update(!0)) : this;
                }
                getSource(e1) {
                    return this._isValidId(e1) ? this.style.getOwnSource(e1) : null;
                }
                addImage(t1, i, { pixelRatio: o = 1, sdf: r = !1, stretchX: n, stretchY: s, content: a } = {}) {
                    this._lazyInitEmptyStyle();
                    const l = e1.I.from(t1);
                    if (i instanceof HTMLImageElement || ImageBitmap && i instanceof ImageBitmap) {
                        const { width: t1, height: c, data: h } = e1.o.getImageData(i);
                        this.style.addImage(l, {
                            data: new e1.q({
                                width: t1,
                                height: c
                            }, h),
                            pixelRatio: o,
                            stretchX: n,
                            stretchY: s,
                            content: a,
                            sdf: r,
                            version: 0,
                            usvg: !1
                        });
                    } else if (void 0 === i.width || void 0 === i.height) this.fire(new e1.B(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    else {
                        const { width: c, height: h } = i, d = i;
                        this.style.addImage(l, {
                            data: new e1.q({
                                width: c,
                                height: h
                            }, new Uint8Array(d.data)),
                            pixelRatio: o,
                            stretchX: n,
                            stretchY: s,
                            content: a,
                            sdf: r,
                            usvg: !1,
                            version: 0,
                            userImage: d
                        }), d.onAdd && d.onAdd(this, t1);
                    }
                }
                updateImage(t1, i) {
                    this._lazyInitEmptyStyle();
                    const o = e1.I.from(t1), r = this.style.getImage(o);
                    if (!r) return void this.fire(new e1.B(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                    const n = i instanceof HTMLImageElement || ImageBitmap && i instanceof ImageBitmap ? e1.o.getImageData(i) : i, { width: s, height: a, data: l } = n;
                    if (void 0 === s || void 0 === a) return void this.fire(new e1.B(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                    if (s !== (r.usvg ? r.icon.usvg_tree.width : r.data.width) || a !== (r.usvg ? r.icon.usvg_tree.height : r.data.height)) return void this.fire(new e1.B(new Error(`The width and height of the updated image (${s}, ${a})\n                must be that same as the previous version of the image\n                (${r.data.width}, ${r.data.height})`)));
                    const c = !(i instanceof HTMLImageElement || ImageBitmap && i instanceof ImageBitmap);
                    let h = !1;
                    r.usvg ? (r.data = new e1.q({
                        width: s,
                        height: a
                    }, new Uint8Array(l)), r.usvg = !1, r.icon = void 0, h = !0) : r.data.replace(l, c), this.style.updateImage(o, r, h);
                }
                hasImage(t1) {
                    return t1 ? !!this.style && !!this.style.getImage(e1.I.from(t1)) : (this.fire(new e1.B(new Error("Missing required image id"))), !1);
                }
                removeImage(t1) {
                    this.style.removeImage(e1.I.from(t1));
                }
                loadImage(t1, i) {
                    e1.n(this._requestManager.transformRequest(t1, e1.R.Image), (e1, t1)=>{
                        i(e1, t1);
                    });
                }
                listImages() {
                    return this.style.listImages().map((e1)=>e1.name);
                }
                addModel(e1, t1) {
                    this._lazyInitEmptyStyle(), this.style.addModel(e1, t1);
                }
                hasModel(t1) {
                    return t1 ? this.style.hasModel(t1) : (this.fire(new e1.B(new Error("Missing required model id"))), !1);
                }
                removeModel(e1) {
                    this.style.removeModel(e1);
                }
                listModels() {
                    return this.style.listModels();
                }
                addLayer(e1, t1) {
                    return this._isValidId(e1.id) ? (this._lazyInitEmptyStyle(), this.style.addLayer(e1, t1), this._update(!0)) : this;
                }
                getSlot(e1) {
                    const t1 = this.getLayer(e1);
                    return t1 && t1.slot || null;
                }
                setSlot(e1, t1) {
                    return this.style.setSlot(e1, t1), this.style.mergeLayers(), this._update(!0);
                }
                addImport(t1, i) {
                    return this.style.addImport(t1, i).catch((t1)=>this.fire(new e1.B(new Error("Failed to add import", t1)))), this;
                }
                updateImport(e1, t1) {
                    return "string" != typeof t1 && t1.id !== e1 ? (this.removeImport(e1), this.addImport(t1)) : (this.style.updateImport(e1, t1), this._update(!0));
                }
                removeImport(e1) {
                    return this.style.removeImport(e1), this;
                }
                moveImport(e1, t1) {
                    return this.style.moveImport(e1, t1), this._update(!0);
                }
                moveLayer(e1, t1) {
                    return this._isValidId(e1) ? (this.style.moveLayer(e1, t1), this._update(!0)) : this;
                }
                removeLayer(e1) {
                    return this._isValidId(e1) ? (this.style.removeLayer(e1), this._update(!0)) : this;
                }
                getLayer(e1) {
                    if (!this._isValidId(e1)) return null;
                    const t1 = this.style.getOwnLayer(e1);
                    return t1 ? "custom" === t1.type ? t1.implementation : t1.serialize() : void 0;
                }
                getSlots() {
                    return this.style.getSlots();
                }
                setLayerZoomRange(e1, t1, i) {
                    return this._isValidId(e1) ? (this.style.setLayerZoomRange(e1, t1, i), this._update(!0)) : this;
                }
                setFilter(e1, t1, i = {}) {
                    return this._isValidId(e1) ? (this.style.setFilter(e1, t1, i), this._update(!0)) : this;
                }
                getFilter(e1) {
                    return this._isValidId(e1) ? this.style.getFilter(e1) : null;
                }
                setPaintProperty(e1, t1, i, o = {}) {
                    return this._isValidId(e1) ? (this.style.setPaintProperty(e1, t1, i, o), this._update(!0)) : this;
                }
                getPaintProperty(e1, t1) {
                    return this._isValidId(e1) ? this.style.getPaintProperty(e1, t1) : null;
                }
                setLayoutProperty(e1, t1, i, o = {}) {
                    return this._isValidId(e1) ? (this.style.setLayoutProperty(e1, t1, i, o), this._update(!0)) : this;
                }
                getLayoutProperty(e1, t1) {
                    return this._isValidId(e1) ? this.style.getLayoutProperty(e1, t1) : null;
                }
                setLayerProperty(e1, t1, i, o = {}) {
                    return this._isValidId(e1) ? ("appearances" === t1 && this._postAddingAppearancesToStyleEvent(), this.style.setLayerProperty(e1, t1, i, o), this._update(!0)) : this;
                }
                getGlyphsUrl() {
                    return this.style.getGlyphsUrl();
                }
                setGlyphsUrl(e1) {
                    return this.style.setGlyphsUrl(e1), this._update(!0);
                }
                getSchema(e1) {
                    return this.style.getSchema(e1);
                }
                setSchema(e1, t1) {
                    return this.style.setSchema(e1, t1), this._update(!0);
                }
                getConfig(e1) {
                    return this.style.getConfig(e1);
                }
                setConfig(e1, t1) {
                    return this.style.setConfig(e1, t1), this._update(!0);
                }
                getConfigProperty(e1, t1) {
                    return this.style.getConfigProperty(e1, t1);
                }
                setConfigProperty(e1, t1, i) {
                    return this.style.setConfigProperty(e1, t1, i), this._update(!0);
                }
                getFeaturesetDescriptors(e1) {
                    return this.style.getFeaturesetDescriptors(e1);
                }
                setLights(e1) {
                    if (this._lazyInitEmptyStyle(), e1 && 1 === e1.length && "flat" === e1[0].type) {
                        const t1 = e1[0];
                        t1.properties ? this.style.setFlatLight(t1.properties, t1.id, {}) : this.style.setFlatLight({}, "flat");
                    } else this.style.setLights(e1), this.painter.terrain && (this.painter.terrain.invalidateRenderCache = !0);
                    return this._update(!0);
                }
                getLights() {
                    const e1 = this.style.getLights() || [];
                    return 0 === e1.length && e1.push({
                        id: this.style.light.id,
                        type: "flat",
                        properties: this.style.getFlatLight()
                    }), e1;
                }
                setLight(e1, t1 = {}) {
                    return console.log("The `map.setLight` function is deprecated, prefer using `map.setLights` with `flat` light type instead."), this.setLights([
                        {
                            id: "flat",
                            type: "flat",
                            properties: e1
                        }
                    ]);
                }
                getLight() {
                    return console.log("The `map.getLight` function is deprecated, prefer using `map.getLights` instead."), this.style.getFlatLight();
                }
                setTerrain(e1) {
                    return this._lazyInitEmptyStyle(), !e1 && this.transform.projection.requiresDraping ? this.style.setTerrainForDraping() : this.style.setTerrain(e1), this._averageElevationLastSampledAt = -1 / 0, this._update(!0);
                }
                getTerrain() {
                    return this.style ? this.style.getTerrain() : null;
                }
                setFog(e1) {
                    return this._lazyInitEmptyStyle(), this.style.setFog(e1), this._update(!0);
                }
                getFog() {
                    return this.style ? this.style.getFog() : null;
                }
                setSnow(e1) {
                    return this._lazyInitEmptyStyle(), this.style.setSnow(e1), this._update(!0);
                }
                getSnow() {
                    return this.style ? this.style.getSnow() : null;
                }
                setRain(e1) {
                    return this._lazyInitEmptyStyle(), this.style.setRain(e1), this._update(!0);
                }
                getRain() {
                    return this.style ? this.style.getRain() : null;
                }
                setColorTheme(e1) {
                    return this._lazyInitEmptyStyle(), this.style.setColorTheme(e1), this._update(!0);
                }
                setImportColorTheme(e1, t1) {
                    return this._lazyInitEmptyStyle(), this.style.setImportColorTheme(e1, t1), this._update(!0);
                }
                setCamera(e1) {
                    return this.style.setCamera(e1), this._triggerCameraUpdate(e1);
                }
                getNearClipOffset() {
                    return this.transform.nearClipOffset;
                }
                setNearClipOffset(e1) {
                    const t1 = this.transform.nearClipOffset !== e1;
                    return this.transform.nearClipOffset = e1, this._update(t1);
                }
                _triggerCameraUpdate(e1) {
                    return this._update(this.transform.setOrthographicProjectionAtLowPitch("orthographic" === e1["camera-projection"]));
                }
                getCamera() {
                    return this.style.camera;
                }
                _queryFogOpacity(t1) {
                    return this.style && this.style.fog ? this.style.fog.getOpacityAtLatLng(e1.aV.convert(t1), this.transform) : 0;
                }
                setFeatureState(e1, t1) {
                    return e1.source && !this._isValidId(e1.source) ? this : (this.style.setFeatureState(e1, t1), this._update());
                }
                removeFeatureState(e1, t1) {
                    return e1.source && !this._isValidId(e1.source) ? this : (this.style.removeFeatureState(e1, t1), this._update());
                }
                getFeatureState(e1) {
                    return e1.source && !this._isValidId(e1.source) ? null : this.style.getFeatureState(e1);
                }
                _selectIndoorFloor(e1) {
                    this.style.indoorManager.selectFloor(e1);
                }
                _setIndoorActiveFloorsVisibility(e1) {
                    this.style.indoorManager.setActiveFloorsVisibility(e1);
                }
                getIndoorTileOptions(e1, t1) {
                    return this.style.isIndoorEnabled() ? this.style.indoorManager.getIndoorTileOptions(e1, t1) : null;
                }
                _updateContainerDimensions() {
                    if (!this._container) return;
                    const e1 = this._container.getBoundingClientRect().width || 400, t1 = this._container.getBoundingClientRect().height || 300;
                    let i, o, r, n = this._container;
                    for(; n && (!o || !r);){
                        const e1 = window.getComputedStyle(n).transform;
                        e1 && "none" !== e1 && (i = e1.match(/matrix.*\((.+)\)/)[1].split(", "), i[0] && "0" !== i[0] && "1" !== i[0] && (o = i[0]), i[3] && "0" !== i[3] && "1" !== i[3] && (r = i[3])), n = n.parentElement;
                    }
                    this._containerWidth = o ? Math.abs(e1 / o) : e1, this._containerHeight = r ? Math.abs(t1 / r) : t1;
                }
                _detectMissingCSS() {
                    "rgb(250, 128, 114)" !== window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color") && e1.w("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");
                }
                _setupContainer() {
                    const e1 = this._container;
                    e1.classList.add("mapboxgl-map"), (this._missingCSSCanary = l("div", "mapboxgl-canary", e1)).style.visibility = "hidden", this._detectMissingCSS();
                    const t1 = this._canvasContainer = l("div", "mapboxgl-canvas-container", e1);
                    this._canvas = l("canvas", "mapboxgl-canvas", t1), this._interactive && (t1.classList.add("mapboxgl-interactive"), this._canvas.setAttribute("tabindex", "0")), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region"), this._updateContainerDimensions(), this._resizeCanvas(this._containerWidth, this._containerHeight);
                    const i = this._controlContainer = l("div", "mapboxgl-control-container", e1), o = this._controlPositions = {};
                    [
                        "top-left",
                        "top",
                        "top-right",
                        "right",
                        "bottom-right",
                        "bottom",
                        "bottom-left",
                        "left"
                    ].forEach((e1)=>{
                        o[e1] = l("div", `mapboxgl-ctrl-${e1}`, i);
                    }), this._container.addEventListener("scroll", this._onMapScroll, !1);
                }
                _resizeCanvas(t1, i) {
                    const o = e1.o.devicePixelRatio || 1;
                    this._canvas.width = o * Math.ceil(t1), this._canvas.height = o * Math.ceil(i), this._canvas.style.width = `${t1}px`, this._canvas.style.height = `${i}px`;
                }
                _addMarker(e1) {
                    this._markers.push(e1);
                }
                _removeMarker(e1) {
                    const t1 = this._markers.indexOf(e1);
                    -1 !== t1 && this._markers.splice(t1, 1);
                }
                _addPopup(e1) {
                    this._popups.push(e1);
                }
                _removePopup(e1) {
                    const t1 = this._popups.indexOf(e1);
                    -1 !== t1 && this._popups.splice(t1, 1);
                }
                _setupPainter() {
                    const t1 = Object.assign({}, a.supported.webGLContextAttributes, {
                        failIfMajorPerformanceCaveat: this._failIfMajorPerformanceCaveat,
                        preserveDrawingBuffer: this._preserveDrawingBuffer,
                        antialias: this._antialias || !1
                    }), i = this._canvas.getContext("webgl2", t1);
                    i ? (H(i, !0), this.painter = new Ba(i, this._contextCreateOptions, this.transform, this._scaleFactor, this._worldview), this.on("data", (e1)=>{
                        if ("source" === e1.dataType) {
                            const t1 = this.transform.elevation ? this.transform.elevation._source() : null;
                            t1 && e1.sourceCacheId === t1.id && this.style && this.style._setLabelPlacementStale(), this.painter.setTileLoadedFlag(!0);
                        }
                    }), e1.k.testSupport(i)) : this.fire(new e1.B(new Error("Failed to initialize WebGL")));
                }
                _contextLost(t1) {
                    t1.preventDefault(), this._frame && (this._frame.cancel(), this._frame = null), this.fire(new e1.C("webglcontextlost", {
                        originalEvent: t1
                    }));
                }
                _contextRestored(t1) {
                    this._setupPainter(), this.painter.resize(Math.ceil(this._containerWidth), Math.ceil(this._containerHeight)), this._updateTerrain(), this.style && (this.style.clearLayers(), this.style.imageManager.destroyAtlasTextures(), this.style.imageManager.imageAtlasCache.destroyTextures(), this.style.reloadModels(), this.style.clearSources()), this._update(), this.fire(new e1.C("webglcontextrestored", {
                        originalEvent: t1
                    }));
                }
                _onMapScroll(e1) {
                    if (e1.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
                }
                idle() {
                    return !this.isMoving() && this.loaded();
                }
                loaded() {
                    return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
                }
                frameReady() {
                    return this.loaded() && !this._placementDirty;
                }
                _update(e1) {
                    return this.style ? (this._styleDirty = this._styleDirty || e1, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
                }
                _requestRenderFrame(e1) {
                    return this._update(), this._renderTaskQueue.add(e1);
                }
                _cancelRenderFrame(e1) {
                    this._renderTaskQueue.remove(e1);
                }
                _requestDomTask(e1) {
                    !this.loaded() || this.loaded() && !this.isMoving() ? e1() : this._domRenderTaskQueue.add(e1);
                }
                _render(t1) {
                    let r;
                    this.fire(new e1.C("renderstart")), ++this._frameId;
                    const n = this.painter.context.extTimerQuery, s = e1.o.now(), a = this.painter.context.gl;
                    if (this.listens("gpu-timing-frame") && (r = a.createQuery(), a.beginQuery(n.TIME_ELAPSED_EXT, r)), this.painter.context.setDirty(), this.painter.setBaseState(), (this.isMoving() || this.isRotating() || this.isZooming()) && (this._interactionRange[0] = Math.min(this._interactionRange[0], performance.now()), this._interactionRange[1] = Math.max(this._interactionRange[1], performance.now())), this._renderTaskQueue.run(t1), this._domRenderTaskQueue.run(t1), this._removed) return;
                    this._updateProjectionTransition();
                    const l = this._isInitialLoad ? 0 : this._fadeDuration;
                    if (this.style && this._styleDirty) {
                        this._styleDirty = !1;
                        const t1 = this.transform.zoom, i = this.transform.pitch, o = e1.o.now(), r = new e1.ae(t1, {
                            now: o,
                            fadeDuration: l,
                            pitch: i,
                            transition: this.style.transition,
                            worldview: this._worldview
                        });
                        this.style.update(r);
                    }
                    this.style && this.style.hasFogTransition() && (this.style._markersNeedUpdate = !0, this._sourcesDirty = !0);
                    let c = !1;
                    if (this.style && this._sourcesDirty ? (this._sourcesDirty = !1, this.painter._updateFog(this.style), this._updateTerrain(), c = this._updateAverageElevation(s), this.style.updateSources(this.transform), this.style.updateImageProviders(), this.isMoving() || this._forceMarkerAndPopupUpdate()) : c = this._updateAverageElevation(s), this.style && (this._placementDirty = this.style._updatePlacement(this.painter.transform, this.showCollisionBoxes, l, this._crossSourceCollisions, this.painter.replacementSource)), this.style && this.painter.render(this.style, {
                        showTileBoundaries: this.showTileBoundaries,
                        showParseStatus: this.showParseStatus,
                        wireframe: {
                            terrain: this.showTerrainWireframe,
                            layers2D: this.showLayers2DWireframe,
                            layers3D: this.showLayers3DWireframe
                        },
                        showOverdrawInspector: this._showOverdrawInspector,
                        showQueryGeometry: !!this._showQueryGeometry,
                        showTileAABBs: this.showTileAABBs,
                        rotating: this.isRotating(),
                        zooming: this.isZooming(),
                        moving: this.isMoving(),
                        fadeDuration: l,
                        isInitialLoad: this._isInitialLoad,
                        showPadding: this.showPadding,
                        gpuTiming: !!this.listens("gpu-timing-layer"),
                        gpuTimingDeferredRender: !!this.listens("gpu-timing-deferred-render"),
                        speedIndexTiming: this.speedIndexTiming
                    }), this.fire(new e1.C("render")), this.loaded() && !this._loaded && (this._loaded = !0, o.mark(i.load), this.fire(new e1.C("load"))), this.style && this.style.hasTransitions() && (this._styleDirty = !0), this.style && (this.style.snow || this.style.rain) && (this._styleDirty = !0), this.style && this.style.imageManager.hasPatternsInFlight() && (this._styleDirty = !0), this.style && !this.style.modelManager.isLoaded() && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles(), r) {
                        const t1 = e1.o.now() - s;
                        a.endQuery(n.TIME_ELAPSED_EXT), setTimeout(()=>{
                            const i = a.getQueryParameter(r, a.QUERY_RESULT) / 1e6;
                            a.deleteQuery(r), this.fire(new e1.C("gpu-timing-frame", {
                                cpuTime: t1,
                                gpuTime: i
                            }));
                        }, 50);
                    }
                    if (this.listens("gpu-timing-layer")) {
                        const t1 = this.painter.collectGpuTimers();
                        setTimeout(()=>{
                            const i = this.painter.queryGpuTimers(t1);
                            this.fire(new e1.C("gpu-timing-layer", {
                                layerTimes: i
                            }));
                        }, 50);
                    }
                    if (this.listens("gpu-timing-deferred-render")) {
                        const t1 = this.painter.collectDeferredRenderGpuQueries();
                        setTimeout(()=>{
                            const i = this.painter.queryGpuTimeDeferredRender(t1);
                            this.fire(new e1.C("gpu-timing-deferred-render", {
                                gpuTime: i
                            }));
                        }, 50);
                    }
                    const h = this._sourcesDirty || this._styleDirty || this._placementDirty || c;
                    if (h || this._repaint) this.triggerRepaint();
                    else {
                        const t1 = this.idle();
                        if (t1 && (c = this._updateAverageElevation(s, !0)), c) this.triggerRepaint();
                        else if (this._triggerFrame(!1), t1 && (this.fire(new e1.C("idle")), this._isInitialLoad = !1, this.speedIndexTiming)) {
                            const t1 = this._calculateSpeedIndex();
                            this.fire(new e1.C("speedindexcompleted", {
                                speedIndex: t1
                            })), this.speedIndexTiming = !1;
                        }
                    }
                    !this._loaded || this._fullyLoaded || h || (this._fullyLoaded = !0, o.mark(i.fullLoad), this._performanceMetricsCollection && j(this._requestManager._customAccessToken, {
                        width: this.painter.width,
                        height: this.painter.height,
                        interactionRange: this._interactionRange,
                        visibilityHidden: this._visibilityHidden,
                        terrainEnabled: !!this.painter.style.getTerrain(),
                        fogEnabled: !!this.painter.style.getFog(),
                        projection: this.getProjection().name,
                        zoom: this.transform.zoom,
                        renderer: this.painter.context.renderer,
                        vendor: this.painter.context.vendor
                    }), this._authenticate());
                }
                _forceMarkerAndPopupUpdate(e1) {
                    for (const t1 of this._markers)e1 && !this.getRenderWorldCopies() && (t1._lngLat = t1._lngLat.wrap()), t1._update();
                    for (const t1 of this._popups)!e1 || this.getRenderWorldCopies() || t1._trackPointer || (t1._lngLat = t1._lngLat.wrap()), t1._update();
                }
                _updateAverageElevation(e1, t1 = !1) {
                    const i = (e1)=>(this.transform.averageElevation = e1, this._update(!1), !0);
                    if (!this.painter.averageElevationNeedsEasing()) return 0 !== this.transform.averageElevation && i(0);
                    const o = this.transform.elevation && this.transform.elevation.exaggeration() !== this._averageElevationExaggeration;
                    if (o || (t1 || e1 - this._averageElevationLastSampledAt > 500) && !this._averageElevation.isEasing(e1)) {
                        const t1 = this.transform.averageElevation;
                        let r = this.transform.sampleAverageElevation();
                        null != this.transform.elevation && (this._averageElevationExaggeration = this.transform.elevation.exaggeration()), isNaN(r) ? r = 0 : this._averageElevationLastSampledAt = e1;
                        const n = Math.abs(t1 - r);
                        if (n > 1) {
                            if (this._isInitialLoad || o) return this._averageElevation.jumpTo(r), i(r);
                            this._averageElevation.easeTo(r, e1, 300);
                        } else if (n > 1e-4) return this._averageElevation.jumpTo(r), i(r);
                    }
                    return !!this._averageElevation.isEasing(e1) && i(this._averageElevation.getValue(e1));
                }
                _authenticate() {
                    q(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, (t1)=>{
                        if (t1 && (t1.message === w || 401 === t1.status)) {
                            const t1 = this.painter.context.gl;
                            H(t1, !1), this._logoControl instanceof jl && this._logoControl._updateLogo(), t1 && t1.clear(t1.DEPTH_BUFFER_BIT | t1.COLOR_BUFFER_BIT | t1.STENCIL_BUFFER_BIT), this._silenceAuthErrors || this.fire(new e1.B(new Error("A valid Mapbox access token is required to use Mapbox GL JS. To create an account or a new access token, visit https://account.mapbox.com/")));
                        }
                    }), M(this._getMapId(), this._requestManager._skuToken, this._requestManager._customAccessToken, ()=>{});
                }
                _postStyleLoadEvent() {
                    this.style.globalId && F(this._requestManager._customAccessToken, {
                        map: this,
                        style: this.style.globalId,
                        importedStyles: this.style.getImportGlobalIds()
                    });
                }
                _postStyleWithAppearanceEvent() {
                    this.style.globalId && this.style.hasAppearances() && k(this._requestManager._customAccessToken);
                }
                _postAddingAppearancesToStyleEvent() {
                    U(this._requestManager._customAccessToken);
                }
                _updateTerrain() {
                    const e1 = this._isDragging();
                    this.painter.updateTerrain(this.style, e1);
                }
                _calculateSpeedIndex() {
                    const e1 = this.painter.canvasCopy(), t1 = this.painter.getCanvasCopiesAndTimestamps();
                    t1.timeStamps.push(performance.now());
                    const i = this.painter.context.gl, o = i.createFramebuffer();
                    function r(e1) {
                        i.framebufferTexture2D(i.FRAMEBUFFER, i.COLOR_ATTACHMENT0, i.TEXTURE_2D, e1, 0);
                        const t1 = new Uint8Array(i.drawingBufferWidth * i.drawingBufferHeight * 4);
                        return i.readPixels(0, 0, i.drawingBufferWidth, i.drawingBufferHeight, i.RGBA, i.UNSIGNED_BYTE, t1), t1;
                    }
                    return i.bindFramebuffer(i.FRAMEBUFFER, o), this._canvasPixelComparison(r(e1), t1.canvasCopies.map(r), t1.timeStamps);
                }
                _canvasPixelComparison(e1, t1, i) {
                    let o = i[1] - i[0];
                    const r = e1.length / 4;
                    for(let n = 0; n < t1.length; n++){
                        const s = t1[n];
                        let a = 0;
                        for(let t1 = 0; t1 < s.length; t1 += 4)s[t1] === e1[t1] && s[t1 + 1] === e1[t1 + 1] && s[t1 + 2] === e1[t1 + 2] && s[t1 + 3] === e1[t1 + 3] && (a += 1);
                        o += (i[n + 2] - i[n + 1]) * (1 - a / r);
                    }
                    return o;
                }
                remove() {
                    this._hash && this._hash.remove();
                    for (const e1 of this._controls)e1.onRemove(this);
                    this._controls = [], this._frame && (this._frame.cancel(), this._frame = null), this._renderTaskQueue.clear(), this._domRenderTaskQueue.clear(), this.style && this.style.destroy(), this.painter.destroy(), this.handlers && this.handlers.destroy(), this.handlers = void 0, this.setStyle(null), window.removeEventListener("resize", this._onWindowResize, !1), window.removeEventListener("orientationchange", this._onWindowResize, !1), window.removeEventListener(this._fullscreenchangeEvent, this._onWindowResize, !1), window.removeEventListener("online", this._onWindowOnline, !1), window.removeEventListener("visibilitychange", this._onVisibilityChange, !1);
                    const t1 = this.painter.context.gl.getExtension("WEBGL_lose_context");
                    t1 && t1.loseContext(), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvasContainer.remove(), this._controlContainer.remove(), this._missingCSSCanary.remove(), this._canvas = void 0, this._canvasContainer = void 0, this._controlContainer = void 0, this._missingCSSCanary = void 0, this._container.classList.remove("mapboxgl-map"), this._container.removeEventListener("scroll", this._onMapScroll, !1), Z.delete(this.painter.context.gl), G.remove(), O.remove(), this._removed = !0, this.fire(new e1.C("remove"));
                }
                triggerRepaint() {
                    this._triggerFrame(!0);
                }
                _triggerFrame(t1) {
                    this._renderNextFrame = this._renderNextFrame || t1, this.style && !this._frame && (this._frame = e1.o.frame((e1)=>{
                        const t1 = !!this._renderNextFrame;
                        this._frame = null, this._renderNextFrame = null, t1 && this._render(e1);
                    }));
                }
                _preloadTiles(t1) {
                    const i = this.style ? this.style.getSourceCaches() : [];
                    return e1.t(i, (e1, i)=>e1._preloadTiles(t1, i), ()=>{
                        this.triggerRepaint();
                    }), this;
                }
                _onWindowOnline() {
                    this._update();
                }
                _onWindowResize(e1) {
                    this._trackResize && this.resize({
                        originalEvent: e1
                    })._update();
                }
                _onVisibilityChange() {
                    "hidden" === document.visibilityState && this._visibilityHidden++;
                }
                get showTileBoundaries() {
                    return !!this._showTileBoundaries;
                }
                set showTileBoundaries(e1) {
                    this._showTileBoundaries !== e1 && (this._showTileBoundaries = e1, this._update());
                }
                get showParseStatus() {
                    return !!this._showParseStatus;
                }
                set showParseStatus(e1) {
                    this._showParseStatus !== e1 && (this._showParseStatus = e1, this._update());
                }
                get showTerrainWireframe() {
                    return !!this._showTerrainWireframe;
                }
                set showTerrainWireframe(e1) {
                    this._showTerrainWireframe !== e1 && (this._showTerrainWireframe = e1, this._update());
                }
                get showLayers2DWireframe() {
                    return !!this._showLayers2DWireframe;
                }
                set showLayers2DWireframe(e1) {
                    this._showLayers2DWireframe !== e1 && (this._showLayers2DWireframe = e1, this._update());
                }
                get showLayers3DWireframe() {
                    return !!this._showLayers3DWireframe;
                }
                set showLayers3DWireframe(e1) {
                    this._showLayers3DWireframe !== e1 && (this._showLayers3DWireframe = e1, this._update());
                }
                get speedIndexTiming() {
                    return !!this._speedIndexTiming;
                }
                set speedIndexTiming(e1) {
                    this._speedIndexTiming !== e1 && (this._speedIndexTiming = e1, this._update());
                }
                get showPadding() {
                    return !!this._showPadding;
                }
                set showPadding(e1) {
                    this._showPadding !== e1 && (this._showPadding = e1, this._update());
                }
                get showCollisionBoxes() {
                    return !!this._showCollisionBoxes;
                }
                set showCollisionBoxes(e1) {
                    this._showCollisionBoxes !== e1 && (this._showCollisionBoxes = e1, this.style && e1 ? this.style._generateCollisionBoxes() : this._update());
                }
                get showOverdrawInspector() {
                    return !!this._showOverdrawInspector;
                }
                set showOverdrawInspector(e1) {
                    this._showOverdrawInspector !== e1 && (this._showOverdrawInspector = e1, this._update());
                }
                get repaint() {
                    return !!this._repaint;
                }
                set repaint(e1) {
                    this._repaint !== e1 && (this._repaint = e1, this.triggerRepaint());
                }
                get vertices() {
                    return !!this._vertices;
                }
                set vertices(e1) {
                    this._vertices = e1, this._update();
                }
                get showTileAABBs() {
                    return !!this._showTileAABBs;
                }
                set showTileAABBs(e1) {
                    this._showTileAABBs !== e1 && (this._showTileAABBs = e1, e1 && this._update());
                }
                _setCacheLimits(t1, i) {
                    e1.eW(t1, i);
                }
                get version() {
                    return t1;
                }
            },
            NavigationControl: class {
                constructor(t1 = {}){
                    this.options = Object.assign({}, Yl, t1), this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.addEventListener("contextmenu", (e1)=>e1.preventDefault()), this.options.showZoom && (e1.a_([
                        "_setButtonTitle",
                        "_updateZoomButtons"
                    ], this), this._zoomInButton = this._createButton("mapboxgl-ctrl-zoom-in", (e1)=>{
                        this._map && this._map.zoomIn({}, {
                            originalEvent: e1
                        });
                    }), l("span", "mapboxgl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("mapboxgl-ctrl-zoom-out", (e1)=>{
                        this._map && this._map.zoomOut({}, {
                            originalEvent: e1
                        });
                    }), l("span", "mapboxgl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (e1.a_([
                        "_rotateCompassArrow"
                    ], this), this._compass = this._createButton("mapboxgl-ctrl-compass", (e1)=>{
                        const t1 = this._map;
                        t1 && (this.options.visualizePitch ? t1.resetNorthPitch({}, {
                            originalEvent: e1
                        }) : t1.resetNorth({}, {
                            originalEvent: e1
                        }));
                    }), this._compassIcon = l("span", "mapboxgl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
                }
                _updateZoomButtons() {
                    const e1 = this._map;
                    if (!e1) return;
                    const t1 = e1.getZoom(), i = t1 === e1.getMaxZoom(), o = t1 === e1.getMinZoom();
                    this._zoomInButton.disabled = i, this._zoomOutButton.disabled = o, this._zoomInButton.setAttribute("aria-disabled", i.toString()), this._zoomOutButton.setAttribute("aria-disabled", o.toString());
                }
                _rotateCompassArrow() {
                    const e1 = this._map;
                    if (!e1) return;
                    const t1 = this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(e1.transform.pitch * (Math.PI / 180)), .5)}) rotateX(${e1.transform.pitch}deg) rotateZ(${e1.transform.angle * (180 / Math.PI)}deg)` : `rotate(${e1.transform.angle * (180 / Math.PI)}deg)`;
                    e1._requestDomTask(()=>{
                        this._compassIcon && (this._compassIcon.style.transform = t1);
                    });
                }
                onAdd(e1) {
                    return this._map = e1, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), e1.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && e1.on("pitch", this._rotateCompassArrow), e1.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new Kl(e1, this._compass, this.options.visualizePitch)), this._container;
                }
                onRemove() {
                    const e1 = this._map;
                    e1 && (this._container.remove(), this.options.showZoom && e1.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && e1.off("pitch", this._rotateCompassArrow), e1.off("rotate", this._rotateCompassArrow), this._handler && this._handler.off(), this._handler = void 0), this._map = void 0);
                }
                _createButton(e1, t1) {
                    const i = l("button", e1, this._container);
                    return i.type = "button", i.addEventListener("click", t1), i;
                }
                _setButtonTitle(e1, t1) {
                    if (!this._map) return;
                    const i = this._map._getUIString(`NavigationControl.${t1}`);
                    e1.setAttribute("aria-label", i), e1.firstElementChild && e1.firstElementChild.setAttribute("title", i);
                }
            },
            GeolocateControl: class extends e1.E {
                constructor(t1 = {}){
                    super();
                    const i = navigator.geolocation;
                    this.options = Object.assign({
                        geolocation: i
                    }, ic, t1), e1.a_([
                        "_onSuccess",
                        "_onError",
                        "_onZoom",
                        "_finish",
                        "_setupUI",
                        "_updateCamera",
                        "_updateMarker",
                        "_updateMarkerRotation",
                        "_onDeviceOrientation"
                    ], this), this._updateMarkerRotationThrottled = ka(this._updateMarkerRotation, 20), this._numberOfWatches = 0;
                }
                onAdd(e1) {
                    return this._map = e1, this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkGeolocationSupport(this._setupUI), this._container;
                }
                onRemove() {
                    this._clearRequestTimeout(), void 0 !== this._geolocationWatchID && (this.options.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), this._container.remove(), this._map.off("zoom", this._onZoom), this._map = void 0, this._numberOfWatches = 0, this._noTimeout = !1;
                }
                _checkGeolocationSupport(e1) {
                    const t1 = (t1 = !!this.options.geolocation)=>{
                        this._supportsGeolocation = t1, e1(t1);
                    };
                    void 0 !== this._supportsGeolocation ? e1(this._supportsGeolocation) : void 0 !== navigator.permissions ? navigator.permissions.query({
                        name: "geolocation"
                    }).then((e1)=>t1("denied" !== e1.state)).catch(()=>t1()) : t1();
                }
                _isOutOfMapMaxBounds(e1) {
                    const t1 = this._map.getMaxBounds(), i = e1.coords;
                    return !!t1 && (i.longitude < t1.getWest() || i.longitude > t1.getEast() || i.latitude < t1.getSouth() || i.latitude > t1.getNorth());
                }
                _setErrorState() {
                    switch(this._watchState){
                        case "WAITING_ACTIVE":
                            this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                            break;
                        case "ACTIVE_LOCK":
                            this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                            break;
                        case "BACKGROUND":
                            this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");
                    }
                }
                _onSuccess(t1) {
                    if (this._map) {
                        if (this._clearRequestTimeout(), this._isOutOfMapMaxBounds(t1)) return this._setErrorState(), this.fire(new e1.C("outofmaxbounds", t1)), this._updateMarker(), void this._finish();
                        if (this.options.trackUserLocation) switch(this._lastKnownPosition = t1, this._watchState){
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                                this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this.options.followUserLocation ? (this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active")) : (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"));
                                break;
                            case "BACKGROUND":
                            case "BACKGROUND_ERROR":
                                this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                        }
                        this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(t1), this.options.followUserLocation && (!this.options.trackUserLocation || "ACTIVE_LOCK" === this._watchState) && this._updateCamera(t1), this.options.showUserLocation && this._userLocationDotMarker.removeClassName("mapboxgl-user-location-dot-stale"), this.fire(new e1.C("geolocate", Object.assign({
                            coords: t1.coords,
                            timestamp: t1.timestamp
                        }, t1.toJSON ? {
                            toJSON: t1.toJSON.bind(t1)
                        } : {}))), this._finish();
                    }
                }
                _updateCamera(t1) {
                    const i = new e1.aV(t1.coords.longitude, t1.coords.latitude), o = t1.coords.accuracy, r = this._map.getBearing(), n = Object.assign({
                        bearing: r
                    }, this.options.fitBoundsOptions);
                    this._map.fitBounds(i.toBounds(o), n, {
                        geolocateSource: !0
                    });
                }
                _updateMarker(t1) {
                    if (t1) {
                        const i = new e1.aV(t1.coords.longitude, t1.coords.latitude);
                        this._accuracyCircleMarker.setLngLat(i).addTo(this._map), this._userLocationDotMarker.setLngLat(i).addTo(this._map), this._accuracy = t1.coords.accuracy, this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                    } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                }
                _updateCircleRadius() {
                    const t1 = this._map.transform, i = e1.bV(1, t1._center.lat) * t1.worldSize, o = Math.ceil(2 * this._accuracy * i);
                    this._circleElement.style.width = `${o}px`, this._circleElement.style.height = `${o}px`;
                }
                _onZoom() {
                    this.options.showUserLocation && this.options.showAccuracyCircle && this._updateCircleRadius();
                }
                _updateMarkerRotation() {
                    this._userLocationDotMarker && "number" == typeof this._heading ? (this._userLocationDotMarker.setRotation(this._heading), this._userLocationDotMarker.addClassName("mapboxgl-user-location-show-heading")) : (this._userLocationDotMarker.removeClassName("mapboxgl-user-location-show-heading"), this._userLocationDotMarker.setRotation(0));
                }
                _onError(t1) {
                    if (this._map) {
                        if (this._clearRequestTimeout(), this.options.trackUserLocation) {
                            if (1 === t1.code) {
                                this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                                const e1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                this._geolocateButton.setAttribute("aria-label", e1), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e1), void 0 !== this._geolocationWatchID && this._clearWatch();
                            } else {
                                if (3 === t1.code && this._noTimeout) return;
                                this._setErrorState();
                            }
                        }
                        "OFF" !== this._watchState && this.options.showUserLocation && this._userLocationDotMarker.addClassName("mapboxgl-user-location-dot-stale"), this.fire(new e1.C("error", {
                            code: t1.code,
                            message: t1.message,
                            PERMISSION_DENIED: t1.PERMISSION_DENIED,
                            POSITION_UNAVAILABLE: t1.POSITION_UNAVAILABLE,
                            TIMEOUT: t1.TIMEOUT
                        })), this._finish();
                    }
                }
                _finish() {
                    this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                }
                _startRequestTimeout() {
                    this._clearRequestTimeout();
                    const e1 = this.options.positionOptions.timeout;
                    e1 && (this._requestTimeoutId = window.setTimeout(()=>{
                        this._onError({
                            code: 3,
                            message: "Geolocation request timed out"
                        });
                    }, e1));
                }
                _clearRequestTimeout() {
                    void 0 !== this._requestTimeoutId && (clearTimeout(this._requestTimeoutId), this._requestTimeoutId = void 0);
                }
                _setupUI(t1) {
                    if (void 0 !== this._map) {
                        if (this._container.addEventListener("contextmenu", (e1)=>e1.preventDefault()), this._geolocateButton = l("button", "mapboxgl-ctrl-geolocate", this._container), l("span", "mapboxgl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", !1 === t1) {
                            e1.w("Geolocation support is not available so the GeolocateControl will be disabled.");
                            const t1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                            this._geolocateButton.disabled = !0, this._geolocateButton.setAttribute("aria-label", t1), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", t1);
                        } else {
                            const e1 = this._map._getUIString("GeolocateControl.FindMyLocation");
                            this._geolocateButton.setAttribute("aria-label", e1), this._geolocateButton.firstElementChild && this._geolocateButton.firstElementChild.setAttribute("title", e1);
                        }
                        this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = l("div", "mapboxgl-user-location"), this._dotElement.appendChild(l("div", "mapboxgl-user-location-dot")), this._dotElement.appendChild(l("div", "mapboxgl-user-location-heading")), this._userLocationDotMarker = new tc({
                            element: this._dotElement,
                            rotationAlignment: "map",
                            pitchAlignment: "map"
                        }), this._circleElement = l("div", "mapboxgl-user-location-accuracy-circle"), this._accuracyCircleMarker = new tc({
                            element: this._circleElement,
                            pitchAlignment: "map"
                        }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onZoom)), this._geolocateButton.addEventListener("click", this.trigger.bind(this)), this._setup = !0, this.options.showButton || (this._container.style.display = "none"), this.options.trackUserLocation && this._map.on("movestart", (t1)=>{
                            t1.geolocateSource || "ACTIVE_LOCK" !== this._watchState || t1.originalEvent && "resize" === t1.originalEvent.type || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this.fire(new e1.C("trackuserlocationend")));
                        });
                    }
                }
                _onDeviceOrientation(e1) {
                    this._userLocationDotMarker && (e1.webkitCompassHeading ? this._heading = e1.webkitCompassHeading : !0 === e1.absolute && (this._heading = -1 * e1.alpha), this._updateMarkerRotationThrottled());
                }
                trigger() {
                    if (!this._setup) return e1.w("Geolocate control triggered before added to a map"), !1;
                    if (this.options.trackUserLocation) {
                        switch(this._watchState){
                            case "OFF":
                                this._watchState = "WAITING_ACTIVE", this.fire(new e1.C("trackuserlocationstart"));
                                break;
                            case "WAITING_ACTIVE":
                            case "ACTIVE_LOCK":
                            case "ACTIVE_ERROR":
                            case "BACKGROUND_ERROR":
                                this._numberOfWatches--, this._noTimeout = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this.fire(new e1.C("trackuserlocationend"));
                                break;
                            case "BACKGROUND":
                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new e1.C("trackuserlocationstart"));
                        }
                        switch(this._watchState){
                            case "WAITING_ACTIVE":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                break;
                            case "ACTIVE_LOCK":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");
                                break;
                            case "ACTIVE_ERROR":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");
                                break;
                            case "BACKGROUND":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");
                                break;
                            case "BACKGROUND_ERROR":
                                this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");
                        }
                        if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                        else if (void 0 === this._geolocationWatchID) {
                            let e1;
                            this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), this._numberOfWatches++, this._numberOfWatches > 1 ? (e1 = {
                                maximumAge: 6e5,
                                timeout: 0
                            }, this._noTimeout = !0) : (e1 = this.options.positionOptions, this._noTimeout = !1), this._geolocationWatchID = this.options.geolocation.watchPosition(this._onSuccess, this._onError, e1), this._startRequestTimeout(), this.options.showUserHeading && this._addDeviceOrientationListener();
                        }
                    } else this.options.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._startRequestTimeout(), this._timeoutId = window.setTimeout(this._finish, 1e4);
                    return !0;
                }
                setFollowUserLocation(t1) {
                    return this.options.followUserLocation = null != t1 ? t1 : ic.followUserLocation, this.options.trackUserLocation && "OFF" !== this._watchState && (this.options.followUserLocation ? "BACKGROUND" !== this._watchState && "BACKGROUND_ERROR" !== this._watchState || (this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new e1.C("trackuserlocationstart"))) : "ACTIVE_LOCK" !== this._watchState && "ACTIVE_ERROR" !== this._watchState || (this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"), this.fire(new e1.C("trackuserlocationend")))), this;
                }
                _addDeviceOrientationListener() {
                    const e1 = ()=>{
                        const e1 = "ondeviceorientationabsolute" in window ? "deviceorientationabsolute" : "deviceorientation";
                        window.addEventListener(e1, this._onDeviceOrientation);
                    };
                    "function" == typeof DeviceOrientationEvent.requestPermission ? DeviceOrientationEvent.requestPermission().then((t1)=>{
                        "granted" === t1 && e1();
                    }).catch(console.error) : e1();
                }
                _clearWatch() {
                    this._clearRequestTimeout(), this.options.geolocation.clearWatch(this._geolocationWatchID), window.removeEventListener("deviceorientation", this._onDeviceOrientation), window.removeEventListener("deviceorientationabsolute", this._onDeviceOrientation), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
                }
            },
            AttributionControl: Vl,
            ScaleControl: class {
                constructor(t1 = {}){
                    this.options = Object.assign({}, oc, t1), e1.a_([
                        "_update",
                        "_setScale",
                        "setUnit"
                    ], this);
                }
                getDefaultPosition() {
                    return "bottom-left";
                }
                _update() {
                    const e1 = this.options.maxWidth || 100, t1 = this._map, i = t1._containerHeight / 2, o = t1._containerWidth / 2 - e1 / 2, r = t1.unproject([
                        o,
                        i
                    ]), n = t1.unproject([
                        o + e1,
                        i
                    ]), s = r.distanceTo(n);
                    if ("imperial" === this.options.unit) {
                        const t1 = 3.2808 * s;
                        t1 > 5280 ? this._setScale(e1, t1 / 5280, "mile") : this._setScale(e1, t1, "foot");
                    } else "nautical" === this.options.unit ? this._setScale(e1, s / 1852, "nautical-mile") : s >= 1e3 ? this._setScale(e1, s / 1e3, "kilometer") : this._setScale(e1, s, "meter");
                }
                _setScale(e1, t1, i) {
                    this._map._requestDomTask(()=>{
                        const o = function(e1) {
                            const t1 = Math.pow(10, `${Math.floor(e1)}`.length - 1);
                            let i = e1 / t1;
                            return i = i >= 10 ? 10 : i >= 5 ? 5 : i >= 3 ? 3 : i >= 2 ? 2 : i >= 1 ? 1 : function(e1) {
                                const t1 = Math.pow(10, Math.ceil(-Math.log(e1) / Math.LN10));
                                return Math.round(e1 * t1) / t1;
                            }(i), t1 * i;
                        }(t1), r = o / t1;
                        this._container.innerHTML = "nautical-mile" !== i ? new Intl.NumberFormat(this._language, {
                            style: "unit",
                            unitDisplay: "short",
                            unit: i
                        }).format(o) : `${o}&nbsp;${rc[i]}`, this._container.style.width = e1 * r + "px";
                    });
                }
                onAdd(e1) {
                    return this._map = e1, this._language = e1.getLanguage(), this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-scale", e1.getContainer()), this._container.dir = "auto", this._map.on("move", this._update), this._update(), this._container;
                }
                onRemove() {
                    this._container.remove(), this._map.off("move", this._update), this._map = void 0;
                }
                _setLanguage(e1) {
                    this._language = e1, this._update();
                }
                setUnit(e1) {
                    this.options.unit = e1, this._update();
                }
            },
            FullscreenControl: class {
                constructor(t1 = {}){
                    this._fullscreen = !1, t1 && t1.container && (t1.container instanceof HTMLElement ? this._container = t1.container : e1.w("Full screen control 'container' must be a DOM element.")), e1.a_([
                        "_onClickFullscreen",
                        "_changeIcon"
                    ], this), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onwebkitfullscreenchange" in document && (this._fullscreenchange = "webkitfullscreenchange");
                }
                onAdd(t1) {
                    return this._map = t1, this._container || (this._container = this._map.getContainer()), this._controlContainer = l("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._checkFullscreenSupport() ? this._setupUI() : (this._controlContainer.style.display = "none", e1.w("This device does not support fullscreen mode.")), this._controlContainer;
                }
                onRemove() {
                    this._controlContainer.remove(), this._map = null, document.removeEventListener(this._fullscreenchange, this._changeIcon);
                }
                _checkFullscreenSupport() {
                    return !(!document.fullscreenEnabled && !document.webkitFullscreenEnabled);
                }
                _setupUI() {
                    const e1 = this._fullscreenButton = l("button", "mapboxgl-ctrl-fullscreen", this._controlContainer);
                    l("span", "mapboxgl-ctrl-icon", e1).setAttribute("aria-hidden", "true"), e1.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), document.addEventListener(this._fullscreenchange, this._changeIcon);
                }
                _updateTitle() {
                    const e1 = this._getTitle();
                    this._fullscreenButton.setAttribute("aria-label", e1), this._fullscreenButton.firstElementChild && this._fullscreenButton.firstElementChild.setAttribute("title", e1);
                }
                _getTitle() {
                    return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
                }
                _isFullscreen() {
                    return this._fullscreen;
                }
                _changeIcon() {
                    (document.fullscreenElement || document.webkitFullscreenElement) === this._container !== this._fullscreen && (this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"), this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"), this._updateTitle());
                }
                _onClickFullscreen() {
                    this._isFullscreen() ? document.exitFullscreen ? document.exitFullscreen() : document.webkitCancelFullScreen && document.webkitCancelFullScreen() : this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.webkitRequestFullscreen && this._container.webkitRequestFullscreen();
                }
            },
            IndoorControl: class {
                constructor(){
                    e1.a_([
                        "_onIndoorUpdate",
                        "_onStyleData",
                        "_scrollUp",
                        "_scrollDown",
                        "_toggleIndoor"
                    ], this), this._visibleFloorStart = 0, this._lastSelectedFloorId = null;
                }
                onAdd(e1) {
                    return this._map = e1, this._container = l("div", "mapboxgl-ctrl mapboxgl-ctrl-group"), this._container.style.display = "none", this._map.on("styledata", this._onStyleData), this._updateConnection(), this._container;
                }
                _onStyleData() {
                    this._updateConnection();
                }
                _updateConnection() {
                    if (this._map && this._map.style && this._map.style.indoorManager) {
                        const e1 = this._map.style.indoorManager;
                        e1.off("selector-update", this._onIndoorUpdate), e1.on("selector-update", this._onIndoorUpdate), this._onIndoorUpdate(e1.getControlState());
                    }
                }
                _createButton(e1, t1) {
                    const i = l("button", e1, this._container);
                    return i.type = "button", i.addEventListener("click", t1), i;
                }
                _setButtonTitle(e1, t1) {
                    e1.setAttribute("aria-label", t1), e1.textContent = t1;
                }
                onRemove() {
                    this._container && this._container.remove(), this._map && (this._map.off("styledata", this._onStyleData), this._map.style && this._map.style.indoorManager.off("selector-update", this._onIndoorUpdate), this._map = null);
                }
                getDefaultPosition() {
                    return "top-right";
                }
                _onIndoorUpdate(e1) {
                    if (!e1 || !e1.floors || 0 === e1.floors.length) return this._model = e1, void (this._container.style.display = "none");
                    const t1 = this._model;
                    this._model = e1, this._container.style.display = "inline-block";
                    const i = !t1 || t1.floors.length !== e1.floors.length || t1.floors.some((t1, i)=>t1.id !== e1.floors[i].id);
                    if (i && (this._visibleFloorStart = 0, this._lastSelectedFloorId = null), e1.selectedFloorId) {
                        if (e1.selectedFloorId !== this._lastSelectedFloorId || i) {
                            const t1 = e1.floors.findIndex((t1)=>t1.id === e1.selectedFloorId);
                            if (-1 !== t1) {
                                const i = e1.floors.length;
                                let o, r;
                                i <= 5 ? (o = 0, r = i - 1) : 0 === this._visibleFloorStart ? (o = 0, r = 3) : this._visibleFloorStart >= i - 3 ? (o = i - 3 - 1, r = i - 1) : (o = this._visibleFloorStart, r = this._visibleFloorStart + 3 - 1), t1 < o ? this._visibleFloorStart = t1 : t1 > r && (this._visibleFloorStart = t1 - 2);
                            }
                        }
                        this._lastSelectedFloorId = e1.selectedFloorId;
                    }
                    this._render();
                }
                _render() {
                    if (!this._container || !this._model || !this._model.floors) return;
                    this._container.innerHTML = "";
                    const e1 = this._createButton("mapboxgl-ctrl-indoor-toggle", this._toggleIndoor);
                    l("span", "mapboxgl-ctrl-icon", e1).setAttribute("aria-hidden", "true"), this._model.activeFloorsVisible || e1.classList.add("mapboxgl-ctrl-level-button-selected"), this._container.appendChild(e1);
                    const t1 = this._model.floors, i = t1.length;
                    if (i <= 5) return void t1.forEach((e1)=>this._createFloorButton(e1));
                    const o = 0 === this._visibleFloorStart, r = this._visibleFloorStart >= i - 3;
                    if (o) this._createFloorButton(t1[0]);
                    else {
                        const e1 = this._createButton("mapboxgl-ctrl-arrow-up", this._scrollUp);
                        l("span", "mapboxgl-ctrl-icon", e1).setAttribute("aria-hidden", "true"), this._container.appendChild(e1);
                    }
                    let n = [];
                    if (n = o ? t1.slice(1, 4) : r ? t1.slice(this._visibleFloorStart - 1, this._visibleFloorStart + 3 - 1) : t1.slice(this._visibleFloorStart, this._visibleFloorStart + 3), n.forEach((e1)=>this._createFloorButton(e1)), r) this._createFloorButton(t1[i - 1]);
                    else {
                        const e1 = this._createButton("mapboxgl-ctrl-arrow-down", this._scrollDown);
                        l("span", "mapboxgl-ctrl-icon", e1).setAttribute("aria-hidden", "true"), this._container.appendChild(e1);
                    }
                }
                _createFloorButton(e1) {
                    const t1 = this._createButton("mapboxgl-ctrl-level-button", ()=>{
                        const t1 = e1.id;
                        this._model && this._model.selectedFloorId === t1 && this._model.activeFloorsVisible || this._map && (this._model && !this._model.activeFloorsVisible && this._map.style && this._map.style.indoorManager && this._map.style.indoorManager.setActiveFloorsVisibility(!0), this._map._selectIndoorFloor(t1));
                    }), i = (e1.name || "").trim(), o = e1.zIndex.toString(), r = i ? Array.from(i).slice(0, 3).join("") : o;
                    this._setButtonTitle(t1, r), this._model && this._model.activeFloorsVisible && e1.id === this._model.selectedFloorId && t1.classList.add("mapboxgl-ctrl-level-button-selected"), this._container && this._container.appendChild(t1);
                }
                _toggleIndoor() {
                    this._map && this._map.style && this._map.style.indoorManager && this._model && this._model.activeFloorsVisible && this._map.style.indoorManager.setActiveFloorsVisibility(!1);
                }
                _scrollUp() {
                    if (this._visibleFloorStart > 0) {
                        this._visibleFloorStart--, 1 === this._visibleFloorStart && (this._visibleFloorStart = 0);
                        const e1 = this._model && this._model.floors || [];
                        if (e1.length > 3) {
                            const t1 = e1.length - 3;
                            this._visibleFloorStart === t1 - 1 && (this._visibleFloorStart = t1 - 2);
                        }
                        this._render();
                    }
                }
                _scrollDown() {
                    if (this._model && this._model.floors) {
                        const e1 = this._model.floors.length - 3;
                        this._visibleFloorStart < e1 && (this._visibleFloorStart++, 1 === this._visibleFloorStart && (this._visibleFloorStart = 2), this._visibleFloorStart === e1 - 1 && (this._visibleFloorStart = e1), this._visibleFloorStart > e1 && (this._visibleFloorStart = e1), this._render());
                    }
                }
            },
            Popup: class extends e1.E {
                constructor(t1){
                    super(), this.options = Object.assign(Object.create(nc), t1), this._altitude = this.options.altitude, e1.a_([
                        "_update",
                        "_onClose",
                        "remove",
                        "_onMouseEvent"
                    ], this), this._classList = new Set(t1 && t1.className ? t1.className.trim().split(/\s+/) : []);
                }
                addTo(t1) {
                    return this._map && this.remove(), this._map = t1, this.options.closeOnClick && t1.on("preclick", this._onClose), this.options.closeOnMove && t1.on("move", this._onClose), t1.on("remove", this.remove), this._update(), t1._addPopup(this), this._focusFirstElement(), this._trackPointer ? (t1.on("mousemove", this._onMouseEvent), t1.on("mouseup", this._onMouseEvent), t1._canvasContainer.classList.add("mapboxgl-track-pointer")) : t1.on("move", this._update), this.fire(new e1.C("open")), this;
                }
                isOpen() {
                    return !!this._map;
                }
                remove() {
                    this._content && this._content.remove(), this._container && (this._container.remove(), this._container = void 0);
                    const t1 = this._map;
                    return t1 && (t1.off("move", this._update), t1.off("move", this._onClose), t1.off("preclick", this._onClose), t1.off("click", this._onClose), t1.off("remove", this.remove), t1.off("mousemove", this._onMouseEvent), t1.off("mouseup", this._onMouseEvent), t1.off("drag", this._onMouseEvent), t1._canvasContainer && t1._canvasContainer.classList.remove("mapboxgl-track-pointer"), t1._removePopup(this), this._map = void 0), this.fire(new e1.C("close")), this;
                }
                getLngLat() {
                    return this._lngLat;
                }
                setLngLat(t1) {
                    this._lngLat = e1.aV.convert(t1), this._pos = null, this._trackPointer = !1, this._update();
                    const i = this._map;
                    return i && (i.on("move", this._update), i.off("mousemove", this._onMouseEvent), i._canvasContainer.classList.remove("mapboxgl-track-pointer")), this;
                }
                getAltitude() {
                    return this._altitude;
                }
                setAltitude(e1) {
                    return this._altitude = e1, this._update(), this;
                }
                trackPointer() {
                    this._trackPointer = !0, this._pos = null, this._update();
                    const e1 = this._map;
                    return e1 && (e1.off("move", this._update), e1.on("mousemove", this._onMouseEvent), e1.on("drag", this._onMouseEvent), e1._canvasContainer.classList.add("mapboxgl-track-pointer")), this;
                }
                getElement() {
                    return this._container;
                }
                setText(e1) {
                    return this.setDOMContent(document.createTextNode(e1));
                }
                setHTML(e1) {
                    const t1 = document.createDocumentFragment(), i = document.createElement("body");
                    let o;
                    for(i.innerHTML = e1; o = i.firstChild, o;)t1.appendChild(o);
                    return this.setDOMContent(t1);
                }
                getMaxWidth() {
                    return this._container && this._container.style.maxWidth;
                }
                setMaxWidth(e1) {
                    return this.options.maxWidth = e1, this._update(), this;
                }
                setDOMContent(e1) {
                    let t1 = this._content;
                    if (t1) for(; t1.hasChildNodes();)t1.firstChild && t1.removeChild(t1.firstChild);
                    else t1 = this._content = l("div", "mapboxgl-popup-content", this._container || void 0);
                    if (t1.appendChild(e1), this.options.closeButton) {
                        const e1 = this._closeButton = l("button", "mapboxgl-popup-close-button", t1);
                        e1.type = "button", e1.setAttribute("aria-label", "Close popup"), e1.innerHTML = '<span aria-hidden="true">&#215;</span>', e1.addEventListener("click", this._onClose);
                    }
                    return this._update(), this._focusFirstElement(), this;
                }
                addClassName(e1) {
                    return this._classList.add(e1), this._updateClassList(), this;
                }
                removeClassName(e1) {
                    return this._classList.delete(e1), this._updateClassList(), this;
                }
                setOffset(e1) {
                    return this.options.offset = e1, this._update(), this;
                }
                toggleClassName(e1) {
                    let t1;
                    return this._classList.delete(e1) ? t1 = !1 : (this._classList.add(e1), t1 = !0), this._updateClassList(), t1;
                }
                _onMouseEvent(e1) {
                    this._update(e1.point);
                }
                _getAnchor(e1) {
                    if (this.options.anchor) return this.options.anchor;
                    const t1 = this._map, i = this._container, o = this._pos;
                    if (!t1 || !i || !o) return "bottom";
                    const r = i.offsetWidth, n = i.offsetHeight, s = o.x < r / 2, a = o.x > t1.transform.width - r / 2;
                    if (o.y + e1 < n) return s ? "top-left" : a ? "top-right" : "top";
                    if (o.y > t1.transform.height - n) {
                        if (s) return "bottom-left";
                        if (a) return "bottom-right";
                    }
                    return s ? "left" : a ? "right" : "bottom";
                }
                _updateClassList() {
                    const e1 = this._container;
                    if (!e1) return;
                    const t1 = [
                        ...this._classList
                    ];
                    t1.push("mapboxgl-popup"), this._anchor && t1.push(`mapboxgl-popup-anchor-${this._anchor}`), this._trackPointer && t1.push("mapboxgl-popup-track-pointer"), e1.className = t1.join(" ");
                }
                _update(t1) {
                    const i = this._map, o = this._content;
                    if (!i || !this._lngLat && !this._trackPointer || !o) return;
                    let r = this._container;
                    if (r || (r = this._container = l("div", "mapboxgl-popup", i.getContainer()), this._tip = l("div", "mapboxgl-popup-tip", r), r.appendChild(o)), this.options.maxWidth && r.style.maxWidth !== this.options.maxWidth && (r.style.maxWidth = this.options.maxWidth), i.transform.renderWorldCopies && !this._trackPointer && (this._lngLat = Ql(this._lngLat, this._pos, i.transform)), !this._trackPointer || t1) {
                        const o = this._pos = this._trackPointer && t1 instanceof e1.P ? t1 : i.project(this._lngLat, this._altitude), r = ac(this.options.offset), n = this._anchor = this._getAnchor(r.y), s = ac(this.options.offset, n), a = o.add(s).round();
                        i._requestDomTask(()=>{
                            this._container && n && (this._container.style.transform = `${Jl[n]} translate(${a.x}px,${a.y}px)`);
                        });
                    }
                    if (!this._marker && i._showingGlobe()) {
                        const t1 = e1.eX(i.transform, this._lngLat) ? 0 : 1;
                        this._setOpacity(t1);
                    }
                    this._updateClassList();
                }
                _focusFirstElement() {
                    if (!this.options.focusAfterOpen || !this._container) return;
                    const e1 = this._container.querySelector(sc);
                    e1 && e1.focus();
                }
                _onClose() {
                    this.remove();
                }
                _setOpacity(e1) {
                    this._container && (this._container.style.opacity = `${e1}`), this._content && (this._content.style.pointerEvents = e1 ? "auto" : "none");
                }
            },
            Marker: tc,
            Style: Lo,
            LngLat: e1.aV,
            LngLatBounds: e1.aK,
            Point: e1.P,
            MercatorCoordinate: e1.ag,
            FreeCameraOptions: to,
            Evented: e1.E,
            config: e1.e,
            prewarm: function() {
                ie().acquire(K);
            },
            clearPrewarmedResources: function() {
                const e1 = ee;
                e1 && (e1.isPreloaded() && 1 === e1.numActive() ? (e1.release(K), ee = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
            },
            get accessToken () {
                return e1.e.ACCESS_TOKEN;
            },
            set accessToken (t){
                e1.e.ACCESS_TOKEN = t;
            },
            get baseApiUrl () {
                return e1.e.API_URL;
            },
            set baseApiUrl (t){
                e1.e.API_URL = t;
            },
            get workerCount () {
                return Q.workerCount;
            },
            set workerCount (e){
                Q.workerCount = e;
            },
            get maxParallelImageRequests () {
                return e1.e.MAX_PARALLEL_IMAGE_REQUESTS;
            },
            set maxParallelImageRequests (t){
                e1.e.MAX_PARALLEL_IMAGE_REQUESTS = t;
            },
            clearStorage (t1) {
                e1.f3(t1);
            },
            get workerUrl () {
                return X.workerUrl;
            },
            set workerUrl (e){
                X.workerUrl = e;
            },
            get workerClass () {
                return X.workerClass;
            },
            set workerClass (e){
                X.workerClass = e;
            },
            get workerParams () {
                return X.workerParams;
            },
            set workerParams (e){
                X.workerParams = e;
            },
            get dracoUrl () {
                return e1.f2();
            },
            set dracoUrl (t){
                e1.e.DRACO_URL = e1.o.resolveURL(t);
            },
            get meshoptUrl () {
                return e1.f1();
            },
            set meshoptUrl (t){
                const i = e1.o.resolveURL(t);
                e1.e.MESHOPT_URL = i, e1.e.MESHOPT_SIMD_URL = i;
            },
            get buildingGenUrl () {
                return e1.f0();
            },
            set buildingGenUrl (t){
                e1.e.BUILDING_GEN_URL = e1.o.resolveURL(t);
            },
            setNow: e1.o.setNow,
            restoreNow: e1.o.restoreNow
        };
        return lc;
    });
    var mapboxgl$1 = mapboxgl;
    return mapboxgl$1;
});

});



var $gKp6f = parcelRequire("gKp6f");
const $778b90c441419e64$var$mapBlocks = document.querySelectorAll('.mapblock');
$778b90c441419e64$var$mapBlocks.forEach((mapBlock)=>{
    const canvas = mapBlock.querySelector('.map-canvas');
    const map = (0, $gKp6f.renderRoute)(canvas);
});

})();
//# sourceMappingURL=map-block.js.map
